(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.eb.e1 === region.dH.e1)
	{
		return 'on line ' + region.eb.e1;
	}
	return 'on lines ' + region.eb.e1 + ' through ' + region.dH.e1;
}



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.nQ,
		impl.qp,
		impl.pY,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	result = init(result.a);
	var model = result.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		result = A2(update, msg, model);
		stepper(model = result.a, viewMetadata);
		_Platform_enqueueEffects(managers, result.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, result.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS


function _VirtualDom_noScript(tag)
{
	return tag == 'script' ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
}

function _VirtualDom_noJavaScriptUri_UNUSED(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,''))
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
}

function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value)
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		od: func(record.od),
		hH: record.hH,
		hj: record.hj
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.od;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.hH;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.hj) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.nQ,
		impl.qp,
		impl.pY,
		function(sendToApp, initialModel) {
			var view = impl.qD;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.nQ,
		impl.qp,
		impl.pY,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.hx && impl.hx(sendToApp)
			var view = impl.qD;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.lG);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.fD) && (_VirtualDom_doc.title = title = doc.fD);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.oy;
	var onUrlRequest = impl.oz;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		hx: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.o6 === next.o6
							&& curr.i7 === next.i7
							&& curr.oY.a === next.oY.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		nQ: function(flags)
		{
			return A3(impl.nQ, flags, _Browser_getUrl(), key);
		},
		qD: impl.qD,
		qp: impl.qp,
		pY: impl.pY
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { nH: 'hidden', lS: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { nH: 'mozHidden', lS: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { nH: 'msHidden', lS: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { nH: 'webkitHidden', lS: 'webkitvisibilitychange' }
		: { nH: 'hidden', lS: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		pz: _Browser_getScene(),
		k6: {
			lc: _Browser_window.pageXOffset,
			ld: _Browser_window.pageYOffset,
			qQ: _Browser_doc.documentElement.clientWidth,
			i6: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		qQ: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		i6: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			pz: {
				qQ: node.scrollWidth,
				i6: node.scrollHeight
			},
			k6: {
				lc: node.scrollLeft,
				ld: node.scrollTop,
				qQ: node.clientWidth,
				i6: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			pz: _Browser_getScene(),
			k6: {
				lc: x,
				ld: y,
				qQ: _Browser_doc.documentElement.clientWidth,
				i6: _Browser_doc.documentElement.clientHeight
			},
			mW: {
				lc: x + rect.left,
				ld: y + rect.top,
				qQ: rect.width,
				i6: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});



function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.m9.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.m9.b, xhr)); });
		$elm$core$Maybe$isJust(request.qi) && _Http_track(router, xhr, request.qi.a);

		try {
			xhr.open(request.of, request.qt, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.qt));
		}

		_Http_configureRequest(xhr, request);

		request.lG.a && xhr.setRequestHeader('Content-Type', request.lG.a);
		xhr.send(request.lG.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.nG; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.p5.a || 0;
	xhr.responseType = request.m9.d;
	xhr.withCredentials = request.ll;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		qt: xhr.responseURL,
		cw: xhr.status,
		pT: xhr.statusText,
		nG: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			pB: event.loaded,
			pJ: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			pi: event.loaded,
			pJ: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}



// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}

// BYTES

function _Bytes_width(bytes)
{
	return bytes.byteLength;
}

var _Bytes_getHostEndianness = F2(function(le, be)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(new Uint8Array(new Uint32Array([1]))[0] === 1 ? le : be));
	});
});


// ENCODERS

function _Bytes_encode(encoder)
{
	var mutableBytes = new DataView(new ArrayBuffer($elm$bytes$Bytes$Encode$getWidth(encoder)));
	$elm$bytes$Bytes$Encode$write(encoder)(mutableBytes)(0);
	return mutableBytes;
}


// SIGNED INTEGERS

var _Bytes_write_i8  = F3(function(mb, i, n) { mb.setInt8(i, n); return i + 1; });
var _Bytes_write_i16 = F4(function(mb, i, n, isLE) { mb.setInt16(i, n, isLE); return i + 2; });
var _Bytes_write_i32 = F4(function(mb, i, n, isLE) { mb.setInt32(i, n, isLE); return i + 4; });


// UNSIGNED INTEGERS

var _Bytes_write_u8  = F3(function(mb, i, n) { mb.setUint8(i, n); return i + 1 ;});
var _Bytes_write_u16 = F4(function(mb, i, n, isLE) { mb.setUint16(i, n, isLE); return i + 2; });
var _Bytes_write_u32 = F4(function(mb, i, n, isLE) { mb.setUint32(i, n, isLE); return i + 4; });


// FLOATS

var _Bytes_write_f32 = F4(function(mb, i, n, isLE) { mb.setFloat32(i, n, isLE); return i + 4; });
var _Bytes_write_f64 = F4(function(mb, i, n, isLE) { mb.setFloat64(i, n, isLE); return i + 8; });


// BYTES

var _Bytes_write_bytes = F3(function(mb, offset, bytes)
{
	for (var i = 0, len = bytes.byteLength, limit = len - 4; i <= limit; i += 4)
	{
		mb.setUint32(offset + i, bytes.getUint32(i));
	}
	for (; i < len; i++)
	{
		mb.setUint8(offset + i, bytes.getUint8(i));
	}
	return offset + len;
});


// STRINGS

function _Bytes_getStringWidth(string)
{
	for (var width = 0, i = 0; i < string.length; i++)
	{
		var code = string.charCodeAt(i);
		width +=
			(code < 0x80) ? 1 :
			(code < 0x800) ? 2 :
			(code < 0xD800 || 0xDBFF < code) ? 3 : (i++, 4);
	}
	return width;
}

var _Bytes_write_string = F3(function(mb, offset, string)
{
	for (var i = 0; i < string.length; i++)
	{
		var code = string.charCodeAt(i);
		offset +=
			(code < 0x80)
				? (mb.setUint8(offset, code)
				, 1
				)
				:
			(code < 0x800)
				? (mb.setUint16(offset, 0xC080 /* 0b1100000010000000 */
					| (code >>> 6 & 0x1F /* 0b00011111 */) << 8
					| code & 0x3F /* 0b00111111 */)
				, 2
				)
				:
			(code < 0xD800 || 0xDBFF < code)
				? (mb.setUint16(offset, 0xE080 /* 0b1110000010000000 */
					| (code >>> 12 & 0xF /* 0b00001111 */) << 8
					| code >>> 6 & 0x3F /* 0b00111111 */)
				, mb.setUint8(offset + 2, 0x80 /* 0b10000000 */
					| code & 0x3F /* 0b00111111 */)
				, 3
				)
				:
			(code = (code - 0xD800) * 0x400 + string.charCodeAt(++i) - 0xDC00 + 0x10000
			, mb.setUint32(offset, 0xF0808080 /* 0b11110000100000001000000010000000 */
				| (code >>> 18 & 0x7 /* 0b00000111 */) << 24
				| (code >>> 12 & 0x3F /* 0b00111111 */) << 16
				| (code >>> 6 & 0x3F /* 0b00111111 */) << 8
				| code & 0x3F /* 0b00111111 */)
			, 4
			);
	}
	return offset;
});


// DECODER

var _Bytes_decode = F2(function(decoder, bytes)
{
	try {
		return $elm$core$Maybe$Just(A2(decoder, bytes, 0).b);
	} catch(e) {
		return $elm$core$Maybe$Nothing;
	}
});

var _Bytes_read_i8  = F2(function(      bytes, offset) { return _Utils_Tuple2(offset + 1, bytes.getInt8(offset)); });
var _Bytes_read_i16 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 2, bytes.getInt16(offset, isLE)); });
var _Bytes_read_i32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getInt32(offset, isLE)); });
var _Bytes_read_u8  = F2(function(      bytes, offset) { return _Utils_Tuple2(offset + 1, bytes.getUint8(offset)); });
var _Bytes_read_u16 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 2, bytes.getUint16(offset, isLE)); });
var _Bytes_read_u32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getUint32(offset, isLE)); });
var _Bytes_read_f32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getFloat32(offset, isLE)); });
var _Bytes_read_f64 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 8, bytes.getFloat64(offset, isLE)); });

var _Bytes_read_bytes = F3(function(len, bytes, offset)
{
	return _Utils_Tuple2(offset + len, new DataView(bytes.buffer, bytes.byteOffset + offset, len));
});

var _Bytes_read_string = F3(function(len, bytes, offset)
{
	var string = '';
	var end = offset + len;
	for (; offset < end;)
	{
		var byte = bytes.getUint8(offset++);
		string +=
			(byte < 128)
				? String.fromCharCode(byte)
				:
			((byte & 0xE0 /* 0b11100000 */) === 0xC0 /* 0b11000000 */)
				? String.fromCharCode((byte & 0x1F /* 0b00011111 */) << 6 | bytes.getUint8(offset++) & 0x3F /* 0b00111111 */)
				:
			((byte & 0xF0 /* 0b11110000 */) === 0xE0 /* 0b11100000 */)
				? String.fromCharCode(
					(byte & 0xF /* 0b00001111 */) << 12
					| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 6
					| bytes.getUint8(offset++) & 0x3F /* 0b00111111 */
				)
				:
				(byte =
					((byte & 0x7 /* 0b00000111 */) << 18
						| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 12
						| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 6
						| bytes.getUint8(offset++) & 0x3F /* 0b00111111 */
					) - 0x10000
				, String.fromCharCode(Math.floor(byte / 0x400) + 0xD800, byte % 0x400 + 0xDC00)
				);
	}
	return _Utils_Tuple2(offset, string);
});

var _Bytes_decodeFailure = F2(function() { throw 0; });



// DECODER

var _File_decoder = _Json_decodePrim(function(value) {
	// NOTE: checks if `File` exists in case this is run on node
	return (typeof File !== 'undefined' && value instanceof File)
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FILE', value);
});


// METADATA

function _File_name(file) { return file.name; }
function _File_mime(file) { return file.type; }
function _File_size(file) { return file.size; }

function _File_lastModified(file)
{
	return $elm$time$Time$millisToPosix(file.lastModified);
}


// DOWNLOAD

var _File_downloadNode;

function _File_getDownloadNode()
{
	return _File_downloadNode || (_File_downloadNode = document.createElement('a'));
}

var _File_download = F3(function(name, mime, content)
{
	return _Scheduler_binding(function(callback)
	{
		var blob = new Blob([content], {type: mime});

		// for IE10+
		if (navigator.msSaveOrOpenBlob)
		{
			navigator.msSaveOrOpenBlob(blob, name);
			return;
		}

		// for HTML5
		var node = _File_getDownloadNode();
		var objectUrl = URL.createObjectURL(blob);
		node.href = objectUrl;
		node.download = name;
		_File_click(node);
		URL.revokeObjectURL(objectUrl);
	});
});

function _File_downloadUrl(href)
{
	return _Scheduler_binding(function(callback)
	{
		var node = _File_getDownloadNode();
		node.href = href;
		node.download = '';
		node.origin === location.origin || (node.target = '_blank');
		_File_click(node);
	});
}


// IE COMPATIBILITY

function _File_makeBytesSafeForInternetExplorer(bytes)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/10
	// all other browsers can just run `new Blob([bytes])` directly with no problem
	//
	return new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
}

function _File_click(node)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/11
	// all other browsers have MouseEvent and do not need this conditional stuff
	//
	if (typeof MouseEvent === 'function')
	{
		node.dispatchEvent(new MouseEvent('click'));
	}
	else
	{
		var event = document.createEvent('MouseEvents');
		event.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
		document.body.appendChild(node);
		node.dispatchEvent(event);
		document.body.removeChild(node);
	}
}


// UPLOAD

var _File_node;

function _File_uploadOne(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			callback(_Scheduler_succeed(event.target.files[0]));
		});
		_File_click(_File_node);
	});
}

function _File_uploadOneOrMore(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.multiple = true;
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			var elmFiles = _List_fromArray(event.target.files);
			callback(_Scheduler_succeed(_Utils_Tuple2(elmFiles.a, elmFiles.b)));
		});
		_File_click(_File_node);
	});
}


// CONTENT

function _File_toString(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsText(blob);
		return function() { reader.abort(); };
	});
}

function _File_toBytes(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(new DataView(reader.result)));
		});
		reader.readAsArrayBuffer(blob);
		return function() { reader.abort(); };
	});
}

function _File_toUrl(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsDataURL(blob);
		return function() { reader.abort(); };
	});
}



// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.oj) { flags += 'm'; }
	if (options.lP) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;
var $author$project$Main$ChangedUrl = function (a) {
	return {$: 2, a: a};
};
var $author$project$Main$ClickedLink = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$List$cons = _List_cons;
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.p) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.w),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.w);
		} else {
			var treeLen = builder.p * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.y) : builder.y;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.p);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.w) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.w);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{y: nodeList, p: (len / $elm$core$Array$branchFactor) | 0, w: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {iX: fragment, i7: host, oO: path, oY: port_, o6: protocol, pe: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$application = _Browser_application;
var $author$project$Main$AdjustTimeZone = function (a) {
	return {$: 1, a: a};
};
var $author$project$Main$NavigationDrawerMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Route$NotFound = {$: 22};
var $author$project$Main$PagesMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Main$SharedMsg = function (a) {
	return {$: 5, a: a};
};
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $author$project$Data$User$User = function (id) {
	return function (token) {
		return function (userType) {
			return function (permissions) {
				return function (expire) {
					return function (concessionaires) {
						return function (userName) {
							return function (permissionsCODE) {
								return function (address) {
									return function (cnpj) {
										return function (phone) {
											return function (taxIss) {
												return {ep: address, l3: cnpj, bR: concessionaires, nc: expire, dM: id, oU: permissions, hg: permissionsCODE, jX: phone, p0: taxIss, kU: token, qx: userName, k$: userType};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $author$project$Data$User$ConcessionaireUser = F2(
	function (id, name) {
		return {dM: id, c3: name};
	});
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $author$project$Components$DecodeUTF8$stringEncode = function (str) {
	return A2(
		$elm$core$List$map,
		$elm$core$Char$toCode,
		$elm$core$String$toList(str));
};
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$or = _Bitwise_or;
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $zwilias$elm_utf_tools$String$UTF8$utf8ToUtf32 = F3(
	function (add, _char, _v0) {
		var curr = _v0.a;
		var need = _v0.b;
		var acc = _v0.c;
		var shiftAndAdd = function (_int) {
			return (63 & _int) | (curr << 6);
		};
		return (!need) ? ((!(128 & _char)) ? _Utils_Tuple3(
			0,
			0,
			A2(add, _char, acc)) : (((224 & _char) === 192) ? _Utils_Tuple3(31 & _char, 1, acc) : (((240 & _char) === 224) ? _Utils_Tuple3(15 & _char, 2, acc) : _Utils_Tuple3(7 & _char, 3, acc)))) : ((need === 1) ? _Utils_Tuple3(
			0,
			0,
			A2(
				add,
				shiftAndAdd(_char),
				acc)) : _Utils_Tuple3(
			shiftAndAdd(_char),
			need - 1,
			acc));
	});
var $zwilias$elm_utf_tools$String$UTF8$foldlUTF8 = F3(
	function (op, acc, input) {
		var _v0 = A3(
			$elm$core$List$foldl,
			$zwilias$elm_utf_tools$String$UTF8$utf8ToUtf32(op),
			_Utils_Tuple3(0, 0, acc),
			input);
		if (!_v0.b) {
			var res = _v0.c;
			return $elm$core$Result$Ok(res);
		} else {
			return $elm$core$Result$Err('invalid UTF-8 sequence');
		}
	});
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Char$fromCode = _Char_fromCode;
var $zwilias$elm_utf_tools$String$UTF8$utf32ByteToString = function (_byte) {
	return $elm$core$String$fromChar(
		$elm$core$Char$fromCode(_byte));
};
var $zwilias$elm_utf_tools$String$UTF8$toString = function (input) {
	return A3(
		$zwilias$elm_utf_tools$String$UTF8$foldlUTF8,
		F2(
			function (_char, string) {
				return _Utils_ap(
					string,
					$zwilias$elm_utf_tools$String$UTF8$utf32ByteToString(_char));
			}),
		'',
		input);
};
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $author$project$Components$DecodeUTF8$bytesDecode = function (str) {
	return A2(
		$elm$core$Result$withDefault,
		'',
		$zwilias$elm_utf_tools$String$UTF8$toString(
			$author$project$Components$DecodeUTF8$stringEncode(str)));
};
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$Data$User$decodeStringUTF16 = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		return $elm$json$Json$Decode$succeed(
			$author$project$Components$DecodeUTF8$bytesDecode(str));
	},
	$elm$json$Json$Decode$string);
var $elm$json$Json$Decode$field = _Json_decodeField;
var $author$project$Data$User$concessionaireUserDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Data$User$ConcessionaireUser,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'name', $author$project$Data$User$decodeStringUTF16));
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $author$project$Services$Models$ADD_PERMISSION = {$: 1};
var $author$project$Services$Models$AVULSAS = function (a) {
	return {$: 22, a: a};
};
var $author$project$Services$Models$BIOMETRY = function (a) {
	return {$: 15, a: a};
};
var $author$project$Services$Models$CLASS = function (a) {
	return {$: 21, a: a};
};
var $author$project$Services$Models$COMPANY = function (a) {
	return {$: 7, a: a};
};
var $author$project$Services$Models$EQUIPMENT = function (a) {
	return {$: 4, a: a};
};
var $author$project$Services$Models$EQUIPMENT_UPDATE = function (a) {
	return {$: 14, a: a};
};
var $author$project$Services$Models$FINANCIAL = function (a) {
	return {$: 9, a: a};
};
var $author$project$Services$Models$GUICHE = function (a) {
	return {$: 3, a: a};
};
var $author$project$Services$Models$LINES = function (a) {
	return {$: 13, a: a};
};
var $author$project$Services$Models$OPERATORS = function (a) {
	return {$: 11, a: a};
};
var $author$project$Services$Models$PASSENGER = function (a) {
	return {$: 19, a: a};
};
var $author$project$Services$Models$POUCH = function (a) {
	return {$: 10, a: a};
};
var $author$project$Services$Models$REASONS = function (a) {
	return {$: 17, a: a};
};
var $author$project$Services$Models$REFUNDS_GUICHE = function (a) {
	return {$: 18, a: a};
};
var $author$project$Services$Models$REPORTS = function (a) {
	return {$: 5, a: a};
};
var $author$project$Services$Models$REPORTS_EVENTS = function (a) {
	return {$: 6, a: a};
};
var $author$project$Services$Models$REPORT_PDF = function (a) {
	return {$: 20, a: a};
};
var $author$project$Services$Models$REVERSE = function (a) {
	return {$: 8, a: a};
};
var $author$project$Services$Models$STOCK = function (a) {
	return {$: 16, a: a};
};
var $author$project$Services$Models$SYSTEM_USER = function (a) {
	return {$: 2, a: a};
};
var $author$project$Services$Models$TARIFFS = function (a) {
	return {$: 12, a: a};
};
var $author$project$Services$Models$Undefined = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$json$Json$Decode$fail = _Json_fail;
var $author$project$Services$Models$COMPANY_REVERSE = 0;
var $author$project$Services$Models$ISS = 1;
var $author$project$Services$Models$functionCompanyPermission = function (_function) {
	_v0$2:
	while (true) {
		if (_function.b && (!_function.b.b)) {
			switch (_function.a) {
				case 'Estornar':
					return $elm$core$Maybe$Just(0);
				case 'ISS':
					return $elm$core$Maybe$Just(1);
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Services$Models$ACCESS = 3;
var $author$project$Services$Models$EDIT = 2;
var $author$project$Services$Models$INCLUDE = 1;
var $author$project$Services$Models$LIST = 0;
var $author$project$Services$Models$functionCruPermission = function (_function) {
	_v0$4:
	while (true) {
		if (_function.b && (!_function.b.b)) {
			switch (_function.a) {
				case 'Listar':
					return $elm$core$Maybe$Just(0);
				case 'Incluir':
					return $elm$core$Maybe$Just(1);
				case 'Editar':
					return $elm$core$Maybe$Just(2);
				case 'Acessar':
					return $elm$core$Maybe$Just(3);
				default:
					break _v0$4;
			}
		} else {
			break _v0$4;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Services$Models$FINANCIAL_ACCESS = 0;
var $author$project$Services$Models$FINANCIAL_PAID_TRANSACTIONS = 2;
var $author$project$Services$Models$FINANCIAL_PENDING_TRANSACTIONS = 3;
var $author$project$Services$Models$FINANCIAL_WITHDRAWAL = 1;
var $author$project$Services$Models$functionFinancialPermission = function (functions) {
	_v0$4:
	while (true) {
		if (functions.b && (!functions.b.b)) {
			switch (functions.a) {
				case 'Acessar':
					return $elm$core$Maybe$Just(0);
				case 'Saque':
					return $elm$core$Maybe$Just(1);
				case 'TransacoesPagas':
					return $elm$core$Maybe$Just(2);
				case 'TransacoesPendentes':
					return $elm$core$Maybe$Just(3);
				default:
					break _v0$4;
			}
		} else {
			break _v0$4;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Services$Models$Access = 1;
var $author$project$Services$Models$Extract = 0;
var $author$project$Services$Models$GuicheOrders = 4;
var $author$project$Services$Models$RefillList = 3;
var $author$project$Services$Models$Transfer = 2;
var $author$project$Services$Models$functionGuichePermission = function (_function) {
	_v0$5:
	while (true) {
		if (_function.b && (!_function.b.b)) {
			switch (_function.a) {
				case 'Extrato':
					return $elm$core$Maybe$Just(0);
				case 'Acessar':
					return $elm$core$Maybe$Just(1);
				case 'transferencia':
					return $elm$core$Maybe$Just(2);
				case 'Pedidos':
					return $elm$core$Maybe$Just(4);
				case 'ListaCargas':
					return $elm$core$Maybe$Just(3);
				default:
					break _v0$5;
			}
		} else {
			break _v0$5;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Services$Models$OPERATORS_ACCESS = 0;
var $author$project$Services$Models$OPERATORS_EDIT = 1;
var $author$project$Services$Models$functionOperatorsPermission = function (functions) {
	_v0$2:
	while (true) {
		if (functions.b && (!functions.b.b)) {
			switch (functions.a) {
				case 'Acessar':
					return $elm$core$Maybe$Just(0);
				case 'Editar':
					return $elm$core$Maybe$Just(1);
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Services$Models$ACCESS_POUCH = 0;
var $author$project$Services$Models$REGISTER_POUCH = 1;
var $author$project$Services$Models$functionPouchPermission = function (functions) {
	_v0$2:
	while (true) {
		if (functions.b && (!functions.b.b)) {
			switch (functions.a) {
				case 'Acessar':
					return $elm$core$Maybe$Just(0);
				case 'Cadastrar':
					return $elm$core$Maybe$Just(1);
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Services$Models$RE_UsesDay = 0;
var $author$project$Services$Models$RE_UsesLine = 3;
var $author$project$Services$Models$RE_UsesOperator = 2;
var $author$project$Services$Models$RE_UsesSession = 4;
var $author$project$Services$Models$RE_UsesVehicle = 1;
var $author$project$Services$Models$functionReportsEventsPermission = function (functions) {
	_v0$5:
	while (true) {
		if (functions.b && (!functions.b.b)) {
			switch (functions.a) {
				case 'UsosDia':
					return $elm$core$Maybe$Just(0);
				case 'UsosVeiculo':
					return $elm$core$Maybe$Just(1);
				case 'UsosOperador':
					return $elm$core$Maybe$Just(2);
				case 'UsosLinha':
					return $elm$core$Maybe$Just(3);
				case 'UsosSessao':
					return $elm$core$Maybe$Just(4);
				default:
					break _v0$5;
			}
		} else {
			break _v0$5;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Services$Models$DetailedVehicle = {$: 4};
var $author$project$Services$Models$ReportAccess = {$: 6};
var $author$project$Services$Models$Sales = {$: 3};
var $author$project$Services$Models$SalesSummary = {$: 5};
var $author$project$Services$Models$SessionsWithoutPouch = {$: 7};
var $author$project$Services$Models$Usage = {$: 8};
var $author$project$Services$Models$UsesClass = {$: 9};
var $author$project$Services$Models$UsesDay = function (a) {
	return {$: 1, a: a};
};
var $author$project$Services$Models$UsesLine = function (a) {
	return {$: 2, a: a};
};
var $author$project$Services$Models$UsesVehicles = function (a) {
	return {$: 0, a: a};
};
var $author$project$Services$Models$functionReportsPermission = function (functions) {
	_v0$10:
	while (true) {
		if (functions.b && (!functions.b.b)) {
			switch (functions.a) {
				case 'UsosVeiculo':
					return $elm$core$Maybe$Just(
						$author$project$Services$Models$UsesVehicles(0));
				case 'UsosDia':
					return $elm$core$Maybe$Just(
						$author$project$Services$Models$UsesDay(0));
				case 'UsosLinha':
					return $elm$core$Maybe$Just(
						$author$project$Services$Models$UsesLine(0));
				case 'Vendas':
					return $elm$core$Maybe$Just($author$project$Services$Models$Sales);
				case 'VeiculoDetalhado':
					return $elm$core$Maybe$Just($author$project$Services$Models$DetailedVehicle);
				case 'VendasResumido':
					return $elm$core$Maybe$Just($author$project$Services$Models$SalesSummary);
				case 'Acessar':
					return $elm$core$Maybe$Just($author$project$Services$Models$ReportAccess);
				case 'SessoesSemMalote':
					return $elm$core$Maybe$Just($author$project$Services$Models$SessionsWithoutPouch);
				case 'Usos':
					return $elm$core$Maybe$Just($author$project$Services$Models$Usage);
				case 'UsosClasses':
					return $elm$core$Maybe$Just($author$project$Services$Models$UsesClass);
				default:
					break _v0$10;
			}
		} else {
			break _v0$10;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Services$Models$REVERSE_ACCESS = 0;
var $author$project$Services$Models$REVERSE_WRITE_OFF = 1;
var $author$project$Services$Models$functionReversePermission = function (_function) {
	_v0$2:
	while (true) {
		if (_function.b && (!_function.b.b)) {
			switch (_function.a) {
				case 'Acessar':
					return $elm$core$Maybe$Just(0);
				case 'Baixar':
					return $elm$core$Maybe$Just(1);
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Services$Models$TARIFFS_ACCESS = 0;
var $author$project$Services$Models$TARIFFS_EDIT = 1;
var $author$project$Services$Models$functionTariffsPermission = function (_function) {
	_v0$2:
	while (true) {
		if (_function.b && (!_function.b.b)) {
			switch (_function.a) {
				case 'Acessar':
					return $elm$core$Maybe$Just(0);
				case 'Editar':
					return $elm$core$Maybe$Just(1);
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Services$Models$AVULSAS_ACCESS = 0;
var $author$project$Services$Models$AVULSAS_EDIT = 1;
var $author$project$Services$Models$functionsAvulsas = function (functions) {
	_v0$2:
	while (true) {
		if (functions.b && (!functions.b.b)) {
			switch (functions.a) {
				case 'Acessar':
					return $elm$core$Maybe$Just(0);
				case 'Editar':
					return $elm$core$Maybe$Just(1);
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Services$Models$BIOMETRY_ACCESS = 0;
var $author$project$Services$Models$BIOMETRY_EDIT = 1;
var $author$project$Services$Models$functionsBiometry = function (functions) {
	_v0$2:
	while (true) {
		if (functions.b && (!functions.b.b)) {
			switch (functions.a) {
				case 'Acessar':
					return $elm$core$Maybe$Just(0);
				case 'Editar':
					return $elm$core$Maybe$Just(1);
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Services$Models$CLASS_ACCESS = 1;
var $author$project$Services$Models$CLASS_EDIT = 0;
var $author$project$Services$Models$functionsClass = function (functions) {
	_v0$2:
	while (true) {
		if (functions.b && (!functions.b.b)) {
			switch (functions.a) {
				case 'Acessar':
					return $elm$core$Maybe$Just(1);
				case 'Editar':
					return $elm$core$Maybe$Just(0);
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Services$Models$EQUIPMENT_UPDATE_CHANGE = 1;
var $author$project$Services$Models$EQUIPMENT_UPDATE_LIST = 0;
var $author$project$Services$Models$functionsEquipmentUpdate = function (functions) {
	_v0$2:
	while (true) {
		if (functions.b && (!functions.b.b)) {
			switch (functions.a) {
				case 'Listar':
					return $elm$core$Maybe$Just(0);
				case 'Atualizar':
					return $elm$core$Maybe$Just(1);
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Services$Models$LINES_ACCESS = 0;
var $author$project$Services$Models$LINES_EDIT = 1;
var $author$project$Services$Models$functionsLinesPermissions = function (functions) {
	_v0$2:
	while (true) {
		if (functions.b && (!functions.b.b)) {
			switch (functions.a) {
				case 'Acessar':
					return $elm$core$Maybe$Just(0);
				case 'Editar':
					return $elm$core$Maybe$Just(1);
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Services$Models$PASSENGER_HISTORY = 0;
var $author$project$Services$Models$functionsPassenger = function (f) {
	if ((f.b && (f.a === 'Historico')) && (!f.b.b)) {
		return $elm$core$Maybe$Just(0);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Services$Models$REASONS_EDIT = 1;
var $author$project$Services$Models$REASONS_LIST = 0;
var $author$project$Services$Models$functionsReasons = function (functions) {
	_v0$2:
	while (true) {
		if (functions.b && (!functions.b.b)) {
			switch (functions.a) {
				case 'Acessar':
					return $elm$core$Maybe$Just(0);
				case 'Editar':
					return $elm$core$Maybe$Just(1);
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Services$Models$REFUNDS_GUICHE_APPROVE = 1;
var $author$project$Services$Models$REFUNDS_GUICHE_REQUEST = 0;
var $author$project$Services$Models$functionsRefundsGuiche = function (f) {
	_v0$2:
	while (true) {
		if (f.b && (!f.b.b)) {
			switch (f.a) {
				case 'Solicitar':
					return $elm$core$Maybe$Just(0);
				case 'Aprovar':
					return $elm$core$Maybe$Just(1);
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Services$Models$REPORT_PDF_ACCESS = 0;
var $author$project$Services$Models$functionsReportPDF = function (functions) {
	if ((functions.b && (functions.a === 'Acessar')) && (!functions.b.b)) {
		return $elm$core$Maybe$Just(0);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Services$Models$STOCK_ACCESS = 0;
var $author$project$Services$Models$functionsStock = function (functions) {
	if ((functions.b && (functions.a === 'Acessar')) && (!functions.b.b)) {
		return $elm$core$Maybe$Just(0);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $author$project$Services$Models$decodePermissions = A2(
	$elm$json$Json$Decode$andThen,
	function (permissionStr) {
		var _v0 = A2($elm$core$String$split, '.', permissionStr);
		_v0$22:
		while (true) {
			if (_v0.b) {
				switch (_v0.a) {
					case 'usuarioSistema':
						var _function = _v0.b;
						return A2(
							$elm$core$Maybe$withDefault,
							$elm$json$Json$Decode$fail('Failed to map \'usuarioSistema\' permissions'),
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $author$project$Services$Models$SYSTEM_USER),
								$author$project$Services$Models$functionCruPermission(_function)));
					case 'guiche':
						var _function = _v0.b;
						return A2(
							$elm$core$Maybe$withDefault,
							$elm$json$Json$Decode$fail('Failed to map \'guiche\' permissions'),
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $author$project$Services$Models$GUICHE),
								$author$project$Services$Models$functionGuichePermission(_function)));
					case 'equipamentos':
						var _function = _v0.b;
						return A2(
							$elm$core$Maybe$withDefault,
							$elm$json$Json$Decode$fail('Failed to map \'equipamentos\' permissions'),
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $author$project$Services$Models$EQUIPMENT),
								$author$project$Services$Models$functionCruPermission(_function)));
					case 'empresas':
						var _function = _v0.b;
						return A2(
							$elm$core$Maybe$withDefault,
							$elm$json$Json$Decode$fail('Failed to map \'empresas\' permissions'),
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $author$project$Services$Models$COMPANY),
								$author$project$Services$Models$functionCompanyPermission(_function)));
					case 'estornos':
						var _function = _v0.b;
						return A2(
							$elm$core$Maybe$withDefault,
							$elm$json$Json$Decode$fail('Failed to map \'estornos\' permissions'),
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $author$project$Services$Models$REVERSE),
								$author$project$Services$Models$functionReversePermission(_function)));
					case 'financeiro':
						var _function = _v0.b;
						return A2(
							$elm$core$Maybe$withDefault,
							$elm$json$Json$Decode$fail('Failed to map \'financeiro\' permissions'),
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $author$project$Services$Models$FINANCIAL),
								$author$project$Services$Models$functionFinancialPermission(_function)));
					case 'malote':
						var _function = _v0.b;
						return A2(
							$elm$core$Maybe$withDefault,
							$elm$json$Json$Decode$fail('Failed to map \'malote\' permissions'),
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $author$project$Services$Models$POUCH),
								$author$project$Services$Models$functionPouchPermission(_function)));
					case 'relatorios':
						var _function = _v0.b;
						return A2(
							$elm$core$Maybe$withDefault,
							$elm$json$Json$Decode$fail('Failed to map \'relatorios\' permissions'),
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $author$project$Services$Models$REPORTS),
								$author$project$Services$Models$functionReportsPermission(_function)));
					case 'relatorioEventos':
						var _function = _v0.b;
						return A2(
							$elm$core$Maybe$withDefault,
							$elm$json$Json$Decode$fail('Failed to map \'relatorioEventos\' permissions'),
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $author$project$Services$Models$REPORTS_EVENTS),
								$author$project$Services$Models$functionReportsEventsPermission(_function)));
					case 'operadores':
						var _function = _v0.b;
						return A2(
							$elm$core$Maybe$withDefault,
							$elm$json$Json$Decode$fail('Failed to map \'operadores\' permissions'),
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $author$project$Services$Models$OPERATORS),
								$author$project$Services$Models$functionOperatorsPermission(_function)));
					case 'tarifas':
						var functions = _v0.b;
						return A2(
							$elm$core$Maybe$withDefault,
							$elm$json$Json$Decode$fail('Failed to map \'tarifas\' permissions'),
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $author$project$Services$Models$TARIFFS),
								$author$project$Services$Models$functionTariffsPermission(functions)));
					case 'linhas':
						var functions = _v0.b;
						return A2(
							$elm$core$Maybe$withDefault,
							$elm$json$Json$Decode$fail('Failed to map \'linhas\' permissions'),
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $author$project$Services$Models$LINES),
								$author$project$Services$Models$functionsLinesPermissions(functions)));
					case 'AtualizacaoEquipamentos':
						var functions = _v0.b;
						return A2(
							$elm$core$Maybe$withDefault,
							$elm$json$Json$Decode$fail('Failed to map \'AtualizacaoEquipamentos\' permissions'),
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $author$project$Services$Models$EQUIPMENT_UPDATE),
								$author$project$Services$Models$functionsEquipmentUpdate(functions)));
					case 'biometria':
						var functions = _v0.b;
						return A2(
							$elm$core$Maybe$withDefault,
							$elm$json$Json$Decode$fail('Failed to map \'biometria\' permissions'),
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $author$project$Services$Models$BIOMETRY),
								$author$project$Services$Models$functionsBiometry(functions)));
					case 'estoque':
						var functions = _v0.b;
						return A2(
							$elm$core$Maybe$withDefault,
							$elm$json$Json$Decode$fail('Failed to map \'estoque\' permissions'),
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $author$project$Services$Models$STOCK),
								$author$project$Services$Models$functionsStock(functions)));
					case 'motivos':
						var functions = _v0.b;
						return A2(
							$elm$core$Maybe$withDefault,
							$elm$json$Json$Decode$fail('Failed to map \'motivos\' permissions'),
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $author$project$Services$Models$REASONS),
								$author$project$Services$Models$functionsReasons(functions)));
					case 'estornosGuiche':
						var functions = _v0.b;
						return A2(
							$elm$core$Maybe$withDefault,
							$elm$json$Json$Decode$fail('Failed to map \'estornosGuiche\' permissions'),
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $author$project$Services$Models$REFUNDS_GUICHE),
								$author$project$Services$Models$functionsRefundsGuiche(functions)));
					case 'passageiro':
						var functions = _v0.b;
						return A2(
							$elm$core$Maybe$withDefault,
							$elm$json$Json$Decode$fail('Failed to map \'passageiro\' permissions'),
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $author$project$Services$Models$PASSENGER),
								$author$project$Services$Models$functionsPassenger(functions)));
					case 'relatoriosPDF':
						var functions = _v0.b;
						return A2(
							$elm$core$Maybe$withDefault,
							$elm$json$Json$Decode$fail('Failed to map \'relatoriosPDF\' permissions'),
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $author$project$Services$Models$REPORT_PDF),
								$author$project$Services$Models$functionsReportPDF(functions)));
					case 'classes':
						var functions = _v0.b;
						return A2(
							$elm$core$Maybe$withDefault,
							$elm$json$Json$Decode$fail('Failed to map \'classes\' permissions'),
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $author$project$Services$Models$CLASS),
								$author$project$Services$Models$functionsClass(functions)));
					case 'avulsas':
						var functions = _v0.b;
						return A2(
							$elm$core$Maybe$withDefault,
							$elm$json$Json$Decode$fail('Failed to map \'avulsas\' permissions'),
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $author$project$Services$Models$AVULSAS),
								$author$project$Services$Models$functionsAvulsas(functions)));
					case 'PERMISSION':
						if ((((_v0.b.b && (_v0.b.a === 'ADD')) && _v0.b.b.b) && (_v0.b.b.a === 'PERMISSION')) && (!_v0.b.b.b.b)) {
							var _v1 = _v0.b;
							var _v2 = _v1.b;
							return $elm$json$Json$Decode$succeed($author$project$Services$Models$ADD_PERMISSION);
						} else {
							break _v0$22;
						}
					default:
						break _v0$22;
				}
			} else {
				break _v0$22;
			}
		}
		var permissionCODE = _v0;
		return $elm$json$Json$Decode$succeed(
			$author$project$Services$Models$Undefined(
				A2($elm$core$String$join, '.', permissionCODE)));
	},
	$elm$json$Json$Decode$string);
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $author$project$Data$Permission$BlockUnblockCard = {$: 5};
var $author$project$Data$Permission$BuzzaoAdmin = {$: 0};
var $author$project$Data$Permission$ConcessionaireAdmin = {$: 1};
var $author$project$Data$Permission$Counting = {$: 7};
var $author$project$Data$Permission$IssuingTicketWindow = {$: 2};
var $author$project$Data$Permission$RegisterBeneficiary = {$: 4};
var $author$project$Data$Permission$SalesTicketWindow = {$: 3};
var $author$project$Data$Permission$SecondCardOperator = {$: 6};
var $author$project$Data$Permission$Unknown = function (a) {
	return {$: 8, a: a};
};
var $author$project$Data$Permission$fromApiString = function (str) {
	switch (str) {
		case 'buzzao_admin':
			return $author$project$Data$Permission$BuzzaoAdmin;
		case 'concessionaire_admin':
			return $author$project$Data$Permission$ConcessionaireAdmin;
		case 'issuing_ticket_window':
			return $author$project$Data$Permission$IssuingTicketWindow;
		case 'sales_ticket_window':
			return $author$project$Data$Permission$SalesTicketWindow;
		case 'register_beneficiary':
			return $author$project$Data$Permission$RegisterBeneficiary;
		case 'block_unblock_card':
			return $author$project$Data$Permission$BlockUnblockCard;
		case 'second_card_operator':
			return $author$project$Data$Permission$SecondCardOperator;
		case 'counting':
			return $author$project$Data$Permission$Counting;
		default:
			return $author$project$Data$Permission$Unknown(str);
	}
};
var $author$project$Data$Permission$jsonDecoder = A2($elm$json$Json$Decode$map, $author$project$Data$Permission$fromApiString, $elm$json$Json$Decode$string);
var $elm$json$Json$Decode$list = _Json_decodeList;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (pathDecoder, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2($elm$json$Json$Decode$decodeValue, pathDecoder, input);
			if (!_v0.$) {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_v1.$) {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					var finalErr = _v1.a;
					return $elm$json$Json$Decode$fail(
						$elm$json$Json$Decode$errorToString(finalErr));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				A2($elm$json$Json$Decode$field, key, $elm$json$Json$Decode$value),
				valDecoder,
				fallback),
			decoder);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $author$project$Data$User$Buzzao = {$: 3};
var $author$project$Data$User$Company = function (a) {
	return {$: 2, a: a};
};
var $author$project$Data$User$Operator = function (a) {
	return {$: 1, a: a};
};
var $author$project$Data$User$Passenger = function (a) {
	return {$: 0, a: a};
};
var $author$project$Data$User$userTypeDecoder = function () {
	var decodeConcessionaireId = A2(
		$elm$json$Json$Decode$map,
		function (id) {
			return {mc: id};
		},
		A2($elm$json$Json$Decode$field, 'concessionaireId', $elm$json$Json$Decode$string));
	var decodeUserType = function (value) {
		switch (value) {
			case 'U':
				return A2($elm$json$Json$Decode$map, $author$project$Data$User$Passenger, decodeConcessionaireId);
			case 'O':
				return A2($elm$json$Json$Decode$map, $author$project$Data$User$Operator, decodeConcessionaireId);
			case 'C':
				return A2($elm$json$Json$Decode$map, $author$project$Data$User$Company, decodeConcessionaireId);
			case 'B':
				return $elm$json$Json$Decode$succeed($author$project$Data$User$Buzzao);
			default:
				return $elm$json$Json$Decode$fail('Unknown user type: \'' + (value + '\''));
		}
	};
	return A2(
		$elm$json$Json$Decode$andThen,
		decodeUserType,
		A2($elm$json$Json$Decode$field, 'userType', $elm$json$Json$Decode$string));
}();
var $author$project$Data$User$decoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'issTax',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$float),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'phone',
		$elm$json$Json$Decode$int,
		0,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'cnpj',
			$elm$json$Json$Decode$string,
			'',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'address',
				$elm$json$Json$Decode$string,
				'',
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'permissions',
					$elm$json$Json$Decode$list($author$project$Services$Models$decodePermissions),
					_List_Nil,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'userName',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'concessionaires',
							$elm$json$Json$Decode$list($author$project$Data$User$concessionaireUserDecoder),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'expire',
								A2(
									$elm$json$Json$Decode$map,
									A2(
										$elm$core$Basics$composeR,
										$elm$core$Basics$mul(1000),
										$elm$time$Time$millisToPosix),
									$elm$json$Json$Decode$int),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'roles',
									$elm$json$Json$Decode$list($author$project$Data$Permission$jsonDecoder),
									A2(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
										$author$project$Data$User$userTypeDecoder,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'token',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'id',
												$elm$json$Json$Decode$string,
												$elm$json$Json$Decode$succeed($author$project$Data$User$User)))))))))))));
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$time$Time$here = _Time_here(0);
var $author$project$Route$EnterpriseDashboard = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Route$EnterpriseHistory = {$: 16};
var $author$project$Route$Guiche = {$: 5};
var $author$project$Route$SavedOrderLists = {$: 14};
var $author$project$Route$AccountabilityReport = {$: 5};
var $author$project$Route$Admin = F2(
	function (a, b) {
		return {$: 19, a: a, b: b};
	});
var $author$project$Route$Cards = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Route$CompanyOrders = {$: 12};
var $author$project$Route$PaymentBillets = {$: 11};
var $author$project$Route$PaymentGuides = {$: 10};
var $author$project$Route$Vehicles = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $author$project$Components$Patterns$NavigationDrawer$adminRoutes = F2(
	function (user, currentCID) {
		return _List_fromArray(
			[
				_Utils_Tuple3(
				false,
				$elm$core$Maybe$Nothing,
				_List_fromArray(
					[
						A2(
						$author$project$Route$Admin,
						A2($author$project$Route$Cards, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
						currentCID)
					])),
				_Utils_Tuple3(
				false,
				$elm$core$Maybe$Nothing,
				_List_fromArray(
					[
						A2(
						$author$project$Route$Admin,
						A3($author$project$Route$Vehicles, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
						currentCID)
					])),
				_Utils_Tuple3(
				false,
				$elm$core$Maybe$Nothing,
				_List_fromArray(
					[
						A2($author$project$Route$Admin, $author$project$Route$AccountabilityReport, currentCID)
					])),
				_Utils_Tuple3(
				false,
				$elm$core$Maybe$Nothing,
				_List_fromArray(
					[
						A2($author$project$Route$Admin, $author$project$Route$PaymentGuides, currentCID)
					])),
				_Utils_Tuple3(
				false,
				$elm$core$Maybe$Nothing,
				_List_fromArray(
					[
						A2($author$project$Route$Admin, $author$project$Route$PaymentBillets, currentCID)
					])),
				_Utils_Tuple3(
				false,
				$elm$core$Maybe$Nothing,
				_List_fromArray(
					[
						A2($author$project$Route$Admin, $author$project$Route$CompanyOrders, currentCID)
					]))
			]);
	});
var $author$project$Route$Classes = function (a) {
	return {$: 10, a: a};
};
var $author$project$Route$ClassesList = {$: 0};
var $author$project$Route$Divergences = function (a) {
	return {$: 10, a: a};
};
var $author$project$Route$EquipmentsV2 = function (a) {
	return {$: 1, a: a};
};
var $author$project$Route$History = function (a) {
	return {$: 14, a: a};
};
var $author$project$Route$List = function (a) {
	return {$: 0, a: a};
};
var $author$project$Route$ManageFare = function (a) {
	return {$: 4, a: a};
};
var $author$project$Route$ManageLines = function (a) {
	return {$: 6, a: a};
};
var $author$project$Route$ManageOperators = {$: 5};
var $author$project$Route$ManagePouches = {$: 3};
var $author$project$Route$PDFs = {$: 12};
var $author$project$Route$Panel = function (a) {
	return {$: 4, a: a};
};
var $author$project$Route$Reason = function (a) {
	return {$: 11, a: a};
};
var $author$project$Route$Report = function (a) {
	return {$: 21, a: a};
};
var $author$project$Route$ReversalApproval = function (a) {
	return {$: 0, a: a};
};
var $author$project$Route$SingleCharge = {$: 12};
var $author$project$Route$Stock = function (a) {
	return {$: 13, a: a};
};
var $author$project$Services$Models$System = 0;
var $author$project$Route$Users = function (a) {
	return {$: 0, a: a};
};
var $author$project$Route$WelcomeBack = {$: 3};
var $author$project$Route$UpdateEquipment = {$: 8};
var $author$project$Route$UpdateRequestsEquipments = {$: 9};
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $author$project$Services$Models$iHaveAccess = function (options) {
	return A2(
		$elm$core$List$any,
		$elm$core$Basics$eq(options.hf),
		options.gZ) ? options.hQ : options.hR;
};
var $author$project$Components$Patterns$NavigationDrawer$isActive = F2(
	function (currentRoute, route) {
		var _v0 = _Utils_Tuple2(route, currentRoute);
		_v0$31:
		while (true) {
			switch (_v0.a.$) {
				case 19:
					if (_v0.b.$ === 19) {
						var _v1 = _v0.a;
						var subItemRoute = _v1.a;
						var _v2 = _v0.b;
						var subCurrentRoute = _v2.a;
						switch (subItemRoute.$) {
							case 5:
								switch (subCurrentRoute.$) {
									case 5:
										return true;
									case 6:
										return true;
									case 7:
										return true;
									default:
										return false;
								}
							case 2:
								switch (subCurrentRoute.$) {
									case 2:
										return true;
									case 3:
										return true;
									default:
										return false;
								}
							case 4:
								if (subCurrentRoute.$ === 4) {
									return true;
								} else {
									return false;
								}
							case 12:
								switch (subCurrentRoute.$) {
									case 13:
										return true;
									case 14:
										return true;
									case 12:
										return true;
									default:
										return false;
								}
							case 0:
								if (!subCurrentRoute.$) {
									return true;
								} else {
									return false;
								}
							default:
								return _Utils_eq(subItemRoute, subCurrentRoute);
						}
					} else {
						break _v0$31;
					}
				case 16:
					if (_v0.b.$ === 17) {
						var _v9 = _v0.a;
						var _v10 = _v0.b;
						return true;
					} else {
						break _v0$31;
					}
				case 21:
					if (_v0.b.$ === 21) {
						switch (_v0.a.a.$) {
							case 0:
								if (!_v0.b.a.$) {
									return true;
								} else {
									break _v0$31;
								}
							case 11:
								if (_v0.b.a.$ === 11) {
									switch (_v0.a.a.a.$) {
										case 0:
											if (!_v0.b.a.a.$) {
												return true;
											} else {
												break _v0$31;
											}
										case 1:
											if (_v0.b.a.a.$ === 1) {
												return true;
											} else {
												break _v0$31;
											}
										case 2:
											if (_v0.b.a.a.$ === 2) {
												return true;
											} else {
												break _v0$31;
											}
										case 3:
											if (_v0.b.a.a.$ === 3) {
												return true;
											} else {
												break _v0$31;
											}
										case 4:
											if (_v0.b.a.a.$ === 4) {
												return true;
											} else {
												break _v0$31;
											}
										default:
											break _v0$31;
									}
								} else {
									break _v0$31;
								}
							case 1:
								if (_v0.b.a.$ === 1) {
									return true;
								} else {
									break _v0$31;
								}
							case 2:
								if (_v0.b.a.$ === 2) {
									return true;
								} else {
									break _v0$31;
								}
							case 9:
								if (_v0.b.a.$ === 9) {
									return true;
								} else {
									break _v0$31;
								}
							case 10:
								if (_v0.b.a.$ === 10) {
									return true;
								} else {
									break _v0$31;
								}
							case 8:
								if (_v0.b.a.$ === 8) {
									return true;
								} else {
									break _v0$31;
								}
							case 3:
								if (_v0.b.a.$ === 3) {
									return true;
								} else {
									break _v0$31;
								}
							case 4:
								if (_v0.b.a.$ === 4) {
									return true;
								} else {
									break _v0$31;
								}
							case 5:
								if (_v0.b.a.$ === 5) {
									return true;
								} else {
									break _v0$31;
								}
							case 7:
								if (_v0.b.a.$ === 7) {
									return true;
								} else {
									break _v0$31;
								}
							default:
								break _v0$31;
						}
					} else {
						break _v0$31;
					}
				case 14:
					if (_v0.b.$ === 15) {
						var _v15 = _v0.a;
						return true;
					} else {
						break _v0$31;
					}
				case 13:
					if (_v0.b.$ === 13) {
						var _v16 = _v0.a;
						var _v17 = _v0.b;
						return true;
					} else {
						break _v0$31;
					}
				case 4:
					if (_v0.b.$ === 4) {
						switch (_v0.a.a.$) {
							case 1:
								if (_v0.b.a.$ === 1) {
									return true;
								} else {
									break _v0$31;
								}
							case 2:
								if (_v0.b.a.$ === 2) {
									switch (_v0.a.a.a.$) {
										case 0:
											if (!_v0.b.a.a.$) {
												return true;
											} else {
												break _v0$31;
											}
										case 1:
											if (_v0.b.a.a.$ === 1) {
												return true;
											} else {
												break _v0$31;
											}
										default:
											if (_v0.b.a.a.$ === 2) {
												return true;
											} else {
												break _v0$31;
											}
									}
								} else {
									break _v0$31;
								}
							case 3:
								if (_v0.b.a.$ === 3) {
									var _v11 = _v0.a.a;
									var _v12 = _v0.b.a;
									return true;
								} else {
									break _v0$31;
								}
							case 4:
								if (_v0.b.a.$ === 4) {
									return true;
								} else {
									break _v0$31;
								}
							case 5:
								if (_v0.b.a.$ === 5) {
									var _v13 = _v0.a.a;
									var _v14 = _v0.b.a;
									return true;
								} else {
									break _v0$31;
								}
							case 6:
								if (_v0.b.a.$ === 6) {
									return true;
								} else {
									break _v0$31;
								}
							case 10:
								if (_v0.b.a.$ === 10) {
									return true;
								} else {
									break _v0$31;
								}
							case 13:
								if (_v0.b.a.$ === 13) {
									return true;
								} else {
									break _v0$31;
								}
							case 11:
								if (_v0.b.a.$ === 11) {
									return true;
								} else {
									break _v0$31;
								}
							case 14:
								if (_v0.b.a.$ === 14) {
									return true;
								} else {
									break _v0$31;
								}
							default:
								break _v0$31;
						}
					} else {
						break _v0$31;
					}
				default:
					break _v0$31;
			}
		}
		return _Utils_eq(currentRoute, route);
	});
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$Patterns$NavigationDrawer$availableRouteWithPermissionsForEquipments = F2(
	function (currentRoute, user) {
		var routes = $author$project$Services$Models$iHaveAccess(
			{
				gZ: user.hg,
				hf: $author$project$Services$Models$EQUIPMENT_UPDATE(0),
				hQ: _Utils_ap(
					_List_fromArray(
						[
							$author$project$Route$Panel($author$project$Route$UpdateEquipment)
						]),
					_List_fromArray(
						[
							$author$project$Route$Panel($author$project$Route$UpdateRequestsEquipments)
						])),
				hR: _List_Nil
			});
		return $elm$core$List$isEmpty(routes) ? _List_Nil : _List_fromArray(
			[
				_Utils_Tuple3(
				A2(
					$elm$core$List$any,
					$author$project$Components$Patterns$NavigationDrawer$isActive(currentRoute),
					routes),
				$elm$core$Maybe$Just(
					_Utils_Tuple2('update-equipments', 'Atualizar equipamentos')),
				routes)
			]);
	});
var $author$project$Route$Audit = function (a) {
	return {$: 5, a: a};
};
var $author$project$Route$DetailedVehicle = function (a) {
	return {$: 3, a: a};
};
var $author$project$Route$DetailedVehicleV2 = function (a) {
	return {$: 4, a: a};
};
var $author$project$Route$Event = function (a) {
	return {$: 11, a: a};
};
var $author$project$Route$Usage = function (a) {
	return {$: 8, a: a};
};
var $author$project$Route$UsesPerClass = function (a) {
	return {$: 9, a: a};
};
var $author$project$Route$UsingDay = function (a) {
	return {$: 2, a: a};
};
var $author$project$Route$UsingLine = function (a) {
	return {$: 1, a: a};
};
var $author$project$Route$UsingOperator = function (a) {
	return {$: 3, a: a};
};
var $author$project$Route$UsingSession = function (a) {
	return {$: 4, a: a};
};
var $author$project$Route$UsingVehicle = function (a) {
	return {$: 0, a: a};
};
var $author$project$Services$Models$initQueriesAudit = {bl: $elm$core$Maybe$Nothing, bX: _List_Nil, bB: $elm$core$Maybe$Nothing, en: _List_Nil};
var $author$project$Services$Models$initQueriesDetailedVehicle = {bl: $elm$core$Maybe$Nothing, ac: $elm$core$Maybe$Nothing, kw: $elm$core$Maybe$Nothing, bB: $elm$core$Maybe$Nothing, k2: $elm$core$Maybe$Nothing, fN: $elm$core$Maybe$Nothing, hN: $elm$core$Maybe$Nothing};
var $author$project$Services$Models$initQueriesDetailedVehicleV2 = {bl: $elm$core$Maybe$Nothing, ac: $elm$core$Maybe$Nothing, kw: $elm$core$Maybe$Nothing, bB: $elm$core$Maybe$Nothing, k2: $elm$core$Maybe$Nothing, fN: $elm$core$Maybe$Nothing, hN: $elm$core$Maybe$Nothing};
var $author$project$Services$Models$initQueriesUsage = {ic: $elm$core$Maybe$Nothing, lX: $elm$core$Maybe$Nothing, bl: $elm$core$Maybe$Nothing, b3: $elm$core$Maybe$Nothing, g6: $elm$core$Maybe$Nothing, bv: 1, kx: $elm$core$Maybe$Nothing, bB: $elm$core$Maybe$Nothing, fN: $elm$core$Maybe$Nothing};
var $author$project$Services$Models$initQueriesUsesPerClass = {ic: $elm$core$Maybe$Nothing, bl: $elm$core$Maybe$Nothing, nB: $elm$core$Maybe$Nothing, b3: $elm$core$Maybe$Nothing, g6: $elm$core$Maybe$Nothing, bv: 1, bB: $elm$core$Maybe$Nothing, fN: $elm$core$Maybe$Nothing};
var $author$project$Services$Models$initQueriesUsingDayPerEvent = {bl: $elm$core$Maybe$Nothing, bB: $elm$core$Maybe$Nothing};
var $author$project$Services$Models$initQueriesUsingLinePerEvent = {bl: $elm$core$Maybe$Nothing, n2: _List_Nil, bB: $elm$core$Maybe$Nothing};
var $author$project$Services$Models$initQueriesUsingOperatorPerEvent = {bl: $elm$core$Maybe$Nothing, c5: _List_Nil, bB: $elm$core$Maybe$Nothing};
var $author$project$Services$Models$initQueriesUsingSessionPerEvent = {bl: $elm$core$Maybe$Nothing, n2: _List_Nil, c5: _List_Nil, bB: $elm$core$Maybe$Nothing, en: _List_Nil};
var $author$project$Services$Models$initQueriesUsingVehiclePerEvent = {bl: $elm$core$Maybe$Nothing, bB: $elm$core$Maybe$Nothing, en: _List_Nil};
var $elm$core$List$sortBy = _List_sortBy;
var $author$project$Components$Patterns$NavigationDrawer$titleBaseClass = function (route) {
	switch (route.$) {
		case 18:
			return _Utils_Tuple2('Funcionários', 'funcionarios');
		case 13:
			return _Utils_Tuple2('Comprar Créditos', 'comprar-creditos');
		case 14:
			return _Utils_Tuple2('Listas de pedidos', 'relatorios');
		case 16:
			return _Utils_Tuple2('Histórico de Compras', 'historico-de-compras');
		case 5:
			return _Utils_Tuple2('Guichê', 'apuracao-de-caixa');
		case 3:
			return _Utils_Tuple2('Home', 'home-page');
		case 21:
			switch (route.a.$) {
				case 0:
					return _Utils_Tuple2('Utilização por veículo', 'relatorios');
				case 12:
					var _v16 = route.a;
					return _Utils_Tuple2('Relatórios gerados', 'icon-md-pdf');
				case 1:
					return _Utils_Tuple2('Utilização por dia', 'relatorios');
				case 2:
					return _Utils_Tuple2('Utilização por linha', 'relatorios');
				case 8:
					return _Utils_Tuple2('Relatório de Usos', 'relatorios');
				case 9:
					return _Utils_Tuple2('Utilização por classes', 'relatorios');
				case 10:
					return _Utils_Tuple2('Biometria Facial', 'icon-md-compare');
				case 3:
					return _Utils_Tuple2('Veículo detalhado', 'relatorios');
				case 4:
					return _Utils_Tuple2('Veículo detalhado v2', 'relatorios');
				case 5:
					return _Utils_Tuple2('Resumidas', 'relatorios');
				case 6:
					return _Utils_Tuple2('Resumidas v2', 'relatorios');
				case 7:
					return _Utils_Tuple2('Administrativas', 'relatorios');
				default:
					switch (route.a.a.$) {
						case 0:
							return _Utils_Tuple2('Utilização por veículo', 'relatorios');
						case 1:
							return _Utils_Tuple2('Utilização por linha', 'relatorios');
						case 2:
							return _Utils_Tuple2('Utilização por dia', 'relatorios');
						case 3:
							return _Utils_Tuple2('Utilização por operador', 'relatorios');
						case 4:
							return _Utils_Tuple2('Utilização por sessão', 'relatorios');
						default:
							return _Utils_Tuple2('Auditorias', 'relatorios');
					}
			}
		case 4:
			switch (route.a.$) {
				case 1:
					return _Utils_Tuple2('Equipamentos', 'equipamentos');
				case 3:
					var _v1 = route.a;
					return _Utils_Tuple2('Malote', 'manage-pouch');
				case 4:
					return _Utils_Tuple2('Tarifa', 'comprar-creditos');
				case 5:
					var _v2 = route.a;
					return _Utils_Tuple2('Operadores', 'icon-engineering');
				case 8:
					var _v3 = route.a;
					return _Utils_Tuple2('Atualizar', 'icon-deployed-code-update');
				case 9:
					var _v4 = route.a;
					return _Utils_Tuple2('Solicitações', 'icon-md-orders');
				case 11:
					return _Utils_Tuple2('Motivos', 'icon-md-content-copy');
				case 12:
					var _v5 = route.a;
					return _Utils_Tuple2('Cobrança avulsa', 'icon-md-content-copy');
				case 14:
					return _Utils_Tuple2('Histórico', 'relatorios');
				case 13:
					return _Utils_Tuple2('Estoque', 'icon-md-inventory');
				case 6:
					return _Utils_Tuple2('Linhas', 'icon-md-route');
				case 0:
					return _Utils_Tuple2('Estornos', 'comprar-creditos');
				case 2:
					switch (route.a.a.$) {
						case 0:
							return _Utils_Tuple2('Conta', 'financial-account');
						case 1:
							return _Utils_Tuple2('Transações', 'financial-account');
						default:
							return _Utils_Tuple2('Transações pendentes', 'financial-account');
					}
				case 7:
					return _Utils_Tuple2('', '');
				default:
					switch (route.a.a.$) {
						case 0:
							var _v6 = route.a.a;
							return _Utils_Tuple2('Classes', 'icon-md-gavel');
						case 1:
							return _Utils_Tuple2('', '');
						default:
							var _v17 = route.a.a;
							return _Utils_Tuple2('', '');
					}
			}
		case 15:
			return _Utils_Tuple2('', '');
		case 19:
			switch (route.a.$) {
				case 0:
					return _Utils_Tuple2('Usuários do Sistema', 'funcionarios');
				case 2:
					var _v7 = route.a;
					return _Utils_Tuple2('Cartões', 'cartoes');
				case 4:
					var _v8 = route.a;
					return _Utils_Tuple2('Veículos', 'equipamentos');
				case 5:
					var _v9 = route.a;
					return _Utils_Tuple2('Relatórios', 'relatorios');
				case 9:
					return _Utils_Tuple2('Vendas', 'relatorios');
				case 6:
					var _v10 = route.a;
					return _Utils_Tuple2('', 'comprar-creditos');
				case 7:
					var _v11 = route.a;
					return _Utils_Tuple2('', 'relatorios');
				case 8:
					var _v12 = route.a;
					return _Utils_Tuple2('Sessões sem malote', 'relatorios');
				case 10:
					var _v13 = route.a;
					return _Utils_Tuple2('Guias', 'comprar-creditos');
				case 11:
					var _v14 = route.a;
					return _Utils_Tuple2('Boletos', 'comprar-creditos');
				case 12:
					var _v15 = route.a;
					return _Utils_Tuple2('Empresas', 'relatorios');
				case 1:
					var _v18 = route.a;
					return _Utils_Tuple2('', '');
				default:
					return _Utils_Tuple2('', '');
			}
		case 0:
			return _Utils_Tuple2('', '');
		case 1:
			return _Utils_Tuple2('', '');
		case 2:
			var maybeString = route.a;
			return _Utils_Tuple2('', '');
		case 6:
			return _Utils_Tuple2('', '');
		case 7:
			var string = route.a;
			var passengerRoute = route.b;
			return _Utils_Tuple2('', '');
		case 8:
			var string = route.a;
			return _Utils_Tuple2('', '');
		case 9:
			var maybeString = route.a;
			return _Utils_Tuple2('', '');
		case 10:
			return _Utils_Tuple2('', '');
		case 11:
			var queriesPosGarage = route.a;
			return _Utils_Tuple2('', '');
		case 12:
			var maybeString = route.a;
			return _Utils_Tuple2('', '');
		case 17:
			return _Utils_Tuple2('', '');
		case 20:
			return _Utils_Tuple2('', '');
		default:
			return _Utils_Tuple2('', '');
	}
};
var $author$project$Components$Patterns$NavigationDrawer$availableRouteWithPermissionsForEventReport = F3(
	function (currentRoute, currentCID, user) {
		var routes = _Utils_ap(
			_List_fromArray(
				[
					$author$project$Route$Report(
					$author$project$Route$Event(
						$author$project$Route$Audit($author$project$Services$Models$initQueriesAudit)))
				]),
			_Utils_ap(
				$author$project$Services$Models$iHaveAccess(
					{
						gZ: user.hg,
						hf: $author$project$Services$Models$REPORTS($author$project$Services$Models$DetailedVehicle),
						hQ: _List_fromArray(
							[
								$author$project$Route$Report(
								$author$project$Route$DetailedVehicleV2($author$project$Services$Models$initQueriesDetailedVehicleV2))
							]),
						hR: _List_Nil
					}),
				_Utils_ap(
					$author$project$Services$Models$iHaveAccess(
						{
							gZ: user.hg,
							hf: $author$project$Services$Models$REPORTS($author$project$Services$Models$DetailedVehicle),
							hQ: _List_fromArray(
								[
									$author$project$Route$Report(
									$author$project$Route$DetailedVehicle($author$project$Services$Models$initQueriesDetailedVehicle))
								]),
							hR: _List_Nil
						}),
					_Utils_ap(
						$author$project$Services$Models$iHaveAccess(
							{
								gZ: user.hg,
								hf: $author$project$Services$Models$REPORTS_EVENTS(4),
								hQ: _List_fromArray(
									[
										$author$project$Route$Report(
										$author$project$Route$Event(
											$author$project$Route$UsingSession($author$project$Services$Models$initQueriesUsingSessionPerEvent)))
									]),
								hR: _List_Nil
							}),
						_Utils_ap(
							$author$project$Services$Models$iHaveAccess(
								{
									gZ: user.hg,
									hf: $author$project$Services$Models$REPORTS_EVENTS(2),
									hQ: _List_fromArray(
										[
											$author$project$Route$Report(
											$author$project$Route$Event(
												$author$project$Route$UsingOperator($author$project$Services$Models$initQueriesUsingOperatorPerEvent)))
										]),
									hR: _List_Nil
								}),
							_Utils_ap(
								$author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$REPORTS_EVENTS(0),
										hQ: _List_fromArray(
											[
												$author$project$Route$Report(
												$author$project$Route$Event(
													$author$project$Route$UsingDay($author$project$Services$Models$initQueriesUsingDayPerEvent)))
											]),
										hR: _List_Nil
									}),
								_Utils_ap(
									$author$project$Services$Models$iHaveAccess(
										{
											gZ: user.hg,
											hf: $author$project$Services$Models$REPORTS_EVENTS(3),
											hQ: _List_fromArray(
												[
													$author$project$Route$Report(
													$author$project$Route$Event(
														$author$project$Route$UsingLine($author$project$Services$Models$initQueriesUsingLinePerEvent)))
												]),
											hR: _List_Nil
										}),
									_Utils_ap(
										$author$project$Services$Models$iHaveAccess(
											{
												gZ: user.hg,
												hf: $author$project$Services$Models$REPORTS_EVENTS(1),
												hQ: _List_fromArray(
													[
														$author$project$Route$Report(
														$author$project$Route$Event(
															$author$project$Route$UsingVehicle($author$project$Services$Models$initQueriesUsingVehiclePerEvent)))
													]),
												hR: _List_Nil
											}),
										_Utils_ap(
											$author$project$Services$Models$iHaveAccess(
												{
													gZ: user.hg,
													hf: $author$project$Services$Models$REPORTS($author$project$Services$Models$UsesClass),
													hQ: _List_fromArray(
														[
															$author$project$Route$Report(
															$author$project$Route$UsesPerClass($author$project$Services$Models$initQueriesUsesPerClass))
														]),
													hR: _List_Nil
												}),
											$author$project$Services$Models$iHaveAccess(
												{
													gZ: user.hg,
													hf: $author$project$Services$Models$REPORTS($author$project$Services$Models$Usage),
													hQ: _List_fromArray(
														[
															$author$project$Route$Report(
															$author$project$Route$Usage($author$project$Services$Models$initQueriesUsage))
														]),
													hR: _List_Nil
												}))))))))));
		var routesOrder = A2(
			$elm$core$List$sortBy,
			A2($elm$core$Basics$composeR, $author$project$Components$Patterns$NavigationDrawer$titleBaseClass, $elm$core$Tuple$first),
			routes);
		return $elm$core$List$isEmpty(routes) ? _List_Nil : _List_fromArray(
			[
				_Utils_Tuple3(
				A2(
					$elm$core$List$any,
					$author$project$Components$Patterns$NavigationDrawer$isActive(currentRoute),
					routes),
				$elm$core$Maybe$Just(
					_Utils_Tuple2('event-reports', 'Relatórios por eventos')),
				routesOrder)
			]);
	});
var $author$project$Route$FinancialAccount = function (a) {
	return {$: 0, a: a};
};
var $author$project$Route$FinancialPendingTransactions = function (a) {
	return {$: 2, a: a};
};
var $author$project$Route$FinancialTransactions = function (a) {
	return {$: 1, a: a};
};
var $author$project$Route$PanelFinancial = function (a) {
	return {$: 2, a: a};
};
var $author$project$Services$Financial$initQueriesFinancialAccount = {bl: $elm$core$Maybe$Nothing, bv: 1, bB: $elm$core$Maybe$Nothing};
var $author$project$Services$Financial$initQueriesFinancialPendingTransactions = {bl: $elm$core$Maybe$Nothing, bv: 1, jW: $elm$core$Maybe$Nothing, bB: $elm$core$Maybe$Nothing, kK: $elm$core$Maybe$Nothing};
var $author$project$Services$Financial$initQueriesFinancialTransactions = {gk: 20, bl: $elm$core$Maybe$Nothing, bv: 1, jW: $elm$core$Maybe$Nothing, bB: $elm$core$Maybe$Nothing, kK: $elm$core$Maybe$Nothing};
var $author$project$Components$Patterns$NavigationDrawer$availableRouteWithPermissionsForFinancial = F2(
	function (currentRoute, user) {
		var routes = _Utils_ap(
			$author$project$Services$Models$iHaveAccess(
				{
					gZ: user.hg,
					hf: $author$project$Services$Models$FINANCIAL(3),
					hQ: _List_fromArray(
						[
							$author$project$Route$Panel(
							$author$project$Route$PanelFinancial(
								$author$project$Route$FinancialPendingTransactions($author$project$Services$Financial$initQueriesFinancialPendingTransactions)))
						]),
					hR: _List_Nil
				}),
			_Utils_ap(
				$author$project$Services$Models$iHaveAccess(
					{
						gZ: user.hg,
						hf: $author$project$Services$Models$FINANCIAL(2),
						hQ: _List_fromArray(
							[
								$author$project$Route$Panel(
								$author$project$Route$PanelFinancial(
									$author$project$Route$FinancialTransactions($author$project$Services$Financial$initQueriesFinancialTransactions)))
							]),
						hR: _List_Nil
					}),
				$author$project$Services$Models$iHaveAccess(
					{
						gZ: user.hg,
						hf: $author$project$Services$Models$FINANCIAL(1),
						hQ: _List_fromArray(
							[
								$author$project$Route$Panel(
								$author$project$Route$PanelFinancial(
									$author$project$Route$FinancialAccount($author$project$Services$Financial$initQueriesFinancialAccount)))
							]),
						hR: _List_Nil
					})));
		return $elm$core$List$isEmpty(routes) ? _List_Nil : _List_fromArray(
			[
				_Utils_Tuple3(
				A2(
					$elm$core$List$any,
					$author$project$Components$Patterns$NavigationDrawer$isActive(currentRoute),
					routes),
				$elm$core$Maybe$Just(
					_Utils_Tuple2('financial', 'Financeiro')),
				routes)
			]);
	});
var $author$project$Components$Patterns$NavigationDrawer$availableRouteWithPermissionsForReport = F3(
	function (currentRoute, currentCID, user) {
		var routes = _List_Nil;
		var routesOrder = A2(
			$elm$core$List$sortBy,
			A2($elm$core$Basics$composeR, $author$project$Components$Patterns$NavigationDrawer$titleBaseClass, $elm$core$Tuple$first),
			routes);
		return $elm$core$List$isEmpty(routes) ? _List_Nil : _List_fromArray(
			[
				_Utils_Tuple3(
				A2(
					$elm$core$List$any,
					$author$project$Components$Patterns$NavigationDrawer$isActive(currentRoute),
					routes),
				$elm$core$Maybe$Just(
					_Utils_Tuple2('reports', 'Relatórios')),
				routesOrder)
			]);
	});
var $author$project$Route$AdministrativeSales = function (a) {
	return {$: 7, a: a};
};
var $author$project$Route$Reports = function (a) {
	return {$: 9, a: a};
};
var $author$project$Route$Sales = $elm$core$Basics$identity;
var $author$project$Route$SalesSummarized = function (a) {
	return {$: 5, a: a};
};
var $author$project$Route$SalesSummarizedV2 = function (a) {
	return {$: 6, a: a};
};
var $author$project$Services$Models$initQueriesAdministrativeSales = {bl: $elm$core$Maybe$Nothing, g6: _List_Nil, bB: $elm$core$Maybe$Nothing};
var $author$project$Services$Models$initQueriesSalesSummarized = {bl: $elm$core$Maybe$Nothing, bB: $elm$core$Maybe$Nothing};
var $author$project$Services$Models$initQueriesSalesV2 = {bl: $elm$core$Maybe$Nothing, bv: 1, bB: $elm$core$Maybe$Nothing};
var $author$project$Components$Patterns$NavigationDrawer$availableRouteWithPermissionsForSales = F3(
	function (currentRoute, currentCID, user) {
		var routes = _Utils_ap(
			$author$project$Services$Models$iHaveAccess(
				{
					gZ: user.hg,
					hf: $author$project$Services$Models$REPORTS($author$project$Services$Models$Sales),
					hQ: _List_fromArray(
						[
							A2(
							$author$project$Route$Admin,
							$author$project$Route$Reports($author$project$Services$Models$initQueriesSalesV2),
							currentCID)
						]),
					hR: _List_Nil
				}),
			_Utils_ap(
				$author$project$Services$Models$iHaveAccess(
					{
						gZ: user.hg,
						hf: $author$project$Services$Models$REPORTS($author$project$Services$Models$SalesSummary),
						hQ: _List_fromArray(
							[
								$author$project$Route$Report(
								$author$project$Route$SalesSummarizedV2($author$project$Services$Models$initQueriesSalesSummarized))
							]),
						hR: _List_Nil
					}),
				_Utils_ap(
					$author$project$Services$Models$iHaveAccess(
						{
							gZ: user.hg,
							hf: $author$project$Services$Models$REPORTS($author$project$Services$Models$SalesSummary),
							hQ: _List_fromArray(
								[
									$author$project$Route$Report(
									$author$project$Route$SalesSummarized($author$project$Services$Models$initQueriesSalesSummarized))
								]),
							hR: _List_Nil
						}),
					$author$project$Services$Models$iHaveAccess(
						{
							gZ: user.hg,
							hf: $author$project$Services$Models$REPORTS($author$project$Services$Models$SalesSummary),
							hQ: _List_fromArray(
								[
									$author$project$Route$Report(
									$author$project$Route$AdministrativeSales($author$project$Services$Models$initQueriesAdministrativeSales))
								]),
							hR: _List_Nil
						}))));
		return $elm$core$List$isEmpty(routes) ? _List_Nil : _List_fromArray(
			[
				_Utils_Tuple3(
				A2(
					$elm$core$List$any,
					$author$project$Components$Patterns$NavigationDrawer$isActive(currentRoute),
					routes),
				$elm$core$Maybe$Just(
					_Utils_Tuple2('sales-reports', 'Relatórios de vendas')),
				routes)
			]);
	});
var $author$project$Route$SessionsWithoutPouchReport = {$: 8};
var $author$project$Route$UsesPerDay = function (a) {
	return {$: 1, a: a};
};
var $author$project$Route$UsesPerLine = function (a) {
	return {$: 2, a: a};
};
var $author$project$Route$UsesPerVehicle = function (a) {
	return {$: 0, a: a};
};
var $author$project$Services$Models$initQueriesUsesPerDay = {bl: $elm$core$Maybe$Nothing, bB: $elm$core$Maybe$Nothing};
var $author$project$Services$Models$initQueriesUsesPerLine = {bl: $elm$core$Maybe$Nothing, bB: $elm$core$Maybe$Nothing};
var $author$project$Services$Models$initQueriesUsesPerVehicle = {bl: $elm$core$Maybe$Nothing, bB: $elm$core$Maybe$Nothing};
var $author$project$Components$Patterns$NavigationDrawer$availableRouteWithPermissionsForSessionReport = F3(
	function (currentRoute, currentCID, user) {
		var routes = _Utils_ap(
			$author$project$Services$Models$iHaveAccess(
				{
					gZ: user.hg,
					hf: $author$project$Services$Models$REPORTS(
						$author$project$Services$Models$UsesVehicles(0)),
					hQ: _List_fromArray(
						[
							$author$project$Route$Report(
							$author$project$Route$UsesPerVehicle($author$project$Services$Models$initQueriesUsesPerVehicle))
						]),
					hR: _List_Nil
				}),
			_Utils_ap(
				$author$project$Services$Models$iHaveAccess(
					{
						gZ: user.hg,
						hf: $author$project$Services$Models$REPORTS(
							$author$project$Services$Models$UsesDay(0)),
						hQ: _List_fromArray(
							[
								$author$project$Route$Report(
								$author$project$Route$UsesPerDay($author$project$Services$Models$initQueriesUsesPerDay))
							]),
						hR: _List_Nil
					}),
				_Utils_ap(
					$author$project$Services$Models$iHaveAccess(
						{
							gZ: user.hg,
							hf: $author$project$Services$Models$REPORTS(
								$author$project$Services$Models$UsesLine(0)),
							hQ: _List_fromArray(
								[
									$author$project$Route$Report(
									$author$project$Route$UsesPerLine($author$project$Services$Models$initQueriesUsesPerLine))
								]),
							hR: _List_Nil
						}),
					$author$project$Services$Models$iHaveAccess(
						{
							gZ: user.hg,
							hf: $author$project$Services$Models$REPORTS($author$project$Services$Models$SessionsWithoutPouch),
							hQ: _List_fromArray(
								[
									A2($author$project$Route$Admin, $author$project$Route$SessionsWithoutPouchReport, currentCID)
								]),
							hR: _List_Nil
						}))));
		var routesOrder = A2(
			$elm$core$List$sortBy,
			A2($elm$core$Basics$composeR, $author$project$Components$Patterns$NavigationDrawer$titleBaseClass, $elm$core$Tuple$first),
			routes);
		return $elm$core$List$isEmpty(routes) ? _List_Nil : _List_fromArray(
			[
				_Utils_Tuple3(
				A2(
					$elm$core$List$any,
					$author$project$Components$Patterns$NavigationDrawer$isActive(currentRoute),
					routes),
				$elm$core$Maybe$Just(
					_Utils_Tuple2('session-reports', 'Relatórios por sessões')),
				routesOrder)
			]);
	});
var $author$project$Services$Models$initQueriesDivergences = {lX: _List_Nil, iI: $elm$core$Maybe$Nothing, gk: 10, bl: $elm$core$Maybe$Nothing, iY: 0, b3: _List_Nil, g6: _List_Nil, bv: 1, kx: $elm$core$Maybe$Nothing, pJ: 10, bB: $elm$core$Maybe$Nothing, kT: 100, kY: $elm$core$Maybe$Nothing, qx: $elm$core$Maybe$Nothing, fN: _List_Nil};
var $author$project$Services$Models$initQueriesEquipmentsV2 = {kw: $elm$core$Maybe$Nothing, k2: $elm$core$Maybe$Nothing};
var $author$project$Services$Models$initQueriesHistory = {bK: _List_Nil, gk: 500, bl: $elm$core$Maybe$Nothing, bZ: _List_Nil, bv: 1, bB: $elm$core$Maybe$Nothing, kZ: $elm$core$Maybe$Nothing};
var $author$project$Services$Models$initQueriesManageFare = {mn: $elm$core$Maybe$Nothing, mo: $elm$core$Maybe$Nothing};
var $author$project$Services$Models$initQueriesManageLine = {mn: $elm$core$Maybe$Nothing, mo: $elm$core$Maybe$Nothing};
var $author$project$Services$Models$initQueriesReason = {hV: $elm$core$Maybe$Nothing};
var $author$project$Services$Models$initQueriesStock = {kw: $elm$core$Maybe$Nothing};
var $author$project$Services$Models$initQueriesUsers = {iI: $elm$core$Maybe$Nothing, mX: $elm$core$Maybe$Nothing, c3: $elm$core$Maybe$Nothing};
var $author$project$Components$Patterns$NavigationDrawer$availableRoutesWithPermission = F3(
	function (currentRoute, user, currentCID) {
		return _Utils_ap(
			_List_fromArray(
				[
					_Utils_Tuple3(
					false,
					$elm$core$Maybe$Nothing,
					_List_fromArray(
						[$author$project$Route$WelcomeBack]))
				]),
			_Utils_ap(
				$author$project$Services$Models$iHaveAccess(
					{
						gZ: user.hg,
						hf: $author$project$Services$Models$SYSTEM_USER(0),
						hQ: _List_fromArray(
							[
								_Utils_Tuple3(
								false,
								$elm$core$Maybe$Nothing,
								_List_fromArray(
									[
										A2(
										$author$project$Route$Admin,
										$author$project$Route$Users($author$project$Services$Models$initQueriesUsers),
										currentCID)
									]))
							]),
						hR: _List_Nil
					}),
				_Utils_ap(
					$author$project$Services$Models$iHaveAccess(
						{
							gZ: user.hg,
							hf: $author$project$Services$Models$OPERATORS(0),
							hQ: _List_fromArray(
								[
									_Utils_Tuple3(
									false,
									$elm$core$Maybe$Nothing,
									_List_fromArray(
										[
											$author$project$Route$Panel($author$project$Route$ManageOperators)
										]))
								]),
							hR: _List_Nil
						}),
					_Utils_ap(
						$author$project$Services$Models$iHaveAccess(
							{
								gZ: user.hg,
								hf: $author$project$Services$Models$EQUIPMENT(3),
								hQ: _List_fromArray(
									[
										_Utils_Tuple3(
										false,
										$elm$core$Maybe$Nothing,
										_List_fromArray(
											[
												$author$project$Route$Panel(
												$author$project$Route$EquipmentsV2($author$project$Services$Models$initQueriesEquipmentsV2))
											]))
									]),
								hR: _List_Nil
							}),
						_Utils_ap(
							$author$project$Services$Models$iHaveAccess(
								{
									gZ: user.hg,
									hf: $author$project$Services$Models$CLASS(1),
									hQ: _List_fromArray(
										[
											_Utils_Tuple3(
											false,
											$elm$core$Maybe$Nothing,
											_List_fromArray(
												[
													$author$project$Route$Panel(
													$author$project$Route$Classes($author$project$Route$ClassesList))
												]))
										]),
									hR: _List_Nil
								}),
							_Utils_ap(
								A2($author$project$Components$Patterns$NavigationDrawer$availableRouteWithPermissionsForEquipments, currentRoute, user),
								_Utils_ap(
									A2($author$project$Components$Patterns$NavigationDrawer$availableRouteWithPermissionsForFinancial, currentRoute, user),
									_Utils_ap(
										A3($author$project$Components$Patterns$NavigationDrawer$availableRouteWithPermissionsForSales, currentRoute, currentCID, user),
										_Utils_ap(
											A3($author$project$Components$Patterns$NavigationDrawer$availableRouteWithPermissionsForSessionReport, currentRoute, currentCID, user),
											_Utils_ap(
												A3($author$project$Components$Patterns$NavigationDrawer$availableRouteWithPermissionsForEventReport, currentRoute, currentCID, user),
												_Utils_ap(
													A3($author$project$Components$Patterns$NavigationDrawer$availableRouteWithPermissionsForReport, currentRoute, currentCID, user),
													_Utils_ap(
														$author$project$Services$Models$iHaveAccess(
															{
																gZ: user.hg,
																hf: $author$project$Services$Models$REPORT_PDF(0),
																hQ: _List_fromArray(
																	[
																		_Utils_Tuple3(
																		false,
																		$elm$core$Maybe$Nothing,
																		_List_fromArray(
																			[
																				$author$project$Route$Report($author$project$Route$PDFs)
																			]))
																	]),
																hR: _List_Nil
															}),
														_Utils_ap(
															$author$project$Services$Models$iHaveAccess(
																{
																	gZ: user.hg,
																	hf: $author$project$Services$Models$REVERSE(0),
																	hQ: _List_fromArray(
																		[
																			_Utils_Tuple3(
																			false,
																			$elm$core$Maybe$Nothing,
																			_List_fromArray(
																				[
																					$author$project$Route$Panel(
																					$author$project$Route$ReversalApproval(0))
																				]))
																		]),
																	hR: _List_Nil
																}),
															_Utils_ap(
																$author$project$Services$Models$iHaveAccess(
																	{
																		gZ: user.hg,
																		hf: $author$project$Services$Models$LINES(0),
																		hQ: _List_fromArray(
																			[
																				_Utils_Tuple3(
																				false,
																				$elm$core$Maybe$Nothing,
																				_List_fromArray(
																					[
																						$author$project$Route$Panel(
																						$author$project$Route$ManageLines($author$project$Services$Models$initQueriesManageLine))
																					]))
																			]),
																		hR: _List_Nil
																	}),
																_Utils_ap(
																	$author$project$Services$Models$iHaveAccess(
																		{
																			gZ: user.hg,
																			hf: $author$project$Services$Models$STOCK(0),
																			hQ: _List_fromArray(
																				[
																					_Utils_Tuple3(
																					false,
																					$elm$core$Maybe$Nothing,
																					_List_fromArray(
																						[
																							$author$project$Route$Panel(
																							$author$project$Route$Stock(
																								$author$project$Route$List($author$project$Services$Models$initQueriesStock)))
																						]))
																				]),
																			hR: _List_Nil
																		}),
																	_Utils_ap(
																		$author$project$Services$Models$iHaveAccess(
																			{
																				gZ: user.hg,
																				hf: $author$project$Services$Models$AVULSAS(0),
																				hQ: _List_fromArray(
																					[
																						_Utils_Tuple3(
																						false,
																						$elm$core$Maybe$Nothing,
																						_List_fromArray(
																							[
																								$author$project$Route$Panel($author$project$Route$SingleCharge)
																							]))
																					]),
																				hR: _List_Nil
																			}),
																		_Utils_ap(
																			$author$project$Services$Models$iHaveAccess(
																				{
																					gZ: user.hg,
																					hf: $author$project$Services$Models$REASONS(0),
																					hQ: _List_fromArray(
																						[
																							_Utils_Tuple3(
																							false,
																							$elm$core$Maybe$Nothing,
																							_List_fromArray(
																								[
																									$author$project$Route$Panel(
																									$author$project$Route$Reason($author$project$Services$Models$initQueriesReason))
																								]))
																						]),
																					hR: _List_Nil
																				}),
																			_Utils_ap(
																				$author$project$Services$Models$iHaveAccess(
																					{
																						gZ: user.hg,
																						hf: $author$project$Services$Models$BIOMETRY(0),
																						hQ: _List_fromArray(
																							[
																								_Utils_Tuple3(
																								false,
																								$elm$core$Maybe$Nothing,
																								_List_fromArray(
																									[
																										$author$project$Route$Report(
																										$author$project$Route$Divergences($author$project$Services$Models$initQueriesDivergences))
																									]))
																							]),
																						hR: _List_Nil
																					}),
																				_Utils_ap(
																					$author$project$Services$Models$iHaveAccess(
																						{
																							gZ: user.hg,
																							hf: $author$project$Services$Models$TARIFFS(0),
																							hQ: _List_fromArray(
																								[
																									_Utils_Tuple3(
																									false,
																									$elm$core$Maybe$Nothing,
																									_List_fromArray(
																										[
																											$author$project$Route$Panel(
																											$author$project$Route$ManageFare($author$project$Services$Models$initQueriesManageFare))
																										]))
																								]),
																							hR: _List_Nil
																						}),
																					_Utils_ap(
																						$author$project$Services$Models$iHaveAccess(
																							{
																								gZ: user.hg,
																								hf: $author$project$Services$Models$POUCH(0),
																								hQ: _List_fromArray(
																									[
																										_Utils_Tuple3(
																										false,
																										$elm$core$Maybe$Nothing,
																										_List_fromArray(
																											[
																												$author$project$Route$Panel($author$project$Route$ManagePouches)
																											]))
																									]),
																								hR: _List_Nil
																							}),
																						$author$project$Services$Models$iHaveAccess(
																							{
																								gZ: user.hg,
																								hf: $author$project$Services$Models$PASSENGER(0),
																								hQ: _List_fromArray(
																									[
																										_Utils_Tuple3(
																										false,
																										$elm$core$Maybe$Nothing,
																										_List_fromArray(
																											[
																												$author$project$Route$Panel(
																												$author$project$Route$History($author$project$Services$Models$initQueriesHistory))
																											]))
																									]),
																								hR: _List_Nil
																							})))))))))))))))))))));
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $author$project$Data$User$canEnterInAdminArea = function (user) {
	return A2($elm$core$List$member, $author$project$Data$Permission$BuzzaoAdmin, user.oU) || A2($elm$core$List$member, $author$project$Data$Permission$ConcessionaireAdmin, user.oU);
};
var $author$project$Components$Patterns$NavigationDrawer$availableRoutes = F3(
	function (currentRoute, user, cID) {
		var guicheRoute = $author$project$Services$Models$iHaveAccess(
			{
				gZ: user.hg,
				hf: $author$project$Services$Models$GUICHE(1),
				hQ: _List_fromArray(
					[
						_Utils_Tuple3(
						false,
						$elm$core$Maybe$Nothing,
						_List_fromArray(
							[$author$project$Route$Guiche]))
					]),
				hR: _List_Nil
			});
		return _Utils_ap(
			A3($author$project$Components$Patterns$NavigationDrawer$availableRoutesWithPermission, currentRoute, user, cID),
			function () {
				var _v0 = user.k$;
				switch (_v0.$) {
					case 0:
						return guicheRoute;
					case 1:
						return $author$project$Data$User$canEnterInAdminArea(user) ? _Utils_ap(
							A2($author$project$Components$Patterns$NavigationDrawer$adminRoutes, user, cID),
							guicheRoute) : guicheRoute;
					case 2:
						var record = _v0.a;
						return _Utils_ap(
							_List_fromArray(
								[
									_Utils_Tuple3(
									false,
									$elm$core$Maybe$Nothing,
									_List_fromArray(
										[
											A2($author$project$Route$EnterpriseDashboard, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing)
										])),
									_Utils_Tuple3(
									false,
									$elm$core$Maybe$Nothing,
									_List_fromArray(
										[$author$project$Route$SavedOrderLists])),
									_Utils_Tuple3(
									false,
									$elm$core$Maybe$Nothing,
									_List_fromArray(
										[$author$project$Route$EnterpriseHistory]))
								]),
							guicheRoute);
					default:
						return _Utils_ap(
							A2($author$project$Components$Patterns$NavigationDrawer$adminRoutes, user, cID),
							guicheRoute);
				}
			}());
	});
var $author$project$Components$Patterns$NavigationDrawer$currentConcessionaireId = function (route) {
	if (route.$ === 19) {
		var maybeId = route.b;
		return maybeId;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Services$Api$Concessionaire = F2(
	function (id, name) {
		return {dM: id, c3: name};
	});
var $author$project$Components$Patterns$NavigationDrawer$GotConcessionaires = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			A2(
				$elm$core$Task$onError,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
					$elm$core$Result$Err),
				A2(
					$elm$core$Task$andThen,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Ok),
					task)));
	});
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $elm$url$Url$Builder$crossOrigin = F3(
	function (prePath, pathSegments, parameters) {
		return prePath + ('/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters)));
	});
var $author$project$Constants$concessionaireServiceUrl = $elm$url$Url$Builder$crossOrigin('https://concessionaires.pazze.app');
var $elm$http$Http$Header = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$header = $elm$http$Http$Header;
var $author$project$Services$Api$authorizationHeader = function (token) {
	return A2($elm$http$Http$header, 'Authorization', 'Bearer ' + token);
};
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $author$project$Services$Api$DecodeError = function (a) {
	return {$: 7, a: a};
};
var $author$project$Services$Api$ServerError = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $author$project$Services$Api$decodeMetaDataAndBody = F3(
	function (decoder, meta, body) {
		var _v0 = A2($elm$json$Json$Decode$decodeString, decoder, body);
		if (!_v0.$) {
			var value = _v0.a;
			return $elm$core$Result$Ok(value);
		} else {
			var err = _v0.a;
			if (meta.cw === 208) {
				var _v1 = A2(
					$elm$json$Json$Decode$decodeString,
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string),
								A2($elm$json$Json$Decode$field, 'errorMessage', $elm$json$Json$Decode$string)
							])),
					body);
				if (!_v1.$) {
					var err_ = _v1.a;
					return $elm$core$Result$Err(
						A2($author$project$Services$Api$ServerError, meta, err_));
				} else {
					return $elm$core$Result$Err(
						$author$project$Services$Api$DecodeError(err));
				}
			} else {
				return $elm$core$Result$Err(
					$author$project$Services$Api$DecodeError(err));
			}
		}
	});
var $author$project$Services$Api$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $author$project$Services$Api$ConcessionaireNotSelected = function (a) {
	return {$: 8, a: a};
};
var $author$project$Services$Api$NetworkError = {$: 2};
var $author$project$Services$Api$NotFound = {$: 4};
var $author$project$Services$Api$ServerErrorDecodeError = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Services$Api$Timeout = {$: 1};
var $author$project$Services$Api$Unauthorized = {$: 3};
var $author$project$Services$Api$decoderConcessionaire = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'name',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'id',
		$elm$json$Json$Decode$string,
		'',
		$elm$json$Json$Decode$succeed($author$project$Services$Api$Concessionaire)));
var $author$project$Services$Api$responseToResult = F2(
	function (response, onGoodStatus) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$author$project$Services$Api$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($author$project$Services$Api$Timeout);
			case 2:
				return $elm$core$Result$Err($author$project$Services$Api$NetworkError);
			case 3:
				var meta = response.a;
				var body = response.b;
				var _v1 = meta.cw;
				switch (_v1) {
					case 401:
						return $elm$core$Result$Err($author$project$Services$Api$Unauthorized);
					case 404:
						return $elm$core$Result$Err($author$project$Services$Api$NotFound);
					case 403:
						var _v2 = _Utils_Tuple3(
							A2(
								$elm$json$Json$Decode$decodeString,
								A2(
									$elm$json$Json$Decode$field,
									'data',
									$elm$json$Json$Decode$list($author$project$Services$Api$decoderConcessionaire)),
								body),
							A2(
								$elm$json$Json$Decode$decodeString,
								A2($elm$json$Json$Decode$field, 'errorMessage', $elm$json$Json$Decode$string),
								body),
							A2(
								$elm$json$Json$Decode$decodeString,
								A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string),
								body));
						if (!_v2.a.$) {
							var err = _v2.a.a;
							return $elm$core$Result$Err(
								$author$project$Services$Api$ConcessionaireNotSelected(err));
						} else {
							if (!_v2.c.$) {
								var message = _v2.c.a;
								return $elm$core$Result$Err(
									A2($author$project$Services$Api$ServerError, meta, message));
							} else {
								if (!_v2.b.$) {
									var err = _v2.b.a;
									return $elm$core$Result$Err(
										A2($author$project$Services$Api$ServerError, meta, err));
								} else {
									var err = _v2.b.a;
									return $elm$core$Result$Err(
										A2($author$project$Services$Api$ServerErrorDecodeError, meta, err));
								}
							}
						}
					default:
						var _v3 = _Utils_Tuple2(
							A2(
								$elm$json$Json$Decode$decodeString,
								A2($elm$json$Json$Decode$field, 'errorMessage', $elm$json$Json$Decode$string),
								body),
							A2(
								$elm$json$Json$Decode$decodeString,
								A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string),
								body));
						if (!_v3.b.$) {
							var message = _v3.b.a;
							return $elm$core$Result$Err(
								A2($author$project$Services$Api$ServerError, meta, message));
						} else {
							if (!_v3.a.$) {
								var err = _v3.a.a;
								return $elm$core$Result$Err(
									A2($author$project$Services$Api$ServerError, meta, err));
							} else {
								var err = _v3.a.a;
								return $elm$core$Result$Err(
									A2($author$project$Services$Api$ServerErrorDecodeError, meta, err));
							}
						}
				}
			default:
				var metadata = response.a;
				var body = response.b;
				return A2(onGoodStatus, metadata, body);
		}
	});
var $elm$http$Http$stringResolver = A2(_Http_expect, '', $elm$core$Basics$identity);
var $author$project$Services$Api$resolver = function (onGoodStatus) {
	return $elm$http$Http$stringResolver(
		function (response) {
			return A2($author$project$Services$Api$responseToResult, response, onGoodStatus);
		});
};
var $author$project$Services$Api$jsonResolver = function (decoder) {
	return $author$project$Services$Api$resolver(
		$author$project$Services$Api$decodeMetaDataAndBody(decoder));
};
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $elm$core$Task$fail = _Scheduler_fail;
var $elm$http$Http$resultToTask = function (result) {
	if (!result.$) {
		var a = result.a;
		return $elm$core$Task$succeed(a);
	} else {
		var x = result.a;
		return $elm$core$Task$fail(x);
	}
};
var $elm$http$Http$task = function (r) {
	return A3(
		_Http_toTask,
		0,
		$elm$http$Http$resultToTask,
		{ll: false, lG: r.lG, m9: r.d6, nG: r.nG, of: r.of, p5: r.p5, qi: $elm$core$Maybe$Nothing, qt: r.qt});
};
var $author$project$Services$Api$getTask = function (options) {
	return $elm$http$Http$task(
		{
			lG: $elm$http$Http$emptyBody,
			nG: A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeR, $author$project$Services$Api$authorizationHeader, $elm$core$List$singleton),
					options.kU)),
			of: 'GET',
			d6: $author$project$Services$Api$jsonResolver(options.mz),
			p5: $elm$core$Maybe$Nothing,
			qt: options.qt
		});
};
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $author$project$Components$Patterns$NavigationDrawer$initCmd = function (user) {
	var _v0 = user.k$;
	if (_v0.$ === 3) {
		return A2(
			$elm$core$Task$attempt,
			$author$project$Components$Patterns$NavigationDrawer$GotConcessionaires,
			$author$project$Services$Api$getTask(
				{
					mz: $elm$json$Json$Decode$list(
						A3(
							$elm$json$Json$Decode$map2,
							$author$project$Services$Api$Concessionaire,
							A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
							A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string))),
					kU: $elm$core$Maybe$Just(user.kU),
					qt: A2(
						$author$project$Constants$concessionaireServiceUrl,
						_List_fromArray(
							['api', 'v1', 'concessionaires']),
						_List_Nil)
				}));
	} else {
		return $elm$core$Platform$Cmd$none;
	}
};
var $author$project$Components$Patterns$NavigationDrawer$init = F2(
	function (user, shared) {
		return _Utils_Tuple2(
			{
				bR: _List_Nil,
				cN: $author$project$Components$Patterns$NavigationDrawer$currentConcessionaireId(shared.pv),
				d7: A3(
					$author$project$Components$Patterns$NavigationDrawer$availableRoutes,
					shared.pv,
					user,
					$author$project$Components$Patterns$NavigationDrawer$currentConcessionaireId(shared.pv))
			},
			$author$project$Components$Patterns$NavigationDrawer$initCmd(user));
	});
var $author$project$Shared$NoOp = {$: 0};
var $author$project$Pages$RedirectPage = {$: 57};
var $author$project$Pages$AdminMsg = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$AdminPage = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Services$Models$Cashier = 1;
var $author$project$Pages$ChangePasswordPage = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$EnterpriseDashboardMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$EnterpriseDashboardPage = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$EnterpriseHistoryMsg = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$EnterpriseHistoryPage = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$EnterpriseRegisterMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$EnterpriseRegisterPage = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$Pages$EquipmentsMsg = function (a) {
	return {$: 20, a: a};
};
var $author$project$Pages$EquipmentsPage = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$FinancialAccountMsg = function (a) {
	return {$: 52, a: a};
};
var $author$project$Pages$FinancialAccountPage = function (a) {
	return {$: 51, a: a};
};
var $author$project$Pages$FinancialPendingTransactionsMsg = function (a) {
	return {$: 54, a: a};
};
var $author$project$Pages$FinancialPendingTransactionsPage = function (a) {
	return {$: 53, a: a};
};
var $author$project$Pages$FinancialTransactionsMsg = function (a) {
	return {$: 53, a: a};
};
var $author$project$Pages$FinancialTransactionsPage = function (a) {
	return {$: 52, a: a};
};
var $author$project$Pages$HistoryMsg = function (a) {
	return {$: 33, a: a};
};
var $author$project$Pages$HistoryPage = function (a) {
	return {$: 32, a: a};
};
var $author$project$Pages$HomeWelcomeBackMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$HomeWelcomeBackPage = function (a) {
	return {$: 4, a: a};
};
var $author$project$Route$Login = {$: 0};
var $author$project$Pages$LoginPage = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$ManageFareMsg = function (a) {
	return {$: 24, a: a};
};
var $author$project$Pages$ManageFarePage = function (a) {
	return {$: 23, a: a};
};
var $author$project$Pages$ManageLinesMsg = function (a) {
	return {$: 32, a: a};
};
var $author$project$Pages$ManageLinesPage = function (a) {
	return {$: 31, a: a};
};
var $author$project$Pages$ManageOperatorsMsg = function (a) {
	return {$: 25, a: a};
};
var $author$project$Pages$ManageOperatorsPage = function (a) {
	return {$: 24, a: a};
};
var $author$project$Pages$ManagePouchesMsg = function (a) {
	return {$: 23, a: a};
};
var $author$project$Pages$ManagePouchesPage = function (a) {
	return {$: 22, a: a};
};
var $author$project$Pages$MyAccountMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$MyAccountPage = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$NotFoundPage = {$: 56};
var $author$project$Pages$PanelClassesMsg = function (a) {
	return {$: 55, a: a};
};
var $author$project$Pages$PanelClassesPage = function (a) {
	return {$: 54, a: a};
};
var $author$project$Pages$PosCloseCashierMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$PosCloseCashierPage = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$PosEditMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$PosEditPage = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$PosGarageMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$PosGaragePage = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$PosGuicheMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$PosGuichePage = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$PosLocalizeMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$PosLocalizePage = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$PosPassengerMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$PosPassengerPage = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Pages$PosRegisterMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$PosRegisterPage = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$ReasonMsg = function (a) {
	return {$: 27, a: a};
};
var $author$project$Pages$ReasonPage = function (a) {
	return {$: 26, a: a};
};
var $author$project$Pages$RecoverPasswordPage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$ReportAdministrativeSalesMsg = function (a) {
	return {$: 51, a: a};
};
var $author$project$Pages$ReportAdministrativeSalesPage = function (a) {
	return {$: 50, a: a};
};
var $author$project$Pages$ReportAuditMsg = function (a) {
	return {$: 41, a: a};
};
var $author$project$Pages$ReportAuditPage = function (a) {
	return {$: 40, a: a};
};
var $author$project$Pages$ReportDetailedVehicleMsg = function (a) {
	return {$: 47, a: a};
};
var $author$project$Pages$ReportDetailedVehiclePage = function (a) {
	return {$: 46, a: a};
};
var $author$project$Pages$ReportDetailedVehicleV2Msg = function (a) {
	return {$: 48, a: a};
};
var $author$project$Pages$ReportDetailedVehicleV2Page = function (a) {
	return {$: 47, a: a};
};
var $author$project$Pages$ReportDivergencesMsg = function (a) {
	return {$: 45, a: a};
};
var $author$project$Pages$ReportDivergencesPage = function (a) {
	return {$: 44, a: a};
};
var $author$project$Pages$ReportEventUsingDayMsg = function (a) {
	return {$: 38, a: a};
};
var $author$project$Pages$ReportEventUsingDayPage = function (a) {
	return {$: 37, a: a};
};
var $author$project$Pages$ReportEventUsingLineMsg = function (a) {
	return {$: 37, a: a};
};
var $author$project$Pages$ReportEventUsingLinePage = function (a) {
	return {$: 36, a: a};
};
var $author$project$Pages$ReportEventUsingOperatorMsg = function (a) {
	return {$: 39, a: a};
};
var $author$project$Pages$ReportEventUsingOperatorPage = function (a) {
	return {$: 38, a: a};
};
var $author$project$Pages$ReportEventUsingSessionMsg = function (a) {
	return {$: 40, a: a};
};
var $author$project$Pages$ReportEventUsingSessionPage = function (a) {
	return {$: 39, a: a};
};
var $author$project$Pages$ReportEventUsingVehicleMsg = function (a) {
	return {$: 36, a: a};
};
var $author$project$Pages$ReportEventUsingVehiclePage = function (a) {
	return {$: 35, a: a};
};
var $author$project$Pages$ReportPDFsMsg = function (a) {
	return {$: 35, a: a};
};
var $author$project$Pages$ReportPDFsPage = function (a) {
	return {$: 34, a: a};
};
var $author$project$Pages$ReportSalesSummarizedMsg = function (a) {
	return {$: 49, a: a};
};
var $author$project$Pages$ReportSalesSummarizedPage = function (a) {
	return {$: 48, a: a};
};
var $author$project$Pages$ReportSalesSummarizedV2Msg = function (a) {
	return {$: 50, a: a};
};
var $author$project$Pages$ReportSalesSummarizedV2Page = function (a) {
	return {$: 49, a: a};
};
var $author$project$Pages$ReportUsageMsg = function (a) {
	return {$: 46, a: a};
};
var $author$project$Pages$ReportUsagePage = function (a) {
	return {$: 45, a: a};
};
var $author$project$Pages$ReportUsesPerClassMsg = function (a) {
	return {$: 44, a: a};
};
var $author$project$Pages$ReportUsesPerClassPage = function (a) {
	return {$: 43, a: a};
};
var $author$project$Pages$ReportUsesPerDayMsg = function (a) {
	return {$: 42, a: a};
};
var $author$project$Pages$ReportUsesPerDayPage = function (a) {
	return {$: 41, a: a};
};
var $author$project$Pages$ReportUsesPerLineMsg = function (a) {
	return {$: 43, a: a};
};
var $author$project$Pages$ReportUsesPerLinePage = function (a) {
	return {$: 42, a: a};
};
var $author$project$Pages$ReportUsesPerVehicleMsg = function (a) {
	return {$: 34, a: a};
};
var $author$project$Pages$ReportUsesPerVehiclePage = function (a) {
	return {$: 33, a: a};
};
var $author$project$Pages$ReversalApprovalCashierMsg = function (a) {
	return {$: 22, a: a};
};
var $author$project$Pages$ReversalApprovalCashierPage = function (a) {
	return {$: 21, a: a};
};
var $author$project$Pages$ReversalApprovalSystemMsg = function (a) {
	return {$: 21, a: a};
};
var $author$project$Pages$ReversalApprovalSystemPage = function (a) {
	return {$: 20, a: a};
};
var $author$project$Pages$SavedOrderDetailMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$SavedOrderDetailPage = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$SavedOrderListsMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$SavedOrderListsPage = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$SingleChargeMsg = function (a) {
	return {$: 28, a: a};
};
var $author$project$Pages$SingleChargePage = function (a) {
	return {$: 27, a: a};
};
var $author$project$Pages$StockDetailsMsg = function (a) {
	return {$: 30, a: a};
};
var $author$project$Pages$StockDetailsPage = function (a) {
	return {$: 29, a: a};
};
var $author$project$Pages$StockListMsg = function (a) {
	return {$: 29, a: a};
};
var $author$project$Pages$StockListPage = function (a) {
	return {$: 28, a: a};
};
var $author$project$Pages$UpdateEquipmentMsg = function (a) {
	return {$: 26, a: a};
};
var $author$project$Pages$UpdateEquipmentPage = function (a) {
	return {$: 25, a: a};
};
var $author$project$Pages$UpdateRequestsEquipmentsMsg = function (a) {
	return {$: 31, a: a};
};
var $author$project$Pages$UpdateRequestsEquipmentsPage = function (a) {
	return {$: 30, a: a};
};
var $author$project$Pages$ZenviaChatPage = {$: 55};
var $author$project$Pages$Admin$AccountabilityReportMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Admin$AccountabilityReportPage = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Admin$CardExtractMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$CardExtractPage = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$Admin$CardsMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$CardsPage = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $author$project$Pages$Admin$CompanyOrdersMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Admin$CompanyOrdersPage = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Admin$EquipmentsMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Admin$EquipmentsPage = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$PaymentBilletsMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Admin$PaymentBilletsPage = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Admin$PaymentGuidesMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Admin$PaymentGuidesPage = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Admin$Redirect = {$: 0};
var $author$project$Pages$Admin$SalesReportMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Admin$SalesReportPage = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Admin$SalesReportV2Msg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Admin$SalesReportV2Page = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Admin$SessionsReportMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Admin$SessionsReportPage = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Admin$SessionsWithoutPouchReportMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Admin$SessionsWithoutPouchReportPage = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Admin$UsersMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$UsersPage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$VehiclesMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Admin$VehiclesPage = F4(
	function (a, b, c, d) {
		return {$: 5, a: a, b: b, c: c, d: d};
	});
var $author$project$Pages$Admin$AccountabilityReport$GotTime = function (a) {
	return {$: 0, a: a};
};
var $krisajenkins$remotedata$RemoteData$NotAsked = {$: 0};
var $Gizra$elm_debouncer$Debouncer$Internal$Config = $elm$core$Basics$identity;
var $Gizra$elm_debouncer$Debouncer$Internal$lastInput = F2(
	function (i, o) {
		return $elm$core$Maybe$Just(i);
	});
var $Gizra$elm_debouncer$Debouncer$Internal$manual = {bJ: $Gizra$elm_debouncer$Debouncer$Internal$lastInput, aw: $elm$core$Maybe$Nothing, ax: $elm$core$Maybe$Nothing, aK: $elm$core$Maybe$Nothing};
var $Gizra$elm_debouncer$Debouncer$Basic$manual = $Gizra$elm_debouncer$Debouncer$Internal$manual;
var $Gizra$elm_debouncer$Debouncer$Internal$settleWhenQuietFor = F2(
	function (time, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{aK: time});
	});
var $Gizra$elm_debouncer$Debouncer$Basic$settleWhenQuietFor = $Gizra$elm_debouncer$Debouncer$Internal$settleWhenQuietFor;
var $Gizra$elm_debouncer$Debouncer$Basic$debounce = function (interval) {
	return A2(
		$Gizra$elm_debouncer$Debouncer$Basic$settleWhenQuietFor,
		$elm$core$Maybe$Just(interval),
		$Gizra$elm_debouncer$Debouncer$Basic$manual);
};
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $Gizra$elm_debouncer$Debouncer$Internal$Debouncer = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $Gizra$elm_debouncer$Debouncer$Internal$Settled = {$: 0};
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $Gizra$elm_debouncer$Debouncer$Internal$nothingIfNegative = $elm$core$Maybe$andThen(
	function (num) {
		return (num < 0) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(num);
	});
var $Gizra$elm_debouncer$Debouncer$Internal$sanitizeConfig = function (_v0) {
	var config = _v0;
	return {
		bJ: config.bJ,
		aw: $Gizra$elm_debouncer$Debouncer$Internal$nothingIfNegative(config.aw),
		ax: $Gizra$elm_debouncer$Debouncer$Internal$nothingIfNegative(config.ax),
		aK: $Gizra$elm_debouncer$Debouncer$Internal$nothingIfNegative(config.aK)
	};
};
var $Gizra$elm_debouncer$Debouncer$Internal$toDebouncer = function (config) {
	return A2(
		$Gizra$elm_debouncer$Debouncer$Internal$Debouncer,
		$Gizra$elm_debouncer$Debouncer$Internal$sanitizeConfig(config),
		$Gizra$elm_debouncer$Debouncer$Internal$Settled);
};
var $Gizra$elm_debouncer$Debouncer$Basic$toDebouncer = $Gizra$elm_debouncer$Debouncer$Internal$toDebouncer;
var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
var $author$project$Pages$Admin$AccountabilityReport$init = function (_v0) {
	return _Utils_Tuple2(
		{
			cO: $elm$core$Maybe$Nothing,
			iU: $Gizra$elm_debouncer$Debouncer$Basic$toDebouncer(
				$Gizra$elm_debouncer$Debouncer$Basic$debounce(500)),
			cf: '',
			ck: $krisajenkins$remotedata$RemoteData$NotAsked,
			fq: '',
			hw: 0,
			co: '',
			kS: $elm$time$Time$utc,
			em: ''
		},
		A2(
			$elm$core$Task$perform,
			$author$project$Pages$Admin$AccountabilityReport$GotTime,
			A3(
				$elm$core$Task$map2,
				F2(
					function (now, timezone) {
						return {e8: now, kS: timezone};
					}),
				$elm$time$Time$now,
				$elm$time$Time$here)));
};
var $author$project$Pages$Admin$CardExtract$GotTime = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$CardExtract$initModel = {cH: $krisajenkins$remotedata$RemoteData$NotAsked, bq: '', az: false, b1: false, cp: '', bC: '', a9: $krisajenkins$remotedata$RemoteData$NotAsked};
var $author$project$Pages$Admin$CardExtract$init = F2(
	function (user, cardId) {
		return _Utils_Tuple2(
			$author$project$Pages$Admin$CardExtract$initModel,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Task$perform,
						$author$project$Pages$Admin$CardExtract$GotTime,
						A3(
							$elm$core$Task$map2,
							F2(
								function (now, timezone) {
									return {e8: now, kS: timezone};
								}),
							$elm$time$Time$now,
							$elm$time$Time$here))
					])));
	});
var $krisajenkins$remotedata$RemoteData$Loading = {$: 1};
var $author$project$Pages$Admin$Cards$ReceivedCards = function (a) {
	return {$: 0, a: a};
};
var $author$project$Services$Concessionaire$Card = F6(
	function (id, serial, name, status, emission, classes) {
		return {dv: classes, mZ: emission, dM: id, c3: name, kw: serial, kK: status};
	});
var $author$project$Data$Passenger$Block = 0;
var $author$project$Data$Passenger$RequestBlock = 2;
var $author$project$Data$Passenger$RequestUnblock = 3;
var $author$project$Data$Passenger$Unblock = 1;
var $author$project$Data$Passenger$blockStatusDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'block':
				return $elm$json$Json$Decode$succeed(0);
			case 'unblock':
				return $elm$json$Json$Decode$succeed(1);
			case '':
				return $elm$json$Json$Decode$succeed(1);
			case 'request_block':
				return $elm$json$Json$Decode$succeed(2);
			case 'request_unblock':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('invalid block status');
		}
	},
	$elm$json$Json$Decode$string);
var $elm$json$Json$Decode$map3 = _Json_map3;
var $elm$json$Json$Decode$map6 = _Json_map6;
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$parser$Parser$ExpectingEnd = {$: 10};
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {ir: col, me: contextStack, j$: problem, ki: row};
	});
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.ki, s.ir, x, s.h));
	});
var $elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			$elm$core$String$length(s.c),
			s.oq) ? A3($elm$parser$Parser$Advanced$Good, false, 0, s) : A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.c);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.oq, offset) < 0,
					0,
					{ir: col, h: s0.h, i: s0.i, oq: offset, ki: row, c: s0.c});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.oq, s.ki, s.ir, s);
	};
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3($elm$core$String$slice, s0.oq, s1.oq, s0.c),
						a),
					s1);
			}
		};
	});
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $elm$core$Basics$round = _Basics_round;
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $elm$core$String$toFloat = _String_toFloat;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs = A2(
	$elm$parser$Parser$andThen,
	function (str) {
		if ($elm$core$String$length(str) <= 9) {
			var _v0 = $elm$core$String$toFloat('0.' + str);
			if (!_v0.$) {
				var floatVal = _v0.a;
				return $elm$parser$Parser$succeed(
					$elm$core$Basics$round(floatVal * 1000));
			} else {
				return $elm$parser$Parser$problem('Invalid float: \"' + (str + '\"'));
			}
		} else {
			return $elm$parser$Parser$problem(
				'Expected at most 9 digits, but got ' + $elm$core$String$fromInt(
					$elm$core$String$length(str)));
		}
	},
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompWhile($elm$core$Char$isDigit)));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts = F6(
	function (monthYearDayMs, hour, minute, second, ms, utcOffsetMinutes) {
		return $elm$time$Time$millisToPosix((((monthYearDayMs + (((hour * 60) * 60) * 1000)) + (((minute - utcOffsetMinutes) * 60) * 1000)) + (second * 1000)) + ms);
	});
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $elm$parser$Parser$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$core$String$append = _String_append;
var $elm$parser$Parser$UnexpectedChar = {$: 11};
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.oq, s.c);
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{ir: 1, h: s.h, i: s.i, oq: s.oq + 1, ki: s.ki + 1, c: s.c}) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{ir: s.ir + 1, h: s.h, i: s.i, oq: newOffset, ki: s.ki, c: s.c}));
		};
	});
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var parse = _v0;
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p1 = _v1.a;
				var step = _v1.b;
				var s1 = _v1.c;
				if (!step.$) {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3($elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var $elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return function (s) {
			return A4($elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
		};
	});
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$toAdvancedStep = function (step) {
	if (!step.$) {
		var s = step.a;
		return $elm$parser$Parser$Advanced$Loop(s);
	} else {
		var a = step.a;
		return $elm$parser$Parser$Advanced$Done(a);
	}
};
var $elm$parser$Parser$loop = F2(
	function (state, callback) {
		return A2(
			$elm$parser$Parser$Advanced$loop,
			state,
			function (s) {
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$toAdvancedStep,
					callback(s));
			});
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt = function (quantity) {
	var helper = function (str) {
		if (_Utils_eq(
			$elm$core$String$length(str),
			quantity)) {
			var _v0 = $elm$core$String$toInt(str);
			if (!_v0.$) {
				var intVal = _v0.a;
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$Done,
					$elm$parser$Parser$succeed(intVal));
			} else {
				return $elm$parser$Parser$problem('Invalid integer: \"' + (str + '\"'));
			}
		} else {
			return A2(
				$elm$parser$Parser$map,
				function (nextChar) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$String$append, str, nextChar));
				},
				$elm$parser$Parser$getChompedString(
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
		}
	};
	return A2($elm$parser$Parser$loop, '', helper);
};
var $elm$parser$Parser$ExpectingSymbol = function (a) {
	return {$: 8, a: a};
};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$core$Basics$not = _Basics_not;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.oq, s.ki, s.ir, s.c);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{ir: newCol, h: s.h, i: s.i, oq: newOffset, ki: newRow, c: s.c});
	};
};
var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
var $elm$parser$Parser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear = 1970;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay = function (day) {
	return $elm$parser$Parser$problem(
		'Invalid day: ' + $elm$core$String$fromInt(day));
};
var $elm$core$Basics$modBy = _Basics_modBy;
var $elm$core$Basics$neq = _Utils_notEqual;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear = function (year) {
	return (!A2($elm$core$Basics$modBy, 4, year)) && ((!(!A2($elm$core$Basics$modBy, 100, year))) || (!A2($elm$core$Basics$modBy, 400, year)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore = function (y1) {
	var y = y1 - 1;
	return (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay = 86400000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear = 31536000000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay = function (_v0) {
	var year = _v0.a;
	var month = _v0.b;
	var dayInMonth = _v0.c;
	if (dayInMonth < 0) {
		return $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth);
	} else {
		var succeedWith = function (extraMs) {
			var yearMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear * (year - $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear);
			var days = ((month < 3) || (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year))) ? (dayInMonth - 1) : dayInMonth;
			var dayMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay * (days + ($rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore(year) - $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore($rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear)));
			return $elm$parser$Parser$succeed((extraMs + yearMs) + dayMs);
		};
		switch (month) {
			case 1:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(0);
			case 2:
				return ((dayInMonth > 29) || ((dayInMonth === 29) && (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year)))) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(2678400000);
			case 3:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(5097600000);
			case 4:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(7776000000);
			case 5:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(10368000000);
			case 6:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(13046400000);
			case 7:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(15638400000);
			case 8:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(18316800000);
			case 9:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(20995200000);
			case 10:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(23587200000);
			case 11:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(26265600000);
			case 12:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(28857600000);
			default:
				return $elm$parser$Parser$problem(
					'Invalid month: \"' + ($elm$core$String$fromInt(month) + '\"'));
		}
	}
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs = A2(
	$elm$parser$Parser$andThen,
	$rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F3(
						function (year, month, day) {
							return _Utils_Tuple3(year, month, day);
						})),
				$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(4)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed($elm$core$Basics$identity),
							$elm$parser$Parser$symbol('-')),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
					]))),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed($elm$core$Basics$identity),
						$elm$parser$Parser$symbol('-')),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
				]))));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes = function () {
	var utcOffsetMinutesFromParts = F3(
		function (multiplier, hours, minutes) {
			return (multiplier * (hours * 60)) + minutes;
		});
	return A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$map,
					function (_v0) {
						return 0;
					},
					$elm$parser$Parser$symbol('Z')),
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed(utcOffsetMinutesFromParts),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$map,
										function (_v1) {
											return 1;
										},
										$elm$parser$Parser$symbol('+')),
										A2(
										$elm$parser$Parser$map,
										function (_v2) {
											return -1;
										},
										$elm$parser$Parser$symbol('-'))
									]))),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$ignorer,
									$elm$parser$Parser$succeed($elm$core$Basics$identity),
									$elm$parser$Parser$symbol(':')),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
								$elm$parser$Parser$succeed(0)
							]))),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(0),
					$elm$parser$Parser$end)
				])));
}();
var $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601 = A2(
	$elm$parser$Parser$andThen,
	function (datePart) {
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed(
											$rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts(datePart)),
										$elm$parser$Parser$symbol('T')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$elm$parser$Parser$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$parser$Parser$keeper,
											A2(
												$elm$parser$Parser$ignorer,
												$elm$parser$Parser$succeed($elm$core$Basics$identity),
												$elm$parser$Parser$symbol(':')),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
										]))),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$keeper,
										A2(
											$elm$parser$Parser$ignorer,
											$elm$parser$Parser$succeed($elm$core$Basics$identity),
											$elm$parser$Parser$symbol(':')),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
									]))),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$symbol('.')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs),
									$elm$parser$Parser$succeed(0)
								]))),
					A2($elm$parser$Parser$ignorer, $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes, $elm$parser$Parser$end)),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A6($rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts, datePart, 0, 0, 0, 0, 0)),
					$elm$parser$Parser$end)
				]));
	},
	$rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs);
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {ir: col, j$: problem, ki: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.ki, p.ir, p.j$);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{ir: 1, h: _List_Nil, i: 1, oq: 0, ki: 1, c: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (!_v0.$) {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime = function (str) {
	return A2($elm$parser$Parser$run, $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601, str);
};
var $author$project$Services$Concessionaire$cardDecoder = A7(
	$elm$json$Json$Decode$map6,
	$author$project$Services$Concessionaire$Card,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'serial', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'status', $author$project$Data$Passenger$blockStatusDecoder),
	A2(
		$elm$json$Json$Decode$field,
		'emission',
		A2(
			$elm$json$Json$Decode$map,
			A2(
				$elm$core$Basics$composeR,
				$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime,
				$elm$core$Result$withDefault(
					$elm$time$Time$millisToPosix(0))),
			$elm$json$Json$Decode$string)),
	A2(
		$elm$json$Json$Decode$field,
		'classes',
		$elm$json$Json$Decode$list(
			A4(
				$elm$json$Json$Decode$map3,
				F3(
					function (id, name, walletId) {
						return {dM: id, c3: name, cC: walletId};
					}),
				A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'walletId', $elm$json$Json$Decode$string)))));
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $author$project$Services$Api$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			function (response) {
				return A2(
					$author$project$Services$Api$responseToResult,
					response,
					$author$project$Services$Api$decodeMetaDataAndBody(decoder));
			});
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$url$Url$Builder$QueryParameter = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $elm$url$Url$Builder$int = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$core$String$fromInt(value));
	});
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {ka: reqs, kN: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.qi;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.ka));
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.kN)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					ll: r.ll,
					lG: r.lG,
					m9: A2(_Http_mapExpect, func, r.m9),
					nG: r.nG,
					of: r.of,
					p5: r.p5,
					qi: r.qi,
					qt: r.qt
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{ll: false, lG: r.lG, m9: r.m9, nG: r.nG, of: r.of, p5: r.p5, qi: r.qi, qt: r.qt}));
};
var $elm$url$Url$Builder$string = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$url$Url$percentEncode(value));
	});
var $author$project$Services$Concessionaire$adminCards = function (options) {
	return $elm$http$Http$request(
		{
			lG: $elm$http$Http$emptyBody,
			m9: A2(
				$author$project$Services$Api$expectJson,
				options.ow,
				A3(
					$elm$json$Json$Decode$map2,
					$elm$core$Tuple$pair,
					A2(
						$elm$json$Json$Decode$field,
						'cards',
						A2(
							$elm$json$Json$Decode$map,
							$elm$core$Maybe$withDefault(_List_Nil),
							$elm$json$Json$Decode$nullable(
								$elm$json$Json$Decode$list($author$project$Services$Concessionaire$cardDecoder)))),
					A2($elm$json$Json$Decode$field, 'recordCount', $elm$json$Json$Decode$int))),
			nG: _List_fromArray(
				[
					$author$project$Services$Api$authorizationHeader(options.kU)
				]),
			of: 'GET',
			p5: $elm$core$Maybe$Nothing,
			qi: $elm$core$Maybe$Nothing,
			qt: A2(
				$author$project$Constants$concessionaireServiceUrl,
				_List_fromArray(
					['api', 'v1', 'cards']),
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$map,
							$elm$url$Url$Builder$string('concessionaireID'),
							options.mc),
							$elm$core$Maybe$Just(
							A2($elm$url$Url$Builder$int, 'limit', options.n$)),
							$elm$core$Maybe$Just(
							A2($elm$url$Url$Builder$int, 'offset', options.oq)),
							A2(
							$elm$core$Maybe$map,
							$elm$url$Url$Builder$string('q'),
							options.fq)
						])))
		});
};
var $author$project$Pages$Admin$Cards$cardsPerPage = 10;
var $author$project$Route$extractConcessionaireId = function (route) {
	if (route.$ === 19) {
		var maybeConcessionaireId = route.b;
		return maybeConcessionaireId;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$Admin$Cards$init = F4(
	function (shared, maybePage, maybeSearch, user) {
		return _Utils_Tuple2(
			{
				f0: $krisajenkins$remotedata$RemoteData$Loading,
				fq: A2($elm$core$Maybe$withDefault, '', maybeSearch),
				kq: $Gizra$elm_debouncer$Debouncer$Basic$toDebouncer(
					$Gizra$elm_debouncer$Debouncer$Basic$debounce(500))
			},
			$author$project$Services$Concessionaire$adminCards(
				{
					mc: $author$project$Route$extractConcessionaireId(shared.pv),
					n$: $author$project$Pages$Admin$Cards$cardsPerPage,
					oq: (A2($elm$core$Maybe$withDefault, 1, maybePage) - 1) * $author$project$Pages$Admin$Cards$cardsPerPage,
					ow: $author$project$Pages$Admin$Cards$ReceivedCards,
					fq: maybeSearch,
					kU: user.kU
				}));
	});
var $author$project$Pages$Admin$CompanyOrders$GotCompanyOrders = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$CompanyOrders$GotDetail = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$CompanyOrders$GotHistoric = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Admin$CompanyOrders$cardsPerPage = 50;
var $author$project$Services$Admin$CompanyOrders$CompanyOrder = function (id) {
	return function (createdAt) {
		return function (updatedAt) {
			return function (deletedAt) {
				return function (userId) {
					return function (concessionaireId) {
						return function (name) {
							return function (cnpj) {
								return function (postalcode) {
									return function (address) {
										return function (addressNumber) {
											return function (addressComplement) {
												return function (neighborhood) {
													return function (state) {
														return function (city) {
															return function (email) {
																return function (phoneNumber) {
																	return function (phoneAreaCode) {
																		return function (managerName) {
																			return function (paymentGuide) {
																				return function (boletoDueDays) {
																					return function (issTax) {
																						return {ep: address, lk: addressComplement, bL: addressNumber, lH: boletoDueDays, lW: city, l3: cnpj, mc: concessionaireId, ix: createdAt, mB: deletedAt, mX: email, dM: id, nY: issTax, n7: managerName, c3: name, om: neighborhood, oP: paymentGuide, oV: phoneAreaCode, oW: phoneNumber, o1: postalcode, fy: state, qs: updatedAt, qw: userId};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $author$project$Services$Admin$CompanyOrders$decodeCompanyOrder = function () {
	var decoderDate = A2(
		$elm$json$Json$Decode$map,
		A2(
			$elm$core$Basics$composeR,
			$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime,
			$elm$core$Result$withDefault(
				$elm$time$Time$millisToPosix(0))),
		$elm$json$Json$Decode$string);
	return A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'issTax',
		$elm$json$Json$Decode$float,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'boletoDueDays',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'paymentGuide',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'managerName',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'phoneAreaCode',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'phoneNumber',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'email',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'city',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'state',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'neighborhood',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'addressComplement',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'addressNumber',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'address',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'postalcode',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'cnpj',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'name',
																	$elm$json$Json$Decode$string,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'concessionaireId',
																		$elm$json$Json$Decode$string,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'userId',
																			$elm$json$Json$Decode$string,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'deletedAt',
																				$elm$json$Json$Decode$maybe(decoderDate),
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'updatedAt',
																					decoderDate,
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'createdAt',
																						decoderDate,
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'id',
																							$elm$json$Json$Decode$string,
																							$elm$json$Json$Decode$succeed($author$project$Services$Admin$CompanyOrders$CompanyOrder)))))))))))))))))))))));
}();
var $author$project$Services$Admin$CompanyOrders$getCompanyOrders = function (options) {
	return $elm$http$Http$request(
		{
			lG: $elm$http$Http$emptyBody,
			m9: A2(
				$author$project$Services$Api$expectJson,
				options.ow,
				$elm$json$Json$Decode$list($author$project$Services$Admin$CompanyOrders$decodeCompanyOrder)),
			nG: _List_fromArray(
				[
					$author$project$Services$Api$authorizationHeader(options.kU)
				]),
			of: 'GET',
			p5: $elm$core$Maybe$Nothing,
			qi: $elm$core$Maybe$Nothing,
			qt: A2(
				$author$project$Constants$concessionaireServiceUrl,
				_List_fromArray(
					['api', 'v1', 'companies']),
				_List_Nil)
		});
};
var $author$project$Pages$Admin$CompanyOrders$Waiting = {$: 3};
var $author$project$Pages$Admin$CompanyOrders$initFilters = {dw: '', iI: ''};
var $author$project$Pages$Admin$CompanyOrders$initModel = {l8: $elm$core$Maybe$Nothing, Z: $author$project$Pages$Admin$CompanyOrders$initFilters, aY: $krisajenkins$remotedata$RemoteData$NotAsked, bv: 1, pO: $elm$core$Maybe$Nothing, fy: $author$project$Pages$Admin$CompanyOrders$Waiting};
var $author$project$Constants$companyServiceUrl = $elm$url$Url$Builder$crossOrigin('https://companies.pazze.app');
var $author$project$Data$Refill$RefillDetails = F9(
	function (id, value, status, paymentMethod, paymentDate, createdAt, createdBy, requester, cardRefillCount) {
		return {lN: cardRefillCount, ix: createdAt, mj: createdBy, dM: id, jV: paymentDate, jW: paymentMethod, pp: requester, kK: status, di: value};
	});
var $author$project$Data$Refill$CreatedBy = F2(
	function (id, name) {
		return {dM: id, c3: name};
	});
var $author$project$Data$Refill$decoderCreatedBy = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Data$Refill$CreatedBy)));
var $author$project$Services$Models$Billet = 5;
var $author$project$Services$Models$Cash = 0;
var $author$project$Services$Models$CreditCard = 1;
var $author$project$Services$Models$DebitCard = 2;
var $author$project$Services$Models$GuicheReversal = 6;
var $author$project$Services$Models$NotExist = 10;
var $author$project$Services$Models$PaymentGuide = 4;
var $author$project$Services$Models$Pix = 3;
var $author$project$Services$Models$Reversal = 11;
var $author$project$Services$Models$TicketWindowCash = 7;
var $author$project$Services$Models$TicketWindowCreditCard = 8;
var $author$project$Services$Models$TicketWindowDebitCard = 9;
var $author$project$Services$Models$decoderPaymentMethod = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'cash':
				return $elm$json$Json$Decode$succeed(0);
			case 'credit_card':
				return $elm$json$Json$Decode$succeed(1);
			case 'debit_card':
				return $elm$json$Json$Decode$succeed(2);
			case 'pix':
				return $elm$json$Json$Decode$succeed(3);
			case 'guia_local':
				return $elm$json$Json$Decode$succeed(4);
			case 'boleto':
				return $elm$json$Json$Decode$succeed(5);
			case 'guiche_reversal':
				return $elm$json$Json$Decode$succeed(6);
			case 'ticket_window_cash':
				return $elm$json$Json$Decode$succeed(7);
			case 'ticket_window_credit_card':
				return $elm$json$Json$Decode$succeed(8);
			case 'ticket_window_debit_card':
				return $elm$json$Json$Decode$succeed(9);
			case '':
				return $elm$json$Json$Decode$succeed(10);
			case 'estorno':
				return $elm$json$Json$Decode$succeed(11);
			default:
				var str_ = str;
				return $elm$json$Json$Decode$fail('Error: ' + (str_ + 'is not mapped'));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Refill$RefillRequester = F7(
	function (name, taxId, cardSerial, appliedDate, appliedBy, value, refillList) {
		return {lr: appliedBy, ls: appliedDate, lO: cardSerial, c3: name, pn: refillList, p$: taxId, di: value};
	});
var $author$project$Data$Refill$decoderRequester = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'refillList',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'value',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'appliedBy',
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
						A2(
						$elm$json$Json$Decode$map,
						function (str) {
							return $elm$core$String$isEmpty(str) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(str);
						},
						$elm$json$Json$Decode$string)
					])),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'appliedAt',
				$elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
							A2(
							$elm$json$Json$Decode$map,
							A2(
								$elm$core$Basics$composeR,
								$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$Result$withDefault(
										$elm$time$Time$millisToPosix(0)),
									$elm$core$Maybe$Just)),
							$elm$json$Json$Decode$string)
						])),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'cardSerial',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'document',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'name',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Data$Refill$RefillRequester))))))));
var $author$project$Data$Refill$decoderStatus = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'open':
				return $elm$json$Json$Decode$succeed('Aberto');
			case 'pending':
				return $elm$json$Json$Decode$succeed('Pendente');
			case 'imported':
				return $elm$json$Json$Decode$succeed('Importado');
			case 'canceled':
				return $elm$json$Json$Decode$succeed('Cancelado');
			case 'close':
				return $elm$json$Json$Decode$succeed('Pago');
			case 'deleted':
				return $elm$json$Json$Decode$succeed('Cancelado');
			case 'closed':
				return $elm$json$Json$Decode$succeed('Pago após baixa manual');
			case 'manual':
				return $elm$json$Json$Decode$succeed('Baixa manual');
			case 'importing':
				return $elm$json$Json$Decode$succeed('Importando');
			default:
				var value = str;
				return $elm$json$Json$Decode$fail('Refill status not mapped ' + value);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Refill$decoderRefillDetails = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'cardRefillCount',
	$elm$json$Json$Decode$int,
	0,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'cardRefills',
		$elm$json$Json$Decode$list($author$project$Data$Refill$decoderRequester),
		_List_Nil,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'createdBy',
			$author$project$Data$Refill$decoderCreatedBy,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'createdAt',
				A2(
					$elm$json$Json$Decode$map,
					A2(
						$elm$core$Basics$composeR,
						$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime,
						$elm$core$Result$withDefault(
							$elm$time$Time$millisToPosix(0))),
					$elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'paymentDate',
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
								A2(
								$elm$json$Json$Decode$map,
								A2(
									$elm$core$Basics$composeR,
									$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime,
									A2(
										$elm$core$Basics$composeR,
										$elm$core$Result$withDefault(
											$elm$time$Time$millisToPosix(0)),
										$elm$core$Maybe$Just)),
								$elm$json$Json$Decode$string)
							])),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'paymentMethod',
						$author$project$Services$Models$decoderPaymentMethod,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'status',
							$author$project$Data$Refill$decoderStatus,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'balance',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'id',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Data$Refill$RefillDetails))))))))));
var $author$project$Services$Company$refill = function (options) {
	var query = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (companyId) {
				return _List_fromArray(
					[
						A2($elm$url$Url$Builder$string, 'companyID', companyId)
					]);
			},
			options.iu));
	var pagination = _List_fromArray(
		[
			A2($elm$url$Url$Builder$int, 'offset', options.oq),
			A2($elm$url$Url$Builder$int, 'limit', options.n$)
		]);
	return $elm$http$Http$request(
		{
			lG: $elm$http$Http$emptyBody,
			m9: A2($author$project$Services$Api$expectJson, options.ow, $author$project$Data$Refill$decoderRefillDetails),
			nG: _List_fromArray(
				[
					$author$project$Services$Api$authorizationHeader(options.kU)
				]),
			of: 'GET',
			p5: $elm$core$Maybe$Nothing,
			qi: $elm$core$Maybe$Nothing,
			qt: A2(
				$author$project$Constants$companyServiceUrl,
				_List_fromArray(
					['api', 'v1', 'refill', 'detail', options.dM]),
				_Utils_ap(query, pagination))
		});
};
var $author$project$Data$Refill$Refill = function (id) {
	return function (value) {
		return function (grossValue) {
			return function (issTax) {
				return function (status) {
					return function (paymentMethod) {
						return function (paymentDate) {
							return function (createdAt) {
								return function (rollback) {
									return function (order) {
										return function (reversed) {
											return function (sequence) {
												return {ix: createdAt, nA: grossValue, dM: id, nY: issTax, oE: order, jV: paymentDate, jW: paymentMethod, ps: reversed, pu: rollback, pC: sequence, kK: status, di: value};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$Refill$RefillOrder = F2(
	function (id, billURL) {
		return {lA: billURL, dM: id};
	});
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt = F4(
	function (path, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				A2($elm$json$Json$Decode$at, path, $elm$json$Json$Decode$value),
				valDecoder,
				fallback),
			decoder);
	});
var $author$project$Data$Refill$decodeOrder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
	_List_fromArray(
		['boletoData', 'url']),
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Data$Refill$RefillOrder)));
var $author$project$Data$Refill$decodePaymentDate = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime,
		$elm$core$Result$withDefault(
			$elm$time$Time$millisToPosix(0))),
	$elm$json$Json$Decode$string);
var $author$project$Data$Refill$decoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'sequence',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'reversed',
		$elm$json$Json$Decode$bool,
		false,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'order',
			$elm$json$Json$Decode$maybe($author$project$Data$Refill$decodeOrder),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'rollback',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'createdAt',
					$author$project$Data$Refill$decodePaymentDate,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'paymentDate',
						$elm$json$Json$Decode$maybe($author$project$Data$Refill$decodePaymentDate),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'paymentMethod',
							$author$project$Services$Models$decoderPaymentMethod,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'status',
								$author$project$Data$Refill$decoderStatus,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'issTax',
									$elm$json$Json$Decode$int,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'grossBalance',
										$elm$json$Json$Decode$int,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'balance',
											$elm$json$Json$Decode$int,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'id',
												$elm$json$Json$Decode$string,
												$elm$json$Json$Decode$succeed($author$project$Data$Refill$Refill)))))))))))));
var $author$project$Services$Company$refills = function (options) {
	var query = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (companyId) {
				return _List_fromArray(
					[
						A2($elm$url$Url$Builder$string, 'companyID', companyId)
					]);
			},
			options.nn));
	return $elm$http$Http$request(
		{
			lG: $elm$http$Http$emptyBody,
			m9: A2(
				$author$project$Services$Api$expectJson,
				options.ow,
				$elm$json$Json$Decode$list($author$project$Data$Refill$decoder)),
			nG: _List_fromArray(
				[
					$author$project$Services$Api$authorizationHeader(options.kU)
				]),
			of: 'GET',
			p5: $elm$core$Maybe$Nothing,
			qi: $elm$core$Maybe$Nothing,
			qt: A2(
				$author$project$Constants$companyServiceUrl,
				_List_fromArray(
					['api', 'v1', 'refill', 'list']),
				query)
		});
};
var $author$project$Pages$Admin$CompanyOrders$init = F5(
	function (source, maybePage, maybeCompanyId, maybeDetailId, user) {
		var page_ = A2($elm$core$Maybe$withDefault, 1, maybePage);
		var cmd = function () {
			var _v0 = _Utils_Tuple2(maybeCompanyId, maybeDetailId);
			if (!_v0.a.$) {
				if (_v0.b.$ === 1) {
					var _v1 = _v0.b;
					return $author$project$Services$Company$refills(
						{nn: maybeCompanyId, ow: $author$project$Pages$Admin$CompanyOrders$GotHistoric, kU: user.kU});
				} else {
					var companyId = _v0.a.a;
					var detailId = _v0.b.a;
					return $author$project$Services$Company$refill(
						{
							iu: $elm$core$Maybe$Just(companyId),
							dM: detailId,
							n$: $author$project$Pages$Admin$CompanyOrders$cardsPerPage,
							oq: (page_ - 1) * $author$project$Pages$Admin$CompanyOrders$cardsPerPage,
							ow: $author$project$Pages$Admin$CompanyOrders$GotDetail,
							kU: user.kU
						});
				}
			} else {
				if (!_v0.b.$) {
					var _v2 = _v0.a;
					var detailId = _v0.b.a;
					return $author$project$Services$Company$refill(
						{iu: $elm$core$Maybe$Nothing, dM: detailId, n$: $author$project$Pages$Admin$CompanyOrders$cardsPerPage, oq: (page_ - 1) * $author$project$Pages$Admin$CompanyOrders$cardsPerPage, ow: $author$project$Pages$Admin$CompanyOrders$GotDetail, kU: user.kU});
				} else {
					var _v3 = _v0.a;
					var _v4 = _v0.b;
					return $author$project$Services$Admin$CompanyOrders$getCompanyOrders(
						{ow: $author$project$Pages$Admin$CompanyOrders$GotCompanyOrders, kU: user.kU});
				}
			}
		}();
		return _Utils_Tuple2(
			_Utils_update(
				$author$project$Pages$Admin$CompanyOrders$initModel,
				{l8: maybeCompanyId, bv: page_, pO: source}),
			cmd);
	});
var $author$project$Pages$Admin$Equipments$ReceivedEquipments = function (a) {
	return {$: 0, a: a};
};
var $author$project$Constants$deviceServiceUrl = $elm$url$Url$Builder$crossOrigin('https://device.pazze.app');
var $author$project$Services$Device$Equipment = function (concessionaireId) {
	return function (createdAt) {
		return function (eb01) {
			return function (eb01Id) {
				return function (id) {
					return function (lastEventAt) {
						return function (macAddress) {
							return function (publicKey) {
								return function (serialNumber) {
									return function (softwareUpdates) {
										return function (softwareVersion) {
											return function (type_) {
												return function (updatedAt) {
													return function (vehicle) {
														return {mc: concessionaireId, ix: createdAt, eH: eb01, mS: eb01Id, dM: id, gP: lastEventAt, n6: macAddress, j2: publicKey, pE: serialNumber, kF: softwareUpdates, kG: softwareVersion, kY: type_, qs: updatedAt, k2: vehicle};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Services$Device$Eb01 = function (concessionaireId) {
	return function (createdAt) {
		return function (id) {
			return function (lastEventAt) {
				return function (macAddress) {
					return function (publicKey) {
						return function (serialNumber) {
							return function (softwareUpdates) {
								return function (softwareVersion) {
									return function (type_) {
										return function (updatedAt) {
											return {mc: concessionaireId, ix: createdAt, dM: id, gP: lastEventAt, n6: macAddress, j2: publicKey, pE: serialNumber, kF: softwareUpdates, kG: softwareVersion, kY: type_, qs: updatedAt};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Services$Device$eb01Decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'updatedAt',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'type',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'softwareVersion',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'softwareUpdates',
				$elm$json$Json$Decode$null(0),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'serialNumber',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'publicKey',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'macAddress',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'lastEventAt',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'id',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'createdAt',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'concessionaireId',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$Services$Device$Eb01))))))))))));
var $author$project$Services$Device$Vehicle = F3(
	function (id, code, plate) {
		return {l4: code, dM: id, ac: plate};
	});
var $author$project$Services$Device$vehicleDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'Plate',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'Code',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'ID',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Services$Device$Vehicle))));
var $author$project$Services$Device$equipmentDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'vehicle',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Services$Device$vehicleDecoder),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'updatedAt',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'type',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'softwareVersion',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'softwareUpdates',
					$elm$json$Json$Decode$null(0),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'serialNumber',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'publicKey',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'macAddress',
								$elm$json$Json$Decode$string,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'lastEventAt',
									$elm$json$Json$Decode$string,
									'-',
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										$elm$json$Json$Decode$string,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'eb01Id',
											$elm$json$Json$Decode$string,
											'-',
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'eb01',
												$elm$json$Json$Decode$maybe($author$project$Services$Device$eb01Decoder),
												$elm$core$Maybe$Nothing,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'createdAt',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'concessionaireId',
														$elm$json$Json$Decode$string,
														$elm$json$Json$Decode$succeed($author$project$Services$Device$Equipment)))))))))))))));
var $author$project$Services$Device$equipments = function (options) {
	return $elm$http$Http$request(
		{
			lG: $elm$http$Http$emptyBody,
			m9: A2(
				$author$project$Services$Api$expectJson,
				options.ow,
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$Maybe$withDefault(_List_Nil),
					$elm$json$Json$Decode$nullable(
						$elm$json$Json$Decode$list($author$project$Services$Device$equipmentDecoder)))),
			nG: _List_fromArray(
				[
					$author$project$Services$Api$authorizationHeader(options.kU)
				]),
			of: 'GET',
			p5: $elm$core$Maybe$Nothing,
			qi: $elm$core$Maybe$Nothing,
			qt: A2(
				$author$project$Constants$deviceServiceUrl,
				_List_fromArray(
					['api', 'v1', 'devices']),
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$map,
							$elm$url$Url$Builder$string('concessionaireIds[]'),
							options.mc),
							$elm$core$Maybe$Just(
							A2($elm$url$Url$Builder$string, 'getDevice', 'true'))
						])))
		});
};
var $author$project$Pages$Admin$Equipments$init = F2(
	function (shared, user) {
		return _Utils_Tuple2(
			{cU: $krisajenkins$remotedata$RemoteData$Loading, dI: '', fq: ''},
			$author$project$Services$Device$equipments(
				{
					mc: $author$project$Route$extractConcessionaireId(shared.pv),
					ow: $author$project$Pages$Admin$Equipments$ReceivedEquipments,
					kU: user.kU
				}));
	});
var $author$project$Pages$Admin$PaymentBillets$GotTime = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$PaymentBillets$initModel = {aR: $krisajenkins$remotedata$RemoteData$NotAsked, dH: '', aY: $elm$core$Maybe$Nothing, eb: '', kK: ''};
var $author$project$Pages$Admin$PaymentBillets$init = function (_v0) {
	return _Utils_Tuple2(
		$author$project$Pages$Admin$PaymentBillets$initModel,
		A2(
			$elm$core$Task$perform,
			$author$project$Pages$Admin$PaymentBillets$GotTime,
			A3(
				$elm$core$Task$map2,
				F2(
					function (now, timezone) {
						return {e8: now, kS: timezone};
					}),
				$elm$time$Time$now,
				$elm$time$Time$here)));
};
var $author$project$Pages$Admin$PaymentGuides$GotTime = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$PaymentGuides$initModel = {dH: '', b0: $krisajenkins$remotedata$RemoteData$NotAsked, aY: $elm$core$Maybe$Nothing, eb: '', kK: ''};
var $author$project$Pages$Admin$PaymentGuides$init = function (_v0) {
	return _Utils_Tuple2(
		$author$project$Pages$Admin$PaymentGuides$initModel,
		A2(
			$elm$core$Task$perform,
			$author$project$Pages$Admin$PaymentGuides$GotTime,
			A3(
				$elm$core$Task$map2,
				F2(
					function (now, timezone) {
						return {e8: now, kS: timezone};
					}),
				$elm$time$Time$now,
				$elm$time$Time$here)));
};
var $author$project$Components$Patterns$Forms$Filling = 0;
var $author$project$Pages$Admin$Reports$Sales$GotTime = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$PDF$Create$init = {aY: $elm$core$Maybe$Nothing};
var $author$project$Pages$Admin$Reports$Sales$init = F2(
	function (queries, user) {
		return _Utils_Tuple2(
			{bQ: $author$project$Components$PDF$Create$init, cO: $elm$core$Maybe$Nothing, dK: false, L: 0, T: queries, ck: $krisajenkins$remotedata$RemoteData$NotAsked, fq: '', ku: '', hw: 0, a5: $elm$core$Maybe$Nothing, cn: $elm$core$Maybe$Nothing, kS: $elm$time$Time$utc},
			A2(
				$elm$core$Task$perform,
				$author$project$Pages$Admin$Reports$Sales$GotTime,
				A3(
					$elm$core$Task$map2,
					F2(
						function (now, timezone) {
							return {e8: now, kS: timezone};
						}),
					$elm$time$Time$now,
					$elm$time$Time$here)));
	});
var $author$project$Pages$Admin$SalesReport$GotTime = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$SalesReport$init = function (_v0) {
	return _Utils_Tuple2(
		{cO: $elm$core$Maybe$Nothing, ck: $krisajenkins$remotedata$RemoteData$NotAsked, fq: '', hw: 0, kS: $elm$time$Time$utc},
		A2(
			$elm$core$Task$perform,
			$author$project$Pages$Admin$SalesReport$GotTime,
			A3(
				$elm$core$Task$map2,
				F2(
					function (now, timezone) {
						return {e8: now, kS: timezone};
					}),
				$elm$time$Time$now,
				$elm$time$Time$here)));
};
var $author$project$Pages$Admin$SessionWithoutPouchReport$GotTime = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$SessionWithoutPouchReport$init = function (_v0) {
	return _Utils_Tuple2(
		{cO: $elm$core$Maybe$Nothing, ck: $krisajenkins$remotedata$RemoteData$NotAsked, fr: '', fs: '', hw: 0, em: ''},
		A2($elm$core$Task$perform, $author$project$Pages$Admin$SessionWithoutPouchReport$GotTime, $elm$time$Time$now));
};
var $author$project$Pages$Admin$SessionsReport$GotTime = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$SessionsReport$init = function (_v0) {
	return _Utils_Tuple2(
		{cO: $elm$core$Maybe$Nothing, ck: $krisajenkins$remotedata$RemoteData$NotAsked, fr: '', fs: '', hw: 0, em: ''},
		A2($elm$core$Task$perform, $author$project$Pages$Admin$SessionsReport$GotTime, $elm$time$Time$now));
};
var $author$project$Pages$Admin$Users$NoModal = {$: 0};
var $author$project$Pages$Admin$Users$ReceivedUsers = function (a) {
	return {$: 2, a: a};
};
var $author$project$Services$Concessionaire$User = F7(
	function (id, cpf, name, email, permissions, concessionaireId, concessionaireName) {
		return {mc: concessionaireId, ex: concessionaireName, aS: cpf, mX: email, dM: id, c3: name, oU: permissions};
	});
var $elm$json$Json$Decode$map7 = _Json_map7;
var $author$project$Services$Concessionaire$getAdminUsers = function (options) {
	var decoder = A8(
		$elm$json$Json$Decode$map7,
		$author$project$Services$Concessionaire$User,
		A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'document', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'email', $elm$json$Json$Decode$string),
		A2(
			$elm$json$Json$Decode$field,
			'roles',
			$elm$json$Json$Decode$list(
				A3(
					$elm$json$Json$Decode$map2,
					F2(
						function (label, value) {
							return {jl: label, di: value};
						}),
					A2($elm$json$Json$Decode$field, 'label', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'value', $author$project$Data$Permission$jsonDecoder)))),
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$Maybe$withDefault($elm$core$Maybe$Nothing),
			$elm$json$Json$Decode$maybe(
				A2(
					$elm$json$Json$Decode$map,
					function (str) {
						return $elm$core$String$isEmpty(str) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(str);
					},
					A2($elm$json$Json$Decode$field, 'concessionaireId', $elm$json$Json$Decode$string)))),
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$Maybe$withDefault($elm$core$Maybe$Nothing),
			$elm$json$Json$Decode$maybe(
				A2(
					$elm$json$Json$Decode$map,
					function (str) {
						return $elm$core$String$isEmpty(str) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(str);
					},
					A2($elm$json$Json$Decode$field, 'concessionaireName', $elm$json$Json$Decode$string)))));
	return $elm$http$Http$request(
		{
			lG: $elm$http$Http$emptyBody,
			m9: A2(
				$author$project$Services$Api$expectJson,
				options.ow,
				$elm$json$Json$Decode$list(decoder)),
			nG: _List_fromArray(
				[
					$author$project$Services$Api$authorizationHeader(options.kU)
				]),
			of: 'GET',
			p5: $elm$core$Maybe$Nothing,
			qi: $elm$core$Maybe$Nothing,
			qt: A2(
				$author$project$Constants$concessionaireServiceUrl,
				_List_fromArray(
					['api', 'v1', 'system', 'users']),
				function () {
					var _v0 = options.mc;
					if (_v0.$ === 1) {
						return _List_Nil;
					} else {
						var concessionaireId = _v0.a;
						return _List_fromArray(
							[
								A2($elm$url$Url$Builder$string, 'concessionaireID', concessionaireId)
							]);
					}
				}())
		});
};
var $author$project$Pages$Admin$Users$init = F3(
	function (queries, shared, user) {
		return _Utils_Tuple2(
			{aY: $author$project$Pages$Admin$Users$NoModal, T: queries, ei: $krisajenkins$remotedata$RemoteData$Loading},
			$author$project$Services$Concessionaire$getAdminUsers(
				{
					mc: $author$project$Route$extractConcessionaireId(shared.pv),
					ow: $author$project$Pages$Admin$Users$ReceivedUsers,
					kU: user.kU
				}));
	});
var $author$project$Pages$Admin$Vehicles$GotVehicles = function (a) {
	return {$: 1, a: a};
};
var $author$project$Services$Concessionaire$Vehicle = F6(
	function (id, active, code, plate, concessionaireId, device) {
		return {at: active, l4: code, mc: concessionaireId, mG: device, dM: id, ac: plate};
	});
var $author$project$Services$Concessionaire$VehicleDevice = F3(
	function (id, installedAt, serialNumber) {
		return {dM: id, nT: installedAt, pE: serialNumber};
	});
var $elm$parser$Parser$deadEndsToString = function (deadEnds) {
	return 'TODO deadEndsToString';
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		var _v0 = $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(str);
		if (_v0.$ === 1) {
			var deadEnds = _v0.a;
			return $elm$json$Json$Decode$fail(
				$elm$parser$Parser$deadEndsToString(deadEnds));
		} else {
			var time = _v0.a;
			return $elm$json$Json$Decode$succeed(time);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Services$Concessionaire$vehicleDecoder = A7(
	$elm$json$Json$Decode$map6,
	$author$project$Services$Concessionaire$Vehicle,
	A2($elm$json$Json$Decode$field, 'ID', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'Active', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'Code', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'Plate', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'ConcessionaireID', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$andThen,
		function (isInstalled) {
			return isInstalled ? A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$Just,
				A4(
					$elm$json$Json$Decode$map3,
					$author$project$Services$Concessionaire$VehicleDevice,
					A2($elm$json$Json$Decode$field, 'CurrentDeviceID', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'DeviceInstalledAt', $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
					A2($elm$json$Json$Decode$field, 'CurrentDeviceSn', $elm$json$Json$Decode$string))) : $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing);
		},
		A2($elm$json$Json$Decode$field, 'DesviceInstalled', $elm$json$Json$Decode$bool)));
var $author$project$Services$Concessionaire$getVehicles = function (options) {
	return $author$project$Services$Api$getTask(
		{
			mz: A3(
				$elm$json$Json$Decode$map2,
				$elm$core$Tuple$pair,
				A2(
					$elm$json$Json$Decode$field,
					'Vehicles',
					A2(
						$elm$json$Json$Decode$map,
						$elm$core$Maybe$withDefault(_List_Nil),
						$elm$json$Json$Decode$nullable(
							$elm$json$Json$Decode$list($author$project$Services$Concessionaire$vehicleDecoder)))),
				A2($elm$json$Json$Decode$field, 'RecordCount', $elm$json$Json$Decode$int)),
			kU: $elm$core$Maybe$Just(options.kU),
			qt: A2(
				$author$project$Constants$concessionaireServiceUrl,
				_List_fromArray(
					['api', 'v1', 'concessionaires', options.mc, 'vehicles']),
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$elm$core$Maybe$Just(
							A2($elm$url$Url$Builder$int, 'limit', options.n$)),
							$elm$core$Maybe$Just(
							A2($elm$url$Url$Builder$int, 'offset', options.oq)),
							A2(
							$elm$core$Maybe$map,
							$elm$url$Url$Builder$string('q'),
							options.fq),
							A2(
							$elm$core$Maybe$map,
							$elm$url$Url$Builder$string('active'),
							options.at)
						])))
		});
};
var $author$project$Pages$Admin$Vehicles$vehiclesPerPage = 100;
var $author$project$Pages$Admin$Vehicles$init = F5(
	function (shared, maybePage, maybeSearch, maybeActive, user) {
		var initModel = {
			at: maybeActive,
			aY: $elm$core$Maybe$Nothing,
			fq: A2($elm$core$Maybe$withDefault, '', maybeSearch),
			kq: $Gizra$elm_debouncer$Debouncer$Basic$toDebouncer(
				$Gizra$elm_debouncer$Debouncer$Basic$debounce(500)),
			en: $krisajenkins$remotedata$RemoteData$Loading
		};
		var _v0 = $author$project$Route$extractConcessionaireId(shared.pv);
		if (_v0.$ === 1) {
			return _Utils_Tuple2(initModel, $elm$core$Platform$Cmd$none);
		} else {
			var concessionaireId = _v0.a;
			return _Utils_Tuple2(
				initModel,
				A2(
					$elm$core$Task$attempt,
					$author$project$Pages$Admin$Vehicles$GotVehicles,
					$author$project$Services$Concessionaire$getVehicles(
						{
							at: maybeActive,
							mc: concessionaireId,
							n$: $author$project$Pages$Admin$Vehicles$vehiclesPerPage,
							oq: (A2($elm$core$Maybe$withDefault, 1, maybePage) - 1) * $author$project$Pages$Admin$Vehicles$vehiclesPerPage,
							fq: maybeSearch,
							kU: user.kU
						})));
		}
	});
var $author$project$Pages$Admin$initModel = function (page) {
	return {bv: page};
};
var $elm$core$Platform$Cmd$map = _Platform_map;
var $elm$browser$Browser$Navigation$replaceUrl = _Browser_replaceUrl;
var $elm$url$Url$Builder$absolute = F2(
	function (pathSegments, parameters) {
		return '/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters));
	});
var $author$project$Services$Reason$actionToCode = function (action) {
	switch (action) {
		case 0:
			return 'unblock';
		case 1:
			return 'block';
		default:
			return 'second_way';
	}
};
var $author$project$Route$adminRouteUsers = {
	T: {iI: 'document', mX: 'email', c3: 'name'},
	b: 'painel'
};
var $author$project$Route$boolToStr = function (v) {
	if (v) {
		return 'true';
	} else {
		return 'false';
	}
};
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $author$project$Route$concessionaireIdQuery = function (maybeConcessionaireId) {
	if (maybeConcessionaireId.$ === 1) {
		return _List_Nil;
	} else {
		var concessionaireId = maybeConcessionaireId.a;
		return _List_fromArray(
			[
				A2($elm$url$Url$Builder$string, 'conId', concessionaireId)
			]);
	}
};
var $author$project$Services$Models$encodeOrderType = function (type_) {
	if (!type_) {
		return 'asc';
	} else {
		return 'desc';
	}
};
var $author$project$Route$encodeQuery = F3(
	function (encode, key, value) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					encode(key),
					$elm$core$List$singleton),
				value));
	});
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $author$project$Services$Financial$pagarmeOrderStatusToCode = function (status) {
	switch (status) {
		case 0:
			return 'pending';
		case 1:
			return 'canceled';
		case 2:
			return 'paid';
		default:
			return 'failed';
	}
};
var $author$project$Services$Financial$pagarmePayablesStatusToCode = function (status) {
	switch (status) {
		case 0:
			return 'paid';
		case 1:
			return 'waiting_funds';
		default:
			return 'prepaid';
	}
};
var $author$project$Route$panelRouteString = {
	dv: {
		f9: {b: 'create'},
		dE: {b: 'details'},
		n3: {b: 'list'},
		b: 'classes'
	},
	cU: {b: 'equipments', kw: 'serial', k2: 'vehicle'},
	e: {
		V: {
			T: {bl: 'endDate', bv: 'page', bB: 'startDate'},
			b: 'account'
		},
		S: {
			T: {bl: 'endDate', bv: 'page', jW: 'paymentMethod', bB: 'startDate', kK: 'status'},
			b: 'pending-transactions'
		},
		b: 'financial',
		a9: {
			T: {gk: 'dynamic-record-total', bl: 'endDate', bv: 'page', jW: 'paymentMethod', bB: 'startDate', kK: 'status'},
			b: 'transactions'
		}
	},
	eN: {
		T: {bK: 'actionType', gk: 'dynamicRecordTotal', bl: 'endDate', bZ: 'executionUserID', bv: 'page', bB: 'startDate', kZ: 'user'},
		b: 'history'
	},
	b6: {
		T: {mn: 'currentOrder', mo: 'currentOrderType'},
		b: 'fare'
	},
	b7: {
		T: {mn: 'currentOrder', mo: 'currentOrderType'},
		b: 'lines'
	},
	gS: {
		T: {f6: 'conId'},
		b: 'operators'
	},
	gT: {b: 'pouches'},
	bt: {V: 'account', oN: 'password', b: 'my-account'},
	pf: {
		T: {hV: 'action'},
		b: 'reason'
	},
	hq: {b: 'reversal-approval', fy: 'state'},
	b: 'panel',
	hy: {b: 'single-charge'},
	kL: {
		dE: {b: 'details'},
		n3: {
			T: {kw: 'serial'},
			b: 'list'
		},
		b: 'stock'
	},
	hK: {b: 'update-equipment'},
	hL: {b: 'Update-requests-equipments'}
};
var $author$project$Services$Models$paymentFormatToCode = function (paymentFormat) {
	switch (paymentFormat) {
		case 0:
			return 'cash';
		case 1:
			return 'credit_card';
		case 2:
			return 'debit_card';
		case 3:
			return 'pix';
		case 4:
			return 'guia_local';
		case 5:
			return 'boleto';
		case 10:
			return '';
		case 6:
			return 'guiche_reversal';
		case 7:
			return 'ticket_window_cash';
		case 11:
			return 'estorno';
		case 8:
			return 'ticket_window_credit_card';
		default:
			return 'ticket_window_debit_card';
	}
};
var $author$project$Route$posGarageRouteString = {
	bf: {bl: 'endDate', b: 'apuracao', bB: 'startDate', kK: 'status'}
};
var $author$project$Route$reportRouteAdministrativeSales = {
	T: {bl: 'endDate', g6: 'operatorID', bB: 'startDate'},
	b: 'administrative-sales'
};
var $author$project$Route$reportRouteDetailedVehicle = {
	T: {bl: 'endDate', ac: 'plate', kw: 'serial', bB: 'startDate', k2: 'vehicle', fN: 'vehicleID', hN: 'vehicleName'},
	b: 'detailed-vehicle'
};
var $author$project$Route$reportRouteDetailedVehicleV2 = {
	T: {bl: 'endDate', ac: 'plate', kw: 'serial', bB: 'startDate', k2: 'vehicle', fN: 'vehicleID', hN: 'vehicleName'},
	b: 'detailed-vehicle-v2'
};
var $author$project$Route$reportRouteDivergences = {
	T: {lX: 'classID', iI: 'document', gk: 'dynamicRecordTotal', bl: 'endDate', iY: 'from-similarity', b3: 'lineCode', g6: 'operatorID', bv: 'page', kx: 'serialCard', pJ: 'size', bB: 'startDate', kT: 'to-similarity', kY: 'type', qx: 'userName', fN: 'vehicleID'},
	b: 'divergences'
};
var $author$project$Route$reportRouteEvent = {
	aj: {
		T: {bl: 'endDate', bX: 'errorType', bB: 'startDate', en: 'vehicleID'},
		b: 'audit'
	},
	b: 'event',
	cA: {
		T: {bl: 'endDate', bB: 'startDate'},
		b: 'using-day'
	},
	bG: {
		T: {bl: 'endDate', b3: 'lineCode', bB: 'startDate'},
		b: 'using-line'
	},
	bb: {
		T: {bl: 'endDate', c5: 'operatorID', bB: 'startDate'},
		b: 'using-operator'
	},
	U: {
		T: {bl: 'endDate', n2: 'lineCODE', c5: 'operatorID', bB: 'startDate', en: 'vehicleID'},
		b: 'using-session'
	},
	bc: {
		T: {bl: 'endDate', bB: 'startDate', fN: 'vehicleID'},
		b: 'using-vehicle'
	}
};
var $author$project$Route$reportRoutePDFs = {b: 'generated-pdfs'};
var $author$project$Route$reportRouteSalesSummarized = {
	T: {bl: 'endDate', bB: 'startDate'},
	b: 'sales-summarized'
};
var $author$project$Route$reportRouteSalesSummarizedV2 = {
	T: {bl: 'endDate', bB: 'startDate'},
	b: 'sales-summarized-v2'
};
var $author$project$Route$reportRouteUsage = {
	T: {ic: 'cashierID', lX: 'classID', gk: 'dynamic-record-total', bl: 'endDate', b3: 'lineCode', g6: 'operatorID', bv: 'page', kx: 'serialCard', bB: 'startDate', fN: 'vehicleID'},
	b: 'usage'
};
var $author$project$Route$reportRouteUsesPerClass = {
	T: {ic: 'cashierID', lX: 'classID', bl: 'endDate', nB: 'groupBy', b3: 'lineCode', g6: 'operatorID', bv: 'page', bB: 'startDate', fN: 'vehicleID'},
	b: 'uses-per-class'
};
var $author$project$Route$reportRouteUsesPerDay = {
	T: {bl: 'endDate', bB: 'startDate'},
	b: 'uses-per-day'
};
var $author$project$Route$reportRouteUsesPerLine = {
	T: {bl: 'endDate', bB: 'startDate'},
	b: 'uses-per-line'
};
var $author$project$Route$reportRouteUsesPerVehicle = {
	T: {bl: 'endDate', bB: 'startDate'},
	b: 'uses-per-vehicles'
};
var $author$project$Services$Models$statusReversalApprovalToStr = function (status) {
	if (!status) {
		return 'system';
	} else {
		return 'cashier';
	}
};
var $author$project$Services$Models$viewStatusToStr = function (status) {
	if (!status) {
		return 'ToCalculate';
	} else {
		return 'Calculated';
	}
};
var $author$project$Route$toString = function (page) {
	var _v0 = function () {
		switch (page.$) {
			case 0:
				return _Utils_Tuple2(
					_List_fromArray(
						['']),
					_List_Nil);
			case 1:
				return _Utils_Tuple2(
					_List_fromArray(
						['recuperar-senha']),
					_List_Nil);
			case 2:
				var token = page.a;
				return _Utils_Tuple2(
					_List_fromArray(
						['mude-minha-senha']),
					function () {
						if (!token.$) {
							var t = token.a;
							return _List_fromArray(
								[
									A2($elm$url$Url$Builder$string, '/', t)
								]);
						} else {
							return _List_Nil;
						}
					}());
			case 5:
				return _Utils_Tuple2(
					_List_fromArray(
						['guiche']),
					_List_Nil);
			case 7:
				var passengerId = page.a;
				var subRoute = page.b;
				var _v3 = function () {
					switch (subRoute) {
						case 0:
							return _Utils_Tuple2(_List_Nil, _List_Nil);
						case 1:
							return _Utils_Tuple2(
								_List_fromArray(
									['venda-bilhetes']),
								_List_Nil);
						case 2:
							return _Utils_Tuple2(
								_List_fromArray(
									['venda-avulsa']),
								_List_Nil);
						case 3:
							return _Utils_Tuple2(
								_List_fromArray(
									['aplicar-carga']),
								_List_Nil);
						case 4:
							return _Utils_Tuple2(
								_List_fromArray(
									['emitir-cartao']),
								_List_Nil);
						case 5:
							return _Utils_Tuple2(
								_List_fromArray(
									['segunda-via-cartao']),
								_List_Nil);
						case 6:
							return _Utils_Tuple2(
								_List_fromArray(
									['registrar-beneficiario']),
								_List_Nil);
						default:
							return _Utils_Tuple2(
								_List_fromArray(
									['desbloquear-cartao']),
								_List_Nil);
					}
				}();
				var paths_ = _v3.a;
				var queries_ = _v3.b;
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						'guiche',
						A2(
							$elm$core$List$cons,
							'cliente',
							A2($elm$core$List$cons, passengerId, paths_))),
					queries_);
			case 6:
				return _Utils_Tuple2(
					_List_fromArray(
						['guiche', 'cadastrar']),
					_List_Nil);
			case 8:
				var id = page.a;
				return _Utils_Tuple2(
					_List_fromArray(
						['guiche', 'cliente', id, 'editar']),
					_List_Nil);
			case 9:
				var maybeSearch = page.a;
				return _Utils_Tuple2(
					_List_fromArray(
						['guiche', 'localizar']),
					function () {
						if (maybeSearch.$ === 1) {
							return _List_Nil;
						} else {
							var search = maybeSearch.a;
							return _List_fromArray(
								[
									A2($elm$url$Url$Builder$string, 'busca', search)
								]);
						}
					}());
			case 10:
				return _Utils_Tuple2(
					_List_fromArray(
						['guiche', 'fechar-caixa']),
					_List_Nil);
			case 11:
				var queries_ = page.a;
				return _Utils_Tuple2(
					_List_fromArray(
						['guiche', 'apuracao']),
					_Utils_ap(
						A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$posGarageRouteString.bf.bB, queries_.bB),
						_Utils_ap(
							A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$posGarageRouteString.bf.bl, queries_.bl),
							A3(
								$author$project$Route$encodeQuery,
								$elm$url$Url$Builder$string,
								$author$project$Route$posGarageRouteString.bf.kK,
								$elm$core$Maybe$Just(
									$author$project$Services$Models$viewStatusToStr(queries_.kK))))));
			case 12:
				var maybeConcessionaireId = page.a;
				return _Utils_Tuple2(
					_List_fromArray(
						['empresa', 'registrar']),
					function () {
						if (maybeConcessionaireId.$ === 1) {
							return _List_Nil;
						} else {
							var concessionaireId = maybeConcessionaireId.a;
							return _List_fromArray(
								[
									A2($elm$url$Url$Builder$string, 'conId', concessionaireId)
								]);
						}
					}());
			case 13:
				var isOpen = page.a;
				var maybeOrderID = page.b;
				return _Utils_Tuple2(
					_List_fromArray(
						['empresa', 'painel']),
					_Utils_ap(
						A3(
							$author$project$Route$encodeQuery,
							$elm$url$Url$Builder$string,
							'isOpen',
							A2($elm$core$Maybe$map, $author$project$Route$boolToStr, isOpen)),
						A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, 'details', maybeOrderID)));
			case 14:
				return _Utils_Tuple2(
					_List_fromArray(
						['empresa', 'saved-order-lists']),
					_List_Nil);
			case 15:
				var orderID = page.a;
				return _Utils_Tuple2(
					_List_fromArray(
						['empresa', 'saved-order-lists', orderID]),
					_List_Nil);
			case 16:
				return _Utils_Tuple2(
					_List_fromArray(
						['empresa', 'historico']),
					_List_Nil);
			case 17:
				var detailId = page.a;
				var maybePage = page.b;
				return _Utils_Tuple2(
					_List_fromArray(
						['empresa', 'historico', 'detail', detailId]),
					$elm$core$List$singleton(
						A2(
							$elm$url$Url$Builder$int,
							'page',
							A2($elm$core$Maybe$withDefault, 1, maybePage))));
			case 18:
				return _Utils_Tuple2(
					_List_fromArray(
						['empresa', 'funcionarios']),
					_List_Nil);
			case 3:
				return _Utils_Tuple2(
					_List_fromArray(
						['welcome-back']),
					_List_Nil);
			case 20:
				return _Utils_Tuple2(
					_List_fromArray(
						['zenvia', 'chat']),
					_List_Nil);
			case 19:
				var subRoute = page.a;
				var maybeConcessionaireId = page.b;
				var _v7 = function () {
					switch (subRoute.$) {
						case 0:
							var userQueries = subRoute.a;
							return _Utils_Tuple2(
								_List_fromArray(
									['painel']),
								_Utils_ap(
									A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$adminRouteUsers.T.c3, userQueries.c3),
									_Utils_ap(
										A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$adminRouteUsers.T.iI, userQueries.iI),
										A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$adminRouteUsers.T.mX, userQueries.mX))));
						case 1:
							return _Utils_Tuple2(
								_List_fromArray(
									['equipamentos']),
								_List_Nil);
						case 2:
							var maybePage = subRoute.a;
							var maybeSearch = subRoute.b;
							return _Utils_Tuple2(
								_List_fromArray(
									['cartoes']),
								$elm$core$List$concat(
									_List_fromArray(
										[
											A2(
											$elm$core$Maybe$withDefault,
											_List_Nil,
											A2(
												$elm$core$Maybe$map,
												$elm$core$List$singleton,
												A2(
													$elm$core$Maybe$map,
													$elm$url$Url$Builder$int('pagina'),
													maybePage))),
											A2(
											$elm$core$Maybe$withDefault,
											_List_Nil,
											A2(
												$elm$core$Maybe$map,
												$elm$core$List$singleton,
												A2(
													$elm$core$Maybe$map,
													$elm$url$Url$Builder$string('busca'),
													maybeSearch)))
										])));
						case 3:
							var id = subRoute.a;
							return _Utils_Tuple2(
								_List_fromArray(
									['cartoes', id]),
								_List_Nil);
						case 4:
							var maybePage = subRoute.a;
							var maybeSearch = subRoute.b;
							var maybeActive = subRoute.c;
							return _Utils_Tuple2(
								_List_fromArray(
									['veiculos']),
								$elm$core$List$concat(
									_List_fromArray(
										[
											A2(
											$elm$core$Maybe$withDefault,
											_List_Nil,
											A2(
												$elm$core$Maybe$map,
												$elm$core$List$singleton,
												A2(
													$elm$core$Maybe$map,
													$elm$url$Url$Builder$int('pagina'),
													maybePage))),
											A2(
											$elm$core$Maybe$withDefault,
											_List_Nil,
											A2(
												$elm$core$Maybe$map,
												$elm$core$List$singleton,
												A2(
													$elm$core$Maybe$map,
													$elm$url$Url$Builder$string('busca'),
													maybeSearch))),
											A2(
											$elm$core$Maybe$withDefault,
											_List_Nil,
											A2(
												$elm$core$Maybe$map,
												$elm$core$List$singleton,
												A2(
													$elm$core$Maybe$map,
													$elm$url$Url$Builder$string('active'),
													maybeActive)))
										])));
						case 5:
							return _Utils_Tuple2(
								_List_fromArray(
									['relatorios', 'arrecadacao']),
								_List_Nil);
						case 6:
							return _Utils_Tuple2(
								_List_fromArray(
									['relatorios', 'vendas']),
								_List_Nil);
						case 7:
							return _Utils_Tuple2(
								_List_fromArray(
									['relatorios', 'sessoes']),
								_List_Nil);
						case 8:
							return _Utils_Tuple2(
								_List_fromArray(
									['relatorios', 'sessoes-sem-malote']),
								_List_Nil);
						case 9:
							var q_ = subRoute.a;
							return _Utils_Tuple2(
								_List_fromArray(
									['relatorios', 'v2', 'vendas']),
								A3(
									$author$project$Route$encodeQuery,
									$elm$url$Url$Builder$int,
									'page',
									$elm$core$Maybe$Just(q_.bv)));
						case 10:
							return _Utils_Tuple2(
								_List_fromArray(
									['guias']),
								_List_Nil);
						case 11:
							return _Utils_Tuple2(
								_List_fromArray(
									['boletos']),
								_List_Nil);
						case 12:
							return _Utils_Tuple2(
								_List_fromArray(
									['empresas']),
								_List_Nil);
						case 13:
							var id = subRoute.a;
							return _Utils_Tuple2(
								_List_fromArray(
									['empresas', 'historico', id]),
								_List_Nil);
						default:
							var companyID = subRoute.a.l8;
							var detailID = subRoute.a.mF;
							var maybePage = subRoute.a.ob;
							var source = subRoute.a.pO;
							return _Utils_Tuple2(
								_List_fromArray(
									['empresas', 'historico', companyID, 'detail', detailID]),
								_Utils_ap(
									A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, 'source', source),
									$elm$core$List$singleton(
										A2(
											$elm$url$Url$Builder$int,
											'page',
											A2($elm$core$Maybe$withDefault, 1, maybePage)))));
					}
				}();
				var paths_ = _v7.a;
				var queries_ = _v7.b;
				return _Utils_Tuple2(
					A2($elm$core$List$cons, 'admin', paths_),
					_Utils_ap(
						queries_,
						$author$project$Route$concessionaireIdQuery(maybeConcessionaireId)));
			case 4:
				switch (page.a.$) {
					case 1:
						var queries_ = page.a.a;
						return _Utils_Tuple2(
							_List_fromArray(
								[$author$project$Route$panelRouteString.b, $author$project$Route$panelRouteString.cU.b]),
							_Utils_ap(
								A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$panelRouteString.cU.kw, queries_.kw),
								A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$panelRouteString.cU.k2, queries_.k2)));
					case 0:
						var state = page.a.a;
						return _Utils_Tuple2(
							_List_fromArray(
								[
									$author$project$Route$panelRouteString.b,
									$author$project$Route$panelRouteString.hq.b,
									$author$project$Services$Models$statusReversalApprovalToStr(state)
								]),
							_List_Nil);
					case 2:
						switch (page.a.a.$) {
							case 0:
								var q = page.a.a.a;
								return _Utils_Tuple2(
									_List_fromArray(
										[$author$project$Route$panelRouteString.b, $author$project$Route$panelRouteString.e.b, $author$project$Route$panelRouteString.e.V.b]),
									_Utils_ap(
										A3(
											$author$project$Route$encodeQuery,
											$elm$url$Url$Builder$int,
											$author$project$Route$panelRouteString.e.V.T.bv,
											$elm$core$Maybe$Just(q.bv)),
										_Utils_ap(
											A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$panelRouteString.e.V.T.bl, q.bl),
											A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$panelRouteString.e.V.T.bB, q.bB))));
							case 1:
								var q = page.a.a.a;
								return _Utils_Tuple2(
									_List_fromArray(
										[$author$project$Route$panelRouteString.b, $author$project$Route$panelRouteString.e.b, $author$project$Route$panelRouteString.e.a9.b]),
									_Utils_ap(
										A3(
											$author$project$Route$encodeQuery,
											$elm$url$Url$Builder$int,
											$author$project$Route$panelRouteString.e.a9.T.gk,
											$elm$core$Maybe$Just(q.gk)),
										_Utils_ap(
											A3(
												$author$project$Route$encodeQuery,
												$elm$url$Url$Builder$int,
												$author$project$Route$panelRouteString.e.a9.T.bv,
												$elm$core$Maybe$Just(q.bv)),
											_Utils_ap(
												A3(
													$author$project$Route$encodeQuery,
													$elm$url$Url$Builder$string,
													$author$project$Route$panelRouteString.e.a9.T.jW,
													A2($elm$core$Maybe$map, $author$project$Services$Models$paymentFormatToCode, q.jW)),
												_Utils_ap(
													A3(
														$author$project$Route$encodeQuery,
														$elm$url$Url$Builder$string,
														$author$project$Route$panelRouteString.e.a9.T.kK,
														A2($elm$core$Maybe$map, $author$project$Services$Financial$pagarmePayablesStatusToCode, q.kK)),
													_Utils_ap(
														A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$panelRouteString.e.a9.T.bl, q.bl),
														A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$panelRouteString.e.a9.T.bB, q.bB)))))));
							default:
								var q = page.a.a.a;
								return _Utils_Tuple2(
									_List_fromArray(
										[$author$project$Route$panelRouteString.b, $author$project$Route$panelRouteString.e.b, $author$project$Route$panelRouteString.e.S.b]),
									_Utils_ap(
										A3(
											$author$project$Route$encodeQuery,
											$elm$url$Url$Builder$int,
											$author$project$Route$panelRouteString.e.S.T.bv,
											$elm$core$Maybe$Just(q.bv)),
										_Utils_ap(
											A3(
												$author$project$Route$encodeQuery,
												$elm$url$Url$Builder$string,
												$author$project$Route$panelRouteString.e.S.T.jW,
												A2($elm$core$Maybe$map, $author$project$Services$Models$paymentFormatToCode, q.jW)),
											_Utils_ap(
												A3(
													$author$project$Route$encodeQuery,
													$elm$url$Url$Builder$string,
													$author$project$Route$panelRouteString.e.S.T.kK,
													A2($elm$core$Maybe$map, $author$project$Services$Financial$pagarmeOrderStatusToCode, q.kK)),
												_Utils_ap(
													A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$panelRouteString.e.S.T.bl, q.bl),
													A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$panelRouteString.e.S.T.bB, q.bB))))));
						}
					case 10:
						switch (page.a.a.$) {
							case 0:
								var _v9 = page.a.a;
								return _Utils_Tuple2(
									_List_fromArray(
										[$author$project$Route$panelRouteString.b, $author$project$Route$panelRouteString.dv.b, $author$project$Route$panelRouteString.dv.n3.b]),
									_List_Nil);
							case 1:
								var id = page.a.a.a;
								return _Utils_Tuple2(
									_List_fromArray(
										[$author$project$Route$panelRouteString.b, $author$project$Route$panelRouteString.dv.b, $author$project$Route$panelRouteString.dv.dE.b, id]),
									_List_Nil);
							default:
								var _v10 = page.a.a;
								return _Utils_Tuple2(
									_List_fromArray(
										[$author$project$Route$panelRouteString.b, $author$project$Route$panelRouteString.dv.b, $author$project$Route$panelRouteString.dv.f9.b]),
									_List_Nil);
						}
					case 3:
						var _v11 = page.a;
						return _Utils_Tuple2(
							_List_fromArray(
								[$author$project$Route$panelRouteString.b, $author$project$Route$panelRouteString.gT.b]),
							_List_Nil);
					case 4:
						var q_ = page.a.a;
						return _Utils_Tuple2(
							_List_fromArray(
								[$author$project$Route$panelRouteString.b, $author$project$Route$panelRouteString.b6.b]),
							_Utils_ap(
								A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$panelRouteString.b6.T.mn, q_.mn),
								A3(
									$author$project$Route$encodeQuery,
									$elm$url$Url$Builder$string,
									$author$project$Route$panelRouteString.b6.T.mo,
									A2($elm$core$Maybe$map, $author$project$Services$Models$encodeOrderType, q_.mo))));
					case 5:
						var _v12 = page.a;
						return _Utils_Tuple2(
							_List_fromArray(
								[$author$project$Route$panelRouteString.b, $author$project$Route$panelRouteString.gS.b]),
							_List_Nil);
					case 8:
						var _v13 = page.a;
						return _Utils_Tuple2(
							_List_fromArray(
								[$author$project$Route$panelRouteString.b, $author$project$Route$panelRouteString.hK.b]),
							_List_Nil);
					case 9:
						var _v14 = page.a;
						return _Utils_Tuple2(
							_List_fromArray(
								[$author$project$Route$panelRouteString.b, $author$project$Route$panelRouteString.hL.b]),
							_List_Nil);
					case 11:
						var q_ = page.a.a;
						return _Utils_Tuple2(
							_List_fromArray(
								[$author$project$Route$panelRouteString.b, $author$project$Route$panelRouteString.pf.b]),
							A3(
								$author$project$Route$encodeQuery,
								$elm$url$Url$Builder$string,
								$author$project$Route$panelRouteString.pf.T.hV,
								A2($elm$core$Maybe$map, $author$project$Services$Reason$actionToCode, q_.hV)));
					case 12:
						var _v15 = page.a;
						return _Utils_Tuple2(
							_List_fromArray(
								[$author$project$Route$panelRouteString.b, $author$project$Route$panelRouteString.hy.b]),
							_List_Nil);
					case 14:
						var q_ = page.a.a;
						var listToStr = function (list) {
							var _v16 = A2(
								$elm$core$String$join,
								',',
								A2(
									$elm$core$List$filter,
									$elm$core$Basics$neq(''),
									list));
							if (_v16 === '') {
								return $elm$core$Maybe$Nothing;
							} else {
								var l = _v16;
								return $elm$core$Maybe$Just(l);
							}
						};
						return _Utils_Tuple2(
							_List_fromArray(
								[$author$project$Route$panelRouteString.b, $author$project$Route$panelRouteString.eN.b]),
							_Utils_ap(
								A3(
									$author$project$Route$encodeQuery,
									$elm$url$Url$Builder$string,
									$author$project$Route$panelRouteString.eN.T.bK,
									listToStr(q_.bK)),
								_Utils_ap(
									A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$panelRouteString.eN.T.kZ, q_.kZ),
									_Utils_ap(
										A3(
											$author$project$Route$encodeQuery,
											$elm$url$Url$Builder$string,
											$author$project$Route$panelRouteString.eN.T.bZ,
											listToStr(q_.bZ)),
										_Utils_ap(
											A3(
												$author$project$Route$encodeQuery,
												$elm$url$Url$Builder$int,
												$author$project$Route$panelRouteString.eN.T.gk,
												$elm$core$Maybe$Just(q_.gk)),
											_Utils_ap(
												A3(
													$author$project$Route$encodeQuery,
													$elm$url$Url$Builder$int,
													$author$project$Route$panelRouteString.eN.T.bv,
													$elm$core$Maybe$Just(q_.bv)),
												_Utils_ap(
													A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$panelRouteString.eN.T.bl, q_.bl),
													A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$panelRouteString.eN.T.bB, q_.bB))))))));
					case 13:
						if (!page.a.a.$) {
							var q_ = page.a.a.a;
							return _Utils_Tuple2(
								_List_fromArray(
									[$author$project$Route$panelRouteString.b, $author$project$Route$panelRouteString.kL.b, $author$project$Route$panelRouteString.kL.n3.b]),
								A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$panelRouteString.kL.n3.T.kw, q_.kw));
						} else {
							var serial = page.a.a.a;
							return _Utils_Tuple2(
								_List_fromArray(
									[$author$project$Route$panelRouteString.b, $author$project$Route$panelRouteString.kL.b, $author$project$Route$panelRouteString.kL.dE.b, serial]),
								_List_Nil);
						}
					case 6:
						var q_ = page.a.a;
						return _Utils_Tuple2(
							_List_fromArray(
								[$author$project$Route$panelRouteString.b, $author$project$Route$panelRouteString.b7.b]),
							_Utils_ap(
								A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$panelRouteString.b7.T.mn, q_.mn),
								A3(
									$author$project$Route$encodeQuery,
									$elm$url$Url$Builder$string,
									$author$project$Route$panelRouteString.b7.T.mo,
									A2($elm$core$Maybe$map, $author$project$Services$Models$encodeOrderType, q_.mo))));
					default:
						if (!page.a.a) {
							var _v17 = page.a.a;
							return _Utils_Tuple2(
								_List_fromArray(
									[$author$project$Route$panelRouteString.b, $author$project$Route$panelRouteString.bt.b, $author$project$Route$panelRouteString.bt.oN]),
								_List_Nil);
						} else {
							var _v18 = page.a.a;
							return _Utils_Tuple2(
								_List_fromArray(
									[$author$project$Route$panelRouteString.b, $author$project$Route$panelRouteString.bt.b, $author$project$Route$panelRouteString.bt.V]),
								_List_Nil);
						}
				}
			case 22:
				return _Utils_Tuple2(
					_List_fromArray(
						['nao-encontrada']),
					_List_Nil);
			default:
				switch (page.a.$) {
					case 0:
						var q = page.a.a;
						return _Utils_Tuple2(
							_List_fromArray(
								['report', $author$project$Route$reportRouteUsesPerVehicle.b]),
							_Utils_ap(
								A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteUsesPerVehicle.T.bB, q.bB),
								A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteUsesPerVehicle.T.bl, q.bl)));
					case 12:
						var _v19 = page.a;
						return _Utils_Tuple2(
							_List_fromArray(
								['report', $author$project$Route$reportRoutePDFs.b]),
							_List_Nil);
					case 1:
						var q = page.a.a;
						return _Utils_Tuple2(
							_List_fromArray(
								['report', $author$project$Route$reportRouteUsesPerDay.b]),
							_Utils_ap(
								A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteUsesPerDay.T.bB, q.bB),
								A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteUsesPerDay.T.bl, q.bl)));
					case 2:
						var q = page.a.a;
						return _Utils_Tuple2(
							_List_fromArray(
								['report', $author$project$Route$reportRouteUsesPerLine.b]),
							_Utils_ap(
								A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteUsesPerLine.T.bB, q.bB),
								A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteUsesPerLine.T.bl, q.bl)));
					case 3:
						var q = page.a.a;
						return _Utils_Tuple2(
							_List_fromArray(
								['report', $author$project$Route$reportRouteDetailedVehicle.b]),
							_Utils_ap(
								A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteDetailedVehicle.T.bB, q.bB),
								_Utils_ap(
									A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteDetailedVehicle.T.bl, q.bl),
									_Utils_ap(
										A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteDetailedVehicle.T.fN, q.fN),
										_Utils_ap(
											A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteDetailedVehicle.T.hN, q.hN),
											_Utils_ap(
												A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteDetailedVehicle.T.k2, q.k2),
												_Utils_ap(
													A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteDetailedVehicle.T.kw, q.kw),
													A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteDetailedVehicle.T.ac, q.ac))))))));
					case 4:
						var q = page.a.a;
						return _Utils_Tuple2(
							_List_fromArray(
								['report', $author$project$Route$reportRouteDetailedVehicleV2.b]),
							_Utils_ap(
								A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteDetailedVehicleV2.T.bB, q.bB),
								_Utils_ap(
									A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteDetailedVehicleV2.T.bl, q.bl),
									_Utils_ap(
										A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteDetailedVehicleV2.T.fN, q.fN),
										_Utils_ap(
											A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteDetailedVehicleV2.T.hN, q.hN),
											_Utils_ap(
												A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteDetailedVehicleV2.T.k2, q.k2),
												_Utils_ap(
													A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteDetailedVehicleV2.T.kw, q.kw),
													A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteDetailedVehicleV2.T.ac, q.ac))))))));
					case 5:
						var q = page.a.a;
						return _Utils_Tuple2(
							_List_fromArray(
								['report', $author$project$Route$reportRouteSalesSummarized.b]),
							_Utils_ap(
								A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteDetailedVehicle.T.bB, q.bB),
								A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteDetailedVehicle.T.bl, q.bl)));
					case 6:
						var q = page.a.a;
						return _Utils_Tuple2(
							_List_fromArray(
								['report', $author$project$Route$reportRouteSalesSummarizedV2.b]),
							_Utils_ap(
								A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteSalesSummarizedV2.T.bB, q.bB),
								A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteSalesSummarizedV2.T.bl, q.bl)));
					case 7:
						var q = page.a.a;
						var listToStr = function (list) {
							var _v20 = A2(
								$elm$core$String$join,
								',',
								A2(
									$elm$core$List$filter,
									$elm$core$Basics$neq(''),
									list));
							if (_v20 === '') {
								return $elm$core$Maybe$Nothing;
							} else {
								var l = _v20;
								return $elm$core$Maybe$Just(l);
							}
						};
						return _Utils_Tuple2(
							_List_fromArray(
								['report', $author$project$Route$reportRouteAdministrativeSales.b]),
							_Utils_ap(
								A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteAdministrativeSales.T.bB, q.bB),
								_Utils_ap(
									A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteAdministrativeSales.T.bl, q.bl),
									A3(
										$author$project$Route$encodeQuery,
										$elm$url$Url$Builder$string,
										$author$project$Route$reportRouteAdministrativeSales.T.g6,
										listToStr(q.g6)))));
					case 8:
						var q = page.a.a;
						return _Utils_Tuple2(
							_List_fromArray(
								['report', $author$project$Route$reportRouteUsage.b]),
							_Utils_ap(
								A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteUsage.T.bB, q.bB),
								_Utils_ap(
									A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteUsage.T.bl, q.bl),
									_Utils_ap(
										A3(
											$author$project$Route$encodeQuery,
											$elm$url$Url$Builder$int,
											$author$project$Route$reportRouteUsage.T.bv,
											$elm$core$Maybe$Just(q.bv)),
										_Utils_ap(
											A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteUsage.T.b3, q.b3),
											_Utils_ap(
												A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteUsage.T.lX, q.lX),
												_Utils_ap(
													A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteUsage.T.g6, q.g6),
													_Utils_ap(
														A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteUsage.T.fN, q.fN),
														_Utils_ap(
															A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteUsage.T.kx, q.kx),
															A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteUsage.T.ic, q.ic))))))))));
					case 9:
						var q = page.a.a;
						return _Utils_Tuple2(
							_List_fromArray(
								['report', $author$project$Route$reportRouteUsesPerClass.b]),
							_Utils_ap(
								A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteUsesPerClass.T.bB, q.bB),
								_Utils_ap(
									A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteUsesPerClass.T.bl, q.bl),
									_Utils_ap(
										A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteUsesPerClass.T.b3, q.b3),
										_Utils_ap(
											A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteUsesPerClass.T.g6, q.g6),
											_Utils_ap(
												A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteUsesPerClass.T.fN, q.fN),
												_Utils_ap(
													A3(
														$author$project$Route$encodeQuery,
														$elm$url$Url$Builder$int,
														$author$project$Route$reportRouteUsesPerClass.T.bv,
														$elm$core$Maybe$Just(q.bv)),
													_Utils_ap(
														A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteUsesPerClass.T.nB, q.nB),
														A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteUsesPerClass.T.ic, q.ic)))))))));
					case 10:
						var q = page.a.a;
						var listToStr = function (list) {
							var _v21 = A2(
								$elm$core$String$join,
								',',
								A2(
									$elm$core$List$filter,
									$elm$core$Basics$neq(''),
									list));
							if (_v21 === '') {
								return $elm$core$Maybe$Nothing;
							} else {
								var l = _v21;
								return $elm$core$Maybe$Just(l);
							}
						};
						return _Utils_Tuple2(
							_List_fromArray(
								['report', $author$project$Route$reportRouteDivergences.b]),
							_Utils_ap(
								A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteDivergences.T.bB, q.bB),
								_Utils_ap(
									A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteDivergences.T.bl, q.bl),
									_Utils_ap(
										A3(
											$author$project$Route$encodeQuery,
											$elm$url$Url$Builder$int,
											$author$project$Route$reportRouteDivergences.T.iY,
											$elm$core$Maybe$Just(q.iY)),
										_Utils_ap(
											A3(
												$author$project$Route$encodeQuery,
												$elm$url$Url$Builder$int,
												$author$project$Route$reportRouteDivergences.T.kT,
												$elm$core$Maybe$Just(q.kT)),
											_Utils_ap(
												A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteDivergences.T.kx, q.kx),
												_Utils_ap(
													A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteDivergences.T.qx, q.qx),
													_Utils_ap(
														A3(
															$author$project$Route$encodeQuery,
															$elm$url$Url$Builder$string,
															$author$project$Route$reportRouteDivergences.T.g6,
															listToStr(q.g6)),
														_Utils_ap(
															A3(
																$author$project$Route$encodeQuery,
																$elm$url$Url$Builder$string,
																$author$project$Route$reportRouteDivergences.T.b3,
																listToStr(q.b3)),
															_Utils_ap(
																A3(
																	$author$project$Route$encodeQuery,
																	$elm$url$Url$Builder$int,
																	$author$project$Route$reportRouteDivergences.T.bv,
																	$elm$core$Maybe$Just(q.bv)),
																_Utils_ap(
																	A3(
																		$author$project$Route$encodeQuery,
																		$elm$url$Url$Builder$int,
																		$author$project$Route$reportRouteDivergences.T.gk,
																		$elm$core$Maybe$Just(q.gk)),
																	_Utils_ap(
																		A3(
																			$author$project$Route$encodeQuery,
																			$elm$url$Url$Builder$int,
																			$author$project$Route$reportRouteDivergences.T.pJ,
																			$elm$core$Maybe$Just(q.pJ)),
																		_Utils_ap(
																			A3(
																				$author$project$Route$encodeQuery,
																				$elm$url$Url$Builder$string,
																				$author$project$Route$reportRouteDivergences.T.lX,
																				listToStr(q.lX)),
																			_Utils_ap(
																				A3(
																					$author$project$Route$encodeQuery,
																					$elm$url$Url$Builder$string,
																					$author$project$Route$reportRouteDivergences.T.fN,
																					listToStr(q.fN)),
																				_Utils_ap(
																					A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteDivergences.T.iI, q.iI),
																					A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteDivergences.T.kY, q.kY))))))))))))))));
					default:
						switch (page.a.a.$) {
							case 0:
								var q = page.a.a.a;
								var listToStr = function (list) {
									var _v22 = A2(
										$elm$core$String$join,
										',',
										A2(
											$elm$core$List$filter,
											$elm$core$Basics$neq(''),
											list));
									if (_v22 === '') {
										return $elm$core$Maybe$Nothing;
									} else {
										var l = _v22;
										return $elm$core$Maybe$Just(l);
									}
								};
								return _Utils_Tuple2(
									_List_fromArray(
										['report', $author$project$Route$reportRouteEvent.b, $author$project$Route$reportRouteEvent.bc.b]),
									_Utils_ap(
										A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteEvent.bc.T.bB, q.bB),
										_Utils_ap(
											A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteEvent.bc.T.bl, q.bl),
											A3(
												$author$project$Route$encodeQuery,
												$elm$url$Url$Builder$string,
												$author$project$Route$reportRouteEvent.bc.T.fN,
												listToStr(q.en)))));
							case 1:
								var q = page.a.a.a;
								var listToStr = function (list) {
									var _v23 = A2(
										$elm$core$String$join,
										',',
										A2(
											$elm$core$List$filter,
											$elm$core$Basics$neq(''),
											list));
									if (_v23 === '') {
										return $elm$core$Maybe$Nothing;
									} else {
										var l = _v23;
										return $elm$core$Maybe$Just(l);
									}
								};
								return _Utils_Tuple2(
									_List_fromArray(
										['report', $author$project$Route$reportRouteEvent.b, $author$project$Route$reportRouteEvent.bG.b]),
									_Utils_ap(
										A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteEvent.bG.T.bB, q.bB),
										_Utils_ap(
											A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteEvent.bG.T.bl, q.bl),
											A3(
												$author$project$Route$encodeQuery,
												$elm$url$Url$Builder$string,
												$author$project$Route$reportRouteEvent.bG.T.b3,
												listToStr(q.n2)))));
							case 2:
								var q = page.a.a.a;
								return _Utils_Tuple2(
									_List_fromArray(
										['report', $author$project$Route$reportRouteEvent.b, $author$project$Route$reportRouteEvent.cA.b]),
									_Utils_ap(
										A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteEvent.cA.T.bB, q.bB),
										A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteEvent.cA.T.bl, q.bl)));
							case 3:
								var q = page.a.a.a;
								var listToStr = function (list) {
									var _v24 = A2(
										$elm$core$String$join,
										',',
										A2(
											$elm$core$List$filter,
											$elm$core$Basics$neq(''),
											list));
									if (_v24 === '') {
										return $elm$core$Maybe$Nothing;
									} else {
										var l = _v24;
										return $elm$core$Maybe$Just(l);
									}
								};
								return _Utils_Tuple2(
									_List_fromArray(
										['report', $author$project$Route$reportRouteEvent.b, $author$project$Route$reportRouteEvent.bb.b]),
									_Utils_ap(
										A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteEvent.bb.T.bB, q.bB),
										_Utils_ap(
											A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteEvent.bb.T.bl, q.bl),
											A3(
												$author$project$Route$encodeQuery,
												$elm$url$Url$Builder$string,
												$author$project$Route$reportRouteEvent.bb.T.c5,
												listToStr(q.c5)))));
							case 4:
								var q = page.a.a.a;
								var listToStr = function (list) {
									var _v25 = A2(
										$elm$core$String$join,
										',',
										A2(
											$elm$core$List$filter,
											$elm$core$Basics$neq(''),
											list));
									if (_v25 === '') {
										return $elm$core$Maybe$Nothing;
									} else {
										var l = _v25;
										return $elm$core$Maybe$Just(l);
									}
								};
								return _Utils_Tuple2(
									_List_fromArray(
										['report', $author$project$Route$reportRouteEvent.b, $author$project$Route$reportRouteEvent.U.b]),
									_Utils_ap(
										A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteEvent.U.T.bB, q.bB),
										_Utils_ap(
											A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteEvent.U.T.bl, q.bl),
											_Utils_ap(
												A3(
													$author$project$Route$encodeQuery,
													$elm$url$Url$Builder$string,
													$author$project$Route$reportRouteEvent.U.T.c5,
													listToStr(q.c5)),
												_Utils_ap(
													A3(
														$author$project$Route$encodeQuery,
														$elm$url$Url$Builder$string,
														$author$project$Route$reportRouteEvent.U.T.en,
														listToStr(q.en)),
													A3(
														$author$project$Route$encodeQuery,
														$elm$url$Url$Builder$string,
														$author$project$Route$reportRouteEvent.U.T.n2,
														listToStr(q.n2)))))));
							default:
								var q = page.a.a.a;
								var listToStr = function (list) {
									var _v26 = A2(
										$elm$core$String$join,
										',',
										A2(
											$elm$core$List$filter,
											$elm$core$Basics$neq(''),
											list));
									if (_v26 === '') {
										return $elm$core$Maybe$Nothing;
									} else {
										var l = _v26;
										return $elm$core$Maybe$Just(l);
									}
								};
								return _Utils_Tuple2(
									_List_fromArray(
										['report', $author$project$Route$reportRouteEvent.b, $author$project$Route$reportRouteEvent.aj.b]),
									_Utils_ap(
										A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteEvent.aj.T.bB, q.bB),
										_Utils_ap(
											A3($author$project$Route$encodeQuery, $elm$url$Url$Builder$string, $author$project$Route$reportRouteEvent.aj.T.bl, q.bl),
											_Utils_ap(
												A3(
													$author$project$Route$encodeQuery,
													$elm$url$Url$Builder$string,
													$author$project$Route$reportRouteEvent.aj.T.en,
													listToStr(q.en)),
												A3(
													$author$project$Route$encodeQuery,
													$elm$url$Url$Builder$string,
													$author$project$Route$reportRouteEvent.aj.T.bX,
													listToStr(q.bX))))));
						}
				}
		}
	}();
	var pieces = _v0.a;
	var queries = _v0.b;
	return A2($elm$url$Url$Builder$absolute, pieces, queries);
};
var $author$project$Route$replaceUrl = F2(
	function (key, route) {
		return A2(
			$elm$browser$Browser$Navigation$replaceUrl,
			key,
			$author$project$Route$toString(route));
	});
var $author$project$Pages$Admin$init_ = F5(
	function (shared, route, maybeConcessionaireId, user, maybeModel) {
		var mapBothNoShared = F3(
			function (fnA, fnB, _v3) {
				var a = _v3.a;
				var b = _v3.b;
				return _Utils_Tuple3(
					function () {
						if (maybeModel.$ === 1) {
							return $author$project$Pages$Admin$initModel(
								fnA(a));
						} else {
							var oldModel = maybeModel.a;
							return _Utils_update(
								oldModel,
								{
									bv: fnA(a)
								});
						}
					}(),
					A2($elm$core$Platform$Cmd$map, fnB, b),
					$author$project$Shared$NoOp);
			});
		var defaultRoute = _Utils_Tuple3(
			$author$project$Pages$Admin$initModel($author$project$Pages$Admin$Redirect),
			A2($author$project$Route$replaceUrl, shared.nZ, $author$project$Route$NotFound),
			$author$project$Shared$NoOp);
		var initPage = function (lazy) {
			switch (route.$) {
				case 0:
					var queries = route.a;
					return $author$project$Services$Models$iHaveAccess(
						{
							gZ: user.hg,
							hf: $author$project$Services$Models$SYSTEM_USER(0),
							hQ: A3(
								mapBothNoShared,
								$author$project$Pages$Admin$UsersPage,
								$author$project$Pages$Admin$UsersMsg,
								A3($author$project$Pages$Admin$Users$init, queries, shared, user)),
							hR: defaultRoute
						});
				case 1:
					return A3(
						mapBothNoShared,
						$author$project$Pages$Admin$EquipmentsPage,
						$author$project$Pages$Admin$EquipmentsMsg,
						A2($author$project$Pages$Admin$Equipments$init, shared, user));
				case 2:
					var maybePage = route.a;
					var maybeSearch = route.b;
					return A3(
						mapBothNoShared,
						A2($author$project$Pages$Admin$CardsPage, maybePage, maybeSearch),
						$author$project$Pages$Admin$CardsMsg,
						A4($author$project$Pages$Admin$Cards$init, shared, maybePage, maybeSearch, user));
				case 3:
					var id = route.a;
					return A3(
						mapBothNoShared,
						$author$project$Pages$Admin$CardExtractPage(id),
						$author$project$Pages$Admin$CardExtractMsg,
						A2($author$project$Pages$Admin$CardExtract$init, user, id));
				case 4:
					var maybePage = route.a;
					var maybeSearch = route.b;
					var maybeActive = route.c;
					return A3(
						mapBothNoShared,
						A3($author$project$Pages$Admin$VehiclesPage, maybePage, maybeSearch, maybeActive),
						$author$project$Pages$Admin$VehiclesMsg,
						A5($author$project$Pages$Admin$Vehicles$init, shared, maybePage, maybeSearch, maybeActive, user));
				case 5:
					return A3(
						mapBothNoShared,
						$author$project$Pages$Admin$AccountabilityReportPage,
						$author$project$Pages$Admin$AccountabilityReportMsg,
						$author$project$Pages$Admin$AccountabilityReport$init(user));
				case 6:
					return A3(
						mapBothNoShared,
						$author$project$Pages$Admin$SalesReportPage,
						$author$project$Pages$Admin$SalesReportMsg,
						$author$project$Pages$Admin$SalesReport$init(user));
				case 7:
					return A3(
						mapBothNoShared,
						$author$project$Pages$Admin$SessionsReportPage,
						$author$project$Pages$Admin$SessionsReportMsg,
						$author$project$Pages$Admin$SessionsReport$init(user));
				case 8:
					return $author$project$Services$Models$iHaveAccess(
						{
							gZ: user.hg,
							hf: $author$project$Services$Models$REPORTS($author$project$Services$Models$SessionsWithoutPouch),
							hQ: A3(
								mapBothNoShared,
								$author$project$Pages$Admin$SessionsWithoutPouchReportPage,
								$author$project$Pages$Admin$SessionsWithoutPouchReportMsg,
								$author$project$Pages$Admin$SessionWithoutPouchReport$init(user)),
							hR: defaultRoute
						});
				case 9:
					var q_ = route.a;
					return $author$project$Services$Models$iHaveAccess(
						{
							gZ: user.hg,
							hf: $author$project$Services$Models$REPORTS($author$project$Services$Models$Sales),
							hQ: A3(
								mapBothNoShared,
								$author$project$Pages$Admin$SalesReportV2Page,
								$author$project$Pages$Admin$SalesReportV2Msg,
								A2($author$project$Pages$Admin$Reports$Sales$init, q_, user)),
							hR: defaultRoute
						});
				case 10:
					return A3(
						mapBothNoShared,
						$author$project$Pages$Admin$PaymentGuidesPage,
						$author$project$Pages$Admin$PaymentGuidesMsg,
						$author$project$Pages$Admin$PaymentGuides$init(user));
				case 11:
					return A3(
						mapBothNoShared,
						$author$project$Pages$Admin$PaymentBilletsPage,
						$author$project$Pages$Admin$PaymentBilletsMsg,
						$author$project$Pages$Admin$PaymentBillets$init(user));
				case 12:
					return A3(
						mapBothNoShared,
						$author$project$Pages$Admin$CompanyOrdersPage,
						$author$project$Pages$Admin$CompanyOrdersMsg,
						A5($author$project$Pages$Admin$CompanyOrders$init, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, user));
				case 13:
					var companyId = route.a;
					var maybeId = function (id) {
						return $elm$core$String$isEmpty(id) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(companyId);
					};
					return A3(
						mapBothNoShared,
						$author$project$Pages$Admin$CompanyOrdersPage,
						$author$project$Pages$Admin$CompanyOrdersMsg,
						A5(
							$author$project$Pages$Admin$CompanyOrders$init,
							$elm$core$Maybe$Nothing,
							$elm$core$Maybe$Nothing,
							maybeId(companyId),
							$elm$core$Maybe$Nothing,
							user));
				default:
					var companyID = route.a.l8;
					var detailID = route.a.mF;
					var maybePage = route.a.ob;
					var source = route.a.pO;
					var maybeId = function (id) {
						return $elm$core$String$isEmpty(id) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(id);
					};
					return A3(
						mapBothNoShared,
						$author$project$Pages$Admin$CompanyOrdersPage,
						$author$project$Pages$Admin$CompanyOrdersMsg,
						A5(
							$author$project$Pages$Admin$CompanyOrders$init,
							source,
							maybePage,
							maybeId(companyID),
							maybeId(detailID),
							user));
			}
		};
		var setConcessionaireIdUrlQuery = function (concessionaireId) {
			return _Utils_eq(
				maybeConcessionaireId,
				$elm$core$Maybe$Just(concessionaireId)) ? initPage(0) : _Utils_Tuple3(
				A2(
					$elm$core$Maybe$withDefault,
					$author$project$Pages$Admin$initModel($author$project$Pages$Admin$Redirect),
					maybeModel),
				A2(
					$author$project$Route$replaceUrl,
					shared.nZ,
					A2(
						$author$project$Route$Admin,
						route,
						$elm$core$Maybe$Just(concessionaireId))),
				$author$project$Shared$NoOp);
		};
		var _v0 = user.k$;
		switch (_v0.$) {
			case 3:
				return initPage(0);
			case 0:
				var concessionaireId = _v0.a.mc;
				return setConcessionaireIdUrlQuery(concessionaireId);
			case 1:
				var concessionaireId = _v0.a.mc;
				return setConcessionaireIdUrlQuery(concessionaireId);
			default:
				var concessionaireId = _v0.a.mc;
				return setConcessionaireIdUrlQuery(concessionaireId);
		}
	});
var $author$project$Pages$Admin$changedRoute = F5(
	function (shared, route, maybeConcessionaireId, model, user) {
		return A5(
			$author$project$Pages$Admin$init_,
			shared,
			route,
			maybeConcessionaireId,
			user,
			$elm$core$Maybe$Just(model));
	});
var $author$project$Pages$Pos$Passenger$ApplyRefill = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Pos$Passenger$GotApplyRefillMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Pos$Passenger$GotIssueCardMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Pos$Passenger$GotIssueDuplicateMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Pos$Passenger$GotPassengerCardMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Pos$Passenger$GotRegisterBeneficiaryMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Pos$Passenger$GotSellSingleChargeMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Pos$Passenger$GotSellTicketMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Pos$Passenger$GotUnlockCardMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Pos$Passenger$Home = {$: 0};
var $author$project$Pages$Pos$Passenger$IssueCard = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Pos$Passenger$IssueDuplicate = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Pos$Passenger$Loaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Pos$Passenger$Loading = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Pages$Pos$Passenger$RegisterBeneficiary = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Pos$Passenger$SellSingleCharge = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Pos$Passenger$SellTicket = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Pos$Passenger$UnlockCard = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Pos$Passenger$GotPassengerInfo = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Data$Passenger$PassengerInfo = function (id) {
	return function (userId) {
		return function (concessionaireId) {
			return function (name) {
				return function (document) {
					return function (documentType) {
						return function (phone) {
							return function (image) {
								return function (classes) {
									return function (cards) {
										return function (email) {
											return {f0: cards, dv: classes, mc: concessionaireId, iI: document, mO: documentType, mX: email, dM: id, nM: image, c3: name, jX: phone, qw: userId};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$Passenger$Card = function (id) {
	return function (serial) {
		return function (criptogram) {
			return function (blockStatus) {
				return function (blockedWhen) {
					return function (expiration) {
						return function (expirationDate) {
							return function (virtual) {
								return function (refills) {
									return function (wallets) {
										return function (blockedByFraud) {
											return function (reason) {
												return {h7: blockStatus, lE: blockedByFraud, lF: blockedWhen, ml: criptogram, na: expiration, nb: expirationDate, dM: id, pf: reason, j8: refills, kw: serial, qE: virtual, hO: wallets};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$Passenger$Refill = F5(
	function (id, value, purseId, counter, cryptogram) {
		return {mg: counter, mm: cryptogram, dM: id, o9: purseId, di: value};
	});
var $elm$json$Json$Decode$map5 = _Json_map5;
var $author$project$Data$Passenger$refillDecoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Data$Passenger$Refill,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'value', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'purseId', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'counter', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'cryptogram', $elm$json$Json$Decode$string));
var $author$project$Data$Passenger$Wallet = F4(
	function (id, balance, classes, purseID) {
		return {h2: balance, dv: classes, dM: id, o8: purseID};
	});
var $author$project$Data$Passenger$Class = F5(
	function (id, name, classId, typeId, purseID) {
		return {lY: classId, dM: id, c3: name, o8: purseID, qn: typeId};
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded = A2($elm$core$Basics$composeR, $elm$json$Json$Decode$succeed, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom);
var $author$project$Data$Passenger$classDecoder = function (maybeClassId) {
	var decoderClassTypeID = function () {
		if (!maybeClassId.$) {
			return $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded(maybeClassId);
		} else {
			return A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'walletClassTypeID',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing);
		}
	}();
	return A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'purseID',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
		$elm$core$Maybe$Nothing,
		decoderClassTypeID(
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'classId',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'name',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Data$Passenger$Class))))));
};
var $elm$json$Json$Decode$map4 = _Json_map4;
var $author$project$Data$Passenger$walletDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Data$Passenger$Wallet,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'balance', $elm$json$Json$Decode$int),
	A2(
		$elm$json$Json$Decode$field,
		'classes',
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					$elm$json$Json$Decode$list(
					$author$project$Data$Passenger$classDecoder($elm$core$Maybe$Nothing)),
					$elm$json$Json$Decode$null(_List_Nil)
				]))),
	A2(
		$elm$json$Json$Decode$field,
		'purseID',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)));
var $author$project$Data$Passenger$cardDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'reason',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'blockedByFraud',
		$elm$json$Json$Decode$bool,
		false,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'wallets',
			$elm$json$Json$Decode$list($author$project$Data$Passenger$walletDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'refills',
				$elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							$elm$json$Json$Decode$list($author$project$Data$Passenger$refillDecoder),
							$elm$json$Json$Decode$succeed(_List_Nil)
						])),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'virtual',
					$elm$json$Json$Decode$bool,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'expirationDate',
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'expiration',
							$elm$json$Json$Decode$maybe($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
							$elm$core$Maybe$Nothing,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'statusAt',
								A2(
									$elm$json$Json$Decode$map,
									A2(
										$elm$core$Basics$composeR,
										$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime,
										$elm$core$Result$withDefault(
											$elm$time$Time$millisToPosix(0))),
									$elm$json$Json$Decode$oneOf(
										_List_fromArray(
											[
												$elm$json$Json$Decode$string,
												$elm$json$Json$Decode$null('')
											]))),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'status',
									$author$project$Data$Passenger$blockStatusDecoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'criptogram',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'serial',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'id',
												$elm$json$Json$Decode$string,
												$elm$json$Json$Decode$succeed($author$project$Data$Passenger$Card)))))))))))));
var $author$project$Data$Passenger$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'email',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'cards',
		$elm$json$Json$Decode$list($author$project$Data$Passenger$cardDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'classes',
			$elm$json$Json$Decode$list(
				$author$project$Data$Passenger$classDecoder($elm$core$Maybe$Nothing)),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'path',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'mobilePhone',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'documentType',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'document',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'name',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'concessionaire_id',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'userId',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'id',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$Data$Passenger$PassengerInfo))))))))))));
var $author$project$Services$Concessionaire$getPassengerInfo = function (options) {
	return $elm$http$Http$task(
		{
			lG: $elm$http$Http$emptyBody,
			nG: _List_fromArray(
				[
					$author$project$Services$Api$authorizationHeader(options.kU)
				]),
			of: 'GET',
			d6: $author$project$Services$Api$jsonResolver($author$project$Data$Passenger$decoder),
			p5: $elm$core$Maybe$Nothing,
			qt: A2(
				$author$project$Constants$concessionaireServiceUrl,
				_List_fromArray(
					['api', 'v1', 'passenger', options.oM]),
				_List_Nil)
		});
};
var $author$project$Pages$Pos$Passenger$getPassenger = F3(
	function (user, passengerId, route) {
		return A2(
			$elm$core$Task$attempt,
			A2($author$project$Pages$Pos$Passenger$GotPassengerInfo, passengerId, route),
			$author$project$Services$Concessionaire$getPassengerInfo(
				{oM: passengerId, kU: user.kU}));
	});
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$PassengerCard$init = function (passenger) {
	return _Utils_Tuple2(
		{
			aY: $elm$core$Maybe$Nothing,
			dc: A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.dM;
				},
				$elm$core$List$head(passenger.f0)),
			dd: 0
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Shared$Batch = function (a) {
	return {$: 1, a: a};
};
var $author$project$Route$Passenger = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Route$PassengerHome = 0;
var $author$project$Shared$RedirectPreserve = function (a) {
	return {$: 3, a: a};
};
var $author$project$Shared$ShowErrorDialog = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Pos$Passenger$ApplyRefill$Unable = {$: 0};
var $author$project$Pages$Pos$Passenger$ApplyRefill$WaitValidateCard = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Pos$Passenger$ApplyRefill$init = F2(
	function (user, passenger) {
		var mPhysicalCard = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.qE;
					},
					$elm$core$Basics$not),
				passenger.f0));
		var hasBlockunblockRequest = _Utils_eq(
			$elm$core$Maybe$Just(true),
			A2(
				$elm$core$Maybe$map,
				function (card) {
					return (card.h7 === 2) || (card.h7 === 3);
				},
				mPhysicalCard));
		if (!mPhysicalCard.$) {
			var physicalCard = mPhysicalCard.a;
			return (hasBlockunblockRequest || ($elm$core$List$length(physicalCard.j8) > 0)) ? _Utils_Tuple3(
				$author$project$Pages$Pos$Passenger$ApplyRefill$WaitValidateCard(
					{
						cH: physicalCard,
						ci: A2(
							$elm$core$List$sortBy,
							function ($) {
								return $.o9;
							},
							A2(
								$elm$core$List$sortBy,
								function ($) {
									return $.mg;
								},
								physicalCard.j8))
					}),
				$elm$core$Platform$Cmd$none,
				$author$project$Shared$NoOp) : _Utils_Tuple3(
				$author$project$Pages$Pos$Passenger$ApplyRefill$Unable,
				$elm$core$Platform$Cmd$none,
				$author$project$Shared$Batch(
					_List_fromArray(
						[
							$author$project$Shared$ShowErrorDialog('Passageiro não possui cargas nem requisição de bloqueio/desbloqueio.'),
							$author$project$Shared$RedirectPreserve(
							A2($author$project$Route$Passenger, passenger.dM, 0))
						])));
		} else {
			return _Utils_Tuple3(
				$author$project$Pages$Pos$Passenger$ApplyRefill$Unable,
				$elm$core$Platform$Cmd$none,
				$author$project$Shared$ShowErrorDialog('Passageiro não possui cartão físico'));
		}
	});
var $author$project$Pages$Pos$Passenger$IssueCard$CantIssue = {$: 0};
var $author$project$Pages$Pos$Passenger$IssueCard$CardAlreadyIssued = {$: 1};
var $author$project$Pages$Pos$Passenger$IssueCard$ChangeCard = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Pos$Passenger$IssueCard$GotDatePickerMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Pos$Passenger$IssueCard$SelectExpiration = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Pos$Passenger$IssueCard$SharedMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Pos$Passenger$IssueCard$isCardValidToIssue = function (card) {
	return (!card.qE) && (card.kw === '');
};
var $author$project$Pages$Pos$Passenger$IssueCard$getCard = function (cards) {
	return $elm$core$List$head(
		A2($elm$core$List$filter, $author$project$Pages$Pos$Passenger$IssueCard$isCardValidToIssue, cards));
};
var $CurrySoftware$elm_datepicker$DatePicker$CurrentDate = function (a) {
	return {$: 0, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$DatePicker = $elm$core$Basics$identity;
var $elm$time$Time$May = 4;
var $justinmimbs$date$Date$RD = $elm$core$Basics$identity;
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $justinmimbs$date$Date$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$date$Date$daysBeforeMonth = F2(
	function (y, m) {
		var leapDays = $justinmimbs$date$Date$isLeapYear(y) ? 1 : 0;
		switch (m) {
			case 0:
				return 0;
			case 1:
				return 31;
			case 2:
				return 59 + leapDays;
			case 3:
				return 90 + leapDays;
			case 4:
				return 120 + leapDays;
			case 5:
				return 151 + leapDays;
			case 6:
				return 181 + leapDays;
			case 7:
				return 212 + leapDays;
			case 8:
				return 243 + leapDays;
			case 9:
				return 273 + leapDays;
			case 10:
				return 304 + leapDays;
			default:
				return 334 + leapDays;
		}
	});
var $justinmimbs$date$Date$floorDiv = F2(
	function (a, b) {
		return $elm$core$Basics$floor(a / b);
	});
var $justinmimbs$date$Date$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (A2($justinmimbs$date$Date$floorDiv, y, 4) - A2($justinmimbs$date$Date$floorDiv, y, 100)) + A2($justinmimbs$date$Date$floorDiv, y, 400);
	return (365 * y) + leapYears;
};
var $justinmimbs$date$Date$daysInMonth = F2(
	function (y, m) {
		switch (m) {
			case 0:
				return 31;
			case 1:
				return $justinmimbs$date$Date$isLeapYear(y) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $justinmimbs$date$Date$fromCalendarDate = F3(
	function (y, m, d) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A3(
			$elm$core$Basics$clamp,
			1,
			A2($justinmimbs$date$Date$daysInMonth, y, m),
			d);
	});
var $CurrySoftware$elm_datepicker$DatePicker$Date$initDate = A3($justinmimbs$date$Date$fromCalendarDate, 1992, 4, 31);
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.eb, posixMinutes) < 0) {
					return posixMinutes + era.oq;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$core$Basics$ge = _Utils_ge;
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		dC: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		b8: month,
		cF: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).dC;
	});
var $elm$time$Time$Apr = 3;
var $elm$time$Time$Aug = 7;
var $elm$time$Time$Dec = 11;
var $elm$time$Time$Feb = 1;
var $elm$time$Time$Jan = 0;
var $elm$time$Time$Jul = 6;
var $elm$time$Time$Jun = 5;
var $elm$time$Time$Mar = 2;
var $elm$time$Time$Nov = 10;
var $elm$time$Time$Oct = 9;
var $elm$time$Time$Sep = 8;
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).b8;
		switch (_v0) {
			case 1:
				return 0;
			case 2:
				return 1;
			case 3:
				return 2;
			case 4:
				return 3;
			case 5:
				return 4;
			case 6:
				return 5;
			case 7:
				return 6;
			case 8:
				return 7;
			case 9:
				return 8;
			case 10:
				return 9;
			case 11:
				return 10;
			default:
				return 11;
		}
	});
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).cF;
	});
var $justinmimbs$date$Date$fromPosix = F2(
	function (zone, posix) {
		return A3(
			$justinmimbs$date$Date$fromCalendarDate,
			A2($elm$time$Time$toYear, zone, posix),
			A2($elm$time$Time$toMonth, zone, posix),
			A2($elm$time$Time$toDay, zone, posix));
	});
var $justinmimbs$date$Date$today = A3($elm$core$Task$map2, $justinmimbs$date$Date$fromPosix, $elm$time$Time$here, $elm$time$Time$now);
var $CurrySoftware$elm_datepicker$DatePicker$init = _Utils_Tuple2(
	{
		_: $elm$core$Maybe$Just($CurrySoftware$elm_datepicker$DatePicker$Date$initDate),
		bo: false,
		aA: $elm$core$Maybe$Nothing,
		jJ: false,
		ef: $CurrySoftware$elm_datepicker$DatePicker$Date$initDate
	},
	A2($elm$core$Task$perform, $CurrySoftware$elm_datepicker$DatePicker$CurrentDate, $justinmimbs$date$Date$today));
var $elm$core$Maybe$map2 = F3(
	function (func, ma, mb) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				return $elm$core$Maybe$Just(
					A2(func, a, b));
			}
		}
	});
var $author$project$Pages$Pos$Passenger$IssueCard$init = F3(
	function (maybeSelectedCard, user, passenger) {
		var userHasCard = A2(
			$elm$core$List$any,
			function (card) {
				return (!card.qE) && (card.kw === '');
			},
			passenger.f0);
		var getCard_ = $author$project$Pages$Pos$Passenger$IssueCard$getCard(passenger.f0);
		var isSameCard = A2(
			$elm$core$Maybe$withDefault,
			false,
			A3(
				$elm$core$Maybe$map2,
				F2(
					function (cardToUse, cardSelected) {
						return _Utils_eq(cardToUse.dM, cardSelected);
					}),
				getCard_,
				maybeSelectedCard));
		var _v0 = _Utils_Tuple3(userHasCard, getCard_, isSameCard);
		if (_v0.a && (!_v0.b.$)) {
			if (_v0.c) {
				var card = _v0.b.a;
				if ($author$project$Pages$Pos$Passenger$IssueCard$isCardValidToIssue(card)) {
					var _v1 = $CurrySoftware$elm_datepicker$DatePicker$init;
					var datePicker = _v1.a;
					var datePickerFx = _v1.b;
					return _Utils_Tuple3(
						$author$project$Pages$Pos$Passenger$IssueCard$SelectExpiration(
							{cH: card, cO: $elm$core$Maybe$Nothing, cP: datePicker}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Pos$Passenger$IssueCard$GotDatePickerMsg, datePickerFx),
						$author$project$Pages$Pos$Passenger$IssueCard$SharedMsg($author$project$Shared$NoOp));
				} else {
					return _Utils_Tuple3(
						$author$project$Pages$Pos$Passenger$IssueCard$CardAlreadyIssued,
						$elm$core$Platform$Cmd$none,
						$author$project$Pages$Pos$Passenger$IssueCard$SharedMsg($author$project$Shared$NoOp));
				}
			} else {
				var card = _v0.b.a;
				if ($author$project$Pages$Pos$Passenger$IssueCard$isCardValidToIssue(card)) {
					var _v2 = $CurrySoftware$elm_datepicker$DatePicker$init;
					var datePicker = _v2.a;
					var datePickerFx = _v2.b;
					return _Utils_Tuple3(
						$author$project$Pages$Pos$Passenger$IssueCard$SelectExpiration(
							{cH: card, cO: $elm$core$Maybe$Nothing, cP: datePicker}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Pos$Passenger$IssueCard$GotDatePickerMsg, datePickerFx),
						$author$project$Pages$Pos$Passenger$IssueCard$ChangeCard(card));
				} else {
					return _Utils_Tuple3(
						$author$project$Pages$Pos$Passenger$IssueCard$CardAlreadyIssued,
						$elm$core$Platform$Cmd$none,
						$author$project$Pages$Pos$Passenger$IssueCard$SharedMsg($author$project$Shared$NoOp));
				}
			}
		} else {
			return _Utils_Tuple3(
				$author$project$Pages$Pos$Passenger$IssueCard$CantIssue,
				$elm$core$Platform$Cmd$none,
				$author$project$Pages$Pos$Passenger$IssueCard$SharedMsg($author$project$Shared$NoOp));
		}
	});
var $author$project$Pages$Pos$Passenger$IssueDuplicate$DisplayCards = {$: 0};
var $author$project$Pages$Pos$Passenger$IssueDuplicate$init = F2(
	function (user, passenger) {
		return _Utils_Tuple3($author$project$Pages$Pos$Passenger$IssueDuplicate$DisplayCards, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
	});
var $author$project$Pages$Pos$Passenger$RegisterBeneficiary$LoadingConcessionaires = {$: 1};
var $author$project$Pages$Pos$Passenger$RegisterBeneficiary$NoVirtualCard = {$: 0};
var $author$project$Pages$Pos$Passenger$RegisterBeneficiary$ReceivedConcessionaireClasses = function (a) {
	return {$: 0, a: a};
};
var $author$project$Services$Concessionaire$ConcessionaireClass = F4(
	function (id, name, types, classID) {
		return {lX: classID, dM: id, c3: name, dh: types};
	});
var $author$project$Services$Concessionaire$getConcessionaireClasses = function (options) {
	var virtualQueryStr = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (virtual) {
				return virtual ? _List_fromArray(
					[
						A2($elm$url$Url$Builder$string, 'type', 'virtual')
					]) : _List_fromArray(
					[
						A2($elm$url$Url$Builder$string, 'type', 'physical')
					]);
			},
			options.qE));
	var classDecoder = A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'classId',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'walletClassesType',
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						$elm$json$Json$Decode$list(
						A3(
							$elm$json$Json$Decode$map2,
							F2(
								function (id, name) {
									return {dM: id, c3: name};
								}),
							A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
							A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string))),
						$elm$json$Json$Decode$succeed(_List_Nil)
					])),
			_List_Nil,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Services$Concessionaire$ConcessionaireClass)))));
	return $elm$http$Http$request(
		{
			lG: $elm$http$Http$emptyBody,
			m9: A2(
				$author$project$Services$Api$expectJson,
				options.ow,
				$elm$json$Json$Decode$list(classDecoder)),
			nG: _List_fromArray(
				[
					$author$project$Services$Api$authorizationHeader(options.kU)
				]),
			of: 'GET',
			p5: $elm$core$Maybe$Nothing,
			qi: $elm$core$Maybe$Nothing,
			qt: A2(
				$author$project$Constants$concessionaireServiceUrl,
				_List_fromArray(
					['api', 'v1', 'wallets', 'classes']),
				virtualQueryStr)
		});
};
var $author$project$Pages$Pos$Passenger$RegisterBeneficiary$init = F2(
	function (user, passenger) {
		var _v0 = A2(
			$elm$core$List$filter,
			function ($) {
				return $.qE;
			},
			passenger.f0);
		if (!_v0.b) {
			return _Utils_Tuple3(
				$author$project$Pages$Pos$Passenger$RegisterBeneficiary$NoVirtualCard,
				$elm$core$Platform$Cmd$none,
				$author$project$Shared$Batch(
					_List_fromArray(
						[
							$author$project$Shared$ShowErrorDialog('Passageiro não tem cartão virtual'),
							$author$project$Shared$RedirectPreserve(
							A2($author$project$Route$Passenger, passenger.dM, 0))
						])));
		} else {
			return _Utils_Tuple3(
				$author$project$Pages$Pos$Passenger$RegisterBeneficiary$LoadingConcessionaires,
				$author$project$Services$Concessionaire$getConcessionaireClasses(
					{
						ow: $author$project$Pages$Pos$Passenger$RegisterBeneficiary$ReceivedConcessionaireClasses,
						kU: user.kU,
						qE: $elm$core$Maybe$Just(true)
					}),
				$author$project$Shared$NoOp);
		}
	});
var $author$project$Pages$Pos$Passenger$SellSingleCharge$SingleChargesType = function (a) {
	return {$: 10, a: a};
};
var $author$project$Constants$apiV2 = $elm$url$Url$Builder$crossOrigin('https://apiv2.pazze.app');
var $author$project$Services$SingleCharge$Inactive = 1;
var $author$project$Services$SingleCharge$SingleCharge = F5(
	function (id, createdAt, value, typeDescription, active) {
		return {at: active, ix: createdAt, dM: id, kX: typeDescription, di: value};
	});
var $author$project$Services$SingleCharge$Active = 0;
var $author$project$Services$SingleCharge$decodeStatus = A2(
	$elm$json$Json$Decode$andThen,
	function (bool) {
		var decode = function (active) {
			return active ? 0 : 1;
		};
		return $elm$json$Json$Decode$succeed(
			decode(bool));
	},
	$elm$json$Json$Decode$bool);
var $author$project$Services$SingleCharge$decodeSingleCharge = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'active',
	$author$project$Services$SingleCharge$decodeStatus,
	1,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'typeDescription',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'value',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'createdAt',
				$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Services$SingleCharge$SingleCharge))))));
var $elm$core$Result$andThen = F2(
	function (callback, result) {
		if (!result.$) {
			var value = result.a;
			return callback(value);
		} else {
			var msg = result.a;
			return $elm$core$Result$Err(msg);
		}
	});
var $author$project$Services$Api$expectStringError = function (response) {
	switch (response.$) {
		case 0:
			return $elm$core$Result$Err('Endereço inválido');
		case 1:
			return $elm$core$Result$Err('Tempo limite de resposta atingido. Verifique sua conexão.');
		case 2:
			return $elm$core$Result$Err('Não foi possível conectar ao servidor');
		case 3:
			var metadata = response.a;
			var body = response.b;
			var _v1 = _Utils_Tuple2(
				metadata.cw,
				A2(
					$elm$json$Json$Decode$decodeString,
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string),
								A2($elm$json$Json$Decode$field, 'errorMessage', $elm$json$Json$Decode$string)
							])),
					body));
			_v1$0:
			while (true) {
				if (!_v1.b.$) {
					if (_v1.a === 401) {
						break _v1$0;
					} else {
						if (_v1.b.a === 'access denied') {
							return $elm$core$Result$Err('Acesso negado');
						} else {
							var errorMessage = _v1.b.a;
							return $elm$core$Result$Err(errorMessage);
						}
					}
				} else {
					if (_v1.a === 401) {
						break _v1$0;
					} else {
						return $elm$core$Result$Err('Ocorreu um erro no servidor');
					}
				}
			}
			return $elm$core$Result$Err('unauthorized');
		default:
			var body = response.b;
			return $elm$core$Result$Ok(body);
	}
};
var $author$project$Services$Api$expectJsonErrorString = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Services$Api$expectStringError,
				$elm$core$Result$andThen(
					function (body) {
						var _v0 = A2($elm$json$Json$Decode$decodeString, decoder, body);
						if (!_v0.$) {
							var value = _v0.a;
							return $elm$core$Result$Ok(value);
						} else {
							var err = _v0.a;
							return $elm$core$Result$Err(
								'Ocorreu um erro: ' + $elm$json$Json$Decode$errorToString(err));
						}
					})));
	});
var $krisajenkins$remotedata$RemoteData$Failure = function (a) {
	return {$: 2, a: a};
};
var $krisajenkins$remotedata$RemoteData$Success = function (a) {
	return {$: 3, a: a};
};
var $krisajenkins$remotedata$RemoteData$fromResult = function (result) {
	if (result.$ === 1) {
		var e = result.a;
		return $krisajenkins$remotedata$RemoteData$Failure(e);
	} else {
		var x = result.a;
		return $krisajenkins$remotedata$RemoteData$Success(x);
	}
};
var $author$project$Services$Api$getHttp = function (options) {
	return $elm$http$Http$request(
		{
			lG: $elm$http$Http$emptyBody,
			m9: options.m9,
			nG: _List_fromArray(
				[
					$author$project$Services$Api$authorizationHeader(options.kU)
				]),
			of: 'GET',
			p5: $elm$core$Maybe$Nothing,
			qi: $elm$core$Maybe$Nothing,
			qt: options.qt
		});
};
var $author$project$Services$SingleCharge$getSingleCharges = function (options) {
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$elm$json$Json$Decode$list($author$project$Services$SingleCharge$decodeSingleCharge)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'extraCharges', 'listAllExtraChargeTypes']),
				_List_Nil)
		});
};
var $author$project$Pages$Pos$Passenger$SellSingleCharge$ModalHidden = {$: 0};
var $author$project$Pages$Pos$Passenger$SellSingleCharge$initModel = function (passenger) {
	return {aY: $author$project$Pages$Pos$Passenger$SellSingleCharge$ModalHidden, fv: $krisajenkins$remotedata$RemoteData$NotAsked, dg: '', fL: passenger.qw};
};
var $author$project$Pages$Pos$Passenger$SellSingleCharge$init = F2(
	function (user, passenger) {
		return _Utils_Tuple3(
			$author$project$Pages$Pos$Passenger$SellSingleCharge$initModel(passenger),
			$author$project$Services$SingleCharge$getSingleCharges(
				{ow: $author$project$Pages$Pos$Passenger$SellSingleCharge$SingleChargesType, kU: user.kU}),
			$author$project$Shared$NoOp);
	});
var $author$project$Pages$Pos$Passenger$SellTicket$GotTime = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Pos$Passenger$SellTicket$ReceivedUUID = function (a) {
	return {$: 3, a: a};
};
var $elm$random$Random$Generate = $elm$core$Basics$identity;
var $elm$random$Random$Seed = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $elm$random$Random$next = function (_v0) {
	var state0 = _v0.a;
	var incr = _v0.b;
	return A2($elm$random$Random$Seed, ((state0 * 1664525) + incr) >>> 0, incr);
};
var $elm$random$Random$initialSeed = function (x) {
	var _v0 = $elm$random$Random$next(
		A2($elm$random$Random$Seed, 0, 1013904223));
	var state1 = _v0.a;
	var incr = _v0.b;
	var state2 = (state1 + x) >>> 0;
	return $elm$random$Random$next(
		A2($elm$random$Random$Seed, state2, incr));
};
var $elm$random$Random$init = A2(
	$elm$core$Task$andThen,
	function (time) {
		return $elm$core$Task$succeed(
			$elm$random$Random$initialSeed(
				$elm$time$Time$posixToMillis(time)));
	},
	$elm$time$Time$now);
var $elm$random$Random$step = F2(
	function (_v0, seed) {
		var generator = _v0;
		return generator(seed);
	});
var $elm$random$Random$onEffects = F3(
	function (router, commands, seed) {
		if (!commands.b) {
			return $elm$core$Task$succeed(seed);
		} else {
			var generator = commands.a;
			var rest = commands.b;
			var _v1 = A2($elm$random$Random$step, generator, seed);
			var value = _v1.a;
			var newSeed = _v1.b;
			return A2(
				$elm$core$Task$andThen,
				function (_v2) {
					return A3($elm$random$Random$onEffects, router, rest, newSeed);
				},
				A2($elm$core$Platform$sendToApp, router, value));
		}
	});
var $elm$random$Random$onSelfMsg = F3(
	function (_v0, _v1, seed) {
		return $elm$core$Task$succeed(seed);
	});
var $elm$random$Random$Generator = $elm$core$Basics$identity;
var $elm$random$Random$map = F2(
	function (func, _v0) {
		var genA = _v0;
		return function (seed0) {
			var _v1 = genA(seed0);
			var a = _v1.a;
			var seed1 = _v1.b;
			return _Utils_Tuple2(
				func(a),
				seed1);
		};
	});
var $elm$random$Random$cmdMap = F2(
	function (func, _v0) {
		var generator = _v0;
		return A2($elm$random$Random$map, func, generator);
	});
_Platform_effectManagers['Random'] = _Platform_createManager($elm$random$Random$init, $elm$random$Random$onEffects, $elm$random$Random$onSelfMsg, $elm$random$Random$cmdMap);
var $elm$random$Random$command = _Platform_leaf('Random');
var $elm$random$Random$generate = F2(
	function (tagger, generator) {
		return $elm$random$Random$command(
			A2($elm$random$Random$map, tagger, generator));
	});
var $author$project$Pages$Pos$Passenger$SellTicket$ModalHidden = {$: 0};
var $author$project$Pages$Pos$Passenger$SellTicket$PhysicalCard = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Pos$Passenger$SellTicket$VirtualCard = {$: 1};
var $author$project$Pages$Pos$Passenger$SellTicket$initModel = function (passenger) {
	return {
		aY: $author$project$Pages$Pos$Passenger$SellTicket$ModalHidden,
		e8: $elm$time$Time$millisToPosix(0),
		k: {
			lY: $elm$core$Maybe$Nothing,
			mk: function () {
				var _v0 = passenger.f0;
				if (_v0.b && (!_v0.b.b)) {
					var onlyOne = _v0.a;
					return onlyOne.qE ? $elm$core$Maybe$Just($author$project$Pages$Pos$Passenger$SellTicket$VirtualCard) : $elm$core$Maybe$Just(
						$author$project$Pages$Pos$Passenger$SellTicket$PhysicalCard(onlyOne.dM));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}(),
			eB: '',
			he: $elm$core$Maybe$Nothing
		},
		qA: $elm$core$Maybe$Nothing
	};
};
var $danyx23$elm_uuid$Uuid$Uuid = $elm$core$Basics$identity;
var $elm$core$Bitwise$xor = _Bitwise_xor;
var $elm$random$Random$peel = function (_v0) {
	var state = _v0.a;
	var word = (state ^ (state >>> ((state >>> 28) + 4))) * 277803737;
	return ((word >>> 22) ^ word) >>> 0;
};
var $elm$random$Random$int = F2(
	function (a, b) {
		return function (seed0) {
			var _v0 = (_Utils_cmp(a, b) < 0) ? _Utils_Tuple2(a, b) : _Utils_Tuple2(b, a);
			var lo = _v0.a;
			var hi = _v0.b;
			var range = (hi - lo) + 1;
			if (!((range - 1) & range)) {
				return _Utils_Tuple2(
					(((range - 1) & $elm$random$Random$peel(seed0)) >>> 0) + lo,
					$elm$random$Random$next(seed0));
			} else {
				var threshhold = (((-range) >>> 0) % range) >>> 0;
				var accountForBias = function (seed) {
					accountForBias:
					while (true) {
						var x = $elm$random$Random$peel(seed);
						var seedN = $elm$random$Random$next(seed);
						if (_Utils_cmp(x, threshhold) < 0) {
							var $temp$seed = seedN;
							seed = $temp$seed;
							continue accountForBias;
						} else {
							return _Utils_Tuple2((x % range) + lo, seedN);
						}
					}
				};
				return accountForBias(seed0);
			}
		};
	});
var $danyx23$elm_uuid$Uuid$Barebones$hexGenerator = A2($elm$random$Random$int, 0, 15);
var $elm$random$Random$listHelp = F4(
	function (revList, n, gen, seed) {
		listHelp:
		while (true) {
			if (n < 1) {
				return _Utils_Tuple2(revList, seed);
			} else {
				var _v0 = gen(seed);
				var value = _v0.a;
				var newSeed = _v0.b;
				var $temp$revList = A2($elm$core$List$cons, value, revList),
					$temp$n = n - 1,
					$temp$gen = gen,
					$temp$seed = newSeed;
				revList = $temp$revList;
				n = $temp$n;
				gen = $temp$gen;
				seed = $temp$seed;
				continue listHelp;
			}
		}
	});
var $elm$random$Random$list = F2(
	function (n, _v0) {
		var gen = _v0;
		return function (seed) {
			return A4($elm$random$Random$listHelp, _List_Nil, n, gen, seed);
		};
	});
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm$core$String$fromList = _String_fromList;
var $danyx23$elm_uuid$Uuid$Barebones$limitDigitRange8ToB = function (digit) {
	return (digit & 3) | 8;
};
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{y: nodeList, p: nodeListSize, w: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $danyx23$elm_uuid$Uuid$Barebones$hexDigits = function () {
	var mapChars = F2(
		function (offset, digit) {
			return $elm$core$Char$fromCode(digit + offset);
		});
	return $elm$core$Array$fromList(
		_Utils_ap(
			A2(
				$elm$core$List$map,
				mapChars(48),
				A2($elm$core$List$range, 0, 9)),
			A2(
				$elm$core$List$map,
				mapChars(97),
				A2($elm$core$List$range, 0, 5))));
}();
var $danyx23$elm_uuid$Uuid$Barebones$mapToHex = function (index) {
	var maybeResult = A2($elm$core$Array$get, index, $danyx23$elm_uuid$Uuid$Barebones$hexDigits);
	if (maybeResult.$ === 1) {
		return 'x';
	} else {
		var result = maybeResult.a;
		return result;
	}
};
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $danyx23$elm_uuid$Uuid$Barebones$toUuidString = function (thirtyOneHexDigits) {
	return $elm$core$String$concat(
		_List_fromArray(
			[
				$elm$core$String$fromList(
				A2(
					$elm$core$List$map,
					$danyx23$elm_uuid$Uuid$Barebones$mapToHex,
					A2($elm$core$List$take, 8, thirtyOneHexDigits))),
				'-',
				$elm$core$String$fromList(
				A2(
					$elm$core$List$map,
					$danyx23$elm_uuid$Uuid$Barebones$mapToHex,
					A2(
						$elm$core$List$take,
						4,
						A2($elm$core$List$drop, 8, thirtyOneHexDigits)))),
				'-',
				'4',
				$elm$core$String$fromList(
				A2(
					$elm$core$List$map,
					$danyx23$elm_uuid$Uuid$Barebones$mapToHex,
					A2(
						$elm$core$List$take,
						3,
						A2($elm$core$List$drop, 12, thirtyOneHexDigits)))),
				'-',
				$elm$core$String$fromList(
				A2(
					$elm$core$List$map,
					$danyx23$elm_uuid$Uuid$Barebones$mapToHex,
					A2(
						$elm$core$List$map,
						$danyx23$elm_uuid$Uuid$Barebones$limitDigitRange8ToB,
						A2(
							$elm$core$List$take,
							1,
							A2($elm$core$List$drop, 15, thirtyOneHexDigits))))),
				$elm$core$String$fromList(
				A2(
					$elm$core$List$map,
					$danyx23$elm_uuid$Uuid$Barebones$mapToHex,
					A2(
						$elm$core$List$take,
						3,
						A2($elm$core$List$drop, 16, thirtyOneHexDigits)))),
				'-',
				$elm$core$String$fromList(
				A2(
					$elm$core$List$map,
					$danyx23$elm_uuid$Uuid$Barebones$mapToHex,
					A2(
						$elm$core$List$take,
						12,
						A2($elm$core$List$drop, 19, thirtyOneHexDigits))))
			]));
};
var $danyx23$elm_uuid$Uuid$Barebones$uuidStringGenerator = A2(
	$elm$random$Random$map,
	$danyx23$elm_uuid$Uuid$Barebones$toUuidString,
	A2($elm$random$Random$list, 31, $danyx23$elm_uuid$Uuid$Barebones$hexGenerator));
var $danyx23$elm_uuid$Uuid$uuidGenerator = A2($elm$random$Random$map, $elm$core$Basics$identity, $danyx23$elm_uuid$Uuid$Barebones$uuidStringGenerator);
var $author$project$Pages$Pos$Passenger$SellTicket$init = F2(
	function (user, passenger) {
		return _Utils_Tuple3(
			$author$project$Pages$Pos$Passenger$SellTicket$initModel(passenger),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$random$Random$generate, $author$project$Pages$Pos$Passenger$SellTicket$ReceivedUUID, $danyx23$elm_uuid$Uuid$uuidGenerator),
						A2(
						$elm$core$Task$perform,
						$author$project$Pages$Pos$Passenger$SellTicket$GotTime,
						A3(
							$elm$core$Task$map2,
							F2(
								function (now, timezone) {
									return {e8: now, kS: timezone};
								}),
							$elm$time$Time$now,
							$elm$time$Time$here))
					])),
			$author$project$Shared$NoOp);
	});
var $author$project$Pages$Pos$Passenger$UnlockCard$DisplayCards = {$: 0};
var $author$project$Pages$Pos$Passenger$UnlockCard$init = F2(
	function (user, passenger) {
		return _Utils_Tuple3($author$project$Pages$Pos$Passenger$UnlockCard$DisplayCards, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
	});
var $author$project$Pages$Pos$Passenger$mapTransition = F3(
	function (fn1, fn2, _v0) {
		var a = _v0.a;
		var b = _v0.b;
		var c = _v0.c;
		return _Utils_Tuple3(
			fn1(a),
			A2($elm$core$Platform$Cmd$map, fn2, b),
			_Utils_Tuple2($elm$core$Maybe$Nothing, c));
	});
var $author$project$Pages$Pos$Passenger$init_ = F5(
	function (user, passengerId, route, maybePassenger, maybeModel) {
		var initWithPassengerId = _Utils_Tuple3(
			A2($author$project$Pages$Pos$Passenger$Loading, passengerId, route),
			A3($author$project$Pages$Pos$Passenger$getPassenger, user, passengerId, route),
			$author$project$Shared$NoOp);
		var initPage = F2(
			function (passenger, selectedCardId) {
				switch (route) {
					case 0:
						return _Utils_Tuple3(
							$author$project$Pages$Pos$Passenger$Home,
							$elm$core$Platform$Cmd$none,
							_Utils_Tuple2($elm$core$Maybe$Nothing, $author$project$Shared$NoOp));
					case 1:
						return A3(
							$author$project$Pages$Pos$Passenger$mapTransition,
							$author$project$Pages$Pos$Passenger$SellTicket,
							$author$project$Pages$Pos$Passenger$GotSellTicketMsg,
							A2($author$project$Pages$Pos$Passenger$SellTicket$init, user, passenger));
					case 2:
						return A3(
							$author$project$Pages$Pos$Passenger$mapTransition,
							$author$project$Pages$Pos$Passenger$SellSingleCharge,
							$author$project$Pages$Pos$Passenger$GotSellSingleChargeMsg,
							A2($author$project$Pages$Pos$Passenger$SellSingleCharge$init, user, passenger));
					case 3:
						return A3(
							$author$project$Pages$Pos$Passenger$mapTransition,
							$author$project$Pages$Pos$Passenger$ApplyRefill,
							$author$project$Pages$Pos$Passenger$GotApplyRefillMsg,
							A2($author$project$Pages$Pos$Passenger$ApplyRefill$init, user, passenger));
					case 4:
						var _v14 = A3($author$project$Pages$Pos$Passenger$IssueCard$init, selectedCardId, user, passenger);
						var model = _v14.a;
						var cmd = _v14.b;
						var sharedOutMsg = _v14.c;
						var sharedMsg = function () {
							if (!sharedOutMsg.$) {
								var card = sharedOutMsg.a;
								return _Utils_Tuple2(
									$elm$core$Maybe$Just(card),
									$author$project$Shared$NoOp);
							} else {
								var msg_ = sharedOutMsg.a;
								return _Utils_Tuple2($elm$core$Maybe$Nothing, msg_);
							}
						}();
						return _Utils_Tuple3(
							$author$project$Pages$Pos$Passenger$IssueCard(model),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Pos$Passenger$GotIssueCardMsg, cmd),
							sharedMsg);
					case 5:
						return A3(
							$author$project$Pages$Pos$Passenger$mapTransition,
							$author$project$Pages$Pos$Passenger$IssueDuplicate,
							$author$project$Pages$Pos$Passenger$GotIssueDuplicateMsg,
							A2($author$project$Pages$Pos$Passenger$IssueDuplicate$init, user, passenger));
					case 6:
						return A3(
							$author$project$Pages$Pos$Passenger$mapTransition,
							$author$project$Pages$Pos$Passenger$RegisterBeneficiary,
							$author$project$Pages$Pos$Passenger$GotRegisterBeneficiaryMsg,
							A2($author$project$Pages$Pos$Passenger$RegisterBeneficiary$init, user, passenger));
					default:
						return A3(
							$author$project$Pages$Pos$Passenger$mapTransition,
							$author$project$Pages$Pos$Passenger$UnlockCard,
							$author$project$Pages$Pos$Passenger$GotUnlockCardMsg,
							A2($author$project$Pages$Pos$Passenger$UnlockCard$init, user, passenger));
				}
			});
		var initWithLModel = function (lModel) {
			var doUpdatePassenger = function () {
				var _v9 = _Utils_Tuple2(lModel.bv, route);
				if (!_v9.b) {
					if (!_v9.a.$) {
						var _v10 = _v9.a;
						var _v11 = _v9.b;
						return false;
					} else {
						var _v12 = _v9.b;
						return true;
					}
				} else {
					return false;
				}
			}();
			var _v6 = A2(initPage, lModel.j, lModel.G.dc);
			var pageModel = _v6.a;
			var pageCmd = _v6.b;
			var _v7 = _v6.c;
			var newCard = _v7.a;
			var sharedMsg = _v7.b;
			var updatePassengerCard = function (passengerCard_) {
				return _Utils_update(
					passengerCard_,
					{
						dc: function () {
							if (!newCard.$) {
								var id = newCard.a.dM;
								return $elm$core$Maybe$Just(id);
							} else {
								return passengerCard_.dc;
							}
						}()
					});
			}(lModel.G);
			return _Utils_Tuple3(
				$author$project$Pages$Pos$Passenger$Loaded(
					_Utils_update(
						lModel,
						{bv: pageModel, G: updatePassengerCard})),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							pageCmd,
							doUpdatePassenger ? A3($author$project$Pages$Pos$Passenger$getPassenger, user, lModel.j.dM, route) : $elm$core$Platform$Cmd$none
						])),
				sharedMsg);
		};
		var initWithPassenger = function (passenger) {
			var _v2 = $author$project$Components$PassengerCard$init(passenger);
			var passengerCardModel = _v2.a;
			var passengerCardCmd = _v2.b;
			var _v3 = A2(initPage, passenger, passengerCardModel.dc);
			var pageModel = _v3.a;
			var pageCmd = _v3.b;
			var _v4 = _v3.c;
			var newCard = _v4.a;
			var sharedMsg = _v4.b;
			var updatePassengerCard = function (passengerCard_) {
				return _Utils_update(
					passengerCard_,
					{
						dc: function () {
							if (!newCard.$) {
								var id = newCard.a.dM;
								return $elm$core$Maybe$Just(id);
							} else {
								return passengerCard_.dc;
							}
						}()
					});
			}(passengerCardModel);
			return _Utils_Tuple3(
				$author$project$Pages$Pos$Passenger$Loaded(
					{bv: pageModel, j: passenger, G: updatePassengerCard}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Pos$Passenger$GotPassengerCardMsg, passengerCardCmd),
							pageCmd
						])),
				sharedMsg);
		};
		var _v0 = _Utils_Tuple2(maybePassenger, maybeModel);
		if (_v0.a.$ === 1) {
			if ((!_v0.b.$) && (_v0.b.a.$ === 2)) {
				var _v1 = _v0.a;
				var lModel = _v0.b.a.a;
				return _Utils_eq(lModel.j.dM, passengerId) ? initWithLModel(lModel) : initWithPassengerId;
			} else {
				return initWithPassengerId;
			}
		} else {
			if ((!_v0.b.$) && (_v0.b.a.$ === 2)) {
				var passenger = _v0.a.a;
				var lModel = _v0.b.a.a;
				return _Utils_eq(lModel.j.dM, passengerId) ? initWithLModel(lModel) : (_Utils_eq(passenger.dM, passengerId) ? initWithPassenger(passenger) : initWithPassengerId);
			} else {
				var passenger = _v0.a.a;
				return _Utils_eq(passenger.dM, passengerId) ? initWithPassenger(passenger) : initWithPassengerId;
			}
		}
	});
var $author$project$Pages$Pos$Passenger$changedRoute = F4(
	function (user, passengerId, route, model) {
		return A5(
			$author$project$Pages$Pos$Passenger$init_,
			user,
			passengerId,
			route,
			$elm$core$Maybe$Nothing,
			$elm$core$Maybe$Just(model));
	});
var $author$project$Data$User$extractConcessionaireId = function (user) {
	var _v0 = user.k$;
	switch (_v0.$) {
		case 0:
			var concessionaireId = _v0.a.mc;
			return $elm$core$Maybe$Just(concessionaireId);
		case 1:
			var concessionaireId = _v0.a.mc;
			return $elm$core$Maybe$Just(concessionaireId);
		case 2:
			var concessionaireId = _v0.a.mc;
			return $elm$core$Maybe$Just(concessionaireId);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$Pos$Edit$extractPassenger = function (model) {
	return $elm$core$Maybe$Nothing;
};
var $author$project$Pages$Pos$Guiche$extractPassenger = function (model) {
	return model.ff;
};
var $author$project$Pages$Pos$Localize$extractPassenger = function (model) {
	return $elm$core$Maybe$Nothing;
};
var $author$project$Pages$Pos$Passenger$extractPassenger = function (model) {
	switch (model.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Nothing;
		default:
			var passenger = model.a.j;
			return $elm$core$Maybe$Just(passenger);
	}
};
var $author$project$Pages$Pos$Register$extractPassenger = function (model) {
	return $elm$core$Maybe$Nothing;
};
var $author$project$Pages$extractPassenger = function (model) {
	var _v0 = A2($elm$core$Maybe$withDefault, $author$project$Pages$RedirectPage, model);
	switch (_v0.$) {
		case 4:
			return $elm$core$Maybe$Nothing;
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Nothing;
		case 2:
			return $elm$core$Maybe$Nothing;
		case 3:
			var model_ = _v0.a;
			return $author$project$Pages$Pos$Guiche$extractPassenger(model_);
		case 6:
			var model_ = _v0.a;
			return $author$project$Pages$Pos$Register$extractPassenger(model_);
		case 7:
			var model_ = _v0.b;
			return $author$project$Pages$Pos$Passenger$extractPassenger(model_);
		case 8:
			var model_ = _v0.a;
			return $author$project$Pages$Pos$Edit$extractPassenger(model_);
		case 9:
			var model_ = _v0.a;
			return $author$project$Pages$Pos$Localize$extractPassenger(model_);
		case 19:
			return $elm$core$Maybe$Nothing;
		case 20:
			return $elm$core$Maybe$Nothing;
		case 21:
			return $elm$core$Maybe$Nothing;
		case 22:
			return $elm$core$Maybe$Nothing;
		case 23:
			return $elm$core$Maybe$Nothing;
		case 24:
			return $elm$core$Maybe$Nothing;
		case 25:
			return $elm$core$Maybe$Nothing;
		case 26:
			return $elm$core$Maybe$Nothing;
		case 27:
			return $elm$core$Maybe$Nothing;
		case 30:
			return $elm$core$Maybe$Nothing;
		case 31:
			return $elm$core$Maybe$Nothing;
		case 10:
			return $elm$core$Maybe$Nothing;
		case 11:
			return $elm$core$Maybe$Nothing;
		case 12:
			return $elm$core$Maybe$Nothing;
		case 13:
			return $elm$core$Maybe$Nothing;
		case 14:
			return $elm$core$Maybe$Nothing;
		case 15:
			return $elm$core$Maybe$Nothing;
		case 16:
			return $elm$core$Maybe$Nothing;
		case 17:
			return $elm$core$Maybe$Nothing;
		case 18:
			return $elm$core$Maybe$Nothing;
		case 55:
			return $elm$core$Maybe$Nothing;
		case 56:
			return $elm$core$Maybe$Nothing;
		case 57:
			return $elm$core$Maybe$Nothing;
		case 33:
			return $elm$core$Maybe$Nothing;
		case 34:
			return $elm$core$Maybe$Nothing;
		case 41:
			return $elm$core$Maybe$Nothing;
		case 42:
			return $elm$core$Maybe$Nothing;
		case 43:
			return $elm$core$Maybe$Nothing;
		case 45:
			return $elm$core$Maybe$Nothing;
		case 46:
			return $elm$core$Maybe$Nothing;
		case 47:
			return $elm$core$Maybe$Nothing;
		case 48:
			return $elm$core$Maybe$Nothing;
		case 49:
			return $elm$core$Maybe$Nothing;
		case 50:
			return $elm$core$Maybe$Nothing;
		case 44:
			return $elm$core$Maybe$Nothing;
		case 51:
			return $elm$core$Maybe$Nothing;
		case 52:
			return $elm$core$Maybe$Nothing;
		case 53:
			return $elm$core$Maybe$Nothing;
		case 54:
			return $elm$core$Maybe$Nothing;
		case 5:
			return $elm$core$Maybe$Nothing;
		case 28:
			return $elm$core$Maybe$Nothing;
		case 29:
			return $elm$core$Maybe$Nothing;
		case 35:
			return $elm$core$Maybe$Nothing;
		case 36:
			return $elm$core$Maybe$Nothing;
		case 37:
			return $elm$core$Maybe$Nothing;
		case 38:
			return $elm$core$Maybe$Nothing;
		case 39:
			return $elm$core$Maybe$Nothing;
		case 40:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$Admin$init = F4(
	function (shared, route, maybeConcessionaireId, user) {
		return A5($author$project$Pages$Admin$init_, shared, route, maybeConcessionaireId, user, $elm$core$Maybe$Nothing);
	});
var $author$project$Pages$ChangePassword$PFalse = 2;
var $author$project$Pages$ChangePassword$ToSent = 0;
var $author$project$Pages$ChangePassword$init = function (token) {
	return {
		bu: '',
		d0: false,
		bw: 2,
		c8: '',
		d4: false,
		ea: 0,
		q: $krisajenkins$remotedata$RemoteData$NotAsked,
		kU: A2($elm$core$Maybe$withDefault, '', token)
	};
};
var $author$project$Pages$Enterprise$Dashboard$GotConcessionaireClasses = function (a) {
	return {$: 31, a: a};
};
var $author$project$Services$Concessionaire$ConcessionaireWalletsClasses = F5(
	function (classId, id, name, typeClass, walletClassesType) {
		return {lY: classId, dM: id, c3: name, qm: typeClass, qL: walletClassesType};
	});
var $author$project$Services$Concessionaire$WalletClassesType = F3(
	function (id, name, walletClassID) {
		return {dM: id, c3: name, dk: walletClassID};
	});
var $author$project$Services$Concessionaire$decoderWalletClassesType = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'walletClassID',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Services$Concessionaire$WalletClassesType))));
var $author$project$Services$Concessionaire$decoderConcessionaireWalletsClasses = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'walletClassesType',
	$elm$json$Json$Decode$list($author$project$Services$Concessionaire$decoderWalletClassesType),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'type',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'classId',
					$elm$json$Json$Decode$int,
					$elm$json$Json$Decode$succeed($author$project$Services$Concessionaire$ConcessionaireWalletsClasses))))));
var $author$project$Services$Concessionaire$getConcessionaireWalletsClasses = function (options) {
	return $elm$http$Http$request(
		{
			lG: $elm$http$Http$emptyBody,
			m9: A2(
				$author$project$Services$Api$expectJson,
				options.ow,
				$elm$json$Json$Decode$list($author$project$Services$Concessionaire$decoderConcessionaireWalletsClasses)),
			nG: _List_fromArray(
				[
					$author$project$Services$Api$authorizationHeader(options.kU)
				]),
			of: 'GET',
			p5: $elm$core$Maybe$Nothing,
			qi: $elm$core$Maybe$Nothing,
			qt: A2(
				$author$project$Constants$concessionaireServiceUrl,
				_List_fromArray(
					['api', 'v1', 'wallets', 'classes']),
				_List_Nil)
		});
};
var $author$project$Pages$Enterprise$Dashboard$None = {$: 0};
var $author$project$Pages$Enterprise$Dashboard$initialModel = F2(
	function (isOpen, importDetails) {
		return {
			cL: _List_Nil,
			d: {h2: 0, bY: _List_Nil, i3: 0, dM: '', an: _List_Nil, nY: 0, pC: $elm$core$Maybe$Nothing},
			cX: importDetails,
			eP: $krisajenkins$remotedata$RemoteData$Loading,
			dP: false,
			gO: isOpen,
			ab: $elm$core$Maybe$Nothing,
			aY: $author$project$Pages$Enterprise$Dashboard$None
		};
	});
var $author$project$Pages$Enterprise$Dashboard$init = F3(
	function (isOpen, maybeImportDetails, user) {
		return _Utils_Tuple2(
			A2($author$project$Pages$Enterprise$Dashboard$initialModel, isOpen, maybeImportDetails),
			$author$project$Services$Concessionaire$getConcessionaireWalletsClasses(
				{ow: $author$project$Pages$Enterprise$Dashboard$GotConcessionaireClasses, kU: user.kU}));
	});
var $author$project$Route$EnterpriseRegister = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Enterprise$Register$First = 0;
var $author$project$Pages$Enterprise$Register$initModel = {ep: '', dn: '', bL: '', bO: '', lW: '', l3: '', mX: '', cT: '', c3: '', om: '', oN: '', c6: '', jX: '', oV: '', fy: '', hG: 0, q: $krisajenkins$remotedata$RemoteData$NotAsked};
var $author$project$Route$starterRoute = function (user) {
	return $author$project$Route$WelcomeBack;
};
var $author$project$Pages$Enterprise$Register$init = F2(
	function (shared, maybeConcessionaireId) {
		return _Utils_Tuple2(
			$author$project$Pages$Enterprise$Register$initModel,
			function () {
				if (maybeConcessionaireId.$ === 1) {
					var _v1 = shared.pF;
					if (!_v1.$) {
						var user = _v1.a;
						var _v2 = $author$project$Data$User$extractConcessionaireId(user);
						if (_v2.$ === 1) {
							return A2(
								$author$project$Route$replaceUrl,
								shared.nZ,
								$author$project$Route$starterRoute(user));
						} else {
							var concessionaireId = _v2.a;
							return A2(
								$author$project$Route$replaceUrl,
								shared.nZ,
								$author$project$Route$EnterpriseRegister(
									$elm$core$Maybe$Just(concessionaireId)));
						}
					} else {
						return A2($author$project$Route$replaceUrl, shared.nZ, $author$project$Route$Login);
					}
				} else {
					return $elm$core$Platform$Cmd$none;
				}
			}());
	});
var $author$project$Pages$Garage$Dashboard$GotTime = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Garage$Dashboard$GotSessionVaults = function (a) {
	return {$: 8, a: a};
};
var $author$project$Constants$cashierServiceUrl = $elm$url$Url$Builder$crossOrigin('https://cashier.pazze.app');
var $author$project$Services$Cashier$SessionVault = function (id) {
	return function (createdAtt) {
		return function (checkedAt) {
			return function (concessionaireId) {
				return function (pouchCode) {
					return function (amount) {
						return function (checkedAmount) {
							return function (divergenceAmount) {
								return function (status) {
									return function (userName) {
										return function (userID) {
											return function (divergencyResolution) {
												return function (vehicles) {
													return {lo: amount, $8: checkedAmount, ig: checkedAt, mc: concessionaireId, ga: createdAtt, gi: divergenceAmount, gj: divergencyResolution, dM: id, fi: pouchCode, kK: status, fL: userID, qx: userName, en: vehicles};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt = F3(
	function (path, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$at, path, valDecoder),
			decoder);
	});
var $author$project$Services$Cashier$sessionVaultDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'cashiers',
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$List$filterMap($elm$core$Basics$identity),
		$elm$json$Json$Decode$list(
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$json$Json$Decode$map,
						$elm$core$Maybe$Just,
						A2(
							$elm$json$Json$Decode$at,
							_List_fromArray(
								['specificInfo', 'vehicle']),
							$author$project$Services$Concessionaire$vehicleDecoder)),
						$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
					])))),
	_List_Nil,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'divergencyResolution',
		$elm$json$Json$Decode$string,
		'',
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['user', 'id']),
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
				_List_fromArray(
					['user', 'name']),
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'status',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'divergenceAmount',
						$elm$json$Json$Decode$int,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'checkedAmount',
							$elm$json$Json$Decode$int,
							0,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'amount',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'pouchCode',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'concessionaireId',
										$elm$json$Json$Decode$string,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'checkedAt',
											$elm$json$Json$Decode$string,
											'-',
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'createdAt',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'id',
													$elm$json$Json$Decode$string,
													$elm$json$Json$Decode$succeed($author$project$Services$Cashier$SessionVault))))))))))))));
var $author$project$Services$Cashier$getSessionVaults = F2(
	function (options, msg) {
		var encodedQuery = F3(
			function (encoder, name, value) {
				return A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							encoder(name),
							$elm$core$List$singleton),
						value));
			});
		var queries = _Utils_ap(
			A3(encodedQuery, $elm$url$Url$Builder$string, 'end', options.T.bl),
			A3(encodedQuery, $elm$url$Url$Builder$string, 'start', options.T.bB));
		return $elm$http$Http$request(
			{
				lG: $elm$http$Http$emptyBody,
				m9: A2(
					$author$project$Services$Api$expectJson,
					msg,
					$elm$json$Json$Decode$list($author$project$Services$Cashier$sessionVaultDecoder)),
				nG: _List_fromArray(
					[
						$author$project$Services$Api$authorizationHeader(options.kU)
					]),
				of: 'GET',
				p5: $elm$core$Maybe$Nothing,
				qi: $elm$core$Maybe$Nothing,
				qt: A2(
					$author$project$Constants$cashierServiceUrl,
					_List_fromArray(
						['api', 'v1', 'accountability']),
					_Utils_ap(
						queries,
						A2(
							$elm$core$List$filterMap,
							$elm$core$Basics$identity,
							_List_fromArray(
								[
									A2(
									$elm$core$Maybe$map,
									$elm$url$Url$Builder$string('conId'),
									options.mc),
									$elm$core$Maybe$Just(
									A2($elm$url$Url$Builder$string, 'status', options.i0)),
									$elm$core$String$isEmpty(options.em) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
									A2($elm$url$Url$Builder$string, 'vehicle', options.em))
								]))))
			});
	});
var $author$project$Pages$Garage$Dashboard$viewStatusToString = function (v) {
	if (!v) {
		return 'opened';
	} else {
		return 'closed';
	}
};
var $author$project$Pages$Garage$Dashboard$cmdGetSessionVaults = F4(
	function (user, shared, model, whichTab) {
		return A2(
			$author$project$Services$Cashier$getSessionVaults,
			{
				mc: $author$project$Data$User$extractConcessionaireId(user),
				i0: $author$project$Pages$Garage$Dashboard$viewStatusToString(whichTab),
				T: model.T,
				kU: user.kU,
				em: model.em
			},
			$author$project$Pages$Garage$Dashboard$GotSessionVaults);
	});
var $author$project$Pages$Garage$Dashboard$init = F3(
	function (queries, shared, user) {
		var newModel = {
			bS: $krisajenkins$remotedata$RemoteData$NotAsked,
			iT: '',
			dK: false,
			e6: false,
			bs: 0,
			g0: false,
			g1: false,
			T: queries,
			hu: '',
			a5: $elm$core$Maybe$Nothing,
			aI: $elm$core$Maybe$Nothing,
			bA: $krisajenkins$remotedata$RemoteData$NotAsked,
			ar: A2(
				$elm$core$Maybe$withDefault,
				$krisajenkins$remotedata$RemoteData$NotAsked,
				A3(
					$elm$core$Maybe$map2,
					F2(
						function (_v2, _v3) {
							return $krisajenkins$remotedata$RemoteData$Loading;
						}),
					queries.bB,
					queries.bl)),
			em: ''
		};
		return _Utils_Tuple2(
			newModel,
			A2(
				$elm$core$Maybe$withDefault,
				A2(
					$elm$core$Task$perform,
					$author$project$Pages$Garage$Dashboard$GotTime,
					A3(
						$elm$core$Task$map2,
						F2(
							function (now, timezone) {
								return {e8: now, kS: timezone};
							}),
						$elm$time$Time$now,
						$elm$time$Time$here)),
				A3(
					$elm$core$Maybe$map2,
					F2(
						function (_v0, _v1) {
							return A4($author$project$Pages$Garage$Dashboard$cmdGetSessionVaults, user, shared, newModel, queries.kK);
						}),
					queries.bB,
					queries.bl)));
	});
var $author$project$Pages$Home$WelcomeBack$init = _Utils_Tuple2(
	{bR: _List_Nil},
	$elm$core$Platform$Cmd$none);
var $author$project$Pages$Login$Form = 0;
var $author$project$Pages$Login$init = {bR: _List_Nil, dy: $elm$core$Maybe$Nothing, mX: '', dL: false, oN: '', ec: 0, q: $krisajenkins$remotedata$RemoteData$NotAsked};
var $author$project$Pages$Order$Detail$GotOrder = function (a) {
	return {$: 0, a: a};
};
var $author$project$Services$Models$Order = function (id) {
	return function (createdAt) {
		return function (updatedAt) {
			return function (concessionaireID) {
				return function (ownerUserID) {
					return function (classID) {
						return function (name) {
							return function (orderListUsers) {
								return function (totalBalance) {
									return function (grossBalance) {
										return function (issTaxValue) {
											return {lX: classID, mb: concessionaireID, ix: createdAt, i3: grossBalance, dM: id, e_: issTaxValue, c3: name, F: orderListUsers, jT: ownerUserID, qd: totalBalance, qs: updatedAt};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Services$Models$OrderUser = F8(
	function (id, createdAt, updatedAt, userID, userName, amount, orderListID, extraInfo) {
		return {lo: amount, ix: createdAt, cV: extraInfo, dM: id, oF: orderListID, qs: updatedAt, fL: userID, qx: userName};
	});
var $author$project$Services$Models$ExtraInfo = function (cardID) {
	return function (userID) {
		return function (balance) {
			return function (serial) {
				return function (virtual) {
					return function (purseName) {
						return function (refillCounter) {
							return function (useCounter) {
								return function (totalRefill) {
									return function (countRefill) {
										return function (status) {
											return {h2: balance, h9: cardID, mf: countRefill, pa: purseName, pl: refillCounter, kw: serial, kK: status, qf: totalRefill, qu: useCounter, fL: userID, qE: virtual};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Services$Company$decodeStrBool = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'true':
				return $elm$json$Json$Decode$succeed(true);
			case 'false':
				return $elm$json$Json$Decode$succeed(false);
			default:
				return $elm$json$Json$Decode$fail('Error map bool');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Services$Company$decodeExtraInfo = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'status',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'countRefill',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'totalRefill',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'useCounter',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'refillCounter',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'purseName',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'virtual',
							$author$project$Services$Company$decodeStrBool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'serial',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'balance',
									$elm$json$Json$Decode$int,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'userID',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'cardID',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$Services$Models$ExtraInfo))))))))))));
var $author$project$Services$Company$decodeOrderUser = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'extraInfo',
	$elm$json$Json$Decode$list($author$project$Services$Company$decodeExtraInfo),
	_List_Nil,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'orderListID',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'amount',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'userName',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'userID',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'updatedAt',
						$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'createdAt',
							$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'id',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Services$Models$OrderUser)))))))));
var $author$project$Services$Company$decodeOrder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'issTaxValue',
	$elm$json$Json$Decode$int,
	0,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'grossBalance',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'totalBalance',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'orderListUsers',
				$elm$json$Json$Decode$list($author$project$Services$Company$decodeOrderUser),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'name',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'classID',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'ownerUserID',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'concessionaireID',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'updatedAt',
									$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'createdAt',
										$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'id',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$Services$Models$Order))))))))))));
var $author$project$Services$Company$getOrderID = function (options) {
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$author$project$Services$Company$decodeOrder),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'orderList', options.d1]),
				_List_Nil)
		});
};
var $author$project$Pages$Order$Detail$init = F2(
	function (orderID, user) {
		return _Utils_Tuple2(
			{x: $krisajenkins$remotedata$RemoteData$Loading, dD: $krisajenkins$remotedata$RemoteData$Loading, aY: $elm$core$Maybe$Nothing},
			$author$project$Services$Company$getOrderID(
				{ow: $author$project$Pages$Order$Detail$GotOrder, d1: orderID, kU: user.kU}));
	});
var $author$project$Pages$Order$Lists$GotOrderList = function (a) {
	return {$: 0, a: a};
};
var $author$project$Services$Models$OrderSummarized = F7(
	function (id, createdAt, updatedAt, concessionaireID, ownerUserID, classID, name) {
		return {lX: classID, mb: concessionaireID, ix: createdAt, dM: id, c3: name, jT: ownerUserID, qs: updatedAt};
	});
var $author$project$Services$Company$decodeOrderSummarized = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'classID',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'ownerUserID',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'concessionaireID',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'updatedAt',
					$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'createdAt',
						$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Services$Models$OrderSummarized))))))));
var $author$project$Services$Company$getOrderList = function (options) {
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$elm$json$Json$Decode$list($author$project$Services$Company$decodeOrderSummarized)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'orderList']),
				_List_Nil)
		});
};
var $author$project$Pages$Order$Lists$init = function (user) {
	return _Utils_Tuple2(
		{fd: $krisajenkins$remotedata$RemoteData$Loading},
		$author$project$Services$Company$getOrderList(
			{ow: $author$project$Pages$Order$Lists$GotOrderList, kU: user.kU}));
};
var $author$project$Pages$Panel$Classes$SubPage$ClassesCreateMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Panel$Classes$SubPage$ClassesCreatePage = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Panel$Classes$SubPage$ClassesDetailsMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Panel$Classes$SubPage$ClassesDetailsPage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Panel$Classes$SubPage$ClassesListMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Panel$Classes$SubPage$ClassesListPage = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Panel$Classes$Create$GotWalletTypes = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Panel$Classes$Create$emptyRule = {K: false, l: $elm$core$Dict$empty, aa: 0, aD: 0, ao: 0, oR: _List_Nil, a7: 0, aM: false, kZ: $elm$core$Maybe$Nothing};
var $author$project$Services$Classes$WalletType = F3(
	function (id, name, card) {
		return {cH: card, dM: id, c3: name};
	});
var $author$project$Services$Classes$decodeWalletType = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'card',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Services$Classes$WalletType))));
var $author$project$Services$Classes$getAllWalletTypes = function (options) {
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$elm$json$Json$Decode$list($author$project$Services$Classes$decodeWalletType)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'wallet', 'listAllWalletTypes']),
				_List_Nil)
		});
};
var $author$project$Pages$Panel$Classes$Create$CompScheduleMsg = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$Panel$Classes$Create$FormMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Schedule$ModeManageAvailability = 0;
var $author$project$Components$Schedule$NoSelection = 0;
var $author$project$Components$Schedule$NotResizing = {$: 0};
var $author$project$Components$Schedule$colors = _List_fromArray(
	['#64748b', '#f59e0b', '#84cc16', '#14532d', '#6ee7b7', '#67e8f9', '#0284c7', '#1e3a8a', '#991b1b', '#9a3412', '#312e81', '#6d28d9', '#a855f7', '#ec4899', '#be123c']);
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$json$Json$Encode$int = _Json_wrap;
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$Ports$periodsToPositionTable = _Platform_outgoingPort(
	'periodsToPositionTable',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string($.dM)),
					_Utils_Tuple2(
					'periods',
					$elm$json$Json$Encode$list(
						$elm$json$Json$Encode$list($elm$json$Json$Encode$int))($.n))
				]));
	});
var $author$project$Components$Schedule$init = function (rule) {
	var paymentRules = rule.oR;
	var getColorsAndIDs = A2(
		$elm$core$List$take,
		$elm$core$List$length(paymentRules),
		$author$project$Components$Schedule$colors);
	var availabilities = A3(
		$elm$core$List$map2,
		F2(
			function (p, id) {
				return {
					lo: function () {
						var _v0 = _Utils_Tuple2(p.oT, p.di);
						_v0$2:
						while (true) {
							if (!_v0.a.$) {
								if (_v0.b.$ === 1) {
									var percent = _v0.a.a;
									var _v1 = _v0.b;
									return $elm$core$Dict$fromList(
										_List_fromArray(
											[
												_Utils_Tuple2('percent', percent)
											]));
								} else {
									break _v0$2;
								}
							} else {
								if (!_v0.b.$) {
									var _v2 = _v0.a;
									var value = _v0.b.a;
									return $elm$core$Dict$fromList(
										_List_fromArray(
											[
												_Utils_Tuple2('value', value)
											]));
								} else {
									break _v0$2;
								}
							}
						}
						return $elm$core$Dict$empty;
					}(),
					cK: id,
					dM: id,
					n: _List_Nil,
					c7: p.n
				};
			}),
		paymentRules,
		getColorsAndIDs);
	var cmd = A2(
		$elm$core$List$map,
		function (av) {
			return $author$project$Ports$periodsToPositionTable(
				{dM: av.dM, n: av.c7});
		},
		availabilities);
	return _Utils_Tuple2(
		{
			g: $krisajenkins$remotedata$RemoteData$Success(availabilities),
			bT: $elm$time$Time$millisToPosix(1721012400000),
			gM: false,
			aC: _List_Nil,
			aY: $elm$core$Maybe$Nothing,
			aZ: 0,
			I: $author$project$Components$Schedule$NotResizing,
			af: $elm$core$Maybe$Nothing,
			A: $elm$core$Set$empty,
			ai: $elm$core$Maybe$Nothing,
			bz: 0
		},
		$elm$core$Platform$Cmd$batch(cmd));
};
var $author$project$Pages$Panel$Classes$Create$initForm = function (rule) {
	var _v0 = $author$project$Components$Schedule$init(rule);
	var modelSchedule = _v0.a;
	var cmd_ = _v0.b;
	return _Utils_Tuple2(
		{
			at: true,
			lX: 0,
			al: modelSchedule,
			K: rule.K,
			l: rule.l,
			aT: '',
			L: 0,
			b2: $elm$time$Time$millisToPosix(0),
			aa: rule.aa,
			aD: rule.aD,
			ao: rule.ao,
			c3: '',
			ch: $elm$core$Maybe$Nothing,
			kj: rule,
			a7: rule.a7,
			aM: rule.aM,
			ba: '',
			bH: '',
			bI: ''
		},
		A2(
			$elm$core$Platform$Cmd$map,
			A2($elm$core$Basics$composeR, $author$project$Pages$Panel$Classes$Create$CompScheduleMsg, $author$project$Pages$Panel$Classes$Create$FormMsg),
			cmd_));
};
var $author$project$Pages$Panel$Classes$Create$init = function (user) {
	var _v0 = $author$project$Pages$Panel$Classes$Create$initForm($author$project$Pages$Panel$Classes$Create$emptyRule);
	var initForm_ = _v0.a;
	var cmd_ = _v0.b;
	return _Utils_Tuple2(
		{bp: initForm_, aY: $elm$core$Maybe$Nothing, eo: $krisajenkins$remotedata$RemoteData$Loading},
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					cmd_,
					$author$project$Services$Classes$getAllWalletTypes(
					{ow: $author$project$Pages$Panel$Classes$Create$GotWalletTypes, kU: user.kU})
				])));
};
var $author$project$Pages$Panel$Classes$Details$GotClassDetails = function (a) {
	return {$: 1, a: a};
};
var $author$project$Services$Classes$ClassDetails = F9(
	function (walletClassResponseID, name, priority, classId, type_, rules, active, walletTypeAppID, walletTypeCardID) {
		return {at: active, lY: classId, c3: name, ch: priority, py: rules, kY: type_, k8: walletClassResponseID, qM: walletTypeAppID, qO: walletTypeCardID};
	});
var $author$project$Services$Classes$Rule = F9(
	function (maxDayUseCounter, maxMonthUseCounter, subsequentUsePeriod, twoSteps, companion, maxCompanions, defaultPaymentRule, paymentRules, user) {
		return {K: companion, l: defaultPaymentRule, aa: maxCompanions, aD: maxDayUseCounter, ao: maxMonthUseCounter, oR: paymentRules, a7: subsequentUsePeriod, aM: twoSteps, kZ: user};
	});
var $author$project$Services$Classes$PaymentRule = F3(
	function (periods, percent, value) {
		return {oT: percent, n: periods, di: value};
	});
var $author$project$Services$Classes$decodePaymentRule = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'value',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'percent',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$float),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'periods',
			$elm$json$Json$Decode$list(
				$elm$json$Json$Decode$list($elm$json$Json$Decode$int)),
			_List_Nil,
			$elm$json$Json$Decode$succeed($author$project$Services$Classes$PaymentRule))));
var $author$project$Services$Classes$User = F3(
	function (concessionaireId, email, name) {
		return {mc: concessionaireId, mX: email, c3: name};
	});
var $author$project$Services$Classes$decodeUser = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'email',
		$elm$json$Json$Decode$string,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'concessionaireId',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			$elm$json$Json$Decode$succeed($author$project$Services$Classes$User))));
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $author$project$Services$Classes$decodeRole = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'user',
	$elm$json$Json$Decode$maybe($author$project$Services$Classes$decodeUser),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'paymentRules',
		$elm$json$Json$Decode$list($author$project$Services$Classes$decodePaymentRule),
		_List_Nil,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'defaultPaymentRule',
			$elm$json$Json$Decode$dict($elm$json$Json$Decode$float),
			$elm$core$Dict$empty,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'maxCompanions',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'companion',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'twoSteps',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'subsequentUsePeriod',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'maxMonthUseCounter',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'maxDayUseCounter',
									$elm$json$Json$Decode$int,
									$elm$json$Json$Decode$succeed($author$project$Services$Classes$Rule))))))))));
var $author$project$Services$Classes$decodeClassDetails = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
	_List_fromArray(
		['walletTypeCard', 'id']),
	$elm$json$Json$Decode$string,
	'-',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
		_List_fromArray(
			['walletTypeApp', 'id']),
		$elm$json$Json$Decode$string,
		'-',
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'active',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'rules',
				$elm$json$Json$Decode$dict($author$project$Services$Classes$decodeRole),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'type',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'classID',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'priority',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'name',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'walletClassResponseID',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Services$Classes$ClassDetails))))))))));
var $author$project$Services$Classes$getWalletClasse = function (options) {
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$author$project$Services$Classes$decodeClassDetails),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'wallet', 'findWalletClassByID', options.dM]),
				_List_Nil)
		});
};
var $author$project$Pages$Panel$Classes$Details$init = F2(
	function (id, user) {
		return _Utils_Tuple2(
			{cI: $krisajenkins$remotedata$RemoteData$Loading, bp: $elm$core$Maybe$Nothing, dM: id, aY: $elm$core$Maybe$Nothing},
			$author$project$Services$Classes$getWalletClasse(
				{dM: id, ow: $author$project$Pages$Panel$Classes$Details$GotClassDetails, kU: user.kU}));
	});
var $author$project$Pages$Panel$Classes$List$GotSummaryClasses = function (a) {
	return {$: 0, a: a};
};
var $author$project$Services$Classes$ClassSummary = F8(
	function (walletClassResponseID, name, priority, type_, rules, active, walletTypeAppID, walletTypeCard) {
		return {at: active, c3: name, ch: priority, py: rules, kY: type_, k8: walletClassResponseID, qM: walletTypeAppID, qN: walletTypeCard};
	});
var $author$project$Services$Classes$decodeClassSummary = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
	_List_fromArray(
		['walletTypeCard', 'id']),
	$elm$json$Json$Decode$string,
	'-',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
		_List_fromArray(
			['walletTypeApp', 'id']),
		$elm$json$Json$Decode$string,
		'-',
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'active',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'rules',
				$elm$json$Json$Decode$dict($author$project$Services$Classes$decodeRole),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'type',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'priority',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'name',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'walletClassResponseID',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Services$Classes$ClassSummary)))))))));
var $author$project$Services$Classes$getSummaryClasses = function (options) {
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$elm$json$Json$Decode$list($author$project$Services$Classes$decodeClassSummary)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'wallet', 'listAllWalletClasses']),
				_List_Nil)
		});
};
var $author$project$Pages$Panel$Classes$List$init = function (user) {
	return _Utils_Tuple2(
		{dN: _List_Nil, dP: false, ck: $krisajenkins$remotedata$RemoteData$Loading},
		$author$project$Services$Classes$getSummaryClasses(
			{ow: $author$project$Pages$Panel$Classes$List$GotSummaryClasses, kU: user.kU}));
};
var $author$project$Pages$Panel$Classes$SubPage$init = F3(
	function (classesRoute, shared, user) {
		var mapBothNoShared = F3(
			function (fnA, fnB, _v1) {
				var a = _v1.a;
				var b = _v1.b;
				return _Utils_Tuple2(
					fnA(a),
					A2($elm$core$Platform$Cmd$map, fnB, b));
			});
		switch (classesRoute.$) {
			case 0:
				return A3(
					mapBothNoShared,
					$author$project$Pages$Panel$Classes$SubPage$ClassesListPage,
					$author$project$Pages$Panel$Classes$SubPage$ClassesListMsg,
					$author$project$Pages$Panel$Classes$List$init(user));
			case 1:
				var id = classesRoute.a;
				return $author$project$Services$Models$iHaveAccess(
					{
						gZ: user.hg,
						hf: $author$project$Services$Models$CLASS(0),
						hQ: A3(
							mapBothNoShared,
							$author$project$Pages$Panel$Classes$SubPage$ClassesDetailsPage,
							$author$project$Pages$Panel$Classes$SubPage$ClassesDetailsMsg,
							A2($author$project$Pages$Panel$Classes$Details$init, id, user)),
						hR: A3(
							mapBothNoShared,
							$author$project$Pages$Panel$Classes$SubPage$ClassesListPage,
							$author$project$Pages$Panel$Classes$SubPage$ClassesListMsg,
							$author$project$Pages$Panel$Classes$List$init(user))
					});
			default:
				return $author$project$Services$Models$iHaveAccess(
					{
						gZ: user.hg,
						hf: $author$project$Services$Models$CLASS(0),
						hQ: A3(
							mapBothNoShared,
							$author$project$Pages$Panel$Classes$SubPage$ClassesCreatePage,
							$author$project$Pages$Panel$Classes$SubPage$ClassesCreateMsg,
							$author$project$Pages$Panel$Classes$Create$init(user)),
						hR: A3(
							mapBothNoShared,
							$author$project$Pages$Panel$Classes$SubPage$ClassesListPage,
							$author$project$Pages$Panel$Classes$SubPage$ClassesListMsg,
							$author$project$Pages$Panel$Classes$List$init(user))
					});
		}
	});
var $author$project$Pages$Panel$EquipmentsV2$GotDeviceListVersion = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Panel$EquipmentsV2$GotEquipments = function (a) {
	return {$: 0, a: a};
};
var $author$project$Services$Equipments$DeviceVersion = F6(
	function (id, createdAt, updatedAt, concessionaireID, type_, version) {
		return {mb: concessionaireID, ix: createdAt, dM: id, kY: type_, qs: updatedAt, k3: version};
	});
var $elm_community$json_extra$Json$Decode$Extra$datetime = A2(
	$elm$json$Json$Decode$andThen,
	function (dateString) {
		var _v0 = $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(dateString);
		if (!_v0.$) {
			var v = _v0.a;
			return $elm$json$Json$Decode$succeed(v);
		} else {
			return $elm$json$Json$Decode$fail('Expecting an ISO-8601 formatted date+time string');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Services$Equipments$Block = 0;
var $author$project$Services$Equipments$Refill = 1;
var $author$project$Services$Equipments$Stock = 2;
var $author$project$Services$Equipments$decodeDeviceVersionType = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'block':
				return $elm$json$Json$Decode$succeed(0);
			case 'refill':
				return $elm$json$Json$Decode$succeed(1);
			case 'stock':
				return $elm$json$Json$Decode$succeed(2);
			default:
				var str_ = str;
				return $elm$json$Json$Decode$fail('Error: ' + (str_ + 'is not mapped'));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Services$Equipments$decodeDeviceVersion = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'version',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'type',
		$author$project$Services$Equipments$decodeDeviceVersionType,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'concessionaireID',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'updatedAt',
				$elm_community$json_extra$Json$Decode$Extra$datetime,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'createdAt',
					$elm_community$json_extra$Json$Decode$Extra$datetime,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Services$Equipments$DeviceVersion)))))));
var $author$project$Services$Equipments$getDeviceListVersion = function (options) {
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$elm$json$Json$Decode$list($author$project$Services$Equipments$decodeDeviceVersion)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'list', options.mb, 'version']),
				_List_Nil)
		});
};
var $author$project$Services$Equipments$Equipment = function (lastStatusAt) {
	return function (validatorSerial) {
		return function (softwareVersion) {
			return function (validatorDate) {
				return function (refill) {
					return function (stock) {
						return function (block) {
							return function (vehicleCode) {
								return function (events) {
									return function (status) {
										return function (ebSerial) {
											return function (ebVersion) {
												return {h5: block, mT: ebSerial, mU: ebVersion, D: events, jo: lastStatusAt, fn: refill, kG: softwareVersion, kK: status, kL: stock, qB: validatorDate, k0: validatorSerial, em: vehicleCode};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Services$Equipments$decodeEquipment = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'ebVersion',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'ebSerial',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'status',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'events',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'vehicleCode',
					$elm$json$Json$Decode$string,
					'-',
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'block',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'stock',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'refill',
								$elm$json$Json$Decode$int,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'validatorDate',
									$elm$json$Json$Decode$maybe($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
									$elm$core$Maybe$Nothing,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'softwareVersion',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'validatorSerial',
											$elm$json$Json$Decode$string,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'lastStatusAt',
												$elm$json$Json$Decode$maybe($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
												$elm$core$Maybe$Nothing,
												$elm$json$Json$Decode$succeed($author$project$Services$Equipments$Equipment)))))))))))));
var $author$project$Services$Equipments$getEquipments = function (options) {
	var query = F3(
		function (encode, key, maybeValue) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						encode(key),
						$elm$core$List$singleton),
					maybeValue));
		});
	var queries = _Utils_ap(
		A3(query, $elm$url$Url$Builder$string, 'serial', options.T.kw),
		A3(query, $elm$url$Url$Builder$string, 'vehicle', options.T.k2));
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$elm$json$Json$Decode$list($author$project$Services$Equipments$decodeEquipment)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'device', 'version']),
				queries)
		});
};
var $author$project$Pages$Panel$EquipmentsV2$init = F4(
	function (concessionaireID, queries, shared, user) {
		return _Utils_Tuple2(
			{dF: $krisajenkins$remotedata$RemoteData$Loading, cU: $krisajenkins$remotedata$RemoteData$Loading, T: queries},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Services$Equipments$getEquipments(
						{ow: $author$project$Pages$Panel$EquipmentsV2$GotEquipments, T: queries, kU: user.kU}),
						$author$project$Services$Equipments$getDeviceListVersion(
						{mb: concessionaireID, ow: $author$project$Pages$Panel$EquipmentsV2$GotDeviceListVersion, kU: user.kU})
					])));
	});
var $author$project$Pages$Panel$Financial$Account$GotInformation = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Panel$Financial$Account$GotPagarmeWithdrawals = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Panel$Financial$Account$GotTime = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Panel$Financial$Account$cardsPerPage = 50;
var $author$project$Services$Financial$InfoPagarmeBalance = function (currency) {
	return function (availableAmount) {
		return function (waitingFundsAmount) {
			return function (transferredAmount) {
				return function (holderName) {
					return function (holderType) {
						return function (bank) {
							return function (holderDocument) {
								return function (branchNumber) {
									return function (accountNumber) {
										return function (accountCheckDigit) {
											return function (type_) {
												return function (status) {
													return {lf: accountCheckDigit, lg: accountNumber, bN: availableAmount, lz: bank, lI: branchNumber, iz: currency, nI: holderDocument, nJ: holderName, nK: holderType, kK: status, ql: transferredAmount, kY: type_, qG: waitingFundsAmount};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Services$Financial$BalanceChecking = 0;
var $author$project$Services$Financial$BalanceSavings = 1;
var $author$project$Services$Financial$decodePagarmeBalanceType = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'checking':
				return $elm$json$Json$Decode$succeed(0);
			case 'savings':
				return $elm$json$Json$Decode$succeed(1);
			default:
				var str_ = str;
				return $elm$json$Json$Decode$fail('Error: ' + (str_ + 'is not mapped'));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Services$Financial$decodeInfoPagarmeBalance = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'status',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'type',
		$author$project$Services$Financial$decodePagarmeBalanceType,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'account_check_digit',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'account_number',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'branch_number',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'holder_document',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'bank',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'holder_type',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'holder_name',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'transferred_amount',
										$elm$json$Json$Decode$int,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'waiting_funds_amount',
											$elm$json$Json$Decode$int,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'available_amount',
												$elm$json$Json$Decode$int,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'currency',
													$elm$json$Json$Decode$string,
													$elm$json$Json$Decode$succeed($author$project$Services$Financial$InfoPagarmeBalance))))))))))))));
var $author$project$Services$Financial$getPagarmeBalance = function (options) {
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$author$project$Services$Financial$decodeInfoPagarmeBalance),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'integrations', 'pagarme', 'balance']),
				_List_Nil)
		});
};
var $author$project$Services$Financial$PagarmeWithdrawalsWithPagination = F2(
	function (data, paging) {
		return {iC: data, oJ: paging};
	});
var $author$project$Services$Financial$PagarmeWithdrawal = F9(
	function (id, gatewayID, amount, status, createdAt, updatedAt, fee, fundingEstimatedDate, type_) {
		return {lo: amount, ix: createdAt, iR: fee, nv: fundingEstimatedDate, nw: gatewayID, dM: id, kK: status, kY: type_, qs: updatedAt};
	});
var $author$project$Services$Financial$Effectived = 1;
var $author$project$Services$Financial$Failed = 2;
var $author$project$Services$Financial$Pending = 0;
var $author$project$Services$Financial$Processing = 3;
var $author$project$Services$Financial$Transferred = 4;
var $author$project$Services$Financial$decodePagarmeWithdrawalStatus = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'pending':
				return $elm$json$Json$Decode$succeed(0);
			case 'failed':
				return $elm$json$Json$Decode$succeed(2);
			case 'effectived':
				return $elm$json$Json$Decode$succeed(1);
			case 'processing':
				return $elm$json$Json$Decode$succeed(3);
			case 'transferred':
				return $elm$json$Json$Decode$succeed(4);
			default:
				var str_ = str;
				return $elm$json$Json$Decode$fail('Error: ' + (str_ + ' is not mapped'));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Services$Financial$decodePagarmeWithdrawal = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'type',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'funding_estimated_date',
		$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'fee',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'updated_at',
				$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'created_at',
					$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'status',
						$author$project$Services$Financial$decodePagarmeWithdrawalStatus,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'amount',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'gateway_id',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'id',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Services$Financial$PagarmeWithdrawal))))))))));
var $author$project$Services$Financial$decodePagarmeWithdrawalsWithPagination = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
	_List_fromArray(
		['paging', 'total']),
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'data',
		$elm$json$Json$Decode$list($author$project$Services$Financial$decodePagarmeWithdrawal),
		$elm$json$Json$Decode$succeed($author$project$Services$Financial$PagarmeWithdrawalsWithPagination)));
var $author$project$Services$Api$queryMaybeValue = F3(
	function (encode, key, maybeValue) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					encode(key),
					$elm$core$List$singleton),
				maybeValue));
	});
var $author$project$Services$Financial$getPagarmeWithdrawals = function (options) {
	var queries = _Utils_ap(
		A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'created_since', options.T.bB),
		A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'created_until', options.T.bl));
	var pagination = _List_fromArray(
		[
			A2($elm$url$Url$Builder$int, 'offset', options.oq),
			A2($elm$url$Url$Builder$int, 'limit', options.n$)
		]);
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$author$project$Services$Financial$decodePagarmeWithdrawalsWithPagination),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'integrations', 'pagarme', 'withdrawals']),
				_Utils_ap(queries, pagination))
		});
};
var $author$project$Pages$Panel$Financial$Account$init = F2(
	function (user, queries) {
		return _Utils_Tuple2(
			{
				bQ: $author$project$Components$PDF$Create$init,
				L: 0,
				cY: $krisajenkins$remotedata$RemoteData$Loading,
				aY: $elm$core$Maybe$Nothing,
				T: queries,
				cE: A2(
					$elm$core$Maybe$withDefault,
					$krisajenkins$remotedata$RemoteData$NotAsked,
					A3(
						$elm$core$Maybe$map2,
						F2(
							function (_v0, _v1) {
								return $krisajenkins$remotedata$RemoteData$Loading;
							}),
						queries.bB,
						queries.bl))
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Services$Financial$getPagarmeBalance(
						{ow: $author$project$Pages$Panel$Financial$Account$GotInformation, kU: user.kU}),
						A2(
						$elm$core$Maybe$withDefault,
						A2(
							$elm$core$Task$perform,
							$author$project$Pages$Panel$Financial$Account$GotTime,
							A3(
								$elm$core$Task$map2,
								F2(
									function (now, timezone) {
										return {e8: now, kS: timezone};
									}),
								$elm$time$Time$now,
								$elm$time$Time$here)),
						A3(
							$elm$core$Maybe$map2,
							F2(
								function (_v2, _v3) {
									return $author$project$Services$Financial$getPagarmeWithdrawals(
										{n$: $author$project$Pages$Panel$Financial$Account$cardsPerPage, oq: (queries.bv - 1) * $author$project$Pages$Panel$Financial$Account$cardsPerPage, ow: $author$project$Pages$Panel$Financial$Account$GotPagarmeWithdrawals, T: queries, kU: user.kU});
								}),
							queries.bB,
							queries.bl))
					])));
	});
var $author$project$Pages$Panel$Financial$PendingTransactions$GotReport = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Panel$Financial$PendingTransactions$GotTime = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Panel$Financial$PendingTransactions$cardsPerPage = 20;
var $author$project$Services$Financial$PagarmeOrder = F2(
	function (data, total) {
		return {iC: data, qc: total};
	});
var $author$project$Services$Financial$PagarmeOrderData = function (id) {
	return function (amount) {
		return function (currency) {
			return function (status) {
				return function (createdAt) {
					return function (document) {
						return function (name) {
							return function (orderID) {
								return function (companyID) {
									return function (paymentMethod) {
										return function (chargeID) {
											return {lo: amount, lU: chargeID, l8: companyID, ix: createdAt, iz: currency, iI: document, dM: id, c3: name, d1: orderID, jW: paymentMethod, kK: status};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Services$Financial$PagarmeOrderStatusCanceled = 1;
var $author$project$Services$Financial$PagarmeOrderStatusFailed = 3;
var $author$project$Services$Financial$PagarmeOrderStatusPaid = 2;
var $author$project$Services$Financial$PagarmeOrderStatusPending = 0;
var $author$project$Services$Financial$decodePagarmeOrderStatus = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'pending':
				return $elm$json$Json$Decode$succeed(0);
			case 'canceled':
				return $elm$json$Json$Decode$succeed(1);
			case 'paid':
				return $elm$json$Json$Decode$succeed(2);
			case 'failed':
				return $elm$json$Json$Decode$succeed(3);
			default:
				var str_ = str;
				return $elm$json$Json$Decode$fail('Error: ' + (str_ + ' is not mapped'));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Services$Financial$decodePagarmeOrderData = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'chargeID',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'paymentMethod',
		$author$project$Services$Models$decoderPaymentMethod,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'companyID',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'orderID',
				$elm$json$Json$Decode$string,
				'',
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'name',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'document',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'createdAt',
							$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'status',
								$author$project$Services$Financial$decodePagarmeOrderStatus,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'currency',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'amount',
										$elm$json$Json$Decode$int,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'id',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$Services$Financial$PagarmeOrderData))))))))))));
var $author$project$Services$Financial$decodePagarmeOrder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'total',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'data',
		$elm$json$Json$Decode$list($author$project$Services$Financial$decodePagarmeOrderData),
		$elm$json$Json$Decode$succeed($author$project$Services$Financial$PagarmeOrder)));
var $author$project$Services$Financial$getPagarmeOrders = function (options) {
	var queries = _Utils_ap(
		A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'created_since', options.T.bB),
		A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'created_until', options.T.bl));
	var pagination = _List_fromArray(
		[
			A2($elm$url$Url$Builder$int, 'page', options.T.bv),
			A2($elm$url$Url$Builder$int, 'size', options.n0)
		]);
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$author$project$Services$Financial$decodePagarmeOrder),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'integrations', 'pagarme', 'orders']),
				_Utils_ap(queries, pagination))
		});
};
var $author$project$Pages$Panel$Financial$PendingTransactions$init = F2(
	function (queries, user) {
		return _Utils_Tuple2(
			{
				bQ: $author$project$Components$PDF$Create$init,
				dK: false,
				L: 0,
				T: queries,
				ck: A2(
					$elm$core$Maybe$withDefault,
					$krisajenkins$remotedata$RemoteData$NotAsked,
					A3(
						$elm$core$Maybe$map2,
						F2(
							function (_v0, _v1) {
								return $krisajenkins$remotedata$RemoteData$Loading;
							}),
						queries.bB,
						queries.bl))
			},
			A2(
				$elm$core$Maybe$withDefault,
				A2(
					$elm$core$Task$perform,
					$author$project$Pages$Panel$Financial$PendingTransactions$GotTime,
					A3(
						$elm$core$Task$map2,
						F2(
							function (now, timezone) {
								return {e8: now, kS: timezone};
							}),
						$elm$time$Time$now,
						$elm$time$Time$here)),
				A3(
					$elm$core$Maybe$map2,
					F2(
						function (_v2, _v3) {
							return $author$project$Services$Financial$getPagarmeOrders(
								{n0: $author$project$Pages$Panel$Financial$PendingTransactions$cardsPerPage, ow: $author$project$Pages$Panel$Financial$PendingTransactions$GotReport, T: queries, kU: user.kU});
						}),
					queries.bB,
					queries.bl)));
	});
var $author$project$Pages$Panel$Financial$Transactions$GotReport = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Panel$Financial$Transactions$GotTime = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Panel$Financial$Transactions$cardsPerPage = 20;
var $author$project$Services$Financial$PagarmePayables = function (id) {
	return function (status) {
		return function (amount) {
			return function (fee) {
				return function (anticipationFee) {
					return function (fraudCoverageFee) {
						return function (installment) {
							return function (chargeID) {
								return function (paymentDate) {
									return function (type_) {
										return function (paymentMethod) {
											return function (accrualAt) {
												return function (createdAt) {
													return function (availableDate) {
														return function (document) {
															return function (name) {
																return function (orderID) {
																	return function (companyID) {
																		return {lh: accrualAt, lo: amount, lp: anticipationFee, ly: availableDate, lU: chargeID, l8: companyID, ix: createdAt, iI: document, iR: fee, nu: fraudCoverageFee, dM: id, nU: installment, c3: name, d1: orderID, jV: paymentDate, jW: paymentMethod, kK: status, kY: type_};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Services$Financial$Paid = 0;
var $author$project$Services$Financial$Prepaid = 2;
var $author$project$Services$Financial$WaitingFunds = 1;
var $author$project$Services$Financial$decodePagarmePayablesStatus = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'paid':
				return $elm$json$Json$Decode$succeed(0);
			case 'waiting_funds':
				return $elm$json$Json$Decode$succeed(1);
			case 'prepaid':
				return $elm$json$Json$Decode$succeed(2);
			default:
				var str_ = str;
				return $elm$json$Json$Decode$fail('Error: ' + (str_ + 'is not mapped'));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Services$Financial$decodePagarmePayables = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'companyID',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'orderID',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'document',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'availableDate',
					$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'created_at',
						$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'accrual_at',
							$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'payment_method',
								$author$project$Services$Models$decoderPaymentMethod,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'type',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'payment_date',
										$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'charge_id',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'installment',
												$elm$json$Json$Decode$int,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'fraud_coverage_fee',
													$elm$json$Json$Decode$int,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'anticipation_fee',
														$elm$json$Json$Decode$int,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'fee',
															$elm$json$Json$Decode$int,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'amount',
																$elm$json$Json$Decode$int,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'status',
																	$author$project$Services$Financial$decodePagarmePayablesStatus,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'id',
																		$elm$json$Json$Decode$int,
																		$elm$json$Json$Decode$succeed($author$project$Services$Financial$PagarmePayables)))))))))))))))))));
var $author$project$Services$Financial$getPagarmePayables = function (options) {
	var queries = _Utils_ap(
		A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'created_since', options.T.bB),
		A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'created_until', options.T.bl));
	var pagination = _List_fromArray(
		[
			A2($elm$url$Url$Builder$int, 'page', options.T.bv),
			A2($elm$url$Url$Builder$int, 'size', options.n0)
		]);
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							A2(
							$elm$json$Json$Decode$field,
							'data',
							$elm$json$Json$Decode$list($author$project$Services$Financial$decodePagarmePayables)),
							A2(
							$elm$json$Json$Decode$field,
							'data',
							$elm$json$Json$Decode$null(_List_Nil))
						]))),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'integrations', 'pagarme', 'payables']),
				_Utils_ap(queries, pagination))
		});
};
var $author$project$Pages$Panel$Financial$Transactions$init = F2(
	function (queries, user) {
		return _Utils_Tuple2(
			{
				bQ: $author$project$Components$PDF$Create$init,
				dK: false,
				L: 0,
				T: queries,
				ck: A2(
					$elm$core$Maybe$withDefault,
					$krisajenkins$remotedata$RemoteData$NotAsked,
					A3(
						$elm$core$Maybe$map2,
						F2(
							function (_v0, _v1) {
								return $krisajenkins$remotedata$RemoteData$Loading;
							}),
						queries.bB,
						queries.bl))
			},
			A2(
				$elm$core$Maybe$withDefault,
				A2(
					$elm$core$Task$perform,
					$author$project$Pages$Panel$Financial$Transactions$GotTime,
					A3(
						$elm$core$Task$map2,
						F2(
							function (now, timezone) {
								return {e8: now, kS: timezone};
							}),
						$elm$time$Time$now,
						$elm$time$Time$here)),
				A3(
					$elm$core$Maybe$map2,
					F2(
						function (_v2, _v3) {
							return $author$project$Services$Financial$getPagarmePayables(
								{n0: $author$project$Pages$Panel$Financial$Transactions$cardsPerPage, ow: $author$project$Pages$Panel$Financial$Transactions$GotReport, T: queries, kU: user.kU});
						}),
					queries.bB,
					queries.bl)));
	});
var $author$project$Pages$Panel$History$GotReport = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Panel$History$GotTime = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Panel$History$GotUsers = function (a) {
	return {$: 2, a: a};
};
var $author$project$Services$History$History = function (id) {
	return function (createdAt) {
		return function (description) {
			return function (username) {
				return function (executionUsername) {
					return function (changedField) {
						return function (oldField) {
							return function (newField) {
								return function (module_) {
									return function (cardSerial) {
										return {lO: cardSerial, lT: changedField, ix: createdAt, z: description, m8: executionUsername, dM: id, oi: module_, oo: newField, os: oldField, qz: username};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Services$History$decodeHistory = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'cardSerial',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'module',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'newField',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'oldField',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'changedField',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'executionUsername',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'username',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'description',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'createdAt',
									$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Services$History$History)))))))))));
var $author$project$Services$History$getHistory = function (options) {
	var listToStr = function (list) {
		var _v0 = A2($elm$core$String$join, ',', list);
		if (_v0 === '') {
			return $elm$core$Maybe$Nothing;
		} else {
			var str = _v0;
			return $elm$core$Maybe$Just(str);
		}
	};
	var queries = _Utils_ap(
		A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'start', options.T.bB),
		_Utils_ap(
			A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'end', options.T.bl),
			_Utils_ap(
				A3(
					$author$project$Services$Api$queryMaybeValue,
					$elm$url$Url$Builder$int,
					'page',
					$elm$core$Maybe$Just(options.T.bv)),
				_Utils_ap(
					A3(
						$author$project$Services$Api$queryMaybeValue,
						$elm$url$Url$Builder$string,
						'executionUserID',
						listToStr(options.T.bZ)),
					_Utils_ap(
						A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'userName', options.T.kZ),
						A3(
							$author$project$Services$Api$queryMaybeValue,
							$elm$url$Url$Builder$string,
							'actionType',
							listToStr(options.T.bK)))))));
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$elm$json$Json$Decode$list($author$project$Services$History$decodeHistory)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'report', 'userChangesLogs']),
				queries)
		});
};
var $author$project$Pages$Panel$History$initActionTypes = _List_fromArray(
	[
		{l4: '1', c3: 'Alteração de Telefone do Usuário'},
		{l4: '2', c3: 'Alteração de classes do cartão do passageiro'},
		{l4: '3', c3: 'Alteração de email do usuário'},
		{l4: '4', c3: 'Alteração de expiração de classes do passageiro'},
		{l4: '5', c3: 'Alteraçao de token'}
	]);
var $author$project$Pages$Panel$History$init = F2(
	function (queries, user) {
		return _Utils_Tuple2(
			{
				dl: $author$project$Pages$Panel$History$initActionTypes,
				dK: false,
				L: 0,
				dQ: false,
				dS: false,
				T: queries,
				ck: A2(
					$elm$core$Maybe$withDefault,
					$krisajenkins$remotedata$RemoteData$NotAsked,
					A3(
						$elm$core$Maybe$map2,
						F2(
							function (_v0, _v1) {
								return $krisajenkins$remotedata$RemoteData$Loading;
							}),
						queries.bB,
						queries.bl)),
				ei: $krisajenkins$remotedata$RemoteData$Loading
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$withDefault,
						A2(
							$elm$core$Task$perform,
							$author$project$Pages$Panel$History$GotTime,
							A3(
								$elm$core$Task$map2,
								F2(
									function (now, timezone) {
										return {e8: now, kS: timezone};
									}),
								$elm$time$Time$now,
								$elm$time$Time$here)),
						A3(
							$elm$core$Maybe$map2,
							F2(
								function (_v2, _v3) {
									return $author$project$Services$History$getHistory(
										{ow: $author$project$Pages$Panel$History$GotReport, T: queries, kU: user.kU});
								}),
							queries.bB,
							queries.bl)),
						$author$project$Services$Concessionaire$getAdminUsers(
						{
							mc: A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.bR;
								},
								A2(
									$elm$core$Basics$composeR,
									$elm$core$List$map(
										function ($) {
											return $.dM;
										}),
									$elm$core$List$head))(user),
							ow: $author$project$Pages$Panel$History$GotUsers,
							kU: user.kU
						})
					])));
	});
var $author$project$Pages$Panel$ManageFare$GotFares = function (a) {
	return {$: 1, a: a};
};
var $author$project$Services$Fares$Fare = F7(
	function (id, createdAt, code, value, effectiveFrom, userID, active) {
		return {at: active, l4: code, ix: createdAt, aT: effectiveFrom, dM: id, fL: userID, di: value};
	});
var $author$project$Services$Fares$Active = 0;
var $author$project$Services$Fares$Inactive = 1;
var $author$project$Services$Fares$decodeStatus = A2(
	$elm$json$Json$Decode$andThen,
	function (bool) {
		var decode = function (active) {
			return active ? 0 : 1;
		};
		return $elm$json$Json$Decode$succeed(
			decode(bool));
	},
	$elm$json$Json$Decode$bool);
var $author$project$Services$Fares$decodeFare = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'active',
	$author$project$Services$Fares$decodeStatus,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'userID',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'effectiveFrom',
			$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'value',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'code',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'createdAt',
						$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Services$Fares$Fare))))))));
var $author$project$Services$Fares$getFares = function (options) {
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$elm$json$Json$Decode$list($author$project$Services$Fares$decodeFare)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'fares']),
				_List_Nil)
		});
};
var $author$project$Pages$Panel$ManageFare$init = F4(
	function (maybeOldModel, queries, shared, user) {
		return _Utils_Tuple2(
			{
				aV: A2(
					$elm$core$Maybe$withDefault,
					$krisajenkins$remotedata$RemoteData$Loading,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.aV;
						},
						maybeOldModel)),
				aY: $elm$core$Maybe$Nothing,
				T: queries
			},
			$author$project$Services$Fares$getFares(
				{ow: $author$project$Pages$Panel$ManageFare$GotFares, kU: user.kU}));
	});
var $author$project$Pages$Panel$ManageLines$GotLines = function (a) {
	return {$: 0, a: a};
};
var $author$project$Services$Line$Line = function (id) {
	return function (createdAt) {
		return function (cityID) {
			return function (fareID) {
				return function (line) {
					return function (fareCode) {
						return function (name) {
							return function (description) {
								return function (type_) {
									return function (active) {
										return {at: active, du: cityID, ix: createdAt, z: description, gq: fareCode, gr: fareID, dM: id, e1: line, c3: name, kY: type_};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Services$Line$Active = 0;
var $author$project$Services$Line$Inactive = 1;
var $author$project$Services$Line$decodeStatus = A2(
	$elm$json$Json$Decode$andThen,
	function (bool) {
		var decode = function (active) {
			return active ? 0 : 1;
		};
		return $elm$json$Json$Decode$succeed(
			decode(bool));
	},
	$elm$json$Json$Decode$bool);
var $author$project$Services$Line$decodeLine = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'active',
	$author$project$Services$Line$decodeStatus,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'type',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'description',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'fareCode',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'line',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'fareID',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'cityID',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'createdAt',
									$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Services$Line$Line)))))))))));
var $author$project$Services$Line$getLines = function (options) {
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$elm$json$Json$Decode$list($author$project$Services$Line$decodeLine)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'lines']),
				_List_Nil)
		});
};
var $author$project$Pages$Panel$ManageLines$init = F3(
	function (maybeOldModel, queries, user) {
		return _Utils_Tuple2(
			{
				n2: A2(
					$elm$core$Maybe$withDefault,
					$krisajenkins$remotedata$RemoteData$Loading,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.n2;
						},
						maybeOldModel)),
				aY: $elm$core$Maybe$Nothing,
				T: queries
			},
			$author$project$Services$Line$getLines(
				{ow: $author$project$Pages$Panel$ManageLines$GotLines, kU: user.kU}));
	});
var $author$project$Pages$Panel$ManageOperators$GotUsers = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Panel$ManageOperators$init = F2(
	function (user, shared) {
		return _Utils_Tuple2(
			{
				f6: A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.bR;
					},
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$map(
							function ($) {
								return $.dM;
							}),
						$elm$core$List$head))(user),
				aY: $elm$core$Maybe$Nothing,
				c5: $krisajenkins$remotedata$RemoteData$Loading
			},
			$author$project$Services$Concessionaire$getAdminUsers(
				{
					mc: A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.bR;
						},
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$map(
								function ($) {
									return $.dM;
								}),
							$elm$core$List$head))(user),
					ow: $author$project$Pages$Panel$ManageOperators$GotUsers,
					kU: user.kU
				}));
	});
var $author$project$Pages$Panel$ManagePouches$GotPouches = function (a) {
	return {$: 5, a: a};
};
var $author$project$Services$Pouches$Pouch = F7(
	function (id, createdAt, updatedAt, concessionaireId, pouchCode, cashierAccountabilityId, status) {
		return {ib: cashierAccountabilityId, mc: concessionaireId, ix: createdAt, dM: id, fi: pouchCode, kK: status, qs: updatedAt};
	});
var $author$project$Services$Pouches$Active = 0;
var $author$project$Services$Pouches$Inactive = 1;
var $author$project$Services$Pouches$strCodeToStatus = function (strCODE) {
	switch (strCODE) {
		case 'ativo':
			return $elm$core$Maybe$Just(0);
		case 'inativo':
			return $elm$core$Maybe$Just(1);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Services$Pouches$decodeStatus = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$json$Json$Decode$fail('Error: ' + (str + 'is not mapped')),
			A2(
				$elm$core$Maybe$map,
				$elm$json$Json$Decode$succeed,
				$author$project$Services$Pouches$strCodeToStatus(str)));
	},
	$elm$json$Json$Decode$string);
var $author$project$Services$Pouches$decodePouch = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'status',
	$author$project$Services$Pouches$decodeStatus,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'cashierAccountabilityId',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'pouchCode',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'concessionaireId',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'updatedAt',
					$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'createdAt',
						$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Services$Pouches$Pouch))))))));
var $author$project$Services$Pouches$getPouches = function (options) {
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$elm$json$Json$Decode$list($author$project$Services$Pouches$decodePouch)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'pouch']),
				_List_Nil)
		});
};
var $author$project$Pages$Panel$ManagePouches$init = function (user) {
	return _Utils_Tuple2(
		{aY: $elm$core$Maybe$Nothing, fj: $krisajenkins$remotedata$RemoteData$Loading},
		$author$project$Services$Pouches$getPouches(
			{ow: $author$project$Pages$Panel$ManagePouches$GotPouches, kU: user.kU}));
};
var $author$project$Pages$Panel$Reason$GotReasons = function (a) {
	return {$: 0, a: a};
};
var $author$project$Services$Reason$Reason = F6(
	function (id, createdAt, updatedAt, action, reason, taxValue) {
		return {hV: action, ix: createdAt, dM: id, pf: reason, fB: taxValue, qs: updatedAt};
	});
var $author$project$Services$Models$Block = 1;
var $author$project$Services$Models$SecondWay = 2;
var $author$project$Services$Models$Unblock = 0;
var $author$project$Services$Reason$decodeAction = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'unblock':
				return $elm$json$Json$Decode$succeed(0);
			case 'block':
				return $elm$json$Json$Decode$succeed(1);
			case 'second_way':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Reason Models.ReasonAction not mapped ' + str);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Services$Reason$decodeReason = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'taxValue',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'reason',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'action',
			$author$project$Services$Reason$decodeAction,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'updatedAt',
				$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'createdAt',
					$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Services$Reason$Reason)))))));
var $author$project$Services$Reason$getReasons = function (options) {
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$elm$json$Json$Decode$list($author$project$Services$Reason$decodeReason)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'reason', 'allReasons']),
				_List_Nil)
		});
};
var $author$project$Pages$Panel$Reason$init = F3(
	function (oldModel, queries, user) {
		return _Utils_Tuple2(
			{
				L: 0,
				aY: $elm$core$Maybe$Nothing,
				T: queries,
				d5: A2(
					$elm$core$Maybe$withDefault,
					$krisajenkins$remotedata$RemoteData$Loading,
					A2(
						$elm$core$Maybe$map,
						function (old) {
							return old.d5;
						},
						oldModel))
			},
			$author$project$Services$Reason$getReasons(
				{ow: $author$project$Pages$Panel$Reason$GotReasons, kU: user.kU}));
	});
var $author$project$Pages$Panel$ReversalApprovalCashier$GotTime = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Panel$ReversalApprovalCashier$initModel = function (state) {
	return {dH: '', aY: $elm$core$Maybe$Nothing, a2: $krisajenkins$remotedata$RemoteData$NotAsked, eb: '', fy: state, kK: ''};
};
var $author$project$Pages$Panel$ReversalApprovalCashier$init = F2(
	function (state, _v0) {
		return _Utils_Tuple2(
			$author$project$Pages$Panel$ReversalApprovalCashier$initModel(state),
			A2(
				$elm$core$Task$perform,
				$author$project$Pages$Panel$ReversalApprovalCashier$GotTime,
				A3(
					$elm$core$Task$map2,
					F2(
						function (now, timezone) {
							return {e8: now, kS: timezone};
						}),
					$elm$time$Time$now,
					$elm$time$Time$here)));
	});
var $author$project$Pages$Panel$ReversalApprovalSystem$GotTime = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Panel$ReversalApprovalSystem$initModel = function (state) {
	return {dH: '', aY: $elm$core$Maybe$Nothing, a2: $krisajenkins$remotedata$RemoteData$NotAsked, eb: '', fy: state, kK: ''};
};
var $author$project$Pages$Panel$ReversalApprovalSystem$init = F2(
	function (state, _v0) {
		return _Utils_Tuple2(
			$author$project$Pages$Panel$ReversalApprovalSystem$initModel(state),
			A2(
				$elm$core$Task$perform,
				$author$project$Pages$Panel$ReversalApprovalSystem$GotTime,
				A3(
					$elm$core$Task$map2,
					F2(
						function (now, timezone) {
							return {e8: now, kS: timezone};
						}),
					$elm$time$Time$now,
					$elm$time$Time$here)));
	});
var $author$project$Pages$Panel$SingleCharge$GotSingleCharges = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Panel$SingleCharge$init = F2(
	function (oldModel, user) {
		return _Utils_Tuple2(
			{
				L: 0,
				aY: $elm$core$Maybe$Nothing,
				cr: A2(
					$elm$core$Maybe$withDefault,
					$krisajenkins$remotedata$RemoteData$Loading,
					A2(
						$elm$core$Maybe$map,
						function (old) {
							return old.cr;
						},
						oldModel))
			},
			$author$project$Services$SingleCharge$getSingleCharges(
				{ow: $author$project$Pages$Panel$SingleCharge$GotSingleCharges, kU: user.kU}));
	});
var $author$project$Pages$Panel$Stock$Details$GotDetails = function (a) {
	return {$: 1, a: a};
};
var $author$project$Services$Stock$StockDetails = function (id) {
	return function (createdAt) {
		return function (updatedAt) {
			return function (concessionaireID) {
				return function (serialNumber) {
					return function (type_) {
						return function (lastEventAt) {
							return function (vehicle) {
								return function (softwareVersion) {
									return function (status) {
										return function (lastStatusAt) {
											return function (batch) {
												return function (pcbID) {
													return {bh: batch, mb: concessionaireID, ix: createdAt, dM: id, gP: lastEventAt, jo: lastStatusAt, bx: pcbID, pE: serialNumber, kG: softwareVersion, kK: status, kY: type_, qs: updatedAt, k2: vehicle};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Services$Stock$Status = function (block) {
	return function (stock) {
		return function (events) {
			return function (refill) {
				return function (status) {
					return function (ebSerial) {
						return function (ebVersion) {
							return function (validatorDate) {
								return function (softwareVersion) {
									return function (validatorSerial) {
										return function (concessionaireId) {
											return {h5: block, mc: concessionaireId, mT: ebSerial, mU: ebVersion, D: events, fn: refill, kG: softwareVersion, kK: status, kL: stock, qB: validatorDate, k0: validatorSerial};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Services$Stock$decodeStatus = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'concessionaireId',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'validatorSerial',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'softwareVersion',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'validatorDate',
				$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'ebVersion',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'ebSerial',
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'status',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'refill',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'events',
									$elm$json$Json$Decode$int,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'stock',
										$elm$json$Json$Decode$int,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'block',
											$elm$json$Json$Decode$int,
											$elm$json$Json$Decode$succeed($author$project$Services$Stock$Status))))))))))));
var $author$project$Services$Stock$decodeEquipmentInStock = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'pcbID',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'batch',
		$elm$json$Json$Decode$string,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'lastStatusAt',
			$elm$json$Json$Decode$maybe($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'status',
				$elm$json$Json$Decode$maybe($author$project$Services$Stock$decodeStatus),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'softwareVersion',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'vehicle',
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'lastEventAt',
							$elm$json$Json$Decode$maybe($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'type',
								$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'serialNumber',
									$elm$json$Json$Decode$string,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'concessionaireID',
										$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
										$elm$core$Maybe$Nothing,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'updatedAt',
											$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'createdAt',
												$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'id',
													$elm$json$Json$Decode$string,
													$elm$json$Json$Decode$succeed($author$project$Services$Stock$StockDetails))))))))))))));
var $author$project$Services$Stock$getEquipmentInStock = function (options) {
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$author$project$Services$Stock$decodeEquipmentInStock),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'stock', 'bySerial', options.kw]),
				_List_Nil)
		});
};
var $author$project$Pages$Panel$Stock$Details$init = F2(
	function (serial, user) {
		return _Utils_Tuple2(
			{dE: $krisajenkins$remotedata$RemoteData$Loading, aY: $elm$core$Maybe$Nothing},
			$author$project$Services$Stock$getEquipmentInStock(
				{ow: $author$project$Pages$Panel$Stock$Details$GotDetails, kw: serial, kU: user.kU}));
	});
var $author$project$Pages$Panel$Stock$List$GotStock = function (a) {
	return {$: 1, a: a};
};
var $author$project$Services$Stock$Stock = F9(
	function (id, createdAt, updatedAt, serialNumber, type_, softwareVersion, batch, pcbID, status) {
		return {bh: batch, ix: createdAt, dM: id, bx: pcbID, pE: serialNumber, kG: softwareVersion, kK: status, kY: type_, qs: updatedAt};
	});
var $author$project$Services$Stock$decodeStock = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
	_List_fromArray(
		['status', 'status']),
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'pcbID',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'batch',
			$elm$json$Json$Decode$string,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'softwareVersion',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'type',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'serialNumber',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'updatedAt',
							$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'createdAt',
								$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'id',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Services$Stock$Stock))))))))));
var $author$project$Services$Stock$getStock = function (options) {
	var queries = A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'serial', options.kw);
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$elm$json$Json$Decode$list($author$project$Services$Stock$decodeStock)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'stock']),
				queries)
		});
};
var $author$project$Pages$Panel$Stock$List$init = F2(
	function (queries, user) {
		return _Utils_Tuple2(
			{L: 0, aY: $elm$core$Maybe$Nothing, T: queries, kL: $krisajenkins$remotedata$RemoteData$Loading},
			$author$project$Services$Stock$getStock(
				{ow: $author$project$Pages$Panel$Stock$List$GotStock, kw: queries.kw, kU: user.kU}));
	});
var $author$project$Pages$Panel$UpdateEquipment$GotDevices = function (a) {
	return {$: 0, a: a};
};
var $author$project$Services$Device$Device = F6(
	function (id, serialNumber, macAddress, type_, softwareVersion, vehicleCode) {
		return {dM: id, n6: macAddress, pE: serialNumber, kG: softwareVersion, kY: type_, em: vehicleCode};
	});
var $author$project$Services$Device$decodeDevice = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'vehicleCode',
	$elm$json$Json$Decode$string,
	'-',
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'softwareVersion',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'type',
			$elm$json$Json$Decode$string,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'macAddress',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'serialNumber',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Services$Device$Device)))))));
var $author$project$Services$Device$getDevices = function (options) {
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$elm$json$Json$Decode$list($author$project$Services$Device$decodeDevice)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'device']),
				_List_Nil)
		});
};
var $author$project$Pages$Panel$UpdateEquipment$init = function (user) {
	return _Utils_Tuple2(
		{eF: $krisajenkins$remotedata$RemoteData$Loading, P: $elm$core$Dict$empty, aY: $elm$core$Maybe$Nothing},
		$author$project$Services$Device$getDevices(
			{ow: $author$project$Pages$Panel$UpdateEquipment$GotDevices, kU: user.kU}));
};
var $author$project$Pages$Panel$UpdateRequestsEquipments$GotUpdateRequests = function (a) {
	return {$: 0, a: a};
};
var $author$project$Services$Device$UpdateRequest = F8(
	function (softwareUpdateCode, serialDevice, createdBy, createdAt, appliedAt, vehicleCode, deviceID, softwareUpdateID) {
		return {lq: appliedAt, ix: createdAt, mj: createdBy, mH: deviceID, pD: serialDevice, pK: softwareUpdateCode, pL: softwareUpdateID, em: vehicleCode};
	});
var $author$project$Services$Device$decodeUpdateRequest = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'softwareUpdateID',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'deviceID',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'vehicleCode',
			$elm$json$Json$Decode$string,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'appliedAt',
				$elm$json$Json$Decode$maybe($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'createdAt',
					$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'createdBy',
						$elm$json$Json$Decode$string,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'serialDevice',
							$elm$json$Json$Decode$string,
							'',
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'softwareUpdateCode',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Services$Device$UpdateRequest)))))))));
var $author$project$Services$Device$getUpdateRequests = function (options) {
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$elm$json$Json$Decode$list($author$project$Services$Device$decodeUpdateRequest)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'device', 'softwareUpdates']),
				_List_Nil)
		});
};
var $author$project$Pages$Panel$UpdateRequestsEquipments$init = function (user) {
	return _Utils_Tuple2(
		{aY: $elm$core$Maybe$Nothing, fK: $krisajenkins$remotedata$RemoteData$Loading},
		$author$project$Services$Device$getUpdateRequests(
			{ow: $author$project$Pages$Panel$UpdateRequestsEquipments$GotUpdateRequests, kU: user.kU}));
};
var $author$project$Services$Pos$PosSummary = F9(
	function (cashierId, concessionaireId, openedAt, closedAt, openUserId, closeUserId, balance, specificInfo, resume) {
		return {h2: balance, ds: cashierId, f4: closeUserId, l2: closedAt, mc: concessionaireId, g3: openUserId, jL: openedAt, cl: resume, fx: specificInfo};
	});
var $author$project$Services$Pos$Resume = F3(
	function (cards, credits, secondWay) {
		return {f0: cards, gb: credits, hv: secondWay};
	});
var $author$project$Services$Pos$ResumeChild = F2(
	function (total, counts) {
		return {dA: counts, qc: total};
	});
var $author$project$Data$Money$Money = $elm$core$Basics$identity;
var $author$project$Data$Money$decoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$int);
var $author$project$Services$Pos$typeAmountTuples = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$Dict$toList,
		$elm$core$List$map(
			function (_v0) {
				var type_ = _v0.a;
				var amount = _v0.b;
				return {lo: amount, kY: type_};
			})),
	$elm$json$Json$Decode$dict($author$project$Data$Money$decoder));
var $author$project$Services$Pos$resumeChild = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'counts',
	$author$project$Services$Pos$typeAmountTuples,
	_List_Nil,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'total',
		$author$project$Data$Money$decoder,
		$elm$json$Json$Decode$succeed($author$project$Services$Pos$ResumeChild)));
var $author$project$Services$Pos$ResumeChildSecondWay = F2(
	function (total, counts) {
		return {dA: counts, qc: total};
	});
var $author$project$Services$Pos$resumeChildSecondWay = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'counts',
	$elm$json$Json$Decode$int,
	0,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'total',
		$author$project$Data$Money$decoder,
		$elm$json$Json$Decode$succeed($author$project$Services$Pos$ResumeChildSecondWay)));
var $author$project$Services$Pos$resume = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'secondWay',
	$author$project$Services$Pos$resumeChildSecondWay,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'credits',
		$author$project$Services$Pos$resumeChild,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'cards',
			$author$project$Services$Pos$resumeChild,
			$elm$json$Json$Decode$succeed($author$project$Services$Pos$Resume))));
var $author$project$Shared$None = {$: 1};
var $author$project$Shared$CashierSpecificDefault = F9(
	function (routeId, cashierId, direction, sessionId, timestamp, operatorId, openingCounter, firmwareVersion, preOpeningCounter) {
		return {ds: cashierId, mL: direction, nr: firmwareVersion, oC: openingCounter, oD: operatorId, o3: preOpeningCounter, pw: routeId, pG: sessionId, p6: timestamp};
	});
var $author$project$Shared$Default = function (a) {
	return {$: 0, a: a};
};
var $author$project$Services$Pos$specificDefaultInfo = A2(
	$elm$json$Json$Decode$map,
	$author$project$Shared$Default,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'preOpeningCounter',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'firmwareVersion',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'openingCounter',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'operatorId',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'timestamp',
						$elm_community$json_extra$Json$Decode$Extra$datetime,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'sessionId',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'direction',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'cashierId',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'routeId',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Shared$CashierSpecificDefault)))))))))));
var $author$project$Services$Pos$specificInfoDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			$author$project$Services$Pos$specificDefaultInfo,
			$elm$json$Json$Decode$succeed($author$project$Shared$None)
		]));
var $author$project$Services$Pos$posSummaryDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'resume',
	$author$project$Services$Pos$resume,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'specificInfo',
		$author$project$Services$Pos$specificInfoDecoder,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'balance',
			$elm$json$Json$Decode$int,
			0,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'closeUserId',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'openUserId',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'closedAt',
						$elm$json$Json$Decode$maybe($elm_community$json_extra$Json$Decode$Extra$datetime),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'openedAt',
							$elm_community$json_extra$Json$Decode$Extra$datetime,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'concessionaireId',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'id',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Services$Pos$PosSummary))))))))));
var $author$project$Services$Pos$getPosSummary = F2(
	function (_v0, processRequest) {
		var token = _v0.kU;
		return $elm$http$Http$request(
			{
				lG: $elm$http$Http$emptyBody,
				m9: A2($author$project$Services$Api$expectJson, processRequest, $author$project$Services$Pos$posSummaryDecoder),
				nG: _List_fromArray(
					[
						$author$project$Services$Api$authorizationHeader(token)
					]),
				of: 'GET',
				p5: $elm$core$Maybe$Nothing,
				qi: $elm$core$Maybe$Nothing,
				qt: A2(
					$author$project$Constants$cashierServiceUrl,
					_List_fromArray(
						['api', 'v1', 'cashier', 'resume']),
					_List_Nil)
			});
	});
var $author$project$Pages$Pos$CloseCashier$HandleModel = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Pos$CloseCashier$NoOp = {$: 3};
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $author$project$Pages$Pos$CloseCashier$handleGetPosSummary = A2(
	$elm$core$Basics$composeR,
	$elm$core$Result$map($author$project$Pages$Pos$CloseCashier$HandleModel),
	$elm$core$Result$withDefault($author$project$Pages$Pos$CloseCashier$NoOp));
var $author$project$Data$Money$fromInt = function (value) {
	return value;
};
var $author$project$Pages$Pos$CloseCashier$resumeChild = {
	dA: _List_Nil,
	qc: $author$project$Data$Money$fromInt(0)
};
var $author$project$Pages$Pos$CloseCashier$resumeInit = {
	f0: $author$project$Pages$Pos$CloseCashier$resumeChild,
	gb: $author$project$Pages$Pos$CloseCashier$resumeChild,
	hv: {
		dA: 0,
		qc: $author$project$Data$Money$fromInt(0)
	}
};
var $author$project$Pages$Pos$CloseCashier$specificInfoInit = $author$project$Shared$None;
var $author$project$Pages$Pos$CloseCashier$initialModel = {
	h2: 0,
	ds: '',
	f4: $elm$core$Maybe$Nothing,
	l2: $elm$core$Maybe$Nothing,
	mc: '',
	e6: false,
	g3: '',
	jL: $elm$time$Time$millisToPosix(0),
	cl: $author$project$Pages$Pos$CloseCashier$resumeInit,
	fx: $author$project$Pages$Pos$CloseCashier$specificInfoInit
};
var $author$project$Pages$Pos$CloseCashier$init = function (user) {
	return _Utils_Tuple2(
		$author$project$Pages$Pos$CloseCashier$initialModel,
		A2($author$project$Services$Pos$getPosSummary, user, $author$project$Pages$Pos$CloseCashier$handleGetPosSummary));
};
var $author$project$Pages$Pos$Edit$GotPassenger = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Pos$Edit$Loading = {$: 0};
var $author$project$Data$Passenger$Full = F4(
	function (meta, address, documents, wallets) {
		return {ep: address, mP: documents, oe: meta, hO: wallets};
	});
var $author$project$Data$Passenger$Address = F8(
	function (country, city, state, neighborhood, street, number, complement, zipCode) {
		return {lW: city, l9: complement, mh: country, om: neighborhood, op: number, fy: state, pU: street, qT: zipCode};
	});
var $author$project$Data$Passenger$addressDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'zipCode',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'complement',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'number',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'street',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'neighborhood',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'state',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'city',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'country',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Data$Passenger$Address)))))))));
var $author$project$Data$Passenger$Document = F2(
	function (url, isPhoto) {
		return {nW: isPhoto, qt: url};
	});
var $author$project$Data$Passenger$documentDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$map,
		function (str) {
			return str === 'photo';
		},
		A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string)),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'path',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Data$Passenger$Document)));
var $author$project$Data$Passenger$Meta = F6(
	function (id, userId, document, name, phone, email) {
		return {iI: document, mX: email, dM: id, c3: name, jX: phone, qw: userId};
	});
var $author$project$Data$Passenger$metaDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'email',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'mobilePhone',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'document',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'userID',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Data$Passenger$Meta)))))));
var $author$project$Data$Passenger$walletDecoderV2 = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'purseID',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'walletClassesWallet',
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					$elm$json$Json$Decode$list(
					A2(
						$elm$json$Json$Decode$andThen,
						function (typeId) {
							return A2(
								$elm$json$Json$Decode$field,
								'class',
								$author$project$Data$Passenger$classDecoder(typeId));
						},
						A2(
							$elm$json$Json$Decode$field,
							'walletClassTypeID',
							$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)))),
					$elm$json$Json$Decode$null(_List_Nil)
				])),
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'balance',
			$elm$json$Json$Decode$int,
			0,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Data$Passenger$Wallet)))));
var $author$project$Data$Passenger$fullDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$field,
		'wallets',
		$elm$json$Json$Decode$list($author$project$Data$Passenger$walletDecoderV2)),
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		A2(
			$elm$json$Json$Decode$field,
			'documents',
			$elm$json$Json$Decode$list($author$project$Data$Passenger$documentDecoder)),
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2(
				$elm$json$Json$Decode$field,
				'address',
				$elm$json$Json$Decode$maybe($author$project$Data$Passenger$addressDecoder)),
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				$author$project$Data$Passenger$metaDecoder,
				$elm$json$Json$Decode$succeed($author$project$Data$Passenger$Full)))));
var $author$project$Services$Concessionaire$getPassengerInfoV2 = function (options) {
	return $elm$http$Http$task(
		{
			lG: $elm$http$Http$emptyBody,
			nG: _List_fromArray(
				[
					$author$project$Services$Api$authorizationHeader(options.kU)
				]),
			of: 'GET',
			d6: $author$project$Services$Api$jsonResolver($author$project$Data$Passenger$fullDecoder),
			p5: $elm$core$Maybe$Nothing,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'passenger', options.oM]),
				_List_Nil)
		});
};
var $author$project$Pages$Pos$Edit$initWithPassengerId = F2(
	function (user, passengerId) {
		return _Utils_Tuple2(
			$author$project$Pages$Pos$Edit$Loading,
			A2(
				$elm$core$Task$attempt,
				$author$project$Pages$Pos$Edit$GotPassenger,
				$author$project$Services$Concessionaire$getPassengerInfoV2(
					{oM: passengerId, kU: user.kU})));
	});
var $author$project$Pages$Pos$Edit$init = F3(
	function (user, passengerId, maybePassenger) {
		return A2($author$project$Pages$Pos$Edit$initWithPassengerId, user, passengerId);
	});
var $author$project$Pages$Pos$Guiche$SetCashierStatus = function (a) {
	return {$: 6, a: a};
};
var $author$project$Services$Pos$getPosSummaryInit = F2(
	function (_v0, processRequest) {
		var token = _v0.kU;
		return $elm$http$Http$request(
			{
				lG: $elm$http$Http$emptyBody,
				m9: A2($author$project$Services$Api$expectJson, processRequest, $author$project$Services$Pos$posSummaryDecoder),
				nG: _List_fromArray(
					[
						$author$project$Services$Api$authorizationHeader(token)
					]),
				of: 'GET',
				p5: $elm$core$Maybe$Nothing,
				qi: $elm$core$Maybe$Nothing,
				qt: A2(
					$author$project$Constants$cashierServiceUrl,
					_List_fromArray(
						['api', 'v1', 'cashier']),
					_List_Nil)
			});
	});
var $author$project$Utils$resultToBool = A2(
	$elm$core$Basics$composeR,
	$elm$core$Result$map(
		function (_v0) {
			return true;
		}),
	$elm$core$Result$withDefault(false));
var $author$project$Pages$Pos$Guiche$init = function (user) {
	return _Utils_Tuple3(
		{dO: $elm$core$Maybe$Nothing, ff: $elm$core$Maybe$Nothing},
		function () {
			var _v0 = user.k$;
			if (_v0.$ === 1) {
				return A2(
					$author$project$Services$Pos$getPosSummaryInit,
					user,
					A2($elm$core$Basics$composeR, $author$project$Utils$resultToBool, $author$project$Pages$Pos$Guiche$SetCashierStatus));
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		}(),
		$author$project$Shared$NoOp);
};
var $author$project$Pages$Pos$Localize$GotPassengers = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Pos$Localize$NoOp = {$: 0};
var $elm$browser$Browser$Dom$focus = _Browser_call('focus');
var $author$project$Services$Passenger$Passenger = F8(
	function (id, userId, concessionaireId, name, document, documentType, phone, image) {
		return {mc: concessionaireId, iI: document, mO: documentType, dM: id, nM: image, c3: name, jX: phone, qw: userId};
	});
var $elm$json$Json$Decode$map8 = _Json_map8;
var $author$project$Constants$passengerServiceUrlV1 = $elm$url$Url$Builder$crossOrigin('https://api.pazze.app/passengers');
var $author$project$Services$Passenger$search = function (options) {
	var decoder = A9(
		$elm$json$Json$Decode$map8,
		$author$project$Services$Passenger$Passenger,
		A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'userId', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'concessionaire_id', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'document', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'documentType', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'mobilephone', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'path', $elm$json$Json$Decode$string));
	return $elm$http$Http$request(
		{
			lG: $elm$http$Http$emptyBody,
			m9: A2(
				$author$project$Services$Api$expectJson,
				options.ow,
				$elm$json$Json$Decode$list(decoder)),
			nG: _List_fromArray(
				[
					$author$project$Services$Api$authorizationHeader(options.kU)
				]),
			of: 'GET',
			p5: $elm$core$Maybe$Nothing,
			qi: $elm$core$Maybe$Nothing,
			qt: A2(
				$author$project$Constants$passengerServiceUrlV1,
				_List_fromArray(
					['api', 'v1', 'concessionaire', 'passenger']),
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$elm$core$Maybe$Just(
							A2($elm$url$Url$Builder$string, 'q', options.pe)),
							options.oA ? $elm$core$Maybe$Just(
							A2($elm$url$Url$Builder$string, 'type', 'app')) : $elm$core$Maybe$Nothing
						])))
		});
};
var $author$project$Pages$Pos$Localize$searchPassengerInputId = 'search-passenger';
var $author$project$Pages$Pos$Localize$init = F2(
	function (user, maybeSearch) {
		var _v0 = function () {
			if (maybeSearch.$ === 1) {
				return _Utils_Tuple2(
					{dB: '', a0: $krisajenkins$remotedata$RemoteData$NotAsked, a3: ''},
					$elm$core$Platform$Cmd$none);
			} else {
				var search = maybeSearch.a;
				return ($elm$core$String$length(search) < 3) ? _Utils_Tuple2(
					{dB: '', a0: $krisajenkins$remotedata$RemoteData$NotAsked, a3: search},
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					{dB: search, a0: $krisajenkins$remotedata$RemoteData$Loading, a3: search},
					$author$project$Services$Passenger$search(
						{ow: $author$project$Pages$Pos$Localize$GotPassengers, oA: false, pe: search, kU: user.kU}));
			}
		}();
		var model = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Task$attempt,
						$elm$core$Basics$always($author$project$Pages$Pos$Localize$NoOp),
						$elm$browser$Browser$Dom$focus($author$project$Pages$Pos$Localize$searchPassengerInputId)),
						cmd
					])));
	});
var $author$project$Pages$Pos$Passenger$init = F4(
	function (user, passengerId, route, maybePassenger) {
		return A5($author$project$Pages$Pos$Passenger$init_, user, passengerId, route, maybePassenger, $elm$core$Maybe$Nothing);
	});
var $author$project$Pages$Pos$Register$GotEditorMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Pos$Editor$GotPassengerInfo = function (a) {
	return {$: 24, a: a};
};
var $author$project$Pages$Pos$Editor$ReceivedClasses = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Pos$Editor$Info = 0;
var $author$project$Pages$Pos$Editor$NoPhoto = {$: 0};
var $author$project$Pages$Pos$Editor$emptyModel = {ep: '', lk: '', bL: '', bd: '', aQ: $elm$core$Maybe$Nothing, lW: '', dv: $krisajenkins$remotedata$RemoteData$Loading, iI: '', bi: $author$project$Pages$Pos$Editor$NoPhoto, bj: $author$project$Pages$Pos$Editor$NoPhoto, mX: '', bn: $author$project$Pages$Pos$Editor$NoPhoto, aY: $elm$core$Maybe$Nothing, c3: '', om: '', j: $elm$core$Maybe$Nothing, cc: $krisajenkins$remotedata$RemoteData$NotAsked, oN: '', c6: '', o0: '', B: $elm$core$Dict$empty, hG: 0, q: $krisajenkins$remotedata$RemoteData$NotAsked};
var $author$project$Pages$Pos$Editor$initModel = function (passenger) {
	var address = passenger.ep;
	return {
		ep: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.pU;
				},
				address)),
		lk: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.l9;
				},
				address)),
		bL: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.op;
				},
				address)),
		bd: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.fy;
				},
				address)),
		aQ: $elm$core$Maybe$Nothing,
		lW: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.lW;
				},
				address)),
		dv: $krisajenkins$remotedata$RemoteData$Loading,
		iI: passenger.oe.iI,
		bi: $author$project$Pages$Pos$Editor$NoPhoto,
		bj: $author$project$Pages$Pos$Editor$NoPhoto,
		mX: A2($elm$core$Maybe$withDefault, '', passenger.oe.mX),
		bn: $author$project$Pages$Pos$Editor$NoPhoto,
		aY: $elm$core$Maybe$Nothing,
		c3: passenger.oe.c3,
		om: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.om;
				},
				address)),
		j: $elm$core$Maybe$Just(passenger),
		cc: $krisajenkins$remotedata$RemoteData$Loading,
		oN: '',
		c6: '',
		o0: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.qT;
				},
				address)),
		B: $elm$core$Dict$empty,
		hG: 0,
		q: $krisajenkins$remotedata$RemoteData$NotAsked
	};
};
var $author$project$Pages$Pos$Editor$init = F2(
	function (user, maybePassenger) {
		return _Utils_Tuple2(
			function () {
				if (maybePassenger.$ === 1) {
					return $author$project$Pages$Pos$Editor$emptyModel;
				} else {
					var passenger = maybePassenger.a;
					return $author$project$Pages$Pos$Editor$initModel(passenger);
				}
			}(),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Services$Concessionaire$getConcessionaireClasses(
						{
							ow: $author$project$Pages$Pos$Editor$ReceivedClasses,
							kU: user.kU,
							qE: $elm$core$Maybe$Just(false)
						}),
						A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Platform$Cmd$none,
						A2(
							$elm$core$Maybe$map,
							function (p) {
								return A2(
									$elm$core$Task$attempt,
									$author$project$Pages$Pos$Editor$GotPassengerInfo,
									$author$project$Services$Concessionaire$getPassengerInfo(
										{oM: p.oe.dM, kU: user.kU}));
							},
							maybePassenger))
					])));
	});
var $author$project$Pages$Pos$Register$init = function (user) {
	var _v0 = A2($author$project$Pages$Pos$Editor$init, user, $elm$core$Maybe$Nothing);
	var editorModel = _v0.a;
	var editorCmd = _v0.b;
	return _Utils_Tuple2(
		{cR: editorModel},
		A2($elm$core$Platform$Cmd$map, $author$project$Pages$Pos$Register$GotEditorMsg, editorCmd));
};
var $author$project$Pages$RecoverPassword$ToSent = 0;
var $author$project$Pages$RecoverPassword$init = {mX: '', d9: 0, q: $krisajenkins$remotedata$RemoteData$NotAsked};
var $author$project$Pages$Reports$AdministrativeSales$GotReport = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Reports$AdministrativeSales$GotTime = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Reports$AdministrativeSales$GotUsers = function (a) {
	return {$: 2, a: a};
};
var $author$project$Services$Reports$AdministrativeSales$AdministrativeSales = F7(
	function (id, createdAt, value, cardSerial, typeDescription, user, cashierUser) {
		return {lO: cardSerial, lR: cashierUser, ix: createdAt, dM: id, kX: typeDescription, kZ: user, di: value};
	});
var $author$project$Services$Reports$AdministrativeSales$User = F3(
	function (email, name, id) {
		return {mX: email, dM: id, c3: name};
	});
var $author$project$Services$Reports$AdministrativeSales$decodeUser = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'id',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'email',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Services$Reports$AdministrativeSales$User))));
var $author$project$Services$Reports$AdministrativeSales$decodeAdministrativeSale = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'cashierUser',
	$author$project$Services$Reports$AdministrativeSales$decodeUser,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'user',
		$author$project$Services$Reports$AdministrativeSales$decodeUser,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'typeDescription',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'cardSerial',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'value',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'createdAt',
						$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Services$Reports$AdministrativeSales$AdministrativeSales))))))));
var $author$project$Services$Reports$AdministrativeSales$getExtraCharges = function (options) {
	var listToStr = function (list) {
		var _v0 = A2($elm$core$String$join, ',', list);
		if (_v0 === '') {
			return $elm$core$Maybe$Nothing;
		} else {
			var str = _v0;
			return $elm$core$Maybe$Just(str);
		}
	};
	var queries = _Utils_ap(
		A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'start', options.T.bB),
		_Utils_ap(
			A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'end', options.T.bl),
			A3(
				$author$project$Services$Api$queryMaybeValue,
				$elm$url$Url$Builder$string,
				'operatorID',
				listToStr(options.T.g6))));
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							$elm$json$Json$Decode$list($author$project$Services$Reports$AdministrativeSales$decodeAdministrativeSale)
						]))),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'report', 'extraCharges']),
				queries)
		});
};
var $author$project$Services$Users$UserGuiche = F3(
	function (id, email, name) {
		return {mX: email, dM: id, c3: name};
	});
var $author$project$Services$Users$decodeUserGuiche = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'email',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Services$Users$UserGuiche))));
var $author$project$Services$Users$getUsersGuiche = function (options) {
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$elm$json$Json$Decode$list($author$project$Services$Users$decodeUserGuiche)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'user', 'getAllSystemUsersGuiche']),
				_List_Nil)
		});
};
var $author$project$Pages$Reports$AdministrativeSales$init = F2(
	function (queries, user) {
		return _Utils_Tuple2(
			{
				bQ: $author$project$Components$PDF$Create$init,
				dK: false,
				L: 0,
				dV: false,
				c5: $krisajenkins$remotedata$RemoteData$Loading,
				T: queries,
				ck: A2(
					$elm$core$Maybe$withDefault,
					$krisajenkins$remotedata$RemoteData$NotAsked,
					A3(
						$elm$core$Maybe$map2,
						F2(
							function (_v0, _v1) {
								return $krisajenkins$remotedata$RemoteData$Loading;
							}),
						queries.bB,
						queries.bl))
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$withDefault,
						A2(
							$elm$core$Task$perform,
							$author$project$Pages$Reports$AdministrativeSales$GotTime,
							A3(
								$elm$core$Task$map2,
								F2(
									function (now, timezone) {
										return {e8: now, kS: timezone};
									}),
								$elm$time$Time$now,
								$elm$time$Time$here)),
						A3(
							$elm$core$Maybe$map2,
							F2(
								function (_v2, _v3) {
									return $author$project$Services$Reports$AdministrativeSales$getExtraCharges(
										{ow: $author$project$Pages$Reports$AdministrativeSales$GotReport, T: queries, kU: user.kU});
								}),
							queries.bB,
							queries.bl)),
						$author$project$Services$Users$getUsersGuiche(
						{ow: $author$project$Pages$Reports$AdministrativeSales$GotUsers, kU: user.kU})
					])));
	});
var $author$project$Pages$Reports$DetailedVehicle$GotDetails = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Reports$DetailedVehicle$GotTime = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Reports$DetailedVehicle$GotVehicles = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Reports$DetailedVehicle$Loading = 0;
var $author$project$Services$Reports$DetailedVehicle$encodeDetails = function (queries) {
	var encode = F2(
		function (k, v) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (v_) {
						return $elm$core$List$singleton(
							_Utils_Tuple2(
								k,
								$elm$json$Json$Encode$string(v_)));
					},
					v));
		});
	return $elm$json$Json$Encode$object(
		_Utils_ap(
			A2(encode, 'end', queries.bl),
			A2(encode, 'start', queries.bB)));
};
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $author$project$Services$Api$postHttp = function (options) {
	return $elm$http$Http$request(
		{
			lG: options.lG,
			m9: options.m9,
			nG: _List_fromArray(
				[
					$author$project$Services$Api$authorizationHeader(options.kU)
				]),
			of: 'POST',
			p5: $elm$core$Maybe$Nothing,
			qi: $elm$core$Maybe$Nothing,
			qt: options.qt
		});
};
var $author$project$Services$Reports$DetailedVehicle$VehicleDetails = function (id) {
	return function (date) {
		return function (description) {
			return function (value) {
				return function (balance) {
					return function (gateCount) {
						return function (ltc) {
							return function (ctc) {
								return function (_class) {
									return function (wallet) {
										return function (temporalIntegration) {
											return function (transactionError) {
												return function (vehicle) {
													return function (line) {
														return function (type_) {
															return function (sequence) {
																return function (sequenceTransaction) {
																	return function (cardSerial) {
																		return function (userName) {
																			return {h2: balance, lO: cardSerial, ih: _class, iy: ctc, cO: date, z: description, eL: gateCount, dM: id, e1: line, js: ltc, pC: sequence, fu: sequenceTransaction, p1: temporalIntegration, bD: transactionError, kY: type_, qx: userName, di: value, k2: vehicle, k7: wallet};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Services$Reports$DetailedVehicle$vehicleDetailsDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'cardUserName',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'cardSerial',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'sequenceTransaction',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'sequence',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'type',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
					$elm$core$Maybe$Nothing,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'line',
						$elm$json$Json$Decode$string,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'vehicle',
							$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
							$elm$core$Maybe$Nothing,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'transactionError',
								$elm$json$Json$Decode$bool,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'temporalIntegration',
									$elm$json$Json$Decode$maybe($elm$json$Json$Decode$bool),
									$elm$core$Maybe$Nothing,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'wallet',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'class',
											$elm$json$Json$Decode$string,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'ctc',
												$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
												$elm$core$Maybe$Nothing,
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'ltc',
													$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
													$elm$core$Maybe$Nothing,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'gateCount',
														$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
														$elm$core$Maybe$Nothing,
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'balance',
															$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
															$elm$core$Maybe$Nothing,
															A4(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																'value',
																$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
																$elm$core$Maybe$Nothing,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'description',
																	$elm$json$Json$Decode$string,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'date',
																		$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'id',
																			$elm$json$Json$Decode$string,
																			$elm$json$Json$Decode$succeed($author$project$Services$Reports$DetailedVehicle$VehicleDetails))))))))))))))))))));
var $author$project$Services$Reports$DetailedVehicle$getDetails = function (options) {
	return $author$project$Services$Api$postHttp(
		{
			lG: $elm$http$Http$jsonBody(
				$author$project$Services$Reports$DetailedVehicle$encodeDetails(options.T)),
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							$elm$json$Json$Decode$list($author$project$Services$Reports$DetailedVehicle$vehicleDetailsDecoder),
							$elm$json$Json$Decode$null(_List_Nil)
						]))),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'report', 'vehicle', options.fN, 'detail']),
				_List_Nil)
		});
};
var $author$project$Services$Reports$DetailedVehicle$VehicleV2 = F7(
	function (id, createdAt, updatedAt, code, plate, concessionaireID, device) {
		return {l4: code, mb: concessionaireID, ix: createdAt, mG: device, dM: id, ac: plate, qs: updatedAt};
	});
var $author$project$Services$Reports$DetailedVehicle$VehicleDeviceV2 = F3(
	function (deviceID, deviceInstalledAt, deviceSn) {
		return {mH: deviceID, mJ: deviceInstalledAt, iF: deviceSn};
	});
var $author$project$Services$Reports$DetailedVehicle$vehicleDeviceV2Decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'deviceSn',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'deviceInstalledAt',
		$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'deviceID',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Services$Reports$DetailedVehicle$VehicleDeviceV2))));
var $author$project$Services$Reports$DetailedVehicle$vehicleV2Decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$elm$json$Json$Decode$maybe($author$project$Services$Reports$DetailedVehicle$vehicleDeviceV2Decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'concessionaireID',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'plate',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'code',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'updatedAt',
					$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'createdAt',
						$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Services$Reports$DetailedVehicle$VehicleV2))))))));
var $author$project$Services$Reports$DetailedVehicle$getVehicleV2 = function (options) {
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$elm$json$Json$Decode$list($author$project$Services$Reports$DetailedVehicle$vehicleV2Decoder)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'concessionaire', 'vehicle']),
				_List_Nil)
		});
};
var $author$project$Pages$Reports$DetailedVehicle$init = F2(
	function (queries, user) {
		return _Utils_Tuple2(
			{dE: $krisajenkins$remotedata$RemoteData$NotAsked, L: 0, az: false, b1: false, T: queries, cq: true, fy: 0, en: $krisajenkins$remotedata$RemoteData$Loading},
			A2(
				$elm$core$Maybe$withDefault,
				$author$project$Services$Reports$DetailedVehicle$getVehicleV2(
					{ow: $author$project$Pages$Reports$DetailedVehicle$GotVehicles, kU: user.kU}),
				A2(
					$elm$core$Maybe$map,
					function (vehicleID) {
						return A2(
							$elm$core$Maybe$withDefault,
							A2(
								$elm$core$Task$perform,
								$author$project$Pages$Reports$DetailedVehicle$GotTime,
								A3(
									$elm$core$Task$map2,
									F2(
										function (now, timezone) {
											return {e8: now, kS: timezone};
										}),
									$elm$time$Time$now,
									$elm$time$Time$here)),
							A3(
								$elm$core$Maybe$map2,
								F2(
									function (_v0, _v1) {
										return $author$project$Services$Reports$DetailedVehicle$getDetails(
											{ow: $author$project$Pages$Reports$DetailedVehicle$GotDetails, T: queries, kU: user.kU, fN: vehicleID});
									}),
								queries.bB,
								queries.bl));
					},
					queries.fN)));
	});
var $author$project$Pages$Reports$DetailedVehicleV2$GotDetails = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Reports$DetailedVehicleV2$GotTime = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Reports$DetailedVehicleV2$GotVehicles = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Reports$DetailedVehicleV2$Loading = 0;
var $author$project$Services$Reports$DetailedVehicle$VehicleDetailsV2 = function (id) {
	return function (eventDate) {
		return function (eventType) {
			return function (eventTransactionId) {
				return function (transactionSequence) {
					return function (userName) {
						return function (cardSerial) {
							return function (walletClass) {
								return function (wallet) {
									return function (walletClassType) {
										return function (value) {
											return function (ltc) {
												return function (ctc) {
													return function (balance) {
														return function (gateCount) {
															return function (cashierID) {
																return {h2: balance, lO: cardSerial, ic: cashierID, iy: ctc, m2: eventDate, m6: eventTransactionId, f: eventType, eL: gateCount, dM: id, js: ltc, qk: transactionSequence, qx: userName, di: value, k7: wallet, qH: walletClass, qK: walletClassType};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Services$Reports$DetailedVehicle$vechicleDetailsV2Decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'cashierID',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'gateCount',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'balance',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'ctc',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'ltc',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'value',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'walletClassType',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'wallet',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'walletClass',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'cardSerial',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'userName',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'transactionSequence',
												$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'eventTransactionId',
													$elm$json$Json$Decode$int,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'eventType',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'eventDate',
															$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'id',
																$elm$json$Json$Decode$int,
																$elm$json$Json$Decode$succeed($author$project$Services$Reports$DetailedVehicle$VehicleDetailsV2)))))))))))))))));
var $author$project$Services$Reports$DetailedVehicle$getDetailsV2 = function (options) {
	var queries = _Utils_ap(
		A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'start', options.T.bB),
		_Utils_ap(
			A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'end', options.T.bl),
			A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'vehicleID', options.T.fN)));
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							$elm$json$Json$Decode$list($author$project$Services$Reports$DetailedVehicle$vechicleDetailsV2Decoder),
							$elm$json$Json$Decode$null(_List_Nil)
						]))),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'report', 'vehicleDetailsMain']),
				queries)
		});
};
var $author$project$Pages$Reports$DetailedVehicleV2$init = F2(
	function (queries, user) {
		return _Utils_Tuple2(
			{dE: $krisajenkins$remotedata$RemoteData$NotAsked, av: _List_Nil, L: 0, az: false, b1: false, T: queries, cq: true, fy: 0, en: $krisajenkins$remotedata$RemoteData$Loading},
			A2(
				$elm$core$Maybe$withDefault,
				$author$project$Services$Reports$DetailedVehicle$getVehicleV2(
					{ow: $author$project$Pages$Reports$DetailedVehicleV2$GotVehicles, kU: user.kU}),
				A2(
					$elm$core$Maybe$map,
					function (vehicleID) {
						return A2(
							$elm$core$Maybe$withDefault,
							A2(
								$elm$core$Task$perform,
								$author$project$Pages$Reports$DetailedVehicleV2$GotTime,
								A3(
									$elm$core$Task$map2,
									F2(
										function (now, timezone) {
											return {e8: now, kS: timezone};
										}),
									$elm$time$Time$now,
									$elm$time$Time$here)),
							A3(
								$elm$core$Maybe$map2,
								F2(
									function (_v0, _v1) {
										return $author$project$Services$Reports$DetailedVehicle$getDetailsV2(
											{ow: $author$project$Pages$Reports$DetailedVehicleV2$GotDetails, T: queries, kU: user.kU});
									}),
								queries.bB,
								queries.bl));
					},
					queries.fN)));
	});
var $author$project$Pages$Reports$Divergences$GotClasses = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Reports$Divergences$GotDivergences = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Reports$Divergences$GotLines = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Reports$Divergences$GotOperators = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Reports$Divergences$GotTime = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Reports$Divergences$GotVehiclesV2 = function (a) {
	return {$: 5, a: a};
};
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $author$project$Services$Reports$Divergences$Divergence = F8(
	function (id, createdAt, cardSerial, similarity, userName, walletClassName, walletClassTypeName, vehicle) {
		return {lO: cardSerial, ix: createdAt, dM: id, pI: similarity, qx: userName, k2: vehicle, qJ: walletClassName, k9: walletClassTypeName};
	});
var $author$project$Services$Reports$Divergences$decodeDivergence = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'vehicle',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'walletClassTypeName',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'walletClassName',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'userName',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'similarity',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'cardSerial',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'createdAt',
							$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'id',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Services$Reports$Divergences$Divergence)))))))));
var $author$project$Services$Reports$Divergences$getDivergences = function (options) {
	var listToStr = function (list) {
		var _v0 = A2($elm$core$String$join, ',', list);
		if (_v0 === '') {
			return $elm$core$Maybe$Nothing;
		} else {
			var str = _v0;
			return $elm$core$Maybe$Just(str);
		}
	};
	var queries = _Utils_ap(
		A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'start', options.T.bB),
		_Utils_ap(
			A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'end', options.T.bl),
			_Utils_ap(
				A3(
					$author$project$Services$Api$queryMaybeValue,
					$elm$url$Url$Builder$int,
					'startSimilarity',
					$elm$core$Maybe$Just(options.T.iY)),
				_Utils_ap(
					A3(
						$author$project$Services$Api$queryMaybeValue,
						$elm$url$Url$Builder$int,
						'endSimilarity',
						$elm$core$Maybe$Just(options.T.kT)),
					_Utils_ap(
						A3(
							$author$project$Services$Api$queryMaybeValue,
							$elm$url$Url$Builder$string,
							'operatorID',
							listToStr(options.T.g6)),
						_Utils_ap(
							A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'cardSerial', options.T.kx),
							_Utils_ap(
								A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'userName', options.T.qx),
								_Utils_ap(
									A3(
										$author$project$Services$Api$queryMaybeValue,
										$elm$url$Url$Builder$string,
										'classID',
										listToStr(options.T.lX)),
									_Utils_ap(
										A3(
											$author$project$Services$Api$queryMaybeValue,
											$elm$url$Url$Builder$string,
											'lineCode',
											listToStr(options.T.b3)),
										_Utils_ap(
											A3(
												$author$project$Services$Api$queryMaybeValue,
												$elm$url$Url$Builder$string,
												'vehicleID',
												listToStr(options.T.fN)),
											_Utils_ap(
												A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'document', options.T.iI),
												_Utils_ap(
													A3(
														$author$project$Services$Api$queryMaybeValue,
														$elm$url$Url$Builder$int,
														'page',
														$elm$core$Maybe$Just(options.T.bv - 1)),
													_Utils_ap(
														A3(
															$author$project$Services$Api$queryMaybeValue,
															$elm$url$Url$Builder$int,
															'size',
															$elm$core$Maybe$Just(options.T.pJ)),
														A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'type', options.T.kY))))))))))))));
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$elm$json$Json$Decode$list($author$project$Services$Reports$Divergences$decodeDivergence)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'recognition']),
				queries)
		});
};
var $author$project$Constants$authServiceUrl = $elm$url$Url$Builder$crossOrigin('https://auth.pazze.app');
var $author$project$Services$Auth$Operator = F2(
	function (id, name) {
		return {dM: id, c3: name};
	});
var $author$project$Services$Auth$decodeOperators = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Services$Auth$Operator)));
var $author$project$Services$Auth$getOperators = function (options) {
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$elm$json$Json$Decode$list($author$project$Services$Auth$decodeOperators)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$authServiceUrl,
				_List_fromArray(
					['api', 'v1', 'users', 'operators']),
				_List_Nil)
		});
};
var $author$project$Pages$Reports$Divergences$maybeCmd = F2(
	function (rd, cmd_) {
		return _Utils_eq(rd, $krisajenkins$remotedata$RemoteData$NotAsked) ? cmd_ : $elm$core$Platform$Cmd$none;
	});
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $author$project$Pages$Reports$Divergences$init = F3(
	function (queries, user, oldModel) {
		var newModel = A2(
			$elm$core$Maybe$withDefault,
			{
				dv: $krisajenkins$remotedata$RemoteData$NotAsked,
				dG: {
					bq: '0',
					jl: $elm$core$Maybe$Just('Faixa de similaridade (%)'),
					jn: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col'),
							A2($elm$html$Html$Attributes$style, 'width', 'fit-content')
						]),
					d$: 100,
					e4: 0,
					gW: 1,
					bC: '100'
				},
				dJ: false,
				L: 0,
				dR: false,
				dT: false,
				dU: false,
				dW: false,
				n2: $krisajenkins$remotedata$RemoteData$NotAsked,
				aY: $elm$core$Maybe$Nothing,
				c5: $krisajenkins$remotedata$RemoteData$NotAsked,
				T: queries,
				ck: A2(
					$elm$core$Maybe$withDefault,
					$krisajenkins$remotedata$RemoteData$NotAsked,
					A3(
						$elm$core$Maybe$map2,
						F2(
							function (_v2, _v3) {
								return $krisajenkins$remotedata$RemoteData$Loading;
							}),
						queries.bB,
						queries.bl)),
				en: $krisajenkins$remotedata$RemoteData$NotAsked
			},
			A2(
				$elm$core$Maybe$map,
				function (m) {
					return _Utils_update(
						m,
						{T: queries});
				},
				oldModel));
		return _Utils_Tuple2(
			newModel,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$withDefault,
						A2(
							$elm$core$Task$perform,
							$author$project$Pages$Reports$Divergences$GotTime,
							A3(
								$elm$core$Task$map2,
								F2(
									function (now, timezone) {
										return {e8: now, kS: timezone};
									}),
								$elm$time$Time$now,
								$elm$time$Time$here)),
						A3(
							$elm$core$Maybe$map2,
							F2(
								function (_v0, _v1) {
									return $author$project$Services$Reports$Divergences$getDivergences(
										{ow: $author$project$Pages$Reports$Divergences$GotDivergences, T: queries, kU: user.kU});
								}),
							queries.bB,
							queries.bl)),
						A2(
						$author$project$Pages$Reports$Divergences$maybeCmd,
						newModel.n2,
						$author$project$Services$Line$getLines(
							{ow: $author$project$Pages$Reports$Divergences$GotLines, kU: user.kU})),
						A2(
						$author$project$Pages$Reports$Divergences$maybeCmd,
						newModel.c5,
						$author$project$Services$Auth$getOperators(
							{ow: $author$project$Pages$Reports$Divergences$GotOperators, kU: user.kU})),
						A2(
						$author$project$Pages$Reports$Divergences$maybeCmd,
						newModel.dv,
						$author$project$Services$Classes$getSummaryClasses(
							{ow: $author$project$Pages$Reports$Divergences$GotClasses, kU: user.kU})),
						A2(
						$author$project$Pages$Reports$Divergences$maybeCmd,
						newModel.en,
						$author$project$Services$Reports$DetailedVehicle$getVehicleV2(
							{ow: $author$project$Pages$Reports$Divergences$GotVehiclesV2, kU: user.kU}))
					])));
	});
var $author$project$Pages$Reports$Event$Audit$GotReport = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Reports$Event$Audit$GotTime = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Reports$Event$Audit$GotVehiclesV2 = function (a) {
	return {$: 2, a: a};
};
var $author$project$Services$Reports$Audit$Audit = function (id) {
	return function (createdAt) {
		return function (vehicleCode) {
			return function (line) {
				return function (gateCount) {
					return function (eventError) {
						return function (hasAction) {
							return function (observation) {
								return function (errorType) {
									return function (validatorSerial) {
										return {ix: createdAt, m1: errorType, m3: eventError, eL: gateCount, nE: hasAction, dM: id, e1: line, ca: observation, k0: validatorSerial, em: vehicleCode};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Services$Reports$Audit$auditDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'validatorSerial',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'errorType',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'observation',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'hasAction',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'eventError',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'gateCount',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'line',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'vehicleCode',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'createdAt',
									$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Services$Reports$Audit$Audit)))))))))));
var $author$project$Services$Reports$Audit$getAudit = function (options) {
	var listToStr = function (list) {
		var _v0 = A2($elm$core$String$join, ',', list);
		if (_v0 === '') {
			return $elm$core$Maybe$Nothing;
		} else {
			var str = _v0;
			return $elm$core$Maybe$Just(str);
		}
	};
	var queries = _Utils_ap(
		A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'start', options.T.bB),
		_Utils_ap(
			A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'end', options.T.bl),
			_Utils_ap(
				A3(
					$author$project$Services$Api$queryMaybeValue,
					$elm$url$Url$Builder$string,
					'vehicles',
					listToStr(options.T.en)),
				A3(
					$author$project$Services$Api$queryMaybeValue,
					$elm$url$Url$Builder$string,
					'errorType',
					listToStr(options.T.bX)))));
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$elm$json$Json$Decode$list($author$project$Services$Reports$Audit$auditDecoder)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'report', 'audit']),
				queries)
		});
};
var $author$project$Pages$Reports$Event$Audit$initActionTypes = _List_fromArray(
	[
		{l4: 'software_start', c3: 'Início de Software'},
		{l4: 'system', c3: 'Sistema'},
		{l4: 'reset_by_PN532', c3: 'Reiniciado pelo PN532'},
		{l4: 'gate_spin_unauthorized', c3: 'Giro de Catraca Não Autorizado'},
		{l4: 'reset_by_sam_initialize', c3: 'Reiniciado durante a Inicialização do SAM'},
		{l4: 'reset_by_sam', c3: 'Reiniciado pelo SAM'},
		{l4: 'reset_clock', c3: 'Reinicialização do Relógio'}
	]);
var $author$project$Pages$Reports$Event$Audit$init = F2(
	function (queries, user) {
		return _Utils_Tuple2(
			{
				dl: $author$project$Pages$Reports$Event$Audit$initActionTypes,
				dK: false,
				L: 0,
				dQ: false,
				dW: false,
				T: queries,
				ck: A2(
					$elm$core$Maybe$withDefault,
					$krisajenkins$remotedata$RemoteData$NotAsked,
					A3(
						$elm$core$Maybe$map2,
						F2(
							function (_v0, _v1) {
								return $krisajenkins$remotedata$RemoteData$Loading;
							}),
						queries.bB,
						queries.bl)),
				en: _List_Nil
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$withDefault,
						A2(
							$elm$core$Task$perform,
							$author$project$Pages$Reports$Event$Audit$GotTime,
							A3(
								$elm$core$Task$map2,
								F2(
									function (now, timezone) {
										return {e8: now, kS: timezone};
									}),
								$elm$time$Time$now,
								$elm$time$Time$here)),
						A3(
							$elm$core$Maybe$map2,
							F2(
								function (_v2, _v3) {
									return $author$project$Services$Reports$Audit$getAudit(
										{ow: $author$project$Pages$Reports$Event$Audit$GotReport, T: queries, kU: user.kU});
								}),
							queries.bB,
							queries.bl)),
						$author$project$Services$Reports$DetailedVehicle$getVehicleV2(
						{ow: $author$project$Pages$Reports$Event$Audit$GotVehiclesV2, kU: user.kU})
					])));
	});
var $author$project$Pages$Reports$Event$UsingDay$GotTime = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Reports$Event$UsingDay$GotUsingDay = function (a) {
	return {$: 1, a: a};
};
var $author$project$Services$Reports$UsesPerDay$UsingDayPerEvent = F2(
	function (headers, rows) {
		return {nG: headers, px: rows};
	});
var $author$project$Services$Reports$UsesPerDay$UsingDayPerEventHeader = F3(
	function (id, className, type_) {
		return {ik: className, dM: id, kY: type_};
	});
var $author$project$Services$Reports$UsesPerDay$decodeHeader = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'type',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'className',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Services$Reports$UsesPerDay$UsingDayPerEventHeader))));
var $author$project$Services$Reports$UsesPerDay$UsingDayPerEventRow = F3(
	function (title, classes, fare) {
		return {dv: classes, ni: fare, fD: title};
	});
var $author$project$Services$Reports$UsesPerDay$decodeRow = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'fare',
	$elm$json$Json$Decode$dict($elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'classes',
		$elm$json$Json$Decode$dict($elm$json$Json$Decode$int),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'title',
			$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
			$elm$json$Json$Decode$succeed($author$project$Services$Reports$UsesPerDay$UsingDayPerEventRow))));
var $author$project$Services$Reports$UsesPerDay$decodeUsingDayPerEvent = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'rows',
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$list($author$project$Services$Reports$UsesPerDay$decodeRow),
				$elm$json$Json$Decode$null(_List_Nil)
			])),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'headers',
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					$elm$json$Json$Decode$list($author$project$Services$Reports$UsesPerDay$decodeHeader),
					$elm$json$Json$Decode$null(_List_Nil)
				])),
		$elm$json$Json$Decode$succeed($author$project$Services$Reports$UsesPerDay$UsingDayPerEvent)));
var $author$project$Services$Reports$UsesPerDay$getUsingDayPerEvent = function (options) {
	var queries = _Utils_ap(
		A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'start', options.T.bB),
		A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'end', options.T.bl));
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$author$project$Services$Reports$UsesPerDay$decodeUsingDayPerEvent),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'report', 'using', 'dayV2']),
				queries)
		});
};
var $author$project$Pages$Reports$Event$UsingDay$init = F2(
	function (queries, user) {
		return _Utils_Tuple2(
			{
				T: queries,
				ck: A2(
					$elm$core$Maybe$withDefault,
					$krisajenkins$remotedata$RemoteData$NotAsked,
					A3(
						$elm$core$Maybe$map2,
						F2(
							function (_v0, _v1) {
								return $krisajenkins$remotedata$RemoteData$Loading;
							}),
						queries.bB,
						queries.bl))
			},
			A2(
				$elm$core$Maybe$withDefault,
				A2(
					$elm$core$Task$perform,
					$author$project$Pages$Reports$Event$UsingDay$GotTime,
					A3(
						$elm$core$Task$map2,
						F2(
							function (now, timezone) {
								return {e8: now, kS: timezone};
							}),
						$elm$time$Time$now,
						$elm$time$Time$here)),
				A3(
					$elm$core$Maybe$map2,
					F2(
						function (_v2, _v3) {
							return $author$project$Services$Reports$UsesPerDay$getUsingDayPerEvent(
								{ow: $author$project$Pages$Reports$Event$UsingDay$GotUsingDay, T: queries, kU: user.kU});
						}),
					queries.bB,
					queries.bl)));
	});
var $author$project$Pages$Reports$Event$UsingLine$GotLines = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Reports$Event$UsingLine$GotTime = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Reports$Event$UsingLine$GotUsingLine = function (a) {
	return {$: 1, a: a};
};
var $author$project$Services$Reports$UsesPerLine$UsingLinePerEvent = F2(
	function (headers, rows) {
		return {nG: headers, px: rows};
	});
var $author$project$Services$Reports$UsesPerLine$UsingLinePerEventHeader = F3(
	function (id, className, type_) {
		return {ik: className, dM: id, kY: type_};
	});
var $author$project$Services$Reports$UsesPerLine$decodeHeader = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'type',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'className',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Services$Reports$UsesPerLine$UsingLinePerEventHeader))));
var $author$project$Services$Reports$UsesPerLine$UsingLinePerEventRow = F3(
	function (title, classes, fare) {
		return {dv: classes, ni: fare, fD: title};
	});
var $author$project$Services$Reports$UsesPerLine$decodeRow = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'fare',
	$elm$json$Json$Decode$dict($elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'classes',
		$elm$json$Json$Decode$dict($elm$json$Json$Decode$int),
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'title',
			$elm$json$Json$Decode$string,
			'',
			$elm$json$Json$Decode$succeed($author$project$Services$Reports$UsesPerLine$UsingLinePerEventRow))));
var $author$project$Services$Reports$UsesPerLine$decodeUsingLinePerEvent = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'rows',
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$list($author$project$Services$Reports$UsesPerLine$decodeRow),
				$elm$json$Json$Decode$null(_List_Nil)
			])),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'headers',
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					$elm$json$Json$Decode$list($author$project$Services$Reports$UsesPerLine$decodeHeader),
					$elm$json$Json$Decode$null(_List_Nil)
				])),
		$elm$json$Json$Decode$succeed($author$project$Services$Reports$UsesPerLine$UsingLinePerEvent)));
var $author$project$Services$Reports$UsesPerLine$getUsingLinePerEvent = function (options) {
	var listToStr = function (list) {
		var _v0 = A2($elm$core$String$join, ',', list);
		if (_v0 === '') {
			return $elm$core$Maybe$Nothing;
		} else {
			var str = _v0;
			return $elm$core$Maybe$Just(str);
		}
	};
	var queries = _Utils_ap(
		A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'start', options.T.bB),
		_Utils_ap(
			A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'end', options.T.bl),
			A3(
				$author$project$Services$Api$queryMaybeValue,
				$elm$url$Url$Builder$string,
				'lineCode',
				listToStr(options.T.n2))));
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$author$project$Services$Reports$UsesPerLine$decodeUsingLinePerEvent),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'report', 'using', 'lineV2']),
				queries)
		});
};
var $author$project$Pages$Reports$Event$UsingLine$maybeCmd = F2(
	function (list, cmd_) {
		return $elm$core$List$isEmpty(list) ? cmd_ : $elm$core$Platform$Cmd$none;
	});
var $author$project$Pages$Reports$Event$UsingLine$init = F3(
	function (queries, user, oldModel) {
		var newModel = A2(
			$elm$core$Maybe$withDefault,
			{
				L: 0,
				dT: false,
				n2: _List_Nil,
				T: queries,
				ck: A2(
					$elm$core$Maybe$withDefault,
					$krisajenkins$remotedata$RemoteData$NotAsked,
					A3(
						$elm$core$Maybe$map2,
						F2(
							function (_v2, _v3) {
								return $krisajenkins$remotedata$RemoteData$Loading;
							}),
						queries.bB,
						queries.bl))
			},
			A2(
				$elm$core$Maybe$map,
				function (m) {
					return _Utils_update(
						m,
						{T: queries});
				},
				oldModel));
		return _Utils_Tuple2(
			newModel,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$withDefault,
						A2(
							$elm$core$Task$perform,
							$author$project$Pages$Reports$Event$UsingLine$GotTime,
							A3(
								$elm$core$Task$map2,
								F2(
									function (now, timezone) {
										return {e8: now, kS: timezone};
									}),
								$elm$time$Time$now,
								$elm$time$Time$here)),
						A3(
							$elm$core$Maybe$map2,
							F2(
								function (_v0, _v1) {
									return $author$project$Services$Reports$UsesPerLine$getUsingLinePerEvent(
										{ow: $author$project$Pages$Reports$Event$UsingLine$GotUsingLine, T: queries, kU: user.kU});
								}),
							queries.bB,
							queries.bl)),
						A2(
						$author$project$Pages$Reports$Event$UsingLine$maybeCmd,
						newModel.n2,
						$author$project$Services$Line$getLines(
							{ow: $author$project$Pages$Reports$Event$UsingLine$GotLines, kU: user.kU}))
					])));
	});
var $author$project$Pages$Reports$Event$UsingOperator$GotOperators = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Reports$Event$UsingOperator$GotTime = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Reports$Event$UsingOperator$GotUsingOperator = function (a) {
	return {$: 1, a: a};
};
var $author$project$Services$Reports$UsesPerOperator$UsingOperatorPerEvent = F2(
	function (headers, rows) {
		return {nG: headers, px: rows};
	});
var $author$project$Services$Reports$UsesPerOperator$Header = F3(
	function (id, className, type_) {
		return {ik: className, dM: id, kY: type_};
	});
var $author$project$Services$Reports$UsesPerOperator$decodeHeader = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'type',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'className',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Services$Reports$UsesPerOperator$Header))));
var $author$project$Services$Reports$UsesPerOperator$Row = F3(
	function (title, classes, fare) {
		return {dv: classes, ni: fare, fD: title};
	});
var $author$project$Services$Reports$UsesPerOperator$decodeRow = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'fare',
	$elm$json$Json$Decode$dict($elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'classes',
		$elm$json$Json$Decode$dict($elm$json$Json$Decode$int),
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'title',
			$elm$json$Json$Decode$string,
			'',
			$elm$json$Json$Decode$succeed($author$project$Services$Reports$UsesPerOperator$Row))));
var $author$project$Services$Reports$UsesPerOperator$decodeUsingDayPerEvent = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'rows',
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$list($author$project$Services$Reports$UsesPerOperator$decodeRow),
				$elm$json$Json$Decode$null(_List_Nil)
			])),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'headers',
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					$elm$json$Json$Decode$list($author$project$Services$Reports$UsesPerOperator$decodeHeader),
					$elm$json$Json$Decode$null(_List_Nil)
				])),
		$elm$json$Json$Decode$succeed($author$project$Services$Reports$UsesPerOperator$UsingOperatorPerEvent)));
var $author$project$Services$Reports$UsesPerOperator$getUsingOperatorPerEvent = function (options) {
	var listToStr = function (list) {
		var _v0 = A2($elm$core$String$join, ',', list);
		if (_v0 === '') {
			return $elm$core$Maybe$Nothing;
		} else {
			var str = _v0;
			return $elm$core$Maybe$Just(str);
		}
	};
	var queries = _Utils_ap(
		A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'start', options.T.bB),
		_Utils_ap(
			A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'end', options.T.bl),
			A3(
				$author$project$Services$Api$queryMaybeValue,
				$elm$url$Url$Builder$string,
				'operatorID',
				listToStr(options.T.c5))));
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$author$project$Services$Reports$UsesPerOperator$decodeUsingDayPerEvent),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'report', 'using', 'operator']),
				queries)
		});
};
var $author$project$Pages$Reports$Event$UsingOperator$maybeCmd = F2(
	function (list, cmd_) {
		return $elm$core$List$isEmpty(list) ? cmd_ : $elm$core$Platform$Cmd$none;
	});
var $author$project$Pages$Reports$Event$UsingOperator$init = F3(
	function (queries, user, oldModel) {
		var newModel = A2(
			$elm$core$Maybe$withDefault,
			{
				dU: false,
				c5: _List_Nil,
				T: queries,
				ck: A2(
					$elm$core$Maybe$withDefault,
					$krisajenkins$remotedata$RemoteData$NotAsked,
					A3(
						$elm$core$Maybe$map2,
						F2(
							function (_v2, _v3) {
								return $krisajenkins$remotedata$RemoteData$Loading;
							}),
						queries.bB,
						queries.bl))
			},
			A2(
				$elm$core$Maybe$map,
				function (m) {
					return _Utils_update(
						m,
						{T: queries});
				},
				oldModel));
		return _Utils_Tuple2(
			newModel,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$withDefault,
						A2(
							$elm$core$Task$perform,
							$author$project$Pages$Reports$Event$UsingOperator$GotTime,
							A3(
								$elm$core$Task$map2,
								F2(
									function (now, timezone) {
										return {e8: now, kS: timezone};
									}),
								$elm$time$Time$now,
								$elm$time$Time$here)),
						A3(
							$elm$core$Maybe$map2,
							F2(
								function (_v0, _v1) {
									return $author$project$Services$Reports$UsesPerOperator$getUsingOperatorPerEvent(
										{ow: $author$project$Pages$Reports$Event$UsingOperator$GotUsingOperator, T: queries, kU: user.kU});
								}),
							queries.bB,
							queries.bl)),
						A2(
						$author$project$Pages$Reports$Event$UsingOperator$maybeCmd,
						newModel.c5,
						$author$project$Services$Auth$getOperators(
							{ow: $author$project$Pages$Reports$Event$UsingOperator$GotOperators, kU: user.kU}))
					])));
	});
var $author$project$Pages$Reports$Event$UsingSession$GotLines = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Reports$Event$UsingSession$GotOperators = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Reports$Event$UsingSession$GotTime = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Reports$Event$UsingSession$GotUsingSession = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Reports$Event$UsingSession$GotVehiclesV2 = function (a) {
	return {$: 4, a: a};
};
var $author$project$Services$Reports$UsesPerSession$UsingSessionPerEvent = function (id) {
	return function (vehicleCode) {
		return function (line) {
			return function (openedAt) {
				return function (closedAt) {
					return function (openOperatorName) {
						return function (closeOperatorName) {
							return function (openGateCount) {
								return function (closeGateCount) {
									return function (spinsCounts) {
										return function (totalSpins) {
											return {l0: closeGateCount, l1: closeOperatorName, l2: closedAt, dM: id, e1: line, oB: openGateCount, jK: openOperatorName, jL: openedAt, kJ: spinsCounts, kV: totalSpins, em: vehicleCode};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Services$Reports$UsesPerSession$SpinsCount = F3(
	function (count, classId, className) {
		return {lY: classId, ik: className, iw: count};
	});
var $author$project$Services$Reports$UsesPerSession$decodeSpinsCount = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'className',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'classId',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'count',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$Services$Reports$UsesPerSession$SpinsCount))));
var $author$project$Services$Reports$UsesPerSession$decodeUsingDayPerEvent = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'totalSpins',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'spinsCounts',
		$elm$json$Json$Decode$list($author$project$Services$Reports$UsesPerSession$decodeSpinsCount),
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'closeGateCount',
			$elm$json$Json$Decode$string,
			'',
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'openGateCount',
				$elm$json$Json$Decode$string,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'closeOperatorName',
					$elm$json$Json$Decode$string,
					'',
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'openOperatorName',
						$elm$json$Json$Decode$string,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'closedAt',
							$elm$json$Json$Decode$maybe($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'openedAt',
								$elm$json$Json$Decode$maybe($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'line',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'vehicleCode',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'id',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$Services$Reports$UsesPerSession$UsingSessionPerEvent))))))))))));
var $author$project$Services$Reports$UsesPerSession$getUsingSessionPerEvent = function (options) {
	var listToStr = function (list) {
		var _v0 = A2($elm$core$String$join, ',', list);
		if (_v0 === '') {
			return $elm$core$Maybe$Nothing;
		} else {
			var str = _v0;
			return $elm$core$Maybe$Just(str);
		}
	};
	var queries = _Utils_ap(
		A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'start', options.T.bB),
		_Utils_ap(
			A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'end', options.T.bl),
			_Utils_ap(
				A3(
					$author$project$Services$Api$queryMaybeValue,
					$elm$url$Url$Builder$string,
					'operatorID',
					listToStr(options.T.c5)),
				_Utils_ap(
					A3(
						$author$project$Services$Api$queryMaybeValue,
						$elm$url$Url$Builder$string,
						'vehicleID',
						listToStr(options.T.en)),
					A3(
						$author$project$Services$Api$queryMaybeValue,
						$elm$url$Url$Builder$string,
						'lineCode',
						listToStr(options.T.n2))))));
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$elm$json$Json$Decode$list($author$project$Services$Reports$UsesPerSession$decodeUsingDayPerEvent)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'report', 'cashiers']),
				queries)
		});
};
var $author$project$Pages$Reports$Event$UsingSession$maybeCmd = F2(
	function (list, cmd_) {
		return $elm$core$List$isEmpty(list) ? cmd_ : $elm$core$Platform$Cmd$none;
	});
var $author$project$Pages$Reports$Event$UsingSession$init = F3(
	function (queries, user, oldModel) {
		var newModel = A2(
			$elm$core$Maybe$withDefault,
			{
				bQ: $author$project$Components$PDF$Create$init,
				dJ: false,
				L: 0,
				dT: false,
				dU: false,
				dW: false,
				n2: _List_Nil,
				c5: _List_Nil,
				T: queries,
				ck: A2(
					$elm$core$Maybe$withDefault,
					$krisajenkins$remotedata$RemoteData$NotAsked,
					A3(
						$elm$core$Maybe$map2,
						F2(
							function (_v2, _v3) {
								return $krisajenkins$remotedata$RemoteData$Loading;
							}),
						queries.bB,
						queries.bl)),
				en: _List_Nil
			},
			A2(
				$elm$core$Maybe$map,
				function (m) {
					return _Utils_update(
						m,
						{T: queries});
				},
				oldModel));
		return _Utils_Tuple2(
			newModel,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$withDefault,
						A2(
							$elm$core$Task$perform,
							$author$project$Pages$Reports$Event$UsingSession$GotTime,
							A3(
								$elm$core$Task$map2,
								F2(
									function (now, timezone) {
										return {e8: now, kS: timezone};
									}),
								$elm$time$Time$now,
								$elm$time$Time$here)),
						A3(
							$elm$core$Maybe$map2,
							F2(
								function (_v0, _v1) {
									return $author$project$Services$Reports$UsesPerSession$getUsingSessionPerEvent(
										{ow: $author$project$Pages$Reports$Event$UsingSession$GotUsingSession, T: queries, kU: user.kU});
								}),
							queries.bB,
							queries.bl)),
						A2(
						$author$project$Pages$Reports$Event$UsingSession$maybeCmd,
						newModel.c5,
						$author$project$Services$Auth$getOperators(
							{ow: $author$project$Pages$Reports$Event$UsingSession$GotOperators, kU: user.kU})),
						A2(
						$author$project$Pages$Reports$Event$UsingSession$maybeCmd,
						newModel.n2,
						$author$project$Services$Line$getLines(
							{ow: $author$project$Pages$Reports$Event$UsingSession$GotLines, kU: user.kU})),
						A2(
						$author$project$Pages$Reports$Event$UsingSession$maybeCmd,
						newModel.en,
						$author$project$Services$Reports$DetailedVehicle$getVehicleV2(
							{ow: $author$project$Pages$Reports$Event$UsingSession$GotVehiclesV2, kU: user.kU}))
					])));
	});
var $author$project$Pages$Reports$Event$UsingVehicle$GotTime = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Reports$Event$UsingVehicle$GotUsingVehicle = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Reports$Event$UsingVehicle$GotVehiclesV2 = function (a) {
	return {$: 2, a: a};
};
var $author$project$Services$Reports$UsesPerVehicle$UsingVehiclePerEvent = F2(
	function (headers, rows) {
		return {nG: headers, px: rows};
	});
var $author$project$Services$Reports$UsesPerVehicle$UsingVehiclePerEventHeader = F3(
	function (id, className, type_) {
		return {ik: className, dM: id, kY: type_};
	});
var $author$project$Services$Reports$UsesPerVehicle$decodeHeader = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'type',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'className',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Services$Reports$UsesPerVehicle$UsingVehiclePerEventHeader))));
var $author$project$Services$Reports$UsesPerVehicle$UsingVehiclePerEventRow = F3(
	function (title, classes, fare) {
		return {dv: classes, ni: fare, fD: title};
	});
var $author$project$Services$Reports$UsesPerVehicle$decodeRow = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'fare',
	$elm$json$Json$Decode$dict($elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'classes',
		$elm$json$Json$Decode$dict($elm$json$Json$Decode$int),
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'title',
			$elm$json$Json$Decode$string,
			'',
			$elm$json$Json$Decode$succeed($author$project$Services$Reports$UsesPerVehicle$UsingVehiclePerEventRow))));
var $author$project$Services$Reports$UsesPerVehicle$decodeUsingVehiclePerEvent = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'rows',
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$list($author$project$Services$Reports$UsesPerVehicle$decodeRow),
				$elm$json$Json$Decode$null(_List_Nil)
			])),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'headers',
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					$elm$json$Json$Decode$list($author$project$Services$Reports$UsesPerVehicle$decodeHeader),
					$elm$json$Json$Decode$null(_List_Nil)
				])),
		$elm$json$Json$Decode$succeed($author$project$Services$Reports$UsesPerVehicle$UsingVehiclePerEvent)));
var $author$project$Services$Reports$UsesPerVehicle$getUsingVehiclePerEvent = function (options) {
	var listToStr = function (list) {
		var _v0 = A2($elm$core$String$join, ',', list);
		if (_v0 === '') {
			return $elm$core$Maybe$Nothing;
		} else {
			var str = _v0;
			return $elm$core$Maybe$Just(str);
		}
	};
	var queries = _Utils_ap(
		A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'start', options.T.bB),
		_Utils_ap(
			A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'end', options.T.bl),
			A3(
				$author$project$Services$Api$queryMaybeValue,
				$elm$url$Url$Builder$string,
				'vehicleID',
				listToStr(options.T.en))));
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$author$project$Services$Reports$UsesPerVehicle$decodeUsingVehiclePerEvent),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'report', 'using', 'vehicleV2']),
				queries)
		});
};
var $author$project$Pages$Reports$Event$UsingVehicle$maybeCmd = F2(
	function (list, cmd_) {
		return $elm$core$List$isEmpty(list) ? cmd_ : $elm$core$Platform$Cmd$none;
	});
var $author$project$Pages$Reports$Event$UsingVehicle$init = F3(
	function (queries, user, oldModel) {
		var newModel = A2(
			$elm$core$Maybe$withDefault,
			{
				L: 0,
				dW: false,
				T: queries,
				ck: A2(
					$elm$core$Maybe$withDefault,
					$krisajenkins$remotedata$RemoteData$NotAsked,
					A3(
						$elm$core$Maybe$map2,
						F2(
							function (_v2, _v3) {
								return $krisajenkins$remotedata$RemoteData$Loading;
							}),
						queries.bB,
						queries.bl)),
				en: _List_Nil
			},
			A2(
				$elm$core$Maybe$map,
				function (m) {
					return _Utils_update(
						m,
						{T: queries});
				},
				oldModel));
		return _Utils_Tuple2(
			newModel,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$withDefault,
						A2(
							$elm$core$Task$perform,
							$author$project$Pages$Reports$Event$UsingVehicle$GotTime,
							A3(
								$elm$core$Task$map2,
								F2(
									function (now, timezone) {
										return {e8: now, kS: timezone};
									}),
								$elm$time$Time$now,
								$elm$time$Time$here)),
						A3(
							$elm$core$Maybe$map2,
							F2(
								function (_v0, _v1) {
									return $author$project$Services$Reports$UsesPerVehicle$getUsingVehiclePerEvent(
										{ow: $author$project$Pages$Reports$Event$UsingVehicle$GotUsingVehicle, T: queries, kU: user.kU});
								}),
							queries.bB,
							queries.bl)),
						A2(
						$author$project$Pages$Reports$Event$UsingVehicle$maybeCmd,
						newModel.en,
						$author$project$Services$Reports$DetailedVehicle$getVehicleV2(
							{ow: $author$project$Pages$Reports$Event$UsingVehicle$GotVehiclesV2, kU: user.kU}))
					])));
	});
var $author$project$Pages$Reports$PDFs$GotPDFs = function (a) {
	return {$: 0, a: a};
};
var $author$project$Services$Pdf$PDF = function (id) {
	return function (exportedAt) {
		return function (reportType) {
			return function (exportType) {
				return function (userName) {
					return function (file) {
						return function (error) {
							return function (sequence) {
								return function (status) {
									return function (downloadType) {
										return function (fileName) {
											return {mR: downloadType, m$: error, Y: exportType, nf: exportedAt, iS: file, nk: fileName, dM: id, hp: reportType, pC: sequence, kK: status, qx: userName};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Services$Pdf$decodePdf = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'fileName',
	$elm$json$Json$Decode$string,
	'',
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'downloadType',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'status',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'sequence',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'error',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'file',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
							_List_fromArray(
								['user', 'name']),
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'exportType',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'reportType',
									$elm$json$Json$Decode$string,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'exportedAt',
										$elm$json$Json$Decode$maybe($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
										$elm$core$Maybe$Nothing,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'id',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$Services$Pdf$PDF))))))))))));
var $author$project$Services$Pdf$getPDFs = function (options) {
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$elm$json$Json$Decode$list($author$project$Services$Pdf$decodePdf)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'exportFile', 'getAll']),
				_List_Nil)
		});
};
var $author$project$Pages$Reports$PDFs$init = function (user) {
	return _Utils_Tuple2(
		{L: 0, ck: $krisajenkins$remotedata$RemoteData$Loading},
		$author$project$Services$Pdf$getPDFs(
			{ow: $author$project$Pages$Reports$PDFs$GotPDFs, kU: user.kU}));
};
var $justinmimbs$time_extra$Time$Extra$Day = 11;
var $author$project$Pages$Reports$SalesSummarized$GotReport = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Reports$SalesSummarized$GotTime = function (a) {
	return {$: 1, a: a};
};
var $justinmimbs$date$Date$Days = 3;
var $justinmimbs$time_extra$Time$Extra$Millisecond = 15;
var $justinmimbs$time_extra$Time$Extra$Month = 2;
var $justinmimbs$date$Date$Months = 1;
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $justinmimbs$date$Date$monthToNumber = function (m) {
	switch (m) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $justinmimbs$date$Date$numberToMonth = function (mn) {
	var _v0 = A2($elm$core$Basics$max, 1, mn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		case 7:
			return 6;
		case 8:
			return 7;
		case 9:
			return 8;
		case 10:
			return 9;
		case 11:
			return 10;
		default:
			return 11;
	}
};
var $justinmimbs$date$Date$toCalendarDateHelp = F3(
	function (y, m, d) {
		toCalendarDateHelp:
		while (true) {
			var monthDays = A2($justinmimbs$date$Date$daysInMonth, y, m);
			var mn = $justinmimbs$date$Date$monthToNumber(m);
			if ((mn < 12) && (_Utils_cmp(d, monthDays) > 0)) {
				var $temp$y = y,
					$temp$m = $justinmimbs$date$Date$numberToMonth(mn + 1),
					$temp$d = d - monthDays;
				y = $temp$y;
				m = $temp$m;
				d = $temp$d;
				continue toCalendarDateHelp;
			} else {
				return {dC: d, b8: m, cF: y};
			}
		}
	});
var $justinmimbs$date$Date$divWithRemainder = F2(
	function (a, b) {
		return _Utils_Tuple2(
			A2($justinmimbs$date$Date$floorDiv, a, b),
			A2($elm$core$Basics$modBy, b, a));
	});
var $justinmimbs$date$Date$year = function (_v0) {
	var rd = _v0;
	var _v1 = A2($justinmimbs$date$Date$divWithRemainder, rd, 146097);
	var n400 = _v1.a;
	var r400 = _v1.b;
	var _v2 = A2($justinmimbs$date$Date$divWithRemainder, r400, 36524);
	var n100 = _v2.a;
	var r100 = _v2.b;
	var _v3 = A2($justinmimbs$date$Date$divWithRemainder, r100, 1461);
	var n4 = _v3.a;
	var r4 = _v3.b;
	var _v4 = A2($justinmimbs$date$Date$divWithRemainder, r4, 365);
	var n1 = _v4.a;
	var r1 = _v4.b;
	var n = (!r1) ? 0 : 1;
	return ((((n400 * 400) + (n100 * 100)) + (n4 * 4)) + n1) + n;
};
var $justinmimbs$date$Date$toOrdinalDate = function (_v0) {
	var rd = _v0;
	var y = $justinmimbs$date$Date$year(rd);
	return {
		ha: rd - $justinmimbs$date$Date$daysBeforeYear(y),
		cF: y
	};
};
var $justinmimbs$date$Date$toCalendarDate = function (_v0) {
	var rd = _v0;
	var date = $justinmimbs$date$Date$toOrdinalDate(rd);
	return A3($justinmimbs$date$Date$toCalendarDateHelp, date.cF, 0, date.ha);
};
var $justinmimbs$date$Date$add = F3(
	function (unit, n, _v0) {
		var rd = _v0;
		switch (unit) {
			case 0:
				return A3($justinmimbs$date$Date$add, 1, 12 * n, rd);
			case 1:
				var date = $justinmimbs$date$Date$toCalendarDate(rd);
				var wholeMonths = ((12 * (date.cF - 1)) + ($justinmimbs$date$Date$monthToNumber(date.b8) - 1)) + n;
				var m = $justinmimbs$date$Date$numberToMonth(
					A2($elm$core$Basics$modBy, 12, wholeMonths) + 1);
				var y = A2($justinmimbs$date$Date$floorDiv, wholeMonths, 12) + 1;
				return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A2(
					$elm$core$Basics$min,
					date.dC,
					A2($justinmimbs$date$Date$daysInMonth, y, m));
			case 2:
				return rd + (7 * n);
			default:
				return rd + n;
		}
	});
var $justinmimbs$date$Date$toRataDie = function (_v0) {
	var rd = _v0;
	return rd;
};
var $justinmimbs$time_extra$Time$Extra$dateToMillis = function (date) {
	var daysSinceEpoch = $justinmimbs$date$Date$toRataDie(date) - 719163;
	return daysSinceEpoch * 86400000;
};
var $justinmimbs$time_extra$Time$Extra$timeFromClock = F4(
	function (hour, minute, second, millisecond) {
		return (((hour * 3600000) + (minute * 60000)) + (second * 1000)) + millisecond;
	});
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $elm$time$Time$toMillis = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			1000,
			$elm$time$Time$posixToMillis(time));
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $elm$time$Time$toSecond = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				1000));
	});
var $justinmimbs$time_extra$Time$Extra$timeFromPosix = F2(
	function (zone, posix) {
		return A4(
			$justinmimbs$time_extra$Time$Extra$timeFromClock,
			A2($elm$time$Time$toHour, zone, posix),
			A2($elm$time$Time$toMinute, zone, posix),
			A2($elm$time$Time$toSecond, zone, posix),
			A2($elm$time$Time$toMillis, zone, posix));
	});
var $justinmimbs$time_extra$Time$Extra$toOffset = F2(
	function (zone, posix) {
		var millis = $elm$time$Time$posixToMillis(posix);
		var localMillis = $justinmimbs$time_extra$Time$Extra$dateToMillis(
			A2($justinmimbs$date$Date$fromPosix, zone, posix)) + A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix);
		return ((localMillis - millis) / 60000) | 0;
	});
var $justinmimbs$time_extra$Time$Extra$posixFromDateTime = F3(
	function (zone, date, time) {
		var millis = $justinmimbs$time_extra$Time$Extra$dateToMillis(date) + time;
		var offset0 = A2(
			$justinmimbs$time_extra$Time$Extra$toOffset,
			zone,
			$elm$time$Time$millisToPosix(millis));
		var posix1 = $elm$time$Time$millisToPosix(millis - (offset0 * 60000));
		var offset1 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix1);
		if (_Utils_eq(offset0, offset1)) {
			return posix1;
		} else {
			var posix2 = $elm$time$Time$millisToPosix(millis - (offset1 * 60000));
			var offset2 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix2);
			return _Utils_eq(offset1, offset2) ? posix2 : posix1;
		}
	});
var $justinmimbs$time_extra$Time$Extra$add = F4(
	function (interval, n, zone, posix) {
		add:
		while (true) {
			switch (interval) {
				case 15:
					return $elm$time$Time$millisToPosix(
						$elm$time$Time$posixToMillis(posix) + n);
				case 14:
					var $temp$interval = 15,
						$temp$n = n * 1000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 13:
					var $temp$interval = 15,
						$temp$n = n * 60000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 12:
					var $temp$interval = 15,
						$temp$n = n * 3600000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 11:
					return A3(
						$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
						zone,
						A3(
							$justinmimbs$date$Date$add,
							3,
							n,
							A2($justinmimbs$date$Date$fromPosix, zone, posix)),
						A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix));
				case 2:
					return A3(
						$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
						zone,
						A3(
							$justinmimbs$date$Date$add,
							1,
							n,
							A2($justinmimbs$date$Date$fromPosix, zone, posix)),
						A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix));
				case 0:
					var $temp$interval = 2,
						$temp$n = n * 12,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 1:
					var $temp$interval = 2,
						$temp$n = n * 3,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 3:
					var $temp$interval = 11,
						$temp$n = n * 7,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				default:
					var weekday = interval;
					var $temp$interval = 11,
						$temp$n = n * 7,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
			}
		}
	});
var $elm$core$Maybe$map3 = F4(
	function (func, ma, mb, mc) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				if (mc.$ === 1) {
					return $elm$core$Maybe$Nothing;
				} else {
					var c = mc.a;
					return $elm$core$Maybe$Just(
						A3(func, a, b, c));
				}
			}
		}
	});
var $author$project$Utils$monthFromInt = function (month) {
	switch (month) {
		case 1:
			return $elm$core$Maybe$Just(0);
		case 2:
			return $elm$core$Maybe$Just(1);
		case 3:
			return $elm$core$Maybe$Just(2);
		case 4:
			return $elm$core$Maybe$Just(3);
		case 5:
			return $elm$core$Maybe$Just(4);
		case 6:
			return $elm$core$Maybe$Just(5);
		case 7:
			return $elm$core$Maybe$Just(6);
		case 8:
			return $elm$core$Maybe$Just(7);
		case 9:
			return $elm$core$Maybe$Just(8);
		case 10:
			return $elm$core$Maybe$Just(9);
		case 11:
			return $elm$core$Maybe$Just(10);
		case 12:
			return $elm$core$Maybe$Just(11);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $justinmimbs$time_extra$Time$Extra$partsToPosix = F2(
	function (zone, _v0) {
		var year = _v0.cF;
		var month = _v0.b8;
		var day = _v0.dC;
		var hour = _v0.eO;
		var minute = _v0.e5;
		var second = _v0.ft;
		var millisecond = _v0.e3;
		return A3(
			$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
			zone,
			A3($justinmimbs$date$Date$fromCalendarDate, year, month, day),
			A4(
				$justinmimbs$time_extra$Time$Extra$timeFromClock,
				A3($elm$core$Basics$clamp, 0, 23, hour),
				A3($elm$core$Basics$clamp, 0, 59, minute),
				A3($elm$core$Basics$clamp, 0, 59, second),
				A3($elm$core$Basics$clamp, 0, 999, millisecond)));
	});
var $author$project$Utils$dateHTMLToPosixWithZone = F2(
	function (timezone, str) {
		var _v0 = A2($elm$core$String$split, '-', str);
		if (((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.b.b)) {
			var y = _v0.a;
			var _v1 = _v0.b;
			var m = _v1.a;
			var _v2 = _v1.b;
			var d = _v2.a;
			return A4(
				$elm$core$Maybe$map3,
				F3(
					function (y_, m_, d_) {
						return A2(
							$justinmimbs$time_extra$Time$Extra$partsToPosix,
							timezone,
							{dC: d_, eO: 0, e3: 0, e5: 0, b8: m_, ft: 0, cF: y_});
					}),
				$elm$core$String$toInt(y),
				A2(
					$elm$core$Maybe$andThen,
					$author$project$Utils$monthFromInt,
					$elm$core$String$toInt(m)),
				$elm$core$String$toInt(d));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Services$Reports$SalesSummarized$SaleSummarized = F2(
	function (paymentType, typeTotal) {
		return {cd: paymentType, fI: typeTotal};
	});
var $author$project$Services$Reason$actionFromCode = function (action) {
	switch (action) {
		case 'unblock':
			return $elm$core$Maybe$Just(0);
		case 'block':
			return $elm$core$Maybe$Just(1);
		case 'second_way':
			return $elm$core$Maybe$Just(2);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Services$Reason$actionToBRL = function (action) {
	switch (action) {
		case 0:
			return 'Desbloqueio';
		case 1:
			return 'Bloqueio';
		default:
			return 'Segunda via';
	}
};
var $author$project$Services$Concessionaire$decoderPaymentMethodToStr = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'cash':
				return $elm$json$Json$Decode$succeed('Dinheiro');
			case 'credit_card':
				return $elm$json$Json$Decode$succeed('Cartão de Crédito');
			case 'debit_card':
				return $elm$json$Json$Decode$succeed('Cartão de Débito');
			case 'pix':
				return $elm$json$Json$Decode$succeed('Pix');
			case 'guia_local':
				return $elm$json$Json$Decode$succeed('Guia de Pagamento');
			case 'boleto':
				return $elm$json$Json$Decode$succeed('Boleto');
			case 'guiche_reversal':
				return $elm$json$Json$Decode$succeed('Estorno');
			case 'ticket_window_cash':
				return $elm$json$Json$Decode$succeed('Dinheiro no guichê');
			case 'ticket_window_credit_card':
				return $elm$json$Json$Decode$succeed('Cartão de Crédito no guichê');
			case 'ticket_window_debit_card':
				return $elm$json$Json$Decode$succeed('Cartão de Débito no guichê');
			case 'estorno':
				return $elm$json$Json$Decode$succeed('Estorno');
			case '':
				return $elm$json$Json$Decode$succeed('-');
			default:
				var otherStr = str;
				return A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Decode$fail('Payment method not mapped in decoder'),
					A2(
						$elm$core$Maybe$map,
						A2($elm$core$Basics$composeR, $author$project$Services$Reason$actionToBRL, $elm$json$Json$Decode$succeed),
						$author$project$Services$Reason$actionFromCode(otherStr)));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Services$Reports$SalesSummarized$decodeSaleSummarized = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'totalValue',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'paymentType',
		$author$project$Services$Concessionaire$decoderPaymentMethodToStr,
		$elm$json$Json$Decode$succeed($author$project$Services$Reports$SalesSummarized$SaleSummarized)));
var $author$project$Services$Reports$SalesSummarized$encodeResumedCashier = function (queries) {
	var encode = F2(
		function (k, v) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (v_) {
						return $elm$core$List$singleton(
							_Utils_Tuple2(
								k,
								$elm$json$Json$Encode$string(v_)));
					},
					v));
		});
	return $elm$json$Json$Encode$object(
		_Utils_ap(
			A2(encode, 'end', queries.bl),
			A2(encode, 'start', queries.bB)));
};
var $author$project$Services$Reports$SalesSummarized$getResumedCashier = function (options) {
	var queries = _Utils_ap(
		A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'start', options.T.bB),
		A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'end', options.T.bl));
	return $author$project$Services$Api$postHttp(
		{
			lG: $elm$http$Http$jsonBody(
				$author$project$Services$Reports$SalesSummarized$encodeResumedCashier(options.T)),
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							$elm$json$Json$Decode$list($author$project$Services$Reports$SalesSummarized$decodeSaleSummarized),
							$elm$json$Json$Decode$null(_List_Nil)
						]))),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'events', 'resumedCashier']),
				queries)
		});
};
var $author$project$Pages$Reports$SalesSummarized$init = F2(
	function (user, queries) {
		var startPosix = A2(
			$elm$core$Maybe$andThen,
			$author$project$Utils$dateHTMLToPosixWithZone($elm$time$Time$utc),
			queries.bB);
		var deadlineForSearching = A2(
			$elm$core$Maybe$map,
			function (current) {
				return A4($justinmimbs$time_extra$Time$Extra$add, 11, 30, $elm$time$Time$utc, current);
			},
			startPosix);
		return _Utils_Tuple2(
			{
				bQ: $author$project$Components$PDF$Create$init,
				eE: deadlineForSearching,
				L: 0,
				T: queries,
				ck: A2(
					$elm$core$Maybe$withDefault,
					$krisajenkins$remotedata$RemoteData$NotAsked,
					A3(
						$elm$core$Maybe$map2,
						F2(
							function (_v0, _v1) {
								return $krisajenkins$remotedata$RemoteData$Loading;
							}),
						queries.bB,
						queries.bl))
			},
			A2(
				$elm$core$Maybe$withDefault,
				A2(
					$elm$core$Task$perform,
					$author$project$Pages$Reports$SalesSummarized$GotTime,
					A3(
						$elm$core$Task$map2,
						F2(
							function (now, timezone) {
								return {e8: now, kS: timezone};
							}),
						$elm$time$Time$now,
						$elm$time$Time$here)),
				A3(
					$elm$core$Maybe$map2,
					F2(
						function (_v2, _v3) {
							return $author$project$Services$Reports$SalesSummarized$getResumedCashier(
								{ow: $author$project$Pages$Reports$SalesSummarized$GotReport, T: queries, kU: user.kU});
						}),
					queries.bB,
					queries.bl)));
	});
var $author$project$Pages$Reports$SalesSummarizedV2$GotReport = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Reports$SalesSummarizedV2$GotTime = function (a) {
	return {$: 1, a: a};
};
var $author$project$Services$Reports$SalesSummarizedV2$SalesByOrigin = F4(
	function (origins, totalByOrigin, grandTotal, totalTransactions) {
		return {nz: grandTotal, hb: origins, fF: totalByOrigin, qh: totalTransactions};
	});
var $author$project$Services$Reports$SalesSummarizedV2$OriginSummary = F6(
	function (origin, transactions, paymentTypes, subtotal, percentage, methods) {
		return {og: methods, a$: origin, oS: paymentTypes, ce: percentage, kO: subtotal, a9: transactions};
	});
var $author$project$Services$Reports$SalesSummarizedV2$MethodSummary = F4(
	function (method, transactions, percentage, value) {
		return {of: method, ce: percentage, a9: transactions, di: value};
	});
var $author$project$Services$Reports$SalesSummarizedV2$decodeMethodSummary = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'value',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'percentage',
		$elm$json$Json$Decode$float,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'transactions',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'method',
				$elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[$author$project$Services$Concessionaire$decoderPaymentMethodToStr, $elm$json$Json$Decode$string])),
				$elm$json$Json$Decode$succeed($author$project$Services$Reports$SalesSummarizedV2$MethodSummary)))));
var $elm$core$String$toLower = _String_toLower;
var $author$project$Services$Concessionaire$originCodeToStr = function (code) {
	var _v0 = $elm$core$String$toLower(code);
	switch (_v0) {
		case 'app':
			return 'Aplicativo';
		case 'application':
			return 'Aplicativo';
		case 'aplicativo':
			return 'Aplicativo';
		case 'company':
			return 'Empresa';
		case 'business':
			return 'Empresa';
		case 'empresa':
			return 'Empresa';
		case 'ticket_window':
			return 'Guichê';
		case 'guiche':
			return 'Guichê';
		case 'guichê':
			return 'Guichê';
		case 'whatsapp':
			return 'WhatsApp';
		case '':
			return '-';
		default:
			return code;
	}
};
var $author$project$Services$Reports$SalesSummarizedV2$decodeOriginSummary = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'methods',
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$list($author$project$Services$Reports$SalesSummarizedV2$decodeMethodSummary),
				$elm$json$Json$Decode$null(_List_Nil)
			])),
	_List_Nil,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'percentage',
		$elm$json$Json$Decode$float,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'subtotal',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'paymentTypes',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'transactions',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'origin',
						A2($elm$json$Json$Decode$map, $author$project$Services$Concessionaire$originCodeToStr, $elm$json$Json$Decode$string),
						$elm$json$Json$Decode$succeed($author$project$Services$Reports$SalesSummarizedV2$OriginSummary)))))));
var $author$project$Services$Reports$SalesSummarizedV2$OriginTotal = F4(
	function (origin, total, percentage, transactions) {
		return {a$: origin, ce: percentage, qc: total, a9: transactions};
	});
var $author$project$Services$Reports$SalesSummarizedV2$decodeOriginTotal = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'transactions',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'percentage',
		$elm$json$Json$Decode$float,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'total',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'origin',
				A2($elm$json$Json$Decode$map, $author$project$Services$Concessionaire$originCodeToStr, $elm$json$Json$Decode$string),
				$elm$json$Json$Decode$succeed($author$project$Services$Reports$SalesSummarizedV2$OriginTotal)))));
var $author$project$Services$Reports$SalesSummarizedV2$decodeSalesByOrigin = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'totalTransactions',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'grandTotal',
		$elm$json$Json$Decode$int,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'totalByOrigin',
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						$elm$json$Json$Decode$list($author$project$Services$Reports$SalesSummarizedV2$decodeOriginTotal),
						$elm$json$Json$Decode$null(_List_Nil)
					])),
			_List_Nil,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'origins',
				$elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							$elm$json$Json$Decode$list($author$project$Services$Reports$SalesSummarizedV2$decodeOriginSummary),
							$elm$json$Json$Decode$null(_List_Nil)
						])),
				_List_Nil,
				$elm$json$Json$Decode$succeed($author$project$Services$Reports$SalesSummarizedV2$SalesByOrigin)))));
var $author$project$Services$Reports$SalesSummarizedV2$encodeQueries = function (queries) {
	var encode = F2(
		function (k, v) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (v_) {
						return $elm$core$List$singleton(
							_Utils_Tuple2(
								k,
								$elm$json$Json$Encode$string(v_)));
					},
					v));
		});
	return $elm$json$Json$Encode$object(
		_Utils_ap(
			A2(encode, 'start', queries.bB),
			A2(encode, 'end', queries.bl)));
};
var $author$project$Services$Reports$SalesSummarizedV2$getSalesByOrigin = function (options) {
	return $author$project$Services$Api$postHttp(
		{
			lG: $elm$http$Http$jsonBody(
				$author$project$Services$Reports$SalesSummarizedV2$encodeQueries(options.T)),
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$author$project$Services$Reports$SalesSummarizedV2$decodeSalesByOrigin),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'events', 'cashier', 'payments']),
				_List_Nil)
		});
};
var $author$project$Pages$Reports$SalesSummarizedV2$init = F2(
	function (user, queries) {
		return _Utils_Tuple2(
			{
				bP: _List_Nil,
				bQ: $author$project$Components$PDF$Create$init,
				L: 0,
				T: queries,
				ck: A2(
					$elm$core$Maybe$withDefault,
					$krisajenkins$remotedata$RemoteData$NotAsked,
					A3(
						$elm$core$Maybe$map2,
						F2(
							function (_v0, _v1) {
								return $krisajenkins$remotedata$RemoteData$Loading;
							}),
						queries.bB,
						queries.bl)),
				ef: $elm$core$Maybe$Nothing
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Platform$Cmd$none,
						A3(
							$elm$core$Maybe$map2,
							F2(
								function (_v2, _v3) {
									return $author$project$Services$Reports$SalesSummarizedV2$getSalesByOrigin(
										{ow: $author$project$Pages$Reports$SalesSummarizedV2$GotReport, T: queries, kU: user.kU});
								}),
							queries.bB,
							queries.bl)),
						A2(
						$elm$core$Task$perform,
						$author$project$Pages$Reports$SalesSummarizedV2$GotTime,
						A3(
							$elm$core$Task$map2,
							F2(
								function (now, timezone) {
									return {e8: now, kS: timezone};
								}),
							$elm$time$Time$now,
							$elm$time$Time$here))
					])));
	});
var $author$project$Pages$Reports$Usage$GotClasses = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Reports$Usage$GotLines = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Reports$Usage$GotOperators = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Reports$Usage$GotTime = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Reports$Usage$GotUsage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Reports$Usage$GotVehiclesV2 = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Reports$Usage$Loading = 1;
var $author$project$Services$Reports$Usage$Usage = function (userName) {
	return function (cardSerial) {
		return function (eventDate) {
			return function (lineName) {
				return function (line) {
					return function (vehicleCode) {
						return function (gateCount) {
							return function (operatorName) {
								return function (className) {
									return function (walletClassTypeName) {
										return function (value) {
											return function (eventTypeDescription) {
												return function (classID) {
													return function (temporalIntegration) {
														return function (type_) {
															return function (sequenceTransaction) {
																return function (companionUse) {
																	return {lO: cardSerial, lX: classID, ik: className, l7: companionUse, m2: eventDate, m7: eventTypeDescription, eL: gateCount, e1: line, n1: lineName, fa: operatorName, fu: sequenceTransaction, p1: temporalIntegration, kY: type_, qx: userName, di: value, em: vehicleCode, k9: walletClassTypeName};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Services$Reports$Usage$decodeUsage = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'companionUse',
	$elm$json$Json$Decode$bool,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'sequenceTransaction',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'type',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'temporalIntegration',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'classID',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'eventTypeDescription',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'value',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'walletClassTypeName',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'className',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'operatorName',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'gateCount',
											$elm$json$Json$Decode$int,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'vehicleCode',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'line',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'lineName',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'eventDate',
															$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'cardSerial',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'userName',
																	$elm$json$Json$Decode$string,
																	$elm$json$Json$Decode$succeed($author$project$Services$Reports$Usage$Usage))))))))))))))))));
var $author$project$Services$Reports$Usage$filterAfter0x = function (input) {
	var _v0 = A2($elm$core$String$split, '0x', input);
	_v0$2:
	while (true) {
		if (_v0.b) {
			if (!_v0.b.b) {
				return input;
			} else {
				if (!_v0.b.b.b) {
					var _v1 = _v0.b;
					var after0x = _v1.a;
					return after0x;
				} else {
					break _v0$2;
				}
			}
		} else {
			break _v0$2;
		}
	}
	var _v2 = $elm$core$List$reverse(
		A2($elm$core$String$split, '0x', input));
	if (_v2.b) {
		var after0x = _v2.a;
		return after0x;
	} else {
		return input;
	}
};
var $author$project$Services$Reports$Usage$getUsage = function (options) {
	var queries = _Utils_ap(
		A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'start', options.T.bB),
		_Utils_ap(
			A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'end', options.T.bl),
			_Utils_ap(
				A3(
					$author$project$Services$Api$queryMaybeValue,
					$elm$url$Url$Builder$int,
					'page',
					$elm$core$Maybe$Just(options.T.bv)),
				_Utils_ap(
					A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'lineCode', options.T.b3),
					_Utils_ap(
						A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'classID', options.T.lX),
						_Utils_ap(
							A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'operatorID', options.T.g6),
							_Utils_ap(
								A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'vehicleID', options.T.fN),
								A3(
									$author$project$Services$Api$queryMaybeValue,
									$elm$url$Url$Builder$string,
									'serialCard',
									A2($elm$core$Maybe$map, $author$project$Services$Reports$Usage$filterAfter0x, options.T.kx)))))))));
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$elm$json$Json$Decode$list($author$project$Services$Reports$Usage$decodeUsage)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'report', 'usage']),
				queries)
		});
};
var $author$project$Services$Reports$Usage$getUsageDetailing = function (options) {
	var queries = A3(
		$author$project$Services$Api$queryMaybeValue,
		$elm$url$Url$Builder$int,
		'page',
		$elm$core$Maybe$Just(options.T.bv));
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$elm$json$Json$Decode$list($author$project$Services$Reports$Usage$decodeUsage)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'report', 'cashierUsage', options.fH]),
				queries)
		});
};
var $author$project$Pages$Reports$Usage$maybeCmd = F2(
	function (rd, cmd_) {
		return _Utils_eq(rd, $krisajenkins$remotedata$RemoteData$NotAsked) ? cmd_ : $elm$core$Platform$Cmd$none;
	});
var $author$project$Pages$Reports$Usage$init = F3(
	function (queries, user, oldModel) {
		var startPosix = A2(
			$elm$core$Maybe$andThen,
			$author$project$Utils$dateHTMLToPosixWithZone($elm$time$Time$utc),
			queries.bB);
		var deadlineForSearching = A2(
			$elm$core$Maybe$map,
			function (current) {
				return A4($justinmimbs$time_extra$Time$Extra$add, 11, 6, $elm$time$Time$utc, current);
			},
			startPosix);
		var newModel = A2(
			$elm$core$Maybe$withDefault,
			{
				dv: $krisajenkins$remotedata$RemoteData$NotAsked,
				bQ: $author$project$Components$PDF$Create$init,
				eE: deadlineForSearching,
				dJ: false,
				L: 0,
				n2: $krisajenkins$remotedata$RemoteData$NotAsked,
				b5: 1,
				c5: $krisajenkins$remotedata$RemoteData$NotAsked,
				T: queries,
				ck: A2(
					$elm$core$Maybe$withDefault,
					$krisajenkins$remotedata$RemoteData$NotAsked,
					A3(
						$elm$core$Maybe$map2,
						F2(
							function (_v2, _v3) {
								return $krisajenkins$remotedata$RemoteData$Loading;
							}),
						queries.bB,
						queries.bl)),
				en: $krisajenkins$remotedata$RemoteData$NotAsked
			},
			A2(
				$elm$core$Maybe$map,
				function (m) {
					return _Utils_update(
						m,
						{eE: deadlineForSearching, T: queries});
				},
				oldModel));
		return _Utils_Tuple2(
			newModel,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						function () {
						var _v0 = _Utils_Tuple3(queries.bB, queries.bl, queries.ic);
						if (!_v0.c.$) {
							var transactionID = _v0.c.a;
							return $author$project$Services$Reports$Usage$getUsageDetailing(
								{ow: $author$project$Pages$Reports$Usage$GotUsage, T: queries, kU: user.kU, fH: transactionID});
						} else {
							if ((!_v0.a.$) && (!_v0.b.$)) {
								var _v1 = _v0.c;
								return $author$project$Services$Reports$Usage$getUsage(
									{ow: $author$project$Pages$Reports$Usage$GotUsage, T: queries, kU: user.kU});
							} else {
								return A2(
									$elm$core$Task$perform,
									$author$project$Pages$Reports$Usage$GotTime,
									A3(
										$elm$core$Task$map2,
										F2(
											function (now, timezone) {
												return {e8: now, kS: timezone};
											}),
										$elm$time$Time$now,
										$elm$time$Time$here));
							}
						}
					}(),
						A2(
						$author$project$Pages$Reports$Usage$maybeCmd,
						newModel.n2,
						$author$project$Services$Line$getLines(
							{ow: $author$project$Pages$Reports$Usage$GotLines, kU: user.kU})),
						A2(
						$author$project$Pages$Reports$Usage$maybeCmd,
						newModel.dv,
						$author$project$Services$Classes$getSummaryClasses(
							{ow: $author$project$Pages$Reports$Usage$GotClasses, kU: user.kU})),
						A2(
						$author$project$Pages$Reports$Usage$maybeCmd,
						newModel.c5,
						$author$project$Services$Auth$getOperators(
							{ow: $author$project$Pages$Reports$Usage$GotOperators, kU: user.kU})),
						A2(
						$author$project$Pages$Reports$Usage$maybeCmd,
						newModel.en,
						$author$project$Services$Reports$DetailedVehicle$getVehicleV2(
							{ow: $author$project$Pages$Reports$Usage$GotVehiclesV2, kU: user.kU}))
					])));
	});
var $author$project$Pages$Reports$UsesPerClass$GotClasses = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Reports$UsesPerClass$GotLines = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Reports$UsesPerClass$GotOperators = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Reports$UsesPerClass$GotTime = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Reports$UsesPerClass$GotUsesPerClass = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Reports$UsesPerClass$GotVehiclesV2 = function (a) {
	return {$: 5, a: a};
};
var $author$project$Services$Reports$UsesPerClass$UsesPerClass = F2(
	function (headers, rows) {
		return {nG: headers, px: rows};
	});
var $author$project$Services$Reports$UsesPerClass$Header = F3(
	function (id, className, type_) {
		return {ik: className, dM: id, kY: type_};
	});
var $author$project$Services$Reports$UsesPerClass$decodeHeader = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'type',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'className',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Services$Reports$UsesPerClass$Header))));
var $author$project$Services$Reports$UsesPerClass$Row = F3(
	function (title, classes, fare) {
		return {dv: classes, ni: fare, fD: title};
	});
var $author$project$Services$Reports$UsesPerClass$decodeRow = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'fare',
	$elm$json$Json$Decode$dict($elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'classes',
		$elm$json$Json$Decode$dict($elm$json$Json$Decode$int),
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'title',
			$elm$json$Json$Decode$string,
			'',
			$elm$json$Json$Decode$succeed($author$project$Services$Reports$UsesPerClass$Row))));
var $author$project$Services$Reports$UsesPerClass$dUsesPerClass = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'rows',
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$list($author$project$Services$Reports$UsesPerClass$decodeRow),
				$elm$json$Json$Decode$null(_List_Nil)
			])),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'headers',
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					$elm$json$Json$Decode$list($author$project$Services$Reports$UsesPerClass$decodeHeader),
					$elm$json$Json$Decode$null(_List_Nil)
				])),
		$elm$json$Json$Decode$succeed($author$project$Services$Reports$UsesPerClass$UsesPerClass)));
var $author$project$Services$Reports$UsesPerClass$empty = {nG: _List_Nil, px: _List_Nil};
var $author$project$Services$Reports$UsesPerClass$decodeUsesPerClass = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			$author$project$Services$Reports$UsesPerClass$dUsesPerClass,
			A2(
			$elm$json$Json$Decode$map,
			function (_v0) {
				return $author$project$Services$Reports$UsesPerClass$empty;
			},
			$elm$json$Json$Decode$list($author$project$Services$Reports$UsesPerClass$dUsesPerClass))
		]));
var $author$project$Services$Reports$UsesPerClass$getUsesPerClass = function (options) {
	var queries = _Utils_ap(
		A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'start', options.T.bB),
		_Utils_ap(
			A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'end', options.T.bl),
			_Utils_ap(
				A3(
					$author$project$Services$Api$queryMaybeValue,
					$elm$url$Url$Builder$int,
					'page',
					$elm$core$Maybe$Just(options.T.bv)),
				_Utils_ap(
					A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'groupBy', options.T.nB),
					_Utils_ap(
						A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'lineCode', options.T.b3),
						_Utils_ap(
							A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'operatorID', options.T.g6),
							A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'vehicleID', options.T.fN)))))));
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$author$project$Services$Reports$UsesPerClass$decodeUsesPerClass),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'report', 'using', 'walletClass']),
				queries)
		});
};
var $author$project$Services$Reports$UsesPerClass$getUsesPerClassDetailing = function (options) {
	var queries = _Utils_ap(
		A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'start', options.T.bB),
		_Utils_ap(
			A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'end', options.T.bl),
			_Utils_ap(
				A3(
					$author$project$Services$Api$queryMaybeValue,
					$elm$url$Url$Builder$int,
					'page',
					$elm$core$Maybe$Just(options.T.bv)),
				_Utils_ap(
					A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'groupBy', options.T.nB),
					_Utils_ap(
						A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'lineCode', options.T.b3),
						_Utils_ap(
							A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'operatorID', options.T.g6),
							A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'vehicleID', options.T.fN)))))));
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$author$project$Services$Reports$UsesPerClass$decodeUsesPerClass),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'report', 'cashierGroupedUsage', options.fH]),
				_List_Nil)
		});
};
var $author$project$Pages$Reports$UsesPerClass$maybeCmd = F2(
	function (rd, cmd_) {
		return _Utils_eq(rd, $krisajenkins$remotedata$RemoteData$NotAsked) ? cmd_ : $elm$core$Platform$Cmd$none;
	});
var $author$project$Pages$Reports$UsesPerClass$init = F3(
	function (queries, user, oldModel) {
		var vehicleIDtrToList = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$elm$core$String$split(','),
				queries.fN));
		var startPosix = A2(
			$elm$core$Maybe$andThen,
			$author$project$Utils$dateHTMLToPosixWithZone($elm$time$Time$utc),
			queries.bB);
		var operatorIDtrToList = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$elm$core$String$split(','),
				queries.g6));
		var lineCodeStrToList = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$elm$core$String$split(','),
				queries.b3));
		var newModel = A2(
			$elm$core$Maybe$withDefault,
			{
				dv: $krisajenkins$remotedata$RemoteData$NotAsked,
				bQ: $author$project$Components$PDF$Create$init,
				dJ: false,
				L: 0,
				dT: false,
				dU: false,
				dW: false,
				aB: lineCodeStrToList,
				n2: $krisajenkins$remotedata$RemoteData$NotAsked,
				c5: $krisajenkins$remotedata$RemoteData$NotAsked,
				aF: operatorIDtrToList,
				T: queries,
				ck: A2(
					$elm$core$Maybe$withDefault,
					$krisajenkins$remotedata$RemoteData$NotAsked,
					A3(
						$elm$core$Maybe$map2,
						F2(
							function (_v2, _v3) {
								return $krisajenkins$remotedata$RemoteData$Loading;
							}),
						queries.bB,
						queries.bl)),
				en: $krisajenkins$remotedata$RemoteData$NotAsked,
				aN: vehicleIDtrToList
			},
			A2(
				$elm$core$Maybe$map,
				function (m) {
					return _Utils_update(
						m,
						{T: queries});
				},
				oldModel));
		return _Utils_Tuple2(
			newModel,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						function () {
						var _v0 = _Utils_Tuple3(queries.bB, queries.bl, queries.ic);
						if (!_v0.c.$) {
							var transactionID = _v0.c.a;
							return $author$project$Services$Reports$UsesPerClass$getUsesPerClassDetailing(
								{ow: $author$project$Pages$Reports$UsesPerClass$GotUsesPerClass, T: queries, kU: user.kU, fH: transactionID});
						} else {
							if ((!_v0.a.$) && (!_v0.b.$)) {
								var _v1 = _v0.c;
								return $author$project$Services$Reports$UsesPerClass$getUsesPerClass(
									{ow: $author$project$Pages$Reports$UsesPerClass$GotUsesPerClass, T: queries, kU: user.kU});
							} else {
								return A2(
									$elm$core$Task$perform,
									$author$project$Pages$Reports$UsesPerClass$GotTime,
									A3(
										$elm$core$Task$map2,
										F2(
											function (now, timezone) {
												return {e8: now, kS: timezone};
											}),
										$elm$time$Time$now,
										$elm$time$Time$here));
							}
						}
					}(),
						A2(
						$author$project$Pages$Reports$UsesPerClass$maybeCmd,
						newModel.n2,
						$author$project$Services$Line$getLines(
							{ow: $author$project$Pages$Reports$UsesPerClass$GotLines, kU: user.kU})),
						A2(
						$author$project$Pages$Reports$UsesPerClass$maybeCmd,
						newModel.dv,
						$author$project$Services$Classes$getSummaryClasses(
							{ow: $author$project$Pages$Reports$UsesPerClass$GotClasses, kU: user.kU})),
						A2(
						$author$project$Pages$Reports$UsesPerClass$maybeCmd,
						newModel.c5,
						$author$project$Services$Auth$getOperators(
							{ow: $author$project$Pages$Reports$UsesPerClass$GotOperators, kU: user.kU})),
						A2(
						$author$project$Pages$Reports$UsesPerClass$maybeCmd,
						newModel.en,
						$author$project$Services$Reports$DetailedVehicle$getVehicleV2(
							{ow: $author$project$Pages$Reports$UsesPerClass$GotVehiclesV2, kU: user.kU}))
					])));
	});
var $author$project$Pages$Reports$UsesPerDay$GotTime = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Reports$UsesPerDay$GotUsingDay = function (a) {
	return {$: 1, a: a};
};
var $author$project$Services$Reports$UsesPerDay$TableUsingDay = F2(
	function (header, rows) {
		return {nF: header, px: rows};
	});
var $author$project$Services$Reports$UsesPerDay$RowUsingVehicle = F3(
	function (title, code, value) {
		return {l4: code, fD: title, di: value};
	});
var $author$project$Services$Reports$UsesPerDay$decodeRowUsingVehicle = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'values',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'code',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'title',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Services$Reports$UsesPerDay$RowUsingVehicle))));
var $author$project$Services$Reports$UsesPerDay$decodeTableUsingDay = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'rows',
	$elm$json$Json$Decode$list($author$project$Services$Reports$UsesPerDay$decodeRowUsingVehicle),
	_List_Nil,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'header',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
		_List_Nil,
		$elm$json$Json$Decode$succeed($author$project$Services$Reports$UsesPerDay$TableUsingDay)));
var $author$project$Services$Reports$UsesPerDay$getUsingDay = function (options) {
	var queries = _Utils_ap(
		A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'start', options.T.bB),
		A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'end', options.T.bl));
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$author$project$Services$Reports$UsesPerDay$decodeTableUsingDay),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'report', 'using', 'day']),
				queries)
		});
};
var $author$project$Pages$Reports$UsesPerDay$init = F2(
	function (queries, user) {
		return _Utils_Tuple2(
			{
				T: queries,
				ck: A2(
					$elm$core$Maybe$withDefault,
					$krisajenkins$remotedata$RemoteData$NotAsked,
					A3(
						$elm$core$Maybe$map2,
						F2(
							function (_v0, _v1) {
								return $krisajenkins$remotedata$RemoteData$Loading;
							}),
						queries.bB,
						queries.bl))
			},
			A2(
				$elm$core$Maybe$withDefault,
				A2(
					$elm$core$Task$perform,
					$author$project$Pages$Reports$UsesPerDay$GotTime,
					A3(
						$elm$core$Task$map2,
						F2(
							function (now, timezone) {
								return {e8: now, kS: timezone};
							}),
						$elm$time$Time$now,
						$elm$time$Time$here)),
				A3(
					$elm$core$Maybe$map2,
					F2(
						function (_v2, _v3) {
							return $author$project$Services$Reports$UsesPerDay$getUsingDay(
								{ow: $author$project$Pages$Reports$UsesPerDay$GotUsingDay, T: queries, kU: user.kU});
						}),
					queries.bB,
					queries.bl)));
	});
var $author$project$Pages$Reports$UsesPerLine$GotTime = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Reports$UsesPerLine$GotUsingLine = function (a) {
	return {$: 1, a: a};
};
var $author$project$Services$Reports$UsesPerLine$TableUsingLine = F2(
	function (header, rows) {
		return {nF: header, px: rows};
	});
var $author$project$Services$Reports$UsesPerLine$RowUsingVehicle = F3(
	function (title, code, value) {
		return {l4: code, fD: title, di: value};
	});
var $author$project$Services$Reports$UsesPerLine$decodeRowUsingVehicle = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'values',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'code',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'title',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Services$Reports$UsesPerLine$RowUsingVehicle))));
var $author$project$Services$Reports$UsesPerLine$decodeTableUsingLine = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'rows',
	$elm$json$Json$Decode$list($author$project$Services$Reports$UsesPerLine$decodeRowUsingVehicle),
	_List_Nil,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'header',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
		_List_Nil,
		$elm$json$Json$Decode$succeed($author$project$Services$Reports$UsesPerLine$TableUsingLine)));
var $author$project$Services$Reports$UsesPerLine$getUsingLine = function (options) {
	var queries = _Utils_ap(
		A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'start', options.T.bB),
		A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'end', options.T.bl));
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$author$project$Services$Reports$UsesPerLine$decodeTableUsingLine),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'report', 'using', 'line']),
				queries)
		});
};
var $author$project$Pages$Reports$UsesPerLine$init = F2(
	function (queries, user) {
		return _Utils_Tuple2(
			{
				T: queries,
				ck: A2(
					$elm$core$Maybe$withDefault,
					$krisajenkins$remotedata$RemoteData$NotAsked,
					A3(
						$elm$core$Maybe$map2,
						F2(
							function (_v0, _v1) {
								return $krisajenkins$remotedata$RemoteData$Loading;
							}),
						queries.bB,
						queries.bl))
			},
			A2(
				$elm$core$Maybe$withDefault,
				A2(
					$elm$core$Task$perform,
					$author$project$Pages$Reports$UsesPerLine$GotTime,
					A3(
						$elm$core$Task$map2,
						F2(
							function (now, timezone) {
								return {e8: now, kS: timezone};
							}),
						$elm$time$Time$now,
						$elm$time$Time$here)),
				A3(
					$elm$core$Maybe$map2,
					F2(
						function (_v2, _v3) {
							return $author$project$Services$Reports$UsesPerLine$getUsingLine(
								{ow: $author$project$Pages$Reports$UsesPerLine$GotUsingLine, T: queries, kU: user.kU});
						}),
					queries.bB,
					queries.bl)));
	});
var $author$project$Pages$Reports$UsesPerVehicle$GotTime = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Reports$UsesPerVehicle$GotUsingVehicle = function (a) {
	return {$: 1, a: a};
};
var $author$project$Services$Reports$UsesPerVehicle$TableUsingVehicle = F2(
	function (header, rows) {
		return {nF: header, px: rows};
	});
var $author$project$Services$Reports$UsesPerVehicle$RowUsingVehicle = F3(
	function (title, code, value) {
		return {l4: code, fD: title, di: value};
	});
var $author$project$Services$Reports$UsesPerVehicle$decodeRowUsingVehicle = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'values',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'code',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'title',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Services$Reports$UsesPerVehicle$RowUsingVehicle))));
var $author$project$Services$Reports$UsesPerVehicle$decodeTableUsingVehicle = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'rows',
	$elm$json$Json$Decode$list($author$project$Services$Reports$UsesPerVehicle$decodeRowUsingVehicle),
	_List_Nil,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'header',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
		_List_Nil,
		$elm$json$Json$Decode$succeed($author$project$Services$Reports$UsesPerVehicle$TableUsingVehicle)));
var $author$project$Services$Reports$UsesPerVehicle$getUsingVehicle = function (options) {
	var queries = _Utils_ap(
		A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'start', options.T.bB),
		A3($author$project$Services$Api$queryMaybeValue, $elm$url$Url$Builder$string, 'end', options.T.bl));
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$author$project$Services$Reports$UsesPerVehicle$decodeTableUsingVehicle),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'report', 'using', 'vehicle']),
				queries)
		});
};
var $author$project$Pages$Reports$UsesPerVehicle$init = F2(
	function (queries, user) {
		return _Utils_Tuple2(
			{
				T: queries,
				ck: A2(
					$elm$core$Maybe$withDefault,
					$krisajenkins$remotedata$RemoteData$NotAsked,
					A3(
						$elm$core$Maybe$map2,
						F2(
							function (_v0, _v1) {
								return $krisajenkins$remotedata$RemoteData$Loading;
							}),
						queries.bB,
						queries.bl))
			},
			A2(
				$elm$core$Maybe$withDefault,
				A2(
					$elm$core$Task$perform,
					$author$project$Pages$Reports$UsesPerVehicle$GotTime,
					A3(
						$elm$core$Task$map2,
						F2(
							function (now, timezone) {
								return {e8: now, kS: timezone};
							}),
						$elm$time$Time$now,
						$elm$time$Time$here)),
				A3(
					$elm$core$Maybe$map2,
					F2(
						function (_v2, _v3) {
							return $author$project$Services$Reports$UsesPerVehicle$getUsingVehicle(
								{ow: $author$project$Pages$Reports$UsesPerVehicle$GotUsingVehicle, T: queries, kU: user.kU});
						}),
					queries.bB,
					queries.bl)));
	});
var $author$project$Pages$Panel$MyAccount$SubPage$Account = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Panel$MyAccount$SubPage$initAccount = _Utils_Tuple2(
	$author$project$Pages$Panel$MyAccount$SubPage$Account(
		{mX: '', bW: '', L: 0}),
	$elm$core$Platform$Cmd$none);
var $author$project$Pages$Panel$MyAccount$SubPage$Password = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Panel$MyAccount$SubPage$initPassword = _Utils_Tuple2(
	$author$project$Pages$Panel$MyAccount$SubPage$Password(
		{
			L: 0,
			oN: {dY: false, di: ''},
			c6: {dY: false, di: ''}
		}),
	$elm$core$Platform$Cmd$none);
var $author$project$Data$User$isBuzzao = function (_v0) {
	var userType = _v0.k$;
	if (userType.$ === 3) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Data$User$isCompany = function (_v0) {
	var userType = _v0.k$;
	if (userType.$ === 2) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Data$User$isOperator = function (_v0) {
	var userType = _v0.k$;
	if (userType.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $author$project$Route$starterWithStrRoute = function (user) {
	return $author$project$Route$toString($author$project$Route$WelcomeBack);
};
var $author$project$Pages$initPage = F2(
	function (shared, oldPage) {
		var withUser = function (init_) {
			var _v42 = shared.pF;
			if (!_v42.$) {
				var user = _v42.a;
				return init_(user);
			} else {
				return _Utils_Tuple3(
					$author$project$Pages$RedirectPage,
					$elm$browser$Browser$Navigation$load(
						$author$project$Route$toString($author$project$Route$Login)),
					$author$project$Shared$NoOp);
			}
		};
		var withGuest = function (init_) {
			var _v41 = shared.pF;
			if (!_v41.$) {
				var user = _v41.a;
				return _Utils_Tuple3(
					$author$project$Pages$RedirectPage,
					$elm$browser$Browser$Navigation$load(
						$author$project$Route$starterWithStrRoute(user)),
					$author$project$Shared$NoOp);
			} else {
				return init_;
			}
		};
		var notFound = _Utils_Tuple3($author$project$Pages$NotFoundPage, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
		var mapTransition = F3(
			function (fn1, fn2, _v40) {
				var a = _v40.a;
				var b = _v40.b;
				var c = _v40.c;
				return _Utils_Tuple3(
					fn1(a),
					A2($elm$core$Platform$Cmd$map, fn2, b),
					c);
			});
		var mapBothNoShared = F3(
			function (fnA, fnB, _v39) {
				var a = _v39.a;
				var b = _v39.b;
				return _Utils_Tuple3(
					fnA(a),
					A2($elm$core$Platform$Cmd$map, fnB, b),
					$author$project$Shared$NoOp);
			});
		var ifUser = F2(
			function (if_, init_) {
				return withUser(
					function (user) {
						return if_(user) ? init_(user) : _Utils_Tuple3(
							$author$project$Pages$RedirectPage,
							$elm$browser$Browser$Navigation$load(
								$author$project$Route$starterWithStrRoute(user)),
							$author$project$Shared$NoOp);
					});
			});
		var _v0 = _Utils_Tuple2(shared.pv, shared.pF);
		_v0$57:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					var _v1 = _v0.a;
					return withGuest(
						_Utils_Tuple3(
							$author$project$Pages$LoginPage($author$project$Pages$Login$init),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp));
				case 1:
					var _v2 = _v0.a;
					return _Utils_Tuple3(
						$author$project$Pages$RecoverPasswordPage($author$project$Pages$RecoverPassword$init),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				case 2:
					var token = _v0.a.a;
					return _Utils_Tuple3(
						$author$project$Pages$ChangePasswordPage(
							$author$project$Pages$ChangePassword$init(token)),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				case 5:
					var _v3 = _v0.a;
					return A2(
						ifUser,
						function (u) {
							return $author$project$Data$User$isOperator(u) || $author$project$Data$User$isBuzzao(u);
						},
						A2(
							$elm$core$Basics$composeR,
							$author$project$Pages$Pos$Guiche$init,
							A2(mapTransition, $author$project$Pages$PosGuichePage, $author$project$Pages$PosGuicheMsg)));
				case 6:
					var _v4 = _v0.a;
					return A2(
						ifUser,
						function (u) {
							return $author$project$Data$User$isOperator(u) || $author$project$Data$User$isBuzzao(u);
						},
						A2(
							$elm$core$Basics$composeR,
							$author$project$Pages$Pos$Register$init,
							A2(mapBothNoShared, $author$project$Pages$PosRegisterPage, $author$project$Pages$PosRegisterMsg)));
				case 7:
					var _v5 = _v0.a;
					var passengerId = _v5.a;
					var subRoute = _v5.b;
					if ((!oldPage.$) && (oldPage.a.$ === 7)) {
						var _v7 = oldPage.a;
						var oldModel = _v7.b;
						return A2(
							ifUser,
							function (u) {
								return $author$project$Data$User$isOperator(u) || $author$project$Data$User$isBuzzao(u);
							},
							A2(
								$elm$core$Basics$composeR,
								function (user) {
									return A4($author$project$Pages$Pos$Passenger$changedRoute, user, passengerId, subRoute, oldModel);
								},
								A2(
									mapTransition,
									$author$project$Pages$PosPassengerPage(passengerId),
									$author$project$Pages$PosPassengerMsg)));
					} else {
						return A2(
							ifUser,
							function (u) {
								return $author$project$Data$User$isOperator(u) || $author$project$Data$User$isBuzzao(u);
							},
							A2(
								$elm$core$Basics$composeR,
								function (user) {
									return A4(
										$author$project$Pages$Pos$Passenger$init,
										user,
										passengerId,
										subRoute,
										$author$project$Pages$extractPassenger(oldPage));
								},
								A2(
									mapTransition,
									$author$project$Pages$PosPassengerPage(passengerId),
									$author$project$Pages$PosPassengerMsg)));
					}
				case 8:
					var id = _v0.a.a;
					return A2(
						ifUser,
						function (u) {
							return $author$project$Data$User$isOperator(u) || $author$project$Data$User$isBuzzao(u);
						},
						A2(
							$elm$core$Basics$composeR,
							function (user) {
								return A3(
									$author$project$Pages$Pos$Edit$init,
									user,
									id,
									$author$project$Pages$extractPassenger(oldPage));
							},
							A2(mapBothNoShared, $author$project$Pages$PosEditPage, $author$project$Pages$PosEditMsg)));
				case 9:
					var maybeSearch = _v0.a.a;
					return A2(
						ifUser,
						function (u) {
							return $author$project$Data$User$isOperator(u) || $author$project$Data$User$isBuzzao(u);
						},
						A2(
							$elm$core$Basics$composeR,
							function (user) {
								return A2($author$project$Pages$Pos$Localize$init, user, maybeSearch);
							},
							A2(mapBothNoShared, $author$project$Pages$PosLocalizePage, $author$project$Pages$PosLocalizeMsg)));
				case 3:
					var _v8 = _v0.a;
					return A3(mapBothNoShared, $author$project$Pages$HomeWelcomeBackPage, $author$project$Pages$HomeWelcomeBackMsg, $author$project$Pages$Home$WelcomeBack$init);
				case 10:
					var _v11 = _v0.a;
					return A2(
						ifUser,
						$author$project$Data$User$isOperator,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Pages$Pos$CloseCashier$init,
							A2(mapBothNoShared, $author$project$Pages$PosCloseCashierPage, $author$project$Pages$PosCloseCashierMsg)));
				case 11:
					var queries = _v0.a.a;
					return A2(
						ifUser,
						$author$project$Data$User$isOperator,
						A2(
							$elm$core$Basics$composeR,
							A2($author$project$Pages$Garage$Dashboard$init, queries, shared),
							A2(mapBothNoShared, $author$project$Pages$PosGaragePage, $author$project$Pages$PosGarageMsg)));
				case 12:
					var maybeConcessionaireId = _v0.a.a;
					return A3(
						mapBothNoShared,
						$author$project$Pages$EnterpriseRegisterPage(maybeConcessionaireId),
						$author$project$Pages$EnterpriseRegisterMsg,
						A2($author$project$Pages$Enterprise$Register$init, shared, maybeConcessionaireId));
				case 13:
					var _v12 = _v0.a;
					var maybeIsOpen = _v12.a;
					var maybeImportDetails = _v12.b;
					return A2(
						ifUser,
						$author$project$Data$User$isCompany,
						A2(
							$elm$core$Basics$composeR,
							A2(
								$author$project$Pages$Enterprise$Dashboard$init,
								A2($elm$core$Maybe$withDefault, false, maybeIsOpen),
								maybeImportDetails),
							A2(mapBothNoShared, $author$project$Pages$EnterpriseDashboardPage, $author$project$Pages$EnterpriseDashboardMsg)));
				case 14:
					var _v13 = _v0.a;
					return A2(
						ifUser,
						$author$project$Data$User$isCompany,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Pages$Order$Lists$init,
							A2(mapBothNoShared, $author$project$Pages$SavedOrderListsPage, $author$project$Pages$SavedOrderListsMsg)));
				case 15:
					var orderID = _v0.a.a;
					return A2(
						ifUser,
						$author$project$Data$User$isCompany,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Pages$Order$Detail$init(orderID),
							A2(mapBothNoShared, $author$project$Pages$SavedOrderDetailPage, $author$project$Pages$SavedOrderDetailMsg)));
				case 16:
					var _v14 = _v0.a;
					return A2(
						ifUser,
						$author$project$Data$User$isCompany,
						A2(
							$elm$core$Basics$composeR,
							A4(
								$author$project$Pages$Admin$CompanyOrders$init,
								$elm$core$Maybe$Nothing,
								$elm$core$Maybe$Nothing,
								$elm$core$Maybe$Just(''),
								$elm$core$Maybe$Nothing),
							A2(mapBothNoShared, $author$project$Pages$EnterpriseHistoryPage, $author$project$Pages$EnterpriseHistoryMsg)));
				case 17:
					var _v15 = _v0.a;
					var detailId = _v15.a;
					var page = _v15.b;
					var maybeId = function (id) {
						return $elm$core$String$isEmpty(id) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(id);
					};
					return A2(
						ifUser,
						$author$project$Data$User$isCompany,
						A2(
							$elm$core$Basics$composeR,
							A4(
								$author$project$Pages$Admin$CompanyOrders$init,
								$elm$core$Maybe$Nothing,
								page,
								$elm$core$Maybe$Nothing,
								maybeId(detailId)),
							A2(mapBothNoShared, $author$project$Pages$EnterpriseHistoryPage, $author$project$Pages$EnterpriseHistoryMsg)));
				case 19:
					var _v16 = _v0.a;
					var subRoute = _v16.a;
					var maybeConcessionaireId = _v16.b;
					if ((!oldPage.$) && (oldPage.a.$ === 18)) {
						var _v18 = oldPage.a;
						var oldModel = _v18.b;
						return A2(
							ifUser,
							$author$project$Data$User$canEnterInAdminArea,
							A2(
								$elm$core$Basics$composeR,
								A4($author$project$Pages$Admin$changedRoute, shared, subRoute, maybeConcessionaireId, oldModel),
								A2(
									mapTransition,
									$author$project$Pages$AdminPage(maybeConcessionaireId),
									$author$project$Pages$AdminMsg)));
					} else {
						return A2(
							ifUser,
							$author$project$Data$User$canEnterInAdminArea,
							A2(
								$elm$core$Basics$composeR,
								A3($author$project$Pages$Admin$init, shared, subRoute, maybeConcessionaireId),
								A2(
									mapTransition,
									$author$project$Pages$AdminPage(maybeConcessionaireId),
									$author$project$Pages$AdminMsg)));
					}
				case 21:
					if (!_v0.b.$) {
						switch (_v0.a.a.$) {
							case 0:
								var queries = _v0.a.a.a;
								var user = _v0.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$REPORTS(
											$author$project$Services$Models$UsesVehicles(0)),
										hQ: A3(
											mapBothNoShared,
											$author$project$Pages$ReportUsesPerVehiclePage,
											$author$project$Pages$ReportUsesPerVehicleMsg,
											A2($author$project$Pages$Reports$UsesPerVehicle$init, queries, user)),
										hR: notFound
									});
							case 12:
								var _v30 = _v0.a.a;
								var user = _v0.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$REPORT_PDF(0),
										hQ: A3(
											mapBothNoShared,
											$author$project$Pages$ReportPDFsPage,
											$author$project$Pages$ReportPDFsMsg,
											$author$project$Pages$Reports$PDFs$init(user)),
										hR: notFound
									});
							case 11:
								switch (_v0.a.a.a.$) {
									case 0:
										var q = _v0.a.a.a.a;
										var user = _v0.b.a;
										var oldModel = function () {
											if ((!oldPage.$) && (oldPage.a.$ === 35)) {
												var oldModel_ = oldPage.a.a;
												return $elm$core$Maybe$Just(oldModel_);
											} else {
												return $elm$core$Maybe$Nothing;
											}
										}();
										return $author$project$Services$Models$iHaveAccess(
											{
												gZ: user.hg,
												hf: $author$project$Services$Models$REPORTS_EVENTS(1),
												hQ: A3(
													mapBothNoShared,
													$author$project$Pages$ReportEventUsingVehiclePage,
													$author$project$Pages$ReportEventUsingVehicleMsg,
													A3($author$project$Pages$Reports$Event$UsingVehicle$init, q, user, oldModel)),
												hR: notFound
											});
									case 1:
										var q = _v0.a.a.a.a;
										var user = _v0.b.a;
										var oldModel = function () {
											if ((!oldPage.$) && (oldPage.a.$ === 36)) {
												var oldModel_ = oldPage.a.a;
												return $elm$core$Maybe$Just(oldModel_);
											} else {
												return $elm$core$Maybe$Nothing;
											}
										}();
										return $author$project$Services$Models$iHaveAccess(
											{
												gZ: user.hg,
												hf: $author$project$Services$Models$REPORTS_EVENTS(3),
												hQ: A3(
													mapBothNoShared,
													$author$project$Pages$ReportEventUsingLinePage,
													$author$project$Pages$ReportEventUsingLineMsg,
													A3($author$project$Pages$Reports$Event$UsingLine$init, q, user, oldModel)),
												hR: notFound
											});
									case 2:
										var q = _v0.a.a.a.a;
										var user = _v0.b.a;
										return $author$project$Services$Models$iHaveAccess(
											{
												gZ: user.hg,
												hf: $author$project$Services$Models$REPORTS_EVENTS(0),
												hQ: A3(
													mapBothNoShared,
													$author$project$Pages$ReportEventUsingDayPage,
													$author$project$Pages$ReportEventUsingDayMsg,
													A2($author$project$Pages$Reports$Event$UsingDay$init, q, user)),
												hR: notFound
											});
									case 3:
										var q = _v0.a.a.a.a;
										var user = _v0.b.a;
										var oldModel = function () {
											if ((!oldPage.$) && (oldPage.a.$ === 38)) {
												var oldModel_ = oldPage.a.a;
												return $elm$core$Maybe$Just(oldModel_);
											} else {
												return $elm$core$Maybe$Nothing;
											}
										}();
										return $author$project$Services$Models$iHaveAccess(
											{
												gZ: user.hg,
												hf: $author$project$Services$Models$REPORTS_EVENTS(2),
												hQ: A3(
													mapBothNoShared,
													$author$project$Pages$ReportEventUsingOperatorPage,
													$author$project$Pages$ReportEventUsingOperatorMsg,
													A3($author$project$Pages$Reports$Event$UsingOperator$init, q, user, oldModel)),
												hR: notFound
											});
									case 4:
										var q = _v0.a.a.a.a;
										var user = _v0.b.a;
										var oldModel = function () {
											if ((!oldPage.$) && (oldPage.a.$ === 39)) {
												var oldModel_ = oldPage.a.a;
												return $elm$core$Maybe$Just(oldModel_);
											} else {
												return $elm$core$Maybe$Nothing;
											}
										}();
										return $author$project$Services$Models$iHaveAccess(
											{
												gZ: user.hg,
												hf: $author$project$Services$Models$REPORTS_EVENTS(4),
												hQ: A3(
													mapBothNoShared,
													$author$project$Pages$ReportEventUsingSessionPage,
													$author$project$Pages$ReportEventUsingSessionMsg,
													A3($author$project$Pages$Reports$Event$UsingSession$init, q, user, oldModel)),
												hR: notFound
											});
									default:
										var q = _v0.a.a.a.a;
										var user = _v0.b.a;
										return A3(
											mapBothNoShared,
											$author$project$Pages$ReportAuditPage,
											$author$project$Pages$ReportAuditMsg,
											A2($author$project$Pages$Reports$Event$Audit$init, q, user));
								}
							case 1:
								var queries = _v0.a.a.a;
								var user = _v0.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$REPORTS(
											$author$project$Services$Models$UsesDay(0)),
										hQ: A3(
											mapBothNoShared,
											$author$project$Pages$ReportUsesPerDayPage,
											$author$project$Pages$ReportUsesPerDayMsg,
											A2($author$project$Pages$Reports$UsesPerDay$init, queries, user)),
										hR: notFound
									});
							case 2:
								var queries = _v0.a.a.a;
								var user = _v0.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$REPORTS(
											$author$project$Services$Models$UsesLine(0)),
										hQ: A3(
											mapBothNoShared,
											$author$project$Pages$ReportUsesPerLinePage,
											$author$project$Pages$ReportUsesPerLineMsg,
											A2($author$project$Pages$Reports$UsesPerLine$init, queries, user)),
										hR: notFound
									});
							case 9:
								var queries = _v0.a.a.a;
								var user = _v0.b.a;
								if ((!oldPage.$) && (oldPage.a.$ === 43)) {
									var oldPage_ = oldPage.a.a;
									return $author$project$Services$Models$iHaveAccess(
										{
											gZ: user.hg,
											hf: $author$project$Services$Models$REPORTS($author$project$Services$Models$UsesClass),
											hQ: A3(
												mapBothNoShared,
												$author$project$Pages$ReportUsesPerClassPage,
												$author$project$Pages$ReportUsesPerClassMsg,
												A3(
													$author$project$Pages$Reports$UsesPerClass$init,
													queries,
													user,
													$elm$core$Maybe$Just(oldPage_))),
											hR: notFound
										});
								} else {
									return $author$project$Services$Models$iHaveAccess(
										{
											gZ: user.hg,
											hf: $author$project$Services$Models$REPORTS($author$project$Services$Models$UsesClass),
											hQ: A3(
												mapBothNoShared,
												$author$project$Pages$ReportUsesPerClassPage,
												$author$project$Pages$ReportUsesPerClassMsg,
												A3($author$project$Pages$Reports$UsesPerClass$init, queries, user, $elm$core$Maybe$Nothing)),
											hR: notFound
										});
								}
							case 10:
								var queries = _v0.a.a.a;
								var user = _v0.b.a;
								if ((!oldPage.$) && (oldPage.a.$ === 44)) {
									var oldPage_ = oldPage.a.a;
									return $author$project$Services$Models$iHaveAccess(
										{
											gZ: user.hg,
											hf: $author$project$Services$Models$BIOMETRY(0),
											hQ: A3(
												mapBothNoShared,
												$author$project$Pages$ReportDivergencesPage,
												$author$project$Pages$ReportDivergencesMsg,
												A3(
													$author$project$Pages$Reports$Divergences$init,
													queries,
													user,
													$elm$core$Maybe$Just(oldPage_))),
											hR: notFound
										});
								} else {
									return $author$project$Services$Models$iHaveAccess(
										{
											gZ: user.hg,
											hf: $author$project$Services$Models$BIOMETRY(0),
											hQ: A3(
												mapBothNoShared,
												$author$project$Pages$ReportDivergencesPage,
												$author$project$Pages$ReportDivergencesMsg,
												A3($author$project$Pages$Reports$Divergences$init, queries, user, $elm$core$Maybe$Nothing)),
											hR: notFound
										});
								}
							case 8:
								var queries = _v0.a.a.a;
								var user = _v0.b.a;
								if ((!oldPage.$) && (oldPage.a.$ === 45)) {
									var oldPage_ = oldPage.a.a;
									return $author$project$Services$Models$iHaveAccess(
										{
											gZ: user.hg,
											hf: $author$project$Services$Models$REPORTS($author$project$Services$Models$Usage),
											hQ: A3(
												mapBothNoShared,
												$author$project$Pages$ReportUsagePage,
												$author$project$Pages$ReportUsageMsg,
												A3(
													$author$project$Pages$Reports$Usage$init,
													queries,
													user,
													$elm$core$Maybe$Just(oldPage_))),
											hR: notFound
										});
								} else {
									return $author$project$Services$Models$iHaveAccess(
										{
											gZ: user.hg,
											hf: $author$project$Services$Models$REPORTS($author$project$Services$Models$Usage),
											hQ: A3(
												mapBothNoShared,
												$author$project$Pages$ReportUsagePage,
												$author$project$Pages$ReportUsageMsg,
												A3($author$project$Pages$Reports$Usage$init, queries, user, $elm$core$Maybe$Nothing)),
											hR: notFound
										});
								}
							case 3:
								var queries = _v0.a.a.a;
								var user = _v0.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$REPORTS($author$project$Services$Models$DetailedVehicle),
										hQ: A3(
											mapBothNoShared,
											$author$project$Pages$ReportDetailedVehiclePage,
											$author$project$Pages$ReportDetailedVehicleMsg,
											A2($author$project$Pages$Reports$DetailedVehicle$init, queries, user)),
										hR: notFound
									});
							case 4:
								var queries = _v0.a.a.a;
								var user = _v0.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$REPORTS($author$project$Services$Models$DetailedVehicle),
										hQ: A3(
											mapBothNoShared,
											$author$project$Pages$ReportDetailedVehicleV2Page,
											$author$project$Pages$ReportDetailedVehicleV2Msg,
											A2($author$project$Pages$Reports$DetailedVehicleV2$init, queries, user)),
										hR: notFound
									});
							case 5:
								var queries = _v0.a.a.a;
								var user = _v0.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$REPORTS($author$project$Services$Models$SalesSummary),
										hQ: A3(
											mapBothNoShared,
											$author$project$Pages$ReportSalesSummarizedPage,
											$author$project$Pages$ReportSalesSummarizedMsg,
											A2($author$project$Pages$Reports$SalesSummarized$init, user, queries)),
										hR: notFound
									});
							case 6:
								var queries = _v0.a.a.a;
								var user = _v0.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$REPORTS($author$project$Services$Models$SalesSummary),
										hQ: A3(
											mapBothNoShared,
											$author$project$Pages$ReportSalesSummarizedV2Page,
											$author$project$Pages$ReportSalesSummarizedV2Msg,
											A2($author$project$Pages$Reports$SalesSummarizedV2$init, user, queries)),
										hR: notFound
									});
							default:
								var queries = _v0.a.a.a;
								var user = _v0.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$REPORTS($author$project$Services$Models$SalesSummary),
										hQ: A3(
											mapBothNoShared,
											$author$project$Pages$ReportAdministrativeSalesPage,
											$author$project$Pages$ReportAdministrativeSalesMsg,
											A2($author$project$Pages$Reports$AdministrativeSales$init, queries, user)),
										hR: notFound
									});
						}
					} else {
						break _v0$57;
					}
				case 4:
					switch (_v0.a.a.$) {
						case 7:
							if (!_v0.a.a.a) {
								var _v9 = _v0.a.a.a;
								return A3(mapBothNoShared, $author$project$Pages$MyAccountPage, $author$project$Pages$MyAccountMsg, $author$project$Pages$Panel$MyAccount$SubPage$initPassword);
							} else {
								var _v10 = _v0.a.a.a;
								return A3(mapBothNoShared, $author$project$Pages$MyAccountPage, $author$project$Pages$MyAccountMsg, $author$project$Pages$Panel$MyAccount$SubPage$initAccount);
							}
						case 1:
							if (!_v0.b.$) {
								var queries = _v0.a.a.a;
								var user = _v0.b.a;
								return A2(
									$elm$core$Maybe$withDefault,
									notFound,
									A2(
										$elm$core$Maybe$map,
										function (conID) {
											return $author$project$Services$Models$iHaveAccess(
												{
													gZ: user.hg,
													hf: $author$project$Services$Models$EQUIPMENT(3),
													hQ: A3(
														mapBothNoShared,
														$author$project$Pages$EquipmentsPage,
														$author$project$Pages$EquipmentsMsg,
														A4($author$project$Pages$Panel$EquipmentsV2$init, conID, queries, shared, user)),
													hR: notFound
												});
										},
										$author$project$Data$User$extractConcessionaireId(user)));
							} else {
								break _v0$57;
							}
						case 0:
							if (!_v0.a.a.a) {
								if (!_v0.b.$) {
									var _v19 = _v0.a.a.a;
									var user = _v0.b.a;
									return $author$project$Services$Models$iHaveAccess(
										{
											gZ: user.hg,
											hf: $author$project$Services$Models$REVERSE(0),
											hQ: A3(
												mapBothNoShared,
												$author$project$Pages$ReversalApprovalSystemPage,
												$author$project$Pages$ReversalApprovalSystemMsg,
												A2($author$project$Pages$Panel$ReversalApprovalSystem$init, 0, user)),
											hR: notFound
										});
								} else {
									break _v0$57;
								}
							} else {
								if (!_v0.b.$) {
									var _v20 = _v0.a.a.a;
									var user = _v0.b.a;
									return $author$project$Services$Models$iHaveAccess(
										{
											gZ: user.hg,
											hf: $author$project$Services$Models$REVERSE(0),
											hQ: A3(
												mapBothNoShared,
												$author$project$Pages$ReversalApprovalCashierPage,
												$author$project$Pages$ReversalApprovalCashierMsg,
												A2($author$project$Pages$Panel$ReversalApprovalCashier$init, 1, user)),
											hR: notFound
										});
								} else {
									break _v0$57;
								}
							}
						case 3:
							if (!_v0.b.$) {
								var _v21 = _v0.a.a;
								var user = _v0.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$POUCH(0),
										hQ: A3(
											mapBothNoShared,
											$author$project$Pages$ManagePouchesPage,
											$author$project$Pages$ManagePouchesMsg,
											$author$project$Pages$Panel$ManagePouches$init(user)),
										hR: notFound
									});
							} else {
								break _v0$57;
							}
						case 4:
							if (!_v0.b.$) {
								var queries = _v0.a.a.a;
								var user = _v0.b.a;
								if ((!oldPage.$) && (oldPage.a.$ === 23)) {
									var oldModel = oldPage.a.a;
									return $author$project$Services$Models$iHaveAccess(
										{
											gZ: user.hg,
											hf: $author$project$Services$Models$TARIFFS(0),
											hQ: A3(
												mapBothNoShared,
												$author$project$Pages$ManageFarePage,
												$author$project$Pages$ManageFareMsg,
												A4(
													$author$project$Pages$Panel$ManageFare$init,
													$elm$core$Maybe$Just(oldModel),
													queries,
													shared,
													user)),
											hR: notFound
										});
								} else {
									return $author$project$Services$Models$iHaveAccess(
										{
											gZ: user.hg,
											hf: $author$project$Services$Models$TARIFFS(0),
											hQ: A3(
												mapBothNoShared,
												$author$project$Pages$ManageFarePage,
												$author$project$Pages$ManageFareMsg,
												A4($author$project$Pages$Panel$ManageFare$init, $elm$core$Maybe$Nothing, queries, shared, user)),
											hR: notFound
										});
								}
							} else {
								break _v0$57;
							}
						case 5:
							if (!_v0.b.$) {
								var _v23 = _v0.a.a;
								var user = _v0.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$OPERATORS(0),
										hQ: A3(
											mapBothNoShared,
											$author$project$Pages$ManageOperatorsPage,
											$author$project$Pages$ManageOperatorsMsg,
											A2($author$project$Pages$Panel$ManageOperators$init, user, shared)),
										hR: notFound
									});
							} else {
								break _v0$57;
							}
						case 8:
							if (!_v0.b.$) {
								var _v24 = _v0.a.a;
								var user = _v0.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$EQUIPMENT_UPDATE(0),
										hQ: A3(
											mapBothNoShared,
											$author$project$Pages$UpdateEquipmentPage,
											$author$project$Pages$UpdateEquipmentMsg,
											$author$project$Pages$Panel$UpdateEquipment$init(user)),
										hR: notFound
									});
							} else {
								break _v0$57;
							}
						case 11:
							if (!_v0.b.$) {
								var q_ = _v0.a.a.a;
								var user = _v0.b.a;
								if ((!oldPage.$) && (oldPage.a.$ === 26)) {
									var oldModel = oldPage.a.a;
									return $author$project$Services$Models$iHaveAccess(
										{
											gZ: user.hg,
											hf: $author$project$Services$Models$REASONS(0),
											hQ: A3(
												mapBothNoShared,
												$author$project$Pages$ReasonPage,
												$author$project$Pages$ReasonMsg,
												A3(
													$author$project$Pages$Panel$Reason$init,
													$elm$core$Maybe$Just(oldModel),
													q_,
													user)),
											hR: notFound
										});
								} else {
									return $author$project$Services$Models$iHaveAccess(
										{
											gZ: user.hg,
											hf: $author$project$Services$Models$REASONS(0),
											hQ: A3(
												mapBothNoShared,
												$author$project$Pages$ReasonPage,
												$author$project$Pages$ReasonMsg,
												A3($author$project$Pages$Panel$Reason$init, $elm$core$Maybe$Nothing, q_, user)),
											hR: notFound
										});
								}
							} else {
								break _v0$57;
							}
						case 12:
							if (!_v0.b.$) {
								var _v26 = _v0.a.a;
								var user = _v0.b.a;
								if ((!oldPage.$) && (oldPage.a.$ === 27)) {
									var oldModel = oldPage.a.a;
									return $author$project$Services$Models$iHaveAccess(
										{
											gZ: user.hg,
											hf: $author$project$Services$Models$AVULSAS(0),
											hQ: A3(
												mapBothNoShared,
												$author$project$Pages$SingleChargePage,
												$author$project$Pages$SingleChargeMsg,
												A2(
													$author$project$Pages$Panel$SingleCharge$init,
													$elm$core$Maybe$Just(oldModel),
													user)),
											hR: notFound
										});
								} else {
									return $author$project$Services$Models$iHaveAccess(
										{
											gZ: user.hg,
											hf: $author$project$Services$Models$AVULSAS(0),
											hQ: A3(
												mapBothNoShared,
												$author$project$Pages$SingleChargePage,
												$author$project$Pages$SingleChargeMsg,
												A2($author$project$Pages$Panel$SingleCharge$init, $elm$core$Maybe$Nothing, user)),
											hR: notFound
										});
								}
							} else {
								break _v0$57;
							}
						case 13:
							if (!_v0.a.a.a.$) {
								if (!_v0.b.$) {
									var q_ = _v0.a.a.a.a;
									var user = _v0.b.a;
									return $author$project$Services$Models$iHaveAccess(
										{
											gZ: user.hg,
											hf: $author$project$Services$Models$STOCK(0),
											hQ: A3(
												mapBothNoShared,
												$author$project$Pages$StockListPage,
												$author$project$Pages$StockListMsg,
												A2($author$project$Pages$Panel$Stock$List$init, q_, user)),
											hR: notFound
										});
								} else {
									break _v0$57;
								}
							} else {
								if (!_v0.b.$) {
									var serial = _v0.a.a.a.a;
									var user = _v0.b.a;
									return $author$project$Services$Models$iHaveAccess(
										{
											gZ: user.hg,
											hf: $author$project$Services$Models$STOCK(0),
											hQ: A3(
												mapBothNoShared,
												$author$project$Pages$StockDetailsPage,
												$author$project$Pages$StockDetailsMsg,
												A2($author$project$Pages$Panel$Stock$Details$init, serial, user)),
											hR: notFound
										});
								} else {
									break _v0$57;
								}
							}
						case 9:
							if (!_v0.b.$) {
								var _v28 = _v0.a.a;
								var user = _v0.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$EQUIPMENT_UPDATE(0),
										hQ: A3(
											mapBothNoShared,
											$author$project$Pages$UpdateRequestsEquipmentsPage,
											$author$project$Pages$UpdateRequestsEquipmentsMsg,
											$author$project$Pages$Panel$UpdateRequestsEquipments$init(user)),
										hR: notFound
									});
							} else {
								break _v0$57;
							}
						case 6:
							if (!_v0.b.$) {
								var q = _v0.a.a.a;
								var user = _v0.b.a;
								if ((!oldPage.$) && (oldPage.a.$ === 31)) {
									var oldModel = oldPage.a.a;
									return $author$project$Services$Models$iHaveAccess(
										{
											gZ: user.hg,
											hf: $author$project$Services$Models$LINES(0),
											hQ: A3(
												mapBothNoShared,
												$author$project$Pages$ManageLinesPage,
												$author$project$Pages$ManageLinesMsg,
												A3(
													$author$project$Pages$Panel$ManageLines$init,
													$elm$core$Maybe$Just(oldModel),
													q,
													user)),
											hR: notFound
										});
								} else {
									return $author$project$Services$Models$iHaveAccess(
										{
											gZ: user.hg,
											hf: $author$project$Services$Models$LINES(0),
											hQ: A3(
												mapBothNoShared,
												$author$project$Pages$ManageLinesPage,
												$author$project$Pages$ManageLinesMsg,
												A3($author$project$Pages$Panel$ManageLines$init, $elm$core$Maybe$Nothing, q, user)),
											hR: notFound
										});
								}
							} else {
								break _v0$57;
							}
						case 14:
							if (!_v0.b.$) {
								var q = _v0.a.a.a;
								var user = _v0.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$PASSENGER(0),
										hQ: A3(
											mapBothNoShared,
											$author$project$Pages$HistoryPage,
											$author$project$Pages$HistoryMsg,
											A2($author$project$Pages$Panel$History$init, q, user)),
										hR: notFound
									});
							} else {
								break _v0$57;
							}
						case 2:
							if (!_v0.b.$) {
								switch (_v0.a.a.a.$) {
									case 0:
										var queries = _v0.a.a.a.a;
										var user = _v0.b.a;
										return $author$project$Services$Models$iHaveAccess(
											{
												gZ: user.hg,
												hf: $author$project$Services$Models$FINANCIAL(1),
												hQ: A3(
													mapBothNoShared,
													$author$project$Pages$FinancialAccountPage,
													$author$project$Pages$FinancialAccountMsg,
													A2($author$project$Pages$Panel$Financial$Account$init, user, queries)),
												hR: notFound
											});
									case 1:
										var queries = _v0.a.a.a.a;
										var user = _v0.b.a;
										return $author$project$Services$Models$iHaveAccess(
											{
												gZ: user.hg,
												hf: $author$project$Services$Models$FINANCIAL(2),
												hQ: A3(
													mapBothNoShared,
													$author$project$Pages$FinancialTransactionsPage,
													$author$project$Pages$FinancialTransactionsMsg,
													A2($author$project$Pages$Panel$Financial$Transactions$init, queries, user)),
												hR: notFound
											});
									default:
										var queries = _v0.a.a.a.a;
										var user = _v0.b.a;
										return $author$project$Services$Models$iHaveAccess(
											{
												gZ: user.hg,
												hf: $author$project$Services$Models$FINANCIAL(3),
												hQ: A3(
													mapBothNoShared,
													$author$project$Pages$FinancialPendingTransactionsPage,
													$author$project$Pages$FinancialPendingTransactionsMsg,
													A2($author$project$Pages$Panel$Financial$PendingTransactions$init, queries, user)),
												hR: notFound
											});
								}
							} else {
								break _v0$57;
							}
						default:
							if (!_v0.b.$) {
								var classesRoute = _v0.a.a.a;
								var user = _v0.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$CLASS(1),
										hQ: A3(
											mapBothNoShared,
											$author$project$Pages$PanelClassesPage,
											$author$project$Pages$PanelClassesMsg,
											A3($author$project$Pages$Panel$Classes$SubPage$init, classesRoute, shared, user)),
										hR: notFound
									});
							} else {
								break _v0$57;
							}
					}
				case 20:
					var _v38 = _v0.a;
					return _Utils_Tuple3($author$project$Pages$ZenviaChatPage, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
				default:
					break _v0$57;
			}
		}
		return notFound;
	});
var $author$project$Data$Billing$isBlocked = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map(
		function ($) {
			return $.fY;
		}),
	$elm$core$Maybe$withDefault(false));
var $author$project$Data$Billing$isRouteAllowedWhenBlocked = function (route) {
	_v0$13:
	while (true) {
		switch (route.$) {
			case 0:
				return true;
			case 1:
				return true;
			case 2:
				return true;
			case 3:
				return true;
			case 5:
				return true;
			case 6:
				return true;
			case 7:
				return true;
			case 8:
				return true;
			case 9:
				return true;
			case 10:
				return true;
			case 11:
				return true;
			case 4:
				if (route.a.$ === 7) {
					return true;
				} else {
					break _v0$13;
				}
			case 22:
				return true;
			default:
				break _v0$13;
		}
	}
	return false;
};
var $author$project$Pages$init = F2(
	function (shared, oldPage) {
		return ($author$project$Data$Billing$isBlocked(shared.lB) && (!$author$project$Data$Billing$isRouteAllowedWhenBlocked(shared.pv))) ? _Utils_Tuple3(
			$author$project$Pages$RedirectPage,
			A2($author$project$Route$replaceUrl, shared.nZ, $author$project$Route$WelcomeBack),
			$author$project$Shared$NoOp) : A2($author$project$Pages$initPage, shared, oldPage);
	});
var $author$project$Shared$CheckBilling = {$: 22};
var $author$project$Shared$CheckUpdate = {$: 20};
var $author$project$Shared$Guest = {$: 1};
var $author$project$Shared$LoggedIn = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Process$sleep = _Process_sleep;
var $author$project$Utils$delay = F2(
	function (time, msg) {
		return A2(
			$elm$core$Task$perform,
			$elm$core$Basics$identity,
			A2(
				$elm$core$Task$andThen,
				$elm$core$Basics$always(
					$elm$core$Task$succeed(msg)),
				$elm$core$Process$sleep(time)));
	});
var $author$project$Route$ChangePassword = function (a) {
	return {$: 2, a: a};
};
var $author$project$Route$EnterpriseEmployees = {$: 18};
var $author$project$Route$EnterpriseHistoryDetails = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$Route$PosCloseCashier = {$: 10};
var $author$project$Route$PosEdit = function (a) {
	return {$: 8, a: a};
};
var $author$project$Route$PosLocalize = function (a) {
	return {$: 9, a: a};
};
var $author$project$Route$PosRegister = {$: 6};
var $author$project$Route$RecoverPassword = {$: 1};
var $author$project$Route$SavedOrderDetails = function (a) {
	return {$: 15, a: a};
};
var $author$project$Route$ZenviaChat = {$: 20};
var $author$project$Route$CardExtract = function (a) {
	return {$: 3, a: a};
};
var $author$project$Route$CompanyOrderHistory = function (a) {
	return {$: 13, a: a};
};
var $author$project$Route$Equipments = {$: 1};
var $author$project$Route$SalesReport = {$: 6};
var $author$project$Route$SessionsReport = {$: 7};
var $author$project$Route$CompanyOrderDetail = function (a) {
	return {$: 14, a: a};
};
var $elm$url$Url$Parser$Internal$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$Query$custom = F2(
	function (key, func) {
		return function (dict) {
			return func(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Dict$get, key, dict)));
		};
	});
var $elm$url$Url$Parser$Query$int = function (key) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		key,
		function (stringList) {
			if (stringList.b && (!stringList.b.b)) {
				var str = stringList.a;
				return $elm$core$String$toInt(str);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		});
};
var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {b_: frag, cb: params, bE: unvisited, di: value, cB: visited};
	});
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var visited = _v0.cB;
		var unvisited = _v0.bE;
		var params = _v0.cb;
		var frag = _v0.b_;
		var value = _v0.di;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0;
		return function (_v1) {
			var visited = _v1.cB;
			var unvisited = _v1.bE;
			var params = _v1.cb;
			var frag = _v1.b_;
			var value = _v1.di;
			return A2(
				$elm$core$List$map,
				$elm$url$Url$Parser$mapState(value),
				parseArg(
					A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
		};
	});
var $elm$url$Url$Parser$query = function (_v0) {
	var queryParser = _v0;
	return function (_v1) {
		var visited = _v1.cB;
		var unvisited = _v1.bE;
		var params = _v1.cb;
		var frag = _v1.b_;
		var value = _v1.di;
		return _List_fromArray(
			[
				A5(
				$elm$url$Url$Parser$State,
				visited,
				unvisited,
				params,
				frag,
				value(
					queryParser(params)))
			]);
	};
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$url$Url$Parser$slash = F2(
	function (_v0, _v1) {
		var parseBefore = _v0;
		var parseAfter = _v1;
		return function (state) {
			return A2(
				$elm$core$List$concatMap,
				parseAfter,
				parseBefore(state));
		};
	});
var $elm$url$Url$Parser$questionMark = F2(
	function (parser, queryParser) {
		return A2(
			$elm$url$Url$Parser$slash,
			parser,
			$elm$url$Url$Parser$query(queryParser));
	});
var $elm$url$Url$Parser$s = function (str) {
	return function (_v0) {
		var visited = _v0.cB;
		var unvisited = _v0.bE;
		var params = _v0.cb;
		var frag = _v0.b_;
		var value = _v0.di;
		if (!unvisited.b) {
			return _List_Nil;
		} else {
			var next = unvisited.a;
			var rest = unvisited.b;
			return _Utils_eq(next, str) ? _List_fromArray(
				[
					A5(
					$elm$url$Url$Parser$State,
					A2($elm$core$List$cons, next, visited),
					rest,
					params,
					frag,
					value)
				]) : _List_Nil;
		}
	};
};
var $elm$url$Url$Parser$custom = F2(
	function (tipe, stringToSomething) {
		return function (_v0) {
			var visited = _v0.cB;
			var unvisited = _v0.bE;
			var params = _v0.cb;
			var frag = _v0.b_;
			var value = _v0.di;
			if (!unvisited.b) {
				return _List_Nil;
			} else {
				var next = unvisited.a;
				var rest = unvisited.b;
				var _v2 = stringToSomething(next);
				if (!_v2.$) {
					var nextValue = _v2.a;
					return _List_fromArray(
						[
							A5(
							$elm$url$Url$Parser$State,
							A2($elm$core$List$cons, next, visited),
							rest,
							params,
							frag,
							value(nextValue))
						]);
				} else {
					return _List_Nil;
				}
			}
		};
	});
var $elm$url$Url$Parser$string = A2($elm$url$Url$Parser$custom, 'STRING', $elm$core$Maybe$Just);
var $elm$url$Url$Parser$Query$string = function (key) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		key,
		function (stringList) {
			if (stringList.b && (!stringList.b.b)) {
				var str = stringList.a;
				return $elm$core$Maybe$Just(str);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		});
};
var $author$project$Route$companyOrderDetailParser = A2(
	$elm$url$Url$Parser$map,
	F4(
		function (companyID, detailID, maybePage, source) {
			return $author$project$Route$CompanyOrderDetail(
				{l8: companyID, mF: detailID, ob: maybePage, pO: source});
		}),
	A2(
		$elm$url$Url$Parser$slash,
		$elm$url$Url$Parser$s('empresas'),
		A2(
			$elm$url$Url$Parser$slash,
			$elm$url$Url$Parser$s('historico'),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$string,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('detail'),
					A2(
						$elm$url$Url$Parser$questionMark,
						A2(
							$elm$url$Url$Parser$questionMark,
							$elm$url$Url$Parser$string,
							$elm$url$Url$Parser$Query$int('page')),
						$elm$url$Url$Parser$Query$string('source')))))));
var $author$project$Route$companyOrderHistoryParser = A2(
	$elm$url$Url$Parser$slash,
	$elm$url$Url$Parser$s('empresas'),
	A2(
		$elm$url$Url$Parser$slash,
		$elm$url$Url$Parser$s('historico'),
		$elm$url$Url$Parser$string));
var $elm$url$Url$Parser$oneOf = function (parsers) {
	return function (state) {
		return A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var parser = _v0;
				return parser(state);
			},
			parsers);
	};
};
var $author$project$Route$parserUser = A2(
	$elm$url$Url$Parser$map,
	F3(
		function (name, document, email) {
			return $author$project$Route$Users(
				{iI: document, mX: email, c3: name});
		}),
	A2(
		$elm$url$Url$Parser$questionMark,
		A2(
			$elm$url$Url$Parser$questionMark,
			A2(
				$elm$url$Url$Parser$questionMark,
				$elm$url$Url$Parser$s($author$project$Route$adminRouteUsers.b),
				$elm$url$Url$Parser$Query$string($author$project$Route$adminRouteUsers.T.c3)),
			$elm$url$Url$Parser$Query$string($author$project$Route$adminRouteUsers.T.iI)),
		$elm$url$Url$Parser$Query$string($author$project$Route$adminRouteUsers.T.mX)));
var $author$project$Route$parserSalesV2 = A2(
	$elm$url$Url$Parser$map,
	F3(
		function (page, startDate, endDate) {
			return {
				bl: endDate,
				bv: A2($elm$core$Maybe$withDefault, 1, page),
				bB: startDate
			};
		}),
	A2(
		$elm$url$Url$Parser$questionMark,
		A2(
			$elm$url$Url$Parser$questionMark,
			A2(
				$elm$url$Url$Parser$questionMark,
				$elm$url$Url$Parser$s('vendas'),
				$elm$url$Url$Parser$Query$int('page')),
			$elm$url$Url$Parser$Query$string('startDate')),
		$elm$url$Url$Parser$Query$string('endDate')));
var $author$project$Route$reportsParser = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[$author$project$Route$parserSalesV2]));
var $author$project$Route$adminMatchers = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			$author$project$Route$parserUser,
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Equipments,
			$elm$url$Url$Parser$s('equipamentos')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$CardExtract,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('cartoes'),
				$elm$url$Url$Parser$string)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Cards,
			A2(
				$elm$url$Url$Parser$questionMark,
				A2(
					$elm$url$Url$Parser$questionMark,
					$elm$url$Url$Parser$s('cartoes'),
					$elm$url$Url$Parser$Query$int('pagina')),
				$elm$url$Url$Parser$Query$string('busca'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Vehicles,
			A2(
				$elm$url$Url$Parser$questionMark,
				A2(
					$elm$url$Url$Parser$questionMark,
					A2(
						$elm$url$Url$Parser$questionMark,
						$elm$url$Url$Parser$s('veiculos'),
						$elm$url$Url$Parser$Query$int('pagina')),
					$elm$url$Url$Parser$Query$string('busca')),
				$elm$url$Url$Parser$Query$string('active'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$AccountabilityReport,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('relatorios'),
				$elm$url$Url$Parser$s('arrecadacao'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$SalesReport,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('relatorios'),
				$elm$url$Url$Parser$s('vendas'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$SessionsReport,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('relatorios'),
				$elm$url$Url$Parser$s('sessoes'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$SessionsWithoutPouchReport,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('relatorios'),
				$elm$url$Url$Parser$s('sessoes-sem-malote'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Reports,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('relatorios'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('v2'),
					$author$project$Route$reportsParser))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$PaymentGuides,
			$elm$url$Url$Parser$s('guias')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$PaymentBillets,
			$elm$url$Url$Parser$s('boletos')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$CompanyOrders,
			$elm$url$Url$Parser$s('empresas')),
			A2($elm$url$Url$Parser$map, $author$project$Route$CompanyOrderHistory, $author$project$Route$companyOrderHistoryParser),
			$author$project$Route$companyOrderDetailParser
		]));
var $author$project$Route$companyOrderDetailParserCompany = A2(
	$elm$url$Url$Parser$slash,
	$elm$url$Url$Parser$s('historico'),
	A2(
		$elm$url$Url$Parser$slash,
		$elm$url$Url$Parser$s('detail'),
		A2(
			$elm$url$Url$Parser$questionMark,
			$elm$url$Url$Parser$string,
			$elm$url$Url$Parser$Query$int('page'))));
var $elm$url$Url$Parser$Query$enum = F2(
	function (key, dict) {
		return A2(
			$elm$url$Url$Parser$Query$custom,
			key,
			function (stringList) {
				if (stringList.b && (!stringList.b.b)) {
					var str = stringList.a;
					return A2($elm$core$Dict$get, str, dict);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			});
	});
var $author$project$Route$MyAccount = function (a) {
	return {$: 7, a: a};
};
var $author$project$Route$ClassesCreate = {$: 2};
var $author$project$Route$ClassesDetails = function (a) {
	return {$: 1, a: a};
};
var $author$project$Route$classesParser = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$ClassesList,
			$elm$url$Url$Parser$s($author$project$Route$panelRouteString.dv.n3.b)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$ClassesDetails,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$panelRouteString.dv.dE.b),
				$elm$url$Url$Parser$string)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$ClassesCreate,
			$elm$url$Url$Parser$s($author$project$Route$panelRouteString.dv.f9.b))
		]));
var $author$project$Route$financialAccountParser = A2(
	$elm$url$Url$Parser$map,
	F3(
		function (startDate, endDate, page) {
			return $author$project$Route$FinancialAccount(
				{
					bl: endDate,
					bv: A2($elm$core$Maybe$withDefault, 1, page),
					bB: startDate
				});
		}),
	A2(
		$elm$url$Url$Parser$questionMark,
		A2(
			$elm$url$Url$Parser$questionMark,
			A2(
				$elm$url$Url$Parser$questionMark,
				$elm$url$Url$Parser$s($author$project$Route$panelRouteString.e.V.b),
				$elm$url$Url$Parser$Query$string($author$project$Route$panelRouteString.e.V.T.bB)),
			$elm$url$Url$Parser$Query$string($author$project$Route$panelRouteString.e.V.T.bl)),
		$elm$url$Url$Parser$Query$int($author$project$Route$panelRouteString.e.V.T.bv)));
var $author$project$Services$Financial$maybeDecodePagarmeOrderStatus = function (str) {
	switch (str) {
		case 'pending':
			return $elm$core$Maybe$Just(0);
		case 'canceled':
			return $elm$core$Maybe$Just(1);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Services$Models$maybeDecoderPaymentMethod = function (str) {
	switch (str) {
		case 'cash':
			return $elm$core$Maybe$Just(0);
		case 'credit_card':
			return $elm$core$Maybe$Just(1);
		case 'debit_card':
			return $elm$core$Maybe$Just(2);
		case 'pix':
			return $elm$core$Maybe$Just(3);
		case 'guia_local':
			return $elm$core$Maybe$Just(4);
		case 'boleto':
			return $elm$core$Maybe$Just(5);
		case 'guiche_reversal':
			return $elm$core$Maybe$Just(6);
		case 'ticket_window_cash':
			return $elm$core$Maybe$Just(7);
		case 'ticket_window_credit_card':
			return $elm$core$Maybe$Just(8);
		case 'ticket_window_debit_card':
			return $elm$core$Maybe$Just(9);
		case '':
			return $elm$core$Maybe$Just(10);
		case 'estorno':
			return $elm$core$Maybe$Just(11);
		default:
			var str_ = str;
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Route$financialPendingTransactionsParser = A2(
	$elm$url$Url$Parser$map,
	F5(
		function (page, startDate, endDate, statusStr, paymentMethodStr) {
			return $author$project$Route$FinancialPendingTransactions(
				{
					bl: endDate,
					bv: A2($elm$core$Maybe$withDefault, 1, page),
					jW: A2($elm$core$Maybe$andThen, $author$project$Services$Models$maybeDecoderPaymentMethod, paymentMethodStr),
					bB: startDate,
					kK: A2($elm$core$Maybe$andThen, $author$project$Services$Financial$maybeDecodePagarmeOrderStatus, statusStr)
				});
		}),
	A2(
		$elm$url$Url$Parser$questionMark,
		A2(
			$elm$url$Url$Parser$questionMark,
			A2(
				$elm$url$Url$Parser$questionMark,
				A2(
					$elm$url$Url$Parser$questionMark,
					A2(
						$elm$url$Url$Parser$questionMark,
						$elm$url$Url$Parser$s($author$project$Route$panelRouteString.e.S.b),
						$elm$url$Url$Parser$Query$int($author$project$Route$panelRouteString.e.S.T.bv)),
					$elm$url$Url$Parser$Query$string($author$project$Route$panelRouteString.e.S.T.bB)),
				$elm$url$Url$Parser$Query$string($author$project$Route$panelRouteString.e.S.T.bl)),
			$elm$url$Url$Parser$Query$string($author$project$Route$panelRouteString.e.S.T.kK)),
		$elm$url$Url$Parser$Query$string($author$project$Route$panelRouteString.e.S.T.jW)));
var $author$project$Services$Financial$maybeDecodePagarmePayablesStatus = function (str) {
	switch (str) {
		case 'paid':
			return $elm$core$Maybe$Just(0);
		case 'waiting_funds':
			return $elm$core$Maybe$Just(1);
		case 'prepaid':
			return $elm$core$Maybe$Just(2);
		default:
			var str_ = str;
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Route$financialTransactionsParser = A2(
	$elm$url$Url$Parser$map,
	F6(
		function (page, dynamicRecordTotal, startDate, endDate, statusStr, paymentMethod) {
			return $author$project$Route$FinancialTransactions(
				{
					gk: A2($elm$core$Maybe$withDefault, 20, dynamicRecordTotal),
					bl: endDate,
					bv: A2($elm$core$Maybe$withDefault, 1, page),
					jW: A2($elm$core$Maybe$andThen, $author$project$Services$Models$maybeDecoderPaymentMethod, paymentMethod),
					bB: startDate,
					kK: A2($elm$core$Maybe$andThen, $author$project$Services$Financial$maybeDecodePagarmePayablesStatus, statusStr)
				});
		}),
	A2(
		$elm$url$Url$Parser$questionMark,
		A2(
			$elm$url$Url$Parser$questionMark,
			A2(
				$elm$url$Url$Parser$questionMark,
				A2(
					$elm$url$Url$Parser$questionMark,
					A2(
						$elm$url$Url$Parser$questionMark,
						A2(
							$elm$url$Url$Parser$questionMark,
							$elm$url$Url$Parser$s($author$project$Route$panelRouteString.e.a9.b),
							$elm$url$Url$Parser$Query$int($author$project$Route$panelRouteString.e.a9.T.bv)),
						$elm$url$Url$Parser$Query$int($author$project$Route$panelRouteString.e.a9.T.gk)),
					$elm$url$Url$Parser$Query$string($author$project$Route$panelRouteString.e.a9.T.bB)),
				$elm$url$Url$Parser$Query$string($author$project$Route$panelRouteString.e.a9.T.bl)),
			$elm$url$Url$Parser$Query$string($author$project$Route$panelRouteString.e.a9.T.kK)),
		$elm$url$Url$Parser$Query$string($author$project$Route$panelRouteString.e.a9.T.jW)));
var $author$project$Route$panelFinancialParser = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[$author$project$Route$financialAccountParser, $author$project$Route$financialTransactionsParser, $author$project$Route$financialPendingTransactionsParser]));
var $author$project$Route$Account = 1;
var $author$project$Route$MyAccountPassword = 0;
var $author$project$Route$panelMyAccountParser = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$url$Url$Parser$map,
			0,
			$elm$url$Url$Parser$s($author$project$Route$panelRouteString.bt.oN)),
			A2(
			$elm$url$Url$Parser$map,
			1,
			$elm$url$Url$Parser$s($author$project$Route$panelRouteString.bt.V))
		]));
var $author$project$Route$parserEquipmentsV2 = A2(
	$elm$url$Url$Parser$map,
	F2(
		function (serial, vehicle) {
			return $author$project$Route$EquipmentsV2(
				{kw: serial, k2: vehicle});
		}),
	A2(
		$elm$url$Url$Parser$questionMark,
		A2(
			$elm$url$Url$Parser$questionMark,
			$elm$url$Url$Parser$s($author$project$Route$panelRouteString.cU.b),
			$elm$url$Url$Parser$Query$string($author$project$Route$panelRouteString.cU.kw)),
		$elm$url$Url$Parser$Query$string($author$project$Route$panelRouteString.cU.k2)));
var $author$project$Route$parserHistory = A2(
	$elm$url$Url$Parser$map,
	F7(
		function (startDate, endDate, page, dynamicRecordTotal, executionUserID, userStr, actionType) {
			var strToList = function (l) {
				return A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						$elm$core$String$split(','),
						l));
			};
			return $author$project$Route$History(
				{
					bK: strToList(actionType),
					gk: A2($elm$core$Maybe$withDefault, 500, dynamicRecordTotal),
					bl: endDate,
					bZ: strToList(executionUserID),
					bv: A2($elm$core$Maybe$withDefault, 1, page),
					bB: startDate,
					kZ: userStr
				});
		}),
	A2(
		$elm$url$Url$Parser$questionMark,
		A2(
			$elm$url$Url$Parser$questionMark,
			A2(
				$elm$url$Url$Parser$questionMark,
				A2(
					$elm$url$Url$Parser$questionMark,
					A2(
						$elm$url$Url$Parser$questionMark,
						A2(
							$elm$url$Url$Parser$questionMark,
							A2(
								$elm$url$Url$Parser$questionMark,
								$elm$url$Url$Parser$s($author$project$Route$panelRouteString.eN.b),
								$elm$url$Url$Parser$Query$string($author$project$Route$panelRouteString.eN.T.bB)),
							$elm$url$Url$Parser$Query$string($author$project$Route$panelRouteString.eN.T.bl)),
						$elm$url$Url$Parser$Query$int($author$project$Route$panelRouteString.eN.T.bv)),
					$elm$url$Url$Parser$Query$int($author$project$Route$panelRouteString.eN.T.gk)),
				$elm$url$Url$Parser$Query$string($author$project$Route$panelRouteString.eN.T.bZ)),
			$elm$url$Url$Parser$Query$string($author$project$Route$panelRouteString.eN.T.kZ)),
		$elm$url$Url$Parser$Query$string($author$project$Route$panelRouteString.eN.T.bK)));
var $author$project$Services$Models$ASC = 0;
var $author$project$Services$Models$DESC = 1;
var $author$project$Services$Models$decodeOrderType = function (typeStr) {
	switch (typeStr) {
		case 'asc':
			return $elm$core$Maybe$Just(0);
		case 'desc':
			return $elm$core$Maybe$Just(1);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Route$parserManageFare = A2(
	$elm$url$Url$Parser$map,
	F2(
		function (currentOrder, currentOrderType) {
			return $author$project$Route$ManageFare(
				{
					mn: currentOrder,
					mo: A2($elm$core$Maybe$andThen, $author$project$Services$Models$decodeOrderType, currentOrderType)
				});
		}),
	A2(
		$elm$url$Url$Parser$questionMark,
		A2(
			$elm$url$Url$Parser$questionMark,
			$elm$url$Url$Parser$s($author$project$Route$panelRouteString.b6.b),
			$elm$url$Url$Parser$Query$string($author$project$Route$panelRouteString.b6.T.mn)),
		$elm$url$Url$Parser$Query$string($author$project$Route$panelRouteString.b6.T.mo)));
var $author$project$Route$parserManageLine = A2(
	$elm$url$Url$Parser$map,
	F2(
		function (currentOrder, currentOrderType) {
			return $author$project$Route$ManageLines(
				{
					mn: currentOrder,
					mo: A2($elm$core$Maybe$andThen, $author$project$Services$Models$decodeOrderType, currentOrderType)
				});
		}),
	A2(
		$elm$url$Url$Parser$questionMark,
		A2(
			$elm$url$Url$Parser$questionMark,
			$elm$url$Url$Parser$s($author$project$Route$panelRouteString.b7.b),
			$elm$url$Url$Parser$Query$string($author$project$Route$panelRouteString.b7.T.mn)),
		$elm$url$Url$Parser$Query$string($author$project$Route$panelRouteString.b7.T.mo)));
var $author$project$Route$parserReason = A2(
	$elm$url$Url$Parser$map,
	function (action) {
		return $author$project$Route$Reason(
			{
				hV: A2($elm$core$Maybe$andThen, $author$project$Services$Reason$actionFromCode, action)
			});
	},
	A2(
		$elm$url$Url$Parser$questionMark,
		$elm$url$Url$Parser$s($author$project$Route$panelRouteString.pf.b),
		$elm$url$Url$Parser$Query$string($author$project$Route$panelRouteString.pf.T.hV)));
var $author$project$Route$parserSingleCharge = A2(
	$elm$url$Url$Parser$map,
	$author$project$Route$SingleCharge,
	$elm$url$Url$Parser$s($author$project$Route$panelRouteString.hy.b));
var $author$project$Services$Models$statusReversalApprovalFromStr = function (status) {
	switch (status) {
		case 'system':
			return $elm$core$Maybe$Just(0);
		case 'cashier':
			return $elm$core$Maybe$Just(1);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Route$Details = function (a) {
	return {$: 1, a: a};
};
var $author$project$Route$parserStockList = A2(
	$elm$url$Url$Parser$map,
	function (serial) {
		return $author$project$Route$List(
			{kw: serial});
	},
	A2(
		$elm$url$Url$Parser$questionMark,
		$elm$url$Url$Parser$s($author$project$Route$panelRouteString.kL.n3.b),
		$elm$url$Url$Parser$Query$string($author$project$Route$panelRouteString.kL.n3.T.kw)));
var $author$project$Route$stockParser = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			$author$project$Route$parserStockList,
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Details,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$panelRouteString.kL.dE.b),
				$elm$url$Url$Parser$string))
		]));
var $author$project$Route$panelParser = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			$author$project$Route$parserEquipmentsV2,
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$ReversalApproval,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$panelRouteString.hq.b),
				A2(
					$elm$url$Url$Parser$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Services$Models$statusReversalApprovalFromStr,
						$elm$core$Maybe$withDefault(0)),
					$elm$url$Url$Parser$string))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$PanelFinancial,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$panelRouteString.e.b),
				$author$project$Route$panelFinancialParser)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Classes,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$panelRouteString.dv.b),
				$author$project$Route$classesParser)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$ManagePouches,
			$elm$url$Url$Parser$s($author$project$Route$panelRouteString.gT.b)),
			$author$project$Route$parserManageFare,
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$ManageOperators,
			$elm$url$Url$Parser$s($author$project$Route$panelRouteString.gS.b)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$UpdateEquipment,
			$elm$url$Url$Parser$s($author$project$Route$panelRouteString.hK.b)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$UpdateRequestsEquipments,
			$elm$url$Url$Parser$s($author$project$Route$panelRouteString.hL.b)),
			$author$project$Route$parserReason,
			$author$project$Route$parserSingleCharge,
			$author$project$Route$parserHistory,
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Stock,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$panelRouteString.kL.b),
				$author$project$Route$stockParser)),
			$author$project$Route$parserManageLine,
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$MyAccount,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$panelRouteString.bt.b),
				$author$project$Route$panelMyAccountParser))
		]));
var $author$project$Services$Models$Calculated = 1;
var $author$project$Route$PosGarage = function (a) {
	return {$: 11, a: a};
};
var $author$project$Services$Models$ToCalculate = 0;
var $author$project$Route$parserPosGarage = A2(
	$elm$url$Url$Parser$map,
	F3(
		function (startDate, endDate, status) {
			return $author$project$Route$PosGarage(
				{
					bl: endDate,
					bB: startDate,
					kK: A2($elm$core$Maybe$withDefault, 0, status)
				});
		}),
	A2(
		$elm$url$Url$Parser$slash,
		$elm$url$Url$Parser$s('guiche'),
		A2(
			$elm$url$Url$Parser$questionMark,
			A2(
				$elm$url$Url$Parser$questionMark,
				A2(
					$elm$url$Url$Parser$questionMark,
					$elm$url$Url$Parser$s($author$project$Route$posGarageRouteString.bf.b),
					$elm$url$Url$Parser$Query$string($author$project$Route$posGarageRouteString.bf.bB)),
				$elm$url$Url$Parser$Query$string($author$project$Route$posGarageRouteString.bf.bl)),
			A2(
				$elm$url$Url$Parser$Query$enum,
				$author$project$Route$posGarageRouteString.bf.kK,
				$elm$core$Dict$fromList(
					_List_fromArray(
						[
							_Utils_Tuple2('ToCalculate', 0),
							_Utils_Tuple2('Calculated', 1)
						]))))));
var $author$project$Route$ApplyRefill = 3;
var $author$project$Route$IssueCard = 4;
var $author$project$Route$IssueDuplicate = 5;
var $author$project$Route$RegisterBeneficiary = 6;
var $author$project$Route$SellSingleCharge = 2;
var $author$project$Route$SellTicket = 1;
var $author$project$Route$UnlockCard = 7;
var $elm$url$Url$Parser$top = function (state) {
	return _List_fromArray(
		[state]);
};
var $author$project$Route$passengerMatchers = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2($elm$url$Url$Parser$map, 0, $elm$url$Url$Parser$top),
			A2(
			$elm$url$Url$Parser$map,
			1,
			$elm$url$Url$Parser$s('venda-bilhetes')),
			A2(
			$elm$url$Url$Parser$map,
			2,
			$elm$url$Url$Parser$s('venda-avulsa')),
			A2(
			$elm$url$Url$Parser$map,
			3,
			$elm$url$Url$Parser$s('aplicar-carga')),
			A2(
			$elm$url$Url$Parser$map,
			4,
			$elm$url$Url$Parser$s('emitir-cartao')),
			A2(
			$elm$url$Url$Parser$map,
			5,
			$elm$url$Url$Parser$s('segunda-via-cartao')),
			A2(
			$elm$url$Url$Parser$map,
			6,
			$elm$url$Url$Parser$s('registrar-beneficiario')),
			A2(
			$elm$url$Url$Parser$map,
			7,
			$elm$url$Url$Parser$s('desbloquear-cartao'))
		]));
var $author$project$Route$passengerParser = A2(
	$elm$url$Url$Parser$slash,
	$elm$url$Url$Parser$s('guiche'),
	A2(
		$elm$url$Url$Parser$slash,
		$elm$url$Url$Parser$s('cliente'),
		$elm$url$Url$Parser$string));
var $author$project$Route$administrativeSalesParser = A2(
	$elm$url$Url$Parser$map,
	F3(
		function (startDate, endDate, operatorsID) {
			var strToList = $elm$core$String$split(',');
			return $author$project$Route$AdministrativeSales(
				{
					bl: endDate,
					g6: A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2($elm$core$Maybe$map, strToList, operatorsID)),
					bB: startDate
				});
		}),
	A2(
		$elm$url$Url$Parser$questionMark,
		A2(
			$elm$url$Url$Parser$questionMark,
			A2(
				$elm$url$Url$Parser$questionMark,
				$elm$url$Url$Parser$s($author$project$Route$reportRouteAdministrativeSales.b),
				$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteAdministrativeSales.T.bB)),
			$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteAdministrativeSales.T.bl)),
		$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteAdministrativeSales.T.g6)));
var $author$project$Route$detailedVehicleParser = A2(
	$elm$url$Url$Parser$map,
	F7(
		function (startDate, endDate, vehicleID, vehicleName, vehicle, serial, plate) {
			return $author$project$Route$DetailedVehicle(
				{bl: endDate, ac: plate, kw: serial, bB: startDate, k2: vehicle, fN: vehicleID, hN: vehicleName});
		}),
	A2(
		$elm$url$Url$Parser$questionMark,
		A2(
			$elm$url$Url$Parser$questionMark,
			A2(
				$elm$url$Url$Parser$questionMark,
				A2(
					$elm$url$Url$Parser$questionMark,
					A2(
						$elm$url$Url$Parser$questionMark,
						A2(
							$elm$url$Url$Parser$questionMark,
							A2(
								$elm$url$Url$Parser$questionMark,
								$elm$url$Url$Parser$s($author$project$Route$reportRouteDetailedVehicle.b),
								$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteDetailedVehicle.T.bB)),
							$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteDetailedVehicle.T.bl)),
						$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteDetailedVehicle.T.fN)),
					$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteDetailedVehicle.T.hN)),
				$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteDetailedVehicle.T.k2)),
			$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteDetailedVehicle.T.kw)),
		$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteDetailedVehicle.T.ac)));
var $author$project$Route$detailedVehicleV2Parser = A2(
	$elm$url$Url$Parser$map,
	F7(
		function (startDate, endDate, vehicleID, vehicleName, vehicle, serial, plate) {
			return $author$project$Route$DetailedVehicleV2(
				{bl: endDate, ac: plate, kw: serial, bB: startDate, k2: vehicle, fN: vehicleID, hN: vehicleName});
		}),
	A2(
		$elm$url$Url$Parser$questionMark,
		A2(
			$elm$url$Url$Parser$questionMark,
			A2(
				$elm$url$Url$Parser$questionMark,
				A2(
					$elm$url$Url$Parser$questionMark,
					A2(
						$elm$url$Url$Parser$questionMark,
						A2(
							$elm$url$Url$Parser$questionMark,
							A2(
								$elm$url$Url$Parser$questionMark,
								$elm$url$Url$Parser$s($author$project$Route$reportRouteDetailedVehicleV2.b),
								$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteDetailedVehicleV2.T.bB)),
							$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteDetailedVehicleV2.T.bl)),
						$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteDetailedVehicleV2.T.fN)),
					$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteDetailedVehicleV2.T.hN)),
				$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteDetailedVehicleV2.T.k2)),
			$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteDetailedVehicleV2.T.kw)),
		$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteDetailedVehicleV2.T.ac)));
var $author$project$Route$divergencesParser = A2(
	$elm$url$Url$Parser$map,
	function (startDate) {
		return function (endDate) {
			return function (operatorID) {
				return function (lineCode) {
					return function (page) {
						return function (dynamicRecordTotal) {
							return function (size) {
								return function (fromSimilarity) {
									return function (toSimilarity) {
										return function (serialCard) {
											return function (userName) {
												return function (classID) {
													return function (vehicleID) {
														return function (document) {
															return function (type_) {
																var strToList = $elm$core$String$split(',');
																return $author$project$Route$Divergences(
																	{
																		lX: A2(
																			$elm$core$Maybe$withDefault,
																			_List_Nil,
																			A2($elm$core$Maybe$map, strToList, classID)),
																		iI: document,
																		gk: A2($elm$core$Maybe$withDefault, 20, dynamicRecordTotal),
																		bl: endDate,
																		iY: A2($elm$core$Maybe$withDefault, 0, fromSimilarity),
																		b3: A2(
																			$elm$core$Maybe$withDefault,
																			_List_Nil,
																			A2($elm$core$Maybe$map, strToList, lineCode)),
																		g6: A2(
																			$elm$core$Maybe$withDefault,
																			_List_Nil,
																			A2($elm$core$Maybe$map, strToList, operatorID)),
																		bv: A2($elm$core$Maybe$withDefault, 1, page),
																		kx: serialCard,
																		pJ: A2($elm$core$Maybe$withDefault, 20, size),
																		bB: startDate,
																		kT: A2($elm$core$Maybe$withDefault, 100, toSimilarity),
																		kY: type_,
																		qx: userName,
																		fN: A2(
																			$elm$core$Maybe$withDefault,
																			_List_Nil,
																			A2($elm$core$Maybe$map, strToList, vehicleID))
																	});
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	},
	A2(
		$elm$url$Url$Parser$questionMark,
		A2(
			$elm$url$Url$Parser$questionMark,
			A2(
				$elm$url$Url$Parser$questionMark,
				A2(
					$elm$url$Url$Parser$questionMark,
					A2(
						$elm$url$Url$Parser$questionMark,
						A2(
							$elm$url$Url$Parser$questionMark,
							A2(
								$elm$url$Url$Parser$questionMark,
								A2(
									$elm$url$Url$Parser$questionMark,
									A2(
										$elm$url$Url$Parser$questionMark,
										A2(
											$elm$url$Url$Parser$questionMark,
											A2(
												$elm$url$Url$Parser$questionMark,
												A2(
													$elm$url$Url$Parser$questionMark,
													A2(
														$elm$url$Url$Parser$questionMark,
														A2(
															$elm$url$Url$Parser$questionMark,
															A2(
																$elm$url$Url$Parser$questionMark,
																$elm$url$Url$Parser$s($author$project$Route$reportRouteDivergences.b),
																$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteDivergences.T.bB)),
															$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteDivergences.T.bl)),
														$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteDivergences.T.g6)),
													$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteDivergences.T.b3)),
												$elm$url$Url$Parser$Query$int($author$project$Route$reportRouteDivergences.T.bv)),
											$elm$url$Url$Parser$Query$int($author$project$Route$reportRouteDivergences.T.gk)),
										$elm$url$Url$Parser$Query$int($author$project$Route$reportRouteDivergences.T.pJ)),
									$elm$url$Url$Parser$Query$int($author$project$Route$reportRouteDivergences.T.iY)),
								$elm$url$Url$Parser$Query$int($author$project$Route$reportRouteDivergences.T.kT)),
							$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteDivergences.T.kx)),
						$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteDivergences.T.qx)),
					$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteDivergences.T.lX)),
				$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteDivergences.T.fN)),
			$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteDivergences.T.iI)),
		$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteDivergences.T.kY)));
var $author$project$Route$auditEventParser = A2(
	$elm$url$Url$Parser$map,
	F4(
		function (startDate, endDate, vehicles, errors) {
			var strToList = $elm$core$String$split(',');
			return $author$project$Route$Audit(
				{
					bl: endDate,
					bX: A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2($elm$core$Maybe$map, strToList, errors)),
					bB: startDate,
					en: A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2($elm$core$Maybe$map, strToList, vehicles))
				});
		}),
	A2(
		$elm$url$Url$Parser$questionMark,
		A2(
			$elm$url$Url$Parser$questionMark,
			A2(
				$elm$url$Url$Parser$questionMark,
				A2(
					$elm$url$Url$Parser$questionMark,
					$elm$url$Url$Parser$s($author$project$Route$reportRouteEvent.aj.b),
					$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteEvent.aj.T.bB)),
				$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteEvent.aj.T.bl)),
			$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteEvent.aj.T.en)),
		$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteEvent.aj.T.bX)));
var $author$project$Route$usingDayPerEventParser = A2(
	$elm$url$Url$Parser$map,
	F2(
		function (startDate, endDate) {
			return $author$project$Route$UsingDay(
				{bl: endDate, bB: startDate});
		}),
	A2(
		$elm$url$Url$Parser$questionMark,
		A2(
			$elm$url$Url$Parser$questionMark,
			$elm$url$Url$Parser$s($author$project$Route$reportRouteEvent.cA.b),
			$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteEvent.cA.T.bB)),
		$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteEvent.cA.T.bl)));
var $author$project$Route$usingLinePerEventParser = A2(
	$elm$url$Url$Parser$map,
	F3(
		function (startDate, endDate, lineCode) {
			var strToList = $elm$core$String$split(',');
			return $author$project$Route$UsingLine(
				{
					bl: endDate,
					n2: A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2($elm$core$Maybe$map, strToList, lineCode)),
					bB: startDate
				});
		}),
	A2(
		$elm$url$Url$Parser$questionMark,
		A2(
			$elm$url$Url$Parser$questionMark,
			A2(
				$elm$url$Url$Parser$questionMark,
				$elm$url$Url$Parser$s($author$project$Route$reportRouteEvent.bG.b),
				$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteEvent.bG.T.bB)),
			$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteEvent.bG.T.bl)),
		$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteUsesPerClass.T.b3)));
var $author$project$Route$usingOperatorEventParser = A2(
	$elm$url$Url$Parser$map,
	F3(
		function (startDate, endDate, operators) {
			var strToList = $elm$core$String$split(',');
			return $author$project$Route$UsingOperator(
				{
					bl: endDate,
					c5: A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2($elm$core$Maybe$map, strToList, operators)),
					bB: startDate
				});
		}),
	A2(
		$elm$url$Url$Parser$questionMark,
		A2(
			$elm$url$Url$Parser$questionMark,
			A2(
				$elm$url$Url$Parser$questionMark,
				$elm$url$Url$Parser$s($author$project$Route$reportRouteEvent.bb.b),
				$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteEvent.bb.T.bB)),
			$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteEvent.bb.T.bl)),
		$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteEvent.bb.T.c5)));
var $author$project$Route$usingSessionEventParser = A2(
	$elm$url$Url$Parser$map,
	F5(
		function (startDate, endDate, operators, vehicles, lines) {
			var strToList = $elm$core$String$split(',');
			return $author$project$Route$UsingSession(
				{
					bl: endDate,
					n2: A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2($elm$core$Maybe$map, strToList, lines)),
					c5: A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2($elm$core$Maybe$map, strToList, operators)),
					bB: startDate,
					en: A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2($elm$core$Maybe$map, strToList, vehicles))
				});
		}),
	A2(
		$elm$url$Url$Parser$questionMark,
		A2(
			$elm$url$Url$Parser$questionMark,
			A2(
				$elm$url$Url$Parser$questionMark,
				A2(
					$elm$url$Url$Parser$questionMark,
					A2(
						$elm$url$Url$Parser$questionMark,
						$elm$url$Url$Parser$s($author$project$Route$reportRouteEvent.U.b),
						$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteEvent.U.T.bB)),
					$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteEvent.U.T.bl)),
				$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteEvent.U.T.c5)),
			$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteEvent.U.T.en)),
		$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteEvent.U.T.n2)));
var $author$project$Route$usingVehiclePerEventParser = A2(
	$elm$url$Url$Parser$map,
	F3(
		function (startDate, endDate, vehicleID) {
			var strToList = $elm$core$String$split(',');
			return $author$project$Route$UsingVehicle(
				{
					bl: endDate,
					bB: startDate,
					en: A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2($elm$core$Maybe$map, strToList, vehicleID))
				});
		}),
	A2(
		$elm$url$Url$Parser$questionMark,
		A2(
			$elm$url$Url$Parser$questionMark,
			A2(
				$elm$url$Url$Parser$questionMark,
				$elm$url$Url$Parser$s($author$project$Route$reportRouteEvent.bc.b),
				$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteEvent.bc.T.bB)),
			$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteEvent.bc.T.bl)),
		$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteEvent.bc.T.fN)));
var $author$project$Route$eventParser = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[$author$project$Route$usingVehiclePerEventParser, $author$project$Route$usingLinePerEventParser, $author$project$Route$usingDayPerEventParser, $author$project$Route$usingOperatorEventParser, $author$project$Route$usingSessionEventParser, $author$project$Route$auditEventParser]));
var $author$project$Route$pdfsParser = A2(
	$elm$url$Url$Parser$map,
	$author$project$Route$PDFs,
	$elm$url$Url$Parser$s($author$project$Route$reportRoutePDFs.b));
var $author$project$Route$salesSummarizedParser = A2(
	$elm$url$Url$Parser$map,
	F2(
		function (startDate, endDate) {
			return $author$project$Route$SalesSummarized(
				{bl: endDate, bB: startDate});
		}),
	A2(
		$elm$url$Url$Parser$questionMark,
		A2(
			$elm$url$Url$Parser$questionMark,
			$elm$url$Url$Parser$s($author$project$Route$reportRouteSalesSummarized.b),
			$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteSalesSummarized.T.bB)),
		$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteSalesSummarized.T.bl)));
var $author$project$Route$salesSummarizedV2Parser = A2(
	$elm$url$Url$Parser$map,
	F2(
		function (startDate, endDate) {
			return $author$project$Route$SalesSummarizedV2(
				{bl: endDate, bB: startDate});
		}),
	A2(
		$elm$url$Url$Parser$questionMark,
		A2(
			$elm$url$Url$Parser$questionMark,
			$elm$url$Url$Parser$s($author$project$Route$reportRouteSalesSummarizedV2.b),
			$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteSalesSummarizedV2.T.bB)),
		$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteSalesSummarizedV2.T.bl)));
var $author$project$Route$usageParser = A2(
	$elm$url$Url$Parser$map,
	F9(
		function (startDate, endDate, page, lineCode, classID, operatorID, vehicleID, serialCard, cashierID) {
			return $author$project$Route$Usage(
				{
					ic: cashierID,
					lX: classID,
					bl: endDate,
					b3: lineCode,
					g6: operatorID,
					bv: A2($elm$core$Maybe$withDefault, 1, page),
					kx: serialCard,
					bB: startDate,
					fN: vehicleID
				});
		}),
	A2(
		$elm$url$Url$Parser$questionMark,
		A2(
			$elm$url$Url$Parser$questionMark,
			A2(
				$elm$url$Url$Parser$questionMark,
				A2(
					$elm$url$Url$Parser$questionMark,
					A2(
						$elm$url$Url$Parser$questionMark,
						A2(
							$elm$url$Url$Parser$questionMark,
							A2(
								$elm$url$Url$Parser$questionMark,
								A2(
									$elm$url$Url$Parser$questionMark,
									A2(
										$elm$url$Url$Parser$questionMark,
										$elm$url$Url$Parser$s($author$project$Route$reportRouteUsage.b),
										$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteUsage.T.bB)),
									$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteUsage.T.bl)),
								$elm$url$Url$Parser$Query$int($author$project$Route$reportRouteUsage.T.bv)),
							$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteUsage.T.b3)),
						$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteUsage.T.lX)),
					$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteUsage.T.g6)),
				$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteUsage.T.fN)),
			$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteUsage.T.kx)),
		$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteUsage.T.ic)));
var $author$project$Route$usesPerClassParser = A2(
	$elm$url$Url$Parser$map,
	F8(
		function (startDate, endDate, lineCode, operatorID, vehicleID, page, groupBy, cashierID) {
			return $author$project$Route$UsesPerClass(
				{
					ic: cashierID,
					bl: endDate,
					nB: groupBy,
					b3: lineCode,
					g6: operatorID,
					bv: A2($elm$core$Maybe$withDefault, 1, page),
					bB: startDate,
					fN: vehicleID
				});
		}),
	A2(
		$elm$url$Url$Parser$questionMark,
		A2(
			$elm$url$Url$Parser$questionMark,
			A2(
				$elm$url$Url$Parser$questionMark,
				A2(
					$elm$url$Url$Parser$questionMark,
					A2(
						$elm$url$Url$Parser$questionMark,
						A2(
							$elm$url$Url$Parser$questionMark,
							A2(
								$elm$url$Url$Parser$questionMark,
								A2(
									$elm$url$Url$Parser$questionMark,
									$elm$url$Url$Parser$s($author$project$Route$reportRouteUsesPerClass.b),
									$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteUsesPerClass.T.bB)),
								$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteUsesPerClass.T.bl)),
							$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteUsesPerClass.T.b3)),
						$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteUsesPerClass.T.g6)),
					$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteUsesPerClass.T.fN)),
				$elm$url$Url$Parser$Query$int($author$project$Route$reportRouteUsesPerClass.T.bv)),
			$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteUsesPerClass.T.nB)),
		$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteUsesPerClass.T.ic)));
var $author$project$Route$usesPerDayParser = A2(
	$elm$url$Url$Parser$map,
	F2(
		function (startDate, endDate) {
			return $author$project$Route$UsesPerDay(
				{bl: endDate, bB: startDate});
		}),
	A2(
		$elm$url$Url$Parser$questionMark,
		A2(
			$elm$url$Url$Parser$questionMark,
			$elm$url$Url$Parser$s($author$project$Route$reportRouteUsesPerDay.b),
			$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteUsesPerDay.T.bB)),
		$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteUsesPerDay.T.bl)));
var $author$project$Route$usesPerLineParser = A2(
	$elm$url$Url$Parser$map,
	F2(
		function (startDate, endDate) {
			return $author$project$Route$UsesPerLine(
				{bl: endDate, bB: startDate});
		}),
	A2(
		$elm$url$Url$Parser$questionMark,
		A2(
			$elm$url$Url$Parser$questionMark,
			$elm$url$Url$Parser$s($author$project$Route$reportRouteUsesPerLine.b),
			$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteUsesPerLine.T.bB)),
		$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteUsesPerLine.T.bl)));
var $author$project$Route$usesPerVehicleParser = A2(
	$elm$url$Url$Parser$map,
	F2(
		function (startDate, endDate) {
			return $author$project$Route$UsesPerVehicle(
				{bl: endDate, bB: startDate});
		}),
	A2(
		$elm$url$Url$Parser$questionMark,
		A2(
			$elm$url$Url$Parser$questionMark,
			$elm$url$Url$Parser$s($author$project$Route$reportRouteUsesPerVehicle.b),
			$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteUsesPerVehicle.T.bB)),
		$elm$url$Url$Parser$Query$string($author$project$Route$reportRouteUsesPerVehicle.T.bl)));
var $author$project$Route$reportParser = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			$author$project$Route$usesPerVehicleParser,
			$author$project$Route$usesPerDayParser,
			$author$project$Route$usesPerLineParser,
			$author$project$Route$usageParser,
			$author$project$Route$usesPerClassParser,
			$author$project$Route$detailedVehicleParser,
			$author$project$Route$detailedVehicleV2Parser,
			$author$project$Route$salesSummarizedParser,
			$author$project$Route$salesSummarizedV2Parser,
			$author$project$Route$administrativeSalesParser,
			$author$project$Route$divergencesParser,
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Event,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$reportRouteEvent.b),
				$author$project$Route$eventParser)),
			$author$project$Route$pdfsParser
		]));
var $author$project$Route$matchers = function () {
	var isOpen = A2(
		$elm$url$Url$Parser$Query$enum,
		'isOpen',
		$elm$core$Dict$fromList(
			_List_fromArray(
				[
					_Utils_Tuple2('true', true),
					_Utils_Tuple2('false', false)
				])));
	return $elm$url$Url$Parser$oneOf(
		_List_fromArray(
			[
				A2($elm$url$Url$Parser$map, $author$project$Route$Login, $elm$url$Url$Parser$top),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$RecoverPassword,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('recuperar-senha'),
					$elm$url$Url$Parser$top)),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$WelcomeBack,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('welcome-back'),
					$elm$url$Url$Parser$top)),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$Report,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('report'),
					$author$project$Route$reportParser)),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$ChangePassword,
				A2(
					$elm$url$Url$Parser$slash,
					A2(
						$elm$url$Url$Parser$questionMark,
						$elm$url$Url$Parser$s('mude-minha-senha'),
						$elm$url$Url$Parser$Query$string('token')),
					$elm$url$Url$Parser$top)),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$Guiche,
				$elm$url$Url$Parser$s('guiche')),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$PosRegister,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('guiche'),
					$elm$url$Url$Parser$s('cadastrar'))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$PosEdit,
				A2(
					$elm$url$Url$Parser$slash,
					$author$project$Route$passengerParser,
					$elm$url$Url$Parser$s('editar'))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$Passenger,
				A2($elm$url$Url$Parser$slash, $author$project$Route$passengerParser, $author$project$Route$passengerMatchers)),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$PosLocalize,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('guiche'),
					A2(
						$elm$url$Url$Parser$questionMark,
						$elm$url$Url$Parser$s('localizar'),
						$elm$url$Url$Parser$Query$string('busca')))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$PosCloseCashier,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('guiche'),
					$elm$url$Url$Parser$s('fechar-caixa'))),
				$author$project$Route$parserPosGarage,
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$EnterpriseRegister,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('empresa'),
					A2(
						$elm$url$Url$Parser$questionMark,
						$elm$url$Url$Parser$s('registrar'),
						$elm$url$Url$Parser$Query$string('conId')))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$EnterpriseDashboard,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('empresa'),
					A2(
						$elm$url$Url$Parser$questionMark,
						A2(
							$elm$url$Url$Parser$questionMark,
							$elm$url$Url$Parser$s('painel'),
							isOpen),
						$elm$url$Url$Parser$Query$string('details')))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$SavedOrderLists,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('empresa'),
					$elm$url$Url$Parser$s('saved-order-lists'))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$SavedOrderDetails,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('empresa'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('saved-order-lists'),
						$elm$url$Url$Parser$string))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$EnterpriseHistory,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('empresa'),
					$elm$url$Url$Parser$s('historico'))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$EnterpriseHistoryDetails,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('empresa'),
					$author$project$Route$companyOrderDetailParserCompany)),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$EnterpriseEmployees,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('empresa'),
					$elm$url$Url$Parser$s('funcionarios'))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$Admin,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('admin'),
					A2(
						$elm$url$Url$Parser$questionMark,
						$author$project$Route$adminMatchers,
						$elm$url$Url$Parser$Query$string('conId')))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$ZenviaChat,
				$elm$url$Url$Parser$s('zenvia-chat')),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$Panel,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Route$panelRouteString.b),
					$author$project$Route$panelParser)),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$NotFound,
				$elm$url$Url$Parser$s('nao-encontrada'))
			]));
}();
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.bE;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.di);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.di);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 1) {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 1) {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.oO),
					$elm$url$Url$Parser$prepareQuery(url.pe),
					url.iX,
					$elm$core$Basics$identity)));
	});
var $author$project$Route$parseUrl = function (url) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Route$NotFound,
		A2($elm$url$Url$Parser$parse, $author$project$Route$matchers, url));
};
var $author$project$Shared$init = F3(
	function (key, url, m_user) {
		return _Utils_Tuple2(
			{
				lB: $elm$core$Maybe$Nothing,
				iG: $elm$core$Maybe$Nothing,
				nZ: key,
				j_: false,
				pv: $author$project$Route$parseUrl(url),
				pF: A2(
					$elm$core$Maybe$withDefault,
					$author$project$Shared$Guest,
					A2($elm$core$Maybe$map, $author$project$Shared$LoggedIn, m_user)),
				kS: $elm$time$Time$utc,
				qq: false,
				qr: $elm$core$Maybe$Nothing,
				qt: url
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Utils$delay, 0, $author$project$Shared$CheckUpdate),
						A2($author$project$Utils$delay, 0, $author$project$Shared$CheckBilling)
					])));
	});
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $elm$json$Json$Encode$bool = _Json_wrap;
var $author$project$Main$toggleSocket = _Platform_outgoingPort('toggleSocket', $elm$json$Json$Encode$bool);
var $author$project$Main$socketCmd = F2(
	function (oldRoute, newRoute) {
		var useSocket = function (route) {
			_v0$5:
			while (true) {
				switch (route.$) {
					case 5:
						return true;
					case 7:
						switch (route.b) {
							case 7:
								var _v1 = route.b;
								return true;
							case 4:
								var _v2 = route.b;
								return true;
							case 3:
								var _v3 = route.b;
								return true;
							default:
								break _v0$5;
						}
					case 8:
						return true;
					default:
						break _v0$5;
				}
			}
			return false;
		};
		var openSocket = (!useSocket(oldRoute)) && useSocket(newRoute);
		var closeSocket = useSocket(oldRoute) && (!useSocket(newRoute));
		return openSocket ? $author$project$Main$toggleSocket(true) : (closeSocket ? $author$project$Main$toggleSocket(false) : $elm$core$Platform$Cmd$none);
	});
var $author$project$Shared$GotBilling = function (a) {
	return {$: 23, a: a};
};
var $author$project$Shared$GotCheckUpdate = function (a) {
	return {$: 21, a: a};
};
var $author$project$Shared$GotUnauthorizedErrorNow = function (a) {
	return {$: 18, a: a};
};
var $author$project$Gen$Environment$buildVersion = $elm$core$Maybe$Just(1791938780453);
var $author$project$Services$Bot$checkUpdate = function (options) {
	return $elm$http$Http$request(
		{
			lG: $elm$http$Http$emptyBody,
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				options.ow,
				A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int)),
			nG: _List_fromArray(
				[
					A2($elm$http$Http$header, 'Cache-Control', 'no-cache')
				]),
			of: 'GET',
			p5: $elm$core$Maybe$Nothing,
			qi: $elm$core$Maybe$Nothing,
			qt: '/data/version'
		});
};
var $author$project$Shared$consoleError = _Platform_outgoingPort('consoleError', $elm$json$Json$Encode$string);
var $author$project$Shared$copy = _Platform_outgoingPort(
	'copy',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'errorMessage',
					$elm$json$Json$Encode$string($.m0)),
					_Utils_Tuple2(
					'successMessage',
					$elm$json$Json$Encode$string($.pZ)),
					_Utils_Tuple2(
					'value',
					$elm$json$Json$Encode$string($.di))
				]));
	});
var $author$project$Services$Models$permissionCODEToString = function (permission) {
	switch (permission.$) {
		case 1:
			return 'PERMISSION.ADD.PERMISSION';
		case 2:
			switch (permission.a) {
				case 0:
					var _v1 = permission.a;
					return 'usuarioSistema.Listar';
				case 1:
					var _v2 = permission.a;
					return 'usuarioSistema.Incluir';
				case 2:
					var _v3 = permission.a;
					return 'usuarioSistema.Editar';
				default:
					var _v4 = permission.a;
					return 'usuarioSistema.Acessar';
			}
		case 4:
			switch (permission.a) {
				case 0:
					var _v5 = permission.a;
					return 'equipamentos.Listar';
				case 1:
					var _v6 = permission.a;
					return 'equipamentos.Incluir';
				case 2:
					var _v7 = permission.a;
					return 'equipamentos.Editar';
				default:
					var _v8 = permission.a;
					return 'equipamentos.Acessar';
			}
		case 3:
			switch (permission.a) {
				case 0:
					var _v9 = permission.a;
					return 'guiche.Extrato';
				case 1:
					var _v10 = permission.a;
					return 'guiche.Acessar';
				case 2:
					var _v11 = permission.a;
					return 'guiche.transferencia';
				case 3:
					var _v12 = permission.a;
					return 'guiche.ListaCargas';
				default:
					var _v13 = permission.a;
					return 'guiche.Pedidos';
			}
		case 5:
			switch (permission.a.$) {
				case 0:
					return 'relatorios.UsosVeiculo';
				case 1:
					return 'relatorios.UsosDia';
				case 2:
					return 'relatorios.UsosLinha';
				case 3:
					var _v14 = permission.a;
					return 'relatorios.Vendas';
				case 4:
					var _v15 = permission.a;
					return 'relatorios.VeiculoDetalhado';
				case 5:
					var _v16 = permission.a;
					return 'relatorios.VendasResumido';
				case 6:
					var _v17 = permission.a;
					return 'relatorios.Acessar';
				case 7:
					var _v18 = permission.a;
					return 'relatorios.SessoesSemMalote';
				case 8:
					var _v19 = permission.a;
					return 'relatorios.Usos';
				default:
					var _v20 = permission.a;
					return 'relatorios.UsosClasses';
			}
		case 6:
			switch (permission.a) {
				case 0:
					var _v21 = permission.a;
					return 'relatorioEventos.UsosDia';
				case 1:
					var _v22 = permission.a;
					return 'relatorioEventos.UsosVeiculo';
				case 2:
					var _v23 = permission.a;
					return 'relatorioEventos.UsosOperador';
				case 3:
					var _v24 = permission.a;
					return 'relatorioEventos.UsosLinha';
				default:
					var _v25 = permission.a;
					return 'relatorioEventos.UsosSessao';
			}
		case 7:
			if (!permission.a) {
				var _v26 = permission.a;
				return 'empresas.Estornar';
			} else {
				var _v27 = permission.a;
				return 'empresas.ISS';
			}
		case 8:
			if (!permission.a) {
				var _v28 = permission.a;
				return 'estornos.Acessar';
			} else {
				var _v29 = permission.a;
				return 'estornos.Baixar';
			}
		case 9:
			switch (permission.a) {
				case 0:
					var _v30 = permission.a;
					return 'financeiro.Acessar';
				case 1:
					var _v31 = permission.a;
					return 'financeiro.Saque';
				case 3:
					var _v32 = permission.a;
					return 'financeiro.TransacoesPendentes';
				default:
					var _v33 = permission.a;
					return 'financeiro.TransacoesPagas';
			}
		case 10:
			if (!permission.a) {
				var _v34 = permission.a;
				return 'malote.Acessar';
			} else {
				var _v35 = permission.a;
				return 'malote.Cadastrar';
			}
		case 11:
			if (!permission.a) {
				var _v36 = permission.a;
				return 'operadores.Acessar';
			} else {
				var _v37 = permission.a;
				return 'operadores.Editar';
			}
		case 12:
			if (!permission.a) {
				var _v38 = permission.a;
				return 'tarifas.Acessar';
			} else {
				var _v39 = permission.a;
				return 'tarifas.Editar';
			}
		case 13:
			if (!permission.a) {
				var _v40 = permission.a;
				return 'linhas.Acessar';
			} else {
				var _v41 = permission.a;
				return 'linhas.Editar';
			}
		case 14:
			if (!permission.a) {
				var _v42 = permission.a;
				return 'AtualizacaoEquipamentos.Listar';
			} else {
				var _v43 = permission.a;
				return 'AtualizacaoEquipamentos.Atualizar';
			}
		case 15:
			if (!permission.a) {
				var _v44 = permission.a;
				return 'biometria.Acessar';
			} else {
				var _v45 = permission.a;
				return 'biometria.Editar';
			}
		case 16:
			var _v46 = permission.a;
			return 'estoque.Acessar';
		case 17:
			if (!permission.a) {
				var _v47 = permission.a;
				return 'motivos.Acessar';
			} else {
				var _v48 = permission.a;
				return 'motivos.Editar';
			}
		case 18:
			if (!permission.a) {
				var _v49 = permission.a;
				return 'estornosGuiche.Solicitar';
			} else {
				var _v50 = permission.a;
				return 'estornosGuiche.Aprovar';
			}
		case 19:
			var _v51 = permission.a;
			return 'passageiro.Historico';
		case 20:
			var _v52 = permission.a;
			return 'relatoriosPDF.Acessar';
		case 21:
			if (!permission.a) {
				var _v53 = permission.a;
				return 'classes.Editar';
			} else {
				var _v54 = permission.a;
				return 'classes.Acessar';
			}
		case 22:
			if (!permission.a) {
				var _v55 = permission.a;
				return 'avulsas.Acessar';
			} else {
				var _v56 = permission.a;
				return 'avulsas.Editar';
			}
		default:
			var code = permission.a;
			return code;
	}
};
var $author$project$Services$Models$encodePermissions = function (permission) {
	return $elm$json$Json$Encode$string(
		$author$project$Services$Models$permissionCODEToString(permission));
};
var $author$project$Data$Billing$BillingStatus = F3(
	function (blockAt, daysRemaining, blocked) {
		return {h6: blockAt, fY: blocked, iE: daysRemaining};
	});
var $author$project$Data$Billing$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (active) {
		return active ? A2(
			$elm$json$Json$Decode$map,
			$elm$core$Maybe$Just,
			A4(
				$elm$json$Json$Decode$map3,
				$author$project$Data$Billing$BillingStatus,
				A2($elm$json$Json$Decode$field, 'blockAt', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'daysRemaining', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'blocked', $elm$json$Json$Decode$bool))) : $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing);
	},
	A2($elm$json$Json$Decode$field, 'active', $elm$json$Json$Decode$bool));
var $author$project$Services$Billing$getBillingStatus = function (options) {
	return $author$project$Services$Api$getHttp(
		{
			m9: A2($author$project$Services$Api$expectJsonErrorString, options.ow, $author$project$Data$Billing$decoder),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'concessionaire', 'billingStatus']),
				_List_Nil)
		});
};
var $elm$core$Maybe$destruct = F3(
	function (_default, func, maybe) {
		if (!maybe.$) {
			var a = maybe.a;
			return func(a);
		} else {
			return _default;
		}
	});
var $elm$json$Json$Encode$float = _Json_wrap;
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $author$project$Shared$login = _Platform_outgoingPort(
	'login',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'address',
					$elm$json$Json$Encode$string($.ep)),
					_Utils_Tuple2(
					'cnpj',
					$elm$json$Json$Encode$string($.l3)),
					_Utils_Tuple2(
					'issTax',
					function ($) {
						return A3($elm$core$Maybe$destruct, $elm$json$Json$Encode$null, $elm$json$Json$Encode$float, $);
					}($.nY)),
					_Utils_Tuple2(
					'permissions',
					$elm$core$Basics$identity($.oU)),
					_Utils_Tuple2(
					'permissionsCODE',
					$elm$core$Basics$identity($.hg)),
					_Utils_Tuple2(
					'phone',
					$elm$json$Json$Encode$int($.jX)),
					_Utils_Tuple2(
					'token',
					$elm$json$Json$Encode$string($.kU))
				]));
	});
var $author$project$Shared$logout = _Platform_outgoingPort(
	'logout',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
var $author$project$Route$pushUrl = F2(
	function (key, route) {
		return A2(
			$elm$browser$Browser$Navigation$pushUrl,
			key,
			$author$project$Route$toString(route));
	});
var $author$project$Shared$logout_ = function (model) {
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{lB: $elm$core$Maybe$Nothing, pF: $author$project$Shared$Guest}),
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					$author$project$Shared$logout(0),
					A2($author$project$Route$pushUrl, model.nZ, $author$project$Route$Login)
				])));
};
var $author$project$Shared$printDocument = _Platform_outgoingPort('printDocument', $elm$json$Json$Encode$string);
var $author$project$Ports$sendPrintHTML = _Platform_outgoingPort('sendPrintHTML', $elm$json$Json$Encode$string);
var $author$project$Data$Permission$toApiString = function (permission) {
	switch (permission.$) {
		case 0:
			return 'buzzao_admin';
		case 1:
			return 'concessionaire_admin';
		case 2:
			return 'issuing_ticket_window';
		case 3:
			return 'sales_ticket_window';
		case 4:
			return 'register_beneficiary';
		case 5:
			return 'block_unblock_card';
		case 6:
			return 'second_card_operator';
		case 7:
			return 'counting';
		default:
			var str = permission.a;
			return str;
	}
};
var $author$project$Data$Permission$toJson = function (permission) {
	return $elm$json$Json$Encode$string(
		$author$project$Data$Permission$toApiString(permission));
};
var $author$project$Shared$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 1:
				var messages = msg.a;
				return A3(
					$elm$core$List$foldl,
					F2(
						function (msg_, _v1) {
							var model_ = _v1.a;
							var cmd = _v1.b;
							var _v2 = A2($author$project$Shared$update, msg_, model_);
							var model__ = _v2.a;
							var cmd_ = _v2.b;
							return _Utils_Tuple2(
								model__,
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[cmd, cmd_])));
						}),
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
					messages);
			case 2:
				var route = msg.a;
				return _Utils_Tuple2(
					model,
					A2($author$project$Route$pushUrl, model.nZ, route));
			case 3:
				var route = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{j_: true}),
					A2($author$project$Route$pushUrl, model.nZ, route));
			case 4:
				var route = msg.a;
				return _Utils_Tuple2(
					model,
					$elm$browser$Browser$Navigation$load(
						$author$project$Route$toString(route)));
			case 9:
				var token = msg.a.kU;
				var permissions = msg.a.oU;
				var permissionsCODE = msg.a.hg;
				var address = msg.a.ep;
				var cnpj = msg.a.l3;
				var phone = msg.a.jX;
				var issTax = msg.a.nY;
				return _Utils_Tuple2(
					model,
					$author$project$Shared$login(
						{
							ep: A2($elm$core$Maybe$withDefault, '-', address),
							l3: A2($elm$core$Maybe$withDefault, '-', cnpj),
							nY: issTax,
							oU: A2($elm$json$Json$Encode$list, $author$project$Data$Permission$toJson, permissions),
							hg: A2($elm$json$Json$Encode$list, $author$project$Services$Models$encodePermissions, permissionsCODE),
							jX: A2($elm$core$Maybe$withDefault, 0, phone),
							kU: token
						}));
			case 5:
				var url = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Shared$printDocument(url));
			case 6:
				var params = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Shared$copy(params));
			case 7:
				var htmlStr = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Ports$sendPrintHTML(htmlStr));
			case 8:
				if (!msg.a.$) {
					var str = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								iG: $elm$core$Maybe$Just(
									$elm$core$Result$Ok(
										{pk: $elm$core$Maybe$Nothing, fD: str}))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var str = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								iG: $elm$core$Maybe$Just(
									$elm$core$Result$Err(str))
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 10:
				return $author$project$Shared$logout_(model);
			case 11:
				var str = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							iG: $elm$core$Maybe$Just(
								$elm$core$Result$Err(str))
						}),
					$elm$core$Platform$Cmd$none);
			case 12:
				var str = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							iG: $elm$core$Maybe$Just(
								$elm$core$Result$Err(str))
						}),
					$author$project$Shared$consoleError(str));
			case 13:
				var str = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							iG: $elm$core$Maybe$Just(
								$elm$core$Result$Ok(
									{pk: $elm$core$Maybe$Nothing, fD: str}))
						}),
					$elm$core$Platform$Cmd$none);
			case 14:
				var options = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							iG: $elm$core$Maybe$Just(
								$elm$core$Result$Ok(
									{
										pk: $elm$core$Maybe$Just(
											{gN: false, pv: options.pv, fD: options.lJ}),
										fD: options.fD
									}))
						}),
					$elm$core$Platform$Cmd$none);
			case 15:
				var options = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							iG: $elm$core$Maybe$Just(
								$elm$core$Result$Ok(
									{
										pk: $elm$core$Maybe$Just(
											{gN: true, pv: options.pv, fD: options.lJ}),
										fD: options.fD
									}))
						}),
					$elm$core$Platform$Cmd$none);
			case 16:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{iG: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
			case 17:
				return _Utils_Tuple2(
					model,
					A2($elm$core$Task$perform, $author$project$Shared$GotUnauthorizedErrorNow, $elm$time$Time$now));
			case 18:
				var now = msg.a;
				var hasAuthExpire = function () {
					var _v3 = model.pF;
					if (!_v3.$) {
						var user = _v3.a;
						return _Utils_cmp(
							$elm$time$Time$posixToMillis(user.nc),
							$elm$time$Time$posixToMillis(now)) < 1;
					} else {
						return false;
					}
				}();
				return hasAuthExpire ? $author$project$Shared$logout_(
					_Utils_update(
						model,
						{
							iG: $elm$core$Maybe$Just(
								$elm$core$Result$Err('Sua sessão expirou, faça o login novamente.'))
						})) : $author$project$Shared$logout_(
					_Utils_update(
						model,
						{
							iG: $elm$core$Maybe$Just(
								$elm$core$Result$Err('Credenciais de autenticação inválidas para o recurso de destino.'))
						}));
			case 19:
				var str = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Shared$consoleError(str));
			case 20:
				return _Utils_Tuple2(
					model,
					$author$project$Services$Bot$checkUpdate(
						{ow: $author$project$Shared$GotCheckUpdate}));
			case 21:
				if (!msg.a.$) {
					var currentVersion = msg.a.a;
					var bundleOutdated = function () {
						var _v5 = $author$project$Gen$Environment$buildVersion;
						if (!_v5.$) {
							var bundleVersion = _v5.a;
							return !_Utils_eq(
								bundleVersion,
								$elm$time$Time$posixToMillis(currentVersion));
						} else {
							return false;
						}
					}();
					var newVersionAvailable = function () {
						var _v4 = model.qr;
						if (!_v4.$) {
							var lastVersion = _v4.a;
							return model.qq || (bundleOutdated || (!_Utils_eq(lastVersion, currentVersion)));
						} else {
							return model.qq || bundleOutdated;
						}
					}();
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								qq: newVersionAvailable,
								qr: $elm$core$Maybe$Just(currentVersion)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 22:
				var _v6 = model.pF;
				if (!_v6.$) {
					var user = _v6.a;
					return $author$project$Data$User$isBuzzao(user) ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
						model,
						$author$project$Services$Billing$getBillingStatus(
							{ow: $author$project$Shared$GotBilling, kU: user.kU}));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			default:
				if (!msg.a.$) {
					var billing = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{lB: billing}),
						($author$project$Data$Billing$isBlocked(billing) && (!$author$project$Data$Billing$isRouteAllowedWhenBlocked(model.pv))) ? A2($author$project$Route$replaceUrl, model.nZ, $author$project$Route$WelcomeBack) : $elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Main$init = F3(
	function (flags, url, key) {
		var _v0 = function () {
			var _v1 = A2($elm$json$Json$Decode$decodeValue, $author$project$Data$User$decoder, flags);
			if (!_v1.$) {
				var user = _v1.a;
				return A3(
					$author$project$Shared$init,
					key,
					url,
					$elm$core$Maybe$Just(user));
			} else {
				return A3($author$project$Shared$init, key, url, $elm$core$Maybe$Nothing);
			}
		}();
		var shared = _v0.a;
		var initSharedCmd = _v0.b;
		var _v2 = A2($author$project$Pages$init, shared, $elm$core$Maybe$Nothing);
		var page = _v2.a;
		var pageCmd = _v2.b;
		var sharedMsg = _v2.c;
		var _v3 = A2($author$project$Shared$update, sharedMsg, shared);
		var newShared = _v3.a;
		var sharedCmd = _v3.b;
		var _v4 = function () {
			var _v5 = A2($elm$json$Json$Decode$decodeValue, $author$project$Data$User$decoder, flags);
			if (!_v5.$) {
				var user = _v5.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					$elm$core$Maybe$Just,
					A2($author$project$Components$Patterns$NavigationDrawer$init, user, shared));
			} else {
				return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
			}
		}();
		var compNavigationDrawerModel = _v4.a;
		var compNavigationDrawerCmd = _v4.b;
		return _Utils_Tuple2(
			{ak: compNavigationDrawerModel, bv: page, v: newShared},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Main$PagesMsg, pageCmd),
						A2($elm$core$Task$perform, $author$project$Main$AdjustTimeZone, $elm$time$Time$here),
						A2($author$project$Main$socketCmd, $author$project$Route$NotFound, newShared.pv),
						A2($elm$core$Platform$Cmd$map, $author$project$Main$SharedMsg, initSharedCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Main$SharedMsg, sharedCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Main$NavigationDrawerMsg, compNavigationDrawerCmd)
					])));
	});
var $author$project$Main$ReceivedTokenData = function (a) {
	return {$: 3, a: a};
};
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$core$Platform$Sub$map = _Platform_map;
var $author$project$Main$receiveTokenData = _Platform_incomingPort('receiveTokenData', $elm$json$Json$Decode$value);
var $author$project$Pages$LoginMsg = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $author$project$Pages$Reports$AdministrativeSales$MS_Operators = 0;
var $author$project$Pages$Reports$AdministrativeSales$SetMultiSelect = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $elm$browser$Browser$Events$Document = 0;
var $elm$browser$Browser$Events$MySub = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$browser$Browser$Events$State = F2(
	function (subs, pids) {
		return {jY: pids, kN: subs};
	});
var $elm$browser$Browser$Events$init = $elm$core$Task$succeed(
	A2($elm$browser$Browser$Events$State, _List_Nil, $elm$core$Dict$empty));
var $elm$browser$Browser$Events$nodeToKey = function (node) {
	if (!node) {
		return 'd_';
	} else {
		return 'w_';
	}
};
var $elm$browser$Browser$Events$addKey = function (sub) {
	var node = sub.a;
	var name = sub.b;
	return _Utils_Tuple2(
		_Utils_ap(
			$elm$browser$Browser$Events$nodeToKey(node),
			name),
		sub);
};
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$browser$Browser$Events$Event = F2(
	function (key, event) {
		return {iL: event, nZ: key};
	});
var $elm$browser$Browser$Events$spawn = F3(
	function (router, key, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var actualNode = function () {
			if (!node) {
				return _Browser_doc;
			} else {
				return _Browser_window;
			}
		}();
		return A2(
			$elm$core$Task$map,
			function (value) {
				return _Utils_Tuple2(key, value);
			},
			A3(
				_Browser_on,
				actualNode,
				name,
				function (event) {
					return A2(
						$elm$core$Platform$sendToSelf,
						router,
						A2($elm$browser$Browser$Events$Event, key, event));
				}));
	});
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $elm$browser$Browser$Events$onEffects = F3(
	function (router, subs, state) {
		var stepRight = F3(
			function (key, sub, _v6) {
				var deads = _v6.a;
				var lives = _v6.b;
				var news = _v6.c;
				return _Utils_Tuple3(
					deads,
					lives,
					A2(
						$elm$core$List$cons,
						A3($elm$browser$Browser$Events$spawn, router, key, sub),
						news));
			});
		var stepLeft = F3(
			function (_v4, pid, _v5) {
				var deads = _v5.a;
				var lives = _v5.b;
				var news = _v5.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, pid, deads),
					lives,
					news);
			});
		var stepBoth = F4(
			function (key, pid, _v2, _v3) {
				var deads = _v3.a;
				var lives = _v3.b;
				var news = _v3.c;
				return _Utils_Tuple3(
					deads,
					A3($elm$core$Dict$insert, key, pid, lives),
					news);
			});
		var newSubs = A2($elm$core$List$map, $elm$browser$Browser$Events$addKey, subs);
		var _v0 = A6(
			$elm$core$Dict$merge,
			stepLeft,
			stepBoth,
			stepRight,
			state.jY,
			$elm$core$Dict$fromList(newSubs),
			_Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));
		var deadPids = _v0.a;
		var livePids = _v0.b;
		var makeNewPids = _v0.c;
		return A2(
			$elm$core$Task$andThen,
			function (pids) {
				return $elm$core$Task$succeed(
					A2(
						$elm$browser$Browser$Events$State,
						newSubs,
						A2(
							$elm$core$Dict$union,
							livePids,
							$elm$core$Dict$fromList(pids))));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$sequence(makeNewPids);
				},
				$elm$core$Task$sequence(
					A2($elm$core$List$map, $elm$core$Process$kill, deadPids))));
	});
var $elm$browser$Browser$Events$onSelfMsg = F3(
	function (router, _v0, state) {
		var key = _v0.nZ;
		var event = _v0.iL;
		var toMessage = function (_v2) {
			var subKey = _v2.a;
			var _v3 = _v2.b;
			var node = _v3.a;
			var name = _v3.b;
			var decoder = _v3.c;
			return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : $elm$core$Maybe$Nothing;
		};
		var messages = A2($elm$core$List$filterMap, toMessage, state.kN);
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Platform$sendToApp(router),
					messages)));
	});
var $elm$browser$Browser$Events$subMap = F2(
	function (func, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var decoder = _v0.c;
		return A3(
			$elm$browser$Browser$Events$MySub,
			node,
			name,
			A2($elm$json$Json$Decode$map, func, decoder));
	});
_Platform_effectManagers['Browser.Events'] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);
var $elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');
var $elm$browser$Browser$Events$on = F3(
	function (node, name, decoder) {
		return $elm$browser$Browser$Events$subscription(
			A3($elm$browser$Browser$Events$MySub, node, name, decoder));
	});
var $elm$browser$Browser$Events$onMouseDown = A2($elm$browser$Browser$Events$on, 0, 'mousedown');
var $author$project$Pages$Reports$AdministrativeSales$operatorInputID = 'administrative-sales-operator-input';
var $author$project$Pages$Reports$AdministrativeSales$operatorSelectID = 'administrative-sales-operator-select';
var $elm$json$Json$Decode$lazy = function (thunk) {
	return A2(
		$elm$json$Json$Decode$andThen,
		thunk,
		$elm$json$Json$Decode$succeed(0));
};
var $author$project$Utils$isOutsideDomNodes = function (nodesId) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$andThen,
				function (id) {
					return A2($elm$core$List$member, id, nodesId) ? $elm$json$Json$Decode$succeed(false) : $elm$json$Json$Decode$fail('continue');
				},
				A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string)),
				$elm$json$Json$Decode$lazy(
				function (_v0) {
					return A2(
						$elm$json$Json$Decode$field,
						'parentNode',
						$author$project$Utils$isOutsideDomNodes(nodesId));
				}),
				$elm$json$Json$Decode$succeed(true)
			]));
};
var $author$project$Utils$outsideTargets = F2(
	function (targetsId, onSuccess) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (isOutside) {
				return isOutside ? $elm$json$Json$Decode$succeed(onSuccess) : $elm$json$Json$Decode$fail('inside target');
			},
			A2(
				$elm$json$Json$Decode$field,
				'target',
				$author$project$Utils$isOutsideDomNodes(targetsId)));
	});
var $author$project$Pages$Reports$AdministrativeSales$subscription = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				model.dV ? $elm$browser$Browser$Events$onMouseDown(
				A2(
					$author$project$Utils$outsideTargets,
					_List_fromArray(
						[$author$project$Pages$Reports$AdministrativeSales$operatorSelectID, $author$project$Pages$Reports$AdministrativeSales$operatorInputID]),
					A2($author$project$Pages$Reports$AdministrativeSales$SetMultiSelect, 0, false))) : $elm$core$Platform$Sub$none
			]));
};
var $author$project$Pages$Reports$Divergences$MS_Class = 0;
var $author$project$Pages$Reports$Divergences$MS_Line = 2;
var $author$project$Pages$Reports$Divergences$MS_Operator = 3;
var $author$project$Pages$Reports$Divergences$MS_Vehicle = 1;
var $author$project$Pages$Reports$Divergences$SetMultiSelect = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Pages$Reports$Divergences$classInputID = 'divergence-class-input';
var $author$project$Pages$Reports$Divergences$classSelectID = 'divergence-class-select';
var $author$project$Pages$Reports$Divergences$lineInputID = 'divergence-line-input';
var $author$project$Pages$Reports$Divergences$lineSelectID = 'divergence-line-select';
var $author$project$Pages$Reports$Divergences$operatorInputID = 'divergence-operator-input';
var $author$project$Pages$Reports$Divergences$operatorSelectID = 'divergence-operator-select';
var $author$project$Pages$Reports$Divergences$vehicleInputID = 'divergence-vehicle-input';
var $author$project$Pages$Reports$Divergences$vehicleSelectID = 'divergence-vehicle-select';
var $author$project$Pages$Reports$Divergences$subscription = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				model.dR ? $elm$browser$Browser$Events$onMouseDown(
				A2(
					$author$project$Utils$outsideTargets,
					_List_fromArray(
						[$author$project$Pages$Reports$Divergences$classSelectID, $author$project$Pages$Reports$Divergences$classInputID]),
					A2($author$project$Pages$Reports$Divergences$SetMultiSelect, 0, false))) : $elm$core$Platform$Sub$none,
				model.dW ? $elm$browser$Browser$Events$onMouseDown(
				A2(
					$author$project$Utils$outsideTargets,
					_List_fromArray(
						[$author$project$Pages$Reports$Divergences$vehicleSelectID, $author$project$Pages$Reports$Divergences$vehicleInputID]),
					A2($author$project$Pages$Reports$Divergences$SetMultiSelect, 1, false))) : $elm$core$Platform$Sub$none,
				model.dT ? $elm$browser$Browser$Events$onMouseDown(
				A2(
					$author$project$Utils$outsideTargets,
					_List_fromArray(
						[$author$project$Pages$Reports$Divergences$lineSelectID, $author$project$Pages$Reports$Divergences$lineInputID]),
					A2($author$project$Pages$Reports$Divergences$SetMultiSelect, 2, false))) : $elm$core$Platform$Sub$none,
				model.dU ? $elm$browser$Browser$Events$onMouseDown(
				A2(
					$author$project$Utils$outsideTargets,
					_List_fromArray(
						[$author$project$Pages$Reports$Divergences$operatorSelectID, $author$project$Pages$Reports$Divergences$operatorInputID]),
					A2($author$project$Pages$Reports$Divergences$SetMultiSelect, 3, false))) : $elm$core$Platform$Sub$none
			]));
};
var $author$project$Pages$Reports$Event$Audit$MS_ActionType = 1;
var $author$project$Pages$Reports$Event$Audit$MS_Vehicle = 0;
var $author$project$Pages$Reports$Event$Audit$SetMultiSelect = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Pages$Reports$Event$Audit$actionTypeInputID = 'audit-action-type-input';
var $author$project$Pages$Reports$Event$Audit$actionTypeSelectID = 'audit-action-type-select';
var $author$project$Pages$Reports$Event$Audit$vehicleInputID = 'audit-vehicle-input';
var $author$project$Pages$Reports$Event$Audit$vehicleSelectID = 'audit-vehicle-select';
var $author$project$Pages$Reports$Event$Audit$subscription = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				model.dW ? $elm$browser$Browser$Events$onMouseDown(
				A2(
					$author$project$Utils$outsideTargets,
					_List_fromArray(
						[$author$project$Pages$Reports$Event$Audit$vehicleSelectID, $author$project$Pages$Reports$Event$Audit$vehicleInputID]),
					A2($author$project$Pages$Reports$Event$Audit$SetMultiSelect, 0, false))) : $elm$core$Platform$Sub$none,
				model.dQ ? $elm$browser$Browser$Events$onMouseDown(
				A2(
					$author$project$Utils$outsideTargets,
					_List_fromArray(
						[$author$project$Pages$Reports$Event$Audit$actionTypeSelectID, $author$project$Pages$Reports$Event$Audit$actionTypeInputID]),
					A2($author$project$Pages$Reports$Event$Audit$SetMultiSelect, 1, false))) : $elm$core$Platform$Sub$none
			]));
};
var $author$project$Pages$Reports$Event$UsingLine$MS_Line = 0;
var $author$project$Pages$Reports$Event$UsingLine$SetMultiSelect = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Pages$Reports$Event$UsingLine$lineInputID = 'using-line-input';
var $author$project$Pages$Reports$Event$UsingLine$lineSelectID = 'using-line-select';
var $author$project$Pages$Reports$Event$UsingLine$subscription = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				model.dT ? $elm$browser$Browser$Events$onMouseDown(
				A2(
					$author$project$Utils$outsideTargets,
					_List_fromArray(
						[$author$project$Pages$Reports$Event$UsingLine$lineSelectID, $author$project$Pages$Reports$Event$UsingLine$lineInputID]),
					A2($author$project$Pages$Reports$Event$UsingLine$SetMultiSelect, 0, false))) : $elm$core$Platform$Sub$none
			]));
};
var $author$project$Pages$Reports$Event$UsingOperator$MS_Operator = 0;
var $author$project$Pages$Reports$Event$UsingOperator$SetMultiSelect = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Pages$Reports$Event$UsingOperator$operatorInputID = 'using-event-operator-input';
var $author$project$Pages$Reports$Event$UsingOperator$operatorSelectID = 'using-event-operator-select';
var $author$project$Pages$Reports$Event$UsingOperator$subscription = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				model.dU ? $elm$browser$Browser$Events$onMouseDown(
				A2(
					$author$project$Utils$outsideTargets,
					_List_fromArray(
						[$author$project$Pages$Reports$Event$UsingOperator$operatorSelectID, $author$project$Pages$Reports$Event$UsingOperator$operatorInputID]),
					A2($author$project$Pages$Reports$Event$UsingOperator$SetMultiSelect, 0, false))) : $elm$core$Platform$Sub$none
			]));
};
var $author$project$Pages$Reports$Event$UsingSession$MS_Line = 2;
var $author$project$Pages$Reports$Event$UsingSession$MS_Operator = 0;
var $author$project$Pages$Reports$Event$UsingSession$MS_Vehicle = 1;
var $author$project$Pages$Reports$Event$UsingSession$SetMultiSelect = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Pages$Reports$Event$UsingSession$lineInputID = 'line-input';
var $author$project$Pages$Reports$Event$UsingSession$lineSelectID = 'line-select';
var $author$project$Pages$Reports$Event$UsingSession$operatorInputID = 'operator-input';
var $author$project$Pages$Reports$Event$UsingSession$operatorSelectID = 'operator-select';
var $author$project$Pages$Reports$Event$UsingSession$vehicleInputID = 'vehicle-input';
var $author$project$Pages$Reports$Event$UsingSession$vehicleSelectID = 'vehicle-select';
var $author$project$Pages$Reports$Event$UsingSession$subscription = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				model.dU ? $elm$browser$Browser$Events$onMouseDown(
				A2(
					$author$project$Utils$outsideTargets,
					_List_fromArray(
						[$author$project$Pages$Reports$Event$UsingSession$operatorSelectID, $author$project$Pages$Reports$Event$UsingSession$operatorInputID]),
					A2($author$project$Pages$Reports$Event$UsingSession$SetMultiSelect, 0, false))) : $elm$core$Platform$Sub$none,
				model.dW ? $elm$browser$Browser$Events$onMouseDown(
				A2(
					$author$project$Utils$outsideTargets,
					_List_fromArray(
						[$author$project$Pages$Reports$Event$UsingSession$vehicleSelectID, $author$project$Pages$Reports$Event$UsingSession$vehicleInputID]),
					A2($author$project$Pages$Reports$Event$UsingSession$SetMultiSelect, 1, false))) : $elm$core$Platform$Sub$none,
				model.dT ? $elm$browser$Browser$Events$onMouseDown(
				A2(
					$author$project$Utils$outsideTargets,
					_List_fromArray(
						[$author$project$Pages$Reports$Event$UsingSession$lineSelectID, $author$project$Pages$Reports$Event$UsingSession$lineInputID]),
					A2($author$project$Pages$Reports$Event$UsingSession$SetMultiSelect, 2, false))) : $elm$core$Platform$Sub$none
			]));
};
var $author$project$Pages$Reports$Event$UsingVehicle$MS_Vehicle = 0;
var $author$project$Pages$Reports$Event$UsingVehicle$SetMultiSelect = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Pages$Reports$Event$UsingVehicle$vehicleInputID = 'using-vehicle-input';
var $author$project$Pages$Reports$Event$UsingVehicle$vehicleSelectID = 'using-vehicle-select';
var $author$project$Pages$Reports$Event$UsingVehicle$subscription = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				model.dW ? $elm$browser$Browser$Events$onMouseDown(
				A2(
					$author$project$Utils$outsideTargets,
					_List_fromArray(
						[$author$project$Pages$Reports$Event$UsingVehicle$vehicleSelectID, $author$project$Pages$Reports$Event$UsingVehicle$vehicleInputID]),
					A2($author$project$Pages$Reports$Event$UsingVehicle$SetMultiSelect, 0, false))) : $elm$core$Platform$Sub$none
			]));
};
var $author$project$Pages$Reports$UsesPerClass$MS_Line = 0;
var $author$project$Pages$Reports$UsesPerClass$MS_Operator = 1;
var $author$project$Pages$Reports$UsesPerClass$MS_Vehicle = 2;
var $author$project$Pages$Reports$UsesPerClass$SetMultiSelect = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Pages$Reports$UsesPerClass$lineInputID = 'uses-per-class-input';
var $author$project$Pages$Reports$UsesPerClass$lineSelectID = 'uses-per-class-select';
var $author$project$Pages$Reports$UsesPerClass$operatorInputID = 'uses-per-class-input-operator';
var $author$project$Pages$Reports$UsesPerClass$operatorSelectID = 'uses-per-class-select-operator';
var $author$project$Pages$Reports$UsesPerClass$vehicleInputID = 'uses-per-class-input-vehicle';
var $author$project$Pages$Reports$UsesPerClass$vehicleSelectID = 'uses-per-class-select-vehicle';
var $author$project$Pages$Reports$UsesPerClass$subscription = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				model.dT ? $elm$browser$Browser$Events$onMouseDown(
				A2(
					$author$project$Utils$outsideTargets,
					_List_fromArray(
						[$author$project$Pages$Reports$UsesPerClass$lineSelectID, $author$project$Pages$Reports$UsesPerClass$lineInputID]),
					A2($author$project$Pages$Reports$UsesPerClass$SetMultiSelect, 0, false))) : $elm$core$Platform$Sub$none,
				model.dU ? $elm$browser$Browser$Events$onMouseDown(
				A2(
					$author$project$Utils$outsideTargets,
					_List_fromArray(
						[$author$project$Pages$Reports$UsesPerClass$operatorSelectID, $author$project$Pages$Reports$UsesPerClass$operatorInputID]),
					A2($author$project$Pages$Reports$UsesPerClass$SetMultiSelect, 1, false))) : $elm$core$Platform$Sub$none,
				model.dW ? $elm$browser$Browser$Events$onMouseDown(
				A2(
					$author$project$Utils$outsideTargets,
					_List_fromArray(
						[$author$project$Pages$Reports$UsesPerClass$vehicleSelectID, $author$project$Pages$Reports$UsesPerClass$vehicleInputID]),
					A2($author$project$Pages$Reports$UsesPerClass$SetMultiSelect, 2, false))) : $elm$core$Platform$Sub$none
			]));
};
var $author$project$Pages$Admin$AccountabilityReport$subscriptions = function (model) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$CardExtract$subscriptions = function (model) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$Cards$subscriptions = $elm$core$Platform$Sub$none;
var $author$project$Pages$Admin$CompanyOrders$subscriptions = function (model) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$Equipments$subscriptions = $elm$core$Platform$Sub$none;
var $author$project$Pages$Admin$PaymentBillets$subscriptions = function (model) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$PaymentGuides$subscriptions = function (model) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$Reports$Sales$Submit = {$: 9};
var $elm$browser$Browser$Events$onKeyPress = A2($elm$browser$Browser$Events$on, 0, 'keypress');
var $author$project$Utils$onPressEnter = function (msg) {
	return $elm$browser$Browser$Events$onKeyPress(
		A2(
			$elm$json$Json$Decode$andThen,
			function (str) {
				return ('Enter' === str) ? $elm$json$Json$Decode$succeed(msg) : $elm$json$Json$Decode$fail('Not Enter');
			},
			A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string)));
};
var $author$project$Pages$Admin$Reports$Sales$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Utils$onPressEnter($author$project$Pages$Admin$Reports$Sales$Submit)
			]));
};
var $author$project$Pages$Admin$SalesReport$MsgUpdateSearch = {$: 8};
var $author$project$Pages$Admin$SalesReport$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Utils$onPressEnter($author$project$Pages$Admin$SalesReport$MsgUpdateSearch)
			]));
};
var $author$project$Pages$Admin$SessionWithoutPouchReport$subscriptions = function (model) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$SessionsReport$subscriptions = function (model) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$Users$AddUserModal_AddUser = {$: 16};
var $author$project$Pages$Admin$Users$AddUserModal_Next = {$: 9};
var $author$project$Pages$Admin$Users$EditUserModal_Delete = {$: 34};
var $author$project$Pages$Admin$Users$EditUserModal_EditUser = {$: 31};
var $krisajenkins$remotedata$RemoteData$isLoading = function (data) {
	if (data.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Pages$Admin$Users$subscriptions = function (model) {
	var _v0 = model.aY;
	switch (_v0.$) {
		case 0:
			return $elm$core$Platform$Sub$none;
		case 1:
			var model_ = _v0.a;
			switch (model_.$) {
				case 0:
					return $author$project$Utils$onPressEnter($author$project$Pages$Admin$Users$AddUserModal_Next);
				case 1:
					return $elm$core$Platform$Sub$none;
				default:
					var model__ = model_.a;
					return $krisajenkins$remotedata$RemoteData$isLoading(model__.hV) ? $elm$core$Platform$Sub$none : $author$project$Utils$onPressEnter($author$project$Pages$Admin$Users$AddUserModal_AddUser);
			}
		case 3:
			var model_ = _v0.a;
			if (!model_.$) {
				return $elm$core$Platform$Sub$none;
			} else {
				var model__ = model_.a;
				return $author$project$Utils$onPressEnter(
					model__.dz ? $author$project$Pages$Admin$Users$EditUserModal_Delete : $author$project$Pages$Admin$Users$EditUserModal_EditUser);
			}
		default:
			var createdUserModal = _v0.a;
			return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Pages$Admin$Vehicles$subscriptions = $elm$core$Platform$Sub$none;
var $author$project$Pages$Admin$subscriptions = function (model) {
	var _v0 = model.bv;
	switch (_v0.$) {
		case 0:
			return $elm$core$Platform$Sub$none;
		case 1:
			var model_ = _v0.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$UsersMsg,
				$author$project$Pages$Admin$Users$subscriptions(model_));
		case 2:
			var model_ = _v0.a;
			return A2($elm$core$Platform$Sub$map, $author$project$Pages$Admin$EquipmentsMsg, $author$project$Pages$Admin$Equipments$subscriptions);
		case 3:
			var maybePage = _v0.a;
			var maybeSearch = _v0.b;
			var model_ = _v0.c;
			return A2($elm$core$Platform$Sub$map, $author$project$Pages$Admin$CardsMsg, $author$project$Pages$Admin$Cards$subscriptions);
		case 4:
			var id = _v0.a;
			var model_ = _v0.b;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$CardExtractMsg,
				$author$project$Pages$Admin$CardExtract$subscriptions(model_));
		case 5:
			var maybePage = _v0.a;
			var maybeSearch = _v0.b;
			var maybeActive = _v0.c;
			var model_ = _v0.d;
			return A2($elm$core$Platform$Sub$map, $author$project$Pages$Admin$VehiclesMsg, $author$project$Pages$Admin$Vehicles$subscriptions);
		case 9:
			var model_ = _v0.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$AccountabilityReportMsg,
				$author$project$Pages$Admin$AccountabilityReport$subscriptions(model_));
		case 10:
			var model_ = _v0.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$SalesReportMsg,
				$author$project$Pages$Admin$SalesReport$subscriptions(model_));
		case 11:
			var model_ = _v0.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$SessionsReportMsg,
				$author$project$Pages$Admin$SessionsReport$subscriptions(model_));
		case 12:
			var model_ = _v0.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$SessionsWithoutPouchReportMsg,
				$author$project$Pages$Admin$SessionWithoutPouchReport$subscriptions(model_));
		case 13:
			var model_ = _v0.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$SalesReportV2Msg,
				$author$project$Pages$Admin$Reports$Sales$subscriptions(model_));
		case 6:
			var model_ = _v0.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$PaymentGuidesMsg,
				$author$project$Pages$Admin$PaymentGuides$subscriptions(model_));
		case 7:
			var model_ = _v0.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$PaymentBilletsMsg,
				$author$project$Pages$Admin$PaymentBillets$subscriptions(model_));
		default:
			var model_ = _v0.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$CompanyOrdersMsg,
				$author$project$Pages$Admin$CompanyOrders$subscriptions(model_));
	}
};
var $author$project$Pages$Enterprise$Dashboard$AddCard = {$: 28};
var $author$project$Pages$Enterprise$Dashboard$subscriptions = function (model) {
	var _v0 = model.aY;
	if (_v0.$ === 2) {
		return $author$project$Utils$onPressEnter($author$project$Pages$Enterprise$Dashboard$AddCard);
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Pages$Enterprise$Register$NextStep = {$: 2};
var $author$project$Pages$Enterprise$Register$subscriptions = function (model) {
	return (!model.hG) ? $author$project$Utils$onPressEnter($author$project$Pages$Enterprise$Register$NextStep) : $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Login$SendLogin = {$: 4};
var $author$project$Pages$Login$subscriptions = function (_v0) {
	return $author$project$Utils$onPressEnter($author$project$Pages$Login$SendLogin);
};
var $author$project$Components$Schedule$GotPeriods = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Schedule$MouseUpped = {$: 4};
var $author$project$Components$Schedule$ConvertedPeriods = F2(
	function (id, periods) {
		return {dM: id, n: periods};
	});
var $author$project$Components$Schedule$decodePeriods = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'periods',
	$elm$json$Json$Decode$list(
		$elm$json$Json$Decode$list($elm$json$Json$Decode$int)),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Components$Schedule$ConvertedPeriods)));
var $elm$browser$Browser$Events$onMouseUp = A2($elm$browser$Browser$Events$on, 0, 'mouseup');
var $author$project$Ports$periodsToPositionTableSucceed = _Platform_incomingPort('periodsToPositionTableSucceed', $elm$json$Json$Decode$value);
var $author$project$Components$Schedule$subscriptions = $elm$core$Platform$Sub$batch(
	_List_fromArray(
		[
			$elm$browser$Browser$Events$onMouseUp(
			$elm$json$Json$Decode$succeed($author$project$Components$Schedule$MouseUpped)),
			$author$project$Ports$periodsToPositionTableSucceed(
			A2(
				$elm$core$Basics$composeR,
				$elm$json$Json$Decode$decodeValue($author$project$Components$Schedule$decodePeriods),
				$author$project$Components$Schedule$GotPeriods))
		]));
var $author$project$Pages$Panel$Classes$Create$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				A2($elm$core$Basics$composeR, $author$project$Pages$Panel$Classes$Create$CompScheduleMsg, $author$project$Pages$Panel$Classes$Create$FormMsg),
				$author$project$Components$Schedule$subscriptions)
			]));
};
var $author$project$Pages$Panel$Classes$Details$CompScheduleMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Panel$Classes$Details$FormMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Panel$Classes$Details$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				A2($elm$core$Basics$composeR, $author$project$Pages$Panel$Classes$Details$CompScheduleMsg, $author$project$Pages$Panel$Classes$Details$FormMsg),
				$author$project$Components$Schedule$subscriptions)
			]));
};
var $author$project$Pages$Panel$Classes$List$GotOrderList = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ports$incomingOrder = _Platform_incomingPort(
	'incomingOrder',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string));
var $author$project$Pages$Panel$Classes$List$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ports$incomingOrder($author$project$Pages$Panel$Classes$List$GotOrderList)
			]));
};
var $author$project$Pages$Panel$Classes$SubPage$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		function () {
			switch (model.$) {
				case 1:
					var model_ = model.a;
					return _List_fromArray(
						[
							A2(
							$elm$core$Platform$Sub$map,
							$author$project$Pages$Panel$Classes$SubPage$ClassesDetailsMsg,
							$author$project$Pages$Panel$Classes$Details$subscriptions(model_))
						]);
				case 0:
					var model_ = model.a;
					return _List_fromArray(
						[
							A2(
							$elm$core$Platform$Sub$map,
							$author$project$Pages$Panel$Classes$SubPage$ClassesListMsg,
							$author$project$Pages$Panel$Classes$List$subscriptions(model_))
						]);
				default:
					var model_ = model.a;
					return _List_fromArray(
						[
							A2(
							$elm$core$Platform$Sub$map,
							$author$project$Pages$Panel$Classes$SubPage$ClassesCreateMsg,
							$author$project$Pages$Panel$Classes$Create$subscriptions(model_))
						]);
			}
		}());
};
var $author$project$Pages$Pos$Edit$GotEditorMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Pos$Editor$GotCameraPhoto = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Pos$Editor$GotUpdateCard = function (a) {
	return {$: 23, a: a};
};
var $author$project$Pages$Pos$Editor$NextStep = {$: 6};
var $author$project$Pages$Pos$Editor$ValidatedCard = function (a) {
	return {$: 28, a: a};
};
var $author$project$Pages$Pos$Editor$gotCameraPhoto = _Platform_incomingPort('gotCameraPhoto', $elm$json$Json$Decode$value);
var $author$project$Ports$onSmartCardValidate = _Platform_incomingPort('onSmartCardValidate', $elm$json$Json$Decode$string);
var $author$project$Ports$updateCardRecv = _Platform_incomingPort('updateCardRecv', $elm$json$Json$Decode$value);
var $author$project$Pages$Pos$Editor$subscriptions = function (model) {
	var issueCardDecoder = $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$map,
				$elm$core$Result$Ok,
				A2($elm$json$Json$Decode$field, 'cardSerial', $elm$json$Json$Decode$string)),
				A2(
				$elm$json$Json$Decode$map,
				$elm$core$Result$Err,
				A2($elm$json$Json$Decode$field, 'error', $elm$json$Json$Decode$string))
			]));
	var toResult = A2(
		$elm$core$Basics$composeR,
		$elm$json$Json$Decode$decodeValue(issueCardDecoder),
		$elm$core$Result$withDefault(
			$elm$core$Result$Err('Erro ao decodificar payload.')));
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Utils$onPressEnter($author$project$Pages$Pos$Editor$NextStep),
				$author$project$Pages$Pos$Editor$gotCameraPhoto($author$project$Pages$Pos$Editor$GotCameraPhoto),
				$author$project$Ports$updateCardRecv(
				A2($elm$core$Basics$composeR, toResult, $author$project$Pages$Pos$Editor$GotUpdateCard)),
				function () {
				var _v0 = model.aY;
				if ((!_v0.$) && (!_v0.a.$)) {
					var m = _v0.a.a;
					var _v1 = m.a6;
					if (_v1.$ === 1) {
						return $author$project$Ports$onSmartCardValidate($author$project$Pages$Pos$Editor$ValidatedCard);
					} else {
						return $elm$core$Platform$Sub$none;
					}
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}()
			]));
};
var $author$project$Pages$Pos$Edit$subscriptions = function (model) {
	if (!model.$) {
		return $elm$core$Platform$Sub$none;
	} else {
		var editorModel = model.a;
		return A2(
			$elm$core$Platform$Sub$map,
			$author$project$Pages$Pos$Edit$GotEditorMsg,
			$author$project$Pages$Pos$Editor$subscriptions(editorModel));
	}
};
var $author$project$Pages$Pos$Guiche$ValidatedCard = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Pos$Guiche$subscriptions = function (model) {
	return $author$project$Ports$onSmartCardValidate($author$project$Pages$Pos$Guiche$ValidatedCard);
};
var $author$project$Pages$Pos$Localize$subscriptions = function (model) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Pos$Passenger$ApplyRefill$Loop = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Pos$Passenger$ApplyRefill$LoopRecvPlugin = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Pos$Passenger$ApplyRefill$ReceivedBlockUnblockCardRequest = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Pages$Pos$Passenger$ApplyRefill$ValidatedCard = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ports$applyBlockUnblockRequestRecv = _Platform_incomingPort('applyBlockUnblockRequestRecv', $elm$json$Json$Decode$value);
var $author$project$Pages$Pos$Passenger$ApplyRefill$applyRefillRecv = _Platform_incomingPort('applyRefillRecv', $elm$json$Json$Decode$value);
var $author$project$Pages$Pos$Passenger$ApplyRefill$subscriptions = function (model) {
	var serialDecoder = $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$map,
				$elm$core$Result$Ok,
				A2($elm$json$Json$Decode$field, 'receipt', $elm$json$Json$Decode$string)),
				A2(
				$elm$json$Json$Decode$map,
				$elm$core$Result$Err,
				A2($elm$json$Json$Decode$field, 'error', $elm$json$Json$Decode$string))
			]));
	var decodeSerial = function (val) {
		var _v1 = A2($elm$json$Json$Decode$decodeValue, serialDecoder, val);
		if (!_v1.$) {
			var ok = _v1.a;
			return ok;
		} else {
			var err = _v1.a;
			return $elm$core$Result$Err(
				$elm$json$Json$Decode$errorToString(err));
		}
	};
	switch (model.$) {
		case 1:
			return $author$project$Ports$onSmartCardValidate($author$project$Pages$Pos$Passenger$ApplyRefill$ValidatedCard);
		case 2:
			return $author$project$Ports$applyBlockUnblockRequestRecv(
				A2(
					$elm$core$Basics$composeR,
					$elm$json$Json$Decode$decodeValue(
						$elm$json$Json$Decode$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$json$Json$Decode$field,
									'error',
									A2($elm$json$Json$Decode$map, $elm$core$Result$Err, $elm$json$Json$Decode$string)),
									$elm$json$Json$Decode$succeed(
									$elm$core$Result$Ok(0))
								]))),
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Result$withDefault(
							$elm$core$Result$Err('Erro ao decodificar payload.')),
						$author$project$Pages$Pos$Passenger$ApplyRefill$ReceivedBlockUnblockCardRequest($elm$core$Maybe$Nothing))));
		case 3:
			return $author$project$Pages$Pos$Passenger$ApplyRefill$applyRefillRecv(
				A2(
					$elm$core$Basics$composeR,
					decodeSerial,
					A2($elm$core$Basics$composeR, $author$project$Pages$Pos$Passenger$ApplyRefill$LoopRecvPlugin, $author$project$Pages$Pos$Passenger$ApplyRefill$Loop)));
		default:
			return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Pages$Pos$Passenger$IssueCard$IssuedPlugin = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Pos$Passenger$IssueCard$NoOp = {$: 0};
var $author$project$Pages$Pos$Passenger$IssueCard$ValidatedCard = {$: 6};
var $author$project$Pages$Pos$Passenger$IssueCard$ValidatedCardAgain = function (a) {
	return {$: 11, a: a};
};
var $author$project$Ports$issueCardRecv = _Platform_incomingPort('issueCardRecv', $elm$json$Json$Decode$value);
var $author$project$Pages$Pos$Passenger$IssueCard$subscriptions = function (model) {
	var issueCardDecoder = $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$map,
				$elm$core$Result$Ok,
				A2($elm$json$Json$Decode$field, 'cardSerial', $elm$json$Json$Decode$string)),
				A2(
				$elm$json$Json$Decode$map,
				$elm$core$Result$Err,
				A2($elm$json$Json$Decode$field, 'error', $elm$json$Json$Decode$string))
			]));
	var toResult = A2(
		$elm$core$Basics$composeR,
		$elm$json$Json$Decode$decodeValue(issueCardDecoder),
		$elm$core$Result$withDefault(
			$elm$core$Result$Err('Erro ao decodificar payload.')));
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ports$onSmartCardValidate(
				function (serial) {
					switch (model.$) {
						case 3:
							var model_ = model.a;
							return (!model_.ek) ? $author$project$Pages$Pos$Passenger$IssueCard$ValidatedCard : $author$project$Pages$Pos$Passenger$IssueCard$NoOp;
						case 5:
							var model_ = model.a;
							return $author$project$Pages$Pos$Passenger$IssueCard$ValidatedCardAgain(serial);
						default:
							return $author$project$Pages$Pos$Passenger$IssueCard$NoOp;
					}
				}),
				function () {
				if (model.$ === 7) {
					var model_ = model.a;
					return $author$project$Ports$issueCardRecv(
						A2($elm$core$Basics$composeR, toResult, $author$project$Pages$Pos$Passenger$IssueCard$IssuedPlugin));
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}()
			]));
};
var $author$project$Pages$Pos$Passenger$IssueDuplicate$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Pos$Passenger$SellSingleCharge$ConfirmValue = {$: 8};
var $author$project$Pages$Pos$Passenger$SellSingleCharge$NextModal = {$: 6};
var $author$project$Pages$Pos$Passenger$SellSingleCharge$subscriptions = function (model) {
	var _v0 = model.aY;
	if (_v0.$ === 2) {
		return $author$project$Utils$onPressEnter($author$project$Pages$Pos$Passenger$SellSingleCharge$ConfirmValue);
	} else {
		return $author$project$Utils$onPressEnter($author$project$Pages$Pos$Passenger$SellSingleCharge$NextModal);
	}
};
var $author$project$Pages$Pos$Passenger$SellTicket$ConfirmValue = {$: 8};
var $author$project$Pages$Pos$Passenger$SellTicket$NextModal = {$: 6};
var $author$project$Pages$Pos$Passenger$SellTicket$subscriptions = function (model) {
	var _v0 = model.aY;
	if (_v0.$ === 2) {
		return $author$project$Utils$onPressEnter($author$project$Pages$Pos$Passenger$SellTicket$ConfirmValue);
	} else {
		return $author$project$Utils$onPressEnter($author$project$Pages$Pos$Passenger$SellTicket$NextModal);
	}
};
var $author$project$Pages$Pos$Passenger$UnlockCard$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Pos$Passenger$subscriptions = function (model) {
	if (model.$ === 2) {
		var lModel = model.a;
		var _v1 = lModel.bv;
		switch (_v1.$) {
			case 0:
				return $elm$core$Platform$Sub$none;
			case 1:
				var subModel = _v1.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$Pos$Passenger$GotSellTicketMsg,
					$author$project$Pages$Pos$Passenger$SellTicket$subscriptions(subModel));
			case 2:
				var subModel = _v1.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$Pos$Passenger$GotSellSingleChargeMsg,
					$author$project$Pages$Pos$Passenger$SellSingleCharge$subscriptions(subModel));
			case 3:
				var subModel = _v1.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$Pos$Passenger$GotApplyRefillMsg,
					$author$project$Pages$Pos$Passenger$ApplyRefill$subscriptions(subModel));
			case 4:
				var subModel = _v1.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$Pos$Passenger$GotIssueCardMsg,
					$author$project$Pages$Pos$Passenger$IssueCard$subscriptions(subModel));
			case 5:
				var subModel = _v1.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$Pos$Passenger$GotIssueDuplicateMsg,
					$author$project$Pages$Pos$Passenger$IssueDuplicate$subscriptions(subModel));
			case 6:
				var subModel = _v1.a;
				return $elm$core$Platform$Sub$none;
			default:
				var subModel = _v1.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$Pos$Passenger$GotUnlockCardMsg,
					$author$project$Pages$Pos$Passenger$UnlockCard$subscriptions(subModel));
		}
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Pages$Pos$Register$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Pages$Pos$Register$GotEditorMsg,
		$author$project$Pages$Pos$Editor$subscriptions(model.cR));
};
var $author$project$Pages$subscriptions = function (model) {
	switch (model.$) {
		case 0:
			var model_ = model.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$LoginMsg,
				$author$project$Pages$Login$subscriptions(model_));
		case 3:
			var model_ = model.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$PosGuicheMsg,
				$author$project$Pages$Pos$Guiche$subscriptions(model_));
		case 7:
			var model_ = model.b;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$PosPassengerMsg,
				$author$project$Pages$Pos$Passenger$subscriptions(model_));
		case 8:
			var model_ = model.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$PosEditMsg,
				$author$project$Pages$Pos$Edit$subscriptions(model_));
		case 6:
			var model_ = model.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$PosRegisterMsg,
				$author$project$Pages$Pos$Register$subscriptions(model_));
		case 9:
			var model_ = model.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$PosLocalizeMsg,
				$author$project$Pages$Pos$Localize$subscriptions(model_));
		case 50:
			var model_ = model.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$ReportAdministrativeSalesMsg,
				$author$project$Pages$Reports$AdministrativeSales$subscription(model_));
		case 17:
			var maybeConcessionaireId = model.a;
			var model_ = model.b;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$EnterpriseRegisterMsg,
				$author$project$Pages$Enterprise$Register$subscriptions(model_));
		case 12:
			var model_ = model.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$EnterpriseDashboardMsg,
				$author$project$Pages$Enterprise$Dashboard$subscriptions(model_));
		case 15:
			var model_ = model.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$EnterpriseHistoryMsg,
				$author$project$Pages$Admin$CompanyOrders$subscriptions(model_));
		case 18:
			var maybeConcessionaireId = model.a;
			var model_ = model.b;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$AdminMsg,
				$author$project$Pages$Admin$subscriptions(model_));
		case 39:
			var model_ = model.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$ReportEventUsingSessionMsg,
				$author$project$Pages$Reports$Event$UsingSession$subscription(model_));
		case 40:
			var model_ = model.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$ReportAuditMsg,
				$author$project$Pages$Reports$Event$Audit$subscription(model_));
		case 38:
			var model_ = model.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$ReportEventUsingOperatorMsg,
				$author$project$Pages$Reports$Event$UsingOperator$subscription(model_));
		case 43:
			var model_ = model.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$ReportUsesPerClassMsg,
				$author$project$Pages$Reports$UsesPerClass$subscription(model_));
		case 36:
			var model_ = model.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$ReportEventUsingLineMsg,
				$author$project$Pages$Reports$Event$UsingLine$subscription(model_));
		case 35:
			var model_ = model.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$ReportEventUsingVehicleMsg,
				$author$project$Pages$Reports$Event$UsingVehicle$subscription(model_));
		case 54:
			var model_ = model.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$PanelClassesMsg,
				$author$project$Pages$Panel$Classes$SubPage$subscriptions(model_));
		case 44:
			var model_ = model.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$ReportDivergencesMsg,
				$author$project$Pages$Reports$Divergences$subscription(model_));
		default:
			return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Shared$CloseDialog = {$: 16};
var $author$project$Shared$GotCopyResponse = function (a) {
	return {$: 8, a: a};
};
var $author$project$Shared$copyFailed = _Platform_incomingPort('copyFailed', $elm$json$Json$Decode$string);
var $author$project$Shared$copySucceed = _Platform_incomingPort('copySucceed', $elm$json$Json$Decode$string);
var $elm$time$Time$Every = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$State = F2(
	function (taggers, processes) {
		return {j1: processes, kP: taggers};
	});
var $elm$time$Time$init = $elm$core$Task$succeed(
	A2($elm$time$Time$State, $elm$core$Dict$empty, $elm$core$Dict$empty));
var $elm$time$Time$addMySub = F2(
	function (_v0, state) {
		var interval = _v0.a;
		var tagger = _v0.b;
		var _v1 = A2($elm$core$Dict$get, interval, state);
		if (_v1.$ === 1) {
			return A3(
				$elm$core$Dict$insert,
				interval,
				_List_fromArray(
					[tagger]),
				state);
		} else {
			var taggers = _v1.a;
			return A3(
				$elm$core$Dict$insert,
				interval,
				A2($elm$core$List$cons, tagger, taggers),
				state);
		}
	});
var $elm$time$Time$setInterval = _Time_setInterval;
var $elm$time$Time$spawnHelp = F3(
	function (router, intervals, processes) {
		if (!intervals.b) {
			return $elm$core$Task$succeed(processes);
		} else {
			var interval = intervals.a;
			var rest = intervals.b;
			var spawnTimer = $elm$core$Process$spawn(
				A2(
					$elm$time$Time$setInterval,
					interval,
					A2($elm$core$Platform$sendToSelf, router, interval)));
			var spawnRest = function (id) {
				return A3(
					$elm$time$Time$spawnHelp,
					router,
					rest,
					A3($elm$core$Dict$insert, interval, id, processes));
			};
			return A2($elm$core$Task$andThen, spawnRest, spawnTimer);
		}
	});
var $elm$time$Time$onEffects = F3(
	function (router, subs, _v0) {
		var processes = _v0.j1;
		var rightStep = F3(
			function (_v6, id, _v7) {
				var spawns = _v7.a;
				var existing = _v7.b;
				var kills = _v7.c;
				return _Utils_Tuple3(
					spawns,
					existing,
					A2(
						$elm$core$Task$andThen,
						function (_v5) {
							return kills;
						},
						$elm$core$Process$kill(id)));
			});
		var newTaggers = A3($elm$core$List$foldl, $elm$time$Time$addMySub, $elm$core$Dict$empty, subs);
		var leftStep = F3(
			function (interval, taggers, _v4) {
				var spawns = _v4.a;
				var existing = _v4.b;
				var kills = _v4.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, interval, spawns),
					existing,
					kills);
			});
		var bothStep = F4(
			function (interval, taggers, id, _v3) {
				var spawns = _v3.a;
				var existing = _v3.b;
				var kills = _v3.c;
				return _Utils_Tuple3(
					spawns,
					A3($elm$core$Dict$insert, interval, id, existing),
					kills);
			});
		var _v1 = A6(
			$elm$core$Dict$merge,
			leftStep,
			bothStep,
			rightStep,
			newTaggers,
			processes,
			_Utils_Tuple3(
				_List_Nil,
				$elm$core$Dict$empty,
				$elm$core$Task$succeed(0)));
		var spawnList = _v1.a;
		var existingDict = _v1.b;
		var killTask = _v1.c;
		return A2(
			$elm$core$Task$andThen,
			function (newProcesses) {
				return $elm$core$Task$succeed(
					A2($elm$time$Time$State, newTaggers, newProcesses));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v2) {
					return A3($elm$time$Time$spawnHelp, router, spawnList, existingDict);
				},
				killTask));
	});
var $elm$time$Time$onSelfMsg = F3(
	function (router, interval, state) {
		var _v0 = A2($elm$core$Dict$get, interval, state.kP);
		if (_v0.$ === 1) {
			return $elm$core$Task$succeed(state);
		} else {
			var taggers = _v0.a;
			var tellTaggers = function (time) {
				return $elm$core$Task$sequence(
					A2(
						$elm$core$List$map,
						function (tagger) {
							return A2(
								$elm$core$Platform$sendToApp,
								router,
								tagger(time));
						},
						taggers));
			};
			return A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$succeed(state);
				},
				A2($elm$core$Task$andThen, tellTaggers, $elm$time$Time$now));
		}
	});
var $elm$time$Time$subMap = F2(
	function (f, _v0) {
		var interval = _v0.a;
		var tagger = _v0.b;
		return A2(
			$elm$time$Time$Every,
			interval,
			A2($elm$core$Basics$composeL, f, tagger));
	});
_Platform_effectManagers['Time'] = _Platform_createManager($elm$time$Time$init, $elm$time$Time$onEffects, $elm$time$Time$onSelfMsg, 0, $elm$time$Time$subMap);
var $elm$time$Time$subscription = _Platform_leaf('Time');
var $elm$time$Time$every = F2(
	function (interval, tagger) {
		return $elm$time$Time$subscription(
			A2($elm$time$Time$Every, interval, tagger));
	});
var $elm$browser$Browser$Events$onKeyDown = A2($elm$browser$Browser$Events$on, 0, 'keydown');
var $author$project$Utils$onPressEsc = function (msg) {
	return $elm$browser$Browser$Events$onKeyDown(
		A2(
			$elm$json$Json$Decode$andThen,
			function (keyCode) {
				return (keyCode === 'Escape') ? $elm$json$Json$Decode$succeed(msg) : $elm$json$Json$Decode$fail('Not Esc');
			},
			A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string)));
};
var $author$project$Shared$subscriptions_ = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Utils$onPressEsc($author$project$Shared$CloseDialog),
				$author$project$Shared$copyFailed(
				A2($elm$core$Basics$composeR, $elm$core$Result$Err, $author$project$Shared$GotCopyResponse)),
				$author$project$Shared$copySucceed(
				A2($elm$core$Basics$composeR, $elm$core$Result$Ok, $author$project$Shared$GotCopyResponse)),
				model.qq ? $elm$core$Platform$Sub$none : A2(
				$elm$time$Time$every,
				(5 * 60) * 1000,
				function (_v0) {
					return $author$project$Shared$CheckUpdate;
				}),
				function () {
				var _v1 = model.pF;
				if (!_v1.$) {
					return A2(
						$elm$time$Time$every,
						(30 * 60) * 1000,
						function (_v2) {
							return $author$project$Shared$CheckBilling;
						});
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}()
			]));
};
var $author$project$Shared$subscriptions = function (model) {
	return $author$project$Shared$subscriptions_(model);
};
var $author$project$Main$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Main$PagesMsg,
				$author$project$Pages$subscriptions(model.bv)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Main$SharedMsg,
				$author$project$Shared$subscriptions(model.v)),
				$author$project$Main$receiveTokenData(
				A2(
					$elm$core$Basics$composeR,
					$elm$json$Json$Decode$decodeValue($author$project$Data$User$decoder),
					$author$project$Main$ReceivedTokenData))
			]));
};
var $elm$core$Tuple$mapBoth = F3(
	function (funcA, funcB, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			funcA(x),
			funcB(y));
	});
var $author$project$Shared$Logout = {$: 10};
var $author$project$Components$Patterns$NavigationDrawer$currentSubRoute = function (route) {
	if (route.$ === 19) {
		switch (route.a.$) {
			case 2:
				var _v1 = route.a;
				return A2($author$project$Route$Cards, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
			case 4:
				var _v2 = route.a;
				return A3($author$project$Route$Vehicles, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
			default:
				var subRoute = route.a;
				return subRoute;
		}
	} else {
		return $author$project$Route$Users($author$project$Services$Models$initQueriesUsers);
	}
};
var $author$project$Components$Patterns$NavigationDrawer$routesThatHaveConcessionaireQuery = function (route) {
	_v0$14:
	while (true) {
		switch (route.$) {
			case 4:
				switch (route.a.$) {
					case 1:
						return true;
					case 3:
						var _v13 = route.a;
						return true;
					case 4:
						return true;
					case 5:
						var _v14 = route.a;
						return true;
					case 6:
						return true;
					default:
						break _v0$14;
				}
			case 19:
				switch (route.a.$) {
					case 2:
						if ((route.a.a.$ === 1) && (route.a.b.$ === 1)) {
							var _v1 = route.a;
							var _v2 = _v1.a;
							var _v3 = _v1.b;
							return true;
						} else {
							break _v0$14;
						}
					case 1:
						var _v4 = route.a;
						return true;
					case 4:
						if (((route.a.a.$ === 1) && (route.a.b.$ === 1)) && (route.a.c.$ === 1)) {
							var _v5 = route.a;
							var _v6 = _v5.a;
							var _v7 = _v5.b;
							var _v8 = _v5.c;
							return true;
						} else {
							break _v0$14;
						}
					case 5:
						var _v9 = route.a;
						return true;
					case 9:
						return true;
					case 10:
						var _v10 = route.a;
						return true;
					case 11:
						var _v11 = route.a;
						return true;
					case 12:
						var _v12 = route.a;
						return true;
					case 0:
						return true;
					default:
						break _v0$14;
				}
			default:
				break _v0$14;
		}
	}
	return false;
};
var $author$project$Components$Patterns$NavigationDrawer$selectedConcessionaireCmd = F2(
	function (id, shared) {
		return $author$project$Components$Patterns$NavigationDrawer$routesThatHaveConcessionaireQuery(shared.pv) ? A2(
			$author$project$Route$pushUrl,
			shared.nZ,
			A2(
				$author$project$Route$Admin,
				$author$project$Components$Patterns$NavigationDrawer$currentSubRoute(shared.pv),
				$elm$core$String$isEmpty(id) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(id))) : $elm$core$Platform$Cmd$none;
	});
var $author$project$Components$Patterns$Forms$strMaybe = function (v) {
	return $elm$core$String$isEmpty(v) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(v);
};
var $author$project$Shared$ConsoleError = function (a) {
	return {$: 19, a: a};
};
var $author$project$Shared$GotUnauthorizedError = {$: 17};
var $author$project$Services$Api$errorToLog = function (error) {
	switch (error.$) {
		case 0:
			var url = error.a;
			return 'BadUrl: ' + url;
		case 1:
			return 'Timeout';
		case 2:
			return 'NetworkError';
		case 3:
			return 'Unauthorized';
		case 5:
			var meta = error.a;
			var err = error.b;
			return 'ServerError:' + err;
		case 6:
			var meta = error.a;
			var decodeError = error.b;
			return 'ServerErrorDecodeError: ' + $elm$json$Json$Decode$errorToString(decodeError);
		case 7:
			var decodeError = error.a;
			return 'DecodeError: ' + $elm$json$Json$Decode$errorToString(decodeError);
		case 4:
			return 'Address not found';
		default:
			return 'concessionaireID is required';
	}
};
var $author$project$Services$Api$errorToUserMessage = function (error) {
	switch (error.$) {
		case 0:
			var url = error.a;
			return 'Endereço inválido';
		case 1:
			return 'Tempo limite de resposta atingido. Verifique sua conexão.';
		case 2:
			return 'Não foi possível se conectar ao servidor';
		case 3:
			return 'Não autorizado';
		case 5:
			var meta = error.a;
			var err = error.b;
			return err;
		case 6:
			var meta = error.a;
			var decodeError = error.b;
			return 'Ocorreu um erro no servidor: resposta inesperada';
		case 7:
			var decodeError = error.a;
			return 'Ocorreu um erro: resposta inesperada';
		case 4:
			return 'Ocorreu um erro: recurso não encontrado';
		default:
			return 'Concessionaria não selecionada';
	}
};
var $author$project$Shared$updateApiError = F2(
	function (shared, error) {
		if (error.$ === 3) {
			return $author$project$Shared$GotUnauthorizedError;
		} else {
			return $author$project$Shared$Batch(
				_List_fromArray(
					[
						$author$project$Shared$ShowErrorDialog(
						$author$project$Services$Api$errorToUserMessage(error)),
						$author$project$Shared$ConsoleError(
						$author$project$Services$Api$errorToLog(error))
					]));
		}
	});
var $author$project$Components$Patterns$NavigationDrawer$update = F3(
	function (msg, shared, model) {
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					var concessionaires_ = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bR: concessionaires_}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						A2($author$project$Shared$updateApiError, shared, error));
				}
			case 1:
				var id = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							cN: $author$project$Components$Patterns$Forms$strMaybe(id)
						}),
					A2($author$project$Components$Patterns$NavigationDrawer$selectedConcessionaireCmd, id, shared),
					$author$project$Shared$NoOp);
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bR: _List_Nil,
							cN: $author$project$Components$Patterns$NavigationDrawer$currentConcessionaireId(shared.pv)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$Logout);
			default:
				var _v1 = msg.a;
				var bool = _v1.a;
				var maybeGrouped = _v1.b;
				var routes = _v1.c;
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp),
					A2(
						$elm$core$Maybe$map,
						function (_v2) {
							var groupedID = _v2.a;
							var groupedName = _v2.b;
							var newRoutes = A2(
								$elm$core$List$map,
								function (_v3) {
									var bool_ = _v3.a;
									var maybeGrouped_ = _v3.b;
									var routes_ = _v3.c;
									return A2(
										$elm$core$Maybe$withDefault,
										_Utils_Tuple3(bool_, maybeGrouped_, routes_),
										A2(
											$elm$core$Maybe$map,
											function (_v4) {
												var groupedID_ = _v4.a;
												var groupedName_ = _v4.b;
												return _Utils_eq(groupedID, groupedID_) ? _Utils_Tuple3(
													!bool_,
													$elm$core$Maybe$Just(
														_Utils_Tuple2(groupedID_, groupedName_)),
													routes_) : _Utils_Tuple3(bool_, maybeGrouped_, routes_);
											},
											maybeGrouped_));
								},
								model.d7);
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{d7: newRoutes}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						},
						maybeGrouped));
		}
	});
var $author$project$Pages$ChangePasswordMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$EnterpriseHistoryDetailsMsg = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$EnterpriseHistoryDetailsPage = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Pages$NotFoundMsg = function (a) {
	return {$: 56, a: a};
};
var $author$project$Pages$RecoverPasswordMsg = function (a) {
	return {$: 2, a: a};
};
var $elm$browser$Browser$Navigation$reloadAndSkipCache = _Browser_reload(true);
var $author$project$Pages$Admin$AccountabilityReport$GenerateCsvDownloadWithTime = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $elm$bytes$Bytes$Encode$getWidth = function (builder) {
	switch (builder.$) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 4;
		case 3:
			return 1;
		case 4:
			return 2;
		case 5:
			return 4;
		case 6:
			return 4;
		case 7:
			return 8;
		case 8:
			var w = builder.a;
			return w;
		case 9:
			var w = builder.a;
			return w;
		default:
			var bs = builder.a;
			return _Bytes_width(bs);
	}
};
var $elm$bytes$Bytes$LE = 0;
var $elm$bytes$Bytes$Encode$write = F3(
	function (builder, mb, offset) {
		switch (builder.$) {
			case 0:
				var n = builder.a;
				return A3(_Bytes_write_i8, mb, offset, n);
			case 1:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_i16, mb, offset, n, !e);
			case 2:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_i32, mb, offset, n, !e);
			case 3:
				var n = builder.a;
				return A3(_Bytes_write_u8, mb, offset, n);
			case 4:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_u16, mb, offset, n, !e);
			case 5:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_u32, mb, offset, n, !e);
			case 6:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_f32, mb, offset, n, !e);
			case 7:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_f64, mb, offset, n, !e);
			case 8:
				var bs = builder.b;
				return A3($elm$bytes$Bytes$Encode$writeSequence, bs, mb, offset);
			case 9:
				var s = builder.b;
				return A3(_Bytes_write_string, mb, offset, s);
			default:
				var bs = builder.a;
				return A3(_Bytes_write_bytes, mb, offset, bs);
		}
	});
var $elm$bytes$Bytes$Encode$writeSequence = F3(
	function (builders, mb, offset) {
		writeSequence:
		while (true) {
			if (!builders.b) {
				return offset;
			} else {
				var b = builders.a;
				var bs = builders.b;
				var $temp$builders = bs,
					$temp$mb = mb,
					$temp$offset = A3($elm$bytes$Bytes$Encode$write, b, mb, offset);
				builders = $temp$builders;
				mb = $temp$mb;
				offset = $temp$offset;
				continue writeSequence;
			}
		}
	});
var $elm$bytes$Bytes$Decode$decode = F2(
	function (_v0, bs) {
		var decoder = _v0;
		return A2(_Bytes_decode, decoder, bs);
	});
var $commonmind$elm_csv_encode$Csv$Encode$defaultSettings = {ln: true, mC: ','};
var $elm$bytes$Bytes$Decode$Decoder = $elm$core$Basics$identity;
var $elm$bytes$Bytes$Decode$string = function (n) {
	return _Bytes_read_string(n);
};
var $elm$bytes$Bytes$Encode$encode = _Bytes_encode;
var $elm$bytes$Bytes$Encode$Utf8 = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $elm$bytes$Bytes$Encode$string = function (str) {
	return A2(
		$elm$bytes$Bytes$Encode$Utf8,
		_Bytes_getStringWidth(str),
		str);
};
var $commonmind$elm_csv_encode$Csv$Encode$crlf = $elm$bytes$Bytes$Encode$string('\u000D\n');
var $commonmind$elm_csv_encode$Csv$Encode$escapeString = A2(
	$elm$core$Basics$composeR,
	$elm$core$String$split('\"'),
	$elm$core$String$join('\"\"'));
var $commonmind$elm_csv_encode$Csv$Encode$formatField = F2(
	function (_v0, s) {
		var alwaysQuoted = _v0.ln;
		var delimiter = _v0.mC;
		return (alwaysQuoted || A2($elm$core$String$contains, delimiter, s)) ? ('\"' + ($commonmind$elm_csv_encode$Csv$Encode$escapeString(s) + '\"')) : $commonmind$elm_csv_encode$Csv$Encode$escapeString(s);
	});
var $elm$core$List$intersperse = F2(
	function (sep, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var hd = xs.a;
			var tl = xs.b;
			var step = F2(
				function (x, rest) {
					return A2(
						$elm$core$List$cons,
						sep,
						A2($elm$core$List$cons, x, rest));
				});
			var spersed = A3($elm$core$List$foldr, step, _List_Nil, tl);
			return A2($elm$core$List$cons, hd, spersed);
		}
	});
var $elm$bytes$Bytes$Encode$Seq = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $elm$bytes$Bytes$Encode$getWidths = F2(
	function (width, builders) {
		getWidths:
		while (true) {
			if (!builders.b) {
				return width;
			} else {
				var b = builders.a;
				var bs = builders.b;
				var $temp$width = width + $elm$bytes$Bytes$Encode$getWidth(b),
					$temp$builders = bs;
				width = $temp$width;
				builders = $temp$builders;
				continue getWidths;
			}
		}
	});
var $elm$bytes$Bytes$Encode$sequence = function (builders) {
	return A2(
		$elm$bytes$Bytes$Encode$Seq,
		A2($elm$bytes$Bytes$Encode$getWidths, 0, builders),
		builders);
};
var $commonmind$elm_csv_encode$Csv$Encode$formatRow = function (setts) {
	var delimiter = setts.mC;
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$List$map(
			$commonmind$elm_csv_encode$Csv$Encode$formatField(setts)),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$intersperse(delimiter),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map($elm$bytes$Bytes$Encode$string),
				$elm$bytes$Bytes$Encode$sequence)));
};
var $commonmind$elm_csv_encode$Csv$Encode$formatLines = function (setts) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$List$map(
			$commonmind$elm_csv_encode$Csv$Encode$formatRow(setts)),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$intersperse($commonmind$elm_csv_encode$Csv$Encode$crlf),
			$elm$bytes$Bytes$Encode$sequence));
};
var $commonmind$elm_csv_encode$Csv$Encode$toEncoderWith = F2(
	function (setts, _v0) {
		var headers = _v0.nG;
		var records = _v0.pj;
		return $elm$bytes$Bytes$Encode$sequence(
			_List_fromArray(
				[
					A2(
					$commonmind$elm_csv_encode$Csv$Encode$formatLines,
					setts,
					A2($elm$core$List$cons, headers, records)),
					$commonmind$elm_csv_encode$Csv$Encode$crlf
				]));
	});
var $commonmind$elm_csv_encode$Csv$Encode$toBytesWith = function (setts) {
	return A2(
		$elm$core$Basics$composeR,
		$commonmind$elm_csv_encode$Csv$Encode$toEncoderWith(setts),
		$elm$bytes$Bytes$Encode$encode);
};
var $elm$bytes$Bytes$width = _Bytes_width;
var $commonmind$elm_csv_encode$Csv$Encode$toStringWith = F2(
	function (setts, csv) {
		var bytes = A2($commonmind$elm_csv_encode$Csv$Encode$toBytesWith, setts, csv);
		var _v0 = A2(
			$elm$bytes$Bytes$Decode$decode,
			$elm$bytes$Bytes$Decode$string(
				$elm$bytes$Bytes$width(bytes)),
			bytes);
		if (!_v0.$) {
			var v = _v0.a;
			return v;
		} else {
			return $commonmind$elm_csv_encode$Csv$Encode$cyclic$toString()(csv);
		}
	});
function $commonmind$elm_csv_encode$Csv$Encode$cyclic$toString() {
	return $commonmind$elm_csv_encode$Csv$Encode$toStringWith($commonmind$elm_csv_encode$Csv$Encode$defaultSettings);
}
var $commonmind$elm_csv_encode$Csv$Encode$toString = $commonmind$elm_csv_encode$Csv$Encode$cyclic$toString();
$commonmind$elm_csv_encode$Csv$Encode$cyclic$toString = function () {
	return $commonmind$elm_csv_encode$Csv$Encode$toString;
};
var $author$project$Components$GeneratorCSV$encode = F2(
	function (records, headers) {
		var removeLineBreak = function (str) {
			return A3(
				$elm$core$String$replace,
				'\n\u000D',
				'',
				A3(
					$elm$core$String$replace,
					'\u000D\n',
					'',
					A3(
						$elm$core$String$replace,
						'\n',
						'',
						A3($elm$core$String$replace, '\u000D', '', str))));
		};
		var structureCsv = {
			nG: A2($elm$core$List$map, removeLineBreak, headers),
			pj: A2(
				$elm$core$List$map,
				$elm$core$List$map(removeLineBreak),
				records)
		};
		var config = {ln: false, mC: ';'};
		return A2($commonmind$elm_csv_encode$Csv$Encode$toStringWith, config, structureCsv);
	});
var $elm$file$File$Download$string = F3(
	function (name, mime, content) {
		return A2(
			$elm$core$Task$perform,
			$elm$core$Basics$never,
			A3(_File_download, name, mime, content));
	});
var $author$project$Components$GeneratorCSV$download = F3(
	function (records, headers, filename) {
		var csv = A2($author$project$Components$GeneratorCSV$encode, records, headers);
		return A3($elm$file$File$Download$string, filename, 'text/csv', csv);
	});
var $author$project$Utils$emptyStrDefault = function (str) {
	return (str !== '') ? str : '-';
};
var $coinop_logan$elm_format_number$Parser$FormattedNumber = F5(
	function (original, integers, decimals, prefix, suffix) {
		return {my: decimals, jh: integers, jS: original, hi: prefix, hI: suffix};
	});
var $coinop_logan$elm_format_number$Parser$Negative = 2;
var $coinop_logan$elm_format_number$Parser$Positive = 0;
var $coinop_logan$elm_format_number$Parser$Zero = 1;
var $coinop_logan$elm_format_number$Parser$classify = function (formatted) {
	var onlyZeros = A2(
		$elm$core$String$all,
		function (_char) {
			return _char === '0';
		},
		$elm$core$String$concat(
			A2(
				$elm$core$List$append,
				formatted.jh,
				$elm$core$List$singleton(formatted.my))));
	return onlyZeros ? 1 : ((formatted.jS < 0) ? 2 : 0);
};
var $elm$core$String$filter = _String_filter;
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $myrho$elm_round$Round$addSign = F2(
	function (signed, str) {
		var isNotZero = A2(
			$elm$core$List$any,
			function (c) {
				return (c !== '0') && (c !== '.');
			},
			$elm$core$String$toList(str));
		return _Utils_ap(
			(signed && isNotZero) ? '-' : '',
			str);
	});
var $elm$core$String$fromFloat = _String_fromNumber;
var $myrho$elm_round$Round$increaseNum = function (_v0) {
	var head = _v0.a;
	var tail = _v0.b;
	if (head === '9') {
		var _v1 = $elm$core$String$uncons(tail);
		if (_v1.$ === 1) {
			return '01';
		} else {
			var headtail = _v1.a;
			return A2(
				$elm$core$String$cons,
				'0',
				$myrho$elm_round$Round$increaseNum(headtail));
		}
	} else {
		var c = $elm$core$Char$toCode(head);
		return ((c >= 48) && (c < 57)) ? A2(
			$elm$core$String$cons,
			$elm$core$Char$fromCode(c + 1),
			tail) : '0';
	}
};
var $elm$core$Basics$isInfinite = _Basics_isInfinite;
var $elm$core$Basics$isNaN = _Basics_isNaN;
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $elm$core$String$padRight = F3(
	function (n, _char, string) {
		return _Utils_ap(
			string,
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)));
	});
var $elm$core$String$reverse = _String_reverse;
var $myrho$elm_round$Round$splitComma = function (str) {
	var _v0 = A2($elm$core$String$split, '.', str);
	if (_v0.b) {
		if (_v0.b.b) {
			var before = _v0.a;
			var _v1 = _v0.b;
			var after = _v1.a;
			return _Utils_Tuple2(before, after);
		} else {
			var before = _v0.a;
			return _Utils_Tuple2(before, '0');
		}
	} else {
		return _Utils_Tuple2('0', '0');
	}
};
var $myrho$elm_round$Round$toDecimal = function (fl) {
	var _v0 = A2(
		$elm$core$String$split,
		'e',
		$elm$core$String$fromFloat(
			$elm$core$Basics$abs(fl)));
	if (_v0.b) {
		if (_v0.b.b) {
			var num = _v0.a;
			var _v1 = _v0.b;
			var exp = _v1.a;
			var e = A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(
					A2($elm$core$String$startsWith, '+', exp) ? A2($elm$core$String$dropLeft, 1, exp) : exp));
			var _v2 = $myrho$elm_round$Round$splitComma(num);
			var before = _v2.a;
			var after = _v2.b;
			var total = _Utils_ap(before, after);
			var zeroed = (e < 0) ? A2(
				$elm$core$Maybe$withDefault,
				'0',
				A2(
					$elm$core$Maybe$map,
					function (_v3) {
						var a = _v3.a;
						var b = _v3.b;
						return a + ('.' + b);
					},
					A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$mapFirst($elm$core$String$fromChar),
						$elm$core$String$uncons(
							_Utils_ap(
								A2(
									$elm$core$String$repeat,
									$elm$core$Basics$abs(e),
									'0'),
								total))))) : A3($elm$core$String$padRight, e + 1, '0', total);
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				zeroed);
		} else {
			var num = _v0.a;
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				num);
		}
	} else {
		return '';
	}
};
var $myrho$elm_round$Round$roundFun = F3(
	function (functor, s, fl) {
		if ($elm$core$Basics$isInfinite(fl) || $elm$core$Basics$isNaN(fl)) {
			return $elm$core$String$fromFloat(fl);
		} else {
			var signed = fl < 0;
			var _v0 = $myrho$elm_round$Round$splitComma(
				$myrho$elm_round$Round$toDecimal(
					$elm$core$Basics$abs(fl)));
			var before = _v0.a;
			var after = _v0.b;
			var r = $elm$core$String$length(before) + s;
			var normalized = _Utils_ap(
				A2($elm$core$String$repeat, (-r) + 1, '0'),
				A3(
					$elm$core$String$padRight,
					r,
					'0',
					_Utils_ap(before, after)));
			var totalLen = $elm$core$String$length(normalized);
			var roundDigitIndex = A2($elm$core$Basics$max, 1, r);
			var increase = A2(
				functor,
				signed,
				A3($elm$core$String$slice, roundDigitIndex, totalLen, normalized));
			var remains = A3($elm$core$String$slice, 0, roundDigitIndex, normalized);
			var num = increase ? $elm$core$String$reverse(
				A2(
					$elm$core$Maybe$withDefault,
					'1',
					A2(
						$elm$core$Maybe$map,
						$myrho$elm_round$Round$increaseNum,
						$elm$core$String$uncons(
							$elm$core$String$reverse(remains))))) : remains;
			var numLen = $elm$core$String$length(num);
			var numZeroed = (num === '0') ? num : ((s <= 0) ? _Utils_ap(
				num,
				A2(
					$elm$core$String$repeat,
					$elm$core$Basics$abs(s),
					'0')) : ((_Utils_cmp(
				s,
				$elm$core$String$length(after)) < 0) ? (A3($elm$core$String$slice, 0, numLen - s, num) + ('.' + A3($elm$core$String$slice, numLen - s, numLen, num))) : _Utils_ap(
				before + '.',
				A3($elm$core$String$padRight, s, '0', after))));
			return A2($myrho$elm_round$Round$addSign, signed, numZeroed);
		}
	});
var $myrho$elm_round$Round$round = $myrho$elm_round$Round$roundFun(
	F2(
		function (signed, str) {
			var _v0 = $elm$core$String$uncons(str);
			if (_v0.$ === 1) {
				return false;
			} else {
				if ('5' === _v0.a.a) {
					if (_v0.a.b === '') {
						var _v1 = _v0.a;
						return !signed;
					} else {
						var _v2 = _v0.a;
						return true;
					}
				} else {
					var _v3 = _v0.a;
					var _int = _v3.a;
					return function (i) {
						return ((i > 53) && signed) || ((i >= 53) && (!signed));
					}(
						$elm$core$Char$toCode(_int));
				}
			}
		}));
var $elm$core$String$dropRight = F2(
	function (n, string) {
		return (n < 1) ? string : A3($elm$core$String$slice, 0, -n, string);
	});
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $coinop_logan$elm_format_number$Parser$splitThousands = function (integers) {
	var reversedSplitThousands = function (value) {
		return ($elm$core$String$length(value) > 3) ? A2(
			$elm$core$List$cons,
			A2($elm$core$String$right, 3, value),
			reversedSplitThousands(
				A2($elm$core$String$dropRight, 3, value))) : _List_fromArray(
			[value]);
	};
	return $elm$core$List$reverse(
		reversedSplitThousands(integers));
};
var $coinop_logan$elm_format_number$Parser$parse = F2(
	function (locale, original) {
		var parts = A2(
			$elm$core$String$split,
			'.',
			A2($myrho$elm_round$Round$round, locale.my, original));
		var integers = $coinop_logan$elm_format_number$Parser$splitThousands(
			A2(
				$elm$core$String$filter,
				$elm$core$Char$isDigit,
				A2(
					$elm$core$Maybe$withDefault,
					'0',
					$elm$core$List$head(parts))));
		var decimals = A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm$core$List$head(
				A2($elm$core$List$drop, 1, parts)));
		var partial = A5($coinop_logan$elm_format_number$Parser$FormattedNumber, original, integers, decimals, '', '');
		var _v0 = $coinop_logan$elm_format_number$Parser$classify(partial);
		switch (_v0) {
			case 2:
				return _Utils_update(
					partial,
					{hi: locale.ok, hI: locale.ol});
			case 0:
				return _Utils_update(
					partial,
					{hi: locale.oZ, hI: locale.o_});
			default:
				return partial;
		}
	});
var $coinop_logan$elm_format_number$Stringfy$formatDecimals = F2(
	function (locale, decimals) {
		return (decimals === '') ? '' : _Utils_ap(locale.mx, decimals);
	});
var $coinop_logan$elm_format_number$Stringfy$removeZeros = function (decimals) {
	return (A2($elm$core$String$right, 1, decimals) !== '0') ? decimals : $coinop_logan$elm_format_number$Stringfy$removeZeros(
		A2($elm$core$String$dropRight, 1, decimals));
};
var $coinop_logan$elm_format_number$Stringfy$humanizeDecimals = F3(
	function (locale, strategy, decimals) {
		if ((decimals === '') || _Utils_eq(
			A2($elm$core$String$repeat, locale.my, '0'),
			decimals)) {
			return '';
		} else {
			if (!strategy) {
				return _Utils_ap(locale.mx, decimals);
			} else {
				return A2(
					$coinop_logan$elm_format_number$Stringfy$formatDecimals,
					locale,
					$coinop_logan$elm_format_number$Stringfy$removeZeros(decimals));
			}
		}
	});
var $coinop_logan$elm_format_number$Stringfy$stringfy = F3(
	function (locale, strategy, formatted) {
		var stringfyDecimals = function () {
			if (!strategy.$) {
				var strategy_ = strategy.a;
				return A2($coinop_logan$elm_format_number$Stringfy$humanizeDecimals, locale, strategy_);
			} else {
				return $coinop_logan$elm_format_number$Stringfy$formatDecimals(locale);
			}
		}();
		var integers = A2($elm$core$String$join, locale.p4, formatted.jh);
		var decimals = stringfyDecimals(formatted.my);
		return $elm$core$String$concat(
			_List_fromArray(
				[formatted.hi, integers, decimals, formatted.hI]));
	});
var $coinop_logan$elm_format_number$FormatNumber$format = F2(
	function (locale, number_) {
		return A3(
			$coinop_logan$elm_format_number$Stringfy$stringfy,
			locale,
			$elm$core$Maybe$Nothing,
			A2($coinop_logan$elm_format_number$Parser$parse, locale, number_));
	});
var $author$project$Utils$formatAsMoney = function (input) {
	return 'R$ ' + A2(
		$coinop_logan$elm_format_number$FormatNumber$format,
		{mx: ',', my: 2, ok: '−', ol: '', oZ: '', o_: '', p4: '.'},
		function (v) {
			return v / 100;
		}(
			A2(
				$elm$core$Maybe$withDefault,
				0.0,
				$elm$core$String$toFloat(
					A3($elm$core$String$replace, ',', '.', input)))));
};
var $ryan_haskell$date_format$DateFormat$DayOfMonthFixed = {$: 7};
var $ryan_haskell$date_format$DateFormat$dayOfMonthFixed = $ryan_haskell$date_format$DateFormat$DayOfMonthFixed;
var $ryan_haskell$date_format$DateFormat$Language$Language = F6(
	function (toMonthName, toMonthAbbreviation, toWeekdayName, toWeekdayAbbreviation, toAmPm, toOrdinalSuffix) {
		return {p7: toAmPm, p8: toMonthAbbreviation, p9: toMonthName, df: toOrdinalSuffix, qa: toWeekdayAbbreviation, qb: toWeekdayName};
	});
var $ryan_haskell$date_format$DateFormat$Language$toEnglishAmPm = function (hour) {
	return (hour > 11) ? 'pm' : 'am';
};
var $ryan_haskell$date_format$DateFormat$Language$toEnglishMonthName = function (month) {
	switch (month) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $ryan_haskell$date_format$DateFormat$Language$toEnglishSuffix = function (num) {
	var _v0 = A2($elm$core$Basics$modBy, 100, num);
	switch (_v0) {
		case 11:
			return 'th';
		case 12:
			return 'th';
		case 13:
			return 'th';
		default:
			var _v1 = A2($elm$core$Basics$modBy, 10, num);
			switch (_v1) {
				case 1:
					return 'st';
				case 2:
					return 'nd';
				case 3:
					return 'rd';
				default:
					return 'th';
			}
	}
};
var $ryan_haskell$date_format$DateFormat$Language$toEnglishWeekdayName = function (weekday) {
	switch (weekday) {
		case 0:
			return 'Monday';
		case 1:
			return 'Tuesday';
		case 2:
			return 'Wednesday';
		case 3:
			return 'Thursday';
		case 4:
			return 'Friday';
		case 5:
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $ryan_haskell$date_format$DateFormat$Language$english = A6(
	$ryan_haskell$date_format$DateFormat$Language$Language,
	$ryan_haskell$date_format$DateFormat$Language$toEnglishMonthName,
	A2(
		$elm$core$Basics$composeR,
		$ryan_haskell$date_format$DateFormat$Language$toEnglishMonthName,
		$elm$core$String$left(3)),
	$ryan_haskell$date_format$DateFormat$Language$toEnglishWeekdayName,
	A2(
		$elm$core$Basics$composeR,
		$ryan_haskell$date_format$DateFormat$Language$toEnglishWeekdayName,
		$elm$core$String$left(3)),
	$ryan_haskell$date_format$DateFormat$Language$toEnglishAmPm,
	$ryan_haskell$date_format$DateFormat$Language$toEnglishSuffix);
var $ryan_haskell$date_format$DateFormat$amPm = F3(
	function (language, zone, posix) {
		return language.p7(
			A2($elm$time$Time$toHour, zone, posix));
	});
var $ryan_haskell$date_format$DateFormat$dayOfMonth = $elm$time$Time$toDay;
var $elm$time$Time$Sun = 6;
var $elm$time$Time$Fri = 4;
var $elm$time$Time$Mon = 0;
var $elm$time$Time$Sat = 5;
var $elm$time$Time$Thu = 3;
var $elm$time$Time$Tue = 1;
var $elm$time$Time$Wed = 2;
var $ryan_haskell$date_format$DateFormat$days = _List_fromArray(
	[6, 0, 1, 2, 3, 4, 5]);
var $elm$time$Time$toWeekday = F2(
	function (zone, time) {
		var _v0 = A2(
			$elm$core$Basics$modBy,
			7,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60 * 24));
		switch (_v0) {
			case 0:
				return 3;
			case 1:
				return 4;
			case 2:
				return 5;
			case 3:
				return 6;
			case 4:
				return 0;
			case 5:
				return 1;
			default:
				return 2;
		}
	});
var $ryan_haskell$date_format$DateFormat$dayOfWeek = F2(
	function (zone, posix) {
		return function (_v1) {
			var i = _v1.a;
			return i;
		}(
			A2(
				$elm$core$Maybe$withDefault,
				_Utils_Tuple2(0, 6),
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (_v0) {
							var day = _v0.b;
							return _Utils_eq(
								day,
								A2($elm$time$Time$toWeekday, zone, posix));
						},
						A2(
							$elm$core$List$indexedMap,
							F2(
								function (i, day) {
									return _Utils_Tuple2(i, day);
								}),
							$ryan_haskell$date_format$DateFormat$days)))));
	});
var $ryan_haskell$date_format$DateFormat$isLeapYear = function (year_) {
	return (!(!A2($elm$core$Basics$modBy, 4, year_))) ? false : ((!(!A2($elm$core$Basics$modBy, 100, year_))) ? true : ((!(!A2($elm$core$Basics$modBy, 400, year_))) ? false : true));
};
var $ryan_haskell$date_format$DateFormat$daysInMonth = F2(
	function (year_, month) {
		switch (month) {
			case 0:
				return 31;
			case 1:
				return $ryan_haskell$date_format$DateFormat$isLeapYear(year_) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $ryan_haskell$date_format$DateFormat$months = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]);
var $ryan_haskell$date_format$DateFormat$monthPair = F2(
	function (zone, posix) {
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(0, 0),
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var i = _v0.a;
						var m = _v0.b;
						return _Utils_eq(
							m,
							A2($elm$time$Time$toMonth, zone, posix));
					},
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (a, b) {
								return _Utils_Tuple2(a, b);
							}),
						$ryan_haskell$date_format$DateFormat$months))));
	});
var $ryan_haskell$date_format$DateFormat$monthNumber_ = F2(
	function (zone, posix) {
		return 1 + function (_v0) {
			var i = _v0.a;
			var m = _v0.b;
			return i;
		}(
			A2($ryan_haskell$date_format$DateFormat$monthPair, zone, posix));
	});
var $elm$core$List$sum = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
};
var $ryan_haskell$date_format$DateFormat$dayOfYear = F2(
	function (zone, posix) {
		var monthsBeforeThisOne = A2(
			$elm$core$List$take,
			A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix) - 1,
			$ryan_haskell$date_format$DateFormat$months);
		var daysBeforeThisMonth = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				$ryan_haskell$date_format$DateFormat$daysInMonth(
					A2($elm$time$Time$toYear, zone, posix)),
				monthsBeforeThisOne));
		return daysBeforeThisMonth + A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix);
	});
var $ryan_haskell$date_format$DateFormat$quarter = F2(
	function (zone, posix) {
		return (A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix) / 4) | 0;
	});
var $ryan_haskell$date_format$DateFormat$toFixedLength = F2(
	function (totalChars, num) {
		var numStr = $elm$core$String$fromInt(num);
		var numZerosNeeded = totalChars - $elm$core$String$length(numStr);
		var zeros = A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				function (_v0) {
					return '0';
				},
				A2($elm$core$List$range, 1, numZerosNeeded)));
		return _Utils_ap(zeros, numStr);
	});
var $ryan_haskell$date_format$DateFormat$toNonMilitary = function (num) {
	return (!num) ? 12 : ((num <= 12) ? num : (num - 12));
};
var $elm$core$String$toUpper = _String_toUpper;
var $ryan_haskell$date_format$DateFormat$millisecondsPerYear = $elm$core$Basics$round((((1000 * 60) * 60) * 24) * 365.25);
var $ryan_haskell$date_format$DateFormat$firstDayOfYear = F2(
	function (zone, time) {
		return $elm$time$Time$millisToPosix(
			$ryan_haskell$date_format$DateFormat$millisecondsPerYear * A2($elm$time$Time$toYear, zone, time));
	});
var $ryan_haskell$date_format$DateFormat$weekOfYear = F2(
	function (zone, posix) {
		var firstDay = A2($ryan_haskell$date_format$DateFormat$firstDayOfYear, zone, posix);
		var firstDayOffset = A2($ryan_haskell$date_format$DateFormat$dayOfWeek, zone, firstDay);
		var daysSoFar = A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix);
		return (((daysSoFar + firstDayOffset) / 7) | 0) + 1;
	});
var $ryan_haskell$date_format$DateFormat$year = F2(
	function (zone, time) {
		return $elm$core$String$fromInt(
			A2($elm$time$Time$toYear, zone, time));
	});
var $ryan_haskell$date_format$DateFormat$piece = F4(
	function (language, zone, posix, token) {
		switch (token.$) {
			case 0:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix));
			case 1:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.df(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix));
			case 2:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix));
			case 3:
				return language.p8(
					A2($elm$time$Time$toMonth, zone, posix));
			case 4:
				return language.p9(
					A2($elm$time$Time$toMonth, zone, posix));
			case 17:
				return $elm$core$String$fromInt(
					1 + A2($ryan_haskell$date_format$DateFormat$quarter, zone, posix));
			case 18:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.df(num));
				}(
					1 + A2($ryan_haskell$date_format$DateFormat$quarter, zone, posix));
			case 5:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix));
			case 6:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.df(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix));
			case 7:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix));
			case 8:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix));
			case 9:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.df(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix));
			case 10:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					3,
					A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix));
			case 11:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$dayOfWeek, zone, posix));
			case 12:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.df(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$dayOfWeek, zone, posix));
			case 13:
				return language.qa(
					A2($elm$time$Time$toWeekday, zone, posix));
			case 14:
				return language.qb(
					A2($elm$time$Time$toWeekday, zone, posix));
			case 19:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$weekOfYear, zone, posix));
			case 20:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.df(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$weekOfYear, zone, posix));
			case 21:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($ryan_haskell$date_format$DateFormat$weekOfYear, zone, posix));
			case 15:
				return A2(
					$elm$core$String$right,
					2,
					A2($ryan_haskell$date_format$DateFormat$year, zone, posix));
			case 16:
				return A2($ryan_haskell$date_format$DateFormat$year, zone, posix);
			case 22:
				return $elm$core$String$toUpper(
					A3($ryan_haskell$date_format$DateFormat$amPm, language, zone, posix));
			case 23:
				return $elm$core$String$toLower(
					A3($ryan_haskell$date_format$DateFormat$amPm, language, zone, posix));
			case 24:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toHour, zone, posix));
			case 25:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toHour, zone, posix));
			case 26:
				return $elm$core$String$fromInt(
					$ryan_haskell$date_format$DateFormat$toNonMilitary(
						A2($elm$time$Time$toHour, zone, posix)));
			case 27:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					$ryan_haskell$date_format$DateFormat$toNonMilitary(
						A2($elm$time$Time$toHour, zone, posix)));
			case 28:
				return $elm$core$String$fromInt(
					1 + A2($elm$time$Time$toHour, zone, posix));
			case 29:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					1 + A2($elm$time$Time$toHour, zone, posix));
			case 30:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toMinute, zone, posix));
			case 31:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toMinute, zone, posix));
			case 32:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toSecond, zone, posix));
			case 33:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toSecond, zone, posix));
			case 34:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toMillis, zone, posix));
			case 35:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					3,
					A2($elm$time$Time$toMillis, zone, posix));
			default:
				var string = token.a;
				return string;
		}
	});
var $ryan_haskell$date_format$DateFormat$formatWithLanguage = F4(
	function (language, tokens, zone, time) {
		return A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				A3($ryan_haskell$date_format$DateFormat$piece, language, zone, time),
				tokens));
	});
var $ryan_haskell$date_format$DateFormat$format = $ryan_haskell$date_format$DateFormat$formatWithLanguage($ryan_haskell$date_format$DateFormat$Language$english);
var $ryan_haskell$date_format$DateFormat$HourMilitaryFixed = {$: 25};
var $ryan_haskell$date_format$DateFormat$hourMilitaryFixed = $ryan_haskell$date_format$DateFormat$HourMilitaryFixed;
var $ryan_haskell$date_format$DateFormat$MinuteFixed = {$: 31};
var $ryan_haskell$date_format$DateFormat$minuteFixed = $ryan_haskell$date_format$DateFormat$MinuteFixed;
var $ryan_haskell$date_format$DateFormat$MonthFixed = {$: 2};
var $ryan_haskell$date_format$DateFormat$monthFixed = $ryan_haskell$date_format$DateFormat$MonthFixed;
var $ryan_haskell$date_format$DateFormat$Text = function (a) {
	return {$: 36, a: a};
};
var $ryan_haskell$date_format$DateFormat$text = $ryan_haskell$date_format$DateFormat$Text;
var $ryan_haskell$date_format$DateFormat$YearNumber = {$: 16};
var $ryan_haskell$date_format$DateFormat$yearNumber = $ryan_haskell$date_format$DateFormat$YearNumber;
var $author$project$Utils$formatDateTimeFromPosix = function (timezone) {
	return A2(
		$ryan_haskell$date_format$DateFormat$format,
		_List_fromArray(
			[
				$ryan_haskell$date_format$DateFormat$dayOfMonthFixed,
				$ryan_haskell$date_format$DateFormat$text('/'),
				$ryan_haskell$date_format$DateFormat$monthFixed,
				$ryan_haskell$date_format$DateFormat$text('/'),
				$ryan_haskell$date_format$DateFormat$yearNumber,
				$ryan_haskell$date_format$DateFormat$text(' '),
				$ryan_haskell$date_format$DateFormat$hourMilitaryFixed,
				$ryan_haskell$date_format$DateFormat$text(':'),
				$ryan_haskell$date_format$DateFormat$minuteFixed
			]),
		timezone);
};
var $author$project$Utils$formatDateTimeFromMaybePosix = F2(
	function (timezone, maybePosix) {
		return A2(
			$elm$core$Maybe$withDefault,
			'-',
			A2(
				$elm$core$Maybe$map,
				$author$project$Utils$formatDateTimeFromPosix(timezone),
				maybePosix));
	});
var $author$project$Pages$Admin$AccountabilityReport$getMoney = function (spinsCounts) {
	return A2(
		$elm$core$List$filterMap,
		function (_v0) {
			var k = _v0.a;
			var v = _v0.b;
			return A2(
				$elm$core$String$contains,
				'dinheiro',
				$elm$core$String$toLower(k)) ? $elm$core$Maybe$Just(v) : $elm$core$Maybe$Nothing;
		},
		$elm$core$Dict$toList(spinsCounts));
};
var $author$project$Utils$iso8601ToSimpleDate = function (str) {
	var _v0 = A2($elm$core$String$split, 'T', str);
	if (_v0.b) {
		var simple_date = _v0.a;
		return simple_date;
	} else {
		return str;
	}
};
var $justinmimbs$time_extra$Time$Extra$posixToParts = F2(
	function (zone, posix) {
		return {
			dC: A2($elm$time$Time$toDay, zone, posix),
			eO: A2($elm$time$Time$toHour, zone, posix),
			e3: A2($elm$time$Time$toMillis, zone, posix),
			e5: A2($elm$time$Time$toMinute, zone, posix),
			b8: A2($elm$time$Time$toMonth, zone, posix),
			ft: A2($elm$time$Time$toSecond, zone, posix),
			cF: A2($elm$time$Time$toYear, zone, posix)
		};
	});
var $author$project$Utils$startOfTheMonth = F2(
	function (timezone, time) {
		var parts = A2($justinmimbs$time_extra$Time$Extra$posixToParts, timezone, time);
		return A2(
			$justinmimbs$time_extra$Time$Extra$partsToPosix,
			timezone,
			{dC: 1, eO: 0, e3: 0, e5: 0, b8: parts.b8, ft: 0, cF: parts.cF});
	});
var $justinmimbs$date$Date$day = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.dC;
	});
var $justinmimbs$date$Date$month = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.b8;
	});
var $justinmimbs$date$Date$monthNumber = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToNumber);
var $justinmimbs$date$Date$ordinalDay = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toOrdinalDate,
	function ($) {
		return $.ha;
	});
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $justinmimbs$date$Date$padSignedInt = F2(
	function (length, _int) {
		return _Utils_ap(
			(_int < 0) ? '-' : '',
			A3(
				$elm$core$String$padLeft,
				length,
				'0',
				$elm$core$String$fromInt(
					$elm$core$Basics$abs(_int))));
	});
var $justinmimbs$date$Date$monthToQuarter = function (m) {
	return (($justinmimbs$date$Date$monthToNumber(m) + 2) / 3) | 0;
};
var $justinmimbs$date$Date$quarter = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToQuarter);
var $justinmimbs$date$Date$weekdayNumber = function (_v0) {
	var rd = _v0;
	var _v1 = A2($elm$core$Basics$modBy, 7, rd);
	if (!_v1) {
		return 7;
	} else {
		var n = _v1;
		return n;
	}
};
var $justinmimbs$date$Date$daysBeforeWeekYear = function (y) {
	var jan4 = $justinmimbs$date$Date$daysBeforeYear(y) + 4;
	return jan4 - $justinmimbs$date$Date$weekdayNumber(jan4);
};
var $justinmimbs$date$Date$numberToWeekday = function (wdn) {
	var _v0 = A2($elm$core$Basics$max, 1, wdn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		default:
			return 6;
	}
};
var $justinmimbs$date$Date$toWeekDate = function (_v0) {
	var rd = _v0;
	var wdn = $justinmimbs$date$Date$weekdayNumber(rd);
	var wy = $justinmimbs$date$Date$year(rd + (4 - wdn));
	var week1Day1 = $justinmimbs$date$Date$daysBeforeWeekYear(wy) + 1;
	return {
		la: 1 + (((rd - week1Day1) / 7) | 0),
		lb: wy,
		qP: $justinmimbs$date$Date$numberToWeekday(wdn)
	};
};
var $justinmimbs$date$Date$weekNumber = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.la;
	});
var $justinmimbs$date$Date$weekYear = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.lb;
	});
var $justinmimbs$date$Date$weekday = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$weekdayNumber, $justinmimbs$date$Date$numberToWeekday);
var $justinmimbs$date$Date$ordinalSuffix = function (n) {
	var nn = A2($elm$core$Basics$modBy, 100, n);
	var _v0 = A2(
		$elm$core$Basics$min,
		(nn < 20) ? nn : A2($elm$core$Basics$modBy, 10, nn),
		4);
	switch (_v0) {
		case 1:
			return 'st';
		case 2:
			return 'nd';
		case 3:
			return 'rd';
		default:
			return 'th';
	}
};
var $justinmimbs$date$Date$withOrdinalSuffix = function (n) {
	return _Utils_ap(
		$elm$core$String$fromInt(n),
		$justinmimbs$date$Date$ordinalSuffix(n));
};
var $justinmimbs$date$Date$formatField = F4(
	function (language, _char, length, date) {
		switch (_char) {
			case 'y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$year(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$year(date));
				}
			case 'Y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekYear(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$weekYear(date));
				}
			case 'Q':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 3:
						return 'Q' + $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 4:
						return $justinmimbs$date$Date$withOrdinalSuffix(
							$justinmimbs$date$Date$quarter(date));
					case 5:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					default:
						return '';
				}
			case 'M':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$monthNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$monthNumber(date)));
					case 3:
						return language.e7(
							$justinmimbs$date$Date$month(date));
					case 4:
						return language.gY(
							$justinmimbs$date$Date$month(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.e7(
								$justinmimbs$date$Date$month(date)));
					default:
						return '';
				}
			case 'w':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekNumber(date)));
					default:
						return '';
				}
			case 'd':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$day(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$day(date)));
					case 3:
						return language.gg(
							$justinmimbs$date$Date$day(date));
					default:
						return '';
				}
			case 'D':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$ordinalDay(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					case 3:
						return A3(
							$elm$core$String$padLeft,
							3,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					default:
						return '';
				}
			case 'E':
				switch (length) {
					case 1:
						return language.cD(
							$justinmimbs$date$Date$weekday(date));
					case 2:
						return language.cD(
							$justinmimbs$date$Date$weekday(date));
					case 3:
						return language.cD(
							$justinmimbs$date$Date$weekday(date));
					case 4:
						return language.hP(
							$justinmimbs$date$Date$weekday(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.cD(
								$justinmimbs$date$Date$weekday(date)));
					case 6:
						return A2(
							$elm$core$String$left,
							2,
							language.cD(
								$justinmimbs$date$Date$weekday(date)));
					default:
						return '';
				}
			case 'e':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					default:
						return A4($justinmimbs$date$Date$formatField, language, 'E', length, date);
				}
			default:
				return '';
		}
	});
var $justinmimbs$date$Date$formatWithTokens = F3(
	function (language, tokens, date) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (token, formatted) {
					if (!token.$) {
						var _char = token.a;
						var length = token.b;
						return _Utils_ap(
							A4($justinmimbs$date$Date$formatField, language, _char, length, date),
							formatted);
					} else {
						var str = token.a;
						return _Utils_ap(str, formatted);
					}
				}),
			'',
			tokens);
	});
var $justinmimbs$date$Pattern$Literal = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $elm$parser$Parser$token = function (str) {
	return $elm$parser$Parser$Advanced$token(
		$elm$parser$Parser$toToken(str));
};
var $justinmimbs$date$Pattern$escapedQuote = A2(
	$elm$parser$Parser$ignorer,
	$elm$parser$Parser$succeed(
		$justinmimbs$date$Pattern$Literal('\'')),
	$elm$parser$Parser$token('\'\''));
var $justinmimbs$date$Pattern$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$getOffset = function (s) {
	return A3($elm$parser$Parser$Advanced$Good, false, s.oq, s);
};
var $elm$parser$Parser$getOffset = $elm$parser$Parser$Advanced$getOffset;
var $justinmimbs$date$Pattern$fieldRepeats = function (str) {
	var _v0 = $elm$core$String$toList(str);
	if (_v0.b && (!_v0.b.b)) {
		var _char = _v0.a;
		return A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F2(
						function (x, y) {
							return A2($justinmimbs$date$Pattern$Field, _char, 1 + (y - x));
						})),
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$getOffset,
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq(_char)))),
			$elm$parser$Parser$getOffset);
	} else {
		return $elm$parser$Parser$problem('expected exactly one char');
	}
};
var $justinmimbs$date$Pattern$field = A2(
	$elm$parser$Parser$andThen,
	$justinmimbs$date$Pattern$fieldRepeats,
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompIf($elm$core$Char$isAlpha)));
var $justinmimbs$date$Pattern$finalize = A2(
	$elm$core$List$foldl,
	F2(
		function (token, tokens) {
			var _v0 = _Utils_Tuple2(token, tokens);
			if (((_v0.a.$ === 1) && _v0.b.b) && (_v0.b.a.$ === 1)) {
				var x = _v0.a.a;
				var _v1 = _v0.b;
				var y = _v1.a.a;
				var rest = _v1.b;
				return A2(
					$elm$core$List$cons,
					$justinmimbs$date$Pattern$Literal(
						_Utils_ap(x, y)),
					rest);
			} else {
				return A2($elm$core$List$cons, token, tokens);
			}
		}),
	_List_Nil);
var $elm$parser$Parser$Advanced$lazy = function (thunk) {
	return function (s) {
		var _v0 = thunk(0);
		var parse = _v0;
		return parse(s);
	};
};
var $elm$parser$Parser$lazy = $elm$parser$Parser$Advanced$lazy;
var $justinmimbs$date$Pattern$isLiteralChar = function (_char) {
	return (_char !== '\'') && (!$elm$core$Char$isAlpha(_char));
};
var $justinmimbs$date$Pattern$literal = A2(
	$elm$parser$Parser$map,
	$justinmimbs$date$Pattern$Literal,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($justinmimbs$date$Pattern$isLiteralChar)),
			$elm$parser$Parser$chompWhile($justinmimbs$date$Pattern$isLiteralChar))));
var $justinmimbs$date$Pattern$quotedHelp = function (result) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (str) {
					return $justinmimbs$date$Pattern$quotedHelp(
						_Utils_ap(result, str));
				},
				$elm$parser$Parser$getChompedString(
					A2(
						$elm$parser$Parser$ignorer,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed(0),
							$elm$parser$Parser$chompIf(
								$elm$core$Basics$neq('\''))),
						$elm$parser$Parser$chompWhile(
							$elm$core$Basics$neq('\''))))),
				A2(
				$elm$parser$Parser$andThen,
				function (_v0) {
					return $justinmimbs$date$Pattern$quotedHelp(result + '\'');
				},
				$elm$parser$Parser$token('\'\'')),
				$elm$parser$Parser$succeed(result)
			]));
};
var $justinmimbs$date$Pattern$quoted = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($justinmimbs$date$Pattern$Literal),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('\''))),
	A2(
		$elm$parser$Parser$ignorer,
		$justinmimbs$date$Pattern$quotedHelp(''),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq('\'')),
					$elm$parser$Parser$end
				]))));
var $justinmimbs$date$Pattern$patternHelp = function (tokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (token) {
					return $justinmimbs$date$Pattern$patternHelp(
						A2($elm$core$List$cons, token, tokens));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[$justinmimbs$date$Pattern$field, $justinmimbs$date$Pattern$literal, $justinmimbs$date$Pattern$escapedQuote, $justinmimbs$date$Pattern$quoted]))),
				$elm$parser$Parser$lazy(
				function (_v0) {
					return $elm$parser$Parser$succeed(
						$justinmimbs$date$Pattern$finalize(tokens));
				})
			]));
};
var $justinmimbs$date$Pattern$fromString = function (str) {
	return A2(
		$elm$core$Result$withDefault,
		_List_fromArray(
			[
				$justinmimbs$date$Pattern$Literal(str)
			]),
		A2(
			$elm$parser$Parser$run,
			$justinmimbs$date$Pattern$patternHelp(_List_Nil),
			str));
};
var $justinmimbs$date$Date$formatWithLanguage = F2(
	function (language, pattern) {
		var tokens = $elm$core$List$reverse(
			$justinmimbs$date$Pattern$fromString(pattern));
		return A2($justinmimbs$date$Date$formatWithTokens, language, tokens);
	});
var $justinmimbs$date$Date$monthToName = function (m) {
	switch (m) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $justinmimbs$date$Date$weekdayToName = function (wd) {
	switch (wd) {
		case 0:
			return 'Monday';
		case 1:
			return 'Tuesday';
		case 2:
			return 'Wednesday';
		case 3:
			return 'Thursday';
		case 4:
			return 'Friday';
		case 5:
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $justinmimbs$date$Date$language_en = {
	gg: $justinmimbs$date$Date$withOrdinalSuffix,
	gY: $justinmimbs$date$Date$monthToName,
	e7: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$monthToName,
		$elm$core$String$left(3)),
	hP: $justinmimbs$date$Date$weekdayToName,
	cD: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$weekdayToName,
		$elm$core$String$left(3))
};
var $justinmimbs$date$Date$format = function (pattern) {
	return A2($justinmimbs$date$Date$formatWithLanguage, $justinmimbs$date$Date$language_en, pattern);
};
var $justinmimbs$date$Date$toIsoString = $justinmimbs$date$Date$format('yyyy-MM-dd');
var $author$project$Pages$Admin$AccountabilityReport$ReceivedReport = function (a) {
	return {$: 2, a: a};
};
var $author$project$Services$Concessionaire$AccountabilityReportRow = function (accountabilitie_date) {
	return function (accountabilitie_name) {
		return function (accountabilitie_value) {
			return function (session_line) {
				return function (session_open_name) {
					return function (session_close_name) {
						return function (session_open) {
							return function (session_close) {
								return function (vehicle) {
									return function (confirmId) {
										return function (pouch) {
											return function (spinsCounts) {
												return {hT: accountabilitie_date, hU: accountabilitie_name, fP: accountabilitie_value, iv: confirmId, cf: pouch, ky: session_close, kz: session_close_name, kA: session_line, kB: session_open, kC: session_open_name, kJ: spinsCounts, k2: vehicle};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$core$Result$toMaybe = function (result) {
	if (!result.$) {
		var v = result.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Utils$decodeNullableIso8601ToPosix = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$map,
			function (v) {
				return (v === '') ? $elm$core$Maybe$Nothing : $elm$core$Result$toMaybe(
					$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(v));
			},
			$elm$json$Json$Decode$string),
			A2(
			$elm$json$Json$Decode$map,
			$elm$core$Basics$always($elm$core$Maybe$Nothing),
			$elm$json$Json$Decode$null(''))
		]));
var $author$project$Services$Concessionaire$accountabilityReport = function (options) {
	var decoder = A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'spinsCounts',
		$elm$json$Json$Decode$dict($elm$json$Json$Decode$int),
		$elm$core$Dict$empty,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'pouch',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'confirmId',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'vehicle',
					A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Services$Concessionaire$vehicleDecoder),
					$elm$core$Maybe$Nothing,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'cashierCloseAt',
						$author$project$Utils$decodeNullableIso8601ToPosix,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'cashierOpenAt',
							$author$project$Utils$decodeNullableIso8601ToPosix,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'cashierCloseName',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'cashierOpenName',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'cashierLine',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'accountabilitieValue',
											$elm$json$Json$Decode$int,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'accountabilitieName',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'accountabilitieDate',
													$author$project$Utils$decodeNullableIso8601ToPosix,
													$elm$json$Json$Decode$succeed($author$project$Services$Concessionaire$AccountabilityReportRow)))))))))))));
	return $elm$http$Http$request(
		{
			lG: $elm$http$Http$emptyBody,
			m9: A2(
				$author$project$Services$Api$expectJson,
				options.ow,
				$elm$json$Json$Decode$list(decoder)),
			nG: _List_fromArray(
				[
					$author$project$Services$Api$authorizationHeader(options.kU)
				]),
			of: 'GET',
			p5: $elm$core$Maybe$Nothing,
			qi: $elm$core$Maybe$Nothing,
			qt: A2(
				$author$project$Constants$cashierServiceUrl,
				_List_fromArray(
					['api', 'v1', 'cashier', 'report', 'accountability']),
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$map,
							$elm$url$Url$Builder$string('concessionaireId'),
							options.mc),
							$elm$core$Maybe$Just(
							A2(
								$elm$url$Url$Builder$string,
								'startDate',
								$author$project$Utils$iso8601ToSimpleDate(options.no.eb))),
							$elm$core$Maybe$Just(
							A2(
								$elm$url$Url$Builder$string,
								'endDate',
								$author$project$Utils$iso8601ToSimpleDate(options.no.dH))),
							$elm$core$String$isEmpty(options.nm) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
							A2($elm$url$Url$Builder$string, 'coletor', options.nm)),
							$elm$core$String$isEmpty(options.em) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
							A2($elm$url$Url$Builder$string, 'vehicle', options.em)),
							$elm$core$String$isEmpty(options.cf) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
							A2($elm$url$Url$Builder$string, 'pouch', options.cf)),
							$elm$core$String$isEmpty(options.co) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
							A2($elm$url$Url$Builder$string, 'status', options.co))
						])))
		});
};
var $author$project$Pages$Admin$AccountabilityReport$updateFilter = F3(
	function (shared, user, model) {
		var _v0 = model.cO;
		if (!_v0.$) {
			var date = _v0.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{ck: $krisajenkins$remotedata$RemoteData$Loading}),
				$author$project$Services$Concessionaire$accountabilityReport(
					{
						mc: $author$project$Route$extractConcessionaireId(shared.pv),
						nm: model.fq,
						no: {dH: date.dH, eb: date.eb},
						ow: $author$project$Pages$Admin$AccountabilityReport$ReceivedReport,
						cf: model.cf,
						co: model.co,
						kU: user.kU,
						em: model.em
					}),
				$author$project$Shared$NoOp);
		} else {
			return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
		}
	});
var $author$project$Pages$Admin$AccountabilityReport$update = F4(
	function (msg, model, shared, user) {
		switch (msg.$) {
			case 0:
				var now = msg.a.e8;
				var timezone = msg.a.kS;
				var today = A2($justinmimbs$date$Date$fromPosix, timezone, now);
				var startOfTheMonth = A2($author$project$Utils$startOfTheMonth, timezone, now);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							cO: $elm$core$Maybe$Just(
								{
									dH: $justinmimbs$date$Date$toIsoString(today),
									eb: $justinmimbs$date$Date$toIsoString(today)
								}),
							kS: timezone
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 1:
				var reports = msg.a;
				var now = msg.b.e8;
				var timezone = msg.b.kS;
				var title = 'Arrecadação ' + (A2($author$project$Utils$formatDateTimeFromPosix, timezone, now) + '.csv');
				var records = A2(
					$elm$core$List$map,
					function (row) {
						var spinsCountsEmpty = function (list) {
							return $elm$core$List$isEmpty(list) ? '-' : $elm$core$String$fromInt(
								$elm$core$List$sum(list));
						};
						return _List_fromArray(
							[
								A2($author$project$Utils$formatDateTimeFromMaybePosix, timezone, row.hT),
								$author$project$Utils$emptyStrDefault(row.hU),
								$author$project$Utils$formatAsMoney(
								$elm$core$String$fromInt(row.fP)),
								A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.l4;
									},
									row.k2)),
								$author$project$Utils$emptyStrDefault(row.kA),
								$author$project$Utils$emptyStrDefault(row.kC),
								$author$project$Utils$emptyStrDefault(row.kz),
								A2($author$project$Utils$formatDateTimeFromMaybePosix, timezone, row.kB),
								A2($author$project$Utils$formatDateTimeFromMaybePosix, timezone, row.ky),
								spinsCountsEmpty(
								$author$project$Pages$Admin$AccountabilityReport$getMoney(row.kJ)),
								A2(
								$elm$core$Maybe$withDefault,
								'-',
								A2(
									$elm$core$Maybe$map,
									A2(
										$elm$core$Basics$composeR,
										$elm$core$String$right(4),
										$elm$core$String$toUpper),
									row.iv)),
								A2(
								$elm$core$Maybe$withDefault,
								'-',
								A2($elm$core$Maybe$map, $author$project$Utils$emptyStrDefault, row.cf))
							]);
					},
					reports);
				var headers = _List_fromArray(
					['Data', 'Arrecadador', 'Valor (R$)', 'Veículo', 'Linha', 'Operador Abertura', 'Operador Fechamento', 'Abertura', 'Fechamento', 'Quantitativo de pagantes em dinheiro', 'Cód. Confirmação', 'Malote']);
				return _Utils_Tuple3(
					model,
					A3($author$project$Components$GeneratorCSV$download, records, headers, title),
					$author$project$Shared$NoOp);
			case 2:
				var res = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ck: $krisajenkins$remotedata$RemoteData$fromResult(res)
						}),
					$elm$core$Platform$Cmd$none,
					function () {
						if (!res.$) {
							return $author$project$Shared$NoOp;
						} else {
							var error = res.a;
							return A2($author$project$Shared$updateApiError, shared, error);
						}
					}());
			case 3:
				var index = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{hw: index}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 4:
				var strDate = msg.a;
				var start = $author$project$Utils$iso8601ToSimpleDate(strDate);
				var date_ = A2(
					$elm$core$Maybe$map,
					function (justDate) {
						return _Utils_update(
							justDate,
							{eb: start});
					},
					model.cO);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cO: date_}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 5:
				var strDate = msg.a;
				var end = $author$project$Utils$iso8601ToSimpleDate(strDate);
				var date_ = A2(
					$elm$core$Maybe$map,
					function (justDate) {
						return _Utils_update(
							justDate,
							{dH: end});
					},
					model.cO);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cO: date_}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 6:
				var search = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{fq: search}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 7:
				var str = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{em: str}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 8:
				var str = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cf: str}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 9:
				var str = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{co: str}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 10:
				return A3($author$project$Pages$Admin$AccountabilityReport$updateFilter, shared, user, model);
			default:
				var reports = msg.a;
				return _Utils_Tuple3(
					model,
					A2(
						$elm$core$Task$perform,
						$author$project$Pages$Admin$AccountabilityReport$GenerateCsvDownloadWithTime(reports),
						A3(
							$elm$core$Task$map2,
							F2(
								function (now, timezone) {
									return {e8: now, kS: timezone};
								}),
							$elm$time$Time$now,
							$elm$time$Time$here)),
					$author$project$Shared$NoOp);
		}
	});
var $author$project$Pages$Admin$CardExtract$GenerateCsvDownloadWithTime = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Pages$Admin$CardExtract$GotCard = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $author$project$Pages$Admin$CardExtract$agroupClasses = A2(
	$elm$core$Basics$composeR,
	A2(
		$elm$core$List$foldl,
		F2(
			function (class_, classes) {
				var _v0 = A2($elm$core$Dict$get, class_.cC, classes);
				if (!_v0.$) {
					var class__ = _v0.a;
					return A3(
						$elm$core$Dict$insert,
						class__.cC,
						_Utils_update(
							class__,
							{c3: class__.c3 + (' / ' + class_.c3)}),
						classes);
				} else {
					return A3($elm$core$Dict$insert, class_.cC, class_, classes);
				}
			}),
		$elm$core$Dict$empty),
	A2(
		$elm$core$Basics$composeR,
		$elm$core$Dict$toList,
		$elm$core$List$map($elm$core$Tuple$second)));
var $justinmimbs$date$Date$compare = F2(
	function (_v0, _v1) {
		var a = _v0;
		var b = _v1;
		return A2($elm$core$Basics$compare, a, b);
	});
var $author$project$Pages$Admin$CardExtract$evaluateToAddTextFailure = F2(
	function (txt, isError) {
		return isError ? ('Falha: ' + txt) : txt;
	});
var $ryan_haskell$date_format$DateFormat$SecondFixed = {$: 33};
var $ryan_haskell$date_format$DateFormat$secondFixed = $ryan_haskell$date_format$DateFormat$SecondFixed;
var $author$project$Utils$formatDateTimeWithSecondsFromPosix = function (timezone) {
	return A2(
		$ryan_haskell$date_format$DateFormat$format,
		_List_fromArray(
			[
				$ryan_haskell$date_format$DateFormat$dayOfMonthFixed,
				$ryan_haskell$date_format$DateFormat$text('/'),
				$ryan_haskell$date_format$DateFormat$monthFixed,
				$ryan_haskell$date_format$DateFormat$text('/'),
				$ryan_haskell$date_format$DateFormat$yearNumber,
				$ryan_haskell$date_format$DateFormat$text(' '),
				$ryan_haskell$date_format$DateFormat$hourMilitaryFixed,
				$ryan_haskell$date_format$DateFormat$text(':'),
				$ryan_haskell$date_format$DateFormat$minuteFixed,
				$ryan_haskell$date_format$DateFormat$text(':'),
				$ryan_haskell$date_format$DateFormat$secondFixed
			]),
		timezone);
};
var $justinmimbs$date$Date$deadEndToString = function (_v0) {
	var problem = _v0.j$;
	if (problem.$ === 12) {
		var message = problem.a;
		return message;
	} else {
		return 'Expected a date in ISO 8601 format';
	}
};
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $justinmimbs$date$Date$MonthAndDay = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $justinmimbs$date$Date$OrdinalDay = function (a) {
	return {$: 2, a: a};
};
var $justinmimbs$date$Date$WeekAndWeekday = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
	var parse = _v0;
	return function (s0) {
		var _v1 = parse(s0);
		if (_v1.$ === 1) {
			var x = _v1.b;
			return A2($elm$parser$Parser$Advanced$Bad, false, x);
		} else {
			var a = _v1.b;
			var s1 = _v1.c;
			return A3($elm$parser$Parser$Advanced$Good, false, a, s1);
		}
	};
};
var $elm$parser$Parser$backtrackable = $elm$parser$Parser$Advanced$backtrackable;
var $elm$parser$Parser$Advanced$commit = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, true, a, s);
	};
};
var $elm$parser$Parser$commit = $elm$parser$Parser$Advanced$commit;
var $elm$parser$Parser$mapChompedString = $elm$parser$Parser$Advanced$mapChompedString;
var $justinmimbs$date$Date$int1 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	$elm$parser$Parser$chompIf($elm$core$Char$isDigit));
var $justinmimbs$date$Date$int2 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed(0),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$int3 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$dayOfYear = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed($elm$core$Basics$identity),
				$elm$parser$Parser$token('-')),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$backtrackable(
						A2(
							$elm$parser$Parser$andThen,
							$elm$parser$Parser$commit,
							A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int2),
									$elm$parser$Parser$succeed(1)
								]))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$ignorer,
								$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
								$elm$parser$Parser$token('W')),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int1),
									$elm$parser$Parser$succeed(1)
								])))
					]))),
			$elm$parser$Parser$backtrackable(
			A2(
				$elm$parser$Parser$andThen,
				$elm$parser$Parser$commit,
				A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
						$justinmimbs$date$Date$int2),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$justinmimbs$date$Date$int2,
								$elm$parser$Parser$succeed(1)
							]))))),
			A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3),
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
					$elm$parser$Parser$token('W')),
				$justinmimbs$date$Date$int2),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$justinmimbs$date$Date$int1,
						$elm$parser$Parser$succeed(1)
					]))),
			$elm$parser$Parser$succeed(
			$justinmimbs$date$Date$OrdinalDay(1))
		]));
var $justinmimbs$date$Date$isBetweenInt = F3(
	function (a, b, x) {
		return (_Utils_cmp(a, x) < 1) && (_Utils_cmp(x, b) < 1);
	});
var $justinmimbs$date$Date$fromCalendarParts = F3(
	function (y, mn, d) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 12, mn) && A3(
			$justinmimbs$date$Date$isBetweenInt,
			1,
			A2(
				$justinmimbs$date$Date$daysInMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn)),
			d)) ? $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeYear(y) + A2(
				$justinmimbs$date$Date$daysBeforeMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn))) + d) : $elm$core$Result$Err(
			'Invalid calendar date (' + ($elm$core$String$fromInt(y) + (', ' + ($elm$core$String$fromInt(mn) + (', ' + ($elm$core$String$fromInt(d) + ')'))))));
	});
var $justinmimbs$date$Date$fromOrdinalParts = F2(
	function (y, od) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 365, od) || ((od === 366) && $justinmimbs$date$Date$isLeapYear(y))) ? $elm$core$Result$Ok(
			$justinmimbs$date$Date$daysBeforeYear(y) + od) : $elm$core$Result$Err(
			'Invalid ordinal date (' + ($elm$core$String$fromInt(y) + (', ' + ($elm$core$String$fromInt(od) + ')'))));
	});
var $justinmimbs$date$Date$firstOfYear = function (y) {
	return $justinmimbs$date$Date$daysBeforeYear(y) + 1;
};
var $justinmimbs$date$Date$is53WeekYear = function (y) {
	var wdnJan1 = $justinmimbs$date$Date$weekdayNumber(
		$justinmimbs$date$Date$firstOfYear(y));
	return (wdnJan1 === 4) || ((wdnJan1 === 3) && $justinmimbs$date$Date$isLeapYear(y));
};
var $justinmimbs$date$Date$fromWeekParts = F3(
	function (wy, wn, wdn) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 7, wdn) && (A3($justinmimbs$date$Date$isBetweenInt, 1, 52, wn) || ((wn === 53) && $justinmimbs$date$Date$is53WeekYear(wy)))) ? $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeWeekYear(wy) + ((wn - 1) * 7)) + wdn) : $elm$core$Result$Err(
			'Invalid week date (' + ($elm$core$String$fromInt(wy) + (', ' + ($elm$core$String$fromInt(wn) + (', ' + ($elm$core$String$fromInt(wdn) + ')'))))));
	});
var $justinmimbs$date$Date$fromYearAndDayOfYear = function (_v0) {
	var y = _v0.a;
	var doy = _v0.b;
	switch (doy.$) {
		case 0:
			var mn = doy.a;
			var d = doy.b;
			return A3($justinmimbs$date$Date$fromCalendarParts, y, mn, d);
		case 1:
			var wn = doy.a;
			var wdn = doy.b;
			return A3($justinmimbs$date$Date$fromWeekParts, y, wn, wdn);
		default:
			var od = doy.a;
			return A2($justinmimbs$date$Date$fromOrdinalParts, y, od);
	}
};
var $justinmimbs$date$Date$int4 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed(0),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									$elm$parser$Parser$chompIf(
									function (c) {
										return c === '-';
									}),
									$elm$parser$Parser$succeed(0)
								]))),
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$resultToParser = function (result) {
	if (!result.$) {
		var x = result.a;
		return $elm$parser$Parser$succeed(x);
	} else {
		var message = result.a;
		return $elm$parser$Parser$problem(message);
	}
};
var $justinmimbs$date$Date$parser = A2(
	$elm$parser$Parser$andThen,
	A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromYearAndDayOfYear, $justinmimbs$date$Date$resultToParser),
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Tuple$pair),
			$justinmimbs$date$Date$int4),
		$justinmimbs$date$Date$dayOfYear));
var $justinmimbs$date$Date$fromIsoString = A2(
	$elm$core$Basics$composeR,
	$elm$parser$Parser$run(
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			A2(
				$elm$parser$Parser$ignorer,
				$justinmimbs$date$Date$parser,
				A2(
					$elm$parser$Parser$andThen,
					$justinmimbs$date$Date$resultToParser,
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2($elm$parser$Parser$map, $elm$core$Result$Ok, $elm$parser$Parser$end),
								A2(
								$elm$parser$Parser$map,
								$elm$core$Basics$always(
									$elm$core$Result$Err('Expected a date only, not a date and time')),
								$elm$parser$Parser$chompIf(
									$elm$core$Basics$eq('T'))),
								$elm$parser$Parser$succeed(
								$elm$core$Result$Err('Expected a date only'))
							])))))),
	$elm$core$Result$mapError(
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$head,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map($justinmimbs$date$Date$deadEndToString),
				$elm$core$Maybe$withDefault('')))));
var $author$project$Pages$Admin$CardExtract$GotTransactions = function (a) {
	return {$: 2, a: a};
};
var $author$project$Services$Concessionaire$AdminCardTransaction = function (id) {
	return function (description) {
		return function (date) {
			return function (value) {
				return function (balance) {
					return function (ctc) {
						return function (ltc) {
							return function (_class) {
								return function (wallet) {
									return function (temporalIntegration) {
										return function (vehicle) {
											return function (line) {
												return function (transactionError) {
													return {h2: balance, ih: _class, iy: ctc, cO: date, z: description, dM: id, e1: line, js: ltc, p1: temporalIntegration, bD: transactionError, di: value, k2: vehicle, k7: wallet};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Services$Concessionaire$TypeBlock = 9;
var $author$project$Services$Concessionaire$TypeCardIssue = 1;
var $author$project$Services$Concessionaire$TypeCardVirtualIssue = 2;
var $author$project$Services$Concessionaire$TypeCredit = 4;
var $author$project$Services$Concessionaire$TypeDebit = 3;
var $author$project$Services$Concessionaire$TypeNegativeCredit = 5;
var $author$project$Services$Concessionaire$TypeRequestBlock = 7;
var $author$project$Services$Concessionaire$TypeRequestUnblock = 8;
var $author$project$Services$Concessionaire$TypeSecondCard = 6;
var $author$project$Services$Concessionaire$TypeUnblock = 10;
var $author$project$Services$Concessionaire$Unknown = 0;
var $author$project$Services$Models$decodeStringOtherThanEmpty = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$andThen,
			function (str) {
				return $elm$core$String$isEmpty(str) ? $elm$json$Json$Decode$succeed('-') : $elm$json$Json$Decode$succeed(str);
			},
			$elm$json$Json$Decode$string),
			$elm$json$Json$Decode$null('-')
		]));
var $author$project$Services$Concessionaire$adminCardReport = function (options) {
	var strToType = function (str) {
		switch (str) {
			case 'card_issue':
				return 1;
			case 'card_virtual_issue':
				return 2;
			case 'debit':
				return 3;
			case 'credit':
				return 4;
			case 'negative_credit':
				return 5;
			case 'second_card':
				return 6;
			case 'request_block':
				return 7;
			case 'request_unblock':
				return 8;
			case 'block':
				return 9;
			case 'unblock':
				return 10;
			default:
				return 0;
		}
	};
	var encoderAdminCardReport = $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'cardId',
				$elm$json$Json$Encode$string(options.lM)),
				_Utils_Tuple2(
				'walletId',
				$elm$json$Json$Encode$string(options.cC)),
				_Utils_Tuple2(
				'start',
				$elm$json$Json$Encode$string(
					$justinmimbs$date$Date$toIsoString(options.mu))),
				_Utils_Tuple2(
				'end',
				$elm$json$Json$Encode$string(
					$justinmimbs$date$Date$toIsoString(options.mv)))
			]));
	var decoder = A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'transactionError',
		$elm$json$Json$Decode$bool,
		false,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'line',
			$author$project$Services$Models$decodeStringOtherThanEmpty,
			'-',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'vehicle',
				$author$project$Services$Models$decodeStringOtherThanEmpty,
				'-',
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'temporalIntegration',
					$elm$json$Json$Decode$bool,
					false,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'wallet',
						$elm$json$Json$Decode$string,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'class',
							$elm$json$Json$Decode$string,
							'-',
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'ltc',
								$elm$json$Json$Decode$maybe(
									$elm$json$Json$Decode$oneOf(
										_List_fromArray(
											[$elm$json$Json$Decode$int]))),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'ctc',
									$elm$json$Json$Decode$maybe(
										$elm$json$Json$Decode$oneOf(
											_List_fromArray(
												[$elm$json$Json$Decode$int]))),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'balance',
										$elm$json$Json$Decode$maybe(
											$elm$json$Json$Decode$oneOf(
												_List_fromArray(
													[$elm$json$Json$Decode$int]))),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'value',
											$elm$json$Json$Decode$maybe(
												$elm$json$Json$Decode$oneOf(
													_List_fromArray(
														[$elm$json$Json$Decode$int]))),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'date',
												A2(
													$elm$json$Json$Decode$map,
													A2(
														$elm$core$Basics$composeR,
														$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime,
														$elm$core$Result$withDefault(
															$elm$time$Time$millisToPosix(0))),
													$elm$json$Json$Decode$string),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'description',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'id',
														$elm$json$Json$Decode$string,
														$elm$json$Json$Decode$succeed($author$project$Services$Concessionaire$AdminCardTransaction))))))))))))));
	return $elm$http$Http$request(
		{
			lG: $elm$http$Http$jsonBody(encoderAdminCardReport),
			m9: A2(
				$author$project$Services$Api$expectJson,
				options.ow,
				$elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							$elm$json$Json$Decode$list(decoder),
							$elm$json$Json$Decode$null(_List_Nil)
						]))),
			nG: _List_fromArray(
				[
					$author$project$Services$Api$authorizationHeader(options.kU)
				]),
			of: 'POST',
			p5: $elm$core$Maybe$Nothing,
			qi: $elm$core$Maybe$Nothing,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'events', 'extract']),
				_List_Nil)
		});
};
var $elm$core$Result$map2 = F3(
	function (func, ra, rb) {
		if (ra.$ === 1) {
			var x = ra.a;
			return $elm$core$Result$Err(x);
		} else {
			var a = ra.a;
			if (rb.$ === 1) {
				var x = rb.a;
				return $elm$core$Result$Err(x);
			} else {
				var b = rb.a;
				return $elm$core$Result$Ok(
					A2(func, a, b));
			}
		}
	});
var $author$project$Pages$Admin$CardExtract$getTransactions = F3(
	function (cardId, user, model) {
		return (model.cp === '') ? _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp) : A2(
			$elm$core$Result$withDefault,
			_Utils_Tuple3(
				model,
				$elm$core$Platform$Cmd$none,
				$author$project$Shared$ShowErrorDialog('Data Inválida!')),
			A3(
				$elm$core$Result$map2,
				F2(
					function (from, to) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{a9: $krisajenkins$remotedata$RemoteData$Loading}),
							$author$project$Services$Concessionaire$adminCardReport(
								{lM: cardId, mu: from, mv: to, ow: $author$project$Pages$Admin$CardExtract$GotTransactions, kU: user.kU, cC: model.cp}),
							$author$project$Shared$NoOp);
					}),
				$justinmimbs$date$Date$fromIsoString(model.bq),
				$justinmimbs$date$Date$fromIsoString(model.bC)));
	});
var $author$project$Pages$Admin$CardExtract$update = F5(
	function (cardId, msg, model, shared, user) {
		switch (msg.$) {
			case 0:
				var now = msg.a.e8;
				var timezone = msg.a.kS;
				var today = A2($justinmimbs$date$Date$fromPosix, timezone, now);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bq: $justinmimbs$date$Date$toIsoString(
								A3($justinmimbs$date$Date$add, 1, -1, today)),
							bC: $justinmimbs$date$Date$toIsoString(today)
						}),
					A2(
						$elm$core$Task$attempt,
						$author$project$Pages$Admin$CardExtract$GotCard(cardId),
						$author$project$Services$Api$getTask(
							{
								mz: $author$project$Services$Concessionaire$cardDecoder,
								kU: $elm$core$Maybe$Just(user.kU),
								qt: A2(
									$author$project$Constants$concessionaireServiceUrl,
									_List_fromArray(
										['api', 'v1', 'card', cardId]),
									_List_Nil)
							})),
					$author$project$Shared$NoOp);
			case 1:
				if (!msg.b.$) {
					var id = msg.a;
					var res = msg.b;
					var card = res.a;
					return _Utils_eq(id, cardId) ? _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cH: $krisajenkins$remotedata$RemoteData$fromResult(res),
								cp: A2(
									$elm$core$Maybe$withDefault,
									'',
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.cC;
										},
										$elm$core$List$head(
											$author$project$Pages$Admin$CardExtract$agroupClasses(card.dv))))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp) : _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
				} else {
					var id = msg.a;
					var res = msg.b;
					var error = res.a;
					return _Utils_eq(id, cardId) ? _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cH: $krisajenkins$remotedata$RemoteData$fromResult(res)
							}),
						$elm$core$Platform$Cmd$none,
						A2($author$project$Shared$updateApiError, shared, error)) : _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
				}
			case 2:
				var res = msg.a;
				var res_ = A2(
					$elm$core$Result$map,
					function (transactions) {
						return A2(
							$elm$core$List$map,
							function (transaction) {
								return transaction.p1 ? _Utils_update(
									transaction,
									{z: transaction.z + ' (Integração Temporal)'}) : transaction;
							},
							transactions);
					},
					res);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							a9: $krisajenkins$remotedata$RemoteData$fromResult(res_)
						}),
					$elm$core$Platform$Cmd$none,
					function () {
						if (!res.$) {
							return $author$project$Shared$NoOp;
						} else {
							var error = res.a;
							return A2($author$project$Shared$updateApiError, shared, error);
						}
					}());
			case 3:
				var str = msg.a;
				var toStr = A2(
					$elm$core$Result$withDefault,
					model.bC,
					A3(
						$elm$core$Result$map2,
						F2(
							function (from, to) {
								return (A2($justinmimbs$date$Date$compare, from, to) === 2) ? str : model.bC;
							}),
						$justinmimbs$date$Date$fromIsoString(str),
						$justinmimbs$date$Date$fromIsoString(model.bC)));
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bq: str, bC: toStr}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 4:
				var str = msg.a;
				var fromStr = A2(
					$elm$core$Result$withDefault,
					model.bq,
					A3(
						$elm$core$Result$map2,
						F2(
							function (from, to) {
								return (A2($justinmimbs$date$Date$compare, from, to) === 2) ? str : model.bq;
							}),
						$justinmimbs$date$Date$fromIsoString(model.bq),
						$justinmimbs$date$Date$fromIsoString(str)));
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bq: fromStr, bC: str}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 5:
				var wID = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cp: wID}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 6:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{az: !model.az}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 7:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{b1: !model.b1}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 8:
				return A3($author$project$Pages$Admin$CardExtract$getTransactions, cardId, user, model);
			case 9:
				var transactions = msg.a;
				return _Utils_Tuple3(
					model,
					A2(
						$elm$core$Task$perform,
						$author$project$Pages$Admin$CardExtract$GenerateCsvDownloadWithTime(transactions),
						$elm$time$Time$now),
					$author$project$Shared$NoOp);
			default:
				var transactions = msg.a;
				var now = msg.b;
				var valueViewMoneyWithDescription = F2(
					function (description, v) {
						return ((description === 'Carga negativa aplicada') || ((description === 'Carga negativa aplicada no Guichê') || (description === 'Transferência de crédito (Débito)'))) ? A2(
							$elm$core$Maybe$withDefault,
							'-',
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$String$fromInt,
									function (v_) {
										return '( ' + ($author$project$Utils$formatAsMoney(v_) + ' )');
									}),
								v)) : A2(
							$elm$core$Maybe$withDefault,
							'-',
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $author$project$Utils$formatAsMoney),
								v));
					});
				var valueViewMoney = function (value) {
					return A2(
						$elm$core$Maybe$withDefault,
						'-',
						A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $author$project$Utils$formatAsMoney),
							value));
				};
				var valueView = function (value) {
					return A2(
						$elm$core$Maybe$withDefault,
						'-',
						A2($elm$core$Maybe$map, $elm$core$String$fromInt, value));
				};
				var title = 'Extrato cartão ' + (A2($author$project$Utils$formatDateTimeFromPosix, shared.kS, now) + '.csv');
				var headers = model.az ? _List_fromArray(
					['Data', 'Veículo', 'Linha', 'Evento', 'Classe', 'Valor', 'Saldo', 'Contador', 'Contador Carga', 'Carteira']) : _List_fromArray(
					['Data', 'Veículo', 'Linha', 'Evento', 'Classe', 'Valor', 'Saldo']);
				var filteredTransactionsRecordsHideDetails = model.az ? transactions : A2(
					$elm$core$List$filter,
					function (_v4) {
						var description = _v4.z;
						return (!A2($elm$core$String$contains, 'Catraca liberada', description)) && (!A2($elm$core$String$contains, 'Catraca girada', description));
					},
					transactions);
				var filteredTransactionsHideError = model.b1 ? filteredTransactionsRecordsHideDetails : A2(
					$elm$core$List$filter,
					function (_v3) {
						var transactionError = _v3.bD;
						return !transactionError;
					},
					filteredTransactionsRecordsHideDetails);
				var classView = function (record) {
					var _v2 = $elm$core$String$isEmpty(record.ih);
					if (_v2) {
						return '-';
					} else {
						return record.ih;
					}
				};
				var records = A2(
					$elm$core$List$map,
					function (record) {
						var list = model.az ? _List_fromArray(
							[
								A2($author$project$Utils$formatDateTimeWithSecondsFromPosix, shared.kS, record.cO),
								record.k2,
								record.e1,
								A2($author$project$Pages$Admin$CardExtract$evaluateToAddTextFailure, record.z, record.bD),
								classView(record),
								A2(valueViewMoneyWithDescription, record.z, record.di),
								valueViewMoney(record.h2),
								valueView(record.iy),
								valueView(record.js),
								record.k7
							]) : _List_fromArray(
							[
								A2($author$project$Utils$formatDateTimeWithSecondsFromPosix, shared.kS, record.cO),
								record.k2,
								record.e1,
								A2($author$project$Pages$Admin$CardExtract$evaluateToAddTextFailure, record.z, record.bD),
								classView(record),
								A2(valueViewMoneyWithDescription, record.z, record.di),
								valueViewMoney(record.h2)
							]);
						return list;
					},
					filteredTransactionsHideError);
				return _Utils_Tuple3(
					model,
					A3($author$project$Components$GeneratorCSV$download, records, headers, title),
					$author$project$Shared$NoOp);
		}
	});
var $author$project$Pages$Admin$Cards$update = F6(
	function (msg, model, shared, maybePage, maybeSearch, user) {
		switch (msg.$) {
			case 0:
				var res = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							f0: $krisajenkins$remotedata$RemoteData$fromResult(res)
						}),
					$elm$core$Platform$Cmd$none,
					function () {
						if (!res.$) {
							return $author$project$Shared$NoOp;
						} else {
							var error = res.a;
							return A2($author$project$Shared$updateApiError, shared, error);
						}
					}());
			case 1:
				var search = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{fq: search}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			default:
				return _Utils_Tuple3(
					model,
					_Utils_eq(
						A2($elm$core$Maybe$withDefault, '', maybeSearch),
						model.fq) ? $elm$core$Platform$Cmd$none : A2(
						$author$project$Route$pushUrl,
						shared.nZ,
						A2(
							$author$project$Route$Admin,
							A2(
								$author$project$Route$Cards,
								$elm$core$Maybe$Nothing,
								$elm$core$String$isEmpty(model.fq) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(model.fq)),
							$author$project$Route$extractConcessionaireId(shared.pv))),
					$author$project$Shared$NoOp);
		}
	});
var $author$project$Pages$Admin$CompanyOrders$CompanyOrders = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$CompanyOrders$ConfirmReversalModal = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$CompanyOrders$ConfirmSaveOrderModal = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$CompanyOrders$Detail = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$CompanyOrders$EditEmail = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$CompanyOrders$GotSaveOrderID = function (a) {
	return {$: 22, a: a};
};
var $author$project$Pages$Admin$CompanyOrders$GotSubmittedConfirmReversal = function (a) {
	return {$: 21, a: a};
};
var $author$project$Pages$Admin$CompanyOrders$GotUpdateEmail = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Pages$Admin$CompanyOrders$GotUpdateISS = function (a) {
	return {$: 20, a: a};
};
var $author$project$Pages$Admin$CompanyOrders$History = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$CompanyOrders$ISSDiscount = function (a) {
	return {$: 3, a: a};
};
var $author$project$Shared$Redirect = function (a) {
	return {$: 2, a: a};
};
var $author$project$Shared$ShowSuccessDialog = function (a) {
	return {$: 13, a: a};
};
var $krisajenkins$remotedata$RemoteData$map = F2(
	function (f, data) {
		switch (data.$) {
			case 3:
				var value = data.a;
				return $krisajenkins$remotedata$RemoteData$Success(
					f(value));
			case 1:
				return $krisajenkins$remotedata$RemoteData$Loading;
			case 0:
				return $krisajenkins$remotedata$RemoteData$NotAsked;
			default:
				var error = data.a;
				return $krisajenkins$remotedata$RemoteData$Failure(error);
		}
	});
var $author$project$Route$pushUrlStr = F2(
	function (key, routeStr) {
		return A2($elm$browser$Browser$Navigation$pushUrl, key, routeStr);
	});
var $author$project$Shared$remoteDataSharedMsg = F2(
	function (maybeSuccess, rd) {
		switch (rd.$) {
			case 2:
				if (rd.a === 'unauthorized') {
					return $author$project$Shared$GotUnauthorizedError;
				} else {
					var e = rd.a;
					return $author$project$Shared$Batch(
						_List_fromArray(
							[
								$author$project$Shared$ShowErrorDialog(e),
								$author$project$Shared$ConsoleError(e)
							]));
				}
			case 3:
				var a = rd.a;
				return A2(
					$elm$core$Maybe$withDefault,
					$author$project$Shared$NoOp,
					A2($elm$core$Maybe$map, $author$project$Shared$ShowSuccessDialog, maybeSuccess));
			default:
				return $author$project$Shared$ShowErrorDialog('Processo de execução está incorreto!');
		}
	});
var $author$project$Services$Api$expectWhatever = function (toMsg) {
	return A2(
		$elm$http$Http$expectStringResponse,
		toMsg,
		function (response) {
			return A2(
				$author$project$Services$Api$responseToResult,
				response,
				F2(
					function (_v0, _v1) {
						return $elm$core$Result$Ok(0);
					}));
		});
};
var $author$project$Constants$paymentsServiceUrl = $elm$url$Url$Builder$crossOrigin('https://payments.pazze.app');
var $author$project$Services$Company$rollback = function (options) {
	return $author$project$Services$Api$postHttp(
		{
			lG: $elm$http$Http$emptyBody,
			m9: $author$project$Services$Api$expectWhatever(options.ow),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$paymentsServiceUrl,
				_List_fromArray(
					['api', 'v1', 'orders', options.d1, 'rollback']),
				_List_Nil)
		});
};
var $author$project$Services$Company$saveOrderID = function (options) {
	return $author$project$Services$Api$postHttp(
		{
			lG: $elm$http$Http$jsonBody(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'name',
							$elm$json$Json$Encode$string('Lista gravada'))
						]))),
			m9: $author$project$Services$Api$expectWhatever(options.ow),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'orderList', 'order', options.d1, 'convert']),
				_List_Nil)
		});
};
var $author$project$Services$Api$putHttp = function (options) {
	return $elm$http$Http$request(
		{
			lG: options.lG,
			m9: options.m9,
			nG: _List_fromArray(
				[
					$author$project$Services$Api$authorizationHeader(options.kU)
				]),
			of: 'PUT',
			p5: $elm$core$Maybe$Nothing,
			qi: $elm$core$Maybe$Nothing,
			qt: options.qt
		});
};
var $author$project$Services$Company$updateEmail = function (options) {
	return $author$project$Services$Api$putHttp(
		{
			lG: $elm$http$Http$jsonBody(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'email',
							$elm$json$Json$Encode$string(options.on))
						]))),
			m9: $author$project$Services$Api$expectWhatever(options.ow),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'user', options.l8, 'changeEmail']),
				_List_Nil)
		});
};
var $author$project$Services$Company$updateIss = function (options) {
	return $author$project$Services$Api$putHttp(
		{
			lG: $elm$http$Http$jsonBody(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'issTax',
							$elm$json$Json$Encode$float(options.oT))
						]))),
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				A2($elm$json$Json$Decode$field, 'issTax', $elm$json$Json$Decode$float)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'companies', options.l8]),
				_List_Nil)
		});
};
var $krisajenkins$remotedata$RemoteData$withDefault = F2(
	function (_default, data) {
		if (data.$ === 3) {
			var x = data.a;
			return x;
		} else {
			return _default;
		}
	});
var $author$project$Pages$Admin$CompanyOrders$update = F4(
	function (msg, model, shared, user) {
		var filters = model.Z;
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
			case 1:
				var now = msg.a.e8;
				var timezone = msg.a.kS;
				var today = A2($justinmimbs$date$Date$fromPosix, timezone, now);
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
			case 2:
				var result = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							fy: $author$project$Pages$Admin$CompanyOrders$CompanyOrders(
								$krisajenkins$remotedata$RemoteData$fromResult(result))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 6:
				var id = msg.a;
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$Redirect(
						A2(
							$author$project$Route$Admin,
							$author$project$Route$CompanyOrderHistory(id),
							$elm$core$Maybe$Nothing)));
			case 7:
				var orderId = msg.a;
				var _v1 = user.k$;
				if (_v1.$ === 2) {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$Redirect(
							A2(
								$author$project$Route$EnterpriseHistoryDetails,
								orderId,
								$elm$core$Maybe$Just(model.bv))));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$Redirect(
							A2(
								$author$project$Route$Admin,
								$author$project$Route$CompanyOrderDetail(
									{
										l8: A2($elm$core$Maybe$withDefault, '', model.l8),
										mF: orderId,
										ob: $elm$core$Maybe$Just(model.bv),
										pO: model.pO
									}),
								$elm$core$Maybe$Nothing)));
				}
			case 4:
				if (!msg.a.$) {
					var result = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								fy: $author$project$Pages$Admin$CompanyOrders$Detail(result)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						A2($author$project$Shared$updateApiError, shared, error));
				}
			case 5:
				if (!msg.b.$) {
					var _v2 = A5(
						$author$project$Pages$Admin$CompanyOrders$init,
						model.pO,
						$elm$core$Maybe$Just(model.bv),
						model.l8,
						$elm$core$Maybe$Nothing,
						user);
					var mode_ = _v2.a;
					var cmd_ = _v2.b;
					return _Utils_Tuple3(mode_, cmd_, $author$project$Shared$NoOp);
				} else {
					var modal = msg.a;
					var error = msg.b.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{aY: modal}),
						$elm$core$Platform$Cmd$none,
						A2($author$project$Shared$updateApiError, shared, error));
				}
			case 3:
				if (!msg.a.$) {
					var result = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								fy: $author$project$Pages$Admin$CompanyOrders$History(result)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						A2($author$project$Shared$updateApiError, shared, error));
				}
			case 8:
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$Redirect(
						A2($author$project$Route$Admin, $author$project$Route$CompanyOrders, $elm$core$Maybe$Nothing)));
			case 9:
				var maybeSource = msg.a;
				var _v3 = _Utils_Tuple2(maybeSource, user.k$);
				if (_v3.a.$ === 1) {
					if (_v3.b.$ === 2) {
						var _v4 = _v3.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$Redirect($author$project$Route$EnterpriseHistory));
					} else {
						var _v5 = _v3.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$Redirect(
								A2(
									$author$project$Route$Admin,
									$author$project$Route$CompanyOrderHistory(
										A2($elm$core$Maybe$withDefault, '', model.l8)),
									$elm$core$Maybe$Nothing)));
					}
				} else {
					var source = _v3.a.a;
					return _Utils_Tuple3(
						model,
						A2($author$project$Route$pushUrlStr, shared.nZ, source),
						$author$project$Shared$NoOp);
				}
			case 10:
				var modal = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aY: $krisajenkins$remotedata$RemoteData$Success(modal)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 11:
				var modal_ = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aY: $krisajenkins$remotedata$RemoteData$Success(
								$author$project$Pages$Admin$CompanyOrders$ConfirmReversalModal(modal_))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 12:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aY: $krisajenkins$remotedata$RemoteData$NotAsked}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 13:
				var orderID = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aY: $krisajenkins$remotedata$RemoteData$Success(
								$author$project$Pages$Admin$CompanyOrders$ConfirmSaveOrderModal(orderID))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 14:
				var orderID = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aY: $krisajenkins$remotedata$RemoteData$Loading}),
					$author$project$Services$Company$saveOrderID(
						{ow: $author$project$Pages$Admin$CompanyOrders$GotSaveOrderID, d1: orderID, kU: user.kU}),
					$author$project$Shared$NoOp);
			case 22:
				if (msg.a.$ === 1) {
					var error = msg.a.a;
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						A2($author$project$Shared$updateApiError, shared, error));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{aY: $krisajenkins$remotedata$RemoteData$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$ShowSuccessDialog('Pedido gravado!'));
				}
			case 15:
				var newEmail = msg.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$withDefault,
					_Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp),
					A2(
						$krisajenkins$remotedata$RemoteData$map,
						function (stateModal) {
							if (!stateModal.$) {
								var modal_ = stateModal.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $krisajenkins$remotedata$RemoteData$Success(
												$author$project$Pages$Admin$CompanyOrders$EditEmail(
													_Utils_update(
														modal_,
														{
															mX: $elm$core$String$toLower(newEmail)
														})))
										}),
									$elm$core$Platform$Cmd$none,
									$author$project$Shared$NoOp);
							} else {
								return _Utils_Tuple3(
									model,
									$elm$core$Platform$Cmd$none,
									$author$project$Shared$ShowErrorDialog('Erro em modal definido!'));
							}
						},
						model.aY));
			case 16:
				var newIss = msg.a;
				return A2(
					$krisajenkins$remotedata$RemoteData$withDefault,
					_Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp),
					A2(
						$krisajenkins$remotedata$RemoteData$map,
						function (stateModal) {
							if (stateModal.$ === 3) {
								var m = stateModal.a;
								var newIssInt = A2(
									$elm$core$Maybe$withDefault,
									0,
									$elm$core$String$toFloat(newIss));
								var v = ((newIssInt < 0) || (newIssInt > 5.0)) ? m.oT : newIss;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $krisajenkins$remotedata$RemoteData$Success(
												$author$project$Pages$Admin$CompanyOrders$ISSDiscount(
													_Utils_update(
														m,
														{oT: v})))
										}),
									$elm$core$Platform$Cmd$none,
									$author$project$Shared$NoOp);
							} else {
								return _Utils_Tuple3(
									model,
									$elm$core$Platform$Cmd$none,
									$author$project$Shared$ShowErrorDialog('Erro em modal definido!'));
							}
						},
						model.aY));
			case 17:
				var companyID = msg.a;
				var newEmail = msg.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aY: $krisajenkins$remotedata$RemoteData$Loading}),
					$author$project$Services$Company$updateEmail(
						{
							l8: companyID,
							on: newEmail,
							ow: $author$project$Pages$Admin$CompanyOrders$GotUpdateEmail(model.aY),
							kU: user.kU
						}),
					$author$project$Shared$NoOp);
			case 18:
				var _v8 = model.aY;
				if ((_v8.$ === 3) && (_v8.a.$ === 1)) {
					var modal_ = _v8.a.a;
					return _Utils_Tuple3(
						model,
						$author$project$Services$Company$rollback(
							{ow: $author$project$Pages$Admin$CompanyOrders$GotSubmittedConfirmReversal, d1: modal_.d1, kU: user.kU}),
						$author$project$Shared$NoOp);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$ShowErrorDialog('Erro em modal definido!'));
				}
			case 21:
				if (!msg.a.$) {
					var _v9 = A5(
						$author$project$Pages$Admin$CompanyOrders$init,
						model.pO,
						$elm$core$Maybe$Just(model.bv),
						model.l8,
						$elm$core$Maybe$Nothing,
						user);
					var model_ = _v9.a;
					var cmd_ = _v9.b;
					return _Utils_Tuple3(
						model_,
						cmd_,
						$author$project$Shared$ShowSuccessDialog('Estorno realizada com sucesso!'));
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						A2($author$project$Shared$updateApiError, shared, error));
				}
			case 19:
				var _v10 = model.aY;
				if ((_v10.$ === 3) && (_v10.a.$ === 3)) {
					var m = _v10.a.a;
					var percentFloat = $elm$core$String$toFloat(m.oT);
					if (!percentFloat.$) {
						var p = percentFloat.a;
						return ((p < 0) || (p > 5.0)) ? _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$ShowErrorDialog('Porcentagem de desconto do ISS está incorreto!')) : _Utils_Tuple3(
							model,
							$author$project$Services$Company$updateIss(
								{l8: m.l8, ow: $author$project$Pages$Admin$CompanyOrders$GotUpdateISS, oT: p, kU: user.kU}),
							$author$project$Shared$NoOp);
					} else {
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$ShowErrorDialog('Porcentagem de desconto do ISS está incorreto!'));
					}
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$ShowErrorDialog('Erro em modal definido!'));
				}
			case 20:
				if (msg.a.$ === 3) {
					var p = msg.a.a;
					var _v12 = A5(
						$author$project$Pages$Admin$CompanyOrders$init,
						model.pO,
						$elm$core$Maybe$Just(model.bv),
						model.l8,
						$elm$core$Maybe$Nothing,
						user);
					var model_ = _v12.a;
					var cmd_ = _v12.b;
					return _Utils_Tuple3(
						model_,
						cmd_,
						$author$project$Shared$ShowSuccessDialog(
							'ISS alterado para ' + ($elm$core$String$fromFloat(p) + '%')));
				} else {
					var rdIss = msg.a;
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rdIss));
				}
			default:
				if (!msg.a.$) {
					var newDocument = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Z: _Utils_update(
									filters,
									{iI: newDocument})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				} else {
					var newCompanyName = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Z: _Utils_update(
									filters,
									{dw: newCompanyName})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				}
		}
	});
var $author$project$Pages$Admin$Equipments$update = F4(
	function (msg, model, shared, _v0) {
		switch (msg.$) {
			case 0:
				var res = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							cU: $krisajenkins$remotedata$RemoteData$fromResult(res)
						}),
					$elm$core$Platform$Cmd$none,
					function () {
						if (!res.$) {
							return $author$project$Shared$NoOp;
						} else {
							var error = res.a;
							return A2($author$project$Shared$updateApiError, shared, error);
						}
					}());
			case 1:
				var search = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{fq: search}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			default:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dI: model.fq}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
		}
	});
var $author$project$Pages$Admin$PaymentBillets$GenerateCsvDownloadWithTime = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Admin$PaymentBillets$GotManualPayResponse = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Admin$PaymentBillets$PayBillet = $elm$core$Basics$identity;
var $author$project$Shared$PrintDocument = function (a) {
	return {$: 5, a: a};
};
var $author$project$Services$Models$htmlProtocolWithHostLocalToString = F2(
	function (url, paths) {
		var protocolToStr = function () {
			var _v0 = url.o6;
			if (!_v0) {
				return 'http://';
			} else {
				return 'https://';
			}
		}();
		var portToStr = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$String$fromInt,
					$elm$core$Basics$append(':')),
				url.oY));
		return _Utils_ap(
			protocolToStr,
			_Utils_ap(portToStr, paths));
	});
var $author$project$Pages$Admin$PaymentBillets$initPayBilletModal = function (billet) {
	return {eq: billet, dP: false};
};
var $author$project$Utils$mapThird = F2(
	function (fn, _v0) {
		var a = _v0.a;
		var b = _v0.b;
		var c = _v0.c;
		return _Utils_Tuple3(
			a,
			b,
			fn(c));
	});
var $Massolari$elm_mask$Mask$maskStringHelper = F3(
	function (pattern, value, result) {
		maskStringHelper:
		while (true) {
			var _v0 = $elm$core$String$uncons(pattern);
			if (!_v0.$) {
				var _v1 = _v0.a;
				var headPattern = _v1.a;
				var tailPattern = _v1.b;
				var _v2 = $elm$core$String$uncons(value);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var charValue = _v3.a;
					var rest = _v3.b;
					if ('#' === headPattern) {
						var $temp$pattern = tailPattern,
							$temp$value = rest,
							$temp$result = _Utils_ap(
							result,
							$elm$core$String$fromChar(charValue));
						pattern = $temp$pattern;
						value = $temp$value;
						result = $temp$result;
						continue maskStringHelper;
					} else {
						var notHashtagHeadPattern = headPattern;
						var $temp$pattern = tailPattern,
							$temp$value = value,
							$temp$result = _Utils_ap(
							result,
							$elm$core$String$fromChar(notHashtagHeadPattern));
						pattern = $temp$pattern;
						value = $temp$value;
						result = $temp$result;
						continue maskStringHelper;
					}
				} else {
					return A2($elm$core$String$contains, '#', pattern) ? result : _Utils_ap(result, pattern);
				}
			} else {
				return result;
			}
		}
	});
var $Massolari$elm_mask$Mask$number = F2(
	function (pattern, value) {
		return function (v) {
			return A3($Massolari$elm_mask$Mask$maskStringHelper, pattern, v, '');
		}(
			A2($elm$core$String$filter, $elm$core$Char$isDigit, value));
	});
var $author$project$Utils$maskCNPJ = $Massolari$elm_mask$Mask$number('##.###.###/####-##');
var $author$project$Services$Api$whateverResolver = $author$project$Services$Api$resolver(
	F2(
		function (_v0, _v1) {
			return $elm$core$Result$Ok(0);
		}));
var $author$project$Services$Payments$payBillet = F2(
	function (token, id) {
		return $elm$http$Http$task(
			{
				lG: $elm$http$Http$emptyBody,
				nG: _List_fromArray(
					[
						$author$project$Services$Api$authorizationHeader(token)
					]),
				of: 'POST',
				d6: $author$project$Services$Api$whateverResolver,
				p5: $elm$core$Maybe$Nothing,
				qt: A2(
					$author$project$Constants$paymentsServiceUrl,
					_List_fromArray(
						['api', 'v1', 'orders', id, 'pay']),
					_List_Nil)
			});
	});
var $author$project$Pages$Admin$PaymentBillets$setModal = F2(
	function (model, modal) {
		return _Utils_update(
			model,
			{
				aY: $elm$core$Maybe$Just(modal)
			});
	});
var $author$project$Services$Payments$statusToUserString = function (status) {
	switch (status) {
		case 0:
			return 'Pago';
		case 1:
			return 'Baixa manual';
		case 2:
			return 'Pago';
		case 3:
			return 'Pendente';
		case 4:
			return 'Cancelado';
		case 5:
			return 'Processando';
		case 6:
			return 'Falhou';
		case 7:
			return 'Pago a mais';
		case 8:
			return 'Pago a menos';
		default:
			return 'Pago após baixa manual';
	}
};
var $author$project$Pages$Admin$PaymentBillets$GotBillets = function (a) {
	return {$: 2, a: a};
};
var $author$project$Services$Payments$Billet = function (id) {
	return function (paymentDate) {
		return function (createdAt) {
			return function (status) {
				return function (amount) {
					return function (url) {
						return function (customer) {
							return function (paymentMethod) {
								return function (referenceID) {
									return function (companyID) {
										return function (grossBalance) {
											return function (issTaxValue) {
												return function (sequence) {
													return {lo: amount, l8: companyID, ix: createdAt, eD: customer, i3: grossBalance, dM: id, e_: issTaxValue, jV: paymentDate, jW: paymentMethod, hm: referenceID, pC: sequence, kK: status, qt: url};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Services$Payments$CustomerBillet = F2(
	function (name, document) {
		return {iI: document, c3: name};
	});
var $author$project$Services$Payments$customerBilletDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Services$Payments$CustomerBillet,
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'document', $elm$json$Json$Decode$string));
var $author$project$Services$Payments$Canceled = 4;
var $author$project$Services$Payments$Closed = 9;
var $author$project$Services$Payments$Failed = 6;
var $author$project$Services$Payments$Overpaid = 7;
var $author$project$Services$Payments$Paid = 0;
var $author$project$Services$Payments$PaidManual = 1;
var $author$project$Services$Payments$PaidPagame = 2;
var $author$project$Services$Payments$Pending = 3;
var $author$project$Services$Payments$Processing = 5;
var $author$project$Services$Payments$Underpaid = 8;
var $author$project$Services$Payments$allStatus = _List_fromArray(
	[0, 1, 2, 3, 4, 9, 5, 6, 7, 8]);
var $author$project$Services$Payments$statusToApiString = function (status) {
	switch (status) {
		case 0:
			return 'paid';
		case 1:
			return 'manual';
		case 2:
			return 'closed';
		case 3:
			return 'pending';
		case 4:
			return 'canceled';
		case 5:
			return 'processing';
		case 6:
			return 'failed';
		case 7:
			return 'overpaid';
		case 8:
			return 'underpaid';
		default:
			return 'closed';
	}
};
var $author$project$Services$Payments$allStatusApiDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (s) {
			return _Utils_Tuple2(
				$author$project$Services$Payments$statusToApiString(s),
				s);
		},
		$author$project$Services$Payments$allStatus));
var $author$project$Services$Payments$statusFromString = function (str) {
	return A2($elm$core$Dict$get, str, $author$project$Services$Payments$allStatusApiDict);
};
var $author$project$Services$Payments$statusDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$json$Json$Decode$fail('Status desconhecido: ' + str),
			A2(
				$elm$core$Maybe$map,
				$elm$json$Json$Decode$succeed,
				$author$project$Services$Payments$statusFromString(str)));
	},
	$elm$json$Json$Decode$string);
var $author$project$Services$Payments$billetsDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'sequence',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'issTaxValue',
		$elm$json$Json$Decode$int,
		0,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'grossBalance',
			$elm$json$Json$Decode$int,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
				_List_fromArray(
					['refill', 'companyId']),
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'referenceId',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'paymentMethod',
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'customer',
							$author$project$Services$Payments$customerBilletDecoder,
							A2(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
								$elm$json$Json$Decode$maybe(
									A2(
										$elm$json$Json$Decode$at,
										_List_fromArray(
											['boleto', 'url']),
										$elm$json$Json$Decode$string)),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'amount',
									$elm$json$Json$Decode$int,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'status',
										$elm$json$Json$Decode$maybe($author$project$Services$Payments$statusDecoder),
										$elm$core$Maybe$Nothing,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'createdAt',
											$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
												_List_fromArray(
													['refill', 'paymentDate']),
												$elm$json$Json$Decode$maybe($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
												$elm$core$Maybe$Nothing,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'id',
													$elm$json$Json$Decode$string,
													$elm$json$Json$Decode$succeed($author$project$Services$Payments$Billet))))))))))))));
var $author$project$Services$Payments$getBillets = F5(
	function (token, start, end, maybeStatus, concessionaireId) {
		return $elm$http$Http$task(
			{
				lG: $elm$http$Http$emptyBody,
				nG: _List_fromArray(
					[
						$author$project$Services$Api$authorizationHeader(token)
					]),
				of: 'GET',
				d6: $author$project$Services$Api$jsonResolver(
					A2(
						$elm$json$Json$Decode$map,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$sortBy(
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.ix;
									},
									$elm$time$Time$posixToMillis)),
							$elm$core$List$reverse),
						$elm$json$Json$Decode$oneOf(
							_List_fromArray(
								[
									$elm$json$Json$Decode$list($author$project$Services$Payments$billetsDecoder),
									$elm$json$Json$Decode$null(_List_Nil)
								])))),
				p5: $elm$core$Maybe$Nothing,
				qt: A2(
					$author$project$Constants$paymentsServiceUrl,
					_List_fromArray(
						['api', 'v1', 'orders', 'boleto']),
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								$elm$core$Maybe$Just(
								A2(
									$elm$url$Url$Builder$string,
									'start',
									$justinmimbs$date$Date$toIsoString(start))),
								$elm$core$Maybe$Just(
								A2(
									$elm$url$Url$Builder$string,
									'end',
									$justinmimbs$date$Date$toIsoString(end))),
								A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Services$Payments$statusToApiString,
									$elm$url$Url$Builder$string('status')),
								maybeStatus),
								A2(
								$elm$core$Maybe$map,
								$elm$url$Url$Builder$string('concessionaireID'),
								concessionaireId)
							])))
			});
	});
var $author$project$Pages$Admin$PaymentBillets$updateFilter = F3(
	function (shared, user, model) {
		return A2(
			$elm$core$Result$withDefault,
			_Utils_Tuple3(
				model,
				$elm$core$Platform$Cmd$none,
				$author$project$Shared$ShowErrorDialog('Necessário informar date de início e fim')),
			A3(
				$elm$core$Result$map2,
				F2(
					function (start, end) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{aR: $krisajenkins$remotedata$RemoteData$Loading}),
							A2(
								$elm$core$Task$attempt,
								$author$project$Pages$Admin$PaymentBillets$GotBillets,
								A5(
									$author$project$Services$Payments$getBillets,
									user.kU,
									start,
									end,
									$author$project$Services$Payments$statusFromString(model.kK),
									$author$project$Route$extractConcessionaireId(shared.pv))),
							$author$project$Shared$NoOp);
					}),
				$justinmimbs$date$Date$fromIsoString(model.eb),
				$justinmimbs$date$Date$fromIsoString(model.dH)));
	});
var $elm$file$File$Download$url = function (href) {
	return A2(
		$elm$core$Task$perform,
		$elm$core$Basics$never,
		_File_downloadUrl(href));
};
var $author$project$Pages$Admin$PaymentBillets$update = F4(
	function (msg, model, shared, user) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
			case 1:
				var now = msg.a.e8;
				var timezone = msg.a.kS;
				var today = A2($justinmimbs$date$Date$fromPosix, timezone, now);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							dH: $justinmimbs$date$Date$toIsoString(today),
							eb: $justinmimbs$date$Date$toIsoString(
								A3($justinmimbs$date$Date$add, 1, -1, today))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 2:
				var res = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aR: $krisajenkins$remotedata$RemoteData$fromResult(res)
						}),
					$elm$core$Platform$Cmd$none,
					function () {
						if (!res.$) {
							return $author$project$Shared$NoOp;
						} else {
							var error = res.a;
							return A2($author$project$Shared$updateApiError, shared, error);
						}
					}());
			case 3:
				var str = msg.a;
				var toStr = A2(
					$elm$core$Result$withDefault,
					model.dH,
					A3(
						$elm$core$Result$map2,
						F2(
							function (from, to) {
								return (A2($justinmimbs$date$Date$compare, from, to) === 2) ? str : model.dH;
							}),
						$justinmimbs$date$Date$fromIsoString(str),
						$justinmimbs$date$Date$fromIsoString(model.dH)));
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dH: toStr, eb: str}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 4:
				var str = msg.a;
				var fromStr = A2(
					$elm$core$Result$withDefault,
					model.eb,
					A3(
						$elm$core$Result$map2,
						F2(
							function (from, to) {
								return (A2($justinmimbs$date$Date$compare, from, to) === 2) ? str : model.eb;
							}),
						$justinmimbs$date$Date$fromIsoString(model.eb),
						$justinmimbs$date$Date$fromIsoString(str)));
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dH: str, eb: fromStr}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 5:
				var str = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{kK: str}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 6:
				var billet = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aY: $elm$core$Maybe$Just(
								$author$project$Pages$Admin$PaymentBillets$initPayBilletModal(billet))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 7:
				var url = msg.a;
				return _Utils_Tuple3(
					model,
					$elm$file$File$Download$url(url),
					$author$project$Shared$NoOp);
			case 8:
				var url = msg.a;
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$PrintDocument(url));
			case 9:
				var _v2 = model.aY;
				if (_v2.$ === 1) {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
				} else {
					var modal = _v2.a;
					return _Utils_Tuple3(
						A2(
							$author$project$Pages$Admin$PaymentBillets$setModal,
							model,
							_Utils_update(
								modal,
								{dP: true})),
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$Admin$PaymentBillets$GotManualPayResponse,
							A2($author$project$Services$Payments$payBillet, user.kU, modal.eq.dM)),
						$author$project$Shared$NoOp);
				}
			case 10:
				if (!msg.a.$) {
					return A2(
						$author$project$Utils$mapThird,
						function (_v3) {
							return $author$project$Shared$ShowSuccessDialog('Boleto pago com sucesso!');
						},
						A3(
							$author$project$Pages$Admin$PaymentBillets$updateFilter,
							shared,
							user,
							_Utils_update(
								model,
								{aY: $elm$core$Maybe$Nothing})));
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						function () {
							var _v4 = model.aY;
							if (_v4.$ === 1) {
								return model;
							} else {
								var modal = _v4.a;
								return A2(
									$author$project$Pages$Admin$PaymentBillets$setModal,
									model,
									_Utils_update(
										modal,
										{dP: false}));
							}
						}(),
						$elm$core$Platform$Cmd$none,
						A2($author$project$Shared$updateApiError, shared, error));
				}
			case 11:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aY: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 12:
				return _Utils_Tuple3(
					model,
					A2(
						$elm$core$Task$perform,
						$author$project$Pages$Admin$PaymentBillets$GenerateCsvDownloadWithTime,
						A3(
							$elm$core$Task$map2,
							F2(
								function (now, timezone) {
									return {e8: now, kS: timezone};
								}),
							$elm$time$Time$now,
							$elm$time$Time$here)),
					$author$project$Shared$NoOp);
			case 13:
				var now = msg.a.e8;
				var timezone = msg.a.kS;
				var title = 'Boletos ' + (A2($author$project$Utils$formatDateTimeFromPosix, timezone, now) + '.csv');
				var hasIss = A2(
					$elm$core$List$any,
					function (_v5) {
						var issTaxValue = _v5.e_;
						return issTaxValue > 0;
					},
					A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, model.aR));
				var headersIss = hasIss ? _List_fromArray(
					['Valor bruto', 'Desconto ISS', 'Valor líquido']) : _List_fromArray(
					['Valor']);
				var headers = _Utils_ap(
					_List_fromArray(
						['Nome', 'Documento', 'Nº do pedido', 'Data', 'Data de pagamento', 'Status']),
					_Utils_ap(
						headersIss,
						_List_fromArray(
							['Link do pedido'])));
				var records = A2(
					$krisajenkins$remotedata$RemoteData$withDefault,
					_List_Nil,
					A2(
						$krisajenkins$remotedata$RemoteData$map,
						function (bs) {
							return A2(
								$elm$core$List$map,
								function (b) {
									var rowIss = hasIss ? _List_fromArray(
										[
											$author$project$Utils$formatAsMoney(
											$elm$core$String$fromInt(b.i3)),
											$author$project$Utils$formatAsMoney(
											$elm$core$String$fromInt(b.e_)),
											$author$project$Utils$formatAsMoney(
											$elm$core$String$fromInt(b.lo))
										]) : _List_fromArray(
										[
											$author$project$Utils$formatAsMoney(
											$elm$core$String$fromInt(b.lo))
										]);
									var link = A2(
										$elm$core$Maybe$withDefault,
										'-',
										A3(
											$elm$core$Maybe$map2,
											F2(
												function (companyID, orderID) {
													return A2(
														$author$project$Services$Models$htmlProtocolWithHostLocalToString,
														shared.qt,
														$author$project$Route$toString(
															A2(
																$author$project$Route$Admin,
																$author$project$Route$CompanyOrderDetail(
																	{l8: companyID, mF: orderID, ob: $elm$core$Maybe$Nothing, pO: $elm$core$Maybe$Nothing}),
																$elm$core$Maybe$Nothing)));
												}),
											b.l8,
											b.hm));
									return _Utils_ap(
										_List_fromArray(
											[
												b.eD.c3,
												$author$project$Utils$maskCNPJ(b.eD.iI),
												A2(
												$elm$core$Maybe$withDefault,
												'-',
												A2($elm$core$Maybe$map, $elm$core$String$fromInt, b.pC)),
												A2($author$project$Utils$formatDateTimeFromPosix, timezone, b.ix),
												A2(
												$elm$core$Maybe$withDefault,
												'-',
												A2(
													$elm$core$Maybe$map,
													$author$project$Utils$formatDateTimeFromPosix(timezone),
													b.jV)),
												A2(
												$elm$core$Maybe$withDefault,
												'Desconhecido',
												A2($elm$core$Maybe$map, $author$project$Services$Payments$statusToUserString, b.kK))
											]),
										_Utils_ap(
											rowIss,
											_List_fromArray(
												[link])));
								},
								bs);
						},
						model.aR));
				return _Utils_Tuple3(
					model,
					A3($author$project$Components$GeneratorCSV$download, records, headers, title),
					$author$project$Shared$NoOp);
			case 14:
				var companyID = msg.a;
				var orderID = msg.b;
				return _Utils_Tuple3(
					model,
					A2(
						$author$project$Route$pushUrl,
						shared.nZ,
						A2(
							$author$project$Route$Admin,
							$author$project$Route$CompanyOrderDetail(
								{
									l8: companyID,
									mF: orderID,
									ob: $elm$core$Maybe$Nothing,
									pO: $elm$core$Maybe$Just(
										$author$project$Route$toString(shared.pv))
								}),
							$elm$core$Maybe$Nothing)),
					$author$project$Shared$NoOp);
			default:
				return A3($author$project$Pages$Admin$PaymentBillets$updateFilter, shared, user, model);
		}
	});
var $author$project$Pages$Admin$PaymentGuides$GenerateCsvDownloadWithTime = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Pages$Admin$PaymentGuides$GotManualPayResponse = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Admin$PaymentGuides$PayGuide = $elm$core$Basics$identity;
var $author$project$Pages$Admin$PaymentGuides$initPayGuideModal = function (guide) {
	return {eM: guide, dP: false};
};
var $author$project$Services$Payments$payGuide = F2(
	function (token, id) {
		return $elm$http$Http$task(
			{
				lG: $elm$http$Http$emptyBody,
				nG: _List_fromArray(
					[
						$author$project$Services$Api$authorizationHeader(token)
					]),
				of: 'POST',
				d6: $author$project$Services$Api$whateverResolver,
				p5: $elm$core$Maybe$Nothing,
				qt: A2(
					$author$project$Constants$paymentsServiceUrl,
					_List_fromArray(
						['api', 'v1', 'orders', id, 'pay']),
					_List_Nil)
			});
	});
var $author$project$Pages$Admin$PaymentGuides$setModal = F2(
	function (model, modal) {
		return _Utils_update(
			model,
			{
				aY: $elm$core$Maybe$Just(modal)
			});
	});
var $author$project$Pages$Admin$PaymentGuides$GotGuides = function (a) {
	return {$: 3, a: a};
};
var $author$project$Services$Payments$Guide = F6(
	function (id, createdAt, status, amount, url, sequence) {
		return {lo: amount, ix: createdAt, dM: id, pC: sequence, kK: status, qt: url};
	});
var $author$project$Services$Payments$guideDecoder = A7(
	$elm$json$Json$Decode$map6,
	$author$project$Services$Payments$Guide,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'createdAt', $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'status', $author$project$Services$Payments$statusDecoder)),
	A2($elm$json$Json$Decode$field, 'amount', $elm$json$Json$Decode$int),
	$elm$json$Json$Decode$maybe(
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['boleto', 'url']),
			$elm$json$Json$Decode$string)),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'sequence', $elm$json$Json$Decode$int)));
var $author$project$Services$Payments$getGuides = F5(
	function (token, start, end, maybeStatus, concessionaireId) {
		return $elm$http$Http$task(
			{
				lG: $elm$http$Http$emptyBody,
				nG: _List_fromArray(
					[
						$author$project$Services$Api$authorizationHeader(token)
					]),
				of: 'GET',
				d6: $author$project$Services$Api$jsonResolver(
					A2(
						$elm$json$Json$Decode$map,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$sortBy(
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.ix;
									},
									$elm$time$Time$posixToMillis)),
							$elm$core$List$reverse),
						$elm$json$Json$Decode$oneOf(
							_List_fromArray(
								[
									$elm$json$Json$Decode$list($author$project$Services$Payments$guideDecoder),
									$elm$json$Json$Decode$null(_List_Nil)
								])))),
				p5: $elm$core$Maybe$Nothing,
				qt: A2(
					$author$project$Constants$paymentsServiceUrl,
					_List_fromArray(
						['api', 'v1', 'orders', 'guia']),
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								$elm$core$Maybe$Just(
								A2(
									$elm$url$Url$Builder$string,
									'start',
									$justinmimbs$date$Date$toIsoString(start))),
								$elm$core$Maybe$Just(
								A2(
									$elm$url$Url$Builder$string,
									'end',
									$justinmimbs$date$Date$toIsoString(end))),
								A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Services$Payments$statusToApiString,
									$elm$url$Url$Builder$string('status')),
								maybeStatus),
								A2(
								$elm$core$Maybe$map,
								$elm$url$Url$Builder$string('concessionaireID'),
								concessionaireId)
							])))
			});
	});
var $author$project$Pages$Admin$PaymentGuides$updateFilters = F3(
	function (shared, user, model) {
		return A2(
			$elm$core$Result$withDefault,
			_Utils_Tuple3(
				model,
				$elm$core$Platform$Cmd$none,
				$author$project$Shared$ShowErrorDialog('Necessário informar date de início e fim')),
			A3(
				$elm$core$Result$map2,
				F2(
					function (start, end) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{b0: $krisajenkins$remotedata$RemoteData$Loading}),
							A2(
								$elm$core$Task$attempt,
								$author$project$Pages$Admin$PaymentGuides$GotGuides,
								A5(
									$author$project$Services$Payments$getGuides,
									user.kU,
									start,
									end,
									$author$project$Services$Payments$statusFromString(model.kK),
									$author$project$Route$extractConcessionaireId(shared.pv))),
							$author$project$Shared$NoOp);
					}),
				$justinmimbs$date$Date$fromIsoString(model.eb),
				$justinmimbs$date$Date$fromIsoString(model.dH)));
	});
var $author$project$Pages$Admin$PaymentGuides$update = F4(
	function (msg, model, shared, user) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
			case 1:
				var now = msg.a.e8;
				var timezone = msg.a.kS;
				var today = A2($justinmimbs$date$Date$fromPosix, timezone, now);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							dH: $justinmimbs$date$Date$toIsoString(today),
							eb: $justinmimbs$date$Date$toIsoString(
								A3($justinmimbs$date$Date$add, 1, -1, today))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 2:
				var guides = msg.a;
				var now = msg.b.e8;
				var timezone = msg.b.kS;
				var title = 'Guias ' + (A2($author$project$Utils$formatDateTimeFromPosix, timezone, now) + '.csv');
				var records = A2(
					$elm$core$List$map,
					function (guide) {
						return _List_fromArray(
							[
								A2($author$project$Utils$formatDateTimeFromPosix, timezone, guide.ix),
								A2(
								$elm$core$Maybe$withDefault,
								'-',
								A2($elm$core$Maybe$map, $elm$core$String$fromInt, guide.pC)),
								A2(
								$elm$core$Maybe$withDefault,
								'Desconhecido',
								A2($elm$core$Maybe$map, $author$project$Services$Payments$statusToUserString, guide.kK)),
								$author$project$Utils$formatAsMoney(
								$elm$core$String$fromInt(guide.lo))
							]);
					},
					guides);
				var headers = _List_fromArray(
					['Data', 'Nº do pedido', 'Status', 'Valor']);
				return _Utils_Tuple3(
					model,
					A3($author$project$Components$GeneratorCSV$download, records, headers, title),
					$author$project$Shared$NoOp);
			case 3:
				var res = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							b0: $krisajenkins$remotedata$RemoteData$fromResult(res)
						}),
					$elm$core$Platform$Cmd$none,
					function () {
						if (!res.$) {
							return $author$project$Shared$NoOp;
						} else {
							var error = res.a;
							return A2($author$project$Shared$updateApiError, shared, error);
						}
					}());
			case 4:
				var str = msg.a;
				var toStr = A2(
					$elm$core$Result$withDefault,
					model.dH,
					A3(
						$elm$core$Result$map2,
						F2(
							function (from, to) {
								return (A2($justinmimbs$date$Date$compare, from, to) === 2) ? str : model.dH;
							}),
						$justinmimbs$date$Date$fromIsoString(str),
						$justinmimbs$date$Date$fromIsoString(model.dH)));
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dH: toStr, eb: str}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 5:
				var str = msg.a;
				var fromStr = A2(
					$elm$core$Result$withDefault,
					model.eb,
					A3(
						$elm$core$Result$map2,
						F2(
							function (from, to) {
								return (A2($justinmimbs$date$Date$compare, from, to) === 2) ? str : model.eb;
							}),
						$justinmimbs$date$Date$fromIsoString(model.eb),
						$justinmimbs$date$Date$fromIsoString(str)));
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dH: str, eb: fromStr}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 6:
				var str = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{kK: str}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 7:
				var guide = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aY: $elm$core$Maybe$Just(
								$author$project$Pages$Admin$PaymentGuides$initPayGuideModal(guide))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 8:
				var url = msg.a;
				return _Utils_Tuple3(
					model,
					$elm$file$File$Download$url(url),
					$author$project$Shared$NoOp);
			case 9:
				var url = msg.a;
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$PrintDocument(url));
			case 10:
				var _v2 = model.aY;
				if (_v2.$ === 1) {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
				} else {
					var modal = _v2.a;
					return _Utils_Tuple3(
						A2(
							$author$project$Pages$Admin$PaymentGuides$setModal,
							model,
							_Utils_update(
								modal,
								{dP: true})),
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$Admin$PaymentGuides$GotManualPayResponse,
							A2($author$project$Services$Payments$payGuide, user.kU, modal.eM.dM)),
						$author$project$Shared$NoOp);
				}
			case 11:
				if (!msg.a.$) {
					return A2(
						$author$project$Utils$mapThird,
						function (_v3) {
							return $author$project$Shared$ShowSuccessDialog('Guia paga com sucesso!');
						},
						A3(
							$author$project$Pages$Admin$PaymentGuides$updateFilters,
							shared,
							user,
							_Utils_update(
								model,
								{aY: $elm$core$Maybe$Nothing})));
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						function () {
							var _v4 = model.aY;
							if (_v4.$ === 1) {
								return model;
							} else {
								var modal = _v4.a;
								return A2(
									$author$project$Pages$Admin$PaymentGuides$setModal,
									model,
									_Utils_update(
										modal,
										{dP: false}));
							}
						}(),
						$elm$core$Platform$Cmd$none,
						A2($author$project$Shared$updateApiError, shared, error));
				}
			case 12:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aY: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 13:
				var guides = msg.a;
				return _Utils_Tuple3(
					model,
					A2(
						$elm$core$Task$perform,
						$author$project$Pages$Admin$PaymentGuides$GenerateCsvDownloadWithTime(guides),
						A3(
							$elm$core$Task$map2,
							F2(
								function (now, timezone) {
									return {e8: now, kS: timezone};
								}),
							$elm$time$Time$now,
							$elm$time$Time$here)),
					$author$project$Shared$NoOp);
			default:
				return A3($author$project$Pages$Admin$PaymentGuides$updateFilters, shared, user, model);
		}
	});
var $author$project$Components$PDF$Create$ClickedOpenModal = F4(
	function (a, b, c, d) {
		return {$: 2, a: a, b: b, c: c, d: d};
	});
var $author$project$Pages$Admin$Reports$Sales$CompPDFCreateMSg = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$Admin$Reports$Sales$GenerateCsvDownloadWithTime = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Pages$Admin$Reports$Sales$GotRequestRefund = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Admin$Reports$Sales$MoreReceivedReport = function (a) {
	return {$: 16, a: a};
};
var $author$project$Shared$PrintHTML = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Admin$Reports$Sales$ReceivedReport = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$Reports$Sales$cardsPerPage = 500;
var $author$project$Pages$Admin$Reports$Sales$feeView = F2(
	function (paymentMethodBRL, fee) {
		return ((fee <= 0) || (paymentMethodBRL === 'Estorno')) ? '-' : $author$project$Utils$formatAsMoney(
			$elm$core$String$fromInt(fee));
	});
var $author$project$Utils$getConcessionaire = function (user) {
	var _v0 = A2(
		$elm$core$Basics$composeL,
		$elm$core$List$head,
		function ($) {
			return $.bR;
		})(user);
	if (!_v0.$) {
		var concessionaire = _v0.a;
		return concessionaire;
	} else {
		return {dM: '', c3: 'Concessionária não informada'};
	}
};
var $author$project$Utils$formatDateFromPosix = function (timezone) {
	return A2(
		$ryan_haskell$date_format$DateFormat$format,
		_List_fromArray(
			[
				$ryan_haskell$date_format$DateFormat$dayOfMonthFixed,
				$ryan_haskell$date_format$DateFormat$text('/'),
				$ryan_haskell$date_format$DateFormat$monthFixed,
				$ryan_haskell$date_format$DateFormat$text('/'),
				$ryan_haskell$date_format$DateFormat$yearNumber
			]),
		timezone);
};
var $author$project$Utils$formatHoursFromPosix = function (timezone) {
	return A2(
		$ryan_haskell$date_format$DateFormat$format,
		_List_fromArray(
			[
				$ryan_haskell$date_format$DateFormat$hourMilitaryFixed,
				$ryan_haskell$date_format$DateFormat$text(':'),
				$ryan_haskell$date_format$DateFormat$minuteFixed
			]),
		timezone);
};
var $author$project$Utils$maskPhoneDDD = $Massolari$elm_mask$Mask$number('(##) # ####-####');
var $author$project$Components$HTMLToPrint$SalesReceipt$htmlStr = F2(
	function (options, timezone) {
		var formatToMoney = function (value) {
			return $author$project$Utils$formatAsMoney(
				$elm$core$String$fromInt(value));
		};
		var diffFromFinalCost = options.fQ - options.lo;
		var viewStrDiffFromFinalCost = (diffFromFinalCost > 0) ? (' <p>Troco a devolver: ' + (formatToMoney(diffFromFinalCost) + ' </p> ')) : '';
		var amountReceived = formatToMoney(options.fQ);
		return '\n    <section style="font-family: Roboto, sans-serif; font-size: 0.5rem; font-weight: 700;">\n        <div style="display:flex;justify-content: space-between; font-size: 1rem; align-items: center;">\n            <p style="margin: 0;"><img style="width: 65px;" src="/images/pazze-logo-black.png"/></p>\n            <p style="margin: 0;">VIA CLIENTE</p>\n        </div>\n        <hr style="border-top: 1px dashed black"></hr>\n        <h1 style="text-align: center; font-size: 1rem; margin: 0;">' + (options.fD + ('</h1>\n        <hr style="border-top: 1px dashed black"></hr>\n        <h2 style="text-align: center; font-size: 0.7rem; margin: 0;">' + (options.ex + ('</h2>\n        <table style="font-weight: 700;font-size: 0.5rem;">\n            <tbody>\n                <tr>\n                    <td style="vertical-align: baseline";> End: </td>\n                    <td> ' + (options.ep + (' </td>\n                </tr>\n                <tr>\n                    <td style="vertical-align: baseline";>CNPJ: </td>\n                    <td>' + (options.ew + ('</td>\n                </tr>\n                <tr>\n                    <td style="vertical-align: baseline";>TEL: </td>\n                    <td>' + (A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $author$project$Utils$maskPhoneDDD)(options.fC) + ('</td>\n                </tr>\n            </tbody>\n        </table>\n        <hr style="border-top: 1px dashed black"></hr>\n        <table style="width: 100%; font-size: 0.7rem; font-weight: 700;">\n            <tbody>\n                <tr>\n                    <td>Data: ' + (A2($author$project$Utils$formatDateFromPosix, timezone, options.cO) + ('</td>\n                    <td style="text-align: end;">Hora: ' + (A2($author$project$Utils$formatHoursFromPosix, timezone, options.cO) + (' </td>\n                </tr>\n            </tbody>\n        </table>\n        <table style="font-weight: 700; font-size: 0.5rem;">\n            <tbody>\n                <tr>\n                    <td>Nome: </td>\n                    <td>' + (options.fg + ('</td>\n                </tr>\n                <tr>\n                    <td>Cartão: </td>\n                    <td> ' + (options.ia + ('</td>\n                </tr>\n                <tr>\n                    <td>Classe: </td>\n                    <td>' + (options.ik + ('</td>\n                </tr>\n                <tr>\n                    <td>Valor: </td>\n                    <td>' + (formatToMoney(options.lo) + (' </td>\n                </tr>\n                <tr>\n                    <td>Pagto: </td>\n                    <td> ' + (options.jW + ('</td>\n                </tr>\n            </tbody>\n        </table>\n        <hr style="border-top: 1px dashed black"></hr>\n        <p style="display:flex; flex-direction: column; margin-top: 0;">\n            <span>Operador</span>\n            <span>' + (options.fa + ('</span>\n        </p>\n        <p style="display:flex; flex-direction: column;">\n            <span>ID da Transação</span>\n            <span>' + (options.fH + '</span>\n        </p>\n    </section>\n     ')))))))))))))))))))))))))));
	});
var $krisajenkins$remotedata$RemoteData$andMap = F2(
	function (wrappedValue, wrappedFunction) {
		var _v0 = _Utils_Tuple2(wrappedFunction, wrappedValue);
		_v0$2:
		while (true) {
			_v0$3:
			while (true) {
				_v0$4:
				while (true) {
					_v0$5:
					while (true) {
						switch (_v0.a.$) {
							case 3:
								switch (_v0.b.$) {
									case 3:
										var f = _v0.a.a;
										var value = _v0.b.a;
										return $krisajenkins$remotedata$RemoteData$Success(
											f(value));
									case 2:
										break _v0$2;
									case 1:
										break _v0$4;
									default:
										var _v4 = _v0.b;
										return $krisajenkins$remotedata$RemoteData$NotAsked;
								}
							case 2:
								var error = _v0.a.a;
								return $krisajenkins$remotedata$RemoteData$Failure(error);
							case 1:
								switch (_v0.b.$) {
									case 2:
										break _v0$2;
									case 1:
										break _v0$3;
									case 0:
										break _v0$3;
									default:
										break _v0$3;
								}
							default:
								switch (_v0.b.$) {
									case 2:
										break _v0$2;
									case 1:
										break _v0$4;
									case 0:
										break _v0$5;
									default:
										break _v0$5;
								}
						}
					}
					var _v3 = _v0.a;
					return $krisajenkins$remotedata$RemoteData$NotAsked;
				}
				var _v2 = _v0.b;
				return $krisajenkins$remotedata$RemoteData$Loading;
			}
			var _v1 = _v0.a;
			return $krisajenkins$remotedata$RemoteData$Loading;
		}
		var error = _v0.b.a;
		return $krisajenkins$remotedata$RemoteData$Failure(error);
	});
var $krisajenkins$remotedata$RemoteData$map2 = F3(
	function (f, a, b) {
		return A2(
			$krisajenkins$remotedata$RemoteData$andMap,
			b,
			A2($krisajenkins$remotedata$RemoteData$map, f, a));
	});
var $author$project$Pages$Admin$Reports$Sales$netValueOf = function (e) {
	return (e.jA > 0) ? e.jA : A2($elm$core$Maybe$withDefault, 0, e.di);
};
var $author$project$Pages$Admin$Reports$Sales$paidValueOf = function (e) {
	return (e.hX > 0) ? e.hX : A2($elm$core$Maybe$withDefault, 0, e.di);
};
var $justinmimbs$time_extra$Time$Extra$Week = 3;
var $justinmimbs$date$Date$Day = 11;
var $justinmimbs$date$Date$Friday = 8;
var $justinmimbs$date$Date$Monday = 4;
var $justinmimbs$date$Date$Month = 2;
var $justinmimbs$date$Date$Quarter = 1;
var $justinmimbs$date$Date$Saturday = 9;
var $justinmimbs$date$Date$Sunday = 10;
var $justinmimbs$date$Date$Thursday = 7;
var $justinmimbs$date$Date$Tuesday = 5;
var $justinmimbs$date$Date$Wednesday = 6;
var $justinmimbs$date$Date$Week = 3;
var $justinmimbs$date$Date$Year = 0;
var $justinmimbs$date$Date$weekdayToNumber = function (wd) {
	switch (wd) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		default:
			return 7;
	}
};
var $justinmimbs$date$Date$daysSincePreviousWeekday = F2(
	function (wd, date) {
		return A2(
			$elm$core$Basics$modBy,
			7,
			($justinmimbs$date$Date$weekdayNumber(date) + 7) - $justinmimbs$date$Date$weekdayToNumber(wd));
	});
var $justinmimbs$date$Date$firstOfMonth = F2(
	function (y, m) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + 1;
	});
var $justinmimbs$date$Date$quarterToMonth = function (q) {
	return $justinmimbs$date$Date$numberToMonth((q * 3) - 2);
};
var $justinmimbs$date$Date$floor = F2(
	function (interval, date) {
		var rd = date;
		switch (interval) {
			case 0:
				return $justinmimbs$date$Date$firstOfYear(
					$justinmimbs$date$Date$year(date));
			case 1:
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$quarterToMonth(
						$justinmimbs$date$Date$quarter(date)));
			case 2:
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$month(date));
			case 3:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 0, date);
			case 4:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 0, date);
			case 5:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 1, date);
			case 6:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 2, date);
			case 7:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 3, date);
			case 8:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 4, date);
			case 9:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 5, date);
			case 10:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 6, date);
			default:
				return date;
		}
	});
var $justinmimbs$time_extra$Time$Extra$floorDate = F3(
	function (dateInterval, zone, posix) {
		return A3(
			$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
			zone,
			A2(
				$justinmimbs$date$Date$floor,
				dateInterval,
				A2($justinmimbs$date$Date$fromPosix, zone, posix)),
			0);
	});
var $justinmimbs$time_extra$Time$Extra$floor = F3(
	function (interval, zone, posix) {
		switch (interval) {
			case 15:
				return posix;
			case 14:
				return A3(
					$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
					zone,
					A2($justinmimbs$date$Date$fromPosix, zone, posix),
					A4(
						$justinmimbs$time_extra$Time$Extra$timeFromClock,
						A2($elm$time$Time$toHour, zone, posix),
						A2($elm$time$Time$toMinute, zone, posix),
						A2($elm$time$Time$toSecond, zone, posix),
						0));
			case 13:
				return A3(
					$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
					zone,
					A2($justinmimbs$date$Date$fromPosix, zone, posix),
					A4(
						$justinmimbs$time_extra$Time$Extra$timeFromClock,
						A2($elm$time$Time$toHour, zone, posix),
						A2($elm$time$Time$toMinute, zone, posix),
						0,
						0));
			case 12:
				return A3(
					$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
					zone,
					A2($justinmimbs$date$Date$fromPosix, zone, posix),
					A4(
						$justinmimbs$time_extra$Time$Extra$timeFromClock,
						A2($elm$time$Time$toHour, zone, posix),
						0,
						0,
						0));
			case 11:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 11, zone, posix);
			case 2:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 2, zone, posix);
			case 0:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 0, zone, posix);
			case 1:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 1, zone, posix);
			case 3:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 3, zone, posix);
			case 4:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 4, zone, posix);
			case 5:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 5, zone, posix);
			case 6:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 6, zone, posix);
			case 7:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 7, zone, posix);
			case 8:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 8, zone, posix);
			case 9:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 9, zone, posix);
			default:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 10, zone, posix);
		}
	});
var $justinmimbs$time_extra$Time$Extra$toFractionalDay = F2(
	function (zone, posix) {
		return A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix) / 86400000;
	});
var $justinmimbs$time_extra$Time$Extra$toMonths = F2(
	function (zone, posix) {
		var wholeMonths = (12 * (A2($elm$time$Time$toYear, zone, posix) - 1)) + ($justinmimbs$date$Date$monthToNumber(
			A2($elm$time$Time$toMonth, zone, posix)) - 1);
		var fractionalMonth = (A2($elm$time$Time$toDay, zone, posix) + A2($justinmimbs$time_extra$Time$Extra$toFractionalDay, zone, posix)) / 100;
		return wholeMonths + fractionalMonth;
	});
var $justinmimbs$time_extra$Time$Extra$toRataDieMoment = F2(
	function (zone, posix) {
		return $justinmimbs$date$Date$toRataDie(
			A2($justinmimbs$date$Date$fromPosix, zone, posix)) + A2($justinmimbs$time_extra$Time$Extra$toFractionalDay, zone, posix);
	});
var $elm$core$Basics$truncate = _Basics_truncate;
var $justinmimbs$time_extra$Time$Extra$diff = F4(
	function (interval, zone, posix1, posix2) {
		diff:
		while (true) {
			switch (interval) {
				case 15:
					return $elm$time$Time$posixToMillis(posix2) - $elm$time$Time$posixToMillis(posix1);
				case 14:
					return (A4($justinmimbs$time_extra$Time$Extra$diff, 15, zone, posix1, posix2) / 1000) | 0;
				case 13:
					return (A4($justinmimbs$time_extra$Time$Extra$diff, 15, zone, posix1, posix2) / 60000) | 0;
				case 12:
					return (A4($justinmimbs$time_extra$Time$Extra$diff, 15, zone, posix1, posix2) / 3600000) | 0;
				case 11:
					return (A2($justinmimbs$time_extra$Time$Extra$toRataDieMoment, zone, posix2) - A2($justinmimbs$time_extra$Time$Extra$toRataDieMoment, zone, posix1)) | 0;
				case 2:
					return (A2($justinmimbs$time_extra$Time$Extra$toMonths, zone, posix2) - A2($justinmimbs$time_extra$Time$Extra$toMonths, zone, posix1)) | 0;
				case 0:
					return (A4($justinmimbs$time_extra$Time$Extra$diff, 2, zone, posix1, posix2) / 12) | 0;
				case 1:
					return (A4($justinmimbs$time_extra$Time$Extra$diff, 2, zone, posix1, posix2) / 3) | 0;
				case 3:
					return (A4($justinmimbs$time_extra$Time$Extra$diff, 11, zone, posix1, posix2) / 7) | 0;
				default:
					var weekday = interval;
					var $temp$interval = 3,
						$temp$zone = zone,
						$temp$posix1 = A3($justinmimbs$time_extra$Time$Extra$floor, weekday, zone, posix1),
						$temp$posix2 = A3($justinmimbs$time_extra$Time$Extra$floor, weekday, zone, posix2);
					interval = $temp$interval;
					zone = $temp$zone;
					posix1 = $temp$posix1;
					posix2 = $temp$posix2;
					continue diff;
			}
		}
	});
var $author$project$Pages$Admin$Reports$Sales$toPosix = function (str) {
	return A2(
		$elm$core$Maybe$andThen,
		$author$project$Utils$dateHTMLToPosixWithZone($elm$time$Time$utc),
		str);
};
var $author$project$Pages$Admin$Reports$Sales$period31daysInvalid = F2(
	function (start, end) {
		var diff = A3(
			$elm$core$Maybe$map2,
			A2($justinmimbs$time_extra$Time$Extra$diff, 11, $elm$time$Time$utc),
			$author$project$Pages$Admin$Reports$Sales$toPosix(start),
			$author$project$Pages$Admin$Reports$Sales$toPosix(end));
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$lt(31),
				diff));
	});
var $author$project$Services$Api$expectWhateverErrorString = function (toMsg) {
	return A2(
		$elm$http$Http$expectStringResponse,
		toMsg,
		A2(
			$elm$core$Basics$composeR,
			$author$project$Services$Api$expectStringError,
			$elm$core$Result$map(
				function (_v0) {
					return 0;
				})));
};
var $author$project$Services$Concessionaire$postRequestRefund = function (options) {
	return $author$project$Services$Api$postHttp(
		{
			lG: $elm$http$Http$emptyBody,
			m9: $author$project$Services$Api$expectWhateverErrorString(
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$concessionaireServiceUrl,
				_List_fromArray(
					['api', 'v1', 'wallets', options.dM, 'paymentOrder', 'rollback', 'request']),
				_List_Nil)
		});
};
var $author$project$Pages$Admin$Reports$Sales$queriesToFilter = function (queries) {
	var maybeQ = F2(
		function (param, mValue) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (v) {
						return $elm$core$List$singleton(
							{oK: param, di: v});
					},
					mValue));
		});
	return _Utils_ap(
		A2(
			maybeQ,
			'page',
			$elm$core$Maybe$Just(
				$elm$core$String$fromInt(queries.bv))),
		_Utils_ap(
			A2(maybeQ, 'start', queries.bB),
			A2(maybeQ, 'end', queries.bl)));
};
var $author$project$Pages$Admin$Reports$Sales$saleValueOf = function (e) {
	return (e.j3 > 0) ? e.j3 : A2($elm$core$Maybe$withDefault, 0, e.di);
};
var $author$project$Services$Concessionaire$SalesReportRowV2 = F2(
	function (events, totalEvents) {
		return {D: events, fG: totalEvents};
	});
var $author$project$Services$Concessionaire$Event = function (id) {
	return function (refill) {
		return function (date) {
			return function (operator) {
				return function (operatorId) {
					return function (cashierId) {
						return function (value) {
							return function (wallet) {
								return function (paymentMethodBRL) {
									return function (paymentMethodCODE) {
										return function (cardUserName) {
											return function (cardSerial) {
												return function (issTaxValue) {
													return function (grossValue) {
														return function (alreadyRollbackRequested) {
															return function (canRollback) {
																return function (origin) {
																	return function (purchaseValue) {
																		return function (convenienceFee) {
																			return function (amountPaid) {
																				return function (pagarmeFee) {
																					return function (netValue) {
																						return {lm: alreadyRollbackRequested, hX: amountPaid, lL: canRollback, lO: cardSerial, f$: cardUserName, ds: cashierId, ey: convenienceFee, cO: date, nA: grossValue, dM: id, e_: issTaxValue, jA: netValue, g4: operator, oD: operatorId, a$: origin, fe: pagarmeFee, s: paymentMethodBRL, oQ: paymentMethodCODE, j3: purchaseValue, fn: refill, di: value, k7: wallet};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Utils$decodeIso8601ToPosix = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime,
		$elm$core$Result$withDefault(
			$elm$time$Time$millisToPosix(0))),
	$elm$json$Json$Decode$string);
var $author$project$Services$Concessionaire$decoderOriginToStr = A2($elm$json$Json$Decode$map, $author$project$Services$Concessionaire$originCodeToStr, $elm$json$Json$Decode$string);
var $author$project$Services$Concessionaire$decodeEvent = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'netValue',
	$elm$json$Json$Decode$int,
	0,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'pagarmeFee',
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$Maybe$withDefault(0),
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int)),
		0,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'amountPaid',
			$elm$json$Json$Decode$int,
			0,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'convenienceFee',
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$Maybe$withDefault(0),
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int)),
				0,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'purchaseValue',
					$elm$json$Json$Decode$int,
					0,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'operator',
						$elm$json$Json$Decode$oneOf(
							_List_fromArray(
								[
									$author$project$Services$Concessionaire$decoderOriginToStr,
									$elm$json$Json$Decode$null('-')
								])),
						'-',
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'canRollback',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'alreadyRollbackRequested',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'grossValue',
									$elm$json$Json$Decode$int,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'issTaxValue',
										$elm$json$Json$Decode$int,
										0,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'cardSerial',
											$elm$json$Json$Decode$string,
											'-',
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'cardUserName',
												$elm$json$Json$Decode$string,
												'-',
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'paymentType',
													$elm$json$Json$Decode$string,
													'-',
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'paymentType',
														$author$project$Services$Concessionaire$decoderPaymentMethodToStr,
														'-',
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'wallet',
															$elm$json$Json$Decode$string,
															'-',
															A4(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																'value',
																$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
																$elm$core$Maybe$Nothing,
																A4(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																	'cashierID',
																	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
																	$elm$core$Maybe$Nothing,
																	A4(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																		'operatorID',
																		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
																		$elm$core$Maybe$Nothing,
																		A4(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																			'operator',
																			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
																			$elm$core$Maybe$Nothing,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'date',
																				$author$project$Utils$decodeIso8601ToPosix,
																				A4(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																					'refill',
																					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
																					$elm$core$Maybe$Nothing,
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'id',
																						$elm$json$Json$Decode$string,
																						$elm$json$Json$Decode$succeed($author$project$Services$Concessionaire$Event)))))))))))))))))))))));
var $author$project$Services$Concessionaire$decoderReportSalesV2 = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'totalEvents',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'events',
		$elm$json$Json$Decode$list($author$project$Services$Concessionaire$decodeEvent),
		$elm$json$Json$Decode$succeed($author$project$Services$Concessionaire$SalesReportRowV2)));
var $author$project$Services$Concessionaire$encodeSalesReport = function (options) {
	var encodeMaybe = F2(
		function (key, value) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (fP) {
						return _List_fromArray(
							[
								_Utils_Tuple2(
								key,
								$elm$json$Json$Encode$string(fP))
							]);
					},
					value));
		});
	return $elm$json$Json$Encode$object(
		_Utils_ap(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'start',
					$elm$json$Json$Encode$string(options.eb)),
					_Utils_Tuple2(
					'end',
					$elm$json$Json$Encode$string(options.dH))
				]),
			A2(encodeMaybe, 'paymentType', options.gs)));
};
var $author$project$Services$Concessionaire$salesReportV2 = function (options) {
	return $elm$http$Http$request(
		{
			lG: $elm$http$Http$jsonBody(
				$author$project$Services$Concessionaire$encodeSalesReport(
					{dH: options.no.dH, gs: options.gs, bv: options.bv, eb: options.no.eb})),
			m9: A2(
				$author$project$Services$Api$expectJson,
				options.ow,
				$elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[$author$project$Services$Concessionaire$decoderReportSalesV2]))),
			nG: _List_fromArray(
				[
					$author$project$Services$Api$authorizationHeader(options.kU)
				]),
			of: 'POST',
			p5: $elm$core$Maybe$Nothing,
			qi: $elm$core$Maybe$Nothing,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'events', 'cashier']),
				_List_Nil)
		});
};
var $author$project$Components$PDF$Create$GotCreatePDF = function (a) {
	return {$: 0, a: a};
};
var $author$project$Shared$ShowSuccessDialogWithRedirect = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Patterns$Forms$Submitting = 2;
var $author$project$Services$Pdf$encodeExportType = function (t) {
	if (!t) {
		return 'PDF';
	} else {
		return 'CSV';
	}
};
var $author$project$Services$Pdf$encodeReportFilter = function (filter) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'param',
				$elm$json$Json$Encode$string(filter.oK)),
				_Utils_Tuple2(
				'value',
				$elm$json$Json$Encode$string(filter.di))
			]));
};
var $author$project$Services$Pdf$pageTypeToStr = function (t) {
	if (!t) {
		return 'full';
	} else {
		return 'page';
	}
};
var $author$project$Services$Pdf$reportTypeToStr = function (t) {
	switch (t) {
		case 0:
			return 'usage';
		case 1:
			return 'cashiers';
		case 2:
			return 'usingByWalletClass';
		case 3:
			return 'cashierGroupedUsage';
		case 4:
			return 'cashierUsage';
		case 5:
			return 'financialPendingTransactions';
		case 6:
			return 'financialTransactions';
		case 7:
			return 'financialAccount';
		case 8:
			return 'sales';
		case 9:
			return 'resumedSales';
		default:
			return 'administrativeSales';
	}
};
var $author$project$Services$Pdf$encodeCreatePDF = F5(
	function (filters, reportType, pageType, exportType, maybeFileName) {
		return $elm$json$Json$Encode$object(
			_Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'reportType',
						$elm$json$Json$Encode$string(
							$author$project$Services$Pdf$reportTypeToStr(reportType))),
						_Utils_Tuple2(
						'reportFilter',
						A2($elm$json$Json$Encode$list, $author$project$Services$Pdf$encodeReportFilter, filters)),
						_Utils_Tuple2(
						'exportType',
						$elm$json$Json$Encode$string(
							$author$project$Services$Pdf$encodeExportType(exportType))),
						_Utils_Tuple2(
						'downloadType',
						$elm$json$Json$Encode$string(
							$author$project$Services$Pdf$pageTypeToStr(pageType)))
					]),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (f) {
							return $elm$core$List$singleton(
								_Utils_Tuple2(
									'fileName',
									$elm$json$Json$Encode$string(f)));
						},
						maybeFileName))));
	});
var $author$project$Services$Pdf$createPDF = function (options) {
	return $author$project$Services$Api$postHttp(
		{
			lG: $elm$http$Http$jsonBody(
				A5($author$project$Services$Pdf$encodeCreatePDF, options.Z, options.kY, options.R, options.Y, options.nk)),
			m9: $author$project$Services$Api$expectWhateverErrorString(
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'exportFile', 'createSchedule']),
				_List_Nil)
		});
};
var $author$project$Components$PDF$Create$initModal = F4(
	function (_v0, exportType, type_, filter) {
		var isShowCurrentPage = _v0.a;
		var isShowEntirePeriodPage = _v0.b;
		return {Y: exportType, Z: filter, L: 0, eY: isShowCurrentPage, eZ: isShowEntirePeriodPage, R: $elm$core$Maybe$Nothing, da: $elm$core$Maybe$Nothing, hp: type_};
	});
var $author$project$Components$PDF$Create$update = F3(
	function (msg, model, user) {
		var _v0 = _Utils_Tuple2(msg, model.aY);
		_v0$5:
		while (true) {
			switch (_v0.a.$) {
				case 2:
					var _v1 = _v0.a;
					var isShowOptionPage = _v1.a;
					var exportType = _v1.b;
					var type_ = _v1.c;
					var filters = _v1.d;
					var newModel = _Utils_update(
						model,
						{
							aY: $elm$core$Maybe$Just(
								A4($author$project$Components$PDF$Create$initModal, isShowOptionPage, exportType, type_, filters))
						});
					return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
				case 0:
					if (!_v0.b.$) {
						var rd = _v0.a.a;
						var modal_ = _v0.b.a;
						return A2(
							$krisajenkins$remotedata$RemoteData$withDefault,
							_Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $elm$core$Maybe$Just(
											_Utils_update(
												modal_,
												{L: 0, R: $elm$core$Maybe$Nothing}))
									}),
								$elm$core$Platform$Cmd$none,
								A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rd)),
							A2(
								$krisajenkins$remotedata$RemoteData$map,
								function (_v2) {
									return _Utils_Tuple3(
										_Utils_update(
											model,
											{aY: $elm$core$Maybe$Nothing}),
										$elm$core$Platform$Cmd$none,
										$author$project$Shared$ShowSuccessDialogWithRedirect(
											{
												lJ: 'Ver relatório Gerados',
												pv: $author$project$Route$Report($author$project$Route$PDFs),
												fD: 'Relatório solicitado com sucesso!'
											}));
								},
								rd));
					} else {
						break _v0$5;
					}
				case 1:
					if (!_v0.b.$) {
						var maybeStr = _v0.a.a;
						var m_ = _v0.b.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $elm$core$Maybe$Just(
										_Utils_update(
											m_,
											{da: maybeStr}))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					} else {
						break _v0$5;
					}
				case 3:
					var _v3 = _v0.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{aY: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				default:
					if (!_v0.b.$) {
						var _v4 = _v0.a;
						var exportType = _v4.a;
						var pageType = _v4.b;
						var m_ = _v0.b.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $elm$core$Maybe$Just(
										_Utils_update(
											m_,
											{
												L: 2,
												R: $elm$core$Maybe$Just(pageType)
											}))
								}),
							$author$project$Services$Pdf$createPDF(
								{Y: exportType, nk: m_.da, Z: m_.Z, ow: $author$project$Components$PDF$Create$GotCreatePDF, R: pageType, kU: user.kU, kY: m_.hp}),
							$author$project$Shared$NoOp);
					} else {
						break _v0$5;
					}
			}
		}
		return _Utils_Tuple3(
			model,
			$elm$core$Platform$Cmd$none,
			$author$project$Shared$ShowErrorDialog('Algo deu errado'));
	});
var $author$project$Pages$Admin$Reports$Sales$updateFilter = F3(
	function (shared, loggedUser, model) {
		var _v0 = model.cO;
		if (!_v0.$) {
			var date = _v0.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{ck: $krisajenkins$remotedata$RemoteData$Loading}),
				$author$project$Services$Concessionaire$salesReportV2(
					{
						mc: $author$project$Route$extractConcessionaireId(shared.pv),
						no: {dH: date.dH, eb: date.eb},
						gs: model.cn,
						ow: $author$project$Pages$Admin$Reports$Sales$ReceivedReport,
						bv: model.T.bv,
						kU: loggedUser.kU
					}),
				$author$project$Shared$NoOp);
		} else {
			return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
		}
	});
var $author$project$Pages$Admin$Reports$Sales$update = F4(
	function (msg, model, shared, loggedUser) {
		var queries = model.T;
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
			case 1:
				var now = msg.a.e8;
				var timezone = msg.a.kS;
				var today = A2($justinmimbs$date$Date$fromPosix, timezone, now);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							cO: $elm$core$Maybe$Just(
								{
									dH: $justinmimbs$date$Date$toIsoString(today),
									eb: $justinmimbs$date$Date$toIsoString(today)
								}),
							T: _Utils_update(
								queries,
								{
									bl: $elm$core$Maybe$Just(
										$justinmimbs$date$Date$toIsoString(today)),
									bB: $elm$core$Maybe$Just(
										$justinmimbs$date$Date$toIsoString(today))
								}),
							kS: timezone
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 2:
				var res = msg.a;
				var resetSelectedOperator = A2(
					$elm$core$List$any,
					$elm$core$Basics$eq(
						A2($elm$core$Maybe$withDefault, '-', model.a5)),
					A2(
						$elm$core$Result$withDefault,
						_List_Nil,
						A2(
							$elm$core$Result$map,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.D;
								},
								$elm$core$List$map(
									function ($) {
										return $.a$;
									})),
							res)));
				var selectedOperator_ = resetSelectedOperator ? model.a5 : $elm$core$Maybe$Nothing;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ck: $krisajenkins$remotedata$RemoteData$fromResult(res),
							a5: selectedOperator_
						}),
					$elm$core$Platform$Cmd$none,
					function () {
						if (!res.$) {
							return $author$project$Shared$NoOp;
						} else {
							var error = res.a;
							return A2($author$project$Shared$updateApiError, shared, error);
						}
					}());
			case 3:
				var index = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{hw: index}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 4:
				var id = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							cn: $elm$core$String$isEmpty(id) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(id)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 5:
				var id = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							a5: (id === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(id)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 6:
				var search = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{fq: search}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 7:
				var strDate = msg.a;
				var start = A2(
					$elm$core$Maybe$withDefault,
					'',
					A2($elm$core$Maybe$map, $author$project$Utils$iso8601ToSimpleDate, strDate));
				var date_ = A2(
					$elm$core$Maybe$map,
					function (justDate) {
						return _Utils_update(
							justDate,
							{eb: start});
					},
					model.cO);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							cO: date_,
							T: _Utils_update(
								queries,
								{
									bB: $elm$core$Maybe$Just(start)
								})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 8:
				var strDate = msg.a;
				var end = A2(
					$elm$core$Maybe$withDefault,
					'',
					A2($elm$core$Maybe$map, $author$project$Utils$iso8601ToSimpleDate, strDate));
				var date_ = A2(
					$elm$core$Maybe$map,
					function (justDate) {
						return _Utils_update(
							justDate,
							{dH: end});
					},
					model.cO);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							cO: date_,
							T: _Utils_update(
								queries,
								{
									bl: $elm$core$Maybe$Just(end)
								})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 9:
				return A3(
					$author$project$Pages$Admin$Reports$Sales$updateFilter,
					shared,
					loggedUser,
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{bv: 1})
						}));
			case 10:
				var sales = msg.a;
				return _Utils_Tuple3(
					model,
					A2(
						$elm$core$Task$perform,
						$author$project$Pages$Admin$Reports$Sales$GenerateCsvDownloadWithTime(sales),
						A3(
							$elm$core$Task$map2,
							F2(
								function (now, timezone) {
									return {e8: now, kS: timezone};
								}),
							$elm$time$Time$now,
							$elm$time$Time$here)),
					$author$project$Shared$NoOp);
			case 11:
				var sales = msg.a;
				var now = msg.b.e8;
				var timezone = msg.b.kS;
				var valueViewMoney = function (value) {
					return A2(
						$elm$core$Maybe$withDefault,
						'-',
						A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $author$project$Utils$formatAsMoney),
							value));
				};
				var title_ = 'Vendas ' + (A2($author$project$Utils$formatDateTimeFromPosix, timezone, now) + '.csv');
				var recordsFiltered = A2(
					$elm$core$Maybe$withDefault,
					sales,
					A2(
						$elm$core$Maybe$map,
						function (op) {
							return _Utils_update(
								sales,
								{
									D: A2(
										$elm$core$List$filter,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.a$;
											},
											$elm$core$Basics$eq(op)),
										sales.D)
								});
						},
						model.a5));
				var hasIss = A2(
					$elm$core$List$any,
					function (_v2) {
						var issTaxValue = _v2.e_;
						return issTaxValue > 0;
					},
					sales.D);
				var headersIss = hasIss ? _List_fromArray(
					['Valor Bruto', 'Desconto ISS', 'Valor Líquido']) : _List_fromArray(
					['Valor']);
				var headers = _Utils_ap(
					_List_fromArray(
						['Data', 'Operador', 'Tipo de Pagamento']),
					_Utils_ap(
						headersIss,
						_List_fromArray(
							['Taxa Conveniência', 'Valor Pago', 'Taxa Pagar.me', 'Valor Líquido', 'Carteira', 'Cartão', 'Nome'])));
				var records = A2(
					$elm$core$List$map,
					function (sale) {
						var valueView = function (v) {
							return (sale.s === 'Estorno') ? A2(
								$elm$core$Basics$composeR,
								valueViewMoney,
								function (v_) {
									return '( ' + (v_ + ' )');
								})(v) : valueViewMoney(v);
						};
						var rowIss = hasIss ? _List_fromArray(
							[
								valueView(
								$elm$core$Maybe$Just(sale.nA)),
								valueViewMoney(
								$elm$core$Maybe$Just(sale.e_)),
								valueView(
								$elm$core$Maybe$Just(
									$author$project$Pages$Admin$Reports$Sales$saleValueOf(sale)))
							]) : _List_fromArray(
							[
								valueView(
								$elm$core$Maybe$Just(
									$author$project$Pages$Admin$Reports$Sales$saleValueOf(sale)))
							]);
						return _Utils_ap(
							_List_fromArray(
								[
									A2($author$project$Utils$formatDateTimeWithSecondsFromPosix, timezone, sale.cO),
									sale.a$,
									sale.s
								]),
							_Utils_ap(
								rowIss,
								_List_fromArray(
									[
										A2($author$project$Pages$Admin$Reports$Sales$feeView, sale.s, sale.ey),
										valueView(
										$elm$core$Maybe$Just(
											$author$project$Pages$Admin$Reports$Sales$paidValueOf(sale))),
										A2($author$project$Pages$Admin$Reports$Sales$feeView, sale.s, sale.fe),
										valueView(
										$elm$core$Maybe$Just(
											$author$project$Pages$Admin$Reports$Sales$netValueOf(sale))),
										sale.k7,
										sale.lO,
										sale.f$
									])));
					},
					recordsFiltered.D);
				return _Utils_Tuple3(
					model,
					A3($author$project$Components$GeneratorCSV$download, records, headers, title_),
					$author$project$Shared$NoOp);
			case 12:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dK: !model.dK}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 13:
				var salesReport = msg.a;
				var receipt = {
					ep: loggedUser.ep,
					lo: A2($elm$core$Maybe$withDefault, 0, salesReport.di),
					fQ: A2($elm$core$Maybe$withDefault, 0, salesReport.di),
					ia: salesReport.lO,
					ik: salesReport.k7,
					ew: loggedUser.l3,
					ex: $author$project$Utils$getConcessionaire(loggedUser).c3,
					cO: salesReport.cO,
					fa: A2($elm$core$Maybe$withDefault, '-', salesReport.g4),
					fg: salesReport.f$,
					jW: salesReport.s,
					fC: loggedUser.jX,
					fD: 'CÓPIA RECIBO DE VENDA',
					fH: salesReport.dM
				};
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$PrintHTML(
						A2($author$project$Components$HTMLToPrint$SalesReceipt$htmlStr, receipt, shared.kS)));
			case 14:
				var s = msg.a;
				return _Utils_Tuple3(
					model,
					$author$project$Services$Concessionaire$postRequestRefund(
						{dM: s.dM, ow: $author$project$Pages$Admin$Reports$Sales$GotRequestRefund, kU: loggedUser.kU}),
					$author$project$Shared$NoOp);
			case 15:
				var rd = msg.a;
				return _Utils_Tuple3(
					model,
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Platform$Cmd$none,
						A2(
							$elm$core$Maybe$map,
							function (d) {
								return $author$project$Services$Concessionaire$salesReportV2(
									{
										mc: $author$project$Route$extractConcessionaireId(shared.pv),
										no: {dH: d.dH, eb: d.eb},
										gs: model.cn,
										ow: $author$project$Pages$Admin$Reports$Sales$ReceivedReport,
										bv: model.T.bv,
										kU: loggedUser.kU
									});
							},
							model.cO)),
					A2(
						$author$project$Shared$remoteDataSharedMsg,
						$elm$core$Maybe$Just('Estorno solicitado com sucesso!'),
						rd));
			case 16:
				var newRdReport = msg.a;
				var canAskMore = _Utils_eq(
					A2(
						$elm$core$Result$withDefault,
						0,
						A2(
							$elm$core$Result$map,
							function ($) {
								return $.fG;
							},
							newRdReport)),
					$author$project$Pages$Admin$Reports$Sales$cardsPerPage);
				var newShared = canAskMore ? $author$project$Shared$NoOp : $author$project$Shared$ShowSuccessDialog('Todos os registros foram carregados!');
				var addMoreReport = A3(
					$krisajenkins$remotedata$RemoteData$map2,
					F2(
						function (r1, r2) {
							var newEventsFiltered = A2(
								$elm$core$List$filter,
								function (novo) {
									return !A2(
										$elm$core$List$any,
										function (antigo) {
											return _Utils_eq(antigo.fn, novo.fn) && ((!_Utils_eq(antigo.fn, $elm$core$Maybe$Nothing)) && (!_Utils_eq(novo.fn, $elm$core$Maybe$Nothing)));
										},
										r1.D);
								},
								r2.D);
							return {
								D: _Utils_ap(r1.D, newEventsFiltered),
								fG: r1.fG + r2.fG
							};
						}),
					model.ck,
					$krisajenkins$remotedata$RemoteData$fromResult(newRdReport));
				var emptyAfterFilteringCanRequestNextPage = A2(
					$krisajenkins$remotedata$RemoteData$withDefault,
					false,
					A3(
						$krisajenkins$remotedata$RemoteData$map2,
						F2(
							function (newFiltered, old) {
								return _Utils_eq(
									$elm$core$List$length(newFiltered.D),
									$elm$core$List$length(old.D)) && canAskMore;
							}),
						addMoreReport,
						model.ck));
				var requestingMoreReportWithScroll = emptyAfterFilteringCanRequestNextPage ? true : false;
				var _v3 = function () {
					var _v4 = _Utils_Tuple2(emptyAfterFilteringCanRequestNextPage, model.cO);
					if (_v4.a && (!_v4.b.$)) {
						var date = _v4.b.a;
						var currentOffset = model.T.bv + 1;
						var newQueries_ = _Utils_update(
							queries,
							{bv: currentOffset});
						return _Utils_Tuple2(
							$author$project$Services$Concessionaire$salesReportV2(
								{
									mc: $author$project$Route$extractConcessionaireId(shared.pv),
									no: {dH: date.dH, eb: date.eb},
									gs: model.cn,
									ow: $author$project$Pages$Admin$Reports$Sales$MoreReceivedReport,
									bv: newQueries_.bv,
									kU: loggedUser.kU
								}),
							newQueries_);
					} else {
						return _Utils_Tuple2($elm$core$Platform$Cmd$none, model.T);
					}
				}();
				var newCmd = _v3.a;
				var newQueries = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{T: newQueries, ck: addMoreReport}),
					newCmd,
					function () {
						if (!newRdReport.$) {
							return newShared;
						} else {
							var error = newRdReport.a;
							return A2($author$project$Shared$updateApiError, shared, error);
						}
					}());
			case 17:
				var isShowOptionPage = msg.a;
				var exportType = msg.b;
				var reportType = msg.c;
				if (A2(
					$author$project$Pages$Admin$Reports$Sales$period31daysInvalid,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.eb;
						},
						model.cO),
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.dH;
						},
						model.cO))) {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$ShowErrorDialog('O período definido é maior que 31 dias. Ajuste a consulta e tente novamente.'));
				} else {
					var newQueries = model.T;
					var _v6 = A3(
						$author$project$Components$PDF$Create$update,
						A4(
							$author$project$Components$PDF$Create$ClickedOpenModal,
							isShowOptionPage,
							exportType,
							reportType,
							$author$project$Pages$Admin$Reports$Sales$queriesToFilter(newQueries)),
						model.bQ,
						loggedUser);
					var newCompModel = _v6.a;
					var cmd = _v6.b;
					var sharedMsg = _v6.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bQ: newCompModel}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Reports$Sales$CompPDFCreateMSg, cmd),
						sharedMsg);
				}
			default:
				var msg_ = msg.a;
				var _v7 = A3($author$project$Components$PDF$Create$update, msg_, model.bQ, loggedUser);
				var newCompModel = _v7.a;
				var cmd = _v7.b;
				var sharedMsg = _v7.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bQ: newCompModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Reports$Sales$CompPDFCreateMSg, cmd),
					sharedMsg);
		}
	});
var $author$project$Pages$Admin$SalesReport$GenerateCsvDownloadWithTime = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Utils$endOfTheDay = F2(
	function (timezone, time) {
		var parts = A2(
			$justinmimbs$time_extra$Time$Extra$posixToParts,
			timezone,
			A4($justinmimbs$time_extra$Time$Extra$add, 11, 1, timezone, time));
		return A2(
			$justinmimbs$time_extra$Time$Extra$partsToPosix,
			timezone,
			{dC: parts.dC, eO: 0, e3: 0, e5: 0, b8: parts.b8, ft: 0, cF: parts.cF});
	});
var $author$project$Utils$monthToStr = function (n) {
	switch (n) {
		case 0:
			return 'Janeiro';
		case 1:
			return 'Fevereiro';
		case 2:
			return 'Março';
		case 3:
			return 'Abril';
		case 4:
			return 'Maio';
		case 5:
			return 'Junho';
		case 6:
			return 'Julho';
		case 7:
			return 'Agosto';
		case 8:
			return 'Setembro';
		case 9:
			return 'Outubro';
		case 10:
			return 'Novembro';
		default:
			return 'Dezembro';
	}
};
var $author$project$Utils$formatMonthYearFromPosix = F2(
	function (timezone, time) {
		var parts = A2($justinmimbs$time_extra$Time$Extra$posixToParts, timezone, time);
		return function (str) {
			return str + ('/' + $elm$core$String$fromInt(parts.cF));
		}(
			$author$project$Utils$monthToStr(parts.b8));
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromMonth = function (month) {
	switch (month) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString = F2(
	function (digits, time) {
		return A3(
			$elm$core$String$padLeft,
			digits,
			'0',
			$elm$core$String$fromInt(time));
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime = function (time) {
	return A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		4,
		A2($elm$time$Time$toYear, $elm$time$Time$utc, time)) + ('-' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		$rtfeldman$elm_iso8601_date_strings$Iso8601$fromMonth(
			A2($elm$time$Time$toMonth, $elm$time$Time$utc, time))) + ('-' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toDay, $elm$time$Time$utc, time)) + ('T' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toHour, $elm$time$Time$utc, time)) + (':' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toMinute, $elm$time$Time$utc, time)) + (':' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toSecond, $elm$time$Time$utc, time)) + ('.' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		3,
		A2($elm$time$Time$toMillis, $elm$time$Time$utc, time)) + 'Z'))))))))))));
};
var $author$project$Pages$Admin$SalesReport$ReceivedReport = function (a) {
	return {$: 3, a: a};
};
var $author$project$Services$Concessionaire$SalesReportRow = F7(
	function (sale_date, sale_operator_name, sale_type_payment, sale_value, client_name, client_card, client_class) {
		return {$9: client_card, l$: client_class, io: client_name, kk: sale_date, kl: sale_operator_name, km: sale_type_payment, ht: sale_value};
	});
var $author$project$Services$Concessionaire$decoderReportSales = A8(
	$elm$json$Json$Decode$map7,
	$author$project$Services$Concessionaire$SalesReportRow,
	A2($elm$json$Json$Decode$field, 'saleDate', $author$project$Utils$decodeIso8601ToPosix),
	A2($elm$json$Json$Decode$field, 'saleOperatorName', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'saleTypePayment', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'saleValue', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'clientName', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'clientCard', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'clientClass',
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$String$join(', '),
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string))));
var $author$project$Services$Concessionaire$salesReport = function (options) {
	return $elm$http$Http$request(
		{
			lG: $elm$http$Http$emptyBody,
			m9: A2(
				$author$project$Services$Api$expectJson,
				options.ow,
				$elm$json$Json$Decode$list($author$project$Services$Concessionaire$decoderReportSales)),
			nG: _List_fromArray(
				[
					$author$project$Services$Api$authorizationHeader(options.kU)
				]),
			of: 'GET',
			p5: $elm$core$Maybe$Nothing,
			qi: $elm$core$Maybe$Nothing,
			qt: A2(
				$author$project$Constants$cashierServiceUrl,
				_List_fromArray(
					['api', 'v1', 'cashier', 'report', 'sales']),
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$map,
							$elm$url$Url$Builder$string('concessionaireId'),
							options.mc),
							$elm$core$Maybe$Just(
							A2(
								$elm$url$Url$Builder$string,
								'startDate',
								$author$project$Utils$iso8601ToSimpleDate(options.no.eb))),
							$elm$core$Maybe$Just(
							A2(
								$elm$url$Url$Builder$string,
								'endDate',
								$author$project$Utils$iso8601ToSimpleDate(options.no.dH))),
							(options.nq !== '') ? $elm$core$Maybe$Just(
							A2($elm$url$Url$Builder$string, 'operator', options.nq)) : $elm$core$Maybe$Nothing
						])))
		});
};
var $author$project$Pages$Admin$SalesReport$updateSearch = F3(
	function (shared, loggedUser, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple3(
				model,
				$elm$core$Platform$Cmd$none,
				$author$project$Shared$ShowErrorDialog('Necessário informar date de início e fim')),
			A2(
				$elm$core$Maybe$map,
				function (d) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ck: $krisajenkins$remotedata$RemoteData$Loading}),
						$author$project$Services$Concessionaire$salesReport(
							{
								mc: $author$project$Route$extractConcessionaireId(shared.pv),
								no: {dH: d.dH, eb: d.eb},
								nq: model.fq,
								ow: $author$project$Pages$Admin$SalesReport$ReceivedReport,
								kU: loggedUser.kU
							}),
						$author$project$Shared$NoOp);
				},
				model.cO));
	});
var $author$project$Pages$Admin$SalesReport$update = F4(
	function (msg, shared, loggedUser, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
			case 1:
				var now = msg.a.e8;
				var timezone = msg.a.kS;
				var today = A2($justinmimbs$date$Date$fromPosix, timezone, now);
				var startOfTheMonth = A2($author$project$Utils$startOfTheMonth, timezone, now);
				var endOfTheDay = A2($author$project$Utils$endOfTheDay, timezone, now);
				var dates = A2(
					$elm$core$List$cons,
					{
						dH: $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(endOfTheDay),
						eb: $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(
							A4($justinmimbs$time_extra$Time$Extra$add, 11, -1, timezone, endOfTheDay)),
						fD: 'Hoje'
					},
					A2(
						$elm$core$List$cons,
						{
							dH: $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(endOfTheDay),
							eb: $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(
								A4($justinmimbs$time_extra$Time$Extra$add, 11, -7, timezone, endOfTheDay)),
							fD: 'Últimos 7 dias'
						},
						$elm$core$List$reverse(
							A2(
								$elm$core$List$map,
								function (posix) {
									return {
										dH: $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(
											A4($justinmimbs$time_extra$Time$Extra$add, 2, 1, timezone, posix)),
										eb: $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(posix),
										fD: A2($author$project$Utils$formatMonthYearFromPosix, timezone, posix)
									};
								},
								A2(
									$elm$core$List$map,
									function (offsetMonth) {
										return A4($justinmimbs$time_extra$Time$Extra$add, 2, offsetMonth, timezone, startOfTheMonth);
									},
									A2($elm$core$List$range, -24, 0))))));
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							cO: $elm$core$Maybe$Just(
								{
									dH: $justinmimbs$date$Date$toIsoString(today),
									eb: $justinmimbs$date$Date$toIsoString(today)
								}),
							kS: timezone
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 3:
				var res = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ck: $krisajenkins$remotedata$RemoteData$fromResult(res)
						}),
					$elm$core$Platform$Cmd$none,
					function () {
						if (!res.$) {
							return $author$project$Shared$NoOp;
						} else {
							var error = res.a;
							return A2($author$project$Shared$updateApiError, shared, error);
						}
					}());
			case 4:
				var index = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{hw: index}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 5:
				var search = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{fq: search}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 6:
				var strDate = msg.a;
				var start = $author$project$Utils$iso8601ToSimpleDate(strDate);
				var date_ = A2(
					$elm$core$Maybe$map,
					function (justDate) {
						return _Utils_update(
							justDate,
							{eb: start});
					},
					model.cO);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cO: date_}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 7:
				var strDate = msg.a;
				var end = $author$project$Utils$iso8601ToSimpleDate(strDate);
				var date_ = A2(
					$elm$core$Maybe$map,
					function (justDate) {
						return _Utils_update(
							justDate,
							{dH: end});
					},
					model.cO);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cO: date_}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 2:
				var reports = msg.a;
				var now = msg.b.e8;
				var timezone = msg.b.kS;
				var title = 'Vendas ' + (A2($author$project$Utils$formatDateTimeFromPosix, timezone, now) + '.csv');
				var records = A2(
					$elm$core$List$map,
					function (row) {
						return _List_fromArray(
							[
								A2($author$project$Utils$formatDateTimeFromPosix, timezone, row.kk),
								row.kl,
								row.km,
								$author$project$Utils$formatAsMoney(
								$elm$core$String$fromInt(row.ht)),
								row.io,
								row.$9
							]);
					},
					reports);
				var headers = _List_fromArray(
					['Data', 'Operador', 'Tipo de Pagamento', 'Valor (R$)', 'Nome', 'Cartão']);
				return _Utils_Tuple3(
					model,
					A3($author$project$Components$GeneratorCSV$download, records, headers, title),
					$author$project$Shared$NoOp);
			case 9:
				var reports = msg.a;
				return _Utils_Tuple3(
					model,
					A2(
						$elm$core$Task$perform,
						$author$project$Pages$Admin$SalesReport$GenerateCsvDownloadWithTime(reports),
						A3(
							$elm$core$Task$map2,
							F2(
								function (now, timezone) {
									return {e8: now, kS: timezone};
								}),
							$elm$time$Time$now,
							$elm$time$Time$here)),
					$author$project$Shared$NoOp);
			default:
				return A3($author$project$Pages$Admin$SalesReport$updateSearch, shared, loggedUser, model);
		}
	});
var $author$project$Pages$Admin$SessionWithoutPouchReport$GenerateCsvDownloadWithTime = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $elm$core$Set$fromList = function (list) {
	return A3($elm$core$List$foldl, $elm$core$Set$insert, $elm$core$Set$empty, list);
};
var $elm$core$List$sort = function (xs) {
	return A2($elm$core$List$sortBy, $elm$core$Basics$identity, xs);
};
var $author$project$Pages$Admin$SessionWithoutPouchReport$ReceivedReport = function (a) {
	return {$: 1, a: a};
};
var $author$project$Services$Concessionaire$SessionsReportRow = function (line) {
	return function (open) {
		return function (closed) {
			return function (operator_closed) {
				return function (operator_open) {
					return function (classes) {
						return function (class_total) {
							return function (gate_start) {
								return function (gate_end) {
									return function (vehicle) {
										return {im: class_total, dv: classes, iq: closed, iZ: gate_end, i_: gate_start, e1: line, jJ: open, jN: operator_closed, fb: operator_open, k2: vehicle};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Services$Concessionaire$sessionsWithoutPouchReport = function (options) {
	var decoder = A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'vehicle',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Services$Concessionaire$vehicleDecoder),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'gateEnd',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'gateStart',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'classesTotal',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'classes',
						A2(
							$elm$json$Json$Decode$map,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Dict$toList,
								$elm$core$List$map(
									function (_v0) {
										var name = _v0.a;
										var value = _v0.b;
										return {c3: name, di: value};
									})),
							$elm$json$Json$Decode$dict($elm$json$Json$Decode$int)),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'operatorOpen',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'operatorClosed',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'close',
									$author$project$Utils$decodeNullableIso8601ToPosix,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'open',
										$author$project$Utils$decodeNullableIso8601ToPosix,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'line',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$Services$Concessionaire$SessionsReportRow)))))))))));
	return $elm$http$Http$request(
		{
			lG: $elm$http$Http$emptyBody,
			m9: A2(
				$author$project$Services$Api$expectJson,
				options.ow,
				$elm$json$Json$Decode$list(decoder)),
			nG: _List_fromArray(
				[
					$author$project$Services$Api$authorizationHeader(options.kU)
				]),
			of: 'GET',
			p5: $elm$core$Maybe$Nothing,
			qi: $elm$core$Maybe$Nothing,
			qt: A2(
				$author$project$Constants$cashierServiceUrl,
				_List_fromArray(
					['api', 'v1', 'cashier', 'closed', 'all']),
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$map,
							$elm$url$Url$Builder$string('concessionaireId'),
							options.mc),
							$elm$core$Maybe$Just(
							A2(
								$elm$url$Url$Builder$string,
								'startDate',
								$author$project$Utils$iso8601ToSimpleDate(options.no.eb))),
							$elm$core$Maybe$Just(
							A2(
								$elm$url$Url$Builder$string,
								'endDate',
								$author$project$Utils$iso8601ToSimpleDate(options.no.dH))),
							$elm$core$String$isEmpty(options.nq) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
							A2($elm$url$Url$Builder$string, 'operator', options.nq)),
							$elm$core$String$isEmpty(options.np) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
							A2($elm$url$Url$Builder$string, 'line', options.np)),
							$elm$core$String$isEmpty(options.em) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
							A2($elm$url$Url$Builder$string, 'vehicle', options.em))
						])))
		});
};
var $author$project$Pages$Admin$SessionWithoutPouchReport$updateFilter = F3(
	function (shared, user, model) {
		var _v0 = model.cO;
		if (!_v0.$) {
			var date = _v0.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{ck: $krisajenkins$remotedata$RemoteData$Loading}),
				$author$project$Services$Concessionaire$sessionsWithoutPouchReport(
					{
						mc: $author$project$Route$extractConcessionaireId(shared.pv),
						no: {dH: date.dH, eb: date.eb},
						np: model.fr,
						nq: model.fs,
						ow: $author$project$Pages$Admin$SessionWithoutPouchReport$ReceivedReport,
						kU: user.kU,
						em: model.em
					}),
				$author$project$Shared$NoOp);
		} else {
			return _Utils_Tuple3(
				model,
				$elm$core$Platform$Cmd$none,
				$author$project$Shared$ShowErrorDialog('Necessário informar date de início e fim'));
		}
	});
var $author$project$Pages$Admin$SessionWithoutPouchReport$update = F4(
	function (msg, model, shared, user) {
		switch (msg.$) {
			case 0:
				var now = msg.a;
				var today = A2($justinmimbs$date$Date$fromPosix, shared.kS, now);
				var startOfTheMonth = A2($author$project$Utils$startOfTheMonth, shared.kS, now);
				var endOfTheDay = A2($author$project$Utils$endOfTheDay, shared.kS, now);
				var dates = A2(
					$elm$core$List$cons,
					{
						dH: $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(endOfTheDay),
						eb: $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(
							A4($justinmimbs$time_extra$Time$Extra$add, 11, -1, shared.kS, endOfTheDay)),
						fD: 'Hoje'
					},
					A2(
						$elm$core$List$cons,
						{
							dH: $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(endOfTheDay),
							eb: $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(
								A4($justinmimbs$time_extra$Time$Extra$add, 11, -7, shared.kS, endOfTheDay)),
							fD: 'Últimos 7 dias'
						},
						$elm$core$List$reverse(
							A2(
								$elm$core$List$map,
								function (posix) {
									return {
										dH: $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(
											A4($justinmimbs$time_extra$Time$Extra$add, 2, 1, shared.kS, posix)),
										eb: $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(posix),
										fD: A2($author$project$Utils$formatMonthYearFromPosix, shared.kS, posix)
									};
								},
								A2(
									$elm$core$List$map,
									function (offsetMonth) {
										return A4($justinmimbs$time_extra$Time$Extra$add, 2, offsetMonth, shared.kS, startOfTheMonth);
									},
									A2($elm$core$List$range, -24, 0))))));
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							cO: $elm$core$Maybe$Just(
								{
									dH: $justinmimbs$date$Date$toIsoString(today),
									eb: $justinmimbs$date$Date$toIsoString(today)
								})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 1:
				var res = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ck: $krisajenkins$remotedata$RemoteData$fromResult(res)
						}),
					$elm$core$Platform$Cmd$none,
					function () {
						if (!res.$) {
							return $author$project$Shared$NoOp;
						} else {
							var error = res.a;
							return A2($author$project$Shared$updateApiError, shared, error);
						}
					}());
			case 3:
				var index = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{hw: index}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 4:
				var search = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{fs: search}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 5:
				var search = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{fr: search}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 7:
				var strDate = msg.a;
				var start = $author$project$Utils$iso8601ToSimpleDate(strDate);
				var date_ = A2(
					$elm$core$Maybe$map,
					function (justDate) {
						return _Utils_update(
							justDate,
							{eb: start});
					},
					model.cO);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cO: date_}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 8:
				var strDate = msg.a;
				var end = $author$project$Utils$iso8601ToSimpleDate(strDate);
				var date_ = A2(
					$elm$core$Maybe$map,
					function (justDate) {
						return _Utils_update(
							justDate,
							{dH: end});
					},
					model.cO);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cO: date_}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 6:
				var str = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{em: str}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 9:
				return A3($author$project$Pages$Admin$SessionWithoutPouchReport$updateFilter, shared, user, model);
			case 2:
				var reports = msg.a;
				var now = msg.b;
				var title = 'Sessões ' + (A2($author$project$Utils$formatDateTimeFromPosix, shared.kS, now) + '.csv');
				var allClasses = $elm$core$List$sort(
					$elm$core$Set$toList(
						$elm$core$Set$fromList(
							$elm$core$List$concat(
								A2(
									$elm$core$List$map,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.dv;
										},
										$elm$core$List$map(
											function ($) {
												return $.c3;
											})),
									reports)))));
				var headers = _Utils_ap(
					_List_fromArray(
						['Veículo', 'Linha', 'Abertura/Fechamento', 'Operadores']),
					_Utils_ap(
						allClasses,
						_List_fromArray(
							['Total', 'Catraca Inicial', 'Final'])));
				var records = A2(
					$elm$core$List$map,
					function (row) {
						var classCells = A2(
							$elm$core$List$map,
							function (_class) {
								return $elm$core$String$fromInt(_class.di);
							},
							A2(
								$elm$core$List$sortBy,
								function ($) {
									return $.c3;
								},
								A3(
									$elm$core$List$foldl,
									F2(
										function (className, acc) {
											return function (v) {
												return A2($elm$core$List$cons, v, acc);
											}(
												A2(
													$elm$core$Maybe$withDefault,
													{c3: className, di: 0},
													$elm$core$List$head(
														A2(
															$elm$core$List$filter,
															A2(
																$elm$core$Basics$composeR,
																function ($) {
																	return $.c3;
																},
																$elm$core$Basics$eq(className)),
															row.dv))));
										}),
									_List_Nil,
									allClasses)));
						return _Utils_ap(
							_List_fromArray(
								[
									A2(
									$elm$core$Maybe$withDefault,
									'',
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.l4;
										},
										row.k2)),
									$author$project$Utils$emptyStrDefault(row.e1),
									A2($author$project$Utils$formatDateTimeFromMaybePosix, shared.kS, row.jJ) + ('  -  ' + A2($author$project$Utils$formatDateTimeFromMaybePosix, shared.kS, row.iq)),
									_Utils_ap(
									$author$project$Utils$emptyStrDefault(row.fb),
									function () {
										var _v2 = _Utils_Tuple2(row.fb, row.jN);
										if (_v2.b === '') {
											return ' | -';
										} else {
											var str = _v2.a;
											var str2 = _v2.b;
											return (!_Utils_eq(str, str2)) ? (' | ' + str2) : '';
										}
									}())
								]),
							_Utils_ap(
								classCells,
								_List_fromArray(
									[
										$elm$core$String$fromInt(row.im),
										$elm$core$String$fromInt(row.i_),
										$elm$core$String$fromInt(row.iZ)
									])));
					},
					reports);
				return _Utils_Tuple3(
					model,
					A3($author$project$Components$GeneratorCSV$download, records, headers, title),
					$author$project$Shared$NoOp);
			default:
				var reports = msg.a;
				return _Utils_Tuple3(
					model,
					A2(
						$elm$core$Task$perform,
						$author$project$Pages$Admin$SessionWithoutPouchReport$GenerateCsvDownloadWithTime(reports),
						$elm$time$Time$now),
					$author$project$Shared$NoOp);
		}
	});
var $author$project$Pages$Admin$SessionsReport$GenerateCsvDownloadWithTime = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Pages$Admin$SessionsReport$ReceivedReport = function (a) {
	return {$: 1, a: a};
};
var $author$project$Services$Concessionaire$sessionsReport = function (options) {
	var decoder = A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'vehicle',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Services$Concessionaire$vehicleDecoder),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'gateEnd',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'gateStart',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'classesTotal',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'classes',
						A2(
							$elm$json$Json$Decode$map,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Dict$toList,
								$elm$core$List$map(
									function (_v0) {
										var name = _v0.a;
										var value = _v0.b;
										return {c3: name, di: value};
									})),
							$elm$json$Json$Decode$dict($elm$json$Json$Decode$int)),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'operatorOpen',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'operatorClosed',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'close',
									$author$project$Utils$decodeNullableIso8601ToPosix,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'open',
										$author$project$Utils$decodeNullableIso8601ToPosix,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'line',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$Services$Concessionaire$SessionsReportRow)))))))))));
	return $elm$http$Http$request(
		{
			lG: $elm$http$Http$emptyBody,
			m9: A2(
				$author$project$Services$Api$expectJson,
				options.ow,
				$elm$json$Json$Decode$list(decoder)),
			nG: _List_fromArray(
				[
					$author$project$Services$Api$authorizationHeader(options.kU)
				]),
			of: 'GET',
			p5: $elm$core$Maybe$Nothing,
			qi: $elm$core$Maybe$Nothing,
			qt: A2(
				$author$project$Constants$cashierServiceUrl,
				_List_fromArray(
					['api', 'v1', 'cashier', 'report', 'sessions']),
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$map,
							$elm$url$Url$Builder$string('concessionaireId'),
							options.mc),
							$elm$core$Maybe$Just(
							A2(
								$elm$url$Url$Builder$string,
								'startDate',
								$author$project$Utils$iso8601ToSimpleDate(options.no.eb))),
							$elm$core$Maybe$Just(
							A2(
								$elm$url$Url$Builder$string,
								'endDate',
								$author$project$Utils$iso8601ToSimpleDate(options.no.dH))),
							$elm$core$String$isEmpty(options.nq) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
							A2($elm$url$Url$Builder$string, 'operator', options.nq)),
							$elm$core$String$isEmpty(options.np) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
							A2($elm$url$Url$Builder$string, 'line', options.np)),
							$elm$core$String$isEmpty(options.em) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
							A2($elm$url$Url$Builder$string, 'vehicle', options.em))
						])))
		});
};
var $author$project$Pages$Admin$SessionsReport$updateFilter = F3(
	function (shared, user, model) {
		var _v0 = model.cO;
		if (!_v0.$) {
			var date = _v0.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{ck: $krisajenkins$remotedata$RemoteData$Loading}),
				$author$project$Services$Concessionaire$sessionsReport(
					{
						mc: $author$project$Route$extractConcessionaireId(shared.pv),
						no: {dH: date.dH, eb: date.eb},
						np: model.fr,
						nq: model.fs,
						ow: $author$project$Pages$Admin$SessionsReport$ReceivedReport,
						kU: user.kU,
						em: model.em
					}),
				$author$project$Shared$NoOp);
		} else {
			return _Utils_Tuple3(
				model,
				$elm$core$Platform$Cmd$none,
				$author$project$Shared$ShowErrorDialog('Necessário informar date de início e fim'));
		}
	});
var $author$project$Pages$Admin$SessionsReport$update = F4(
	function (msg, model, shared, user) {
		switch (msg.$) {
			case 0:
				var now = msg.a;
				var today = A2($justinmimbs$date$Date$fromPosix, shared.kS, now);
				var startOfTheMonth = A2($author$project$Utils$startOfTheMonth, shared.kS, now);
				var endOfTheDay = A2($author$project$Utils$endOfTheDay, shared.kS, now);
				var dates = A2(
					$elm$core$List$cons,
					{
						dH: $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(endOfTheDay),
						eb: $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(
							A4($justinmimbs$time_extra$Time$Extra$add, 11, -1, shared.kS, endOfTheDay)),
						fD: 'Hoje'
					},
					A2(
						$elm$core$List$cons,
						{
							dH: $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(endOfTheDay),
							eb: $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(
								A4($justinmimbs$time_extra$Time$Extra$add, 11, -7, shared.kS, endOfTheDay)),
							fD: 'Últimos 7 dias'
						},
						$elm$core$List$reverse(
							A2(
								$elm$core$List$map,
								function (posix) {
									return {
										dH: $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(
											A4($justinmimbs$time_extra$Time$Extra$add, 2, 1, shared.kS, posix)),
										eb: $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(posix),
										fD: A2($author$project$Utils$formatMonthYearFromPosix, shared.kS, posix)
									};
								},
								A2(
									$elm$core$List$map,
									function (offsetMonth) {
										return A4($justinmimbs$time_extra$Time$Extra$add, 2, offsetMonth, shared.kS, startOfTheMonth);
									},
									A2($elm$core$List$range, -24, 0))))));
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							cO: $elm$core$Maybe$Just(
								{
									dH: $justinmimbs$date$Date$toIsoString(today),
									eb: $justinmimbs$date$Date$toIsoString(today)
								})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 1:
				var res = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ck: $krisajenkins$remotedata$RemoteData$fromResult(res)
						}),
					$elm$core$Platform$Cmd$none,
					function () {
						if (!res.$) {
							return $author$project$Shared$NoOp;
						} else {
							var error = res.a;
							return A2($author$project$Shared$updateApiError, shared, error);
						}
					}());
			case 3:
				var index = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{hw: index}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 4:
				var search = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{fs: search}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 5:
				var search = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{fr: search}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 7:
				var strDate = msg.a;
				var start = $author$project$Utils$iso8601ToSimpleDate(strDate);
				var date_ = A2(
					$elm$core$Maybe$map,
					function (justDate) {
						return _Utils_update(
							justDate,
							{eb: start});
					},
					model.cO);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cO: date_}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 8:
				var strDate = msg.a;
				var end = $author$project$Utils$iso8601ToSimpleDate(strDate);
				var date_ = A2(
					$elm$core$Maybe$map,
					function (justDate) {
						return _Utils_update(
							justDate,
							{dH: end});
					},
					model.cO);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cO: date_}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 6:
				var str = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{em: str}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 9:
				return A3($author$project$Pages$Admin$SessionsReport$updateFilter, shared, user, model);
			case 2:
				var reports = msg.a;
				var now = msg.b;
				var title = 'Sessões ' + (A2($author$project$Utils$formatDateTimeFromPosix, shared.kS, now) + '.csv');
				var allClasses = $elm$core$List$sort(
					$elm$core$Set$toList(
						$elm$core$Set$fromList(
							$elm$core$List$concat(
								A2(
									$elm$core$List$map,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.dv;
										},
										$elm$core$List$map(
											function ($) {
												return $.c3;
											})),
									reports)))));
				var headers = _Utils_ap(
					_List_fromArray(
						['Veículo', 'Linha', 'Abertura/Fechamento', 'Operadores']),
					_Utils_ap(
						allClasses,
						_List_fromArray(
							['Total', 'Catraca Inicial', 'Final'])));
				var records = A2(
					$elm$core$List$map,
					function (row) {
						var classCells = A2(
							$elm$core$List$map,
							function (_class) {
								return $elm$core$String$fromInt(_class.di);
							},
							A2(
								$elm$core$List$sortBy,
								function ($) {
									return $.c3;
								},
								A3(
									$elm$core$List$foldl,
									F2(
										function (className, acc) {
											return function (v) {
												return A2($elm$core$List$cons, v, acc);
											}(
												A2(
													$elm$core$Maybe$withDefault,
													{c3: className, di: 0},
													$elm$core$List$head(
														A2(
															$elm$core$List$filter,
															A2(
																$elm$core$Basics$composeR,
																function ($) {
																	return $.c3;
																},
																$elm$core$Basics$eq(className)),
															row.dv))));
										}),
									_List_Nil,
									allClasses)));
						return _Utils_ap(
							_List_fromArray(
								[
									A2(
									$elm$core$Maybe$withDefault,
									'',
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.l4;
										},
										row.k2)),
									$author$project$Utils$emptyStrDefault(row.e1),
									A2($author$project$Utils$formatDateTimeFromMaybePosix, shared.kS, row.jJ) + ('  -  ' + A2($author$project$Utils$formatDateTimeFromMaybePosix, shared.kS, row.iq)),
									_Utils_ap(
									$author$project$Utils$emptyStrDefault(row.fb),
									function () {
										var _v2 = _Utils_Tuple2(row.fb, row.jN);
										if (_v2.b === '') {
											return ' | -';
										} else {
											var str = _v2.a;
											var str2 = _v2.b;
											return (!_Utils_eq(str, str2)) ? (' | ' + str2) : '';
										}
									}())
								]),
							_Utils_ap(
								classCells,
								_List_fromArray(
									[
										$elm$core$String$fromInt(row.im),
										$elm$core$String$fromInt(row.i_),
										$elm$core$String$fromInt(row.iZ)
									])));
					},
					reports);
				return _Utils_Tuple3(
					model,
					A3($author$project$Components$GeneratorCSV$download, records, headers, title),
					$author$project$Shared$NoOp);
			default:
				var reports = msg.a;
				return _Utils_Tuple3(
					model,
					A2(
						$elm$core$Task$perform,
						$author$project$Pages$Admin$SessionsReport$GenerateCsvDownloadWithTime(reports),
						$elm$time$Time$now),
					$author$project$Shared$NoOp);
		}
	});
var $author$project$Pages$Admin$Users$AddUserForm = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$Users$AddUserInputCpf = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$Users$AddUserLoadingPermissions = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$Users$AddUserModal = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$Users$AddUserModal_GotAddProfiles = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Pages$Admin$Users$AddUserModal_GotAllPermissionsV2 = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Admin$Users$AddUserModal_ReceivedAddUser = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$Admin$Users$AddUserModal_ReceivedPermissions = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Admin$Users$EditUserForm = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$Users$EditUserLoadingUser = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$Users$EditUserModal = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Admin$Users$EditUserModal_GotAddProfiles = function (a) {
	return {$: 23, a: a};
};
var $author$project$Pages$Admin$Users$EditUserModal_GotAllProfiles = function (a) {
	return {$: 21, a: a};
};
var $author$project$Pages$Admin$Users$EditUserModal_GotUserProfiles = function (a) {
	return {$: 22, a: a};
};
var $author$project$Pages$Admin$Users$EditUserModal_ReceivedDeleteUser = function (a) {
	return {$: 35, a: a};
};
var $author$project$Pages$Admin$Users$EditUserModal_ReceivedEditUser = function (a) {
	return {$: 32, a: a};
};
var $author$project$Pages$Admin$Users$EditUserModal_ReceivedPermissions = function (a) {
	return {$: 20, a: a};
};
var $author$project$Pages$Admin$Users$NoOp = {$: 0};
var $author$project$Pages$Admin$Users$QRCodeModal = function (a) {
	return {$: 2, a: a};
};
var $author$project$Services$Concessionaire$CreatedUserModal = F4(
	function (name, id, userID, document) {
		return {iI: document, dM: id, c3: name, fL: userID};
	});
var $author$project$Services$Concessionaire$decoderCreatedUserModal = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'document',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'userId',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Services$Concessionaire$CreatedUserModal)))));
var $author$project$Services$Concessionaire$createUser = function (options) {
	return $elm$http$Http$request(
		{
			lG: $elm$http$Http$jsonBody(
				$elm$json$Json$Encode$object(
					$elm$core$List$concat(
						_List_fromArray(
							[
								_List_fromArray(
								[
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string(options.c3)),
									_Utils_Tuple2(
									'document',
									$elm$json$Json$Encode$string(options.iI)),
									_Utils_Tuple2(
									'email',
									$elm$json$Json$Encode$string(options.mX)),
									_Utils_Tuple2(
									'roles',
									A2($elm$json$Json$Encode$list, $author$project$Data$Permission$toJson, options.oU))
								]),
								function () {
								var _v0 = options.mb;
								if (_v0.$ === 1) {
									return _List_Nil;
								} else {
									var concessionaireId = _v0.a;
									return _List_fromArray(
										[
											_Utils_Tuple2(
											'concessionaireID',
											$elm$json$Json$Encode$string(concessionaireId))
										]);
								}
							}()
							])))),
			m9: A2($author$project$Services$Api$expectJson, options.ow, $author$project$Services$Concessionaire$decoderCreatedUserModal),
			nG: _List_fromArray(
				[
					$author$project$Services$Api$authorizationHeader(options.kU)
				]),
			of: 'POST',
			p5: $elm$core$Maybe$Nothing,
			qi: $elm$core$Maybe$Nothing,
			qt: A2(
				$author$project$Constants$concessionaireServiceUrl,
				_List_fromArray(
					['api', 'v1', 'system', 'users']),
				_List_Nil)
		});
};
var $author$project$Services$Concessionaire$deleteUser = function (options) {
	return $elm$http$Http$request(
		{
			lG: $elm$http$Http$emptyBody,
			m9: $author$project$Services$Api$expectWhatever(options.ow),
			nG: _List_fromArray(
				[
					$author$project$Services$Api$authorizationHeader(options.kU)
				]),
			of: 'DELETE',
			p5: $elm$core$Maybe$Nothing,
			qi: $elm$core$Maybe$Nothing,
			qt: A2(
				$author$project$Constants$concessionaireServiceUrl,
				_List_fromArray(
					['api', 'v1', 'system', 'users', options.qw]),
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$map,
							$elm$url$Url$Builder$string('concessionaireId'),
							options.mc)
						])))
		});
};
var $author$project$Services$Concessionaire$editUser = function (options) {
	return $elm$http$Http$request(
		{
			lG: $elm$http$Http$jsonBody(
				$elm$json$Json$Encode$object(
					$elm$core$List$concat(
						_List_fromArray(
							[
								_List_fromArray(
								[
									_Utils_Tuple2(
									'userId',
									$elm$json$Json$Encode$string(options.qw)),
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string(options.c3)),
									_Utils_Tuple2(
									'document',
									$elm$json$Json$Encode$string(options.iI)),
									_Utils_Tuple2(
									'email',
									$elm$json$Json$Encode$string(options.mX)),
									_Utils_Tuple2(
									'roles',
									A2($elm$json$Json$Encode$list, $author$project$Data$Permission$toJson, options.pt))
								]),
								function () {
								var _v0 = options.mc;
								if (_v0.$ === 1) {
									return _List_Nil;
								} else {
									var concessionaireId = _v0.a;
									return _List_fromArray(
										[
											_Utils_Tuple2(
											'concessionaireId',
											$elm$json$Json$Encode$string(concessionaireId))
										]);
								}
							}()
							])))),
			m9: $author$project$Services$Api$expectWhatever(options.ow),
			nG: _List_fromArray(
				[
					$author$project$Services$Api$authorizationHeader(options.kU)
				]),
			of: 'PUT',
			p5: $elm$core$Maybe$Nothing,
			qi: $elm$core$Maybe$Nothing,
			qt: A2(
				$author$project$Constants$concessionaireServiceUrl,
				_List_fromArray(
					['api', 'v1', 'system', 'users', options.qw]),
				_List_Nil)
		});
};
var $author$project$Services$Concessionaire$getAllPermissions = function (options) {
	var decoder = A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (label, value) {
				return {jl: label, di: value};
			}),
		A2($elm$json$Json$Decode$field, 'label', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'value', $author$project$Data$Permission$jsonDecoder));
	return $elm$http$Http$request(
		{
			lG: $elm$http$Http$emptyBody,
			m9: A2(
				$author$project$Services$Api$expectJson,
				options.ow,
				$elm$json$Json$Decode$list(decoder)),
			nG: _List_fromArray(
				[
					$author$project$Services$Api$authorizationHeader(options.kU)
				]),
			of: 'GET',
			p5: $elm$core$Maybe$Nothing,
			qi: $elm$core$Maybe$Nothing,
			qt: A2(
				$author$project$Constants$concessionaireServiceUrl,
				_List_fromArray(
					['api', 'v1', 'system', 'roles']),
				_List_Nil)
		});
};
var $author$project$Services$Models$Profile = F2(
	function (id, name) {
		return {dM: id, c3: name};
	});
var $author$project$Services$Concessionaire$decodeProfile = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'nome',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Services$Models$Profile)));
var $author$project$Services$Concessionaire$getAllProfiles = function (options) {
	return $elm$http$Http$request(
		{
			lG: $elm$http$Http$emptyBody,
			m9: A2(
				$author$project$Services$Api$expectJson,
				options.ow,
				$elm$json$Json$Decode$list($author$project$Services$Concessionaire$decodeProfile)),
			nG: _List_fromArray(
				[
					$author$project$Services$Api$authorizationHeader(options.kU)
				]),
			of: 'GET',
			p5: $elm$core$Maybe$Nothing,
			qi: $elm$core$Maybe$Nothing,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'profile']),
				_List_Nil)
		});
};
var $author$project$Services$Models$UserProfile = F2(
	function (profileID, userID) {
		return {o4: profileID, fL: userID};
	});
var $author$project$Services$Concessionaire$decodeUserProfile = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'userID',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'profileID',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Services$Models$UserProfile)));
var $author$project$Services$Concessionaire$getUserProfiles = function (options) {
	return $elm$http$Http$request(
		{
			lG: $elm$http$Http$emptyBody,
			m9: A2(
				$author$project$Services$Api$expectJson,
				options.ow,
				$elm$json$Json$Decode$list($author$project$Services$Concessionaire$decodeUserProfile)),
			nG: _List_fromArray(
				[
					$author$project$Services$Api$authorizationHeader(options.kU)
				]),
			of: 'GET',
			p5: $elm$core$Maybe$Nothing,
			qi: $elm$core$Maybe$Nothing,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'profile', 'user', options.fL]),
				_List_Nil)
		});
};
var $author$project$Pages$Admin$Users$isOperatorOrMaintenance = function (selectedPermissions) {
	return A2(
		$elm$core$List$any,
		function (permission) {
			return _Utils_eq(
				permission,
				$author$project$Data$Permission$Unknown('maintenance')) || _Utils_eq(
				permission,
				$author$project$Data$Permission$Unknown('operator'));
		},
		selectedPermissions);
};
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $author$project$Validate$Cpf$isValid = function (cpf) {
	var cpfInts = A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		A2(
			$elm$core$List$map,
			A2($elm$core$Basics$composeR, $elm$core$String$fromChar, $elm$core$String$toInt),
			$elm$core$String$toList(cpf)));
	var maybeDV1 = $elm$core$List$head(
		A2($elm$core$List$drop, 9, cpfInts));
	var maybeDV2 = $elm$core$List$head(
		A2($elm$core$List$drop, 10, cpfInts));
	var calcDV = function (cpfInts_) {
		return ((10 * $elm$core$List$sum(
			A3(
				$elm$core$List$map2,
				$elm$core$Basics$mul,
				cpfInts_,
				$elm$core$List$reverse(
					A2(
						$elm$core$List$range,
						2,
						$elm$core$List$length(cpfInts_) + 1))))) % 11) % 10;
	};
	var calcDV1 = calcDV(
		A2($elm$core$List$take, 9, cpfInts));
	var calcDV2 = calcDV(
		A2($elm$core$List$take, 10, cpfInts));
	return _Utils_eq(
		$elm$core$Maybe$Just(calcDV1),
		maybeDV1) && (_Utils_eq(
		$elm$core$Maybe$Just(calcDV2),
		maybeDV2) && (!A2(
		$elm$core$List$all,
		$elm$core$Basics$eq(calcDV1),
		cpfInts)));
};
var $author$project$Services$Concessionaire$setProfile = function (options) {
	var profilesIDs = A2(
		$elm$core$List$map,
		function ($) {
			return $.dM;
		},
		options.aq);
	return $elm$http$Http$request(
		{
			lG: $elm$http$Http$jsonBody(
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, profilesIDs)),
			m9: $author$project$Services$Api$expectWhatever(options.ow),
			nG: _List_fromArray(
				[
					$author$project$Services$Api$authorizationHeader(options.kU)
				]),
			of: 'PUT',
			p5: $elm$core$Maybe$Nothing,
			qi: $elm$core$Maybe$Nothing,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'profile', 'user', options.fL, 'profiles']),
				_List_Nil)
		});
};
var $author$project$Utils$tuple3 = F2(
	function (_v0, c) {
		var a = _v0.a;
		var b = _v0.b;
		return _Utils_Tuple3(a, b, c);
	});
var $author$project$Pages$Admin$Users$updateProfilesForCreate = F2(
	function (modal_, profile) {
		var permissionIsAlreadyInTheList = A2($elm$core$List$member, profile, modal_.C);
		var updatePermissions = permissionIsAlreadyInTheList ? A2(
			$elm$core$List$filter,
			$elm$core$Basics$neq(profile),
			modal_.C) : A2($elm$core$List$cons, profile, modal_.C);
		return _Utils_update(
			modal_,
			{C: updatePermissions});
	});
var $author$project$Pages$Admin$Users$updateProfilesForCreateAndRemove = F2(
	function (model, profile) {
		var selectedProfiles = A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, model.C);
		var removeFromList = F2(
			function (profile_, list) {
				return A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.dM;
						},
						$elm$core$Basics$neq(profile_.dM)),
					list);
			});
		var isSelected = A2(
			$elm$core$List$any,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.dM;
				},
				$elm$core$Basics$eq(profile.dM)),
			selectedProfiles);
		var newProfiles = isSelected ? A2(removeFromList, profile, selectedProfiles) : A2($elm$core$List$cons, profile, selectedProfiles);
		return _Utils_update(
			model,
			{
				C: $krisajenkins$remotedata$RemoteData$Success(newProfiles)
			});
	});
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {jc: index, n8: match, op: number, pV: submatches};
	});
var $elm$regex$Regex$contains = _Regex_contains;
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{lP: false, oj: false},
		string);
};
var $elm$regex$Regex$never = _Regex_never;
var $author$project$Utils$isValidEmail = $elm$regex$Regex$contains(
	A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('^[\\w\\._-]+@([\\w_-]+\\.)+[\\w_-]{2,4}$')));
var $author$project$Pages$Admin$Users$validateForm = function (model) {
	return (model.c3 !== '') ? ($author$project$Utils$isValidEmail(model.mX) ? $elm$core$Result$Ok(0) : $elm$core$Result$Err('Email inválido')) : $elm$core$Result$Err('Preencha o nome');
};
var $author$project$Pages$Admin$Users$update = F4(
	function (msg, model, shared, user) {
		var queries = model.T;
		var _v0 = _Utils_Tuple2(model.aY, msg);
		_v0$45:
		while (true) {
			switch (_v0.b.$) {
				case 0:
					var _v1 = _v0.b;
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
				case 1:
					var isRefresh = _v0.b.a;
					return isRefresh ? A2(
						$author$project$Utils$tuple3,
						A3($author$project$Pages$Admin$Users$init, model.T, shared, user),
						$author$project$Shared$NoOp) : _Utils_Tuple3(
						_Utils_update(
							model,
							{aY: $author$project$Pages$Admin$Users$NoModal}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				case 3:
					var newName = _v0.b.a;
					var updateQueries = _Utils_update(
						queries,
						{
							c3: $author$project$Components$Patterns$Forms$strMaybe(newName)
						});
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{T: updateQueries}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				case 4:
					var newDocument = _v0.b.a;
					var realValue = A2($elm$core$String$filter, $elm$core$Char$isDigit, newDocument);
					var updateQueries = _Utils_update(
						queries,
						{
							iI: $author$project$Components$Patterns$Forms$strMaybe(realValue)
						});
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{T: updateQueries}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				case 5:
					var newEmail = _v0.b.a;
					var updateQueries = _Utils_update(
						queries,
						{
							mX: $author$project$Components$Patterns$Forms$strMaybe(newEmail)
						});
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{T: updateQueries}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				case 2:
					if (!_v0.a.$) {
						var _v2 = _v0.a;
						var res = _v0.b.a;
						if (!res.$) {
							var users = res.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										ei: $krisajenkins$remotedata$RemoteData$Success(users)
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						} else {
							var error = res.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										ei: $krisajenkins$remotedata$RemoteData$Failure(error)
									}),
								$elm$core$Platform$Cmd$none,
								A2($author$project$Shared$updateApiError, shared, error));
						}
					} else {
						break _v0$45;
					}
				case 6:
					if (!_v0.a.$) {
						var _v4 = _v0.a;
						var _v5 = _v0.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $author$project$Pages$Admin$Users$AddUserModal(
										$author$project$Pages$Admin$Users$AddUserInputCpf(''))
								}),
							A2(
								$elm$core$Task$attempt,
								$elm$core$Basics$always($author$project$Pages$Admin$Users$NoOp),
								$elm$browser$Browser$Dom$focus('input-cpf')),
							$author$project$Shared$NoOp);
					} else {
						break _v0$45;
					}
				case 7:
					if ((_v0.a.$ === 1) && (!_v0.a.a.$)) {
						var value = _v0.b.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $author$project$Pages$Admin$Users$AddUserModal(
										$author$project$Pages$Admin$Users$AddUserInputCpf(value))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					} else {
						break _v0$45;
					}
				case 8:
					if ((_v0.a.$ === 1) && (_v0.a.a.$ === 2)) {
						var model_ = _v0.a.a.a;
						var _v6 = _v0.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $author$project$Pages$Admin$Users$AddUserModal(
										$author$project$Pages$Admin$Users$AddUserInputCpf(model_.aS))
								}),
							A2(
								$elm$core$Task$attempt,
								$elm$core$Basics$always($author$project$Pages$Admin$Users$NoOp),
								$elm$browser$Browser$Dom$focus('input-cpf')),
							$author$project$Shared$NoOp);
					} else {
						break _v0$45;
					}
				case 9:
					if ((_v0.a.$ === 1) && (!_v0.a.a.$)) {
						var cpf = _v0.a.a.a;
						var _v7 = _v0.b;
						return $author$project$Validate$Cpf$isValid(cpf) ? _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $author$project$Pages$Admin$Users$AddUserModal(
										$author$project$Pages$Admin$Users$AddUserLoadingPermissions(cpf))
								}),
							$author$project$Services$Concessionaire$getAllPermissions(
								{ow: $author$project$Pages$Admin$Users$AddUserModal_ReceivedPermissions, kU: user.kU}),
							$author$project$Shared$CloseDialog) : _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$ShowErrorDialog('CPF inválido'));
					} else {
						break _v0$45;
					}
				case 10:
					if ((_v0.a.$ === 1) && (_v0.a.a.$ === 1)) {
						var cpf = _v0.a.a.a;
						var res = _v0.b.a;
						if (!res.$) {
							var permissions = res.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $author$project$Pages$Admin$Users$AddUserModal(
											$author$project$Pages$Admin$Users$AddUserForm(
												{hV: $krisajenkins$remotedata$RemoteData$NotAsked, aS: cpf, mX: '', c3: '', oU: permissions, aq: _List_Nil, J: _List_Nil, C: _List_Nil}))
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2(
											$elm$core$Task$attempt,
											$elm$core$Basics$always($author$project$Pages$Admin$Users$NoOp),
											$elm$browser$Browser$Dom$focus('input-name')),
											$author$project$Services$Concessionaire$getAllProfiles(
											{ow: $author$project$Pages$Admin$Users$AddUserModal_GotAllPermissionsV2, kU: user.kU})
										])),
								$author$project$Shared$CloseDialog);
						} else {
							var error = res.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{aY: $author$project$Pages$Admin$Users$NoModal}),
								$elm$core$Platform$Cmd$none,
								A2($author$project$Shared$updateApiError, shared, error));
						}
					} else {
						break _v0$45;
					}
				case 11:
					if (!_v0.b.a.$) {
						if ((_v0.a.$ === 1) && (_v0.a.a.$ === 2)) {
							var modal_ = _v0.a.a.a;
							var permissionsV2 = _v0.b.a.a;
							var newModal = $author$project$Pages$Admin$Users$AddUserModal(
								$author$project$Pages$Admin$Users$AddUserForm(
									_Utils_update(
										modal_,
										{aq: permissionsV2})));
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{aY: newModal}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						} else {
							break _v0$45;
						}
					} else {
						var error = _v0.b.a.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							A2($author$project$Shared$updateApiError, shared, error));
					}
				case 12:
					if ((_v0.a.$ === 1) && (_v0.a.a.$ === 2)) {
						var model_ = _v0.a.a.a;
						var value = _v0.b.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $author$project$Pages$Admin$Users$AddUserModal(
										$author$project$Pages$Admin$Users$AddUserForm(
											_Utils_update(
												model_,
												{c3: value})))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					} else {
						break _v0$45;
					}
				case 13:
					if ((_v0.a.$ === 1) && (_v0.a.a.$ === 2)) {
						var model_ = _v0.a.a.a;
						var value = _v0.b.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $author$project$Pages$Admin$Users$AddUserModal(
										$author$project$Pages$Admin$Users$AddUserForm(
											_Utils_update(
												model_,
												{mX: value})))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					} else {
						break _v0$45;
					}
				case 14:
					if ((_v0.a.$ === 1) && (_v0.a.a.$ === 2)) {
						var model_ = _v0.a.a.a;
						var permission = _v0.b.a;
						var filteredPermissions = A2(
							$elm$core$List$filter,
							$elm$core$Basics$neq(permission),
							model_.J);
						var selectedPermissions = A2(
							$elm$core$Maybe$withDefault,
							A2($elm$core$List$cons, permission, filteredPermissions),
							A2(
								$elm$core$Maybe$map,
								$elm$core$Basics$always(filteredPermissions),
								$elm$core$List$head(
									A2(
										$elm$core$List$filter,
										$elm$core$Basics$eq(permission),
										model_.J))));
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $author$project$Pages$Admin$Users$AddUserModal(
										$author$project$Pages$Admin$Users$AddUserForm(
											_Utils_update(
												model_,
												{J: selectedPermissions})))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					} else {
						break _v0$45;
					}
				case 15:
					if ((_v0.a.$ === 1) && (_v0.a.a.$ === 2)) {
						var modal_ = _v0.a.a.a;
						var profile = _v0.b.a;
						var newModal = $author$project$Pages$Admin$Users$AddUserModal(
							$author$project$Pages$Admin$Users$AddUserForm(
								A2($author$project$Pages$Admin$Users$updateProfilesForCreate, modal_, profile)));
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{aY: newModal}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					} else {
						break _v0$45;
					}
				case 16:
					if ((_v0.a.$ === 1) && (_v0.a.a.$ === 2)) {
						var model_ = _v0.a.a.a;
						var _v9 = _v0.b;
						var _v10 = $author$project$Pages$Admin$Users$validateForm(model_);
						if (!_v10.$) {
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $author$project$Pages$Admin$Users$AddUserModal(
											$author$project$Pages$Admin$Users$AddUserForm(
												_Utils_update(
													model_,
													{hV: $krisajenkins$remotedata$RemoteData$Loading})))
									}),
								$author$project$Services$Concessionaire$createUser(
									{
										mb: $author$project$Route$extractConcessionaireId(shared.pv),
										iI: model_.aS,
										mX: model_.mX,
										c3: model_.c3,
										ow: $author$project$Pages$Admin$Users$AddUserModal_ReceivedAddUser,
										oU: model_.J,
										kU: user.kU
									}),
								$author$project$Shared$NoOp);
						} else {
							var error = _v10.a;
							return _Utils_Tuple3(
								model,
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$ShowErrorDialog(error));
						}
					} else {
						break _v0$45;
					}
				case 17:
					if (!_v0.b.a.$) {
						if ((_v0.a.$ === 1) && (_v0.a.a.$ === 2)) {
							var model_ = _v0.a.a.a;
							var userCreated = _v0.b.a.a;
							return _Utils_Tuple3(
								model,
								$author$project$Services$Concessionaire$setProfile(
									{
										ow: $author$project$Pages$Admin$Users$AddUserModal_GotAddProfiles(userCreated),
										aq: model_.C,
										kU: user.kU,
										fL: userCreated.fL
									}),
								$author$project$Shared$CloseDialog);
						} else {
							break _v0$45;
						}
					} else {
						var error = _v0.b.a.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							A2($author$project$Shared$updateApiError, shared, error));
					}
				case 18:
					if (!_v0.b.b.$) {
						if ((_v0.a.$ === 1) && (_v0.a.a.$ === 2)) {
							var model_ = _v0.a.a.a;
							var _v11 = _v0.b;
							var userCreated = _v11.a;
							var _v12 = $author$project$Pages$Admin$Users$isOperatorOrMaintenance(
								function ($) {
									return $.J;
								}(model_));
							if (!_v12) {
								return A2(
									$author$project$Utils$tuple3,
									A3($author$project$Pages$Admin$Users$init, model.T, shared, user),
									$author$project$Shared$ShowSuccessDialog('Usuário do sistema adicionado com sucesso!'));
							} else {
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $author$project$Pages$Admin$Users$QRCodeModal(
												{iI: userCreated.iI, dM: userCreated.dM, eW: true, c3: userCreated.c3, fD: 'Usuário criado com sucesso!'})
										}),
									$elm$core$Platform$Cmd$none,
									$author$project$Shared$NoOp);
							}
						} else {
							break _v0$45;
						}
					} else {
						var _v13 = _v0.b;
						var error = _v13.b.a;
						return A2(
							$author$project$Utils$tuple3,
							A3($author$project$Pages$Admin$Users$init, model.T, shared, user),
							A2($author$project$Shared$updateApiError, shared, error));
					}
				case 19:
					if (!_v0.a.$) {
						var _v14 = _v0.a;
						var user_ = _v0.b.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $author$project$Pages$Admin$Users$EditUserModal(
										$author$project$Pages$Admin$Users$EditUserLoadingUser(user_))
								}),
							$author$project$Services$Concessionaire$getAllPermissions(
								{ow: $author$project$Pages$Admin$Users$EditUserModal_ReceivedPermissions, kU: user.kU}),
							$author$project$Shared$NoOp);
					} else {
						break _v0$45;
					}
				case 20:
					if ((_v0.a.$ === 3) && (!_v0.a.a.$)) {
						var user_ = _v0.a.a.a;
						var res = _v0.b.a;
						if (!res.$) {
							var permissions = res.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $author$project$Pages$Admin$Users$EditUserModal(
											$author$project$Pages$Admin$Users$EditUserForm(
												{
													hV: $krisajenkins$remotedata$RemoteData$NotAsked,
													mc: user_.mc,
													dz: false,
													aS: user_.aS,
													mX: user_.mX,
													dM: user_.dM,
													c3: user_.c3,
													oU: permissions,
													aq: _List_Nil,
													J: A2(
														$elm$core$List$map,
														function ($) {
															return $.di;
														},
														user_.oU),
													C: $krisajenkins$remotedata$RemoteData$Loading
												}))
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2(
											$elm$core$Task$attempt,
											$elm$core$Basics$always($author$project$Pages$Admin$Users$NoOp),
											$elm$browser$Browser$Dom$focus('input-name')),
											$author$project$Services$Concessionaire$getAllProfiles(
											{ow: $author$project$Pages$Admin$Users$EditUserModal_GotAllProfiles, kU: user.kU})
										])),
								$author$project$Shared$NoOp);
						} else {
							var error = res.a;
							return A2(
								$author$project$Utils$tuple3,
								A3($author$project$Pages$Admin$Users$init, model.T, shared, user),
								A2($author$project$Shared$updateApiError, shared, error));
						}
					} else {
						break _v0$45;
					}
				case 21:
					if (!_v0.b.a.$) {
						if ((_v0.a.$ === 3) && (_v0.a.a.$ === 1)) {
							var modal_ = _v0.a.a.a;
							var profiles = _v0.b.a.a;
							var newModal = $author$project$Pages$Admin$Users$EditUserModal(
								$author$project$Pages$Admin$Users$EditUserForm(
									_Utils_update(
										modal_,
										{aq: profiles})));
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{aY: newModal}),
								$author$project$Services$Concessionaire$getUserProfiles(
									{ow: $author$project$Pages$Admin$Users$EditUserModal_GotUserProfiles, kU: user.kU, fL: modal_.dM}),
								$author$project$Shared$NoOp);
						} else {
							break _v0$45;
						}
					} else {
						var error = _v0.b.a.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							A2($author$project$Shared$updateApiError, shared, error));
					}
				case 22:
					if (!_v0.b.a.$) {
						if ((_v0.a.$ === 3) && (_v0.a.a.$ === 1)) {
							var modal_ = _v0.a.a.a;
							var profiles = _v0.b.a.a;
							var findProfiles = A2(
								$elm$core$List$filter,
								function (p) {
									return A2(
										$elm$core$List$any,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.o4;
											},
											$elm$core$Basics$eq(p.dM)),
										profiles);
								},
								modal_.aq);
							var newModal = $author$project$Pages$Admin$Users$EditUserModal(
								$author$project$Pages$Admin$Users$EditUserForm(
									_Utils_update(
										modal_,
										{
											C: $krisajenkins$remotedata$RemoteData$Success(findProfiles)
										})));
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{aY: newModal}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						} else {
							break _v0$45;
						}
					} else {
						var error = _v0.b.a.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							A2($author$project$Shared$updateApiError, shared, error));
					}
				case 23:
					if (!_v0.b.a.$) {
						if ((_v0.a.$ === 3) && (_v0.a.a.$ === 1)) {
							var modal_ = _v0.a.a.a;
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
						} else {
							break _v0$45;
						}
					} else {
						var error = _v0.b.a.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							A2($author$project$Shared$updateApiError, shared, error));
					}
				case 24:
					if (!_v0.b.a.$) {
						if ((_v0.a.$ === 3) && (_v0.a.a.$ === 1)) {
							var modal_ = _v0.a.a.a;
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
						} else {
							break _v0$45;
						}
					} else {
						var error = _v0.b.a.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							A2($author$project$Shared$updateApiError, shared, error));
					}
				case 25:
					if ((_v0.a.$ === 3) && (_v0.a.a.$ === 1)) {
						var model_ = _v0.a.a.a;
						var value = _v0.b.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $author$project$Pages$Admin$Users$EditUserModal(
										$author$project$Pages$Admin$Users$EditUserForm(
											_Utils_update(
												model_,
												{c3: value})))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					} else {
						break _v0$45;
					}
				case 26:
					if ((_v0.a.$ === 3) && (_v0.a.a.$ === 1)) {
						var model_ = _v0.a.a.a;
						var value = _v0.b.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $author$project$Pages$Admin$Users$EditUserModal(
										$author$project$Pages$Admin$Users$EditUserForm(
											_Utils_update(
												model_,
												{mX: value})))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					} else {
						break _v0$45;
					}
				case 27:
					if ((_v0.a.$ === 3) && (_v0.a.a.$ === 1)) {
						var model_ = _v0.a.a.a;
						var permission = _v0.b.a;
						var filteredPermissions = A2(
							$elm$core$List$filter,
							$elm$core$Basics$neq(permission),
							model_.J);
						var selectedPermissions = A2(
							$elm$core$Maybe$withDefault,
							A2($elm$core$List$cons, permission, filteredPermissions),
							A2(
								$elm$core$Maybe$map,
								$elm$core$Basics$always(filteredPermissions),
								$elm$core$List$head(
									A2(
										$elm$core$List$filter,
										$elm$core$Basics$eq(permission),
										model_.J))));
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $author$project$Pages$Admin$Users$EditUserModal(
										$author$project$Pages$Admin$Users$EditUserForm(
											_Utils_update(
												model_,
												{J: selectedPermissions})))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					} else {
						break _v0$45;
					}
				case 28:
					if ((_v0.a.$ === 3) && (_v0.a.a.$ === 1)) {
						var modal_ = _v0.a.a.a;
						var profile = _v0.b.a;
						var newModal = $author$project$Pages$Admin$Users$EditUserModal(
							$author$project$Pages$Admin$Users$EditUserForm(
								A2($author$project$Pages$Admin$Users$updateProfilesForCreateAndRemove, modal_, profile)));
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{aY: newModal}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					} else {
						break _v0$45;
					}
				case 29:
					if ((_v0.a.$ === 3) && (_v0.a.a.$ === 1)) {
						var model_ = _v0.a.a.a;
						var _v16 = _v0.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $author$project$Pages$Admin$Users$EditUserModal(
										$author$project$Pages$Admin$Users$EditUserForm(
											_Utils_update(
												model_,
												{dz: false})))
								}),
							A2(
								$elm$core$Task$attempt,
								$elm$core$Basics$always($author$project$Pages$Admin$Users$NoOp),
								$elm$browser$Browser$Dom$focus('input-name')),
							$author$project$Shared$NoOp);
					} else {
						break _v0$45;
					}
				case 30:
					if ((_v0.a.$ === 3) && (_v0.a.a.$ === 1)) {
						var model_ = _v0.a.a.a;
						var _v17 = _v0.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $author$project$Pages$Admin$Users$EditUserModal(
										$author$project$Pages$Admin$Users$EditUserForm(
											_Utils_update(
												model_,
												{dz: true})))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					} else {
						break _v0$45;
					}
				case 31:
					if ((_v0.a.$ === 3) && (_v0.a.a.$ === 1)) {
						var model_ = _v0.a.a.a;
						var _v18 = _v0.b;
						var _v19 = $author$project$Pages$Admin$Users$validateForm(model_);
						if (!_v19.$) {
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $author$project$Pages$Admin$Users$EditUserModal(
											$author$project$Pages$Admin$Users$EditUserForm(
												_Utils_update(
													model_,
													{hV: $krisajenkins$remotedata$RemoteData$Loading})))
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											$author$project$Services$Concessionaire$editUser(
											{mc: model_.mc, iI: model_.aS, mX: model_.mX, c3: model_.c3, ow: $author$project$Pages$Admin$Users$EditUserModal_ReceivedEditUser, pt: model_.J, kU: user.kU, qw: model_.dM}),
											$author$project$Services$Concessionaire$setProfile(
											{
												ow: $author$project$Pages$Admin$Users$EditUserModal_GotAddProfiles,
												aq: A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, model_.C),
												kU: user.kU,
												fL: model_.dM
											})
										])),
								$author$project$Shared$CloseDialog);
						} else {
							var error = _v19.a;
							return _Utils_Tuple3(
								model,
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$ShowErrorDialog(error));
						}
					} else {
						break _v0$45;
					}
				case 32:
					if ((_v0.a.$ === 3) && (_v0.a.a.$ === 1)) {
						var model_ = _v0.a.a.a;
						var res = _v0.b.a;
						if (!res.$) {
							return A2(
								$author$project$Utils$tuple3,
								A3($author$project$Pages$Admin$Users$init, model.T, shared, user),
								$author$project$Shared$ShowSuccessDialog('Usuário do sistema editado com sucesso!'));
						} else {
							var error = res.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $author$project$Pages$Admin$Users$EditUserModal(
											$author$project$Pages$Admin$Users$EditUserForm(
												_Utils_update(
													model_,
													{
														hV: $krisajenkins$remotedata$RemoteData$Failure(error)
													})))
									}),
								$elm$core$Platform$Cmd$none,
								A2($author$project$Shared$updateApiError, shared, error));
						}
					} else {
						break _v0$45;
					}
				case 33:
					if (!_v0.b.a.$) {
						if ((_v0.a.$ === 3) && (_v0.a.a.$ === 1)) {
							var model_ = _v0.a.a.a;
							return A2(
								$author$project$Utils$tuple3,
								A3($author$project$Pages$Admin$Users$init, model.T, shared, user),
								$author$project$Shared$ShowSuccessDialog('Permissões editadas com sucesso!'));
						} else {
							break _v0$45;
						}
					} else {
						var error = _v0.b.a.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							A2($author$project$Shared$updateApiError, shared, error));
					}
				case 34:
					if ((_v0.a.$ === 3) && (_v0.a.a.$ === 1)) {
						var model_ = _v0.a.a.a;
						var _v21 = _v0.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $author$project$Pages$Admin$Users$EditUserModal(
										$author$project$Pages$Admin$Users$EditUserForm(
											_Utils_update(
												model_,
												{hV: $krisajenkins$remotedata$RemoteData$Loading})))
								}),
							$author$project$Services$Concessionaire$deleteUser(
								{
									mc: $author$project$Data$User$extractConcessionaireId(user),
									ow: $author$project$Pages$Admin$Users$EditUserModal_ReceivedDeleteUser,
									kU: user.kU,
									qw: model_.dM
								}),
							$author$project$Shared$CloseDialog);
					} else {
						break _v0$45;
					}
				case 35:
					if ((_v0.a.$ === 3) && (_v0.a.a.$ === 1)) {
						var res = _v0.b.a;
						if (!res.$) {
							return A2(
								$author$project$Utils$tuple3,
								A3($author$project$Pages$Admin$Users$init, model.T, shared, user),
								$author$project$Shared$ShowSuccessDialog('Usuário do sistema excluído com sucesso!'));
						} else {
							var error = res.a;
							return A2(
								$author$project$Utils$tuple3,
								A3($author$project$Pages$Admin$Users$init, model.T, shared, user),
								A2($author$project$Shared$updateApiError, shared, error));
						}
					} else {
						break _v0$45;
					}
				default:
					if (!_v0.a.$) {
						var _v23 = _v0.a;
						var user_ = _v0.b.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $author$project$Pages$Admin$Users$QRCodeModal(
										{iI: user_.aS, dM: user_.dM, eW: false, c3: user_.c3, fD: 'QRCode do Operador'})
								}),
							$author$project$Services$Concessionaire$getAllPermissions(
								{ow: $author$project$Pages$Admin$Users$EditUserModal_ReceivedPermissions, kU: user.kU}),
							$author$project$Shared$NoOp);
					} else {
						break _v0$45;
					}
			}
		}
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
	});
var $author$project$Pages$Admin$Vehicles$GotAddEditVehicle = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Pages$Admin$Vehicles$GotCheckDevice = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Admin$Vehicles$GotFocusNode = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$Vehicles$InstallDeviceModal = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Pages$Admin$Vehicles$VehicleEditorModal = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Services$Api$isCode = F2(
	function (code, error) {
		switch (error.$) {
			case 3:
				return code === 401;
			case 4:
				return code === 404;
			case 5:
				var meta = error.a;
				return _Utils_eq(meta.cw, code);
			case 6:
				var meta = error.a;
				return _Utils_eq(meta.cw, code);
			case 7:
				return code === 200;
			default:
				return false;
		}
	});
var $author$project$Services$Concessionaire$checkDevice = function (options) {
	return A2(
		$elm$core$Task$onError,
		function (apiError) {
			return A2($author$project$Services$Api$isCode, 400, apiError) ? $elm$core$Task$succeed($elm$core$Maybe$Nothing) : $elm$core$Task$fail(apiError);
		},
		$author$project$Services$Api$getTask(
			{
				mz: A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Services$Concessionaire$vehicleDecoder),
				kU: $elm$core$Maybe$Just(options.kU),
				qt: A2(
					$author$project$Constants$concessionaireServiceUrl,
					_List_fromArray(
						['api', 'v1', 'concessionaires', options.mc, 'byDevice', 'vehicles', options.pE]),
					_List_Nil)
			}));
};
var $author$project$Services$Api$postTask = function (options) {
	return $elm$http$Http$task(
		{
			lG: options.lG,
			nG: function () {
				var _v0 = options.kU;
				if (_v0.$ === 1) {
					return _List_Nil;
				} else {
					var token = _v0.a;
					return _List_fromArray(
						[
							$author$project$Services$Api$authorizationHeader(token)
						]);
				}
			}(),
			of: 'POST',
			d6: options.d6,
			p5: $elm$core$Maybe$Nothing,
			qt: options.qt
		});
};
var $author$project$Services$Concessionaire$createVehicle = function (options) {
	return $author$project$Services$Api$postTask(
		{
			lG: $elm$http$Http$jsonBody(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'Code',
							$elm$json$Json$Encode$string(options.l4)),
							_Utils_Tuple2(
							'Plate',
							$elm$json$Json$Encode$string(options.ac))
						]))),
			d6: $author$project$Services$Api$whateverResolver,
			kU: $elm$core$Maybe$Just(options.kU),
			qt: A2(
				$author$project$Constants$concessionaireServiceUrl,
				_List_fromArray(
					['api', 'v1', 'concessionaires', options.mc, 'vehicles']),
				_List_Nil)
		});
};
var $author$project$Services$Api$patchTask = function (options) {
	return $elm$http$Http$task(
		{
			lG: options.lG,
			nG: function () {
				var _v0 = options.kU;
				if (_v0.$ === 1) {
					return _List_Nil;
				} else {
					var token = _v0.a;
					return _List_fromArray(
						[
							$author$project$Services$Api$authorizationHeader(token)
						]);
				}
			}(),
			of: 'PATCH',
			d6: options.d6,
			p5: $elm$core$Maybe$Nothing,
			qt: options.qt
		});
};
var $author$project$Services$Concessionaire$editVehicle = function (options) {
	return $author$project$Services$Api$patchTask(
		{
			lG: $elm$http$Http$jsonBody(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'Code',
							$elm$json$Json$Encode$string(options.l4)),
							_Utils_Tuple2(
							'Plate',
							$elm$json$Json$Encode$string(options.ac))
						]))),
			d6: $author$project$Services$Api$whateverResolver,
			kU: $elm$core$Maybe$Just(options.kU),
			qt: A2(
				$author$project$Constants$concessionaireServiceUrl,
				_List_fromArray(
					['api', 'v1', 'concessionaires', options.mc, 'vehicles', options.hM]),
				_List_Nil)
		});
};
var $author$project$Services$Concessionaire$installDevice = function (options) {
	return $author$project$Services$Api$postTask(
		{
			lG: $elm$http$Http$emptyBody,
			d6: $author$project$Services$Api$whateverResolver,
			kU: $elm$core$Maybe$Just(options.kU),
			qt: A2(
				$author$project$Constants$concessionaireServiceUrl,
				_List_fromArray(
					['api', 'v1', 'concessionaires', options.mc, 'vehicles', options.hM, 'devices', options.pE]),
				_List_Nil)
		});
};
var $author$project$Pages$Admin$Vehicles$setModal = F2(
	function (model, modal) {
		return _Utils_update(
			model,
			{
				aY: $elm$core$Maybe$Just(modal)
			});
	});
var $author$project$Pages$Admin$Vehicles$updateVehicleEditor = F2(
	function (model, fn) {
		var _v0 = model.aY;
		if ((!_v0.$) && (!_v0.a.$)) {
			var _v1 = _v0.a;
			var v = _v1.a;
			var m = _v1.b;
			return A2(
				$author$project$Pages$Admin$Vehicles$setModal,
				model,
				A2(
					$author$project$Pages$Admin$Vehicles$VehicleEditorModal,
					v,
					fn(m)));
		} else {
			return model;
		}
	});
var $author$project$Pages$Admin$Vehicles$update = F7(
	function (msg, model, shared, maybePage, maybeSearch, maybeActive, user) {
		switch (msg.$) {
			case 0:
				var res = msg.a;
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
			case 1:
				var res = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							en: $krisajenkins$remotedata$RemoteData$fromResult(res)
						}),
					$elm$core$Platform$Cmd$none,
					function () {
						if (!res.$) {
							return $author$project$Shared$NoOp;
						} else {
							var error = res.a;
							return A2($author$project$Shared$updateApiError, shared, error);
						}
					}());
			case 2:
				var search = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{fq: search}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 3:
				var maybeBoolStr = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{at: maybeBoolStr}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 4:
				return _Utils_Tuple3(
					model,
					A2(
						$author$project$Route$pushUrl,
						shared.nZ,
						A2(
							$author$project$Route$Admin,
							A3(
								$author$project$Route$Vehicles,
								$elm$core$Maybe$Nothing,
								$elm$core$String$isEmpty(model.fq) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(model.fq),
								model.at),
							$author$project$Route$extractConcessionaireId(shared.pv))),
					$author$project$Shared$NoOp);
			case 5:
				return _Utils_Tuple3(
					A2(
						$author$project$Pages$Admin$Vehicles$setModal,
						model,
						A2(
							$author$project$Pages$Admin$Vehicles$VehicleEditorModal,
							$elm$core$Maybe$Nothing,
							{l4: '', ac: '', q: $krisajenkins$remotedata$RemoteData$NotAsked})),
					A2(
						$elm$core$Task$attempt,
						$author$project$Pages$Admin$Vehicles$GotFocusNode,
						$elm$browser$Browser$Dom$focus('input-name')),
					$author$project$Shared$NoOp);
			case 6:
				var vehicle = msg.a;
				return _Utils_Tuple3(
					A2(
						$author$project$Pages$Admin$Vehicles$setModal,
						model,
						A2(
							$author$project$Pages$Admin$Vehicles$VehicleEditorModal,
							$elm$core$Maybe$Just(vehicle),
							{l4: vehicle.l4, ac: vehicle.ac, q: $krisajenkins$remotedata$RemoteData$NotAsked})),
					A2(
						$elm$core$Task$attempt,
						$author$project$Pages$Admin$Vehicles$GotFocusNode,
						$elm$browser$Browser$Dom$focus('input-name')),
					$author$project$Shared$NoOp);
			case 7:
				var vehicle = msg.a;
				return _Utils_Tuple3(
					A2(
						$author$project$Pages$Admin$Vehicles$setModal,
						model,
						A2(
							$author$project$Pages$Admin$Vehicles$InstallDeviceModal,
							vehicle,
							{cM: $krisajenkins$remotedata$RemoteData$NotAsked, pE: '', q: $krisajenkins$remotedata$RemoteData$NotAsked})),
					A2(
						$elm$core$Task$attempt,
						$author$project$Pages$Admin$Vehicles$GotFocusNode,
						$elm$browser$Browser$Dom$focus('input-name')),
					$author$project$Shared$NoOp);
			case 8:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aY: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 9:
				var str = msg.a;
				return _Utils_Tuple3(
					A2(
						$author$project$Pages$Admin$Vehicles$updateVehicleEditor,
						model,
						function (m) {
							return _Utils_update(
								m,
								{l4: str});
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 10:
				var str = msg.a;
				return _Utils_Tuple3(
					A2(
						$author$project$Pages$Admin$Vehicles$updateVehicleEditor,
						model,
						function (m) {
							return _Utils_update(
								m,
								{ac: str});
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 11:
				var str = msg.a;
				return _Utils_Tuple3(
					function () {
						var _v2 = model.aY;
						if ((!_v2.$) && (_v2.a.$ === 1)) {
							var _v3 = _v2.a;
							var v = _v3.a;
							var m = _v3.b;
							return A2(
								$author$project$Pages$Admin$Vehicles$setModal,
								model,
								A2(
									$author$project$Pages$Admin$Vehicles$InstallDeviceModal,
									v,
									_Utils_update(
										m,
										{pE: str, q: $krisajenkins$remotedata$RemoteData$NotAsked})));
						} else {
							return model;
						}
					}(),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 12:
				var _v4 = model.aY;
				if (!_v4.$) {
					if (!_v4.a.$) {
						if (_v4.a.a.$ === 1) {
							var _v5 = _v4.a;
							var _v6 = _v5.a;
							var modal = _v5.b;
							return _Utils_Tuple3(
								A2(
									$author$project$Pages$Admin$Vehicles$setModal,
									model,
									A2(
										$author$project$Pages$Admin$Vehicles$VehicleEditorModal,
										$elm$core$Maybe$Nothing,
										_Utils_update(
											modal,
											{q: $krisajenkins$remotedata$RemoteData$Loading}))),
								A2(
									$elm$core$Task$attempt,
									$author$project$Pages$Admin$Vehicles$GotAddEditVehicle('Veículo adicionado com sucesso!'),
									$author$project$Services$Concessionaire$createVehicle(
										{
											l4: modal.l4,
											mc: A2(
												$elm$core$Maybe$withDefault,
												'',
												$author$project$Route$extractConcessionaireId(shared.pv)),
											ac: modal.ac,
											kU: user.kU
										})),
								$author$project$Shared$NoOp);
						} else {
							var _v7 = _v4.a;
							var vehicle = _v7.a.a;
							var modal = _v7.b;
							return _Utils_Tuple3(
								A2(
									$author$project$Pages$Admin$Vehicles$setModal,
									model,
									A2(
										$author$project$Pages$Admin$Vehicles$VehicleEditorModal,
										$elm$core$Maybe$Just(vehicle),
										_Utils_update(
											modal,
											{q: $krisajenkins$remotedata$RemoteData$Loading}))),
								A2(
									$elm$core$Task$attempt,
									$author$project$Pages$Admin$Vehicles$GotAddEditVehicle('Veículo editado com sucesso!'),
									$author$project$Services$Concessionaire$editVehicle(
										{
											l4: modal.l4,
											mc: A2(
												$elm$core$Maybe$withDefault,
												'',
												$author$project$Route$extractConcessionaireId(shared.pv)),
											ac: modal.ac,
											kU: user.kU,
											hM: vehicle.dM
										})),
								$author$project$Shared$NoOp);
						}
					} else {
						var _v8 = _v4.a;
						var vehicle = _v8.a;
						var modal = _v8.b;
						var _v9 = modal.q;
						if (_v9.$ === 3) {
							return _Utils_Tuple3(
								A2(
									$author$project$Pages$Admin$Vehicles$setModal,
									model,
									A2(
										$author$project$Pages$Admin$Vehicles$InstallDeviceModal,
										vehicle,
										_Utils_update(
											modal,
											{cM: $krisajenkins$remotedata$RemoteData$Loading}))),
								A2(
									$elm$core$Task$attempt,
									$author$project$Pages$Admin$Vehicles$GotAddEditVehicle('Equipamento instalado com sucesso!'),
									$author$project$Services$Concessionaire$installDevice(
										{
											mc: A2(
												$elm$core$Maybe$withDefault,
												'',
												$author$project$Route$extractConcessionaireId(shared.pv)),
											pE: modal.pE,
											kU: user.kU,
											hM: vehicle.dM
										})),
								$author$project$Shared$NoOp);
						} else {
							return _Utils_Tuple3(
								A2(
									$author$project$Pages$Admin$Vehicles$setModal,
									model,
									A2(
										$author$project$Pages$Admin$Vehicles$InstallDeviceModal,
										vehicle,
										_Utils_update(
											modal,
											{q: $krisajenkins$remotedata$RemoteData$Loading}))),
								A2(
									$elm$core$Task$attempt,
									$author$project$Pages$Admin$Vehicles$GotCheckDevice,
									$author$project$Services$Concessionaire$checkDevice(
										{
											mc: A2(
												$elm$core$Maybe$withDefault,
												'',
												$author$project$Route$extractConcessionaireId(shared.pv)),
											pE: modal.pE,
											kU: user.kU
										})),
								$author$project$Shared$NoOp);
						}
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
				}
			case 13:
				if (!msg.b.$) {
					var successMessage = msg.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{aY: $elm$core$Maybe$Nothing}),
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$Admin$Vehicles$GotVehicles,
							$author$project$Services$Concessionaire$getVehicles(
								{
									at: maybeActive,
									mc: A2(
										$elm$core$Maybe$withDefault,
										'',
										$author$project$Route$extractConcessionaireId(shared.pv)),
									n$: $author$project$Pages$Admin$Vehicles$vehiclesPerPage,
									oq: (A2($elm$core$Maybe$withDefault, 1, maybePage) - 1) * $author$project$Pages$Admin$Vehicles$vehiclesPerPage,
									fq: maybeSearch,
									kU: user.kU
								})),
						$author$project$Shared$ShowSuccessDialog(successMessage));
				} else {
					var apiError = msg.b.a;
					return _Utils_Tuple3(
						function () {
							var _v10 = model.aY;
							if (!_v10.$) {
								if (!_v10.a.$) {
									var _v11 = _v10.a;
									var v = _v11.a;
									var modal = _v11.b;
									return A2(
										$author$project$Pages$Admin$Vehicles$setModal,
										model,
										A2(
											$author$project$Pages$Admin$Vehicles$VehicleEditorModal,
											v,
											_Utils_update(
												modal,
												{
													q: $krisajenkins$remotedata$RemoteData$Failure(apiError)
												})));
								} else {
									var _v12 = _v10.a;
									var vehicle = _v12.a;
									var modal = _v12.b;
									return A2(
										$author$project$Pages$Admin$Vehicles$setModal,
										model,
										A2(
											$author$project$Pages$Admin$Vehicles$InstallDeviceModal,
											vehicle,
											_Utils_update(
												modal,
												{
													cM: $krisajenkins$remotedata$RemoteData$Failure(apiError)
												})));
								}
							} else {
								return model;
							}
						}(),
						$elm$core$Platform$Cmd$none,
						A2($author$project$Shared$updateApiError, shared, apiError));
				}
			default:
				var res = msg.a;
				if (res.$ === 1) {
					var apiError = res.a;
					if (apiError.$ === 4) {
						var _v15 = model.aY;
						if ((!_v15.$) && (_v15.a.$ === 1)) {
							var _v16 = _v15.a;
							var vehicle = _v16.a;
							var modal = _v16.b;
							return _Utils_Tuple3(
								A2(
									$author$project$Pages$Admin$Vehicles$setModal,
									model,
									A2(
										$author$project$Pages$Admin$Vehicles$InstallDeviceModal,
										vehicle,
										_Utils_update(
											modal,
											{cM: $krisajenkins$remotedata$RemoteData$Loading}))),
								A2(
									$elm$core$Task$attempt,
									$author$project$Pages$Admin$Vehicles$GotAddEditVehicle('Equipamento instalado com sucesso!'),
									$author$project$Services$Concessionaire$installDevice(
										{
											mc: A2(
												$elm$core$Maybe$withDefault,
												'',
												$author$project$Route$extractConcessionaireId(shared.pv)),
											pE: modal.pE,
											kU: user.kU,
											hM: vehicle.dM
										})),
								$author$project$Shared$NoOp);
						} else {
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
						}
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
					}
				} else {
					return _Utils_Tuple3(
						function () {
							var _v17 = model.aY;
							if ((!_v17.$) && (_v17.a.$ === 1)) {
								var _v18 = _v17.a;
								var vehicle = _v18.a;
								var modal = _v18.b;
								return A2(
									$author$project$Pages$Admin$Vehicles$setModal,
									model,
									A2(
										$author$project$Pages$Admin$Vehicles$InstallDeviceModal,
										vehicle,
										_Utils_update(
											modal,
											{
												q: $krisajenkins$remotedata$RemoteData$fromResult(res)
											})));
							} else {
								return model;
							}
						}(),
						$elm$core$Platform$Cmd$none,
						function () {
							if (res.$ === 1) {
								var apiError = res.a;
								if (apiError.$ === 4) {
									return $author$project$Shared$NoOp;
								} else {
									return A2($author$project$Shared$updateApiError, shared, apiError);
								}
							} else {
								return $author$project$Shared$NoOp;
							}
						}());
				}
		}
	});
var $author$project$Pages$Admin$update = F5(
	function (msg, model, shared, maybeConcessionaireId, user) {
		var mapPage = F3(
			function (fnA, fnB, _v8) {
				var a = _v8.a;
				var b = _v8.b;
				var s = _v8.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bv: fnA(a)
						}),
					A2($elm$core$Platform$Cmd$map, fnB, b),
					s);
			});
		var _default = _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
		var _v0 = _Utils_Tuple2(msg, model.bv);
		_v0$15:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					var _v1 = _v0.a;
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$Logout);
				case 1:
					var id = _v0.a.a;
					var currentSubRoute = function () {
						var _v2 = shared.pv;
						if (_v2.$ === 19) {
							switch (_v2.a.$) {
								case 2:
									var _v3 = _v2.a;
									return A2($author$project$Route$Cards, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
								case 4:
									var _v4 = _v2.a;
									return A3($author$project$Route$Vehicles, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
								default:
									var subRoute = _v2.a;
									return subRoute;
							}
						} else {
							return $author$project$Route$Users($author$project$Services$Models$initQueriesUsers);
						}
					}();
					return _Utils_Tuple3(
						model,
						A2(
							$author$project$Route$pushUrl,
							shared.nZ,
							A2(
								$author$project$Route$Admin,
								currentSubRoute,
								$elm$core$String$isEmpty(id) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(id))),
						$author$project$Shared$NoOp);
				case 2:
					if (_v0.b.$ === 1) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						return $author$project$Services$Models$iHaveAccess(
							{
								gZ: user.hg,
								hf: $author$project$Services$Models$SYSTEM_USER(0),
								hQ: A3(
									mapPage,
									$author$project$Pages$Admin$UsersPage,
									$author$project$Pages$Admin$UsersMsg,
									A4($author$project$Pages$Admin$Users$update, msg_, model_, shared, user)),
								hR: _default
							});
					} else {
						break _v0$15;
					}
				case 3:
					if (_v0.b.$ === 2) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						return A3(
							mapPage,
							$author$project$Pages$Admin$EquipmentsPage,
							$author$project$Pages$Admin$EquipmentsMsg,
							A4($author$project$Pages$Admin$Equipments$update, msg_, model_, shared, user));
					} else {
						break _v0$15;
					}
				case 4:
					if (_v0.b.$ === 3) {
						var msg_ = _v0.a.a;
						var _v5 = _v0.b;
						var maybePage = _v5.a;
						var maybeSearch = _v5.b;
						var model_ = _v5.c;
						return A3(
							mapPage,
							A2($author$project$Pages$Admin$CardsPage, maybePage, maybeSearch),
							$author$project$Pages$Admin$CardsMsg,
							A6($author$project$Pages$Admin$Cards$update, msg_, model_, shared, maybePage, maybeSearch, user));
					} else {
						break _v0$15;
					}
				case 5:
					if (_v0.b.$ === 4) {
						var msg_ = _v0.a.a;
						var _v6 = _v0.b;
						var id = _v6.a;
						var model_ = _v6.b;
						return A3(
							mapPage,
							$author$project$Pages$Admin$CardExtractPage(id),
							$author$project$Pages$Admin$CardExtractMsg,
							A5($author$project$Pages$Admin$CardExtract$update, id, msg_, model_, shared, user));
					} else {
						break _v0$15;
					}
				case 6:
					if (_v0.b.$ === 5) {
						var msg_ = _v0.a.a;
						var _v7 = _v0.b;
						var maybePage = _v7.a;
						var maybeSearch = _v7.b;
						var maybeActive = _v7.c;
						var model_ = _v7.d;
						return A3(
							mapPage,
							A3($author$project$Pages$Admin$VehiclesPage, maybePage, maybeSearch, maybeActive),
							$author$project$Pages$Admin$VehiclesMsg,
							A7($author$project$Pages$Admin$Vehicles$update, msg_, model_, shared, maybePage, maybeSearch, maybeActive, user));
					} else {
						break _v0$15;
					}
				case 10:
					if (_v0.b.$ === 9) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						return A3(
							mapPage,
							$author$project$Pages$Admin$AccountabilityReportPage,
							$author$project$Pages$Admin$AccountabilityReportMsg,
							A4($author$project$Pages$Admin$AccountabilityReport$update, msg_, model_, shared, user));
					} else {
						break _v0$15;
					}
				case 7:
					if (_v0.b.$ === 6) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						return A3(
							mapPage,
							$author$project$Pages$Admin$PaymentGuidesPage,
							$author$project$Pages$Admin$PaymentGuidesMsg,
							A4($author$project$Pages$Admin$PaymentGuides$update, msg_, model_, shared, user));
					} else {
						break _v0$15;
					}
				case 8:
					if (_v0.b.$ === 7) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						return A3(
							mapPage,
							$author$project$Pages$Admin$PaymentBilletsPage,
							$author$project$Pages$Admin$PaymentBilletsMsg,
							A4($author$project$Pages$Admin$PaymentBillets$update, msg_, model_, shared, user));
					} else {
						break _v0$15;
					}
				case 9:
					if (_v0.b.$ === 8) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						return A3(
							mapPage,
							$author$project$Pages$Admin$CompanyOrdersPage,
							$author$project$Pages$Admin$CompanyOrdersMsg,
							A4($author$project$Pages$Admin$CompanyOrders$update, msg_, model_, shared, user));
					} else {
						break _v0$15;
					}
				case 11:
					if (_v0.b.$ === 10) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						return A3(
							mapPage,
							$author$project$Pages$Admin$SalesReportPage,
							$author$project$Pages$Admin$SalesReportMsg,
							A4($author$project$Pages$Admin$SalesReport$update, msg_, shared, user, model_));
					} else {
						break _v0$15;
					}
				case 14:
					if (_v0.b.$ === 13) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						return $author$project$Services$Models$iHaveAccess(
							{
								gZ: user.hg,
								hf: $author$project$Services$Models$REPORTS($author$project$Services$Models$Sales),
								hQ: A3(
									mapPage,
									$author$project$Pages$Admin$SalesReportV2Page,
									$author$project$Pages$Admin$SalesReportV2Msg,
									A4($author$project$Pages$Admin$Reports$Sales$update, msg_, model_, shared, user)),
								hR: _default
							});
					} else {
						break _v0$15;
					}
				case 12:
					if (_v0.b.$ === 11) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						return A3(
							mapPage,
							$author$project$Pages$Admin$SessionsReportPage,
							$author$project$Pages$Admin$SessionsReportMsg,
							A4($author$project$Pages$Admin$SessionsReport$update, msg_, model_, shared, user));
					} else {
						break _v0$15;
					}
				default:
					if (_v0.b.$ === 12) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						return $author$project$Services$Models$iHaveAccess(
							{
								gZ: user.hg,
								hf: $author$project$Services$Models$REPORTS($author$project$Services$Models$SessionsWithoutPouch),
								hQ: A3(
									mapPage,
									$author$project$Pages$Admin$SessionsWithoutPouchReportPage,
									$author$project$Pages$Admin$SessionsWithoutPouchReportMsg,
									A4($author$project$Pages$Admin$SessionWithoutPouchReport$update, msg_, model_, shared, user)),
								hR: _default
							});
					} else {
						break _v0$15;
					}
			}
		}
		return _default;
	});
var $author$project$Pages$ChangePassword$Invalid = 1;
var $author$project$Pages$ChangePassword$InvalidToken = 2;
var $author$project$Pages$ChangePassword$ReceivedSetNewPassowrd = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$ChangePassword$Sent = 1;
var $author$project$Services$Auth$setNewPasswordEncoder = function (data) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'password',
				$elm$json$Json$Encode$string(data.oN)),
				_Utils_Tuple2(
				'token',
				$elm$json$Json$Encode$string(data.kU))
			]));
};
var $author$project$Services$Auth$setNewPassword = F2(
	function (data, processRequest) {
		return $elm$http$Http$request(
			{
				lG: $elm$http$Http$jsonBody(
					$author$project$Services$Auth$setNewPasswordEncoder(data)),
				m9: $author$project$Services$Api$expectWhatever(processRequest),
				nG: _List_Nil,
				of: 'POST',
				p5: $elm$core$Maybe$Nothing,
				qi: $elm$core$Maybe$Nothing,
				qt: A2(
					$author$project$Constants$authServiceUrl,
					_List_fromArray(
						['api', 'v1', 'users', 'password-set']),
					_List_Nil)
			});
	});
var $author$project$Pages$ChangePassword$update = F3(
	function (msg, model, sharedModel) {
		switch (msg.$) {
			case 0:
				var newPassword = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bu: newPassword, bw: 2}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 1:
				var rNewPassword = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bw: 2, c8: rNewPassword}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{d0: !model.d0}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{d4: !model.d4}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 4:
				return _Utils_eq(model.bu, model.c8) ? _Utils_Tuple3(
					_Utils_update(
						model,
						{q: $krisajenkins$remotedata$RemoteData$Loading}),
					A2(
						$author$project$Services$Auth$setNewPassword,
						{oN: model.bu, kU: model.kU},
						$author$project$Pages$ChangePassword$ReceivedSetNewPassowrd),
					$author$project$Shared$CloseDialog) : _Utils_Tuple3(
					_Utils_update(
						model,
						{bw: 1}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			default:
				if (!msg.a.$) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ea: 1}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ea: 2}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$ShowErrorDialog(
							$author$project$Services$Api$errorToUserMessage(error)));
				}
		}
	});
var $author$project$Pages$Enterprise$Dashboard$AddCardModal = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Enterprise$Dashboard$AddedCard = function (a) {
	return {$: 29, a: a};
};
var $author$project$Pages$Enterprise$Dashboard$BankSlip = {$: 0};
var $author$project$Shared$Copy = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Enterprise$Dashboard$DeleteListModal = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Enterprise$Dashboard$DetailsCsv = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Enterprise$Dashboard$GotCreateListOrder = function (a) {
	return {$: 37, a: a};
};
var $author$project$Pages$Enterprise$Dashboard$GotCsv = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Enterprise$Dashboard$GotDeleteList = function (a) {
	return {$: 36, a: a};
};
var $author$project$Pages$Enterprise$Dashboard$GotOpenRefill = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$Enterprise$Dashboard$ImportCsv = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Enterprise$Dashboard$ImportModal = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Enterprise$Dashboard$ImportModalIdle = {$: 0};
var $author$project$Pages$Enterprise$Dashboard$ImportModalImporting = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Enterprise$Dashboard$ImportModalPicked = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Enterprise$Dashboard$ImportedCsv = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Enterprise$Dashboard$LoadEmployees = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Enterprise$Dashboard$OpenPaymentModal = {$: 12};
var $author$project$Pages$Enterprise$Dashboard$PayedWithBankSlip = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$Enterprise$Dashboard$PayedWithCreditCard = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$Enterprise$Dashboard$PayedWithPaymentGuide = function (a) {
	return {$: 21, a: a};
};
var $author$project$Pages$Enterprise$Dashboard$PayedWithPix = function (a) {
	return {$: 20, a: a};
};
var $author$project$Pages$Enterprise$Dashboard$PaymentModal = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Enterprise$Dashboard$PaymentModalCards = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Enterprise$Dashboard$PaymentModalLoading = {$: 0};
var $author$project$Pages$Enterprise$Dashboard$PaymentModalPayedCard = {$: 4};
var $author$project$Pages$Enterprise$Dashboard$PaymentModalPayedWithBankSlip = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Enterprise$Dashboard$PaymentModalPayedWithPaymentGuide = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Enterprise$Dashboard$PaymentModalPayedWithPix = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Enterprise$Dashboard$PaymentModalPaying = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Enterprise$Dashboard$PaymentModalSelectedMethod = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Pages$Enterprise$Dashboard$ReceivedCards = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Enterprise$Dashboard$SaveListModal = function (a) {
	return {$: 4, a: a};
};
var $author$project$Services$Models$CreditCardInfo = F4(
	function (providerCardId, customerId, id, lastFourDigits) {
		return {mq: customerId, dM: id, c1: lastFourDigits, o7: providerCardId};
	});
var $author$project$Utils$optionalMaybe = F2(
	function (name, decoder) {
		return A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			name,
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Services$Payments$creditCardDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'lastFourDigits',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		A3(
			$author$project$Utils$optionalMaybe,
			'customerId',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$Utils$optionalMaybe,
				'providerCardId',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Services$Models$CreditCardInfo)))));
var $author$project$Services$Payments$cardBrandToString = function (brand) {
	switch (brand) {
		case 0:
			return 'amex';
		case 1:
			return 'aura';
		case 2:
			return 'banese';
		case 3:
			return 'cabal';
		case 4:
			return 'diners';
		case 5:
			return 'discover';
		case 6:
			return 'elo';
		case 7:
			return 'fortbrasil';
		case 8:
			return 'grand_card';
		case 9:
			return 'hiper_card';
		case 10:
			return 'jcb';
		case 11:
			return 'mastercard';
		case 12:
			return 'personal_card';
		case 13:
			return 'sorocred';
		case 14:
			return 'valecard';
		default:
			return 'visa';
	}
};
var $author$project$Services$Payments$creditCardEncoder = function (card) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'number',
				$elm$json$Json$Encode$string(card.op)),
				_Utils_Tuple2(
				'brand',
				A2($elm$core$Basics$composeR, $author$project$Services$Payments$cardBrandToString, $elm$json$Json$Encode$string)(card.f_)),
				_Utils_Tuple2(
				'holderName',
				$elm$json$Json$Encode$string(card.nJ)),
				_Utils_Tuple2(
				'expMonth',
				$elm$json$Json$Encode$int(card.gn)),
				_Utils_Tuple2(
				'expYear',
				$elm$json$Json$Encode$int(card.go)),
				_Utils_Tuple2(
				'cvv',
				$elm$json$Json$Encode$string(card.bU)),
				_Utils_Tuple2(
				'brand',
				$elm$json$Json$Encode$string('Mastercard'))
			]));
};
var $author$project$Services$Company$addCreditCard = F3(
	function (_v0, card, processRequest) {
		var token = _v0.kU;
		return $elm$http$Http$request(
			{
				lG: $elm$http$Http$jsonBody(
					$author$project$Services$Payments$creditCardEncoder(card)),
				m9: A2($author$project$Services$Api$expectJson, processRequest, $author$project$Services$Payments$creditCardDecoder),
				nG: _List_fromArray(
					[
						A2($elm$http$Http$header, 'Content-Type', 'application/json'),
						$author$project$Services$Api$authorizationHeader(token)
					]),
				of: 'POST',
				p5: $elm$core$Maybe$Nothing,
				qi: $elm$core$Maybe$Nothing,
				qt: A2(
					$author$project$Constants$companyServiceUrl,
					_List_fromArray(
						['api', 'v1', 'card', 'add']),
					_List_Nil)
			});
	});
var $author$project$Services$Payments$canEmitPaymentGuide = function (token) {
	return $elm$http$Http$task(
		{
			lG: $elm$http$Http$emptyBody,
			nG: _List_fromArray(
				[
					$author$project$Services$Api$authorizationHeader(token)
				]),
			of: 'GET',
			d6: $author$project$Services$Api$jsonResolver(
				A2($elm$json$Json$Decode$field, 'paymentGuide', $elm$json$Json$Decode$bool)),
			p5: $elm$core$Maybe$Nothing,
			qt: A2(
				$author$project$Constants$companyServiceUrl,
				_List_fromArray(
					['api', 'v1', 'detail']),
				_List_Nil)
		});
};
var $author$project$Services$Payments$cardBrandFromNumber = F2(
	function (_v0, acc) {
		var regex = _v0.a;
		var brand = _v0.b;
		var cardNumber = acc.a;
		var value = acc.b;
		if (!value.$) {
			return acc;
		} else {
			return A2($elm$regex$Regex$contains, regex, cardNumber) ? _Utils_Tuple2(
				cardNumber,
				$elm$core$Maybe$Just(brand)) : _Utils_Tuple2(cardNumber, $elm$core$Maybe$Nothing);
		}
	});
var $author$project$Services$Payments$Amex = 0;
var $author$project$Services$Payments$Aura = 1;
var $author$project$Services$Payments$Banese = 2;
var $author$project$Services$Payments$Cabal = 3;
var $author$project$Services$Payments$Diners = 4;
var $author$project$Services$Payments$Discover = 5;
var $author$project$Services$Payments$Elo = 6;
var $author$project$Services$Payments$FortBrasil = 7;
var $author$project$Services$Payments$GrandCard = 8;
var $author$project$Services$Payments$HiperCard = 9;
var $author$project$Services$Payments$JCB = 10;
var $author$project$Services$Payments$Mastercard = 11;
var $author$project$Services$Payments$PersonalCard = 12;
var $author$project$Services$Payments$Sorocred = 13;
var $author$project$Services$Payments$Valecard = 14;
var $author$project$Services$Payments$Visa = 15;
var $author$project$Services$Payments$amexRegExp = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^3[47][0-9]{13}'));
var $author$project$Services$Payments$auraRegExp = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^507860'));
var $author$project$Services$Payments$baneseCardRegExp = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^636117'));
var $author$project$Services$Payments$cabalRegExp = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(60420[1-9]|6042[1-9][0-9]|6043[0-9]{2}|604400)'));
var $author$project$Services$Payments$dinersRegExp = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(36[0-8][0-9]{3}|369[0-8][0-9]{2}|3699[0-8][0-9]|36999[0-9])'));
var $author$project$Services$Payments$discoverRegExp = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^6(?:011|5[0-9]{2})[0-9]{12}'));
var $author$project$Services$Payments$eloRegExp = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^4011(78|79)|^43(1274|8935)|^45(1416|7393|763(1|2))|^504175|^627780|^63(6297|6368|6369)|(65003[5-9]|65004[0-9]|65005[01])|(65040[5-9]|6504[1-3][0-9])|(65048[5-9]|65049[0-9]|6505[0-2][0-9]|65053[0-8])|(65054[1-9]|6505[5-8][0-9]|65059[0-8])|(65070[0-9]|65071[0-8])|(65072[0-7])|(65090[1-9]|6509[1-6][0-9]|65097[0-8])|(65165[2-9]|6516[67][0-9])|(65500[0-9]|65501[0-9])|(65502[1-9]|6550[34][0-9]|65505[0-8])|^(506699|5067[0-6][0-9]|50677[0-8])|^(509[0-8][0-9]{2}|5099[0-8][0-9]|50999[0-9])|^65003[1-3]|^(65003[5-9]|65004\\d|65005[0-1])|^(65040[5-9]|6504[1-3]\\d)|^(65048[5-9]|65049\\d|6505[0-2]\\d|65053[0-8])|^(65054[1-9]|6505[5-8]\\d|65059[0-8])|^(65070\\d|65071[0-8])|^65072[0-7]|^(65090[1-9]|65091\\d|650920)|^(65165[2-9]|6516[6-7]\\d)|^(65500\\d|65501\\d)|^(65502[1-9]|6550[3-4]\\d|65505[0-8])'));
var $author$project$Services$Payments$fortBrasilRegExp = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^628167'));
var $author$project$Services$Payments$grandCardRegExp = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^605032'));
var $author$project$Services$Payments$hiperCardRegExp = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^606282|^637095|^637599|^637568'));
var $author$project$Services$Payments$jcbRegExp = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^(?:2131|1800|35\\d{3})\\d{11}'));
var $author$project$Services$Payments$masterCardRegExp = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$'));
var $author$project$Services$Payments$personalCardRegExp = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^636085'));
var $author$project$Services$Payments$soroCredRegExp = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^627892|^636414'));
var $author$project$Services$Payments$valeCardRegExp = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^606444|^606458|^606482'));
var $author$project$Services$Payments$visaRegExp = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^4[0-9]{12}(?:[0-9]{3})'));
var $author$project$Services$Payments$cardBrandValidations = _List_fromArray(
	[
		_Utils_Tuple2($author$project$Services$Payments$amexRegExp, 0),
		_Utils_Tuple2($author$project$Services$Payments$auraRegExp, 1),
		_Utils_Tuple2($author$project$Services$Payments$baneseCardRegExp, 2),
		_Utils_Tuple2($author$project$Services$Payments$cabalRegExp, 3),
		_Utils_Tuple2($author$project$Services$Payments$dinersRegExp, 4),
		_Utils_Tuple2($author$project$Services$Payments$discoverRegExp, 5),
		_Utils_Tuple2($author$project$Services$Payments$eloRegExp, 6),
		_Utils_Tuple2($author$project$Services$Payments$fortBrasilRegExp, 7),
		_Utils_Tuple2($author$project$Services$Payments$grandCardRegExp, 8),
		_Utils_Tuple2($author$project$Services$Payments$hiperCardRegExp, 9),
		_Utils_Tuple2($author$project$Services$Payments$jcbRegExp, 10),
		_Utils_Tuple2($author$project$Services$Payments$masterCardRegExp, 11),
		_Utils_Tuple2($author$project$Services$Payments$personalCardRegExp, 12),
		_Utils_Tuple2($author$project$Services$Payments$soroCredRegExp, 13),
		_Utils_Tuple2($author$project$Services$Payments$valeCardRegExp, 14),
		_Utils_Tuple2($author$project$Services$Payments$visaRegExp, 15)
	]);
var $author$project$Services$Payments$cardBrandFromCardNumber = function (cardNumber) {
	var _v0 = A3(
		$elm$core$List$foldl,
		$author$project$Services$Payments$cardBrandFromNumber,
		_Utils_Tuple2(cardNumber, $elm$core$Maybe$Nothing),
		$author$project$Services$Payments$cardBrandValidations);
	var maybeCardBrand = _v0.b;
	return maybeCardBrand;
};
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $author$project$Validate$Cnpj$isValid = function (cnpj) {
	var tamanho = 12;
	var tamanho_ = tamanho + 1;
	var cnpjInts = A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		A2(
			$elm$core$List$map,
			A2($elm$core$Basics$composeR, $elm$core$String$fromChar, $elm$core$String$toInt),
			$elm$core$String$toList(cnpj)));
	var digitos = A2($elm$core$List$drop, tamanho, cnpjInts);
	var numeros = A2($elm$core$List$take, tamanho, cnpjInts);
	var soma = A3(
		$elm$core$List$foldr,
		F2(
			function (i, _v1) {
				var tmpSoma = _v1.a;
				var tmpPos = _v1.b;
				var num = A2(
					$elm$core$Maybe$withDefault,
					0,
					A2(
						$elm$core$Array$get,
						tamanho - i,
						$elm$core$Array$fromList(numeros)));
				return _Utils_Tuple2(
					tmpSoma + (num * tmpPos),
					((tmpPos - 1) < 2) ? 9 : (tmpPos - 1));
			}),
		_Utils_Tuple2(0, tamanho - 7),
		A2($elm$core$List$range, 1, tamanho)).a;
	var resultado = ((soma % 11) < 2) ? 0 : (11 - (soma % 11));
	var numeros_ = A2($elm$core$List$take, tamanho_, cnpjInts);
	var soma_ = A3(
		$elm$core$List$foldr,
		F2(
			function (i, _v0) {
				var tmpSoma = _v0.a;
				var tmpPos = _v0.b;
				var num = A2(
					$elm$core$Maybe$withDefault,
					0,
					A2(
						$elm$core$Array$get,
						tamanho_ - i,
						$elm$core$Array$fromList(numeros_)));
				return _Utils_Tuple2(
					tmpSoma + (num * tmpPos),
					((tmpPos - 1) < 2) ? 9 : (tmpPos - 1));
			}),
		_Utils_Tuple2(0, tamanho_ - 7),
		A2($elm$core$List$range, 1, tamanho_)).a;
	var resultado_ = ((soma_ % 11) < 2) ? 0 : (11 - (soma_ % 11));
	return ($elm$core$List$length(cnpjInts) === 14) && (A2(
		$elm$core$List$all,
		$elm$core$Basics$neq(cnpjInts),
		A2(
			$elm$core$List$map,
			$elm$core$List$repeat(14),
			A2($elm$core$List$range, 0, 9))) && (_Utils_eq(
		$elm$core$Maybe$Just(resultado),
		$elm$core$List$head(digitos)) && _Utils_eq(
		$elm$core$Maybe$Just(resultado_),
		$elm$core$List$head(
			A2($elm$core$List$drop, 1, digitos)))));
};
var $author$project$Utils$parseExpirationDate = function (date) {
	var _v0 = A2(
		$elm$core$List$map,
		$elm$core$String$toInt,
		_List_fromArray(
			[
				A2($elm$core$String$dropRight, 2, date),
				A2($elm$core$String$dropLeft, 2, date)
			]));
	if ((((_v0.b && (!_v0.a.$)) && _v0.b.b) && (!_v0.b.a.$)) && (!_v0.b.b.b)) {
		var month = _v0.a.a;
		var _v1 = _v0.b;
		var year = _v1.a.a;
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(month, year));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$Enterprise$Dashboard$cardInputValidation = function (card) {
	var validateBrandAndExpiration = F2(
		function (cardNumber, expirationDate) {
			var _v0 = _Utils_Tuple2(
				$author$project$Services$Payments$cardBrandFromCardNumber(cardNumber),
				$author$project$Utils$parseExpirationDate(expirationDate));
			if (!_v0.a.$) {
				if (!_v0.b.$) {
					var brand = _v0.a.a;
					var _v1 = _v0.b.a;
					var month = _v1.a;
					var year = _v1.b;
					return $elm$core$Result$Ok(
						{f_: brand, gn: month, go: year});
				} else {
					var _v3 = _v0.b;
					return $elm$core$Result$Err('Validade inválida');
				}
			} else {
				var _v2 = _v0.a;
				return $elm$core$Result$Err('Bandeira não encontrada');
			}
		});
	var enterpriseNameValid = A2(
		$elm$core$Basics$composeR,
		$elm$core$String$split(' '),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$length,
			$elm$core$Basics$lt(1)));
	var isHolderNameValid = enterpriseNameValid(card.cT);
	var cardNumberValid = A2(
		$elm$core$Basics$composeR,
		$elm$core$String$length,
		$elm$core$Basics$eq(16));
	var isCardNumberValid = cardNumberValid(card.ia);
	var cardCvvValidSize = function (n) {
		return (n === 3) || (n === 4);
	};
	var cvvValid = A2($elm$core$Basics$composeR, $elm$core$String$length, cardCvvValidSize);
	var isSecurityCodeValid = cvvValid(card.bU);
	return A2(
		$elm$core$Maybe$withDefault,
		A2(validateBrandAndExpiration, card.ia, card.nb),
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $elm$core$Result$Err),
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					$elm$core$Tuple$first,
					_List_fromArray(
						[
							_Utils_Tuple2(!isCardNumberValid, 'Número do cartão inválido'),
							_Utils_Tuple2(!isHolderNameValid, 'Nome da empresa inválido'),
							_Utils_Tuple2(card.nb === '', 'Preencha a validade'),
							_Utils_Tuple2(!isSecurityCodeValid, 'CVV inválido'),
							_Utils_Tuple2(
							!$author$project$Validate$Cnpj$isValid(card.l3),
							'CNPJ inválido')
						])))));
};
var $author$project$Services$Company$encodeOrder = function (order) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'userID',
				$elm$json$Json$Encode$string(order.fL)),
				_Utils_Tuple2(
				'amount',
				$elm$json$Json$Encode$int(order.lo))
			]));
};
var $author$project$Services$Company$encodeCreateListOrder = function (options) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'classID',
				$elm$json$Json$Encode$string(options.lX)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(options.n4)),
				_Utils_Tuple2(
				'orderListUsers',
				A2($elm$json$Json$Encode$list, $author$project$Services$Company$encodeOrder, options.oI))
			]));
};
var $author$project$Services$Company$createListOrder = function (options) {
	return $author$project$Services$Api$postHttp(
		{
			lG: $elm$http$Http$jsonBody(
				$author$project$Services$Company$encodeCreateListOrder(
					{lX: options.lX, n4: options.n4, oI: options.oI})),
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'orderList']),
				_List_Nil)
		});
};
var $author$project$Pages$Enterprise$Dashboard$createThird = F3(
	function (a, b, c) {
		return _Utils_Tuple3(a, b, c);
	});
var $author$project$Services$Company$deleteListImport = function (options) {
	return $author$project$Services$Api$postHttp(
		{
			lG: $elm$http$Http$emptyBody,
			m9: $author$project$Services$Api$expectWhateverErrorString(
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$companyServiceUrl,
				_List_fromArray(
					['api', 'v1', 'refill', 'import', options.dM, 'cancel']),
				_List_Nil)
		});
};
var $author$project$Services$Company$BaseEmployees = F7(
	function (id, included, excluded, issTax, grossBalance, balance, sequence) {
		return {h2: balance, bY: excluded, i3: grossBalance, dM: id, an: included, nY: issTax, pC: sequence};
	});
var $author$project$Services$Company$Employee = F7(
	function (userId, name, phone, cpf, companyId, refillId, balance) {
		return {h2: balance, iu: companyId, aS: cpf, c3: name, jX: phone, pm: refillId, qw: userId};
	});
var $author$project$Services$Company$employeeDecoder = A8(
	$elm$json$Json$Decode$map7,
	$author$project$Services$Company$Employee,
	A2($elm$json$Json$Decode$field, 'userId', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$map,
				$elm$core$String$fromInt,
				A2($elm$json$Json$Decode$field, 'phone', $elm$json$Json$Decode$int)),
				$elm$json$Json$Decode$succeed('')
			])),
	A2($elm$json$Json$Decode$field, 'cpf', $elm$json$Json$Decode$string),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$field, 'company_id', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'companyId', $elm$json$Json$Decode$string)
			])),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$field, 'refill_id', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'refillId', $elm$json$Json$Decode$string)
			])),
	A2($elm$json$Json$Decode$field, 'balance', $elm$json$Json$Decode$int));
var $author$project$Services$Company$ExcludedEmployeeError = function (a) {
	return {$: 1, a: a};
};
var $author$project$Services$Company$ExcludedEmployeeSuccess = function (a) {
	return {$: 0, a: a};
};
var $author$project$Services$Company$excludedEmployeeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (xs) {
		_v0$2:
		while (true) {
			if (xs.b) {
				if (xs.b.b) {
					if ((xs.b.b.b && xs.b.b.b.b) && xs.b.b.b.b.b) {
						var name = xs.a;
						var _v1 = xs.b;
						var phone = _v1.a;
						var _v2 = _v1.b;
						var cpf = _v2.a;
						var _v3 = _v2.b;
						var balance = _v3.a;
						var _v4 = _v3.b;
						var error = _v4.a;
						return $elm$json$Json$Decode$succeed(
							$elm$core$Maybe$Just(
								$author$project$Services$Company$ExcludedEmployeeSuccess(
									{
										h2: A2(
											$elm$core$Maybe$withDefault,
											0,
											$elm$core$String$toInt(balance)),
										aS: cpf,
										m$: error,
										c3: name,
										jX: phone
									})));
					} else {
						break _v0$2;
					}
				} else {
					var error = xs.a;
					return $elm$json$Json$Decode$succeed(
						$elm$core$Maybe$Just(
							$author$project$Services$Company$ExcludedEmployeeError(error)));
				}
			} else {
				break _v0$2;
			}
		}
		return $elm$json$Json$Decode$fail('Invalid excluded format');
	},
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string));
var $author$project$Services$Company$baseEmployeesDecoder = A8(
	$elm$json$Json$Decode$map7,
	$author$project$Services$Company$BaseEmployees,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'included',
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					$elm$json$Json$Decode$list($author$project$Services$Company$employeeDecoder),
					$elm$json$Json$Decode$null(_List_Nil)
				]))),
	A2(
		$elm$json$Json$Decode$field,
		'excluded',
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					$elm$json$Json$Decode$null(_List_Nil),
					A2(
					$elm$json$Json$Decode$andThen,
					function (list) {
						return $elm$json$Json$Decode$succeed(
							A2($elm$core$List$filterMap, $elm$core$Basics$identity, list));
					},
					$elm$json$Json$Decode$list(
						$elm$json$Json$Decode$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$json$Json$Decode$andThen,
									function (_v0) {
										return $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing);
									},
									$elm$json$Json$Decode$null($elm$core$Maybe$Nothing)),
									$author$project$Services$Company$excludedEmployeeDecoder
								]))))
				]))),
	A2($elm$json$Json$Decode$field, 'issTax', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'grossBalance', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'balance', $elm$json$Json$Decode$int),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'sequence', $elm$json$Json$Decode$int)));
var $author$project$Services$Company$detailsPurchaseOrder = function (options) {
	return $author$project$Services$Api$getHttp(
		{
			m9: A2($author$project$Services$Api$expectJson, options.ow, $author$project$Services$Company$baseEmployeesDecoder),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$companyServiceUrl,
				_List_fromArray(
					['api', 'v1', 'refill', 'imported', options.d1, 'detail']),
				_List_Nil)
		});
};
var $elm$file$File$Select$file = F2(
	function (mimes, toMsg) {
		return A2(
			$elm$core$Task$perform,
			toMsg,
			_File_uploadOne(mimes));
	});
var $elm$http$Http$filePart = _Http_pair;
var $elm$http$Http$multipartBody = function (parts) {
	return A2(
		_Http_pair,
		'',
		_Http_toFormData(parts));
};
var $author$project$Services$Company$fillEmployees = F4(
	function (_v0, file, walletClassID, processRequest) {
		var token = _v0.kU;
		return $elm$http$Http$request(
			{
				lG: $elm$http$Http$multipartBody(
					_List_fromArray(
						[
							A2($elm$http$Http$filePart, 'file', file)
						])),
				m9: $author$project$Services$Api$expectWhateverErrorString(processRequest),
				nG: _List_fromArray(
					[
						$author$project$Services$Api$authorizationHeader(token)
					]),
				of: 'POST',
				p5: $elm$core$Maybe$Nothing,
				qi: $elm$core$Maybe$Nothing,
				qt: A2(
					$author$project$Constants$companyServiceUrl,
					_List_fromArray(
						['api', 'v1', 'refill', 'import']),
					_List_fromArray(
						[
							A2($elm$url$Url$Builder$string, 'walletClassID', walletClassID)
						]))
			});
	});
var $author$project$Services$Company$generateBankSlip = function (options) {
	return $elm$http$Http$request(
		{
			lG: $elm$http$Http$emptyBody,
			m9: A2(
				$author$project$Services$Api$expectJson,
				options.ow,
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['boleto', 'url']),
					$elm$json$Json$Decode$string)),
			nG: _List_fromArray(
				[
					$author$project$Services$Api$authorizationHeader(options.kU)
				]),
			of: 'GET',
			p5: $elm$core$Maybe$Nothing,
			qi: $elm$core$Maybe$Nothing,
			qt: A2(
				$author$project$Constants$companyServiceUrl,
				_List_fromArray(
					['api', 'v1', 'refill', 'charge', options.dk, 'boleto']),
				_List_Nil)
		});
};
var $author$project$Services$Company$Pix = F3(
	function (qrCode, qrCodeUrl, expiresAt) {
		return {nd: expiresAt, pc: qrCode, pd: qrCodeUrl};
	});
var $author$project$Services$Company$generatePix = function (options) {
	return $elm$http$Http$request(
		{
			lG: $elm$http$Http$emptyBody,
			m9: A2(
				$author$project$Services$Api$expectJson,
				options.ow,
				A2(
					$elm$json$Json$Decode$field,
					'pix',
					A4(
						$elm$json$Json$Decode$map3,
						$author$project$Services$Company$Pix,
						A2($elm$json$Json$Decode$field, 'qrCode', $elm$json$Json$Decode$string),
						A2($elm$json$Json$Decode$field, 'qrCodeURL', $elm$json$Json$Decode$string),
						A2($elm$json$Json$Decode$field, 'expiresAt', $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder)))),
			nG: _List_fromArray(
				[
					$author$project$Services$Api$authorizationHeader(options.kU)
				]),
			of: 'GET',
			p5: $elm$core$Maybe$Nothing,
			qi: $elm$core$Maybe$Nothing,
			qt: A2(
				$author$project$Constants$companyServiceUrl,
				_List_fromArray(
					['api', 'v1', 'refill', 'charge', options.dk, 'pix']),
				_List_Nil)
		});
};
var $author$project$Services$Payments$getAvailablePaymentMethods = function (token) {
	return $elm$http$Http$task(
		{
			lG: $elm$http$Http$emptyBody,
			nG: _List_fromArray(
				[
					$author$project$Services$Api$authorizationHeader(token)
				]),
			of: 'GET',
			d6: $author$project$Services$Api$jsonResolver(
				$elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							$elm$json$Json$Decode$list($author$project$Services$Models$decoderPaymentMethod),
							$elm$json$Json$Decode$null(_List_Nil)
						]))),
			p5: $elm$core$Maybe$Nothing,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'concessionaire', 'config', 'providers']),
				_List_Nil)
		});
};
var $author$project$Services$Payments$getCardList = function (token) {
	return $elm$http$Http$task(
		{
			lG: $elm$http$Http$emptyBody,
			nG: _List_fromArray(
				[
					$author$project$Services$Api$authorizationHeader(token)
				]),
			of: 'GET',
			d6: $author$project$Services$Api$jsonResolver(
				$elm$json$Json$Decode$list($author$project$Services$Payments$creditCardDecoder)),
			p5: $elm$core$Maybe$Nothing,
			qt: A2(
				$author$project$Constants$paymentsServiceUrl,
				_List_fromArray(
					['api', 'v1', 'cards']),
				_List_Nil)
		});
};
var $author$project$Pages$Enterprise$Dashboard$GotListImport = function (a) {
	return {$: 2, a: a};
};
var $author$project$Services$Company$Import = F8(
	function (id, createdAt, createdBy, totalCards, value, fileName, status, walletClassName) {
		return {ix: createdAt, mj: createdBy, nk: fileName, dM: id, kK: status, qe: totalCards, di: value, qJ: walletClassName};
	});
var $author$project$Services$Company$decodeImport = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'walletClassName',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'status',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'fileName',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'value',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'totalCards',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'createdBy',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'createdAt',
							$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'id',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Services$Company$Import)))))))));
var $author$project$Services$Company$getListImport = function (options) {
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$elm$json$Json$Decode$list($author$project$Services$Company$decodeImport)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$companyServiceUrl,
				_List_fromArray(
					['api', 'v1', 'refill', 'import', 'list']),
				_List_Nil)
		});
};
var $author$project$Pages$Enterprise$Dashboard$getImports = function (token) {
	return $author$project$Services$Company$getListImport(
		{ow: $author$project$Pages$Enterprise$Dashboard$GotListImport, kU: token});
};
var $author$project$Services$Company$RefillEmployees = F7(
	function (id, employees, refillWalletClassID, balance, grossBalance, issTax, sequence) {
		return {h2: balance, d: employees, i3: grossBalance, dM: id, nY: issTax, po: refillWalletClassID, pC: sequence};
	});
var $author$project$Services$Api$expectJsonAnd404 = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			function (response) {
				switch (response.$) {
					case 0:
						var url = response.a;
						return $elm$core$Result$Err(
							$author$project$Services$Api$BadUrl(url));
					case 1:
						return $elm$core$Result$Err($author$project$Services$Api$Timeout);
					case 2:
						return $elm$core$Result$Err($author$project$Services$Api$NetworkError);
					case 3:
						var metadata = response.a;
						var body = response.b;
						var _v1 = metadata.cw;
						switch (_v1) {
							case 401:
								return $elm$core$Result$Err($author$project$Services$Api$Unauthorized);
							case 404:
								return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
							default:
								var _v2 = A2(
									$elm$json$Json$Decode$decodeString,
									A2($elm$json$Json$Decode$field, 'errorMessage', $elm$json$Json$Decode$string),
									body);
								if (!_v2.$) {
									var errorMessage = _v2.a;
									return $elm$core$Result$Err(
										A2($author$project$Services$Api$ServerError, metadata, errorMessage));
								} else {
									var decodeError = _v2.a;
									return $elm$core$Result$Err(
										A2($author$project$Services$Api$ServerErrorDecodeError, metadata, decodeError));
								}
						}
					default:
						var metadata = response.a;
						var body = response.b;
						return A3(
							$author$project$Services$Api$decodeMetaDataAndBody,
							$elm$json$Json$Decode$maybe(decoder),
							metadata,
							body);
				}
			});
	});
var $author$project$Services$Company$getOpenEmployees = function (options) {
	var decoder = A8(
		$elm$json$Json$Decode$map7,
		$author$project$Services$Company$RefillEmployees,
		A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
		A2(
			$elm$json$Json$Decode$field,
			'employees',
			$elm$json$Json$Decode$list($author$project$Services$Company$employeeDecoder)),
		A2($elm$json$Json$Decode$field, 'refillWalletClassID', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'balance', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'grossBalance', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'issTax', $elm$json$Json$Decode$int),
		$elm$json$Json$Decode$maybe(
			A2($elm$json$Json$Decode$field, 'sequence', $elm$json$Json$Decode$int)));
	return $elm$http$Http$request(
		{
			lG: $elm$http$Http$emptyBody,
			m9: A2($author$project$Services$Api$expectJsonAnd404, options.ow, decoder),
			nG: _List_fromArray(
				[
					$author$project$Services$Api$authorizationHeader(options.kU)
				]),
			of: 'GET',
			p5: $elm$core$Maybe$Nothing,
			qi: $elm$core$Maybe$Nothing,
			qt: A2(
				$author$project$Constants$companyServiceUrl,
				_List_fromArray(
					['api', 'v1', 'refill', 'open']),
				_List_Nil)
		});
};
var $author$project$Services$Company$getPaymentGuide = F2(
	function (token, id) {
		return $elm$http$Http$task(
			{
				lG: $elm$http$Http$emptyBody,
				nG: _List_fromArray(
					[
						$author$project$Services$Api$authorizationHeader(token)
					]),
				of: 'GET',
				d6: $author$project$Services$Api$jsonResolver(
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['boleto', 'url']),
						$elm$json$Json$Decode$string)),
				p5: $elm$core$Maybe$Nothing,
				qt: A2(
					$author$project$Constants$companyServiceUrl,
					_List_fromArray(
						['api', 'v1', 'refill', 'charge', id, 'guia']),
					_List_Nil)
			});
	});
var $author$project$Pages$Enterprise$Dashboard$initDeleteListModal = function (id) {
	return {dM: id, dP: false};
};
var $author$project$Pages$Enterprise$Dashboard$initSaveListModal = {c2: '', jr: false};
var $elm$core$Task$map3 = F4(
	function (func, taskA, taskB, taskC) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return A2(
							$elm$core$Task$andThen,
							function (c) {
								return $elm$core$Task$succeed(
									A3(func, a, b, c));
							},
							taskC);
					},
					taskB);
			},
			taskA);
	});
var $author$project$Pages$Enterprise$Dashboard$orderToList = function (included) {
	return A2(
		$elm$core$List$map,
		function (i) {
			return {lo: i.h2, fL: i.qw};
		},
		included);
};
var $author$project$Services$Company$payWithCreditCard = function (options) {
	return $elm$http$Http$request(
		{
			lG: $elm$http$Http$jsonBody(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'cardID',
							$elm$json$Json$Encode$string(options.lM))
						]))),
			m9: $author$project$Services$Api$expectWhatever(options.ow),
			nG: _List_fromArray(
				[
					$author$project$Services$Api$authorizationHeader(options.kU)
				]),
			of: 'POST',
			p5: $elm$core$Maybe$Nothing,
			qi: $elm$core$Maybe$Nothing,
			qt: A2(
				$author$project$Constants$companyServiceUrl,
				_List_fromArray(
					['api', 'v1', 'refill', 'charge', options.dk, 'credcard']),
				_List_Nil)
		});
};
var $author$project$Services$Payments$postOpenRefill = F2(
	function (refillID, token) {
		return $elm$http$Http$task(
			{
				lG: $elm$http$Http$emptyBody,
				nG: _List_fromArray(
					[
						$author$project$Services$Api$authorizationHeader(token)
					]),
				of: 'POST',
				d6: $author$project$Services$Api$whateverResolver,
				p5: $elm$core$Maybe$Nothing,
				qt: A2(
					$author$project$Constants$companyServiceUrl,
					_List_fromArray(
						['api', 'v1', 'refill', 'import', refillID, 'open']),
					_List_Nil)
			});
	});
var $author$project$Pages$Enterprise$Dashboard$sumTotalValue = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.d;
	},
	function ($) {
		return $.h2;
	});
var $elm$file$File$toString = _File_toString;
var $author$project$Pages$Enterprise$Dashboard$update = F4(
	function (msg, model, shared, user) {
		update:
		while (true) {
			var _v0 = _Utils_Tuple2(model.aY, msg);
			_v0$42:
			while (true) {
				switch (_v0.b.$) {
					case 0:
						var route = _v0.b.a;
						return _Utils_Tuple3(
							model,
							A2($author$project$Route$pushUrl, shared.nZ, route),
							$author$project$Shared$NoOp);
					case 1:
						if (!_v0.a.$) {
							var _v1 = _v0.a;
							var res = _v0.b.a;
							if (!res.$) {
								if (!res.a.$) {
									var data = res.a.a;
									var findConcessionaire = $elm$core$List$head(
										A2(
											$elm$core$List$filter,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.dM;
												},
												$elm$core$Basics$eq(data.po)),
											model.cL));
									var _v3 = model;
									var employees = _v3.d;
									return _Utils_Tuple3(
										_Utils_update(
											model,
											{
												d: _Utils_update(
													employees,
													{h2: data.h2, i3: data.i3, dM: data.dM, an: data.d, nY: data.nY, pC: data.pC}),
												dP: false,
												ab: findConcessionaire
											}),
										$elm$core$Platform$Cmd$none,
										$author$project$Shared$NoOp);
								} else {
									var _v4 = res.a;
									return _Utils_Tuple3(
										_Utils_update(
											model,
											{dP: false}),
										$elm$core$Platform$Cmd$none,
										$author$project$Shared$NoOp);
								}
							} else {
								var error = res.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{dP: false}),
									$elm$core$Platform$Cmd$none,
									A2($author$project$Shared$updateApiError, shared, error));
							}
						} else {
							break _v0$42;
						}
					case 2:
						var rd = _v0.b.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{eP: rd, dP: false}),
							$elm$core$Platform$Cmd$none,
							A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rd));
					case 3:
						var _v5 = _v0.b;
						var routeDefault = A2(
							$author$project$Route$pushUrl,
							shared.nZ,
							A2($author$project$Route$EnterpriseDashboard, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing));
						var clearEmployees = {h2: 0, bY: _List_Nil, i3: 0, dM: '', an: _List_Nil, nY: 0, pC: $elm$core$Maybe$Nothing};
						var _v6 = model.aY;
						_v6$4:
						while (true) {
							if (_v6.$ === 3) {
								switch (_v6.a.$) {
									case 4:
										var _v7 = _v6.a;
										return _Utils_Tuple3(
											_Utils_update(
												model,
												{d: clearEmployees, aY: $author$project$Pages$Enterprise$Dashboard$None}),
											routeDefault,
											$author$project$Shared$NoOp);
									case 5:
										return _Utils_Tuple3(
											_Utils_update(
												model,
												{d: clearEmployees, aY: $author$project$Pages$Enterprise$Dashboard$None}),
											routeDefault,
											$author$project$Shared$NoOp);
									case 6:
										return _Utils_Tuple3(
											_Utils_update(
												model,
												{d: clearEmployees, aY: $author$project$Pages$Enterprise$Dashboard$None}),
											routeDefault,
											$author$project$Shared$NoOp);
									case 7:
										return _Utils_Tuple3(
											_Utils_update(
												model,
												{d: clearEmployees, aY: $author$project$Pages$Enterprise$Dashboard$None}),
											routeDefault,
											$author$project$Shared$NoOp);
									default:
										break _v6$4;
								}
							} else {
								break _v6$4;
							}
						}
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{aY: $author$project$Pages$Enterprise$Dashboard$None}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					case 4:
						if (!_v0.a.$) {
							var _v8 = _v0.a;
							var _v9 = _v0.b;
							var _v10 = model.ab;
							if (!_v10.$) {
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $author$project$Pages$Enterprise$Dashboard$ImportModal($author$project$Pages$Enterprise$Dashboard$ImportModalIdle)
										}),
									$elm$core$Platform$Cmd$none,
									$author$project$Shared$NoOp);
							} else {
								return _Utils_Tuple3(
									model,
									$elm$core$Platform$Cmd$none,
									$author$project$Shared$ShowErrorDialog('Selecione uma classe para importar planilha'));
							}
						} else {
							break _v0$42;
						}
					case 5:
						if (_v0.a.$ === 1) {
							var _v11 = _v0.b;
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
						} else {
							break _v0$42;
						}
					case 6:
						if (_v0.a.$ === 1) {
							var _v12 = _v0.b;
							return _Utils_Tuple3(
								model,
								A2(
									$elm$file$File$Select$file,
									_List_fromArray(
										['.csv', 'text/csv']),
									$author$project$Pages$Enterprise$Dashboard$GotCsv),
								$author$project$Shared$NoOp);
						} else {
							break _v0$42;
						}
					case 7:
						if (_v0.a.$ === 1) {
							var file = _v0.b.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $author$project$Pages$Enterprise$Dashboard$ImportModal(
											$author$project$Pages$Enterprise$Dashboard$ImportModalPicked(file))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						} else {
							break _v0$42;
						}
					case 8:
						if ((_v0.a.$ === 1) && (_v0.a.a.$ === 1)) {
							var file = _v0.a.a.a;
							var _v13 = _v0.b;
							return _Utils_Tuple3(
								model,
								A2(
									$elm$core$Task$perform,
									$author$project$Pages$Enterprise$Dashboard$ImportCsv,
									$elm$file$File$toString(file)),
								$author$project$Shared$CloseDialog);
						} else {
							break _v0$42;
						}
					case 9:
						if ((_v0.a.$ === 1) && (_v0.a.a.$ === 1)) {
							var file = _v0.a.a.a;
							var content = _v0.b.a;
							var validCsv = function (list_) {
								return $elm$core$List$length(list_) < 3;
							}(
								A2(
									$elm$core$List$filterMap,
									function (index) {
										return function (value) {
											return A2(
												$elm$core$String$all,
												function (_char) {
													return _char !== '\u000D';
												},
												value) ? $elm$core$Maybe$Just(value) : $elm$core$Maybe$Nothing;
										}(
											A3($elm$core$String$slice, index - 1, index + 5, content));
									},
									A2($elm$core$String$indexes, ',', content)));
							if (validCsv) {
								var _v14 = model.ab;
								if (!_v14.$) {
									var _class = _v14.a;
									return _Utils_Tuple3(
										_Utils_update(
											model,
											{
												aY: $author$project$Pages$Enterprise$Dashboard$ImportModal(
													$author$project$Pages$Enterprise$Dashboard$ImportModalImporting(file))
											}),
										A4($author$project$Services$Company$fillEmployees, user, file, _class.dM, $author$project$Pages$Enterprise$Dashboard$ImportedCsv),
										$author$project$Shared$NoOp);
								} else {
									return _Utils_Tuple3(
										model,
										$elm$core$Platform$Cmd$none,
										$author$project$Shared$ShowErrorDialog('Selecione uma classe para importar a planilha'));
								}
							} else {
								return _Utils_Tuple3(
									model,
									$elm$core$Platform$Cmd$none,
									$author$project$Shared$ShowErrorDialog('Delimitador não deve ser \',\' e sim \';\''));
							}
						} else {
							break _v0$42;
						}
					case 10:
						if ((_v0.a.$ === 1) && (_v0.a.a.$ === 2)) {
							var file = _v0.a.a.a;
							var res = _v0.b.a;
							if (!res.$) {
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{aY: $author$project$Pages$Enterprise$Dashboard$None}),
									$author$project$Pages$Enterprise$Dashboard$getImports(user.kU),
									$author$project$Shared$NoOp);
							} else {
								var error = res.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $author$project$Pages$Enterprise$Dashboard$ImportModal(
												$author$project$Pages$Enterprise$Dashboard$ImportModalPicked(file))
										}),
									$elm$core$Platform$Cmd$none,
									A2(
										$author$project$Shared$remoteDataSharedMsg,
										$elm$core$Maybe$Nothing,
										$krisajenkins$remotedata$RemoteData$Failure(error)));
							}
						} else {
							break _v0$42;
						}
					case 11:
						if (!_v0.a.$) {
							var _v16 = _v0.a;
							var res = _v0.b.a;
							if (!res.$) {
								var data = res.a;
								var _v18 = model;
								var employees = _v18.d;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											d: _Utils_update(
												employees,
												{h2: data.h2, bY: data.bY, i3: data.i3, dM: data.dM, an: data.an, nY: data.nY, pC: data.pC}),
											dP: false,
											aY: $author$project$Pages$Enterprise$Dashboard$None
										}),
									$elm$core$Platform$Cmd$none,
									$author$project$Shared$NoOp);
							} else {
								var error = res.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{dP: false}),
									$elm$core$Platform$Cmd$none,
									A2($author$project$Shared$updateApiError, shared, error));
							}
						} else {
							break _v0$42;
						}
					case 12:
						if (!_v0.a.$) {
							var _v19 = _v0.a;
							var _v20 = _v0.b;
							var taskCmd = A2(
								$elm$core$Task$attempt,
								$author$project$Pages$Enterprise$Dashboard$ReceivedCards,
								A4(
									$elm$core$Task$map3,
									$author$project$Pages$Enterprise$Dashboard$createThird,
									$author$project$Services$Payments$getCardList(user.kU),
									$author$project$Services$Payments$canEmitPaymentGuide(user.kU),
									$author$project$Services$Payments$getAvailablePaymentMethods(user.kU)));
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $author$project$Pages$Enterprise$Dashboard$PaymentModal($author$project$Pages$Enterprise$Dashboard$PaymentModalLoading)
									}),
								taskCmd,
								$author$project$Shared$NoOp);
						} else {
							break _v0$42;
						}
					case 13:
						if ((_v0.a.$ === 3) && (!_v0.a.a.$)) {
							var _v21 = _v0.a.a;
							var res = _v0.b.a;
							if (!res.$) {
								if (!res.a.c.b) {
									var _v23 = res.a;
									return _Utils_Tuple3(
										_Utils_update(
											model,
											{aY: $author$project$Pages$Enterprise$Dashboard$None}),
										$elm$core$Platform$Cmd$none,
										$author$project$Shared$ShowErrorDialog('Nenhum método de pagamento está disponível'));
								} else {
									var cards = res.a;
									return _Utils_Tuple3(
										_Utils_update(
											model,
											{
												aY: $author$project$Pages$Enterprise$Dashboard$PaymentModal(
													$author$project$Pages$Enterprise$Dashboard$PaymentModalCards(cards))
											}),
										$elm$core$Platform$Cmd$none,
										$author$project$Shared$NoOp);
								}
							} else {
								var error = res.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{aY: $author$project$Pages$Enterprise$Dashboard$None}),
									$elm$core$Platform$Cmd$none,
									A2($author$project$Shared$updateApiError, shared, error));
							}
						} else {
							break _v0$42;
						}
					case 14:
						if (_v0.a.$ === 3) {
							var _v24 = _v0.b;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $author$project$Pages$Enterprise$Dashboard$AddCardModal(
											{dm: $krisajenkins$remotedata$RemoteData$NotAsked, ia: '', l3: '', bU: '', cT: '', nb: ''})
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						} else {
							break _v0$42;
						}
					case 15:
						if (_v0.a.$ === 3) {
							var model_ = _v0.a.a;
							var method = _v0.b.a;
							var totalValue = $author$project$Pages$Enterprise$Dashboard$sumTotalValue(model);
							var m_cards = function () {
								switch (model_.$) {
									case 1:
										var cards = model_.a;
										return $elm$core$Maybe$Just(cards);
									case 2:
										var cards = model_.a;
										return $elm$core$Maybe$Just(cards);
									default:
										return $elm$core$Maybe$Nothing;
								}
							}();
							if (_Utils_eq(method, $author$project$Pages$Enterprise$Dashboard$BankSlip) && (totalValue < 500)) {
								return _Utils_Tuple3(
									model,
									$elm$core$Platform$Cmd$none,
									$author$project$Shared$ShowErrorDialog('Para poder selecionar boleto bancário é necessário que o valor total seja maior que R$ 5,00'));
							} else {
								if (!m_cards.$) {
									var cards = m_cards.a;
									return _Utils_Tuple3(
										_Utils_update(
											model,
											{
												aY: $author$project$Pages$Enterprise$Dashboard$PaymentModal(
													A2($author$project$Pages$Enterprise$Dashboard$PaymentModalSelectedMethod, cards, method))
											}),
										$elm$core$Platform$Cmd$none,
										$author$project$Shared$NoOp);
								} else {
									return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
								}
							}
						} else {
							break _v0$42;
						}
					case 16:
						if ((_v0.a.$ === 3) && (_v0.a.a.$ === 2)) {
							var _v27 = _v0.a.a;
							var cards = _v27.a;
							var method = _v27.b;
							var _v28 = _v0.b;
							var _v29 = model.ab;
							if (!_v29.$) {
								var _class = _v29.a;
								var cmd = A2(
									$elm$core$Maybe$withDefault,
									function () {
										switch (method.$) {
											case 3:
												var card = method.a;
												return $author$project$Services$Company$payWithCreditCard(
													{lM: card.dM, ow: $author$project$Pages$Enterprise$Dashboard$PayedWithCreditCard, kU: user.kU, dk: model.d.dM});
											case 0:
												return $author$project$Services$Company$generateBankSlip(
													{ow: $author$project$Pages$Enterprise$Dashboard$PayedWithBankSlip, kU: user.kU, dk: model.d.dM});
											case 1:
												return $author$project$Services$Company$generatePix(
													{ow: $author$project$Pages$Enterprise$Dashboard$PayedWithPix, kU: user.kU, dk: model.d.dM});
											default:
												return A2(
													$elm$core$Task$attempt,
													$author$project$Pages$Enterprise$Dashboard$PayedWithPaymentGuide,
													A2($author$project$Services$Company$getPaymentGuide, user.kU, model.d.dM));
										}
									}(),
									A2(
										$elm$core$Maybe$map,
										function (i) {
											return A2(
												$elm$core$Task$attempt,
												$author$project$Pages$Enterprise$Dashboard$GotOpenRefill,
												A2($author$project$Services$Payments$postOpenRefill, i, user.kU));
										},
										model.cX));
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $author$project$Pages$Enterprise$Dashboard$PaymentModal(
												A2($author$project$Pages$Enterprise$Dashboard$PaymentModalPaying, cards, method))
										}),
									cmd,
									$author$project$Shared$NoOp);
							} else {
								return _Utils_Tuple3(
									model,
									$elm$core$Platform$Cmd$none,
									$author$project$Shared$ShowErrorDialog('Selecione uma classe'));
							}
						} else {
							break _v0$42;
						}
					case 17:
						if ((_v0.a.$ === 3) && (_v0.a.a.$ === 3)) {
							var _v31 = _v0.a.a;
							var cards = _v31.a;
							var method = _v31.b;
							var res = _v0.b.a;
							var _v32 = _Utils_Tuple2(model.ab, res);
							if (!_v32.b.$) {
								if (!_v32.a.$) {
									var _class = _v32.a.a;
									var cmd = function () {
										switch (method.$) {
											case 3:
												var card = method.a;
												return $author$project$Services$Company$payWithCreditCard(
													{lM: card.dM, ow: $author$project$Pages$Enterprise$Dashboard$PayedWithCreditCard, kU: user.kU, dk: model.d.dM});
											case 0:
												return $author$project$Services$Company$generateBankSlip(
													{ow: $author$project$Pages$Enterprise$Dashboard$PayedWithBankSlip, kU: user.kU, dk: model.d.dM});
											case 1:
												return $author$project$Services$Company$generatePix(
													{ow: $author$project$Pages$Enterprise$Dashboard$PayedWithPix, kU: user.kU, dk: model.d.dM});
											default:
												return A2(
													$elm$core$Task$attempt,
													$author$project$Pages$Enterprise$Dashboard$PayedWithPaymentGuide,
													A2($author$project$Services$Company$getPaymentGuide, user.kU, model.d.dM));
										}
									}();
									return _Utils_Tuple3(
										_Utils_update(
											model,
											{
												aY: $author$project$Pages$Enterprise$Dashboard$PaymentModal(
													A2($author$project$Pages$Enterprise$Dashboard$PaymentModalPaying, cards, method))
											}),
										cmd,
										$author$project$Shared$NoOp);
								} else {
									var _v34 = _v32.a;
									return _Utils_Tuple3(
										model,
										$elm$core$Platform$Cmd$none,
										$author$project$Shared$ShowErrorDialog('Selecione uma classe'));
								}
							} else {
								var error = _v32.b.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $author$project$Pages$Enterprise$Dashboard$PaymentModal(
												A2($author$project$Pages$Enterprise$Dashboard$PaymentModalSelectedMethod, cards, method))
										}),
									$elm$core$Platform$Cmd$none,
									A2($author$project$Shared$updateApiError, shared, error));
							}
						} else {
							break _v0$42;
						}
					case 18:
						if ((_v0.a.$ === 3) && (_v0.a.a.$ === 3)) {
							var _v35 = _v0.a.a;
							var cards = _v35.a;
							var method = _v35.b;
							var res = _v0.b.a;
							if (!res.$) {
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $author$project$Pages$Enterprise$Dashboard$PaymentModal($author$project$Pages$Enterprise$Dashboard$PaymentModalPayedCard)
										}),
									$elm$core$Platform$Cmd$none,
									$author$project$Shared$NoOp);
							} else {
								var error = res.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $author$project$Pages$Enterprise$Dashboard$PaymentModal(
												A2($author$project$Pages$Enterprise$Dashboard$PaymentModalSelectedMethod, cards, method))
										}),
									$elm$core$Platform$Cmd$none,
									A2($author$project$Shared$updateApiError, shared, error));
							}
						} else {
							break _v0$42;
						}
					case 19:
						if ((_v0.a.$ === 3) && (_v0.a.a.$ === 3)) {
							var _v37 = _v0.a.a;
							var cards = _v37.a;
							var method = _v37.b;
							var res = _v0.b.a;
							if (!res.$) {
								var url = res.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $author$project$Pages$Enterprise$Dashboard$PaymentModal(
												$author$project$Pages$Enterprise$Dashboard$PaymentModalPayedWithBankSlip(url))
										}),
									$elm$core$Platform$Cmd$none,
									$author$project$Shared$NoOp);
							} else {
								var error = res.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $author$project$Pages$Enterprise$Dashboard$PaymentModal(
												A2($author$project$Pages$Enterprise$Dashboard$PaymentModalSelectedMethod, cards, method))
										}),
									$elm$core$Platform$Cmd$none,
									A2($author$project$Shared$updateApiError, shared, error));
							}
						} else {
							break _v0$42;
						}
					case 20:
						if ((_v0.a.$ === 3) && (_v0.a.a.$ === 3)) {
							var _v39 = _v0.a.a;
							var cards = _v39.a;
							var method = _v39.b;
							var res = _v0.b.a;
							if (!res.$) {
								var pix = res.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $author$project$Pages$Enterprise$Dashboard$PaymentModal(
												$author$project$Pages$Enterprise$Dashboard$PaymentModalPayedWithPix(pix))
										}),
									$elm$core$Platform$Cmd$none,
									$author$project$Shared$NoOp);
							} else {
								var error = res.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $author$project$Pages$Enterprise$Dashboard$PaymentModal(
												A2($author$project$Pages$Enterprise$Dashboard$PaymentModalSelectedMethod, cards, method))
										}),
									$elm$core$Platform$Cmd$none,
									A2($author$project$Shared$updateApiError, shared, error));
							}
						} else {
							break _v0$42;
						}
					case 21:
						if ((_v0.a.$ === 3) && (_v0.a.a.$ === 3)) {
							var _v41 = _v0.a.a;
							var cards = _v41.a;
							var method = _v41.b;
							var res = _v0.b.a;
							if (!res.$) {
								var url = res.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $author$project$Pages$Enterprise$Dashboard$PaymentModal(
												$author$project$Pages$Enterprise$Dashboard$PaymentModalPayedWithPaymentGuide(url))
										}),
									$elm$core$Platform$Cmd$none,
									$author$project$Shared$NoOp);
							} else {
								var error = res.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $author$project$Pages$Enterprise$Dashboard$PaymentModal(
												A2($author$project$Pages$Enterprise$Dashboard$PaymentModalSelectedMethod, cards, method))
										}),
									$elm$core$Platform$Cmd$none,
									A2($author$project$Shared$updateApiError, shared, error));
							}
						} else {
							break _v0$42;
						}
					case 22:
						if ((_v0.a.$ === 3) && (_v0.a.a.$ === 5)) {
							var url = _v0.a.a.a;
							var _v43 = _v0.b;
							return _Utils_Tuple3(
								model,
								$elm$file$File$Download$url(url),
								$author$project$Shared$NoOp);
						} else {
							break _v0$42;
						}
					case 23:
						if ((_v0.a.$ === 3) && (_v0.a.a.$ === 5)) {
							var url = _v0.a.a.a;
							var _v44 = _v0.b;
							return _Utils_Tuple3(
								model,
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$PrintDocument(url));
						} else {
							break _v0$42;
						}
					case 24:
						if ((_v0.a.$ === 3) && (_v0.a.a.$ === 6)) {
							var pix = _v0.a.a.a;
							var _v45 = _v0.b;
							return _Utils_Tuple3(
								model,
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$Copy(
									{m0: 'Não foi possível copiar o PIX!', pZ: 'PIX copiado com sucesso!', di: pix.pc}));
						} else {
							break _v0$42;
						}
					case 25:
						if ((_v0.a.$ === 3) && (_v0.a.a.$ === 7)) {
							var url = _v0.a.a.a;
							var _v46 = _v0.b;
							return _Utils_Tuple3(
								model,
								$elm$file$File$Download$url(url),
								$author$project$Shared$NoOp);
						} else {
							break _v0$42;
						}
					case 26:
						if ((_v0.a.$ === 3) && (_v0.a.a.$ === 7)) {
							var url = _v0.a.a.a;
							var _v47 = _v0.b;
							return _Utils_Tuple3(
								model,
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$PrintDocument(url));
						} else {
							break _v0$42;
						}
					case 27:
						if (_v0.a.$ === 2) {
							var model_ = _v0.a.a;
							var _v48 = _v0.b;
							var field = _v48.a;
							var text = _v48.b;
							var updatedCard = function () {
								switch (field) {
									case 0:
										return _Utils_update(
											model_,
											{ia: text});
									case 1:
										return _Utils_update(
											model_,
											{cT: text});
									case 2:
										return _Utils_update(
											model_,
											{nb: text});
									case 3:
										return _Utils_update(
											model_,
											{bU: text});
									default:
										return _Utils_update(
											model_,
											{l3: text});
								}
							}();
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $author$project$Pages$Enterprise$Dashboard$AddCardModal(updatedCard)
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						} else {
							break _v0$42;
						}
					case 28:
						if (_v0.a.$ === 2) {
							var model_ = _v0.a.a;
							var _v50 = _v0.b;
							var _v51 = $author$project$Pages$Enterprise$Dashboard$cardInputValidation(model_);
							if (!_v51.$) {
								var brand = _v51.a.f_;
								var expirationMonth = _v51.a.gn;
								var expirationYear = _v51.a.go;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $author$project$Pages$Enterprise$Dashboard$AddCardModal(
												_Utils_update(
													model_,
													{dm: $krisajenkins$remotedata$RemoteData$Loading}))
										}),
									A3(
										$author$project$Services$Company$addCreditCard,
										user,
										{f_: brand, bU: model_.bU, gn: expirationMonth, go: expirationYear, nI: model_.l3, nJ: model_.cT, op: model_.ia},
										$author$project$Pages$Enterprise$Dashboard$AddedCard),
									$author$project$Shared$CloseDialog);
							} else {
								var error = _v51.a;
								return _Utils_Tuple3(
									model,
									$elm$core$Platform$Cmd$none,
									$author$project$Shared$ShowErrorDialog(error));
							}
						} else {
							break _v0$42;
						}
					case 29:
						if (_v0.a.$ === 2) {
							var model_ = _v0.a.a;
							var res = _v0.b.a;
							if (!res.$) {
								var $temp$msg = $author$project$Pages$Enterprise$Dashboard$OpenPaymentModal,
									$temp$model = _Utils_update(
									model,
									{aY: $author$project$Pages$Enterprise$Dashboard$None}),
									$temp$shared = shared,
									$temp$user = user;
								msg = $temp$msg;
								model = $temp$model;
								shared = $temp$shared;
								user = $temp$user;
								continue update;
							} else {
								var error = res.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $author$project$Pages$Enterprise$Dashboard$AddCardModal(
												_Utils_update(
													model_,
													{
														dm: $krisajenkins$remotedata$RemoteData$Failure(error)
													}))
										}),
									$elm$core$Platform$Cmd$none,
									A2($author$project$Shared$updateApiError, shared, error));
							}
						} else {
							break _v0$42;
						}
					case 30:
						var _v53 = _v0.b;
						return _Utils_Tuple3(
							model,
							A2(
								$author$project$Route$pushUrl,
								shared.nZ,
								A2($author$project$Route$EnterpriseDashboard, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing)),
							$author$project$Shared$NoOp);
					case 31:
						if (!_v0.a.$) {
							if (!_v0.b.a.$) {
								var _v54 = _v0.a;
								var resultClasses = _v0.b.a.a;
								var autoSelected = $elm$core$List$head(
									A2(
										$elm$core$List$filter,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.qm;
											},
											$elm$core$Basics$eq('vt')),
										resultClasses));
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{cL: resultClasses, dP: true, ab: autoSelected}),
									function () {
										var _v55 = _Utils_Tuple2(model.gO, model.cX);
										if (!_v55.b.$) {
											var id_ = _v55.b.a;
											return $author$project$Services$Company$detailsPurchaseOrder(
												{ow: $author$project$Pages$Enterprise$Dashboard$DetailsCsv, d1: id_, kU: user.kU});
										} else {
											if (_v55.a) {
												return $author$project$Services$Company$getOpenEmployees(
													{ow: $author$project$Pages$Enterprise$Dashboard$LoadEmployees, kU: user.kU});
											} else {
												return $author$project$Pages$Enterprise$Dashboard$getImports(user.kU);
											}
										}
									}(),
									$author$project$Shared$NoOp);
							} else {
								var _v56 = _v0.a;
								var err = _v0.b.a.a;
								return _Utils_Tuple3(
									model,
									$elm$core$Platform$Cmd$none,
									A2($author$project$Shared$updateApiError, shared, err));
							}
						} else {
							break _v0$42;
						}
					case 32:
						if (!_v0.a.$) {
							var _v57 = _v0.a;
							var classID = _v0.b.a;
							var findClass = $elm$core$List$head(
								A2(
									$elm$core$List$filter,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.dM;
										},
										$elm$core$Basics$eq(classID)),
									model.cL));
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										d: {h2: 0, bY: _List_Nil, i3: 0, dM: '', an: _List_Nil, nY: 0, pC: $elm$core$Maybe$Nothing},
										ab: findClass
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						} else {
							break _v0$42;
						}
					case 38:
						var _v58 = _v0.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $author$project$Pages$Enterprise$Dashboard$SaveListModal($author$project$Pages$Enterprise$Dashboard$initSaveListModal)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					case 39:
						var id = _v0.b.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $author$project$Pages$Enterprise$Dashboard$DeleteListModal(
										$author$project$Pages$Enterprise$Dashboard$initDeleteListModal(id))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					case 34:
						if (_v0.a.$ === 4) {
							var m = _v0.a.a;
							var _v59 = _v0.b;
							return A2(
								$elm$core$Maybe$withDefault,
								_Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp),
								A2(
									$elm$core$Maybe$map,
									function (_v60) {
										var id = _v60.dM;
										return _Utils_Tuple3(
											_Utils_update(
												model,
												{
													aY: $author$project$Pages$Enterprise$Dashboard$SaveListModal(
														_Utils_update(
															m,
															{jr: true}))
												}),
											$author$project$Services$Company$createListOrder(
												{
													lX: id,
													n4: m.c2,
													ow: $author$project$Pages$Enterprise$Dashboard$GotCreateListOrder,
													oI: $author$project$Pages$Enterprise$Dashboard$orderToList(model.d.an),
													kU: user.kU
												}),
											$author$project$Shared$NoOp);
									},
									model.ab));
						} else {
							break _v0$42;
						}
					case 35:
						if (_v0.a.$ === 5) {
							var m = _v0.a.a;
							var _v61 = _v0.b;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $author$project$Pages$Enterprise$Dashboard$DeleteListModal(
											_Utils_update(
												m,
												{dP: true}))
									}),
								$author$project$Services$Company$deleteListImport(
									{dM: m.dM, ow: $author$project$Pages$Enterprise$Dashboard$GotDeleteList, kU: user.kU}),
								$author$project$Shared$NoOp);
						} else {
							break _v0$42;
						}
					case 36:
						if (_v0.a.$ === 5) {
							var m = _v0.a.a;
							var rd = _v0.b.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: A2(
											$krisajenkins$remotedata$RemoteData$withDefault,
											$author$project$Pages$Enterprise$Dashboard$DeleteListModal(
												_Utils_update(
													m,
													{dP: false})),
											A2(
												$krisajenkins$remotedata$RemoteData$map,
												function (_v62) {
													return $author$project$Pages$Enterprise$Dashboard$None;
												},
												rd))
									}),
								A2(
									$krisajenkins$remotedata$RemoteData$withDefault,
									$elm$core$Platform$Cmd$none,
									A2(
										$krisajenkins$remotedata$RemoteData$map,
										function (_v63) {
											return A2(
												$author$project$Route$pushUrl,
												shared.nZ,
												A2($author$project$Route$EnterpriseDashboard, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing));
										},
										rd)),
								A2(
									$author$project$Shared$remoteDataSharedMsg,
									$elm$core$Maybe$Just('Importação cancelada!'),
									rd));
						} else {
							break _v0$42;
						}
					case 37:
						if (_v0.a.$ === 4) {
							if (_v0.b.a.$ === 3) {
								var m = _v0.a.a;
								var orderID = _v0.b.a.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{aY: $author$project$Pages$Enterprise$Dashboard$None}),
									$elm$core$Platform$Cmd$none,
									$author$project$Shared$ShowSuccessDialogWithRedirect(
										{
											lJ: 'Ir para pedido',
											pv: $author$project$Route$SavedOrderDetails(orderID),
											fD: 'Lista de pedido gravada com sucesso! '
										}));
							} else {
								var m = _v0.a.a;
								var rd = _v0.b.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $author$project$Pages$Enterprise$Dashboard$SaveListModal(
												_Utils_update(
													m,
													{jr: false}))
										}),
									$elm$core$Platform$Cmd$none,
									A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rd));
							}
						} else {
							break _v0$42;
						}
					default:
						if (_v0.a.$ === 4) {
							var m = _v0.a.a;
							var newListOrderName = _v0.b.a;
							var updateModal = $author$project$Pages$Enterprise$Dashboard$SaveListModal(
								_Utils_update(
									m,
									{c2: newListOrderName}));
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{aY: updateModal}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						} else {
							break _v0$42;
						}
				}
			}
			return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
		}
	});
var $author$project$Pages$Enterprise$HistoryDetails$update = F4(
	function (msg, model, shared, _v0) {
		switch (msg.$) {
			case 0:
				var route = msg.a;
				return _Utils_Tuple3(
					model,
					A2($author$project$Route$pushUrl, shared.nZ, route),
					$author$project$Shared$NoOp);
			case 1:
				var res = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							fk: $krisajenkins$remotedata$RemoteData$fromResult(res)
						}),
					$elm$core$Platform$Cmd$none,
					function () {
						if (!res.$) {
							return $author$project$Shared$NoOp;
						} else {
							var error = res.a;
							return A2($author$project$Shared$updateApiError, shared, error);
						}
					}());
			default:
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$Redirect($author$project$Route$EnterpriseHistory));
		}
	});
var $author$project$Pages$Enterprise$Register$AddedCompany = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Enterprise$Register$Finished = 2;
var $author$project$Pages$Enterprise$Register$GotAdressInfo = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Enterprise$Register$NoOp = {$: 0};
var $author$project$Pages$Enterprise$Register$Second = 1;
var $author$project$Services$Company$companyEncoder = function (company) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'concessionaireId',
				$elm$json$Json$Encode$string(company.mc)),
				_Utils_Tuple2(
				'managerName',
				$elm$json$Json$Encode$string(company.n7)),
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(company.mX)),
				_Utils_Tuple2(
				'password',
				$elm$json$Json$Encode$string(company.oN)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(company.c3)),
				_Utils_Tuple2(
				'cnpj',
				$elm$json$Json$Encode$string(company.l3)),
				_Utils_Tuple2(
				'postalCode',
				$elm$json$Json$Encode$string(company.o0)),
				_Utils_Tuple2(
				'address',
				$elm$json$Json$Encode$string(company.ep)),
				_Utils_Tuple2(
				'addressNumber',
				$elm$json$Json$Encode$string(company.bL)),
				_Utils_Tuple2(
				'addressComplement',
				$elm$json$Json$Encode$string(company.lk)),
				_Utils_Tuple2(
				'phoneNumber',
				$elm$json$Json$Encode$string(company.oW)),
				_Utils_Tuple2(
				'phoneAreaCode',
				$elm$json$Json$Encode$string(company.oV)),
				_Utils_Tuple2(
				'state',
				$elm$json$Json$Encode$string(company.fy)),
				_Utils_Tuple2(
				'city',
				$elm$json$Json$Encode$string(company.lW))
			]));
};
var $author$project$Services$Company$addCompany = F2(
	function (company, processRequest) {
		return $elm$http$Http$request(
			{
				lG: $elm$http$Http$jsonBody(
					$author$project$Services$Company$companyEncoder(company)),
				m9: $author$project$Services$Api$expectWhatever(processRequest),
				nG: _List_fromArray(
					[
						A2($elm$http$Http$header, 'Content-Type', 'application/json')
					]),
				of: 'POST',
				p5: $elm$core$Maybe$Nothing,
				qi: $elm$core$Maybe$Nothing,
				qt: A2(
					$author$project$Constants$companyServiceUrl,
					_List_fromArray(
						['api', 'v1', 'registration']),
					_List_Nil)
			});
	});
var $author$project$Services$Cep$Response = F4(
	function (location, neighborhood, street, state) {
		return {n5: location, om: neighborhood, fy: state, pU: street};
	});
var $author$project$Services$Cep$decoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$map,
			$elm$core$Maybe$Just,
			A5(
				$elm$json$Json$Decode$map4,
				$author$project$Services$Cep$Response,
				A2($elm$json$Json$Decode$field, 'localidade', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'bairro', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'logradouro', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'uf', $elm$json$Json$Decode$string))),
			A2(
			$elm$json$Json$Decode$map,
			function (_v0) {
				return $elm$core$Maybe$Nothing;
			},
			A2($elm$json$Json$Decode$field, 'erro', $elm$json$Json$Decode$bool))
		]));
var $elm$http$Http$get = function (r) {
	return $elm$http$Http$request(
		{lG: $elm$http$Http$emptyBody, m9: r.m9, nG: _List_Nil, of: 'GET', p5: $elm$core$Maybe$Nothing, qi: $elm$core$Maybe$Nothing, qt: r.qt});
};
var $author$project$Services$Cep$get = F2(
	function (cep, onResponse) {
		var cepDigits = A2($elm$core$String$filter, $elm$core$Char$isDigit, cep);
		return $elm$http$Http$get(
			{
				m9: A2($author$project$Services$Api$expectJson, onResponse, $author$project$Services$Cep$decoder),
				qt: A3(
					$elm$url$Url$Builder$crossOrigin,
					'https://viacep.com.br',
					_List_fromArray(
						['ws', cepDigits, 'json']),
					_List_Nil)
			});
	});
var $author$project$Pages$Enterprise$Register$validateForm = function (model) {
	var validations = function () {
		var _v0 = model.hG;
		switch (_v0) {
			case 0:
				return _List_fromArray(
					[
						_Utils_Tuple2(model.c3 === '', 'Preencha o nome'),
						_Utils_Tuple2(
						!$author$project$Utils$isValidEmail(model.mX),
						'Email inválido'),
						_Utils_Tuple2(model.oV === '', 'Preencha o DDD'),
						_Utils_Tuple2(model.jX === '', 'Preencha o telefone'),
						_Utils_Tuple2(model.oN === '', 'Preencha a senha'),
						_Utils_Tuple2(
						$elm$core$String$length(model.oN) < 6,
						'Senha precisa ter ao menos 6 caracteres'),
						_Utils_Tuple2(
						!_Utils_eq(model.oN, model.c6),
						'Confirmação está errada')
					]);
			case 1:
				return _List_fromArray(
					[
						_Utils_Tuple2(model.l3 === '', 'Preencha o CNPJ'),
						_Utils_Tuple2(
						!$author$project$Validate$Cnpj$isValid(model.l3),
						'CNPJ inválido'),
						_Utils_Tuple2(model.cT === '', 'Preencha a razão social'),
						_Utils_Tuple2(model.bO === '', 'Preencha o CEP'),
						_Utils_Tuple2(
						$elm$core$String$length(model.bO) !== 8,
						'Preencha um CEP válido'),
						_Utils_Tuple2(model.ep === '', 'Preencha o endereço'),
						_Utils_Tuple2(model.bL === '', 'Preencha o número do endereço'),
						_Utils_Tuple2(model.om === '', 'Preencha o bairro'),
						_Utils_Tuple2(model.lW === '', 'Preencha a cidade'),
						_Utils_Tuple2(model.fy === '', 'Selecione o estado')
					]);
			default:
				return _List_Nil;
		}
	}();
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Result$Ok(0),
		A2(
			$elm$core$Maybe$map,
			$elm$core$Result$Err,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$second,
				$elm$core$List$head(
					A2($elm$core$List$filter, $elm$core$Tuple$first, validations)))));
};
var $author$project$Pages$Enterprise$Register$update = F4(
	function (msg, model, shared, maybeConcessionaireId) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							hG: (model.hG === 1) ? 0 : model.hG
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 2:
				var _v1 = $author$project$Pages$Enterprise$Register$validateForm(model);
				if (!_v1.$) {
					return (!model.hG) ? _Utils_Tuple3(
						_Utils_update(
							model,
							{hG: 1}),
						A2(
							$elm$core$Task$attempt,
							$elm$core$Basics$always($author$project$Pages$Enterprise$Register$NoOp),
							$elm$browser$Browser$Dom$focus('cnpj')),
						$author$project$Shared$CloseDialog) : _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$CloseDialog);
				} else {
					var error = _v1.a;
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$ShowErrorDialog(error));
				}
			case 3:
				var field = msg.a;
				var value = msg.b;
				switch (field) {
					case 0:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{c3: value}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					case 1:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{mX: value}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{oV: value}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{jX: value}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					case 4:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{oN: value}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					case 5:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{c6: value}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					case 6:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{l3: value}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					case 7:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{cT: value}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					case 8:
						var command = ($elm$core$String$length(value) === 8) ? A2($author$project$Services$Cep$get, value, $author$project$Pages$Enterprise$Register$GotAdressInfo) : $elm$core$Platform$Cmd$none;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{bO: value}),
							command,
							$author$project$Shared$NoOp);
					case 9:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{ep: value}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					case 10:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{bL: value}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					case 11:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{dn: value}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					case 12:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{om: value}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					case 13:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{lW: value}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					default:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{fy: value}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
				}
			case 6:
				if (!msg.a.$) {
					if (!msg.a.a.$) {
						var res = msg.a.a.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{ep: res.pU, lW: res.n5, om: res.om, fy: res.fy}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					} else {
						var _v3 = msg.a.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$ShowErrorDialog('CEP não encontrado'));
					}
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						A2($author$project$Shared$updateApiError, shared, error));
				}
			case 4:
				var _v4 = _Utils_Tuple2(
					$author$project$Pages$Enterprise$Register$validateForm(model),
					maybeConcessionaireId);
				if (_v4.a.$ === 1) {
					var error = _v4.a.a;
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$ShowErrorDialog(error));
				} else {
					if (_v4.b.$ === 1) {
						var _v5 = _v4.b;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$ShowErrorDialog('Concessionária inválida'));
					} else {
						var concessionaireId = _v4.b.a;
						var company = {ep: model.ep, lk: model.dn, bL: model.bL, lW: model.lW, l3: model.l3, mc: concessionaireId, mX: model.mX, n7: model.c3, c3: model.cT, oN: model.oN, oV: model.oV, oW: model.jX, o0: model.bO, fy: model.fy};
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{q: $krisajenkins$remotedata$RemoteData$Loading}),
							A2($author$project$Services$Company$addCompany, company, $author$project$Pages$Enterprise$Register$AddedCompany),
							$author$project$Shared$CloseDialog);
					}
				}
			default:
				if (msg.a.$ === 1) {
					var error = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								q: $krisajenkins$remotedata$RemoteData$Failure(error)
							}),
						$elm$core$Platform$Cmd$none,
						A2($author$project$Shared$updateApiError, shared, error));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{hG: 2}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				}
		}
	});
var $author$project$Pages$Garage$Dashboard$NextModal = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Garage$Dashboard$ReceivedConfirmation = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Garage$Dashboard$ReceivedSessionVaultDetails = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Garage$Dashboard$UpdateSessionVault = function (a) {
	return {$: 7, a: a};
};
var $author$project$Services$Cashier$apurar = function (options) {
	var encode = $elm$json$Json$Encode$object(
		$elm$core$List$concat(
			_List_fromArray(
				[
					function () {
					var _v0 = options.mc;
					if (!_v0.$) {
						var concessionaireId = _v0.a;
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'concessionaireId',
								$elm$json$Json$Encode$string(concessionaireId))
							]);
					} else {
						return _List_Nil;
					}
				}(),
					_List_fromArray(
					[
						_Utils_Tuple2(
						'cashierAccountabilityId',
						$elm$json$Json$Encode$string(options.ib)),
						_Utils_Tuple2(
						'checkedAmount',
						$elm$json$Json$Encode$int(options.$8)),
						_Utils_Tuple2(
						'divergenceNotes',
						$elm$json$Json$Encode$string(options.mN))
					])
				])));
	var decoder = $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$field,
				'error',
				$elm$json$Json$Decode$fail('cannot have error field')),
				$elm$json$Json$Decode$succeed(0)
			]));
	return $elm$http$Http$request(
		{
			lG: $elm$http$Http$jsonBody(encode),
			m9: A2($author$project$Services$Api$expectJson, options.ow, decoder),
			nG: _List_fromArray(
				[
					$author$project$Services$Api$authorizationHeader(options.kU)
				]),
			of: 'PATCH',
			p5: $elm$core$Maybe$Nothing,
			qi: $elm$core$Maybe$Nothing,
			qt: A2(
				$author$project$Constants$cashierServiceUrl,
				_List_fromArray(
					['api', 'v1', 'accountability']),
				_List_Nil)
		});
};
var $author$project$Services$Cashier$SessionVaultDetails = F2(
	function (amount, lines) {
		return {lo: amount, n2: lines};
	});
var $author$project$Services$Cashier$Line = F9(
	function (line, balance, openedAt, closedAt, vehicleCode, fare, openGateCount, closeGateCount, spinsCounts) {
		return {h2: balance, l0: closeGateCount, l2: closedAt, ni: fare, e1: line, oB: openGateCount, jL: openedAt, kJ: spinsCounts, em: vehicleCode};
	});
var $author$project$Services$Cashier$SpinsCount = F2(
	function (count, classId) {
		return {lY: classId, iw: count};
	});
var $author$project$Services$Cashier$decodeSpinsCount = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'classId',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'count',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Services$Cashier$SpinsCount)));
var $author$project$Services$Cashier$lineDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
	_List_fromArray(
		['specificInfo', 'spinsCounts']),
	$elm$json$Json$Decode$list($author$project$Services$Cashier$decodeSpinsCount),
	_List_Nil,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
		_List_fromArray(
			['specificInfo', 'closeGateCount']),
		$elm$json$Json$Decode$int,
		0,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
			_List_fromArray(
				['specificInfo', 'openGateCount']),
			$elm$json$Json$Decode$int,
			0,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
				_List_fromArray(
					['specificInfo', 'fare']),
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
					_List_fromArray(
						['vehicle', 'code']),
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'closedAt',
						A2(
							$elm$json$Json$Decode$map,
							A2(
								$elm$core$Basics$composeR,
								$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime,
								$elm$core$Result$withDefault(
									$elm$time$Time$millisToPosix(0))),
							$elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'openedAt',
							A2(
								$elm$json$Json$Decode$map,
								A2(
									$elm$core$Basics$composeR,
									$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime,
									$elm$core$Result$withDefault(
										$elm$time$Time$millisToPosix(0))),
								$elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'balance',
								$elm$json$Json$Decode$int,
								A2(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
									$elm$json$Json$Decode$oneOf(
										_List_fromArray(
											[
												A2(
												$elm$json$Json$Decode$field,
												'line',
												A3(
													$elm$json$Json$Decode$map2,
													F2(
														function (line, name) {
															return line + (' ' + name);
														}),
													A2($elm$json$Json$Decode$field, 'line', $elm$json$Json$Decode$string),
													A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string))),
												$elm$json$Json$Decode$succeed('')
											])),
									$elm$json$Json$Decode$succeed($author$project$Services$Cashier$Line))))))))));
var $author$project$Services$Cashier$sessionVaultDetailsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'cashiers',
	$elm$json$Json$Decode$list($author$project$Services$Cashier$lineDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'amount',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Services$Cashier$SessionVaultDetails)));
var $author$project$Services$Cashier$getSessionVaultDetails = function (options) {
	return $elm$http$Http$request(
		{
			lG: $elm$http$Http$emptyBody,
			m9: A2($author$project$Services$Api$expectJson, options.ow, $author$project$Services$Cashier$sessionVaultDetailsDecoder),
			nG: _List_fromArray(
				[
					$author$project$Services$Api$authorizationHeader(options.kU)
				]),
			of: 'GET',
			p5: $elm$core$Maybe$Nothing,
			qi: $elm$core$Maybe$Nothing,
			qt: A2(
				$author$project$Constants$cashierServiceUrl,
				_List_fromArray(
					['api', 'v1', 'accountability', 'details']),
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$map,
							$elm$url$Url$Builder$string('conId'),
							options.mc),
							$elm$core$Maybe$Just(
							A2($elm$url$Url$Builder$string, 'cashierAccountabilityId', options.ib))
						])))
		});
};
var $author$project$Services$Models$initQueriesPosGarage = {bl: $elm$core$Maybe$Nothing, bB: $elm$core$Maybe$Nothing, kK: 0};
var $author$project$Pages$Garage$Dashboard$update = F4(
	function (msg, model, shared, user) {
		update:
		while (true) {
			var queries = model.T;
			switch (msg.$) {
				case 0:
					var now = msg.a.e8;
					var timezone = msg.a.kS;
					var today = A2($justinmimbs$date$Date$fromPosix, timezone, now);
					var newQueries = function () {
						var _v1 = _Utils_Tuple2(queries.bB, queries.bl);
						if ((!_v1.a.$) && (!_v1.b.$)) {
							return queries;
						} else {
							return _Utils_update(
								queries,
								{
									bl: $elm$core$Maybe$Just(
										$justinmimbs$date$Date$toIsoString(today)),
									bB: $elm$core$Maybe$Just(
										$justinmimbs$date$Date$toIsoString(today))
								});
						}
					}();
					var newModel = _Utils_update(
						model,
						{T: newQueries});
					return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
				case 2:
					return _Utils_Tuple3(
						model,
						A2($author$project$Route$pushUrl, shared.nZ, $author$project$Route$Login),
						$author$project$Shared$NoOp);
				case 3:
					var maybeSessionVault = msg.a;
					if (!maybeSessionVault.$) {
						var sessionVault = maybeSessionVault.a;
						var modelNextModal = _Utils_update(
							model,
							{bs: model.bs + 1});
						var $temp$msg = $author$project$Pages$Garage$Dashboard$UpdateSessionVault(sessionVault),
							$temp$model = modelNextModal,
							$temp$shared = shared,
							$temp$user = user;
						msg = $temp$msg;
						model = $temp$model;
						shared = $temp$shared;
						user = $temp$user;
						continue update;
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{bs: model.bs + 1}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					}
				case 4:
					var givenSessionVault = msg.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								e6: true,
								aI: $elm$core$Maybe$Just(givenSessionVault),
								bA: $krisajenkins$remotedata$RemoteData$Loading
							}),
						$author$project$Services$Cashier$getSessionVaultDetails(
							{
								ib: givenSessionVault.dM,
								mc: $author$project$Data$User$extractConcessionaireId(user),
								ow: $author$project$Pages$Garage$Dashboard$ReceivedSessionVaultDetails,
								kU: user.kU
							}),
						$author$project$Shared$NoOp);
				case 5:
					var res = msg.a;
					if (!res.$) {
						var sessionVaults = res.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bA: $krisajenkins$remotedata$RemoteData$Success(sessionVaults)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					} else {
						var error = res.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bA: $krisajenkins$remotedata$RemoteData$Failure(error)
								}),
							$elm$core$Platform$Cmd$none,
							A2($author$project$Shared$updateApiError, shared, error));
					}
				case 6:
					var whichTab = msg.a;
					var newQueries = function (q) {
						return _Utils_update(
							q,
							{kK: whichTab});
					}($author$project$Services$Models$initQueriesPosGarage);
					var newModel = _Utils_update(
						model,
						{T: newQueries, ar: $krisajenkins$remotedata$RemoteData$Loading});
					return _Utils_Tuple3(
						newModel,
						A2(
							$author$project$Route$pushUrl,
							shared.nZ,
							$author$project$Route$PosGarage(newQueries)),
						$author$project$Shared$NoOp);
				case 1:
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bS: $krisajenkins$remotedata$RemoteData$NotAsked, bs: 0, g0: false, g1: false, hu: '', aI: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				case 7:
					var updatedSessionVault = msg.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aI: $elm$core$Maybe$Just(updatedSessionVault),
								ar: $krisajenkins$remotedata$RemoteData$Loading
							}),
						A2(
							$author$project$Services$Cashier$getSessionVaults,
							{
								mc: $author$project$Data$User$extractConcessionaireId(user),
								i0: $author$project$Pages$Garage$Dashboard$viewStatusToString(0),
								T: model.T,
								kU: user.kU,
								em: model.em
							},
							$author$project$Pages$Garage$Dashboard$GotSessionVaults),
						$author$project$Shared$NoOp);
				case 8:
					var res = msg.a;
					if (!res.$) {
						var sessionVaults = res.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ar: $krisajenkins$remotedata$RemoteData$Success(sessionVaults)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					} else {
						var error = res.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ar: $krisajenkins$remotedata$RemoteData$Failure(error)
								}),
							$elm$core$Platform$Cmd$none,
							A2($author$project$Shared$updateApiError, shared, error));
					}
				case 9:
					var sessionVault = msg.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bS: $krisajenkins$remotedata$RemoteData$Loading}),
						$author$project$Services$Cashier$apurar(
							{
								ib: sessionVault.dM,
								$8: sessionVault.lo,
								mc: $author$project$Data$User$extractConcessionaireId(user),
								mN: sessionVault.gj,
								ow: $author$project$Pages$Garage$Dashboard$ReceivedConfirmation,
								kU: user.kU
							}),
						$author$project$Shared$NoOp);
				case 10:
					var res = msg.a;
					if (!res.$) {
						var _v6 = model.aI;
						if (!_v6.$) {
							var sessionVault = _v6.a;
							var $temp$msg = $author$project$Pages$Garage$Dashboard$NextModal(
								$elm$core$Maybe$Just(
									_Utils_update(
										sessionVault,
										{kK: 'closed'}))),
								$temp$model = _Utils_update(
								model,
								{bS: $krisajenkins$remotedata$RemoteData$NotAsked}),
								$temp$shared = shared,
								$temp$user = user;
							msg = $temp$msg;
							model = $temp$model;
							shared = $temp$shared;
							user = $temp$user;
							continue update;
						} else {
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
						}
					} else {
						var error = res.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bS: $krisajenkins$remotedata$RemoteData$Failure(error)
								}),
							$elm$core$Platform$Cmd$none,
							A2($author$project$Shared$updateApiError, shared, error));
					}
				case 11:
					var startDate = msg.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								T: _Utils_update(
									queries,
									{
										bB: $elm$core$Maybe$Just(startDate)
									})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				case 12:
					var endDate = msg.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								T: _Utils_update(
									queries,
									{
										bl: $elm$core$Maybe$Just(endDate)
									})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				case 13:
					var id = msg.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								a5: (id === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(id)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				case 14:
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dK: !model.dK}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				default:
					return _Utils_Tuple3(
						model,
						A2(
							$author$project$Route$pushUrl,
							shared.nZ,
							$author$project$Route$PosGarage(queries)),
						$author$project$Shared$NoOp);
			}
		}
	});
var $author$project$Pages$Home$WelcomeBack$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
			case 1:
				var string = msg.a;
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$Logout);
		}
	});
var $author$project$Pages$Login$ReceivedLogin = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Login$SelectConcessionaires = 1;
var $author$project$Shared$SetToken = function (a) {
	return {$: 9, a: a};
};
var $author$project$Services$Auth$AuthSucess = F7(
	function (token, permissions, permissionsCODE, address, cnpj, phone, issTax) {
		return {ep: address, l3: cnpj, nY: issTax, oU: permissions, hg: permissionsCODE, jX: phone, kU: token};
	});
var $author$project$Services$Auth$authDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'issTax',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$float),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'phone',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'cnpj',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'address',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'permissions',
					$elm$json$Json$Decode$list($author$project$Services$Models$decodePermissions),
					_List_Nil,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'roles',
						$elm$json$Json$Decode$list($author$project$Data$Permission$jsonDecoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'token',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Services$Auth$AuthSucess))))))));
var $author$project$Services$Auth$authEncoder = function (auth) {
	return $elm$json$Json$Encode$object(
		function (object) {
			return $elm$core$String$isEmpty(auth.mc) ? object : _Utils_ap(
				object,
				_List_fromArray(
					[
						_Utils_Tuple2(
						'concessionaireID',
						$elm$json$Json$Encode$string(auth.mc))
					]));
		}(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'token',
					$elm$json$Json$Encode$string(auth.kU)),
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string(auth.mX)),
					_Utils_Tuple2(
					'provider',
					$elm$json$Json$Encode$string('email'))
				])));
};
var $author$project$Services$Auth$loginUser = F2(
	function (auth, processRequest) {
		return $elm$http$Http$request(
			{
				lG: $elm$http$Http$jsonBody(
					$author$project$Services$Auth$authEncoder(auth)),
				m9: A2($author$project$Services$Api$expectJson, processRequest, $author$project$Services$Auth$authDecoder),
				nG: _List_Nil,
				of: 'POST',
				p5: $elm$core$Maybe$Nothing,
				qi: $elm$core$Maybe$Nothing,
				qt: A2(
					$author$project$Constants$authServiceUrl,
					_List_fromArray(
						['auth', 'login']),
					_List_Nil)
			});
	});
var $author$project$Pages$Login$update = F3(
	function (msg, model, shared) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
			case 1:
				var text = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{mX: text}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 2:
				var text = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oN: text}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 6:
				var id = msg.a;
				var gotConcessionaire = $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.dM;
							},
							$elm$core$Basics$eq(id)),
						model.bR));
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dy: gotConcessionaire, q: $krisajenkins$remotedata$RemoteData$Loading}),
					A2(
						$author$project$Services$Auth$loginUser,
						{mc: id, mX: model.mX, kU: model.oN},
						$author$project$Pages$Login$ReceivedLogin),
					$author$project$Shared$NoOp);
			case 7:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bR: _List_Nil, dy: $elm$core$Maybe$Nothing, ec: 0}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dL: !model.dL}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{q: $krisajenkins$remotedata$RemoteData$Loading}),
					A2(
						$author$project$Services$Auth$loginUser,
						{mc: '', mX: model.mX, kU: model.oN},
						$author$project$Pages$Login$ReceivedLogin),
					$author$project$Shared$CloseDialog);
			default:
				var res = msg.a;
				if (!res.$) {
					var data = res.a;
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$SetToken(data));
				} else {
					var error = res.a;
					if (error.$ === 8) {
						var value = error.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{bR: value, ec: 1, q: $krisajenkins$remotedata$RemoteData$NotAsked}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$CloseDialog);
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									q: $krisajenkins$remotedata$RemoteData$Failure(error)
								}),
							$elm$core$Platform$Cmd$none,
							A2($author$project$Shared$updateApiError, shared, error));
					}
				}
		}
	});
var $author$project$Pages$NotFound$update = F2(
	function (msg, shared) {
		return A2($author$project$Route$pushUrl, shared.nZ, $author$project$Route$Login);
	});
var $author$project$Pages$Order$Detail$ConfirmRecordDeletionModal = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Order$Detail$CreateRecordModal = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Order$Detail$EditListNameModal = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Order$Detail$EditRecordModal = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Order$Detail$GotGeneratePurchaseOrder = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Pages$Order$Detail$GotOpenPurchaseOrder = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Order$Detail$GotUpdateOrder = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Order$Detail$ModalMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Services$Company$generatePurchaseOrder = function (options) {
	return $author$project$Services$Api$postHttp(
		{
			lG: $elm$http$Http$emptyBody,
			m9: A2(
				$author$project$Services$Api$expectJson,
				options.ow,
				A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'orderList', options.d1, 'refillGenerate']),
				_List_Nil)
		});
};
var $author$project$Pages$Order$Detail$initCreateRecordModel = {lo: 0, cZ: '', bF: $krisajenkins$remotedata$RemoteData$NotAsked};
var $author$project$Services$Company$openPurchaseOrder = function (options) {
	return $author$project$Services$Api$postHttp(
		{
			lG: $elm$http$Http$emptyBody,
			m9: $author$project$Services$Api$expectWhatever(options.ow),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$companyServiceUrl,
				_List_fromArray(
					['api', 'v1', 'refill', 'import', options.d1, 'open']),
				_List_Nil)
		});
};
var $author$project$Pages$Order$Detail$GotFinUser = function (a) {
	return {$: 7, a: a};
};
var $author$project$Services$Models$UserSummarized = F3(
	function (id, name, document) {
		return {iI: document, dM: id, c3: name};
	});
var $author$project$Services$Company$decodeFindUser = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'document',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Services$Models$UserSummarized))));
var $author$project$Services$Company$finUser = function (options) {
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$author$project$Services$Company$decodeFindUser),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'orderList', 'user', options.iI, options.lX, 'extraInfo']),
				_List_Nil)
		});
};
var $author$project$Pages$Order$Detail$realValue = $elm$core$String$filter($elm$core$Char$isDigit);
var $author$project$Pages$Order$Detail$updateModal = F4(
	function (msg, model, user, shared) {
		var detailedOrder = model.x;
		var _v0 = _Utils_Tuple3(msg, model.aY, detailedOrder);
		_v0$9:
		while (true) {
			if (!_v0.b.$) {
				switch (_v0.b.a.$) {
					case 1:
						if (_v0.c.$ === 3) {
							switch (_v0.a.$) {
								case 1:
									var newValue = _v0.a.a;
									var modal_ = _v0.b.a.a;
									var detailedOrder_ = _v0.c.a;
									var updateDetailedOrder = _Utils_update(
										modal_,
										{c3: newValue});
									return $elm$core$String$isEmpty(newValue) ? _Utils_Tuple3(
										model,
										$elm$core$Platform$Cmd$none,
										$author$project$Shared$ShowErrorDialog('Nome não pode ser vazio')) : _Utils_Tuple3(
										_Utils_update(
											model,
											{
												aY: $elm$core$Maybe$Just(
													$author$project$Pages$Order$Detail$EditListNameModal(updateDetailedOrder))
											}),
										$elm$core$Platform$Cmd$none,
										$author$project$Shared$NoOp);
								case 2:
									var _v1 = _v0.a;
									var modal_ = _v0.b.a.a;
									var detailedOrder_ = _v0.c.a;
									var updateDetailedOrder = $krisajenkins$remotedata$RemoteData$Success(
										_Utils_update(
											detailedOrder_,
											{c3: modal_.c3}));
									return _Utils_Tuple3(
										_Utils_update(
											model,
											{x: updateDetailedOrder, aY: $elm$core$Maybe$Nothing}),
										$elm$core$Platform$Cmd$none,
										$author$project$Shared$ShowSuccessDialog('Nome da lista alterado!'));
								default:
									break _v0$9;
							}
						} else {
							break _v0$9;
						}
					case 0:
						if ((!_v0.a.$) && (_v0.c.$ === 3)) {
							var newValue = _v0.a.a;
							var orderUser = _v0.b.a.a;
							var detailedOrder_ = _v0.c.a;
							var newOrderUser = _Utils_update(
								orderUser,
								{
									lo: A2(
										$elm$core$Maybe$withDefault,
										0,
										$elm$core$String$toInt(
											$author$project$Pages$Order$Detail$realValue(newValue)))
								});
							var updateOrderListUsers = A2(
								$elm$core$List$map,
								function (user_) {
									return _Utils_eq(user_.fL, orderUser.fL) ? newOrderUser : user_;
								},
								detailedOrder_.F);
							var updateDetailedOrder = $krisajenkins$remotedata$RemoteData$Success(
								_Utils_update(
									detailedOrder_,
									{F: updateOrderListUsers}));
							return (A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$String$toInt(
									$author$project$Pages$Order$Detail$realValue(newValue))) > 0) ? _Utils_Tuple3(
								_Utils_update(
									model,
									{
										x: updateDetailedOrder,
										aY: $elm$core$Maybe$Just(
											$author$project$Pages$Order$Detail$EditRecordModal(newOrderUser))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp) : _Utils_Tuple3(
								model,
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$ShowErrorDialog('Valor precisa ser maior que 0'));
						} else {
							break _v0$9;
						}
					case 2:
						if ((_v0.a.$ === 3) && (_v0.c.$ === 3)) {
							var _v2 = _v0.a;
							var orderUser = _v0.b.a.a;
							var detailedOrder_ = _v0.c.a;
							var updateOrderListUsers = A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.fL;
									},
									$elm$core$Basics$neq(orderUser.fL)),
								detailedOrder_.F);
							var updateDetailedOrder = $krisajenkins$remotedata$RemoteData$Success(
								_Utils_update(
									detailedOrder_,
									{F: updateOrderListUsers}));
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{x: updateDetailedOrder, aY: $elm$core$Maybe$Nothing}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$ShowSuccessDialog('Registro deletado!'));
						} else {
							break _v0$9;
						}
					default:
						switch (_v0.a.$) {
							case 4:
								var newValue = _v0.a.a;
								var modal_ = _v0.b.a.a;
								var updateModal_ = $author$project$Pages$Order$Detail$CreateRecordModal(
									_Utils_update(
										modal_,
										{
											cZ: $author$project$Pages$Order$Detail$realValue(newValue)
										}));
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $elm$core$Maybe$Just(updateModal_)
										}),
									$elm$core$Platform$Cmd$none,
									$author$project$Shared$NoOp);
							case 5:
								var newValue = _v0.a.a;
								var modal_ = _v0.b.a.a;
								var updateModal_ = $author$project$Pages$Order$Detail$CreateRecordModal(
									_Utils_update(
										modal_,
										{
											lo: A2(
												$elm$core$Maybe$withDefault,
												0,
												$elm$core$String$toInt(
													$author$project$Pages$Order$Detail$realValue(newValue)))
										}));
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $elm$core$Maybe$Just(updateModal_)
										}),
									$elm$core$Platform$Cmd$none,
									$author$project$Shared$NoOp);
							case 6:
								if (_v0.c.$ === 3) {
									var _v3 = _v0.a;
									var modal_ = _v0.b.a.a;
									var detailedOrder_ = _v0.c.a;
									if ($author$project$Validate$Cpf$isValid(modal_.cZ)) {
										var updateModal_ = $author$project$Pages$Order$Detail$CreateRecordModal(
											_Utils_update(
												modal_,
												{bF: $krisajenkins$remotedata$RemoteData$Loading}));
										return _Utils_Tuple3(
											_Utils_update(
												model,
												{
													aY: $elm$core$Maybe$Just(updateModal_)
												}),
											$author$project$Services$Company$finUser(
												{lX: detailedOrder_.lX, iI: modal_.cZ, ow: $author$project$Pages$Order$Detail$GotFinUser, kU: user.kU}),
											$author$project$Shared$NoOp);
									} else {
										return _Utils_Tuple3(
											model,
											$elm$core$Platform$Cmd$none,
											$author$project$Shared$ShowErrorDialog('CPF está incorreto!'));
									}
								} else {
									break _v0$9;
								}
							case 8:
								if (_v0.c.$ === 3) {
									var _v4 = _v0.a;
									var modal_ = _v0.b.a.a;
									var detailedOrder_ = _v0.c.a;
									var _v5 = _Utils_Tuple2(modal_.bF, modal_.lo > 0);
									if (_v5.a.$ === 3) {
										if (_v5.b) {
											var userSummarized = _v5.a.a;
											var mock = {
												lo: modal_.lo,
												ix: $elm$time$Time$millisToPosix(0),
												cV: _List_Nil,
												dM: '',
												oF: '',
												qs: $elm$time$Time$millisToPosix(0),
												fL: userSummarized.dM,
												qx: userSummarized.c3
											};
											var updateOrderListUsers = A2(
												$elm$core$List$append,
												detailedOrder_.F,
												_List_fromArray(
													[mock]));
											var updateDetailedOrder = $krisajenkins$remotedata$RemoteData$Success(
												_Utils_update(
													detailedOrder_,
													{F: updateOrderListUsers}));
											var message = userSummarized.c3 + ' foi adicionado(a) no pedido!';
											return _Utils_Tuple3(
												_Utils_update(
													model,
													{x: updateDetailedOrder, aY: $elm$core$Maybe$Nothing}),
												$elm$core$Platform$Cmd$none,
												$author$project$Shared$ShowSuccessDialog(message));
										} else {
											return _Utils_Tuple3(
												model,
												$elm$core$Platform$Cmd$none,
												$author$project$Shared$ShowErrorDialog('Campo valor é inválido'));
										}
									} else {
										return _Utils_Tuple3(
											model,
											$elm$core$Platform$Cmd$none,
											$author$project$Shared$ShowErrorDialog('Usuário é inválido'));
									}
								} else {
									break _v0$9;
								}
							case 7:
								var result = _v0.a.a;
								var modal_ = _v0.b.a.a;
								return A2(
									$elm$core$List$any,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.fL;
										},
										$elm$core$Basics$eq(
											A2(
												$krisajenkins$remotedata$RemoteData$withDefault,
												'',
												A2(
													$krisajenkins$remotedata$RemoteData$map,
													function ($) {
														return $.dM;
													},
													result)))),
									A2(
										$krisajenkins$remotedata$RemoteData$withDefault,
										_List_Nil,
										A2(
											$krisajenkins$remotedata$RemoteData$map,
											function ($) {
												return $.F;
											},
											model.x))) ? _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $elm$core$Maybe$Just(
												$author$project$Pages$Order$Detail$CreateRecordModal(
													_Utils_update(
														modal_,
														{bF: $krisajenkins$remotedata$RemoteData$NotAsked})))
										}),
									$elm$core$Platform$Cmd$none,
									$author$project$Shared$ShowErrorDialog(
										'O passageiro ' + (A2(
											$krisajenkins$remotedata$RemoteData$withDefault,
											'',
											A2(
												$krisajenkins$remotedata$RemoteData$map,
												function ($) {
													return $.c3;
												},
												result)) + ' já está na lista'))) : _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $elm$core$Maybe$Just(
												$author$project$Pages$Order$Detail$CreateRecordModal(
													_Utils_update(
														modal_,
														{bF: result})))
										}),
									$elm$core$Platform$Cmd$none,
									A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, result));
							default:
								break _v0$9;
						}
				}
			} else {
				break _v0$9;
			}
		}
		return _Utils_Tuple3(
			model,
			$elm$core$Platform$Cmd$none,
			$author$project$Shared$ShowErrorDialog('Algo deu errado!'));
	});
var $author$project$Services$Company$encodeOrderListUsersSummarized = function (user) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'userID',
				$elm$json$Json$Encode$string(user.fL)),
				_Utils_Tuple2(
				'amount',
				$elm$json$Json$Encode$int(user.lo))
			]));
};
var $author$project$Services$Company$encodeUpdateOrder = function (options) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'classID',
				$elm$json$Json$Encode$string(options.lX)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(options.oH)),
				_Utils_Tuple2(
				'orderListUsers',
				A2($elm$json$Json$Encode$list, $author$project$Services$Company$encodeOrderListUsersSummarized, options.F))
			]));
};
var $author$project$Services$Company$updateOrder = function (options) {
	return $author$project$Services$Api$putHttp(
		{
			lG: $elm$http$Http$jsonBody(
				$author$project$Services$Company$encodeUpdateOrder(options)),
			m9: $author$project$Services$Api$expectWhatever(options.ow),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'orderList', options.d1]),
				_List_Nil)
		});
};
var $author$project$Pages$Order$Detail$update = F4(
	function (msg, model, user, shared) {
		switch (msg.$) {
			case 0:
				var result = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{x: result, dD: result}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, result));
			case 1:
				var orderUser = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aY: $elm$core$Maybe$Just(
								$author$project$Pages$Order$Detail$EditRecordModal(orderUser))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 2:
				var order = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aY: $elm$core$Maybe$Just(
								$author$project$Pages$Order$Detail$EditListNameModal(
									{c3: order.c3}))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 3:
				var orderUser = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aY: $elm$core$Maybe$Just(
								$author$project$Pages$Order$Detail$ConfirmRecordDeletionModal(orderUser))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aY: $elm$core$Maybe$Just(
								$author$project$Pages$Order$Detail$CreateRecordModal($author$project$Pages$Order$Detail$initCreateRecordModel))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 5:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aY: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 6:
				return _Utils_Tuple3(
					model,
					A2($author$project$Route$pushUrl, shared.nZ, $author$project$Route$SavedOrderLists),
					$author$project$Shared$NoOp);
			case 7:
				return A2(
					$krisajenkins$remotedata$RemoteData$withDefault,
					_Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$ShowErrorDialog('Algo deu errado!')),
					A2(
						$krisajenkins$remotedata$RemoteData$map,
						function (order_) {
							return _Utils_Tuple3(
								model,
								$author$project$Services$Company$updateOrder(
									{lX: order_.lX, ow: $author$project$Pages$Order$Detail$GotUpdateOrder, d1: order_.dM, F: order_.F, oH: order_.c3, kU: user.kU}),
								$author$project$Shared$NoOp);
						},
						model.x));
			case 8:
				var orderID = msg.a;
				return _Utils_Tuple3(
					model,
					$author$project$Services$Company$generatePurchaseOrder(
						{
							ow: $author$project$Pages$Order$Detail$GotGeneratePurchaseOrder(orderID),
							d1: orderID,
							kU: user.kU
						}),
					$author$project$Shared$NoOp);
			case 12:
				var msg_ = msg.a;
				var _v2 = A4($author$project$Pages$Order$Detail$updateModal, msg_, model, user, shared);
				var newModel = _v2.a;
				var cmd = _v2.b;
				var sharedMsg = _v2.c;
				return _Utils_Tuple3(
					newModel,
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Order$Detail$ModalMsg, cmd),
					sharedMsg);
			case 9:
				if (!msg.b.$) {
					var orderID = msg.a;
					var id = msg.b.a;
					return _Utils_Tuple3(
						model,
						$author$project$Services$Company$openPurchaseOrder(
							{ow: $author$project$Pages$Order$Detail$GotOpenPurchaseOrder, d1: id, kU: user.kU}),
						$author$project$Shared$NoOp);
				} else {
					var error = msg.b.a;
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						A2($author$project$Shared$updateApiError, shared, error));
				}
			case 10:
				if (!msg.a.$) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{aY: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$ShowSuccessDialogWithRedirect(
							{
								lJ: 'Ir para pedido',
								pv: A2(
									$author$project$Route$EnterpriseDashboard,
									$elm$core$Maybe$Just(true),
									$elm$core$Maybe$Nothing),
								fD: 'Gerado pedido de compra'
							}));
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						A2($author$project$Shared$updateApiError, shared, error));
				}
			default:
				if (!msg.a.$) {
					return A2(
						$krisajenkins$remotedata$RemoteData$withDefault,
						_Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$ShowErrorDialog('Algo deu errado!')),
						A2(
							$krisajenkins$remotedata$RemoteData$map,
							function (order) {
								var _v1 = A2($author$project$Pages$Order$Detail$init, order.dM, user);
								var newModel = _v1.a;
								var cmd = _v1.b;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{aY: $elm$core$Maybe$Nothing}),
									cmd,
									$author$project$Shared$ShowSuccessDialog('Lista atualizada!'));
							},
							model.x));
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						A2($author$project$Shared$updateApiError, shared, error));
				}
		}
	});
var $author$project$Pages$Order$Lists$update = F3(
	function (msg, model, shared) {
		if (!msg.$) {
			var result = msg.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{fd: result}),
				$elm$core$Platform$Cmd$none,
				A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, result));
		} else {
			var orderID = msg.a;
			return _Utils_Tuple3(
				model,
				A2(
					$author$project$Route$pushUrl,
					shared.nZ,
					$author$project$Route$SavedOrderDetails(orderID)),
				$author$project$Shared$NoOp);
		}
	});
var $author$project$Pages$Panel$Classes$Create$GotCreate = function (a) {
	return {$: 21, a: a};
};
var $author$project$Pages$Panel$Classes$Create$GotCurrentDate = function (a) {
	return {$: 20, a: a};
};
var $author$project$Components$Patterns$Forms$HasError = 1;
var $author$project$Pages$Panel$Classes$Create$Schedule = 0;
var $author$project$Utils$map6 = F7(
	function (func, ma, mb, mc, md, me, mf) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				if (mc.$ === 1) {
					return $elm$core$Maybe$Nothing;
				} else {
					var c = mc.a;
					if (md.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var d = md.a;
						if (me.$ === 1) {
							return $elm$core$Maybe$Nothing;
						} else {
							var e = me.a;
							if (mf.$ === 1) {
								return $elm$core$Maybe$Nothing;
							} else {
								var f = mf.a;
								return $elm$core$Maybe$Just(
									A6(func, a, b, c, d, e, f));
							}
						}
					}
				}
			}
		}
	});
var $author$project$Utils$datetimeLocalHTMLToPosixWithZone = F2(
	function (timezone, str) {
		var map_ = F6(
			function (y, m, d, h, min, sec) {
				return A7(
					$author$project$Utils$map6,
					F6(
						function (y_, m_, d_, h_, min_, sec_) {
							return A2(
								$justinmimbs$time_extra$Time$Extra$partsToPosix,
								timezone,
								{dC: d_, eO: h_, e3: 0, e5: min_, b8: m_, ft: sec_, cF: y_});
						}),
					$elm$core$String$toInt(y),
					A2(
						$elm$core$Maybe$andThen,
						$author$project$Utils$monthFromInt,
						$elm$core$String$toInt(m)),
					$elm$core$String$toInt(d),
					$elm$core$String$toInt(h),
					$elm$core$String$toInt(min),
					$elm$core$String$toInt(sec));
			});
		var dateTimeLocalReplace = A3(
			$elm$core$String$replace,
			':',
			'-',
			A3($elm$core$String$replace, 'T', '-', str));
		var _v0 = A2($elm$core$String$split, '-', dateTimeLocalReplace);
		_v0$2:
		while (true) {
			if ((((_v0.b && _v0.b.b) && _v0.b.b.b) && _v0.b.b.b.b) && _v0.b.b.b.b.b) {
				if (_v0.b.b.b.b.b.b) {
					if (!_v0.b.b.b.b.b.b.b) {
						var y = _v0.a;
						var _v1 = _v0.b;
						var m = _v1.a;
						var _v2 = _v1.b;
						var d = _v2.a;
						var _v3 = _v2.b;
						var h = _v3.a;
						var _v4 = _v3.b;
						var min = _v4.a;
						var _v5 = _v4.b;
						var sec = _v5.a;
						return A6(map_, y, m, d, h, min, sec);
					} else {
						break _v0$2;
					}
				} else {
					var y = _v0.a;
					var _v6 = _v0.b;
					var m = _v6.a;
					var _v7 = _v6.b;
					var d = _v7.a;
					var _v8 = _v7.b;
					var h = _v8.a;
					var _v9 = _v8.b;
					var min = _v9.a;
					return A6(map_, y, m, d, h, min, '00');
				}
			} else {
				break _v0$2;
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Pages$Panel$Classes$Create$isInvalidClasseID = function (value) {
	return (value < 0) || (value > 255);
};
var $author$project$Pages$Panel$Classes$Create$isInvalidMaxCompanions = F2(
	function (isCompanion, value) {
		return (isCompanion && ((value <= 0) || (value > 3))) || ((!isCompanion) && (!(!value)));
	});
var $author$project$Pages$Panel$Classes$Create$isInvalidMaxDayUseCounter = function (value) {
	return (value < 0) || (value > 15);
};
var $author$project$Pages$Panel$Classes$Create$isInvalidMaxMonthUseCounter = function (value) {
	return (value < 0) || (value > 255);
};
var $author$project$Pages$Panel$Classes$Create$isInvalidDefaultPaymentPercent = function (value) {
	return (value < 0) || (value > 200);
};
var $author$project$Pages$Panel$Classes$Create$isInvalidDefaultPaymentValue = function (value) {
	return (value < 0) || (value > 4000);
};
var $elm$core$Dict$isEmpty = function (dict) {
	if (dict.$ === -2) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Pages$Panel$Classes$Create$isInvalidPaymentRule = F2(
	function (rules, defaultPaymentRule) {
		return $elm$core$List$isEmpty(
			$elm$core$List$concat(rules)) && $elm$core$Dict$isEmpty(defaultPaymentRule);
	});
var $author$project$Pages$Panel$Classes$Create$isInvalidSubsequentUsePeriod = function (value) {
	return (value < 0) || (value > 180);
};
var $author$project$Pages$Panel$Classes$Create$isInvalidWalletTypes = F2(
	function (wF, wV) {
		return $elm$core$String$isEmpty(wF) && $elm$core$String$isEmpty(wV);
	});
var $author$project$Pages$Panel$Classes$Create$isInvalidSubmitInfo = function (form) {
	return !A2(
		$elm$core$List$all,
		$elm$core$Basics$eq(false),
		_List_fromArray(
			[
				$author$project$Pages$Panel$Classes$Create$isInvalidMaxDayUseCounter(form.aD),
				$author$project$Pages$Panel$Classes$Create$isInvalidMaxMonthUseCounter(form.ao),
				$author$project$Pages$Panel$Classes$Create$isInvalidSubsequentUsePeriod(form.a7),
				$author$project$Pages$Panel$Classes$Create$isInvalidClasseID(form.lX),
				A2($author$project$Pages$Panel$Classes$Create$isInvalidMaxCompanions, form.K, form.aa),
				A2(
				$author$project$Pages$Panel$Classes$Create$isInvalidPaymentRule,
				A2(
					$krisajenkins$remotedata$RemoteData$withDefault,
					_List_Nil,
					A2(
						$krisajenkins$remotedata$RemoteData$map,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$map(
								function ($) {
									return $.c7;
								}),
							$elm$core$List$concat),
						form.al.g)),
				form.l),
				A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					$author$project$Pages$Panel$Classes$Create$isInvalidDefaultPaymentPercent,
					A2($elm$core$Dict$get, 'percent', form.l))),
				A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					$author$project$Pages$Panel$Classes$Create$isInvalidDefaultPaymentValue,
					A2($elm$core$Dict$get, 'value', form.l))),
				A2($author$project$Pages$Panel$Classes$Create$isInvalidWalletTypes, form.bH, form.bI),
				$elm$core$String$isEmpty(form.ba),
				$elm$core$String$isEmpty(form.c3)
			]));
};
var $elm$json$Json$Encode$dict = F3(
	function (toKey, toValue, dictionary) {
		return _Json_wrap(
			A3(
				$elm$core$Dict$foldl,
				F3(
					function (key, value, obj) {
						return A3(
							_Json_addField,
							toKey(key),
							toValue(value),
							obj);
					}),
				_Json_emptyObject(0),
				dictionary));
	});
var $author$project$Services$Classes$encodePaymentRule = function (pr) {
	var maybeValue = F3(
		function (key, encode, maybeV) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (v) {
						return $elm$core$List$singleton(
							_Utils_Tuple2(
								key,
								encode(v)));
					},
					maybeV));
		});
	return $elm$json$Json$Encode$object(
		_Utils_ap(
			A3(maybeValue, 'value', $elm$json$Json$Encode$int, pr.di),
			_Utils_ap(
				A3(maybeValue, 'percent', $elm$json$Json$Encode$float, pr.oT),
				_List_fromArray(
					[
						_Utils_Tuple2(
						'periods',
						A2(
							$elm$json$Json$Encode$list,
							$elm$json$Json$Encode$list($elm$json$Json$Encode$int),
							pr.n))
					]))));
};
var $author$project$Services$Classes$encodeRule = function (rule) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'maxDayUseCounter',
				$elm$json$Json$Encode$int(rule.aD)),
				_Utils_Tuple2(
				'maxMonthUseCounter',
				$elm$json$Json$Encode$int(rule.ao)),
				_Utils_Tuple2(
				'subsequentUsePeriod',
				$elm$json$Json$Encode$int(rule.a7)),
				_Utils_Tuple2(
				'twoSteps',
				$elm$json$Json$Encode$bool(rule.aM)),
				_Utils_Tuple2(
				'companion',
				$elm$json$Json$Encode$bool(rule.K)),
				_Utils_Tuple2(
				'maxCompanions',
				$elm$json$Json$Encode$int(rule.aa)),
				_Utils_Tuple2(
				'paymentRules',
				A2($elm$json$Json$Encode$list, $author$project$Services$Classes$encodePaymentRule, rule.oR)),
				_Utils_Tuple2(
				'defaultPaymentRule',
				A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $elm$json$Json$Encode$float, rule.l))
			]));
};
var $author$project$Services$Classes$encodeWalletClasse = function (options) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(options.c3)),
				_Utils_Tuple2(
				'walletTypeAppID',
				$elm$json$Json$Encode$string(options.qM)),
				_Utils_Tuple2(
				'walletTypeCardID',
				$elm$json$Json$Encode$string(options.qO)),
				_Utils_Tuple2(
				'concessionaireID',
				$elm$json$Json$Encode$string(options.mb)),
				_Utils_Tuple2(
				'priority',
				$elm$json$Json$Encode$int(options.ch)),
				_Utils_Tuple2(
				'classID',
				$elm$json$Json$Encode$int(options.lY)),
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string(options.kY)),
				_Utils_Tuple2(
				'rules',
				A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $author$project$Services$Classes$encodeRule, options.py)),
				_Utils_Tuple2(
				'active',
				$elm$json$Json$Encode$bool(options.at))
			]));
};
var $author$project$Services$Classes$postWalletClasse = function (options) {
	return $author$project$Services$Api$postHttp(
		{
			lG: $elm$http$Http$jsonBody(
				$author$project$Services$Classes$encodeWalletClasse(options.ih)),
			m9: $author$project$Services$Api$expectWhateverErrorString(
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'wallet', 'createWalletClass']),
				_List_Nil)
		});
};
var $author$project$Components$Schedule$CreateNewPeriod = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Schedule$MouseOveredAvailability = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Schedule$Resized = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Schedule$Resizing = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Schedule$ScheduleCloseModal = {$: 1};
var $author$project$Components$Schedule$ScheduleOpenModal = {$: 0};
var $author$project$Components$Schedule$SelectedPeriod = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Schedule$SharedMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Schedule$ToConfirm = 1;
var $author$project$Components$Schedule$isInSelectingRegion = F3(
	function (colIndex, rowIndex, sr) {
		var _v0 = (_Utils_cmp(sr.cv, sr.bm) < 0) ? _Utils_Tuple2(sr.cv, sr.bm) : _Utils_Tuple2(sr.bm, sr.cv);
		var startRowIndex = _v0.a;
		var endRowIndex = _v0.b;
		var _v1 = (_Utils_cmp(sr.cu, sr.bk) < 0) ? _Utils_Tuple2(sr.cu, sr.bk) : _Utils_Tuple2(sr.bk, sr.cu);
		var startColIndex = _v1.a;
		var endColIndex = _v1.b;
		return (_Utils_cmp(startColIndex, colIndex) < 1) && ((_Utils_cmp(colIndex, endColIndex) < 1) && ((_Utils_cmp(startRowIndex, rowIndex) < 1) && (_Utils_cmp(rowIndex, endRowIndex) < 1)));
	});
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$member, key, dict);
	});
var $author$project$Components$Schedule$ToCancel = 2;
var $author$project$Components$Schedule$updateIsSelected = F4(
	function (model, isInSelectingRegion_, maybeAvailability, isSelected) {
		var canSelect = isSelected ? ((isInSelectingRegion_ && _Utils_eq(
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.eT;
				},
				model.ai),
			$elm$core$Maybe$Just(false))) ? false : true) : ((isInSelectingRegion_ && _Utils_eq(
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.eT;
				},
				model.ai),
			$elm$core$Maybe$Just(false))) ? false : isInSelectingRegion_);
		if (canSelect) {
			if (maybeAvailability.$ === 1) {
				return model.bz !== 2;
			} else {
				var availability = maybeAvailability.a;
				return model.bz !== 2;
			}
		} else {
			return false;
		}
	});
var $author$project$Components$Schedule$cellView = F3(
	function (model, index, maybeAvailability) {
		var rowIndex = index % 48;
		var colIndex = (index / 48) | 0;
		var _v0 = function () {
			if (!maybeAvailability.$) {
				var _v2 = maybeAvailability.a;
				var _v3 = _v2.a;
				var isSel = _v2.b;
				return isSel;
			} else {
				return _Utils_Tuple2(
					A2(
						$elm$core$Set$member,
						_Utils_Tuple2(colIndex, rowIndex),
						model.A),
					_Utils_eq(
						A2(
							$elm$core$Maybe$map,
							A2($author$project$Components$Schedule$isInSelectingRegion, colIndex, rowIndex),
							model.ai),
						$elm$core$Maybe$Just(true)));
			}
		}();
		var isSelected = _v0.a;
		var isInSelectingRegion_ = _v0.b;
		var viewAsSelected = A4(
			$author$project$Components$Schedule$updateIsSelected,
			model,
			isInSelectingRegion_,
			A2(
				$elm$core$Maybe$andThen,
				function (_v5) {
					var _v6 = _v5.a;
					var av = _v6.a;
					return $elm$core$Maybe$Just(av);
				},
				maybeAvailability),
			isSelected);
		return {
			g: A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (_v4) {
						var avWithIndex = _v4.a;
						return _List_fromArray(
							[avWithIndex]);
					},
					maybeAvailability)),
			r: colIndex,
			eX: viewAsSelected,
			m: rowIndex
		};
	});
var $author$project$Components$Schedule$availabilityToCellViews = F4(
	function (model, availabilities, period, _v0) {
		var acc = _v0.a;
		var prevLastIndex = _v0.b;
		var startIndex = function () {
			var startDay = period.a;
			var startBlock = period.b;
			return (startDay * 48) + startBlock;
		}();
		var startRowIndex = startIndex % 48;
		var startColIndex = (startIndex / 48) | 0;
		var previousEmptyCellsCount = startIndex - prevLastIndex;
		var availability30minutesBlocks = _List_fromArray(
			[0]);
		var availability = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (av) {
					return A2(
						$elm$core$List$any,
						function (days) {
							return A2(
								$elm$core$List$any,
								$elm$core$Basics$eq(period),
								days);
						},
						av.n);
				},
				availabilities));
		var _v1 = _Utils_Tuple2(
			((!prevLastIndex) && (previousEmptyCellsCount < 0)) ? A2(
				$elm$core$Set$member,
				_Utils_Tuple2(0, 0),
				model.A) : A2(
				$elm$core$Set$member,
				_Utils_Tuple2(startColIndex, startRowIndex),
				model.A),
			function () {
				var _v2 = model.ai;
				if (_v2.$ === 1) {
					return false;
				} else {
					var selectingRegion = _v2.a;
					return A2(
						$elm$core$List$member,
						true,
						A2(
							$elm$core$List$map,
							function (avIndex) {
								var index = startIndex + avIndex;
								var rowIndex = index % 48;
								var colIndex = (index / 48) | 0;
								return A3($author$project$Components$Schedule$isInSelectingRegion, colIndex, rowIndex, selectingRegion);
							},
							availability30minutesBlocks));
				}
			}());
		var isSelected = _v1.a;
		var isInSelectingRegion_ = _v1.b;
		var availabilityCells = A2(
			$elm$core$List$map,
			function (avIndex) {
				return A3(
					$author$project$Components$Schedule$cellView,
					model,
					startIndex + avIndex,
					A2(
						$elm$core$Maybe$andThen,
						function (av_) {
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(
									_Utils_Tuple2(av_, avIndex),
									_Utils_Tuple2(isSelected, isInSelectingRegion_)));
						},
						availability));
			},
			availability30minutesBlocks);
		var _v3 = _Utils_Tuple2(period, availability);
		if (previousEmptyCellsCount < 0) {
			var _v4 = _Utils_Tuple2(
				$elm$core$List$reverse(acc),
				availabilityCells);
			if (_v4.a.b && _v4.b.b) {
				var _v5 = _v4.a;
				var lastCell = _v5.a;
				var cellsTail = _v5.b;
				var _v6 = _v4.b;
				var fistAvCell = _v6.a;
				var avCellsTail = _v6.b;
				return _Utils_Tuple2(
					_Utils_ap(
						$elm$core$List$reverse(cellsTail),
						A2(
							$elm$core$List$cons,
							_Utils_update(
								fistAvCell,
								{
									g: _Utils_ap(lastCell.g, fistAvCell.g)
								}),
							avCellsTail)),
					prevLastIndex + ($elm$core$List$length(availabilityCells) - 1));
			} else {
				var cells = A2(
					$elm$core$List$drop,
					$elm$core$Basics$abs(previousEmptyCellsCount),
					availabilityCells);
				return _Utils_Tuple2(
					_Utils_ap(acc, cells),
					prevLastIndex + $elm$core$List$length(cells));
			}
		} else {
			var previousEmptyCells = (0 < previousEmptyCellsCount) ? A2(
				$elm$core$List$map,
				function (cIndex) {
					return A3($author$project$Components$Schedule$cellView, model, prevLastIndex + cIndex, $elm$core$Maybe$Nothing);
				},
				A2($elm$core$List$range, 0, previousEmptyCellsCount - 1)) : _List_Nil;
			var cells = _Utils_ap(previousEmptyCells, availabilityCells);
			return _Utils_Tuple2(
				_Utils_ap(acc, cells),
				prevLastIndex + $elm$core$List$length(cells));
		}
	});
var $author$project$Components$Schedule$emptyGrid = A2(
	$elm$core$List$map,
	function (colIndex) {
		return A2(
			$elm$core$List$map,
			function (rowIndex) {
				return {g: _List_Nil, r: colIndex, eX: false, m: rowIndex};
			},
			A2($elm$core$List$range, 0, 47));
	},
	A2($elm$core$List$range, 0, 6));
var $elm_community$list_extra$List$Extra$groupsOfWithStep = F3(
	function (size, step, xs) {
		var xs_ = A2($elm$core$List$drop, step, xs);
		var thisGroup = A2($elm$core$List$take, size, xs);
		var okayLength = _Utils_eq(
			size,
			$elm$core$List$length(thisGroup));
		var okayArgs = (size > 0) && (step > 0);
		return (okayArgs && okayLength) ? A2(
			$elm$core$List$cons,
			thisGroup,
			A3($elm_community$list_extra$List$Extra$groupsOfWithStep, size, step, xs_)) : _List_Nil;
	});
var $elm_community$list_extra$List$Extra$groupsOf = F2(
	function (size, xs) {
		return A3($elm_community$list_extra$List$Extra$groupsOfWithStep, size, size, xs);
	});
var $author$project$Components$Schedule$availabilitiesToCellViews = function (model) {
	var _v0 = model.g;
	if (_v0.$ === 3) {
		var availabilities = _v0.a;
		var periods = $elm$core$List$sort(
			$elm$core$List$concat(
				$elm$core$List$concat(
					A2(
						$elm$core$List$map,
						function ($) {
							return $.n;
						},
						availabilities))));
		var cellsUntilLastAvailability = A3(
			$elm$core$List$foldl,
			A2($author$project$Components$Schedule$availabilityToCellViews, model, availabilities),
			_Utils_Tuple2(_List_Nil, 0),
			periods).a;
		var cellsUntilLastAvailabilityLength = $elm$core$List$length(cellsUntilLastAvailability);
		var remainCellsCount = 336 - cellsUntilLastAvailabilityLength;
		var remainCells = (0 < remainCellsCount) ? A2(
			$elm$core$List$map,
			function (cIndex) {
				return A3($author$project$Components$Schedule$cellView, model, cellsUntilLastAvailabilityLength + cIndex, $elm$core$Maybe$Nothing);
			},
			A2($elm$core$List$range, 0, remainCellsCount - 1)) : _List_Nil;
		return A2(
			$elm$core$List$take,
			7,
			A2(
				$elm_community$list_extra$List$Extra$groupsOf,
				48,
				_Utils_ap(cellsUntilLastAvailability, remainCells)));
	} else {
		return $author$project$Components$Schedule$emptyGrid;
	}
};
var $author$project$Components$Schedule$availability30minutesBlocksLength = function (availability) {
	return $elm$core$List$length(availability.n);
};
var $author$project$Components$Schedule$ViewRequest = {$: 1};
var $author$project$Utils$Time$calculate = F3(
	function (date1, calcFun, date2) {
		return A2(
			calcFun,
			$elm$time$Time$posixToMillis(date1),
			$elm$time$Time$posixToMillis(date2));
	});
var $author$project$Components$Schedule$dayInMillis1 = ((1000 * 60) * 60) * 24;
var $author$project$Components$Schedule$minutesInMillis30 = (30 * 60) * 1000;
var $author$project$Components$Schedule$cellToPeriod = F2(
	function (currentWeekStart, _v0) {
		var colIndex = _v0.a;
		var rowIndex = _v0.b;
		var currentWeekStartMillis = $elm$time$Time$posixToMillis(currentWeekStart);
		var cellStartTimeMillis = (currentWeekStartMillis + (colIndex * $author$project$Components$Schedule$dayInMillis1)) + (rowIndex * $author$project$Components$Schedule$minutesInMillis30);
		return _Utils_Tuple2(
			$elm$time$Time$millisToPosix(cellStartTimeMillis),
			$elm$time$Time$millisToPosix(cellStartTimeMillis + $author$project$Components$Schedule$minutesInMillis30));
	});
var $author$project$Components$Schedule$cellStartEndEnd = F2(
	function (currentWeek, _v0) {
		var colIndex = _v0.a;
		var rowIndex = _v0.b;
		return A2(
			$author$project$Components$Schedule$cellToPeriod,
			currentWeek,
			_Utils_Tuple2(colIndex, rowIndex));
	});
var $author$project$Components$Schedule$getCellAvailabilities = F4(
	function (shared, model, colIndex, rowIndex) {
		var _v0 = model.g;
		if (_v0.$ === 3) {
			var availabilities = _v0.a;
			var _v1 = A2(
				$author$project$Components$Schedule$cellStartEndEnd,
				model.bT,
				_Utils_Tuple2(colIndex, rowIndex));
			var cellStart = _v1.a;
			var cellEnd = _v1.b;
			return $elm$core$Maybe$Just(
				A2(
					$elm$core$List$filter,
					function (av) {
						return A2(
							$elm$core$List$any,
							function (days) {
								return A2(
									$elm$core$List$any,
									$elm$core$Basics$eq(
										_Utils_Tuple2(colIndex, rowIndex)),
									days);
							},
							av.n);
					},
					availabilities));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Schedule$clickedTimeSlot = F5(
	function (now, model, shared, colIndex, rowIndex) {
		var maybeAvailabilitiesClicked = A4($author$project$Components$Schedule$getCellAvailabilities, shared, model, colIndex, rowIndex);
		var ifNowIsAfter = F2(
			function (time_, _return) {
				return A3($author$project$Utils$Time$calculate, time_, $elm$core$Basics$lt, now) ? _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Schedule$SharedMsg(
						$author$project$Shared$ShowErrorDialog('Não é possível alterar eventos passados.'))) : _return;
			});
		if (!maybeAvailabilitiesClicked.$) {
			if (maybeAvailabilitiesClicked.a.b && (!maybeAvailabilitiesClicked.a.b.b)) {
				var _v1 = maybeAvailabilitiesClicked.a;
				var availability = _v1.a;
				var isResizing = function () {
					var _v3 = model.I;
					switch (_v3.$) {
						case 2:
							var r = _v3.a;
							return _Utils_eq(r.dM, availability.dM);
						case 3:
							var r = _v3.a;
							return _Utils_eq(r.dM, availability.dM);
						default:
							return false;
					}
				}();
				if (isResizing) {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Components$Schedule$SharedMsg($author$project$Shared$NoOp));
				} else {
					var _v2 = model.aZ;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aY: $elm$core$Maybe$Just($author$project$Components$Schedule$ViewRequest)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Components$Schedule$SharedMsg($author$project$Shared$NoOp));
				}
			} else {
				var availabilities = maybeAvailabilitiesClicked.a;
				var filterIsClickable = function (s) {
					return true;
				};
				var _v4 = _Utils_Tuple2(
					model.aZ,
					A2($elm$core$List$filter, filterIsClickable, availabilities));
				if (!_v4.b.b) {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Components$Schedule$SharedMsg($author$project$Shared$NoOp));
				} else {
					var _v5 = _v4.a;
					var availabilitiesFiltered = _v4.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aY: $elm$core$Maybe$Just($author$project$Components$Schedule$ViewRequest)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Components$Schedule$SharedMsg($author$project$Shared$NoOp));
				}
			}
		} else {
			return _Utils_Tuple3(
				model,
				$elm$core$Platform$Cmd$none,
				$author$project$Components$Schedule$SharedMsg($author$project$Shared$NoOp));
		}
	});
var $elm_community$list_extra$List$Extra$find = F2(
	function (predicate, list) {
		find:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var first = list.a;
				var rest = list.b;
				if (predicate(first)) {
					return $elm$core$Maybe$Just(first);
				} else {
					var $temp$predicate = predicate,
						$temp$list = rest;
					predicate = $temp$predicate;
					list = $temp$list;
					continue find;
				}
			}
		}
	});
var $author$project$Components$Schedule$getCellAvailability = F4(
	function (shared, model, colIndex, rowIndex) {
		var _v0 = model.g;
		if (_v0.$ === 3) {
			var availabilities = _v0.a;
			var _v1 = A2(
				$author$project$Components$Schedule$cellStartEndEnd,
				model.bT,
				_Utils_Tuple2(colIndex, rowIndex));
			var cellStart = _v1.a;
			var cellEnd = _v1.b;
			return $elm$core$List$head(
				$elm$core$List$reverse(
					A2(
						$elm$core$List$filter,
						function (av) {
							return A2(
								$elm$core$List$any,
								function (days) {
									return A2(
										$elm$core$List$any,
										$elm$core$Basics$eq(
											_Utils_Tuple2(colIndex, rowIndex)),
										days);
								},
								av.n);
						},
						availabilities)));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Schedule$getSelected = F2(
	function (shared, model) {
		return $elm$core$List$reverse(
			A3(
				$elm$core$List$foldl,
				F2(
					function (maybeAv, acc) {
						if (acc.b) {
							if (acc.a.$ === 1) {
								var _v2 = acc.a;
								var tail = acc.b;
								return A2($elm$core$List$cons, maybeAv, acc);
							} else {
								var prevAv = acc.a.a;
								var tail = acc.b;
								if (maybeAv.$ === 1) {
									return A2($elm$core$List$cons, maybeAv, acc);
								} else {
									var av = maybeAv.a;
									return _Utils_eq(av.dM, prevAv.dM) ? acc : A2($elm$core$List$cons, maybeAv, acc);
								}
							}
						} else {
							return _List_fromArray(
								[maybeAv]);
						}
					}),
				_List_Nil,
				A2(
					$elm$core$List$map,
					function (_v0) {
						var c = _v0.a;
						var i = _v0.b;
						return A4($author$project$Components$Schedule$getCellAvailability, shared, model, c, i);
					},
					$elm$core$Set$toList(model.A))));
	});
var $author$project$Components$Schedule$getSelectionStatus = F2(
	function (shared, model) {
		var selected = A2($author$project$Components$Schedule$getSelected, shared, model);
		var hasSelectedEmptyCell = A2($elm$core$List$member, $elm$core$Maybe$Nothing, selected);
		var _v0 = model.aZ;
		return hasSelectedEmptyCell ? 1 : 0;
	});
var $elm$core$List$partition = F2(
	function (pred, list) {
		var step = F2(
			function (x, _v0) {
				var trues = _v0.a;
				var falses = _v0.b;
				return pred(x) ? _Utils_Tuple2(
					A2($elm$core$List$cons, x, trues),
					falses) : _Utils_Tuple2(
					trues,
					A2($elm$core$List$cons, x, falses));
			});
		return A3(
			$elm$core$List$foldr,
			step,
			_Utils_Tuple2(_List_Nil, _List_Nil),
			list);
	});
var $author$project$Components$Schedule$positionToPeriods = function (listPositions) {
	var minutesInDay = 24 * 60;
	var minutesInBlock = 30;
	var periodToMinutes = function (_v6) {
		var day = _v6.a;
		var block = _v6.b;
		return (day * minutesInDay) + (block * minutesInBlock);
	};
	var groupPeriods = function (periods) {
		var step = F2(
			function (period, _v5) {
				var maybeCurrentGroup = _v5.a;
				var acc = _v5.b;
				if (maybeCurrentGroup.$ === 1) {
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_List_fromArray(
								[period])),
						acc);
				} else {
					var currentGroup = maybeCurrentGroup.a;
					var previousPeriod = $elm$core$List$head(
						$elm$core$List$reverse(currentGroup));
					if (previousPeriod.$ === 1) {
						return _Utils_Tuple2(
							$elm$core$Maybe$Just(
								_List_fromArray(
									[period])),
							acc);
					} else {
						var prev = previousPeriod.a;
						return _Utils_eq(
							periodToMinutes(period),
							periodToMinutes(prev) + minutesInBlock) ? _Utils_Tuple2(
							$elm$core$Maybe$Just(
								_Utils_ap(
									currentGroup,
									_List_fromArray(
										[period]))),
							acc) : _Utils_Tuple2(
							$elm$core$Maybe$Just(
								_List_fromArray(
									[period])),
							_Utils_ap(
								acc,
								_List_fromArray(
									[currentGroup])));
					}
				}
			});
		var sortedPeriods = A2($elm$core$List$sortBy, periodToMinutes, periods);
		var _v1 = A3(
			$elm$core$List$foldl,
			step,
			_Utils_Tuple2($elm$core$Maybe$Nothing, _List_Nil),
			sortedPeriods);
		if (_v1.a.$ === 1) {
			var _v2 = _v1.a;
			var acc = _v1.b;
			return acc;
		} else {
			var lastGroup = _v1.a.a;
			var acc = _v1.b;
			return _Utils_ap(
				acc,
				_List_fromArray(
					[lastGroup]));
		}
	};
	var groupAndConvert = function (periods) {
		var groups = groupPeriods(periods);
		return A2(
			$elm$core$List$map,
			function (group) {
				var start = periodToMinutes(
					A2(
						$elm$core$Maybe$withDefault,
						_Utils_Tuple2(0, 0),
						$elm$core$List$head(group)));
				var end = periodToMinutes(
					A2(
						$elm$core$Maybe$withDefault,
						_Utils_Tuple2(0, 0),
						$elm$core$List$head(
							$elm$core$List$reverse(group)))) + minutesInBlock;
				return _Utils_Tuple2(start, end);
			},
			groups);
	};
	var convertFromNestedList = function (nestedPeriods) {
		var flatPeriods = $elm$core$List$concat(nestedPeriods);
		return groupAndConvert(flatPeriods);
	};
	return A2(
		$elm$core$List$map,
		function (_v0) {
			var s = _v0.a;
			var e = _v0.b;
			return _List_fromArray(
				[s, e]);
		},
		convertFromNestedList(listPositions));
};
var $elm$core$Dict$filter = F2(
	function (isGood, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, d) {
					return A2(isGood, k, v) ? A3($elm$core$Dict$insert, k, v, d) : d;
				}),
			$elm$core$Dict$empty,
			dict);
	});
var $elm$core$Set$filter = F2(
	function (isGood, _v0) {
		var dict = _v0;
		return A2(
			$elm$core$Dict$filter,
			F2(
				function (key, _v1) {
					return isGood(key);
				}),
			dict);
	});
var $elm$core$Set$isEmpty = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$isEmpty(dict);
};
var $author$project$Components$Schedule$nowIndexes = F2(
	function (currentWeekStart, now) {
		var diff = $elm$time$Time$posixToMillis(now) - $elm$time$Time$posixToMillis(currentWeekStart);
		var nowColIndex = (diff / $author$project$Components$Schedule$dayInMillis1) | 0;
		var remainDayMillis = diff % $author$project$Components$Schedule$dayInMillis1;
		var rowIndex = (remainDayMillis / $author$project$Components$Schedule$minutesInMillis30) | 0;
		return {r: nowColIndex, jc: (nowColIndex * 48) + rowIndex, hn: remainDayMillis % $author$project$Components$Schedule$minutesInMillis30, m: rowIndex, kR: now};
	});
var $author$project$Components$Schedule$selectRegion = F3(
	function (now_, shared, model) {
		var periods = $elm$core$List$concat(
			$elm$core$List$concat(
				A2(
					$krisajenkins$remotedata$RemoteData$withDefault,
					_List_Nil,
					A2(
						$krisajenkins$remotedata$RemoteData$map,
						$elm$core$List$map(
							function ($) {
								return $.n;
							}),
						model.g))));
		var origin = A2($elm$core$Maybe$withDefault, '-', model.af);
		var now = A2($author$project$Components$Schedule$nowIndexes, model.bT, now_);
		var newSelectedCells = $elm$core$Set$fromList(
			A2(
				$elm$core$List$map,
				function (cv) {
					return _Utils_Tuple2(cv.r, cv.m);
				},
				A2(
					$elm$core$List$filter,
					function ($) {
						return $.eX;
					},
					$elm$core$List$concat(
						$author$project$Components$Schedule$availabilitiesToCellViews(model)))));
		var filterNewSelectedCells = function () {
			if (origin === '-') {
				return A2(
					$elm$core$Set$filter,
					function (s) {
						return !A2(
							$elm$core$List$any,
							$elm$core$Basics$eq(s),
							periods);
					},
					newSelectedCells);
			} else {
				var getPeriodsAvailability = $elm$core$List$concat(
					$elm$core$List$concat(
						A2(
							$krisajenkins$remotedata$RemoteData$withDefault,
							_List_Nil,
							A2(
								$krisajenkins$remotedata$RemoteData$map,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$List$filter(
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.dM;
											},
											$elm$core$Basics$eq(origin))),
									$elm$core$List$map(
										function ($) {
											return $.n;
										})),
								model.g))));
				return A2(
					$elm$core$Set$filter,
					function (s) {
						return A2(
							$elm$core$List$any,
							$elm$core$Basics$eq(s),
							getPeriodsAvailability);
					},
					newSelectedCells);
			}
		}();
		var allBudgetsSelectedBeingEqual = function () {
			var _v0 = model.af;
			if (!_v0.$) {
				var selectedAvailabilityID = _v0.a;
				return A2(
					$elm$core$List$filter,
					function (x) {
						return _Utils_eq(x, selectedAvailabilityID);
					},
					model.aC);
			} else {
				return _List_Nil;
			}
		}();
		return (_Utils_eq(
			$elm$core$List$length(allBudgetsSelectedBeingEqual),
			$elm$core$List$length(model.aC)) && (!$elm$core$Set$isEmpty(filterNewSelectedCells))) ? _Utils_update(
			model,
			{A: filterNewSelectedCells}) : _Utils_update(
			model,
			{aC: _List_Nil, af: $elm$core$Maybe$Nothing, A: $elm$core$Set$empty});
	});
var $krisajenkins$remotedata$RemoteData$toMaybe = A2(
	$elm$core$Basics$composeR,
	$krisajenkins$remotedata$RemoteData$map($elm$core$Maybe$Just),
	$krisajenkins$remotedata$RemoteData$withDefault($elm$core$Maybe$Nothing));
var $author$project$Components$Schedule$update = F3(
	function (msg, model, shared) {
		var now_ = $elm$time$Time$millisToPosix(1721012400000);
		switch (msg.$) {
			case 0:
				var colIndex = msg.a;
				var rowIndex = msg.b;
				return A5($author$project$Components$Schedule$clickedTimeSlot, now_, model, shared, colIndex, rowIndex);
			case 1:
				var colIndex = msg.a;
				var rowIndex = msg.b;
				var _v1 = model.ai;
				if (_v1.$ === 1) {
					var maybeAvailabilityOvered = A4($author$project$Components$Schedule$getCellAvailability, shared, model, colIndex, rowIndex);
					var isResizable = function (av) {
						return false;
					};
					var newResize = _Utils_Tuple3(
						function () {
							var _v3 = A2(
								$elm$core$Maybe$map,
								function (av) {
									return _Utils_Tuple2(
										isResizable(av),
										av);
								},
								maybeAvailabilityOvered);
							if ((!_v3.$) && _v3.a.a) {
								var _v4 = _v3.a;
								var av = _v4.b;
								return _Utils_update(
									model,
									{
										I: $author$project$Components$Schedule$MouseOveredAvailability(av.dM)
									});
							} else {
								return _Utils_update(
									model,
									{I: $author$project$Components$Schedule$NotResizing});
							}
						}(),
						$elm$core$Platform$Cmd$none,
						$author$project$Components$Schedule$SharedMsg($author$project$Shared$NoOp));
					var _v2 = model.I;
					switch (_v2.$) {
						case 0:
							return newResize;
						case 1:
							return newResize;
						case 2:
							var r = _v2.a;
							var updtResizing = $author$project$Components$Schedule$Resizing(
								_Utils_update(
									r,
									{aU: rowIndex}));
							var resizeLength = r.c$ ? (rowIndex - r.aL) : (r.aL - rowIndex);
							var maybeAvailability = A2(
								$elm_community$list_extra$List$Extra$find,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.dM;
									},
									$elm$core$Basics$eq(r.dM)),
								A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, model.g));
							var isResizeAfterNow = true;
							var availabilityLength = A2(
								$elm$core$Maybe$withDefault,
								0,
								A2($elm$core$Maybe$map, $author$project$Components$Schedule$availability30minutesBlocksLength, maybeAvailability));
							return _Utils_Tuple3(
								((0 <= resizeLength) && ((0 < (availabilityLength - resizeLength)) && isResizeAfterNow)) ? _Utils_update(
									model,
									{I: updtResizing}) : model,
								$elm$core$Platform$Cmd$none,
								$author$project$Components$Schedule$SharedMsg($author$project$Shared$NoOp));
						default:
							return _Utils_Tuple3(
								model,
								$elm$core$Platform$Cmd$none,
								$author$project$Components$Schedule$SharedMsg($author$project$Shared$NoOp));
					}
				} else {
					var selectingRegion = _v1.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ai: $elm$core$Maybe$Just(
									_Utils_update(
										selectingRegion,
										{bk: colIndex, bm: rowIndex}))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Components$Schedule$SharedMsg($author$project$Shared$NoOp));
				}
			case 2:
				var colIndex = msg.a;
				var rowIndex = msg.b;
				var _v5 = A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(false, $elm$core$Maybe$Nothing),
					$elm$core$List$head(
						A2(
							$elm$core$List$filterMap,
							function (cv) {
								if (_Utils_eq(cv.r, colIndex) && _Utils_eq(cv.m, rowIndex)) {
									var maybeAvailability = $elm$core$List$head(
										$elm$core$List$reverse(cv.g));
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											cv.eX,
											A2(
												$elm$core$Maybe$andThen,
												function (_v6) {
													var av = _v6.a;
													var idx = _v6.b;
													return $elm$core$Maybe$Just(
														_Utils_Tuple2(av, idx));
												},
												maybeAvailability)));
								} else {
									return $elm$core$Maybe$Nothing;
								}
							},
							$elm$core$List$concat(
								$author$project$Components$Schedule$availabilitiesToCellViews(model)))));
				var isSelected = _v5.a;
				var maybeCellAvailability = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aC: A2(
								$elm$core$List$append,
								model.aC,
								function () {
									if (maybeCellAvailability.$ === 1) {
										return _List_fromArray(
											['-']);
									} else {
										var _v8 = maybeCellAvailability.a;
										var av = _v8.a;
										return _List_fromArray(
											[av.dM]);
									}
								}()),
							af: function () {
								if (maybeCellAvailability.$ === 1) {
									return $elm$core$Maybe$Just('-');
								} else {
									var _v10 = maybeCellAvailability.a;
									var av = _v10.a;
									return $elm$core$Maybe$Just(av.dM);
								}
							}(),
							ai: $elm$core$Maybe$Just(
								{bk: colIndex, bm: rowIndex, eT: !isSelected, cu: colIndex, cv: rowIndex}),
							bz: function () {
								var _v11 = model.bz;
								if (!_v11) {
									var _v12 = model.aZ;
									return 1;
								} else {
									return model.bz;
								}
							}()
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Schedule$SharedMsg($author$project$Shared$NoOp));
			case 3:
				var isTop = msg.a;
				var startRow = msg.b;
				return _Utils_Tuple3(
					function () {
						var _v13 = model.I;
						if (_v13.$ === 1) {
							var id = _v13.a;
							return _Utils_update(
								model,
								{
									I: $author$project$Components$Schedule$Resizing(
										{aU: startRow, dM: id, c$: isTop, aL: startRow})
								});
						} else {
							return model;
						}
					}(),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Schedule$SharedMsg($author$project$Shared$NoOp));
			case 4:
				var updateSelectionStatus = function (m) {
					return _Utils_update(
						m,
						{
							bz: A2($author$project$Components$Schedule$getSelectionStatus, shared, m)
						});
				};
				var updateSelectedList = function (model_) {
					return model_;
				};
				var updateResizing = function (m) {
					var _v15 = m.I;
					if (_v15.$ === 2) {
						var r = _v15.a;
						if (_Utils_eq(r.aL, r.aU)) {
							return _Utils_Tuple3(
								_Utils_update(
									m,
									{I: $author$project$Components$Schedule$NotResizing}),
								$elm$core$Platform$Cmd$none,
								$author$project$Components$Schedule$SharedMsg($author$project$Shared$NoOp));
						} else {
							var maybeAvailability = A2(
								$elm$core$Maybe$andThen,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$List$filter(
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.dM;
											},
											$elm$core$Basics$eq(r.dM))),
									$elm$core$List$head),
								$krisajenkins$remotedata$RemoteData$toMaybe(model.g));
							if (maybeAvailability.$ === 1) {
								return _Utils_Tuple3(
									_Utils_update(
										m,
										{I: $author$project$Components$Schedule$NotResizing}),
									$elm$core$Platform$Cmd$none,
									$author$project$Components$Schedule$SharedMsg($author$project$Shared$NoOp));
							} else {
								var av = maybeAvailability.a;
								return _Utils_Tuple3(
									_Utils_update(
										m,
										{
											I: A2(
												$author$project$Components$Schedule$Resized,
												{aU: r.aU, dM: r.dM, c$: r.c$, aL: r.aL},
												$krisajenkins$remotedata$RemoteData$Loading)
										}),
									$elm$core$Platform$Cmd$none,
									$author$project$Components$Schedule$SharedMsg($author$project$Shared$NoOp));
							}
						}
					} else {
						return _Utils_Tuple3(
							m,
							$elm$core$Platform$Cmd$none,
							$author$project$Components$Schedule$SharedMsg($author$project$Shared$NoOp));
					}
				};
				var _v14 = model.ai;
				if (_v14.$ === 1) {
					return updateResizing(
						updateSelectionStatus(model));
				} else {
					var selectingRegion = _v14.a;
					return updateResizing(
						updateSelectedList(
							updateSelectionStatus(
								function (m) {
									return _Utils_update(
										m,
										{ai: $elm$core$Maybe$Nothing});
								}(
									A3($author$project$Components$Schedule$selectRegion, now_, shared, model)))));
				}
			case 5:
				var getAvailability = A2(
					$krisajenkins$remotedata$RemoteData$withDefault,
					$elm$core$Maybe$Nothing,
					A2(
						$krisajenkins$remotedata$RemoteData$map,
						function (avs) {
							return $elm$core$List$head(
								A2(
									$elm$core$List$filter,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.dM;
										},
										$elm$core$Basics$eq(
											A2($elm$core$Maybe$withDefault, '-', model.af))),
									avs));
						},
						model.g));
				if (!getAvailability.$) {
					var availability = getAvailability.a;
					var periodsToRemove = $elm$core$Set$toList(model.A);
					var updatePeriods = A2(
						$elm$core$List$map,
						function (blocksDay) {
							return A2(
								$elm$core$List$filter,
								function (b) {
									return !A2(
										$elm$core$List$any,
										$elm$core$Basics$eq(b),
										periodsToRemove);
								},
								blocksDay);
						},
						availability.n);
					var newAvailability = _Utils_update(
						availability,
						{
							n: updatePeriods,
							c7: $author$project$Components$Schedule$positionToPeriods(updatePeriods)
						});
					var setAvailability = A2(
						$krisajenkins$remotedata$RemoteData$map,
						function (avs) {
							return A2(
								$elm$core$List$filterMap,
								function (av) {
									return (_Utils_eq(av.dM, newAvailability.dM) && (!$elm$core$List$isEmpty(
										$elm$core$List$concat(updatePeriods)))) ? $elm$core$Maybe$Just(newAvailability) : ((_Utils_eq(av.dM, newAvailability.dM) && $elm$core$List$isEmpty(
										$elm$core$List$concat(updatePeriods))) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(av));
								},
								avs);
						},
						model.g);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{g: setAvailability, aC: _List_Nil, af: $elm$core$Maybe$Nothing, A: $elm$core$Set$empty}),
						$elm$core$Platform$Cmd$none,
						$author$project$Components$Schedule$SharedMsg($author$project$Shared$NoOp));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Components$Schedule$SharedMsg(
							$author$project$Shared$ShowErrorDialog('Não foi possível encontrar o período')));
				}
			case 6:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aY: $elm$core$Maybe$Just(
								$author$project$Components$Schedule$SelectedPeriod(
									{L: 0, cm: ''}))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Schedule$ScheduleOpenModal);
			case 7:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aY: $elm$core$Maybe$Just(
								$author$project$Components$Schedule$CreateNewPeriod(
									{lo: 0, L: 0, ah: 'percent'}))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Schedule$ScheduleOpenModal);
			case 11:
				var newAmountType = msg.a;
				var _v18 = model.aY;
				if ((!_v18.$) && (_v18.a.$ === 7)) {
					var m = _v18.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aY: $elm$core$Maybe$Just(
									$author$project$Components$Schedule$CreateNewPeriod(
										_Utils_update(
											m,
											{ah: newAmountType})))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Components$Schedule$SharedMsg($author$project$Shared$NoOp));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Components$Schedule$SharedMsg($author$project$Shared$NoOp));
				}
			case 12:
				var newAmountStr = msg.a;
				var _v19 = _Utils_Tuple2(
					model.aY,
					$elm$core$String$toInt(newAmountStr));
				if ((!_v19.a.$) && (_v19.a.a.$ === 7)) {
					if (!_v19.b.$) {
						var m = _v19.a.a.a;
						var newAmount = _v19.b.a;
						return ((m.ah === 'percent') && ((newAmount >= 0) && (newAmount <= 200))) ? _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $elm$core$Maybe$Just(
										$author$project$Components$Schedule$CreateNewPeriod(
											_Utils_update(
												m,
												{lo: newAmount})))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Components$Schedule$SharedMsg($author$project$Shared$NoOp)) : (((m.ah === 'value') && ((newAmount >= 0) && (newAmount <= 4000))) ? _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $elm$core$Maybe$Just(
										$author$project$Components$Schedule$CreateNewPeriod(
											_Utils_update(
												m,
												{lo: newAmount})))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Components$Schedule$SharedMsg($author$project$Shared$NoOp)) : _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$Components$Schedule$SharedMsg($author$project$Shared$NoOp)));
					} else {
						var m = _v19.a.a.a;
						var _v20 = _v19.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $elm$core$Maybe$Just(
										$author$project$Components$Schedule$CreateNewPeriod(
											_Utils_update(
												m,
												{lo: 0})))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Components$Schedule$SharedMsg($author$project$Shared$NoOp));
					}
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Components$Schedule$SharedMsg($author$project$Shared$NoOp));
				}
			case 8:
				var avID = msg.a;
				var _v21 = model.aY;
				if ((!_v21.$) && (_v21.a.$ === 6)) {
					var m = _v21.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aY: $elm$core$Maybe$Just(
									$author$project$Components$Schedule$SelectedPeriod(
										_Utils_update(
											m,
											{cm: avID})))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Components$Schedule$SharedMsg($author$project$Shared$NoOp));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Components$Schedule$SharedMsg(
							$author$project$Shared$ShowErrorDialog('Algo deu errado, entre em contato com o suporte')));
				}
			case 9:
				var modal = msg.a;
				var getAvailability = A2(
					$krisajenkins$remotedata$RemoteData$withDefault,
					$elm$core$Maybe$Nothing,
					A2(
						$krisajenkins$remotedata$RemoteData$map,
						function (avs) {
							return $elm$core$List$head(
								A2(
									$elm$core$List$filter,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.dM;
										},
										$elm$core$Basics$eq(modal.cm)),
									avs));
						},
						model.g));
				var _v22 = _Utils_Tuple2(modal.cm !== '', getAvailability);
				if (_v22.a && (!_v22.b.$)) {
					var availability = _v22.b.a;
					var periodsToAdd = $elm$core$Set$toList(model.A);
					var addToList = F2(
						function (_v29, lists) {
							var a = _v29.a;
							var b = _v29.b;
							var _v23 = A2(
								$elm$core$List$partition,
								$elm$core$List$any(
									function (_v24) {
										var x = _v24.a;
										return _Utils_eq(x, a);
									}),
								lists);
							var found = _v23.a;
							var notFound = _v23.b;
							if (!found.b) {
								return $elm$core$List$sort(
									A2(
										$elm$core$List$cons,
										A2(
											$elm$core$List$sortBy,
											function (_v26) {
												var y = _v26.b;
												return y;
											},
											A2(
												$elm$core$List$cons,
												_Utils_Tuple2(a, b),
												_List_Nil)),
										lists));
							} else {
								return A2(
									$elm$core$List$map,
									function (sublist) {
										return A2(
											$elm$core$List$any,
											function (_v27) {
												var x = _v27.a;
												return _Utils_eq(x, a);
											},
											sublist) ? A2(
											$elm$core$List$sortBy,
											function (_v28) {
												var y = _v28.b;
												return y;
											},
											A2(
												$elm$core$List$cons,
												_Utils_Tuple2(a, b),
												sublist)) : sublist;
									},
									lists);
							}
						});
					var processLists = F2(
						function (initialList, newList) {
							return A3($elm$core$List$foldl, addToList, initialList, newList);
						});
					var updatePeriods = A2(processLists, availability.n, periodsToAdd);
					var newAvailability = _Utils_update(
						availability,
						{
							n: updatePeriods,
							c7: $author$project$Components$Schedule$positionToPeriods(updatePeriods)
						});
					var setAvailability = A2(
						$krisajenkins$remotedata$RemoteData$map,
						function (avs) {
							return A2(
								$elm$core$List$map,
								function (av) {
									return _Utils_eq(av.dM, newAvailability.dM) ? newAvailability : av;
								},
								avs);
						},
						model.g);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{g: setAvailability, aC: _List_Nil, aY: $elm$core$Maybe$Nothing, af: $elm$core$Maybe$Nothing, A: $elm$core$Set$empty}),
						$elm$core$Platform$Cmd$none,
						$author$project$Components$Schedule$ScheduleCloseModal);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aY: $elm$core$Maybe$Just(
									$author$project$Components$Schedule$SelectedPeriod(
										_Utils_update(
											modal,
											{L: 1})))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Components$Schedule$SharedMsg(
							$author$project$Shared$ShowErrorDialog('Algo deu errado, entre em contato com o suporte')));
				}
			case 10:
				var m = msg.a;
				var periodsToAdd = $elm$core$Set$toList(model.A);
				var generateColorAndID = $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (c) {
							return !A2(
								$elm$core$List$any,
								$elm$core$Basics$eq(c),
								A2(
									$krisajenkins$remotedata$RemoteData$withDefault,
									_List_Nil,
									A2(
										$krisajenkins$remotedata$RemoteData$map,
										$elm$core$List$map(
											function ($) {
												return $.cK;
											}),
										model.g)));
						},
						$author$project$Components$Schedule$colors));
				var addToList = F2(
					function (_v37, lists) {
						var a = _v37.a;
						var b = _v37.b;
						var _v31 = A2(
							$elm$core$List$partition,
							$elm$core$List$any(
								function (_v32) {
									var x = _v32.a;
									return _Utils_eq(x, a);
								}),
							lists);
						var found = _v31.a;
						var notFound = _v31.b;
						if (!found.b) {
							return $elm$core$List$sort(
								A2(
									$elm$core$List$cons,
									A2(
										$elm$core$List$sortBy,
										function (_v34) {
											var y = _v34.b;
											return y;
										},
										A2(
											$elm$core$List$cons,
											_Utils_Tuple2(a, b),
											_List_Nil)),
									lists));
						} else {
							return A2(
								$elm$core$List$map,
								function (sublist) {
									return A2(
										$elm$core$List$any,
										function (_v35) {
											var x = _v35.a;
											return _Utils_eq(x, a);
										},
										sublist) ? A2(
										$elm$core$List$sortBy,
										function (_v36) {
											var y = _v36.b;
											return y;
										},
										A2(
											$elm$core$List$cons,
											_Utils_Tuple2(a, b),
											sublist)) : sublist;
								},
								lists);
						}
					});
				var processLists = F2(
					function (initialList, newList) {
						return A3($elm$core$List$foldl, addToList, initialList, newList);
					});
				var updatePeriods = A2(processLists, _List_Nil, periodsToAdd);
				if (!generateColorAndID.$) {
					var id = generateColorAndID.a;
					var newAv = {
						lo: $elm$core$Dict$fromList(
							_List_fromArray(
								[
									_Utils_Tuple2(m.ah, m.lo)
								])),
						cK: id,
						dM: id,
						n: updatePeriods,
						c7: $author$project$Components$Schedule$positionToPeriods(updatePeriods)
					};
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								g: A2(
									$krisajenkins$remotedata$RemoteData$map,
									$elm$core$List$cons(newAv),
									model.g),
								aC: _List_Nil,
								aY: $elm$core$Maybe$Nothing,
								af: $elm$core$Maybe$Nothing,
								A: $elm$core$Set$empty
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Components$Schedule$ScheduleCloseModal);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Components$Schedule$SharedMsg(
							$author$project$Shared$ShowErrorDialog('Limite de período atingido')));
				}
			case 13:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aY: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Schedule$ScheduleCloseModal);
			default:
				if (!msg.a.$) {
					var receivedPeriods = msg.a.a;
					var periodsToTuple = A2(
						$elm$core$List$filterMap,
						function (p) {
							if ((p.b && p.b.b) && (!p.b.b.b)) {
								var col = p.a;
								var _v39 = p.b;
								var row = _v39.a;
								return $elm$core$Maybe$Just(
									_Utils_Tuple2(col, row));
							} else {
								return $elm$core$Maybe$Nothing;
							}
						},
						receivedPeriods.n);
					var updateAvailabilities = A2(
						$krisajenkins$remotedata$RemoteData$map,
						function (avs) {
							return A2(
								$elm$core$List$map,
								function (av) {
									return _Utils_eq(av.dM, receivedPeriods.dM) ? _Utils_update(
										av,
										{
											n: _List_fromArray(
												[periodsToTuple])
										}) : av;
								},
								avs);
						},
						model.g);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{g: updateAvailabilities}),
						$elm$core$Platform$Cmd$none,
						$author$project$Components$Schedule$SharedMsg($author$project$Shared$NoOp));
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Components$Schedule$SharedMsg(
							$author$project$Shared$ShowErrorDialog(
								$elm$json$Json$Decode$errorToString(error))));
				}
		}
	});
var $author$project$Pages$Panel$Classes$Create$updateForm = F4(
	function (user, msg, model, shared) {
		var _v0 = _Utils_Tuple2(msg, model.bp);
		switch (_v0.a.$) {
			case 7:
				var newName = _v0.a.a;
				var form = _v0.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bp: _Utils_update(
								form,
								{c3: newName})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 8:
				var newPriority = _v0.a.a;
				var form = _v0.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bp: _Utils_update(
								form,
								{
									ch: $elm$core$String$toInt(newPriority)
								})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 0:
				var newValueStr = _v0.a.a;
				var form = _v0.b;
				var _v1 = _Utils_Tuple2(
					$elm$core$String$toInt(newValueStr),
					A2(
						$elm$core$Maybe$withDefault,
						true,
						A2(
							$elm$core$Maybe$map,
							$author$project$Pages$Panel$Classes$Create$isInvalidMaxDayUseCounter,
							$elm$core$String$toInt(newValueStr))));
				if (!_v1.a.$) {
					if (!_v1.b) {
						var v = _v1.a.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bp: _Utils_update(
										form,
										{aD: v})
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
					}
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bp: _Utils_update(
									form,
									{aD: 0})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				}
			case 1:
				var newValueStr = _v0.a.a;
				var form = _v0.b;
				var _v2 = _Utils_Tuple2(
					$elm$core$String$toInt(newValueStr),
					A2(
						$elm$core$Maybe$withDefault,
						true,
						A2(
							$elm$core$Maybe$map,
							$author$project$Pages$Panel$Classes$Create$isInvalidMaxMonthUseCounter,
							$elm$core$String$toInt(newValueStr))));
				if (!_v2.a.$) {
					if (!_v2.b) {
						var v = _v2.a.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bp: _Utils_update(
										form,
										{ao: v})
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
					}
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bp: _Utils_update(
									form,
									{ao: 0})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				}
			case 2:
				var newValueStr = _v0.a.a;
				var form = _v0.b;
				var _v3 = _Utils_Tuple2(
					$elm$core$String$toInt(newValueStr),
					A2(
						$elm$core$Maybe$withDefault,
						true,
						A2(
							$elm$core$Maybe$map,
							$author$project$Pages$Panel$Classes$Create$isInvalidMaxCompanions(form.K),
							$elm$core$String$toInt(newValueStr))));
				if (!_v3.a.$) {
					if (!_v3.b) {
						var v = _v3.a.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bp: _Utils_update(
										form,
										{aa: v})
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
					}
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bp: _Utils_update(
									form,
									{aa: 0})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				}
			case 3:
				var newValueStr = _v0.a.a;
				var form = _v0.b;
				var _v4 = _Utils_Tuple2(
					$elm$core$String$toInt(newValueStr),
					A2(
						$elm$core$Maybe$withDefault,
						true,
						A2(
							$elm$core$Maybe$map,
							$author$project$Pages$Panel$Classes$Create$isInvalidSubsequentUsePeriod,
							$elm$core$String$toInt(newValueStr))));
				if (!_v4.a.$) {
					if (!_v4.b) {
						var v = _v4.a.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bp: _Utils_update(
										form,
										{a7: v})
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
					}
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bp: _Utils_update(
									form,
									{ao: 0})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				}
			case 4:
				var newValueStr = _v0.a.a;
				var form = _v0.b;
				var _v5 = _Utils_Tuple2(
					$elm$core$String$toInt(newValueStr),
					A2(
						$elm$core$Maybe$withDefault,
						true,
						A2(
							$elm$core$Maybe$map,
							$author$project$Pages$Panel$Classes$Create$isInvalidClasseID,
							$elm$core$String$toInt(newValueStr))));
				if (!_v5.a.$) {
					if (!_v5.b) {
						var v = _v5.a.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bp: _Utils_update(
										form,
										{lX: v})
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
					}
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bp: _Utils_update(
									form,
									{lX: 0})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				}
			case 5:
				var _v6 = _v0.a;
				var key = _v6.a;
				var newValue = _v6.b;
				var form = _v0.b;
				var updateValue = F2(
					function (maybeNewValue, _default) {
						if (!maybeNewValue.$) {
							var v = maybeNewValue.a;
							return $elm$core$Maybe$Just(v);
						} else {
							return _default;
						}
					});
				var newForm = _Utils_update(
					form,
					{
						l: A3(
							$elm$core$Dict$update,
							key,
							updateValue(newValue),
							form.l)
					});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bp: newForm}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 6:
				var newEffectiveFrom = _v0.a.a;
				var form = _v0.b;
				var append_ = ($elm$core$String$length(newEffectiveFrom) < 19) ? A2($elm$core$String$append, newEffectiveFrom, ':00') : newEffectiveFrom;
				var updateForm_ = _Utils_update(
					form,
					{aT: append_});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bp: updateForm_}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 9:
				var form = _v0.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bp: _Utils_update(
								form,
								{aM: !form.aM})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 10:
				var form = _v0.b;
				var newCompanion = !form.K;
				var newMaxCompanions = newCompanion ? 1 : 0;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bp: _Utils_update(
								form,
								{K: newCompanion, aa: newMaxCompanions})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 11:
				var paymentRoleType = _v0.a.a;
				var form = _v0.b;
				var newForm = function () {
					switch (paymentRoleType) {
						case 'default-payment-true-percent':
							return _Utils_update(
								form,
								{
									l: $elm$core$Dict$fromList(
										$elm$core$List$singleton(
											_Utils_Tuple2('percent', 0)))
								});
						case 'default-payment-true-value':
							return _Utils_update(
								form,
								{
									l: $elm$core$Dict$fromList(
										$elm$core$List$singleton(
											_Utils_Tuple2('value', 0)))
								});
						default:
							return _Utils_update(
								form,
								{l: $elm$core$Dict$empty});
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bp: newForm}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 12:
				var newType = _v0.a.a;
				var form = _v0.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bp: _Utils_update(
								form,
								{ba: newType})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 13:
				var _v9 = _v0.a;
				var form = _v0.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bp: _Utils_update(
								form,
								{at: !form.at})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 14:
				var wtID = _v0.a.a;
				var form = _v0.b;
				var updateItem = _Utils_eq(wtID, form.bI) ? '' : wtID;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bp: _Utils_update(
								form,
								{bI: updateItem})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 15:
				var wtID = _v0.a.a;
				var form = _v0.b;
				var updateItem = _Utils_eq(wtID, form.bH) ? '' : wtID;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bp: _Utils_update(
								form,
								{bH: updateItem})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 18:
				var msg_ = _v0.a.a;
				var form = _v0.b;
				var _v10 = A3($author$project$Components$Schedule$update, msg_, form.al, shared);
				var newSchedule = _v10.a;
				var cmd = _v10.b;
				var outMsg = _v10.c;
				var _v11 = function () {
					switch (outMsg.$) {
						case 0:
							return _Utils_Tuple2(
								$author$project$Shared$NoOp,
								$elm$core$Maybe$Just(0));
						case 1:
							return _Utils_Tuple2($author$project$Shared$NoOp, $elm$core$Maybe$Nothing);
						default:
							var sharedMsg_ = outMsg.a;
							return _Utils_Tuple2(sharedMsg_, model.aY);
					}
				}();
				var sharedMsg = _v11.a;
				var newModal = _v11.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bp: _Utils_update(
								form,
								{al: newSchedule}),
							aY: newModal
						}),
					A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeR, $author$project$Pages$Panel$Classes$Create$CompScheduleMsg, $author$project$Pages$Panel$Classes$Create$FormMsg),
						cmd),
					sharedMsg);
			case 16:
				var _v13 = _v0.a;
				var form = _v0.b;
				return $author$project$Pages$Panel$Classes$Create$isInvalidSubmitInfo(form) ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bp: _Utils_update(
								form,
								{L: 1})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$ShowErrorDialog('Existe campos incorretos')) : _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bp: _Utils_update(
								form,
								{L: 2})
						}),
					A2(
						$elm$core$Task$perform,
						A2($elm$core$Basics$composeR, $author$project$Pages$Panel$Classes$Create$GotCurrentDate, $author$project$Pages$Panel$Classes$Create$FormMsg),
						A3(
							$elm$core$Task$map2,
							F2(
								function (now, timezone) {
									return {e8: now, kS: timezone};
								}),
							$elm$time$Time$now,
							$elm$time$Time$here)),
					$author$project$Shared$NoOp);
			case 19:
				var _v14 = _v0.a;
				var form = _v0.b;
				return _Utils_Tuple3(
					model,
					A2(
						$elm$core$Task$perform,
						A2($elm$core$Basics$composeR, $author$project$Pages$Panel$Classes$Create$GotCurrentDate, $author$project$Pages$Panel$Classes$Create$FormMsg),
						A3(
							$elm$core$Task$map2,
							F2(
								function (now, timezone) {
									return {e8: now, kS: timezone};
								}),
							$elm$time$Time$now,
							$elm$time$Time$here)),
					$author$project$Shared$NoOp);
			case 20:
				var now = _v0.a.a.e8;
				var timezone = _v0.a.a.kS;
				var form = _v0.b;
				var dateTimeInPosix = A2(
					$elm$core$Maybe$withDefault,
					$elm$time$Time$millisToPosix(0),
					A2($author$project$Utils$datetimeLocalHTMLToPosixWithZone, timezone, form.aT));
				var isInvalid = $elm$core$String$isEmpty(form.aT) || (_Utils_cmp(
					$elm$time$Time$posixToMillis(now),
					$elm$time$Time$posixToMillis(dateTimeInPosix)) > -1);
				var date = A2(
					$elm$core$Maybe$map,
					$rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime,
					A2($author$project$Utils$datetimeLocalHTMLToPosixWithZone, shared.kS, form.aT));
				var _v15 = _Utils_Tuple2(isInvalid, date);
				if (_v15.a) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bp: _Utils_update(
									form,
									{L: 1, b2: now})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				} else {
					if (_v15.b.$ === 1) {
						var _v16 = _v15.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bp: _Utils_update(
										form,
										{L: 1, b2: now})
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					} else {
						var date_ = _v15.b.a;
						var newRule = {
							K: form.K,
							l: form.l,
							aa: form.aa,
							aD: form.aD,
							ao: form.ao,
							oR: A2(
								$krisajenkins$remotedata$RemoteData$withDefault,
								_List_Nil,
								A2(
									$krisajenkins$remotedata$RemoteData$map,
									function (avs) {
										return A2(
											$elm$core$List$map,
											function (av) {
												return {
													oT: A2($elm$core$Dict$get, 'percent', av.lo),
													n: av.c7,
													di: A2(
														$elm$core$Maybe$map,
														$elm$core$Basics$round,
														A2($elm$core$Dict$get, 'value', av.lo))
												};
											},
											avs);
									},
									form.al.g)),
							a7: form.a7,
							aM: form.aM,
							kZ: $elm$core$Maybe$Nothing
						};
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bp: _Utils_update(
										form,
										{L: 2, b2: now})
								}),
							$author$project$Services$Classes$postWalletClasse(
								{
									ih: {
										at: form.at,
										lY: form.lX,
										mb: A2(
											$elm$core$Maybe$withDefault,
											'',
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.bR;
												},
												A2(
													$elm$core$Basics$composeR,
													$elm$core$List$map(
														function ($) {
															return $.dM;
														}),
													$elm$core$List$head))(user)),
										c3: form.c3,
										ch: A2($elm$core$Maybe$withDefault, 0, form.ch),
										py: $elm$core$Dict$fromList(
											_List_fromArray(
												[
													_Utils_Tuple2(date_, newRule)
												])),
										kY: form.ba,
										qM: form.bI,
										qO: form.bH
									},
									ow: A2($elm$core$Basics$composeR, $author$project$Pages$Panel$Classes$Create$GotCreate, $author$project$Pages$Panel$Classes$Create$FormMsg),
									kU: user.kU
								}),
							$author$project$Shared$NoOp);
					}
				}
			case 21:
				var rd = _v0.a.a;
				var form = _v0.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bp: _Utils_update(
								form,
								{L: 0})
						}),
					A2(
						$krisajenkins$remotedata$RemoteData$withDefault,
						$elm$core$Platform$Cmd$none,
						A2(
							$krisajenkins$remotedata$RemoteData$map,
							function (_v17) {
								return A2(
									$author$project$Route$pushUrl,
									shared.nZ,
									$author$project$Route$Panel(
										$author$project$Route$Classes($author$project$Route$ClassesList)));
							},
							rd)),
					A2(
						$author$project$Shared$remoteDataSharedMsg,
						$elm$core$Maybe$Just('Criado com sucesso!'),
						rd));
			default:
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$ShowErrorDialog('MSG não mapeada!'));
		}
	});
var $author$project$Pages$Panel$Classes$Create$update = F4(
	function (user, msg, model, shared) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(
					model,
					A2(
						$author$project$Route$pushUrl,
						shared.nZ,
						$author$project$Route$Panel(
							$author$project$Route$Classes($author$project$Route$ClassesList))),
					$author$project$Shared$NoOp);
			case 3:
				var msg_ = msg.a;
				return A4($author$project$Pages$Panel$Classes$Create$updateForm, user, msg_, model, shared);
			case 1:
				var newModal = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aY: $elm$core$Maybe$Just(newModal)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aY: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			default:
				var rd = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{eo: rd}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rd));
		}
	});
var $author$project$Pages$Panel$Classes$Details$initForm = F2(
	function (ruleKey, rule) {
		var _v0 = $author$project$Components$Schedule$init(rule);
		var modelSchedule = _v0.a;
		var cmd_ = _v0.b;
		return _Utils_Tuple2(
			{al: modelSchedule, K: rule.K, l: rule.l, L: 0, aa: rule.aa, aD: rule.aD, ao: rule.ao, kj: rule, db: ruleKey, a7: rule.a7, aM: rule.aM},
			A2(
				$elm$core$Platform$Cmd$map,
				A2($elm$core$Basics$composeR, $author$project$Pages$Panel$Classes$Details$CompScheduleMsg, $author$project$Pages$Panel$Classes$Details$FormMsg),
				cmd_));
	});
var $author$project$Pages$Panel$Classes$Details$Schedule = {$: 1};
var $author$project$Pages$Panel$Classes$Details$UpdateRule = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Panel$Classes$Details$initUpdateRuleModel = {
	aT: '',
	L: 0,
	b2: $elm$time$Time$millisToPosix(0)
};
var $author$project$Pages$Panel$Classes$Details$isInvalidMaxCompanions = F2(
	function (isCompanion, value) {
		return (isCompanion && ((value <= 0) || (value > 3))) || ((!isCompanion) && (!(!value)));
	});
var $author$project$Pages$Panel$Classes$Details$isInvalidMaxDayUseCounter = function (value) {
	return (value < 0) || (value > 15);
};
var $author$project$Pages$Panel$Classes$Details$isInvalidMaxMonthUseCounter = function (value) {
	return (value < 0) || (value > 255);
};
var $author$project$Pages$Panel$Classes$Details$isInvalidSubsequentUsePeriod = function (value) {
	return (value < 0) || (value > 180);
};
var $author$project$Pages$Panel$Classes$Details$isInvalidDefaultPaymentPercent = function (value) {
	return (value < 0) || (value > 200);
};
var $author$project$Pages$Panel$Classes$Details$isInvalidDefaultPaymentValue = function (value) {
	return (value < 0) || (value > 4000);
};
var $author$project$Pages$Panel$Classes$Details$isInvalidPaymentRule = F2(
	function (rules, defaultPaymentRule) {
		return $elm$core$List$isEmpty(
			$elm$core$List$concat(rules)) && $elm$core$Dict$isEmpty(defaultPaymentRule);
	});
var $author$project$Pages$Panel$Classes$Details$isValidSubmitInfo = function (form) {
	return !A2(
		$elm$core$List$all,
		$elm$core$Basics$eq(false),
		_List_fromArray(
			[
				$author$project$Pages$Panel$Classes$Details$isInvalidMaxDayUseCounter(form.aD),
				$author$project$Pages$Panel$Classes$Details$isInvalidMaxMonthUseCounter(form.ao),
				$author$project$Pages$Panel$Classes$Details$isInvalidSubsequentUsePeriod(form.a7),
				A2($author$project$Pages$Panel$Classes$Details$isInvalidMaxCompanions, form.K, form.aa),
				A2(
				$author$project$Pages$Panel$Classes$Details$isInvalidPaymentRule,
				A2(
					$krisajenkins$remotedata$RemoteData$withDefault,
					_List_Nil,
					A2(
						$krisajenkins$remotedata$RemoteData$map,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$map(
								function ($) {
									return $.c7;
								}),
							$elm$core$List$concat),
						form.al.g)),
				form.l),
				A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					$author$project$Pages$Panel$Classes$Details$isInvalidDefaultPaymentPercent,
					A2($elm$core$Dict$get, 'percent', form.l))),
				A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					$author$project$Pages$Panel$Classes$Details$isInvalidDefaultPaymentValue,
					A2($elm$core$Dict$get, 'value', form.l)))
			]));
};
var $author$project$Pages$Panel$Classes$Details$updateForm = F4(
	function (user, msg, model, shared) {
		var _v0 = _Utils_Tuple3(msg, model.bp, model.cI);
		_v0$12:
		while (true) {
			if (_v0.b.$ === 1) {
				if ((_v0.a.$ === 10) && (_v0.a.a.$ === 4)) {
					var _v11 = _v0.a.a;
					var _v12 = _v0.b;
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
				} else {
					break _v0$12;
				}
			} else {
				switch (_v0.a.$) {
					case 0:
						var newValueStr = _v0.a.a;
						var form = _v0.b.a;
						var _v1 = _Utils_Tuple2(
							$elm$core$String$toInt(newValueStr),
							A2(
								$elm$core$Maybe$withDefault,
								true,
								A2(
									$elm$core$Maybe$map,
									$author$project$Pages$Panel$Classes$Details$isInvalidMaxDayUseCounter,
									$elm$core$String$toInt(newValueStr))));
						if (!_v1.a.$) {
							if (!_v1.b) {
								var v = _v1.a.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											bp: $elm$core$Maybe$Just(
												_Utils_update(
													form,
													{aD: v}))
										}),
									$elm$core$Platform$Cmd$none,
									$author$project$Shared$NoOp);
							} else {
								return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
							}
						} else {
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										bp: $elm$core$Maybe$Just(
											_Utils_update(
												form,
												{aD: 0}))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						}
					case 1:
						var newValueStr = _v0.a.a;
						var form = _v0.b.a;
						var _v2 = _Utils_Tuple2(
							$elm$core$String$toInt(newValueStr),
							A2(
								$elm$core$Maybe$withDefault,
								true,
								A2(
									$elm$core$Maybe$map,
									$author$project$Pages$Panel$Classes$Details$isInvalidMaxMonthUseCounter,
									$elm$core$String$toInt(newValueStr))));
						if (!_v2.a.$) {
							if (!_v2.b) {
								var v = _v2.a.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											bp: $elm$core$Maybe$Just(
												_Utils_update(
													form,
													{ao: v}))
										}),
									$elm$core$Platform$Cmd$none,
									$author$project$Shared$NoOp);
							} else {
								return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
							}
						} else {
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										bp: $elm$core$Maybe$Just(
											_Utils_update(
												form,
												{ao: 0}))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						}
					case 2:
						var newValueStr = _v0.a.a;
						var form = _v0.b.a;
						var _v3 = _Utils_Tuple2(
							$elm$core$String$toInt(newValueStr),
							A2(
								$elm$core$Maybe$withDefault,
								true,
								A2(
									$elm$core$Maybe$map,
									$author$project$Pages$Panel$Classes$Details$isInvalidMaxCompanions(form.K),
									$elm$core$String$toInt(newValueStr))));
						if (!_v3.a.$) {
							if (!_v3.b) {
								var v = _v3.a.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											bp: $elm$core$Maybe$Just(
												_Utils_update(
													form,
													{aa: v}))
										}),
									$elm$core$Platform$Cmd$none,
									$author$project$Shared$NoOp);
							} else {
								return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
							}
						} else {
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										bp: $elm$core$Maybe$Just(
											_Utils_update(
												form,
												{aa: 0}))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						}
					case 3:
						var newValueStr = _v0.a.a;
						var form = _v0.b.a;
						var _v4 = _Utils_Tuple2(
							$elm$core$String$toInt(newValueStr),
							A2(
								$elm$core$Maybe$withDefault,
								true,
								A2(
									$elm$core$Maybe$map,
									$author$project$Pages$Panel$Classes$Details$isInvalidSubsequentUsePeriod,
									$elm$core$String$toInt(newValueStr))));
						if (!_v4.a.$) {
							if (!_v4.b) {
								var v = _v4.a.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											bp: $elm$core$Maybe$Just(
												_Utils_update(
													form,
													{a7: v}))
										}),
									$elm$core$Platform$Cmd$none,
									$author$project$Shared$NoOp);
							} else {
								return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
							}
						} else {
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										bp: $elm$core$Maybe$Just(
											_Utils_update(
												form,
												{ao: 0}))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						}
					case 4:
						var _v5 = _v0.a;
						var key = _v5.a;
						var newValue = _v5.b;
						var form = _v0.b.a;
						var updateValue = F2(
							function (maybeNewValue, _default) {
								if (!maybeNewValue.$) {
									var v = maybeNewValue.a;
									return $elm$core$Maybe$Just(v);
								} else {
									return _default;
								}
							});
						var newForm = _Utils_update(
							form,
							{
								l: A3(
									$elm$core$Dict$update,
									key,
									updateValue(newValue),
									form.l)
							});
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bp: $elm$core$Maybe$Just(newForm)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					case 5:
						var form = _v0.b.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bp: $elm$core$Maybe$Just(
										_Utils_update(
											form,
											{aM: !form.aM}))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					case 6:
						var form = _v0.b.a;
						var newCompanion = !form.K;
						var newMaxCompanions = newCompanion ? 1 : 0;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bp: $elm$core$Maybe$Just(
										_Utils_update(
											form,
											{K: newCompanion, aa: newMaxCompanions}))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					case 7:
						var paymentRoleType = _v0.a.a;
						var form = _v0.b.a;
						var newForm = function () {
							switch (paymentRoleType) {
								case 'default-payment-true-percent':
									return _Utils_update(
										form,
										{
											l: $elm$core$Dict$fromList(
												$elm$core$List$singleton(
													_Utils_Tuple2('percent', 0)))
										});
								case 'default-payment-true-value':
									return _Utils_update(
										form,
										{
											l: $elm$core$Dict$fromList(
												$elm$core$List$singleton(
													_Utils_Tuple2('value', 0)))
										});
								default:
									return _Utils_update(
										form,
										{l: $elm$core$Dict$empty});
							}
						}();
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bp: $elm$core$Maybe$Just(newForm)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					case 10:
						var msg_ = _v0.a.a;
						var form = _v0.b.a;
						var _v8 = A3($author$project$Components$Schedule$update, msg_, form.al, shared);
						var newSchedule = _v8.a;
						var cmd = _v8.b;
						var outMsg = _v8.c;
						var _v9 = function () {
							switch (outMsg.$) {
								case 0:
									return _Utils_Tuple2(
										$author$project$Shared$NoOp,
										$elm$core$Maybe$Just($author$project$Pages$Panel$Classes$Details$Schedule));
								case 1:
									return _Utils_Tuple2($author$project$Shared$NoOp, $elm$core$Maybe$Nothing);
								default:
									var sharedMsg_ = outMsg.a;
									return _Utils_Tuple2(sharedMsg_, model.aY);
							}
						}();
						var sharedMsg = _v9.a;
						var newModal = _v9.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bp: $elm$core$Maybe$Just(
										_Utils_update(
											form,
											{al: newSchedule})),
									aY: newModal
								}),
							A2(
								$elm$core$Platform$Cmd$map,
								A2($elm$core$Basics$composeR, $author$project$Pages$Panel$Classes$Details$CompScheduleMsg, $author$project$Pages$Panel$Classes$Details$FormMsg),
								cmd),
							sharedMsg);
					case 8:
						if (_v0.c.$ === 3) {
							var _v13 = _v0.a;
							var form = _v0.b.a;
							var _class = _v0.c.a;
							return $author$project$Pages$Panel$Classes$Details$isValidSubmitInfo(form) ? _Utils_Tuple3(
								_Utils_update(
									model,
									{
										bp: $elm$core$Maybe$Just(
											_Utils_update(
												form,
												{L: 1}))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$ShowErrorDialog('Existe campos incorretos')) : _Utils_Tuple3(
								_Utils_update(
									model,
									{
										bp: $elm$core$Maybe$Just(
											_Utils_update(
												form,
												{L: 0})),
										aY: $elm$core$Maybe$Just(
											$author$project$Pages$Panel$Classes$Details$UpdateRule($author$project$Pages$Panel$Classes$Details$initUpdateRuleModel))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						} else {
							break _v0$12;
						}
					default:
						if (_v0.c.$ === 3) {
							var _v14 = _v0.a;
							var form = _v0.b.a;
							var _class = _v0.c.a;
							return $author$project$Pages$Panel$Classes$Details$isValidSubmitInfo(form) ? _Utils_Tuple3(
								_Utils_update(
									model,
									{
										bp: $elm$core$Maybe$Just(
											_Utils_update(
												form,
												{L: 1}))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$ShowErrorDialog('Existe campos incorretos')) : _Utils_Tuple3(
								_Utils_update(
									model,
									{
										bp: $elm$core$Maybe$Just(
											_Utils_update(
												form,
												{L: 0})),
										aY: $elm$core$Maybe$Just(
											$author$project$Pages$Panel$Classes$Details$UpdateRule($author$project$Pages$Panel$Classes$Details$initUpdateRuleModel))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						} else {
							break _v0$12;
						}
				}
			}
		}
		return _Utils_Tuple3(
			model,
			$elm$core$Platform$Cmd$none,
			$author$project$Shared$ShowErrorDialog('MSG não mapeada!'));
	});
var $author$project$Pages$Panel$Classes$Details$GotCurrentDate = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Panel$Classes$Details$GotUpdate = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Panel$Classes$Details$ModalMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Services$Classes$putWalletClasse = function (options) {
	return $author$project$Services$Api$putHttp(
		{
			lG: $elm$http$Http$jsonBody(
				$author$project$Services$Classes$encodeWalletClasse(options.ih)),
			m9: $author$project$Services$Api$expectWhateverErrorString(
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'wallet', 'updateWalletClassByID', options.dk]),
				_List_Nil)
		});
};
var $author$project$Pages$Panel$Classes$Details$updateModal = F4(
	function (msg, model, shared, user) {
		var _v0 = _Utils_Tuple3(
			msg,
			model.aY,
			_Utils_Tuple2(model.cI, model.bp));
		_v0$4:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					if ((!_v0.b.$) && (!_v0.b.a.$)) {
						var newEffectiveFrom = _v0.a.a;
						var m = _v0.b.a.a;
						var append_ = ($elm$core$String$length(newEffectiveFrom) < 19) ? A2($elm$core$String$append, newEffectiveFrom, ':00') : newEffectiveFrom;
						var updateModal_ = _Utils_update(
							m,
							{aT: append_});
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $elm$core$Maybe$Just(
										$author$project$Pages$Panel$Classes$Details$UpdateRule(updateModal_))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					} else {
						break _v0$4;
					}
				case 1:
					var _v1 = _v0.a;
					return _Utils_Tuple3(
						model,
						A2(
							$elm$core$Task$perform,
							A2($elm$core$Basics$composeR, $author$project$Pages$Panel$Classes$Details$GotCurrentDate, $author$project$Pages$Panel$Classes$Details$ModalMsg),
							A3(
								$elm$core$Task$map2,
								F2(
									function (now, timezone) {
										return {e8: now, kS: timezone};
									}),
								$elm$time$Time$now,
								$elm$time$Time$here)),
						$author$project$Shared$NoOp);
				case 2:
					if ((((!_v0.b.$) && (!_v0.b.a.$)) && (_v0.c.a.$ === 3)) && (!_v0.c.b.$)) {
						var now = _v0.a.a.e8;
						var timezone = _v0.a.a.kS;
						var m = _v0.b.a.a;
						var _v2 = _v0.c;
						var _class = _v2.a.a;
						var form = _v2.b.a;
						var dateTimeInPosix = A2(
							$elm$core$Maybe$withDefault,
							$elm$time$Time$millisToPosix(0),
							A2($author$project$Utils$datetimeLocalHTMLToPosixWithZone, timezone, m.aT));
						var isInvalid = $elm$core$String$isEmpty(m.aT) || (_Utils_cmp(
							$elm$time$Time$posixToMillis(now),
							$elm$time$Time$posixToMillis(dateTimeInPosix)) > -1);
						var date = A2(
							$elm$core$Maybe$map,
							$rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime,
							A2($author$project$Utils$datetimeLocalHTMLToPosixWithZone, shared.kS, m.aT));
						var _v3 = _Utils_Tuple2(isInvalid, date);
						if (_v3.a) {
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $elm$core$Maybe$Just(
											$author$project$Pages$Panel$Classes$Details$UpdateRule(
												_Utils_update(
													m,
													{L: 1, b2: now})))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						} else {
							if (_v3.b.$ === 1) {
								var _v4 = _v3.b;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $elm$core$Maybe$Just(
												$author$project$Pages$Panel$Classes$Details$UpdateRule(
													_Utils_update(
														m,
														{L: 1, b2: now})))
										}),
									$elm$core$Platform$Cmd$none,
									$author$project$Shared$NoOp);
							} else {
								var date_ = _v3.b.a;
								var newRule = {
									K: form.K,
									l: form.l,
									aa: form.aa,
									aD: form.aD,
									ao: form.ao,
									oR: A2(
										$krisajenkins$remotedata$RemoteData$withDefault,
										_List_Nil,
										A2(
											$krisajenkins$remotedata$RemoteData$map,
											function (avs) {
												return A2(
													$elm$core$List$map,
													function (av) {
														return {
															oT: A2($elm$core$Dict$get, 'percent', av.lo),
															n: av.c7,
															di: A2(
																$elm$core$Maybe$map,
																$elm$core$Basics$round,
																A2($elm$core$Dict$get, 'value', av.lo))
														};
													},
													avs);
											},
											form.al.g)),
									a7: form.a7,
									aM: form.aM,
									kZ: $elm$core$Maybe$Nothing
								};
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $elm$core$Maybe$Just(
												$author$project$Pages$Panel$Classes$Details$UpdateRule(
													_Utils_update(
														m,
														{L: 2, b2: now})))
										}),
									$author$project$Services$Classes$putWalletClasse(
										{
											ih: {
												at: _class.at,
												lY: _class.lY,
												mb: _class.k8,
												c3: _class.c3,
												ch: _class.ch,
												py: $elm$core$Dict$fromList(
													_List_fromArray(
														[
															_Utils_Tuple2(date_, newRule)
														])),
												kY: _class.kY,
												qM: _class.qM,
												qO: _class.qO
											},
											ow: A2($elm$core$Basics$composeR, $author$project$Pages$Panel$Classes$Details$GotUpdate, $author$project$Pages$Panel$Classes$Details$ModalMsg),
											kU: user.kU,
											dk: _class.k8
										}),
									$author$project$Shared$NoOp);
							}
						}
					} else {
						break _v0$4;
					}
				default:
					if ((!_v0.b.$) && (!_v0.b.a.$)) {
						var rd = _v0.a.a;
						var m = _v0.b.a.a;
						var _v5 = _v0.c;
						var maybeForm = _v5.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bp: A2(
										$krisajenkins$remotedata$RemoteData$withDefault,
										maybeForm,
										A2(
											$krisajenkins$remotedata$RemoteData$map,
											function (_v6) {
												return $elm$core$Maybe$Nothing;
											},
											rd)),
									aY: A2(
										$elm$core$Maybe$withDefault,
										$elm$core$Maybe$Just(
											$author$project$Pages$Panel$Classes$Details$UpdateRule(
												_Utils_update(
													m,
													{L: 0}))),
										A2(
											$elm$core$Maybe$map,
											function (_v7) {
												return $elm$core$Maybe$Nothing;
											},
											$krisajenkins$remotedata$RemoteData$toMaybe(rd)))
								}),
							$author$project$Services$Classes$getWalletClasse(
								{dM: model.dM, ow: $author$project$Pages$Panel$Classes$Details$GotClassDetails, kU: user.kU}),
							A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rd));
					} else {
						break _v0$4;
					}
			}
		}
		return _Utils_Tuple3(
			model,
			$elm$core$Platform$Cmd$none,
			$author$project$Shared$ShowErrorDialog('MSG não mapeada!'));
	});
var $author$project$Pages$Panel$Classes$Details$update = F4(
	function (user, msg, model, shared) {
		switch (msg.$) {
			case 1:
				var rdResult = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cI: rdResult}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rdResult));
			case 0:
				return _Utils_Tuple3(
					model,
					A2(
						$author$project$Route$pushUrl,
						shared.nZ,
						$author$project$Route$Panel(
							$author$project$Route$Classes($author$project$Route$ClassesList))),
					$author$project$Shared$NoOp);
			case 2:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
			case 3:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
			case 4:
				var ruleKey = msg.a;
				var rule = msg.b;
				return A2(
					$elm$core$Maybe$withDefault,
					function () {
						var _v2 = A2($author$project$Pages$Panel$Classes$Details$initForm, ruleKey, rule);
						var modelForm = _v2.a;
						var cmd = _v2.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bp: $elm$core$Maybe$Just(modelForm)
								}),
							cmd,
							$author$project$Shared$NoOp);
					}(),
					A2(
						$elm$core$Maybe$map,
						function (f) {
							if (_Utils_eq(ruleKey, f.db)) {
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{bp: $elm$core$Maybe$Nothing}),
									$elm$core$Platform$Cmd$none,
									$author$project$Shared$NoOp);
							} else {
								var _v1 = A2($author$project$Pages$Panel$Classes$Details$initForm, ruleKey, rule);
								var modelForm = _v1.a;
								var cmd = _v1.b;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											bp: $elm$core$Maybe$Just(modelForm)
										}),
									cmd,
									$author$project$Shared$NoOp);
							}
						},
						model.bp));
			case 7:
				var msg_ = msg.a;
				return A4($author$project$Pages$Panel$Classes$Details$updateForm, user, msg_, model, shared);
			case 8:
				var msg_ = msg.a;
				return A4($author$project$Pages$Panel$Classes$Details$updateModal, msg_, model, shared, user);
			case 5:
				var newModal = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aY: $elm$core$Maybe$Just(newModal)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			default:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aY: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
		}
	});
var $author$project$Pages$Panel$Classes$List$GotUpdateList = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ports$outgoingOrder = _Platform_outgoingPort(
	'outgoingOrder',
	$elm$json$Json$Encode$list($elm$json$Json$Encode$int));
var $author$project$Components$Patterns$Tables$outgoingOrderCmd = function (ids) {
	return $author$project$Ports$outgoingOrder(ids);
};
var $author$project$Services$Classes$encodeUpdateListAllWalletClasses = function (_class) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(_class.dM)),
				_Utils_Tuple2(
				'priority',
				$elm$json$Json$Encode$int(_class.ch))
			]));
};
var $author$project$Services$Classes$putListAllWalletClasses = function (options) {
	var convertList = A2(
		$elm$core$List$indexedMap,
		F2(
			function (index, r) {
				return {dM: r.k8, ch: index + 1};
			}),
		options.n3);
	return $author$project$Services$Api$postHttp(
		{
			lG: $elm$http$Http$jsonBody(
				A2($elm$json$Json$Encode$list, $author$project$Services$Classes$encodeUpdateListAllWalletClasses, convertList)),
			m9: $author$project$Services$Api$expectWhateverErrorString(
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'wallet', 'updateWalletClassPriority']),
				_List_Nil)
		});
};
var $author$project$Pages$Panel$Classes$List$update = F4(
	function (msg, model, shared, user) {
		switch (msg.$) {
			case 0:
				var rdResult = msg.a;
				var resultOrdered = A2(
					$krisajenkins$remotedata$RemoteData$map,
					$elm$core$List$sortBy(
						function ($) {
							return $.ch;
						}),
					rdResult);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							dN: A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, resultOrdered),
							ck: resultOrdered
						}),
					$author$project$Components$Patterns$Tables$outgoingOrderCmd(
						A2(
							$krisajenkins$remotedata$RemoteData$withDefault,
							_List_Nil,
							A2(
								$krisajenkins$remotedata$RemoteData$map,
								$elm$core$List$map(
									function ($) {
										return $.ch;
									}),
								resultOrdered))),
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rdResult));
			case 1:
				var id = msg.a;
				return _Utils_Tuple3(
					model,
					A2(
						$author$project$Route$pushUrl,
						shared.nZ,
						$author$project$Route$Panel(
							$author$project$Route$Classes(
								$author$project$Route$ClassesDetails(id)))),
					$author$project$Shared$NoOp);
			case 2:
				var newOrder = msg.a;
				var newRows = A2(
					$krisajenkins$remotedata$RemoteData$map,
					function (report) {
						return A2(
							$elm$core$List$filterMap,
							$elm$core$Basics$identity,
							A2(
								$elm$core$List$map,
								function (id) {
									return A2(
										$elm_community$list_extra$List$Extra$find,
										function (r) {
											return _Utils_eq(r.k8, id);
										},
										report);
								},
								newOrder));
					},
					model.ck);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ck: newRows}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dP: true}),
					$author$project$Services$Classes$putListAllWalletClasses(
						{
							n3: A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, model.ck),
							ow: $author$project$Pages$Panel$Classes$List$GotUpdateList,
							kU: user.kU
						}),
					$author$project$Shared$NoOp);
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ck: $krisajenkins$remotedata$RemoteData$Success(model.dN)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 5:
				var rd = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dP: false}),
					$author$project$Services$Classes$getSummaryClasses(
						{ow: $author$project$Pages$Panel$Classes$List$GotSummaryClasses, kU: user.kU}),
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rd));
			default:
				return _Utils_Tuple3(
					model,
					A2(
						$author$project$Route$pushUrl,
						shared.nZ,
						$author$project$Route$Panel(
							$author$project$Route$Classes($author$project$Route$ClassesCreate))),
					$author$project$Shared$NoOp);
		}
	});
var $author$project$Pages$Panel$Classes$SubPage$update = F4(
	function (user, msg, model, shared) {
		var _v0 = _Utils_Tuple2(msg, model);
		_v0$3:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					if (!_v0.b.$) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var _v1 = A4($author$project$Pages$Panel$Classes$List$update, msg_, model_, shared, user);
						var newModel = _v1.a;
						var cmd = _v1.b;
						var sharedMsg = _v1.c;
						return _Utils_Tuple3(
							$author$project$Pages$Panel$Classes$SubPage$ClassesListPage(newModel),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Panel$Classes$SubPage$ClassesListMsg, cmd),
							sharedMsg);
					} else {
						break _v0$3;
					}
				case 1:
					if (_v0.b.$ === 1) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var _v2 = A4($author$project$Pages$Panel$Classes$Details$update, user, msg_, model_, shared);
						var newModel = _v2.a;
						var cmd = _v2.b;
						var sharedMsg = _v2.c;
						return _Utils_Tuple3(
							$author$project$Pages$Panel$Classes$SubPage$ClassesDetailsPage(newModel),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Panel$Classes$SubPage$ClassesDetailsMsg, cmd),
							sharedMsg);
					} else {
						break _v0$3;
					}
				default:
					if (_v0.b.$ === 2) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var _v3 = A4($author$project$Pages$Panel$Classes$Create$update, user, msg_, model_, shared);
						var newModel = _v3.a;
						var cmd = _v3.b;
						var sharedMsg = _v3.c;
						return _Utils_Tuple3(
							$author$project$Pages$Panel$Classes$SubPage$ClassesCreatePage(newModel),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Panel$Classes$SubPage$ClassesCreateMsg, cmd),
							sharedMsg);
					} else {
						break _v0$3;
					}
			}
		}
		return _Utils_Tuple3(
			model,
			$elm$core$Platform$Cmd$none,
			$author$project$Shared$ShowErrorDialog('Algo que não foi mapeado, foi executado!'));
	});
var $author$project$Pages$Panel$EquipmentsV2$update = F3(
	function (msg, model, shared) {
		var queries = model.T;
		switch (msg.$) {
			case 0:
				var result = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cU: result}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, result));
			case 1:
				var result = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dF: result}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, result));
			case 2:
				return _Utils_Tuple3(
					model,
					A2(
						$author$project$Route$pushUrl,
						shared.nZ,
						$author$project$Route$Panel(
							$author$project$Route$EquipmentsV2(model.T))),
					$author$project$Shared$NoOp);
			case 3:
				var value = msg.a;
				var updateQueries = _Utils_update(
					queries,
					{
						kw: $author$project$Components$Patterns$Forms$strMaybe(value)
					});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{T: updateQueries}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			default:
				var value = msg.a;
				var updateQueries = _Utils_update(
					queries,
					{
						k2: $author$project$Components$Patterns$Forms$strMaybe(value)
					});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{T: updateQueries}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
		}
	});
var $author$project$Pages$Panel$Financial$Account$CompPDFCreateMSg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Panel$Financial$Account$toPosix = function (str) {
	return A2(
		$elm$core$Maybe$andThen,
		$author$project$Utils$dateHTMLToPosixWithZone($elm$time$Time$utc),
		str);
};
var $author$project$Pages$Panel$Financial$Account$period31daysInvalid = F2(
	function (start, end) {
		var diff = A3(
			$elm$core$Maybe$map2,
			A2($justinmimbs$time_extra$Time$Extra$diff, 11, $elm$time$Time$utc),
			$author$project$Pages$Panel$Financial$Account$toPosix(start),
			$author$project$Pages$Panel$Financial$Account$toPosix(end));
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$lt(31),
				diff));
	});
var $author$project$Pages$Panel$Financial$Account$queriesToFilter = function (queries) {
	var maybeQ = F2(
		function (param, mValue) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (v) {
						return $elm$core$List$singleton(
							{oK: param, di: v});
					},
					mValue));
		});
	return _Utils_ap(
		A2(maybeQ, 'created_since', queries.bB),
		_Utils_ap(
			A2(maybeQ, 'created_until', queries.bl),
			A2(
				maybeQ,
				'page',
				$elm$core$Maybe$Just(
					$elm$core$String$fromInt(queries.bv)))));
};
var $author$project$Pages$Panel$Financial$Account$remoteDataSharedMsg = F2(
	function (strSuccess, rd) {
		switch (rd.$) {
			case 2:
				var e = rd.a;
				return $author$project$Shared$ShowErrorDialog(e);
			case 3:
				var a = rd.a;
				return A2(
					$elm$core$Maybe$withDefault,
					$author$project$Shared$NoOp,
					A2($elm$core$Maybe$map, $author$project$Shared$ShowSuccessDialog, strSuccess));
			default:
				return $author$project$Shared$ShowErrorDialog('Processo de execução de tarefa está incorreto!');
		}
	});
var $author$project$Pages$Panel$Financial$Account$GotWithdrawals = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Panel$Financial$Account$isGreaterThanMaximum = F2(
	function (max, amount) {
		return _Utils_cmp(
			A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(amount)),
			max) > 0;
	});
var $author$project$Pages$Panel$Financial$Account$isLessMinimum = function (amount) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		$elm$core$String$toInt(amount)) < 1000;
};
var $author$project$Services$Financial$postWithdrawals = function (options) {
	return $author$project$Services$Api$postHttp(
		{
			lG: $elm$http$Http$jsonBody(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'amount',
							$elm$json$Json$Encode$int(options.lo))
						]))),
			m9: $author$project$Services$Api$expectWhateverErrorString(
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'integrations', 'pagarme', 'withdrawals']),
				_List_Nil)
		});
};
var $author$project$Pages$Panel$Financial$Account$updateModal = F4(
	function (user, msg, maybeModal, rdInfo) {
		var _v0 = _Utils_Tuple3(msg, maybeModal, rdInfo);
		_v0$2:
		while (true) {
			if (!_v0.a.$) {
				if (!_v0.b.$) {
					var newAmount = _v0.a.a;
					var m = _v0.b.a;
					return _Utils_Tuple3(
						$elm$core$Maybe$Just(
							_Utils_update(
								m,
								{aP: newAmount})),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				} else {
					break _v0$2;
				}
			} else {
				if ((!_v0.b.$) && (_v0.c.$ === 3)) {
					var _v1 = _v0.a;
					var m = _v0.b.a;
					var info = _v0.c.a;
					return ($author$project$Pages$Panel$Financial$Account$isLessMinimum(m.aP) || A2($author$project$Pages$Panel$Financial$Account$isGreaterThanMaximum, info.bN, m.aP)) ? _Utils_Tuple3(
						$elm$core$Maybe$Just(
							_Utils_update(
								m,
								{cx: 1})),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$ShowErrorDialog('Existe erro no formulário!')) : A2(
						$elm$core$Maybe$withDefault,
						_Utils_Tuple3(
							$elm$core$Maybe$Just(
								_Utils_update(
									m,
									{cx: 1})),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$ShowErrorDialog('O valor informado está no formato incorreto')),
						A2(
							$elm$core$Maybe$map,
							function (a) {
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(
										_Utils_update(
											m,
											{cx: 0})),
									$author$project$Services$Financial$postWithdrawals(
										{lo: a, ow: $author$project$Pages$Panel$Financial$Account$GotWithdrawals, kU: user.kU}),
									$author$project$Shared$NoOp);
							},
							$elm$core$String$toInt(m.aP)));
				} else {
					break _v0$2;
				}
			}
		}
		return _Utils_Tuple3(maybeModal, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
	});
var $author$project$Pages$Panel$Financial$Account$update = F4(
	function (msg, model, user, shared) {
		var queries = model.T;
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
			case 1:
				var modalMsg = msg.a;
				var _v1 = A4($author$project$Pages$Panel$Financial$Account$updateModal, user, modalMsg, model.aY, model.cY);
				var newModal = _v1.a;
				var newCmd = _v1.b;
				var newShared = _v1.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aY: newModal}),
					newCmd,
					newShared);
			case 2:
				var message = msg.a;
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$ShowErrorDialog(message));
			case 3:
				var now = msg.a.e8;
				var timezone = msg.a.kS;
				var today = A2($justinmimbs$date$Date$fromPosix, timezone, now);
				var newQueries = _Utils_update(
					queries,
					{
						bl: $elm$core$Maybe$Just(
							$justinmimbs$date$Date$toIsoString(today)),
						bB: $elm$core$Maybe$Just(
							$justinmimbs$date$Date$toIsoString(
								A3($justinmimbs$date$Date$add, 1, -1, today)))
					});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{T: newQueries}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{L: 2, cE: $krisajenkins$remotedata$RemoteData$Loading}),
					$author$project$Services$Financial$getPagarmeWithdrawals(
						{n$: $author$project$Pages$Panel$Financial$Account$cardsPerPage, oq: (model.T.bv - 1) * $author$project$Pages$Panel$Financial$Account$cardsPerPage, ow: $author$project$Pages$Panel$Financial$Account$GotPagarmeWithdrawals, T: model.T, kU: user.kU}),
					$author$project$Shared$NoOp);
			case 5:
				var dateStr = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{bB: dateStr})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 6:
				var dateStr = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{bl: dateStr})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 10:
				var newModal = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aY: $elm$core$Maybe$Just(newModal)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 11:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aY: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 7:
				var rd = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cY: rd}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Pages$Panel$Financial$Account$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rd));
			case 8:
				var rd = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{L: 0, cE: rd}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Pages$Panel$Financial$Account$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rd));
			case 9:
				var rd = msg.a;
				var reloadCmd = A2(
					$krisajenkins$remotedata$RemoteData$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$krisajenkins$remotedata$RemoteData$map,
						function (_v3) {
							return A2($author$project$Pages$Panel$Financial$Account$init, user, model.T).b;
						},
						rd));
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aY: A2(
								$krisajenkins$remotedata$RemoteData$withDefault,
								model.aY,
								A2(
									$krisajenkins$remotedata$RemoteData$map,
									function (_v2) {
										return $elm$core$Maybe$Nothing;
									},
									rd))
						}),
					reloadCmd,
					A2(
						$author$project$Pages$Panel$Financial$Account$remoteDataSharedMsg,
						$elm$core$Maybe$Just('Saque solicitado com sucesso'),
						rd));
			case 12:
				var isShowOptionPage = msg.a;
				var exportType = msg.b;
				var reportType = msg.c;
				if (A2($author$project$Pages$Panel$Financial$Account$period31daysInvalid, model.T.bB, model.T.bl)) {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$ShowErrorDialog('O período definido é maior que 31 dias. Ajuste a consulta e tente novamente.'));
				} else {
					var newQueries = model.T;
					var _v4 = A3(
						$author$project$Components$PDF$Create$update,
						A4(
							$author$project$Components$PDF$Create$ClickedOpenModal,
							isShowOptionPage,
							exportType,
							reportType,
							$author$project$Pages$Panel$Financial$Account$queriesToFilter(newQueries)),
						model.bQ,
						user);
					var newCompModel = _v4.a;
					var cmd = _v4.b;
					var sharedMsg = _v4.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bQ: newCompModel}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Panel$Financial$Account$CompPDFCreateMSg, cmd),
						sharedMsg);
				}
			default:
				var msg_ = msg.a;
				var _v5 = A3($author$project$Components$PDF$Create$update, msg_, model.bQ, user);
				var newCompModel = _v5.a;
				var cmd = _v5.b;
				var sharedMsg = _v5.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bQ: newCompModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Panel$Financial$Account$CompPDFCreateMSg, cmd),
					sharedMsg);
		}
	});
var $author$project$Pages$Panel$Financial$PendingTransactions$CompPDFCreateMSg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Panel$Financial$PendingTransactions$GenerateCsvDownloadWithTime = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Panel$Financial$PendingTransactions$toPosix = function (str) {
	return A2(
		$elm$core$Maybe$andThen,
		$author$project$Utils$dateHTMLToPosixWithZone($elm$time$Time$utc),
		str);
};
var $author$project$Pages$Panel$Financial$PendingTransactions$period31daysInvalid = F2(
	function (start, end) {
		var diff = A3(
			$elm$core$Maybe$map2,
			A2($justinmimbs$time_extra$Time$Extra$diff, 11, $elm$time$Time$utc),
			$author$project$Pages$Panel$Financial$PendingTransactions$toPosix(start),
			$author$project$Pages$Panel$Financial$PendingTransactions$toPosix(end));
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$lt(31),
				diff));
	});
var $author$project$Pages$Panel$Financial$PendingTransactions$queriesToFilter = function (queries) {
	var maybeQ = F2(
		function (param, mValue) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (v) {
						return $elm$core$List$singleton(
							{oK: param, di: v});
					},
					mValue));
		});
	return _Utils_ap(
		A2(maybeQ, 'created_since', queries.bB),
		_Utils_ap(
			A2(maybeQ, 'created_until', queries.bl),
			A2(
				maybeQ,
				'page',
				$elm$core$Maybe$Just(
					$elm$core$String$fromInt(queries.bv)))));
};
var $author$project$Pages$Panel$Financial$PendingTransactions$reportHeaders = _List_fromArray(
	['Criação', 'Situação', 'Cód.Pagarme', 'Documento', 'Razão social', 'Tipo de pagamento', 'Valor da venda', 'Link pedido']);
var $author$project$Utils$formatDateTimeFromPosixWithSeconds = function (timezone) {
	return A2(
		$ryan_haskell$date_format$DateFormat$format,
		_List_fromArray(
			[
				$ryan_haskell$date_format$DateFormat$dayOfMonthFixed,
				$ryan_haskell$date_format$DateFormat$text('/'),
				$ryan_haskell$date_format$DateFormat$monthFixed,
				$ryan_haskell$date_format$DateFormat$text('/'),
				$ryan_haskell$date_format$DateFormat$yearNumber,
				$ryan_haskell$date_format$DateFormat$text(' '),
				$ryan_haskell$date_format$DateFormat$hourMilitaryFixed,
				$ryan_haskell$date_format$DateFormat$text(':'),
				$ryan_haskell$date_format$DateFormat$minuteFixed,
				$ryan_haskell$date_format$DateFormat$text(':'),
				$ryan_haskell$date_format$DateFormat$secondFixed
			]),
		timezone);
};
var $author$project$Utils$maskCPF = $Massolari$elm_mask$Mask$number('###.###.###-##');
var $author$project$Utils$maskCPFOrCNPJ = function (value) {
	return ($elm$core$String$length(value) > 11) ? $author$project$Utils$maskCNPJ(value) : $author$project$Utils$maskCPF(value);
};
var $author$project$Services$Financial$pagarmeOrderStatusToBRL = function (status) {
	switch (status) {
		case 0:
			return 'Pendente';
		case 1:
			return 'Cancelado';
		case 2:
			return 'Pago';
		default:
			return 'Falhou';
	}
};
var $author$project$Services$Models$paymentFormatToStr = function (paymentFormat) {
	switch (paymentFormat) {
		case 0:
			return 'Dinheiro';
		case 1:
			return 'Crédito';
		case 2:
			return 'Débito';
		case 3:
			return 'Pix';
		case 4:
			return 'Guia de Pagamento';
		case 5:
			return 'Boleto';
		case 6:
			return 'Estorno';
		case 10:
			return '-';
		case 7:
			return 'Dinheiro no guichê';
		case 11:
			return 'Estorno';
		case 8:
			return 'Cartão de crédito no guichê';
		default:
			return 'Cartão de débito no guichê';
	}
};
var $author$project$Pages$Panel$Financial$PendingTransactions$reportRow = F2(
	function (timezone, row) {
		return _List_fromArray(
			[
				A2($author$project$Utils$formatDateTimeFromPosixWithSeconds, timezone, row.ix),
				$author$project$Services$Financial$pagarmeOrderStatusToBRL(row.kK),
				row.lU,
				$author$project$Utils$maskCPFOrCNPJ(row.iI),
				row.c3,
				$author$project$Services$Models$paymentFormatToStr(row.jW),
				$author$project$Utils$formatAsMoney(
				$elm$core$String$fromInt(row.lo))
			]);
	});
var $author$project$Pages$Panel$Financial$PendingTransactions$valueNotEmpty = function (str) {
	return $elm$core$String$isEmpty(str) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(str);
};
var $author$project$Pages$Panel$Financial$PendingTransactions$reportRowOrderLink = F2(
	function (shared, row) {
		var maybeAccessOrder = A2(
			$elm$core$Maybe$withDefault,
			'',
			A3(
				$elm$core$Maybe$map2,
				F2(
					function (companyID, orderID) {
						return $author$project$Route$toString(
							A2(
								$author$project$Route$Admin,
								$author$project$Route$CompanyOrderDetail(
									{
										l8: companyID,
										mF: orderID,
										ob: $elm$core$Maybe$Nothing,
										pO: $elm$core$Maybe$Just(
											$author$project$Route$toString(shared.pv))
									}),
								$elm$core$Maybe$Nothing));
					}),
				A2($elm$core$Maybe$andThen, $author$project$Pages$Panel$Financial$PendingTransactions$valueNotEmpty, row.l8),
				$author$project$Pages$Panel$Financial$PendingTransactions$valueNotEmpty(row.d1)));
		return maybeAccessOrder;
	});
var $author$project$Pages$Panel$Financial$PendingTransactions$update = F4(
	function (msg, model, shared, user) {
		var queries = model.T;
		switch (msg.$) {
			case 0:
				var now = msg.a.e8;
				var timezone = msg.a.kS;
				var today = A2($justinmimbs$date$Date$fromPosix, timezone, now);
				var newQueries = _Utils_update(
					queries,
					{
						bl: $elm$core$Maybe$Just(
							$justinmimbs$date$Date$toIsoString(today)),
						bB: $elm$core$Maybe$Just(
							$justinmimbs$date$Date$toIsoString(
								A3($justinmimbs$date$Date$add, 1, -1, today)))
					});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{T: newQueries}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 1:
				var rd = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ck: rd}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rd));
			case 2:
				var dateStr = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{bB: dateStr})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 3:
				var dateStr = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{bl: dateStr})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 4:
				var statusStr = msg.a;
				return (statusStr === '-') ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{kK: $elm$core$Maybe$Nothing})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp) : A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$ShowErrorDialog('Erro: ' + (statusStr + ' Status is not mapped in maybeDecodePagarmeOrderStatus'))),
					A2(
						$elm$core$Maybe$map,
						function (status) {
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										T: _Utils_update(
											queries,
											{
												kK: $elm$core$Maybe$Just(status)
											})
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						},
						$author$project$Services$Financial$maybeDecodePagarmeOrderStatus(statusStr)));
			case 5:
				var paymentMethodStr = msg.a;
				return (paymentMethodStr === '-') ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{jW: $elm$core$Maybe$Nothing})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp) : A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$ShowErrorDialog('Erro: ' + (paymentMethodStr + ' Status is not mapped in maybeDecoderPaymentMethod'))),
					A2(
						$elm$core$Maybe$map,
						function (status) {
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										T: _Utils_update(
											queries,
											{
												jW: $elm$core$Maybe$Just(status)
											})
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						},
						$author$project$Services$Models$maybeDecoderPaymentMethod(paymentMethodStr)));
			case 6:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{L: 2}),
					A2(
						$author$project$Route$pushUrl,
						shared.nZ,
						$author$project$Route$Panel(
							$author$project$Route$PanelFinancial(
								$author$project$Route$FinancialPendingTransactions(queries)))),
					$author$project$Shared$NoOp);
			case 7:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dK: !model.dK}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 8:
				return _Utils_Tuple3(
					model,
					A2(
						$elm$core$Task$perform,
						$author$project$Pages$Panel$Financial$PendingTransactions$GenerateCsvDownloadWithTime,
						A3(
							$elm$core$Task$map2,
							F2(
								function (now, timezone) {
									return {e8: now, kS: timezone};
								}),
							$elm$time$Time$now,
							$elm$time$Time$here)),
					$author$project$Shared$NoOp);
			case 9:
				var now = msg.a.e8;
				var timezone = msg.a.kS;
				var title_ = 'Transações pendentes ' + (A2($author$project$Utils$formatDateTimeFromPosix, timezone, now) + '.csv');
				var records = A2(
					$krisajenkins$remotedata$RemoteData$withDefault,
					_List_Nil,
					A2(
						$krisajenkins$remotedata$RemoteData$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.iC;
							},
							$elm$core$List$map(
								function (item) {
									return _Utils_ap(
										A2($author$project$Pages$Panel$Financial$PendingTransactions$reportRow, shared.kS, item),
										_List_fromArray(
											[
												A2(
												$author$project$Services$Models$htmlProtocolWithHostLocalToString,
												shared.qt,
												A2($author$project$Pages$Panel$Financial$PendingTransactions$reportRowOrderLink, shared, item))
											]));
								})),
						model.ck));
				var headers = $author$project$Pages$Panel$Financial$PendingTransactions$reportHeaders;
				return _Utils_Tuple3(
					model,
					A3($author$project$Components$GeneratorCSV$download, records, headers, title_),
					$author$project$Shared$NoOp);
			case 10:
				var isShowOptionPage = msg.a;
				var exportType = msg.b;
				var reportType = msg.c;
				if (A2($author$project$Pages$Panel$Financial$PendingTransactions$period31daysInvalid, model.T.bB, model.T.bl)) {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$ShowErrorDialog('O período definido é maior que 31 dias. Ajuste a consulta e tente novamente.'));
				} else {
					var newQueries = model.T;
					var _v1 = A3(
						$author$project$Components$PDF$Create$update,
						A4(
							$author$project$Components$PDF$Create$ClickedOpenModal,
							isShowOptionPage,
							exportType,
							reportType,
							$author$project$Pages$Panel$Financial$PendingTransactions$queriesToFilter(newQueries)),
						model.bQ,
						user);
					var newCompModel = _v1.a;
					var cmd = _v1.b;
					var sharedMsg = _v1.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bQ: newCompModel}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Panel$Financial$PendingTransactions$CompPDFCreateMSg, cmd),
						sharedMsg);
				}
			default:
				var msg_ = msg.a;
				var _v2 = A3($author$project$Components$PDF$Create$update, msg_, model.bQ, user);
				var newCompModel = _v2.a;
				var cmd = _v2.b;
				var sharedMsg = _v2.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bQ: newCompModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Panel$Financial$PendingTransactions$CompPDFCreateMSg, cmd),
					sharedMsg);
		}
	});
var $author$project$Pages$Panel$Financial$Transactions$CompPDFCreateMSg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Panel$Financial$Transactions$GenerateCsvDownloadWithTime = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Panel$Financial$Transactions$addAnotherTab = F3(
	function (currentPage, currentTotal, rdRecords) {
		return A2(
			$krisajenkins$remotedata$RemoteData$withDefault,
			currentTotal,
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				function (r) {
					var isLastPage = _Utils_eq(
						$elm$core$Basics$ceiling(currentTotal / $author$project$Pages$Panel$Financial$Transactions$cardsPerPage),
						currentPage);
					return (_Utils_eq(
						$elm$core$List$length(r),
						$author$project$Pages$Panel$Financial$Transactions$cardsPerPage) && isLastPage) ? (currentTotal + $author$project$Pages$Panel$Financial$Transactions$cardsPerPage) : (_Utils_eq(
						$elm$core$List$length(r),
						$author$project$Pages$Panel$Financial$Transactions$cardsPerPage) ? currentTotal : (currentPage * $author$project$Pages$Panel$Financial$Transactions$cardsPerPage));
				},
				rdRecords));
	});
var $author$project$Pages$Panel$Financial$Transactions$toPosix = function (str) {
	return A2(
		$elm$core$Maybe$andThen,
		$author$project$Utils$dateHTMLToPosixWithZone($elm$time$Time$utc),
		str);
};
var $author$project$Pages$Panel$Financial$Transactions$period31daysInvalid = F2(
	function (start, end) {
		var diff = A3(
			$elm$core$Maybe$map2,
			A2($justinmimbs$time_extra$Time$Extra$diff, 11, $elm$time$Time$utc),
			$author$project$Pages$Panel$Financial$Transactions$toPosix(start),
			$author$project$Pages$Panel$Financial$Transactions$toPosix(end));
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$lt(31),
				diff));
	});
var $author$project$Pages$Panel$Financial$Transactions$queriesToFilter = function (queries) {
	var maybeQ = F2(
		function (param, mValue) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (v) {
						return $elm$core$List$singleton(
							{oK: param, di: v});
					},
					mValue));
		});
	return _Utils_ap(
		A2(maybeQ, 'created_since', queries.bB),
		_Utils_ap(
			A2(maybeQ, 'created_until', queries.bl),
			A2(
				maybeQ,
				'page',
				$elm$core$Maybe$Just(
					$elm$core$String$fromInt(queries.bv)))));
};
var $author$project$Pages$Panel$Financial$Transactions$reportHeaders = _List_fromArray(
	['Criação', 'Pagamento', 'Disponível', 'Situação', 'Cód.Pagarme', 'Documento', 'Razão social', 'Tipo de pagamento', 'Valor de venda', 'Taxa Pagar.me', 'Valor liquido', 'Link do pedido']);
var $author$project$Services$Financial$pagarmePayablesStatusToBRL = function (status) {
	switch (status) {
		case 0:
			return 'Liberado';
		case 1:
			return 'Aguardando';
		default:
			return 'pré-pago';
	}
};
var $author$project$Pages$Panel$Financial$Transactions$reportRow = F2(
	function (timezone, row) {
		var sumFee = (row.iR + row.lp) + row.nu;
		return _List_fromArray(
			[
				A2($author$project$Utils$formatDateTimeFromPosixWithSeconds, timezone, row.ix),
				A2($author$project$Utils$formatDateTimeFromPosixWithSeconds, timezone, row.jV),
				A2($author$project$Utils$formatDateFromPosix, timezone, row.ly),
				$author$project$Services$Financial$pagarmePayablesStatusToBRL(row.kK),
				row.lU,
				$author$project$Utils$maskCPFOrCNPJ(row.iI),
				row.c3,
				$author$project$Services$Models$paymentFormatToStr(row.jW),
				$author$project$Utils$formatAsMoney(
				$elm$core$String$fromInt(row.lo)),
				$author$project$Utils$formatAsMoney(
				$elm$core$String$fromInt(sumFee)),
				$author$project$Utils$formatAsMoney(
				$elm$core$String$fromInt(row.lo - sumFee))
			]);
	});
var $author$project$Pages$Panel$Financial$Transactions$valueNotEmpty = function (str) {
	return $elm$core$String$isEmpty(str) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(str);
};
var $author$project$Pages$Panel$Financial$Transactions$reportRowOrderLink = F2(
	function (shared, row) {
		var maybeAccessOrder = A2(
			$elm$core$Maybe$withDefault,
			'',
			A3(
				$elm$core$Maybe$map2,
				F2(
					function (companyID, orderID) {
						return $author$project$Route$toString(
							A2(
								$author$project$Route$Admin,
								$author$project$Route$CompanyOrderDetail(
									{
										l8: companyID,
										mF: orderID,
										ob: $elm$core$Maybe$Nothing,
										pO: $elm$core$Maybe$Just(
											$author$project$Route$toString(shared.pv))
									}),
								$elm$core$Maybe$Nothing));
					}),
				row.l8,
				$author$project$Pages$Panel$Financial$Transactions$valueNotEmpty(row.d1)));
		return maybeAccessOrder;
	});
var $author$project$Pages$Panel$Financial$Transactions$update = F4(
	function (msg, model, shared, user) {
		var queries = model.T;
		switch (msg.$) {
			case 0:
				var now = msg.a.e8;
				var timezone = msg.a.kS;
				var today = A2($justinmimbs$date$Date$fromPosix, timezone, now);
				var newQueries = _Utils_update(
					queries,
					{
						bl: $elm$core$Maybe$Just(
							$justinmimbs$date$Date$toIsoString(today)),
						bB: $elm$core$Maybe$Just(
							$justinmimbs$date$Date$toIsoString(
								A3($justinmimbs$date$Date$add, 1, -1, today)))
					});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{T: newQueries}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 1:
				var rd = msg.a;
				var updateQueries = _Utils_update(
					queries,
					{
						gk: A3($author$project$Pages$Panel$Financial$Transactions$addAnotherTab, queries.bv, queries.gk, rd)
					});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{T: updateQueries, ck: rd}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rd));
			case 2:
				var dateStr = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{bB: dateStr})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 3:
				var dateStr = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{bl: dateStr})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 4:
				var statusStr = msg.a;
				return (statusStr === '') ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{kK: $elm$core$Maybe$Nothing})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp) : A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$ShowErrorDialog('Erro: ' + (statusStr + ' Status is not mapped in decodePagarmePayablesStatus'))),
					A2(
						$elm$core$Maybe$map,
						function (status) {
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										T: _Utils_update(
											queries,
											{
												kK: $elm$core$Maybe$Just(status)
											})
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						},
						$author$project$Services$Financial$maybeDecodePagarmePayablesStatus(statusStr)));
			case 5:
				var paymentMethodStr = msg.a;
				return (paymentMethodStr === '') ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{jW: $elm$core$Maybe$Nothing})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp) : A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$ShowErrorDialog('Erro: ' + (paymentMethodStr + ' Status is not mapped in maybeDecoderPaymentMethod'))),
					A2(
						$elm$core$Maybe$map,
						function (status) {
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										T: _Utils_update(
											queries,
											{
												jW: $elm$core$Maybe$Just(status)
											})
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						},
						$author$project$Services$Models$maybeDecoderPaymentMethod(paymentMethodStr)));
			case 6:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{L: 2}),
					A2(
						$author$project$Route$pushUrl,
						shared.nZ,
						$author$project$Route$Panel(
							$author$project$Route$PanelFinancial(
								$author$project$Route$FinancialTransactions(queries)))),
					$author$project$Shared$NoOp);
			case 7:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dK: !model.dK}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 8:
				return _Utils_Tuple3(
					model,
					A2(
						$elm$core$Task$perform,
						$author$project$Pages$Panel$Financial$Transactions$GenerateCsvDownloadWithTime,
						A3(
							$elm$core$Task$map2,
							F2(
								function (now, timezone) {
									return {e8: now, kS: timezone};
								}),
							$elm$time$Time$now,
							$elm$time$Time$here)),
					$author$project$Shared$NoOp);
			case 9:
				var now = msg.a.e8;
				var timezone = msg.a.kS;
				var title_ = 'Transações ' + (A2($author$project$Utils$formatDateTimeFromPosix, timezone, now) + '.csv');
				var records = A2(
					$krisajenkins$remotedata$RemoteData$withDefault,
					_List_Nil,
					A2(
						$krisajenkins$remotedata$RemoteData$map,
						$elm$core$List$map(
							function (item) {
								return _Utils_ap(
									A2($author$project$Pages$Panel$Financial$Transactions$reportRow, shared.kS, item),
									_List_fromArray(
										[
											A2(
											$author$project$Services$Models$htmlProtocolWithHostLocalToString,
											shared.qt,
											A2($author$project$Pages$Panel$Financial$Transactions$reportRowOrderLink, shared, item))
										]));
							}),
						model.ck));
				var headers = $author$project$Pages$Panel$Financial$Transactions$reportHeaders;
				return _Utils_Tuple3(
					model,
					A3($author$project$Components$GeneratorCSV$download, records, headers, title_),
					$author$project$Shared$NoOp);
			case 10:
				var isShowOptionPage = msg.a;
				var exportType = msg.b;
				var reportType = msg.c;
				if (A2($author$project$Pages$Panel$Financial$Transactions$period31daysInvalid, model.T.bB, model.T.bl)) {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$ShowErrorDialog('O período definido é maior que 31 dias. Ajuste a consulta e tente novamente.'));
				} else {
					var newQueries = model.T;
					var _v1 = A3(
						$author$project$Components$PDF$Create$update,
						A4(
							$author$project$Components$PDF$Create$ClickedOpenModal,
							isShowOptionPage,
							exportType,
							reportType,
							$author$project$Pages$Panel$Financial$Transactions$queriesToFilter(newQueries)),
						model.bQ,
						user);
					var newCompModel = _v1.a;
					var cmd = _v1.b;
					var sharedMsg = _v1.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bQ: newCompModel}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Panel$Financial$Transactions$CompPDFCreateMSg, cmd),
						sharedMsg);
				}
			default:
				var msg_ = msg.a;
				var _v2 = A3($author$project$Components$PDF$Create$update, msg_, model.bQ, user);
				var newCompModel = _v2.a;
				var cmd = _v2.b;
				var sharedMsg = _v2.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bQ: newCompModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Panel$Financial$Transactions$CompPDFCreateMSg, cmd),
					sharedMsg);
		}
	});
var $author$project$Pages$Panel$History$GenerateCsvDownloadWithTime = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Panel$History$cardsPerPage = 500;
var $author$project$Pages$Panel$History$addAnotherTab = F3(
	function (currentPage, currentTotal, rdRecords) {
		return A2(
			$krisajenkins$remotedata$RemoteData$withDefault,
			currentTotal,
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				function (r) {
					var isLastPage = _Utils_eq(
						$elm$core$Basics$ceiling(currentTotal / $author$project$Pages$Panel$History$cardsPerPage),
						currentPage);
					return (_Utils_eq(
						$elm$core$List$length(r),
						$author$project$Pages$Panel$History$cardsPerPage) && isLastPage) ? (currentTotal + $author$project$Pages$Panel$History$cardsPerPage) : (_Utils_eq(
						$elm$core$List$length(r),
						$author$project$Pages$Panel$History$cardsPerPage) ? currentTotal : (currentPage * $author$project$Pages$Panel$History$cardsPerPage));
				},
				rdRecords));
	});
var $author$project$Pages$Panel$History$reportHeaders = _List_fromArray(
	['Criado em', 'Ação realizada por', 'Ação recebida por', 'Campo alterado', 'Cartão', 'Descrição', 'Módulo', 'Informação anterior', 'Nova informação']);
var $author$project$Pages$Panel$History$setsEmptyValue = function (v_) {
	return $elm$core$String$isEmpty(v_) ? '-' : v_;
};
var $author$project$Pages$Panel$History$reportRow = F2(
	function (timezone, row) {
		return A2(
			$elm$core$List$map,
			$author$project$Pages$Panel$History$setsEmptyValue,
			_List_fromArray(
				[
					A2($author$project$Utils$formatDateTimeFromPosixWithSeconds, timezone, row.ix),
					row.m8,
					row.qz,
					row.lT,
					row.lO,
					row.z,
					row.oi,
					row.os,
					row.oo
				]));
	});
var $author$project$Pages$Panel$History$valueNotEmpty = function (str) {
	return $elm$core$String$isEmpty(str) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(str);
};
var $author$project$Pages$Panel$History$update = F3(
	function (msg, model, shared) {
		var queries = model.T;
		switch (msg.$) {
			case 0:
				var now = msg.a.e8;
				var timezone = msg.a.kS;
				var today = A2($justinmimbs$date$Date$fromPosix, timezone, now);
				var newQueries = _Utils_update(
					queries,
					{
						bl: $elm$core$Maybe$Just(
							$justinmimbs$date$Date$toIsoString(today)),
						bB: $elm$core$Maybe$Just(
							$justinmimbs$date$Date$toIsoString(
								A3($justinmimbs$date$Date$add, 3, -1, today)))
					});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{T: newQueries}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 1:
				var rd = msg.a;
				var updateQueries = _Utils_update(
					queries,
					{
						gk: A3($author$project$Pages$Panel$History$addAnotherTab, queries.bv, queries.gk, rd)
					});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{T: updateQueries, ck: rd}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rd));
			case 2:
				if (!msg.a.$) {
					var users = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ei: $krisajenkins$remotedata$RemoteData$Success(users)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ei: $krisajenkins$remotedata$RemoteData$Failure(error)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$ShowErrorDialog('Algo deu errado!'));
				}
			case 3:
				var dateStr = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{bB: dateStr})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 4:
				var dateStr = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{bl: dateStr})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 5:
				var userStr = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{kZ: userStr})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 6:
				var ms = msg.a;
				var isOpen = msg.b;
				if (!ms) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dS: isOpen}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dQ: isOpen}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				}
			case 7:
				var userID = msg.a;
				var updateCodeList = function () {
					var _v2 = _Utils_Tuple2(
						$author$project$Pages$Panel$History$valueNotEmpty(userID),
						A2(
							$elm$core$List$any,
							$elm$core$Basics$eq(userID),
							model.T.bZ));
					if (!_v2.a.$) {
						if (_v2.b) {
							var l = _v2.a.a;
							var updateLineCodeListDeselectAllLines = A2(
								$elm$core$List$any,
								$elm$core$Basics$eq(''),
								model.T.bZ) ? A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(''),
								model.T.bZ) : model.T.bZ;
							return A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(l),
								updateLineCodeListDeselectAllLines);
						} else {
							var l = _v2.a.a;
							var _new = A2($elm$core$List$cons, l, model.T.bZ);
							var all = A2(
								$elm$core$List$map,
								function ($) {
									return $.dM;
								},
								A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, model.ei));
							return _Utils_eq(
								$elm$core$List$length(all),
								$elm$core$List$length(_new)) ? A2($elm$core$List$cons, '', _new) : _new;
						}
					} else {
						if (_v2.b) {
							var _v3 = _v2.a;
							return _List_Nil;
						} else {
							var _v4 = _v2.a;
							var all = A2(
								$elm$core$List$map,
								function ($) {
									return $.dM;
								},
								A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, model.ei));
							return A2($elm$core$List$cons, userID, all);
						}
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{bZ: updateCodeList})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 8:
				var actionTypeCODE = msg.a;
				var updateCodeList = function () {
					var _v5 = _Utils_Tuple2(
						$author$project$Pages$Panel$History$valueNotEmpty(actionTypeCODE),
						A2(
							$elm$core$List$any,
							$elm$core$Basics$eq(actionTypeCODE),
							model.T.bK));
					if (!_v5.a.$) {
						if (_v5.b) {
							var l = _v5.a.a;
							var updateLineCodeListDeselectAllLines = A2(
								$elm$core$List$any,
								$elm$core$Basics$eq(''),
								model.T.bK) ? A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(''),
								model.T.bK) : model.T.bK;
							return A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(l),
								updateLineCodeListDeselectAllLines);
						} else {
							var l = _v5.a.a;
							var _new = A2($elm$core$List$cons, l, model.T.bK);
							var all = A2(
								$elm$core$List$map,
								function ($) {
									return $.l4;
								},
								model.dl);
							return _Utils_eq(
								$elm$core$List$length(all),
								$elm$core$List$length(_new)) ? A2($elm$core$List$cons, '', _new) : _new;
						}
					} else {
						if (_v5.b) {
							var _v6 = _v5.a;
							return _List_Nil;
						} else {
							var _v7 = _v5.a;
							var all = A2(
								$elm$core$List$map,
								function ($) {
									return $.l4;
								},
								model.dl);
							return A2($elm$core$List$cons, actionTypeCODE, all);
						}
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{bK: updateCodeList})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 9:
				return _Utils_Tuple3(
					model,
					A2(
						$author$project$Route$pushUrl,
						shared.nZ,
						$author$project$Route$Panel(
							$author$project$Route$History(queries))),
					$author$project$Shared$NoOp);
			case 10:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dK: !model.dK}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 11:
				return _Utils_Tuple3(
					model,
					A2(
						$elm$core$Task$perform,
						$author$project$Pages$Panel$History$GenerateCsvDownloadWithTime,
						A3(
							$elm$core$Task$map2,
							F2(
								function (now, timezone) {
									return {e8: now, kS: timezone};
								}),
							$elm$time$Time$now,
							$elm$time$Time$here)),
					$author$project$Shared$NoOp);
			default:
				var now = msg.a.e8;
				var timezone = msg.a.kS;
				var title_ = 'Histórico ' + (A2($author$project$Utils$formatDateTimeFromPosix, timezone, now) + '.csv');
				var records = A2(
					$krisajenkins$remotedata$RemoteData$withDefault,
					_List_Nil,
					A2(
						$krisajenkins$remotedata$RemoteData$map,
						$elm$core$List$map(
							function (item) {
								return A2($author$project$Pages$Panel$History$reportRow, shared.kS, item);
							}),
						model.ck));
				var headers = $author$project$Pages$Panel$History$reportHeaders;
				return _Utils_Tuple3(
					model,
					A3($author$project$Components$GeneratorCSV$download, records, headers, title_),
					$author$project$Shared$NoOp);
		}
	});
var $author$project$Pages$Panel$ManageFare$CREATE = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Panel$ManageFare$GotEditFare = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Pages$Panel$ManageFare$HISTORY = function (a) {
	return {$: 1, a: a};
};
var $author$project$Utils$formatDatetimeLocalInputHTMLFromPosix = function (timezone) {
	return A2(
		$ryan_haskell$date_format$DateFormat$format,
		_List_fromArray(
			[
				$ryan_haskell$date_format$DateFormat$yearNumber,
				$ryan_haskell$date_format$DateFormat$text('-'),
				$ryan_haskell$date_format$DateFormat$monthFixed,
				$ryan_haskell$date_format$DateFormat$text('-'),
				$ryan_haskell$date_format$DateFormat$dayOfMonthFixed,
				$ryan_haskell$date_format$DateFormat$text('T'),
				$ryan_haskell$date_format$DateFormat$hourMilitaryFixed,
				$ryan_haskell$date_format$DateFormat$text(':'),
				$ryan_haskell$date_format$DateFormat$minuteFixed,
				$ryan_haskell$date_format$DateFormat$text(':'),
				$ryan_haskell$date_format$DateFormat$secondFixed
			]),
		timezone);
};
var $author$project$Pages$Panel$ManageFare$initModalCREATE = F2(
	function (timezone, fare) {
		return A2(
			$elm$core$Maybe$withDefault,
			{
				l4: '',
				aT: '',
				L: 0,
				b$: false,
				aW: false,
				b2: $elm$time$Time$millisToPosix(0),
				di: ''
			},
			A2(
				$elm$core$Maybe$map,
				function (f) {
					return {
						l4: f.l4,
						aT: A2($author$project$Utils$formatDatetimeLocalInputHTMLFromPosix, timezone, f.aT),
						L: 0,
						b$: true,
						aW: !f.di,
						b2: $elm$time$Time$millisToPosix(0),
						di: $elm$core$String$fromInt(f.di)
					};
				},
				fare));
	});
var $author$project$Pages$Panel$ManageFare$GotFareHistory = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Panel$ManageFare$ModalMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Services$Fares$FareHistory = F6(
	function (id, createdAt, value, effectiveFrom, active, userName) {
		return {at: active, ix: createdAt, aT: effectiveFrom, dM: id, qx: userName, di: value};
	});
var $author$project$Services$Fares$decodeFareHistory = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
	_List_fromArray(
		['user', 'name']),
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'active',
		$author$project$Services$Fares$decodeStatus,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'effectiveFrom',
			$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'value',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'createdAt',
					$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Services$Fares$FareHistory)))))));
var $author$project$Services$Fares$getHistoryFare = function (options) {
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$elm$json$Json$Decode$list($author$project$Services$Fares$decodeFareHistory)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'fares', options.iQ]),
				_List_Nil)
		});
};
var $author$project$Pages$Panel$ManageFare$initModalHISTORY = F2(
	function (user, fare) {
		return _Utils_Tuple2(
			{ni: fare, eN: $krisajenkins$remotedata$RemoteData$Loading},
			$author$project$Services$Fares$getHistoryFare(
				{
					iQ: fare.l4,
					ow: A2($elm$core$Basics$composeL, $author$project$Pages$Panel$ManageFare$ModalMsg, $author$project$Pages$Panel$ManageFare$GotFareHistory),
					kU: user.kU
				}));
	});
var $author$project$Services$Fares$encodeStatus = function (status) {
	if (!status) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Services$Fares$putFareEdit = function (options) {
	return $author$project$Services$Api$putHttp(
		{
			lG: $elm$http$Http$jsonBody(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'active',
							$elm$json$Json$Encode$bool(
								$author$project$Services$Fares$encodeStatus(options.nj)))
						]))),
			m9: $author$project$Services$Api$expectWhateverErrorString(
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'fares', options.iQ]),
				_List_Nil)
		});
};
var $author$project$Services$Fares$statusChangeApplied = function (status) {
	if (!status) {
		return 'ativada';
	} else {
		return 'desativada';
	}
};
var $author$project$Services$Fares$toggleStatus = function (status) {
	if (!status) {
		return 1;
	} else {
		return 0;
	}
};
var $author$project$Pages$Panel$ManageFare$GotCreateFare = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Panel$ManageFare$GotCurrentDate = function (a) {
	return {$: 6, a: a};
};
var $author$project$Services$Fares$encodeCreateFare = function (options) {
	var objectElement = F3(
		function (key, encode, value) {
			return _List_fromArray(
				[
					_Utils_Tuple2(
					key,
					encode(value))
				]);
		});
	return $elm$json$Json$Encode$object(
		_Utils_ap(
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					A2(objectElement, 'value', $elm$json$Json$Encode$int),
					$elm$core$String$toInt(options.di))),
			_List_fromArray(
				[
					_Utils_Tuple2(
					'code',
					$elm$json$Json$Encode$string(options.l4)),
					_Utils_Tuple2(
					'effectiveFrom',
					$elm$json$Json$Encode$string(options.aT)),
					_Utils_Tuple2(
					'active',
					$elm$json$Json$Encode$bool(true))
				])));
};
var $author$project$Services$Fares$postCreateFare = function (options) {
	return $author$project$Services$Api$postHttp(
		{
			lG: $elm$http$Http$jsonBody(
				$author$project$Services$Fares$encodeCreateFare(
					{l4: options.l4, aT: options.aT, di: options.di})),
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$author$project$Services$Fares$decodeFare),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'fares']),
				_List_Nil)
		});
};
var $author$project$Pages$Panel$ManageFare$updateModal = F3(
	function (msg, model, user) {
		var _v0 = _Utils_Tuple2(msg, model.aY);
		_v0$9:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					if ((!_v0.b.$) && (!_v0.b.a.$)) {
						var newCode = _v0.a.a;
						var m = _v0.b.a.a;
						var updateModal_ = _Utils_update(
							m,
							{l4: newCode});
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $elm$core$Maybe$Just(
										$author$project$Pages$Panel$ManageFare$CREATE(updateModal_))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					} else {
						break _v0$9;
					}
				case 1:
					if ((!_v0.b.$) && (!_v0.b.a.$)) {
						var newValue = _v0.a.a;
						var m = _v0.b.a.a;
						var updateModal_ = _Utils_update(
							m,
							{di: newValue});
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $elm$core$Maybe$Just(
										$author$project$Pages$Panel$ManageFare$CREATE(updateModal_))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					} else {
						break _v0$9;
					}
				case 2:
					if ((!_v0.b.$) && (!_v0.b.a.$)) {
						var newEffectiveFrom = _v0.a.a;
						var m = _v0.b.a.a;
						var append_ = ($elm$core$String$length(newEffectiveFrom) < 19) ? A2($elm$core$String$append, newEffectiveFrom, ':00') : newEffectiveFrom;
						var updateModal_ = _Utils_update(
							m,
							{aT: append_});
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $elm$core$Maybe$Just(
										$author$project$Pages$Panel$ManageFare$CREATE(updateModal_))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					} else {
						break _v0$9;
					}
				case 5:
					var _v1 = _v0.a;
					return _Utils_Tuple3(
						model,
						A2(
							$elm$core$Task$perform,
							A2($elm$core$Basics$composeR, $author$project$Pages$Panel$ManageFare$GotCurrentDate, $author$project$Pages$Panel$ManageFare$ModalMsg),
							A3(
								$elm$core$Task$map2,
								F2(
									function (now, timezone) {
										return {e8: now, kS: timezone};
									}),
								$elm$time$Time$now,
								$elm$time$Time$here)),
						$author$project$Shared$NoOp);
				case 6:
					if ((!_v0.b.$) && (!_v0.b.a.$)) {
						var now = _v0.a.a.e8;
						var timezone = _v0.a.a.kS;
						var m = _v0.b.a.a;
						var dateTimeInPosix = A2(
							$elm$core$Maybe$withDefault,
							$elm$time$Time$millisToPosix(0),
							A2($author$project$Utils$datetimeLocalHTMLToPosixWithZone, timezone, m.aT));
						var isInvalid = $elm$core$String$isEmpty(m.aT) || ($elm$core$String$isEmpty(m.di) || ($elm$core$String$isEmpty(m.l4) || (_Utils_cmp(
							$elm$time$Time$posixToMillis(now),
							$elm$time$Time$posixToMillis(dateTimeInPosix)) > -1)));
						return isInvalid ? _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $elm$core$Maybe$Just(
										$author$project$Pages$Panel$ManageFare$CREATE(
											_Utils_update(
												m,
												{L: 1, b2: now})))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp) : _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $elm$core$Maybe$Just(
										$author$project$Pages$Panel$ManageFare$CREATE(
											_Utils_update(
												m,
												{L: 2, b2: now})))
								}),
							$author$project$Services$Fares$postCreateFare(
								{
									l4: m.l4,
									aT: m.aT,
									ow: A2($elm$core$Basics$composeR, $author$project$Pages$Panel$ManageFare$GotCreateFare, $author$project$Pages$Panel$ManageFare$ModalMsg),
									kU: user.kU,
									di: m.di
								}),
							$author$project$Shared$NoOp);
					} else {
						break _v0$9;
					}
				case 7:
					if ((!_v0.b.$) && (!_v0.b.a.$)) {
						if (_v0.a.a.$ === 3) {
							var newFare = _v0.a.a.a;
							var m = _v0.b.a.a;
							return A2(
								$krisajenkins$remotedata$RemoteData$withDefault,
								_Utils_Tuple3(
									_Utils_update(
										model,
										{aY: $elm$core$Maybe$Nothing}),
									$author$project$Services$Fares$getFares(
										{ow: $author$project$Pages$Panel$ManageFare$GotFares, kU: user.kU}),
									$author$project$Shared$ShowSuccessDialog('Tarifa criada com sucesso! ')),
								A2(
									$krisajenkins$remotedata$RemoteData$map,
									function (fares) {
										return _Utils_Tuple3(
											_Utils_update(
												model,
												{
													aV: $krisajenkins$remotedata$RemoteData$Success(
														A2($elm$core$List$cons, newFare, fares)),
													aY: $elm$core$Maybe$Nothing
												}),
											$elm$core$Platform$Cmd$none,
											$author$project$Shared$ShowSuccessDialog('Tarifa criada com sucesso!'));
									},
									model.aV));
						} else {
							var result = _v0.a.a;
							var m = _v0.b.a.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $elm$core$Maybe$Just(
											$author$project$Pages$Panel$ManageFare$CREATE(
												_Utils_update(
													m,
													{L: 0})))
									}),
								$elm$core$Platform$Cmd$none,
								A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, result));
						}
					} else {
						break _v0$9;
					}
				case 3:
					if ((!_v0.b.$) && (!_v0.b.a.$)) {
						var _v2 = _v0.a;
						var m = _v0.b.a.a;
						var newIsFreeFare = !m.aW;
						var newValue = newIsFreeFare ? '0' : m.di;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $elm$core$Maybe$Just(
										$author$project$Pages$Panel$ManageFare$CREATE(
											_Utils_update(
												m,
												{aW: newIsFreeFare, di: newValue})))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					} else {
						break _v0$9;
					}
				case 8:
					if ((!_v0.b.$) && (_v0.b.a.$ === 1)) {
						var result = _v0.a.a;
						var m = _v0.b.a.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $elm$core$Maybe$Just(
										$author$project$Pages$Panel$ManageFare$HISTORY(
											_Utils_update(
												m,
												{eN: result})))
								}),
							$elm$core$Platform$Cmd$none,
							A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, result));
					} else {
						break _v0$9;
					}
				default:
					break _v0$9;
			}
		}
		return _Utils_Tuple3(
			model,
			$elm$core$Platform$Cmd$none,
			$author$project$Shared$ShowErrorDialog('Essa MSG não está mapeado'));
	});
var $author$project$Pages$Panel$ManageFare$update = F4(
	function (msg, model, shared, user) {
		var queries = model.T;
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aY: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 1:
				var result = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aV: result}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, result));
			case 2:
				var initModal = $author$project$Pages$Panel$ManageFare$CREATE(
					A2($author$project$Pages$Panel$ManageFare$initModalCREATE, shared.kS, $elm$core$Maybe$Nothing));
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aY: $elm$core$Maybe$Just(initModal)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 3:
				var fare = msg.a;
				var initModal = $author$project$Pages$Panel$ManageFare$CREATE(
					A2(
						$author$project$Pages$Panel$ManageFare$initModalCREATE,
						shared.kS,
						$elm$core$Maybe$Just(fare)));
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aY: $elm$core$Maybe$Just(initModal)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 4:
				var fare = msg.a;
				var _v1 = A2($author$project$Pages$Panel$ManageFare$initModalHISTORY, user, fare);
				var initModal = _v1.a;
				var cmd_ = _v1.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aY: $elm$core$Maybe$Just(
								$author$project$Pages$Panel$ManageFare$HISTORY(initModal))
						}),
					cmd_,
					$author$project$Shared$NoOp);
			case 5:
				var fare = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aV: A2(
								$krisajenkins$remotedata$RemoteData$map,
								function (fs) {
									return A2(
										$elm$core$List$map,
										function (f) {
											return _Utils_eq(f.dM, fare.dM) ? _Utils_update(
												f,
												{
													at: $author$project$Services$Fares$toggleStatus(fare.at)
												}) : f;
										},
										fs);
								},
								model.aV)
						}),
					$author$project$Services$Fares$putFareEdit(
						{
							iQ: fare.l4,
							nj: $author$project$Services$Fares$toggleStatus(fare.at),
							ow: $author$project$Pages$Panel$ManageFare$GotEditFare(fare),
							kU: user.kU
						}),
					$author$project$Shared$NoOp);
			case 6:
				var oldFare = msg.a;
				var result = msg.b;
				var txt = $author$project$Services$Fares$statusChangeApplied(
					$author$project$Services$Fares$toggleStatus(oldFare.at));
				return _Utils_Tuple3(
					model,
					$author$project$Services$Fares$getFares(
						{ow: $author$project$Pages$Panel$ManageFare$GotFares, kU: user.kU}),
					A2(
						$author$project$Shared$remoteDataSharedMsg,
						$elm$core$Maybe$Just('Tarifa ' + (txt + ' com sucesso!')),
						result));
			case 7:
				var newOrderCode = msg.a;
				var nexOrderType = function () {
					var _v2 = _Utils_Tuple2(
						_Utils_eq(
							model.T.mn,
							$elm$core$Maybe$Just(newOrderCode)),
						model.T.mo);
					if (_v2.a) {
						if (_v2.b.$ === 1) {
							var _v3 = _v2.b;
							return $elm$core$Maybe$Just(1);
						} else {
							if (_v2.b.a === 1) {
								var _v4 = _v2.b.a;
								return $elm$core$Maybe$Just(0);
							} else {
								var _v5 = _v2.b.a;
								return $elm$core$Maybe$Nothing;
							}
						}
					} else {
						return $elm$core$Maybe$Just(1);
					}
				}();
				var nextOrderCode = _Utils_eq(nexOrderType, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(newOrderCode);
				var updateQueries = _Utils_update(
					queries,
					{mn: nextOrderCode, mo: nexOrderType});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{T: updateQueries}),
					A2(
						$author$project$Route$pushUrl,
						shared.nZ,
						$author$project$Route$Panel(
							$author$project$Route$ManageFare(updateQueries))),
					$author$project$Shared$NoOp);
			default:
				var msg_ = msg.a;
				return A3($author$project$Pages$Panel$ManageFare$updateModal, msg_, model, user);
		}
	});
var $author$project$Pages$Panel$ManageLines$CREATE = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Panel$ManageLines$EDIT = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Panel$ManageLines$GotFares = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Panel$ManageLines$ModalMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Panel$ManageLines$initModalCREATE = function (user) {
	return _Utils_Tuple2(
		{at: 0, cK: '#f89f00', z: '', aV: $krisajenkins$remotedata$RemoteData$Loading, L: 0, e1: '', c3: '', u: '', as: '#ffffff', kY: 'Local'},
		$author$project$Services$Fares$getFares(
			{
				ow: A2($elm$core$Basics$composeL, $author$project$Pages$Panel$ManageLines$ModalMsg, $author$project$Pages$Panel$ManageLines$GotFares),
				kU: user.kU
			}));
};
var $author$project$Pages$Panel$ManageLines$initModalEDIT = F2(
	function (line, user) {
		return _Utils_Tuple2(
			{at: line.at, du: line.du, cK: '#f89f00', z: line.z, aV: $krisajenkins$remotedata$RemoteData$Loading, L: 0, e1: line.e1, e2: line.dM, c3: line.c3, u: line.gr, as: '#ffffff', kY: 'Local'},
			$author$project$Services$Fares$getFares(
				{
					ow: A2($elm$core$Basics$composeL, $author$project$Pages$Panel$ManageLines$ModalMsg, $author$project$Pages$Panel$ManageLines$GotFares),
					kU: user.kU
				}));
	});
var $author$project$Pages$Panel$ManageLines$GotCreateLine = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Panel$ManageLines$GotEditLine = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Panel$ManageLines$isInvalid = function (validators) {
	return A2(
		$elm$core$List$filterMap,
		function (_v0) {
			var isInvalid_ = _v0.a;
			var error = _v0.b;
			return isInvalid_ ? $elm$core$Maybe$Just(error) : $elm$core$Maybe$Nothing;
		},
		validators);
};
var $author$project$Pages$Panel$ManageLines$isInvalidInput = F2(
	function (input, validators) {
		return A2(
			$elm$core$List$filterMap,
			function (_v0) {
				var isInvalid_ = _v0.a;
				var error = _v0.b;
				return isInvalid_ ? $elm$core$Maybe$Just(error) : $elm$core$Maybe$Nothing;
			},
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$mapFirst(
					function (isInvalid_) {
						return isInvalid_(input);
					}),
				validators));
	});
var $author$project$Pages$Panel$ManageLines$optionsFare = F2(
	function (fareSelected, rdFares) {
		return A2(
			$krisajenkins$remotedata$RemoteData$withDefault,
			_List_Nil,
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				function (fares) {
					var listCODE = $elm$core$Dict$keys(
						$elm$core$Dict$fromList(
							A2(
								$elm$core$List$map,
								function (f) {
									return _Utils_Tuple2(f.l4, f);
								},
								fares)));
					var filtered = A2(
						$elm$core$List$filterMap,
						function (fCODE) {
							return $elm$core$List$head(
								A2(
									$elm$core$List$sortBy,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.aT;
										},
										$elm$time$Time$posixToMillis),
									A2(
										$elm$core$List$filter,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.l4;
											},
											$elm$core$Basics$eq(fCODE)),
										fares)));
						},
						listCODE);
					return A2(
						$elm$core$List$map,
						function (fare) {
							return {
								eX: _Utils_eq(fare.dM, fareSelected),
								c3: fare.l4,
								di: fare.dM
							};
						},
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.at;
								},
								$elm$core$Basics$eq(0)),
							filtered));
				},
				rdFares));
	});
var $author$project$Pages$Panel$ManageLines$optionsLineType = function (lineTypeSelected) {
	var list = _List_fromArray(
		['Local', 'Metropolitano']);
	return A2(
		$elm$core$List$map,
		function (type_) {
			return {
				eX: _Utils_eq(lineTypeSelected, type_),
				c3: type_,
				di: type_
			};
		},
		list);
};
var $author$project$Pages$Panel$ManageLines$validatorsColor = function (valueSelected) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			$elm$core$String$length(valueSelected) <= 1,
			'Cor não pode ser vazio')
		]);
};
var $author$project$Pages$Panel$ManageLines$validatorsColorText = function (valueSelected) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			$elm$core$String$length(valueSelected) <= 1,
			'Cor do texto não pode ser vazio')
		]);
};
var $author$project$Pages$Panel$ManageLines$validatorsDescription = _List_fromArray(
	[
		_Utils_Tuple2($elm$core$String$isEmpty, 'Descrição não pode ser vazio')
	]);
var $author$project$Pages$Panel$ManageLines$validatorsFare = F3(
	function (valueSelected, fares, options) {
		var isInactiveFare = function (f) {
			return _Utils_eq(f.dM, valueSelected) && (f.at === 1);
		};
		var getSelected = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.di;
					},
					$elm$core$Basics$eq(valueSelected)),
				options));
		var getInactiveFareCODE = A2(
			$elm$core$Maybe$withDefault,
			'-',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.l4;
				},
				$elm$core$List$head(
					A2($elm$core$List$filter, isInactiveFare, fares))));
		return _List_fromArray(
			[
				_Utils_Tuple2(
				A2(
					$elm$core$Maybe$withDefault,
					true,
					A2(
						$elm$core$Maybe$map,
						function (_v0) {
							return false;
						},
						getSelected)),
				'Tarifa é obrigatório'),
				_Utils_Tuple2(
				A2($elm$core$List$any, isInactiveFare, fares),
				'A tarifa (' + (getInactiveFareCODE + ') está inativa'))
			]);
	});
var $author$project$Pages$Panel$ManageLines$validatorsLine = _List_fromArray(
	[
		_Utils_Tuple2(
		A2(
			$elm$core$Basics$composeR,
			$elm$core$String$toInt,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$withDefault(0),
				$elm$core$Basics$ge(0))),
		'Valor precisa ser maior que 0'),
		_Utils_Tuple2(
		A2(
			$elm$core$Basics$composeR,
			$elm$core$String$toInt,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$withDefault(0),
				$elm$core$Basics$lt(255))),
		'Valor precisa ser menor que 255')
	]);
var $author$project$Pages$Panel$ManageLines$validatorsLineType = F2(
	function (valueSelected, options) {
		var getSelected = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.di;
					},
					$elm$core$Basics$eq(valueSelected)),
				options));
		return _List_fromArray(
			[
				_Utils_Tuple2(
				A2(
					$elm$core$Maybe$withDefault,
					true,
					A2(
						$elm$core$Maybe$map,
						function (_v0) {
							return false;
						},
						getSelected)),
				'Tipo da linha é obrigatório')
			]);
	});
var $author$project$Pages$Panel$ManageLines$validatorsName = _List_fromArray(
	[
		_Utils_Tuple2($elm$core$String$isEmpty, 'Nome não pode ser vazio')
	]);
var $author$project$Pages$Panel$ManageLines$allValidatorsToSubmitted = function (m) {
	return _Utils_ap(
		$author$project$Pages$Panel$ManageLines$isInvalid(
			$author$project$Pages$Panel$ManageLines$validatorsColorText(m.as)),
		_Utils_ap(
			$author$project$Pages$Panel$ManageLines$isInvalid(
				$author$project$Pages$Panel$ManageLines$validatorsColor(m.cK)),
			_Utils_ap(
				$author$project$Pages$Panel$ManageLines$isInvalid(
					A2(
						$author$project$Pages$Panel$ManageLines$validatorsLineType,
						m.kY,
						$author$project$Pages$Panel$ManageLines$optionsLineType(m.kY))),
				_Utils_ap(
					A2($author$project$Pages$Panel$ManageLines$isInvalidInput, m.z, $author$project$Pages$Panel$ManageLines$validatorsDescription),
					_Utils_ap(
						A2($author$project$Pages$Panel$ManageLines$isInvalidInput, m.c3, $author$project$Pages$Panel$ManageLines$validatorsName),
						_Utils_ap(
							A2($author$project$Pages$Panel$ManageLines$isInvalidInput, m.e1, $author$project$Pages$Panel$ManageLines$validatorsLine),
							$author$project$Pages$Panel$ManageLines$isInvalid(
								A3(
									$author$project$Pages$Panel$ManageLines$validatorsFare,
									m.u,
									A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, m.aV),
									A2($author$project$Pages$Panel$ManageLines$optionsFare, m.u, m.aV)))))))));
};
var $krisajenkins$remotedata$RemoteData$isSuccess = function (data) {
	if (data.$ === 3) {
		var x = data.a;
		return true;
	} else {
		return false;
	}
};
var $author$project$Pages$Panel$ManageLines$isValidInputEmptyValue = function (input) {
	var _v0 = $elm$core$String$toInt(input);
	if (!_v0.$) {
		var number = _v0.a;
		return (number >= 0) && (number <= 255);
	} else {
		return $elm$core$String$isEmpty(input);
	}
};
var $author$project$Services$Line$encodeStatus = function (status) {
	if (!status) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Services$Line$encodeLine = function (options) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'fareID',
				$elm$json$Json$Encode$string(options.gr)),
				_Utils_Tuple2(
				'line',
				$elm$json$Json$Encode$string(options.e1)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(options.c3)),
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(options.z)),
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string(options.kY)),
				_Utils_Tuple2(
				'color',
				$elm$json$Json$Encode$string(options.cK)),
				_Utils_Tuple2(
				'textColor',
				$elm$json$Json$Encode$string(options.as)),
				_Utils_Tuple2(
				'active',
				$elm$json$Json$Encode$bool(
					$author$project$Services$Line$encodeStatus(options.at)))
			]));
};
var $author$project$Services$Line$postLine = function (options) {
	return $author$project$Services$Api$postHttp(
		{
			lG: $elm$http$Http$jsonBody(
				$author$project$Services$Line$encodeLine(options)),
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$author$project$Services$Line$decodeLine),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'lines']),
				_List_Nil)
		});
};
var $author$project$Services$Line$encodePutLine = function (options) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'fareID',
				$elm$json$Json$Encode$string(options.gr)),
				_Utils_Tuple2(
				'cityID',
				$elm$json$Json$Encode$string(options.du)),
				_Utils_Tuple2(
				'line',
				$elm$json$Json$Encode$string(options.e1)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(options.c3)),
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(options.z)),
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string(options.kY)),
				_Utils_Tuple2(
				'color',
				$elm$json$Json$Encode$string(options.cK)),
				_Utils_Tuple2(
				'textColor',
				$elm$json$Json$Encode$string(options.as)),
				_Utils_Tuple2(
				'active',
				$elm$json$Json$Encode$bool(
					$author$project$Services$Line$encodeStatus(options.at)))
			]));
};
var $author$project$Services$Line$putLine = function (options) {
	return $author$project$Services$Api$putHttp(
		{
			lG: $elm$http$Http$jsonBody(
				$author$project$Services$Line$encodePutLine(options)),
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$author$project$Services$Line$decodeLine),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'lines', options.e2]),
				_List_Nil)
		});
};
var $author$project$Services$Line$strCodeToStatus = function (strCODE) {
	switch (strCODE) {
		case 'ativo':
			return $elm$core$Maybe$Just(0);
		case 'inativo':
			return $elm$core$Maybe$Just(1);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$Panel$ManageLines$updateModal = F3(
	function (msg, user, model) {
		var _v0 = _Utils_Tuple2(msg, model.aY);
		_v0$22:
		while (true) {
			if (!_v0.b.$) {
				if (!_v0.b.a.$) {
					switch (_v0.a.$) {
						case 0:
							var remoteData = _v0.a.a;
							var m = _v0.b.a.a;
							var getInactiveFareSelected = function (f) {
								return _Utils_eq(f.dM, m.u) && (f.at === 1);
							};
							var hasError = A2(
								$elm$core$List$any,
								getInactiveFareSelected,
								A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, remoteData));
							var formStatus = hasError ? 1 : m.L;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $elm$core$Maybe$Just(
											$author$project$Pages$Panel$ManageLines$CREATE(
												_Utils_update(
													m,
													{aV: remoteData, L: formStatus})))
									}),
								$elm$core$Platform$Cmd$none,
								A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, remoteData));
						case 3:
							var fareID = _v0.a.a;
							var m = _v0.b.a.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $elm$core$Maybe$Just(
											$author$project$Pages$Panel$ManageLines$CREATE(
												_Utils_update(
													m,
													{u: fareID})))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						case 4:
							var lineType = _v0.a.a;
							var m = _v0.b.a.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $elm$core$Maybe$Just(
											$author$project$Pages$Panel$ManageLines$CREATE(
												_Utils_update(
													m,
													{kY: lineType})))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						case 5:
							var newActive = _v0.a.a;
							var m = _v0.b.a.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $elm$core$Maybe$Just(
											$author$project$Pages$Panel$ManageLines$CREATE(
												_Utils_update(
													m,
													{
														at: A2(
															$elm$core$Maybe$withDefault,
															1,
															$author$project$Services$Line$strCodeToStatus(newActive))
													})))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						case 6:
							var newLineStr = _v0.a.a;
							var m = _v0.b.a.a;
							return $author$project$Pages$Panel$ManageLines$isValidInputEmptyValue(newLineStr) ? _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $elm$core$Maybe$Just(
											$author$project$Pages$Panel$ManageLines$CREATE(
												_Utils_update(
													m,
													{e1: newLineStr})))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp) : _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $elm$core$Maybe$Just(
											$author$project$Pages$Panel$ManageLines$CREATE(
												_Utils_update(
													m,
													{L: 1})))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						case 7:
							var newName = _v0.a.a;
							var m = _v0.b.a.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $elm$core$Maybe$Just(
											$author$project$Pages$Panel$ManageLines$CREATE(
												_Utils_update(
													m,
													{c3: newName})))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						case 8:
							var newDescription = _v0.a.a;
							var m = _v0.b.a.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $elm$core$Maybe$Just(
											$author$project$Pages$Panel$ManageLines$CREATE(
												_Utils_update(
													m,
													{z: newDescription})))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						case 9:
							var newColor = _v0.a.a;
							var m = _v0.b.a.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $elm$core$Maybe$Just(
											$author$project$Pages$Panel$ManageLines$CREATE(
												_Utils_update(
													m,
													{cK: newColor})))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						case 10:
							var newTextColor = _v0.a.a;
							var m = _v0.b.a.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $elm$core$Maybe$Just(
											$author$project$Pages$Panel$ManageLines$CREATE(
												_Utils_update(
													m,
													{as: newTextColor})))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						case 11:
							var _v1 = _v0.a;
							var m = _v0.b.a.a;
							var _v2 = $author$project$Pages$Panel$ManageLines$allValidatorsToSubmitted(m);
							if (!_v2.b) {
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $elm$core$Maybe$Just(
												$author$project$Pages$Panel$ManageLines$CREATE(
													_Utils_update(
														m,
														{L: 2})))
										}),
									$author$project$Services$Line$postLine(
										{
											at: m.at,
											cK: m.cK,
											z: m.z,
											gr: m.u,
											e1: m.e1,
											c3: m.c3,
											ow: A2($elm$core$Basics$composeL, $author$project$Pages$Panel$ManageLines$ModalMsg, $author$project$Pages$Panel$ManageLines$GotCreateLine),
											as: m.as,
											kU: user.kU,
											kY: m.kY
										}),
									$author$project$Shared$NoOp);
							} else {
								var errors = _v2;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $elm$core$Maybe$Just(
												$author$project$Pages$Panel$ManageLines$CREATE(
													_Utils_update(
														m,
														{L: 1})))
										}),
									$elm$core$Platform$Cmd$none,
									$author$project$Shared$ShowErrorDialog(
										'Existe campos incorretos no formulário: ' + A2($elm$core$String$join, ', ', errors)));
							}
						case 1:
							var rdResult = _v0.a.a;
							var m = _v0.b.a.a;
							var _v3 = $krisajenkins$remotedata$RemoteData$isSuccess(rdResult) ? _Utils_Tuple2(
								$elm$core$Maybe$Nothing,
								$author$project$Services$Line$getLines(
									{ow: $author$project$Pages$Panel$ManageLines$GotLines, kU: user.kU})) : _Utils_Tuple2(
								$elm$core$Maybe$Just(
									$author$project$Pages$Panel$ManageLines$CREATE(
										_Utils_update(
											m,
											{L: 0}))),
								$elm$core$Platform$Cmd$none);
							var newModal = _v3.a;
							var cmd = _v3.b;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{aY: newModal}),
								cmd,
								A2(
									$author$project$Shared$remoteDataSharedMsg,
									$elm$core$Maybe$Just('Linha criada com sucesso!'),
									rdResult));
						default:
							break _v0$22;
					}
				} else {
					switch (_v0.a.$) {
						case 0:
							var remoteData = _v0.a.a;
							var m = _v0.b.a.a;
							var getInactiveFareSelected = function (f) {
								return _Utils_eq(f.dM, m.u) && (f.at === 1);
							};
							var hasError = A2(
								$elm$core$List$any,
								getInactiveFareSelected,
								A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, remoteData));
							var formStatus = hasError ? 1 : m.L;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $elm$core$Maybe$Just(
											$author$project$Pages$Panel$ManageLines$EDIT(
												_Utils_update(
													m,
													{aV: remoteData, L: formStatus})))
									}),
								$elm$core$Platform$Cmd$none,
								A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, remoteData));
						case 3:
							var fareID = _v0.a.a;
							var m = _v0.b.a.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $elm$core$Maybe$Just(
											$author$project$Pages$Panel$ManageLines$EDIT(
												_Utils_update(
													m,
													{u: fareID})))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						case 4:
							var lineType = _v0.a.a;
							var m = _v0.b.a.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $elm$core$Maybe$Just(
											$author$project$Pages$Panel$ManageLines$EDIT(
												_Utils_update(
													m,
													{kY: lineType})))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						case 5:
							var newActive = _v0.a.a;
							var m = _v0.b.a.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $elm$core$Maybe$Just(
											$author$project$Pages$Panel$ManageLines$EDIT(
												_Utils_update(
													m,
													{
														at: A2(
															$elm$core$Maybe$withDefault,
															1,
															$author$project$Services$Line$strCodeToStatus(newActive))
													})))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						case 6:
							var newLineStr = _v0.a.a;
							var m = _v0.b.a.a;
							return $author$project$Pages$Panel$ManageLines$isValidInputEmptyValue(newLineStr) ? _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $elm$core$Maybe$Just(
											$author$project$Pages$Panel$ManageLines$EDIT(
												_Utils_update(
													m,
													{e1: newLineStr})))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp) : _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $elm$core$Maybe$Just(
											$author$project$Pages$Panel$ManageLines$EDIT(
												_Utils_update(
													m,
													{L: 1})))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						case 7:
							var newName = _v0.a.a;
							var m = _v0.b.a.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $elm$core$Maybe$Just(
											$author$project$Pages$Panel$ManageLines$EDIT(
												_Utils_update(
													m,
													{c3: newName})))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						case 8:
							var newDescription = _v0.a.a;
							var m = _v0.b.a.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $elm$core$Maybe$Just(
											$author$project$Pages$Panel$ManageLines$EDIT(
												_Utils_update(
													m,
													{z: newDescription})))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						case 9:
							var newColor = _v0.a.a;
							var m = _v0.b.a.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $elm$core$Maybe$Just(
											$author$project$Pages$Panel$ManageLines$EDIT(
												_Utils_update(
													m,
													{cK: newColor})))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						case 10:
							var newTextColor = _v0.a.a;
							var m = _v0.b.a.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $elm$core$Maybe$Just(
											$author$project$Pages$Panel$ManageLines$EDIT(
												_Utils_update(
													m,
													{as: newTextColor})))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						case 12:
							var _v4 = _v0.a;
							var m = _v0.b.a.a;
							var _v5 = $author$project$Pages$Panel$ManageLines$allValidatorsToSubmitted(m);
							if (!_v5.b) {
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $elm$core$Maybe$Just(
												$author$project$Pages$Panel$ManageLines$EDIT(
													_Utils_update(
														m,
														{L: 2})))
										}),
									$author$project$Services$Line$putLine(
										{
											at: m.at,
											du: m.du,
											cK: m.cK,
											z: m.z,
											gr: m.u,
											e1: m.e1,
											e2: m.e2,
											c3: m.c3,
											ow: A2($elm$core$Basics$composeL, $author$project$Pages$Panel$ManageLines$ModalMsg, $author$project$Pages$Panel$ManageLines$GotEditLine),
											as: m.as,
											kU: user.kU,
											kY: m.kY
										}),
									$author$project$Shared$NoOp);
							} else {
								var errors = _v5;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $elm$core$Maybe$Just(
												$author$project$Pages$Panel$ManageLines$EDIT(
													_Utils_update(
														m,
														{L: 1})))
										}),
									$elm$core$Platform$Cmd$none,
									$author$project$Shared$ShowErrorDialog(
										'Existe campos incorretos no formulário: ' + A2($elm$core$String$join, ', ', errors)));
							}
						case 2:
							var rdResult = _v0.a.a;
							var m = _v0.b.a.a;
							var _v6 = $krisajenkins$remotedata$RemoteData$isSuccess(rdResult) ? _Utils_Tuple2(
								$elm$core$Maybe$Nothing,
								$author$project$Services$Line$getLines(
									{ow: $author$project$Pages$Panel$ManageLines$GotLines, kU: user.kU})) : _Utils_Tuple2(
								$elm$core$Maybe$Just(
									$author$project$Pages$Panel$ManageLines$EDIT(
										_Utils_update(
											m,
											{L: 0}))),
								$elm$core$Platform$Cmd$none);
							var newModal = _v6.a;
							var cmd = _v6.b;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{aY: newModal}),
								cmd,
								A2(
									$author$project$Shared$remoteDataSharedMsg,
									$elm$core$Maybe$Just('Linha editada com sucesso!'),
									rdResult));
						default:
							break _v0$22;
					}
				}
			} else {
				break _v0$22;
			}
		}
		return _Utils_Tuple3(
			model,
			$elm$core$Platform$Cmd$none,
			$author$project$Shared$ShowErrorDialog('Algo que não foi mapeado, foi executado!'));
	});
var $author$project$Pages$Panel$ManageLines$update = F4(
	function (msg, shared, user, model) {
		var queries = model.T;
		switch (msg.$) {
			case 0:
				var result = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{n2: result}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, result));
			case 1:
				var _v1 = $author$project$Pages$Panel$ManageLines$initModalCREATE(user);
				var newModal = _v1.a;
				var cmd = _v1.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aY: $elm$core$Maybe$Just(
								$author$project$Pages$Panel$ManageLines$CREATE(newModal))
						}),
					cmd,
					$author$project$Shared$NoOp);
			case 2:
				var line = msg.a;
				var _v2 = A2($author$project$Pages$Panel$ManageLines$initModalEDIT, line, user);
				var newModal = _v2.a;
				var cmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aY: $elm$core$Maybe$Just(
								$author$project$Pages$Panel$ManageLines$EDIT(newModal))
						}),
					cmd,
					$author$project$Shared$NoOp);
			case 3:
				var newOrderCode = msg.a;
				var nexOrderType = function () {
					var _v3 = _Utils_Tuple2(
						_Utils_eq(
							model.T.mn,
							$elm$core$Maybe$Just(newOrderCode)),
						model.T.mo);
					if (_v3.a) {
						if (_v3.b.$ === 1) {
							var _v4 = _v3.b;
							return $elm$core$Maybe$Just(1);
						} else {
							if (_v3.b.a === 1) {
								var _v5 = _v3.b.a;
								return $elm$core$Maybe$Just(0);
							} else {
								var _v6 = _v3.b.a;
								return $elm$core$Maybe$Nothing;
							}
						}
					} else {
						return $elm$core$Maybe$Just(1);
					}
				}();
				var nextOrderCode = _Utils_eq(nexOrderType, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(newOrderCode);
				var updateQueries = _Utils_update(
					queries,
					{mn: nextOrderCode, mo: nexOrderType});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{T: updateQueries}),
					A2(
						$author$project$Route$pushUrl,
						shared.nZ,
						$author$project$Route$Panel(
							$author$project$Route$ManageLines(updateQueries))),
					$author$project$Shared$NoOp);
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aY: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			default:
				var msg_ = msg.a;
				return A3($author$project$Pages$Panel$ManageLines$updateModal, msg_, user, model);
		}
	});
var $author$project$Pages$Panel$ManageOperators$DELETE = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Panel$ManageOperators$EDIT = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Panel$ManageOperators$INSERT_DOCUMENT = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Panel$ManageOperators$QRCODE = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Panel$ManageOperators$initDELETE = function (user) {
	return {dP: false, kZ: user};
};
var $author$project$Pages$Panel$ManageOperators$GotPermissions = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Panel$ManageOperators$ModalMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Panel$ManageOperators$initEDIT = F6(
	function (userID, document, email, name, selectedPermissions, user) {
		return _Utils_Tuple2(
			{iI: document, mX: email, L: 0, c3: name, oU: $krisajenkins$remotedata$RemoteData$Loading, J: selectedPermissions, fL: userID},
			$author$project$Services$Concessionaire$getAllPermissions(
				{
					ow: A2($elm$core$Basics$composeL, $author$project$Pages$Panel$ManageOperators$ModalMsg, $author$project$Pages$Panel$ManageOperators$GotPermissions),
					kU: user.kU
				}));
	});
var $author$project$Pages$Panel$ManageOperators$initINSERT_DOCUMENT = {iI: '', L: 0};
var $author$project$Pages$Panel$ManageOperators$initQRCODE = function (user) {
	return {g5: user.aS, g6: user.dM, fa: user.c3};
};
var $author$project$Pages$Panel$ManageOperators$CREATE = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Panel$ManageOperators$GotCreateOperator = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Panel$ManageOperators$GotDeleteOperator = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Panel$ManageOperators$GotEditOperator = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Panel$ManageOperators$filterPermission = function (permission) {
	var _v0 = permission.di;
	_v0$2:
	while (true) {
		if (_v0.$ === 8) {
			switch (_v0.a) {
				case 'maintenance':
					return true;
				case 'operator':
					return true;
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return false;
};
var $author$project$Pages$Panel$ManageOperators$initCREATE = F2(
	function (document, user) {
		return _Utils_Tuple2(
			{iI: document, mX: '', L: 0, c3: '', oU: $krisajenkins$remotedata$RemoteData$Loading, J: _List_Nil},
			$author$project$Services$Concessionaire$getAllPermissions(
				{
					ow: A2($elm$core$Basics$composeL, $author$project$Pages$Panel$ManageOperators$ModalMsg, $author$project$Pages$Panel$ManageOperators$GotPermissions),
					kU: user.kU
				}));
	});
var $author$project$Pages$Panel$ManageOperators$isInvalidContentCREATE = function (modal) {
	return $elm$core$String$isEmpty(modal.c3) || ((!$author$project$Utils$isValidEmail(modal.mX)) || $elm$core$List$isEmpty(modal.J));
};
var $author$project$Pages$Panel$ManageOperators$isInvalidContentEDIT = function (modal) {
	return $elm$core$String$isEmpty(modal.c3) || (!$author$project$Utils$isValidEmail(modal.mX));
};
var $author$project$Pages$Panel$ManageOperators$updateModal = F4(
	function (msg, model, shared, user) {
		var _v0 = _Utils_Tuple2(msg, model.aY);
		_v0$22:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					var _v1 = _v0.a;
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
				case 1:
					if (!_v0.a.a.$) {
						if (!_v0.b.$) {
							switch (_v0.b.a.$) {
								case 1:
									var permissions = _v0.a.a.a;
									var modal = _v0.b.a.a;
									var filteredPermission_ = A2($elm$core$List$filter, $author$project$Pages$Panel$ManageOperators$filterPermission, permissions);
									var updateModal_ = _Utils_update(
										modal,
										{
											oU: $krisajenkins$remotedata$RemoteData$Success(filteredPermission_)
										});
									return _Utils_Tuple3(
										_Utils_update(
											model,
											{
												aY: $elm$core$Maybe$Just(
													$author$project$Pages$Panel$ManageOperators$CREATE(updateModal_))
											}),
										$elm$core$Platform$Cmd$none,
										$author$project$Shared$NoOp);
								case 2:
									var permissions = _v0.a.a.a;
									var modal = _v0.b.a.a;
									var filteredPermission_ = A2($elm$core$List$filter, $author$project$Pages$Panel$ManageOperators$filterPermission, permissions);
									var updateModal_ = _Utils_update(
										modal,
										{
											oU: $krisajenkins$remotedata$RemoteData$Success(filteredPermission_)
										});
									return _Utils_Tuple3(
										_Utils_update(
											model,
											{
												aY: $elm$core$Maybe$Just(
													$author$project$Pages$Panel$ManageOperators$EDIT(updateModal_))
											}),
										$elm$core$Platform$Cmd$none,
										$author$project$Shared$NoOp);
								default:
									break _v0$22;
							}
						} else {
							break _v0$22;
						}
					} else {
						if (!_v0.b.$) {
							switch (_v0.b.a.$) {
								case 1:
									var error = _v0.a.a.a;
									var m = _v0.b.a.a;
									return _Utils_Tuple3(
										_Utils_update(
											model,
											{
												aY: $elm$core$Maybe$Just(
													$author$project$Pages$Panel$ManageOperators$CREATE(
														_Utils_update(
															m,
															{L: 0})))
											}),
										$elm$core$Platform$Cmd$none,
										A2($author$project$Shared$updateApiError, shared, error));
								case 2:
									var error = _v0.a.a.a;
									var m = _v0.b.a.a;
									return _Utils_Tuple3(
										_Utils_update(
											model,
											{
												aY: $elm$core$Maybe$Just(
													$author$project$Pages$Panel$ManageOperators$EDIT(
														_Utils_update(
															m,
															{L: 0})))
											}),
										$elm$core$Platform$Cmd$none,
										A2($author$project$Shared$updateApiError, shared, error));
								default:
									break _v0$22;
							}
						} else {
							break _v0$22;
						}
					}
				case 2:
					if (!_v0.a.a.$) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{aY: $elm$core$Maybe$Nothing}),
							$author$project$Services$Concessionaire$getAdminUsers(
								{
									mc: A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.bR;
										},
										A2(
											$elm$core$Basics$composeR,
											$elm$core$List$map(
												function ($) {
													return $.dM;
												}),
											$elm$core$List$head))(user),
									ow: $author$project$Pages$Panel$ManageOperators$GotUsers,
									kU: user.kU
								}),
							$author$project$Shared$ShowSuccessDialog('Operador criado com sucesso! '));
					} else {
						if ((!_v0.b.$) && (_v0.b.a.$ === 1)) {
							var error = _v0.a.a.a;
							var m = _v0.b.a.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $elm$core$Maybe$Just(
											$author$project$Pages$Panel$ManageOperators$CREATE(
												_Utils_update(
													m,
													{L: 0})))
									}),
								$elm$core$Platform$Cmd$none,
								A2($author$project$Shared$updateApiError, shared, error));
						} else {
							break _v0$22;
						}
					}
				case 4:
					if (!_v0.a.a.$) {
						if ((!_v0.b.$) && (_v0.b.a.$ === 3)) {
							var m = _v0.b.a.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{aY: $elm$core$Maybe$Nothing}),
								$author$project$Services$Concessionaire$getAdminUsers(
									{
										mc: A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.bR;
											},
											A2(
												$elm$core$Basics$composeR,
												$elm$core$List$map(
													function ($) {
														return $.dM;
													}),
												$elm$core$List$head))(user),
										ow: $author$project$Pages$Panel$ManageOperators$GotUsers,
										kU: user.kU
									}),
								$author$project$Shared$ShowSuccessDialog('Operador inativado com sucesso!'));
						} else {
							break _v0$22;
						}
					} else {
						if ((!_v0.b.$) && (_v0.b.a.$ === 3)) {
							var error = _v0.a.a.a;
							var m = _v0.b.a.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $elm$core$Maybe$Just(
											$author$project$Pages$Panel$ManageOperators$DELETE(
												_Utils_update(
													m,
													{dP: false})))
									}),
								$elm$core$Platform$Cmd$none,
								A2($author$project$Shared$updateApiError, shared, error));
						} else {
							break _v0$22;
						}
					}
				case 5:
					if ((!_v0.b.$) && (!_v0.b.a.$)) {
						var newDocument = _v0.a.a;
						var modal = _v0.b.a.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $elm$core$Maybe$Just(
										$author$project$Pages$Panel$ManageOperators$INSERT_DOCUMENT(
											_Utils_update(
												modal,
												{iI: newDocument})))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					} else {
						break _v0$22;
					}
				case 6:
					if (!_v0.b.$) {
						switch (_v0.b.a.$) {
							case 1:
								var newEmail = _v0.a.a;
								var m = _v0.b.a.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $elm$core$Maybe$Just(
												$author$project$Pages$Panel$ManageOperators$CREATE(
													_Utils_update(
														m,
														{mX: newEmail})))
										}),
									$elm$core$Platform$Cmd$none,
									$author$project$Shared$NoOp);
							case 2:
								var newEmail = _v0.a.a;
								var m = _v0.b.a.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $elm$core$Maybe$Just(
												$author$project$Pages$Panel$ManageOperators$EDIT(
													_Utils_update(
														m,
														{mX: newEmail})))
										}),
									$elm$core$Platform$Cmd$none,
									$author$project$Shared$NoOp);
							default:
								break _v0$22;
						}
					} else {
						break _v0$22;
					}
				case 7:
					if (!_v0.b.$) {
						switch (_v0.b.a.$) {
							case 1:
								var newName = _v0.a.a;
								var m = _v0.b.a.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $elm$core$Maybe$Just(
												$author$project$Pages$Panel$ManageOperators$CREATE(
													_Utils_update(
														m,
														{c3: newName})))
										}),
									$elm$core$Platform$Cmd$none,
									$author$project$Shared$NoOp);
							case 2:
								var newName = _v0.a.a;
								var m = _v0.b.a.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $elm$core$Maybe$Just(
												$author$project$Pages$Panel$ManageOperators$EDIT(
													_Utils_update(
														m,
														{c3: newName})))
										}),
									$elm$core$Platform$Cmd$none,
									$author$project$Shared$NoOp);
							default:
								break _v0$22;
						}
					} else {
						break _v0$22;
					}
				case 9:
					if ((!_v0.b.$) && (!_v0.b.a.$)) {
						var _v2 = _v0.a;
						var m = _v0.b.a.a;
						if ($elm$core$String$isEmpty(m.iI) || ($elm$core$String$length(
							A2($elm$core$String$filter, $elm$core$Char$isDigit, m.iI)) < 11)) {
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $elm$core$Maybe$Just(
											$author$project$Pages$Panel$ManageOperators$INSERT_DOCUMENT(
												_Utils_update(
													m,
													{L: 1})))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$ShowErrorDialog('Formulário está incorreto!'));
						} else {
							var filter = function (user_) {
								return _Utils_eq(user_.aS, m.iI);
							};
							var maybeGetUser = $elm$core$List$head(
								A2(
									$krisajenkins$remotedata$RemoteData$withDefault,
									_List_Nil,
									A2(
										$krisajenkins$remotedata$RemoteData$map,
										$elm$core$List$filter(filter),
										model.c5)));
							var _v3 = A2(
								$elm$core$Maybe$withDefault,
								A2(
									$elm$core$Tuple$mapFirst,
									$author$project$Pages$Panel$ManageOperators$CREATE,
									A2($author$project$Pages$Panel$ManageOperators$initCREATE, m.iI, user)),
								A2(
									$elm$core$Maybe$map,
									function (user_) {
										return A2(
											$elm$core$Tuple$mapFirst,
											$author$project$Pages$Panel$ManageOperators$EDIT,
											A6(
												$author$project$Pages$Panel$ManageOperators$initEDIT,
												user_.dM,
												user_.aS,
												user_.mX,
												user_.c3,
												A2(
													$elm$core$List$map,
													function ($) {
														return $.di;
													},
													user_.oU),
												user));
									},
									maybeGetUser));
							var newModal = _v3.a;
							var cmd = _v3.b;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $elm$core$Maybe$Just(newModal)
									}),
								cmd,
								$author$project$Shared$NoOp);
						}
					} else {
						break _v0$22;
					}
				case 10:
					if ((!_v0.b.$) && (_v0.b.a.$ === 1)) {
						var _v4 = _v0.a;
						var m = _v0.b.a.a;
						return $author$project$Pages$Panel$ManageOperators$isInvalidContentCREATE(m) ? _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $elm$core$Maybe$Just(
										$author$project$Pages$Panel$ManageOperators$CREATE(
											_Utils_update(
												m,
												{L: 1})))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$ShowErrorDialog('Formulário está incorreto!')) : _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $elm$core$Maybe$Just(
										$author$project$Pages$Panel$ManageOperators$CREATE(
											_Utils_update(
												m,
												{L: 2})))
								}),
							$author$project$Services$Concessionaire$createUser(
								{
									mb: model.f6,
									iI: m.iI,
									mX: m.mX,
									c3: m.c3,
									ow: A2($elm$core$Basics$composeL, $author$project$Pages$Panel$ManageOperators$ModalMsg, $author$project$Pages$Panel$ManageOperators$GotCreateOperator),
									oU: m.J,
									kU: user.kU
								}),
							$author$project$Shared$NoOp);
					} else {
						break _v0$22;
					}
				case 11:
					if ((!_v0.b.$) && (_v0.b.a.$ === 2)) {
						var _v5 = _v0.a;
						var m = _v0.b.a.a;
						return $author$project$Pages$Panel$ManageOperators$isInvalidContentEDIT(m) ? _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $elm$core$Maybe$Just(
										$author$project$Pages$Panel$ManageOperators$EDIT(
											_Utils_update(
												m,
												{L: 1})))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$ShowErrorDialog('Formulário está incorreto!')) : _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $elm$core$Maybe$Just(
										$author$project$Pages$Panel$ManageOperators$EDIT(
											_Utils_update(
												m,
												{L: 2})))
								}),
							$author$project$Services$Concessionaire$editUser(
								{
									mc: A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.bR;
										},
										A2(
											$elm$core$Basics$composeR,
											$elm$core$List$map(
												function ($) {
													return $.dM;
												}),
											$elm$core$List$head))(user),
									iI: m.iI,
									mX: m.mX,
									c3: m.c3,
									ow: A2($elm$core$Basics$composeL, $author$project$Pages$Panel$ManageOperators$ModalMsg, $author$project$Pages$Panel$ManageOperators$GotEditOperator),
									pt: m.J,
									kU: user.kU,
									qw: m.fL
								}),
							$author$project$Shared$NoOp);
					} else {
						break _v0$22;
					}
				case 12:
					if ((!_v0.b.$) && (_v0.b.a.$ === 3)) {
						var _v6 = _v0.a;
						var m = _v0.b.a.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $elm$core$Maybe$Just(
										$author$project$Pages$Panel$ManageOperators$DELETE(
											_Utils_update(
												m,
												{dP: true})))
								}),
							$author$project$Services$Concessionaire$deleteUser(
								{
									mc: A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.bR;
										},
										A2(
											$elm$core$Basics$composeR,
											$elm$core$List$map(
												function ($) {
													return $.dM;
												}),
											$elm$core$List$head))(user),
									ow: A2($elm$core$Basics$composeL, $author$project$Pages$Panel$ManageOperators$ModalMsg, $author$project$Pages$Panel$ManageOperators$GotDeleteOperator),
									kU: user.kU,
									qw: m.kZ.dM
								}),
							$author$project$Shared$NoOp);
					} else {
						break _v0$22;
					}
				case 3:
					if (_v0.a.a.$ === 1) {
						if ((!_v0.b.$) && (_v0.b.a.$ === 2)) {
							var error = _v0.a.a.a;
							var m = _v0.b.a.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $elm$core$Maybe$Just(
											$author$project$Pages$Panel$ManageOperators$EDIT(
												_Utils_update(
													m,
													{L: 0})))
									}),
								$elm$core$Platform$Cmd$none,
								A2($author$project$Shared$updateApiError, shared, error));
						} else {
							break _v0$22;
						}
					} else {
						if ((!_v0.b.$) && (_v0.b.a.$ === 2)) {
							var m = _v0.b.a.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{aY: $elm$core$Maybe$Nothing}),
								$author$project$Services$Concessionaire$getAdminUsers(
									{
										mc: A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.bR;
											},
											A2(
												$elm$core$Basics$composeR,
												$elm$core$List$map(
													function ($) {
														return $.dM;
													}),
												$elm$core$List$head))(user),
										ow: $author$project$Pages$Panel$ManageOperators$GotUsers,
										kU: user.kU
									}),
								$author$project$Shared$ShowSuccessDialog('Operador foi editado com sucesso!'));
						} else {
							break _v0$22;
						}
					}
				default:
					if (!_v0.b.$) {
						switch (_v0.b.a.$) {
							case 1:
								var permission = _v0.a.a;
								var m = _v0.b.a.a;
								var filteredPermissions = A2(
									$elm$core$List$filter,
									$elm$core$Basics$neq(permission),
									m.J);
								var selectedPermissions = A2(
									$elm$core$Maybe$withDefault,
									A2($elm$core$List$cons, permission, filteredPermissions),
									A2(
										$elm$core$Maybe$map,
										$elm$core$Basics$always(filteredPermissions),
										$elm$core$List$head(
											A2(
												$elm$core$List$filter,
												$elm$core$Basics$eq(permission),
												m.J))));
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $elm$core$Maybe$Just(
												$author$project$Pages$Panel$ManageOperators$CREATE(
													_Utils_update(
														m,
														{J: selectedPermissions})))
										}),
									$elm$core$Platform$Cmd$none,
									$author$project$Shared$NoOp);
							case 2:
								var permission = _v0.a.a;
								var m = _v0.b.a.a;
								var filteredPermissions = A2(
									$elm$core$List$filter,
									$elm$core$Basics$neq(permission),
									m.J);
								var selectedPermissions = A2(
									$elm$core$Maybe$withDefault,
									A2($elm$core$List$cons, permission, filteredPermissions),
									A2(
										$elm$core$Maybe$map,
										$elm$core$Basics$always(filteredPermissions),
										$elm$core$List$head(
											A2(
												$elm$core$List$filter,
												$elm$core$Basics$eq(permission),
												m.J))));
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $elm$core$Maybe$Just(
												$author$project$Pages$Panel$ManageOperators$EDIT(
													_Utils_update(
														m,
														{J: selectedPermissions})))
										}),
									$elm$core$Platform$Cmd$none,
									$author$project$Shared$NoOp);
							default:
								break _v0$22;
						}
					} else {
						break _v0$22;
					}
			}
		}
		return _Utils_Tuple3(
			model,
			$elm$core$Platform$Cmd$none,
			$author$project$Shared$ShowErrorDialog('MSG não mapeada!'));
	});
var $author$project$Pages$Panel$ManageOperators$update = F4(
	function (msg, shared, user, model) {
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					var users = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								c5: $krisajenkins$remotedata$RemoteData$Success(users)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								c5: $krisajenkins$remotedata$RemoteData$Failure(error)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$ShowErrorDialog('Algo deu errado!'));
				}
			case 1:
				var newModal = $author$project$Pages$Panel$ManageOperators$initINSERT_DOCUMENT;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aY: $elm$core$Maybe$Just(
								$author$project$Pages$Panel$ManageOperators$INSERT_DOCUMENT(newModal))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 2:
				var user_ = msg.a;
				var _v1 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Pages$Panel$ManageOperators$EDIT,
					A6(
						$author$project$Pages$Panel$ManageOperators$initEDIT,
						user_.dM,
						user_.aS,
						user_.mX,
						user_.c3,
						A2(
							$elm$core$List$map,
							function ($) {
								return $.di;
							},
							user_.oU),
						user));
				var newModal = _v1.a;
				var cmd = _v1.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aY: $elm$core$Maybe$Just(newModal)
						}),
					cmd,
					$author$project$Shared$NoOp);
			case 3:
				var user_ = msg.a;
				var newModal = $author$project$Pages$Panel$ManageOperators$DELETE(
					$author$project$Pages$Panel$ManageOperators$initDELETE(user_));
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aY: $elm$core$Maybe$Just(newModal)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 4:
				var user_ = msg.a;
				var newModal = $author$project$Pages$Panel$ManageOperators$QRCODE(
					$author$project$Pages$Panel$ManageOperators$initQRCODE(user_));
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aY: $elm$core$Maybe$Just(newModal)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 5:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aY: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			default:
				var msg_ = msg.a;
				var _v2 = A4($author$project$Pages$Panel$ManageOperators$updateModal, msg_, model, shared, user);
				var newModel = _v2.a;
				var cmd = _v2.b;
				var sharedMsg = _v2.c;
				return _Utils_Tuple3(newModel, cmd, sharedMsg);
		}
	});
var $author$project$Pages$Panel$ManagePouches$CREATE = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Panel$ManagePouches$EDIT = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Panel$ManagePouches$QRCODE = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Panel$ManagePouches$initModalEDIT = function (pouch) {
	return {L: 0, cf: pouch, M: pouch.kK};
};
var $author$project$Pages$Panel$ManagePouches$initModalVIEW = {L: 0, fi: '', M: 0};
var $author$project$Pages$Panel$ManagePouches$GotPouchCreated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Panel$ManagePouches$ModalMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Services$Pouches$statusToStrCODE = function (status) {
	if (!status) {
		return 'ativo';
	} else {
		return 'inativo';
	}
};
var $author$project$Services$Pouches$postPouchCreate = function (options) {
	return $author$project$Services$Api$postHttp(
		{
			lG: $elm$http$Http$jsonBody(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'pouchCode',
							$elm$json$Json$Encode$string(options.jZ)),
							_Utils_Tuple2(
							'status',
							$elm$json$Json$Encode$string(
								$author$project$Services$Pouches$statusToStrCODE(options.M)))
						]))),
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$author$project$Services$Pouches$decodePouch),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'pouch', 'create']),
				_List_Nil)
		});
};
var $author$project$Services$Pouches$putPouchEdit = function (options) {
	return $author$project$Services$Api$putHttp(
		{
			lG: $elm$http$Http$jsonBody(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'pouchCode',
							$elm$json$Json$Encode$string(options.jZ)),
							_Utils_Tuple2(
							'status',
							$elm$json$Json$Encode$string(
								$author$project$Services$Pouches$statusToStrCODE(options.M)))
						]))),
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$author$project$Services$Pouches$decodePouch),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'pouch', options.o2]),
				_List_Nil)
		});
};
var $author$project$Pages$Panel$ManagePouches$updateModal = F3(
	function (user, msg, model) {
		var _v0 = _Utils_Tuple2(msg, model.aY);
		_v0$7:
		while (true) {
			if (!_v0.b.$) {
				switch (_v0.b.a.$) {
					case 1:
						switch (_v0.a.$) {
							case 0:
								var pouchCode = _v0.a.a;
								var modal = _v0.b.a.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $elm$core$Maybe$Just(
												$author$project$Pages$Panel$ManagePouches$CREATE(
													_Utils_update(
														modal,
														{fi: pouchCode})))
										}),
									$elm$core$Platform$Cmd$none,
									$author$project$Shared$NoOp);
							case 1:
								var statusStrCODE = _v0.a.a;
								var modal = _v0.b.a.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $elm$core$Maybe$Just(
												$author$project$Pages$Panel$ManagePouches$CREATE(
													_Utils_update(
														modal,
														{
															M: A2(
																$elm$core$Maybe$withDefault,
																modal.M,
																$author$project$Services$Pouches$strCodeToStatus(statusStrCODE))
														})))
										}),
									$elm$core$Platform$Cmd$none,
									$author$project$Shared$NoOp);
							case 2:
								var _v1 = _v0.a;
								var modal = _v0.b.a.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $elm$core$Maybe$Just(
												$author$project$Pages$Panel$ManagePouches$CREATE(
													_Utils_update(
														modal,
														{L: 2})))
										}),
									$author$project$Services$Pouches$postPouchCreate(
										{
											ow: A2($elm$core$Basics$composeR, $author$project$Pages$Panel$ManagePouches$GotPouchCreated, $author$project$Pages$Panel$ManagePouches$ModalMsg),
											jZ: modal.fi,
											M: modal.M,
											kU: user.kU
										}),
									$author$project$Shared$NoOp);
							default:
								var result = _v0.a.a;
								var modal = _v0.b.a.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: A2(
												$krisajenkins$remotedata$RemoteData$withDefault,
												$elm$core$Maybe$Just(
													$author$project$Pages$Panel$ManagePouches$CREATE(
														_Utils_update(
															modal,
															{L: 0}))),
												A2(
													$krisajenkins$remotedata$RemoteData$map,
													function (_v2) {
														return $elm$core$Maybe$Nothing;
													},
													result))
										}),
									$author$project$Services$Pouches$getPouches(
										{ow: $author$project$Pages$Panel$ManagePouches$GotPouches, kU: user.kU}),
									A2(
										$author$project$Shared$remoteDataSharedMsg,
										$elm$core$Maybe$Just('Malote ' + (modal.fi + ' criado com sucesso!')),
										result));
						}
					case 2:
						switch (_v0.a.$) {
							case 1:
								var statusStrCODE = _v0.a.a;
								var modal = _v0.b.a.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $elm$core$Maybe$Just(
												$author$project$Pages$Panel$ManagePouches$EDIT(
													_Utils_update(
														modal,
														{
															M: A2(
																$elm$core$Maybe$withDefault,
																modal.M,
																$author$project$Services$Pouches$strCodeToStatus(statusStrCODE))
														})))
										}),
									$elm$core$Platform$Cmd$none,
									$author$project$Shared$NoOp);
							case 2:
								var _v3 = _v0.a;
								var modal = _v0.b.a.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $elm$core$Maybe$Just(
												$author$project$Pages$Panel$ManagePouches$EDIT(
													_Utils_update(
														modal,
														{L: 2})))
										}),
									$author$project$Services$Pouches$putPouchEdit(
										{
											ow: A2($elm$core$Basics$composeR, $author$project$Pages$Panel$ManagePouches$GotPouchCreated, $author$project$Pages$Panel$ManagePouches$ModalMsg),
											jZ: modal.cf.fi,
											o2: modal.cf.dM,
											M: modal.M,
											kU: user.kU
										}),
									$author$project$Shared$NoOp);
							case 3:
								var result = _v0.a.a;
								var modal = _v0.b.a.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: A2(
												$krisajenkins$remotedata$RemoteData$withDefault,
												$elm$core$Maybe$Just(
													$author$project$Pages$Panel$ManagePouches$EDIT(
														_Utils_update(
															modal,
															{L: 0}))),
												A2(
													$krisajenkins$remotedata$RemoteData$map,
													function (_v4) {
														return $elm$core$Maybe$Nothing;
													},
													result))
										}),
									$author$project$Services$Pouches$getPouches(
										{ow: $author$project$Pages$Panel$ManagePouches$GotPouches, kU: user.kU}),
									A2(
										$author$project$Shared$remoteDataSharedMsg,
										$elm$core$Maybe$Just('Malote ' + (modal.cf.fi + ' atualizado com sucesso!')),
										result));
							default:
								break _v0$7;
						}
					default:
						break _v0$7;
				}
			} else {
				break _v0$7;
			}
		}
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
	});
var $author$project$Pages$Panel$ManagePouches$update = F3(
	function (user, msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aY: $elm$core$Maybe$Just(
								$author$project$Pages$Panel$ManagePouches$CREATE($author$project$Pages$Panel$ManagePouches$initModalVIEW))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 2:
				var pouch = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aY: $elm$core$Maybe$Just(
								$author$project$Pages$Panel$ManagePouches$EDIT(
									$author$project$Pages$Panel$ManagePouches$initModalEDIT(pouch)))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 3:
				var pouch = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aY: $elm$core$Maybe$Just(
								$author$project$Pages$Panel$ManagePouches$QRCODE(pouch))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aY: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 5:
				var result = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{fj: result}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, result));
			default:
				var msg_ = msg.a;
				return A3($author$project$Pages$Panel$ManagePouches$updateModal, user, msg_, model);
		}
	});
var $author$project$Pages$Panel$MyAccount$SubPage$AccountMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Panel$MyAccount$SubPage$GotChangeEmail = function (a) {
	return {$: 3, a: a};
};
var $author$project$Services$Auth$changeEmail = function (options) {
	return $author$project$Services$Api$putHttp(
		{
			lG: $elm$http$Http$jsonBody(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'email',
							$elm$json$Json$Encode$string(options.on))
						]))),
			m9: $author$project$Services$Api$expectWhateverErrorString(
				A2($elm$core$Basics$composeL, options.ow, $krisajenkins$remotedata$RemoteData$fromResult)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'user', 'current', 'updateEmail']),
				_List_Nil)
		});
};
var $author$project$Pages$Panel$MyAccount$SubPage$isInvalidPasswordConfirmation = F2(
	function (password, passwordConfirmation) {
		return !_Utils_eq(passwordConfirmation, password);
	});
var $author$project$Pages$Panel$MyAccount$SubPage$isInvalidForm = F2(
	function (password, passwordConfirmation) {
		return A2($author$project$Pages$Panel$MyAccount$SubPage$isInvalidPasswordConfirmation, password, passwordConfirmation) || ($elm$core$String$isEmpty(password) || $elm$core$String$isEmpty(passwordConfirmation));
	});
var $author$project$Pages$Panel$MyAccount$SubPage$accountUpdate = F3(
	function (msg, model, user) {
		var setModel = function (_v1) {
			var a = _v1.a;
			var b = _v1.b;
			var c = _v1.c;
			return _Utils_Tuple3(
				$author$project$Pages$Panel$MyAccount$SubPage$Account(a),
				b,
				c);
		};
		return setModel(
			function () {
				switch (msg.$) {
					case 0:
						var newEmail = msg.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									mX: $elm$core$String$toLower(newEmail)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					case 1:
						var newEmailConfirmation = msg.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bW: $elm$core$String$toLower(newEmailConfirmation)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					case 2:
						return A2($author$project$Pages$Panel$MyAccount$SubPage$isInvalidForm, model.mX, model.bW) ? _Utils_Tuple3(
							_Utils_update(
								model,
								{L: 1}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp) : _Utils_Tuple3(
							_Utils_update(
								model,
								{L: 2}),
							$author$project$Services$Auth$changeEmail(
								{
									on: model.mX,
									ow: A2($elm$core$Basics$composeL, $author$project$Pages$Panel$MyAccount$SubPage$AccountMsg, $author$project$Pages$Panel$MyAccount$SubPage$GotChangeEmail),
									kU: user.kU
								}),
							$author$project$Shared$NoOp);
					default:
						if (msg.a.$ === 3) {
							return _Utils_Tuple3(
								{mX: '', bW: '', L: 0},
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$ShowSuccessDialog('E-mail alterado com sucesso!'));
						} else {
							var rd = msg.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{L: 0}),
								$elm$core$Platform$Cmd$none,
								A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rd));
						}
				}
			}());
	});
var $author$project$Pages$Panel$MyAccount$SubPage$GotChangePassword = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Panel$MyAccount$SubPage$PasswordMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Services$Auth$changePassword = function (options) {
	return $author$project$Services$Api$putHttp(
		{
			lG: $elm$http$Http$jsonBody(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'password',
							$elm$json$Json$Encode$string(options.bu))
						]))),
			m9: $author$project$Services$Api$expectWhateverErrorString(
				A2($elm$core$Basics$composeL, options.ow, $krisajenkins$remotedata$RemoteData$fromResult)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'auth', 'changePassword']),
				_List_Nil)
		});
};
var $author$project$Pages$Panel$MyAccount$SubPage$passwordUpdate = F3(
	function (msg, model, user) {
		var password = model.oN;
		var passwordConfirmation = model.c6;
		var setModel = function (_v1) {
			var a = _v1.a;
			var b = _v1.b;
			var c = _v1.c;
			return _Utils_Tuple3(
				$author$project$Pages$Panel$MyAccount$SubPage$Password(a),
				b,
				c);
		};
		return setModel(
			function () {
				switch (msg.$) {
					case 0:
						var newPassword = msg.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									oN: _Utils_update(
										password,
										{di: newPassword})
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					case 1:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									oN: _Utils_update(
										password,
										{dY: !password.dY})
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					case 2:
						var newPasswordConfirmation = msg.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									c6: _Utils_update(
										passwordConfirmation,
										{di: newPasswordConfirmation})
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									c6: _Utils_update(
										passwordConfirmation,
										{dY: !passwordConfirmation.dY})
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					case 4:
						return A2($author$project$Pages$Panel$MyAccount$SubPage$isInvalidForm, password.di, passwordConfirmation.di) ? _Utils_Tuple3(
							_Utils_update(
								model,
								{L: 1}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp) : _Utils_Tuple3(
							_Utils_update(
								model,
								{L: 2}),
							$author$project$Services$Auth$changePassword(
								{
									bu: password.di,
									ow: A2($elm$core$Basics$composeL, $author$project$Pages$Panel$MyAccount$SubPage$PasswordMsg, $author$project$Pages$Panel$MyAccount$SubPage$GotChangePassword),
									kU: user.kU
								}),
							$author$project$Shared$NoOp);
					default:
						if (msg.a.$ === 3) {
							return _Utils_Tuple3(
								{
									L: 0,
									oN: {dY: false, di: ''},
									c6: {dY: false, di: ''}
								},
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$ShowSuccessDialog('Senha alterada com sucesso!'));
						} else {
							var rd = msg.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{L: 0}),
								$elm$core$Platform$Cmd$none,
								A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rd));
						}
				}
			}());
	});
var $author$project$Pages$Panel$MyAccount$SubPage$update = F3(
	function (msg, model, user) {
		if (!msg.$) {
			var msg_ = msg.a;
			if (!model.$) {
				var m = model.a;
				return A3($author$project$Pages$Panel$MyAccount$SubPage$passwordUpdate, msg_, m, user);
			} else {
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
			}
		} else {
			var msg_ = msg.a;
			if (model.$ === 1) {
				var m = model.a;
				return A3($author$project$Pages$Panel$MyAccount$SubPage$accountUpdate, msg_, m, user);
			} else {
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
			}
		}
	});
var $author$project$Pages$Panel$Reason$CreateReason = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Panel$Reason$EditReason = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Panel$Reason$initCreateReasonModel = {lo: 0, z: '', L: 0, N: $elm$core$Maybe$Nothing};
var $author$project$Pages$Panel$Reason$initEditReasonModel = function (reason) {
	return {
		lo: reason.fB,
		z: reason.pf,
		L: 0,
		dM: reason.dM,
		N: $elm$core$Maybe$Just(reason.hV)
	};
};
var $author$project$Pages$Panel$Reason$GotCreateReason = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Panel$Reason$ModalMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Services$Reason$allActions = _List_fromArray(
	[1, 0, 2]);
var $author$project$Pages$Panel$Reason$isInvalid = function (validators) {
	return A2(
		$elm$core$List$filterMap,
		function (_v0) {
			var isInvalid_ = _v0.a;
			var error = _v0.b;
			return isInvalid_ ? $elm$core$Maybe$Just(error) : $elm$core$Maybe$Nothing;
		},
		validators);
};
var $author$project$Pages$Panel$Reason$isInvalidInput = F2(
	function (input, validators) {
		return A2(
			$elm$core$List$filterMap,
			function (_v0) {
				var isInvalid_ = _v0.a;
				var error = _v0.b;
				return isInvalid_ ? $elm$core$Maybe$Just(error) : $elm$core$Maybe$Nothing;
			},
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$mapFirst(
					function (isInvalid_) {
						return isInvalid_(input);
					}),
				validators));
	});
var $author$project$Pages$Panel$Reason$validatorsActions = F2(
	function (maybeValueSelected, options) {
		var getSelected = A2(
			$elm$core$Maybe$andThen,
			function (valueSelected) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						$elm$core$Basics$eq(valueSelected),
						options));
			},
			maybeValueSelected);
		return _List_fromArray(
			[
				_Utils_Tuple2(
				A2(
					$elm$core$Maybe$withDefault,
					true,
					A2(
						$elm$core$Maybe$map,
						function (_v0) {
							return false;
						},
						getSelected)),
				'Tipo do motivo é obrigatório')
			]);
	});
var $author$project$Pages$Panel$Reason$validatorsDescription = _List_fromArray(
	[
		_Utils_Tuple2($elm$core$String$isEmpty, 'Descrição não pode ser vazio')
	]);
var $author$project$Pages$Panel$Reason$validatorsValue = _List_Nil;
var $author$project$Pages$Panel$Reason$allValidatorsToSubmitted = function (m) {
	return _Utils_ap(
		A2(
			$author$project$Pages$Panel$Reason$isInvalidInput,
			$elm$core$String$fromInt(m.lo),
			$author$project$Pages$Panel$Reason$validatorsValue),
		_Utils_ap(
			$author$project$Pages$Panel$Reason$isInvalid(
				A2($author$project$Pages$Panel$Reason$validatorsActions, m.N, $author$project$Services$Reason$allActions)),
			A2($author$project$Pages$Panel$Reason$isInvalidInput, m.z, $author$project$Pages$Panel$Reason$validatorsDescription)));
};
var $author$project$Services$Reason$encodeAction = function (action) {
	return $elm$json$Json$Encode$string(
		$author$project$Services$Reason$actionToCode(action));
};
var $author$project$Services$Reason$encodeCreateReason = function (options) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(options.c3)),
				_Utils_Tuple2(
				'action',
				$author$project$Services$Reason$encodeAction(options.hV)),
				_Utils_Tuple2(
				'taxValue',
				$elm$json$Json$Encode$int(options.fB))
			]));
};
var $author$project$Services$Reason$createReason = function (options) {
	return $author$project$Services$Api$postHttp(
		{
			lG: $elm$http$Http$jsonBody(
				$author$project$Services$Reason$encodeCreateReason(options)),
			m9: $author$project$Services$Api$expectWhateverErrorString(
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'reason']),
				_List_Nil)
		});
};
var $author$project$Services$Reason$editReason = function (options) {
	return $author$project$Services$Api$putHttp(
		{
			lG: $elm$http$Http$jsonBody(
				$author$project$Services$Reason$encodeCreateReason(options)),
			m9: $author$project$Services$Api$expectWhateverErrorString(
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'reason', 'updateByID', options.dM]),
				_List_Nil)
		});
};
var $author$project$Pages$Panel$Reason$updateModal = F3(
	function (msg, m, user) {
		var _v0 = _Utils_Tuple2(msg, m.aY);
		_v0$10:
		while (true) {
			if (!_v0.b.$) {
				if (!_v0.b.a.$) {
					switch (_v0.a.$) {
						case 0:
							var newValue = _v0.a.a;
							var modal = _v0.b.a.a;
							return _Utils_Tuple3(
								_Utils_update(
									m,
									{
										aY: $elm$core$Maybe$Just(
											$author$project$Pages$Panel$Reason$CreateReason(
												_Utils_update(
													modal,
													{z: newValue})))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						case 1:
							var actionStr = _v0.a.a;
							var modal = _v0.b.a.a;
							var setValue = function () {
								var _v1 = $author$project$Services$Reason$actionFromCode(actionStr);
								if ((!_v1.$) && (_v1.a === 2)) {
									var _v2 = _v1.a;
									return modal.lo;
								} else {
									return 0;
								}
							}();
							return _Utils_Tuple3(
								_Utils_update(
									m,
									{
										aY: $elm$core$Maybe$Just(
											$author$project$Pages$Panel$Reason$CreateReason(
												_Utils_update(
													modal,
													{
														lo: setValue,
														N: $author$project$Services$Reason$actionFromCode(actionStr)
													})))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						case 2:
							var newValue = _v0.a.a;
							var modal = _v0.b.a.a;
							return _Utils_Tuple3(
								_Utils_update(
									m,
									{
										aY: $elm$core$Maybe$Just(
											$author$project$Pages$Panel$Reason$CreateReason(
												_Utils_update(
													modal,
													{
														lo: A2(
															$elm$core$Maybe$withDefault,
															0,
															$elm$core$String$toInt(newValue))
													})))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						case 3:
							var _v3 = _v0.a;
							var modal = _v0.b.a.a;
							var _v4 = _Utils_Tuple2(
								$author$project$Pages$Panel$Reason$allValidatorsToSubmitted(modal),
								modal.N);
							if ((!_v4.a.b) && (!_v4.b.$)) {
								var action = _v4.b.a;
								return _Utils_Tuple3(
									_Utils_update(
										m,
										{
											aY: $elm$core$Maybe$Just(
												$author$project$Pages$Panel$Reason$CreateReason(
													_Utils_update(
														modal,
														{L: 2})))
										}),
									$author$project$Services$Reason$createReason(
										{
											hV: action,
											c3: modal.z,
											ow: A2($elm$core$Basics$composeR, $author$project$Pages$Panel$Reason$GotCreateReason, $author$project$Pages$Panel$Reason$ModalMsg),
											fB: modal.lo,
											kU: user.kU
										}),
									$author$project$Shared$NoOp);
							} else {
								var errors = _v4.a;
								return _Utils_Tuple3(
									_Utils_update(
										m,
										{
											aY: $elm$core$Maybe$Just(
												$author$project$Pages$Panel$Reason$CreateReason(
													_Utils_update(
														modal,
														{L: 1})))
										}),
									$elm$core$Platform$Cmd$none,
									$author$project$Shared$ShowErrorDialog(
										'Existe campos incorretos no formulário: ' + A2($elm$core$String$join, ', ', errors)));
							}
						case 5:
							var result = _v0.a.a;
							var modal = _v0.b.a.a;
							return _Utils_Tuple3(
								_Utils_update(
									m,
									{
										aY: A2(
											$krisajenkins$remotedata$RemoteData$withDefault,
											$elm$core$Maybe$Just(
												$author$project$Pages$Panel$Reason$CreateReason(
													_Utils_update(
														modal,
														{L: 0}))),
											A2(
												$krisajenkins$remotedata$RemoteData$map,
												function (_v5) {
													return $elm$core$Maybe$Nothing;
												},
												result))
									}),
								A2(
									$krisajenkins$remotedata$RemoteData$withDefault,
									$elm$core$Platform$Cmd$none,
									A2(
										$krisajenkins$remotedata$RemoteData$map,
										function (_v6) {
											return $author$project$Services$Reason$getReasons(
												{ow: $author$project$Pages$Panel$Reason$GotReasons, kU: user.kU});
										},
										result)),
								A2(
									$author$project$Shared$remoteDataSharedMsg,
									$elm$core$Maybe$Just('Motivo Criado com sucesso!'),
									result));
						default:
							break _v0$10;
					}
				} else {
					switch (_v0.a.$) {
						case 0:
							var newValue = _v0.a.a;
							var modal = _v0.b.a.a;
							return _Utils_Tuple3(
								_Utils_update(
									m,
									{
										aY: $elm$core$Maybe$Just(
											$author$project$Pages$Panel$Reason$EditReason(
												_Utils_update(
													modal,
													{z: newValue})))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						case 1:
							var actionStr = _v0.a.a;
							var modal = _v0.b.a.a;
							return _Utils_Tuple3(
								_Utils_update(
									m,
									{
										aY: $elm$core$Maybe$Just(
											$author$project$Pages$Panel$Reason$EditReason(
												_Utils_update(
													modal,
													{
														N: $author$project$Services$Reason$actionFromCode(actionStr)
													})))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						case 2:
							var newValue = _v0.a.a;
							var modal = _v0.b.a.a;
							return _Utils_Tuple3(
								_Utils_update(
									m,
									{
										aY: $elm$core$Maybe$Just(
											$author$project$Pages$Panel$Reason$EditReason(
												_Utils_update(
													modal,
													{
														lo: A2(
															$elm$core$Maybe$withDefault,
															0,
															$elm$core$String$toInt(newValue))
													})))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						case 4:
							var _v7 = _v0.a;
							var modal = _v0.b.a.a;
							var _v8 = _Utils_Tuple2(
								$author$project$Pages$Panel$Reason$allValidatorsToSubmitted(modal),
								modal.N);
							if ((!_v8.a.b) && (!_v8.b.$)) {
								var action = _v8.b.a;
								return _Utils_Tuple3(
									_Utils_update(
										m,
										{
											aY: $elm$core$Maybe$Just(
												$author$project$Pages$Panel$Reason$EditReason(
													_Utils_update(
														modal,
														{L: 2})))
										}),
									$author$project$Services$Reason$editReason(
										{
											hV: action,
											dM: modal.dM,
											c3: modal.z,
											ow: A2($elm$core$Basics$composeR, $author$project$Pages$Panel$Reason$GotCreateReason, $author$project$Pages$Panel$Reason$ModalMsg),
											fB: modal.lo,
											kU: user.kU
										}),
									$author$project$Shared$NoOp);
							} else {
								var errors = _v8.a;
								return _Utils_Tuple3(
									_Utils_update(
										m,
										{
											aY: $elm$core$Maybe$Just(
												$author$project$Pages$Panel$Reason$EditReason(
													_Utils_update(
														modal,
														{L: 1})))
										}),
									$elm$core$Platform$Cmd$none,
									$author$project$Shared$ShowErrorDialog(
										'Existe campos incorretos no formulário: ' + A2($elm$core$String$join, ', ', errors)));
							}
						case 5:
							var result = _v0.a.a;
							var modal = _v0.b.a.a;
							return _Utils_Tuple3(
								_Utils_update(
									m,
									{
										aY: A2(
											$krisajenkins$remotedata$RemoteData$withDefault,
											$elm$core$Maybe$Just(
												$author$project$Pages$Panel$Reason$EditReason(
													_Utils_update(
														modal,
														{L: 0}))),
											A2(
												$krisajenkins$remotedata$RemoteData$map,
												function (_v9) {
													return $elm$core$Maybe$Nothing;
												},
												result))
									}),
								A2(
									$krisajenkins$remotedata$RemoteData$withDefault,
									$elm$core$Platform$Cmd$none,
									A2(
										$krisajenkins$remotedata$RemoteData$map,
										function (_v10) {
											return $author$project$Services$Reason$getReasons(
												{ow: $author$project$Pages$Panel$Reason$GotReasons, kU: user.kU});
										},
										result)),
								A2(
									$author$project$Shared$remoteDataSharedMsg,
									$elm$core$Maybe$Just('Motivo editado com sucesso!'),
									result));
						default:
							break _v0$10;
					}
				}
			} else {
				break _v0$10;
			}
		}
		return _Utils_Tuple3(
			m,
			$elm$core$Platform$Cmd$none,
			$author$project$Shared$ShowErrorDialog('Algo deu errado!'));
	});
var $author$project$Pages$Panel$Reason$update = F4(
	function (msg, model, shared, user) {
		var queries = model.T;
		switch (msg.$) {
			case 0:
				var result = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{d5: result}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, result));
			case 1:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aY: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aY: $elm$core$Maybe$Just(
								$author$project$Pages$Panel$Reason$CreateReason($author$project$Pages$Panel$Reason$initCreateReasonModel))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 5:
				var reason = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aY: $elm$core$Maybe$Just(
								$author$project$Pages$Panel$Reason$EditReason(
									$author$project$Pages$Panel$Reason$initEditReasonModel(reason)))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 6:
				var actionStr = msg.a;
				var updateQueries = _Utils_update(
					queries,
					{
						hV: $author$project$Services$Reason$actionFromCode(actionStr)
					});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{T: updateQueries}),
					A2(
						$author$project$Route$pushUrl,
						shared.nZ,
						$author$project$Route$Panel(
							$author$project$Route$Reason(updateQueries))),
					$author$project$Shared$NoOp);
			default:
				var msg_ = msg.a;
				return A3($author$project$Pages$Panel$Reason$updateModal, msg_, model, user);
		}
	});
var $author$project$Pages$Panel$ReversalApprovalCashier$GenerateCsvDownloadWithTime = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Panel$ReversalApprovalCashier$GotManualPayResponse = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Panel$ReversalApprovalCashier$PayBillet = $elm$core$Basics$identity;
var $author$project$Pages$Panel$ReversalApprovalCashier$emptyValue = function (v) {
	return $elm$core$String$isEmpty(v) ? '-' : v;
};
var $author$project$Pages$Panel$ReversalApprovalCashier$initPayBilletModal = function (billet) {
	return {eq: billet, dP: false};
};
var $author$project$Services$Payments$requestRefund = F2(
	function (token, id) {
		return $elm$http$Http$task(
			{
				lG: $elm$http$Http$emptyBody,
				nG: _List_fromArray(
					[
						$author$project$Services$Api$authorizationHeader(token)
					]),
				of: 'POST',
				d6: $author$project$Services$Api$whateverResolver,
				p5: $elm$core$Maybe$Nothing,
				qt: A2(
					$author$project$Constants$concessionaireServiceUrl,
					_List_fromArray(
						['api', 'v1', 'wallets', id, 'paymentOrder', 'rollback', 'approve']),
					_List_Nil)
			});
	});
var $author$project$Pages$Panel$ReversalApprovalCashier$setModal = F2(
	function (model, modal) {
		return _Utils_update(
			model,
			{
				aY: $elm$core$Maybe$Just(modal)
			});
	});
var $author$project$Pages$Panel$ReversalApprovalCashier$GotRollback = function (a) {
	return {$: 2, a: a};
};
var $author$project$Services$Payments$Rollback = F2(
	function (cashierOrders, systemOrders) {
		return {lQ: cashierOrders, p_: systemOrders};
	});
var $author$project$Services$Payments$RollbackCashierOrder = function (id) {
	return function (createdAt) {
		return function (rollBackRequestUserName) {
			return function (rollBackAppliedBy) {
				return function (rollBackAppliedAt) {
					return function (rollBackUserName) {
						return function (rollBackUserDocument) {
							return function (status) {
								return function (paymentMethod) {
									return function (amount) {
										return {lo: amount, ix: createdAt, dM: id, jW: paymentMethod, kd: rollBackAppliedAt, ke: rollBackAppliedBy, kf: rollBackRequestUserName, kg: rollBackUserDocument, kh: rollBackUserName, kK: status};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Services$Payments$rollbackCashierOrderDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'amount',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'paymentMethod',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'status',
			$author$project$Services$Payments$statusDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
				_List_fromArray(
					['rollBackData', 'rollBackUserDocument']),
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
					_List_fromArray(
						['rollBackData', 'rollBackUserName']),
					$elm$json$Json$Decode$string,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
						_List_fromArray(
							['rollBackData', 'rollBackAppliedAt']),
						$elm$json$Json$Decode$maybe($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
							_List_fromArray(
								['rollBackData', 'rollBackAppliedBy']),
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
								_List_fromArray(
									['rollBackData', 'rollBackRequestUserName']),
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'createdAt',
									$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Services$Payments$RollbackCashierOrder)))))))))));
var $author$project$Services$Payments$RollbackSystemOrder = function (id) {
	return function (createdAt) {
		return function (rollBackRequestUserName) {
			return function (rollBackAppliedBy) {
				return function (rollBackAppliedAt) {
					return function (rollBackUserName) {
						return function (rollBackUserDocument) {
							return function (status) {
								return function (paymentMethod) {
									return function (amount) {
										return function (sequence) {
											return {lo: amount, ix: createdAt, dM: id, jW: paymentMethod, kd: rollBackAppliedAt, ke: rollBackAppliedBy, kf: rollBackRequestUserName, kg: rollBackUserDocument, kh: rollBackUserName, pC: sequence, kK: status};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Services$Payments$rollbackSystemOrderDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'sequence',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'amount',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'paymentMethod',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'status',
				$author$project$Services$Payments$statusDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
					_List_fromArray(
						['rollBackData', 'rollBackUserDocument']),
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
						_List_fromArray(
							['rollBackData', 'rollBackUserName']),
						$elm$json$Json$Decode$string,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
							_List_fromArray(
								['rollBackData', 'rollBackAppliedAt']),
							$elm$json$Json$Decode$maybe($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
							$elm$core$Maybe$Nothing,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
								_List_fromArray(
									['rollBackData', 'rollBackAppliedBy']),
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
									_List_fromArray(
										['rollBackData', 'rollBackRequestUserName']),
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'createdAt',
										$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'id',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$Services$Payments$RollbackSystemOrder))))))))))));
var $author$project$Services$Payments$rollbackDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'systemOrders',
	$elm$json$Json$Decode$list($author$project$Services$Payments$rollbackSystemOrderDecoder),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'cashierOrders',
		$elm$json$Json$Decode$maybe(
			$elm$json$Json$Decode$list($author$project$Services$Payments$rollbackCashierOrderDecoder)),
		$elm$core$Maybe$Nothing,
		$elm$json$Json$Decode$succeed($author$project$Services$Payments$Rollback)));
var $author$project$Services$Payments$getReversalApproval = F5(
	function (token, start, end, maybeStatus, concessionaireId) {
		return $elm$http$Http$task(
			{
				lG: $elm$http$Http$emptyBody,
				nG: _List_fromArray(
					[
						$author$project$Services$Api$authorizationHeader(token)
					]),
				of: 'GET',
				d6: $author$project$Services$Api$jsonResolver($author$project$Services$Payments$rollbackDecoder),
				p5: $elm$core$Maybe$Nothing,
				qt: A2(
					$author$project$Constants$paymentsServiceUrl,
					_List_fromArray(
						['api', 'v1', 'orders', 'rollback']),
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								$elm$core$Maybe$Just(
								A2(
									$elm$url$Url$Builder$string,
									'start',
									$justinmimbs$date$Date$toIsoString(start))),
								$elm$core$Maybe$Just(
								A2(
									$elm$url$Url$Builder$string,
									'end',
									$justinmimbs$date$Date$toIsoString(end))),
								A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Services$Payments$statusToApiString,
									$elm$url$Url$Builder$string('status')),
								maybeStatus),
								A2(
								$elm$core$Maybe$map,
								$elm$url$Url$Builder$string('concessionaireID'),
								concessionaireId)
							])))
			});
	});
var $author$project$Pages$Panel$ReversalApprovalCashier$updateFilter = F4(
	function (newRollbacks, shared, user, model) {
		return A2(
			$elm$core$Result$withDefault,
			_Utils_Tuple3(
				model,
				$elm$core$Platform$Cmd$none,
				$author$project$Shared$ShowErrorDialog('Necessário informar date de início e fim')),
			A3(
				$elm$core$Result$map2,
				F2(
					function (start, end) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{a2: newRollbacks}),
							A2(
								$elm$core$Task$attempt,
								$author$project$Pages$Panel$ReversalApprovalCashier$GotRollback,
								A5(
									$author$project$Services$Payments$getReversalApproval,
									user.kU,
									start,
									end,
									$author$project$Services$Payments$statusFromString(model.kK),
									$author$project$Route$extractConcessionaireId(shared.pv))),
							$author$project$Shared$NoOp);
					}),
				$justinmimbs$date$Date$fromIsoString(model.eb),
				$justinmimbs$date$Date$fromIsoString(model.dH)));
	});
var $author$project$Pages$Panel$ReversalApprovalCashier$update = F4(
	function (msg, model, shared, user) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
			case 1:
				var now = msg.a.e8;
				var timezone = msg.a.kS;
				var today = A2($justinmimbs$date$Date$fromPosix, timezone, now);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							dH: $justinmimbs$date$Date$toIsoString(today),
							eb: $justinmimbs$date$Date$toIsoString(
								A3($justinmimbs$date$Date$add, 1, -1, today))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 2:
				var res = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							a2: $krisajenkins$remotedata$RemoteData$fromResult(
								A2(
									$elm$core$Result$map,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.lQ;
										},
										$elm$core$Maybe$withDefault(_List_Nil)),
									res))
						}),
					$elm$core$Platform$Cmd$none,
					function () {
						if (!res.$) {
							return $author$project$Shared$NoOp;
						} else {
							var error = res.a;
							return A2($author$project$Shared$updateApiError, shared, error);
						}
					}());
			case 3:
				var str = msg.a;
				var toStr = A2(
					$elm$core$Result$withDefault,
					model.dH,
					A3(
						$elm$core$Result$map2,
						F2(
							function (from, to) {
								return (A2($justinmimbs$date$Date$compare, from, to) === 2) ? str : model.dH;
							}),
						$justinmimbs$date$Date$fromIsoString(str),
						$justinmimbs$date$Date$fromIsoString(model.dH)));
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dH: toStr, eb: str}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 4:
				var str = msg.a;
				var fromStr = A2(
					$elm$core$Result$withDefault,
					model.eb,
					A3(
						$elm$core$Result$map2,
						F2(
							function (from, to) {
								return (A2($justinmimbs$date$Date$compare, from, to) === 2) ? str : model.eb;
							}),
						$justinmimbs$date$Date$fromIsoString(model.eb),
						$justinmimbs$date$Date$fromIsoString(str)));
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dH: str, eb: fromStr}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 5:
				var str = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{kK: str}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 6:
				var billet = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aY: $elm$core$Maybe$Just(
								$author$project$Pages$Panel$ReversalApprovalCashier$initPayBilletModal(billet))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 7:
				var url = msg.a;
				return _Utils_Tuple3(
					model,
					$elm$file$File$Download$url(url),
					$author$project$Shared$NoOp);
			case 8:
				var url = msg.a;
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$PrintDocument(url));
			case 9:
				var _v2 = model.aY;
				if (_v2.$ === 1) {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
				} else {
					var modal = _v2.a;
					return _Utils_Tuple3(
						A2(
							$author$project$Pages$Panel$ReversalApprovalCashier$setModal,
							model,
							_Utils_update(
								modal,
								{dP: true})),
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$Panel$ReversalApprovalCashier$GotManualPayResponse,
							A2($author$project$Services$Payments$requestRefund, user.kU, modal.eq.dM)),
						$author$project$Shared$NoOp);
				}
			case 10:
				var newState = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{fy: newState}),
					A2(
						$author$project$Route$pushUrl,
						shared.nZ,
						$author$project$Route$Panel(
							$author$project$Route$ReversalApproval(newState))),
					$author$project$Shared$NoOp);
			case 11:
				if (!msg.a.$) {
					return A2(
						$author$project$Utils$mapThird,
						function (_v3) {
							return $author$project$Shared$ShowSuccessDialog('Estorno efetuado com sucesso!');
						},
						A4(
							$author$project$Pages$Panel$ReversalApprovalCashier$updateFilter,
							model.a2,
							shared,
							user,
							_Utils_update(
								model,
								{aY: $elm$core$Maybe$Nothing})));
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						function () {
							var _v4 = model.aY;
							if (_v4.$ === 1) {
								return model;
							} else {
								var modal = _v4.a;
								return A2(
									$author$project$Pages$Panel$ReversalApprovalCashier$setModal,
									model,
									_Utils_update(
										modal,
										{dP: false}));
							}
						}(),
						$elm$core$Platform$Cmd$none,
						A2($author$project$Shared$updateApiError, shared, error));
				}
			case 12:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aY: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 13:
				return _Utils_Tuple3(
					model,
					A2(
						$elm$core$Task$perform,
						$author$project$Pages$Panel$ReversalApprovalCashier$GenerateCsvDownloadWithTime,
						A3(
							$elm$core$Task$map2,
							F2(
								function (now, timezone) {
									return {e8: now, kS: timezone};
								}),
							$elm$time$Time$now,
							$elm$time$Time$here)),
					$author$project$Shared$NoOp);
			case 14:
				var now = msg.a.e8;
				var timezone = msg.a.kS;
				var title = 'Estornos do caixa ' + (A2($author$project$Utils$formatDateTimeFromPosix, timezone, now) + '.csv');
				var records = A2(
					$krisajenkins$remotedata$RemoteData$withDefault,
					_List_Nil,
					A2(
						$krisajenkins$remotedata$RemoteData$map,
						function (r) {
							return A2(
								$elm$core$List$map,
								function (r_) {
									return _List_fromArray(
										[
											A2($author$project$Utils$formatDateTimeFromPosix, timezone, r_.ix),
											r_.kf,
											$author$project$Pages$Panel$ReversalApprovalCashier$emptyValue(r_.ke),
											A2(
											$elm$core$Maybe$withDefault,
											'-',
											A2(
												$elm$core$Maybe$map,
												$author$project$Utils$formatDateTimeFromPosix(timezone),
												r_.kd)),
											r_.kh,
											$author$project$Utils$maskCPFOrCNPJ(r_.kg),
											$author$project$Services$Payments$statusToUserString(r_.kK),
											$author$project$Utils$formatAsMoney(
											$elm$core$String$fromInt(r_.lo))
										]);
								},
								r);
						},
						model.a2));
				var headers = _List_fromArray(
					['Data de solicitação', 'Solicitante', 'Aprovado por', 'Aprovado em', 'Usuário', 'Documento', 'Status', 'Valor']);
				return _Utils_Tuple3(
					model,
					A3($author$project$Components$GeneratorCSV$download, records, headers, title),
					$author$project$Shared$NoOp);
			default:
				return A4($author$project$Pages$Panel$ReversalApprovalCashier$updateFilter, $krisajenkins$remotedata$RemoteData$Loading, shared, user, model);
		}
	});
var $author$project$Pages$Panel$ReversalApprovalSystem$GenerateCsvDownloadWithTime = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Panel$ReversalApprovalSystem$GotManualPayResponse = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Panel$ReversalApprovalSystem$PayBillet = $elm$core$Basics$identity;
var $author$project$Pages$Panel$ReversalApprovalSystem$emptyValue = function (v) {
	return $elm$core$String$isEmpty(v) ? '-' : v;
};
var $author$project$Pages$Panel$ReversalApprovalSystem$initPayBilletModal = function (billet) {
	return {eq: billet, dP: false};
};
var $author$project$Pages$Panel$ReversalApprovalSystem$setModal = F2(
	function (model, modal) {
		return _Utils_update(
			model,
			{
				aY: $elm$core$Maybe$Just(modal)
			});
	});
var $author$project$Pages$Panel$ReversalApprovalSystem$GotRollback = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Panel$ReversalApprovalSystem$updateFilter = F3(
	function (shared, user, model) {
		return A2(
			$elm$core$Result$withDefault,
			_Utils_Tuple3(
				model,
				$elm$core$Platform$Cmd$none,
				$author$project$Shared$ShowErrorDialog('Necessário informar date de início e fim')),
			A3(
				$elm$core$Result$map2,
				F2(
					function (start, end) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{a2: $krisajenkins$remotedata$RemoteData$Loading}),
							A2(
								$elm$core$Task$attempt,
								$author$project$Pages$Panel$ReversalApprovalSystem$GotRollback,
								A5(
									$author$project$Services$Payments$getReversalApproval,
									user.kU,
									start,
									end,
									$author$project$Services$Payments$statusFromString(model.kK),
									$author$project$Route$extractConcessionaireId(shared.pv))),
							$author$project$Shared$NoOp);
					}),
				$justinmimbs$date$Date$fromIsoString(model.eb),
				$justinmimbs$date$Date$fromIsoString(model.dH)));
	});
var $author$project$Pages$Panel$ReversalApprovalSystem$update = F4(
	function (msg, model, shared, user) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
			case 1:
				var now = msg.a.e8;
				var timezone = msg.a.kS;
				var today = A2($justinmimbs$date$Date$fromPosix, timezone, now);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							dH: $justinmimbs$date$Date$toIsoString(today),
							eb: $justinmimbs$date$Date$toIsoString(
								A3($justinmimbs$date$Date$add, 1, -1, today))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 2:
				var res = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							a2: $krisajenkins$remotedata$RemoteData$fromResult(
								A2(
									$elm$core$Result$map,
									function ($) {
										return $.p_;
									},
									res))
						}),
					$elm$core$Platform$Cmd$none,
					function () {
						if (!res.$) {
							return $author$project$Shared$NoOp;
						} else {
							var error = res.a;
							return A2($author$project$Shared$updateApiError, shared, error);
						}
					}());
			case 3:
				var str = msg.a;
				var toStr = A2(
					$elm$core$Result$withDefault,
					model.dH,
					A3(
						$elm$core$Result$map2,
						F2(
							function (from, to) {
								return (A2($justinmimbs$date$Date$compare, from, to) === 2) ? str : model.dH;
							}),
						$justinmimbs$date$Date$fromIsoString(str),
						$justinmimbs$date$Date$fromIsoString(model.dH)));
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dH: toStr, eb: str}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 4:
				var str = msg.a;
				var fromStr = A2(
					$elm$core$Result$withDefault,
					model.eb,
					A3(
						$elm$core$Result$map2,
						F2(
							function (from, to) {
								return (A2($justinmimbs$date$Date$compare, from, to) === 2) ? str : model.eb;
							}),
						$justinmimbs$date$Date$fromIsoString(model.eb),
						$justinmimbs$date$Date$fromIsoString(str)));
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dH: str, eb: fromStr}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 5:
				var str = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{kK: str}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 6:
				var billet = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aY: $elm$core$Maybe$Just(
								$author$project$Pages$Panel$ReversalApprovalSystem$initPayBilletModal(billet))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 7:
				var url = msg.a;
				return _Utils_Tuple3(
					model,
					$elm$file$File$Download$url(url),
					$author$project$Shared$NoOp);
			case 8:
				var url = msg.a;
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$PrintDocument(url));
			case 9:
				var _v2 = model.aY;
				if (_v2.$ === 1) {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
				} else {
					var modal = _v2.a;
					return _Utils_Tuple3(
						A2(
							$author$project$Pages$Panel$ReversalApprovalSystem$setModal,
							model,
							_Utils_update(
								modal,
								{dP: true})),
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$Panel$ReversalApprovalSystem$GotManualPayResponse,
							A2($author$project$Services$Payments$payBillet, user.kU, modal.eq.dM)),
						$author$project$Shared$NoOp);
				}
			case 10:
				var newState = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{fy: newState}),
					A2(
						$author$project$Route$pushUrl,
						shared.nZ,
						$author$project$Route$Panel(
							$author$project$Route$ReversalApproval(newState))),
					$author$project$Shared$NoOp);
			case 11:
				if (!msg.a.$) {
					return A2(
						$author$project$Utils$mapThird,
						function (_v3) {
							return $author$project$Shared$ShowSuccessDialog('Estorno efetuado com sucesso!');
						},
						A3(
							$author$project$Pages$Panel$ReversalApprovalSystem$updateFilter,
							shared,
							user,
							_Utils_update(
								model,
								{aY: $elm$core$Maybe$Nothing})));
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						function () {
							var _v4 = model.aY;
							if (_v4.$ === 1) {
								return model;
							} else {
								var modal = _v4.a;
								return A2(
									$author$project$Pages$Panel$ReversalApprovalSystem$setModal,
									model,
									_Utils_update(
										modal,
										{dP: false}));
							}
						}(),
						$elm$core$Platform$Cmd$none,
						A2($author$project$Shared$updateApiError, shared, error));
				}
			case 12:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aY: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 13:
				return _Utils_Tuple3(
					model,
					A2(
						$elm$core$Task$perform,
						$author$project$Pages$Panel$ReversalApprovalSystem$GenerateCsvDownloadWithTime,
						A3(
							$elm$core$Task$map2,
							F2(
								function (now, timezone) {
									return {e8: now, kS: timezone};
								}),
							$elm$time$Time$now,
							$elm$time$Time$here)),
					$author$project$Shared$NoOp);
			case 14:
				var now = msg.a.e8;
				var timezone = msg.a.kS;
				var title = 'Estornos de pedidos' + (A2($author$project$Utils$formatDateTimeFromPosix, timezone, now) + '.csv');
				var records = A2(
					$krisajenkins$remotedata$RemoteData$withDefault,
					_List_Nil,
					A2(
						$krisajenkins$remotedata$RemoteData$map,
						function (r) {
							return A2(
								$elm$core$List$map,
								function (b) {
									return _List_fromArray(
										[
											A2($author$project$Utils$formatDateTimeFromPosix, timezone, b.ix),
											b.kf,
											$author$project$Pages$Panel$ReversalApprovalSystem$emptyValue(b.ke),
											A2(
											$elm$core$Maybe$withDefault,
											'-',
											A2(
												$elm$core$Maybe$map,
												$author$project$Utils$formatDateTimeFromPosix(timezone),
												b.kd)),
											b.kh,
											$author$project$Utils$maskCPFOrCNPJ(b.kg),
											$elm$core$String$fromInt(b.pC),
											$author$project$Services$Payments$statusToUserString(b.kK),
											$author$project$Utils$formatAsMoney(
											$elm$core$String$fromInt(b.lo))
										]);
								},
								r);
						},
						model.a2));
				var headers = _List_fromArray(
					['Data de solicitação', 'Solicitante', 'Aprovado por', 'Aprovado em', 'Empresa', 'Documento', 'Número do Pedido', 'Status', 'Valor']);
				return _Utils_Tuple3(
					model,
					A3($author$project$Components$GeneratorCSV$download, records, headers, title),
					$author$project$Shared$NoOp);
			default:
				return A3($author$project$Pages$Panel$ReversalApprovalSystem$updateFilter, shared, user, model);
		}
	});
var $author$project$Pages$Panel$SingleCharge$Create = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Panel$SingleCharge$Edit = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Panel$SingleCharge$GotStatusSingleCharge = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Pages$Panel$SingleCharge$initCreateModel = {z: '', L: 0, di: 0};
var $author$project$Pages$Panel$SingleCharge$initEditModel = function (singleCharge) {
	return {z: singleCharge.kX, L: 0, dM: singleCharge.dM, di: singleCharge.di};
};
var $author$project$Services$SingleCharge$statusChangeApplied = function (status) {
	if (!status) {
		return 'ativada';
	} else {
		return 'desativada';
	}
};
var $author$project$Services$SingleCharge$encodeStatus = function (status) {
	if (!status) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Services$SingleCharge$encodeStatusSingleChargeType = function (options) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'typeID',
				$elm$json$Json$Encode$string(options.dM)),
				_Utils_Tuple2(
				'active',
				$elm$json$Json$Encode$bool(
					$author$project$Services$SingleCharge$encodeStatus(options.kK)))
			]));
};
var $author$project$Services$SingleCharge$statusChargeType = function (options) {
	return $author$project$Services$Api$putHttp(
		{
			lG: $elm$http$Http$jsonBody(
				$author$project$Services$SingleCharge$encodeStatusSingleChargeType(options)),
			m9: $author$project$Services$Api$expectWhateverErrorString(
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'extraCharges', 'activeExtraChargeTypes']),
				_List_Nil)
		});
};
var $author$project$Services$SingleCharge$toggleStatus = function (status) {
	if (!status) {
		return 1;
	} else {
		return 0;
	}
};
var $author$project$Pages$Panel$SingleCharge$GotCreate = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Panel$SingleCharge$ModalMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Panel$SingleCharge$isInvalidInput = F2(
	function (input, validators) {
		return A2(
			$elm$core$List$filterMap,
			function (_v0) {
				var isInvalid_ = _v0.a;
				var error = _v0.b;
				return isInvalid_ ? $elm$core$Maybe$Just(error) : $elm$core$Maybe$Nothing;
			},
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$mapFirst(
					function (isInvalid_) {
						return isInvalid_(input);
					}),
				validators));
	});
var $author$project$Pages$Panel$SingleCharge$validatorsDescription = _List_fromArray(
	[
		_Utils_Tuple2($elm$core$String$isEmpty, 'Descrição não pode ser vazio')
	]);
var $author$project$Pages$Panel$SingleCharge$validatorsValue = _List_Nil;
var $author$project$Pages$Panel$SingleCharge$allValidatorsToSubmitted = function (m) {
	return _Utils_ap(
		A2(
			$author$project$Pages$Panel$SingleCharge$isInvalidInput,
			$elm$core$String$fromInt(m.di),
			$author$project$Pages$Panel$SingleCharge$validatorsValue),
		A2($author$project$Pages$Panel$SingleCharge$isInvalidInput, m.z, $author$project$Pages$Panel$SingleCharge$validatorsDescription));
};
var $author$project$Services$SingleCharge$encodeCreateSingleChargeType = function (options) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(options.z)),
				_Utils_Tuple2(
				'value',
				$elm$json$Json$Encode$int(options.di))
			]));
};
var $author$project$Services$SingleCharge$createSingleChargeType = function (options) {
	return $author$project$Services$Api$postHttp(
		{
			lG: $elm$http$Http$jsonBody(
				$author$project$Services$SingleCharge$encodeCreateSingleChargeType(options)),
			m9: $author$project$Services$Api$expectWhateverErrorString(
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'extraCharges', 'createExtraChargeTypes']),
				_List_Nil)
		});
};
var $author$project$Services$SingleCharge$encodeEditSingleChargeType = function (options) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'typeID',
				$elm$json$Json$Encode$string(options.dM)),
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(options.z)),
				_Utils_Tuple2(
				'value',
				$elm$json$Json$Encode$int(options.di))
			]));
};
var $author$project$Services$SingleCharge$editSingleChargeType = function (options) {
	return $author$project$Services$Api$putHttp(
		{
			lG: $elm$http$Http$jsonBody(
				$author$project$Services$SingleCharge$encodeEditSingleChargeType(options)),
			m9: $author$project$Services$Api$expectWhateverErrorString(
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'extraCharges', 'updateExtraChargeTypes']),
				_List_Nil)
		});
};
var $author$project$Pages$Panel$SingleCharge$updateModal = F3(
	function (msg, m, user) {
		var _v0 = _Utils_Tuple2(msg, m.aY);
		_v0$8:
		while (true) {
			if (!_v0.b.$) {
				if (!_v0.b.a.$) {
					switch (_v0.a.$) {
						case 0:
							var newValue = _v0.a.a;
							var modal = _v0.b.a.a;
							return _Utils_Tuple3(
								_Utils_update(
									m,
									{
										aY: $elm$core$Maybe$Just(
											$author$project$Pages$Panel$SingleCharge$Create(
												_Utils_update(
													modal,
													{z: newValue})))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						case 2:
							var newValue = _v0.a.a;
							var modal = _v0.b.a.a;
							return _Utils_Tuple3(
								_Utils_update(
									m,
									{
										aY: $elm$core$Maybe$Just(
											$author$project$Pages$Panel$SingleCharge$Create(
												_Utils_update(
													modal,
													{
														di: A2(
															$elm$core$Maybe$withDefault,
															0,
															$elm$core$String$toInt(newValue))
													})))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						case 3:
							var _v1 = _v0.a;
							var modal = _v0.b.a.a;
							var _v2 = $author$project$Pages$Panel$SingleCharge$allValidatorsToSubmitted(modal);
							if (!_v2.b) {
								return _Utils_Tuple3(
									_Utils_update(
										m,
										{
											aY: $elm$core$Maybe$Just(
												$author$project$Pages$Panel$SingleCharge$Create(
													_Utils_update(
														modal,
														{L: 2})))
										}),
									$author$project$Services$SingleCharge$createSingleChargeType(
										{
											z: modal.z,
											ow: A2($elm$core$Basics$composeR, $author$project$Pages$Panel$SingleCharge$GotCreate, $author$project$Pages$Panel$SingleCharge$ModalMsg),
											kU: user.kU,
											di: modal.di
										}),
									$author$project$Shared$NoOp);
							} else {
								var errors = _v2;
								return _Utils_Tuple3(
									_Utils_update(
										m,
										{
											aY: $elm$core$Maybe$Just(
												$author$project$Pages$Panel$SingleCharge$Create(
													_Utils_update(
														modal,
														{L: 1})))
										}),
									$elm$core$Platform$Cmd$none,
									$author$project$Shared$ShowErrorDialog(
										'Existe campos incorretos no formulário: ' + A2($elm$core$String$join, ', ', errors)));
							}
						case 5:
							var result = _v0.a.a;
							var modal = _v0.b.a.a;
							return _Utils_Tuple3(
								_Utils_update(
									m,
									{
										aY: A2(
											$krisajenkins$remotedata$RemoteData$withDefault,
											$elm$core$Maybe$Just(
												$author$project$Pages$Panel$SingleCharge$Create(
													_Utils_update(
														modal,
														{L: 0}))),
											A2(
												$krisajenkins$remotedata$RemoteData$map,
												function (_v3) {
													return $elm$core$Maybe$Nothing;
												},
												result))
									}),
								A2(
									$krisajenkins$remotedata$RemoteData$withDefault,
									$elm$core$Platform$Cmd$none,
									A2(
										$krisajenkins$remotedata$RemoteData$map,
										function (_v4) {
											return $author$project$Services$SingleCharge$getSingleCharges(
												{ow: $author$project$Pages$Panel$SingleCharge$GotSingleCharges, kU: user.kU});
										},
										result)),
								A2(
									$author$project$Shared$remoteDataSharedMsg,
									$elm$core$Maybe$Just('Tipo de cobrança Criado com sucesso!'),
									result));
						default:
							break _v0$8;
					}
				} else {
					switch (_v0.a.$) {
						case 0:
							var newValue = _v0.a.a;
							var modal = _v0.b.a.a;
							return _Utils_Tuple3(
								_Utils_update(
									m,
									{
										aY: $elm$core$Maybe$Just(
											$author$project$Pages$Panel$SingleCharge$Edit(
												_Utils_update(
													modal,
													{z: newValue})))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						case 2:
							var newValue = _v0.a.a;
							var modal = _v0.b.a.a;
							return _Utils_Tuple3(
								_Utils_update(
									m,
									{
										aY: $elm$core$Maybe$Just(
											$author$project$Pages$Panel$SingleCharge$Edit(
												_Utils_update(
													modal,
													{
														di: A2(
															$elm$core$Maybe$withDefault,
															0,
															$elm$core$String$toInt(newValue))
													})))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						case 4:
							var _v5 = _v0.a;
							var modal = _v0.b.a.a;
							var _v6 = $author$project$Pages$Panel$SingleCharge$allValidatorsToSubmitted(modal);
							if (!_v6.b) {
								return _Utils_Tuple3(
									_Utils_update(
										m,
										{
											aY: $elm$core$Maybe$Just(
												$author$project$Pages$Panel$SingleCharge$Edit(
													_Utils_update(
														modal,
														{L: 2})))
										}),
									$author$project$Services$SingleCharge$editSingleChargeType(
										{
											z: modal.z,
											dM: modal.dM,
											ow: A2($elm$core$Basics$composeR, $author$project$Pages$Panel$SingleCharge$GotCreate, $author$project$Pages$Panel$SingleCharge$ModalMsg),
											kU: user.kU,
											di: modal.di
										}),
									$author$project$Shared$NoOp);
							} else {
								var errors = _v6;
								return _Utils_Tuple3(
									_Utils_update(
										m,
										{
											aY: $elm$core$Maybe$Just(
												$author$project$Pages$Panel$SingleCharge$Edit(
													_Utils_update(
														modal,
														{L: 1})))
										}),
									$elm$core$Platform$Cmd$none,
									$author$project$Shared$ShowErrorDialog(
										'Existe campos incorretos no formulário: ' + A2($elm$core$String$join, ', ', errors)));
							}
						case 5:
							var result = _v0.a.a;
							var modal = _v0.b.a.a;
							return _Utils_Tuple3(
								_Utils_update(
									m,
									{
										aY: A2(
											$krisajenkins$remotedata$RemoteData$withDefault,
											$elm$core$Maybe$Just(
												$author$project$Pages$Panel$SingleCharge$Edit(
													_Utils_update(
														modal,
														{L: 0}))),
											A2(
												$krisajenkins$remotedata$RemoteData$map,
												function (_v7) {
													return $elm$core$Maybe$Nothing;
												},
												result))
									}),
								A2(
									$krisajenkins$remotedata$RemoteData$withDefault,
									$elm$core$Platform$Cmd$none,
									A2(
										$krisajenkins$remotedata$RemoteData$map,
										function (_v8) {
											return $author$project$Services$SingleCharge$getSingleCharges(
												{ow: $author$project$Pages$Panel$SingleCharge$GotSingleCharges, kU: user.kU});
										},
										result)),
								A2(
									$author$project$Shared$remoteDataSharedMsg,
									$elm$core$Maybe$Just('Tipo da cobrança editado com sucesso!'),
									result));
						default:
							break _v0$8;
					}
				}
			} else {
				break _v0$8;
			}
		}
		return _Utils_Tuple3(
			m,
			$elm$core$Platform$Cmd$none,
			$author$project$Shared$ShowErrorDialog('Algo deu errado!'));
	});
var $author$project$Pages$Panel$SingleCharge$update = F4(
	function (msg, model, shared, user) {
		switch (msg.$) {
			case 0:
				var result = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cr: result}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, result));
			case 1:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aY: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aY: $elm$core$Maybe$Just(
								$author$project$Pages$Panel$SingleCharge$Create($author$project$Pages$Panel$SingleCharge$initCreateModel))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 5:
				var singleCharge = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aY: $elm$core$Maybe$Just(
								$author$project$Pages$Panel$SingleCharge$Edit(
									$author$project$Pages$Panel$SingleCharge$initEditModel(singleCharge)))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 6:
				var singleCharge = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							cr: A2(
								$krisajenkins$remotedata$RemoteData$map,
								function (fs) {
									return A2(
										$elm$core$List$map,
										function (f) {
											return _Utils_eq(f.dM, singleCharge.dM) ? _Utils_update(
												f,
												{
													at: $author$project$Services$SingleCharge$toggleStatus(singleCharge.at)
												}) : f;
										},
										fs);
								},
								model.cr)
						}),
					$author$project$Services$SingleCharge$statusChargeType(
						{
							dM: singleCharge.dM,
							ow: $author$project$Pages$Panel$SingleCharge$GotStatusSingleCharge(singleCharge),
							kK: $author$project$Services$SingleCharge$toggleStatus(singleCharge.at),
							kU: user.kU
						}),
					$author$project$Shared$NoOp);
			case 7:
				var singleCharges = msg.a;
				var result = msg.b;
				var txt = $author$project$Services$SingleCharge$statusChangeApplied(
					$author$project$Services$SingleCharge$toggleStatus(singleCharges.at));
				return _Utils_Tuple3(
					model,
					$author$project$Services$SingleCharge$getSingleCharges(
						{ow: $author$project$Pages$Panel$SingleCharge$GotSingleCharges, kU: user.kU}),
					A2(
						$author$project$Shared$remoteDataSharedMsg,
						$elm$core$Maybe$Just('Tipo de cobrança ' + (txt + ' com sucesso!')),
						result));
			default:
				var msg_ = msg.a;
				return A3($author$project$Pages$Panel$SingleCharge$updateModal, msg_, model, user);
		}
	});
var $author$project$Pages$Panel$Stock$Details$DeleteEquipment = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Pages$Panel$Stock$Details$EditEquipment = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Panel$Stock$Details$initEditEquipment = function (equipment) {
	return {
		bh: equipment.bh,
		L: 0,
		ca: '',
		kw: equipment.pE,
		kK: A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.kK;
			},
			equipment.kK)
	};
};
var $author$project$Pages$Panel$Stock$Details$GotDeleteEquipment = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Panel$Stock$Details$GotUpdateEquipment = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Panel$Stock$Details$ModalMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Services$Stock$allStatus = _List_fromArray(
	['Estoque', 'Cliente', 'Manutenção', 'Expedição', 'Descarte', 'Transportadora']);
var $author$project$Pages$Panel$Stock$Details$isInvalid = function (validators) {
	return A2(
		$elm$core$List$filterMap,
		function (_v0) {
			var isInvalid_ = _v0.a;
			var error = _v0.b;
			return isInvalid_ ? $elm$core$Maybe$Just(error) : $elm$core$Maybe$Nothing;
		},
		validators);
};
var $author$project$Pages$Panel$Stock$Details$isInvalidInput = F2(
	function (input, validators) {
		return A2(
			$elm$core$List$filterMap,
			function (_v0) {
				var isInvalid_ = _v0.a;
				var error = _v0.b;
				return isInvalid_ ? $elm$core$Maybe$Just(error) : $elm$core$Maybe$Nothing;
			},
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$mapFirst(
					function (isInvalid_) {
						return isInvalid_(input);
					}),
				validators));
	});
var $author$project$Pages$Panel$Stock$Details$validatorsBatch = _List_Nil;
var $author$project$Pages$Panel$Stock$Details$validatorsDescription = _List_Nil;
var $author$project$Pages$Panel$Stock$Details$validatorsStatus = F2(
	function (maybeValueSelected, options) {
		var getSelected = A2(
			$elm$core$Maybe$andThen,
			function (valueSelected) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						$elm$core$Basics$eq(valueSelected),
						options));
			},
			maybeValueSelected);
		return _List_fromArray(
			[
				_Utils_Tuple2(
				A2(
					$elm$core$Maybe$withDefault,
					true,
					A2(
						$elm$core$Maybe$map,
						function (_v0) {
							return false;
						},
						getSelected)),
				'Status é obrigatório')
			]);
	});
var $author$project$Pages$Panel$Stock$Details$allValidatorsToSubmitted = function (m) {
	return _Utils_ap(
		$author$project$Pages$Panel$Stock$Details$isInvalid(
			A2($author$project$Pages$Panel$Stock$Details$validatorsStatus, m.kK, $author$project$Services$Stock$allStatus)),
		_Utils_ap(
			A2($author$project$Pages$Panel$Stock$Details$isInvalidInput, m.bh, $author$project$Pages$Panel$Stock$Details$validatorsBatch),
			A2($author$project$Pages$Panel$Stock$Details$isInvalidInput, m.ca, $author$project$Pages$Panel$Stock$Details$validatorsDescription)));
};
var $author$project$Services$Api$deleteHttp = function (options) {
	return $elm$http$Http$request(
		{
			lG: options.lG,
			m9: options.m9,
			nG: _List_fromArray(
				[
					$author$project$Services$Api$authorizationHeader(options.kU)
				]),
			of: 'DELETE',
			p5: $elm$core$Maybe$Nothing,
			qi: $elm$core$Maybe$Nothing,
			qt: options.qt
		});
};
var $author$project$Services$Stock$deleteEquipmentInStock = function (options) {
	return $author$project$Services$Api$deleteHttp(
		{
			lG: $elm$http$Http$emptyBody,
			m9: $author$project$Services$Api$expectWhateverErrorString(
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'stock', options.kw]),
				_List_Nil)
		});
};
var $author$project$Services$Stock$encodeUpdateEquipment = function (opts) {
	var maybeValue = function (maybeV) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$json$Json$Encode$null,
			A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, maybeV));
	};
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'status',
				maybeValue(opts.kK)),
				_Utils_Tuple2(
				'observation',
				$elm$json$Json$Encode$string(opts.ca)),
				_Utils_Tuple2(
				'batch',
				$elm$json$Json$Encode$string(opts.bh))
			]));
};
var $author$project$Services$Stock$updateEquipmentInStock = function (options) {
	return $author$project$Services$Api$putHttp(
		{
			lG: $elm$http$Http$jsonBody(
				$author$project$Services$Stock$encodeUpdateEquipment(options)),
			m9: $author$project$Services$Api$expectWhateverErrorString(
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'stock', options.kw]),
				_List_Nil)
		});
};
var $author$project$Pages$Panel$Stock$Details$updateModal = F4(
	function (msg, model, shared, user) {
		var _v0 = _Utils_Tuple2(msg, model.aY);
		_v0$7:
		while (true) {
			if (!_v0.b.$) {
				if (!_v0.b.a.$) {
					switch (_v0.a.$) {
						case 0:
							var newStatus = _v0.a.a;
							var m = _v0.b.a.a;
							var maybeStatus = $elm$core$String$isEmpty(newStatus) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(newStatus);
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $elm$core$Maybe$Just(
											$author$project$Pages$Panel$Stock$Details$EditEquipment(
												_Utils_update(
													m,
													{kK: maybeStatus})))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						case 1:
							var newDescription = _v0.a.a;
							var m = _v0.b.a.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $elm$core$Maybe$Just(
											$author$project$Pages$Panel$Stock$Details$EditEquipment(
												_Utils_update(
													m,
													{ca: newDescription})))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						case 2:
							var newBatch = _v0.a.a;
							var m = _v0.b.a.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $elm$core$Maybe$Just(
											$author$project$Pages$Panel$Stock$Details$EditEquipment(
												_Utils_update(
													m,
													{bh: newBatch})))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						case 3:
							var _v1 = _v0.a;
							var m = _v0.b.a.a;
							var _v2 = $author$project$Pages$Panel$Stock$Details$allValidatorsToSubmitted(m);
							if (!_v2.b) {
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $elm$core$Maybe$Just(
												$author$project$Pages$Panel$Stock$Details$EditEquipment(
													_Utils_update(
														m,
														{L: 2})))
										}),
									$author$project$Services$Stock$updateEquipmentInStock(
										{
											bh: m.bh,
											ca: m.ca,
											ow: A2($elm$core$Basics$composeR, $author$project$Pages$Panel$Stock$Details$GotUpdateEquipment, $author$project$Pages$Panel$Stock$Details$ModalMsg),
											kw: m.kw,
											kK: m.kK,
											kU: user.kU
										}),
									$author$project$Shared$NoOp);
							} else {
								var errors = _v2;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $elm$core$Maybe$Just(
												$author$project$Pages$Panel$Stock$Details$EditEquipment(
													_Utils_update(
														m,
														{L: 1})))
										}),
									$elm$core$Platform$Cmd$none,
									$author$project$Shared$ShowErrorDialog(
										'Existe campos incorretos no formulário: ' + A2($elm$core$String$join, ', ', errors)));
							}
						case 4:
							var result = _v0.a.a;
							var m = _v0.b.a.a;
							var _v3 = A2(
								$krisajenkins$remotedata$RemoteData$withDefault,
								_Utils_Tuple2(
									_Utils_update(
										model,
										{
											aY: $elm$core$Maybe$Just(
												$author$project$Pages$Panel$Stock$Details$EditEquipment(
													_Utils_update(
														m,
														{L: 0})))
										}),
									$elm$core$Platform$Cmd$none),
								A2(
									$krisajenkins$remotedata$RemoteData$map,
									function (_v4) {
										return _Utils_Tuple2(
											_Utils_update(
												model,
												{aY: $elm$core$Maybe$Nothing}),
											$author$project$Services$Stock$getEquipmentInStock(
												{ow: $author$project$Pages$Panel$Stock$Details$GotDetails, kw: m.kw, kU: user.kU}));
									},
									result));
							var newModel = _v3.a;
							var cmd = _v3.b;
							return _Utils_Tuple3(
								newModel,
								cmd,
								A2(
									$author$project$Shared$remoteDataSharedMsg,
									$elm$core$Maybe$Just('Equipamento Editado!'),
									result));
						default:
							break _v0$7;
					}
				} else {
					switch (_v0.a.$) {
						case 5:
							var _v5 = _v0.a;
							var _v6 = _v0.b.a;
							var serial = _v6.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $elm$core$Maybe$Just(
											A2($author$project$Pages$Panel$Stock$Details$DeleteEquipment, serial, true))
									}),
								$author$project$Services$Stock$deleteEquipmentInStock(
									{
										ow: A2($elm$core$Basics$composeR, $author$project$Pages$Panel$Stock$Details$GotDeleteEquipment, $author$project$Pages$Panel$Stock$Details$ModalMsg),
										kw: serial,
										kU: user.kU
									}),
								$author$project$Shared$NoOp);
						case 6:
							var result = _v0.a.a;
							var _v7 = _v0.b.a;
							var serial = _v7.a;
							var isLoading = _v7.b;
							var _v8 = A2(
								$krisajenkins$remotedata$RemoteData$withDefault,
								_Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $elm$core$Maybe$Just(
												A2($author$project$Pages$Panel$Stock$Details$DeleteEquipment, serial, false))
										}),
									$elm$core$Platform$Cmd$none,
									A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, result)),
								A2(
									$krisajenkins$remotedata$RemoteData$map,
									function (_v9) {
										return _Utils_Tuple3(
											_Utils_update(
												model,
												{aY: $elm$core$Maybe$Nothing}),
											$elm$core$Platform$Cmd$none,
											$author$project$Shared$ShowSuccessDialogWithRedirect(
												{
													lJ: 'Ok',
													pv: $author$project$Route$Panel(
														$author$project$Route$Stock(
															$author$project$Route$List($author$project$Services$Models$initQueriesStock))),
													fD: 'Equipamento excluído com sucesso!'
												}));
									},
									result));
							var newModel = _v8.a;
							var cmd = _v8.b;
							var sharedMsg = _v8.c;
							return _Utils_Tuple3(newModel, cmd, sharedMsg);
						default:
							break _v0$7;
					}
				}
			} else {
				break _v0$7;
			}
		}
		return _Utils_Tuple3(
			model,
			$elm$core$Platform$Cmd$none,
			$author$project$Shared$ShowErrorDialog('Essa MSG não está mapeado'));
	});
var $author$project$Pages$Panel$Stock$Details$update = F4(
	function (msg, model, shared, user) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
			case 1:
				var rdResult = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dE: rdResult}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rdResult));
			case 2:
				var equipment = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aY: $elm$core$Maybe$Just(
								$author$project$Pages$Panel$Stock$Details$EditEquipment(
									$author$project$Pages$Panel$Stock$Details$initEditEquipment(equipment)))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 3:
				var serial = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aY: $elm$core$Maybe$Just(
								A2($author$project$Pages$Panel$Stock$Details$DeleteEquipment, serial, false))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 4:
				return _Utils_Tuple3(
					model,
					A2(
						$author$project$Route$pushUrl,
						shared.nZ,
						$author$project$Route$Panel(
							$author$project$Route$Stock(
								$author$project$Route$List($author$project$Services$Models$initQueriesStock)))),
					$author$project$Shared$NoOp);
			case 5:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aY: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			default:
				var msg_ = msg.a;
				return A4($author$project$Pages$Panel$Stock$Details$updateModal, msg_, model, shared, user);
		}
	});
var $author$project$Pages$Panel$Stock$List$CreateStock = $elm$core$Basics$identity;
var $author$project$Pages$Panel$Stock$List$initCreateStock = {bh: '', z: '', L: 0, bx: '', kw: '', kK: $elm$core$Maybe$Nothing, kY: $elm$core$Maybe$Nothing};
var $author$project$Pages$Panel$Stock$List$GotRegisterEquipment = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Panel$Stock$List$ModalMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Services$Stock$allTypes = _List_fromArray(
	['EB01', 'VALIDATOR']);
var $author$project$Pages$Panel$Stock$List$isInvalid = function (validators) {
	return A2(
		$elm$core$List$filterMap,
		function (_v0) {
			var isInvalid_ = _v0.a;
			var error = _v0.b;
			return isInvalid_ ? $elm$core$Maybe$Just(error) : $elm$core$Maybe$Nothing;
		},
		validators);
};
var $author$project$Pages$Panel$Stock$List$isInvalidInput = F2(
	function (input, validators) {
		return A2(
			$elm$core$List$filterMap,
			function (_v0) {
				var isInvalid_ = _v0.a;
				var error = _v0.b;
				return isInvalid_ ? $elm$core$Maybe$Just(error) : $elm$core$Maybe$Nothing;
			},
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$mapFirst(
					function (isInvalid_) {
						return isInvalid_(input);
					}),
				validators));
	});
var $author$project$Pages$Panel$Stock$List$validatorsBatch = _List_Nil;
var $author$project$Pages$Panel$Stock$List$validatorsDescription = _List_Nil;
var $author$project$Pages$Panel$Stock$List$validatorsPcbID = _List_Nil;
var $author$project$Pages$Panel$Stock$List$validatorsSerial = _List_fromArray(
	[
		_Utils_Tuple2($elm$core$String$isEmpty, 'Serial não pode ser vazio')
	]);
var $author$project$Pages$Panel$Stock$List$validatorsStatus = F2(
	function (maybeValueSelected, options) {
		var getSelected = A2(
			$elm$core$Maybe$andThen,
			function (valueSelected) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						$elm$core$Basics$eq(valueSelected),
						options));
			},
			maybeValueSelected);
		return _List_fromArray(
			[
				_Utils_Tuple2(
				A2(
					$elm$core$Maybe$withDefault,
					true,
					A2(
						$elm$core$Maybe$map,
						function (_v0) {
							return false;
						},
						getSelected)),
				'Status é obrigatório')
			]);
	});
var $author$project$Pages$Panel$Stock$List$validatorsTypes = F2(
	function (maybeValueSelected, options) {
		var getSelected = A2(
			$elm$core$Maybe$andThen,
			function (valueSelected) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						$elm$core$Basics$eq(valueSelected),
						options));
			},
			maybeValueSelected);
		return _List_fromArray(
			[
				_Utils_Tuple2(
				A2(
					$elm$core$Maybe$withDefault,
					true,
					A2(
						$elm$core$Maybe$map,
						function (_v0) {
							return false;
						},
						getSelected)),
				'Tipo é obrigatório')
			]);
	});
var $author$project$Pages$Panel$Stock$List$allValidatorsToSubmitted = function (m) {
	return _Utils_ap(
		$author$project$Pages$Panel$Stock$List$isInvalid(
			A2($author$project$Pages$Panel$Stock$List$validatorsTypes, m.kY, $author$project$Services$Stock$allTypes)),
		_Utils_ap(
			$author$project$Pages$Panel$Stock$List$isInvalid(
				A2($author$project$Pages$Panel$Stock$List$validatorsStatus, m.kK, $author$project$Services$Stock$allStatus)),
			_Utils_ap(
				A2($author$project$Pages$Panel$Stock$List$isInvalidInput, m.bx, $author$project$Pages$Panel$Stock$List$validatorsPcbID),
				_Utils_ap(
					A2($author$project$Pages$Panel$Stock$List$isInvalidInput, m.bh, $author$project$Pages$Panel$Stock$List$validatorsBatch),
					_Utils_ap(
						A2($author$project$Pages$Panel$Stock$List$isInvalidInput, m.z, $author$project$Pages$Panel$Stock$List$validatorsDescription),
						A2($author$project$Pages$Panel$Stock$List$isInvalidInput, m.kw, $author$project$Pages$Panel$Stock$List$validatorsSerial))))));
};
var $author$project$Services$Stock$encodeRegisterEquipment = function (opts) {
	var maybeValue = function (maybeV) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$json$Json$Encode$null,
			A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, maybeV));
	};
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'serialNumber',
				$elm$json$Json$Encode$string(opts.kw)),
				_Utils_Tuple2(
				'status',
				maybeValue(opts.kK)),
				_Utils_Tuple2(
				'type',
				maybeValue(opts.kY)),
				_Utils_Tuple2(
				'observation',
				$elm$json$Json$Encode$string(opts.z)),
				_Utils_Tuple2(
				'batch',
				$elm$json$Json$Encode$string(opts.bh)),
				_Utils_Tuple2(
				'pcbID',
				$elm$json$Json$Encode$string(opts.bx))
			]));
};
var $author$project$Services$Stock$registerEquipment = function (options) {
	return $author$project$Services$Api$postHttp(
		{
			lG: $elm$http$Http$jsonBody(
				$author$project$Services$Stock$encodeRegisterEquipment(options)),
			m9: $author$project$Services$Api$expectWhateverErrorString(
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'stock']),
				_List_Nil)
		});
};
var $author$project$Pages$Panel$Stock$List$updateModal = F3(
	function (msg, model, user) {
		var _v0 = _Utils_Tuple2(msg, model.aY);
		if (!_v0.b.$) {
			switch (_v0.a.$) {
				case 0:
					var newSerial = _v0.a.a;
					var m = _v0.b.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aY: $elm$core$Maybe$Just(
									_Utils_update(
										m,
										{kw: newSerial}))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				case 1:
					var newDescription = _v0.a.a;
					var m = _v0.b.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aY: $elm$core$Maybe$Just(
									_Utils_update(
										m,
										{z: newDescription}))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				case 2:
					var newBatch = _v0.a.a;
					var m = _v0.b.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aY: $elm$core$Maybe$Just(
									_Utils_update(
										m,
										{bh: newBatch}))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				case 3:
					var newPcbID = _v0.a.a;
					var m = _v0.b.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aY: $elm$core$Maybe$Just(
									_Utils_update(
										m,
										{bx: newPcbID}))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				case 4:
					var newStatus = _v0.a.a;
					var m = _v0.b.a;
					var maybeStatus = $elm$core$String$isEmpty(newStatus) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(newStatus);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aY: $elm$core$Maybe$Just(
									_Utils_update(
										m,
										{kK: maybeStatus}))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				case 5:
					var newType = _v0.a.a;
					var m = _v0.b.a;
					var maybeType = $elm$core$String$isEmpty(newType) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(newType);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aY: $elm$core$Maybe$Just(
									_Utils_update(
										m,
										{kY: maybeType}))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				case 6:
					var _v1 = _v0.a;
					var m = _v0.b.a;
					var _v2 = $author$project$Pages$Panel$Stock$List$allValidatorsToSubmitted(m);
					if (!_v2.b) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $elm$core$Maybe$Just(
										_Utils_update(
											m,
											{L: 2}))
								}),
							$author$project$Services$Stock$registerEquipment(
								{
									bh: m.bh,
									z: m.z,
									ow: A2($elm$core$Basics$composeR, $author$project$Pages$Panel$Stock$List$GotRegisterEquipment, $author$project$Pages$Panel$Stock$List$ModalMsg),
									bx: m.bx,
									kw: m.kw,
									kK: m.kK,
									kU: user.kU,
									kY: m.kY
								}),
							$author$project$Shared$NoOp);
					} else {
						var errors = _v2;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $elm$core$Maybe$Just(
										_Utils_update(
											m,
											{L: 1}))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$ShowErrorDialog(
								'Existe campos incorretos no formulário: ' + A2($elm$core$String$join, ', ', errors)));
					}
				default:
					var rdResult = _v0.a.a;
					var m = _v0.b.a;
					var _v3 = A2(
						$krisajenkins$remotedata$RemoteData$withDefault,
						_Utils_Tuple2(
							_Utils_update(
								model,
								{
									aY: $elm$core$Maybe$Just(
										_Utils_update(
											m,
											{L: 0}))
								}),
							$elm$core$Platform$Cmd$none),
						A2(
							$krisajenkins$remotedata$RemoteData$map,
							function (_v4) {
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{aY: $elm$core$Maybe$Nothing}),
									$author$project$Services$Stock$getStock(
										{ow: $author$project$Pages$Panel$Stock$List$GotStock, kw: model.T.kw, kU: user.kU}));
							},
							rdResult));
					var newModel = _v3.a;
					var cmd = _v3.b;
					return _Utils_Tuple3(
						newModel,
						cmd,
						A2(
							$author$project$Shared$remoteDataSharedMsg,
							$elm$core$Maybe$Just('Equipamento cadastrado!'),
							rdResult));
			}
		} else {
			return _Utils_Tuple3(
				model,
				$elm$core$Platform$Cmd$none,
				$author$project$Shared$ShowErrorDialog('Essa MSG não está mapeado'));
		}
	});
var $author$project$Pages$Panel$Stock$List$update = F4(
	function (msg, model, shared, user) {
		var queries = model.T;
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
			case 1:
				var rdStock = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{kL: rdStock}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rdStock));
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aY: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aY: $elm$core$Maybe$Just($author$project$Pages$Panel$Stock$List$initCreateStock)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 5:
				var serial = msg.a;
				return _Utils_Tuple3(
					model,
					A2(
						$author$project$Route$pushUrl,
						shared.nZ,
						$author$project$Route$Panel(
							$author$project$Route$Stock(
								$author$project$Route$Details(serial)))),
					$author$project$Shared$NoOp);
			case 6:
				var newSerial = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{kw: newSerial})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 7:
				return _Utils_Tuple3(
					model,
					A2(
						$author$project$Route$pushUrl,
						shared.nZ,
						$author$project$Route$Panel(
							$author$project$Route$Stock(
								$author$project$Route$List(model.T)))),
					$author$project$Shared$NoOp);
			default:
				var msg_ = msg.a;
				return A3($author$project$Pages$Panel$Stock$List$updateModal, msg_, model, user);
		}
	});
var $author$project$Pages$Panel$UpdateEquipment$UPDATE = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Panel$UpdateEquipment$GotSoftwares = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Panel$UpdateEquipment$ModalMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Services$Device$Software = F7(
	function (id, createdAt, updatedAt, type_, code, file, stable) {
		return {l4: code, ix: createdAt, iS: file, dM: id, pS: stable, kY: type_, qs: updatedAt};
	});
var $author$project$Services$Device$SoftwareFile = F4(
	function (key, name, endpoint, extension) {
		return {m_: endpoint, ng: extension, nZ: key, c3: name};
	});
var $author$project$Services$Device$decodeSoftwareFile = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'extension',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'endpoint',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'key',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Services$Device$SoftwareFile)))));
var $author$project$Services$Device$decodeSoftware = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'stable',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'file',
		$author$project$Services$Device$decodeSoftwareFile,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'code',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'type',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'updatedAt',
					$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'createdAt',
						$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Services$Device$Software))))))));
var $author$project$Services$Device$getSoftwares = function (options) {
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$elm$json$Json$Decode$list($author$project$Services$Device$decodeSoftware)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'device', 'software']),
				_List_Nil)
		});
};
var $author$project$Pages$Panel$UpdateEquipment$initModalUPDATE = function (user) {
	return _Utils_Tuple2(
		{L: 0, cs: '', fw: $krisajenkins$remotedata$RemoteData$Loading},
		$author$project$Services$Device$getSoftwares(
			{
				ow: A2($elm$core$Basics$composeR, $author$project$Pages$Panel$UpdateEquipment$GotSoftwares, $author$project$Pages$Panel$UpdateEquipment$ModalMsg),
				kU: user.kU
			}));
};
var $elm$core$Dict$sizeHelp = F2(
	function (n, dict) {
		sizeHelp:
		while (true) {
			if (dict.$ === -2) {
				return n;
			} else {
				var left = dict.d;
				var right = dict.e;
				var $temp$n = A2($elm$core$Dict$sizeHelp, n + 1, right),
					$temp$dict = left;
				n = $temp$n;
				dict = $temp$dict;
				continue sizeHelp;
			}
		}
	});
var $elm$core$Dict$size = function (dict) {
	return A2($elm$core$Dict$sizeHelp, 0, dict);
};
var $author$project$Pages$Panel$UpdateEquipment$GotUpdateSubmitted = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Panel$UpdateEquipment$UPDATE_SUCCESS = function (a) {
	return {$: 1, a: a};
};
var $author$project$Services$Device$ResultUpdateDevice = F4(
	function (added_devices, failed_devices, message, software_update) {
		return {lj: added_devices, nh: failed_devices, od: message, pN: software_update};
	});
var $author$project$Services$Device$decodeResultUpdateDevice = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'software_update',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'message',
		$elm$json$Json$Decode$string,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'failed_devices',
			$elm$json$Json$Decode$maybe(
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'added_devices',
				$elm$json$Json$Decode$maybe(
					$elm$json$Json$Decode$list(
						A2($elm$json$Json$Decode$field, 'deviceId', $elm$json$Json$Decode$string))),
				$elm$core$Maybe$Nothing,
				$elm$json$Json$Decode$succeed($author$project$Services$Device$ResultUpdateDevice)))));
var $author$project$Services$Device$encodeCreateListOrder = function (options) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'softwareUpdateId',
				$elm$json$Json$Encode$string(options.pM)),
				_Utils_Tuple2(
				'deviceIds',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, options.mI))
			]));
};
var $author$project$Services$Device$postUpdateDevice = function (options) {
	return $author$project$Services$Api$postHttp(
		{
			lG: $elm$http$Http$jsonBody(
				$author$project$Services$Device$encodeCreateListOrder(
					{mI: options.mI, pM: options.pM})),
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$author$project$Services$Device$decodeResultUpdateDevice),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'device', 'softwareUpdate', 'create']),
				_List_Nil)
		});
};
var $author$project$Pages$Panel$UpdateEquipment$updateModal = F3(
	function (user, msg, model) {
		var modal = model.aY;
		var _v0 = _Utils_Tuple2(msg, modal);
		_v0$5:
		while (true) {
			if ((!_v0.b.$) && (!_v0.b.a.$)) {
				switch (_v0.a.$) {
					case 0:
						var rdResult = _v0.a.a;
						var m = _v0.b.a.a;
						var updateM = _Utils_update(
							model,
							{
								aY: $elm$core$Maybe$Just(
									$author$project$Pages$Panel$UpdateEquipment$UPDATE(
										_Utils_update(
											m,
											{fw: rdResult})))
							});
						return _Utils_Tuple3(
							updateM,
							$elm$core$Platform$Cmd$none,
							A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rdResult));
					case 1:
						var newSoftwareID = _v0.a.a;
						var m = _v0.b.a.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $elm$core$Maybe$Just(
										$author$project$Pages$Panel$UpdateEquipment$UPDATE(
											_Utils_update(
												m,
												{cs: newSoftwareID})))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					case 2:
						var _v1 = _v0.a;
						var m = _v0.b.a.a;
						return (m.cs !== '') ? _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $elm$core$Maybe$Just(
										$author$project$Pages$Panel$UpdateEquipment$UPDATE(
											_Utils_update(
												m,
												{L: 2})))
								}),
							$author$project$Services$Device$postUpdateDevice(
								{
									mI: $elm$core$Dict$keys(model.P),
									ow: A2($elm$core$Basics$composeR, $author$project$Pages$Panel$UpdateEquipment$GotUpdateSubmitted, $author$project$Pages$Panel$UpdateEquipment$ModalMsg),
									pM: m.cs,
									kU: user.kU
								}),
							$author$project$Shared$NoOp) : _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $elm$core$Maybe$Just(
										$author$project$Pages$Panel$UpdateEquipment$UPDATE(
											_Utils_update(
												m,
												{L: 1})))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$ShowErrorDialog('Versão do software é obrigatório!'));
					default:
						switch (_v0.a.a.$) {
							case 2:
								var error = _v0.a.a.a;
								var m = _v0.b.a.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $elm$core$Maybe$Just(
												$author$project$Pages$Panel$UpdateEquipment$UPDATE(
													_Utils_update(
														m,
														{L: 0})))
										}),
									$elm$core$Platform$Cmd$none,
									A2(
										$author$project$Shared$remoteDataSharedMsg,
										$elm$core$Maybe$Nothing,
										$krisajenkins$remotedata$RemoteData$Failure(error)));
							case 3:
								var result = _v0.a.a.a;
								var m = _v0.b.a.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $elm$core$Maybe$Just(
												$author$project$Pages$Panel$UpdateEquipment$UPDATE_SUCCESS(result))
										}),
									$elm$core$Platform$Cmd$none,
									$author$project$Shared$NoOp);
							default:
								break _v0$5;
						}
				}
			} else {
				break _v0$5;
			}
		}
		return _Utils_Tuple3(
			model,
			$elm$core$Platform$Cmd$none,
			$author$project$Shared$ShowErrorDialog('Processo de execução está incorreto!'));
	});
var $author$project$Pages$Panel$UpdateEquipment$update = F3(
	function (user, msg, model) {
		switch (msg.$) {
			case 0:
				var rdResult = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{eF: rdResult}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rdResult));
			case 1:
				var device = msg.a;
				var toggleDevice = A2($elm$core$Dict$member, device.dM, model.P) ? A2($elm$core$Dict$remove, device.dM, model.P) : A3($elm$core$Dict$insert, device.dM, device, model.P);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{P: toggleDevice}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 2:
				var devices = msg.a;
				var toggleAllDevice = _Utils_eq(
					$elm$core$Dict$size(model.P),
					$elm$core$List$length(devices)) ? $elm$core$Dict$empty : $elm$core$Dict$fromList(
					A2(
						$elm$core$List$map,
						function (d) {
							return _Utils_Tuple2(d.dM, d);
						},
						devices));
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{P: toggleAllDevice}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 3:
				var _v1 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Pages$Panel$UpdateEquipment$UPDATE,
					$author$project$Pages$Panel$UpdateEquipment$initModalUPDATE(user));
				var initModal = _v1.a;
				var cmd = _v1.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aY: $elm$core$Maybe$Just(initModal)
						}),
					cmd,
					$author$project$Shared$NoOp);
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aY: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			default:
				var msg_ = msg.a;
				return A3($author$project$Pages$Panel$UpdateEquipment$updateModal, user, msg_, model);
		}
	});
var $author$project$Pages$Panel$UpdateRequestsEquipments$DELETE_SUCCESS = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Panel$UpdateRequestsEquipments$GotDeleteUpdateDevice = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Panel$UpdateRequestsEquipments$ModalMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Services$Device$decodeResultDeleteUpdateDevice = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'software_update',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'message',
		$elm$json$Json$Decode$string,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'failed_devices',
			$elm$json$Json$Decode$maybe(
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'deleted_devices',
				$elm$json$Json$Decode$maybe(
					$elm$json$Json$Decode$list(
						A2($elm$json$Json$Decode$field, 'deviceId', $elm$json$Json$Decode$string))),
				$elm$core$Maybe$Nothing,
				$elm$json$Json$Decode$succeed($author$project$Services$Device$ResultUpdateDevice)))));
var $author$project$Services$Device$deleteUpdateDevice = function (options) {
	return $author$project$Services$Api$deleteHttp(
		{
			lG: $elm$http$Http$jsonBody(
				$author$project$Services$Device$encodeCreateListOrder(
					{mI: options.mI, pM: options.pM})),
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$author$project$Services$Device$decodeResultDeleteUpdateDevice),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'device', 'softwareUpdate', 'delete']),
				_List_Nil)
		});
};
var $author$project$Pages$Panel$UpdateRequestsEquipments$updateModal = F3(
	function (msg, model, user) {
		var _v0 = _Utils_Tuple2(msg, model.aY);
		_v0$3:
		while (true) {
			if (!_v0.a.$) {
				if ((!_v0.b.$) && (!_v0.b.a.$)) {
					var _v1 = _v0.a;
					var updateRequest = _v0.b.a.a;
					return _Utils_Tuple3(
						model,
						$author$project$Services$Device$deleteUpdateDevice(
							{
								mI: _List_fromArray(
									[updateRequest.mH]),
								ow: A2($elm$core$Basics$composeL, $author$project$Pages$Panel$UpdateRequestsEquipments$ModalMsg, $author$project$Pages$Panel$UpdateRequestsEquipments$GotDeleteUpdateDevice),
								pM: updateRequest.pL,
								kU: user.kU
							}),
						$author$project$Shared$NoOp);
				} else {
					break _v0$3;
				}
			} else {
				if ((!_v0.b.$) && (!_v0.b.a.$)) {
					switch (_v0.a.a.$) {
						case 2:
							var error = _v0.a.a.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{aY: $elm$core$Maybe$Nothing}),
								$author$project$Services$Device$getUpdateRequests(
									{ow: $author$project$Pages$Panel$UpdateRequestsEquipments$GotUpdateRequests, kU: user.kU}),
								A2(
									$author$project$Shared$remoteDataSharedMsg,
									$elm$core$Maybe$Nothing,
									$krisajenkins$remotedata$RemoteData$Failure(error)));
						case 3:
							var result = _v0.a.a.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $elm$core$Maybe$Just(
											$author$project$Pages$Panel$UpdateRequestsEquipments$DELETE_SUCCESS(result))
									}),
								$author$project$Services$Device$getUpdateRequests(
									{ow: $author$project$Pages$Panel$UpdateRequestsEquipments$GotUpdateRequests, kU: user.kU}),
								$author$project$Shared$NoOp);
						default:
							break _v0$3;
					}
				} else {
					break _v0$3;
				}
			}
		}
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
	});
var $author$project$Pages$Panel$UpdateRequestsEquipments$update = F3(
	function (msg, model, user) {
		switch (msg.$) {
			case 0:
				var rdUpdateRequests = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{fK: rdUpdateRequests}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rdUpdateRequests));
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aY: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 2:
				var newModal = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aY: $elm$core$Maybe$Just(newModal)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			default:
				var msg_ = msg.a;
				return A3($author$project$Pages$Panel$UpdateRequestsEquipments$updateModal, msg_, model, user);
		}
	});
var $author$project$Data$Money$encode = function (_v0) {
	var money = _v0;
	return $elm$json$Json$Encode$int(money);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$encode = A2($elm$core$Basics$composeR, $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime, $elm$json$Json$Encode$string);
var $author$project$Services$Pos$specificInfoDefaultEncoder = function (info) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'routeId',
				$elm$json$Json$Encode$string(info.pw)),
				_Utils_Tuple2(
				'cashierId',
				$elm$json$Json$Encode$string(info.ds)),
				_Utils_Tuple2(
				'direction',
				$elm$json$Json$Encode$int(info.mL)),
				_Utils_Tuple2(
				'sessionId',
				$elm$json$Json$Encode$string(info.pG)),
				_Utils_Tuple2(
				'timestamp',
				$rtfeldman$elm_iso8601_date_strings$Iso8601$encode(info.p6)),
				_Utils_Tuple2(
				'operatorId',
				$elm$json$Json$Encode$string(info.oD)),
				_Utils_Tuple2(
				'openingCounter',
				$elm$json$Json$Encode$int(info.oC)),
				_Utils_Tuple2(
				'firmwareVersion',
				$elm$json$Json$Encode$string(info.nr)),
				_Utils_Tuple2(
				'preOpeningCounter',
				$elm$json$Json$Encode$int(info.o3))
			]));
};
var $author$project$Services$Pos$specificInfoEncoder = function (info) {
	if (!info.$) {
		var defaultInfo = info.a;
		return $author$project$Services$Pos$specificInfoDefaultEncoder(defaultInfo);
	} else {
		return $elm$json$Json$Encode$object(_List_Nil);
	}
};
var $author$project$Services$Pos$closeCashierPayloadEncoder = function (payload) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'concessionaireId',
				$elm$json$Json$Encode$string(payload.mc)),
				_Utils_Tuple2(
				'cashierId',
				$elm$json$Json$Encode$string(payload.ds)),
				_Utils_Tuple2(
				'balance',
				$author$project$Data$Money$encode(payload.h2)),
				_Utils_Tuple2(
				'specificInfo',
				$author$project$Services$Pos$specificInfoEncoder(payload.nP))
			]));
};
var $author$project$Services$Pos$closePos = F3(
	function (_v0, payload, processRequest) {
		var token = _v0.kU;
		return $elm$http$Http$request(
			{
				lG: $elm$http$Http$jsonBody(
					$author$project$Services$Pos$closeCashierPayloadEncoder(payload)),
				m9: A2(
					$author$project$Services$Api$expectJson,
					processRequest,
					A2($elm$json$Json$Decode$field, 'closedAt', $elm_community$json_extra$Json$Decode$Extra$datetime)),
				nG: _List_fromArray(
					[
						$author$project$Services$Api$authorizationHeader(token)
					]),
				of: 'POST',
				p5: $elm$core$Maybe$Nothing,
				qi: $elm$core$Maybe$Nothing,
				qt: A2(
					$author$project$Constants$cashierServiceUrl,
					_List_fromArray(
						['api', 'v1', 'cashier', 'close']),
					_List_Nil)
			});
	});
var $author$project$Pages$Pos$CloseCashier$SetClosingTimestamp = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Pos$CloseCashier$handlePosClosing = function (result) {
	if (!result.$) {
		var timestamp = result.a;
		return $author$project$Pages$Pos$CloseCashier$SetClosingTimestamp(timestamp);
	} else {
		return $author$project$Pages$Pos$CloseCashier$NoOp;
	}
};
var $author$project$Pages$Pos$CloseCashier$closeCashierCmd = F2(
	function (model, user) {
		var cashierInfo = {h2: model.cl.gb.qc, ds: model.ds, mc: model.mc, nP: model.fx};
		return A3($author$project$Services$Pos$closePos, user, cashierInfo, $author$project$Pages$Pos$CloseCashier$handlePosClosing);
	});
var $author$project$Pages$Pos$CloseCashier$handleModel = F2(
	function (receivedModel, model) {
		var newModel = {h2: receivedModel.h2, ds: receivedModel.ds, f4: receivedModel.f4, l2: receivedModel.l2, mc: receivedModel.mc, e6: model.e6, g3: receivedModel.g3, jL: receivedModel.jL, cl: receivedModel.cl, fx: receivedModel.fx};
		return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
	});
var $author$project$Pages$Pos$CloseCashier$update = F4(
	function (msg, model, shared, user) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(
					model,
					A2($author$project$Pages$Pos$CloseCashier$closeCashierCmd, model, user),
					$author$project$Shared$NoOp);
			case 2:
				var timestamp = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							l2: $elm$core$Maybe$Just(timestamp),
							e6: true
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 1:
				var receivedModel = msg.a;
				return A2($author$project$Pages$Pos$CloseCashier$handleModel, receivedModel, model);
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
		}
	});
var $author$project$Pages$Pos$Edit$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Pos$Editor$CameraReady = {$: 2};
var $author$project$Pages$Pos$Editor$DocumentImageBack = 3;
var $author$project$Pages$Pos$Editor$DocumentImageFront = 2;
var $author$project$Pages$Pos$Editor$EditClasses = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Pos$Editor$EditPhone = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Pos$Editor$Editing = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Pos$Editor$FaceImage = 1;
var $author$project$Pages$Pos$Editor$GotAdressInfo = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Pos$Editor$GotClasses = function (a) {
	return {$: 26, a: a};
};
var $author$project$Pages$Pos$Editor$GotNewPhone = function (a) {
	return {$: 27, a: a};
};
var $author$project$Pages$Pos$Editor$GotPassengerFullNewPhone = function (a) {
	return {$: 25, a: a};
};
var $author$project$Pages$Pos$Editor$GotPhoto = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Pos$Editor$GotPhotoPreview = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Pos$Editor$Load = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Pos$Editor$LoadReader = {$: 1};
var $author$project$Pages$Pos$Editor$PhotoTaken = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Pos$Editor$PhotoUploaded = function (a) {
	return {$: 1, a: a};
};
var $elm$file$File$decoder = _File_decoder;
var $author$project$Pages$Pos$Editor$cameraDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A3(
			$elm$json$Json$Decode$map2,
			F2(
				function (p, f) {
					return $elm$core$Result$Ok(
						{iS: f, cg: p});
				}),
			A2($elm$json$Json$Decode$field, 'preview', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'file', $elm$file$File$decoder)),
			A2(
			$elm$json$Json$Decode$map,
			$elm$core$Result$Err,
			A2($elm$json$Json$Decode$field, 'error', $elm$json$Json$Decode$string))
		]));
var $author$project$Pages$Pos$Editor$canSubmitPhoto = F2(
	function (photo, model) {
		return (!_Utils_eq(model.j, $elm$core$Maybe$Nothing)) || function () {
			switch (photo.$) {
				case 1:
					return true;
				case 3:
					return true;
				default:
					return false;
			}
		}();
	});
var $author$project$Utils$formatDate = A2(
	$elm$core$Basics$composeR,
	$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$Result$withDefault(
			$elm$time$Time$millisToPosix(0)),
		A2(
			$ryan_haskell$date_format$DateFormat$format,
			_List_fromArray(
				[
					$ryan_haskell$date_format$DateFormat$dayOfMonthFixed,
					$ryan_haskell$date_format$DateFormat$text('/'),
					$ryan_haskell$date_format$DateFormat$monthFixed,
					$ryan_haskell$date_format$DateFormat$text('/'),
					$ryan_haskell$date_format$DateFormat$yearNumber
				]),
			$elm$time$Time$utc)));
var $author$project$Pages$Pos$Editor$initEditClassesModel = F2(
	function (timezone, card) {
		var takeClasses = $elm$core$Dict$fromList(
			$elm$core$List$concat(
				A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.dv;
						},
						$elm$core$List$map(
							function (c) {
								return _Utils_Tuple2(c.dM, c.qn);
							})),
					card.hO)));
		return {
			cH: card,
			dv: takeClasses,
			am: card.nb,
			a6: $author$project$Pages$Pos$Editor$Editing(0)
		};
	});
var $author$project$Pages$Pos$Editor$initEditPhoneModel = function (p) {
	return {b9: p.oe.jX, j: p, kK: 0};
};
var $justinmimbs$date$Date$toMonths = function (rd) {
	var date = $justinmimbs$date$Date$toCalendarDate(rd);
	var wholeMonths = (12 * (date.cF - 1)) + ($justinmimbs$date$Date$monthToNumber(date.b8) - 1);
	return wholeMonths + (date.dC / 100);
};
var $justinmimbs$date$Date$diff = F3(
	function (unit, _v0, _v1) {
		var rd1 = _v0;
		var rd2 = _v1;
		switch (unit) {
			case 0:
				return ((($justinmimbs$date$Date$toMonths(rd2) - $justinmimbs$date$Date$toMonths(rd1)) | 0) / 12) | 0;
			case 1:
				return ($justinmimbs$date$Date$toMonths(rd2) - $justinmimbs$date$Date$toMonths(rd1)) | 0;
			case 2:
				return ((rd2 - rd1) / 7) | 0;
			default:
				return rd2 - rd1;
		}
	});
var $author$project$Pages$Pos$Editor$isInvalidDueDate = function (dueDate) {
	return A2(
		$elm$core$Result$withDefault,
		true,
		A3(
			$elm$core$Result$map2,
			F2(
				function (dueDate_, dateLimit) {
					return A3($justinmimbs$date$Date$diff, 3, dueDate_, dateLimit) < 0;
				}),
			$justinmimbs$date$Date$fromIsoString(
				A2($elm$core$Maybe$withDefault, '', dueDate)),
			$justinmimbs$date$Date$fromIsoString('2148-12-31')));
};
var $author$project$Pages$Pos$Editor$isInvalidForm = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Result$Ok(0),
		A2(
			$elm$core$Maybe$map,
			$elm$core$Result$Err,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$second,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						$elm$core$Tuple$first,
						_List_fromArray(
							[
								_Utils_Tuple2(model.c3 === '', 'Preencha o nome'),
								_Utils_Tuple2(model.iI === '', 'Preencha o CPF'),
								_Utils_Tuple2(
								!$author$project$Validate$Cpf$isValid(model.iI),
								'CPF inválido'),
								_Utils_Tuple2(
								(model.mX !== '') && (!$author$project$Utils$isValidEmail(model.mX)),
								'Email inválido'),
								_Utils_Tuple2(model.o0 === '', 'Preencha o CEP'),
								_Utils_Tuple2(
								$elm$core$String$length(model.o0) !== 8,
								'Preencha um CEP válido'),
								_Utils_Tuple2(model.ep === '', 'Preencha o endereço'),
								_Utils_Tuple2(model.bL === '', 'Preencha o número do endereço'),
								_Utils_Tuple2(model.om === '', 'Preencha o bairro'),
								_Utils_Tuple2(model.lW === '', 'Preencha a cidade'),
								_Utils_Tuple2(model.bd === '', 'Preencha a UF'),
								_Utils_Tuple2(
								$elm$core$Dict$isEmpty(model.B),
								'Selecione o tipo de cadastro'),
								function () {
								var _v0 = model.dv;
								if (_v0.$ === 3) {
									var classes = _v0.a;
									return A2(
										$elm$core$Maybe$withDefault,
										_Utils_Tuple2(false, ''),
										$elm$core$List$head(
											A2(
												$elm$core$List$filterMap,
												function (_v1) {
													var classId = _v1.a;
													var maybeTypeId = _v1.b;
													return A2(
														$elm$core$Maybe$andThen,
														function (_class) {
															if ($elm$core$List$isEmpty(_class.dh)) {
																return $elm$core$Maybe$Nothing;
															} else {
																if (maybeTypeId.$ === 1) {
																	return $elm$core$Maybe$Just(
																		_Utils_Tuple2(true, 'Selecione um tipo para a classe ' + _class.c3));
																} else {
																	return $elm$core$Maybe$Nothing;
																}
															}
														},
														$elm$core$List$head(
															A2(
																$elm$core$List$filter,
																A2(
																	$elm$core$Basics$composeR,
																	function ($) {
																		return $.dM;
																	},
																	$elm$core$Basics$eq(classId)),
																classes)));
												},
												$elm$core$Dict$toList(model.B))));
								} else {
									return _Utils_Tuple2(false, '');
								}
							}()
							]))))));
};
var $author$project$Pages$Pos$Editor$isInvalidNewPhone = function (num) {
	return 11 !== $elm$core$String$length(
		A2($elm$core$String$filter, $elm$core$Char$isDigit, num));
};
var $author$project$Services$Passenger$encodePutClasses = F2(
	function (classes, expiration) {
		var encodeClasse = A2(
			$elm$core$List$map,
			function (_v0) {
				var _class = _v0.a;
				var maybeClassType = _v0.b;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						'walletClassID',
						$elm$json$Json$Encode$string(_class)),
					function () {
						if (maybeClassType.$ === 1) {
							return _List_Nil;
						} else {
							var classType = maybeClassType.a;
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'walletClassTypeID',
									$elm$json$Json$Encode$string(classType))
								]);
						}
					}());
			},
			classes);
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'expiration',
					$elm$json$Json$Encode$string(expiration)),
					_Utils_Tuple2(
					'classes',
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$object, encodeClasse))
				]));
	});
var $author$project$Services$Passenger$putClasses = function (options) {
	return $author$project$Services$Api$putHttp(
		{
			lG: $elm$http$Http$jsonBody(
				A2($author$project$Services$Passenger$encodePutClasses, options.dv, options.na)),
			m9: $author$project$Services$Api$expectWhateverErrorString(
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'passenger', options.hd, 'classes']),
				_List_Nil)
		});
};
var $author$project$Services$Passenger$putPhone = function (options) {
	return $author$project$Services$Api$putHttp(
		{
			lG: $elm$http$Http$jsonBody(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'phone',
							$elm$json$Json$Encode$int(options.b9))
						]))),
			m9: $author$project$Services$Api$expectWhateverErrorString(
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'user', options.hd, 'changePhone']),
				_List_Nil)
		});
};
var $author$project$Pages$Pos$Editor$setPhoto = F2(
	function (photo, model) {
		var _v0 = model.hG;
		switch (_v0) {
			case 0:
				return model;
			case 1:
				return _Utils_update(
					model,
					{bn: photo});
			case 2:
				return _Utils_update(
					model,
					{bj: photo});
			default:
				return _Utils_update(
					model,
					{bi: photo});
		}
	});
var $elm$file$File$size = _File_size;
var $author$project$Pages$Pos$Editor$GotSubmitResponse = function (a) {
	return {$: 11, a: a};
};
var $author$project$Services$Passenger$newEdit = F2(
	function (maybeId, options) {
		var maybeAddString = F3(
			function (key, maybeContent, acc) {
				if (maybeContent.$ === 1) {
					return acc;
				} else {
					var str = maybeContent.a;
					return A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							key,
							$elm$json$Json$Encode$string(str)),
						acc);
				}
			});
		var parts = $elm$json$Json$Encode$object(
			A3(
				maybeAddString,
				'faceImage',
				options.bn,
				A3(
					maybeAddString,
					'documentImageBack',
					options.bi,
					A3(
						maybeAddString,
						'documentImageFront',
						options.bj,
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(options.c3)),
								_Utils_Tuple2(
								'document',
								$elm$json$Json$Encode$string(options.iI)),
								_Utils_Tuple2(
								'documentType',
								$elm$json$Json$Encode$string('cpf')),
								_Utils_Tuple2(
								'email',
								$elm$json$Json$Encode$string(options.mX)),
								_Utils_Tuple2(
								'address',
								$elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'zipCode',
											$elm$json$Json$Encode$string(options.ep.qT)),
											_Utils_Tuple2(
											'street',
											$elm$json$Json$Encode$string(options.ep.pU)),
											_Utils_Tuple2(
											'number',
											$elm$json$Json$Encode$string(options.ep.op)),
											_Utils_Tuple2(
											'complement',
											$elm$json$Json$Encode$string(options.ep.l9)),
											_Utils_Tuple2(
											'neighborhood',
											$elm$json$Json$Encode$string(options.ep.om)),
											_Utils_Tuple2(
											'city',
											$elm$json$Json$Encode$string(options.ep.lW)),
											_Utils_Tuple2(
											'state',
											$elm$json$Json$Encode$string(options.ep.fy)),
											_Utils_Tuple2(
											'country',
											$elm$json$Json$Encode$string('Brasil'))
										]))),
								_Utils_Tuple2(
								'classes',
								A2(
									$elm$json$Json$Encode$list,
									$elm$json$Json$Encode$object,
									A2(
										$elm$core$List$map,
										function (_v5) {
											var _class = _v5.a;
											var maybeClassType = _v5.b;
											return A2(
												$elm$core$List$cons,
												_Utils_Tuple2(
													'walletClassID',
													$elm$json$Json$Encode$string(_class)),
												function () {
													if (maybeClassType.$ === 1) {
														return _List_Nil;
													} else {
														var classType = maybeClassType.a;
														return _List_fromArray(
															[
																_Utils_Tuple2(
																'walletClassTypeID',
																$elm$json$Json$Encode$string(classType))
															]);
													}
												}());
										},
										options.dv)))
							])))));
		var partsCreate = $elm$json$Json$Encode$object(
			A3(
				maybeAddString,
				'faceImage',
				options.bn,
				A3(
					maybeAddString,
					'documentImageBack',
					options.bi,
					A3(
						maybeAddString,
						'documentImageFront',
						options.bj,
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(options.c3)),
								_Utils_Tuple2(
								'document',
								$elm$json$Json$Encode$string(options.iI)),
								_Utils_Tuple2(
								'documentType',
								$elm$json$Json$Encode$string('cpf')),
								_Utils_Tuple2(
								'email',
								$elm$json$Json$Encode$string(options.mX)),
								_Utils_Tuple2(
								'zipCode',
								$elm$json$Json$Encode$string(options.ep.qT)),
								_Utils_Tuple2(
								'street',
								$elm$json$Json$Encode$string(options.ep.pU)),
								_Utils_Tuple2(
								'number',
								$elm$json$Json$Encode$string(options.ep.op)),
								_Utils_Tuple2(
								'complement',
								$elm$json$Json$Encode$string(options.ep.l9)),
								_Utils_Tuple2(
								'neighborhood',
								$elm$json$Json$Encode$string(options.ep.om)),
								_Utils_Tuple2(
								'city',
								$elm$json$Json$Encode$string(options.ep.lW)),
								_Utils_Tuple2(
								'state',
								$elm$json$Json$Encode$string(options.ep.fy)),
								_Utils_Tuple2(
								'country',
								$elm$json$Json$Encode$string('Brasil')),
								_Utils_Tuple2(
								'classes',
								A2(
									$elm$json$Json$Encode$list,
									$elm$json$Json$Encode$object,
									A2(
										$elm$core$List$map,
										function (_v3) {
											var _class = _v3.a;
											var maybeClassType = _v3.b;
											return A2(
												$elm$core$List$cons,
												_Utils_Tuple2(
													'walletClassID',
													$elm$json$Json$Encode$string(_class)),
												function () {
													if (maybeClassType.$ === 1) {
														return _List_Nil;
													} else {
														var classType = maybeClassType.a;
														return _List_fromArray(
															[
																_Utils_Tuple2(
																'walletClassTypeID',
																$elm$json$Json$Encode$string(classType))
															]);
													}
												}());
										},
										options.dv)))
							])))));
		var decoder = A2(
			$elm$json$Json$Decode$map,
			function (id) {
				return {dM: id};
			},
			A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string));
		var _v0 = function () {
			if (maybeId.$ === 1) {
				return _Utils_Tuple2('POST', _List_Nil);
			} else {
				var id = maybeId.a;
				return _Utils_Tuple2(
					'PUT',
					_List_fromArray(
						[id]));
			}
		}();
		var method = _v0.a;
		var finalPath = _v0.b;
		return $elm$http$Http$request(
			{
				lG: $elm$http$Http$jsonBody(parts),
				m9: A2($author$project$Services$Api$expectJson, options.ow, decoder),
				nG: _List_fromArray(
					[
						$author$project$Services$Api$authorizationHeader(options.kU)
					]),
				of: method,
				p5: $elm$core$Maybe$Nothing,
				qi: $elm$core$Maybe$Nothing,
				qt: function () {
					if (maybeId.$ === 1) {
						return A2(
							$author$project$Constants$apiV2,
							_List_fromArray(
								['api', 'passenger', 'fromWeb']),
							_List_Nil);
					} else {
						var id = maybeId.a;
						return A2(
							$author$project$Constants$apiV2,
							_List_fromArray(
								['api', 'passenger', 'fromWeb', id]),
							_List_Nil);
					}
				}()
			});
	});
var $author$project$Services$Passenger$edit = function (passengerId) {
	return $author$project$Services$Passenger$newEdit(
		$elm$core$Maybe$Just(passengerId));
};
var $author$project$Services$Passenger$new = $author$project$Services$Passenger$newEdit($elm$core$Maybe$Nothing);
var $author$project$Pages$Pos$Editor$submit = F2(
	function (user, model) {
		var getPhoto = function (photo) {
			switch (photo.$) {
				case 1:
					var photo_ = photo.a;
					return $elm$core$Maybe$Just(photo_);
				case 3:
					var photo_ = photo.a;
					return $elm$core$Maybe$Just(photo_);
				default:
					return $elm$core$Maybe$Nothing;
			}
		};
		var body = {
			ep: {lW: model.lW, l9: model.lk, om: model.om, op: model.bL, fy: model.bd, pU: model.ep, qT: model.o0},
			dv: $elm$core$Dict$toList(model.B),
			iI: model.iI,
			bi: A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.cg;
				},
				getPhoto(model.bi)),
			bj: A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.cg;
				},
				getPhoto(model.bj)),
			mX: model.mX,
			bn: A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.cg;
				},
				getPhoto(model.bn)),
			c3: model.c3,
			ow: $author$project$Pages$Pos$Editor$GotSubmitResponse,
			kU: user.kU
		};
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{q: $krisajenkins$remotedata$RemoteData$Loading}),
			function () {
				var _v0 = model.j;
				if (_v0.$ === 1) {
					return $author$project$Services$Passenger$new(body);
				} else {
					var passenger = _v0.a;
					return A2($author$project$Services$Passenger$edit, passenger.oe.dM, body);
				}
			}(),
			$author$project$Shared$CloseDialog);
	});
var $author$project$Pages$Pos$Editor$takePhoto = _Platform_outgoingPort('takePhoto', $elm$json$Json$Encode$string);
var $elm$file$File$toUrl = _File_toUrl;
var $author$project$Ports$updateCard = _Platform_outgoingPort(
	'updateCard',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'classes',
					$elm$json$Json$Encode$list($elm$json$Json$Encode$int)($.dv)),
					_Utils_Tuple2(
					'validity',
					$elm$json$Json$Encode$string($.qC))
				]));
	});
var $author$project$Pages$Pos$Editor$useCamera = _Platform_outgoingPort('useCamera', $elm$json$Json$Encode$string);
var $author$project$Pages$Pos$Editor$videoElemId = 'user-editor-video';
var $author$project$Pages$Pos$Editor$update = F4(
	function (msg, model, shared, user) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
			case 1:
				var classes = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							dv: $krisajenkins$remotedata$RemoteData$fromResult(classes)
						}),
					$elm$core$Platform$Cmd$none,
					function () {
						if (classes.$ === 1) {
							var error = classes.a;
							return A2($author$project$Shared$updateApiError, shared, error);
						} else {
							return $author$project$Shared$NoOp;
						}
					}());
			case 2:
				var input = msg.a;
				var newModel = function () {
					switch (input.$) {
						case 0:
							var value = input.a;
							return _Utils_update(
								model,
								{c3: value});
						case 1:
							var value = input.a;
							return _Utils_update(
								model,
								{iI: value});
						case 2:
							var value = input.a;
							return _Utils_update(
								model,
								{mX: value});
						case 3:
							var value = input.a;
							return _Utils_update(
								model,
								{o0: value});
						case 4:
							var value = input.a;
							return _Utils_update(
								model,
								{ep: value});
						case 5:
							var value = input.a;
							return _Utils_update(
								model,
								{bL: value});
						case 6:
							var value = input.a;
							return _Utils_update(
								model,
								{lk: value});
						case 7:
							var value = input.a;
							return _Utils_update(
								model,
								{om: value});
						case 8:
							var value = input.a;
							return _Utils_update(
								model,
								{lW: value});
						case 9:
							var value = input.a;
							return _Utils_update(
								model,
								{bd: value});
						case 10:
							var value = input.a;
							return _Utils_update(
								model,
								{oN: value});
						default:
							var value = input.a;
							return _Utils_update(
								model,
								{c6: value});
					}
				}();
				var cmd = function () {
					if (input.$ === 3) {
						var postalCode = input.a;
						return ($elm$core$String$length(postalCode) === 8) ? A2($author$project$Services$Cep$get, postalCode, $author$project$Pages$Pos$Editor$GotAdressInfo) : $elm$core$Platform$Cmd$none;
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return _Utils_Tuple3(newModel, cmd, $author$project$Shared$NoOp);
			case 3:
				if (!msg.a.$) {
					if (!msg.a.a.$) {
						var viaCepResponse = msg.a.a.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{ep: viaCepResponse.pU, bd: viaCepResponse.fy, lW: viaCepResponse.n5, om: viaCepResponse.om}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					} else {
						var _v4 = msg.a.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$ShowErrorDialog('CEP não encontrado'));
					}
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ep: '', lW: '', om: ''}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$ShowErrorDialog(
							$author$project$Services$Api$errorToUserMessage(error)));
				}
			case 4:
				var classId = msg.a;
				var checked = msg.b;
				var _v5 = _Utils_Tuple2(model.aY, model.dv);
				_v5$2:
				while (true) {
					if (!_v5.a.$) {
						if (!_v5.a.a.$) {
							var modal = _v5.a.a.a;
							var newClasses = function () {
								if (checked) {
									var maybeTypeId = function () {
										var _v8 = model.dv;
										if (_v8.$ === 3) {
											var classes = _v8.a;
											return A2(
												$elm$core$Maybe$andThen,
												function (c) {
													var _v9 = c.dh;
													if (_v9.b) {
														var single = _v9.a;
														return $elm$core$Maybe$Just(single.dM);
													} else {
														return $elm$core$Maybe$Nothing;
													}
												},
												$elm$core$List$head(
													A2(
														$elm$core$List$filter,
														function (c) {
															return _Utils_eq(c.dM, classId);
														},
														classes)));
										} else {
											return $elm$core$Maybe$Nothing;
										}
									}();
									return A3($elm$core$Dict$insert, classId, maybeTypeId, modal.dv);
								} else {
									return A2($elm$core$Dict$remove, classId, modal.dv);
								}
							}();
							var totalSelected = function () {
								var _v6 = model.dv;
								if (_v6.$ === 3) {
									var classes = _v6.a;
									return $elm$core$List$length(
										A2(
											$elm$core$List$filter,
											function (class_) {
												var _v7 = A2($elm$core$Dict$get, class_.dM, newClasses);
												if (!_v7.$) {
													return true;
												} else {
													return false;
												}
											},
											classes));
								} else {
									return 0;
								}
							}();
							return ((totalSelected >= 1) && (totalSelected <= 4)) ? _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $elm$core$Maybe$Just(
											$author$project$Pages$Pos$Editor$EditClasses(
												_Utils_update(
													modal,
													{dv: newClasses})))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp) : ((totalSelected < 1) ? _Utils_Tuple3(
								model,
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$ShowErrorDialog('É necessário selecionar pelo menos uma classe!')) : _Utils_Tuple3(
								model,
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$ShowErrorDialog('Você pode selecionar até quatro classes.')));
						} else {
							break _v5$2;
						}
					} else {
						if (_v5.b.$ === 3) {
							var _v10 = _v5.a;
							var classes = _v5.b.a;
							var newClasses = function () {
								if (checked) {
									var maybeTypeId = A2(
										$elm$core$Maybe$andThen,
										function (c) {
											var _v12 = c.dh;
											if (_v12.b) {
												var single = _v12.a;
												return $elm$core$Maybe$Just(single.dM);
											} else {
												return $elm$core$Maybe$Nothing;
											}
										},
										$elm$core$List$head(
											A2(
												$elm$core$List$filter,
												function (c) {
													return _Utils_eq(c.dM, classId);
												},
												classes)));
									return A3($elm$core$Dict$insert, classId, maybeTypeId, model.B);
								} else {
									return A2($elm$core$Dict$remove, classId, model.B);
								}
							}();
							var totalSelected = $elm$core$List$length(
								A2(
									$elm$core$List$filter,
									function (class_) {
										var _v11 = A2($elm$core$Dict$get, class_.dM, newClasses);
										if (!_v11.$) {
											return true;
										} else {
											return false;
										}
									},
									classes));
							return ((totalSelected >= 1) && (totalSelected <= 4)) ? _Utils_Tuple3(
								_Utils_update(
									model,
									{B: newClasses}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp) : ((totalSelected < 1) ? _Utils_Tuple3(
								model,
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$ShowErrorDialog('É necessário selecionar pelo menos uma classe!')) : _Utils_Tuple3(
								model,
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$ShowErrorDialog('Você pode selecionar até quatro classes.')));
						} else {
							break _v5$2;
						}
					}
				}
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$ShowErrorDialog('Algo deu errado!'));
			case 5:
				var classId = msg.a;
				var typeId = msg.b;
				var _v13 = model.aY;
				if (!_v13.$) {
					if (!_v13.a.$) {
						var modal = _v13.a.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $elm$core$Maybe$Just(
										$author$project$Pages$Pos$Editor$EditClasses(
											_Utils_update(
												modal,
												{
													dv: A3(
														$elm$core$Dict$insert,
														classId,
														$elm$core$Maybe$Just(typeId),
														modal.dv)
												})))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
					}
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								B: A3(
									$elm$core$Dict$insert,
									classId,
									$elm$core$Maybe$Just(typeId),
									model.B)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				}
			case 6:
				var _v14 = model.hG;
				switch (_v14) {
					case 0:
						var _v15 = $author$project$Pages$Pos$Editor$isInvalidForm(model);
						if (!_v15.$) {
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{hG: 1}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$CloseDialog);
						} else {
							var error = _v15.a;
							return _Utils_Tuple3(
								model,
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$ShowErrorDialog(error));
						}
					case 1:
						return A2($author$project$Pages$Pos$Editor$canSubmitPhoto, model.bn, model) ? _Utils_Tuple3(
							_Utils_update(
								model,
								{hG: 2}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$CloseDialog) : _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$ShowErrorDialog('Anexe a foto do usuário'));
					case 2:
						return A2($author$project$Pages$Pos$Editor$canSubmitPhoto, model.bj, model) ? _Utils_Tuple3(
							_Utils_update(
								model,
								{hG: 3}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$CloseDialog) : _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$ShowErrorDialog('Anexe os documentos'));
					default:
						return A2($author$project$Pages$Pos$Editor$canSubmitPhoto, model.bi, model) ? (((!$krisajenkins$remotedata$RemoteData$isSuccess(model.q)) && (!$krisajenkins$remotedata$RemoteData$isLoading(model.q))) ? A2($author$project$Pages$Pos$Editor$submit, user, model) : _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp)) : _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$ShowErrorDialog('Anexe os documentos'));
				}
			case 7:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							hG: function () {
								var _v16 = model.hG;
								switch (_v16) {
									case 0:
										return 0;
									case 1:
										return 0;
									case 2:
										return 1;
									default:
										return 2;
								}
							}()
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$CloseDialog);
			case 8:
				return _Utils_Tuple3(
					model,
					A2(
						$elm$file$File$Select$file,
						_List_fromArray(
							['image/*']),
						$author$project$Pages$Pos$Editor$GotPhoto),
					$author$project$Shared$NoOp);
			case 9:
				var file = msg.a;
				return ($elm$file$File$size(file) > 260000) ? _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$ShowErrorDialog('Oops! Parece que a imagem selecionada é muito grande. Por favor, reduza o tamanho da imagem para menos de 250KB antes de carregá-la novamente.')) : _Utils_Tuple3(
					model,
					A2(
						$elm$core$Task$perform,
						$author$project$Pages$Pos$Editor$GotPhotoPreview,
						A2(
							$elm$core$Task$map,
							function (preview) {
								return {iS: file, cg: preview};
							},
							$elm$file$File$toUrl(file))),
					$author$project$Shared$NoOp);
			case 10:
				var photo = msg.a;
				return _Utils_Tuple3(
					A2(
						$author$project$Pages$Pos$Editor$setPhoto,
						$author$project$Pages$Pos$Editor$PhotoUploaded(photo),
						model),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 11:
				var res = msg.a;
				if (!res.$) {
					var id = res.a.dM;
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						function () {
							var _v18 = model.j;
							if (_v18.$ === 1) {
								return $author$project$Shared$Batch(
									_List_fromArray(
										[
											$author$project$Shared$ShowSuccessDialogWithRedirect(
											{
												lJ: 'Ir para Emissão de Cartão',
												pv: A2($author$project$Route$Passenger, id, 4),
												fD: 'Cadastro Realizado com sucesso!'
											}),
											$author$project$Shared$RedirectPreserve(
											A2($author$project$Route$Passenger, id, 0))
										]));
							} else {
								var oldPassenger = _v18.a;
								var oldPassengerClasses = $elm$core$Dict$fromList(
									$elm$core$List$concat(
										A2(
											$elm$core$List$map,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.dv;
												},
												$elm$core$List$map(
													function (c) {
														return _Utils_Tuple2(c.dM, c.qn);
													})),
											oldPassenger.hO)));
								var hasClassesChanged = !_Utils_eq(model.B, oldPassengerClasses);
								return $author$project$Shared$Batch(
									_List_fromArray(
										[
											$author$project$Shared$ShowSuccessDialog('Cadastro Atualizado com sucesso!'),
											$author$project$Shared$RedirectPreserve(
											A2($author$project$Route$Passenger, id, 0))
										]));
							}
						}());
				} else {
					var error = res.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								q: $krisajenkins$remotedata$RemoteData$Failure(error)
							}),
						$elm$core$Platform$Cmd$none,
						A2($author$project$Shared$updateApiError, shared, error));
				}
			case 12:
				return _Utils_Tuple3(
					A2($author$project$Pages$Pos$Editor$setPhoto, $author$project$Pages$Pos$Editor$CameraReady, model),
					$author$project$Pages$Pos$Editor$useCamera($author$project$Pages$Pos$Editor$videoElemId),
					$author$project$Shared$NoOp);
			case 13:
				return _Utils_Tuple3(
					model,
					$author$project$Pages$Pos$Editor$takePhoto($author$project$Pages$Pos$Editor$videoElemId),
					$author$project$Shared$NoOp);
			case 14:
				var val = msg.a;
				var _v19 = A2(
					$elm$core$Result$andThen,
					$elm$core$Basics$identity,
					A2(
						$elm$core$Result$mapError,
						$elm$json$Json$Decode$errorToString,
						A2($elm$json$Json$Decode$decodeValue, $author$project$Pages$Pos$Editor$cameraDecoder, val)));
				if (!_v19.$) {
					var photo = _v19.a;
					return _Utils_Tuple3(
						A2(
							$author$project$Pages$Pos$Editor$setPhoto,
							$author$project$Pages$Pos$Editor$PhotoTaken(photo),
							model),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				} else {
					var errorMessage = _v19.a;
					return _Utils_Tuple3(
						A2($author$project$Pages$Pos$Editor$setPhoto, $author$project$Pages$Pos$Editor$NoPhoto, model),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$ShowErrorDialog(errorMessage));
				}
			case 15:
				return _Utils_Tuple3(
					A2($author$project$Pages$Pos$Editor$setPhoto, $author$project$Pages$Pos$Editor$NoPhoto, model),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 16:
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$ShowErrorDialog('Algo deu errado!')),
					A2(
						$elm$core$Maybe$map,
						function (card) {
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $elm$core$Maybe$Just(
											$author$project$Pages$Pos$Editor$EditClasses(
												A2($author$project$Pages$Pos$Editor$initEditClassesModel, shared.kS, card)))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						},
						model.aQ));
			case 17:
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$ShowErrorDialog('Algo deu errado!')),
					A2(
						$elm$core$Maybe$map,
						function (p) {
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $elm$core$Maybe$Just(
											$author$project$Pages$Pos$Editor$EditPhone(
												$author$project$Pages$Pos$Editor$initEditPhoneModel(p)))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						},
						model.j));
			case 18:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aY: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 19:
				var dateStr = msg.a;
				var _v20 = model.aY;
				if ((!_v20.$) && (!_v20.a.$)) {
					var modal = _v20.a.a;
					var updateModal = _Utils_update(
						modal,
						{
							am: $elm$core$Maybe$Just(dateStr)
						});
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aY: $elm$core$Maybe$Just(
									$author$project$Pages$Pos$Editor$EditClasses(updateModal))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
				}
			case 20:
				var phoneStr = msg.a;
				var _v21 = model.aY;
				if ((!_v21.$) && (_v21.a.$ === 1)) {
					var m = _v21.a.a;
					var updateModal = _Utils_update(
						m,
						{
							b9: A2($elm$core$String$filter, $elm$core$Char$isDigit, phoneStr)
						});
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aY: $elm$core$Maybe$Just(
									$author$project$Pages$Pos$Editor$EditPhone(updateModal))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
				}
			case 21:
				var _v22 = _Utils_Tuple2(model.aY, model.cc);
				if (((!_v22.a.$) && (!_v22.a.a.$)) && (_v22.b.$ === 3)) {
					var modal = _v22.a.a.a;
					var passengerInfo = _v22.b.a;
					if ($author$project$Pages$Pos$Editor$isInvalidDueDate(modal.am)) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $elm$core$Maybe$Just(
										$author$project$Pages$Pos$Editor$EditClasses(
											_Utils_update(
												modal,
												{
													a6: $author$project$Pages$Pos$Editor$Editing(1)
												})))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					} else {
						if (((!modal.cH.qE) && (!$elm$core$String$isEmpty(modal.cH.kw))) && (!_Utils_eq(modal.am, $elm$core$Maybe$Nothing))) {
							var updateModal = $author$project$Pages$Pos$Editor$EditClasses(
								_Utils_update(
									modal,
									{a6: $author$project$Pages$Pos$Editor$LoadReader}));
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $elm$core$Maybe$Just(updateModal)
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						} else {
							if ($elm$core$String$isEmpty(modal.cH.kw) && (!_Utils_eq(modal.am, $elm$core$Maybe$Nothing))) {
								var updateModal = $author$project$Pages$Pos$Editor$EditClasses(
									_Utils_update(
										modal,
										{
											a6: $author$project$Pages$Pos$Editor$Load('Salvando no sistema...')
										}));
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $elm$core$Maybe$Just(updateModal)
										}),
									$author$project$Services$Passenger$putClasses(
										{
											dv: $elm$core$Dict$toList(modal.dv),
											na: A2($elm$core$Maybe$withDefault, '', modal.am),
											ow: $author$project$Pages$Pos$Editor$GotClasses,
											hd: passengerInfo.dM,
											kU: user.kU
										}),
									$author$project$Shared$NoOp);
							} else {
								return _Utils_Tuple3(
									model,
									$elm$core$Platform$Cmd$none,
									$author$project$Shared$ShowErrorDialog('Erro: Não foi possível editar as classes!'));
							}
						}
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
				}
			case 22:
				var _v23 = model.aY;
				if ((!_v23.$) && (_v23.a.$ === 1)) {
					var m = _v23.a.a;
					var _v24 = _Utils_Tuple2(
						$author$project$Pages$Pos$Editor$isInvalidNewPhone(m.b9),
						$elm$core$String$toInt(m.b9));
					if (_v24.a) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $elm$core$Maybe$Just(
										$author$project$Pages$Pos$Editor$EditPhone(
											_Utils_update(
												m,
												{kK: 1})))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					} else {
						if (!_v24.b.$) {
							var phoneInt = _v24.b.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $elm$core$Maybe$Just(
											$author$project$Pages$Pos$Editor$EditPhone(
												_Utils_update(
													m,
													{kK: 2})))
									}),
								$author$project$Services$Passenger$putPhone(
									{b9: phoneInt, ow: $author$project$Pages$Pos$Editor$GotNewPhone, hd: m.j.oe.qw, kU: user.kU}),
								$author$project$Shared$NoOp);
						} else {
							var _v25 = _v24.b;
							return _Utils_Tuple3(
								model,
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$ShowErrorDialog('Erro: Não foi possível converter para Int!'));
						}
					}
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$ShowErrorDialog('Erro: Não foi possível editar o celular!'));
				}
			case 27:
				var rd = msg.a;
				var newModal = A2(
					$elm$core$Maybe$map,
					function (m) {
						if (m.$ === 1) {
							var m_ = m.a;
							return $author$project$Pages$Pos$Editor$EditPhone(
								_Utils_update(
									m_,
									{kK: 0}));
						} else {
							var m_ = m;
							return m_;
						}
					},
					model.aY);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aY: A2(
								$krisajenkins$remotedata$RemoteData$withDefault,
								newModal,
								A2(
									$krisajenkins$remotedata$RemoteData$map,
									function (_v27) {
										return $elm$core$Maybe$Nothing;
									},
									rd))
						}),
					A2(
						$krisajenkins$remotedata$RemoteData$withDefault,
						$elm$core$Platform$Cmd$none,
						A2(
							$krisajenkins$remotedata$RemoteData$map,
							function (_v28) {
								return A2(
									$elm$core$Maybe$withDefault,
									$elm$core$Platform$Cmd$none,
									A2(
										$elm$core$Maybe$map,
										function (p) {
											return A2(
												$elm$core$Task$attempt,
												$author$project$Pages$Pos$Editor$GotPassengerFullNewPhone,
												$author$project$Services$Concessionaire$getPassengerInfoV2(
													{oM: p.oe.dM, kU: user.kU}));
										},
										model.j));
							},
							rd)),
					A2(
						$author$project$Shared$remoteDataSharedMsg,
						$elm$core$Maybe$Just('Número de celular editado!'),
						rd));
			case 26:
				if (msg.a.$ === 3) {
					var updateModel = function () {
						var _v26 = _Utils_Tuple2(model.aY, model.aQ);
						if (((!_v26.a.$) && (!_v26.a.a.$)) && (!_v26.b.$)) {
							var m = _v26.a.a.a;
							var card = _v26.b.a;
							return _Utils_update(
								model,
								{
									aQ: $elm$core$Maybe$Just(
										_Utils_update(
											card,
											{
												na: A2(
													$elm$core$Maybe$andThen,
													$author$project$Utils$dateHTMLToPosixWithZone(shared.kS),
													m.am)
											})),
									B: m.dv
								});
						} else {
							return model;
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							updateModel,
							{aY: $elm$core$Maybe$Nothing}),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$Maybe$map,
								function (p) {
									return A2(
										$elm$core$Task$attempt,
										$author$project$Pages$Pos$Editor$GotPassengerInfo,
										$author$project$Services$Concessionaire$getPassengerInfo(
											{oM: p.oe.dM, kU: user.kU}));
								},
								model.j)),
						$author$project$Shared$ShowSuccessDialog('Classes editadas!'));
				} else {
					var rd = msg.a;
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rd));
				}
			case 23:
				if (!msg.a.$) {
					var updateModel = function (m) {
						if ((!m.$) && (!m.a.$)) {
							var m_ = m.a.a;
							return $elm$core$Maybe$Just(
								$author$project$Pages$Pos$Editor$EditClasses(
									_Utils_update(
										m_,
										{
											a6: $author$project$Pages$Pos$Editor$Load('Salvando no sistema...')
										})));
						} else {
							return m;
						}
					}(model.aY);
					var _v30 = _Utils_Tuple2(model.aY, model.cc);
					if (((!_v30.a.$) && (!_v30.a.a.$)) && (_v30.b.$ === 3)) {
						var modal = _v30.a.a.a;
						var passengerInfo = _v30.b.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{aY: updateModel}),
							$author$project$Services$Passenger$putClasses(
								{
									dv: $elm$core$Dict$toList(modal.dv),
									na: A2($elm$core$Maybe$withDefault, '', modal.am),
									ow: $author$project$Pages$Pos$Editor$GotClasses,
									hd: passengerInfo.dM,
									kU: user.kU
								}),
							$author$project$Shared$NoOp);
					} else {
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$ShowErrorDialog('Algo deu errado!'));
					}
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$ShowErrorDialog(error));
				}
			case 24:
				var resultPassenger = msg.a;
				var takeCardAnalyze = A2(
					$elm$core$Result$withDefault,
					$elm$core$Maybe$Nothing,
					A2(
						$elm$core$Result$map,
						function (p) {
							return A2(
								$elm$core$Maybe$andThen,
								function (card) {
									return card.qE ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(card);
								},
								$elm$core$List$head(p.f0));
						},
						resultPassenger));
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aQ: takeCardAnalyze,
							cc: $krisajenkins$remotedata$RemoteData$fromResult(resultPassenger),
							B: A2(
								$elm$core$Maybe$withDefault,
								$elm$core$Dict$empty,
								A2(
									$elm$core$Maybe$map,
									function (card) {
										return $elm$core$Dict$fromList(
											$elm$core$List$concat(
												A2(
													$elm$core$List$map,
													A2(
														$elm$core$Basics$composeR,
														function ($) {
															return $.dv;
														},
														$elm$core$List$map(
															function (c) {
																return _Utils_Tuple2(c.dM, c.qn);
															})),
													card.hO)));
									},
									takeCardAnalyze))
						}),
					$elm$core$Platform$Cmd$none,
					function () {
						if (!resultPassenger.$) {
							return $author$project$Shared$NoOp;
						} else {
							var error = resultPassenger.a;
							return A2($author$project$Shared$updateApiError, shared, error);
						}
					}());
			case 25:
				var resultPassengerFull = msg.a;
				var _v33 = _Utils_Tuple2(model.j, resultPassengerFull);
				if ((!_v33.a.$) && (!_v33.b.$)) {
					var p = _v33.a.a;
					var meta = p.oe;
					var newPassenger = _v33.b.a;
					var newPhone = A3(
						$elm$core$Basics$composeR,
						function ($) {
							return $.oe;
						},
						function ($) {
							return $.jX;
						},
						newPassenger);
					var updatePassenger = _Utils_update(
						p,
						{
							oe: _Utils_update(
								meta,
								{jX: newPhone})
						});
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								j: $elm$core$Maybe$Just(updatePassenger)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						function () {
							if (!resultPassengerFull.$) {
								return $author$project$Shared$NoOp;
							} else {
								var error = resultPassengerFull.a;
								return A2($author$project$Shared$updateApiError, shared, error);
							}
						}());
				}
			default:
				var serial = msg.a;
				var _v35 = _Utils_Tuple3(model.aY, model.aQ, model.cc);
				if ((((!_v35.a.$) && (!_v35.a.a.$)) && (!_v35.b.$)) && (_v35.c.$ === 3)) {
					var modal = _v35.a.a.a;
					var card = _v35.b.a;
					var passengerInfo = _v35.c.a;
					return _Utils_eq(card.kw, serial) ? A2(
						$elm$core$Maybe$withDefault,
						_Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$ShowErrorDialog('Erro: Validade do cartão não está definida!')),
						A2(
							$elm$core$Maybe$map,
							function (dueDate) {
								var updateModal = $author$project$Pages$Pos$Editor$EditClasses(
									_Utils_update(
										modal,
										{
											a6: $author$project$Pages$Pos$Editor$Load('Atualizando cartão, aguarde…')
										}));
								var takeClasses = A2(
									$krisajenkins$remotedata$RemoteData$withDefault,
									_List_Nil,
									A2(
										$krisajenkins$remotedata$RemoteData$map,
										$elm$core$List$filterMap(
											function (class_) {
												return A2(
													$elm$core$Maybe$map,
													function (_v36) {
														return class_;
													},
													A2($elm$core$Dict$get, class_.dM, modal.dv));
											}),
										model.dv));
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $elm$core$Maybe$Just(updateModal)
										}),
									$author$project$Ports$updateCard(
										{
											dv: A2(
												$elm$core$List$filterMap,
												function ($) {
													return $.lX;
												},
												takeClasses),
											qC: $author$project$Utils$formatDate(dueDate)
										}),
									$author$project$Shared$NoOp);
							},
							modal.am)) : _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$ShowErrorDialog('Esse cartão não é desse passageiro'));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$ShowErrorDialog('Algo deu errado, tente novamente!'));
				}
		}
	});
var $author$project$Pages$Pos$Edit$update = F4(
	function (msg, model, shared, user) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
			case 1:
				var subMsg = msg.a;
				if (!model.$) {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
				} else {
					var subModel = model.a;
					var _v2 = A4($author$project$Pages$Pos$Editor$update, subMsg, subModel, shared, user);
					var editorModel = _v2.a;
					var editorCmd = _v2.b;
					var editorSharedMsg = _v2.c;
					return _Utils_Tuple3(
						$author$project$Pages$Pos$Edit$Loaded(editorModel),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Pos$Edit$GotEditorMsg, editorCmd),
						editorSharedMsg);
				}
			default:
				if (!msg.a.$) {
					var passenger = msg.a.a;
					var _v3 = A2(
						$author$project$Pages$Pos$Editor$init,
						user,
						$elm$core$Maybe$Just(passenger));
					var editorModel = _v3.a;
					var editorCmd = _v3.b;
					return _Utils_Tuple3(
						$author$project$Pages$Pos$Edit$Loaded(editorModel),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Pos$Edit$GotEditorMsg, editorCmd),
						$author$project$Shared$NoOp);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						A2($author$project$Shared$updateApiError, shared, error));
				}
		}
	});
var $author$project$Pages$Pos$Guiche$OpenPos = {$: 4};
var $author$project$Pages$Pos$Guiche$ReceivedPassengerInfoFromSerial = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Pos$Guiche$Reload = {$: 5};
var $author$project$Services$Concessionaire$getPassengerInfoBySerial = function (options) {
	return $elm$http$Http$request(
		{
			lG: $elm$http$Http$emptyBody,
			m9: A2($author$project$Services$Api$expectJson, options.ow, $author$project$Data$Passenger$decoder),
			nG: _List_fromArray(
				[
					$author$project$Services$Api$authorizationHeader(options.kU)
				]),
			of: 'GET',
			p5: $elm$core$Maybe$Nothing,
			qi: $elm$core$Maybe$Nothing,
			qt: A2(
				$author$project$Constants$concessionaireServiceUrl,
				_List_fromArray(
					['api', 'v1', 'scard', options.kw, 'passenger']),
				_List_Nil)
		});
};
var $elm$http$Http$expectBytesResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'arraybuffer',
			_Http_toDataView,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$http$Http$BadBody = function (a) {
	return {$: 4, a: a};
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $elm$http$Http$Timeout = {$: 1};
var $elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 2:
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 3:
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.cw));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$http$Http$BadBody,
					toResult(body));
		}
	});
var $elm$http$Http$expectWhatever = function (toMsg) {
	return A2(
		$elm$http$Http$expectBytesResponse,
		toMsg,
		$elm$http$Http$resolve(
			function (_v0) {
				return $elm$core$Result$Ok(0);
			}));
};
var $author$project$Services$Pos$openCashierBody = $elm$json$Json$Encode$object(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'type',
			$elm$json$Json$Encode$string('ticket_window')),
			_Utils_Tuple2(
			'specificInfo',
			$elm$json$Json$Encode$object(_List_Nil))
		]));
var $author$project$Services$Pos$openPos = F2(
	function (_v0, processRequest) {
		var token = _v0.kU;
		return $elm$http$Http$request(
			{
				lG: $elm$http$Http$jsonBody($author$project$Services$Pos$openCashierBody),
				m9: $elm$http$Http$expectWhatever(processRequest),
				nG: _List_fromArray(
					[
						$author$project$Services$Api$authorizationHeader(token)
					]),
				of: 'POST',
				p5: $elm$core$Maybe$Nothing,
				qi: $elm$core$Maybe$Nothing,
				qt: A2(
					$author$project$Constants$cashierServiceUrl,
					_List_fromArray(
						['api', 'v1', 'cashier', 'open']),
					_List_Nil)
			});
	});
var $author$project$Pages$Pos$Guiche$update = F4(
	function (msg, model, shared, user) {
		switch (msg.$) {
			case 2:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$Logout);
			case 0:
				var serial = msg.a;
				return _Utils_Tuple3(
					model,
					$author$project$Services$Concessionaire$getPassengerInfoBySerial(
						{ow: $author$project$Pages$Pos$Guiche$ReceivedPassengerInfoFromSerial, kw: serial, kU: user.kU}),
					$author$project$Shared$NoOp);
			case 1:
				var res = msg.a;
				if (!res.$) {
					var passenger = res.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ff: $elm$core$Maybe$Just(passenger)
							}),
						A2(
							$author$project$Route$pushUrl,
							shared.nZ,
							A2($author$project$Route$Passenger, passenger.dM, 0)),
						$author$project$Shared$NoOp);
				} else {
					var error = res.a;
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						A2($author$project$Shared$updateApiError, shared, error));
				}
			case 3:
				var _v2 = model.dO;
				if (!_v2.$) {
					if (_v2.a) {
						return _Utils_Tuple3(
							model,
							A2($author$project$Route$pushUrl, shared.nZ, $author$project$Route$PosCloseCashier),
							$author$project$Shared$NoOp);
					} else {
						return _Utils_Tuple3(
							model,
							A2($author$project$Utils$delay, 0, $author$project$Pages$Pos$Guiche$OpenPos),
							$author$project$Shared$CloseDialog);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
				}
			case 4:
				return _Utils_Tuple3(
					model,
					A2(
						$author$project$Services$Pos$openPos,
						user,
						$elm$core$Basics$always($author$project$Pages$Pos$Guiche$Reload)),
					$author$project$Shared$NoOp);
			case 6:
				var status = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							dO: $elm$core$Maybe$Just(status)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			default:
				return $author$project$Pages$Pos$Guiche$init(user);
		}
	});
var $author$project$Pages$Pos$Localize$update = F4(
	function (msg, model, shared, user) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
			case 1:
				var text = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{a3: text}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 2:
				return ($elm$core$String$length(model.a3) < 3) ? _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp) : _Utils_Tuple3(
					model,
					A2(
						$author$project$Route$pushUrl,
						shared.nZ,
						$author$project$Route$PosLocalize(
							$elm$core$Maybe$Just(model.a3))),
					$author$project$Shared$CloseDialog);
			default:
				var passengers = msg.a;
				if (!passengers.$) {
					var passengers_ = passengers.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								a0: $krisajenkins$remotedata$RemoteData$Success(passengers_)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				} else {
					var error = passengers.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								a0: $krisajenkins$remotedata$RemoteData$Success(_List_Nil)
							}),
						$elm$core$Platform$Cmd$none,
						A2($author$project$Shared$updateApiError, shared, error));
				}
		}
	});
var $author$project$Pages$Pos$Passenger$IssueCard$ChangedCard = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Pos$Passenger$LoadingFailed = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Components$PassengerCard$SelectedCard = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Pos$Passenger$getCardById = F2(
	function (maybeCardID, cards) {
		return A2(
			$elm$core$Maybe$andThen,
			function (cardID) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.dM;
							},
							$elm$core$Basics$eq(cardID)),
						cards));
			},
			maybeCardID);
	});
var $author$project$Pages$Pos$Passenger$mapLoaded = F2(
	function (fn, model) {
		if (model.$ === 2) {
			var m = model.a;
			return $elm$core$Maybe$Just(
				fn(m));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$PassengerCard$AppliedRefillModel = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$PassengerCard$AppliedRefillMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$PassengerCard$CardExtractMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$PassengerCard$ChangedCard = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$PassengerCard$CreditTransfer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$PassengerCard$CreditTransferMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$PassengerCard$CustomerObservationModal = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$PassengerCard$CustomerObservationMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$PassengerCard$ExtractCard = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$PassengerCard$GotSetViewportOfWallets = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$PassengerCard$SharedMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$PassengerCard$TransferCompleted = {$: 0};
var $elm$browser$Browser$Dom$getViewportOf = _Browser_getViewportOf;
var $author$project$Components$CreditTransfer$Normal = 0;
var $author$project$Components$CreditTransfer$init = _Utils_Tuple2(
	{bM: '', be: '', dx: 0, aH: $elm$core$Maybe$Nothing, a4: $elm$core$Maybe$Nothing, ag: $elm$core$Maybe$Nothing, aJ: $elm$core$Maybe$Nothing},
	$elm$core$Platform$Cmd$none);
var $author$project$Components$CustomerObservation$GotObservations = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$CustomerObservation$ViewObservation = {$: 0};
var $author$project$Services$CustomerObservation$Observation = F5(
	function (observationText, operationDate, operator, customerName, customerEmail) {
		return {mp: customerEmail, mr: customerName, g_: observationText, jM: operationDate, g4: operator};
	});
var $author$project$Services$CustomerObservation$Operator = F3(
	function (concessionaireId, email, name) {
		return {mc: concessionaireId, mX: email, c3: name};
	});
var $author$project$Services$CustomerObservation$decodeOperator = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'email',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'concessionaireId',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			$elm$json$Json$Decode$succeed($author$project$Services$CustomerObservation$Operator))));
var $author$project$Services$CustomerObservation$decodeObservation = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
	_List_fromArray(
		['customer', 'email']),
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
		_List_fromArray(
			['customer', 'name']),
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'operator',
			$author$project$Services$CustomerObservation$decodeOperator,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'operationDate',
				$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'observationText',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Services$CustomerObservation$Observation))))));
var $author$project$Services$CustomerObservation$getCustomerObservation = function (options) {
	var query = F3(
		function (encode, key, maybeValue) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						encode(key),
						$elm$core$List$singleton),
					maybeValue));
		});
	var queries = _Utils_ap(
		A3(query, $elm$url$Url$Builder$string, 'start_date', options.Z.bB),
		A3(query, $elm$url$Url$Builder$string, 'end_date', options.Z.bl));
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							$elm$json$Json$Decode$list($author$project$Services$CustomerObservation$decodeObservation),
							$elm$json$Json$Decode$null(_List_Nil)
						]))),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'customerObservation', options.ge]),
				queries)
		});
};
var $author$project$Components$CustomerObservation$initFilters = {bl: $elm$core$Maybe$Nothing, L: 0, dY: false, bB: $elm$core$Maybe$Nothing};
var $author$project$Components$CustomerObservation$initForm = {L: 0, c4: ''};
var $author$project$Components$CustomerObservation$init = F2(
	function (user, passengerID) {
		return _Utils_Tuple2(
			{Z: $author$project$Components$CustomerObservation$initFilters, bp: $author$project$Components$CustomerObservation$initForm, e9: $krisajenkins$remotedata$RemoteData$Loading, fy: $author$project$Components$CustomerObservation$ViewObservation},
			$author$project$Services$CustomerObservation$getCustomerObservation(
				{
					ge: passengerID,
					Z: {bl: $elm$core$Maybe$Nothing, bB: $elm$core$Maybe$Nothing},
					ow: $author$project$Components$CustomerObservation$GotObservations,
					kU: user.kU
				}));
	});
var $author$project$Pages$Pos$Passenger$AppliedRefill$GotTime = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Pos$Passenger$AppliedRefill$RefillList = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Pos$Passenger$AppliedRefill$init = F4(
	function (cards, user, document, serial) {
		return _Utils_Tuple2(
			$author$project$Pages$Pos$Passenger$AppliedRefill$RefillList(
				{eu: serial, f0: cards, iI: document, bl: '', c9: $krisajenkins$remotedata$RemoteData$NotAsked, bB: ''}),
			A2(
				$elm$core$Task$perform,
				$author$project$Pages$Pos$Passenger$AppliedRefill$GotTime(document),
				A3(
					$elm$core$Task$map2,
					F2(
						function (now, timezone) {
							return {e8: now, kS: timezone};
						}),
					$elm$time$Time$now,
					$elm$time$Time$here)));
	});
var $elm$browser$Browser$Dom$setViewportOf = _Browser_setViewportOf;
var $author$project$Components$CreditTransfer$GotSubmit = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$CreditTransfer$Loading = 1;
var $author$project$Components$CreditTransfer$SharedMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$CreditTransfer$TransferCompleted = {$: 0};
var $author$project$Services$CreditTransfer$encodeCreateTransfer = function (options) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'userSourceID',
				$elm$json$Json$Encode$string(options.qy)),
				_Utils_Tuple2(
				'sourceCard',
				$elm$json$Json$Encode$string(options.pP)),
				_Utils_Tuple2(
				'destinyCard',
				$elm$json$Json$Encode$string(options.mD)),
				_Utils_Tuple2(
				'sourcePurse',
				$elm$json$Json$Encode$int(options.pR)),
				_Utils_Tuple2(
				'destinyPurse',
				$elm$json$Json$Encode$int(options.mE)),
				_Utils_Tuple2(
				'amount',
				$elm$json$Json$Encode$int(options.lo)),
				_Utils_Tuple2(
				'amountRefill',
				$elm$json$Json$Encode$int(options.be)),
				_Utils_Tuple2(
				'immediate',
				$elm$json$Json$Encode$bool(options.nN))
			]));
};
var $author$project$Services$CreditTransfer$createTransfer = function (options) {
	return $author$project$Services$Api$postHttp(
		{
			lG: $elm$http$Http$jsonBody(
				$author$project$Services$CreditTransfer$encodeCreateTransfer(options)),
			m9: $author$project$Services$Api$expectWhatever(options.ow),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'creditTransfer', 'create']),
				_List_Nil)
		});
};
var $author$project$Components$CreditTransfer$getClassPurseIDSelected = F2(
	function (classes, selectedClassID) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				function (c) {
					return _Utils_eq(
						A2($elm$core$Maybe$withDefault, '', selectedClassID),
						c.dM) ? c.o8 : $elm$core$Maybe$Nothing;
				},
				classes));
	});
var $author$project$Components$CreditTransfer$getCardSelected = function (selectedCardID) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$List$filter(
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.dM;
				},
				$elm$core$Basics$eq(
					A2($elm$core$Maybe$withDefault, '', selectedCardID)))),
		$elm$core$List$head);
};
var $author$project$Components$CreditTransfer$getClassCode = function (w) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm$core$List$head(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.dM;
				},
				w.dv)));
};
var $author$project$Components$CreditTransfer$getWalletSelected = function (selectedWalletID) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$List$filter(
			A2(
				$elm$core$Basics$composeR,
				$author$project$Components$CreditTransfer$getClassCode,
				$elm$core$Basics$eq(
					A2($elm$core$Maybe$withDefault, '', selectedWalletID)))),
		$elm$core$List$head);
};
var $author$project$Components$CreditTransfer$hasErrorValueSourceBalance = F2(
	function (model, passengerInfo) {
		var sourceWallets = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.hO;
			},
			A2($author$project$Components$CreditTransfer$getCardSelected, model.ag, passengerInfo.f0));
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Maybe$Nothing,
			A2(
				$elm$core$Maybe$map,
				function (selectedSourceWalletClassID) {
					var maybeValue = $elm$core$String$toInt(model.bM);
					var max = selectedSourceWalletClassID.h2;
					return A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Maybe$Nothing,
						A2(
							$elm$core$Maybe$map,
							function (v) {
								return (_Utils_cmp(v, max) < 1) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(max);
							},
							maybeValue));
				},
				A2(
					$author$project$Components$CreditTransfer$getWalletSelected,
					model.aJ,
					A2($elm$core$Maybe$withDefault, _List_Nil, sourceWallets))));
	});
var $author$project$Components$CreditTransfer$hasErrorValueSourceRefill = F2(
	function (model, passengerInfo) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Maybe$Nothing,
			A2(
				$elm$core$Maybe$map,
				function (c) {
					var maybeValue = $elm$core$String$toInt(model.be);
					var max = A3(
						$elm$core$List$foldl,
						$elm$core$Basics$add,
						0,
						A2(
							$elm$core$List$map,
							function ($) {
								return $.di;
							},
							c.j8));
					return A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Maybe$Nothing,
						A2(
							$elm$core$Maybe$map,
							function (v) {
								return (_Utils_cmp(v, max) < 1) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(max);
							},
							maybeValue));
				},
				A2($author$project$Components$CreditTransfer$getCardSelected, model.ag, passengerInfo.f0)));
	});
var $author$project$Components$CreditTransfer$valueIsValid = function (newCard) {
	return $elm$core$String$isEmpty(newCard) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(newCard);
};
var $author$project$Components$CreditTransfer$update = F5(
	function (msg, model, shared, user, passengerInfo) {
		switch (msg.$) {
			case 0:
				if (!msg.a) {
					var _v1 = msg.a;
					var newCard = msg.b;
					return _Utils_eq(
						newCard,
						A2($elm$core$Maybe$withDefault, '', model.aH)) ? _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aH: $elm$core$Maybe$Nothing,
								a4: $elm$core$Maybe$Nothing,
								ag: $author$project$Components$CreditTransfer$valueIsValid(newCard),
								aJ: $elm$core$Maybe$Nothing
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Components$CreditTransfer$SharedMsg($author$project$Shared$NoOp)) : _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ag: $author$project$Components$CreditTransfer$valueIsValid(newCard),
								aJ: $elm$core$Maybe$Nothing
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Components$CreditTransfer$SharedMsg($author$project$Shared$NoOp));
				} else {
					var _v2 = msg.a;
					var newCard = msg.b;
					return _Utils_eq(
						newCard,
						A2($elm$core$Maybe$withDefault, '', model.ag)) ? _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aH: $author$project$Components$CreditTransfer$valueIsValid(newCard),
								a4: $elm$core$Maybe$Nothing,
								ag: $elm$core$Maybe$Nothing,
								aJ: $elm$core$Maybe$Nothing
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Components$CreditTransfer$SharedMsg($author$project$Shared$NoOp)) : _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aH: $author$project$Components$CreditTransfer$valueIsValid(newCard),
								a4: $elm$core$Maybe$Nothing
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Components$CreditTransfer$SharedMsg($author$project$Shared$NoOp));
				}
			case 1:
				if (!msg.a) {
					var _v3 = msg.a;
					var newWallet = msg.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aJ: $author$project$Components$CreditTransfer$valueIsValid(newWallet)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Components$CreditTransfer$SharedMsg($author$project$Shared$NoOp));
				} else {
					var _v4 = msg.a;
					var newWallet = msg.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								a4: $author$project$Components$CreditTransfer$valueIsValid(newWallet)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Components$CreditTransfer$SharedMsg($author$project$Shared$NoOp));
				}
			case 2:
				var newAmount = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bM: newAmount}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$CreditTransfer$SharedMsg($author$project$Shared$NoOp));
			case 3:
				var newAmount = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{be: newAmount}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$CreditTransfer$SharedMsg($author$project$Shared$NoOp));
			case 4:
				var isSetValues = (!_Utils_eq(
					$elm$core$String$toInt(model.bM),
					$elm$core$Maybe$Nothing)) || (!_Utils_eq(
					$elm$core$String$toInt(model.be),
					$elm$core$Maybe$Nothing));
				var hasErrorValueSourceRefill_ = A2($author$project$Components$CreditTransfer$hasErrorValueSourceRefill, model, passengerInfo);
				var hasErrorValueSourceBalance_ = A2($author$project$Components$CreditTransfer$hasErrorValueSourceBalance, model, passengerInfo);
				var _v5 = _Utils_Tuple3(
					model.ag,
					model.aH,
					_Utils_Tuple3(
						A2($author$project$Components$CreditTransfer$getClassPurseIDSelected, passengerInfo.dv, model.aJ),
						A2($author$project$Components$CreditTransfer$getClassPurseIDSelected, passengerInfo.dv, model.a4),
						_Utils_Tuple3(isSetValues, hasErrorValueSourceBalance_, hasErrorValueSourceRefill_)));
				if (!_v5.a.$) {
					if (!_v5.b.$) {
						if (!_v5.c.a.$) {
							if (!_v5.c.b.$) {
								if (_v5.c.c.a) {
									if (_v5.c.c.b.$ === 1) {
										if (_v5.c.c.c.$ === 1) {
											var selectedSourceCardID = _v5.a.a;
											var selectedDestinyCardID = _v5.b.a;
											var _v6 = _v5.c;
											var selectedSourceWalletClassID = _v6.a.a;
											var selectedDestinyWalletClassID = _v6.b.a;
											var _v7 = _v6.c;
											var _v8 = _v7.b;
											var _v9 = _v7.c;
											return _Utils_Tuple3(
												_Utils_update(
													model,
													{dx: 1}),
												$author$project$Services$CreditTransfer$createTransfer(
													{
														lo: A2(
															$elm$core$Maybe$withDefault,
															0,
															$elm$core$String$toInt(model.bM)),
														be: A2(
															$elm$core$Maybe$withDefault,
															0,
															$elm$core$String$toInt(model.be)),
														mD: selectedDestinyCardID,
														mE: selectedDestinyWalletClassID,
														nN: true,
														ow: $author$project$Components$CreditTransfer$GotSubmit,
														pP: selectedSourceCardID,
														pR: selectedSourceWalletClassID,
														kU: user.kU,
														qy: passengerInfo.qw
													}),
												$author$project$Components$CreditTransfer$SharedMsg($author$project$Shared$NoOp));
										} else {
											var _v20 = _v5.c;
											var _v21 = _v20.c;
											var valueMax = _v21.c.a;
											return _Utils_Tuple3(
												model,
												$elm$core$Platform$Cmd$none,
												$author$project$Components$CreditTransfer$SharedMsg(
													$author$project$Shared$ShowErrorDialog(
														'Valor máximo disponível para cargas é de ' + $author$project$Utils$formatAsMoney(
															$elm$core$String$fromInt(valueMax)))));
										}
									} else {
										var _v18 = _v5.c;
										var _v19 = _v18.c;
										var valueMax = _v19.b.a;
										return _Utils_Tuple3(
											model,
											$elm$core$Platform$Cmd$none,
											$author$project$Components$CreditTransfer$SharedMsg(
												$author$project$Shared$ShowErrorDialog(
													'Valor máximo disponível para saldo é de ' + $author$project$Utils$formatAsMoney(
														$elm$core$String$fromInt(valueMax)))));
									}
								} else {
									var _v16 = _v5.c;
									var _v17 = _v16.c;
									return _Utils_Tuple3(
										model,
										$elm$core$Platform$Cmd$none,
										$author$project$Components$CreditTransfer$SharedMsg(
											$author$project$Shared$ShowErrorDialog('Informe o valor para ser transferido')));
								}
							} else {
								var _v14 = _v5.c;
								var _v15 = _v14.b;
								return _Utils_Tuple3(
									model,
									$elm$core$Platform$Cmd$none,
									$author$project$Components$CreditTransfer$SharedMsg(
										$author$project$Shared$ShowErrorDialog('Selecione uma carteira de destino')));
							}
						} else {
							var _v12 = _v5.c;
							var _v13 = _v12.a;
							return _Utils_Tuple3(
								model,
								$elm$core$Platform$Cmd$none,
								$author$project$Components$CreditTransfer$SharedMsg(
									$author$project$Shared$ShowErrorDialog('Selecione uma carteira de origem')));
						}
					} else {
						var _v11 = _v5.b;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$Components$CreditTransfer$SharedMsg(
								$author$project$Shared$ShowErrorDialog('Selecione um cartão de destino')));
					}
				} else {
					var _v10 = _v5.a;
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Components$CreditTransfer$SharedMsg(
							$author$project$Shared$ShowErrorDialog('Selecione um cartão de origem')));
				}
			default:
				if (!msg.a.$) {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Components$CreditTransfer$TransferCompleted);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dx: 0}),
						$elm$core$Platform$Cmd$none,
						$author$project$Components$CreditTransfer$SharedMsg(
							A2($author$project$Shared$updateApiError, shared, error)));
				}
		}
	});
var $author$project$Components$CustomerObservation$GotCreateObservation = function (a) {
	return {$: 8, a: a};
};
var $author$project$Services$CustomerObservation$encodeCreateObservation = function (options) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'observationText',
				$elm$json$Json$Encode$string(options.g_)),
				_Utils_Tuple2(
				'customerID',
				$elm$json$Json$Encode$string(options.ge))
			]));
};
var $author$project$Services$CustomerObservation$postCreateObservation = function (options) {
	return $author$project$Services$Api$postHttp(
		{
			lG: $elm$http$Http$jsonBody(
				$author$project$Services$CustomerObservation$encodeCreateObservation(options)),
			m9: $author$project$Services$Api$expectWhateverErrorString(
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'customerObservation']),
				_List_Nil)
		});
};
var $author$project$Components$CustomerObservation$update = F4(
	function (passengerID, user, msg, model) {
		var filters = model.Z;
		var form = model.bp;
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							Z: _Utils_update(
								filters,
								{dY: !filters.dY})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 1:
				var dateStr = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							Z: _Utils_update(
								filters,
								{bB: dateStr})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 2:
				var dateStr = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							Z: _Utils_update(
								filters,
								{bl: dateStr})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 3:
				var newObservation = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bp: _Utils_update(
								form,
								{c4: newObservation})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 5:
				return (_Utils_eq(filters.bB, $elm$core$Maybe$Nothing) || _Utils_eq(filters.bl, $elm$core$Maybe$Nothing)) ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							Z: _Utils_update(
								filters,
								{L: 1})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$ShowErrorDialog('Os campos de início e fim não podem estar vazios!')) : _Utils_Tuple3(
					_Utils_update(
						model,
						{
							Z: _Utils_update(
								filters,
								{L: 2})
						}),
					$author$project$Services$CustomerObservation$getCustomerObservation(
						{
							ge: passengerID,
							Z: {bl: filters.bl, bB: filters.bB},
							ow: $author$project$Components$CustomerObservation$GotObservations,
							kU: user.kU
						}),
					$author$project$Shared$NoOp);
			case 4:
				return $elm$core$String$isEmpty(form.c4) ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bp: _Utils_update(
								form,
								{L: 1})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp) : _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bp: _Utils_update(
								form,
								{L: 2})
						}),
					$author$project$Services$CustomerObservation$postCreateObservation(
						{ge: passengerID, g_: form.c4, ow: $author$project$Components$CustomerObservation$GotCreateObservation, kU: user.kU}),
					$author$project$Shared$NoOp);
			case 6:
				var newState = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{fy: newState}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 7:
				var rdResult = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							Z: _Utils_update(
								filters,
								{L: 0}),
							e9: rdResult
						}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rdResult));
			default:
				var rdResult = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bp: _Utils_update(
								form,
								{L: 0})
						}),
					$elm$core$Platform$Cmd$none,
					A2(
						$author$project$Shared$remoteDataSharedMsg,
						$elm$core$Maybe$Just('Observação criada com sucesso!'),
						rdResult));
		}
	});
var $author$project$Pages$Pos$Passenger$AppliedRefill$GotRefillDetails = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Pos$Passenger$AppliedRefill$HistoryDetailsMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Pos$Passenger$AppliedRefill$OrderDetails = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Services$Passenger$AppliedRefill = function (refillCounter) {
	return function (origin) {
		return function (type_) {
			return function (typeDescription) {
				return function (value) {
					return function (buyDate) {
						return function (generationDate) {
							return function (applyDate) {
								return function (applyLocation) {
									return function (refillList) {
										return function (wallet) {
											return function (refillId) {
												return function (companyId) {
													return {lt: applyDate, lu: applyLocation, lK: buyDate, iu: companyId, nx: generationDate, a$: origin, pl: refillCounter, pm: refillId, pn: refillList, kX: typeDescription, kY: type_, di: value, k7: wallet};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Services$Passenger$decodeAppliedRefill = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'companyId',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'refillId',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'wallet',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'refillList',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'applyLocation',
					$elm$json$Json$Decode$string,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'applyDate',
						$elm$json$Json$Decode$maybe($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'generationDate',
							$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'buyDate',
								$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'value',
									$elm$json$Json$Decode$int,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'typeDescription',
										$elm$json$Json$Decode$string,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'type',
											$elm$json$Json$Decode$maybe($author$project$Services$Models$decoderPaymentMethod),
											$elm$core$Maybe$Nothing,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'origin',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'refillCounter',
													$elm$json$Json$Decode$int,
													$elm$json$Json$Decode$succeed($author$project$Services$Passenger$AppliedRefill))))))))))))));
var $author$project$Services$Passenger$getRefillDetails = function (options) {
	var queries = _Utils_ap(
		A3(
			$author$project$Services$Api$queryMaybeValue,
			$elm$url$Url$Builder$string,
			'start',
			$elm$core$Maybe$Just(options.bB)),
		_Utils_ap(
			A3(
				$author$project$Services$Api$queryMaybeValue,
				$elm$url$Url$Builder$string,
				'end',
				$elm$core$Maybe$Just(options.bl)),
			A3(
				$author$project$Services$Api$queryMaybeValue,
				$elm$url$Url$Builder$string,
				'card',
				$elm$core$Maybe$Just(options.lO))));
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$elm$json$Json$Decode$list($author$project$Services$Passenger$decodeAppliedRefill)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'report', 'passenger', options.iI, 'refillDetails']),
				queries)
		});
};
var $author$project$Pages$Pos$Passenger$AppliedRefill$update = F4(
	function (shared, user, msg, typeModal) {
		var _v0 = _Utils_Tuple2(typeModal, msg);
		_v0$8:
		while (true) {
			if (!_v0.a.$) {
				switch (_v0.b.$) {
					case 3:
						var model = _v0.a.a;
						var _v1 = _v0.b;
						var document = _v1.a;
						var now = _v1.b.e8;
						var timezone = _v1.b.kS;
						var today = A2($justinmimbs$date$Date$fromPosix, timezone, now);
						var newModel = _Utils_update(
							model,
							{
								bl: $justinmimbs$date$Date$toIsoString(today),
								bB: $justinmimbs$date$Date$toIsoString(
									A3($justinmimbs$date$Date$add, 1, -1, today))
							});
						return _Utils_Tuple3(
							$author$project$Pages$Pos$Passenger$AppliedRefill$RefillList(newModel),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					case 0:
						var model = _v0.a.a;
						var result = _v0.b.a;
						return _Utils_Tuple3(
							$author$project$Pages$Pos$Passenger$AppliedRefill$RefillList(
								_Utils_update(
									model,
									{c9: result})),
							$elm$core$Platform$Cmd$none,
							A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, result));
					case 1:
						var model = _v0.a.a;
						var start = _v0.b.a;
						return _Utils_Tuple3(
							$author$project$Pages$Pos$Passenger$AppliedRefill$RefillList(
								_Utils_update(
									model,
									{bB: start})),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					case 2:
						var model = _v0.a.a;
						var end = _v0.b.a;
						return _Utils_Tuple3(
							$author$project$Pages$Pos$Passenger$AppliedRefill$RefillList(
								_Utils_update(
									model,
									{bl: end})),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					case 4:
						var model = _v0.a.a;
						var _v2 = _v0.b;
						return _Utils_Tuple3(
							$author$project$Pages$Pos$Passenger$AppliedRefill$RefillList(
								_Utils_update(
									model,
									{c9: $krisajenkins$remotedata$RemoteData$Loading})),
							$author$project$Services$Passenger$getRefillDetails(
								{lO: model.eu, iI: model.iI, bl: model.bl, ow: $author$project$Pages$Pos$Passenger$AppliedRefill$GotRefillDetails, bB: model.bB, kU: user.kU}),
							$author$project$Shared$NoOp);
					case 5:
						var model = _v0.a.a;
						var _v3 = _v0.b;
						var companyID = _v3.a;
						var id = _v3.b;
						var _v4 = A5(
							$author$project$Pages$Admin$CompanyOrders$init,
							$elm$core$Maybe$Nothing,
							$elm$core$Maybe$Nothing,
							$elm$core$Maybe$Just(companyID),
							$elm$core$Maybe$Just(id),
							user);
						var newModel = _v4.a;
						var cmd_ = _v4.b;
						return _Utils_Tuple3(
							A2($author$project$Pages$Pos$Passenger$AppliedRefill$OrderDetails, model, newModel),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Pos$Passenger$AppliedRefill$HistoryDetailsMsg, cmd_),
							$author$project$Shared$NoOp);
					default:
						break _v0$8;
				}
			} else {
				switch (_v0.b.$) {
					case 7:
						var _v5 = _v0.a;
						var modelRefillList = _v5.a;
						var model = _v5.b;
						var msg_ = _v0.b.a;
						var _v6 = A4($author$project$Pages$Admin$CompanyOrders$update, msg_, model, shared, user);
						var newModel = _v6.a;
						var cmd_ = _v6.b;
						var sharedMsg_ = _v6.c;
						return _Utils_Tuple3(
							A2($author$project$Pages$Pos$Passenger$AppliedRefill$OrderDetails, modelRefillList, newModel),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Pos$Passenger$AppliedRefill$HistoryDetailsMsg, cmd_),
							sharedMsg_);
					case 6:
						var _v7 = _v0.a;
						var modelRefillList = _v7.a;
						var model = _v7.b;
						var _v8 = _v0.b;
						return _Utils_Tuple3(
							$author$project$Pages$Pos$Passenger$AppliedRefill$RefillList(modelRefillList),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					default:
						break _v0$8;
				}
			}
		}
		return _Utils_Tuple3(
			typeModal,
			$elm$core$Platform$Cmd$none,
			$author$project$Shared$ShowErrorDialog('Algo deu errado!'));
	});
var $author$project$Components$PassengerCard$update = F5(
	function (passenger, msg, model, shared, user) {
		switch (msg.$) {
			case 0:
				var cardId = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							dc: $elm$core$Maybe$Just(cardId),
							dd: 0
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$PassengerCard$ChangedCard(cardId));
			case 1:
				var walletIndex = msg.a;
				var walletsCount = A2(
					$elm$core$Maybe$withDefault,
					0,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.hO;
							},
							$elm$core$List$length),
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (c) {
									return _Utils_eq(
										$elm$core$Maybe$Just(c.dM),
										model.dc);
								},
								passenger.f0))));
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dd: walletIndex}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Task$attempt,
								$author$project$Components$PassengerCard$GotSetViewportOfWallets,
								A2(
									$elm$core$Task$andThen,
									function (_v1) {
										var scene = _v1.pz;
										return A3($elm$browser$Browser$Dom$setViewportOf, 'wallets-scrollable', (scene.qQ / walletsCount) * (walletIndex - 0.5), 0);
									},
									$elm$browser$Browser$Dom$getViewportOf('wallets-scrollable')))
							])),
					$author$project$Components$PassengerCard$SharedMsg($author$project$Shared$NoOp));
			case 2:
				if (!msg.a.$) {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Components$PassengerCard$SharedMsg($author$project$Shared$NoOp));
				} else {
					var domError = msg.a.a;
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Components$PassengerCard$SharedMsg($author$project$Shared$NoOp));
				}
			case 3:
				if (!msg.a.$) {
					var element = msg.a.a;
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Components$PassengerCard$SharedMsg($author$project$Shared$NoOp));
				} else {
					var domError = msg.a.a;
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Components$PassengerCard$SharedMsg($author$project$Shared$NoOp));
				}
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aY: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$PassengerCard$SharedMsg($author$project$Shared$NoOp));
			case 5:
				var cardID = msg.a;
				var _v2 = A2($author$project$Pages$Admin$CardExtract$init, user, cardID);
				var initModelComp = _v2.a;
				var cmdModelComp = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aY: $elm$core$Maybe$Just(
								$author$project$Components$PassengerCard$ExtractCard(initModelComp))
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$PassengerCard$CardExtractMsg, cmdModelComp),
					$author$project$Components$PassengerCard$SharedMsg($author$project$Shared$NoOp));
			case 6:
				var cards = msg.a;
				var document = msg.b;
				var serial = msg.c;
				var _v3 = A4($author$project$Pages$Pos$Passenger$AppliedRefill$init, cards, user, document, serial);
				var initModelComp = _v3.a;
				var cmdModelComp = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aY: $elm$core$Maybe$Just(
								$author$project$Components$PassengerCard$AppliedRefillModel(initModelComp))
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$PassengerCard$AppliedRefillMsg, cmdModelComp),
					$author$project$Components$PassengerCard$SharedMsg($author$project$Shared$NoOp));
			case 7:
				var _v4 = $author$project$Components$CreditTransfer$init;
				var iniModelComp = _v4.a;
				var cmdComp = _v4.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aY: $elm$core$Maybe$Just(
								$author$project$Components$PassengerCard$CreditTransfer(iniModelComp))
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$PassengerCard$CreditTransferMsg, cmdComp),
					$author$project$Components$PassengerCard$SharedMsg($author$project$Shared$NoOp));
			case 8:
				var _v5 = A2($author$project$Components$CustomerObservation$init, user, passenger.dM);
				var initModel = _v5.a;
				var cmd = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aY: $elm$core$Maybe$Just(
								$author$project$Components$PassengerCard$CustomerObservationModal(initModel))
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$PassengerCard$CustomerObservationMsg, cmd),
					$author$project$Components$PassengerCard$SharedMsg($author$project$Shared$NoOp));
			case 9:
				var msg_ = msg.a;
				var _v6 = _Utils_Tuple2(model.dc, model.aY);
				if (((!_v6.a.$) && (!_v6.b.$)) && (!_v6.b.a.$)) {
					var cardID = _v6.a.a;
					var modelComp = _v6.b.a.a;
					var _v7 = A5($author$project$Pages$Admin$CardExtract$update, cardID, msg_, modelComp, shared, user);
					var newModel = _v7.a;
					var newCmd = _v7.b;
					var sharedMsg = _v7.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aY: $elm$core$Maybe$Just(
									$author$project$Components$PassengerCard$ExtractCard(newModel))
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$PassengerCard$CardExtractMsg, newCmd),
						$author$project$Components$PassengerCard$SharedMsg(sharedMsg));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Components$PassengerCard$SharedMsg($author$project$Shared$NoOp));
				}
			case 10:
				var msg_ = msg.a;
				var _v8 = model.aY;
				if ((!_v8.$) && (_v8.a.$ === 2)) {
					var m = _v8.a.a;
					var _v9 = A4($author$project$Pages$Pos$Passenger$AppliedRefill$update, shared, user, msg_, m);
					var newModel = _v9.a;
					var newCmd = _v9.b;
					var sharedMsg = _v9.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aY: $elm$core$Maybe$Just(
									$author$project$Components$PassengerCard$AppliedRefillModel(newModel))
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$PassengerCard$AppliedRefillMsg, newCmd),
						$author$project$Components$PassengerCard$SharedMsg(sharedMsg));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Components$PassengerCard$SharedMsg($author$project$Shared$NoOp));
				}
			case 11:
				var msg_ = msg.a;
				var _v10 = model.aY;
				if ((!_v10.$) && (_v10.a.$ === 1)) {
					var modelComp = _v10.a.a;
					var _v11 = A5($author$project$Components$CreditTransfer$update, msg_, modelComp, shared, user, passenger);
					var newModelComp = _v11.a;
					var cmdComp = _v11.b;
					var sharedOutMsg = _v11.c;
					var sharedMsg = function () {
						if (!sharedOutMsg.$) {
							return $author$project$Components$PassengerCard$TransferCompleted;
						} else {
							var sharedOutMsg_ = sharedOutMsg.a;
							return $author$project$Components$PassengerCard$SharedMsg(sharedOutMsg_);
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aY: $elm$core$Maybe$Just(
									$author$project$Components$PassengerCard$CreditTransfer(newModelComp))
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$PassengerCard$CreditTransferMsg, cmdComp),
						sharedMsg);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Components$PassengerCard$SharedMsg($author$project$Shared$NoOp));
				}
			default:
				var msg_ = msg.a;
				var _v13 = model.aY;
				if ((!_v13.$) && (_v13.a.$ === 3)) {
					var m = _v13.a.a;
					var _v14 = A4($author$project$Components$CustomerObservation$update, passenger.dM, user, msg_, m);
					var newModel = _v14.a;
					var cmd = _v14.b;
					var sharedMsg = _v14.c;
					var maybeCloseModal = function () {
						if ((msg_.$ === 8) && (msg_.a.$ === 3)) {
							return $elm$core$Maybe$Nothing;
						} else {
							return $elm$core$Maybe$Just(
								$author$project$Components$PassengerCard$CustomerObservationModal(newModel));
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{aY: maybeCloseModal}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$PassengerCard$CustomerObservationMsg, cmd),
						$author$project$Components$PassengerCard$SharedMsg(sharedMsg));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Components$PassengerCard$SharedMsg($author$project$Shared$NoOp));
				}
		}
	});
var $author$project$Pages$Pos$Passenger$ApplyRefill$Apply = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Pos$Passenger$ApplyRefill$BeforeLoop = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Pos$Passenger$ApplyRefill$BlockUnblockRequest = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Pos$Passenger$ApplyRefill$LoopRecvUpdate = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Pos$Passenger$ApplyRefill$LoopStart = {$: 0};
var $author$project$Pages$Pos$Passenger$ApplyRefill$ReceivedBlockUnblockCardBackendRequest = function (a) {
	return {$: 2, a: a};
};
var $author$project$Services$Concessionaire$applyBlockUnblock = function (options) {
	var block_unblock = options.qo ? 'unblock' : 'block';
	return $elm$http$Http$request(
		{
			lG: $elm$http$Http$jsonBody(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'appliedAt',
							$elm$json$Json$Encode$int(
								($elm$time$Time$posixToMillis(options.lq) / 1000) | 0)),
							_Utils_Tuple2(
							'cryptogram',
							$elm$json$Json$Encode$string(options.mm))
						]))),
			m9: $author$project$Services$Api$expectWhatever(options.ow),
			nG: _List_fromArray(
				[
					$author$project$Services$Api$authorizationHeader(options.kU)
				]),
			of: 'PATCH',
			p5: $elm$core$Maybe$Nothing,
			qi: $elm$core$Maybe$Nothing,
			qt: A2(
				$author$project$Constants$concessionaireServiceUrl,
				_List_fromArray(
					['api', 'v1', 'cards', block_unblock, 'applied']),
				_List_Nil)
		});
};
var $author$project$Ports$applyBlockUnblockRequest = _Platform_outgoingPort(
	'applyBlockUnblockRequest',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'cryptogram',
					$elm$json$Json$Encode$string($.mm))
				]));
	});
var $author$project$Pages$Pos$Passenger$ApplyRefill$applyRefill = _Platform_outgoingPort(
	'applyRefill',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'counter',
					$elm$json$Json$Encode$int($.mg)),
					_Utils_Tuple2(
					'cryptogram',
					$elm$json$Json$Encode$string($.mm)),
					_Utils_Tuple2(
					'purse',
					$elm$json$Json$Encode$int($.j4)),
					_Utils_Tuple2(
					'value',
					$elm$json$Json$Encode$int($.di))
				]));
	});
var $author$project$Services$Concessionaire$applyRefill = function (_v0) {
	var token = _v0.kU;
	var passengerId = _v0.oM;
	var refillId = _v0.pm;
	var receipt = _v0.ph;
	var appliedAt = _v0.lq;
	var onResponse = _v0.ow;
	return $elm$http$Http$request(
		{
			lG: $elm$http$Http$jsonBody(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'appliedAt',
							$elm$json$Json$Encode$int(
								($elm$time$Time$posixToMillis(appliedAt) / 1000) | 0)),
							_Utils_Tuple2(
							'receipt',
							$elm$json$Json$Encode$string(receipt))
						]))),
			m9: $author$project$Services$Api$expectWhatever(onResponse),
			nG: _List_fromArray(
				[
					$author$project$Services$Api$authorizationHeader(token)
				]),
			of: 'PATCH',
			p5: $elm$core$Maybe$Nothing,
			qi: $elm$core$Maybe$Nothing,
			qt: A2(
				$author$project$Constants$concessionaireServiceUrl,
				_List_fromArray(
					['api', 'v1', 'passenger', passengerId, 'refill', refillId]),
				_List_Nil)
		});
};
var $author$project$Pages$Pos$Passenger$ApplyRefill$update = F5(
	function (msg, model, shared, user, passenger) {
		update:
		while (true) {
			switch (msg.$) {
				case 0:
					var serial = msg.a;
					if (model.$ === 1) {
						var model_ = model.a;
						return _Utils_eq(model_.cH.kw, serial) ? _Utils_Tuple3(
							$author$project$Pages$Pos$Passenger$ApplyRefill$BlockUnblockRequest(model_),
							((model_.cH.h7 === 2) || (model_.cH.h7 === 3)) ? $author$project$Ports$applyBlockUnblockRequest(
								{mm: model_.cH.ml}) : A2($elm$core$Task$perform, $author$project$Pages$Pos$Passenger$ApplyRefill$BeforeLoop, $elm$time$Time$now),
							$author$project$Shared$NoOp) : A2(
							$author$project$Utils$mapThird,
							function (_v2) {
								return $author$project$Shared$ShowErrorDialog('Esse cartão não é desse passageiro');
							},
							A2($author$project$Pages$Pos$Passenger$ApplyRefill$init, user, passenger));
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
					}
				case 1:
					if (!msg.b.$) {
						var mTimestamp = msg.a;
						if (model.$ === 2) {
							var model_ = model.a;
							return _Utils_Tuple3(
								model,
								function () {
									if (!mTimestamp.$) {
										var appliedAt = mTimestamp.a;
										return $author$project$Services$Concessionaire$applyBlockUnblock(
											{lq: appliedAt, mm: model_.cH.ml, ow: $author$project$Pages$Pos$Passenger$ApplyRefill$ReceivedBlockUnblockCardBackendRequest, kU: user.kU, qo: model_.cH.h7 === 3});
									} else {
										return A2(
											$elm$core$Task$perform,
											function (now) {
												return A2(
													$author$project$Pages$Pos$Passenger$ApplyRefill$ReceivedBlockUnblockCardRequest,
													$elm$core$Maybe$Just(now),
													$elm$core$Result$Ok(0));
											},
											$elm$time$Time$now);
									}
								}(),
								$author$project$Shared$NoOp);
						} else {
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
						}
					} else {
						var mTimestamp = msg.a;
						var error = msg.b.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$ShowErrorDialog(error));
					}
				case 2:
					if (!msg.a.$) {
						if (model.$ === 2) {
							var model_ = model.a;
							return _Utils_Tuple3(
								model,
								A2($elm$core$Task$perform, $author$project$Pages$Pos$Passenger$ApplyRefill$BeforeLoop, $elm$time$Time$now),
								$author$project$Shared$NoOp);
						} else {
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
						}
					} else {
						var error = msg.a.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							A2($author$project$Shared$updateApiError, shared, error));
					}
				case 3:
					var now = msg.a;
					if (model.$ === 2) {
						var state = model.a;
						return _Utils_Tuple3(
							$author$project$Pages$Pos$Passenger$ApplyRefill$Apply(
								{
									e8: now,
									ci: state.ci,
									hk: $elm$core$List$length(state.ci),
									fn: {mg: 0, mm: '', dM: '', o9: 0, di: 0},
									fA: true
								}),
							A2(
								$author$project$Utils$delay,
								500,
								$author$project$Pages$Pos$Passenger$ApplyRefill$Loop($author$project$Pages$Pos$Passenger$ApplyRefill$LoopStart)),
							$author$project$Shared$NoOp);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
					}
				default:
					var loop = msg.a;
					if (model.$ === 3) {
						var state = model.a;
						switch (loop.$) {
							case 0:
								var _v9 = state.ci;
								if (_v9.b) {
									var refill = _v9.a;
									var refills = _v9.b;
									return _Utils_Tuple3(
										$author$project$Pages$Pos$Passenger$ApplyRefill$Apply(
											_Utils_update(
												state,
												{ci: refills, fn: refill, fA: true})),
										$author$project$Pages$Pos$Passenger$ApplyRefill$applyRefill(
											{mg: refill.mg, mm: refill.mm, j4: refill.o9, di: refill.di}),
										$author$project$Shared$NoOp);
								} else {
									return A2(
										$author$project$Utils$mapThird,
										function (_v10) {
											return $author$project$Shared$Batch(
												_List_fromArray(
													[
														$author$project$Shared$ShowSuccessDialog('Operação realizada com sucesso!'),
														$author$project$Shared$RedirectPreserve(
														A2($author$project$Route$Passenger, passenger.dM, 0))
													]));
										},
										A2($author$project$Pages$Pos$Passenger$ApplyRefill$init, user, passenger));
								}
							case 1:
								if (!loop.a.$) {
									var receipt = loop.a.a;
									return _Utils_Tuple3(
										$author$project$Pages$Pos$Passenger$ApplyRefill$Apply(
											_Utils_update(
												state,
												{fA: false})),
										$author$project$Services$Concessionaire$applyRefill(
											{
												lq: state.e8,
												ow: A2($elm$core$Basics$composeL, $author$project$Pages$Pos$Passenger$ApplyRefill$Loop, $author$project$Pages$Pos$Passenger$ApplyRefill$LoopRecvUpdate),
												oM: passenger.dM,
												ph: receipt,
												pm: state.fn.dM,
												kU: user.kU
											}),
										$author$project$Shared$NoOp);
								} else {
									var errStr = loop.a.a;
									if (A2($elm$core$String$contains, 'sw: 6807', errStr)) {
										var $temp$msg = $author$project$Pages$Pos$Passenger$ApplyRefill$Loop($author$project$Pages$Pos$Passenger$ApplyRefill$LoopStart),
											$temp$model = model,
											$temp$shared = shared,
											$temp$user = user,
											$temp$passenger = passenger;
										msg = $temp$msg;
										model = $temp$model;
										shared = $temp$shared;
										user = $temp$user;
										passenger = $temp$passenger;
										continue update;
									} else {
										return A2(
											$author$project$Utils$mapThird,
											function (_v11) {
												return $author$project$Shared$ShowErrorDialog('Falha ao se comunicar com o plugin: ' + errStr);
											},
											A2($author$project$Pages$Pos$Passenger$ApplyRefill$init, user, passenger));
									}
								}
							default:
								var res = loop.a;
								if (!res.$) {
									var $temp$msg = $author$project$Pages$Pos$Passenger$ApplyRefill$Loop($author$project$Pages$Pos$Passenger$ApplyRefill$LoopStart),
										$temp$model = model,
										$temp$shared = shared,
										$temp$user = user,
										$temp$passenger = passenger;
									msg = $temp$msg;
									model = $temp$model;
									shared = $temp$shared;
									user = $temp$user;
									passenger = $temp$passenger;
									continue update;
								} else {
									return A2(
										$author$project$Utils$mapThird,
										function (_v13) {
											return $author$project$Shared$ShowErrorDialog('Falha ao atualizar valor');
										},
										A2($author$project$Pages$Pos$Passenger$ApplyRefill$init, user, passenger));
								}
						}
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
					}
			}
		}
	});
var $author$project$Pages$Pos$Passenger$IssueCard$GotPassengerToPrint = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Pos$Passenger$IssueCard$Issued = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Pos$Passenger$IssueCard$IssuedCard = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Pos$Passenger$IssueCard$IssuingCard = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Pos$Passenger$IssueCard$Print = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Pos$Passenger$IssueCard$ReceivedSerialValidation = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Pages$Pos$Passenger$IssueCard$ReceivedUUID = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Pos$Passenger$IssueCard$ValidateCard = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Pos$Passenger$IssueCard$ValidateCardAgain = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Pos$Passenger$IssueCard$ValidateSerialBackend = function (a) {
	return {$: 6, a: a};
};
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $CurrySoftware$elm_datepicker$DatePicker$formatCell = function (day) {
	return $elm$html$Html$text(day);
};
var $CurrySoftware$elm_datepicker$DatePicker$Date$formatDay = function (day) {
	switch (day) {
		case 0:
			return 'Mo';
		case 1:
			return 'Tu';
		case 2:
			return 'We';
		case 3:
			return 'Th';
		case 4:
			return 'Fr';
		case 5:
			return 'Sa';
		default:
			return 'Su';
	}
};
var $CurrySoftware$elm_datepicker$DatePicker$Date$formatMonth = function (month) {
	switch (month) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $CurrySoftware$elm_datepicker$DatePicker$Date$Off = {$: 0};
var $CurrySoftware$elm_datepicker$DatePicker$off = $CurrySoftware$elm_datepicker$DatePicker$Date$Off;
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$required = $elm$html$Html$Attributes$boolProperty('required');
var $CurrySoftware$elm_datepicker$DatePicker$defaultSettings = {
	f3: $CurrySoftware$elm_datepicker$DatePicker$formatCell,
	dt: $CurrySoftware$elm_datepicker$DatePicker$off,
	cJ: 'elm-datepicker--',
	f8: _List_Nil,
	mt: $justinmimbs$date$Date$format('yyyy-MM-dd'),
	gf: $CurrySoftware$elm_datepicker$DatePicker$Date$formatDay,
	eK: 6,
	je: _List_fromArray(
		[
			$elm$html$Html$Attributes$required(false)
		]),
	gG: _List_Nil,
	gI: $elm$core$Maybe$Nothing,
	gJ: $elm$core$Maybe$Nothing,
	eU: $elm$core$Basics$always(false),
	gX: $CurrySoftware$elm_datepicker$DatePicker$Date$formatMonth,
	oL: $justinmimbs$date$Date$fromIsoString,
	hh: 'Please pick a date...',
	hS: $elm$core$String$fromInt
};
var $author$project$Pages$Pos$Passenger$IssueCard$datePickerSettings = function () {
	var settings = $CurrySoftware$elm_datepicker$DatePicker$defaultSettings;
	return _Utils_update(
		settings,
		{
			mt: A2($elm$core$Basics$composeR, $justinmimbs$date$Date$toIsoString, $author$project$Utils$formatDate),
			je: _Utils_ap(settings.je, _List_Nil),
			oL: A2(
				$elm$core$Basics$composeR,
				$elm$core$String$split('/'),
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$reverse,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$String$join('-'),
						A2(
							$elm$core$Basics$composeR,
							$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Result$map(
									$justinmimbs$date$Date$fromPosix($elm$time$Time$utc)),
								$elm$core$Result$mapError(
									function (_v0) {
										return 'Invalid Date';
									})))))),
			hh: 'Selecione uma data de vencimento'
		});
}();
var $author$project$Ports$issueCard = _Platform_outgoingPort(
	'issueCard',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'classes',
					$elm$json$Json$Encode$list($elm$json$Json$Encode$int)($.dv)),
					_Utils_Tuple2(
					'validity',
					$elm$json$Json$Encode$string($.qC))
				]));
	});
var $danyx23$elm_uuid$Uuid$toString = function (_v0) {
	var internalString = _v0;
	return internalString;
};
var $author$project$Services$Concessionaire$issueCard = function (options) {
	var encode = $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'serial',
				$elm$json$Json$Encode$string(options.kw)),
				_Utils_Tuple2(
				'transactionId',
				$elm$json$Json$Encode$string(
					$danyx23$elm_uuid$Uuid$toString(options.qA))),
				_Utils_Tuple2(
				'validity',
				$elm$json$Json$Encode$string(options.qC))
			]));
	return $elm$http$Http$request(
		{
			lG: $elm$http$Http$jsonBody(encode),
			m9: $author$project$Services$Api$expectWhatever(options.ow),
			nG: _List_fromArray(
				[
					$author$project$Services$Api$authorizationHeader(options.kU)
				]),
			of: 'PATCH',
			p5: $elm$core$Maybe$Nothing,
			qi: $elm$core$Maybe$Nothing,
			qt: A2(
				$author$project$Constants$concessionaireServiceUrl,
				_List_fromArray(
					['api', 'v1', 'passenger', options.oM, 'scards', options.lM]),
				_List_Nil)
		});
};
var $author$project$Ports$printCard = _Platform_outgoingPort(
	'printCard',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'cpf',
					$elm$json$Json$Encode$string($.aS)),
					_Utils_Tuple2(
					'image',
					$elm$json$Json$Encode$string($.nM)),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string($.c3))
				]));
	});
var $author$project$Pages$Pos$Passenger$IssueCard$takeCardClasses = function (card) {
	return $elm$core$List$concat(
		A2(
			$elm$core$List$map,
			function ($) {
				return $.dv;
			},
			card.hO));
};
var $CurrySoftware$elm_datepicker$DatePicker$Disabled = function (a) {
	return {$: 2, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$EmptyString = {$: 1};
var $CurrySoftware$elm_datepicker$DatePicker$FailedInput = function (a) {
	return {$: 1, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$Invalid = function (a) {
	return {$: 0, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$None = {$: 0};
var $CurrySoftware$elm_datepicker$DatePicker$Picked = function (a) {
	return {$: 2, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$update = F3(
	function (settings, msg, _v0) {
		var model = _v0;
		var forceOpen = model.bo;
		var focused = model._;
		switch (msg.$) {
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							_: $elm$core$Maybe$Just(date),
							ef: date
						}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			case 1:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							_: $elm$core$Maybe$Just(date)
						}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			case 2:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{_: $elm$core$Maybe$Nothing, aA: $elm$core$Maybe$Nothing, jJ: false}),
					$CurrySoftware$elm_datepicker$DatePicker$Picked(date));
			case 3:
				var text = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aA: $elm$core$Maybe$Just(text)
						}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			case 4:
				if (forceOpen) {
					return _Utils_Tuple2(model, $CurrySoftware$elm_datepicker$DatePicker$None);
				} else {
					var dateEvent = function () {
						var _v5 = model.aA;
						if (_v5.$ === 1) {
							return $CurrySoftware$elm_datepicker$DatePicker$FailedInput($CurrySoftware$elm_datepicker$DatePicker$EmptyString);
						} else {
							if (_v5.a === '') {
								return $CurrySoftware$elm_datepicker$DatePicker$FailedInput($CurrySoftware$elm_datepicker$DatePicker$EmptyString);
							} else {
								var rawInput = _v5.a;
								var _v6 = settings.oL(rawInput);
								if (!_v6.$) {
									var date = _v6.a;
									return settings.eU(date) ? $CurrySoftware$elm_datepicker$DatePicker$FailedInput(
										$CurrySoftware$elm_datepicker$DatePicker$Disabled(date)) : $CurrySoftware$elm_datepicker$DatePicker$Picked(date);
								} else {
									var e = _v6.a;
									return $CurrySoftware$elm_datepicker$DatePicker$FailedInput(
										$CurrySoftware$elm_datepicker$DatePicker$Invalid(e));
								}
							}
						}
					}();
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								_: function () {
									if (dateEvent.$ === 2) {
										var date = dateEvent.a;
										return $elm$core$Maybe$Just(date);
									} else {
										return model._;
									}
								}(),
								aA: function () {
									if (dateEvent.$ === 2) {
										return $elm$core$Maybe$Nothing;
									} else {
										return model.aA;
									}
								}()
							}),
						dateEvent);
				}
			case 5:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bo: false, jJ: true}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			case 6:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{jJ: forceOpen}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			case 7:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bo: true}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bo: false}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
		}
	});
var $author$project$Pages$Pos$Passenger$IssueCard$update = F6(
	function (msg, maybeSelectedCard, model, shared, user, passenger) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$Pages$Pos$Passenger$IssueCard$SharedMsg($author$project$Shared$NoOp));
			case 1:
				return A3($author$project$Pages$Pos$Passenger$IssueCard$init, maybeSelectedCard, user, passenger);
			case 2:
				var newCard = msg.a;
				if ($author$project$Pages$Pos$Passenger$IssueCard$isCardValidToIssue(newCard)) {
					var _v1 = $CurrySoftware$elm_datepicker$DatePicker$init;
					var datePicker = _v1.a;
					var datePickerFx = _v1.b;
					return _Utils_Tuple3(
						$author$project$Pages$Pos$Passenger$IssueCard$SelectExpiration(
							{cH: newCard, cO: $elm$core$Maybe$Nothing, cP: datePicker}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Pos$Passenger$IssueCard$GotDatePickerMsg, datePickerFx),
						$author$project$Pages$Pos$Passenger$IssueCard$SharedMsg($author$project$Shared$NoOp));
				} else {
					return _Utils_Tuple3(
						$author$project$Pages$Pos$Passenger$IssueCard$CardAlreadyIssued,
						$elm$core$Platform$Cmd$none,
						$author$project$Pages$Pos$Passenger$IssueCard$SharedMsg(
							$author$project$Shared$ShowErrorDialog('Não é possível emitir um cartão já emitido!')));
				}
			case 3:
				if (model.$ === 8) {
					var model_ = model.a;
					return _Utils_Tuple3(
						$author$project$Pages$Pos$Passenger$IssueCard$Print(
							{cH: model_.cH, cO: model_.cO, d3: false}),
						$elm$core$Platform$Cmd$none,
						$author$project$Pages$Pos$Passenger$IssueCard$SharedMsg($author$project$Shared$NoOp));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Pages$Pos$Passenger$IssueCard$SharedMsg(
							$author$project$Shared$ShowErrorDialog('Algo deu errado no msg <ClickedReturnToPassenger>')));
				}
			case 4:
				var subMsg = msg.a;
				if (model.$ === 2) {
					var model_ = model.a;
					var _v4 = A3($CurrySoftware$elm_datepicker$DatePicker$update, $author$project$Pages$Pos$Passenger$IssueCard$datePickerSettings, subMsg, model_.cP);
					var newDatePicker = _v4.a;
					var dateEvent = _v4.b;
					var newDate = function () {
						if (dateEvent.$ === 2) {
							var changedDate = dateEvent.a;
							return $elm$core$Maybe$Just(changedDate);
						} else {
							return model_.cO;
						}
					}();
					return _Utils_Tuple3(
						$author$project$Pages$Pos$Passenger$IssueCard$SelectExpiration(
							_Utils_update(
								model_,
								{cO: newDate, cP: newDatePicker})),
						$elm$core$Platform$Cmd$none,
						$author$project$Pages$Pos$Passenger$IssueCard$SharedMsg($author$project$Shared$NoOp));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Pages$Pos$Passenger$IssueCard$SharedMsg($author$project$Shared$NoOp));
				}
			case 5:
				if (model.$ === 2) {
					var model_ = model.a;
					var _v7 = _Utils_Tuple2(
						model_.cO,
						$justinmimbs$date$Date$fromIsoString('2148-12-31'));
					if ((!_v7.a.$) && (!_v7.b.$)) {
						var date = _v7.a.a;
						var dateLimit = _v7.b.a;
						return (A3($justinmimbs$date$Date$diff, 3, date, dateLimit) < 0) ? _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$Pages$Pos$Passenger$IssueCard$SharedMsg(
								$author$project$Shared$ShowErrorDialog('Data limite de vencimento é 31/12/2148.'))) : _Utils_Tuple3(
							$author$project$Pages$Pos$Passenger$IssueCard$ValidateCard(
								{cH: model_.cH, cO: date, ek: false}),
							$elm$core$Platform$Cmd$none,
							$author$project$Pages$Pos$Passenger$IssueCard$SharedMsg($author$project$Shared$NoOp));
					} else {
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$Pages$Pos$Passenger$IssueCard$SharedMsg($author$project$Shared$NoOp));
					}
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Pages$Pos$Passenger$IssueCard$SharedMsg($author$project$Shared$NoOp));
				}
			case 6:
				if (model.$ === 3) {
					var model_ = model.a;
					return _Utils_Tuple3(
						$author$project$Pages$Pos$Passenger$IssueCard$ValidateCard(
							{cH: model_.cH, cO: model_.cO, ek: true}),
						$elm$core$Platform$Cmd$none,
						$author$project$Pages$Pos$Passenger$IssueCard$SharedMsg($author$project$Shared$NoOp));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Pages$Pos$Passenger$IssueCard$SharedMsg($author$project$Shared$NoOp));
				}
			case 7:
				if (model.$ === 3) {
					var model_ = model.a;
					return _Utils_Tuple3(
						$author$project$Pages$Pos$Passenger$IssueCard$ValidateCardAgain(
							{cH: model_.cH, cO: model_.cO}),
						$elm$core$Platform$Cmd$none,
						$author$project$Pages$Pos$Passenger$IssueCard$SharedMsg($author$project$Shared$NoOp));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Pages$Pos$Passenger$IssueCard$SharedMsg($author$project$Shared$NoOp));
				}
			case 8:
				return _Utils_Tuple3(
					model,
					A2(
						$elm$core$Task$attempt,
						$author$project$Pages$Pos$Passenger$IssueCard$GotPassengerToPrint,
						$author$project$Services$Concessionaire$getPassengerInfo(
							{oM: passenger.dM, kU: user.kU})),
					$author$project$Pages$Pos$Passenger$IssueCard$SharedMsg($author$project$Shared$NoOp));
			case 9:
				var res = msg.a;
				var pass = A2($elm$core$Result$withDefault, passenger, res);
				return _Utils_Tuple3(
					function () {
						if (model.$ === 4) {
							var model_ = model.a;
							return $author$project$Pages$Pos$Passenger$IssueCard$Print(
								_Utils_update(
									model_,
									{d3: true}));
						} else {
							return model;
						}
					}(),
					$author$project$Ports$printCard(
						{
							aS: $author$project$Utils$maskCPF(pass.iI),
							nM: pass.nM,
							c3: pass.c3
						}),
					$author$project$Pages$Pos$Passenger$IssueCard$SharedMsg($author$project$Shared$NoOp));
			case 10:
				return _Utils_Tuple3(
					model,
					A2(
						$author$project$Route$pushUrl,
						shared.nZ,
						A2($author$project$Route$Passenger, passenger.dM, 0)),
					$author$project$Pages$Pos$Passenger$IssueCard$SharedMsg($author$project$Shared$CloseDialog));
			case 11:
				var serial = msg.a;
				if (model.$ === 5) {
					var model_ = model.a;
					return _Utils_Tuple3(
						$author$project$Pages$Pos$Passenger$IssueCard$ValidateSerialBackend(model_),
						$author$project$Services$Concessionaire$getPassengerInfoBySerial(
							{
								ow: $author$project$Pages$Pos$Passenger$IssueCard$ReceivedSerialValidation(serial),
								kw: serial,
								kU: user.kU
							}),
						$author$project$Pages$Pos$Passenger$IssueCard$SharedMsg($author$project$Shared$NoOp));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Pages$Pos$Passenger$IssueCard$SharedMsg($author$project$Shared$NoOp));
				}
			case 12:
				if (!msg.b.$) {
					var serial = msg.a;
					if (model.$ === 6) {
						var model_ = model.a;
						return _Utils_Tuple3(
							$author$project$Pages$Pos$Passenger$IssueCard$ValidateCardAgain(
								{cH: model_.cH, cO: model_.cO}),
							$elm$core$Platform$Cmd$none,
							$author$project$Pages$Pos$Passenger$IssueCard$SharedMsg(
								$author$project$Shared$ShowErrorDialog('Este serial já foi usado')));
					} else {
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$Pages$Pos$Passenger$IssueCard$SharedMsg($author$project$Shared$NoOp));
					}
				} else {
					var serial = msg.a;
					if (model.$ === 6) {
						var model_ = model.a;
						return _Utils_Tuple3(
							$author$project$Pages$Pos$Passenger$IssueCard$IssuingCard(
								{cH: model_.cH, cO: model_.cO, kw: serial}),
							$author$project$Ports$issueCard(
								{
									dv: A2(
										$elm$core$List$map,
										function ($) {
											return $.lY;
										},
										$author$project$Pages$Pos$Passenger$IssueCard$takeCardClasses(model_.cH)),
									qC: $author$project$Utils$formatDate(
										$justinmimbs$date$Date$toIsoString(model_.cO))
								}),
							$author$project$Pages$Pos$Passenger$IssueCard$SharedMsg($author$project$Shared$CloseDialog));
					} else {
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$Pages$Pos$Passenger$IssueCard$SharedMsg($author$project$Shared$NoOp));
					}
				}
			case 13:
				if (!msg.a.$) {
					return _Utils_Tuple3(
						model,
						A2($elm$random$Random$generate, $author$project$Pages$Pos$Passenger$IssueCard$ReceivedUUID, $danyx23$elm_uuid$Uuid$uuidGenerator),
						$author$project$Pages$Pos$Passenger$IssueCard$SharedMsg($author$project$Shared$NoOp));
				} else {
					var error = msg.a.a;
					if (model.$ === 7) {
						var model_ = model.a;
						return _Utils_Tuple3(
							$author$project$Pages$Pos$Passenger$IssueCard$ValidateCardAgain(
								{cH: model_.cH, cO: model_.cO}),
							$elm$core$Platform$Cmd$none,
							$author$project$Pages$Pos$Passenger$IssueCard$SharedMsg(
								$author$project$Shared$ShowErrorDialog(error)));
					} else {
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$Pages$Pos$Passenger$IssueCard$SharedMsg($author$project$Shared$NoOp));
					}
				}
			case 14:
				var uuid = msg.a;
				if (model.$ === 7) {
					var model_ = model.a;
					return _Utils_Tuple3(
						$author$project$Pages$Pos$Passenger$IssueCard$IssuingCard(
							{cH: model_.cH, cO: model_.cO, kw: model_.kw}),
						$author$project$Services$Concessionaire$issueCard(
							{
								lM: model_.cH.dM,
								ow: $author$project$Pages$Pos$Passenger$IssueCard$Issued,
								oM: passenger.dM,
								kw: model_.kw,
								kU: user.kU,
								qA: uuid,
								qC: $author$project$Utils$formatDate(
									$justinmimbs$date$Date$toIsoString(model_.cO))
							}),
						$author$project$Pages$Pos$Passenger$IssueCard$SharedMsg($author$project$Shared$NoOp));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Pages$Pos$Passenger$IssueCard$SharedMsg($author$project$Shared$NoOp));
				}
			default:
				if (!msg.a.$) {
					if (model.$ === 7) {
						var m_ = model.a;
						return _Utils_Tuple3(
							$author$project$Pages$Pos$Passenger$IssueCard$IssuedCard(
								{cH: m_.cH, cO: m_.cO}),
							$elm$core$Platform$Cmd$none,
							$author$project$Pages$Pos$Passenger$IssueCard$SharedMsg($author$project$Shared$NoOp));
					} else {
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$Pages$Pos$Passenger$IssueCard$SharedMsg($author$project$Shared$NoOp));
					}
				} else {
					var error = msg.a.a;
					if (model.$ === 7) {
						var model_ = model.a;
						return _Utils_Tuple3(
							$author$project$Pages$Pos$Passenger$IssueCard$ValidateCardAgain(
								{cH: model_.cH, cO: model_.cO}),
							$elm$core$Platform$Cmd$none,
							$author$project$Pages$Pos$Passenger$IssueCard$SharedMsg(
								A2($author$project$Shared$updateApiError, shared, error)));
					} else {
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$Pages$Pos$Passenger$IssueCard$SharedMsg($author$project$Shared$NoOp));
					}
				}
		}
	});
var $author$project$Pages$Pos$Passenger$IssueDuplicate$IssueDuplicate = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Pos$Passenger$IssueDuplicate$LoadingReasons = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Pos$Passenger$IssueDuplicate$ReceivedReasons = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Pos$Passenger$IssueDuplicate$RecvSubmit = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Pos$Passenger$IssueDuplicate$SharedMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Shared$ShowSuccessDialogWithLoadPage = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Pos$Passenger$IssueDuplicate$SubmitWithUuid = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Pos$Passenger$IssueDuplicate$UpdatePassenger = function (a) {
	return {$: 1, a: a};
};
var $author$project$Services$Reason$getReasonsByAction = function (options) {
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$elm$json$Json$Decode$list($author$project$Services$Reason$decodeReason)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					[
						'api',
						'reason',
						'getReasonByAction',
						$author$project$Services$Reason$actionToCode(options.hV)
					]),
				_List_Nil)
		});
};
var $author$project$Constants$walletServiceUrl = $elm$url$Url$Builder$crossOrigin('https://wallet.pazze.app');
var $author$project$Services$Wallet$issueDuplicate = function (options) {
	var encode = $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'concessionaireId',
				$elm$json$Json$Encode$string(options.mc)),
				_Utils_Tuple2(
				'module',
				$elm$json$Json$Encode$string('guiche')),
				_Utils_Tuple2(
				'userId',
				$elm$json$Json$Encode$string(options.qw)),
				_Utils_Tuple2(
				'transactionId',
				$elm$json$Json$Encode$string(
					$danyx23$elm_uuid$Uuid$toString(options.qj))),
				_Utils_Tuple2(
				'reasonId',
				$elm$json$Json$Encode$string(options.pg))
			]));
	return $elm$http$Http$request(
		{
			lG: $elm$http$Http$jsonBody(encode),
			m9: $author$project$Services$Api$expectWhatever(options.ow),
			nG: _List_fromArray(
				[
					$author$project$Services$Api$authorizationHeader(options.kU)
				]),
			of: 'POST',
			p5: $elm$core$Maybe$Nothing,
			qi: $elm$core$Maybe$Nothing,
			qt: A2(
				$author$project$Constants$walletServiceUrl,
				_List_fromArray(
					['api', 'v1', 'cards', 'second']),
				_List_Nil)
		});
};
var $author$project$Pages$Pos$Passenger$IssueDuplicate$update = F5(
	function (msg, model, shared, user, passenger) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(
					$author$project$Pages$Pos$Passenger$IssueDuplicate$DisplayCards,
					$elm$core$Platform$Cmd$none,
					$author$project$Pages$Pos$Passenger$IssueDuplicate$SharedMsg($author$project$Shared$NoOp));
			case 1:
				var card = msg.a;
				if (!model.$) {
					return (card.ml === '') ? _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Pages$Pos$Passenger$IssueDuplicate$SharedMsg(
							$author$project$Shared$ShowErrorDialog('Este cartão não tem criptograma.'))) : _Utils_Tuple3(
						$author$project$Pages$Pos$Passenger$IssueDuplicate$LoadingReasons(card),
						$author$project$Services$Reason$getReasonsByAction(
							{hV: 2, ow: $author$project$Pages$Pos$Passenger$IssueDuplicate$ReceivedReasons, kU: user.kU}),
						$author$project$Pages$Pos$Passenger$IssueDuplicate$SharedMsg($author$project$Shared$NoOp));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Pages$Pos$Passenger$IssueDuplicate$SharedMsg($author$project$Shared$NoOp));
				}
			case 2:
				if (msg.a.$ === 3) {
					var reasons = msg.a.a;
					if (model.$ === 1) {
						var card = model.a;
						return _Utils_Tuple3(
							$author$project$Pages$Pos$Passenger$IssueDuplicate$IssueDuplicate(
								{cH: card, d5: reasons, d8: $elm$core$Maybe$Nothing, q: $krisajenkins$remotedata$RemoteData$NotAsked}),
							$elm$core$Platform$Cmd$none,
							$author$project$Pages$Pos$Passenger$IssueDuplicate$SharedMsg($author$project$Shared$CloseDialog));
					} else {
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$Pages$Pos$Passenger$IssueDuplicate$SharedMsg($author$project$Shared$NoOp));
					}
				} else {
					var result = msg.a;
					return A2(
						$author$project$Utils$mapThird,
						function (_v3) {
							return $author$project$Pages$Pos$Passenger$IssueDuplicate$SharedMsg(
								A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, result));
						},
						A2($author$project$Pages$Pos$Passenger$IssueDuplicate$init, user, passenger));
				}
			case 3:
				var reason = msg.a;
				if (model.$ === 2) {
					var model_ = model.a;
					return _Utils_Tuple3(
						$author$project$Pages$Pos$Passenger$IssueDuplicate$IssueDuplicate(
							_Utils_update(
								model_,
								{
									d8: $elm$core$Maybe$Just(reason.dM)
								})),
						$elm$core$Platform$Cmd$none,
						$author$project$Pages$Pos$Passenger$IssueDuplicate$SharedMsg($author$project$Shared$CloseDialog));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Pages$Pos$Passenger$IssueDuplicate$SharedMsg($author$project$Shared$NoOp));
				}
			case 4:
				return _Utils_Tuple3(
					model,
					A2($elm$random$Random$generate, $author$project$Pages$Pos$Passenger$IssueDuplicate$SubmitWithUuid, $danyx23$elm_uuid$Uuid$uuidGenerator),
					$author$project$Pages$Pos$Passenger$IssueDuplicate$SharedMsg($author$project$Shared$NoOp));
			case 5:
				var uuid = msg.a;
				if (model.$ === 2) {
					var model_ = model.a;
					var _v6 = model_.d8;
					if (!_v6.$) {
						var reasonID = _v6.a;
						return _Utils_Tuple3(
							$author$project$Pages$Pos$Passenger$IssueDuplicate$IssueDuplicate(
								_Utils_update(
									model_,
									{q: $krisajenkins$remotedata$RemoteData$Loading})),
							$author$project$Services$Wallet$issueDuplicate(
								{mc: passenger.mc, ow: $author$project$Pages$Pos$Passenger$IssueDuplicate$RecvSubmit, pg: reasonID, kU: user.kU, qj: uuid, qw: passenger.qw}),
							$author$project$Pages$Pos$Passenger$IssueDuplicate$SharedMsg($author$project$Shared$NoOp));
					} else {
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$Pages$Pos$Passenger$IssueDuplicate$SharedMsg($author$project$Shared$NoOp));
					}
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Pages$Pos$Passenger$IssueDuplicate$SharedMsg($author$project$Shared$NoOp));
				}
			default:
				if (!msg.a.$) {
					if (model.$ === 2) {
						var model_ = model.a;
						return A2(
							$author$project$Utils$mapThird,
							function (_v8) {
								return $author$project$Pages$Pos$Passenger$IssueDuplicate$UpdatePassenger(
									$elm$core$Maybe$Just(
										$author$project$Shared$ShowSuccessDialogWithLoadPage(
											{
												lJ: 'Ir para emissão de cartão',
												pv: A2($author$project$Route$Passenger, passenger.dM, 4),
												fD: 'Solicitação de 2a via emitida concluída!'
											})));
							},
							_Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp));
					} else {
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$Pages$Pos$Passenger$IssueDuplicate$UpdatePassenger($elm$core$Maybe$Nothing));
					}
				} else {
					var error = msg.a.a;
					if (model.$ === 2) {
						var model_ = model.a;
						return _Utils_Tuple3(
							$author$project$Pages$Pos$Passenger$IssueDuplicate$IssueDuplicate(
								_Utils_update(
									model_,
									{
										q: $krisajenkins$remotedata$RemoteData$Failure(error)
									})),
							$elm$core$Platform$Cmd$none,
							$author$project$Pages$Pos$Passenger$IssueDuplicate$SharedMsg(
								A2($author$project$Shared$updateApiError, shared, error)));
					} else {
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$Pages$Pos$Passenger$IssueDuplicate$SharedMsg(
								A2($author$project$Shared$updateApiError, shared, error)));
					}
				}
		}
	});
var $author$project$Pages$Pos$Passenger$RegisterBeneficiary$LoadingConcessionairesFailed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Pos$Passenger$RegisterBeneficiary$RecvSubmit = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Pos$Passenger$RegisterBeneficiary$Register = function (a) {
	return {$: 3, a: a};
};
var $author$project$Services$Concessionaire$registerBeneficiary = function (options) {
	return $elm$http$Http$request(
		{
			lG: $elm$http$Http$jsonBody(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'classes',
							A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, options.dv))
						]))),
			m9: $author$project$Services$Api$expectWhatever(options.ow),
			nG: _List_fromArray(
				[
					$author$project$Services$Api$authorizationHeader(options.kU)
				]),
			of: 'PUT',
			p5: $elm$core$Maybe$Nothing,
			qi: $elm$core$Maybe$Nothing,
			qt: A2(
				$author$project$Constants$walletServiceUrl,
				_List_fromArray(
					['api', 'v1', 'wallet', 'classes', 'user', options.oM]),
				_List_Nil)
		});
};
var $elm$core$Set$remove = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$remove, key, dict);
	});
var $author$project$Pages$Pos$Passenger$RegisterBeneficiary$update = F5(
	function (msg, model, shared, user, passenger) {
		switch (msg.$) {
			case 4:
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$Redirect(
						A2($author$project$Route$Passenger, passenger.dM, 0)));
			case 0:
				if (!msg.a.$) {
					var concessionaireClasses = msg.a.a;
					var passengerVirtualClasses = A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.hO;
								},
								A2(
									$elm$core$Basics$composeR,
									$elm$core$List$map(
										function ($) {
											return $.dv;
										}),
									A2(
										$elm$core$Basics$composeR,
										$elm$core$List$concat,
										$elm$core$List$map(
											function (c) {
												return {dM: c.dM, c3: c.c3};
											})))),
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									function ($) {
										return $.qE;
									},
									passenger.f0))));
					return _Utils_Tuple3(
						$author$project$Pages$Pos$Passenger$RegisterBeneficiary$Register(
							{
								dv: concessionaireClasses,
								B: $elm$core$Set$fromList(
									A2(
										$elm$core$List$filter,
										function (id) {
											return A2(
												$elm$core$List$any,
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.dM;
													},
													$elm$core$Basics$eq(id)),
												concessionaireClasses);
										},
										A2(
											$elm$core$List$map,
											function ($) {
												return $.dM;
											},
											passengerVirtualClasses))),
								q: $krisajenkins$remotedata$RemoteData$NotAsked
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						$author$project$Pages$Pos$Passenger$RegisterBeneficiary$LoadingConcessionairesFailed(error),
						$elm$core$Platform$Cmd$none,
						A2($author$project$Shared$updateApiError, shared, error));
				}
			case 1:
				var classId = msg.a;
				if (model.$ === 3) {
					var model_ = model.a;
					return _Utils_Tuple3(
						$author$project$Pages$Pos$Passenger$RegisterBeneficiary$Register(
							_Utils_update(
								model_,
								{
									B: A2($elm$core$Set$member, classId, model_.B) ? A2($elm$core$Set$remove, classId, model_.B) : A2($elm$core$Set$insert, classId, model_.B)
								})),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
				}
			case 2:
				if (model.$ === 3) {
					var model_ = model.a;
					return _Utils_Tuple3(
						$author$project$Pages$Pos$Passenger$RegisterBeneficiary$Register(
							_Utils_update(
								model_,
								{q: $krisajenkins$remotedata$RemoteData$Loading})),
						$author$project$Services$Concessionaire$registerBeneficiary(
							{
								dv: $elm$core$Set$toList(model_.B),
								ow: $author$project$Pages$Pos$Passenger$RegisterBeneficiary$RecvSubmit,
								oM: passenger.qw,
								kU: user.kU
							}),
						$author$project$Shared$CloseDialog);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$Redirect(
							A2($author$project$Route$Passenger, passenger.dM, 0)));
				}
			default:
				if (!msg.a.$) {
					if (model.$ === 3) {
						var model_ = model.a;
						return A2(
							$author$project$Utils$mapThird,
							function (_v4) {
								return $author$project$Shared$Redirect(
									A2($author$project$Route$Passenger, passenger.dM, 0));
							},
							A2($author$project$Pages$Pos$Passenger$RegisterBeneficiary$init, user, passenger));
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
					}
				} else {
					var error = msg.a.a;
					if (model.$ === 3) {
						var model_ = model.a;
						return _Utils_Tuple3(
							$author$project$Pages$Pos$Passenger$RegisterBeneficiary$Register(
								_Utils_update(
									model_,
									{
										q: $krisajenkins$remotedata$RemoteData$Failure(error)
									})),
							$elm$core$Platform$Cmd$none,
							A2($author$project$Shared$updateApiError, shared, error));
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
					}
				}
		}
	});
var $author$project$Pages$Pos$Passenger$SellSingleCharge$GotCreateSingleCharge = function (a) {
	return {$: 13, a: a};
};
var $author$project$Services$SingleCharge$SingleChargeResult = F4(
	function (id, createdAt, value, typeDescription) {
		return {ix: createdAt, dM: id, kX: typeDescription, di: value};
	});
var $author$project$Services$SingleCharge$decodeSingleChargeResult = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'typeDescription',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'value',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'createdAt',
			$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Services$SingleCharge$SingleChargeResult)))));
var $author$project$Services$SingleCharge$encodeCreateSingleCharge = function (options) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'typeID',
				$elm$json$Json$Encode$string(options.dg)),
				_Utils_Tuple2(
				'userID',
				$elm$json$Json$Encode$string(options.fL))
			]));
};
var $author$project$Services$SingleCharge$createSingleCharge = function (options) {
	return $author$project$Services$Api$postHttp(
		{
			lG: $elm$http$Http$jsonBody(
				$author$project$Services$SingleCharge$encodeCreateSingleCharge(options)),
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$author$project$Services$SingleCharge$decodeSingleChargeResult),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'extraCharges', 'createExtraCharge']),
				_List_Nil)
		});
};
var $author$project$Components$HTMLToPrint$SalesReceipt$singleChargeHtmlStr = F2(
	function (options, timezone) {
		var formatToMoney = function (value) {
			return $author$project$Utils$formatAsMoney(
				$elm$core$String$fromInt(value));
		};
		return '\n    <section style="font-family: Roboto, sans-serif; font-size: 0.5rem; font-weight: 700;">\n        <div style="display:flex;justify-content: space-between; font-size: 1rem; align-items: center;">\n            <p style="margin: 0;"><img style="width: 65px;" src="/images/pazze-logo-black.png"/></p>\n            <p style="margin: 0;">VIA CLIENTE</p>\n        </div>\n        <hr style="border-top: 1px dashed black"></hr>\n        <h1 style="text-align: center; font-size: 1rem; margin: 0;">' + (options.fD + ('</h1>\n        <hr style="border-top: 1px dashed black"></hr>\n        <h2 style="text-align: center; font-size: 0.7rem; margin: 0;">' + (options.ex + ('</h2>\n        <table style="font-weight: 700;font-size: 0.5rem;">\n            <tbody>\n                <tr>\n                    <td style="vertical-align: baseline";> End: </td>\n                    <td> ' + (options.ep + (' </td>\n                </tr>\n                <tr>\n                    <td style="vertical-align: baseline";>CNPJ: </td>\n                    <td>' + (options.ew + ('</td>\n                </tr>\n                <tr>\n                    <td style="vertical-align: baseline";>TEL: </td>\n                    <td>' + (A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $author$project$Utils$maskPhoneDDD)(options.fC) + ('</td>\n                </tr>\n            </tbody>\n        </table>\n        <hr style="border-top: 1px dashed black"></hr>\n        <table style="width: 100%; font-size: 0.7rem; font-weight: 700;">\n            <tbody>\n                <tr>\n                    <td>Data: ' + (A2($author$project$Utils$formatDateFromPosix, timezone, options.cO) + ('</td>\n                    <td style="text-align: end;">Hora: ' + (A2($author$project$Utils$formatHoursFromPosix, timezone, options.cO) + (' </td>\n                </tr>\n            </tbody>\n        </table>\n        <table style="font-weight: 700; font-size: 0.5rem;">\n            <tbody>\n                <tr>\n                    <td>Nome: </td>\n                    <td>' + (options.fg + ('</td>\n                </tr>\n                <tr>\n                    <td>Tipo da venda: </td>\n                    <td>' + (options.kX + ('</td>\n                </tr>\n                <tr>\n                    <td>Valor: </td>\n                    <td>' + (formatToMoney(options.lo) + (' </td>\n                </tr>\n            </tbody>\n        </table>\n        <hr style="border-top: 1px dashed black"></hr>\n        <p style="display:flex; flex-direction: column; margin-top: 0;">\n            <span>Operador</span>\n            <span>' + (options.fa + ('</span>\n        </p>\n        <p style="display:flex; flex-direction: column;">\n            <span>ID da Transação</span>\n            <span>' + (options.fH + '</span>\n        </p>\n    </section>\n     ')))))))))))))))))))))));
	});
var $author$project$Pages$Pos$Passenger$SellSingleCharge$update = F5(
	function (msg, model, shared, user, passenger) {
		var _v0 = _Utils_Tuple2(model.aY, msg);
		switch (_v0.b.$) {
			case 0:
				var _v1 = _v0.b;
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
			case 1:
				var _v2 = _v0.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aY: $author$project$Pages$Pos$Passenger$SellSingleCharge$ModalHidden}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$CloseDialog);
			case 10:
				var remoteData = _v0.b.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{fv: remoteData}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 11:
				var newTypeID = _v0.b.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dg: newTypeID}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 12:
				var _v3 = _v0.b;
				return _Utils_Tuple3(
					model,
					$author$project$Services$SingleCharge$createSingleCharge(
						{ow: $author$project$Pages$Pos$Passenger$SellSingleCharge$GotCreateSingleCharge, kU: user.kU, dg: model.dg, fL: model.fL}),
					$author$project$Shared$NoOp);
			case 13:
				var rd = _v0.b.a;
				switch (rd.$) {
					case 3:
						var result = rd.a;
						var receipt = {
							ep: user.ep,
							lo: result.di,
							ew: user.l3,
							ex: $author$project$Utils$getConcessionaire(user).c3,
							cO: result.ix,
							fa: user.qx,
							fg: passenger.c3,
							fC: user.jX,
							fD: 'RECIBO DE VENDA AVULSA',
							fH: result.dM,
							kX: result.kX
						};
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{aY: $author$project$Pages$Pos$Passenger$SellSingleCharge$ModalHidden}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$Batch(
								_List_fromArray(
									[
										$author$project$Shared$ShowSuccessDialog('Venda avulsa realizada com sucesso!'),
										$author$project$Shared$RedirectPreserve(
										A2($author$project$Route$Passenger, passenger.dM, 0)),
										$author$project$Shared$PrintHTML(
										A2($author$project$Components$HTMLToPrint$SalesReceipt$singleChargeHtmlStr, receipt, shared.kS))
									])));
					case 2:
						var error = rd.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$ShowErrorDialog(error));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
				}
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
		}
	});
var $author$project$Pages$Pos$Passenger$SellTicket$ModalConfirmation = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Pos$Passenger$SellTicket$ModalReceipt = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Pos$Passenger$SellTicket$ReceivedConfirmation = function (a) {
	return {$: 9, a: a};
};
var $author$project$Services$Concessionaire$GotSellCredit = function (transactionID) {
	return {fH: transactionID};
};
var $author$project$Services$Concessionaire$sellCredit = function (options) {
	var decodeSellCredit = A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'transactionId',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Services$Concessionaire$GotSellCredit));
	return $elm$http$Http$request(
		{
			lG: $elm$http$Http$jsonBody(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'value',
							$elm$json$Json$Encode$int(options.di)),
							_Utils_Tuple2(
							'walletClassId',
							$elm$json$Json$Encode$string(options.qI)),
							_Utils_Tuple2(
							'cashierTransactionType',
							$elm$json$Json$Encode$string(options.he)),
							_Utils_Tuple2(
							'transactionId',
							$elm$json$Json$Encode$string(
								$danyx23$elm_uuid$Uuid$toString(options.qA))),
							_Utils_Tuple2(
							'cardSerial',
							$elm$json$Json$Encode$string(options.lO))
						]))),
			m9: A2($author$project$Services$Api$expectJsonErrorString, options.ow, decodeSellCredit),
			nG: _List_fromArray(
				[
					$author$project$Services$Api$authorizationHeader(options.kU)
				]),
			of: 'POST',
			p5: $elm$core$Maybe$Nothing,
			qi: $elm$core$Maybe$Nothing,
			qt: A2(
				$author$project$Constants$concessionaireServiceUrl,
				_List_fromArray(
					['api', 'v1', 'passenger', options.oM, 'refill']),
				_List_Nil)
		});
};
var $author$project$Pages$Pos$Passenger$SellTicket$NoOp = {$: 0};
var $author$project$Pages$Pos$Passenger$SellTicket$availableWallets = F2(
	function (model, passenger) {
		return $elm$core$Dict$toList(
			$elm$core$Dict$fromList(
				$elm$core$List$concat(
					A2(
						$elm$core$List$map,
						function (wallet) {
							return A2(
								$elm$core$List$map,
								function (c) {
									return _Utils_Tuple2(c.dM, c.c3);
								},
								wallet.dv);
						},
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.hO;
								},
								$elm$core$List$head(
									A2(
										$elm$core$List$filter,
										function (card) {
											var _v0 = model.k.mk;
											if (!_v0.$) {
												if (!_v0.a.$) {
													var s = _v0.a.a;
													return _Utils_eq(card.dM, s);
												} else {
													var _v1 = _v0.a;
													return card.qE;
												}
											} else {
												return false;
											}
										},
										passenger.f0))))))));
	});
var $elm$browser$Browser$Dom$setViewport = _Browser_setViewport;
var $elm$core$String$trim = _String_trim;
var $author$project$Utils$sanitazedStringToFloat = function (string) {
	var _v0 = A2(
		$elm$core$Basics$composeL,
		A2(
			$elm$core$Basics$composeL,
			$elm$core$String$toFloat,
			A2($elm$core$String$replace, ',', '.')),
		$elm$core$String$trim)(string);
	if (!_v0.$) {
		var floatValue = _v0.a;
		return floatValue;
	} else {
		return 0.0;
	}
};
var $author$project$Utils$toFixed2 = function (stringfiedValue) {
	if (A2($elm$core$String$contains, '.', stringfiedValue)) {
		var _v0 = A2($elm$core$String$split, '.', stringfiedValue);
		if (_v0.b && _v0.b.b) {
			var prefix = _v0.a;
			var _v1 = _v0.b;
			var suffix = _v1.a;
			var formattedPrefix = prefix + '.';
			var _v2 = $elm$core$String$length(suffix);
			switch (_v2) {
				case 1:
					return A2(
						$elm$core$String$join,
						'',
						_List_fromArray(
							[formattedPrefix, suffix, '0']));
				case 2:
					return _Utils_ap(formattedPrefix, suffix);
				default:
					return _Utils_ap(
						formattedPrefix,
						A3($elm$core$String$slice, 0, 2, suffix));
			}
		} else {
			return stringfiedValue;
		}
	} else {
		return stringfiedValue + '.00';
	}
};
var $author$project$Utils$stringInputToFloat = A2(
	$elm$core$Basics$composeR,
	A2($elm$core$String$replace, ',', '.'),
	A2(
		$elm$core$Basics$composeR,
		$author$project$Utils$toFixed2,
		A2($elm$core$Basics$composeR, $elm$core$String$trim, $author$project$Utils$sanitazedStringToFloat)));
var $author$project$Pages$Pos$Passenger$SellTicket$validateForm = function (model) {
	var _v0 = model.aY;
	switch (_v0.$) {
		case 0:
			return A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Result$Ok(0),
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $elm$core$Result$Err),
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							$elm$core$Tuple$first,
							_List_fromArray(
								[
									_Utils_Tuple2(
									_Utils_eq(model.k.mk, $elm$core$Maybe$Nothing),
									'Selecione um destino de crédito.'),
									_Utils_Tuple2(model.k.eB === '', 'Informe o valor.'),
									_Utils_Tuple2(
									100000 < A2(
										$elm$core$Maybe$withDefault,
										0,
										$elm$core$String$toInt(model.k.eB)),
									'Valor não pode ser superior à R$ 1000'),
									_Utils_Tuple2(
									$author$project$Utils$stringInputToFloat(model.k.eB) <= 0,
									'Informe um valor válido.'),
									_Utils_Tuple2(
									_Utils_eq(model.k.lY, $elm$core$Maybe$Nothing),
									'Selecione a classe.'),
									_Utils_Tuple2(
									_Utils_eq(model.k.he, $elm$core$Maybe$Nothing),
									'Selecione a forma de pagamento.')
								])))));
		case 1:
			var receivedAmount = _v0.a.j7;
			return (receivedAmount === '') ? $elm$core$Result$Err('Informe o valor recebido.') : (($author$project$Utils$stringInputToFloat(receivedAmount) <= 0) ? $elm$core$Result$Err('Valor inválido.') : $elm$core$Result$Ok(0));
		default:
			var paymentDataFinal = _v0.a.jU;
			var receivedAmount = _v0.a.j7;
			return ((receivedAmount - paymentDataFinal.eB) >= 0) ? $elm$core$Result$Ok(0) : $elm$core$Result$Err('Valor a ser recebido menor que total a pagar.');
	}
};
var $author$project$Pages$Pos$Passenger$SellTicket$transitionModal = F6(
	function (model, user, shared, passenger, next, maybeSellCredit) {
		var _v0 = _Utils_Tuple2(
			$author$project$Pages$Pos$Passenger$SellTicket$validateForm(model),
			next);
		if ((_v0.a.$ === 1) && _v0.b) {
			var error = _v0.a.a;
			return _Utils_Tuple3(
				model,
				$elm$core$Platform$Cmd$none,
				$author$project$Shared$ShowErrorDialog(error));
		} else {
			var _v1 = _Utils_Tuple2(model.aY, next);
			if (_v1.b) {
				switch (_v1.a.$) {
					case 0:
						var _v2 = _v1.a;
						var _v3 = model;
						var paymentData = _v3.k;
						var _v4 = paymentData;
						var creditDestiny = _v4.mk;
						var paymentFormat = _v4.he;
						var classId = _v4.lY;
						var creditValue = _v4.eB;
						var maybeSerial = A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.kw;
							},
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									function (card) {
										var _v9 = _Utils_Tuple2(creditDestiny, card.qE);
										_v9$2:
										while (true) {
											if (!_v9.a.$) {
												if (!_v9.a.a.$) {
													if (!_v9.b) {
														return true;
													} else {
														break _v9$2;
													}
												} else {
													if (_v9.b) {
														var _v10 = _v9.a.a;
														return true;
													} else {
														break _v9$2;
													}
												}
											} else {
												break _v9$2;
											}
										}
										return false;
									},
									passenger.f0)));
						var _v5 = _Utils_Tuple3(
							model.qA,
							maybeSerial,
							_Utils_Tuple2(paymentFormat, classId));
						if ((((!_v5.a.$) && (!_v5.b.$)) && (!_v5.c.a.$)) && (!_v5.c.b.$)) {
							var uuid = _v5.a.a;
							var serial_ = _v5.b.a;
							var _v6 = _v5.c;
							var paymentFormat_ = _v6.a.a;
							var classId_ = _v6.b.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $author$project$Pages$Pos$Passenger$SellTicket$ModalReceipt(
											{
												jU: {
													lY: classId_,
													eB: A2(
														$elm$core$Maybe$withDefault,
														0,
														$elm$core$String$toInt(creditValue)),
													he: paymentFormat_,
													kw: serial_
												},
												j7: '',
												qA: uuid
											})
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2(
											$elm$core$Task$attempt,
											function (_v7) {
												return $author$project$Pages$Pos$Passenger$SellTicket$NoOp;
											},
											$elm$browser$Browser$Dom$focus('received-amount')),
											A2(
											$elm$core$Task$perform,
											function (_v8) {
												return $author$project$Pages$Pos$Passenger$SellTicket$NoOp;
											},
											A2($elm$browser$Browser$Dom$setViewport, 0, 0))
										])),
								$author$project$Shared$CloseDialog);
						} else {
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
						}
					case 1:
						var state = _v1.a.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $author$project$Pages$Pos$Passenger$SellTicket$ModalConfirmation(
										{
											bS: $krisajenkins$remotedata$RemoteData$NotAsked,
											jU: state.jU,
											j7: A2(
												$elm$core$Maybe$withDefault,
												0,
												$elm$core$String$toInt(state.j7)),
											qA: state.qA
										})
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$CloseDialog);
					default:
						var m = _v1.a.a;
						var getClass = $elm$core$List$head(
							A2(
								$elm$core$List$filterMap,
								function (_v11) {
									var id = _v11.a;
									var name = _v11.b;
									return _Utils_eq(
										id,
										A2($elm$core$Maybe$withDefault, '', model.k.lY)) ? $elm$core$Maybe$Just(name) : $elm$core$Maybe$Nothing;
								},
								A2($author$project$Pages$Pos$Passenger$SellTicket$availableWallets, model, passenger)));
						var receipt = {
							ep: user.ep,
							lo: m.jU.eB,
							fQ: m.j7,
							ia: m.jU.kw,
							ik: A2($elm$core$Maybe$withDefault, '-', getClass),
							ew: user.l3,
							ex: $author$project$Utils$getConcessionaire(user).c3,
							cO: model.e8,
							fa: user.qx,
							fg: passenger.c3,
							jW: A2(
								$elm$core$Maybe$withDefault,
								'-',
								A2($elm$core$Maybe$map, $author$project$Services$Models$paymentFormatToStr, model.k.he)),
							fC: user.jX,
							fD: 'RECIBO DE VENDA',
							fH: A2(
								$elm$core$Maybe$withDefault,
								'-',
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.fH;
									},
									maybeSellCredit))
						};
						return _Utils_Tuple3(
							$author$project$Pages$Pos$Passenger$SellTicket$initModel(passenger),
							A2($elm$random$Random$generate, $author$project$Pages$Pos$Passenger$SellTicket$ReceivedUUID, $danyx23$elm_uuid$Uuid$uuidGenerator),
							_Utils_eq(
								model.k.mk,
								$elm$core$Maybe$Just($author$project$Pages$Pos$Passenger$SellTicket$VirtualCard)) ? $author$project$Shared$Batch(
								_List_fromArray(
									[
										$author$project$Shared$ShowSuccessDialog('Pagamento realizado com sucesso!'),
										$author$project$Shared$RedirectPreserve(
										A2($author$project$Route$Passenger, passenger.dM, 0)),
										$author$project$Shared$PrintHTML(
										A2($author$project$Components$HTMLToPrint$SalesReceipt$htmlStr, receipt, shared.kS))
									])) : $author$project$Shared$Batch(
								_List_fromArray(
									[
										$author$project$Shared$ShowSuccessDialogWithRedirect(
										{
											lJ: 'Ir para Aplicar Carga',
											pv: A2($author$project$Route$Passenger, passenger.dM, 3),
											fD: 'Pagamento realizado com sucesso!'
										}),
										$author$project$Shared$RedirectPreserve(
										A2($author$project$Route$Passenger, passenger.dM, 0)),
										$author$project$Shared$PrintHTML(
										A2($author$project$Components$HTMLToPrint$SalesReceipt$htmlStr, receipt, shared.kS))
									])));
				}
			} else {
				if (_v1.a.$ === 2) {
					var state = _v1.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aY: $author$project$Pages$Pos$Passenger$SellTicket$ModalReceipt(
									{
										jU: state.jU,
										j7: $elm$core$String$fromInt(state.j7),
										qA: state.qA
									})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$CloseDialog);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
				}
			}
		}
	});
var $author$project$Pages$Pos$Passenger$SellTicket$update = F5(
	function (msg, model, shared, user, passenger) {
		var _v0 = _Utils_Tuple2(model.aY, msg);
		_v0$11:
		while (true) {
			switch (_v0.b.$) {
				case 0:
					var _v1 = _v0.b;
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
				case 1:
					var _v2 = _v0.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{aY: $author$project$Pages$Pos$Passenger$SellTicket$ModalHidden}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$CloseDialog);
				case 2:
					var now = _v0.b.a.e8;
					var timezone = _v0.b.a.kS;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{e8: now}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				case 3:
					switch (_v0.a.$) {
						case 0:
							var _v3 = _v0.a;
							var uuid = _v0.b.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										qA: $elm$core$Maybe$Just(uuid)
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						case 2:
							var m = _v0.a.a;
							var newUuid = _v0.b.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $author$project$Pages$Pos$Passenger$SellTicket$ModalConfirmation(
											_Utils_update(
												m,
												{qA: newUuid})),
										qA: $elm$core$Maybe$Just(newUuid)
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$NoOp);
						default:
							break _v0$11;
					}
				case 4:
					if (!_v0.a.$) {
						var _v4 = _v0.a;
						var newPaymentData = _v0.b.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{k: newPaymentData}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					} else {
						break _v0$11;
					}
				case 5:
					if (_v0.a.$ === 1) {
						var data = _v0.a.a;
						var str = _v0.b.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $author$project$Pages$Pos$Passenger$SellTicket$ModalReceipt(
										_Utils_update(
											data,
											{j7: str}))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					} else {
						break _v0$11;
					}
				case 6:
					var _v5 = _v0.b;
					return A6($author$project$Pages$Pos$Passenger$SellTicket$transitionModal, model, user, shared, passenger, true, $elm$core$Maybe$Nothing);
				case 7:
					var _v6 = _v0.b;
					return A6($author$project$Pages$Pos$Passenger$SellTicket$transitionModal, model, user, shared, passenger, false, $elm$core$Maybe$Nothing);
				case 8:
					if (_v0.a.$ === 2) {
						var data = _v0.a.a;
						var _v7 = _v0.b;
						var _v8 = _Utils_Tuple2(
							$author$project$Pages$Pos$Passenger$SellTicket$validateForm(model),
							!_Utils_eq(data.bS, $krisajenkins$remotedata$RemoteData$Loading));
						if (!_v8.a.$) {
							if (_v8.b) {
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $author$project$Pages$Pos$Passenger$SellTicket$ModalConfirmation(
												_Utils_update(
													data,
													{bS: $krisajenkins$remotedata$RemoteData$Loading}))
										}),
									$elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[
												A2($elm$random$Random$generate, $author$project$Pages$Pos$Passenger$SellTicket$ReceivedUUID, $danyx23$elm_uuid$Uuid$uuidGenerator),
												$author$project$Services$Concessionaire$sellCredit(
												{
													lO: data.jU.kw,
													ow: $author$project$Pages$Pos$Passenger$SellTicket$ReceivedConfirmation,
													oM: passenger.dM,
													he: $author$project$Services$Models$paymentFormatToCode(data.jU.he),
													kU: user.kU,
													qA: data.qA,
													di: data.jU.eB,
													qI: data.jU.lY
												})
											])),
									$author$project$Shared$NoOp);
							} else {
								return _Utils_Tuple3(
									model,
									$elm$core$Platform$Cmd$none,
									$author$project$Shared$ShowErrorDialog('Uma venda já está sendo processada. Por favor, aguarde a finalização!'));
							}
						} else {
							var error = _v8.a.a;
							return _Utils_Tuple3(
								model,
								$elm$core$Platform$Cmd$none,
								$author$project$Shared$ShowErrorDialog(error));
						}
					} else {
						break _v0$11;
					}
				default:
					if (_v0.a.$ === 2) {
						var data = _v0.a.a;
						var confirmation = _v0.b.a;
						if (!confirmation.$) {
							var sellCredit = confirmation.a;
							return A6(
								$author$project$Pages$Pos$Passenger$SellTicket$transitionModal,
								model,
								user,
								shared,
								passenger,
								true,
								$elm$core$Maybe$Just(sellCredit));
						} else {
							var error = confirmation.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aY: $author$project$Pages$Pos$Passenger$SellTicket$ModalConfirmation(
											_Utils_update(
												data,
												{
													bS: $krisajenkins$remotedata$RemoteData$Failure(error)
												}))
									}),
								$elm$core$Platform$Cmd$none,
								A2(
									$author$project$Shared$remoteDataSharedMsg,
									$elm$core$Maybe$Nothing,
									$krisajenkins$remotedata$RemoteData$fromResult(confirmation)));
						}
					} else {
						break _v0$11;
					}
			}
		}
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
	});
var $author$project$Pages$Pos$Passenger$UnlockCard$DetailsFraudEvidence = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Pos$Passenger$UnlockCard$GotFraudEvidence = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Pos$Passenger$UnlockCard$GotFraudEvidenceExport = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Pos$Passenger$UnlockCard$LoadingReasons = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Pos$Passenger$UnlockCard$LockUnlock = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Pos$Passenger$UnlockCard$ReceivedReasons = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Pos$Passenger$UnlockCard$RecvSubmit = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Pos$Passenger$UnlockCard$RecvSubmitOkWithDelay = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Pos$Passenger$UnlockCard$RecvUUID = function (a) {
	return {$: 9, a: a};
};
var $author$project$Shared$RedirectLoadPage = function (a) {
	return {$: 4, a: a};
};
var $elm$file$File$Download$bytes = F3(
	function (name, mime, content) {
		return A2(
			$elm$core$Task$perform,
			$elm$core$Basics$never,
			A3(
				_File_download,
				name,
				mime,
				_File_makeBytesSafeForInternetExplorer(content)));
	});
var $author$project$Services$Api$expectBytesError = function (response) {
	switch (response.$) {
		case 0:
			return $elm$core$Result$Err('Endereço inválido');
		case 1:
			return $elm$core$Result$Err('Tempo limite de resposta atingido. Verifique sua conexão.');
		case 2:
			return $elm$core$Result$Err('Não foi possível conectar ao servidor');
		case 3:
			var metadata = response.a;
			var body = response.b;
			return $elm$core$Result$Err('Ocorreu um erro no servidor');
		default:
			var m = response.a;
			var body = response.b;
			return $elm$core$Result$Ok(body);
	}
};
var $author$project$Services$Api$expectBytesErrorString = function (toMsg) {
	return A2($elm$http$Http$expectBytesResponse, toMsg, $author$project$Services$Api$expectBytesError);
};
var $author$project$Services$Passenger$fraudEvidenceExport = function (options) {
	return $author$project$Services$Api$postHttp(
		{
			lG: $elm$http$Http$emptyBody,
			m9: $author$project$Services$Api$expectBytesErrorString(
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'user', 'fraudEvidenceExport', options.h9]),
				_List_Nil)
		});
};
var $author$project$Services$Passenger$FraudEvidence = function (line) {
	return function (vehicleCode) {
		return function (profilePhoto) {
			return function (embeddedPhoto) {
				return function (eventDate) {
					return function (blockedBy) {
						return function (blockedAt) {
							return function (walletClass) {
								return function (walletClassType) {
									return function (cardSerial) {
										return function (similarity) {
											return function (userBlockedName) {
												return function (userBlockedDocument) {
													return {lC: blockedAt, lD: blockedBy, lO: cardSerial, mY: embeddedPhoto, m2: eventDate, e1: line, o5: profilePhoto, pI: similarity, qv: userBlockedDocument, k_: userBlockedName, em: vehicleCode, qH: walletClass, qK: walletClassType};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Services$Passenger$decodeFraudEvidence = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'userBlockedDocument',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'userBlockedName',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'similarity',
			$elm$json$Json$Decode$float,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'cardSerial',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'walletClassType',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'walletClass',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'blockedAt',
							$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'blockedBy',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'eventDate',
									$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'embeddedPhoto',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'profilePhoto',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'vehicleCode',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'line',
													$elm$json$Json$Decode$string,
													$elm$json$Json$Decode$succeed($author$project$Services$Passenger$FraudEvidence))))))))))))));
var $author$project$Services$Passenger$getFraudEvidence = function (options) {
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$author$project$Services$Passenger$decodeFraudEvidence),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'user', 'fraudEvidence', options.h9]),
				_List_Nil)
		});
};
var $author$project$Utils$mapSecond = F2(
	function (fn, _v0) {
		var a = _v0.a;
		var b = _v0.b;
		var c = _v0.c;
		return _Utils_Tuple3(
			a,
			fn(b),
			c);
	});
var $author$project$Services$Concessionaire$requestBlockOrUnBlockCard = function (options) {
	var encode = $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'userId',
				$elm$json$Json$Encode$string(options.qw)),
				_Utils_Tuple2(
				'transactionId',
				$elm$json$Json$Encode$string(
					$danyx23$elm_uuid$Uuid$toString(options.qj))),
				_Utils_Tuple2(
				'reasonId',
				$elm$json$Json$Encode$string(options.pg)),
				_Utils_Tuple2(
				'virtual',
				$elm$json$Json$Encode$bool(options.qE))
			]));
	var block_or_unblock = options.qo ? 'unblock' : 'block';
	return $elm$http$Http$request(
		{
			lG: $elm$http$Http$jsonBody(encode),
			m9: $author$project$Services$Api$expectWhatever(options.ow),
			nG: _List_fromArray(
				[
					$author$project$Services$Api$authorizationHeader(options.kU)
				]),
			of: 'POST',
			p5: $elm$core$Maybe$Nothing,
			qi: $elm$core$Maybe$Nothing,
			qt: A2(
				$author$project$Constants$concessionaireServiceUrl,
				_List_fromArray(
					['api', 'v1', 'cards', block_or_unblock]),
				_List_Nil)
		});
};
var $author$project$Pages$Pos$Passenger$UnlockCard$update = F5(
	function (msg, model, shared, user, passenger) {
		switch (msg.$) {
			case 0:
				return A2(
					$author$project$Utils$mapThird,
					function (_v1) {
						return $author$project$Shared$CloseDialog;
					},
					A2($author$project$Pages$Pos$Passenger$UnlockCard$init, user, passenger));
			case 1:
				var card = msg.a;
				if (!model.$) {
					var unblock = (!card.h7) || (card.h7 === 2);
					var action = function () {
						var _v3 = card.h7;
						switch (_v3) {
							case 0:
								return 0;
							case 2:
								return 0;
							case 1:
								return 1;
							default:
								return 1;
						}
					}();
					return _Utils_Tuple3(
						$author$project$Pages$Pos$Passenger$UnlockCard$LoadingReasons(
							{cH: card, qo: unblock}),
						$author$project$Services$Reason$getReasonsByAction(
							{hV: action, ow: $author$project$Pages$Pos$Passenger$UnlockCard$ReceivedReasons, kU: user.kU}),
						$author$project$Shared$NoOp);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
				}
			case 2:
				var card = msg.a;
				return _Utils_Tuple3(
					$author$project$Pages$Pos$Passenger$UnlockCard$DetailsFraudEvidence(
						{cH: card, eG: false, eJ: $krisajenkins$remotedata$RemoteData$Loading}),
					$author$project$Services$Passenger$getFraudEvidence(
						{h9: card.dM, ow: $author$project$Pages$Pos$Passenger$UnlockCard$GotFraudEvidence, kU: user.kU}),
					$author$project$Shared$NoOp);
			case 3:
				var rd = msg.a;
				if (model.$ === 3) {
					var model_ = model.a;
					return _Utils_Tuple3(
						$author$project$Pages$Pos$Passenger$UnlockCard$DetailsFraudEvidence(
							_Utils_update(
								model_,
								{eJ: rd})),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
				}
			case 4:
				var cardID = msg.a;
				if (model.$ === 3) {
					var model_ = model.a;
					return _Utils_Tuple3(
						$author$project$Pages$Pos$Passenger$UnlockCard$DetailsFraudEvidence(
							_Utils_update(
								model_,
								{eG: true})),
						$author$project$Services$Passenger$fraudEvidenceExport(
							{h9: cardID, ow: $author$project$Pages$Pos$Passenger$UnlockCard$GotFraudEvidenceExport, kU: user.kU}),
						$author$project$Shared$NoOp);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
				}
			case 5:
				var rd = msg.a;
				if (model.$ === 3) {
					var model_ = model.a;
					return _Utils_Tuple3(
						$author$project$Pages$Pos$Passenger$UnlockCard$DetailsFraudEvidence(
							_Utils_update(
								model_,
								{eG: false})),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(
									$krisajenkins$remotedata$RemoteData$withDefault,
									$elm$core$Platform$Cmd$none,
									A3(
										$krisajenkins$remotedata$RemoteData$map2,
										F2(
											function (bytes, evidence) {
												return A3($elm$file$File$Download$bytes, 'Evidência de ' + evidence.k_, 'application/pdf', bytes);
											}),
										rd,
										model_.eJ))
								])),
						A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rd));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
				}
			case 6:
				if (msg.a.$ === 3) {
					var reasons = msg.a.a;
					if (model.$ === 1) {
						var model_ = model.a;
						return _Utils_Tuple3(
							$author$project$Pages$Pos$Passenger$UnlockCard$LockUnlock(
								{cH: model_.cH, d5: reasons, d8: $elm$core$Maybe$Nothing, q: $krisajenkins$remotedata$RemoteData$NotAsked, qo: model_.qo}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$CloseDialog);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
					}
				} else {
					var remoteData = msg.a;
					return A2(
						$author$project$Utils$mapThird,
						function (_v8) {
							return A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, remoteData);
						},
						A2($author$project$Pages$Pos$Passenger$UnlockCard$init, user, passenger));
				}
			case 7:
				var reason = msg.a;
				if (model.$ === 2) {
					var model_ = model.a;
					return _Utils_Tuple3(
						$author$project$Pages$Pos$Passenger$UnlockCard$LockUnlock(
							_Utils_update(
								model_,
								{
									d8: $elm$core$Maybe$Just(reason.dM)
								})),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$CloseDialog);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
				}
			case 8:
				if (model.$ === 2) {
					var model_ = model.a;
					var _v11 = model_.d8;
					if (!_v11.$) {
						var reasonID = _v11.a;
						return _Utils_Tuple3(
							$author$project$Pages$Pos$Passenger$UnlockCard$LockUnlock(
								_Utils_update(
									model_,
									{q: $krisajenkins$remotedata$RemoteData$Loading})),
							A2(
								$elm$random$Random$generate,
								function (uuid) {
									return $author$project$Pages$Pos$Passenger$UnlockCard$RecvUUID(
										{j6: reasonID, qA: uuid});
								},
								$danyx23$elm_uuid$Uuid$uuidGenerator),
							$author$project$Shared$NoOp);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
				}
			case 9:
				var uuid = msg.a.qA;
				var reasonID = msg.a.j6;
				if (model.$ === 2) {
					var model_ = model.a;
					return _Utils_Tuple3(
						$author$project$Pages$Pos$Passenger$UnlockCard$LockUnlock(
							_Utils_update(
								model_,
								{q: $krisajenkins$remotedata$RemoteData$Loading})),
						$author$project$Services$Concessionaire$requestBlockOrUnBlockCard(
							{ow: $author$project$Pages$Pos$Passenger$UnlockCard$RecvSubmit, pg: reasonID, kU: user.kU, qj: uuid, qo: model_.qo, qw: passenger.qw, qE: model_.cH.qE}),
						$author$project$Shared$CloseDialog);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
				}
			case 11:
				var unblock = msg.a;
				var blockStr = unblock ? 'desbloqueio' : 'bloqueio';
				return A2(
					$author$project$Utils$mapThird,
					function (_v16) {
						return $author$project$Shared$ShowSuccessDialogWithRedirect(
							{
								lJ: 'Aplicar ' + blockStr,
								pv: A2($author$project$Route$Passenger, passenger.dM, 3),
								fD: 'Solicitação de ' + (blockStr + ' concluída!')
							});
					},
					A2($author$project$Pages$Pos$Passenger$UnlockCard$init, user, passenger));
			default:
				if (!msg.a.$) {
					if (model.$ === 2) {
						var model_ = model.a;
						var blockStr = model_.qo ? 'desbloqueio' : 'bloqueio';
						return model_.cH.qE ? A2(
							$author$project$Utils$mapThird,
							function (_v14) {
								return $author$project$Shared$Batch(
									_List_fromArray(
										[
											$author$project$Shared$ShowSuccessDialog('Solicitação de ' + (blockStr + ' concluída!')),
											$author$project$Shared$RedirectLoadPage(
											A2($author$project$Route$Passenger, passenger.dM, 7))
										]));
							},
							A2($author$project$Pages$Pos$Passenger$UnlockCard$init, user, passenger)) : A2(
							$author$project$Utils$mapSecond,
							function (_v15) {
								return A2(
									$author$project$Utils$delay,
									1000,
									$author$project$Pages$Pos$Passenger$UnlockCard$RecvSubmitOkWithDelay(model_.qo));
							},
							A2($author$project$Pages$Pos$Passenger$UnlockCard$init, user, passenger));
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
					}
				} else {
					var error = msg.a.a;
					if (model.$ === 2) {
						var model_ = model.a;
						return _Utils_Tuple3(
							$author$project$Pages$Pos$Passenger$UnlockCard$LockUnlock(
								_Utils_update(
									model_,
									{
										q: $krisajenkins$remotedata$RemoteData$Failure(error)
									})),
							$elm$core$Platform$Cmd$none,
							A2($author$project$Shared$updateApiError, shared, error));
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
					}
				}
		}
	});
var $author$project$Pages$Pos$Passenger$update = F5(
	function (passengerId, msg, model, shared, user) {
		switch (msg.$) {
			case 0:
				if (!msg.c.$) {
					var passengerId_ = msg.a;
					var route = msg.b;
					var passenger = msg.c.a;
					if (_Utils_eq(passengerId, passengerId_)) {
						var model_ = function () {
							if (model.$ === 2) {
								var lModel = model.a;
								return $author$project$Pages$Pos$Passenger$Loaded(
									_Utils_update(
										lModel,
										{j: passenger}));
							} else {
								return model;
							}
						}();
						return A5(
							$author$project$Pages$Pos$Passenger$init_,
							user,
							passengerId_,
							route,
							$elm$core$Maybe$Just(passenger),
							$elm$core$Maybe$Just(model_));
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
					}
				} else {
					var passengerId_ = msg.a;
					var route = msg.b;
					var error = msg.c.a;
					return _Utils_eq(passengerId, passengerId_) ? _Utils_Tuple3(
						A3($author$project$Pages$Pos$Passenger$LoadingFailed, passengerId_, route, error),
						$elm$core$Platform$Cmd$none,
						A2($author$project$Shared$updateApiError, shared, error)) : _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
				}
			case 1:
				var subMsg = msg.a;
				if (model.$ === 2) {
					var lModel = model.a;
					var _v3 = A5($author$project$Components$PassengerCard$update, lModel.j, subMsg, lModel.G, shared, user);
					var passengerCardModel = _v3.a;
					var passengerCardCmd = _v3.b;
					var sharedOutMsg = _v3.c;
					var update_ = function () {
						switch (sharedOutMsg.$) {
							case 0:
								return A2(
									$author$project$Utils$mapThird,
									function (s) {
										return $author$project$Shared$Batch(
											_List_fromArray(
												[
													s,
													$author$project$Shared$ShowSuccessDialog('Transferência realizada com sucesso!')
												]));
									},
									A4($author$project$Pages$Pos$Passenger$init, user, passengerId, 0, $elm$core$Maybe$Nothing));
							case 1:
								var cardID = sharedOutMsg.a;
								var _v5 = _Utils_Tuple2(
									lModel.bv,
									A2(
										$author$project$Pages$Pos$Passenger$getCardById,
										$elm$core$Maybe$Just(cardID),
										lModel.j.f0));
								if ((_v5.a.$ === 4) && (!_v5.b.$)) {
									var subModel = _v5.a.a;
									var newCard = _v5.b.a;
									var _v6 = A6(
										$author$project$Pages$Pos$Passenger$IssueCard$update,
										$author$project$Pages$Pos$Passenger$IssueCard$ChangedCard(newCard),
										passengerCardModel.dc,
										subModel,
										shared,
										user,
										lModel.j);
									var updtModel = _v6.a;
									var cmd = _v6.b;
									var sharedOutMsg_ = _v6.c;
									var sharedMsg = function () {
										if (!sharedOutMsg_.$) {
											return $author$project$Shared$NoOp;
										} else {
											var sharedMsg_ = sharedOutMsg_.a;
											return sharedMsg_;
										}
									}();
									return _Utils_Tuple3(
										$author$project$Pages$Pos$Passenger$Loaded(
											_Utils_update(
												lModel,
												{
													bv: $author$project$Pages$Pos$Passenger$IssueCard(updtModel),
													G: passengerCardModel
												})),
										$elm$core$Platform$Cmd$batch(
											_List_fromArray(
												[
													A2($elm$core$Platform$Cmd$map, $author$project$Pages$Pos$Passenger$GotIssueCardMsg, cmd),
													A2($elm$core$Platform$Cmd$map, $author$project$Pages$Pos$Passenger$GotPassengerCardMsg, passengerCardCmd)
												])),
										sharedMsg);
								} else {
									return _Utils_Tuple3(
										$author$project$Pages$Pos$Passenger$Loaded(
											_Utils_update(
												lModel,
												{G: passengerCardModel})),
										A2($elm$core$Platform$Cmd$map, $author$project$Pages$Pos$Passenger$GotPassengerCardMsg, passengerCardCmd),
										$author$project$Shared$NoOp);
								}
							default:
								var sharedMsg_ = sharedOutMsg.a;
								return _Utils_Tuple3(
									$author$project$Pages$Pos$Passenger$Loaded(
										_Utils_update(
											lModel,
											{G: passengerCardModel})),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Pos$Passenger$GotPassengerCardMsg, passengerCardCmd),
									sharedMsg_);
						}
					}();
					return update_;
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
				}
			case 2:
				var subMsg = msg.a;
				var _v8 = A2(
					$author$project$Pages$Pos$Passenger$mapLoaded,
					function (m) {
						return _Utils_Tuple2(m, m.bv);
					},
					model);
				if ((!_v8.$) && (_v8.a.b.$ === 1)) {
					var _v9 = _v8.a;
					var lModel = _v9.a;
					var subModel = _v9.b.a;
					var _v10 = A5($author$project$Pages$Pos$Passenger$SellTicket$update, subMsg, subModel, shared, user, lModel.j);
					var updtModel = _v10.a;
					var cmd = _v10.b;
					var sharedMsg = _v10.c;
					return _Utils_Tuple3(
						$author$project$Pages$Pos$Passenger$Loaded(
							_Utils_update(
								lModel,
								{
									bv: $author$project$Pages$Pos$Passenger$SellTicket(updtModel)
								})),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Pos$Passenger$GotSellTicketMsg, cmd),
						sharedMsg);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
				}
			case 3:
				var subMsg = msg.a;
				var _v11 = A2(
					$author$project$Pages$Pos$Passenger$mapLoaded,
					function (m) {
						return _Utils_Tuple2(m, m.bv);
					},
					model);
				if ((!_v11.$) && (_v11.a.b.$ === 2)) {
					var _v12 = _v11.a;
					var lModel = _v12.a;
					var subModel = _v12.b.a;
					var _v13 = A5($author$project$Pages$Pos$Passenger$SellSingleCharge$update, subMsg, subModel, shared, user, lModel.j);
					var updtModel = _v13.a;
					var cmd = _v13.b;
					var sharedMsg = _v13.c;
					return _Utils_Tuple3(
						$author$project$Pages$Pos$Passenger$Loaded(
							_Utils_update(
								lModel,
								{
									bv: $author$project$Pages$Pos$Passenger$SellSingleCharge(updtModel)
								})),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Pos$Passenger$GotSellSingleChargeMsg, cmd),
						sharedMsg);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
				}
			case 4:
				var subMsg = msg.a;
				var _v14 = A2(
					$author$project$Pages$Pos$Passenger$mapLoaded,
					function (m) {
						return _Utils_Tuple2(m, m.bv);
					},
					model);
				if ((!_v14.$) && (_v14.a.b.$ === 3)) {
					var _v15 = _v14.a;
					var lModel = _v15.a;
					var subModel = _v15.b.a;
					var _v16 = A5($author$project$Pages$Pos$Passenger$ApplyRefill$update, subMsg, subModel, shared, user, lModel.j);
					var updtModel = _v16.a;
					var cmd = _v16.b;
					var sharedMsg = _v16.c;
					return _Utils_Tuple3(
						$author$project$Pages$Pos$Passenger$Loaded(
							_Utils_update(
								lModel,
								{
									bv: $author$project$Pages$Pos$Passenger$ApplyRefill(updtModel)
								})),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Pos$Passenger$GotApplyRefillMsg, cmd),
						sharedMsg);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
				}
			case 5:
				var subMsg = msg.a;
				var _v17 = A2(
					$author$project$Pages$Pos$Passenger$mapLoaded,
					function (m) {
						return _Utils_Tuple2(m, m.bv);
					},
					model);
				if ((!_v17.$) && (_v17.a.b.$ === 4)) {
					var _v18 = _v17.a;
					var lModel = _v18.a;
					var subModel = _v18.b.a;
					var _v19 = A6($author$project$Pages$Pos$Passenger$IssueCard$update, subMsg, lModel.G.dc, subModel, shared, user, lModel.j);
					var updtModel = _v19.a;
					var cmd = _v19.b;
					var sharedOutMsg = _v19.c;
					var _v20 = function () {
						if (!sharedOutMsg.$) {
							var card = sharedOutMsg.a;
							return function (_v22) {
								var a = _v22.a;
								var b = _v22.b;
								return _Utils_Tuple3(
									a,
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Pos$Passenger$GotPassengerCardMsg, b),
									$author$project$Shared$NoOp);
							}(
								A5(
									$author$project$Components$PassengerCard$update,
									lModel.j,
									$author$project$Components$PassengerCard$SelectedCard(card.dM),
									lModel.G,
									shared,
									user));
						} else {
							var sharedMsg_ = sharedOutMsg.a;
							return _Utils_Tuple3(lModel.G, $elm$core$Platform$Cmd$none, sharedMsg_);
						}
					}();
					var passengerCardModel = _v20.a;
					var passengerCardCmd = _v20.b;
					var sharedMsg = _v20.c;
					return _Utils_Tuple3(
						$author$project$Pages$Pos$Passenger$Loaded(
							_Utils_update(
								lModel,
								{
									bv: $author$project$Pages$Pos$Passenger$IssueCard(updtModel),
									G: passengerCardModel
								})),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Pos$Passenger$GotIssueCardMsg, cmd),
									passengerCardCmd
								])),
						sharedMsg);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
				}
			case 6:
				var subMsg = msg.a;
				var _v23 = A2(
					$author$project$Pages$Pos$Passenger$mapLoaded,
					function (m) {
						return _Utils_Tuple2(m, m.bv);
					},
					model);
				if ((!_v23.$) && (_v23.a.b.$ === 5)) {
					var _v24 = _v23.a;
					var lModel = _v24.a;
					var subModel = _v24.b.a;
					var _v25 = A5($author$project$Pages$Pos$Passenger$IssueDuplicate$update, subMsg, subModel, shared, user, lModel.j);
					var updtModel = _v25.a;
					var cmd = _v25.b;
					var sharedOutMsg = _v25.c;
					var _v26 = function () {
						if (!sharedOutMsg.$) {
							var sharedMsg_ = sharedOutMsg.a;
							return _Utils_Tuple2(sharedMsg_, $elm$core$Platform$Cmd$none);
						} else {
							var maybeMsg = sharedOutMsg.a;
							return _Utils_Tuple2(
								A2($elm$core$Maybe$withDefault, $author$project$Shared$NoOp, maybeMsg),
								A3($author$project$Pages$Pos$Passenger$getPassenger, user, passengerId, 5));
						}
					}();
					var sharedMsg = _v26.a;
					var sharedMsgCmd = _v26.b;
					return _Utils_Tuple3(
						$author$project$Pages$Pos$Passenger$Loaded(
							_Utils_update(
								lModel,
								{
									bv: $author$project$Pages$Pos$Passenger$IssueDuplicate(updtModel)
								})),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Pos$Passenger$GotIssueDuplicateMsg, cmd),
									sharedMsgCmd
								])),
						sharedMsg);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
				}
			case 7:
				var subMsg = msg.a;
				var _v28 = A2(
					$author$project$Pages$Pos$Passenger$mapLoaded,
					function (m) {
						return _Utils_Tuple2(m, m.bv);
					},
					model);
				if ((!_v28.$) && (_v28.a.b.$ === 6)) {
					var _v29 = _v28.a;
					var lModel = _v29.a;
					var subModel = _v29.b.a;
					var _v30 = A5($author$project$Pages$Pos$Passenger$RegisterBeneficiary$update, subMsg, subModel, shared, user, lModel.j);
					var updtModel = _v30.a;
					var cmd = _v30.b;
					var sharedMsg = _v30.c;
					return _Utils_Tuple3(
						$author$project$Pages$Pos$Passenger$Loaded(
							_Utils_update(
								lModel,
								{
									bv: $author$project$Pages$Pos$Passenger$RegisterBeneficiary(updtModel)
								})),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Pos$Passenger$GotRegisterBeneficiaryMsg, cmd),
						sharedMsg);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
				}
			default:
				var subMsg = msg.a;
				var _v31 = A2(
					$author$project$Pages$Pos$Passenger$mapLoaded,
					function (m) {
						return _Utils_Tuple2(m, m.bv);
					},
					model);
				if ((!_v31.$) && (_v31.a.b.$ === 7)) {
					var _v32 = _v31.a;
					var lModel = _v32.a;
					var subModel = _v32.b.a;
					var _v33 = A5($author$project$Pages$Pos$Passenger$UnlockCard$update, subMsg, subModel, shared, user, lModel.j);
					var updtModel = _v33.a;
					var cmd = _v33.b;
					var sharedMsg = _v33.c;
					return _Utils_Tuple3(
						$author$project$Pages$Pos$Passenger$Loaded(
							_Utils_update(
								lModel,
								{
									bv: $author$project$Pages$Pos$Passenger$UnlockCard(updtModel)
								})),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Pos$Passenger$GotUnlockCardMsg, cmd),
						sharedMsg);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
				}
		}
	});
var $author$project$Pages$Pos$Register$update = F4(
	function (msg, model, shared, user) {
		if (!msg.$) {
			return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
		} else {
			var subMsg = msg.a;
			var _v1 = A4($author$project$Pages$Pos$Editor$update, subMsg, model.cR, shared, user);
			var editorModel = _v1.a;
			var editorCmd = _v1.b;
			var editorSharedMsg = _v1.c;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{cR: editorModel}),
				A2($elm$core$Platform$Cmd$map, $author$project$Pages$Pos$Register$GotEditorMsg, editorCmd),
				editorSharedMsg);
		}
	});
var $author$project$Pages$RecoverPassword$NotFound = 2;
var $author$project$Pages$RecoverPassword$ReceivedRecoverSendEmail = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$RecoverPassword$Sent = 1;
var $author$project$Services$Auth$recoverPassword = F2(
	function (_v0, processRequest) {
		var email = _v0.mX;
		return $elm$http$Http$request(
			{
				lG: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'email',
								$elm$json$Json$Encode$string(email))
							]))),
				m9: $author$project$Services$Api$expectWhatever(processRequest),
				nG: _List_Nil,
				of: 'POST',
				p5: $elm$core$Maybe$Nothing,
				qi: $elm$core$Maybe$Nothing,
				qt: A2(
					$author$project$Constants$authServiceUrl,
					_List_fromArray(
						['api', 'v1', 'users', 'password-reset']),
					_List_Nil)
			});
	});
var $author$project$Pages$RecoverPassword$update = F3(
	function (msg, model, sharedModel) {
		switch (msg.$) {
			case 0:
				var text = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{mX: text}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{q: $krisajenkins$remotedata$RemoteData$Loading}),
					A2(
						$author$project$Services$Auth$recoverPassword,
						{mX: model.mX},
						$author$project$Pages$RecoverPassword$ReceivedRecoverSendEmail),
					$author$project$Shared$CloseDialog);
			case 2:
				if (!msg.a.$) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{d9: 1}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{d9: 2}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				}
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
		}
	});
var $author$project$Pages$Reports$AdministrativeSales$CompPDFCreateMSg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Reports$AdministrativeSales$GenerateCsvDownloadWithTime = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Reports$AdministrativeSales$toPosix = function (str) {
	return A2(
		$elm$core$Maybe$andThen,
		$author$project$Utils$dateHTMLToPosixWithZone($elm$time$Time$utc),
		str);
};
var $author$project$Pages$Reports$AdministrativeSales$period31daysInvalid = F2(
	function (start, end) {
		var diff = A3(
			$elm$core$Maybe$map2,
			A2($justinmimbs$time_extra$Time$Extra$diff, 11, $elm$time$Time$utc),
			$author$project$Pages$Reports$AdministrativeSales$toPosix(start),
			$author$project$Pages$Reports$AdministrativeSales$toPosix(end));
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$lt(31),
				diff));
	});
var $author$project$Pages$Reports$AdministrativeSales$queriesToFilter = function (queries) {
	var maybeQ = F2(
		function (param, mValue) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (v) {
						return $elm$core$List$singleton(
							{oK: param, di: v});
					},
					mValue));
		});
	var listToStr = function (l) {
		return $elm$core$List$isEmpty(l) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			A2($elm$core$String$join, ',', l));
	};
	return _Utils_ap(
		A2(maybeQ, 'start', queries.bB),
		_Utils_ap(
			A2(maybeQ, 'end', queries.bl),
			A2(
				maybeQ,
				'operatorID',
				listToStr(queries.g6))));
};
var $author$project$Pages$Reports$AdministrativeSales$reportHeaders = _List_fromArray(
	['Criado em', 'Operador', 'Passageiro', 'Serial do cartão', 'Descrição', 'Valor']);
var $author$project$Pages$Reports$AdministrativeSales$setsEmptyValue = function (v_) {
	return $elm$core$String$isEmpty(v_) ? '-' : v_;
};
var $author$project$Pages$Reports$AdministrativeSales$reportRow = F2(
	function (timezone, row) {
		return A2(
			$elm$core$List$map,
			$author$project$Pages$Reports$AdministrativeSales$setsEmptyValue,
			_List_fromArray(
				[
					A2($author$project$Utils$formatDateTimeFromPosixWithSeconds, timezone, row.ix),
					row.lR.c3,
					row.kZ.c3,
					row.lO,
					row.kX,
					A3($elm$core$Basics$composeR, $elm$core$String$fromInt, $author$project$Utils$formatAsMoney, row.di)
				]));
	});
var $author$project$Pages$Reports$AdministrativeSales$valueNotEmpty = function (str) {
	return $elm$core$String$isEmpty(str) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(str);
};
var $author$project$Pages$Reports$AdministrativeSales$update = F4(
	function (msg, model, shared, user) {
		var queries = model.T;
		switch (msg.$) {
			case 0:
				var now = msg.a.e8;
				var timezone = msg.a.kS;
				var today = A2($justinmimbs$date$Date$fromPosix, timezone, now);
				var newQueries = _Utils_update(
					queries,
					{
						bl: $elm$core$Maybe$Just(
							$justinmimbs$date$Date$toIsoString(today)),
						bB: $elm$core$Maybe$Just(
							$justinmimbs$date$Date$toIsoString(
								A3($justinmimbs$date$Date$add, 3, -1, today)))
					});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{T: newQueries}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 1:
				var rd = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ck: rd}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rd));
			case 2:
				var rd = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{c5: rd}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rd));
			case 3:
				var dateStr = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{bB: dateStr})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 4:
				var dateStr = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{bl: dateStr})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 5:
				var ms = msg.a;
				var isOpen = msg.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dV: isOpen}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 6:
				var userID = msg.a;
				var updateCodeList = function () {
					var _v2 = _Utils_Tuple2(
						$author$project$Pages$Reports$AdministrativeSales$valueNotEmpty(userID),
						A2(
							$elm$core$List$any,
							$elm$core$Basics$eq(userID),
							model.T.g6));
					if (!_v2.a.$) {
						if (_v2.b) {
							var l = _v2.a.a;
							var updateLineCodeListDeselectAllLines = A2(
								$elm$core$List$any,
								$elm$core$Basics$eq(''),
								model.T.g6) ? A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(''),
								model.T.g6) : model.T.g6;
							return A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(l),
								updateLineCodeListDeselectAllLines);
						} else {
							var l = _v2.a.a;
							var _new = A2($elm$core$List$cons, l, model.T.g6);
							var all = A2(
								$elm$core$List$map,
								function ($) {
									return $.dM;
								},
								A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, model.c5));
							return _Utils_eq(
								$elm$core$List$length(all),
								$elm$core$List$length(_new)) ? A2($elm$core$List$cons, '', _new) : _new;
						}
					} else {
						if (_v2.b) {
							var _v3 = _v2.a;
							return _List_Nil;
						} else {
							var _v4 = _v2.a;
							var all = A2(
								$elm$core$List$map,
								function ($) {
									return $.dM;
								},
								A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, model.c5));
							return A2($elm$core$List$cons, userID, all);
						}
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{g6: updateCodeList})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 7:
				return _Utils_Tuple3(
					model,
					A2(
						$author$project$Route$pushUrl,
						shared.nZ,
						$author$project$Route$Report(
							$author$project$Route$AdministrativeSales(queries))),
					$author$project$Shared$NoOp);
			case 8:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dK: !model.dK}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 9:
				return _Utils_Tuple3(
					model,
					A2(
						$elm$core$Task$perform,
						$author$project$Pages$Reports$AdministrativeSales$GenerateCsvDownloadWithTime,
						A3(
							$elm$core$Task$map2,
							F2(
								function (now, timezone) {
									return {e8: now, kS: timezone};
								}),
							$elm$time$Time$now,
							$elm$time$Time$here)),
					$author$project$Shared$NoOp);
			case 10:
				var now = msg.a.e8;
				var timezone = msg.a.kS;
				var title_ = 'Vendas administrativas ' + (A2($author$project$Utils$formatDateTimeFromPosix, timezone, now) + '.csv');
				var records = A2(
					$krisajenkins$remotedata$RemoteData$withDefault,
					_List_Nil,
					A2(
						$krisajenkins$remotedata$RemoteData$map,
						$elm$core$List$map(
							function (item) {
								return A2($author$project$Pages$Reports$AdministrativeSales$reportRow, shared.kS, item);
							}),
						model.ck));
				var headers = $author$project$Pages$Reports$AdministrativeSales$reportHeaders;
				return _Utils_Tuple3(
					model,
					A3($author$project$Components$GeneratorCSV$download, records, headers, title_),
					$author$project$Shared$NoOp);
			case 11:
				var isShowOptionPage = msg.a;
				var exportType = msg.b;
				var reportType = msg.c;
				if (A2($author$project$Pages$Reports$AdministrativeSales$period31daysInvalid, model.T.bB, model.T.bl)) {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$ShowErrorDialog('O período definido é maior que 31 dias. Ajuste a consulta e tente novamente.'));
				} else {
					var newQueries = model.T;
					var _v5 = A3(
						$author$project$Components$PDF$Create$update,
						A4(
							$author$project$Components$PDF$Create$ClickedOpenModal,
							isShowOptionPage,
							exportType,
							reportType,
							$author$project$Pages$Reports$AdministrativeSales$queriesToFilter(newQueries)),
						model.bQ,
						user);
					var newCompModel = _v5.a;
					var cmd = _v5.b;
					var sharedMsg = _v5.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bQ: newCompModel}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Reports$AdministrativeSales$CompPDFCreateMSg, cmd),
						sharedMsg);
				}
			default:
				var msg_ = msg.a;
				var _v6 = A3($author$project$Components$PDF$Create$update, msg_, model.bQ, user);
				var newCompModel = _v6.a;
				var cmd = _v6.b;
				var sharedMsg = _v6.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bQ: newCompModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Reports$AdministrativeSales$CompPDFCreateMSg, cmd),
					sharedMsg);
		}
	});
var $author$project$Pages$Reports$DetailedVehicle$DetailedVehicle = 2;
var $author$project$Pages$Reports$DetailedVehicle$GenerateCsvDownloadWithTime = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$Reports$DetailedVehicle$Vehicles = 1;
var $author$project$Pages$Reports$DetailedVehicle$maybeCell = function (v_) {
	return A2($elm$core$Maybe$withDefault, '-', v_);
};
var $author$project$Pages$Reports$DetailedVehicle$setsEmptyValue = function (v_) {
	return $elm$core$String$isEmpty(v_) ? '-' : v_;
};
var $author$project$Pages$Reports$DetailedVehicle$update = F3(
	function (msg, model, shared) {
		var queries = model.T;
		switch (msg.$) {
			case 0:
				var now = msg.a.e8;
				var timezone = msg.a.kS;
				var today = A2($justinmimbs$date$Date$fromPosix, timezone, now);
				var newQueries = _Utils_update(
					queries,
					{
						bl: $elm$core$Maybe$Just(
							$justinmimbs$date$Date$toIsoString(today) + 'T23:59:00'),
						bB: $elm$core$Maybe$Just(
							$justinmimbs$date$Date$toIsoString(today) + 'T00:00:00')
					});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{T: newQueries, fy: 2}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 1:
				var result = msg.a;
				return _Utils_Tuple3(
					A2(
						$krisajenkins$remotedata$RemoteData$withDefault,
						_Utils_update(
							model,
							{en: result}),
						A2(
							$krisajenkins$remotedata$RemoteData$map,
							function (_v1) {
								return _Utils_update(
									model,
									{fy: 1, en: result});
							},
							result)),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, result));
			case 2:
				var result = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							dE: result,
							fy: A2(
								$krisajenkins$remotedata$RemoteData$withDefault,
								model.fy,
								A2(
									$krisajenkins$remotedata$RemoteData$map,
									function (_v2) {
										return 2;
									},
									result))
						}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, result));
			case 5:
				var id = msg.a;
				var code = msg.b;
				var newQueries = _Utils_update(
					queries,
					{
						fN: $elm$core$Maybe$Just(id),
						hN: $elm$core$Maybe$Just(code)
					});
				return _Utils_Tuple3(
					model,
					A2(
						$author$project$Route$pushUrl,
						shared.nZ,
						$author$project$Route$Report(
							$author$project$Route$DetailedVehicle(newQueries))),
					$author$project$Shared$NoOp);
			case 6:
				return _Utils_Tuple3(
					model,
					A2(
						$author$project$Route$pushUrl,
						shared.nZ,
						$author$project$Route$Report(
							$author$project$Route$DetailedVehicle(model.T))),
					$author$project$Shared$NoOp);
			case 7:
				var str = msg.a;
				var newStr = ($elm$core$String$length(str) === 16) ? (str + ':00') : str;
				var end = A2($elm$core$Maybe$withDefault, '', queries.bl);
				var endStr = A2(
					$elm$core$Result$withDefault,
					end,
					A3(
						$elm$core$Result$map2,
						F2(
							function (from, to) {
								return (A2($justinmimbs$date$Date$compare, from, to) === 2) ? newStr : end;
							}),
						$justinmimbs$date$Date$fromIsoString(newStr),
						$justinmimbs$date$Date$fromIsoString(end)));
				var newQueries = _Utils_update(
					queries,
					{
						bl: $elm$core$Maybe$Just(endStr),
						bB: $elm$core$Maybe$Just(newStr)
					});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{T: newQueries}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 8:
				var str = msg.a;
				var start = A2($elm$core$Maybe$withDefault, '', queries.bB);
				var newStr = ($elm$core$String$length(str) === 16) ? (str + ':00') : str;
				var startStr = A2(
					$elm$core$Result$withDefault,
					start,
					A3(
						$elm$core$Result$map2,
						F2(
							function (from, to) {
								return (A2($justinmimbs$date$Date$compare, from, to) === 2) ? newStr : start;
							}),
						$justinmimbs$date$Date$fromIsoString(start),
						$justinmimbs$date$Date$fromIsoString(newStr)));
				var newQueries = _Utils_update(
					queries,
					{
						bl: $elm$core$Maybe$Just(newStr),
						bB: $elm$core$Maybe$Just(startStr)
					});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{T: newQueries}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 9:
				var str = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{kw: str})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 10:
				var str = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{k2: str})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 11:
				var maybeStr = msg.a;
				var filtered = A2(
					$elm$core$Maybe$map,
					$elm$core$String$filter(
						$elm$core$Basics$neq('-')),
					maybeStr);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{ac: filtered})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 12:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{az: !model.az}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 13:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{b1: !model.b1}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 14:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cq: !model.cq}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 15:
				var newQueries = _Utils_update(
					queries,
					{bl: $elm$core$Maybe$Nothing, bB: $elm$core$Maybe$Nothing, fN: $elm$core$Maybe$Nothing, hN: $elm$core$Maybe$Nothing});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{T: newQueries}),
					A2(
						$author$project$Route$pushUrl,
						shared.nZ,
						$author$project$Route$Report(
							$author$project$Route$DetailedVehicle(newQueries))),
					$author$project$Shared$NoOp);
			case 3:
				var details = msg.a;
				return _Utils_Tuple3(
					model,
					A2(
						$elm$core$Task$perform,
						$author$project$Pages$Reports$DetailedVehicle$GenerateCsvDownloadWithTime(details),
						$elm$time$Time$now),
					$author$project$Shared$NoOp);
			default:
				var details = msg.a;
				var now = msg.b;
				var valueViewMoneyWithDescription = F2(
					function (description, v) {
						return ((description === 'Carga negativa aplicada') || ((description === 'Carga negativa aplicada no Guichê') || (description === 'Transferência de crédito (Débito)'))) ? A2(
							$elm$core$Maybe$withDefault,
							'-',
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$String$fromInt,
									function (v_) {
										return '( ' + ($author$project$Utils$formatAsMoney(v_) + ' )');
									}),
								v)) : A2(
							$elm$core$Maybe$withDefault,
							'-',
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $author$project$Utils$formatAsMoney),
								v));
					});
				var valueViewMoney = function (value) {
					return A2(
						$elm$core$Maybe$withDefault,
						'-',
						A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $author$project$Utils$formatAsMoney),
							value));
				};
				var valueView = function (value) {
					return A2(
						$elm$core$Maybe$withDefault,
						'-',
						A2($elm$core$Maybe$map, $elm$core$String$fromInt, value));
				};
				var title = 'Veículo detalhado ' + (A2($author$project$Utils$formatDateTimeFromPosix, shared.kS, now) + '.csv');
				var sessionOpeningLineStr = function (r) {
					return ((r.z === 'Abertura de sessão (App)') || (r.z === 'Abertura de sessão')) ? (r.z + (' - ' + r.e1)) : r.z;
				};
				var headers = model.az ? _List_fromArray(
					['', 'Data/Horário', 'Evento', 'Cartão', 'Classe', 'Valor', 'Saldo', 'Contador', 'Contador carga', 'Contador catraca', 'Carteira']) : _List_fromArray(
					['', 'Data/Horário', 'Evento', 'Cartão', 'Classe', 'Valor', 'Saldo', 'Contador catraca']);
				var filteredTransactionsRecordsHideDetails = model.az ? details : A2(
					$elm$core$List$filter,
					function (_v6) {
						var description = _v6.z;
						return (description !== 'Catraca liberada') && (description !== 'Catraca girada');
					},
					details);
				var filteredTransactionsHideError = model.b1 ? filteredTransactionsRecordsHideDetails : A2(
					$elm$core$List$filter,
					function (_v5) {
						var transactionError = _v5.bD;
						return !transactionError;
					},
					filteredTransactionsRecordsHideDetails);
				var filteredTransactionsShowOnlyPayment = model.cq ? A2(
					$elm$core$List$filter,
					function (_v4) {
						var description = _v4.z;
						return (description === 'Pagamento de passagem') || ((description === 'Catraca liberada via Botoeira') || ((description === 'Abertura de sessão (App)') || ((description === 'Abertura de sessão') || ((description === 'Fechamento de sessão (App)') || (description === 'Fechamento de sessão')))));
					},
					filteredTransactionsHideError) : filteredTransactionsHideError;
				var records = A2(
					$elm$core$List$map,
					function (record) {
						var list = model.az ? _List_fromArray(
							[
								valueView(record.fu),
								$author$project$Pages$Reports$DetailedVehicle$setsEmptyValue(
								A2($author$project$Utils$formatDateTimeFromPosixWithSeconds, shared.kS, record.cO)),
								$author$project$Pages$Reports$DetailedVehicle$setsEmptyValue(
								sessionOpeningLineStr(record)),
								$author$project$Pages$Reports$DetailedVehicle$setsEmptyValue(
								$author$project$Pages$Reports$DetailedVehicle$maybeCell(record.lO)),
								$author$project$Pages$Reports$DetailedVehicle$setsEmptyValue(record.ih),
								A2(valueViewMoneyWithDescription, record.z, record.di),
								valueViewMoney(record.h2),
								valueView(record.iy),
								valueView(record.js),
								valueView(record.eL),
								record.k7
							]) : _List_fromArray(
							[
								valueView(record.fu),
								$author$project$Pages$Reports$DetailedVehicle$setsEmptyValue(
								A2($author$project$Utils$formatDateTimeFromPosixWithSeconds, shared.kS, record.cO)),
								$author$project$Pages$Reports$DetailedVehicle$setsEmptyValue(
								sessionOpeningLineStr(record)),
								$author$project$Pages$Reports$DetailedVehicle$setsEmptyValue(
								$author$project$Pages$Reports$DetailedVehicle$maybeCell(record.lO)),
								$author$project$Pages$Reports$DetailedVehicle$setsEmptyValue(record.ih),
								A2(valueViewMoneyWithDescription, record.z, record.di),
								valueViewMoney(record.h2),
								valueView(record.eL)
							]);
						return list;
					},
					filteredTransactionsShowOnlyPayment);
				var classView = function (record) {
					var _v3 = $elm$core$String$isEmpty(record.ih);
					if (_v3) {
						return '-';
					} else {
						return record.ih;
					}
				};
				return _Utils_Tuple3(
					model,
					A3($author$project$Components$GeneratorCSV$download, records, headers, title),
					$author$project$Shared$NoOp);
		}
	});
var $author$project$Pages$Reports$DetailedVehicleV2$DetailedVehicle = 2;
var $author$project$Pages$Reports$DetailedVehicleV2$GenerateCsvDownloadWithTime = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$Reports$DetailedVehicleV2$GotDetailsBreakdown = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$Pages$Reports$DetailedVehicleV2$Vehicles = 1;
var $ryan_haskell$date_format$DateFormat$MillisecondFixed = {$: 35};
var $ryan_haskell$date_format$DateFormat$millisecondFixed = $ryan_haskell$date_format$DateFormat$MillisecondFixed;
var $author$project$Utils$formatDateTimeFromPosixWithSecondsAndMilliseconds = function (timezone) {
	return A2(
		$ryan_haskell$date_format$DateFormat$format,
		_List_fromArray(
			[
				$ryan_haskell$date_format$DateFormat$dayOfMonthFixed,
				$ryan_haskell$date_format$DateFormat$text('/'),
				$ryan_haskell$date_format$DateFormat$monthFixed,
				$ryan_haskell$date_format$DateFormat$text('/'),
				$ryan_haskell$date_format$DateFormat$yearNumber,
				$ryan_haskell$date_format$DateFormat$text(' '),
				$ryan_haskell$date_format$DateFormat$hourMilitaryFixed,
				$ryan_haskell$date_format$DateFormat$text(':'),
				$ryan_haskell$date_format$DateFormat$minuteFixed,
				$ryan_haskell$date_format$DateFormat$text(':'),
				$ryan_haskell$date_format$DateFormat$secondFixed,
				$ryan_haskell$date_format$DateFormat$text('.'),
				$ryan_haskell$date_format$DateFormat$millisecondFixed
			]),
		timezone);
};
var $author$project$Services$Reports$DetailedVehicle$DetailsBreakdown = F5(
	function (eventDate, eventType, eventSequence, gateCount, value) {
		return {m2: eventDate, m4: eventSequence, f: eventType, eL: gateCount, di: value};
	});
var $author$project$Services$Reports$DetailedVehicle$vehicleDetailsBreakdownDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'value',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'gateCount',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'eventSequence',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'eventType',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'eventDate',
					$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
					$elm$json$Json$Decode$succeed($author$project$Services$Reports$DetailedVehicle$DetailsBreakdown))))));
var $author$project$Services$Reports$DetailedVehicle$getDetailsBreakdown = function (options) {
	var queries = A3(
		$author$project$Services$Api$queryMaybeValue,
		$elm$url$Url$Builder$string,
		'event_transaction_id',
		$elm$core$Maybe$Just(options.m5));
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							$elm$json$Json$Decode$list($author$project$Services$Reports$DetailedVehicle$vehicleDetailsBreakdownDecoder),
							$elm$json$Json$Decode$null(_List_Nil)
						]))),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'report', 'vehicleDetailsBreakdown']),
				queries)
		});
};
var $author$project$Pages$Reports$DetailedVehicleV2$maybeCell = function (v_) {
	return A2($elm$core$Maybe$withDefault, '-', v_);
};
var $author$project$Pages$Reports$DetailedVehicleV2$setsEmptyValue = function (v_) {
	return $elm$core$String$isEmpty(v_) ? '-' : v_;
};
var $elm$html$Html$td = _VirtualDom_node('td');
var $author$project$Pages$Reports$DetailedVehicleV2$viewRecordDetails = F3(
	function (hideDetails, timezone, detail) {
		var valueViewMoney = function (value) {
			return A2(
				$elm$core$Maybe$withDefault,
				'-',
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $author$project$Utils$formatAsMoney),
					value));
		};
		var valueView = function (v) {
			return ((detail.f === 'Carga negativa aplicada') || ((detail.f === 'Carga negativa aplicada no Guichê') || (detail.f === 'Transferência de crédito (Débito)'))) ? A2(
				$elm$core$Basics$composeR,
				valueViewMoney,
				function (v_) {
					return '( ' + (v_ + ' )');
				})(v) : valueViewMoney(v);
		};
		var valueNegativeClass = function (value) {
			return ((value < 0) || ((detail.f === 'Carga negativa aplicada') || ((detail.f === 'Carga negativa aplicada no Guichê') || (detail.f === 'Transferência de crédito (Débito)')))) ? $elm$html$Html$Attributes$class('text-red-500') : A2($elm$html$Html$Attributes$style, '', '');
		};
		var userName = detail.qx;
		var startOrEndOfSessionClass = ((detail.f === 'Abertura de sessão (App)') || ((detail.f === 'Abertura de sessão') || A2($elm$core$String$startsWith, 'Abertura de sessão', detail.f))) ? $elm$html$Html$Attributes$class('bg-purple-main text-white font-bold') : (((detail.f === 'Fechamento de sessão (App)') || ((detail.f === 'Fechamento de sessão') || A2($elm$core$String$startsWith, 'Fechamento de sessão', detail.f))) ? $elm$html$Html$Attributes$class('bg-purple-secondary text-white font-bold') : $elm$html$Html$Attributes$class(''));
		var sessionOpeningLineStr = ((detail.f === 'Abertura de sessão (App)') || ((detail.f === 'Abertura de sessão') || A2($elm$core$String$startsWith, 'Abertura de sessão', detail.f))) ? (detail.f + (' - ' + $elm$core$String$fromInt(detail.m6))) : detail.f;
		return _Utils_Tuple2(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[startOrEndOfSessionClass]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Pages$Reports$DetailedVehicleV2$setsEmptyValue(
								$author$project$Pages$Reports$DetailedVehicleV2$maybeCell(
									A2($elm$core$Maybe$map, $elm$core$String$fromInt, detail.qk))))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							startOrEndOfSessionClass,
							A2($elm$html$Html$Attributes$style, 'text-wrap', 'nowrap')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Pages$Reports$DetailedVehicleV2$setsEmptyValue(
								A2($author$project$Utils$formatDateTimeFromPosixWithSecondsAndMilliseconds, timezone, detail.m2)))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							startOrEndOfSessionClass,
							$elm$html$Html$Attributes$class('min-w-23rem')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Pages$Reports$DetailedVehicleV2$setsEmptyValue(sessionOpeningLineStr))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[startOrEndOfSessionClass]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Pages$Reports$DetailedVehicleV2$setsEmptyValue(userName))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[startOrEndOfSessionClass]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Pages$Reports$DetailedVehicleV2$setsEmptyValue(
								$author$project$Pages$Reports$DetailedVehicleV2$maybeCell(
									$elm$core$Maybe$Just(detail.lO))))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[startOrEndOfSessionClass]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Pages$Reports$DetailedVehicleV2$setsEmptyValue(detail.qH))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							startOrEndOfSessionClass,
							A2($elm$html$Html$Attributes$style, 'text-wrap', 'nowrap'),
							valueNegativeClass(detail.di)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							valueView(
								$elm$core$Maybe$Just(detail.di)))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							startOrEndOfSessionClass,
							A2($elm$html$Html$Attributes$style, 'text-wrap', 'nowrap')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Pages$Reports$DetailedVehicleV2$setsEmptyValue(
								$author$project$Pages$Reports$DetailedVehicleV2$maybeCell(
									$elm$core$Maybe$Just(
										A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $author$project$Utils$formatAsMoney)(detail.h2)))))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[startOrEndOfSessionClass]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Pages$Reports$DetailedVehicleV2$setsEmptyValue(
								$author$project$Pages$Reports$DetailedVehicleV2$maybeCell(
									A2(
										$elm$core$Maybe$map,
										$elm$core$String$fromInt,
										$elm$core$Maybe$Just(detail.iy)))))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[startOrEndOfSessionClass]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Pages$Reports$DetailedVehicleV2$setsEmptyValue(
								$author$project$Pages$Reports$DetailedVehicleV2$maybeCell(
									A2(
										$elm$core$Maybe$map,
										$elm$core$String$fromInt,
										$elm$core$Maybe$Just(detail.js)))))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[startOrEndOfSessionClass]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Pages$Reports$DetailedVehicleV2$setsEmptyValue(
								$author$project$Pages$Reports$DetailedVehicleV2$maybeCell(
									A2(
										$elm$core$Maybe$map,
										$elm$core$String$fromInt,
										$elm$core$Maybe$Just(detail.eL)))))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[startOrEndOfSessionClass]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Pages$Reports$DetailedVehicleV2$setsEmptyValue(detail.k7))
						]))
				]),
			startOrEndOfSessionClass);
	});
var $author$project$Pages$Reports$DetailedVehicleV2$update = F4(
	function (msg, model, shared, user) {
		var queries = model.T;
		switch (msg.$) {
			case 0:
				var now = msg.a.e8;
				var timezone = msg.a.kS;
				var today = A2($justinmimbs$date$Date$fromPosix, timezone, now);
				var newQueries = _Utils_update(
					queries,
					{
						bl: $elm$core$Maybe$Just(
							$justinmimbs$date$Date$toIsoString(today) + 'T23:59:00'),
						bB: $elm$core$Maybe$Just(
							$justinmimbs$date$Date$toIsoString(today) + 'T00:00:00')
					});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{T: newQueries, fy: 2}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 1:
				var result = msg.a;
				return _Utils_Tuple3(
					A2(
						$krisajenkins$remotedata$RemoteData$withDefault,
						_Utils_update(
							model,
							{en: result}),
						A2(
							$krisajenkins$remotedata$RemoteData$map,
							function (_v1) {
								return _Utils_update(
									model,
									{fy: 1, en: result});
							},
							result)),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, result));
			case 2:
				if (msg.a.$ === 3) {
					var result = msg.a.a;
					var filteredTransactionsHideDetails = result;
					var filteredTransactionsHideError = filteredTransactionsHideDetails;
					var filteredTransactionsShowOnlyPayment = filteredTransactionsHideError;
					var viewRecords = A2(
						$elm$core$List$indexedMap,
						F2(
							function (i, r) {
								return {
									m6: $elm$core$String$fromInt(r.m6),
									iM: _List_Nil,
									dM: $elm$core$String$fromInt(r.dM),
									eV: false,
									gR: A3($author$project$Pages$Reports$DetailedVehicleV2$viewRecordDetails, model.az, shared.kS, r),
									qk: r.qk
								};
							}),
						filteredTransactionsShowOnlyPayment);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								dE: $krisajenkins$remotedata$RemoteData$Success(result),
								av: viewRecords,
								fy: A2(
									$krisajenkins$remotedata$RemoteData$withDefault,
									model.fy,
									A2(
										$krisajenkins$remotedata$RemoteData$map,
										function (_v2) {
											return 2;
										},
										$krisajenkins$remotedata$RemoteData$Success(result)))
							}),
						$elm$core$Platform$Cmd$none,
						A2(
							$author$project$Shared$remoteDataSharedMsg,
							$elm$core$Maybe$Nothing,
							$krisajenkins$remotedata$RemoteData$Success(result)));
				} else {
					var result = msg.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								dE: result,
								av: _List_Nil,
								fy: A2(
									$krisajenkins$remotedata$RemoteData$withDefault,
									model.fy,
									A2(
										$krisajenkins$remotedata$RemoteData$map,
										function (_v3) {
											return 2;
										},
										result))
							}),
						$elm$core$Platform$Cmd$none,
						A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, result));
				}
			case 5:
				var id = msg.a;
				var code = msg.b;
				var newQueries = _Utils_update(
					queries,
					{
						fN: $elm$core$Maybe$Just(id),
						hN: $elm$core$Maybe$Just(code)
					});
				return _Utils_Tuple3(
					model,
					A2(
						$author$project$Route$pushUrl,
						shared.nZ,
						$author$project$Route$Report(
							$author$project$Route$DetailedVehicleV2(newQueries))),
					$author$project$Shared$NoOp);
			case 6:
				return _Utils_Tuple3(
					model,
					A2(
						$author$project$Route$pushUrl,
						shared.nZ,
						$author$project$Route$Report(
							$author$project$Route$DetailedVehicleV2(model.T))),
					$author$project$Shared$NoOp);
			case 7:
				var str = msg.a;
				var newStr = ($elm$core$String$length(str) === 16) ? (str + ':00') : str;
				var end = A2($elm$core$Maybe$withDefault, '', queries.bl);
				var endStr = A2(
					$elm$core$Result$withDefault,
					end,
					A3(
						$elm$core$Result$map2,
						F2(
							function (from, to) {
								return (A2($justinmimbs$date$Date$compare, from, to) === 2) ? newStr : end;
							}),
						$justinmimbs$date$Date$fromIsoString(newStr),
						$justinmimbs$date$Date$fromIsoString(end)));
				var newQueries = _Utils_update(
					queries,
					{
						bl: $elm$core$Maybe$Just(endStr),
						bB: $elm$core$Maybe$Just(newStr)
					});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{T: newQueries}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 8:
				var str = msg.a;
				var start = A2($elm$core$Maybe$withDefault, '', queries.bB);
				var newStr = ($elm$core$String$length(str) === 16) ? (str + ':00') : str;
				var startStr = A2(
					$elm$core$Result$withDefault,
					start,
					A3(
						$elm$core$Result$map2,
						F2(
							function (from, to) {
								return (A2($justinmimbs$date$Date$compare, from, to) === 2) ? newStr : start;
							}),
						$justinmimbs$date$Date$fromIsoString(start),
						$justinmimbs$date$Date$fromIsoString(newStr)));
				var newQueries = _Utils_update(
					queries,
					{
						bl: $elm$core$Maybe$Just(newStr),
						bB: $elm$core$Maybe$Just(startStr)
					});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{T: newQueries}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 9:
				var str = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{kw: str})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 10:
				var str = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{k2: str})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 11:
				var maybeStr = msg.a;
				var filtered = A2(
					$elm$core$Maybe$map,
					$elm$core$String$filter(
						$elm$core$Basics$neq('-')),
					maybeStr);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{ac: filtered})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 12:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{az: !model.az}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 13:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{b1: !model.b1}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 14:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cq: !model.cq}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 15:
				var newQueries = _Utils_update(
					queries,
					{bl: $elm$core$Maybe$Nothing, bB: $elm$core$Maybe$Nothing, fN: $elm$core$Maybe$Nothing, hN: $elm$core$Maybe$Nothing});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{T: newQueries}),
					A2(
						$author$project$Route$pushUrl,
						shared.nZ,
						$author$project$Route$Report(
							$author$project$Route$DetailedVehicleV2(newQueries))),
					$author$project$Shared$NoOp);
			case 3:
				var details = msg.a;
				return _Utils_Tuple3(
					model,
					A2(
						$elm$core$Task$perform,
						$author$project$Pages$Reports$DetailedVehicleV2$GenerateCsvDownloadWithTime(details),
						$elm$time$Time$now),
					$author$project$Shared$NoOp);
			case 4:
				var details = msg.a;
				var now = msg.b;
				var valueViewMoneyWithDescription = F2(
					function (description, v) {
						return ((description === 'Carga negativa aplicada') || ((description === 'Carga negativa aplicada no Guichê') || (description === 'Transferência de crédito (Débito)'))) ? A2(
							$elm$core$Maybe$withDefault,
							'-',
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$String$fromInt,
									function (v_) {
										return '( ' + ($author$project$Utils$formatAsMoney(v_) + ' )');
									}),
								v)) : A2(
							$elm$core$Maybe$withDefault,
							'-',
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $author$project$Utils$formatAsMoney),
								v));
					});
				var valueViewMoney = function (value) {
					return A2(
						$elm$core$Maybe$withDefault,
						'-',
						A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $author$project$Utils$formatAsMoney),
							value));
				};
				var valueView = function (value) {
					return A2(
						$elm$core$Maybe$withDefault,
						'-',
						A2($elm$core$Maybe$map, $elm$core$String$fromInt, value));
				};
				var title = 'Veículo detalhado ' + (A2($author$project$Utils$formatDateTimeFromPosix, shared.kS, now) + '.csv');
				var sessionOpeningLineStrV2 = function (r) {
					return ((r.f === 'Abertura de sessão (App)') || (r.f === 'Abertura de sessão')) ? (r.f + (' - ' + $elm$core$String$fromInt(r.m6))) : r.f;
				};
				var sessionOpeningLineStr = function (r) {
					return ((r.f === 'Abertura de sessão (App)') || (r.f === 'Abertura de sessão')) ? (r.f + (' - ' + r.e1)) : r.f;
				};
				var headers = model.az ? _List_fromArray(
					['', 'Data/Horário', 'Evento', 'Cartão', 'Classe', 'Valor', 'Saldo', 'Contador', 'Contador carga', 'Contador de uso', 'Carteira']) : _List_fromArray(
					['', 'Data/Horário', 'Evento', 'Cartão', 'Classe', 'Valor', 'Saldo', 'Contador de uso']);
				var filteredTransactionsRecordsHideDetails = details;
				var filteredTransactionsHideError = filteredTransactionsRecordsHideDetails;
				var filteredTransactionsShowOnlyPayment = filteredTransactionsHideError;
				var records = A2(
					$elm$core$List$map,
					function (record) {
						var list = _List_fromArray(
							[
								valueView(record.qk),
								$author$project$Pages$Reports$DetailedVehicleV2$setsEmptyValue(
								A2($author$project$Utils$formatDateTimeFromPosixWithSecondsAndMilliseconds, shared.kS, record.m2)),
								$author$project$Pages$Reports$DetailedVehicleV2$setsEmptyValue(
								sessionOpeningLineStrV2(record)),
								$author$project$Pages$Reports$DetailedVehicleV2$setsEmptyValue(
								$author$project$Pages$Reports$DetailedVehicleV2$maybeCell(
									$elm$core$Maybe$Just(record.lO))),
								$author$project$Pages$Reports$DetailedVehicleV2$setsEmptyValue(record.k7),
								A2(
								valueViewMoneyWithDescription,
								record.f,
								$elm$core$Maybe$Just(record.di)),
								valueViewMoney(
								$elm$core$Maybe$Just(record.h2)),
								valueView(
								$elm$core$Maybe$Just(record.eL)),
								valueView(
								$elm$core$Maybe$Just(record.iy))
							]);
						return list;
					},
					filteredTransactionsShowOnlyPayment);
				var classView = function (record) {
					var _v4 = $elm$core$String$isEmpty(record.ih);
					if (_v4) {
						return '-';
					} else {
						return record.ih;
					}
				};
				return _Utils_Tuple3(
					model,
					A3($author$project$Components$GeneratorCSV$download, records, headers, title),
					$author$project$Shared$NoOp);
			case 16:
				var _v5 = msg.a;
				var id = _v5.a;
				var eventTransactionId = _v5.b;
				var updatedDetailsformatedAndFiltered = A2(
					$elm$core$List$map,
					function (item) {
						return _Utils_eq(item.dM, id) ? _Utils_update(
							item,
							{eV: !item.eV}) : item;
					},
					model.av);
				var isExpanded = A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.eV;
						},
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (item) {
									return _Utils_eq(item.dM, id);
								},
								updatedDetailsformatedAndFiltered))));
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{av: updatedDetailsformatedAndFiltered}),
					isExpanded ? $author$project$Services$Reports$DetailedVehicle$getDetailsBreakdown(
						{
							m5: eventTransactionId,
							ow: $author$project$Pages$Reports$DetailedVehicleV2$GotDetailsBreakdown(id),
							kU: user.kU
						}) : $elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			default:
				var id = msg.a;
				var result = msg.b;
				var updatedDetailsformatedAndFiltered = A2(
					$elm$core$List$map,
					function (item) {
						if (_Utils_eq(item.dM, id)) {
							var updateExpanded = A2(
								$elm$core$List$map,
								function (detail) {
									var valueViewMoney = function (value) {
										return A2(
											$elm$core$Maybe$withDefault,
											'-',
											A2(
												$elm$core$Maybe$map,
												A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $author$project$Utils$formatAsMoney),
												value));
									};
									var valueView = function (v) {
										return ((detail.f === 'Carga negativa aplicada') || ((detail.f === 'Carga negativa aplicada no Guichê') || (detail.f === 'Transferência de crédito (Débito)'))) ? A2(
											$elm$core$Basics$composeR,
											valueViewMoney,
											function (v_) {
												return '( ' + (v_ + ' )');
											})(v) : valueViewMoney(v);
									};
									var valueNegativeClass = function (value) {
										return ((value < 0) || ((detail.f === 'Carga negativa aplicada') || ((detail.f === 'Carga negativa aplicada no Guichê') || (detail.f === 'Transferência de crédito (Débito)')))) ? $elm$html$Html$Attributes$class('text-red-500') : A2($elm$html$Html$Attributes$style, '', '');
									};
									var startOrEndOfSessionClass = $elm$html$Html$Attributes$class('');
									return _List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_fromArray(
												[startOrEndOfSessionClass]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Pages$Reports$DetailedVehicleV2$setsEmptyValue(
														$author$project$Pages$Reports$DetailedVehicleV2$maybeCell(
															$elm$core$Maybe$Just(
																$elm$core$String$fromInt(detail.m4)))))
												])),
											A2(
											$elm$html$Html$td,
											_List_fromArray(
												[
													startOrEndOfSessionClass,
													A2($elm$html$Html$Attributes$style, 'text-wrap', 'nowrap')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Pages$Reports$DetailedVehicleV2$setsEmptyValue(
														A2($author$project$Utils$formatDateTimeFromPosixWithSecondsAndMilliseconds, shared.kS, detail.m2)))
												])),
											A2(
											$elm$html$Html$td,
											_List_fromArray(
												[
													startOrEndOfSessionClass,
													$elm$html$Html$Attributes$class('min-w-23rem')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Pages$Reports$DetailedVehicleV2$setsEmptyValue(detail.f))
												])),
											A2(
											$elm$html$Html$td,
											_List_fromArray(
												[startOrEndOfSessionClass]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Pages$Reports$DetailedVehicleV2$setsEmptyValue(''))
												])),
											A2(
											$elm$html$Html$td,
											_List_fromArray(
												[startOrEndOfSessionClass]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Pages$Reports$DetailedVehicleV2$setsEmptyValue(''))
												])),
											A2(
											$elm$html$Html$td,
											_List_fromArray(
												[startOrEndOfSessionClass]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Pages$Reports$DetailedVehicleV2$setsEmptyValue(''))
												])),
											A2(
											$elm$html$Html$td,
											_List_fromArray(
												[
													startOrEndOfSessionClass,
													A2($elm$html$Html$Attributes$style, 'text-wrap', 'nowrap'),
													valueNegativeClass(detail.di)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													valueView(
														$elm$core$Maybe$Just(detail.di)))
												])),
											A2(
											$elm$html$Html$td,
											_List_fromArray(
												[
													startOrEndOfSessionClass,
													A2($elm$html$Html$Attributes$style, 'text-wrap', 'nowrap')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Pages$Reports$DetailedVehicleV2$setsEmptyValue(''))
												])),
											A2(
											$elm$html$Html$td,
											_List_fromArray(
												[startOrEndOfSessionClass]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Pages$Reports$DetailedVehicleV2$setsEmptyValue(''))
												])),
											A2(
											$elm$html$Html$td,
											_List_fromArray(
												[startOrEndOfSessionClass]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Pages$Reports$DetailedVehicleV2$setsEmptyValue(''))
												])),
											A2(
											$elm$html$Html$td,
											_List_fromArray(
												[startOrEndOfSessionClass]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Pages$Reports$DetailedVehicleV2$setsEmptyValue(
														$author$project$Pages$Reports$DetailedVehicleV2$maybeCell(
															A2(
																$elm$core$Maybe$map,
																$elm$core$String$fromInt,
																$elm$core$Maybe$Just(detail.eL)))))
												])),
											A2(
											$elm$html$Html$td,
											_List_fromArray(
												[startOrEndOfSessionClass]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Pages$Reports$DetailedVehicleV2$setsEmptyValue(''))
												]))
										]);
								},
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									$krisajenkins$remotedata$RemoteData$toMaybe(result)));
							return _Utils_update(
								item,
								{iM: updateExpanded});
						} else {
							return item;
						}
					},
					model.av);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{av: updatedDetailsformatedAndFiltered}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, result));
		}
	});
var $author$project$Pages$Reports$Divergences$Details = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Reports$Divergences$GotDetails = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Reports$Divergences$ModalMsg = function (a) {
	return {$: 21, a: a};
};
var $author$project$Pages$Reports$Divergences$cardsPerPage = 10;
var $author$project$Pages$Reports$Divergences$addAnotherTab = F3(
	function (currentPage, currentTotal, rdRecords) {
		return A2(
			$krisajenkins$remotedata$RemoteData$withDefault,
			currentTotal,
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				function (r) {
					var isLastPage = _Utils_eq(
						$elm$core$Basics$ceiling(currentTotal / $author$project$Pages$Reports$Divergences$cardsPerPage),
						currentPage);
					return (_Utils_eq(
						$elm$core$List$length(r),
						$author$project$Pages$Reports$Divergences$cardsPerPage) && isLastPage) ? (currentTotal + $author$project$Pages$Reports$Divergences$cardsPerPage) : (_Utils_eq(
						$elm$core$List$length(r),
						$author$project$Pages$Reports$Divergences$cardsPerPage) ? currentTotal : (currentPage * $author$project$Pages$Reports$Divergences$cardsPerPage));
				},
				rdRecords));
	});
var $author$project$Services$Reports$Divergences$Details = F8(
	function (id, path, sourcePath, similarity, user, cardSerial, updatedAt, error) {
		return {lO: cardSerial, m$: error, dM: id, oO: path, pI: similarity, pQ: sourcePath, qs: updatedAt, kZ: user};
	});
var $author$project$Services$Reports$Divergences$User = F4(
	function (id, document, name, active) {
		return {at: active, iI: document, dM: id, c3: name};
	});
var $author$project$Services$Reports$Divergences$decodeUser = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'active',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'document',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Services$Reports$Divergences$User)))));
var $author$project$Services$Reports$Divergences$decodeDetails = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'error',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'updatedAt',
		$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'cardSerial',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'user',
				$author$project$Services$Reports$Divergences$decodeUser,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'similarity',
					$elm$json$Json$Decode$float,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'sourcePath',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'path',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'id',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Services$Reports$Divergences$Details)))))))));
var $author$project$Services$Reports$Divergences$getDetails = function (options) {
	return $author$project$Services$Api$getHttp(
		{
			m9: A2(
				$author$project$Services$Api$expectJsonErrorString,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow),
				$author$project$Services$Reports$Divergences$decodeDetails),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'recognition', options.cQ]),
				_List_Nil)
		});
};
var $author$project$Components$Patterns$Input$DualRange$isMinOrMax = F4(
	function (strOld, _new, min, max) {
		var old = A2(
			$elm$core$Maybe$withDefault,
			min,
			$elm$core$String$toInt(strOld));
		return ((_Utils_cmp(_new, min) > -1) && (_Utils_cmp(_new, max) < 1)) ? _new : old;
	});
var $author$project$Components$Patterns$Input$DualRange$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var value = msg.a;
			var vFiltered = function () {
				var _v1 = _Utils_Tuple2(
					$elm$core$String$toInt(value),
					$elm$core$String$toInt(model.bC));
				if ((!_v1.a.$) && (!_v1.b.$)) {
					var newFrom = _v1.a.a;
					var currentTo = _v1.b.a;
					return (_Utils_cmp(currentTo - newFrom, model.gW) > -1) ? $elm$core$String$fromInt(
						A4($author$project$Components$Patterns$Input$DualRange$isMinOrMax, model.bq, newFrom, model.e4, model.d$)) : model.bq;
				} else {
					return model.bq;
				}
			}();
			return _Utils_update(
				model,
				{bq: vFiltered});
		} else {
			var value = msg.a;
			var vFiltered = function () {
				var _v2 = _Utils_Tuple2(
					$elm$core$String$toInt(value),
					$elm$core$String$toInt(model.bq));
				if ((!_v2.a.$) && (!_v2.b.$)) {
					var newTo = _v2.a.a;
					var currentFrom = _v2.b.a;
					return (_Utils_cmp(newTo - currentFrom, model.gW) > -1) ? $elm$core$String$fromInt(
						A4($author$project$Components$Patterns$Input$DualRange$isMinOrMax, model.bC, newTo, model.e4, model.d$)) : model.bC;
				} else {
					return model.bC;
				}
			}();
			return _Utils_update(
				model,
				{bC: vFiltered});
		}
	});
var $author$project$Pages$Reports$Divergences$Block = function (a) {
	return {$: 1, a: a};
};
var $author$project$Services$Reports$Divergences$Block = 2;
var $author$project$Pages$Reports$Divergences$GotBlock = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Reports$Divergences$GotDetailsIgnoreConfirmation = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Reports$Divergences$GotIgnore = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Reports$Divergences$GotReprocess = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Pages$Reports$Divergences$Ignore = function (a) {
	return {$: 2, a: a};
};
var $author$project$Services$Reports$Divergences$Ignore = 1;
var $author$project$Services$Reports$Divergences$reprocessImg = function (options) {
	return $author$project$Services$Api$putHttp(
		{
			lG: $elm$http$Http$emptyBody,
			m9: $author$project$Services$Api$expectWhateverErrorString(
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					['api', 'recognition', options.cQ, 'reprocess']),
				_List_Nil)
		});
};
var $author$project$Services$Reports$Divergences$actionToStr = function (action) {
	switch (action) {
		case 0:
			return 'accept';
		case 1:
			return 'ignore';
		default:
			return 'block';
	}
};
var $author$project$Services$Reports$Divergences$update = function (options) {
	return $author$project$Services$Api$putHttp(
		{
			lG: $elm$http$Http$emptyBody,
			m9: $author$project$Services$Api$expectWhateverErrorString(
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, options.ow)),
			kU: options.kU,
			qt: A2(
				$author$project$Constants$apiV2,
				_List_fromArray(
					[
						'api',
						'recognition',
						options.cQ,
						$author$project$Services$Reports$Divergences$actionToStr(options.hV)
					]),
				_List_Nil)
		});
};
var $author$project$Pages$Reports$Divergences$updateModal = F3(
	function (msg, model, user) {
		var _v0 = _Utils_Tuple2(msg, model.aY);
		_v0$11:
		while (true) {
			switch (_v0.a.$) {
				case 8:
					if ((!_v0.b.$) && (!_v0.b.a.$)) {
						var rdResult = _v0.a.a;
						var m = _v0.b.a.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $elm$core$Maybe$Just(
										$author$project$Pages$Reports$Divergences$Details(
											_Utils_update(
												m,
												{dE: rdResult})))
								}),
							$elm$core$Platform$Cmd$none,
							A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rdResult));
					} else {
						break _v0$11;
					}
				case 0:
					if ((!_v0.b.$) && (!_v0.b.a.$)) {
						var details = _v0.a.a;
						var m = _v0.b.a.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $elm$core$Maybe$Just(
										$author$project$Pages$Reports$Divergences$Block(
											{dE: details, dP: false}))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					} else {
						break _v0$11;
					}
				case 1:
					var _v1 = _v0.a;
					var divergenceID = _v1.a;
					var maybeDetails = _v1.b;
					return A2(
						$elm$core$Maybe$withDefault,
						_Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $elm$core$Maybe$Just(
										$author$project$Pages$Reports$Divergences$Ignore(
											{dE: $krisajenkins$remotedata$RemoteData$Loading, c_: false}))
								}),
							$author$project$Services$Reports$Divergences$getDetails(
								{
									cQ: divergenceID,
									ow: A2($elm$core$Basics$composeR, $author$project$Pages$Reports$Divergences$GotDetailsIgnoreConfirmation, $author$project$Pages$Reports$Divergences$ModalMsg),
									kU: user.kU
								}),
							$author$project$Shared$NoOp),
						A2(
							$elm$core$Maybe$map,
							function (d) {
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aY: $elm$core$Maybe$Just(
												$author$project$Pages$Reports$Divergences$Ignore(
													{
														dE: $krisajenkins$remotedata$RemoteData$Success(d),
														c_: false
													}))
										}),
									$elm$core$Platform$Cmd$none,
									$author$project$Shared$NoOp);
							},
							maybeDetails));
				case 2:
					if ((!_v0.b.$) && (!_v0.b.a.$)) {
						var divergenceID = _v0.a.a;
						var m = _v0.b.a.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $elm$core$Maybe$Just(
										$author$project$Pages$Reports$Divergences$Details(
											_Utils_update(
												m,
												{br: true})))
								}),
							$author$project$Services$Reports$Divergences$reprocessImg(
								{
									cQ: divergenceID,
									ow: A2(
										$elm$core$Basics$composeR,
										$author$project$Pages$Reports$Divergences$GotReprocess(divergenceID),
										$author$project$Pages$Reports$Divergences$ModalMsg),
									kU: user.kU
								}),
							$author$project$Shared$NoOp);
					} else {
						break _v0$11;
					}
				case 9:
					if ((!_v0.b.$) && (_v0.b.a.$ === 2)) {
						var rdResult = _v0.a.a;
						var m = _v0.b.a.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $elm$core$Maybe$Just(
										$author$project$Pages$Reports$Divergences$Ignore(
											{dE: rdResult, c_: false}))
								}),
							$elm$core$Platform$Cmd$none,
							A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rdResult));
					} else {
						break _v0$11;
					}
				case 4:
					if ((!_v0.b.$) && (_v0.b.a.$ === 1)) {
						var _v2 = _v0.a;
						var m = _v0.b.a.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $elm$core$Maybe$Just(
										$author$project$Pages$Reports$Divergences$Block(
											_Utils_update(
												m,
												{dP: true})))
								}),
							$author$project$Services$Reports$Divergences$update(
								{
									hV: 2,
									cQ: m.dE.dM,
									ow: A2($elm$core$Basics$composeR, $author$project$Pages$Reports$Divergences$GotBlock, $author$project$Pages$Reports$Divergences$ModalMsg),
									kU: user.kU
								}),
							$author$project$Shared$NoOp);
					} else {
						break _v0$11;
					}
				case 5:
					if ((!_v0.b.$) && (_v0.b.a.$ === 2)) {
						var details = _v0.a.a;
						var m = _v0.b.a.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $elm$core$Maybe$Just(
										$author$project$Pages$Reports$Divergences$Ignore(
											_Utils_update(
												m,
												{c_: true})))
								}),
							$author$project$Services$Reports$Divergences$update(
								{
									hV: 1,
									cQ: details.dM,
									ow: A2($elm$core$Basics$composeR, $author$project$Pages$Reports$Divergences$GotIgnore, $author$project$Pages$Reports$Divergences$ModalMsg),
									kU: user.kU
								}),
							$author$project$Shared$NoOp);
					} else {
						break _v0$11;
					}
				case 3:
					var details = _v0.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aY: $elm$core$Maybe$Just(
									$author$project$Pages$Reports$Divergences$Details(
										{
											dE: $krisajenkins$remotedata$RemoteData$Success(details),
											br: false
										}))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				case 6:
					if ((!_v0.b.$) && (_v0.b.a.$ === 1)) {
						var rdResult = _v0.a.a;
						var m = _v0.b.a.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: A2(
										$krisajenkins$remotedata$RemoteData$withDefault,
										$elm$core$Maybe$Just(
											$author$project$Pages$Reports$Divergences$Block(m)),
										A2(
											$krisajenkins$remotedata$RemoteData$map,
											function (_v3) {
												return $elm$core$Maybe$Nothing;
											},
											rdResult))
								}),
							$author$project$Services$Reports$Divergences$getDivergences(
								{ow: $author$project$Pages$Reports$Divergences$GotDivergences, T: model.T, kU: user.kU}),
							A2(
								$author$project$Shared$remoteDataSharedMsg,
								$elm$core$Maybe$Just('Bloqueado com sucesso!'),
								rdResult));
					} else {
						break _v0$11;
					}
				case 7:
					if ((!_v0.b.$) && (_v0.b.a.$ === 2)) {
						var rdResult = _v0.a.a;
						var m = _v0.b.a.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: A2(
										$krisajenkins$remotedata$RemoteData$withDefault,
										$elm$core$Maybe$Just(
											$author$project$Pages$Reports$Divergences$Ignore(m)),
										A2(
											$krisajenkins$remotedata$RemoteData$map,
											function (_v4) {
												return $elm$core$Maybe$Nothing;
											},
											rdResult))
								}),
							$author$project$Services$Reports$Divergences$getDivergences(
								{ow: $author$project$Pages$Reports$Divergences$GotDivergences, T: model.T, kU: user.kU}),
							A2(
								$author$project$Shared$remoteDataSharedMsg,
								$elm$core$Maybe$Just('Divergência ignorada!'),
								rdResult));
					} else {
						break _v0$11;
					}
				default:
					if ((!_v0.b.$) && (!_v0.b.a.$)) {
						var _v5 = _v0.a;
						var divergenceID = _v5.a;
						var rdResult = _v5.b;
						var m = _v0.b.a.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aY: $elm$core$Maybe$Just(
										$author$project$Pages$Reports$Divergences$Details(
											_Utils_update(
												m,
												{br: false})))
								}),
							$author$project$Services$Reports$Divergences$getDetails(
								{
									cQ: divergenceID,
									ow: A2($elm$core$Basics$composeR, $author$project$Pages$Reports$Divergences$GotDetails, $author$project$Pages$Reports$Divergences$ModalMsg),
									kU: user.kU
								}),
							A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rdResult));
					} else {
						break _v0$11;
					}
			}
		}
		return _Utils_Tuple3(
			model,
			$elm$core$Platform$Cmd$none,
			$author$project$Shared$ShowErrorDialog('Essa MSG não está mapeado'));
	});
var $author$project$Pages$Reports$Divergences$valueNotEmpty = function (str) {
	return $elm$core$String$isEmpty(str) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(str);
};
var $author$project$Pages$Reports$Divergences$update = F4(
	function (msg, model, shared, user) {
		var queries = model.T;
		switch (msg.$) {
			case 0:
				var now = msg.a.e8;
				var timezone = msg.a.kS;
				var today = A2($justinmimbs$date$Date$fromPosix, timezone, now);
				var newQueries = _Utils_update(
					queries,
					{
						bl: $elm$core$Maybe$Just(
							$justinmimbs$date$Date$toIsoString(today) + 'T23:59:00'),
						bB: $elm$core$Maybe$Just(
							$justinmimbs$date$Date$toIsoString(today) + 'T00:00:00')
					});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{T: newQueries}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 1:
				var rdReport = msg.a;
				var updateQueries = _Utils_update(
					queries,
					{
						gk: A3($author$project$Pages$Reports$Divergences$addAnotherTab, queries.bv, queries.gk, rdReport)
					});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{T: updateQueries, ck: rdReport}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rdReport));
			case 2:
				var rdLines = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{n2: rdLines}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rdLines));
			case 3:
				var rdOperators = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{c5: rdOperators}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rdOperators));
			case 4:
				var rdClasses = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dv: rdClasses}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rdClasses));
			case 5:
				var rdVehicles = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{en: rdVehicles}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rdVehicles));
			case 6:
				var dateStr = msg.a;
				var startStr = A2($elm$core$Maybe$withDefault, '', dateStr);
				var newStr = ($elm$core$String$length(startStr) === 16) ? (startStr + ':00') : startStr;
				var end = A2($elm$core$Maybe$withDefault, '', queries.bl);
				var endStr = A2(
					$elm$core$Result$withDefault,
					end,
					A3(
						$elm$core$Result$map2,
						F2(
							function (from, to) {
								return (A2($justinmimbs$date$Date$compare, from, to) === 2) ? newStr : end;
							}),
						$justinmimbs$date$Date$fromIsoString(newStr),
						$justinmimbs$date$Date$fromIsoString(end)));
				var newQueries = _Utils_update(
					queries,
					{
						bl: $elm$core$Maybe$Just(endStr),
						bB: $elm$core$Maybe$Just(newStr)
					});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{T: newQueries}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 7:
				var dateStr = msg.a;
				var str = A2($elm$core$Maybe$withDefault, '', dateStr);
				var start = A2($elm$core$Maybe$withDefault, '', queries.bB);
				var newStr = ($elm$core$String$length(str) === 16) ? (str + ':00') : str;
				var startStr = A2(
					$elm$core$Result$withDefault,
					start,
					A3(
						$elm$core$Result$map2,
						F2(
							function (from, to) {
								return (A2($justinmimbs$date$Date$compare, from, to) === 2) ? newStr : start;
							}),
						$justinmimbs$date$Date$fromIsoString(start),
						$justinmimbs$date$Date$fromIsoString(newStr)));
				var newQueries = _Utils_update(
					queries,
					{
						bl: $elm$core$Maybe$Just(newStr),
						bB: $elm$core$Maybe$Just(startStr)
					});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{T: newQueries}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 8:
				var newSerialCard = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{kx: newSerialCard})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 9:
				var newUserName = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{qx: newUserName})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 10:
				var newDocument = msg.a;
				var documentFiltered = A2(
					$elm$core$Maybe$map,
					$elm$core$String$filter($elm$core$Char$isDigit),
					newDocument);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{iI: documentFiltered})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 11:
				var ms = msg.a;
				var isOpen = msg.b;
				switch (ms) {
					case 0:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{dR: isOpen}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					case 1:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{dW: isOpen}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{dT: isOpen}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					default:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{dU: isOpen}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
				}
			case 12:
				var classID = msg.a;
				var updateCodeList = function () {
					var _v2 = _Utils_Tuple2(
						$author$project$Pages$Reports$Divergences$valueNotEmpty(classID),
						A2(
							$elm$core$List$any,
							$elm$core$Basics$eq(classID),
							model.T.lX));
					if (!_v2.a.$) {
						if (_v2.b) {
							var l = _v2.a.a;
							var updateLineCodeListDeselectAllLines = A2(
								$elm$core$List$any,
								$elm$core$Basics$eq(''),
								model.T.lX) ? A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(''),
								model.T.lX) : model.T.lX;
							return A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(l),
								updateLineCodeListDeselectAllLines);
						} else {
							var l = _v2.a.a;
							var _new = A2($elm$core$List$cons, l, model.T.lX);
							var all = A2(
								$elm$core$List$map,
								function ($) {
									return $.k8;
								},
								A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, model.dv));
							return _Utils_eq(
								$elm$core$List$length(all),
								$elm$core$List$length(_new)) ? A2($elm$core$List$cons, '', _new) : _new;
						}
					} else {
						if (_v2.b) {
							var _v3 = _v2.a;
							return _List_Nil;
						} else {
							var _v4 = _v2.a;
							var all = A2(
								$elm$core$List$map,
								function ($) {
									return $.k8;
								},
								A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, model.dv));
							return A2($elm$core$List$cons, classID, all);
						}
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{lX: updateCodeList})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 13:
				var vehicleID = msg.a;
				var updateCodeList = function () {
					var _v5 = _Utils_Tuple2(
						$author$project$Pages$Reports$Divergences$valueNotEmpty(vehicleID),
						A2(
							$elm$core$List$any,
							$elm$core$Basics$eq(vehicleID),
							model.T.fN));
					if (!_v5.a.$) {
						if (_v5.b) {
							var l = _v5.a.a;
							var updateLineCodeListDeselectAllVehicles = A2(
								$elm$core$List$any,
								$elm$core$Basics$eq(''),
								model.T.fN) ? A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(''),
								model.T.fN) : model.T.fN;
							return A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(l),
								updateLineCodeListDeselectAllVehicles);
						} else {
							var l = _v5.a.a;
							var _new = A2($elm$core$List$cons, l, model.T.fN);
							var all = A2(
								$elm$core$List$map,
								function ($) {
									return $.dM;
								},
								A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, model.en));
							return _Utils_eq(
								$elm$core$List$length(all),
								$elm$core$List$length(_new)) ? A2($elm$core$List$cons, '', _new) : _new;
						}
					} else {
						if (_v5.b) {
							var _v6 = _v5.a;
							return _List_Nil;
						} else {
							var _v7 = _v5.a;
							var all = A2(
								$elm$core$List$map,
								function ($) {
									return $.dM;
								},
								A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, model.en));
							return A2($elm$core$List$cons, vehicleID, all);
						}
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{fN: updateCodeList})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 14:
				var lineCode = msg.a;
				var updateCodeList = function () {
					var _v8 = _Utils_Tuple2(
						$author$project$Pages$Reports$Divergences$valueNotEmpty(lineCode),
						A2(
							$elm$core$List$any,
							$elm$core$Basics$eq(lineCode),
							model.T.b3));
					if (!_v8.a.$) {
						if (_v8.b) {
							var l = _v8.a.a;
							var updateLineCodeListDeselectAllLines = A2(
								$elm$core$List$any,
								$elm$core$Basics$eq(''),
								model.T.b3) ? A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(''),
								model.T.b3) : model.T.b3;
							return A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(l),
								updateLineCodeListDeselectAllLines);
						} else {
							var l = _v8.a.a;
							var _new = A2($elm$core$List$cons, l, model.T.b3);
							var all = A2(
								$elm$core$List$map,
								function ($) {
									return $.e1;
								},
								A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, model.n2));
							return _Utils_eq(
								$elm$core$List$length(all),
								$elm$core$List$length(_new)) ? A2($elm$core$List$cons, '', _new) : _new;
						}
					} else {
						if (_v8.b) {
							var _v9 = _v8.a;
							return _List_Nil;
						} else {
							var _v10 = _v8.a;
							var all = A2(
								$elm$core$List$map,
								function ($) {
									return $.e1;
								},
								A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, model.n2));
							return A2($elm$core$List$cons, lineCode, all);
						}
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{b3: updateCodeList})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 15:
				var operatorID = msg.a;
				var updateCodeList = function () {
					var _v11 = _Utils_Tuple2(
						$author$project$Pages$Reports$Divergences$valueNotEmpty(operatorID),
						A2(
							$elm$core$List$any,
							$elm$core$Basics$eq(operatorID),
							model.T.g6));
					if (!_v11.a.$) {
						if (_v11.b) {
							var l = _v11.a.a;
							var updateLineCodeListDeselectAllOperators = A2(
								$elm$core$List$any,
								$elm$core$Basics$eq(''),
								model.T.g6) ? A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(''),
								model.T.g6) : model.T.g6;
							return A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(l),
								updateLineCodeListDeselectAllOperators);
						} else {
							var l = _v11.a.a;
							var _new = A2($elm$core$List$cons, l, model.T.g6);
							var all = A2(
								$elm$core$List$map,
								function ($) {
									return $.dM;
								},
								A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, model.c5));
							return _Utils_eq(
								$elm$core$List$length(all),
								$elm$core$List$length(_new)) ? A2($elm$core$List$cons, '', _new) : _new;
						}
					} else {
						if (_v11.b) {
							var _v12 = _v11.a;
							return _List_Nil;
						} else {
							var _v13 = _v11.a;
							var all = A2(
								$elm$core$List$map,
								function ($) {
									return $.dM;
								},
								A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, model.c5));
							return A2($elm$core$List$cons, operatorID, all);
						}
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{g6: updateCodeList})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 16:
				var type_ = msg.a;
				var newQueries = _Utils_update(
					queries,
					{
						kY: $author$project$Pages$Reports$Divergences$valueNotEmpty(type_)
					});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{T: newQueries}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 17:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dJ: !model.dJ}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 18:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{L: 0, ck: $krisajenkins$remotedata$RemoteData$Loading}),
					A2(
						$author$project$Route$pushUrl,
						shared.nZ,
						$author$project$Route$Report(
							$author$project$Route$Divergences(
								_Utils_update(
									queries,
									{gk: $author$project$Pages$Reports$Divergences$cardsPerPage, bv: 1, pJ: $author$project$Pages$Reports$Divergences$cardsPerPage})))),
					$author$project$Shared$NoOp);
			case 19:
				var id = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aY: $elm$core$Maybe$Just(
								$author$project$Pages$Reports$Divergences$Details(
									{dE: $krisajenkins$remotedata$RemoteData$Loading, br: false}))
						}),
					$author$project$Services$Reports$Divergences$getDetails(
						{
							cQ: id,
							ow: A2($elm$core$Basics$composeR, $author$project$Pages$Reports$Divergences$GotDetails, $author$project$Pages$Reports$Divergences$ModalMsg),
							kU: user.kU
						}),
					$author$project$Shared$NoOp);
			case 20:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aY: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 21:
				var msg_ = msg.a;
				return A3($author$project$Pages$Reports$Divergences$updateModal, msg_, model, user);
			default:
				var msg_ = msg.a;
				var newDualRangeComp = A2($author$project$Components$Patterns$Input$DualRange$update, msg_, model.dG);
				var newQueries = _Utils_update(
					queries,
					{
						iY: A2(
							$elm$core$Maybe$withDefault,
							queries.iY,
							$elm$core$String$toInt(newDualRangeComp.bq)),
						kT: A2(
							$elm$core$Maybe$withDefault,
							queries.kT,
							$elm$core$String$toInt(newDualRangeComp.bC))
					});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dG: newDualRangeComp, T: newQueries}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
		}
	});
var $author$project$Pages$Reports$Event$Audit$GenerateCsvDownloadWithTime = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Reports$Event$Audit$reportHeaders = _List_fromArray(
	['Criado em', 'Identificador do Veículo', 'Serial do equipamento', 'Descrição do evento de erro', 'Informações complementares do evento de erro']);
var $author$project$Pages$Reports$Event$Audit$setsEmptyValue = function (v_) {
	return $elm$core$String$isEmpty(v_) ? '-' : v_;
};
var $author$project$Pages$Reports$Event$Audit$reportRow = F2(
	function (timezone, row) {
		return A2(
			$elm$core$List$map,
			$author$project$Pages$Reports$Event$Audit$setsEmptyValue,
			_List_fromArray(
				[
					A2($author$project$Utils$formatDateTimeFromPosixWithSeconds, timezone, row.ix),
					row.em,
					row.k0,
					row.m3,
					row.ca
				]));
	});
var $author$project$Pages$Reports$Event$Audit$valueNotEmpty = function (str) {
	return $elm$core$String$isEmpty(str) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(str);
};
var $author$project$Pages$Reports$Event$Audit$update = F3(
	function (msg, model, shared) {
		var queries = model.T;
		switch (msg.$) {
			case 0:
				var now = msg.a.e8;
				var timezone = msg.a.kS;
				var today = A2($justinmimbs$date$Date$fromPosix, timezone, now);
				var newQueries = _Utils_update(
					queries,
					{
						bl: $elm$core$Maybe$Just(
							$justinmimbs$date$Date$toIsoString(today)),
						bB: $elm$core$Maybe$Just(
							$justinmimbs$date$Date$toIsoString(
								A3($justinmimbs$date$Date$add, 3, -1, today)))
					});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{T: newQueries}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 1:
				var rd = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ck: rd}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rd));
			case 2:
				var rd = msg.a;
				var list = A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, rd);
				var updateQueriesVehicles = _Utils_eq(
					$elm$core$List$length(queries.en),
					$elm$core$List$length(list)) ? A2($elm$core$List$cons, '', queries.en) : queries.en;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{en: updateQueriesVehicles}),
							en: list
						}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rd));
			case 3:
				var dateStr = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{bB: dateStr})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 4:
				var dateStr = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{bl: dateStr})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 5:
				var userStr = msg.a;
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
			case 6:
				var ms = msg.a;
				var isOpen = msg.b;
				if (!ms) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dW: isOpen}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dQ: isOpen}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				}
			case 7:
				var vehicleID = msg.a;
				var updateVehicleList = function () {
					var _v2 = _Utils_Tuple2(
						$author$project$Pages$Reports$Event$Audit$valueNotEmpty(vehicleID),
						A2(
							$elm$core$List$any,
							$elm$core$Basics$eq(vehicleID),
							model.T.en));
					if (!_v2.a.$) {
						if (_v2.b) {
							var l = _v2.a.a;
							var updateVehicleListDeselectAll = A2(
								$elm$core$List$any,
								$elm$core$Basics$eq(''),
								model.T.en) ? A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(''),
								model.T.en) : model.T.en;
							return A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(l),
								updateVehicleListDeselectAll);
						} else {
							var l = _v2.a.a;
							var newVehiclesIDList = A2($elm$core$List$cons, l, model.T.en);
							var allVehiclesID = A2(
								$elm$core$List$map,
								function ($) {
									return $.dM;
								},
								model.en);
							return _Utils_eq(
								$elm$core$List$length(allVehiclesID),
								$elm$core$List$length(newVehiclesIDList)) ? A2($elm$core$List$cons, '', newVehiclesIDList) : newVehiclesIDList;
						}
					} else {
						if (_v2.b) {
							var _v3 = _v2.a;
							return _List_Nil;
						} else {
							var _v4 = _v2.a;
							var allLines = A2(
								$elm$core$List$map,
								function ($) {
									return $.dM;
								},
								model.en);
							return A2($elm$core$List$cons, vehicleID, allLines);
						}
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{en: updateVehicleList})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 8:
				var actionTypeCODE = msg.a;
				var updateCodeList = function () {
					var _v5 = _Utils_Tuple2(
						$author$project$Pages$Reports$Event$Audit$valueNotEmpty(actionTypeCODE),
						A2(
							$elm$core$List$any,
							$elm$core$Basics$eq(actionTypeCODE),
							model.T.bX));
					if (!_v5.a.$) {
						if (_v5.b) {
							var l = _v5.a.a;
							var updateLineCodeListDeselectAllLines = A2(
								$elm$core$List$any,
								$elm$core$Basics$eq(''),
								model.T.bX) ? A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(''),
								model.T.bX) : model.T.bX;
							return A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(l),
								updateLineCodeListDeselectAllLines);
						} else {
							var l = _v5.a.a;
							var _new = A2($elm$core$List$cons, l, model.T.bX);
							var all = A2(
								$elm$core$List$map,
								function ($) {
									return $.l4;
								},
								model.dl);
							return _Utils_eq(
								$elm$core$List$length(all),
								$elm$core$List$length(_new)) ? A2($elm$core$List$cons, '', _new) : _new;
						}
					} else {
						if (_v5.b) {
							var _v6 = _v5.a;
							return _List_Nil;
						} else {
							var _v7 = _v5.a;
							var all = A2(
								$elm$core$List$map,
								function ($) {
									return $.l4;
								},
								model.dl);
							return A2($elm$core$List$cons, actionTypeCODE, all);
						}
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{bX: updateCodeList})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 9:
				return _Utils_Tuple3(
					model,
					A2(
						$author$project$Route$pushUrl,
						shared.nZ,
						$author$project$Route$Report(
							$author$project$Route$Event(
								$author$project$Route$Audit(queries)))),
					$author$project$Shared$NoOp);
			case 10:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dK: !model.dK}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 11:
				return _Utils_Tuple3(
					model,
					A2(
						$elm$core$Task$perform,
						$author$project$Pages$Reports$Event$Audit$GenerateCsvDownloadWithTime,
						A3(
							$elm$core$Task$map2,
							F2(
								function (now, timezone) {
									return {e8: now, kS: timezone};
								}),
							$elm$time$Time$now,
							$elm$time$Time$here)),
					$author$project$Shared$NoOp);
			default:
				var now = msg.a.e8;
				var timezone = msg.a.kS;
				var title_ = 'Auditoria ' + (A2($author$project$Utils$formatDateTimeFromPosix, timezone, now) + '.csv');
				var records = A2(
					$krisajenkins$remotedata$RemoteData$withDefault,
					_List_Nil,
					A2(
						$krisajenkins$remotedata$RemoteData$map,
						$elm$core$List$map(
							function (item) {
								return A2($author$project$Pages$Reports$Event$Audit$reportRow, shared.kS, item);
							}),
						model.ck));
				var headers = $author$project$Pages$Reports$Event$Audit$reportHeaders;
				return _Utils_Tuple3(
					model,
					A3($author$project$Components$GeneratorCSV$download, records, headers, title_),
					$author$project$Shared$NoOp);
		}
	});
var $author$project$Pages$Reports$Event$UsingDay$GenerateCsvDownloadWithTime = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Reports$Event$UsingDay$dataHeaders = function (headers_) {
	return $elm$core$List$concat(
		A2(
			$elm$core$List$map,
			function (h_) {
				var addCount = function (hStr) {
					return ((h_.dM === 'totalQuantity') || (h_.dM === 'totalFare')) ? _List_Nil : _List_fromArray(
						['Contador ' + hStr]);
				};
				return $elm$core$String$isEmpty(h_.kY) ? _Utils_ap(
					addCount(h_.ik),
					_List_fromArray(
						[h_.ik])) : _Utils_ap(
					addCount(h_.kY),
					_List_fromArray(
						[h_.kY]));
			},
			headers_));
};
var $author$project$Pages$Reports$Event$UsingDay$headers = function (data) {
	return _Utils_ap(
		_List_fromArray(
			['Dia']),
		$author$project$Pages$Reports$Event$UsingDay$dataHeaders(data.nG));
};
var $author$project$Pages$Reports$Event$UsingDay$recordCSV = F3(
	function (headers_, timezone, row) {
		var cell = F2(
			function (identifier, h) {
				var totalQuantity = ($elm$core$String$toLower(h) === 'quantidade total') ? A2(
					$elm$core$Maybe$map,
					$elm$core$String$fromInt,
					A2($elm$core$Dict$get, 'totalQuantity', row.dv)) : ((($elm$core$String$toLower(h) === 'tarifa total') || ($elm$core$String$toLower(h) === 'valor total')) ? A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Utils$formatAsMoney, $elm$core$String$fromInt),
					A2($elm$core$Dict$get, 'totalFare', row.ni)) : $elm$core$Maybe$Nothing);
				var quantity = A2(
					$elm$core$Maybe$map,
					$elm$core$String$fromInt,
					A2($elm$core$Dict$get, identifier, row.dv));
				var fare = A2(
					$elm$core$Maybe$map,
					$elm$core$String$fromInt,
					A2($elm$core$Dict$get, identifier, row.ni));
				var addCount = function (q_) {
					return ((h === 'Quantidade Total') || (h === 'Valor Total')) ? _List_Nil : _List_fromArray(
						[q_]);
				};
				var _v0 = _Utils_Tuple3(quantity, fare, totalQuantity);
				if (!_v0.a.$) {
					if (!_v0.b.$) {
						var q = _v0.a.a;
						var f = _v0.b.a;
						return _Utils_ap(
							addCount(q),
							_List_fromArray(
								[
									$author$project$Utils$formatAsMoney(f)
								]));
					} else {
						var q = _v0.a.a;
						var _v2 = _v0.b;
						return addCount(q);
					}
				} else {
					if (!_v0.b.$) {
						var _v1 = _v0.a;
						var f = _v0.b.a;
						return _List_fromArray(
							[
								$author$project$Utils$formatAsMoney(f)
							]);
					} else {
						if (!_v0.c.$) {
							var _v3 = _v0.a;
							var _v4 = _v0.b;
							var total = _v0.c.a;
							return _List_fromArray(
								[total]);
						} else {
							var _v5 = _v0.a;
							var _v6 = _v0.b;
							var _v7 = _v0.c;
							return _List_fromArray(
								['-', '-']);
						}
					}
				}
			});
		return A2(
			$elm$core$List$cons,
			A2($author$project$Utils$formatDateFromPosix, $elm$time$Time$utc, row.fD),
			$elm$core$List$concat(
				A2(
					$elm$core$List$map,
					function (h_) {
						return $elm$core$String$isEmpty(h_.kY) ? A2(cell, h_.dM, h_.kY) : A2(cell, h_.dM, h_.ik);
					},
					headers_)));
	});
var $author$project$Pages$Reports$Event$UsingDay$update = F3(
	function (msg, model, shared) {
		var queries = model.T;
		switch (msg.$) {
			case 0:
				var now = msg.a.e8;
				var timezone = msg.a.kS;
				var today = A2($justinmimbs$date$Date$fromPosix, timezone, now);
				var newQueries = _Utils_update(
					queries,
					{
						bl: $elm$core$Maybe$Just(
							$justinmimbs$date$Date$toIsoString(today)),
						bB: $elm$core$Maybe$Just(
							$justinmimbs$date$Date$toIsoString(today))
					});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{T: newQueries}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 1:
				var table = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ck: table}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, table));
			case 2:
				var dateStr = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{bB: dateStr})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 3:
				var dateStr = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{bl: dateStr})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 4:
				return _Utils_Tuple3(
					model,
					A2(
						$author$project$Route$pushUrl,
						shared.nZ,
						$author$project$Route$Report(
							$author$project$Route$Event(
								$author$project$Route$UsingDay(model.T)))),
					$author$project$Shared$NoOp);
			case 5:
				return _Utils_Tuple3(
					model,
					A2(
						$elm$core$Task$perform,
						$author$project$Pages$Reports$Event$UsingDay$GenerateCsvDownloadWithTime,
						A3(
							$elm$core$Task$map2,
							F2(
								function (now, timezone) {
									return {e8: now, kS: timezone};
								}),
							$elm$time$Time$now,
							$elm$time$Time$here)),
					$author$project$Shared$NoOp);
			default:
				var now = msg.a.e8;
				var timezone = msg.a.kS;
				return A2(
					$krisajenkins$remotedata$RemoteData$withDefault,
					_Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$ShowErrorDialog('Não foi possível gera o arquivo CSV')),
					A2(
						$krisajenkins$remotedata$RemoteData$map,
						function (data) {
							var title_ = 'Utilização por dia baseado em eventos ' + (A2($author$project$Utils$formatDateTimeFromPosix, timezone, now) + '.csv');
							var records = A2(
								$elm$core$List$map,
								A2($author$project$Pages$Reports$Event$UsingDay$recordCSV, data.nG, shared.kS),
								data.px);
							return _Utils_Tuple3(
								model,
								A3(
									$author$project$Components$GeneratorCSV$download,
									records,
									$author$project$Pages$Reports$Event$UsingDay$headers(data),
									title_),
								$author$project$Shared$NoOp);
						},
						model.ck));
		}
	});
var $author$project$Pages$Reports$Event$UsingLine$GenerateCsvDownloadWithTime = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Reports$Event$UsingLine$dataHeaders = function (headers_) {
	return $elm$core$List$concat(
		A2(
			$elm$core$List$map,
			function (h_) {
				var addCount = function (hStr) {
					return ((h_.dM === 'totalQuantity') || (h_.dM === 'totalFare')) ? _List_Nil : _List_fromArray(
						['Contador ' + hStr]);
				};
				return $elm$core$String$isEmpty(h_.kY) ? _Utils_ap(
					addCount(h_.ik),
					_List_fromArray(
						[h_.ik])) : _Utils_ap(
					addCount(h_.kY),
					_List_fromArray(
						[h_.kY]));
			},
			headers_));
};
var $author$project$Pages$Reports$Event$UsingLine$headers = function (data) {
	return _Utils_ap(
		_List_fromArray(
			['Linha']),
		$author$project$Pages$Reports$Event$UsingLine$dataHeaders(data.nG));
};
var $author$project$Pages$Reports$Event$UsingLine$recordCSV = F3(
	function (headers_, timezone, row) {
		var cell = F2(
			function (identifier, h) {
				var totalQuantity = ($elm$core$String$toLower(h) === 'quantidade total') ? A2(
					$elm$core$Maybe$map,
					$elm$core$String$fromInt,
					A2($elm$core$Dict$get, 'totalQuantity', row.dv)) : ((($elm$core$String$toLower(h) === 'tarifa total') || ($elm$core$String$toLower(h) === 'valor total')) ? A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Utils$formatAsMoney, $elm$core$String$fromInt),
					A2($elm$core$Dict$get, 'totalFare', row.ni)) : $elm$core$Maybe$Nothing);
				var quantity = A2(
					$elm$core$Maybe$map,
					$elm$core$String$fromInt,
					A2($elm$core$Dict$get, identifier, row.dv));
				var fare = A2(
					$elm$core$Maybe$map,
					$elm$core$String$fromInt,
					A2($elm$core$Dict$get, identifier, row.ni));
				var addCount = function (q_) {
					return ((h === 'Quantidade Total') || (h === 'Valor Total')) ? _List_Nil : _List_fromArray(
						[q_]);
				};
				var _v0 = _Utils_Tuple3(quantity, fare, totalQuantity);
				if (!_v0.a.$) {
					if (!_v0.b.$) {
						var q = _v0.a.a;
						var f = _v0.b.a;
						return _Utils_ap(
							addCount(q),
							_List_fromArray(
								[
									$author$project$Utils$formatAsMoney(f)
								]));
					} else {
						var q = _v0.a.a;
						var _v2 = _v0.b;
						return addCount(q);
					}
				} else {
					if (!_v0.b.$) {
						var _v1 = _v0.a;
						var f = _v0.b.a;
						return _List_fromArray(
							[
								$author$project$Utils$formatAsMoney(f)
							]);
					} else {
						if (!_v0.c.$) {
							var _v3 = _v0.a;
							var _v4 = _v0.b;
							var total = _v0.c.a;
							return _List_fromArray(
								[total]);
						} else {
							var _v5 = _v0.a;
							var _v6 = _v0.b;
							var _v7 = _v0.c;
							return _List_fromArray(
								['-', '-']);
						}
					}
				}
			});
		return A2(
			$elm$core$List$cons,
			row.fD,
			$elm$core$List$concat(
				A2(
					$elm$core$List$map,
					function (h_) {
						return $elm$core$String$isEmpty(h_.kY) ? A2(cell, h_.dM, h_.kY) : A2(cell, h_.dM, h_.ik);
					},
					headers_)));
	});
var $author$project$Pages$Reports$Event$UsingLine$valueNotEmpty = function (str) {
	return $elm$core$String$isEmpty(str) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(str);
};
var $author$project$Pages$Reports$Event$UsingLine$update = F3(
	function (msg, model, shared) {
		var queries = model.T;
		switch (msg.$) {
			case 0:
				var now = msg.a.e8;
				var timezone = msg.a.kS;
				var today = A2($justinmimbs$date$Date$fromPosix, timezone, now);
				var newQueries = _Utils_update(
					queries,
					{
						bl: $elm$core$Maybe$Just(
							$justinmimbs$date$Date$toIsoString(today)),
						bB: $elm$core$Maybe$Just(
							$justinmimbs$date$Date$toIsoString(today))
					});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{T: newQueries}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 1:
				var table = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ck: table}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, table));
			case 2:
				var rd = msg.a;
				var list = A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, rd);
				var updateQueriesLines = _Utils_eq(
					$elm$core$List$length(queries.n2),
					$elm$core$List$length(list)) ? A2($elm$core$List$cons, '', queries.n2) : queries.n2;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							n2: list,
							T: _Utils_update(
								queries,
								{n2: updateQueriesLines})
						}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rd));
			case 3:
				var dateStr = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{bB: dateStr})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 4:
				var dateStr = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{bl: dateStr})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 5:
				var lineCode = msg.a;
				var updateLineCodeList = function () {
					var _v1 = _Utils_Tuple2(
						$author$project$Pages$Reports$Event$UsingLine$valueNotEmpty(lineCode),
						A2(
							$elm$core$List$any,
							$elm$core$Basics$eq(lineCode),
							model.T.n2));
					if (!_v1.a.$) {
						if (_v1.b) {
							var l = _v1.a.a;
							var updateLineCodeListDeselectAllLines = A2(
								$elm$core$List$any,
								$elm$core$Basics$eq(''),
								model.T.n2) ? A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(''),
								model.T.n2) : model.T.n2;
							return A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(l),
								updateLineCodeListDeselectAllLines);
						} else {
							var l = _v1.a.a;
							var newOperatorIDList = A2($elm$core$List$cons, l, model.T.n2);
							var allOperatorsID = A2(
								$elm$core$List$map,
								function ($) {
									return $.e1;
								},
								model.n2);
							return _Utils_eq(
								$elm$core$List$length(allOperatorsID),
								$elm$core$List$length(newOperatorIDList)) ? A2($elm$core$List$cons, '', newOperatorIDList) : newOperatorIDList;
						}
					} else {
						if (_v1.b) {
							var _v2 = _v1.a;
							return _List_Nil;
						} else {
							var _v3 = _v1.a;
							var allLines = A2(
								$elm$core$List$map,
								function ($) {
									return $.e1;
								},
								model.n2);
							return A2($elm$core$List$cons, lineCode, allLines);
						}
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{n2: updateLineCodeList})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 6:
				var ms = msg.a;
				var isOpen = msg.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dT: isOpen}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 7:
				return _Utils_Tuple3(
					model,
					A2(
						$author$project$Route$pushUrl,
						shared.nZ,
						$author$project$Route$Report(
							$author$project$Route$Event(
								$author$project$Route$UsingLine(model.T)))),
					$author$project$Shared$NoOp);
			case 8:
				return _Utils_Tuple3(
					model,
					A2(
						$elm$core$Task$perform,
						$author$project$Pages$Reports$Event$UsingLine$GenerateCsvDownloadWithTime,
						A3(
							$elm$core$Task$map2,
							F2(
								function (now, timezone) {
									return {e8: now, kS: timezone};
								}),
							$elm$time$Time$now,
							$elm$time$Time$here)),
					$author$project$Shared$NoOp);
			default:
				var now = msg.a.e8;
				var timezone = msg.a.kS;
				return A2(
					$krisajenkins$remotedata$RemoteData$withDefault,
					_Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$ShowErrorDialog('Não foi possível gera o arquivo CSV')),
					A2(
						$krisajenkins$remotedata$RemoteData$map,
						function (data) {
							var title_ = 'Utilização por linha baseado em eventos ' + (A2($author$project$Utils$formatDateTimeFromPosix, timezone, now) + '.csv');
							var records = A2(
								$elm$core$List$map,
								A2($author$project$Pages$Reports$Event$UsingLine$recordCSV, data.nG, shared.kS),
								data.px);
							return _Utils_Tuple3(
								model,
								A3(
									$author$project$Components$GeneratorCSV$download,
									records,
									$author$project$Pages$Reports$Event$UsingLine$headers(data),
									title_),
								$author$project$Shared$NoOp);
						},
						model.ck));
		}
	});
var $author$project$Pages$Reports$Event$UsingOperator$GenerateCsvDownloadWithTime = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Reports$Event$UsingOperator$dataHeaders = function (headers_) {
	return $elm$core$List$concat(
		A2(
			$elm$core$List$map,
			function (h_) {
				var addCount = function (hStr) {
					return ((h_.dM === 'totalQuantity') || (h_.dM === 'totalFare')) ? _List_Nil : _List_fromArray(
						['Contador ' + hStr]);
				};
				return $elm$core$String$isEmpty(h_.kY) ? _Utils_ap(
					addCount(h_.ik),
					_List_fromArray(
						[h_.ik])) : _Utils_ap(
					addCount(h_.kY),
					_List_fromArray(
						[h_.kY]));
			},
			headers_));
};
var $author$project$Pages$Reports$Event$UsingOperator$headers = function (data) {
	return _Utils_ap(
		_List_fromArray(
			['Operador']),
		$author$project$Pages$Reports$Event$UsingOperator$dataHeaders(data.nG));
};
var $author$project$Pages$Reports$Event$UsingOperator$recordCSV = F3(
	function (headers_, timezone, row) {
		var cell = F2(
			function (identifier, h) {
				var totalQuantity = ($elm$core$String$toLower(h) === 'quantidade total') ? A2(
					$elm$core$Maybe$map,
					$elm$core$String$fromInt,
					A2($elm$core$Dict$get, 'totalQuantity', row.dv)) : ((($elm$core$String$toLower(h) === 'tarifa total') || ($elm$core$String$toLower(h) === 'valor total')) ? A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Utils$formatAsMoney, $elm$core$String$fromInt),
					A2($elm$core$Dict$get, 'totalFare', row.ni)) : $elm$core$Maybe$Nothing);
				var quantity = A2(
					$elm$core$Maybe$map,
					$elm$core$String$fromInt,
					A2($elm$core$Dict$get, identifier, row.dv));
				var fare = A2(
					$elm$core$Maybe$map,
					$elm$core$String$fromInt,
					A2($elm$core$Dict$get, identifier, row.ni));
				var addCount = function (q_) {
					return ((h === 'Quantidade Total') || (h === 'Valor Total')) ? _List_Nil : _List_fromArray(
						[q_]);
				};
				var _v0 = _Utils_Tuple3(quantity, fare, totalQuantity);
				if (!_v0.a.$) {
					if (!_v0.b.$) {
						var q = _v0.a.a;
						var f = _v0.b.a;
						return _Utils_ap(
							addCount(q),
							_List_fromArray(
								[
									$author$project$Utils$formatAsMoney(f)
								]));
					} else {
						var q = _v0.a.a;
						var _v2 = _v0.b;
						return addCount(q);
					}
				} else {
					if (!_v0.b.$) {
						var _v1 = _v0.a;
						var f = _v0.b.a;
						return _List_fromArray(
							[
								$author$project$Utils$formatAsMoney(f)
							]);
					} else {
						if (!_v0.c.$) {
							var _v3 = _v0.a;
							var _v4 = _v0.b;
							var total = _v0.c.a;
							return _List_fromArray(
								[total]);
						} else {
							var _v5 = _v0.a;
							var _v6 = _v0.b;
							var _v7 = _v0.c;
							return _List_fromArray(
								['-', '-']);
						}
					}
				}
			});
		return A2(
			$elm$core$List$cons,
			row.fD,
			$elm$core$List$concat(
				A2(
					$elm$core$List$map,
					function (h_) {
						return $elm$core$String$isEmpty(h_.kY) ? A2(cell, h_.dM, h_.kY) : A2(cell, h_.dM, h_.ik);
					},
					headers_)));
	});
var $author$project$Pages$Reports$Event$UsingOperator$valueNotEmpty = function (str) {
	return $elm$core$String$isEmpty(str) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(str);
};
var $author$project$Pages$Reports$Event$UsingOperator$update = F3(
	function (msg, model, shared) {
		var queries = model.T;
		switch (msg.$) {
			case 0:
				var now = msg.a.e8;
				var timezone = msg.a.kS;
				var today = A2($justinmimbs$date$Date$fromPosix, timezone, now);
				var newQueries = _Utils_update(
					queries,
					{
						bl: $elm$core$Maybe$Just(
							$justinmimbs$date$Date$toIsoString(today)),
						bB: $elm$core$Maybe$Just(
							$justinmimbs$date$Date$toIsoString(today))
					});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{T: newQueries}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 1:
				var table = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ck: table}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, table));
			case 2:
				var rd = msg.a;
				var list = A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, rd);
				var updateQueriesOperators = _Utils_eq(
					$elm$core$List$length(queries.c5),
					$elm$core$List$length(list)) ? A2($elm$core$List$cons, '', queries.c5) : queries.c5;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							c5: list,
							T: _Utils_update(
								queries,
								{c5: updateQueriesOperators})
						}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rd));
			case 3:
				var dateStr = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{bB: dateStr})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 4:
				var dateStr = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{bl: dateStr})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 5:
				var lineCode = msg.a;
				var updateLineCodeList = function () {
					var _v1 = _Utils_Tuple2(
						$author$project$Pages$Reports$Event$UsingOperator$valueNotEmpty(lineCode),
						A2(
							$elm$core$List$any,
							$elm$core$Basics$eq(lineCode),
							model.T.c5));
					if (!_v1.a.$) {
						if (_v1.b) {
							var l = _v1.a.a;
							var updateLineCodeListDeselectAllLines = A2(
								$elm$core$List$any,
								$elm$core$Basics$eq(''),
								model.T.c5) ? A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(''),
								model.T.c5) : model.T.c5;
							return A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(l),
								updateLineCodeListDeselectAllLines);
						} else {
							var l = _v1.a.a;
							var newOperatorIDList = A2($elm$core$List$cons, l, model.T.c5);
							var allOperatorsID = A2(
								$elm$core$List$map,
								function ($) {
									return $.dM;
								},
								model.c5);
							return _Utils_eq(
								$elm$core$List$length(allOperatorsID),
								$elm$core$List$length(newOperatorIDList)) ? A2($elm$core$List$cons, '', newOperatorIDList) : newOperatorIDList;
						}
					} else {
						if (_v1.b) {
							var _v2 = _v1.a;
							return _List_Nil;
						} else {
							var _v3 = _v1.a;
							var allOperators = A2(
								$elm$core$List$map,
								function ($) {
									return $.dM;
								},
								model.c5);
							return A2($elm$core$List$cons, lineCode, allOperators);
						}
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{c5: updateLineCodeList})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 6:
				return _Utils_Tuple3(
					model,
					A2(
						$author$project$Route$pushUrl,
						shared.nZ,
						$author$project$Route$Report(
							$author$project$Route$Event(
								$author$project$Route$UsingOperator(model.T)))),
					$author$project$Shared$NoOp);
			case 7:
				return _Utils_Tuple3(
					model,
					A2(
						$elm$core$Task$perform,
						$author$project$Pages$Reports$Event$UsingOperator$GenerateCsvDownloadWithTime,
						A3(
							$elm$core$Task$map2,
							F2(
								function (now, timezone) {
									return {e8: now, kS: timezone};
								}),
							$elm$time$Time$now,
							$elm$time$Time$here)),
					$author$project$Shared$NoOp);
			case 8:
				var now = msg.a.e8;
				var timezone = msg.a.kS;
				return A2(
					$krisajenkins$remotedata$RemoteData$withDefault,
					_Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$ShowErrorDialog('Não foi possível gera o arquivo CSV')),
					A2(
						$krisajenkins$remotedata$RemoteData$map,
						function (data) {
							var title_ = 'Utilização por operador baseado em eventos ' + (A2($author$project$Utils$formatDateTimeFromPosix, timezone, now) + '.csv');
							var records = A2(
								$elm$core$List$map,
								A2($author$project$Pages$Reports$Event$UsingOperator$recordCSV, data.nG, shared.kS),
								data.px);
							return _Utils_Tuple3(
								model,
								A3(
									$author$project$Components$GeneratorCSV$download,
									records,
									$author$project$Pages$Reports$Event$UsingOperator$headers(data),
									title_),
								$author$project$Shared$NoOp);
						},
						model.ck));
			default:
				var ms = msg.a;
				var isOpen = msg.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dU: isOpen}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
		}
	});
var $author$project$Pages$Reports$Event$UsingSession$CompPDFCreateMSg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Reports$Event$UsingSession$valueNotEmpty = function (str) {
	return $elm$core$String$isEmpty(str) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(str);
};
var $author$project$Pages$Reports$Event$UsingSession$update = F4(
	function (msg, model, shared, user) {
		var queries = model.T;
		switch (msg.$) {
			case 0:
				var now = msg.a.e8;
				var timezone = msg.a.kS;
				var today = A2($justinmimbs$date$Date$fromPosix, timezone, now);
				var newQueries = _Utils_update(
					queries,
					{
						bl: $elm$core$Maybe$Just(
							$justinmimbs$date$Date$toIsoString(today) + 'T23:59:00'),
						bB: $elm$core$Maybe$Just(
							$justinmimbs$date$Date$toIsoString(today) + 'T00:00:00')
					});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{T: newQueries}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 1:
				var table = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ck: table}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, table));
			case 2:
				var rd = msg.a;
				var list = A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, rd);
				var updateQueriesOperators = _Utils_eq(
					$elm$core$List$length(queries.c5),
					$elm$core$List$length(list)) ? A2($elm$core$List$cons, '', queries.c5) : queries.c5;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							c5: list,
							T: _Utils_update(
								queries,
								{c5: updateQueriesOperators})
						}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rd));
			case 3:
				var rd = msg.a;
				var list = A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, rd);
				var updateQueriesLines = _Utils_eq(
					$elm$core$List$length(queries.n2),
					$elm$core$List$length(list)) ? A2($elm$core$List$cons, '', queries.n2) : queries.n2;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							n2: list,
							T: _Utils_update(
								queries,
								{n2: updateQueriesLines})
						}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rd));
			case 4:
				var rd = msg.a;
				var list = A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, rd);
				var updateQueriesVehicles = _Utils_eq(
					$elm$core$List$length(queries.en),
					$elm$core$List$length(list)) ? A2($elm$core$List$cons, '', queries.en) : queries.en;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{en: updateQueriesVehicles}),
							en: list
						}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rd));
			case 5:
				var dateStr = msg.a;
				var newStr = function (str) {
					return ($elm$core$String$length(str) === 16) ? (str + ':00') : str;
				};
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{
									bB: A2($elm$core$Maybe$map, newStr, dateStr)
								})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 6:
				var dateStr = msg.a;
				var newStr = function (str) {
					return ($elm$core$String$length(str) === 16) ? (str + ':00') : str;
				};
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{
									bl: A2($elm$core$Maybe$map, newStr, dateStr)
								})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 7:
				var lineCode = msg.a;
				var updateLineCodeList = function () {
					var _v1 = _Utils_Tuple2(
						$author$project$Pages$Reports$Event$UsingSession$valueNotEmpty(lineCode),
						A2(
							$elm$core$List$any,
							$elm$core$Basics$eq(lineCode),
							model.T.n2));
					if (!_v1.a.$) {
						if (_v1.b) {
							var l = _v1.a.a;
							var updateLineCodeListDeselectAllLines = A2(
								$elm$core$List$any,
								$elm$core$Basics$eq(''),
								model.T.n2) ? A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(''),
								model.T.n2) : model.T.n2;
							return A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(l),
								updateLineCodeListDeselectAllLines);
						} else {
							var l = _v1.a.a;
							var newOperatorIDList = A2($elm$core$List$cons, l, model.T.n2);
							var allOperatorsID = A2(
								$elm$core$List$map,
								function ($) {
									return $.e1;
								},
								model.n2);
							return _Utils_eq(
								$elm$core$List$length(allOperatorsID),
								$elm$core$List$length(newOperatorIDList)) ? A2($elm$core$List$cons, '', newOperatorIDList) : newOperatorIDList;
						}
					} else {
						if (_v1.b) {
							var _v2 = _v1.a;
							return _List_Nil;
						} else {
							var _v3 = _v1.a;
							var allOperators = A2(
								$elm$core$List$map,
								function ($) {
									return $.e1;
								},
								model.n2);
							return A2($elm$core$List$cons, lineCode, allOperators);
						}
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{n2: updateLineCodeList})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 8:
				var newOperator = msg.a;
				var updateOperatorCodeList = function () {
					var _v4 = _Utils_Tuple2(
						$author$project$Pages$Reports$Event$UsingSession$valueNotEmpty(newOperator),
						A2(
							$elm$core$List$any,
							$elm$core$Basics$eq(newOperator),
							model.T.c5));
					if (!_v4.a.$) {
						if (_v4.b) {
							var l = _v4.a.a;
							var updateOperatorListDeselectAllLines = A2(
								$elm$core$List$any,
								$elm$core$Basics$eq(''),
								model.T.c5) ? A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(''),
								model.T.c5) : model.T.c5;
							return A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(l),
								updateOperatorListDeselectAllLines);
						} else {
							var l = _v4.a.a;
							var newOperatorIDList = A2($elm$core$List$cons, l, model.T.c5);
							var allOperatorsID = A2(
								$elm$core$List$map,
								function ($) {
									return $.dM;
								},
								model.c5);
							return _Utils_eq(
								$elm$core$List$length(allOperatorsID),
								$elm$core$List$length(newOperatorIDList)) ? A2($elm$core$List$cons, '', newOperatorIDList) : newOperatorIDList;
						}
					} else {
						if (_v4.b) {
							var _v5 = _v4.a;
							return _List_Nil;
						} else {
							var _v6 = _v4.a;
							var allOperators = A2(
								$elm$core$List$map,
								function ($) {
									return $.dM;
								},
								model.c5);
							return A2($elm$core$List$cons, newOperator, allOperators);
						}
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{c5: updateOperatorCodeList})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 9:
				var newVehicle = msg.a;
				var updateVehicle = function () {
					var _v7 = _Utils_Tuple2(
						$author$project$Pages$Reports$Event$UsingSession$valueNotEmpty(newVehicle),
						A2(
							$elm$core$List$any,
							$elm$core$Basics$eq(newVehicle),
							model.T.en));
					if (!_v7.a.$) {
						if (_v7.b) {
							var l = _v7.a.a;
							var updateVehicleListDeselectAllLines = A2(
								$elm$core$List$any,
								$elm$core$Basics$eq(''),
								model.T.en) ? A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(''),
								model.T.en) : model.T.en;
							return A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(l),
								updateVehicleListDeselectAllLines);
						} else {
							var l = _v7.a.a;
							var newVehicleIDList = A2($elm$core$List$cons, l, model.T.en);
							var allVehiclesID = A2(
								$elm$core$List$map,
								function ($) {
									return $.dM;
								},
								model.en);
							return _Utils_eq(
								$elm$core$List$length(allVehiclesID),
								$elm$core$List$length(newVehicleIDList)) ? A2($elm$core$List$cons, '', newVehicleIDList) : newVehicleIDList;
						}
					} else {
						if (_v7.b) {
							var _v8 = _v7.a;
							return _List_Nil;
						} else {
							var _v9 = _v7.a;
							var allVehicle = A2(
								$elm$core$List$map,
								function ($) {
									return $.dM;
								},
								model.en);
							return A2($elm$core$List$cons, newVehicle, allVehicle);
						}
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{en: updateVehicle})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 10:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dJ: !model.dJ}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 11:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ck: $krisajenkins$remotedata$RemoteData$Loading}),
					A2(
						$author$project$Route$pushUrl,
						shared.nZ,
						$author$project$Route$Report(
							$author$project$Route$Event(
								$author$project$Route$UsingSession(model.T)))),
					$author$project$Shared$NoOp);
			case 12:
				var ms = msg.a;
				var isOpen = msg.b;
				switch (ms) {
					case 0:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{dU: isOpen}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					case 1:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{dW: isOpen}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					default:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{dT: isOpen}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
				}
			case 13:
				var msg_ = msg.a;
				var _v11 = A3($author$project$Components$PDF$Create$update, msg_, model.bQ, user);
				var newCompModel = _v11.a;
				var cmd = _v11.b;
				var sharedMsg = _v11.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bQ: newCompModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Reports$Event$UsingSession$CompPDFCreateMSg, cmd),
					sharedMsg);
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
		}
	});
var $author$project$Pages$Reports$Event$UsingVehicle$GenerateCsvDownloadWithTime = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Reports$Event$UsingVehicle$dataHeaders = function (headers_) {
	return $elm$core$List$concat(
		A2(
			$elm$core$List$map,
			function (h_) {
				var addCount = function (hStr) {
					return ((h_.dM === 'totalQuantity') || (h_.dM === 'totalFare')) ? _List_Nil : _List_fromArray(
						['Contador ' + hStr]);
				};
				return $elm$core$String$isEmpty(h_.kY) ? _Utils_ap(
					addCount(h_.ik),
					_List_fromArray(
						[h_.ik])) : _Utils_ap(
					addCount(h_.kY),
					_List_fromArray(
						[h_.kY]));
			},
			headers_));
};
var $author$project$Pages$Reports$Event$UsingVehicle$headers = function (data) {
	return _Utils_ap(
		_List_fromArray(
			['Veículo']),
		$author$project$Pages$Reports$Event$UsingVehicle$dataHeaders(data.nG));
};
var $author$project$Pages$Reports$Event$UsingVehicle$recordCSV = F3(
	function (headers_, timezone, row) {
		var cell = F2(
			function (identifier, h) {
				var totalQuantity = ($elm$core$String$toLower(h) === 'quantidade total') ? A2(
					$elm$core$Maybe$map,
					$elm$core$String$fromInt,
					A2($elm$core$Dict$get, 'totalQuantity', row.dv)) : ((($elm$core$String$toLower(h) === 'tarifa total') || ($elm$core$String$toLower(h) === 'valor total')) ? A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Utils$formatAsMoney, $elm$core$String$fromInt),
					A2($elm$core$Dict$get, 'totalFare', row.ni)) : $elm$core$Maybe$Nothing);
				var quantity = A2(
					$elm$core$Maybe$map,
					$elm$core$String$fromInt,
					A2($elm$core$Dict$get, identifier, row.dv));
				var fare = A2(
					$elm$core$Maybe$map,
					$elm$core$String$fromInt,
					A2($elm$core$Dict$get, identifier, row.ni));
				var addCount = function (q_) {
					return ((h === 'Quantidade Total') || (h === 'Valor Total')) ? _List_Nil : _List_fromArray(
						[q_]);
				};
				var _v0 = _Utils_Tuple3(quantity, fare, totalQuantity);
				if (!_v0.a.$) {
					if (!_v0.b.$) {
						var q = _v0.a.a;
						var f = _v0.b.a;
						return _Utils_ap(
							addCount(q),
							_List_fromArray(
								[
									$author$project$Utils$formatAsMoney(f)
								]));
					} else {
						var q = _v0.a.a;
						var _v2 = _v0.b;
						return addCount(q);
					}
				} else {
					if (!_v0.b.$) {
						var _v1 = _v0.a;
						var f = _v0.b.a;
						return _List_fromArray(
							[
								$author$project$Utils$formatAsMoney(f)
							]);
					} else {
						if (!_v0.c.$) {
							var _v3 = _v0.a;
							var _v4 = _v0.b;
							var total = _v0.c.a;
							return _List_fromArray(
								[total]);
						} else {
							var _v5 = _v0.a;
							var _v6 = _v0.b;
							var _v7 = _v0.c;
							return _List_fromArray(
								['-', '-']);
						}
					}
				}
			});
		return A2(
			$elm$core$List$cons,
			row.fD,
			$elm$core$List$concat(
				A2(
					$elm$core$List$map,
					function (h_) {
						return $elm$core$String$isEmpty(h_.kY) ? A2(cell, h_.dM, h_.kY) : A2(cell, h_.dM, h_.ik);
					},
					headers_)));
	});
var $author$project$Pages$Reports$Event$UsingVehicle$valueNotEmpty = function (str) {
	return $elm$core$String$isEmpty(str) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(str);
};
var $author$project$Pages$Reports$Event$UsingVehicle$update = F3(
	function (msg, model, shared) {
		var queries = model.T;
		switch (msg.$) {
			case 0:
				var now = msg.a.e8;
				var timezone = msg.a.kS;
				var today = A2($justinmimbs$date$Date$fromPosix, timezone, now);
				var newQueries = _Utils_update(
					queries,
					{
						bl: $elm$core$Maybe$Just(
							$justinmimbs$date$Date$toIsoString(today)),
						bB: $elm$core$Maybe$Just(
							$justinmimbs$date$Date$toIsoString(today))
					});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{T: newQueries}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 1:
				var table = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ck: table}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, table));
			case 2:
				var rd = msg.a;
				var list = A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, rd);
				var updateQueriesVehicles = _Utils_eq(
					$elm$core$List$length(queries.en),
					$elm$core$List$length(list)) ? A2($elm$core$List$cons, '', queries.en) : queries.en;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{en: updateQueriesVehicles}),
							en: list
						}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rd));
			case 3:
				var dateStr = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{bB: dateStr})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 4:
				var dateStr = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{bl: dateStr})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 5:
				var vehicleID = msg.a;
				var updateVehicleList = function () {
					var _v1 = _Utils_Tuple2(
						$author$project$Pages$Reports$Event$UsingVehicle$valueNotEmpty(vehicleID),
						A2(
							$elm$core$List$any,
							$elm$core$Basics$eq(vehicleID),
							model.T.en));
					if (!_v1.a.$) {
						if (_v1.b) {
							var l = _v1.a.a;
							var updateVehicleListDeselectAll = A2(
								$elm$core$List$any,
								$elm$core$Basics$eq(''),
								model.T.en) ? A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(''),
								model.T.en) : model.T.en;
							return A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(l),
								updateVehicleListDeselectAll);
						} else {
							var l = _v1.a.a;
							var newVehiclesIDList = A2($elm$core$List$cons, l, model.T.en);
							var allVehiclesID = A2(
								$elm$core$List$map,
								function ($) {
									return $.dM;
								},
								model.en);
							return _Utils_eq(
								$elm$core$List$length(allVehiclesID),
								$elm$core$List$length(newVehiclesIDList)) ? A2($elm$core$List$cons, '', newVehiclesIDList) : newVehiclesIDList;
						}
					} else {
						if (_v1.b) {
							var _v2 = _v1.a;
							return _List_Nil;
						} else {
							var _v3 = _v1.a;
							var allLines = A2(
								$elm$core$List$map,
								function ($) {
									return $.dM;
								},
								model.en);
							return A2($elm$core$List$cons, vehicleID, allLines);
						}
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{en: updateVehicleList})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 6:
				var ms = msg.a;
				var isOpen = msg.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dW: isOpen}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 7:
				return _Utils_Tuple3(
					model,
					A2(
						$author$project$Route$pushUrl,
						shared.nZ,
						$author$project$Route$Report(
							$author$project$Route$Event(
								$author$project$Route$UsingVehicle(model.T)))),
					$author$project$Shared$NoOp);
			case 8:
				return _Utils_Tuple3(
					model,
					A2(
						$elm$core$Task$perform,
						$author$project$Pages$Reports$Event$UsingVehicle$GenerateCsvDownloadWithTime,
						A3(
							$elm$core$Task$map2,
							F2(
								function (now, timezone) {
									return {e8: now, kS: timezone};
								}),
							$elm$time$Time$now,
							$elm$time$Time$here)),
					$author$project$Shared$NoOp);
			default:
				var now = msg.a.e8;
				var timezone = msg.a.kS;
				return A2(
					$krisajenkins$remotedata$RemoteData$withDefault,
					_Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$ShowErrorDialog('Não foi possível gera o arquivo CSV')),
					A2(
						$krisajenkins$remotedata$RemoteData$map,
						function (data) {
							var title_ = 'Utilização por veículo baseado em eventos ' + (A2($author$project$Utils$formatDateTimeFromPosix, timezone, now) + '.csv');
							var records = A2(
								$elm$core$List$map,
								A2($author$project$Pages$Reports$Event$UsingVehicle$recordCSV, data.nG, shared.kS),
								data.px);
							return _Utils_Tuple3(
								model,
								A3(
									$author$project$Components$GeneratorCSV$download,
									records,
									$author$project$Pages$Reports$Event$UsingVehicle$headers(data),
									title_),
								$author$project$Shared$NoOp);
						},
						model.ck));
		}
	});
var $author$project$Pages$Reports$PDFs$update = F4(
	function (msg, model, shared, user) {
		if (!msg.$) {
			var rd = msg.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{ck: rd}),
				$elm$core$Platform$Cmd$none,
				A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rd));
		} else {
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{ck: $krisajenkins$remotedata$RemoteData$Loading}),
				$author$project$Services$Pdf$getPDFs(
					{ow: $author$project$Pages$Reports$PDFs$GotPDFs, kU: user.kU}),
				$author$project$Shared$NoOp);
		}
	});
var $author$project$Pages$Reports$SalesSummarized$CompPDFCreateMSg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Reports$SalesSummarized$GenerateCsvDownloadWithTime = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Pages$Reports$SalesSummarized$headerReport = _List_fromArray(
	['Tipo de pagamento', 'Valor (R$)']);
var $author$project$Pages$Reports$SalesSummarized$toPosix = function (str) {
	return A2(
		$elm$core$Maybe$andThen,
		$author$project$Utils$dateHTMLToPosixWithZone($elm$time$Time$utc),
		str);
};
var $author$project$Pages$Reports$SalesSummarized$periodInvalid = F2(
	function (start, end) {
		var diff = A3(
			$elm$core$Maybe$map2,
			A2($justinmimbs$time_extra$Time$Extra$diff, 11, $elm$time$Time$utc),
			$author$project$Pages$Reports$SalesSummarized$toPosix(start),
			$author$project$Pages$Reports$SalesSummarized$toPosix(end));
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$lt(31),
				diff));
	});
var $author$project$Pages$Reports$SalesSummarized$queriesToFilter = function (queries) {
	var maybeQ = F2(
		function (param, mValue) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (v) {
						return $elm$core$List$singleton(
							{oK: param, di: v});
					},
					mValue));
		});
	return _Utils_ap(
		A2(maybeQ, 'start', queries.bB),
		A2(maybeQ, 'end', queries.bl));
};
var $author$project$Pages$Reports$SalesSummarized$update = F4(
	function (msg, model, shared, user) {
		var queries = model.T;
		switch (msg.$) {
			case 1:
				var now = msg.a.e8;
				var timezone = msg.a.kS;
				var today = A2($justinmimbs$date$Date$fromPosix, timezone, now);
				var newQueries = _Utils_update(
					queries,
					{
						bl: $elm$core$Maybe$Just(
							$justinmimbs$date$Date$toIsoString(today)),
						bB: $elm$core$Maybe$Just(
							$justinmimbs$date$Date$toIsoString(today))
					});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{T: newQueries}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 0:
				var result = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ck: result}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, result));
			case 2:
				var maybeDate = msg.a;
				var startPosix = A2(
					$elm$core$Maybe$andThen,
					$author$project$Utils$dateHTMLToPosixWithZone($elm$time$Time$utc),
					maybeDate);
				var deadlineForSearching = A2(
					$elm$core$Maybe$map,
					function (current) {
						return A4($justinmimbs$time_extra$Time$Extra$add, 11, 30, $elm$time$Time$utc, current);
					},
					startPosix);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							eE: deadlineForSearching,
							T: _Utils_update(
								queries,
								{bB: maybeDate})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 3:
				var maybeDate = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{bl: maybeDate})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 4:
				var report = msg.a;
				return _Utils_Tuple3(
					model,
					A2(
						$elm$core$Task$perform,
						$author$project$Pages$Reports$SalesSummarized$GenerateCsvDownloadWithTime(report),
						$elm$time$Time$now),
					$author$project$Shared$NoOp);
			case 5:
				var report = msg.a;
				var now = msg.b;
				var title = 'Vendas resumidas ' + (A2($author$project$Utils$formatDateTimeFromPosix, shared.kS, now) + '.csv');
				var row_ = A2(
					$elm$core$List$map,
					function (row) {
						var valueViewMoney = function (value) {
							return A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $author$project$Utils$formatAsMoney)(value);
						};
						var valueView = function (v) {
							return (row.cd === 'Estorno') ? A2(
								$elm$core$Basics$composeR,
								valueViewMoney,
								function (v_) {
									return '( ' + (v_ + ' )');
								})(v) : valueViewMoney(v);
						};
						return _List_fromArray(
							[
								row.cd,
								valueView(row.fI)
							]);
					},
					report);
				return _Utils_Tuple3(
					model,
					A3($author$project$Components$GeneratorCSV$download, row_, $author$project$Pages$Reports$SalesSummarized$headerReport, title),
					$author$project$Shared$NoOp);
			case 6:
				return A2($author$project$Pages$Reports$SalesSummarized$periodInvalid, model.T.bB, model.T.bl) ? _Utils_Tuple3(
					_Utils_update(
						model,
						{L: 1}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp) : _Utils_Tuple3(
					_Utils_update(
						model,
						{L: 0}),
					A2(
						$author$project$Route$pushUrl,
						shared.nZ,
						$author$project$Route$Report(
							$author$project$Route$SalesSummarized(model.T))),
					$author$project$Shared$NoOp);
			case 7:
				var isShowOptionPage = msg.a;
				var exportType = msg.b;
				var reportType = msg.c;
				if (A2($author$project$Pages$Reports$SalesSummarized$periodInvalid, model.T.bB, model.T.bl)) {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$ShowErrorDialog('O período definido é maior que 31 dias. Ajuste a consulta e tente novamente.'));
				} else {
					var newQueries = model.T;
					var _v1 = A3(
						$author$project$Components$PDF$Create$update,
						A4(
							$author$project$Components$PDF$Create$ClickedOpenModal,
							isShowOptionPage,
							exportType,
							reportType,
							$author$project$Pages$Reports$SalesSummarized$queriesToFilter(newQueries)),
						model.bQ,
						user);
					var newCompModel = _v1.a;
					var cmd = _v1.b;
					var sharedMsg = _v1.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bQ: newCompModel}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Reports$SalesSummarized$CompPDFCreateMSg, cmd),
						sharedMsg);
				}
			default:
				var msg_ = msg.a;
				var _v2 = A3($author$project$Components$PDF$Create$update, msg_, model.bQ, user);
				var newCompModel = _v2.a;
				var cmd = _v2.b;
				var sharedMsg = _v2.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bQ: newCompModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Reports$SalesSummarized$CompPDFCreateMSg, cmd),
					sharedMsg);
		}
	});
var $author$project$Pages$Reports$SalesSummarizedV2$CompPDFCreateMSg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Reports$SalesSummarizedV2$toPosix = function (str) {
	return A2(
		$elm$core$Maybe$andThen,
		$author$project$Utils$dateHTMLToPosixWithZone($elm$time$Time$utc),
		str);
};
var $author$project$Pages$Reports$SalesSummarizedV2$periodInvalid = F2(
	function (start, end) {
		var diff = A3(
			$elm$core$Maybe$map2,
			A2($justinmimbs$time_extra$Time$Extra$diff, 11, $elm$time$Time$utc),
			$author$project$Pages$Reports$SalesSummarizedV2$toPosix(start),
			$author$project$Pages$Reports$SalesSummarizedV2$toPosix(end));
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$lt(31),
				diff));
	});
var $author$project$Pages$Reports$SalesSummarizedV2$queriesToFilter = function (queries) {
	var maybeQ = F2(
		function (param, mValue) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (v) {
						return $elm$core$List$singleton(
							{oK: param, di: v});
					},
					mValue));
		});
	return _Utils_ap(
		A2(maybeQ, 'start', queries.bB),
		A2(maybeQ, 'end', queries.bl));
};
var $author$project$Pages$Reports$SalesSummarizedV2$quickRange = F2(
	function (quickPeriod, today) {
		switch (quickPeriod) {
			case 0:
				return {dH: today, eb: today};
			case 1:
				return {
					dH: today,
					eb: A3($justinmimbs$date$Date$add, 3, -6, today)
				};
			case 2:
				return {
					dH: today,
					eb: A3($justinmimbs$date$Date$add, 3, -29, today)
				};
			case 3:
				return {
					dH: today,
					eb: A2($justinmimbs$date$Date$floor, 2, today)
				};
			default:
				var firstOfCurrent = A2($justinmimbs$date$Date$floor, 2, today);
				return {
					dH: A3($justinmimbs$date$Date$add, 3, -1, firstOfCurrent),
					eb: A3($justinmimbs$date$Date$add, 1, -1, firstOfCurrent)
				};
		}
	});
var $author$project$Pages$Reports$SalesSummarizedV2$update = F4(
	function (msg, model, shared, user) {
		var queries = model.T;
		switch (msg.$) {
			case 1:
				var now = msg.a.e8;
				var timezone = msg.a.kS;
				var today = A2($justinmimbs$date$Date$fromPosix, timezone, now);
				var newQueries = function () {
					var _v1 = _Utils_Tuple2(queries.bB, queries.bl);
					if ((!_v1.a.$) && (!_v1.b.$)) {
						return queries;
					} else {
						return _Utils_update(
							queries,
							{
								bl: $elm$core$Maybe$Just(
									$justinmimbs$date$Date$toIsoString(today)),
								bB: $elm$core$Maybe$Just(
									$justinmimbs$date$Date$toIsoString(today))
							});
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: newQueries,
							ef: $elm$core$Maybe$Just(today)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 0:
				var result = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ck: result}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, result));
			case 2:
				var maybeDate = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{bB: maybeDate})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 3:
				var maybeDate = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{bl: maybeDate})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 4:
				var quickPeriod = msg.a;
				var _v2 = model.ef;
				if (!_v2.$) {
					var today = _v2.a;
					var range = A2($author$project$Pages$Reports$SalesSummarizedV2$quickRange, quickPeriod, today);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								T: _Utils_update(
									queries,
									{
										bl: $elm$core$Maybe$Just(
											$justinmimbs$date$Date$toIsoString(range.dH)),
										bB: $elm$core$Maybe$Just(
											$justinmimbs$date$Date$toIsoString(range.eb))
									})
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$NoOp);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
				}
			case 5:
				return A2($author$project$Pages$Reports$SalesSummarizedV2$periodInvalid, model.T.bB, model.T.bl) ? _Utils_Tuple3(
					_Utils_update(
						model,
						{L: 1}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp) : _Utils_Tuple3(
					_Utils_update(
						model,
						{L: 0}),
					A2(
						$author$project$Route$pushUrl,
						shared.nZ,
						$author$project$Route$Report(
							$author$project$Route$SalesSummarizedV2(model.T))),
					$author$project$Shared$NoOp);
			case 6:
				var origin = msg.a;
				var collapsedOrigins = A2($elm$core$List$member, origin, model.bP) ? A2(
					$elm$core$List$filter,
					$elm$core$Basics$neq(origin),
					model.bP) : A2($elm$core$List$cons, origin, model.bP);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bP: collapsedOrigins}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 7:
				var isShowOptionPage = msg.a;
				var exportType = msg.b;
				var reportType = msg.c;
				if (A2($author$project$Pages$Reports$SalesSummarizedV2$periodInvalid, model.T.bB, model.T.bl)) {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$ShowErrorDialog('O período definido é maior que 31 dias. Ajuste a consulta e tente novamente.'));
				} else {
					var _v3 = A3(
						$author$project$Components$PDF$Create$update,
						A4(
							$author$project$Components$PDF$Create$ClickedOpenModal,
							isShowOptionPage,
							exportType,
							reportType,
							$author$project$Pages$Reports$SalesSummarizedV2$queriesToFilter(model.T)),
						model.bQ,
						user);
					var newCompModel = _v3.a;
					var cmd = _v3.b;
					var sharedMsg = _v3.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bQ: newCompModel}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Reports$SalesSummarizedV2$CompPDFCreateMSg, cmd),
						sharedMsg);
				}
			default:
				var msg_ = msg.a;
				var _v4 = A3($author$project$Components$PDF$Create$update, msg_, model.bQ, user);
				var newCompModel = _v4.a;
				var cmd = _v4.b;
				var sharedMsg = _v4.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bQ: newCompModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Reports$SalesSummarizedV2$CompPDFCreateMSg, cmd),
					sharedMsg);
		}
	});
var $author$project$Pages$Reports$Usage$Available = 0;
var $author$project$Pages$Reports$Usage$CompPDFCreateMSg = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$Reports$Usage$GenerateCsvDownloadWithTime = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$Reports$Usage$GotMoreUsage = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Reports$Usage$LoadedAllRecords = 2;
var $author$project$Pages$Reports$Usage$cardsPerPage = 500;
var $author$project$Pages$Reports$Usage$headers = function (q) {
	var columD = (!_Utils_eq(q.ic, $elm$core$Maybe$Nothing)) ? _List_Nil : _List_fromArray(
		['']);
	return _Utils_ap(
		columD,
		_List_fromArray(
			['Data do evento', 'Usuário', 'Cartão', 'Linha', 'Veículo', 'Catraca', 'Operador', 'Classe', 'Tipo da classe', 'Valor', 'Evento', 'Integração', 'Acompanhante']));
};
var $author$project$Pages$Reports$Usage$toPosix = function (str) {
	return A2(
		$elm$core$Maybe$andThen,
		$author$project$Utils$dateHTMLToPosixWithZone($elm$time$Time$utc),
		str);
};
var $author$project$Pages$Reports$Usage$period31daysInvalid = F2(
	function (start, end) {
		var diff = A3(
			$elm$core$Maybe$map2,
			A2($justinmimbs$time_extra$Time$Extra$diff, 11, $elm$time$Time$utc),
			$author$project$Pages$Reports$Usage$toPosix(start),
			$author$project$Pages$Reports$Usage$toPosix(end));
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$lt(31),
				diff));
	});
var $author$project$Pages$Reports$Usage$period7daysInvalid = F2(
	function (start, end) {
		var diff = A3(
			$elm$core$Maybe$map2,
			A2($justinmimbs$time_extra$Time$Extra$diff, 11, $elm$time$Time$utc),
			$author$project$Pages$Reports$Usage$toPosix(start),
			$author$project$Pages$Reports$Usage$toPosix(end));
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$lt(6),
				diff));
	});
var $author$project$Pages$Reports$Usage$queriesToFilter = function (queries) {
	var maybeQ = F2(
		function (param, mValue) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (v) {
						return $elm$core$List$singleton(
							{oK: param, di: v});
					},
					mValue));
		});
	return _Utils_ap(
		A2(maybeQ, 'start', queries.bB),
		_Utils_ap(
			A2(maybeQ, 'end', queries.bl),
			_Utils_ap(
				A2(
					maybeQ,
					'page',
					$elm$core$Maybe$Just(
						$elm$core$String$fromInt(queries.bv))),
				_Utils_ap(
					A2(maybeQ, 'lineCode', queries.b3),
					_Utils_ap(
						A2(maybeQ, 'classID', queries.lX),
						_Utils_ap(
							A2(maybeQ, 'operatorID', queries.g6),
							_Utils_ap(
								A2(maybeQ, 'vehicleID', queries.fN),
								_Utils_ap(
									A2(
										maybeQ,
										'serialCard',
										A2($elm$core$Maybe$map, $author$project$Services$Reports$Usage$filterAfter0x, queries.kx)),
									A2(maybeQ, 'cashierID', queries.ic)))))))));
};
var $author$project$Components$Patterns$Forms$cellMaybe = function (v) {
	return A2($elm$core$Maybe$withDefault, '-', v);
};
var $author$project$Pages$Reports$Usage$record = F3(
	function (q, timezone, usage) {
		var fromBool = function (v) {
			return v ? 'Sim' : 'Não';
		};
		var columD = (!_Utils_eq(q.ic, $elm$core$Maybe$Nothing)) ? _List_Nil : _List_fromArray(
			[
				$author$project$Components$Patterns$Forms$cellMaybe(
				A2($elm$core$Maybe$map, $elm$core$String$fromInt, usage.fu))
			]);
		return _Utils_ap(
			columD,
			_List_fromArray(
				[
					A2($author$project$Utils$formatDateTimeFromPosixWithSeconds, timezone, usage.m2),
					usage.qx,
					usage.lO,
					usage.e1 + (' - ' + usage.n1),
					usage.em,
					$elm$core$String$fromInt(usage.eL),
					usage.fa,
					usage.ik,
					usage.k9,
					$author$project$Utils$formatAsMoney(
					$elm$core$String$fromInt(usage.di)),
					usage.m7,
					fromBool(usage.p1),
					fromBool(usage.l7)
				]));
	});
var $author$project$Pages$Reports$Usage$valueNotEmpty = function (str) {
	return $elm$core$String$isEmpty(str) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(str);
};
var $author$project$Pages$Reports$Usage$update = F4(
	function (msg, model, shared, user) {
		var queries = model.T;
		switch (msg.$) {
			case 0:
				var now = msg.a.e8;
				var timezone = msg.a.kS;
				var today = A2($justinmimbs$date$Date$fromPosix, timezone, now);
				var newQueries = _Utils_update(
					queries,
					{
						bl: $elm$core$Maybe$Just(
							$justinmimbs$date$Date$toIsoString(today)),
						bB: $elm$core$Maybe$Just(
							$justinmimbs$date$Date$toIsoString(today))
					});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{T: newQueries}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 1:
				var rdReport = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{b5: 0, ck: rdReport}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rdReport));
			case 2:
				var newRdReport = msg.a;
				if (_Utils_eq(
					$elm$core$List$length(
						A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, newRdReport)),
					$author$project$Pages$Reports$Usage$cardsPerPage)) {
					var addMoreReport = A3(
						$krisajenkins$remotedata$RemoteData$map2,
						F2(
							function (r1, r2) {
								return _Utils_ap(r1, r2);
							}),
						model.ck,
						newRdReport);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{b5: 0, ck: addMoreReport}),
						$elm$core$Platform$Cmd$none,
						A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, newRdReport));
				} else {
					var addMoreReport = A3(
						$krisajenkins$remotedata$RemoteData$map2,
						F2(
							function (r1, r2) {
								return _Utils_ap(r1, r2);
							}),
						model.ck,
						newRdReport);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{b5: 2, ck: addMoreReport}),
						$elm$core$Platform$Cmd$none,
						A2(
							$author$project$Shared$remoteDataSharedMsg,
							$elm$core$Maybe$Just('Todos os registros foram carregados!'),
							newRdReport));
				}
			case 3:
				var rdLines = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{n2: rdLines}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rdLines));
			case 4:
				var rdClasses = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dv: rdClasses}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rdClasses));
			case 5:
				var rdOperators = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{c5: rdOperators}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rdOperators));
			case 6:
				var rdVehiclesV2 = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{en: rdVehiclesV2}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rdVehiclesV2));
			case 7:
				var dateStr = msg.a;
				var startPosix = A2(
					$elm$core$Maybe$andThen,
					$author$project$Utils$dateHTMLToPosixWithZone($elm$time$Time$utc),
					dateStr);
				var deadlineForSearching = A2(
					$elm$core$Maybe$map,
					function (current) {
						return A4($justinmimbs$time_extra$Time$Extra$add, 11, 6, $elm$time$Time$utc, current);
					},
					startPosix);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							eE: deadlineForSearching,
							T: _Utils_update(
								queries,
								{bB: dateStr})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 8:
				var dateStr = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{bl: dateStr})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 9:
				var cardStr = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{kx: cardStr})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 10:
				var lineCode = msg.a;
				var updateQueries = _Utils_update(
					queries,
					{
						b3: $author$project$Pages$Reports$Usage$valueNotEmpty(lineCode)
					});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{T: updateQueries}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 11:
				var classID = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{
									lX: $author$project$Pages$Reports$Usage$valueNotEmpty(classID)
								})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 12:
				var operatorID = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{
									g6: $author$project$Pages$Reports$Usage$valueNotEmpty(operatorID)
								})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 13:
				var vehicleID = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{
									fN: $author$project$Pages$Reports$Usage$valueNotEmpty(vehicleID)
								})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 14:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dJ: !model.dJ}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 15:
				return A2($author$project$Pages$Reports$Usage$period7daysInvalid, model.T.bB, model.T.bl) ? _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$ShowErrorDialog('O período definido é maior que 7 dias. Ajuste a consulta e pesquise novamente.')) : _Utils_Tuple3(
					_Utils_update(
						model,
						{L: 0, ck: $krisajenkins$remotedata$RemoteData$Loading}),
					A2(
						$author$project$Route$pushUrl,
						shared.nZ,
						$author$project$Route$Report(
							$author$project$Route$Usage(
								_Utils_update(
									queries,
									{bv: 1})))),
					$author$project$Shared$NoOp);
			case 16:
				return _Utils_Tuple3(
					model,
					A2(
						$elm$core$Task$perform,
						$author$project$Pages$Reports$Usage$GenerateCsvDownloadWithTime,
						A3(
							$elm$core$Task$map2,
							F2(
								function (now, timezone) {
									return {e8: now, kS: timezone};
								}),
							$elm$time$Time$now,
							$elm$time$Time$here)),
					$author$project$Shared$NoOp);
			case 17:
				var now = msg.a.e8;
				var timezone = msg.a.kS;
				var title_ = 'Relatório de Usos ' + (A2($author$project$Utils$formatDateTimeFromPosix, timezone, now) + '.csv');
				var records = A2(
					$krisajenkins$remotedata$RemoteData$withDefault,
					_List_Nil,
					A2(
						$krisajenkins$remotedata$RemoteData$map,
						function (row) {
							return A2(
								$elm$core$List$map,
								A2($author$project$Pages$Reports$Usage$record, model.T, shared.kS),
								row);
						},
						model.ck));
				return _Utils_Tuple3(
					model,
					A3(
						$author$project$Components$GeneratorCSV$download,
						records,
						$author$project$Pages$Reports$Usage$headers(model.T),
						title_),
					$author$project$Shared$NoOp);
			case 18:
				var info = msg.a;
				if ((_Utils_cmp(info.ko - info.kp, info.jD + 1) < 1) && (!model.b5)) {
					var currentOffset = model.T.bv + 1;
					var newQueries = _Utils_update(
						queries,
						{bv: currentOffset});
					var _v1 = _Utils_Tuple3(queries.bB, queries.bl, queries.ic);
					if (!_v1.c.$) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{b5: 2}),
							$elm$core$Platform$Cmd$none,
							A2(
								$author$project$Shared$remoteDataSharedMsg,
								$elm$core$Maybe$Just('Todos os registros foram carregados!'),
								model.ck));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{T: newQueries}),
							$author$project$Services$Reports$Usage$getUsage(
								{ow: $author$project$Pages$Reports$Usage$GotMoreUsage, T: newQueries, kU: user.kU}),
							$author$project$Shared$NoOp);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
				}
			case 19:
				var msg_ = msg.a;
				var _v2 = A3($author$project$Components$PDF$Create$update, msg_, model.bQ, user);
				var newCompModel = _v2.a;
				var cmd = _v2.b;
				var sharedMsg = _v2.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bQ: newCompModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Reports$Usage$CompPDFCreateMSg, cmd),
					sharedMsg);
			default:
				var isShowOptionPage = msg.a;
				var exportType = msg.b;
				var reportType = msg.c;
				if (A2($author$project$Pages$Reports$Usage$period31daysInvalid, model.T.bB, model.T.bl)) {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$ShowErrorDialog('O período definido é maior que 31 dias. Ajuste a consulta e tente novamente.'));
				} else {
					var newQueries = function () {
						var _v4 = model.T.ic;
						if (!_v4.$) {
							var cashierID = _v4.a;
							return function (q) {
								return _Utils_update(
									q,
									{
										ic: $elm$core$Maybe$Just(cashierID)
									});
							}($author$project$Services$Models$initQueriesUsage);
						} else {
							return model.T;
						}
					}();
					var _v3 = A3(
						$author$project$Components$PDF$Create$update,
						A4(
							$author$project$Components$PDF$Create$ClickedOpenModal,
							isShowOptionPage,
							exportType,
							reportType,
							$author$project$Pages$Reports$Usage$queriesToFilter(newQueries)),
						model.bQ,
						user);
					var newCompModel = _v3.a;
					var cmd = _v3.b;
					var sharedMsg = _v3.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bQ: newCompModel}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Reports$Usage$CompPDFCreateMSg, cmd),
						sharedMsg);
				}
		}
	});
var $author$project$Pages$Reports$UsesPerClass$CompPDFCreateMSg = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$Reports$UsesPerClass$GenerateCsvDownloadWithTime = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Reports$UsesPerClass$compareHeaders = F2(
	function (a, b) {
		return _Utils_eq(a.ik, b.ik) ? (((a.kY === '') && (b.kY !== '')) ? 0 : (((a.kY !== '') && (b.kY === '')) ? 2 : 1)) : A2($elm$core$Basics$compare, a.ik, b.ik);
	});
var $author$project$Pages$Reports$UsesPerClass$dataHeaders = function (headers_) {
	return $elm$core$List$concat(
		A2(
			$elm$core$List$map,
			function (h_) {
				var addCount = function (hStr) {
					return ((h_.dM === 'totalQuantity') || (h_.dM === 'totalFare')) ? _List_Nil : _List_fromArray(
						['Contador ' + hStr]);
				};
				return $elm$core$String$isEmpty(h_.kY) ? _Utils_ap(
					addCount(h_.ik),
					_List_fromArray(
						[h_.ik])) : _Utils_ap(
					addCount(h_.kY),
					_List_fromArray(
						[h_.kY]));
			},
			headers_));
};
var $author$project$Pages$Reports$UsesPerClass$groups = _List_fromArray(
	[
		_Utils_Tuple2('line', 'Linha'),
		_Utils_Tuple2('vehicle', 'Veículo'),
		_Utils_Tuple2('operator', 'Operador')
	]);
var $author$project$Pages$Reports$UsesPerClass$headers = F2(
	function (groupBy, data) {
		if (!groupBy.$) {
			var g = groupBy.a;
			return _Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$withDefault,
						'-',
						A2(
							$elm$core$Maybe$map,
							$elm$core$Tuple$second,
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									function (_v1) {
										var k = _v1.a;
										return _Utils_eq(k, g);
									},
									$author$project$Pages$Reports$UsesPerClass$groups))))
					]),
				$author$project$Pages$Reports$UsesPerClass$dataHeaders(data.nG));
		} else {
			return _List_fromArray(
				['Classe', 'Quantidade', 'Valor']);
		}
	});
var $author$project$Pages$Reports$UsesPerClass$getClassAmount = F2(
	function (headerID, rows) {
		return $elm$core$String$fromInt(
			$elm$core$List$sum(
				A2(
					$elm$core$List$filterMap,
					function (_v0) {
						var classes = _v0.dv;
						return A2($elm$core$Dict$get, headerID, classes);
					},
					rows)));
	});
var $author$project$Pages$Reports$UsesPerClass$isSubClass = function (header) {
	return !$elm$core$String$isEmpty(header.kY);
};
var $author$project$Pages$Reports$UsesPerClass$getClassName = function (header) {
	return $author$project$Pages$Reports$UsesPerClass$isSubClass(header) ? header.kY : header.ik;
};
var $author$project$Pages$Reports$UsesPerClass$getFareAmount = F2(
	function (headerID, rows) {
		return $elm$core$String$fromInt(
			$elm$core$List$sum(
				A2(
					$elm$core$List$filterMap,
					function (_v0) {
						var fare = _v0.ni;
						return A2($elm$core$Dict$get, headerID, fare);
					},
					rows)));
	});
var $author$project$Pages$Reports$UsesPerClass$hasBreadClass = F2(
	function (header, data) {
		return A2(
			$elm$core$List$any,
			function (h_) {
				return _Utils_eq(header.ik, h_.ik) && (h_.kY === '');
			},
			data.nG);
	});
var $author$project$Pages$Reports$UsesPerClass$recordNoGrouping = F3(
	function (data, timezone, header) {
		var addSpaceSubItem = ($author$project$Pages$Reports$UsesPerClass$isSubClass(header) && A2($author$project$Pages$Reports$UsesPerClass$hasBreadClass, header, data)) ? ' - ' : '';
		var classRows = _List_fromArray(
			[
				_List_fromArray(
				[
					_Utils_ap(
					addSpaceSubItem,
					$author$project$Pages$Reports$UsesPerClass$getClassName(header)),
					A2($author$project$Pages$Reports$UsesPerClass$getClassAmount, header.dM, data.px),
					$author$project$Utils$formatAsMoney(
					A2($author$project$Pages$Reports$UsesPerClass$getFareAmount, header.dM, data.px))
				])
			]);
		return classRows;
	});
var $author$project$Pages$Reports$UsesPerClass$recordWithGrouping = F4(
	function (groupBy, headers_, timezone, row) {
		var cell = F2(
			function (identifier, h) {
				var totalQuantity = ($elm$core$String$toLower(h) === 'quantidade total') ? A2(
					$elm$core$Maybe$map,
					$elm$core$String$fromInt,
					A2($elm$core$Dict$get, 'totalQuantity', row.dv)) : ((($elm$core$String$toLower(h) === 'tarifa total') || ($elm$core$String$toLower(h) === 'valor total')) ? A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Utils$formatAsMoney, $elm$core$String$fromInt),
					A2($elm$core$Dict$get, 'totalFare', row.ni)) : $elm$core$Maybe$Nothing);
				var quantity = A2(
					$elm$core$Maybe$map,
					$elm$core$String$fromInt,
					A2($elm$core$Dict$get, identifier, row.dv));
				var fare = A2(
					$elm$core$Maybe$map,
					$elm$core$String$fromInt,
					A2($elm$core$Dict$get, identifier, row.ni));
				var addCount = function (q_) {
					return ((h === 'Quantidade Total') || (h === 'Valor Total')) ? _List_Nil : _List_fromArray(
						[q_]);
				};
				var _v0 = _Utils_Tuple3(quantity, fare, totalQuantity);
				if (!_v0.a.$) {
					if (!_v0.b.$) {
						var q = _v0.a.a;
						var f = _v0.b.a;
						return _Utils_ap(
							addCount(q),
							_List_fromArray(
								[
									$author$project$Utils$formatAsMoney(f)
								]));
					} else {
						var q = _v0.a.a;
						var _v2 = _v0.b;
						return addCount(q);
					}
				} else {
					if (!_v0.b.$) {
						var _v1 = _v0.a;
						var f = _v0.b.a;
						return _List_fromArray(
							[
								$author$project$Utils$formatAsMoney(f)
							]);
					} else {
						if (!_v0.c.$) {
							var _v3 = _v0.a;
							var _v4 = _v0.b;
							var total = _v0.c.a;
							return _List_fromArray(
								[total]);
						} else {
							var _v5 = _v0.a;
							var _v6 = _v0.b;
							var _v7 = _v0.c;
							return _List_fromArray(
								['-', '-']);
						}
					}
				}
			});
		return A2(
			$elm$core$List$cons,
			row.fD,
			$elm$core$List$concat(
				A2(
					$elm$core$List$map,
					function (h_) {
						return $elm$core$String$isEmpty(h_.kY) ? A2(cell, h_.dM, h_.kY) : A2(cell, h_.dM, h_.ik);
					},
					headers_)));
	});
var $elm$core$List$sortWith = _List_sortWith;
var $author$project$Pages$Reports$UsesPerClass$valueNotEmpty = function (str) {
	return $elm$core$String$isEmpty(str) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(str);
};
var $author$project$Pages$Reports$UsesPerClass$update = F4(
	function (msg, model, shared, user) {
		var queries = model.T;
		switch (msg.$) {
			case 0:
				var now = msg.a.e8;
				var timezone = msg.a.kS;
				var today = A2($justinmimbs$date$Date$fromPosix, timezone, now);
				var newQueries = _Utils_update(
					queries,
					{
						bl: $elm$core$Maybe$Just(
							$justinmimbs$date$Date$toIsoString(today)),
						bB: $elm$core$Maybe$Just(
							$justinmimbs$date$Date$toIsoString(today))
					});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{T: newQueries}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 1:
				var rdReport = msg.a;
				var rdReportFiltered = A2(
					$krisajenkins$remotedata$RemoteData$map,
					function (u) {
						var takeTotalValues = A2(
							$elm$core$List$sortWith,
							$author$project$Pages$Reports$UsesPerClass$compareHeaders,
							A2(
								$elm$core$List$filter,
								function (h_) {
									return (h_.dM !== 'totalFare') && (h_.dM !== 'totalQuantity');
								},
								u.nG));
						var getTotalQuantity = A2(
							$elm$core$List$filter,
							function (h_) {
								return h_.dM === 'totalQuantity';
							},
							u.nG);
						var getTotalFare = A2(
							$elm$core$List$filter,
							function (h_) {
								return h_.dM === 'totalFare';
							},
							u.nG);
						var headersOrder = _Utils_ap(
							takeTotalValues,
							_Utils_ap(getTotalQuantity, getTotalFare));
						return _Utils_update(
							u,
							{nG: headersOrder});
					},
					rdReport);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ck: rdReportFiltered}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rdReport));
			case 2:
				var rdLines = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{n2: rdLines}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rdLines));
			case 3:
				var rdClasses = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dv: rdClasses}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rdClasses));
			case 4:
				var rdOperators = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{c5: rdOperators}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rdOperators));
			case 5:
				var rdVehiclesV2 = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{en: rdVehiclesV2}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, rdVehiclesV2));
			case 6:
				var dateStr = msg.a;
				var startPosix = A2(
					$elm$core$Maybe$andThen,
					$author$project$Utils$dateHTMLToPosixWithZone($elm$time$Time$utc),
					dateStr);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{bB: dateStr})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 7:
				var dateStr = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{bl: dateStr})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 8:
				var lineCode = msg.a;
				var updateLineCodeList = function () {
					var _v1 = _Utils_Tuple2(
						$author$project$Pages$Reports$UsesPerClass$valueNotEmpty(lineCode),
						A2(
							$elm$core$List$any,
							$elm$core$Basics$eq(lineCode),
							model.aB));
					if (!_v1.a.$) {
						if (_v1.b) {
							var l = _v1.a.a;
							var updateLineCodeListDeselectAllLines = A2(
								$elm$core$List$any,
								$elm$core$Basics$eq(''),
								model.aB) ? A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(''),
								model.aB) : model.aB;
							return A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(l),
								updateLineCodeListDeselectAllLines);
						} else {
							var l = _v1.a.a;
							var newLineCodeList = A2($elm$core$List$cons, l, model.aB);
							var allLines = A2(
								$elm$core$List$map,
								function ($) {
									return $.e1;
								},
								A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, model.n2));
							return _Utils_eq(
								$elm$core$List$length(allLines),
								$elm$core$List$length(newLineCodeList)) ? A2($elm$core$List$cons, '', newLineCodeList) : newLineCodeList;
						}
					} else {
						if (_v1.b) {
							var _v2 = _v1.a;
							return _List_Nil;
						} else {
							var _v3 = _v1.a;
							var allLines = A2(
								$elm$core$List$map,
								function ($) {
									return $.e1;
								},
								A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, model.n2));
							return A2($elm$core$List$cons, lineCode, allLines);
						}
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aB: updateLineCodeList}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 9:
				var groupBy = msg.a;
				var updateQueries = _Utils_update(
					queries,
					{
						nB: $author$project$Pages$Reports$UsesPerClass$valueNotEmpty(groupBy)
					});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{T: updateQueries}),
					A2(
						$author$project$Route$pushUrl,
						shared.nZ,
						$author$project$Route$Report(
							$author$project$Route$UsesPerClass(
								_Utils_update(
									updateQueries,
									{bv: 1})))),
					$author$project$Shared$NoOp);
			case 10:
				var operatorID = msg.a;
				var updateOperatorIDList = function () {
					var _v4 = _Utils_Tuple2(
						$author$project$Pages$Reports$UsesPerClass$valueNotEmpty(operatorID),
						A2(
							$elm$core$List$any,
							$elm$core$Basics$eq(operatorID),
							model.aF));
					if (!_v4.a.$) {
						if (_v4.b) {
							var l = _v4.a.a;
							var updateOperatorIDListDeselectAll = A2(
								$elm$core$List$any,
								$elm$core$Basics$eq(''),
								model.aF) ? A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(''),
								model.aF) : model.aF;
							return A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(l),
								updateOperatorIDListDeselectAll);
						} else {
							var l = _v4.a.a;
							var newOperatorIDList = A2($elm$core$List$cons, l, model.aF);
							var allOperators = A2(
								$elm$core$List$map,
								function ($) {
									return $.dM;
								},
								A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, model.c5));
							return _Utils_eq(
								$elm$core$List$length(allOperators),
								$elm$core$List$length(newOperatorIDList)) ? A2($elm$core$List$cons, '', newOperatorIDList) : newOperatorIDList;
						}
					} else {
						if (_v4.b) {
							var _v5 = _v4.a;
							return _List_Nil;
						} else {
							var _v6 = _v4.a;
							var allOperators = A2(
								$elm$core$List$map,
								function ($) {
									return $.dM;
								},
								A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, model.c5));
							return A2($elm$core$List$cons, operatorID, allOperators);
						}
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aF: updateOperatorIDList}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 11:
				var vehicleID = msg.a;
				var updateVehicleIDList = function () {
					var _v7 = _Utils_Tuple2(
						$author$project$Pages$Reports$UsesPerClass$valueNotEmpty(vehicleID),
						A2(
							$elm$core$List$any,
							$elm$core$Basics$eq(vehicleID),
							model.aN));
					if (!_v7.a.$) {
						if (_v7.b) {
							var l = _v7.a.a;
							var updateVehicleIDListDeselectAll = A2(
								$elm$core$List$any,
								$elm$core$Basics$eq(''),
								model.aN) ? A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(''),
								model.aN) : model.aN;
							return A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(l),
								updateVehicleIDListDeselectAll);
						} else {
							var l = _v7.a.a;
							var newVehicleIDList = A2($elm$core$List$cons, l, model.aN);
							var allVehicles = A2(
								$elm$core$List$map,
								function ($) {
									return $.dM;
								},
								A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, model.en));
							return _Utils_eq(
								$elm$core$List$length(allVehicles),
								$elm$core$List$length(newVehicleIDList)) ? A2($elm$core$List$cons, '', newVehicleIDList) : newVehicleIDList;
						}
					} else {
						if (_v7.b) {
							var _v8 = _v7.a;
							return _List_Nil;
						} else {
							var _v9 = _v7.a;
							var allVehicles = A2(
								$elm$core$List$map,
								function ($) {
									return $.dM;
								},
								A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, model.en));
							return A2($elm$core$List$cons, vehicleID, allVehicles);
						}
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aN: updateVehicleIDList}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 12:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dJ: !model.dJ}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 13:
				var vehicleIDListToStr = function () {
					var _v12 = A2(
						$elm$core$String$join,
						',',
						A2(
							$elm$core$List$filter,
							$elm$core$Basics$neq(''),
							model.aN));
					if (_v12 === '') {
						return $elm$core$Maybe$Nothing;
					} else {
						var l = _v12;
						return $elm$core$Maybe$Just(l);
					}
				}();
				var operatorIDListToStr = function () {
					var _v11 = A2(
						$elm$core$String$join,
						',',
						A2(
							$elm$core$List$filter,
							$elm$core$Basics$neq(''),
							model.aF));
					if (_v11 === '') {
						return $elm$core$Maybe$Nothing;
					} else {
						var l = _v11;
						return $elm$core$Maybe$Just(l);
					}
				}();
				var lineCodeListToStr = function () {
					var _v10 = A2(
						$elm$core$String$join,
						',',
						A2(
							$elm$core$List$filter,
							$elm$core$Basics$neq(''),
							model.aB));
					if (_v10 === '') {
						return $elm$core$Maybe$Nothing;
					} else {
						var l = _v10;
						return $elm$core$Maybe$Just(l);
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{L: 0, ck: $krisajenkins$remotedata$RemoteData$Loading}),
					A2(
						$author$project$Route$pushUrl,
						shared.nZ,
						$author$project$Route$Report(
							$author$project$Route$UsesPerClass(
								_Utils_update(
									queries,
									{b3: lineCodeListToStr, g6: operatorIDListToStr, bv: 1, fN: vehicleIDListToStr})))),
					$author$project$Shared$NoOp);
			case 14:
				return _Utils_Tuple3(
					model,
					A2(
						$elm$core$Task$perform,
						$author$project$Pages$Reports$UsesPerClass$GenerateCsvDownloadWithTime,
						A3(
							$elm$core$Task$map2,
							F2(
								function (now, timezone) {
									return {e8: now, kS: timezone};
								}),
							$elm$time$Time$now,
							$elm$time$Time$here)),
					$author$project$Shared$NoOp);
			case 15:
				var now = msg.a.e8;
				var timezone = msg.a.kS;
				return A2(
					$krisajenkins$remotedata$RemoteData$withDefault,
					_Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$Shared$ShowErrorDialog('Não foi possível gera o arquivo CSV')),
					A2(
						$krisajenkins$remotedata$RemoteData$map,
						function (data) {
							var title_ = 'Relatório utilização por classes ' + (A2($author$project$Utils$formatDateTimeFromPosix, timezone, now) + '.csv');
							var records = function () {
								var _v13 = model.T.nB;
								if (!_v13.$) {
									var g = _v13.a;
									return A2(
										$elm$core$List$map,
										A3($author$project$Pages$Reports$UsesPerClass$recordWithGrouping, g, data.nG, shared.kS),
										data.px);
								} else {
									var takeTotalValues = A2(
										$elm$core$List$filter,
										function (h_) {
											return (h_.dM !== 'totalFare') && (h_.dM !== 'totalQuantity');
										},
										data.nG);
									var _v14 = A3(
										$elm$core$List$foldl,
										F2(
											function (row, _v15) {
												var qtyAcc = _v15.a;
												var fareAcc = _v15.b;
												return _Utils_Tuple2(
													qtyAcc + A2(
														$elm$core$Maybe$withDefault,
														0,
														A2($elm$core$Dict$get, 'totalQuantity', row.dv)),
													fareAcc + A2(
														$elm$core$Maybe$withDefault,
														0,
														A2($elm$core$Dict$get, 'totalFare', row.ni)));
											}),
										_Utils_Tuple2(0, 0),
										data.px);
									var totalQuantity = _v14.a;
									var totalFare = _v14.b;
									var total = _List_fromArray(
										[
											_List_fromArray(
											[
												'Total',
												$elm$core$String$fromInt(totalQuantity),
												$author$project$Utils$formatAsMoney(
												$elm$core$String$fromInt(totalFare))
											])
										]);
									return _Utils_ap(
										A2(
											$elm$core$List$concatMap,
											A2($author$project$Pages$Reports$UsesPerClass$recordNoGrouping, data, shared.kS),
											takeTotalValues),
										total);
								}
							}();
							return _Utils_Tuple3(
								model,
								A3(
									$author$project$Components$GeneratorCSV$download,
									records,
									A2($author$project$Pages$Reports$UsesPerClass$headers, model.T.nB, data),
									title_),
								$author$project$Shared$NoOp);
						},
						model.ck));
			case 16:
				var ms = msg.a;
				var isOpen = msg.b;
				switch (ms) {
					case 0:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{dT: isOpen}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					case 1:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{dU: isOpen}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
					default:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{dW: isOpen}),
							$elm$core$Platform$Cmd$none,
							$author$project$Shared$NoOp);
				}
			default:
				var msg_ = msg.a;
				var _v17 = A3($author$project$Components$PDF$Create$update, msg_, model.bQ, user);
				var newCompModel = _v17.a;
				var cmd = _v17.b;
				var sharedMsg = _v17.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bQ: newCompModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Reports$UsesPerClass$CompPDFCreateMSg, cmd),
					sharedMsg);
		}
	});
var $author$project$Pages$Reports$UsesPerDay$GenerateCsvDownloadWithTime = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Reports$UsesPerDay$update = F3(
	function (msg, model, shared) {
		var queries = model.T;
		switch (msg.$) {
			case 0:
				var now = msg.a.e8;
				var timezone = msg.a.kS;
				var today = A2($justinmimbs$date$Date$fromPosix, timezone, now);
				var newQueries = _Utils_update(
					queries,
					{
						bl: $elm$core$Maybe$Just(
							$justinmimbs$date$Date$toIsoString(today)),
						bB: $elm$core$Maybe$Just(
							$justinmimbs$date$Date$toIsoString(today))
					});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{T: newQueries}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 1:
				var table = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ck: table}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, table));
			case 2:
				var dateStr = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{bB: dateStr})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 3:
				var dateStr = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{bl: dateStr})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 4:
				return _Utils_Tuple3(
					model,
					A2(
						$author$project$Route$pushUrl,
						shared.nZ,
						$author$project$Route$Report(
							$author$project$Route$UsesPerDay(model.T))),
					$author$project$Shared$NoOp);
			case 5:
				return _Utils_Tuple3(
					model,
					A2(
						$elm$core$Task$perform,
						$author$project$Pages$Reports$UsesPerDay$GenerateCsvDownloadWithTime,
						A3(
							$elm$core$Task$map2,
							F2(
								function (now, timezone) {
									return {e8: now, kS: timezone};
								}),
							$elm$time$Time$now,
							$elm$time$Time$here)),
					$author$project$Shared$NoOp);
			default:
				var now = msg.a.e8;
				var timezone = msg.a.kS;
				var title_ = 'Uso por dia ' + (A2($author$project$Utils$formatDateTimeFromPosix, timezone, now) + '.csv');
				var records = A2(
					$krisajenkins$remotedata$RemoteData$withDefault,
					_List_Nil,
					A2(
						$krisajenkins$remotedata$RemoteData$map,
						function (_v1) {
							var rows = _v1.px;
							return A2(
								$elm$core$List$map,
								function (_v2) {
									var title = _v2.fD;
									var value = _v2.di;
									return A2(
										$elm$core$List$cons,
										title,
										A2($elm$core$List$map, $elm$core$String$fromInt, value));
								},
								rows);
						},
						model.ck));
				var headers = A2(
					$elm$core$List$cons,
					'Classe',
					A2(
						$krisajenkins$remotedata$RemoteData$withDefault,
						_List_Nil,
						A2(
							$krisajenkins$remotedata$RemoteData$map,
							function ($) {
								return $.nF;
							},
							model.ck)));
				return _Utils_Tuple3(
					model,
					A3($author$project$Components$GeneratorCSV$download, records, headers, title_),
					$author$project$Shared$NoOp);
		}
	});
var $author$project$Pages$Reports$UsesPerLine$GenerateCsvDownloadWithTime = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Reports$UsesPerLine$update = F3(
	function (msg, model, shared) {
		var queries = model.T;
		switch (msg.$) {
			case 0:
				var now = msg.a.e8;
				var timezone = msg.a.kS;
				var today = A2($justinmimbs$date$Date$fromPosix, timezone, now);
				var newQueries = _Utils_update(
					queries,
					{
						bl: $elm$core$Maybe$Just(
							$justinmimbs$date$Date$toIsoString(today)),
						bB: $elm$core$Maybe$Just(
							$justinmimbs$date$Date$toIsoString(today))
					});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{T: newQueries}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 1:
				var table = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ck: table}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, table));
			case 2:
				var dateStr = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{bB: dateStr})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 3:
				var dateStr = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{bl: dateStr})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 4:
				return _Utils_Tuple3(
					model,
					A2(
						$author$project$Route$pushUrl,
						shared.nZ,
						$author$project$Route$Report(
							$author$project$Route$UsesPerLine(model.T))),
					$author$project$Shared$NoOp);
			case 5:
				return _Utils_Tuple3(
					model,
					A2(
						$elm$core$Task$perform,
						$author$project$Pages$Reports$UsesPerLine$GenerateCsvDownloadWithTime,
						A3(
							$elm$core$Task$map2,
							F2(
								function (now, timezone) {
									return {e8: now, kS: timezone};
								}),
							$elm$time$Time$now,
							$elm$time$Time$here)),
					$author$project$Shared$NoOp);
			default:
				var now = msg.a.e8;
				var timezone = msg.a.kS;
				var title_ = 'Uso por linha ' + (A2($author$project$Utils$formatDateTimeFromPosix, timezone, now) + '.csv');
				var records = A2(
					$krisajenkins$remotedata$RemoteData$withDefault,
					_List_Nil,
					A2(
						$krisajenkins$remotedata$RemoteData$map,
						function (_v1) {
							var rows = _v1.px;
							return A2(
								$elm$core$List$map,
								function (_v2) {
									var title = _v2.fD;
									var value = _v2.di;
									return A2(
										$elm$core$List$cons,
										title,
										A2($elm$core$List$map, $elm$core$String$fromInt, value));
								},
								rows);
						},
						model.ck));
				var headers = A2(
					$elm$core$List$cons,
					'Classe',
					A2(
						$krisajenkins$remotedata$RemoteData$withDefault,
						_List_Nil,
						A2(
							$krisajenkins$remotedata$RemoteData$map,
							function ($) {
								return $.nF;
							},
							model.ck)));
				return _Utils_Tuple3(
					model,
					A3($author$project$Components$GeneratorCSV$download, records, headers, title_),
					$author$project$Shared$NoOp);
		}
	});
var $author$project$Pages$Reports$UsesPerVehicle$GenerateCsvDownloadWithTime = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Reports$UsesPerVehicle$update = F3(
	function (msg, model, shared) {
		var queries = model.T;
		switch (msg.$) {
			case 0:
				var now = msg.a.e8;
				var timezone = msg.a.kS;
				var today = A2($justinmimbs$date$Date$fromPosix, timezone, now);
				var newQueries = _Utils_update(
					queries,
					{
						bl: $elm$core$Maybe$Just(
							$justinmimbs$date$Date$toIsoString(today)),
						bB: $elm$core$Maybe$Just(
							$justinmimbs$date$Date$toIsoString(today))
					});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{T: newQueries}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 1:
				var table = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ck: table}),
					$elm$core$Platform$Cmd$none,
					A2($author$project$Shared$remoteDataSharedMsg, $elm$core$Maybe$Nothing, table));
			case 2:
				var dateStr = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{bB: dateStr})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 3:
				var dateStr = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							T: _Utils_update(
								queries,
								{bl: dateStr})
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Shared$NoOp);
			case 4:
				return _Utils_Tuple3(
					model,
					A2(
						$author$project$Route$pushUrl,
						shared.nZ,
						$author$project$Route$Report(
							$author$project$Route$UsesPerVehicle(model.T))),
					$author$project$Shared$NoOp);
			case 5:
				return _Utils_Tuple3(
					model,
					A2(
						$elm$core$Task$perform,
						$author$project$Pages$Reports$UsesPerVehicle$GenerateCsvDownloadWithTime,
						A3(
							$elm$core$Task$map2,
							F2(
								function (now, timezone) {
									return {e8: now, kS: timezone};
								}),
							$elm$time$Time$now,
							$elm$time$Time$here)),
					$author$project$Shared$NoOp);
			default:
				var now = msg.a.e8;
				var timezone = msg.a.kS;
				var title_ = 'Uso por veiculo ' + (A2($author$project$Utils$formatDateTimeFromPosix, timezone, now) + '.csv');
				var records = A2(
					$krisajenkins$remotedata$RemoteData$withDefault,
					_List_Nil,
					A2(
						$krisajenkins$remotedata$RemoteData$map,
						function (_v1) {
							var rows = _v1.px;
							return A2(
								$elm$core$List$map,
								function (_v2) {
									var title = _v2.fD;
									var value = _v2.di;
									return A2(
										$elm$core$List$cons,
										title,
										A2($elm$core$List$map, $elm$core$String$fromInt, value));
								},
								rows);
						},
						model.ck));
				var headers = A2(
					$elm$core$List$cons,
					'Classe',
					A2(
						$krisajenkins$remotedata$RemoteData$withDefault,
						_List_Nil,
						A2(
							$krisajenkins$remotedata$RemoteData$map,
							function ($) {
								return $.nF;
							},
							model.ck)));
				return _Utils_Tuple3(
					model,
					A3($author$project$Components$GeneratorCSV$download, records, headers, title_),
					$author$project$Shared$NoOp);
		}
	});
var $author$project$Pages$update = F3(
	function (msg, model, shared) {
		var nothing = _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp);
		var _v0 = _Utils_Tuple3(msg, model, shared.pF);
		_v0$57:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					var _v1 = _v0.a;
					return _Utils_Tuple3(model, $elm$browser$Browser$Navigation$reloadAndSkipCache, $author$project$Shared$NoOp);
				case 1:
					if ((!_v0.b.$) && (_v0.c.$ === 1)) {
						var pageOneMsg = _v0.a.a;
						var pageOneModel = _v0.b.a;
						var _v2 = _v0.c;
						var _v3 = A3($author$project$Pages$Login$update, pageOneMsg, pageOneModel, shared);
						var newPageOneModel = _v3.a;
						var cmd = _v3.b;
						var sharedMsg = _v3.c;
						return _Utils_Tuple3(
							$author$project$Pages$LoginPage(newPageOneModel),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$LoginMsg, cmd),
							sharedMsg);
					} else {
						break _v0$57;
					}
				case 2:
					if ((_v0.b.$ === 1) && (_v0.c.$ === 1)) {
						var pageOneMsg = _v0.a.a;
						var pageOneModel = _v0.b.a;
						var _v4 = _v0.c;
						var _v5 = A3($author$project$Pages$RecoverPassword$update, pageOneMsg, pageOneModel, shared);
						var newPageOneModel = _v5.a;
						var cmd = _v5.b;
						var sharedMsg = _v5.c;
						return _Utils_Tuple3(
							$author$project$Pages$RecoverPasswordPage(newPageOneModel),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$RecoverPasswordMsg, cmd),
							sharedMsg);
					} else {
						break _v0$57;
					}
				case 3:
					if (_v0.b.$ === 2) {
						var pageOneMsg = _v0.a.a;
						var pageOneModel = _v0.b.a;
						var _v6 = A3($author$project$Pages$ChangePassword$update, pageOneMsg, pageOneModel, shared);
						var newPageoneModel = _v6.a;
						var cmd = _v6.b;
						var sharedMsg = _v6.c;
						return _Utils_Tuple3(
							$author$project$Pages$ChangePasswordPage(newPageoneModel),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$ChangePasswordMsg, cmd),
							sharedMsg);
					} else {
						break _v0$57;
					}
				case 4:
					if ((_v0.b.$ === 3) && (!_v0.c.$)) {
						var posGuicheMsg = _v0.a.a;
						var posHomeModel = _v0.b.a;
						var user = _v0.c.a;
						var _v7 = A4($author$project$Pages$Pos$Guiche$update, posGuicheMsg, posHomeModel, shared, user);
						var newPosGuiche = _v7.a;
						var cmd = _v7.b;
						var sharedMsg = _v7.c;
						return _Utils_Tuple3(
							$author$project$Pages$PosGuichePage(newPosGuiche),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$PosGuicheMsg, cmd),
							sharedMsg);
					} else {
						break _v0$57;
					}
				case 5:
					if ((_v0.b.$ === 4) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var user = _v0.c.a;
						var _v8 = A2($author$project$Pages$Home$WelcomeBack$update, msg_, model_);
						var newModel = _v8.a;
						var cmd = _v8.b;
						var sharedMsg = _v8.c;
						return _Utils_Tuple3(
							$author$project$Pages$HomeWelcomeBackPage(newModel),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$HomeWelcomeBackMsg, cmd),
							sharedMsg);
					} else {
						break _v0$57;
					}
				case 6:
					if ((_v0.b.$ === 5) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var user = _v0.c.a;
						var _v9 = A3($author$project$Pages$Panel$MyAccount$SubPage$update, msg_, model_, user);
						var newModel = _v9.a;
						var cmd = _v9.b;
						var sharedMsg = _v9.c;
						return _Utils_Tuple3(
							$author$project$Pages$MyAccountPage(newModel),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$MyAccountMsg, cmd),
							sharedMsg);
					} else {
						break _v0$57;
					}
				case 7:
					if ((_v0.b.$ === 6) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var user = _v0.c.a;
						var _v10 = A4($author$project$Pages$Pos$Register$update, msg_, model_, shared, user);
						var newModel = _v10.a;
						var cmd = _v10.b;
						var sharedMsg = _v10.c;
						return _Utils_Tuple3(
							$author$project$Pages$PosRegisterPage(newModel),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$PosRegisterMsg, cmd),
							sharedMsg);
					} else {
						break _v0$57;
					}
				case 8:
					if ((_v0.b.$ === 7) && (!_v0.c.$)) {
						var subMsg = _v0.a.a;
						var _v11 = _v0.b;
						var passengerId = _v11.a;
						var subModel = _v11.b;
						var user = _v0.c.a;
						var _v12 = A5($author$project$Pages$Pos$Passenger$update, passengerId, subMsg, subModel, shared, user);
						var newSubModel = _v12.a;
						var cmd = _v12.b;
						var sharedMsg = _v12.c;
						return _Utils_Tuple3(
							A2($author$project$Pages$PosPassengerPage, passengerId, newSubModel),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$PosPassengerMsg, cmd),
							sharedMsg);
					} else {
						break _v0$57;
					}
				case 9:
					if ((_v0.b.$ === 8) && (!_v0.c.$)) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						var user = _v0.c.a;
						var _v13 = A4($author$project$Pages$Pos$Edit$update, subMsg, subModel, shared, user);
						var newSubModel = _v13.a;
						var cmd = _v13.b;
						var sharedMsg = _v13.c;
						return _Utils_Tuple3(
							$author$project$Pages$PosEditPage(newSubModel),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$PosEditMsg, cmd),
							sharedMsg);
					} else {
						break _v0$57;
					}
				case 10:
					if ((_v0.b.$ === 9) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var user = _v0.c.a;
						var _v14 = A4($author$project$Pages$Pos$Localize$update, msg_, model_, shared, user);
						var newModel = _v14.a;
						var cmd = _v14.b;
						var sharedMsg = _v14.c;
						return _Utils_Tuple3(
							$author$project$Pages$PosLocalizePage(newModel),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$PosLocalizeMsg, cmd),
							sharedMsg);
					} else {
						break _v0$57;
					}
				case 11:
					if ((_v0.b.$ === 10) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var user = _v0.c.a;
						var _v15 = A4($author$project$Pages$Pos$CloseCashier$update, msg_, model_, shared, user);
						var newModel = _v15.a;
						var cmd = _v15.b;
						var sharedMsg = _v15.c;
						return _Utils_Tuple3(
							$author$project$Pages$PosCloseCashierPage(newModel),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$PosCloseCashierMsg, cmd),
							sharedMsg);
					} else {
						break _v0$57;
					}
				case 12:
					if ((_v0.b.$ === 11) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var user = _v0.c.a;
						var _v16 = A4($author$project$Pages$Garage$Dashboard$update, msg_, model_, shared, user);
						var newModel = _v16.a;
						var cmd = _v16.b;
						var sharedMsg = _v16.c;
						return _Utils_Tuple3(
							$author$project$Pages$PosGaragePage(newModel),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$PosGarageMsg, cmd),
							sharedMsg);
					} else {
						break _v0$57;
					}
				case 13:
					if (_v0.b.$ === 17) {
						var msg_ = _v0.a.a;
						var _v17 = _v0.b;
						var maybeConcessionaireId = _v17.a;
						var model_ = _v17.b;
						var _v18 = A4($author$project$Pages$Enterprise$Register$update, msg_, model_, shared, maybeConcessionaireId);
						var newModel = _v18.a;
						var cmd = _v18.b;
						var sharedMsg = _v18.c;
						return _Utils_Tuple3(
							A2($author$project$Pages$EnterpriseRegisterPage, maybeConcessionaireId, newModel),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$EnterpriseRegisterMsg, cmd),
							sharedMsg);
					} else {
						break _v0$57;
					}
				case 14:
					if ((_v0.b.$ === 12) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var user = _v0.c.a;
						var _v19 = A4($author$project$Pages$Enterprise$Dashboard$update, msg_, model_, shared, user);
						var newModel = _v19.a;
						var cmd = _v19.b;
						var sharedMsg = _v19.c;
						return _Utils_Tuple3(
							$author$project$Pages$EnterpriseDashboardPage(newModel),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$EnterpriseDashboardMsg, cmd),
							sharedMsg);
					} else {
						break _v0$57;
					}
				case 15:
					if ((_v0.b.$ === 13) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var user = _v0.c.a;
						var _v20 = A3($author$project$Pages$Order$Lists$update, msg_, model_, shared);
						var newModel = _v20.a;
						var cmd = _v20.b;
						var sharedMsg = _v20.c;
						return _Utils_Tuple3(
							$author$project$Pages$SavedOrderListsPage(newModel),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$SavedOrderListsMsg, cmd),
							sharedMsg);
					} else {
						break _v0$57;
					}
				case 16:
					if ((_v0.b.$ === 14) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var user = _v0.c.a;
						var _v21 = A4($author$project$Pages$Order$Detail$update, msg_, model_, user, shared);
						var newModel = _v21.a;
						var cmd = _v21.b;
						var sharedMsg = _v21.c;
						return _Utils_Tuple3(
							$author$project$Pages$SavedOrderDetailPage(newModel),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$SavedOrderDetailMsg, cmd),
							sharedMsg);
					} else {
						break _v0$57;
					}
				case 17:
					if ((_v0.b.$ === 15) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var user = _v0.c.a;
						var _v22 = A4($author$project$Pages$Admin$CompanyOrders$update, msg_, model_, shared, user);
						var newModel = _v22.a;
						var cmd = _v22.b;
						var sharedMsg = _v22.c;
						return _Utils_Tuple3(
							$author$project$Pages$EnterpriseHistoryPage(newModel),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$EnterpriseHistoryMsg, cmd),
							sharedMsg);
					} else {
						break _v0$57;
					}
				case 18:
					if ((_v0.b.$ === 16) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var _v23 = _v0.b;
						var maybePage = _v23.a;
						var model_ = _v23.b;
						var user = _v0.c.a;
						var _v24 = A4($author$project$Pages$Enterprise$HistoryDetails$update, msg_, model_, shared, user);
						var newModel = _v24.a;
						var cmd_ = _v24.b;
						var sharedMsg = _v24.c;
						return _Utils_Tuple3(
							A2($author$project$Pages$EnterpriseHistoryDetailsPage, maybePage, newModel),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$EnterpriseHistoryDetailsMsg, cmd_),
							sharedMsg);
					} else {
						break _v0$57;
					}
				case 19:
					if ((_v0.b.$ === 18) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var _v25 = _v0.b;
						var maybeConcessionaireId = _v25.a;
						var model_ = _v25.b;
						var user = _v0.c.a;
						var _v26 = A5($author$project$Pages$Admin$update, msg_, model_, shared, maybeConcessionaireId, user);
						var newModel = _v26.a;
						var cmd = _v26.b;
						var sharedMsg = _v26.c;
						return _Utils_Tuple3(
							A2($author$project$Pages$AdminPage, maybeConcessionaireId, newModel),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$AdminMsg, cmd),
							sharedMsg);
					} else {
						break _v0$57;
					}
				case 20:
					if ((_v0.b.$ === 19) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var user = _v0.c.a;
						var _v27 = A3($author$project$Pages$Panel$EquipmentsV2$update, msg_, model_, shared);
						var newModel = _v27.a;
						var cmd = _v27.b;
						var sharedMsg = _v27.c;
						return $author$project$Services$Models$iHaveAccess(
							{
								gZ: user.hg,
								hf: $author$project$Services$Models$EQUIPMENT(3),
								hQ: _Utils_Tuple3(
									$author$project$Pages$EquipmentsPage(newModel),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$EquipmentsMsg, cmd),
									sharedMsg),
								hR: nothing
							});
					} else {
						break _v0$57;
					}
				case 21:
					if ((_v0.b.$ === 20) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var user = _v0.c.a;
						var _v28 = A4($author$project$Pages$Panel$ReversalApprovalSystem$update, msg_, model_, shared, user);
						var newModel = _v28.a;
						var cmd_ = _v28.b;
						var sharedMsg = _v28.c;
						return $author$project$Services$Models$iHaveAccess(
							{
								gZ: user.hg,
								hf: $author$project$Services$Models$REVERSE(0),
								hQ: _Utils_Tuple3(
									$author$project$Pages$ReversalApprovalSystemPage(newModel),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$ReversalApprovalSystemMsg, cmd_),
									sharedMsg),
								hR: nothing
							});
					} else {
						break _v0$57;
					}
				case 22:
					if ((_v0.b.$ === 21) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var user = _v0.c.a;
						var _v29 = A4($author$project$Pages$Panel$ReversalApprovalCashier$update, msg_, model_, shared, user);
						var newModel = _v29.a;
						var cmd_ = _v29.b;
						var sharedMsg = _v29.c;
						return $author$project$Services$Models$iHaveAccess(
							{
								gZ: user.hg,
								hf: $author$project$Services$Models$REVERSE(0),
								hQ: _Utils_Tuple3(
									$author$project$Pages$ReversalApprovalCashierPage(newModel),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$ReversalApprovalCashierMsg, cmd_),
									sharedMsg),
								hR: nothing
							});
					} else {
						break _v0$57;
					}
				case 23:
					if ((_v0.b.$ === 22) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var user = _v0.c.a;
						var _v30 = A3($author$project$Pages$Panel$ManagePouches$update, user, msg_, model_);
						var newModel = _v30.a;
						var cmd_ = _v30.b;
						var sharedMsg = _v30.c;
						return $author$project$Services$Models$iHaveAccess(
							{
								gZ: user.hg,
								hf: $author$project$Services$Models$POUCH(0),
								hQ: _Utils_Tuple3(
									$author$project$Pages$ManagePouchesPage(newModel),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$ManagePouchesMsg, cmd_),
									sharedMsg),
								hR: nothing
							});
					} else {
						break _v0$57;
					}
				case 24:
					if ((_v0.b.$ === 23) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var user = _v0.c.a;
						var _v31 = A4($author$project$Pages$Panel$ManageFare$update, msg_, model_, shared, user);
						var newModel = _v31.a;
						var cmd_ = _v31.b;
						var sharedMsg = _v31.c;
						return $author$project$Services$Models$iHaveAccess(
							{
								gZ: user.hg,
								hf: $author$project$Services$Models$TARIFFS(0),
								hQ: _Utils_Tuple3(
									$author$project$Pages$ManageFarePage(newModel),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$ManageFareMsg, cmd_),
									sharedMsg),
								hR: nothing
							});
					} else {
						break _v0$57;
					}
				case 25:
					if ((_v0.b.$ === 24) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var user = _v0.c.a;
						var _v32 = A4($author$project$Pages$Panel$ManageOperators$update, msg_, shared, user, model_);
						var newModel = _v32.a;
						var cmd_ = _v32.b;
						var sharedMsg = _v32.c;
						return $author$project$Services$Models$iHaveAccess(
							{
								gZ: user.hg,
								hf: $author$project$Services$Models$OPERATORS(0),
								hQ: _Utils_Tuple3(
									$author$project$Pages$ManageOperatorsPage(newModel),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$ManageOperatorsMsg, cmd_),
									sharedMsg),
								hR: nothing
							});
					} else {
						break _v0$57;
					}
				case 26:
					if ((_v0.b.$ === 25) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var user = _v0.c.a;
						var _v33 = A3($author$project$Pages$Panel$UpdateEquipment$update, user, msg_, model_);
						var newModel = _v33.a;
						var cmd_ = _v33.b;
						var sharedMsg = _v33.c;
						return $author$project$Services$Models$iHaveAccess(
							{
								gZ: user.hg,
								hf: $author$project$Services$Models$EQUIPMENT_UPDATE(0),
								hQ: _Utils_Tuple3(
									$author$project$Pages$UpdateEquipmentPage(newModel),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$UpdateEquipmentMsg, cmd_),
									sharedMsg),
								hR: nothing
							});
					} else {
						break _v0$57;
					}
				case 27:
					if ((_v0.b.$ === 26) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var user = _v0.c.a;
						var _v34 = A4($author$project$Pages$Panel$Reason$update, msg_, model_, shared, user);
						var newModel = _v34.a;
						var cmd_ = _v34.b;
						var sharedMsg = _v34.c;
						return $author$project$Services$Models$iHaveAccess(
							{
								gZ: user.hg,
								hf: $author$project$Services$Models$REASONS(0),
								hQ: _Utils_Tuple3(
									$author$project$Pages$ReasonPage(newModel),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$ReasonMsg, cmd_),
									sharedMsg),
								hR: nothing
							});
					} else {
						break _v0$57;
					}
				case 28:
					if ((_v0.b.$ === 27) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var user = _v0.c.a;
						var _v35 = A4($author$project$Pages$Panel$SingleCharge$update, msg_, model_, shared, user);
						var newModel = _v35.a;
						var cmd_ = _v35.b;
						var sharedMsg = _v35.c;
						return $author$project$Services$Models$iHaveAccess(
							{
								gZ: user.hg,
								hf: $author$project$Services$Models$AVULSAS(0),
								hQ: _Utils_Tuple3(
									$author$project$Pages$SingleChargePage(newModel),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$SingleChargeMsg, cmd_),
									sharedMsg),
								hR: nothing
							});
					} else {
						break _v0$57;
					}
				case 29:
					if ((_v0.b.$ === 28) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var user = _v0.c.a;
						var _v36 = A4($author$project$Pages$Panel$Stock$List$update, msg_, model_, shared, user);
						var newModel = _v36.a;
						var cmd_ = _v36.b;
						var sharedMsg = _v36.c;
						return $author$project$Services$Models$iHaveAccess(
							{
								gZ: user.hg,
								hf: $author$project$Services$Models$STOCK(0),
								hQ: _Utils_Tuple3(
									$author$project$Pages$StockListPage(newModel),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$StockListMsg, cmd_),
									sharedMsg),
								hR: nothing
							});
					} else {
						break _v0$57;
					}
				case 30:
					if ((_v0.b.$ === 29) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var user = _v0.c.a;
						var _v37 = A4($author$project$Pages$Panel$Stock$Details$update, msg_, model_, shared, user);
						var newModel = _v37.a;
						var cmd_ = _v37.b;
						var sharedMsg = _v37.c;
						return $author$project$Services$Models$iHaveAccess(
							{
								gZ: user.hg,
								hf: $author$project$Services$Models$STOCK(0),
								hQ: _Utils_Tuple3(
									$author$project$Pages$StockDetailsPage(newModel),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$StockDetailsMsg, cmd_),
									sharedMsg),
								hR: nothing
							});
					} else {
						break _v0$57;
					}
				case 31:
					if ((_v0.b.$ === 30) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var user = _v0.c.a;
						var _v38 = A3($author$project$Pages$Panel$UpdateRequestsEquipments$update, msg_, model_, user);
						var newModel = _v38.a;
						var cmd_ = _v38.b;
						var sharedMsg = _v38.c;
						return $author$project$Services$Models$iHaveAccess(
							{
								gZ: user.hg,
								hf: $author$project$Services$Models$EQUIPMENT_UPDATE(0),
								hQ: _Utils_Tuple3(
									$author$project$Pages$UpdateRequestsEquipmentsPage(newModel),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$UpdateRequestsEquipmentsMsg, cmd_),
									sharedMsg),
								hR: nothing
							});
					} else {
						break _v0$57;
					}
				case 32:
					if ((_v0.b.$ === 31) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var user = _v0.c.a;
						var _v39 = A4($author$project$Pages$Panel$ManageLines$update, msg_, shared, user, model_);
						var newModel = _v39.a;
						var cmd_ = _v39.b;
						var sharedMsg = _v39.c;
						return $author$project$Services$Models$iHaveAccess(
							{
								gZ: user.hg,
								hf: $author$project$Services$Models$LINES(0),
								hQ: _Utils_Tuple3(
									$author$project$Pages$ManageLinesPage(newModel),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$ManageLinesMsg, cmd_),
									sharedMsg),
								hR: nothing
							});
					} else {
						break _v0$57;
					}
				case 33:
					if ((_v0.b.$ === 32) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var user = _v0.c.a;
						var _v40 = A3($author$project$Pages$Panel$History$update, msg_, model_, shared);
						var newModel = _v40.a;
						var cmd_ = _v40.b;
						var sharedMsg = _v40.c;
						return $author$project$Services$Models$iHaveAccess(
							{
								gZ: user.hg,
								hf: $author$project$Services$Models$PASSENGER(0),
								hQ: _Utils_Tuple3(
									$author$project$Pages$HistoryPage(newModel),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$HistoryMsg, cmd_),
									sharedMsg),
								hR: nothing
							});
					} else {
						break _v0$57;
					}
				case 34:
					if ((_v0.b.$ === 33) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var user = _v0.c.a;
						var _v41 = A3($author$project$Pages$Reports$UsesPerVehicle$update, msg_, model_, shared);
						var newModel = _v41.a;
						var cmd = _v41.b;
						var sharedMsg = _v41.c;
						return $author$project$Services$Models$iHaveAccess(
							{
								gZ: user.hg,
								hf: $author$project$Services$Models$REPORTS(
									$author$project$Services$Models$UsesVehicles(0)),
								hQ: _Utils_Tuple3(
									$author$project$Pages$ReportUsesPerVehiclePage(newModel),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$ReportUsesPerVehicleMsg, cmd),
									sharedMsg),
								hR: nothing
							});
					} else {
						break _v0$57;
					}
				case 35:
					if ((_v0.b.$ === 34) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var user = _v0.c.a;
						var _v42 = A4($author$project$Pages$Reports$PDFs$update, msg_, model_, shared, user);
						var newModel = _v42.a;
						var cmd = _v42.b;
						var sharedMsg = _v42.c;
						return $author$project$Services$Models$iHaveAccess(
							{
								gZ: user.hg,
								hf: $author$project$Services$Models$REPORT_PDF(0),
								hQ: _Utils_Tuple3(
									$author$project$Pages$ReportPDFsPage(newModel),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$ReportPDFsMsg, cmd),
									sharedMsg),
								hR: nothing
							});
					} else {
						break _v0$57;
					}
				case 36:
					if ((_v0.b.$ === 35) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var user = _v0.c.a;
						var _v43 = A3($author$project$Pages$Reports$Event$UsingVehicle$update, msg_, model_, shared);
						var newModel = _v43.a;
						var cmd = _v43.b;
						var sharedMsg = _v43.c;
						return $author$project$Services$Models$iHaveAccess(
							{
								gZ: user.hg,
								hf: $author$project$Services$Models$REPORTS_EVENTS(1),
								hQ: _Utils_Tuple3(
									$author$project$Pages$ReportEventUsingVehiclePage(newModel),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$ReportEventUsingVehicleMsg, cmd),
									sharedMsg),
								hR: nothing
							});
					} else {
						break _v0$57;
					}
				case 37:
					if ((_v0.b.$ === 36) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var user = _v0.c.a;
						var _v44 = A3($author$project$Pages$Reports$Event$UsingLine$update, msg_, model_, shared);
						var newModel = _v44.a;
						var cmd = _v44.b;
						var sharedMsg = _v44.c;
						return $author$project$Services$Models$iHaveAccess(
							{
								gZ: user.hg,
								hf: $author$project$Services$Models$REPORTS_EVENTS(3),
								hQ: _Utils_Tuple3(
									$author$project$Pages$ReportEventUsingLinePage(newModel),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$ReportEventUsingLineMsg, cmd),
									sharedMsg),
								hR: nothing
							});
					} else {
						break _v0$57;
					}
				case 38:
					if ((_v0.b.$ === 37) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var user = _v0.c.a;
						var _v45 = A3($author$project$Pages$Reports$Event$UsingDay$update, msg_, model_, shared);
						var newModel = _v45.a;
						var cmd = _v45.b;
						var sharedMsg = _v45.c;
						return $author$project$Services$Models$iHaveAccess(
							{
								gZ: user.hg,
								hf: $author$project$Services$Models$REPORTS_EVENTS(0),
								hQ: _Utils_Tuple3(
									$author$project$Pages$ReportEventUsingDayPage(newModel),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$ReportEventUsingDayMsg, cmd),
									sharedMsg),
								hR: nothing
							});
					} else {
						break _v0$57;
					}
				case 39:
					if ((_v0.b.$ === 38) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var user = _v0.c.a;
						var _v46 = A3($author$project$Pages$Reports$Event$UsingOperator$update, msg_, model_, shared);
						var newModel = _v46.a;
						var cmd = _v46.b;
						var sharedMsg = _v46.c;
						return $author$project$Services$Models$iHaveAccess(
							{
								gZ: user.hg,
								hf: $author$project$Services$Models$REPORTS_EVENTS(2),
								hQ: _Utils_Tuple3(
									$author$project$Pages$ReportEventUsingOperatorPage(newModel),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$ReportEventUsingOperatorMsg, cmd),
									sharedMsg),
								hR: nothing
							});
					} else {
						break _v0$57;
					}
				case 40:
					if ((_v0.b.$ === 39) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var user = _v0.c.a;
						var _v47 = A4($author$project$Pages$Reports$Event$UsingSession$update, msg_, model_, shared, user);
						var newModel = _v47.a;
						var cmd = _v47.b;
						var sharedMsg = _v47.c;
						return $author$project$Services$Models$iHaveAccess(
							{
								gZ: user.hg,
								hf: $author$project$Services$Models$REPORTS_EVENTS(4),
								hQ: _Utils_Tuple3(
									$author$project$Pages$ReportEventUsingSessionPage(newModel),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$ReportEventUsingSessionMsg, cmd),
									sharedMsg),
								hR: nothing
							});
					} else {
						break _v0$57;
					}
				case 41:
					if ((_v0.b.$ === 40) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var user = _v0.c.a;
						var _v48 = A3($author$project$Pages$Reports$Event$Audit$update, msg_, model_, shared);
						var newModel = _v48.a;
						var cmd = _v48.b;
						var sharedMsg = _v48.c;
						return _Utils_Tuple3(
							$author$project$Pages$ReportAuditPage(newModel),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$ReportAuditMsg, cmd),
							sharedMsg);
					} else {
						break _v0$57;
					}
				case 42:
					if ((_v0.b.$ === 41) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var user = _v0.c.a;
						var _v49 = A3($author$project$Pages$Reports$UsesPerDay$update, msg_, model_, shared);
						var newModel = _v49.a;
						var cmd = _v49.b;
						var sharedMsg = _v49.c;
						return $author$project$Services$Models$iHaveAccess(
							{
								gZ: user.hg,
								hf: $author$project$Services$Models$REPORTS(
									$author$project$Services$Models$UsesDay(0)),
								hQ: _Utils_Tuple3(
									$author$project$Pages$ReportUsesPerDayPage(newModel),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$ReportUsesPerDayMsg, cmd),
									sharedMsg),
								hR: nothing
							});
					} else {
						break _v0$57;
					}
				case 43:
					if ((_v0.b.$ === 42) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var user = _v0.c.a;
						var _v50 = A3($author$project$Pages$Reports$UsesPerLine$update, msg_, model_, shared);
						var newModel = _v50.a;
						var cmd = _v50.b;
						var sharedMsg = _v50.c;
						return $author$project$Services$Models$iHaveAccess(
							{
								gZ: user.hg,
								hf: $author$project$Services$Models$REPORTS(
									$author$project$Services$Models$UsesLine(0)),
								hQ: _Utils_Tuple3(
									$author$project$Pages$ReportUsesPerLinePage(newModel),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$ReportUsesPerLineMsg, cmd),
									sharedMsg),
								hR: nothing
							});
					} else {
						break _v0$57;
					}
				case 46:
					if ((_v0.b.$ === 45) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var user = _v0.c.a;
						var _v51 = A4($author$project$Pages$Reports$Usage$update, msg_, model_, shared, user);
						var newModel = _v51.a;
						var cmd = _v51.b;
						var sharedMsg = _v51.c;
						return $author$project$Services$Models$iHaveAccess(
							{
								gZ: user.hg,
								hf: $author$project$Services$Models$REPORTS($author$project$Services$Models$Usage),
								hQ: _Utils_Tuple3(
									$author$project$Pages$ReportUsagePage(newModel),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$ReportUsageMsg, cmd),
									sharedMsg),
								hR: nothing
							});
					} else {
						break _v0$57;
					}
				case 44:
					if ((_v0.b.$ === 43) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var user = _v0.c.a;
						var _v52 = A4($author$project$Pages$Reports$UsesPerClass$update, msg_, model_, shared, user);
						var newModel = _v52.a;
						var cmd = _v52.b;
						var sharedMsg = _v52.c;
						return $author$project$Services$Models$iHaveAccess(
							{
								gZ: user.hg,
								hf: $author$project$Services$Models$REPORTS($author$project$Services$Models$UsesClass),
								hQ: _Utils_Tuple3(
									$author$project$Pages$ReportUsesPerClassPage(newModel),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$ReportUsesPerClassMsg, cmd),
									sharedMsg),
								hR: nothing
							});
					} else {
						break _v0$57;
					}
				case 45:
					if ((_v0.b.$ === 44) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var user = _v0.c.a;
						var _v53 = A4($author$project$Pages$Reports$Divergences$update, msg_, model_, shared, user);
						var newModel = _v53.a;
						var cmd = _v53.b;
						var sharedMsg = _v53.c;
						return $author$project$Services$Models$iHaveAccess(
							{
								gZ: user.hg,
								hf: $author$project$Services$Models$BIOMETRY(0),
								hQ: _Utils_Tuple3(
									$author$project$Pages$ReportDivergencesPage(newModel),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$ReportDivergencesMsg, cmd),
									sharedMsg),
								hR: nothing
							});
					} else {
						break _v0$57;
					}
				case 47:
					if ((_v0.b.$ === 46) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var user = _v0.c.a;
						var _v54 = A3($author$project$Pages$Reports$DetailedVehicle$update, msg_, model_, shared);
						var newModel = _v54.a;
						var cmd = _v54.b;
						var sharedMsg = _v54.c;
						return $author$project$Services$Models$iHaveAccess(
							{
								gZ: user.hg,
								hf: $author$project$Services$Models$REPORTS($author$project$Services$Models$DetailedVehicle),
								hQ: _Utils_Tuple3(
									$author$project$Pages$ReportDetailedVehiclePage(newModel),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$ReportDetailedVehicleMsg, cmd),
									sharedMsg),
								hR: nothing
							});
					} else {
						break _v0$57;
					}
				case 48:
					if ((_v0.b.$ === 47) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var user = _v0.c.a;
						var _v55 = A4($author$project$Pages$Reports$DetailedVehicleV2$update, msg_, model_, shared, user);
						var newModel = _v55.a;
						var cmd = _v55.b;
						var sharedMsg = _v55.c;
						return $author$project$Services$Models$iHaveAccess(
							{
								gZ: user.hg,
								hf: $author$project$Services$Models$REPORTS($author$project$Services$Models$DetailedVehicle),
								hQ: _Utils_Tuple3(
									$author$project$Pages$ReportDetailedVehicleV2Page(newModel),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$ReportDetailedVehicleV2Msg, cmd),
									sharedMsg),
								hR: nothing
							});
					} else {
						break _v0$57;
					}
				case 49:
					if ((_v0.b.$ === 48) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var user = _v0.c.a;
						var _v56 = A4($author$project$Pages$Reports$SalesSummarized$update, msg_, model_, shared, user);
						var newModel = _v56.a;
						var cmd = _v56.b;
						var sharedMsg = _v56.c;
						return $author$project$Services$Models$iHaveAccess(
							{
								gZ: user.hg,
								hf: $author$project$Services$Models$REPORTS($author$project$Services$Models$SalesSummary),
								hQ: _Utils_Tuple3(
									$author$project$Pages$ReportSalesSummarizedPage(newModel),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$ReportSalesSummarizedMsg, cmd),
									sharedMsg),
								hR: nothing
							});
					} else {
						break _v0$57;
					}
				case 50:
					if ((_v0.b.$ === 49) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var user = _v0.c.a;
						var _v57 = A4($author$project$Pages$Reports$SalesSummarizedV2$update, msg_, model_, shared, user);
						var newModel = _v57.a;
						var cmd = _v57.b;
						var sharedMsg = _v57.c;
						return $author$project$Services$Models$iHaveAccess(
							{
								gZ: user.hg,
								hf: $author$project$Services$Models$REPORTS($author$project$Services$Models$SalesSummary),
								hQ: _Utils_Tuple3(
									$author$project$Pages$ReportSalesSummarizedV2Page(newModel),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$ReportSalesSummarizedV2Msg, cmd),
									sharedMsg),
								hR: nothing
							});
					} else {
						break _v0$57;
					}
				case 51:
					if ((_v0.b.$ === 50) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var user = _v0.c.a;
						var _v58 = A4($author$project$Pages$Reports$AdministrativeSales$update, msg_, model_, shared, user);
						var newModel = _v58.a;
						var cmd = _v58.b;
						var sharedMsg = _v58.c;
						return $author$project$Services$Models$iHaveAccess(
							{
								gZ: user.hg,
								hf: $author$project$Services$Models$REPORTS($author$project$Services$Models$SalesSummary),
								hQ: _Utils_Tuple3(
									$author$project$Pages$ReportAdministrativeSalesPage(newModel),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$ReportAdministrativeSalesMsg, cmd),
									sharedMsg),
								hR: nothing
							});
					} else {
						break _v0$57;
					}
				case 52:
					if ((_v0.b.$ === 51) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var user = _v0.c.a;
						var _v59 = A4($author$project$Pages$Panel$Financial$Account$update, msg_, model_, user, shared);
						var newModel = _v59.a;
						var cmd = _v59.b;
						var sharedMsg = _v59.c;
						return $author$project$Services$Models$iHaveAccess(
							{
								gZ: user.hg,
								hf: $author$project$Services$Models$FINANCIAL(1),
								hQ: _Utils_Tuple3(
									$author$project$Pages$FinancialAccountPage(newModel),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$FinancialAccountMsg, cmd),
									sharedMsg),
								hR: nothing
							});
					} else {
						break _v0$57;
					}
				case 53:
					if ((_v0.b.$ === 52) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var user = _v0.c.a;
						var _v60 = A4($author$project$Pages$Panel$Financial$Transactions$update, msg_, model_, shared, user);
						var newModel = _v60.a;
						var cmd = _v60.b;
						var sharedMsg = _v60.c;
						return $author$project$Services$Models$iHaveAccess(
							{
								gZ: user.hg,
								hf: $author$project$Services$Models$FINANCIAL(2),
								hQ: _Utils_Tuple3(
									$author$project$Pages$FinancialTransactionsPage(newModel),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$FinancialTransactionsMsg, cmd),
									sharedMsg),
								hR: nothing
							});
					} else {
						break _v0$57;
					}
				case 54:
					if ((_v0.b.$ === 53) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var user = _v0.c.a;
						var _v61 = A4($author$project$Pages$Panel$Financial$PendingTransactions$update, msg_, model_, shared, user);
						var newModel = _v61.a;
						var cmd = _v61.b;
						var sharedMsg = _v61.c;
						return $author$project$Services$Models$iHaveAccess(
							{
								gZ: user.hg,
								hf: $author$project$Services$Models$FINANCIAL(3),
								hQ: _Utils_Tuple3(
									$author$project$Pages$FinancialPendingTransactionsPage(newModel),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$FinancialPendingTransactionsMsg, cmd),
									sharedMsg),
								hR: nothing
							});
					} else {
						break _v0$57;
					}
				case 55:
					if ((_v0.b.$ === 54) && (!_v0.c.$)) {
						var msg_ = _v0.a.a;
						var model_ = _v0.b.a;
						var user = _v0.c.a;
						var _v62 = A4($author$project$Pages$Panel$Classes$SubPage$update, user, msg_, model_, shared);
						var newModel = _v62.a;
						var cmd = _v62.b;
						var sharedMsg = _v62.c;
						return $author$project$Services$Models$iHaveAccess(
							{
								gZ: user.hg,
								hf: $author$project$Services$Models$CLASS(1),
								hQ: _Utils_Tuple3(
									$author$project$Pages$PanelClassesPage(newModel),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$PanelClassesMsg, cmd),
									sharedMsg),
								hR: nothing
							});
					} else {
						break _v0$57;
					}
				case 56:
					if (_v0.b.$ === 56) {
						var pageTwoMsg = _v0.a.a;
						var _v63 = _v0.b;
						var cmd = A2($author$project$Pages$NotFound$update, pageTwoMsg, shared);
						return _Utils_Tuple3(
							$author$project$Pages$NotFoundPage,
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$NotFoundMsg, cmd),
							$author$project$Shared$NoOp);
					} else {
						break _v0$57;
					}
				default:
					break _v0$57;
			}
		}
		return nothing;
	});
var $author$project$Main$update = F2(
	function (msg, model) {
		var shared = model.v;
		switch (msg.$) {
			case 1:
				var zone = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							v: _Utils_update(
								shared,
								{kS: zone})
						}),
					$elm$core$Platform$Cmd$none);
			case 0:
				if (!msg.a.$) {
					var url = msg.a.a;
					return _Utils_Tuple2(
						model,
						A2(
							$author$project$Route$pushUrl,
							shared.nZ,
							$author$project$Route$parseUrl(url)));
				} else {
					var href = msg.a.a;
					return _Utils_Tuple2(
						model,
						$elm$browser$Browser$Navigation$load(href));
				}
			case 2:
				var url = msg.a;
				var updtShared = _Utils_update(
					shared,
					{
						pv: $author$project$Route$parseUrl(url),
						qt: url
					});
				var _v1 = A2(
					$author$project$Pages$init,
					updtShared,
					$elm$core$Maybe$Just(model.bv));
				var page = _v1.a;
				var cmd = _v1.b;
				var sharedMsg = _v1.c;
				var _v2 = A2($author$project$Shared$update, sharedMsg, updtShared);
				var newShared = _v2.a;
				var sharedCmd = _v2.b;
				var newCompNavigationDrawer = function () {
					var _v3 = _Utils_Tuple2(newShared.pF, model.ak);
					if ((!_v3.a.$) && (!_v3.b.$)) {
						var user = _v3.a.a;
						var navigationDrawer = _v3.b.a;
						return $elm$core$Maybe$Just(
							_Utils_update(
								navigationDrawer,
								{
									d7: A3(
										$author$project$Components$Patterns$NavigationDrawer$availableRoutes,
										newShared.pv,
										user,
										$author$project$Components$Patterns$NavigationDrawer$currentConcessionaireId(shared.pv))
								}));
					} else {
						return model.ak;
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ak: newCompNavigationDrawer,
							bv: page,
							v: _Utils_update(
								newShared,
								{
									iG: newShared.j_ ? newShared.iG : $elm$core$Maybe$Nothing,
									j_: false
								})
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Main$PagesMsg, cmd),
								A2($elm$core$Platform$Cmd$map, $author$project$Main$SharedMsg, sharedCmd),
								A2(
								$author$project$Main$socketCmd,
								$author$project$Route$parseUrl(model.v.qt),
								$author$project$Route$parseUrl(url))
							])));
			case 3:
				var res = msg.a;
				if (res.$ === 1) {
					var error = res.a;
					return _Utils_Tuple2(
						model,
						A2(
							$elm$core$Task$perform,
							$elm$core$Basics$identity,
							$elm$core$Task$succeed(
								$author$project$Main$SharedMsg(
									$author$project$Shared$Batch(
										_List_fromArray(
											[
												$author$project$Shared$ShowErrorDialog(
												'Não foi possível fazer login. ' + $elm$json$Json$Decode$errorToString(error)),
												$author$project$Shared$RedirectPreserve($author$project$Route$Login)
											]))))));
				} else {
					var user = res.a;
					var _v5 = A2($author$project$Components$Patterns$NavigationDrawer$init, user, shared);
					var initCompNavigationDrawer = _v5.a;
					var initCompNavigationDrawerCmd = _v5.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ak: $elm$core$Maybe$Just(initCompNavigationDrawer),
								v: _Utils_update(
									shared,
									{
										pF: $author$project$Shared$LoggedIn(user)
									})
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$elm$browser$Browser$Navigation$load(
									$author$project$Route$starterWithStrRoute(user)),
									A2($elm$core$Platform$Cmd$map, $author$project$Main$NavigationDrawerMsg, initCompNavigationDrawerCmd)
								])));
				}
			case 4:
				var pagesMsg = msg.a;
				var _v6 = A3($author$project$Pages$update, pagesMsg, model.bv, shared);
				var newPage = _v6.a;
				var cmd = _v6.b;
				var sharedMsg = _v6.c;
				var _v7 = A2($author$project$Shared$update, sharedMsg, shared);
				var newShared = _v7.a;
				var sharedCmd = _v7.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bv: newPage, v: newShared}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Main$PagesMsg, cmd),
								A2($elm$core$Platform$Cmd$map, $author$project$Main$SharedMsg, sharedCmd)
							])));
			case 5:
				var msg_ = msg.a;
				return A3(
					$elm$core$Tuple$mapBoth,
					function (sharedModel) {
						return _Utils_update(
							model,
							{v: sharedModel});
					},
					$elm$core$Platform$Cmd$map($author$project$Main$SharedMsg),
					A2($author$project$Shared$update, msg_, model.v));
			default:
				var msg_ = msg.a;
				var _v8 = A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple3(model.ak, $elm$core$Platform$Cmd$none, $author$project$Shared$NoOp),
					A2(
						$elm$core$Maybe$map,
						function (c) {
							var _v9 = A3($author$project$Components$Patterns$NavigationDrawer$update, msg_, shared, c);
							var m = _v9.a;
							var cm = _v9.b;
							var s = _v9.c;
							return _Utils_Tuple3(
								$elm$core$Maybe$Just(m),
								cm,
								s);
						},
						model.ak));
				var newModel = _v8.a;
				var cmd = _v8.b;
				var sharedMsg = _v8.c;
				var _v10 = A2($author$project$Shared$update, sharedMsg, shared);
				var newShared = _v10.a;
				var sharedCmd = _v10.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ak: newModel, v: newShared}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Main$NavigationDrawerMsg, cmd),
								A2($elm$core$Platform$Cmd$map, $author$project$Main$SharedMsg, sharedCmd)
							])));
		}
	});
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $author$project$Data$Billing$daysText = function (days) {
	return (days === 1) ? '1 dia' : ($elm$core$String$fromInt(days) + ' dias');
};
var $elm$html$Html$div = _VirtualDom_node('div');
var $author$project$Data$Billing$formatDate = function (isoDate) {
	var _v0 = A2(
		$elm$core$String$split,
		'-',
		A2($elm$core$String$left, 10, isoDate));
	if (((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.b.b)) {
		var year = _v0.a;
		var _v1 = _v0.b;
		var month = _v1.a;
		var _v2 = _v1.b;
		var day = _v2.a;
		return day + ('/' + (month + ('/' + year)));
	} else {
		return isoDate;
	}
};
var $author$project$Data$Billing$view = function (billing) {
	if (!billing.$) {
		var status = billing.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('billing-banner'),
					A2($elm$html$Html$Attributes$attribute, 'role', 'alert')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					status.fY ? 'Sistema bloqueado por pendência financeira. Apenas os menus Home e Guichê estão disponíveis. Regularize os pagamentos para restabelecer o acesso.' : ('Pendência financeira: o sistema será bloqueado em ' + ($author$project$Data$Billing$daysText(status.iE) + (' (' + ($author$project$Data$Billing$formatDate(status.h6) + '). Regularize os pagamentos para evitar o bloqueio.')))))
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Shared$billingBanner = function (model) {
	return $author$project$Data$Billing$view(model.lB);
};
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$Keyed$node = $elm$virtual_dom$VirtualDom$keyedNode;
var $author$project$Components$Patterns$NavigationDrawer$pagesWithNavigationDrawer = function (route) {
	switch (route.$) {
		case 4:
			switch (route.a.$) {
				case 1:
					return true;
				case 0:
					return true;
				case 2:
					switch (route.a.a.$) {
						case 0:
							return true;
						case 1:
							return true;
						default:
							return true;
					}
				case 10:
					return true;
				case 7:
					return true;
				case 3:
					var _v11 = route.a;
					return true;
				case 4:
					return true;
				case 5:
					var _v12 = route.a;
					return true;
				case 8:
					var _v13 = route.a;
					return true;
				case 9:
					var _v14 = route.a;
					return true;
				case 11:
					return true;
				case 12:
					var _v15 = route.a;
					return true;
				case 14:
					return true;
				case 13:
					return true;
				default:
					return true;
			}
		case 19:
			switch (route.a.$) {
				case 2:
					var _v1 = route.a;
					return true;
				case 1:
					var _v2 = route.a;
					return true;
				case 4:
					var _v3 = route.a;
					return true;
				case 5:
					var _v4 = route.a;
					return true;
				case 9:
					return true;
				case 10:
					var _v5 = route.a;
					return true;
				case 11:
					var _v6 = route.a;
					return true;
				case 12:
					var _v7 = route.a;
					return true;
				case 13:
					return true;
				case 14:
					return true;
				case 3:
					return true;
				case 7:
					var _v8 = route.a;
					return true;
				case 8:
					var _v9 = route.a;
					return true;
				case 6:
					var _v10 = route.a;
					return true;
				default:
					return true;
			}
		case 3:
			return true;
		case 13:
			return true;
		case 14:
			return true;
		case 15:
			return true;
		case 16:
			return true;
		case 17:
			return true;
		case 21:
			switch (route.a.$) {
				case 0:
					return true;
				case 12:
					var _v16 = route.a;
					return true;
				case 11:
					switch (route.a.a.$) {
						case 0:
							return true;
						case 1:
							return true;
						case 2:
							return true;
						case 3:
							return true;
						case 4:
							return true;
						default:
							return true;
					}
				case 1:
					return true;
				case 2:
					return true;
				case 9:
					return true;
				case 10:
					return true;
				case 8:
					return true;
				case 3:
					return true;
				case 4:
					return true;
				case 5:
					return true;
				case 6:
					return true;
				default:
					return true;
			}
		case 0:
			return false;
		case 1:
			return false;
		case 2:
			return false;
		case 5:
			return false;
		case 6:
			return false;
		case 7:
			return false;
		case 8:
			return false;
		case 9:
			return false;
		case 10:
			return false;
		case 11:
			return false;
		case 12:
			return false;
		case 18:
			return false;
		case 20:
			return false;
		default:
			return false;
	}
};
var $author$project$Gen$Environment$version = '20261014-51e42ce';
var $author$project$Components$View$version = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('version')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('v.:' + $author$project$Gen$Environment$version)
		]));
var $author$project$Components$Patterns$NavigationDrawer$ClickedLogout = {$: 2};
var $author$project$Components$Patterns$NavigationDrawer$SelectedConcessionaire = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$a = _VirtualDom_node('a');
var $elm$html$Html$Attributes$alt = $elm$html$Html$Attributes$stringProperty('alt');
var $elm$html$Html$button = _VirtualDom_node('button');
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $author$project$Data$Billing$isMenuRouteAllowedWhenBlocked = function (route) {
	switch (route.$) {
		case 3:
			return true;
		case 5:
			return true;
		default:
			return false;
	}
};
var $author$project$Data$Billing$filterMenuRoutes = F2(
	function (billing, routes) {
		return $author$project$Data$Billing$isBlocked(billing) ? A2(
			$elm$core$List$filter,
			function (_v0) {
				var routes_ = _v0.c;
				return A2($elm$core$List$all, $author$project$Data$Billing$isMenuRouteAllowedWhenBlocked, routes_);
			},
			routes) : routes;
	});
var $author$project$Components$Patterns$NavigationDrawer$getConcessionaire = function (user) {
	var _v0 = A2(
		$elm$core$Basics$composeL,
		$elm$core$List$head,
		function ($) {
			return $.bR;
		})(user);
	if (!_v0.$) {
		var concessionaire = _v0.a;
		return concessionaire;
	} else {
		return {dM: '', c3: 'Concessionária não informada'};
	}
};
var $author$project$Components$Patterns$NavigationDrawer$getUserName = function ($) {
	return $.qx;
};
var $elm$html$Html$h2 = _VirtualDom_node('h2');
var $elm$html$Html$header = _VirtualDom_node('header');
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $author$project$Route$href = function (targetRoute) {
	return $elm$html$Html$Attributes$href(
		$author$project$Route$toString(targetRoute));
};
var $elm$html$Html$img = _VirtualDom_node('img');
var $elm$html$Html$nav = _VirtualDom_node('nav');
var $author$project$Components$Patterns$NavigationDrawer$ClickedMenuExpand = function (a) {
	return {$: 3, a: a};
};
var $elm$html$Html$label = _VirtualDom_node('label');
var $elm$html$Html$li = _VirtualDom_node('li');
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $author$project$Components$Patterns$NavigationDrawer$navigationMenuItem = F2(
	function (currentRoute, itemRoute) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('menu-item')
				]),
			_List_fromArray(
				[
					function () {
					if (itemRoute.c.b && (!itemRoute.c.b.b)) {
						var _v1 = itemRoute.c;
						var item = _v1.a;
						return A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class(
									$author$project$Components$Patterns$NavigationDrawer$titleBaseClass(item).b),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'active',
											A2($author$project$Components$Patterns$NavigationDrawer$isActive, currentRoute, item))
										])),
									$author$project$Route$href(item)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Components$Patterns$NavigationDrawer$titleBaseClass(item).a)
								]));
					} else {
						if (!itemRoute.b.$) {
							var itemGrouped = itemRoute;
							var isExpand = itemGrouped.a;
							var _v2 = itemGrouped.b.a;
							var groupID = _v2.a;
							var groupName = _v2.b;
							var grouped = itemGrouped.c;
							var fontColor = isExpand ? 'text-teal-main icon-category-selected' : 'icon-category';
							var direction = isExpand ? '↑' : '↓';
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class(' text-lg pl-8 font-semibold hover:text-teal-main ' + fontColor),
												$elm$html$Html$Events$onClick(
												$author$project$Components$Patterns$NavigationDrawer$ClickedMenuExpand(itemGrouped)),
												A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(groupName + (' ' + direction))
											])),
										isExpand ? A2(
										$elm$html$Html$ul,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('flex flex-col gap-2 mt-2'),
												A2($elm$html$Html$Attributes$style, 'margin-left', '1rem')
											]),
										A2(
											$elm$core$List$map,
											function (item) {
												return A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class(
															$author$project$Components$Patterns$NavigationDrawer$titleBaseClass(item).b),
															$elm$html$Html$Attributes$classList(
															_List_fromArray(
																[
																	_Utils_Tuple2(
																	'active',
																	A2($author$project$Components$Patterns$NavigationDrawer$isActive, currentRoute, item))
																])),
															$author$project$Route$href(item)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Components$Patterns$NavigationDrawer$titleBaseClass(item).a)
														]));
											},
											grouped)) : $elm$html$Html$text('')
									]));
						} else {
							return $elm$html$Html$text('');
						}
					}
				}()
				]));
	});
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $elm$html$Html$option = _VirtualDom_node('option');
var $elm$html$Html$select = _VirtualDom_node('select');
var $elm$html$Html$Attributes$selected = $elm$html$Html$Attributes$boolProperty('selected');
var $elm$html$Html$span = _VirtualDom_node('span');
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $author$project$Components$Patterns$Forms$viewErrors = F2(
	function (showError, errors) {
		return showError ? A2(
			$elm$html$Html$ul,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (error) {
					return A2(
						$elm$html$Html$li,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-secondary-error')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(error)
									]))
							]));
				},
				errors)) : $elm$html$Html$text('');
	});
var $author$project$Components$Patterns$Forms$selectWithError = function (opts) {
	var viewOption = function (option) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(option.di),
					$elm$html$Html$Attributes$selected(option.eX)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$elm$core$String$toUpper(option.c3))
				]));
	};
	var getOptionAll = A2(
		$elm$core$List$filter,
		function (op) {
			return op.di === '';
		},
		opts.jO);
	var optionsOrder = opts.jQ ? opts.jO : A2(
		$elm$core$List$append,
		getOptionAll,
		A2(
			$elm$core$List$sortBy,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.c3;
				},
				$elm$core$String$toLower),
			A2(
				$elm$core$List$filter,
				function (op) {
					return op.di !== '';
				},
				opts.jO)));
	var currentErrors = A2(
		$elm$core$List$filterMap,
		function (_v2) {
			var isInvalid = _v2.a;
			var errorName = _v2.b;
			return isInvalid ? $elm$core$Maybe$Just(errorName) : $elm$core$Maybe$Nothing;
		},
		opts.k1);
	return A2(
		$elm$html$Html$label,
		A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'input-error',
						opts.kE && (!$elm$core$List$isEmpty(currentErrors))),
						_Utils_Tuple2('m-0', true)
					])),
			opts.jn),
		_List_fromArray(
			[
				function () {
				var _v0 = opts.jl;
				if (!_v0.$) {
					var label = _v0.a;
					return A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-purple-main')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(label)
							]));
				} else {
					return $elm$html$Html$text('');
				}
			}(),
				A2(
				$elm$html$Html$select,
				_Utils_ap(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-lg'),
							A2($elm$html$Html$Attributes$style, 'margin-bottom', '1rem'),
							$elm$html$Html$Attributes$disabled(opts.iH),
							function () {
							var _v1 = opts.jI;
							if (!_v1.$) {
								var onInputMsg = _v1.a;
								return $elm$html$Html$Events$onInput(onInputMsg);
							} else {
								return $elm$html$Html$Attributes$class('');
							}
						}()
						]),
					opts.ks),
				A2($elm$core$List$map, viewOption, optionsOrder)),
				A2($author$project$Components$Patterns$Forms$viewErrors, opts.kE, currentErrors)
			]));
};
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty('title');
var $author$project$Components$Patterns$NavigationDrawer$view = F3(
	function (user, model, shared) {
		var viewHeaderConcessionaire = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(' flex flex-col items-center text-white')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-0'),
							$elm$html$Html$Attributes$title(
							'Concessionária ' + function ($) {
								return $.c3;
							}(
								$author$project$Components$Patterns$NavigationDrawer$getConcessionaire(user)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							function ($) {
								return $.c3;
							}(
								$author$project$Components$Patterns$NavigationDrawer$getConcessionaire(user)))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-center')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Components$Patterns$NavigationDrawer$getUserName(user))
						]))
				]));
		var manageAccountsActive = function () {
			var _v0 = shared.pv;
			if ((_v0.$ === 4) && (_v0.a.$ === 7)) {
				return true;
			} else {
				return false;
			}
		}();
		return A2(
			$elm$html$Html$header,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('header-dashboard scroll-nav')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('logo-img')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$alt('Pazze'),
									$elm$html$Html$Attributes$src('/images/logo-pazze.png')
								]),
							_List_Nil),
							viewHeaderConcessionaire
						])),
					$elm$core$List$isEmpty(model.bR) ? $elm$html$Html$text('') : $author$project$Components$Patterns$Forms$selectWithError(
					{
						iH: false,
						jl: $elm$core$Maybe$Nothing,
						jn: _List_Nil,
						jI: $elm$core$Maybe$Just($author$project$Components$Patterns$NavigationDrawer$SelectedConcessionaire),
						jO: A2(
							$elm$core$List$cons,
							{
								eX: _Utils_eq(model.cN, $elm$core$Maybe$Nothing),
								c3: 'Todas as concessionárias',
								di: ''
							},
							A2(
								$elm$core$List$map,
								function (c) {
									return {
										eX: _Utils_eq(
											model.cN,
											$elm$core$Maybe$Just(c.dM)),
										c3: c.c3,
										di: c.dM
									};
								},
								A2(
									$elm$core$List$sortBy,
									function ($) {
										return $.c3;
									},
									model.bR))),
						jQ: false,
						ks: _List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'width', '90%'),
								A2($elm$html$Html$Attributes$style, 'align-self', 'center')
							]),
						kE: false,
						k1: _List_Nil
					}),
					A2(
					$elm$html$Html$nav,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('menu')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('justify-self-start ml-6')
								]),
							A2(
								$elm$core$List$map,
								$author$project$Components$Patterns$NavigationDrawer$navigationMenuItem(shared.pv),
								A2($author$project$Data$Billing$filterMenuRoutes, shared.lB, model.d7)))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col h-full justify-self-start ml-6')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('btn-configuracoes')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-white hover:text-teal-main manage-accounts'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('active text-teal-main', manageAccountsActive)
												])),
											$author$project$Route$href(
											$author$project$Route$Panel(
												$author$project$Route$MyAccount(1)))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'padding-left', '2.1rem')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Minha conta')
												]))
										]))
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('btn-configuracoes'),
									$elm$html$Html$Events$onClick($author$project$Components$Patterns$NavigationDrawer$ClickedLogout)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('configuracoes')
										]),
									_List_Nil),
									$elm$html$Html$text('Logout')
								]))
						]))
				]));
	});
var $author$project$Pages$RedirectMsg = function (a) {
	return {$: 57, a: a};
};
var $author$project$Pages$UpdateWebapp = {$: 0};
var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var $elm$svg$Svg$Attributes$clipRule = _VirtualDom_attribute('clip-rule');
var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $elm$svg$Svg$Attributes$fillRule = _VirtualDom_attribute('fill-rule');
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $author$project$Svgs$alert = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$viewBox('0 0 20 20'),
			$elm$svg$Svg$Attributes$fill('#fdc700'),
			A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true'),
			A2($elm$html$Html$Attributes$attribute, 'data-slot', 'icon'),
			$elm$svg$Svg$Attributes$class('om bdo')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fillRule('evenodd'),
					$elm$svg$Svg$Attributes$d('M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495ZM10 5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 10 5Zm0 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z'),
					$elm$svg$Svg$Attributes$clipRule('evenodd')
				]),
			_List_Nil)
		]));
var $elm$html$Html$h3 = _VirtualDom_node('h3');
var $elm$html$Html$p = _VirtualDom_node('p');
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $author$project$Pages$Admin$AccountabilityReport$GetTimeToDownload = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Admin$AccountabilityReport$GotFilter = {$: 10};
var $author$project$Pages$Admin$AccountabilityReport$InputSearch = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Admin$AccountabilityReport$InputVehicle = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Admin$AccountabilityReport$InputtedEnd = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$AccountabilityReport$InputtedPouch = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Admin$AccountabilityReport$InputtedStart = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$AccountabilityReport$SelectedStatus = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$GeneratorCSV$buttonDownload = function (msg) {
	return A2(
		$elm$html$Html$label,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'width', 'fit-content')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('action-system green-btn min-btn-with-icon'),
						A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap'),
						$elm$html$Html$Attributes$type_('button'),
						$elm$html$Html$Events$onClick(msg)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('material-symbols-outlined text-sm')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('download')
							])),
						$elm$html$Html$text('Baixar CSV')
					]))
			]));
};
var $elm$html$Html$form = _VirtualDom_node('form');
var $elm$html$Html$input = _VirtualDom_node('input');
var $author$project$Pages$Admin$AccountabilityReport$listStatus = _List_fromArray(
	[
		_Utils_Tuple2('closed', 'Fechado'),
		_Utils_Tuple2('open', 'Aberto')
	]);
var $author$project$Components$View$loading = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('loading-container')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('loading')
				]),
			_List_Nil),
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('loading-txt')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Carregando')
				]))
		]));
var $elm$html$Html$main_ = _VirtualDom_node('main');
var $elm$html$Html$Events$alwaysPreventDefault = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $elm$html$Html$Events$onSubmit = function (msg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'submit',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysPreventDefault,
			$elm$json$Json$Decode$succeed(msg)));
};
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $author$project$Components$View$searchButton = F2(
	function (classLabel, disabledSubmit) {
		return A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mr-4 ' + classLabel)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('action-system green-btn min-btn-with-icon '),
							$elm$html$Html$Attributes$disabled(disabledSubmit),
							$elm$html$Html$Attributes$type_('submit')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('material-symbols-outlined text-sm')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('search')
								])),
							$elm$html$Html$text('Pesquisar')
						]))
				]));
	});
var $elm$html$Html$strong = _VirtualDom_node('strong');
var $elm$html$Html$table = _VirtualDom_node('table');
var $elm$html$Html$tbody = _VirtualDom_node('tbody');
var $elm$html$Html$th = _VirtualDom_node('th');
var $elm$html$Html$thead = _VirtualDom_node('thead');
var $elm$html$Html$tr = _VirtualDom_node('tr');
var $author$project$Pages$Admin$AccountabilityReport$viewRow = F2(
	function (timezone, row) {
		var spinsCountsEmpty = function (list) {
			return $elm$core$List$isEmpty(list) ? '-' : $elm$core$String$fromInt(
				$elm$core$List$sum(list));
		};
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Utils$formatDateTimeFromMaybePosix, timezone, row.hT))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$emptyStrDefault(row.hU))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$formatAsMoney(
								$elm$core$String$fromInt(row.fP)))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.l4;
									},
									row.k2)))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$emptyStrDefault(row.kA))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$emptyStrDefault(row.kC))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$emptyStrDefault(row.kz))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Utils$formatDateTimeFromMaybePosix, timezone, row.kB))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Utils$formatDateTimeFromMaybePosix, timezone, row.ky))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							spinsCountsEmpty(
								$author$project$Pages$Admin$AccountabilityReport$getMoney(row.kJ)))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'-',
								A2(
									$elm$core$Maybe$map,
									A2(
										$elm$core$Basics$composeR,
										$elm$core$String$right(4),
										$elm$core$String$toUpper),
									row.iv)))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'-',
								A2($elm$core$Maybe$map, $author$project$Utils$emptyStrDefault, row.cf)))
						]))
				]));
	});
var $author$project$Pages$Admin$AccountabilityReport$viewTable = F2(
	function (timezone, rows) {
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'cellspacing', '0'),
					$elm$html$Html$Attributes$class('data-table-dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$thead,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Data')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Arrecadador')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Valor (R$)')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Veículo')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Linha')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Operador Abertura')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Operador Fechamento')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Abertura')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Fechamento')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Quantitativo de pagantes em dinheiro')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Cód. Confirmação')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Malote')
										]))
								]))
						])),
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					A2(
						$elm$core$List$map,
						$author$project$Pages$Admin$AccountabilityReport$viewRow(timezone),
						rows))
				]));
	});
var $author$project$Pages$Admin$AccountabilityReport$viewPage = F3(
	function (model, shared, user) {
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard admin-reports')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('top-actions')
						]),
					_List_fromArray(
						[
							A2($elm$html$Html$div, _List_Nil, _List_Nil),
							A2($elm$html$Html$div, _List_Nil, _List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('report-types')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$author$project$Route$href(
									A2(
										$author$project$Route$Admin,
										$author$project$Route$AccountabilityReport,
										$author$project$Route$extractConcessionaireId(shared.pv))),
									$elm$html$Html$Attributes$class('active')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Arrecadação')
								])),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$author$project$Route$href(
									A2(
										$author$project$Route$Admin,
										$author$project$Route$SalesReport,
										$author$project$Route$extractConcessionaireId(shared.pv)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Vendas')
								])),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$author$project$Route$href(
									A2(
										$author$project$Route$Admin,
										$author$project$Route$SessionsReport,
										$author$project$Route$extractConcessionaireId(shared.pv)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Sessões')
								]))
						])),
					A2(
					$elm$html$Html$form,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('filtros-container account-ability'),
							$elm$html$Html$Events$onSubmit($author$project$Pages$Admin$AccountabilityReport$GotFilter)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Início'),
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$value(
											A2(
												$elm$core$Maybe$withDefault,
												'',
												A2(
													$elm$core$Maybe$map,
													function ($) {
														return $.eb;
													},
													model.cO))),
											A2($elm$html$Html$Attributes$style, 'margin-bottom', '1rem'),
											$elm$html$Html$Attributes$type_('date'),
											$elm$html$Html$Events$onInput($author$project$Pages$Admin$AccountabilityReport$InputtedStart)
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Fim'),
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$value(
											A2(
												$elm$core$Maybe$withDefault,
												'',
												A2(
													$elm$core$Maybe$map,
													function ($) {
														return $.dH;
													},
													model.cO))),
											A2($elm$html$Html$Attributes$style, 'margin-bottom', '1rem'),
											$elm$html$Html$Attributes$type_('date'),
											$elm$html$Html$Events$onInput($author$project$Pages$Admin$AccountabilityReport$InputtedEnd)
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Arrecadador'),
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('bg-busca-right'),
											$elm$html$Html$Attributes$placeholder('Todos'),
											$elm$html$Html$Attributes$type_('text'),
											A2($elm$html$Html$Attributes$style, 'margin-bottom', '1rem'),
											$elm$html$Html$Events$onInput($author$project$Pages$Admin$AccountabilityReport$InputSearch)
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Veículo'),
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('bg-busca-right'),
											$elm$html$Html$Attributes$placeholder('Todos'),
											$elm$html$Html$Attributes$type_('text'),
											A2($elm$html$Html$Attributes$style, 'margin-bottom', '1rem'),
											A2($elm$html$Html$Attributes$style, 'width', '10rem'),
											$elm$html$Html$Events$onInput($author$project$Pages$Admin$AccountabilityReport$InputVehicle)
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('self-end')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Status'),
									$author$project$Components$Patterns$Forms$selectWithError(
									{
										iH: false,
										jl: $elm$core$Maybe$Nothing,
										jn: _List_Nil,
										jI: $elm$core$Maybe$Just($author$project$Pages$Admin$AccountabilityReport$SelectedStatus),
										jO: A2(
											$elm$core$List$cons,
											{eX: model.co === '', c3: 'Todos', di: ''},
											A2(
												$elm$core$List$map,
												function (_v0) {
													var id = _v0.a;
													var name = _v0.b;
													return {
														eX: _Utils_eq(model.co, id),
														c3: name,
														di: id
													};
												},
												$author$project$Pages$Admin$AccountabilityReport$listStatus)),
										jQ: false,
										ks: _List_Nil,
										kE: false,
										k1: _List_Nil
									})
								])),
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Malote'),
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('bg-busca-right'),
											A2($elm$html$Html$Attributes$style, 'width', '10rem'),
											$elm$html$Html$Attributes$placeholder('Todos'),
											$elm$html$Html$Attributes$type_('text'),
											A2($elm$html$Html$Attributes$style, 'margin-bottom', '1rem'),
											$elm$html$Html$Events$onInput($author$project$Pages$Admin$AccountabilityReport$InputtedPouch)
										]),
									_List_Nil)
								])),
							A2(
							$author$project$Components$View$searchButton,
							'',
							$krisajenkins$remotedata$RemoteData$isLoading(model.ck)),
							function () {
							var _v1 = model.ck;
							if (_v1.$ === 3) {
								if (!_v1.a.b) {
									return $elm$html$Html$text('');
								} else {
									var rows = _v1.a;
									return $author$project$Components$GeneratorCSV$buttonDownload(
										$author$project$Pages$Admin$AccountabilityReport$GetTimeToDownload(rows));
								}
							} else {
								return $elm$html$Html$text('');
							}
						}()
						])),
					function () {
					var _v2 = model.ck;
					switch (_v2.$) {
						case 0:
							return $elm$html$Html$text('Por favor, defina um período desejado ou utilize as datas padrão para realizar a busca.');
						case 1:
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[$author$project$Components$View$loading]));
						case 2:
							return $elm$html$Html$text('Ops! Algo deu errado');
						default:
							if (!_v2.a.b) {
								return $elm$html$Html$text('Nenhum registro encontrado');
							} else {
								var rows = _v2.a;
								return A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2($author$project$Pages$Admin$AccountabilityReport$viewTable, shared.kS, rows),
											function () {
											var totaValue = A3(
												$elm$core$List$foldl,
												F2(
													function (row, acc) {
														return row.fP + acc;
													}),
												0,
												rows);
											return A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('bottom-actions flex justify-between')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$p,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('selecionados')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$strong,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('pr-2')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Totais no período')
																	])),
																A2(
																$elm$html$Html$strong,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		$author$project$Utils$formatAsMoney(
																			$elm$core$String$fromInt(totaValue)))
																	]))
															]))
													]));
										}()
										]));
							}
					}
				}()
				]));
	});
var $author$project$Pages$Admin$AccountabilityReport$view = F3(
	function (model, shared, user) {
		return _Utils_Tuple3(
			'Relatório Arrecadação',
			A3($author$project$Pages$Admin$AccountabilityReport$viewPage, model, shared, user),
			$elm$html$Html$text(''));
	});
var $author$project$Pages$Admin$CardExtract$ClickedDetails = {$: 6};
var $author$project$Pages$Admin$CardExtract$ClickedHideFails = {$: 7};
var $author$project$Pages$Admin$CardExtract$GetTimeToDownload = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Admin$CardExtract$InputtedClass = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$CardExtract$InputtedFrom = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Admin$CardExtract$InputtedTo = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$CardExtract$SubmitForm = {$: 8};
var $elm$html$Html$article = _VirtualDom_node('article');
var $elm$html$Html$Attributes$checked = $elm$html$Html$Attributes$boolProperty('checked');
var $author$project$Pages$Admin$CardExtract$viewCheckBox = function (options) {
	return options.iH ? $elm$html$Html$text('') : A2(
		$elm$html$Html$label,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('c-custom'),
				A2($elm$html$Html$Attributes$style, 'color', '#6e46c8')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('checkbox'),
						$elm$html$Html$Events$onClick(options.jG),
						$elm$html$Html$Attributes$checked(options.ie),
						$elm$html$Html$Attributes$disabled(options.iH)
					]),
				_List_Nil),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('checkmark'),
						A2($elm$html$Html$Attributes$style, 'margin-top', '0.15rem')
					]),
				_List_Nil),
				$elm$html$Html$text(options.c3)
			]));
};
var $author$project$Pages$Admin$CardExtract$evaluateToAddClassColorRedFailure = function (isError) {
	return isError ? $elm$html$Html$Attributes$class('text-red-500') : $elm$html$Html$Attributes$class('');
};
var $author$project$Pages$Admin$CardExtract$viewRow = F3(
	function (hideDetails, timezone, transaction) {
		var valueViewMoney = function (value) {
			return A2(
				$elm$core$Maybe$withDefault,
				'-',
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $author$project$Utils$formatAsMoney),
					value));
		};
		var valueView = function (v) {
			return ((transaction.z === 'Carga negativa aplicada') || ((transaction.z === 'Carga negativa aplicada no Guichê') || (transaction.z === 'Transferência de crédito (Débito)'))) ? A2(
				$elm$core$Basics$composeR,
				valueViewMoney,
				function (v_) {
					return '( ' + (v_ + ' )');
				})(v) : valueViewMoney(v);
		};
		var valueClass = function (value) {
			return ((value < 0) || ((transaction.z === 'Carga negativa aplicada') || ((transaction.z === 'Carga negativa aplicada no Guichê') || (transaction.z === 'Transferência de crédito (Débito)')))) ? $elm$html$Html$Attributes$class('text-red-500') : A2($elm$html$Html$Attributes$style, '', '');
		};
		var classView = function () {
			var _v0 = $elm$core$String$isEmpty(transaction.ih);
			if (_v0) {
				return '-';
			} else {
				return transaction.ih;
			}
		}();
		var viewTr = hideDetails ? A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Utils$formatDateTimeWithSecondsFromPosix, timezone, transaction.cO))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(transaction.k2)
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(transaction.e1)
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$author$project$Pages$Admin$CardExtract$evaluateToAddClassColorRedFailure(transaction.bD)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Pages$Admin$CardExtract$evaluateToAddTextFailure, transaction.z, transaction.bD))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(classView)
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'text-wrap', 'nowrap'),
							valueClass(
							A2($elm$core$Maybe$withDefault, 0, transaction.di))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							valueView(transaction.di))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'text-wrap', 'nowrap')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							valueViewMoney(transaction.h2))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'-',
								A2($elm$core$Maybe$map, $elm$core$String$fromInt, transaction.iy)))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'-',
								A2($elm$core$Maybe$map, $elm$core$String$fromInt, transaction.js)))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(transaction.k7)
						]))
				])) : A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Utils$formatDateTimeWithSecondsFromPosix, timezone, transaction.cO))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(transaction.k2)
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(transaction.e1)
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$author$project$Pages$Admin$CardExtract$evaluateToAddClassColorRedFailure(transaction.bD)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Pages$Admin$CardExtract$evaluateToAddTextFailure, transaction.z, transaction.bD))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(classView)
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'text-wrap', 'nowrap'),
							valueClass(
							A2($elm$core$Maybe$withDefault, 0, transaction.di))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							valueView(transaction.di))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'text-wrap', 'nowrap')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							valueViewMoney(transaction.h2))
						]))
				]));
		return viewTr;
	});
var $author$project$Pages$Admin$CardExtract$viewTable = F3(
	function (hideDetails, timezone, transactions) {
		var headers = hideDetails ? _List_fromArray(
			[
				A2(
				$elm$html$Html$tr,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$th,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Data')
							])),
						A2(
						$elm$html$Html$th,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Veículo')
							])),
						A2(
						$elm$html$Html$th,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Linha')
							])),
						A2(
						$elm$html$Html$th,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Evento')
							])),
						A2(
						$elm$html$Html$th,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Classe')
							])),
						A2(
						$elm$html$Html$th,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Valor')
							])),
						A2(
						$elm$html$Html$th,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Saldo')
							])),
						A2(
						$elm$html$Html$th,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Contador')
							])),
						A2(
						$elm$html$Html$th,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Contador Carga')
							])),
						A2(
						$elm$html$Html$th,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Carteira')
							]))
					]))
			]) : _List_fromArray(
			[
				A2(
				$elm$html$Html$tr,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$th,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Data')
							])),
						A2(
						$elm$html$Html$th,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Veículo')
							])),
						A2(
						$elm$html$Html$th,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Linha')
							])),
						A2(
						$elm$html$Html$th,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Evento')
							])),
						A2(
						$elm$html$Html$th,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Classe')
							])),
						A2(
						$elm$html$Html$th,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Valor')
							])),
						A2(
						$elm$html$Html$th,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Saldo')
							]))
					]))
			]);
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('data-table-dashboard'),
					A2($elm$html$Html$Attributes$attribute, 'cellspacing', '0')
				]),
			_List_fromArray(
				[
					A2($elm$html$Html$thead, _List_Nil, headers),
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					A2(
						$elm$core$List$map,
						A2($author$project$Pages$Admin$CardExtract$viewRow, hideDetails, timezone),
						transactions))
				]));
	});
var $author$project$Pages$Admin$CardExtract$contentExtractCard = F2(
	function (model, shared) {
		var disabledSubmit = $krisajenkins$remotedata$RemoteData$isLoading(model.a9);
		var _v0 = function () {
			var _v1 = model.cH;
			if (_v1.$ === 3) {
				var card = _v1.a;
				return _Utils_Tuple2(
					card.kw,
					$author$project$Pages$Admin$CardExtract$agroupClasses(card.dv));
			} else {
				return _Utils_Tuple2('', _List_Nil);
			}
		}();
		var serial = _v0.a;
		var classes = _v0.b;
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$h2,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'color', 'black'),
						$elm$html$Html$Attributes$class('inner-center')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Extrato Cartão ' + serial)
					])),
				$elm$core$List$isEmpty(classes) ? $elm$html$Html$text('') : A2(
				$elm$html$Html$form,
				_List_fromArray(
					[
						disabledSubmit ? $elm$html$Html$Attributes$class('') : $elm$html$Html$Events$onSubmit($author$project$Pages$Admin$CardExtract$SubmitForm)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$article,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('filtros-container payment-guides items-center gap-2')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Início'),
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$value(model.bq),
												$elm$html$Html$Attributes$type_('date'),
												$elm$html$Html$Events$onInput($author$project$Pages$Admin$CardExtract$InputtedFrom),
												A2($elm$html$Html$Attributes$style, 'margin-bottom', '1rem')
											]),
										_List_Nil)
									])),
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Fim'),
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$value(model.bC),
												$elm$html$Html$Attributes$type_('date'),
												$elm$html$Html$Events$onInput($author$project$Pages$Admin$CardExtract$InputtedTo),
												A2($elm$html$Html$Attributes$style, 'margin-bottom', '1rem')
											]),
										_List_Nil)
									])),
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Classe'),
										$author$project$Components$Patterns$Forms$selectWithError(
										{
											iH: false,
											jl: $elm$core$Maybe$Nothing,
											jn: _List_Nil,
											jI: $elm$core$Maybe$Just($author$project$Pages$Admin$CardExtract$InputtedClass),
											jO: A2(
												$elm$core$List$map,
												function (class_) {
													return {
														eX: _Utils_eq(model.cp, class_.cC),
														c3: class_.c3,
														di: class_.cC
													};
												},
												classes),
											jQ: false,
											ks: _List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'padding-top', '5px'),
													A2($elm$html$Html$Attributes$style, 'width', '250px'),
													A2($elm$html$Html$Attributes$style, 'margin-bottom', '1rem')
												]),
											kE: false,
											k1: _List_Nil
										})
									])),
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('self-center')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('action-system green-btn min-btn-with-icon '),
												$elm$html$Html$Attributes$disabled(disabledSubmit),
												$elm$html$Html$Attributes$type_('submit')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('material-symbols-outlined text-sm')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('search')
													])),
												$elm$html$Html$text('Pesquisar')
											]))
									])),
								function () {
								var _v2 = model.a9;
								if (_v2.$ === 3) {
									if (!_v2.a.b) {
										return $elm$html$Html$text('');
									} else {
										var rows = _v2.a;
										return $author$project$Components$GeneratorCSV$buttonDownload(
											$author$project$Pages$Admin$CardExtract$GetTimeToDownload(rows));
									}
								} else {
									return $elm$html$Html$text('');
								}
							}()
							])),
						$author$project$Pages$Admin$CardExtract$viewCheckBox(
						{
							ie: model.az,
							iH: !$krisajenkins$remotedata$RemoteData$isSuccess(model.a9),
							c3: 'Detalhes',
							jG: $author$project$Pages$Admin$CardExtract$ClickedDetails
						}),
						$author$project$Pages$Admin$CardExtract$viewCheckBox(
						{
							ie: model.b1,
							iH: !$krisajenkins$remotedata$RemoteData$isSuccess(model.a9),
							c3: 'Mostrar falhas',
							jG: $author$project$Pages$Admin$CardExtract$ClickedHideFails
						})
					])),
				function () {
				var _v3 = model.a9;
				switch (_v3.$) {
					case 0:
						var _v4 = model.cH;
						switch (_v4.$) {
							case 3:
								var card = _v4.a;
								return $elm$core$List$isEmpty(card.dv) ? $elm$html$Html$text('O cartão não tem nenhuma classe cadastrada.') : $elm$html$Html$text('Por favor, defina um período desejado ou utilize as datas padrão para realizar a busca.');
							case 0:
								return $author$project$Components$View$loading;
							case 1:
								return $author$project$Components$View$loading;
							default:
								var e = _v4.a;
								return $elm$html$Html$text('Ops! Algo deu errado');
						}
					case 1:
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-col items-center')
								]),
							_List_fromArray(
								[
									$author$project$Components$View$loading,
									$elm$html$Html$text('Pesquisando, aguarde…')
								]));
					case 2:
						var err = _v3.a;
						return $elm$html$Html$text(
							$author$project$Services$Api$errorToUserMessage(err));
					default:
						var transactions = _v3.a;
						var filteredTransactionsHideDetails = model.az ? transactions : A2(
							$elm$core$List$filter,
							function (_v6) {
								var description = _v6.z;
								return (!A2($elm$core$String$contains, 'Catraca liberada', description)) && (!A2($elm$core$String$contains, 'Catraca girada', description));
							},
							transactions);
						var filteredTransactionsHideError = model.b1 ? filteredTransactionsHideDetails : A2(
							$elm$core$List$filter,
							function (_v5) {
								var transactionError = _v5.bD;
								return !transactionError;
							},
							filteredTransactionsHideDetails);
						return $elm$core$List$isEmpty(filteredTransactionsHideError) ? $elm$html$Html$text('Nenhuma transação encontrada para os filtros selecionados.') : A3($author$project$Pages$Admin$CardExtract$viewTable, model.az, shared.kS, filteredTransactionsHideError);
				}
			}()
			]);
	});
var $author$project$Pages$Admin$CardExtract$viewPage = F3(
	function (model, shared, user) {
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard admin-reports')
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('top-actions')
							]),
						_List_fromArray(
							[
								A2($elm$html$Html$div, _List_Nil, _List_Nil),
								A2($elm$html$Html$div, _List_Nil, _List_Nil)
							]))
					]),
				A2($author$project$Pages$Admin$CardExtract$contentExtractCard, model, shared)));
	});
var $author$project$Pages$Admin$CardExtract$view = F3(
	function (model, shared, user) {
		return _Utils_Tuple3(
			'Extrato Cartão',
			A3($author$project$Pages$Admin$CardExtract$viewPage, model, shared, user),
			$elm$html$Html$text(''));
	});
var $author$project$Pages$Admin$Cards$GotSearch = {$: 2};
var $author$project$Pages$Admin$Cards$InputtedSearch = function (a) {
	return {$: 1, a: a};
};
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $elm$svg$Svg$Attributes$stroke = _VirtualDom_attribute('stroke');
var $elm$svg$Svg$Attributes$strokeWidth = _VirtualDom_attribute('stroke-width');
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $author$project$Svgs$chevron = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$width('24'),
			$elm$svg$Svg$Attributes$height('24'),
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$fill('none')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M7 2L17 12L7 22'),
					$elm$svg$Svg$Attributes$stroke('#6E46C8'),
					$elm$svg$Svg$Attributes$strokeWidth('2')
				]),
			_List_Nil)
		]));
var $author$project$Components$View$pagination = F4(
	function (toRoute, pageSize, maybePage, totalCount) {
		var totalPages = $elm$core$Basics$ceiling(totalCount / pageSize);
		var pageNumber = A2($elm$core$Maybe$withDefault, 1, maybePage);
		var previousPages = (pageNumber <= 5) ? A2($elm$core$List$range, 1, pageNumber - 1) : A2(
			$elm$core$List$cons,
			1,
			A2(
				$elm$core$List$cons,
				0,
				A2($elm$core$List$range, pageNumber - 2, pageNumber - 1)));
		var to = A2($elm$core$Basics$min, totalCount, pageNumber * pageSize);
		var viewArrowLink = function (isPrev) {
			var _v0 = isPrev ? _Utils_Tuple3(
				pageNumber === 1,
				pageNumber - 1,
				_Utils_Tuple2('página anterior', '<')) : _Utils_Tuple3(
				_Utils_cmp(pageNumber, totalPages) > -1,
				pageNumber + 1,
				_Utils_Tuple2('próxima página', '>'));
			var isHide = _v0.a;
			var pageNum = _v0.b;
			var _v1 = _v0.c;
			var descr = _v1.a;
			var arrow = _v1.b;
			return isHide ? $elm$html$Html$text('') : A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('arrow'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('prev', isPrev)
							])),
						$elm$html$Html$Attributes$title('Ir para ' + descr),
						$author$project$Route$href(
						toRoute(pageNum))
					]),
				_List_fromArray(
					[$author$project$Svgs$chevron]));
		};
		var viewPageNumberLink = function (pageNum) {
			return _Utils_Tuple2(
				'pagination-' + $elm$core$String$fromInt(pageNum),
				(!pageNum) ? A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('item')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('...')
						])) : (_Utils_eq(pageNum, pageNumber) ? A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('item')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(pageNum))
						])) : A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('item'),
							$elm$html$Html$Attributes$title(
							'Ir para página ' + $elm$core$String$fromInt(pageNum)),
							$author$project$Route$href(
							toRoute(pageNum))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(pageNum))
						]))));
		};
		var nextPages = ((totalPages - pageNumber) <= 4) ? A2($elm$core$List$range, pageNumber + 1, totalPages) : _Utils_ap(
			A2($elm$core$List$range, pageNumber + 1, pageNumber + 2),
			_List_fromArray(
				[0, totalPages]));
		var from = ((pageNumber - 1) * pageSize) + 1;
		return (totalPages <= 1) ? $elm$html$Html$text('') : A3(
			$elm$html$Html$Keyed$node,
			'div',
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pagination')
				]),
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'pagination-back',
					viewArrowLink(true)),
				_Utils_ap(
					A2(
						$elm$core$List$map,
						viewPageNumberLink,
						_Utils_ap(
							previousPages,
							_Utils_ap(
								_List_fromArray(
									[pageNumber]),
								nextPages))),
					_List_fromArray(
						[
							_Utils_Tuple2(
							'pagination-next',
							viewArrowLink(false))
						]))));
	});
var $author$project$Data$Passenger$blockStatusToStr = function (status) {
	switch (status) {
		case 0:
			return 'Bloqueado';
		case 1:
			return 'Desbloqueado';
		case 2:
			return 'Solicit. Bloqueio';
		default:
			return 'Solicit. Desbloqueio';
	}
};
var $author$project$Pages$Admin$Cards$viewRow = F2(
	function (shared, card) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(card.kw)
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(card.c3)
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Data$Passenger$blockStatusToStr(card.kK))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Utils$formatDateTimeFromPosix, shared.kS, card.mZ))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'padding', '8px 16px 8px 0px')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('action-system green-btn'),
									$author$project$Route$href(
									A2(
										$author$project$Route$Admin,
										$author$project$Route$CardExtract(card.dM),
										$author$project$Route$extractConcessionaireId(shared.pv))),
									A2($elm$html$Html$Attributes$style, 'margin-left', 'auto')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Ver Extrato')
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$Cards$viewTable = F4(
	function (shared, maybePage, cards, recordCount) {
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'cellspacing', '0'),
					$elm$html$Html$Attributes$class('data-table-dashboard'),
					A2($elm$html$Html$Attributes$style, 'margin-bottom', '10px')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$thead,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Nº Cartão')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Nome')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Status')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Emissão')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('')
										]))
								]))
						])),
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					A2(
						$elm$core$List$map,
						$author$project$Pages$Admin$Cards$viewRow(shared),
						cards))
				]));
	});
var $author$project$Pages$Admin$Cards$viewPage = F5(
	function (model, shared, maybePage, maybeSearch, user) {
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('top-actions')
						]),
					_List_fromArray(
						[
							A2($elm$html$Html$div, _List_Nil, _List_Nil),
							A2($elm$html$Html$div, _List_Nil, _List_Nil)
						])),
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'color', 'black'),
							$elm$html$Html$Attributes$class('inner-center')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Cartões')
						])),
					A2(
					$elm$html$Html$form,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('filtros-container items-baseline'),
							$elm$html$Html$Events$onSubmit($author$project$Pages$Admin$Cards$GotSearch)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('bg-busca'),
											$elm$html$Html$Attributes$placeholder('Buscar'),
											$elm$html$Html$Attributes$type_('text'),
											$elm$html$Html$Attributes$value(model.fq),
											$elm$html$Html$Events$onInput($author$project$Pages$Admin$Cards$InputtedSearch)
										]),
									_List_Nil)
								])),
							A2(
							$author$project$Components$View$searchButton,
							'',
							!$krisajenkins$remotedata$RemoteData$isSuccess(model.f0))
						])),
					function () {
					var _v0 = model.f0;
					switch (_v0.$) {
						case 0:
							return $elm$html$Html$text('');
						case 1:
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[$author$project$Components$View$loading]));
						case 2:
							var err = _v0.a;
							return $elm$html$Html$text(
								$author$project$Services$Api$errorToUserMessage(err));
						default:
							if ((!_v0.a.a.b) && (!_v0.a.b)) {
								var _v1 = _v0.a;
								if (maybeSearch.$ === 1) {
									return $elm$html$Html$text('Nenhum cartão encontrado.');
								} else {
									var search = maybeSearch.a;
									return $elm$html$Html$text('Nenhum cartão encontrado contendo o termo \"' + (search + '\".'));
								}
							} else {
								var _v3 = _v0.a;
								var cards = _v3.a;
								var recordCount = _v3.b;
								return A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A4($author$project$Pages$Admin$Cards$viewTable, shared, maybePage, cards, recordCount),
											A4(
											$author$project$Components$View$pagination,
											function (p) {
												return A2(
													$author$project$Route$Admin,
													A2(
														$author$project$Route$Cards,
														$elm$core$Maybe$Just(p),
														maybeSearch),
													$author$project$Route$extractConcessionaireId(shared.pv));
											},
											$author$project$Pages$Admin$Cards$cardsPerPage,
											maybePage,
											recordCount)
										]));
							}
					}
				}()
				]));
	});
var $author$project$Pages$Admin$Cards$view = F5(
	function (model, shared, maybePage, maybeSearch, user) {
		return _Utils_Tuple3(
			A2(
				$elm$core$String$join,
				'',
				_List_fromArray(
					[
						'Cartões',
						A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$String$fromInt,
								$elm$core$Basics$append(' página ')),
							maybePage))
					])),
			A5($author$project$Pages$Admin$Cards$viewPage, model, shared, maybePage, maybeSearch, user),
			$elm$html$Html$text(''));
	});
var $author$project$Pages$Admin$CompanyOrders$ClickedCloseModal = {$: 12};
var $author$project$Components$Patterns$Modal$simple = function (options) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal-overlay')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('modal-container modal-dashboard rounded-2xl mb-[40px]' + options.ii),
						A2(
						$elm$core$Maybe$withDefault,
						$elm$html$Html$Attributes$class(''),
						options.hY)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('header-modal')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h3,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(options.il + ' mx-4')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(options.fD)
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('action-header absolute'),
										$elm$html$Html$Events$onClick(options.ip)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('fechar-ico')
											]),
										_List_Nil)
									]))
							])),
						options.k4,
						options.k5
					]))
			]));
};
var $author$project$Pages$Admin$CompanyOrders$SubmittedConfirmReversal = {$: 18};
var $author$project$Pages$Admin$CompanyOrders$viewConfirmReversal = function (model) {
	var viewFooter = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex gap-4 w-full  flex-col-reverse ')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('action-system white-btn w-full m-0'),
						A2($elm$html$Html$Attributes$style, 'box-shadow', '0px 0px 10px rgba(0, 0, 0, 0.25)'),
						$elm$html$Html$Events$onClick($author$project$Pages$Admin$CompanyOrders$ClickedCloseModal)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Fechar')
					])),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('action-system green-btn w-full'),
						$elm$html$Html$Events$onClick($author$project$Pages$Admin$CompanyOrders$SubmittedConfirmReversal)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Confirmar')
					]))
			]));
	var value = $author$project$Utils$formatAsMoney(
		$elm$core$String$fromInt(model.di));
	var viewBody = A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('font-medium text-lg ')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Você está prestes a realizar o estorno do valor de '),
						A2(
						$elm$html$Html$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(value)
							])),
						$elm$html$Html$text('. Esta ação não poderá ser desfeita. Se você tem certeza, clique em \"Confirmar\". Caso contrário, clique em \"Cancelar\".')
					]))
			]));
	return _Utils_Tuple2(viewBody, viewFooter);
};
var $author$project$Pages$Admin$CompanyOrders$ClickedConfirmSaveOrder = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Admin$CompanyOrders$viewConfirmSaveOrder = function (orderID) {
	var viewFooter = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex gap-4 w-full  flex-col ')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('action-system green-btn w-full'),
						$elm$html$Html$Events$onClick(
						$author$project$Pages$Admin$CompanyOrders$ClickedConfirmSaveOrder(orderID))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Confirmar')
					])),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('action-system white-btn w-full m-0'),
						$elm$html$Html$Events$onClick($author$project$Pages$Admin$CompanyOrders$ClickedCloseModal)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Fechar')
					]))
			]));
	var viewBody = A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('font-medium text-lg ')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Você está prestes a salvar esse pedido.'),
						$elm$html$Html$text(' Clique em \"Confirmar\". Caso contrário, clique em \"Cancelar\".')
					]))
			]));
	return _Utils_Tuple2(viewBody, viewFooter);
};
var $author$project$Pages$Admin$CompanyOrders$InputtedEditEmail = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Admin$CompanyOrders$SubmittedNewEmail = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$Components$Patterns$Forms$input = function (options) {
	return A2(
		$elm$html$Html$input,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class(options.ih),
				A2($elm$html$Html$Attributes$style, 'margin-bottom', '1rem'),
				$elm$html$Html$Attributes$placeholder(options.hh),
				$elm$html$Html$Attributes$type_(options.kY),
				$elm$html$Html$Events$onInput(options.jI),
				$elm$html$Html$Attributes$value(options.di)
			]),
		_List_Nil);
};
var $author$project$Pages$Admin$CompanyOrders$viewEditEmail = function (modal) {
	var viewFooter = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex gap-4 w-full flex-col-reverse')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('action-system white-btn w-full m-0'),
						A2($elm$html$Html$Attributes$style, 'box-shadow', '0px 0px 10px rgba(0, 0, 0, 0.25)'),
						$elm$html$Html$Events$onClick($author$project$Pages$Admin$CompanyOrders$ClickedCloseModal)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Fechar')
					])),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('action-system green-btn w-full'),
						$elm$html$Html$Events$onClick(
						A2($author$project$Pages$Admin$CompanyOrders$SubmittedNewEmail, modal.f5.qw, modal.mX))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Confirmar')
					]))
			]));
	var viewBody = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('w-full px-20 ')
			]),
		_List_fromArray(
			[
				$author$project$Components$Patterns$Forms$input(
				{ih: 'text-center', jI: $author$project$Pages$Admin$CompanyOrders$InputtedEditEmail, hh: 'E-Mail', kY: 'email', di: modal.mX})
			]));
	return _Utils_Tuple2(viewBody, viewFooter);
};
var $author$project$Components$Patterns$Forms$Custom = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Patterns$Forms$Html = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Patterns$Forms$Input = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$CompanyOrders$InputtedISS = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Patterns$Forms$Slider = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Admin$CompanyOrders$SubmittedISSDiscount = {$: 19};
var $author$project$Components$Patterns$Forms$buttonIconInput = F6(
	function (clickedMsg, disabled, title, code, formStatus, attr) {
		var classSubmitting = function () {
			if (formStatus === 2) {
				return 'bg-purple-main cursor-wait';
			} else {
				return 'green-btn ';
			}
		}();
		return A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('w-auto content-center')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_Utils_ap(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('action-system green-btn min-btn-with-icon ' + classSubmitting),
								A2($elm$html$Html$Attributes$style, 'width', 'auto'),
								$elm$html$Html$Attributes$title(title),
								$elm$html$Html$Attributes$type_('button'),
								$elm$html$Html$Events$onClick(clickedMsg),
								$elm$html$Html$Attributes$disabled(disabled)
							]),
						attr),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('material-symbols-outlined align-middle ')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(code)
								]))
						]))
				]));
	});
var $author$project$Components$View$loadingForButton = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('loading-container m-0 flex flex-row justify-center gap-4')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('loading-small')
				]),
			_List_Nil),
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('loading-txt m-0')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Carregando...')
				]))
		]));
var $author$project$Components$Patterns$Forms$buttonInput = F5(
	function (clickedMsg, disabled, title, formStatus, attr) {
		var classSubmitting = function () {
			if (formStatus === 2) {
				return 'bg-purple-main cursor-wait';
			} else {
				return 'green-btn ';
			}
		}();
		return A2(
			$elm$html$Html$button,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('m-0 action-system ' + classSubmitting),
						$elm$html$Html$Attributes$disabled(disabled),
						$elm$html$Html$Attributes$type_('button'),
						$elm$html$Html$Events$onClick(clickedMsg)
					]),
				attr),
			_List_fromArray(
				[
					function () {
					if (formStatus === 2) {
						return $author$project$Components$View$loadingForButton;
					} else {
						return $elm$html$Html$text(title);
					}
				}()
				]));
	});
var $author$project$Components$Patterns$Forms$buttonSubmit = F4(
	function (disabled, title, formStatus, attr) {
		var classSubmitting = function () {
			if (formStatus === 2) {
				return 'bg-purple-main cursor-wait';
			} else {
				return 'green-btn ';
			}
		}();
		return A2(
			$elm$html$Html$button,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('m-0 action-system ' + classSubmitting),
						$elm$html$Html$Attributes$disabled(disabled),
						$elm$html$Html$Attributes$type_('submit')
					]),
				attr),
			_List_fromArray(
				[
					function () {
					if (formStatus === 2) {
						return $author$project$Components$View$loadingForButton;
					} else {
						return $elm$html$Html$text(title);
					}
				}()
				]));
	});
var $author$project$Components$Patterns$Forms$getErrors = F2(
	function (maybeValidators, value) {
		return A2(
			$elm$core$List$filterMap,
			function (_v0) {
				var validator = _v0.a;
				var message = _v0.b;
				return validator(value) ? $elm$core$Maybe$Just(message) : $elm$core$Maybe$Nothing;
			},
			maybeValidators);
	});
var $author$project$Components$Patterns$Forms$limitChars = function (maybeMaxCharacters) {
	if (!maybeMaxCharacters.$) {
		var maxCharacters = maybeMaxCharacters.a;
		return $elm$core$String$left(maxCharacters);
	} else {
		return $elm$core$Basics$identity;
	}
};
var $elm$html$Html$Attributes$name = $elm$html$Html$Attributes$stringProperty('name');
var $elm$html$Html$Events$onBlur = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'blur',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$targetChecked = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'checked']),
	$elm$json$Json$Decode$bool);
var $elm$html$Html$Events$onCheck = function (tagger) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetChecked));
};
var $elm$html$Html$Events$keyCode = A2($elm$json$Json$Decode$field, 'keyCode', $elm$json$Json$Decode$int);
var $elm_community$html_extra$Html$Events$Extra$onEnter = function (onEnterAction) {
	return A2(
		$elm$html$Html$Events$on,
		'keyup',
		A2(
			$elm$json$Json$Decode$andThen,
			function (keyCode) {
				return (keyCode === 13) ? $elm$json$Json$Decode$succeed(onEnterAction) : $elm$json$Json$Decode$fail(
					$elm$core$String$fromInt(keyCode));
			},
			$elm$html$Html$Events$keyCode));
};
var $author$project$Components$Patterns$Forms$inputPasswordWithError = function (opts) {
	var type__ = opts.dY ? 'text' : 'password';
	var errors = F2(
		function (validators, value) {
			return A2($author$project$Components$Patterns$Forms$getErrors, validators, value);
		});
	var hasError = F3(
		function (validators, value, showError) {
			return showError && (!$elm$core$List$isEmpty(
				A2(errors, validators, value)));
		});
	return A2(
		$elm$html$Html$label,
		A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'input-error',
						A3(hasError, opts.k1, opts.di, opts.kE)),
						_Utils_Tuple2('m-0', true)
					])),
			opts.jn),
		_List_fromArray(
			[
				function () {
				var _v0 = opts.jl;
				if (!_v0.$) {
					var label = _v0.a;
					return A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('font-semibold text-purple-main')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(label)
							]));
				} else {
					return $elm$html$Html$text('');
				}
			}(),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex justify-end')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-purple-main pointer absolute material-symbols-outlined pl-2 pr-2 align-middle '),
								$elm$html$Html$Events$onClick(opts.jH)
							]),
						_List_fromArray(
							[
								opts.dY ? $elm$html$Html$text('visibility_off') : $elm$html$Html$text('visibility')
							])),
						A2(
						$elm$html$Html$input,
						_Utils_ap(
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('border-purple-main text-black m-0 mt-2'),
									$elm$html$Html$Attributes$value(opts.di),
									$elm$html$Html$Attributes$type_(type__),
									$elm$html$Html$Attributes$disabled(opts.iH),
									$elm$html$Html$Attributes$placeholder(opts.hh),
									$elm$html$Html$Attributes$name(opts.c3),
									function () {
									var _v1 = opts.jI;
									if (!_v1.$) {
										var onInputMsg = _v1.a;
										return $elm$html$Html$Events$onInput(
											A2(
												$elm$core$Basics$composeR,
												$author$project$Components$Patterns$Forms$limitChars(opts.n9),
												onInputMsg));
									} else {
										return $elm$html$Html$Attributes$class('');
									}
								}(),
									function () {
									var _v2 = opts.ov;
									if (!_v2.$) {
										var onEnterMsg = _v2.a;
										return $elm_community$html_extra$Html$Events$Extra$onEnter(onEnterMsg);
									} else {
										return $elm$html$Html$Attributes$class('');
									}
								}(),
									function () {
									var _v3 = opts.jF;
									if (!_v3.$) {
										var onCheckMsg = _v3.a;
										return $elm$html$Html$Events$onCheck(onCheckMsg);
									} else {
										return $elm$html$Html$Attributes$class('');
									}
								}(),
									function () {
									var _v4 = opts.jG;
									if (!_v4.$) {
										var onClickMsg = _v4.a;
										return $elm$html$Html$Events$onClick(onClickMsg);
									} else {
										return $elm$html$Html$Attributes$class('');
									}
								}(),
									function () {
									var _v5 = opts.jE;
									if (!_v5.$) {
										var onBlurMsg = _v5.a;
										return $elm$html$Html$Events$onBlur(onBlurMsg);
									} else {
										return $elm$html$Html$Attributes$class('');
									}
								}(),
									function () {
									var _v6 = opts.ie;
									if (!_v6.$) {
										var checkedValue = _v6.a;
										return $elm$html$Html$Attributes$checked(checkedValue);
									} else {
										return $elm$html$Html$Attributes$class('');
									}
								}()
								]),
							opts.nR),
						_List_Nil)
					])),
				A2(
				$author$project$Components$Patterns$Forms$viewErrors,
				A3(hasError, opts.k1, opts.di, opts.kE),
				A2(errors, opts.k1, opts.di))
			]));
};
var $elm$html$Html$Attributes$size = function (n) {
	return A2(
		_VirtualDom_attribute,
		'size',
		$elm$core$String$fromInt(n));
};
var $author$project$Components$Patterns$Forms$inputWithError = function (opts) {
	var errors = F2(
		function (validators, value) {
			return A2($author$project$Components$Patterns$Forms$getErrors, validators, value);
		});
	var hasError = F3(
		function (validators, value, showError) {
			return showError && (!$elm$core$List$isEmpty(
				A2(errors, validators, value)));
		});
	return A2(
		$elm$html$Html$label,
		A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'input-error',
						A3(hasError, opts.k1, opts.di, opts.kE)),
						_Utils_Tuple2('m-0', true)
					])),
			opts.jn),
		_List_fromArray(
			[
				function () {
				var _v0 = opts.jl;
				if (!_v0.$) {
					var label = _v0.a;
					return A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('font-semibold text-purple-main')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(label)
							]));
				} else {
					return $elm$html$Html$text('');
				}
			}(),
				A2(
				$elm$html$Html$input,
				_Utils_ap(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('border-purple-main text-black m-0 mt-2'),
							$elm$html$Html$Attributes$value(opts.di),
							$elm$html$Html$Attributes$type_(opts.kY),
							$elm$html$Html$Attributes$disabled(opts.iH),
							$elm$html$Html$Attributes$placeholder(opts.hh),
							$elm$html$Html$Attributes$name(opts.c3),
							A2(
							$elm$core$Maybe$withDefault,
							$elm$html$Html$Attributes$class(''),
							A2($elm$core$Maybe$map, $elm$html$Html$Attributes$size, opts.n9)),
							function () {
							var _v1 = opts.jI;
							if (!_v1.$) {
								var onInputMsg = _v1.a;
								return $elm$html$Html$Events$onInput(
									A2(
										$elm$core$Basics$composeR,
										$author$project$Components$Patterns$Forms$limitChars(opts.n9),
										onInputMsg));
							} else {
								return $elm$html$Html$Attributes$class('');
							}
						}(),
							function () {
							var _v2 = opts.ov;
							if (!_v2.$) {
								var onEnterMsg = _v2.a;
								return $elm_community$html_extra$Html$Events$Extra$onEnter(onEnterMsg);
							} else {
								return $elm$html$Html$Attributes$class('');
							}
						}(),
							function () {
							var _v3 = opts.jF;
							if (!_v3.$) {
								var onCheckMsg = _v3.a;
								return $elm$html$Html$Events$onCheck(onCheckMsg);
							} else {
								return $elm$html$Html$Attributes$class('');
							}
						}(),
							function () {
							var _v4 = opts.jG;
							if (!_v4.$) {
								var onClickMsg = _v4.a;
								return $elm$html$Html$Events$onClick(onClickMsg);
							} else {
								return $elm$html$Html$Attributes$class('');
							}
						}(),
							function () {
							var _v5 = opts.jE;
							if (!_v5.$) {
								var onBlurMsg = _v5.a;
								return $elm$html$Html$Events$onBlur(onBlurMsg);
							} else {
								return $elm$html$Html$Attributes$class('');
							}
						}(),
							function () {
							var _v6 = opts.ie;
							if (!_v6.$) {
								var checkedValue = _v6.a;
								return $elm$html$Html$Attributes$checked(checkedValue);
							} else {
								return $elm$html$Html$Attributes$class('');
							}
						}()
						]),
					opts.nR),
				_List_Nil),
				A2(
				$author$project$Components$Patterns$Forms$viewErrors,
				A3(hasError, opts.k1, opts.di, opts.kE),
				A2(errors, opts.k1, opts.di)),
				A2($elm$html$Html$div, _List_Nil, opts.iP)
			]));
};
var $elm$html$Html$Attributes$max = $elm$html$Html$Attributes$stringProperty('max');
var $elm$html$Html$Attributes$min = $elm$html$Html$Attributes$stringProperty('min');
var $elm$html$Html$Attributes$step = function (n) {
	return A2($elm$html$Html$Attributes$stringProperty, 'step', n);
};
var $author$project$Components$Patterns$Forms$slider = function (opts) {
	var errors = F2(
		function (validators, value) {
			return A2($author$project$Components$Patterns$Forms$getErrors, validators, value);
		});
	var hasError = F3(
		function (validators, value, showError) {
			return showError && (!$elm$core$List$isEmpty(
				A2(errors, validators, value)));
		});
	return A2(
		$elm$html$Html$label,
		A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'input-error',
						A3(hasError, opts.k1, opts.di, opts.kE)),
						_Utils_Tuple2('m-0', true)
					])),
			opts.jn),
		_List_fromArray(
			[
				function () {
				var _v0 = opts.jl;
				if (!_v0.$) {
					var label = _v0.a;
					return A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('font-semibold text-purple-main')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(label)
							]));
				} else {
					return $elm$html$Html$text('');
				}
			}(),
				A2(
				$elm$html$Html$input,
				_Utils_ap(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ui-slider border-purple-main text-black m-0 mt-2'),
							$elm$html$Html$Attributes$value(opts.di),
							$elm$html$Html$Attributes$type_('range'),
							$elm$html$Html$Attributes$disabled(opts.iH),
							$elm$html$Html$Attributes$name(opts.c3),
							function () {
							var _v1 = opts.jI;
							if (!_v1.$) {
								var onInputMsg = _v1.a;
								return $elm$html$Html$Events$onInput(onInputMsg);
							} else {
								return $elm$html$Html$Attributes$class('');
							}
						}(),
							$elm$html$Html$Attributes$min(opts.e4),
							$elm$html$Html$Attributes$max(opts.d$),
							$elm$html$Html$Attributes$step(opts.hG)
						]),
					opts.nR),
				_List_Nil),
				A2(
				$author$project$Components$Patterns$Forms$viewErrors,
				A3(hasError, opts.k1, opts.di, opts.kE),
				A2(errors, opts.k1, opts.di))
			]));
};
var $author$project$Components$Patterns$Forms$sliderWithInput = function (opts) {
	var errors = F2(
		function (validators, value) {
			return A2($author$project$Components$Patterns$Forms$getErrors, validators, value);
		});
	var hasError = F3(
		function (validators, value, showError) {
			return showError && (!$elm$core$List$isEmpty(
				A2(errors, validators, value)));
		});
	return A2(
		$elm$html$Html$label,
		A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'input-error',
						A3(hasError, opts.k1, opts.di, opts.kE)),
						_Utils_Tuple2('m-0', true)
					])),
			opts.jn),
		_List_fromArray(
			[
				function () {
				var _v0 = opts.jl;
				if (!_v0.$) {
					var label = _v0.a;
					return A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('font-semibold text-purple-main')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(label)
							]));
				} else {
					return $elm$html$Html$text('');
				}
			}(),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex gap-2 items-center')
					]),
				_List_fromArray(
					[
						$author$project$Components$Patterns$Forms$inputWithError(
						{
							ie: $elm$core$Maybe$Nothing,
							iH: opts.iH,
							iP: _List_Nil,
							nR: _List_fromArray(
								[
									$elm$html$Html$Attributes$max(opts.d$),
									$elm$html$Html$Attributes$min(opts.e4),
									$elm$html$Html$Attributes$size(
									1 + A2(
										$elm$core$Maybe$withDefault,
										0,
										$elm$core$String$toInt(opts.d$))),
									$elm$html$Html$Attributes$class('remove-btn-increment-and-decrement')
								]),
							jl: $elm$core$Maybe$Nothing,
							jn: _List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'width', 'max-content')
								]),
							n9: $elm$core$Maybe$Nothing,
							c3: opts.c3,
							jE: $elm$core$Maybe$Nothing,
							jF: $elm$core$Maybe$Nothing,
							jG: $elm$core$Maybe$Nothing,
							ov: $elm$core$Maybe$Nothing,
							jI: opts.jI,
							hh: '',
							kE: false,
							kY: 'number',
							k1: _List_Nil,
							di: opts.di
						}),
						A2(
						$elm$html$Html$input,
						_Utils_ap(
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ui-slider border-purple-main text-black m-0 mt-2'),
									$elm$html$Html$Attributes$type_('range'),
									$elm$html$Html$Attributes$disabled(opts.iH),
									$elm$html$Html$Attributes$name(opts.c3),
									function () {
									var _v1 = opts.jI;
									if (!_v1.$) {
										var onInputMsg = _v1.a;
										return $elm$html$Html$Events$onInput(onInputMsg);
									} else {
										return $elm$html$Html$Attributes$class('');
									}
								}(),
									$elm$html$Html$Attributes$min(opts.e4),
									$elm$html$Html$Attributes$max(opts.d$),
									$elm$html$Html$Attributes$step(opts.hG),
									A2($elm$html$Html$Attributes$attribute, 'value', opts.di)
								]),
							opts.nR),
						_List_Nil)
					])),
				A2(
				$author$project$Components$Patterns$Forms$viewErrors,
				A3(hasError, opts.k1, opts.di, opts.kE),
				A2(errors, opts.k1, opts.di))
			]));
};
var $elm$html$Html$Attributes$cols = function (n) {
	return A2(
		_VirtualDom_attribute,
		'cols',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$em = _VirtualDom_node('em');
var $elm$html$Html$Attributes$rows = function (n) {
	return A2(
		_VirtualDom_attribute,
		'rows',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$textarea = _VirtualDom_node('textarea');
var $author$project$Components$Patterns$Forms$textAreaWithError = function (opts) {
	var toString = function (_int) {
		return $elm$core$String$fromInt(_int);
	};
	var toLength = function (str) {
		return $elm$core$String$length(str);
	};
	var errors = F2(
		function (validators, value) {
			return A2($author$project$Components$Patterns$Forms$getErrors, validators, value);
		});
	var hasError = F3(
		function (validators, value, showError) {
			return showError && (!$elm$core$List$isEmpty(
				A2(errors, validators, value)));
		});
	return A2(
		$elm$html$Html$label,
		A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'input-error',
						A3(hasError, opts.k1, opts.di, opts.kE)),
						_Utils_Tuple2('m-0', true)
					])),
			opts.jn),
		_List_fromArray(
			[
				function () {
				var _v0 = opts.jl;
				if (!_v0.$) {
					var label = _v0.a;
					return A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('font-semibold text-purple-main')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(label)
							]));
				} else {
					return $elm$html$Html$text('');
				}
			}(),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex flex-col gap-1 items-end')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$textarea,
						_Utils_ap(
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('border-purple-main text-black m-0 mt-2'),
									$elm$html$Html$Attributes$value(opts.di),
									A2(
									$elm$core$Maybe$withDefault,
									$elm$html$Html$Attributes$class(''),
									A2($elm$core$Maybe$map, $elm$html$Html$Attributes$rows, opts.px)),
									A2(
									$elm$core$Maybe$withDefault,
									$elm$html$Html$Attributes$class(''),
									A2($elm$core$Maybe$map, $elm$html$Html$Attributes$cols, opts.l6)),
									$elm$html$Html$Attributes$disabled(opts.iH),
									$elm$html$Html$Attributes$placeholder(opts.hh),
									$elm$html$Html$Attributes$name(opts.c3),
									function () {
									var _v1 = opts.jI;
									if (!_v1.$) {
										var onInputMsg = _v1.a;
										return $elm$html$Html$Events$onInput(
											A2(
												$elm$core$Basics$composeR,
												$author$project$Components$Patterns$Forms$limitChars(opts.n9),
												onInputMsg));
									} else {
										return $elm$html$Html$Attributes$class('');
									}
								}(),
									function () {
									var _v2 = opts.ov;
									if (!_v2.$) {
										var onEnterMsg = _v2.a;
										return $elm_community$html_extra$Html$Events$Extra$onEnter(onEnterMsg);
									} else {
										return $elm$html$Html$Attributes$class('');
									}
								}()
								]),
							opts.nR),
						_List_Nil),
						A2(
						$elm$core$Maybe$withDefault,
						$elm$html$Html$text(''),
						A2(
							$elm$core$Maybe$map,
							function (chars) {
								return A2(
									$elm$html$Html$em,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-purple-main text-sm')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											toString(
												toLength(opts.di)) + ('/' + toString(chars)))
										]));
							},
							opts.n9))
					])),
				A2(
				$author$project$Components$Patterns$Forms$viewErrors,
				A3(hasError, opts.k1, opts.di, opts.kE),
				A2(errors, opts.k1, opts.di))
			]));
};
var $elm$html$Html$Attributes$maxlength = function (n) {
	return A2(
		_VirtualDom_attribute,
		'maxlength',
		$elm$core$String$fromInt(n));
};
var $author$project$Components$Patterns$Input$Color$viewErrors = F2(
	function (showError, errors) {
		return showError ? A2(
			$elm$html$Html$ul,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (error) {
					return A2(
						$elm$html$Html$li,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-secondary-error')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(error)
									]))
							]));
				},
				errors)) : $elm$html$Html$text('');
	});
var $author$project$Components$Patterns$Input$Color$view = function (opts) {
	var value_ = function (onInput_) {
		return $elm$core$String$toLower(
			'#' + A2(
				$elm$core$String$filter,
				$elm$core$Basics$neq('#'),
				onInput_));
	};
	var currentErrors = A2(
		$elm$core$List$filterMap,
		function (_v0) {
			var isInvalid = _v0.a;
			var errorName = _v0.b;
			return isInvalid ? $elm$core$Maybe$Just(errorName) : $elm$core$Maybe$Nothing;
		},
		opts.k1);
	var showError = opts.kE && (!$elm$core$List$isEmpty(currentErrors));
	var classBorder = showError ? A2($elm$html$Html$Attributes$style, 'border-bottom', '1px solid  #F48080FF') : A2($elm$html$Html$Attributes$style, 'border-bottom', '1px solid #6e46c8');
	return A2(
		$elm$html$Html$label,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('m-0'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('input-error', showError)
						]))
				]),
			opts.jn),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-purple-main')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(opts.jl)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex gap-4 p-2'),
						A2($elm$html$Html$Attributes$style, 'width', 'fit-content'),
						classBorder
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('text'),
								$elm$html$Html$Attributes$class('border-purple-main m-0 remove-border'),
								A2($elm$html$Html$Attributes$style, 'border', 'none'),
								A2($elm$html$Html$Attributes$style, 'width', 'fit-content'),
								$elm$html$Html$Attributes$size(7),
								$elm$html$Html$Attributes$maxlength(7),
								$elm$html$Html$Attributes$value(opts.gz),
								A2(
								$elm$core$Maybe$withDefault,
								$elm$html$Html$Attributes$class(''),
								A2(
									$elm$core$Maybe$map,
									function (msg_) {
										return $elm$html$Html$Events$onInput(
											A2($elm$core$Basics$composeL, msg_, value_));
									},
									opts.jI)),
								$elm$html$Html$Attributes$disabled(opts.iH)
							]),
						_List_Nil),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('color'),
								$elm$html$Html$Attributes$class('input-color'),
								$elm$html$Html$Attributes$value(opts.gz),
								A2(
								$elm$core$Maybe$withDefault,
								$elm$html$Html$Attributes$class(''),
								A2($elm$core$Maybe$map, $elm$html$Html$Events$onInput, opts.jI)),
								$elm$html$Html$Attributes$disabled(opts.iH)
							]),
						_List_Nil)
					])),
				A2($author$project$Components$Patterns$Input$Color$viewErrors, opts.kE, currentErrors)
			]));
};
var $elm$html$Html$details = _VirtualDom_node('details');
var $elm$html$Html$summary = _VirtualDom_node('summary');
var $author$project$Components$Patterns$MultiSelect$viewCheckbox = F4(
	function (value, checked, title, msg) {
		return A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('c-custom m-0 pl-6 flex items-center text-gray-shade')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('checkbox'),
							$elm$html$Html$Attributes$name('fc'),
							$elm$html$Html$Attributes$value(value),
							$elm$html$Html$Attributes$checked(checked),
							$elm$html$Html$Events$onClick(
							msg(value))
						]),
					_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('checkmark'),
							A2($elm$html$Html$Attributes$style, 'margin-top', '3px')
						]),
					_List_Nil),
					$elm$html$Html$text(title)
				]));
	});
var $author$project$Components$Patterns$MultiSelect$view = function (opts) {
	var isOpenAttr = opts.gO ? A2($elm$html$Html$Attributes$attribute, 'open', '') : A2($elm$html$Html$Attributes$attribute, 'close', '');
	var getOptionAll = A2(
		$elm$core$List$filter,
		function (_v2) {
			var k = _v2.a;
			return k === '';
		},
		opts.jO);
	var optionsOrder = opts.fT ? A2(
		$elm$core$List$append,
		getOptionAll,
		A2(
			$elm$core$List$sortBy,
			A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $elm$core$String$toLower),
			A2(
				$elm$core$List$filter,
				function (_v1) {
					var k = _v1.a;
					return k !== '';
				},
				opts.jO))) : opts.jO;
	return A2(
		$elm$html$Html$label,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('multi-select flex flex-col')
				]),
			opts.h$),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-purple-main')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(opts.jl)
					])),
				A2(
				$elm$html$Html$details,
				_List_fromArray(
					[isOpenAttr]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$summary,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(opts.g2),
								$elm$html$Html$Attributes$id(opts.eS)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(opts.hh)
							])),
						A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex flex-col gap-2'),
								$elm$html$Html$Attributes$id(opts.kt)
							]),
						A2(
							$elm$core$List$map,
							function (_v0) {
								var k = _v0.a;
								var v = _v0.b;
								return A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A4(
											$author$project$Components$Patterns$MultiSelect$viewCheckbox,
											k,
											A2(
												$elm$core$List$any,
												$elm$core$Basics$eq(k),
												opts.g7),
											v,
											opts.ot)
										]));
							},
							optionsOrder))
					]))
			]));
};
var $author$project$Components$Patterns$Forms$viewCheckBox = function (options) {
	return A2(
		$elm$html$Html$label,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('c-custom m-0 pl-6')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('checkbox'),
						$elm$html$Html$Events$onClick(options.jG),
						$elm$html$Html$Attributes$checked(options.ie),
						$elm$html$Html$Attributes$disabled(options.iH)
					]),
				_List_Nil),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('checkmark')
					]),
				_List_Nil),
				$elm$html$Html$text(options.c3)
			]));
};
var $elm$html$Html$Attributes$for = $elm$html$Html$Attributes$stringProperty('htmlFor');
var $author$project$Components$Patterns$Forms$viewRadio = function (config) {
	return A2(
		$elm$html$Html$article,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_Utils_ap(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col gap-1.5')
						]),
					config.jm),
				_List_fromArray(
					[
						function () {
						var _v0 = config.fD;
						if (!_v0.$) {
							var label = _v0.a;
							return A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('font-semibold text-purple-main mb-2')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(label)
									]));
						} else {
							return $elm$html$Html$text('');
						}
					}(),
						A2(
						$elm$html$Html$div,
						config.jP,
						A2(
							$elm$core$List$map,
							function (opt) {
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-black flex mt-0 relative modal-comprar-creditos p-0')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class(''),
													$elm$html$Html$Attributes$type_('radio'),
													$elm$html$Html$Attributes$value(opt.dM),
													$elm$html$Html$Attributes$name('class-type-' + config.i5),
													$elm$html$Html$Attributes$id(opt.dM),
													$elm$html$Html$Attributes$checked(opt.ie),
													$elm$html$Html$Events$onInput(config.jG)
												]),
											_List_Nil),
											A2(
											$elm$html$Html$label,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$for(opt.dM),
													$elm$html$Html$Attributes$class('text-black m-0 pl-5')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$em,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('pl-2')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(opt.c3)
														]))
												]))
										]));
							},
							config.jO))
					]))
			]));
};
var $author$project$Components$Patterns$Forms$formSimple = function (_v0) {
	var inputs = _v0.jf;
	var maybeSubmit = _v0.oc;
	var submitName = _v0.pX;
	var formStatus = _v0.L;
	var attrForm = _v0.hZ;
	var submitMsg = A2(
		$elm$core$Maybe$withDefault,
		$elm$html$Html$Attributes$class(''),
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.l_;
				},
				$elm$html$Html$Events$onSubmit),
			maybeSubmit));
	var formInputToInputWithLabel = F2(
		function (onEnter, inputStatus) {
			switch (inputStatus.$) {
				case 1:
					var opts = inputStatus.a;
					return $author$project$Components$Patterns$Forms$inputWithError(
						_Utils_update(
							opts,
							{ov: onEnter}));
				case 2:
					var opts = inputStatus.a;
					return $author$project$Components$Patterns$Forms$inputPasswordWithError(
						_Utils_update(
							opts,
							{ov: onEnter}));
				case 3:
					var opts = inputStatus.a;
					return $author$project$Components$Patterns$Forms$textAreaWithError(
						_Utils_update(
							opts,
							{ov: onEnter}));
				case 4:
					var opts = inputStatus.a;
					return $author$project$Components$Patterns$Forms$selectWithError(opts);
				case 5:
					var opts = inputStatus.a;
					return $author$project$Components$Patterns$MultiSelect$view(
						{h$: opts.h$, fT: opts.fT, eS: opts.eS, gO: opts.gO, jl: opts.jl, ot: opts.jI, g2: opts.g2, jO: opts.jO, g7: opts.g7, hh: opts.hh, kt: opts.eS});
				case 6:
					var opts = inputStatus.a;
					return A2(
						$elm$html$Html$article,
						_Utils_ap(
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('checkbox-line-container flex gap-4')
								]),
							opts.h0),
						A2($elm$core$List$map, $author$project$Components$Patterns$Forms$viewCheckBox, opts.jk));
				case 7:
					var config = inputStatus.a;
					return $author$project$Components$Patterns$Forms$viewRadio(config);
				case 8:
					var opts = inputStatus.a;
					return $author$project$Components$Patterns$Input$Color$view(opts);
				case 9:
					var options = inputStatus.a;
					return A5($author$project$Components$Patterns$Forms$buttonInput, options.l_, options.iH, options.fD, formStatus, options.lx);
				case 10:
					var options = inputStatus.a;
					return A6($author$project$Components$Patterns$Forms$buttonIconInput, options.l_, options.iH, options.fD, options.l4, formStatus, options.lx);
				case 11:
					var html_ = inputStatus.a;
					return html_;
				case 12:
					var options = inputStatus.a;
					return $author$project$Components$Patterns$Forms$slider(options);
				case 13:
					var options = inputStatus.a;
					return $author$project$Components$Patterns$Forms$sliderWithInput(options);
				default:
					var classStr = inputStatus.a;
					var listInputStatus = inputStatus.b;
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(classStr)
							]),
						A2(
							$elm$core$List$map,
							function (inputStatus_) {
								return A2(formInputToInputWithLabel, onEnter, inputStatus_);
							},
							listInputStatus));
			}
		});
	return A2(
		$elm$html$Html$form,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('ui-form'),
					submitMsg
				]),
			attrForm),
		_Utils_ap(
			function () {
				if ((inputs.b && (inputs.a.$ === 1)) && (!inputs.b.b)) {
					var input_ = inputs.a.a;
					return _List_fromArray(
						[
							A2(
							formInputToInputWithLabel,
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.l_;
								},
								maybeSubmit),
							$author$project$Components$Patterns$Forms$Input(input_))
						]);
				} else {
					var inputs_ = inputs;
					return A2(
						$elm$core$List$map,
						formInputToInputWithLabel($elm$core$Maybe$Nothing),
						inputs_);
				}
			}(),
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (submit) {
						return $elm$core$List$singleton(
							A4($author$project$Components$Patterns$Forms$buttonSubmit, submit.iH, submitName, formStatus, submit.lx));
					},
					maybeSubmit))));
};
var $author$project$Pages$Admin$CompanyOrders$viewISSDiscount = function (m) {
	var viewFooter = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex gap-4 w-full')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('action-system green-btn w-full'),
						$elm$html$Html$Events$onClick($author$project$Pages$Admin$CompanyOrders$SubmittedISSDiscount)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Salvar')
					])),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('action-system white-btn w-full m-0'),
						$elm$html$Html$Events$onClick($author$project$Pages$Admin$CompanyOrders$ClickedCloseModal)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Fechar')
					]))
			]));
	var viewBody = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex flex-col gap-4 w-3/4')
			]),
		_List_fromArray(
			[
				$author$project$Components$Patterns$Forms$formSimple(
				{
					hZ: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col gap-2 ')
						]),
					L: m.L,
					jf: _List_fromArray(
						[
							$author$project$Components$Patterns$Forms$Html(
							A2(
								$elm$html$Html$strong,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-lg font-semibold text-purple-main')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Porcentagem de desconto do ISS')
									]))),
							A2(
							$author$project$Components$Patterns$Forms$Custom,
							'flex  items-center',
							_List_fromArray(
								[
									$author$project$Components$Patterns$Forms$Input(
									{
										ie: $elm$core$Maybe$Nothing,
										iH: m.L === 2,
										iP: _List_Nil,
										nR: _List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-gray-shade'),
												$elm$html$Html$Attributes$max('5.0'),
												$elm$html$Html$Attributes$min('0')
											]),
										jl: $elm$core$Maybe$Nothing,
										jn: _List_fromArray(
											[
												$elm$html$Html$Attributes$class('w-14')
											]),
										n9: $elm$core$Maybe$Just(3),
										c3: 'Campo para Desconto ISS',
										jE: $elm$core$Maybe$Nothing,
										jF: $elm$core$Maybe$Nothing,
										jG: $elm$core$Maybe$Nothing,
										ov: $elm$core$Maybe$Nothing,
										jI: $elm$core$Maybe$Just($author$project$Pages$Admin$CompanyOrders$InputtedISS),
										hh: '',
										kE: m.L === 1,
										kY: 'number',
										k1: _List_Nil,
										di: m.oT
									}),
									$author$project$Components$Patterns$Forms$Html(
									A2(
										$elm$html$Html$strong,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-xl')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('%')
											]))),
									$author$project$Components$Patterns$Forms$Slider(
									{
										iH: m.L === 2,
										nR: _List_Nil,
										jl: $elm$core$Maybe$Nothing,
										jn: _List_fromArray(
											[
												$elm$html$Html$Attributes$class('ml-4 w-full')
											]),
										d$: '5',
										e4: '0',
										c3: 'Range para Desconto ISS',
										jI: $elm$core$Maybe$Just($author$project$Pages$Admin$CompanyOrders$InputtedISS),
										kE: m.L === 1,
										hG: '0.1',
										k1: _List_Nil,
										di: m.oT
									})
								])),
							$author$project$Components$Patterns$Forms$Html(
							A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-purple-secondary')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('A porcentagem pode ser de 0% até 5%')
									])))
						]),
					oc: $elm$core$Maybe$Nothing,
					pX: 'Enviar'
				})
			]));
	return _Utils_Tuple2(viewBody, viewFooter);
};
var $author$project$Pages$Admin$CompanyOrders$viewModal = function (modal) {
	var contentModal = F3(
		function (title, body, footer) {
			return $author$project$Components$Patterns$Modal$simple(
				{
					hY: $elm$core$Maybe$Just(
						A2($elm$html$Html$Attributes$style, 'min-height', 'fit-content')),
					ii: 'modal-cadastro-usuario-sistema gap-12 p-8',
					il: 'truncate ',
					ip: $author$project$Pages$Admin$CompanyOrders$ClickedCloseModal,
					fD: title,
					k4: body,
					k5: footer
				});
		});
	switch (modal.$) {
		case 1:
			return A3(
				contentModal,
				'Carregando..',
				$author$project$Components$View$loading,
				$elm$html$Html$text(''));
		case 3:
			switch (modal.a.$) {
				case 0:
					var modal_ = modal.a.a;
					var _v1 = $author$project$Pages$Admin$CompanyOrders$viewEditEmail(modal_);
					var body = _v1.a;
					var footer = _v1.b;
					return A3(contentModal, 'Editar Email - ' + modal_.f5.c3, body, footer);
				case 1:
					var modal_ = modal.a.a;
					var _v2 = $author$project$Pages$Admin$CompanyOrders$viewConfirmReversal(modal_);
					var body = _v2.a;
					var footer = _v2.b;
					return A3(contentModal, 'Confirmação de estorno', body, footer);
				case 2:
					var orderID = modal.a.a;
					var _v3 = $author$project$Pages$Admin$CompanyOrders$viewConfirmSaveOrder(orderID);
					var body = _v3.a;
					var footer = _v3.b;
					return A3(contentModal, 'Confirmar gravação de lista', body, footer);
				default:
					var m = modal.a.a;
					var _v4 = $author$project$Pages$Admin$CompanyOrders$viewISSDiscount(m);
					var body = _v4.a;
					var footer = _v4.b;
					return A3(contentModal, 'Desconto do ISS que será aplicada à empresa', body, footer);
			}
		case 2:
			var error = modal.a;
			return A3(
				contentModal,
				'Algo deu errado!',
				$author$project$Components$View$loading,
				$elm$html$Html$text(''));
		default:
			return $elm$html$Html$text('');
	}
};
var $author$project$Pages$Admin$CompanyOrders$ClickedBackHistory = function (a) {
	return {$: 9, a: a};
};
var $elm$html$Html$section = _VirtualDom_node('section');
var $author$project$Pages$Admin$CompanyOrders$viewPagination = F5(
	function (recordCount, historic, detail, page, source) {
		return _List_fromArray(
			[
				A4(
				$author$project$Components$View$pagination,
				function (p) {
					return A2(
						$author$project$Route$Admin,
						$author$project$Route$CompanyOrderDetail(
							{
								l8: historic,
								mF: detail,
								ob: $elm$core$Maybe$Just(p),
								pO: source
							}),
						$elm$core$Maybe$Nothing);
				},
				$author$project$Pages$Admin$CompanyOrders$cardsPerPage,
				$elm$core$Maybe$Just(page),
				recordCount)
			]);
	});
var $author$project$Utils$maybeEmptyStrDefault = function (str) {
	if (!str.$) {
		if (str.a === '') {
			return '-';
		} else {
			var str_ = str.a;
			return str_;
		}
	} else {
		return '-';
	}
};
var $author$project$Pages$Admin$CompanyOrders$viewRequesterRowDetail = F2(
	function (timezone, requester) {
		var strAppliedDate = A2(
			$elm$core$Basics$composeL,
			$elm$core$Maybe$withDefault('Não aplicada'),
			$elm$core$Maybe$map(
				$author$project$Utils$formatDateTimeFromPosix(timezone)));
		var strAppliedBy = $elm$core$Maybe$withDefault('Não aplicada');
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							function ($) {
								return $.c3;
							}(requester))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$maskCPF(
								function ($) {
									return $.p$;
								}(requester)))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							function ($) {
								return $.lO;
							}(requester))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$formatAsMoney(
								$elm$core$String$fromInt(
									function ($) {
										return $.di;
									}(requester))))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$maybeEmptyStrDefault(
								A2($elm$core$Maybe$map, $elm$core$String$fromInt, requester.pn)))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							strAppliedDate(
								function ($) {
									return $.ls;
								}(requester)))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							strAppliedBy(
								function ($) {
									return $.lr;
								}(requester)))
						]))
				]));
	});
var $author$project$Pages$Admin$CompanyOrders$viewRequesterTableDetail = F2(
	function (timezone, requesters) {
		return $elm$core$List$isEmpty(requesters) ? _List_fromArray(
			[
				$elm$html$Html$text('')
			]) : _List_fromArray(
			[
				A2(
				$elm$html$Html$h2,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'color', 'black'),
						$elm$html$Html$Attributes$class('inner-center')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Detalhes do solicitante')
					])),
				A2(
				$elm$html$Html$table,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'cellspacing', '0'),
						$elm$html$Html$Attributes$class('data-table-dashboard'),
						A2($elm$html$Html$Attributes$style, 'margin-bottom', '0')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$th,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Nome')
											])),
										A2(
										$elm$html$Html$th,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('CPF')
											])),
										A2(
										$elm$html$Html$th,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Cartão')
											])),
										A2(
										$elm$html$Html$th,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Valor da carga')
											])),
										A2(
										$elm$html$Html$th,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Lista de carga')
											])),
										A2(
										$elm$html$Html$th,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Data da aplicação')
											])),
										A2(
										$elm$html$Html$th,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Aplicado por')
											]))
									]))
							])),
						A2(
						$elm$html$Html$tbody,
						_List_Nil,
						A2(
							$elm$core$List$map,
							$author$project$Pages$Admin$CompanyOrders$viewRequesterRowDetail(timezone),
							requesters))
					]))
			]);
	});
var $author$project$Pages$Admin$CompanyOrders$viewPurchaseRowDetail = F2(
	function (timezone, purchase) {
		var strPaymentMethod = $author$project$Services$Models$paymentFormatToStr(
			function ($) {
				return $.jW;
			}(purchase));
		var strPaymentDate = A2(
			$elm$core$Basics$composeL,
			$elm$core$Maybe$withDefault(''),
			$elm$core$Maybe$map(
				$author$project$Utils$formatDateTimeFromPosix(timezone)));
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Basics$composeL,
								function ($) {
									return $.c3;
								},
								function ($) {
									return $.mj;
								})(purchase))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Utils$formatDateTimeFromPosix, timezone, purchase.ix))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							strPaymentDate(
								function ($) {
									return $.jV;
								}(purchase)))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(purchase.kK)
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(strPaymentMethod)
						]))
				]));
	});
var $author$project$Pages$Admin$CompanyOrders$viewTableDetail = F2(
	function (timezone, purchaseDetail) {
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'cellspacing', '0'),
					$elm$html$Html$Attributes$class('data-table-dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$thead,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Solicitante')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Criado em ')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Data Pagamento')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Status')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Tipo')
										]))
								]))
						])),
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Pages$Admin$CompanyOrders$viewPurchaseRowDetail, timezone, purchaseDetail)
						]))
				]));
	});
var $author$project$Pages$Admin$CompanyOrders$viewContentDetails = F5(
	function (shared, purchase, companyID, page, source) {
		return _Utils_ap(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'color', 'black'),
							$elm$html$Html$Attributes$class('inner-center')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Detalhes do Pedido')
						])),
					A2($author$project$Pages$Admin$CompanyOrders$viewTableDetail, shared.kS, purchase)
				]),
			_Utils_ap(
				A2($author$project$Pages$Admin$CompanyOrders$viewRequesterTableDetail, shared.kS, purchase.pp),
				A5(
					$author$project$Pages$Admin$CompanyOrders$viewPagination,
					purchase.lN,
					A2($elm$core$Maybe$withDefault, '', companyID),
					purchase.dM,
					page,
					source)));
	});
var $author$project$Pages$Admin$CompanyOrders$viewDetail = F5(
	function (companyID, shared, page, source, purchase) {
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(' mb-4  ')
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('top-actions')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('voltar-ico-blue'),
										$elm$html$Html$Attributes$title('Histórico'),
										$elm$html$Html$Events$onClick(
										$author$project$Pages$Admin$CompanyOrders$ClickedBackHistory(source))
									]),
								_List_Nil)
							]))
					]),
				A5($author$project$Pages$Admin$CompanyOrders$viewContentDetails, shared, purchase, companyID, page, source)));
	});
var $author$project$Pages$Admin$CompanyOrders$FiltersMsg = function (a) {
	return {$: 23, a: a};
};
var $author$project$Pages$Admin$CompanyOrders$InputtedCompanyName = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$CompanyOrders$viewInputCompanyName = function (name) {
	return $author$project$Components$Patterns$Forms$Input(
		{
			ie: $elm$core$Maybe$Nothing,
			iH: false,
			iP: _List_Nil,
			nR: _List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col'),
					A2($elm$html$Html$Attributes$style, 'width', 'fit-content')
				]),
			jl: $elm$core$Maybe$Just('Razão social'),
			jn: _List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'width', 'fit-content')
				]),
			n9: $elm$core$Maybe$Just(35),
			c3: 'Razão social',
			jE: $elm$core$Maybe$Nothing,
			jF: $elm$core$Maybe$Nothing,
			jG: $elm$core$Maybe$Nothing,
			ov: $elm$core$Maybe$Nothing,
			jI: $elm$core$Maybe$Just(
				A2($elm$core$Basics$composeL, $author$project$Pages$Admin$CompanyOrders$FiltersMsg, $author$project$Pages$Admin$CompanyOrders$InputtedCompanyName)),
			hh: 'Insira a Razão social da empresa desejada',
			kE: false,
			kY: 'text',
			k1: _List_Nil,
			di: name
		});
};
var $author$project$Pages$Admin$CompanyOrders$InputtedDocument = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$CompanyOrders$viewInputDocument = function (document) {
	return $author$project$Components$Patterns$Forms$Input(
		{
			ie: $elm$core$Maybe$Nothing,
			iH: false,
			iP: _List_Nil,
			nR: _List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col'),
					A2($elm$html$Html$Attributes$style, 'width', 'fit-content')
				]),
			jl: $elm$core$Maybe$Just('CNPJ'),
			jn: _List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'width', 'fit-content')
				]),
			n9: $elm$core$Maybe$Just(18),
			c3: 'CNPJ',
			jE: $elm$core$Maybe$Nothing,
			jF: $elm$core$Maybe$Nothing,
			jG: $elm$core$Maybe$Nothing,
			ov: $elm$core$Maybe$Nothing,
			jI: $elm$core$Maybe$Just(
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Pages$Admin$CompanyOrders$FiltersMsg, $author$project$Pages$Admin$CompanyOrders$InputtedDocument),
					$elm$core$String$filter($elm$core$Char$isDigit))),
			hh: 'Insira o CNPJ da empresa desejada',
			kE: false,
			kY: 'text',
			k1: _List_Nil,
			di: $author$project$Utils$maskCNPJ(document)
		});
};
var $author$project$Pages$Admin$CompanyOrders$viewFilters = function (filters) {
	return $author$project$Components$Patterns$Forms$formSimple(
		{
			hZ: _List_fromArray(
				[
					$elm$html$Html$Attributes$class('mb-4 flex gap-4')
				]),
			L: 0,
			jf: _List_fromArray(
				[
					$author$project$Pages$Admin$CompanyOrders$viewInputDocument(filters.iI),
					$author$project$Pages$Admin$CompanyOrders$viewInputCompanyName(filters.dw)
				]),
			oc: $elm$core$Maybe$Nothing,
			pX: ''
		});
};
var $author$project$Pages$Admin$CompanyOrders$algorithmToFilter = F2(
	function (filters, list) {
		var filtered = F3(
			function (filter, key, list_) {
				return A2(
					$elm$core$Maybe$withDefault,
					list_,
					A2(
						$elm$core$Maybe$map,
						function (queryName) {
							return A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									filter,
									A2(
										$elm$core$Basics$composeR,
										$elm$core$String$toLower,
										$elm$core$String$contains(queryName))),
								list);
						},
						key));
			});
		var filterActive = function (filter) {
			return $elm$core$String$isEmpty(filter) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(filter);
		};
		return A3(
			filtered,
			function ($) {
				return $.c3;
			},
			A2(
				$elm$core$Maybe$map,
				$elm$core$String$toLower,
				filterActive(filters.dw)),
			A3(
				filtered,
				function ($) {
					return $.l3;
				},
				A2(
					$elm$core$Maybe$map,
					$elm$core$String$toLower,
					filterActive(filters.iI)),
				list));
	});
var $author$project$Pages$Admin$CompanyOrders$ClickedCompany = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Admin$CompanyOrders$ClickedOpenModal = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Patterns$Button$icon = F4(
	function (msg, classBtn, codeIcon, title) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('action-system green-btn ' + classBtn),
					$elm$html$Html$Events$onClick(msg),
					$elm$html$Html$Attributes$title(title)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('material-symbols-outlined pl-2 pr-2 align-middle ')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(codeIcon)
						]))
				]));
	});
var $author$project$Pages$Admin$CompanyOrders$initISSDiscount = F2(
	function (companyID, issTax) {
		return {
			l8: companyID,
			L: 0,
			oT: $elm$core$String$fromFloat(issTax)
		};
	});
var $author$project$Pages$Admin$CompanyOrders$viewPurchaseRow = F3(
	function (user, timezone, companyOrder) {
		var issBtn = $author$project$Services$Models$iHaveAccess(
			{
				gZ: user.hg,
				hf: $author$project$Services$Models$COMPANY(1),
				hQ: A4(
					$author$project$Components$Patterns$Button$icon,
					$author$project$Pages$Admin$CompanyOrders$ClickedOpenModal(
						$author$project$Pages$Admin$CompanyOrders$ISSDiscount(
							A2($author$project$Pages$Admin$CompanyOrders$initISSDiscount, companyOrder.dM, companyOrder.nY))),
					'icon-edit contents',
					'attach_money',
					'Desconto do ISS'),
				hR: $elm$html$Html$text('')
			});
		var event = $elm$html$Html$Events$onClick(
			$author$project$Pages$Admin$CompanyOrders$ClickedCompany(companyOrder.dM));
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[event]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Utils$formatDateTimeFromPosix, timezone, companyOrder.ix))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[event]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							function ($) {
								return $.c3;
							}(companyOrder))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[event]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							function ($) {
								return $.n7;
							}(companyOrder))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[event]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							function ($) {
								return $.mX;
							}(companyOrder))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							event,
							$elm$html$Html$Attributes$class('whitespace-nowrap ')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$maskCNPJ(
								function ($) {
									return $.l3;
								}(companyOrder)))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							event,
							$elm$html$Html$Attributes$class('whitespace-nowrap ')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$maskPhoneDDD(
								_Utils_ap(
									function ($) {
										return $.oV;
									}(companyOrder),
									function ($) {
										return $.oW;
									}(companyOrder))))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex')
						]),
					_List_fromArray(
						[
							A4(
							$author$project$Components$Patterns$Button$icon,
							$author$project$Pages$Admin$CompanyOrders$ClickedOpenModal(
								$author$project$Pages$Admin$CompanyOrders$EditEmail(
									{f5: companyOrder, mX: companyOrder.mX})),
							'icon-edit contents',
							'edit_square',
							'Editar E-Mail'),
							issBtn
						]))
				]));
	});
var $author$project$Pages$Admin$CompanyOrders$viewPurchaseTable = F4(
	function (user, timezone, filters, companyOrder) {
		var sortedList = A2(
			$elm$core$List$sortBy,
			function ($) {
				return $.c3;
			},
			companyOrder);
		var filteredList = A2($author$project$Pages$Admin$CompanyOrders$algorithmToFilter, filters, sortedList);
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'cellspacing', '0'),
					$elm$html$Html$Attributes$class('data-table-dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$thead,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Criado em')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Nome')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Responsável')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Email')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('CNPJ')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Fone')
										])),
									A2($elm$html$Html$th, _List_Nil, _List_Nil)
								]))
						])),
					A2(
					$elm$html$Html$tbody,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tbody-table-company-orders')
						]),
					A2(
						$elm$core$List$map,
						A2($author$project$Pages$Admin$CompanyOrders$viewPurchaseRow, user, timezone),
						filteredList))
				]));
	});
var $author$project$Pages$Admin$CompanyOrders$ClickedBackCompany = {$: 8};
var $author$project$Pages$Admin$CompanyOrders$ClickedDetail = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Admin$CompanyOrders$ClickedOpenModalConfirmReversalModal = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Patterns$Button$text = F4(
	function (attrBtn, classBtn, title, msg) {
		return A2(
			$elm$html$Html$button,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('action-system green-btn ' + classBtn),
						$elm$html$Html$Events$onClick(msg)
					]),
				attrBtn),
			_List_fromArray(
				[
					$elm$html$Html$text(title)
				]));
	});
var $author$project$Pages$Admin$CompanyOrders$NoOp = {$: 0};
var $author$project$Pages$Admin$CompanyOrders$isDisplayButtonToViewBillPDF = function (refill) {
	return (refill.jW === 5) && ((refill.kK === 'Pendente') || (refill.kK === 'Baixa manual'));
};
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $author$project$Pages$Admin$CompanyOrders$viewIconPrint = function (refill) {
	var _v0 = _Utils_Tuple2(
		A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.lA;
			},
			refill.oE),
		$author$project$Pages$Admin$CompanyOrders$isDisplayButtonToViewBillPDF(refill));
	if ((!_v0.a.$) && _v0.b) {
		var billURL = _v0.a.a;
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href(billURL),
					$elm$html$Html$Attributes$target('_blank')
				]),
			_List_fromArray(
				[
					A4($author$project$Components$Patterns$Button$icon, $author$project$Pages$Admin$CompanyOrders$NoOp, 'icon-print-config', 'print', 'Imprimir boleto')
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Pages$Admin$CompanyOrders$ClickedSaveOrder = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Admin$CompanyOrders$viewIconSaveOrder = function (orderID) {
	return A4(
		$author$project$Components$Patterns$Button$icon,
		$author$project$Pages$Admin$CompanyOrders$ClickedSaveOrder(orderID),
		'icon-print-config',
		'save',
		'Gravar lista');
};
var $author$project$Pages$Admin$CompanyOrders$viewPurchaseRowHistory = F5(
	function (hasIss, permissionsCODE, userType, timezone, purchase) {
		var valueViewMoney = function (value) {
			return $author$project$Utils$formatAsMoney(
				$elm$core$String$fromInt(value));
		};
		var valueView = function (v) {
			return (purchase.jW === 11) ? A2(
				$elm$core$Basics$composeR,
				valueViewMoney,
				function (v_) {
					return '( ' + (v_ + ' )');
				})(v) : valueViewMoney(v);
		};
		var valueClass = (purchase.jW === 11) ? $elm$html$Html$Attributes$class('text-red-500') : A2($elm$html$Html$Attributes$style, '', '');
		var strPaymentMethod = $author$project$Services$Models$paymentFormatToStr(
			function ($) {
				return $.jW;
			}(purchase));
		var strPaymentDate = A2(
			$elm$core$Basics$composeL,
			$elm$core$Maybe$withDefault(''),
			$elm$core$Maybe$map(
				$author$project$Utils$formatDateTimeFromPosix(timezone)));
		var openModalMsg = function (orderID) {
			return $author$project$Pages$Admin$CompanyOrders$ClickedOpenModalConfirmReversalModal(
				{d1: orderID, di: purchase.di});
		};
		var viewTdConfirmReversal = (((purchase.kK === 'Pago') || ((purchase.kK === 'Baixa manual') || ((purchase.kK === 'Fechado') || (purchase.kK === 'Pago após baixa manual')))) && (!purchase.pu)) ? A2(
			$elm$core$Maybe$withDefault,
			$elm$html$Html$text(''),
			A2(
				$elm$core$Maybe$map,
				function (order_) {
					return purchase.ps ? $elm$html$Html$text('Estorno já criado') : A4(
						$author$project$Components$Patterns$Button$text,
						_List_Nil,
						'',
						'Estornar',
						openModalMsg(order_.dM));
				},
				purchase.oE)) : $elm$html$Html$text('');
		var viewWithPermissionConfirmReversal = $author$project$Services$Models$iHaveAccess(
			{
				gZ: permissionsCODE,
				hf: $author$project$Services$Models$COMPANY(0),
				hQ: viewTdConfirmReversal,
				hR: $elm$html$Html$text('')
			});
		var attrMsg = $elm$html$Html$Events$onClick(
			$author$project$Pages$Admin$CompanyOrders$ClickedDetail(purchase.dM));
		var viewTdsIss = hasIss ? _List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						attrMsg,
						valueClass,
						$elm$html$Html$Attributes$class('whitespace-nowrap')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						valueView(purchase.nA))
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						attrMsg,
						$elm$html$Html$Attributes$class('whitespace-nowrap')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						valueViewMoney(purchase.nY))
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						attrMsg,
						valueClass,
						$elm$html$Html$Attributes$class('whitespace-nowrap')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						valueView(purchase.di))
					]))
			]) : _List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[attrMsg, valueClass]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						valueView(purchase.di))
					]))
			]);
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[attrMsg]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($author$project$Utils$formatDateTimeFromPosix, timezone, purchase.ix))
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$elm$core$Maybe$withDefault,
									'-',
									A2($elm$core$Maybe$map, $elm$core$String$fromInt, purchase.pC)))
							]))
					]),
				_Utils_ap(
					viewTdsIss,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[attrMsg]),
							_List_fromArray(
								[
									$elm$html$Html$text(purchase.kK)
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[attrMsg]),
							_List_fromArray(
								[
									$elm$html$Html$text(strPaymentMethod)
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[attrMsg]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									strPaymentDate(
										function ($) {
											return $.jV;
										}(purchase)))
								])),
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[viewWithPermissionConfirmReversal])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex gap-2')
								]),
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Pages$Admin$CompanyOrders$viewIconPrint(purchase)
									]),
								function () {
									var _v0 = _Utils_Tuple2(userType, strPaymentMethod !== 'Estorno');
									if ((_v0.a.$ === 2) && _v0.b) {
										return _List_fromArray(
											[
												A2(
												$elm$core$Maybe$withDefault,
												$elm$html$Html$text(''),
												A2(
													$elm$core$Maybe$map,
													A2(
														$elm$core$Basics$composeR,
														function ($) {
															return $.dM;
														},
														$author$project$Pages$Admin$CompanyOrders$viewIconSaveOrder),
													purchase.oE))
											]);
									} else {
										return _List_Nil;
									}
								}()))
						]))));
	});
var $author$project$Pages$Admin$CompanyOrders$viewPurchaseTableHistory = F4(
	function (userType, permissionsCODE, timezone, purchases) {
		var hasIss = A2(
			$elm$core$List$any,
			function (_v1) {
				var issTax = _v1.nY;
				return issTax > 0;
			},
			purchases);
		var headersIss = hasIss ? _List_fromArray(
			[
				A2(
				$elm$html$Html$th,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Valor bruto')
					])),
				A2(
				$elm$html$Html$th,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Desconto ISS')
					])),
				A2(
				$elm$html$Html$th,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Valor líquido')
					]))
			]) : _List_fromArray(
			[
				A2(
				$elm$html$Html$th,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Valor')
					]))
			]);
		return _List_fromArray(
			[
				function () {
				if (userType.$ === 2) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('top-actions')
							]),
						_List_Nil);
				} else {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('top-actions')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('voltar-ico-blue'),
										$elm$html$Html$Attributes$title('Empresas'),
										$elm$html$Html$Events$onClick($author$project$Pages$Admin$CompanyOrders$ClickedBackCompany)
									]),
								_List_Nil)
							]));
				}
			}(),
				A2(
				$elm$html$Html$h2,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'color', 'black'),
						$elm$html$Html$Attributes$class('inner-center')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Histórico da empresa')
					])),
				A2(
				$elm$html$Html$table,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'cellspacing', '0'),
						$elm$html$Html$Attributes$class('data-table-dashboard')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$tr,
								_List_Nil,
								_Utils_ap(
									_List_fromArray(
										[
											A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Data Criação')
												])),
											A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Nº do pedido')
												]))
										]),
									_Utils_ap(
										headersIss,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$th,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Status')
													])),
												A2(
												$elm$html$Html$th,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Tipo')
													])),
												A2(
												$elm$html$Html$th,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Data Pagamento')
													])),
												A2($elm$html$Html$th, _List_Nil, _List_Nil),
												A2($elm$html$Html$th, _List_Nil, _List_Nil)
											]))))
							])),
						$elm$core$List$isEmpty(purchases) ? A2(
						$elm$html$Html$tbody,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Nenhum registro encontrado.')
							])) : A2(
						$elm$html$Html$tbody,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('tbody-table-company-orders')
							]),
						A2(
							$elm$core$List$map,
							A4($author$project$Pages$Admin$CompanyOrders$viewPurchaseRowHistory, hasIss, permissionsCODE, userType, timezone),
							purchases))
					]))
			]);
	});
var $author$project$Pages$Admin$CompanyOrders$viewPage = F4(
	function (model, page, shared, user) {
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard admin-reports')
				]),
			function () {
				var _v0 = model.fy;
				switch (_v0.$) {
					case 0:
						var refills = _v0.a;
						return A4($author$project$Pages$Admin$CompanyOrders$viewPurchaseTableHistory, user.k$, user.hg, shared.kS, refills);
					case 1:
						switch (_v0.a.$) {
							case 3:
								var orders = _v0.a.a;
								return _List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('top-actions')
											]),
										_List_Nil),
										A2(
										$elm$html$Html$h2,
										_List_fromArray(
											[
												A2($elm$html$Html$Attributes$style, 'color', 'black'),
												$elm$html$Html$Attributes$class('inner-center mb-4')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Empresas')
											])),
										$author$project$Pages$Admin$CompanyOrders$viewFilters(model.Z),
										A4($author$project$Pages$Admin$CompanyOrders$viewPurchaseTable, user, shared.kS, model.Z, orders)
									]);
							case 2:
								var e = _v0.a.a;
								return _List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Services$Api$errorToUserMessage(e))
									]);
							default:
								return _List_fromArray(
									[$author$project$Components$View$loading]);
						}
					case 2:
						var refillDetails = _v0.a;
						return _List_fromArray(
							[
								A5($author$project$Pages$Admin$CompanyOrders$viewDetail, model.l8, shared, page, model.pO, refillDetails)
							]);
					default:
						return _List_fromArray(
							[$author$project$Components$View$loading]);
				}
			}());
	});
var $author$project$Pages$Admin$CompanyOrders$view = F3(
	function (model, shared, user) {
		return _Utils_Tuple3(
			'Empresas',
			A4($author$project$Pages$Admin$CompanyOrders$viewPage, model, model.bv, shared, user),
			$author$project$Pages$Admin$CompanyOrders$viewModal(model.aY));
	});
var $author$project$Pages$Admin$Equipments$InputSearch = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$Equipments$Submit = {$: 2};
var $author$project$Utils$formatDateTime = function (timezone) {
	return A2(
		$elm$core$Basics$composeR,
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Result$withDefault(
				$elm$time$Time$millisToPosix(0)),
			$author$project$Utils$formatDateTimeFromPosix(timezone)));
};
var $author$project$Pages$Admin$Equipments$viewRow = F2(
	function (timezone, eq) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'-',
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.dM;
									},
									eq.eH)))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'-',
								A2(
									$elm$core$Maybe$map,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.gP;
										},
										$author$project$Utils$formatDateTime(timezone)),
									eq.eH)))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'-',
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.kG;
									},
									eq.eH)))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(eq.pE)
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Utils$formatDateTime, timezone, eq.gP))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(eq.kG)
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = eq.k2;
							if (_v0.$ === 1) {
								return $elm$html$Html$text('Não está instalado em um veículo');
							} else {
								var vehicle = _v0.a;
								return $elm$html$Html$text(vehicle.l4);
							}
						}()
						]))
				]));
	});
var $author$project$Pages$Admin$Equipments$viewTable = F3(
	function (filter, timezone, equipments) {
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'cellspacing', '0'),
					$elm$html$Html$Attributes$class('data-table-dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$thead,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Nº EB01')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Última Comunicação EB01')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Versão EB01')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Nº Validador')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Última Comunicação Validador')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Versão Validador')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Veículo')
										]))
								]))
						])),
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					A2(
						$elm$core$List$map,
						$author$project$Pages$Admin$Equipments$viewRow(timezone),
						A2(
							$elm$core$List$sortBy,
							function ($) {
								return $.gP;
							},
							A2(
								$elm$core$List$filter,
								function (_v0) {
									var eb01 = _v0.eH;
									return A2(
										$elm$core$Maybe$withDefault,
										false,
										A2(
											$elm$core$Maybe$map,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.dM;
												},
												$elm$core$String$contains(filter)),
											eb01));
								},
								equipments))))
				]));
	});
var $author$project$Pages$Admin$Equipments$viewPage = F3(
	function (model, shared, user) {
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('top-actions')
						]),
					_List_fromArray(
						[
							A2($elm$html$Html$div, _List_Nil, _List_Nil),
							A2($elm$html$Html$div, _List_Nil, _List_Nil)
						])),
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'color', 'black'),
							$elm$html$Html$Attributes$class('inner-center')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Histórico')
						])),
					($elm$core$String$isEmpty(model.dI) && _Utils_eq(
					model.cU,
					$krisajenkins$remotedata$RemoteData$Success(_List_Nil))) ? $elm$html$Html$text('') : A2(
					$elm$html$Html$form,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('filtros-container items-baseline'),
							$elm$html$Html$Events$onSubmit($author$project$Pages$Admin$Equipments$Submit)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('bg-busca'),
											$elm$html$Html$Attributes$placeholder('Buscar por Nº EB01'),
											$elm$html$Html$Attributes$type_('text'),
											$elm$html$Html$Events$onInput($author$project$Pages$Admin$Equipments$InputSearch)
										]),
									_List_Nil)
								])),
							A2(
							$author$project$Components$View$searchButton,
							'',
							!$krisajenkins$remotedata$RemoteData$isSuccess(model.cU))
						])),
					function () {
					var _v0 = model.cU;
					switch (_v0.$) {
						case 0:
							return $elm$html$Html$text('');
						case 1:
							return $author$project$Components$View$loading;
						case 2:
							var err = _v0.a;
							return $elm$html$Html$text(
								$author$project$Services$Api$errorToUserMessage(err));
						default:
							if (!_v0.a.b) {
								return $elm$html$Html$text('Nenhum histórico encontrado.');
							} else {
								var equipments = _v0.a;
								return A3($author$project$Pages$Admin$Equipments$viewTable, model.dI, shared.kS, equipments);
							}
					}
				}()
				]));
	});
var $author$project$Pages$Admin$Equipments$view = F3(
	function (model, shared, user) {
		return _Utils_Tuple3(
			'Equipamentos',
			A3($author$project$Pages$Admin$Equipments$viewPage, model, shared, user),
			$elm$html$Html$text(''));
	});
var $author$project$Pages$Admin$PaymentBillets$GenerateCsvDownload = {$: 12};
var $author$project$Pages$Admin$PaymentBillets$InputtedEnd = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$PaymentBillets$InputtedStart = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Admin$PaymentBillets$InputtedStatus = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$PaymentBillets$Submit = {$: 15};
var $author$project$Services$Payments$allStatusPayment = _List_fromArray(
	[0, 3, 1, 9, 4]);
var $author$project$Components$Patterns$Tables$defaultSomeLinesAreClickable = function (opts) {
	var cssTableDefaultPanel = opts.nX ? _List_fromArray(
		[
			$elm$html$Html$Attributes$class('overflow-x-auto'),
			A2($elm$html$Html$Attributes$style, 'width', 'calc(100vw - 23rem)')
		]) : _List_Nil;
	return A2(
		$elm$html$Html$div,
		_Utils_ap(cssTableDefaultPanel, opts.lw),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$table,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'cellspacing', '0'),
						$elm$html$Html$Attributes$class('data-table-dashboard my-4')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$tr,
								_List_Nil,
								A2(
									$elm$core$List$map,
									function (header) {
										return A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(header)
												]));
									},
									opts.nF))
							])),
						A2(
						$elm$html$Html$tbody,
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (_v0) {
								var record = _v0.a;
								var isClickable = _v0.b;
								return A2(
									$elm$html$Html$tr,
									isClickable ? _List_fromArray(
										[
											$elm$html$Html$Attributes$class('hover:bg-gray-tint1 cursor-pointer')
										]) : _List_Nil,
									record);
							},
							opts.pj))
					]))
			]));
};
var $author$project$Pages$Admin$PaymentBillets$ClickedPay = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Admin$PaymentBillets$GoOrderDetails = F2(
	function (a, b) {
		return {$: 14, a: a, b: b};
	});
var $author$project$Pages$Admin$PaymentBillets$viewRow = F3(
	function (hasIss, timezone, billet) {
		var isClickable = (!_Utils_eq(billet.l8, $elm$core$Maybe$Nothing)) && (!_Utils_eq(billet.hm, $elm$core$Maybe$Nothing));
		var classClickMsg = A2(
			$elm$core$Maybe$withDefault,
			$elm$html$Html$Attributes$class(''),
			A2(
				$elm$core$Maybe$map,
				$elm$html$Html$Events$onClick,
				A3($elm$core$Maybe$map2, $author$project$Pages$Admin$PaymentBillets$GoOrderDetails, billet.l8, billet.hm)));
		var viewIssTd = hasIss ? _List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						classClickMsg,
						$elm$html$Html$Attributes$class('text-align-right '),
						A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Utils$formatAsMoney(
							$elm$core$String$fromInt(billet.i3)))
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						classClickMsg,
						$elm$html$Html$Attributes$class('text-align-right '),
						A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Utils$formatAsMoney(
							$elm$core$String$fromInt(billet.e_)))
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						classClickMsg,
						$elm$html$Html$Attributes$class('whitespace-nowrap'),
						A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Utils$formatAsMoney(
							$elm$core$String$fromInt(billet.lo)))
					]))
			]) : _List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						classClickMsg,
						$elm$html$Html$Attributes$class('text-align-right')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Utils$formatAsMoney(
							$elm$core$String$fromInt(billet.lo)))
					]))
			]);
		return _Utils_Tuple2(
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[classClickMsg]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.eD;
									},
									function ($) {
										return $.c3;
									})(billet))
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[classClickMsg]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Utils$maskCNPJ(
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.eD;
										},
										function ($) {
											return $.iI;
										})(billet)))
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$elm$core$Maybe$withDefault,
									'-',
									A2(
										$elm$core$Maybe$map,
										$elm$core$String$fromInt,
										function ($) {
											return $.pC;
										}(billet))))
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[classClickMsg]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($author$project$Utils$formatDateTimeFromPosix, timezone, billet.ix))
							])),
						A2(
						$elm$core$Maybe$withDefault,
						A2(
							$elm$html$Html$td,
							_List_fromArray(
								[classClickMsg]),
							_List_fromArray(
								[
									$elm$html$Html$text('-')
								])),
						A2(
							$elm$core$Maybe$map,
							function (paymentDate) {
								return A2(
									$elm$html$Html$td,
									_List_fromArray(
										[classClickMsg]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2($author$project$Utils$formatDateTimeFromPosix, timezone, paymentDate))
										]));
							},
							billet.jV)),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[classClickMsg]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$elm$core$Maybe$withDefault,
									'Desconhecido',
									A2($elm$core$Maybe$map, $author$project$Services$Payments$statusToUserString, billet.kK)))
							]))
					]),
				_Utils_ap(
					viewIssTd,
					_List_fromArray(
						[
							function () {
							var _v0 = _Utils_Tuple2(billet.qt, billet.kK);
							if (((!_v0.a.$) && (!_v0.b.$)) && (_v0.b.a === 3)) {
								var url = _v0.a.a;
								var _v1 = _v0.b.a;
								return A2(
									$elm$html$Html$td,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('flex-justify-end')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('action-system green-btn'),
													$elm$html$Html$Events$onClick(
													$author$project$Pages$Admin$PaymentBillets$ClickedPay(billet))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Ações')
												]))
										]));
							} else {
								return A2($elm$html$Html$td, _List_Nil, _List_Nil);
							}
						}()
						]))),
			isClickable);
	});
var $author$project$Pages$Admin$PaymentBillets$viewTable = F2(
	function (timezone, rows) {
		var hasIss = A2(
			$elm$core$List$any,
			function (_v0) {
				var issTaxValue = _v0.e_;
				return issTaxValue > 0;
			},
			rows);
		var headersIss = hasIss ? _List_fromArray(
			['Valor bruto', 'Desconto ISS', 'Valor líquido']) : _List_fromArray(
			['Valor']);
		return $author$project$Components$Patterns$Tables$defaultSomeLinesAreClickable(
			{
				lw: _List_Nil,
				nF: _Utils_ap(
					_List_fromArray(
						['Nome', 'Documento', 'Nº do pedido', 'Data', 'Data de pagamento', 'Status']),
					headersIss),
				nX: true,
				pj: A2(
					$elm$core$List$map,
					A2($author$project$Pages$Admin$PaymentBillets$viewRow, hasIss, timezone),
					rows)
			});
	});
var $author$project$Pages$Admin$PaymentBillets$viewPage = F3(
	function (model, shared, user) {
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard admin-reports')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('top-actions')
						]),
					_List_fromArray(
						[
							A2($elm$html$Html$div, _List_Nil, _List_Nil),
							A2($elm$html$Html$div, _List_Nil, _List_Nil)
						])),
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'color', 'black'),
							$elm$html$Html$Attributes$class('inner-center')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Boletos')
						])),
					A2(
					$elm$html$Html$form,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('filtros-container payment-guides'),
							$elm$html$Html$Events$onSubmit($author$project$Pages$Admin$PaymentBillets$Submit)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Início'),
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$value(model.eb),
											$elm$html$Html$Attributes$type_('date'),
											$elm$html$Html$Events$onInput($author$project$Pages$Admin$PaymentBillets$InputtedStart)
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Fim'),
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$value(model.dH),
											$elm$html$Html$Attributes$type_('date'),
											$elm$html$Html$Events$onInput($author$project$Pages$Admin$PaymentBillets$InputtedEnd)
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Status'),
									$author$project$Components$Patterns$Forms$selectWithError(
									{
										iH: false,
										jl: $elm$core$Maybe$Nothing,
										jn: _List_Nil,
										jI: $elm$core$Maybe$Just($author$project$Pages$Admin$PaymentBillets$InputtedStatus),
										jO: A2(
											$elm$core$List$cons,
											{eX: model.kK === '', c3: 'Todos', di: ''},
											A2(
												$elm$core$List$map,
												function (status) {
													return {
														eX: _Utils_eq(
															model.kK,
															$author$project$Services$Payments$statusToApiString(status)),
														c3: $author$project$Services$Payments$statusToUserString(status),
														di: $author$project$Services$Payments$statusToApiString(status)
													};
												},
												$author$project$Services$Payments$allStatusPayment)),
										jQ: false,
										ks: _List_fromArray(
											[
												A2($elm$html$Html$Attributes$style, 'padding-top', '5px'),
												A2($elm$html$Html$Attributes$style, 'width', '250px')
											]),
										kE: false,
										k1: _List_Nil
									})
								])),
							A2(
							$author$project$Components$View$searchButton,
							'',
							$krisajenkins$remotedata$RemoteData$isLoading(model.aR)),
							function () {
							var _v0 = model.aR;
							if (_v0.$ === 3) {
								if (!_v0.a.b) {
									return $elm$html$Html$text('');
								} else {
									var rows = _v0.a;
									return $author$project$Components$GeneratorCSV$buttonDownload($author$project$Pages$Admin$PaymentBillets$GenerateCsvDownload);
								}
							} else {
								return $elm$html$Html$text('');
							}
						}()
						])),
					function () {
					var _v1 = model.aR;
					switch (_v1.$) {
						case 0:
							return $elm$html$Html$text('Por favor, defina um período desejado ou utilize as datas padrão para realizar a busca.');
						case 1:
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[$author$project$Components$View$loading]));
						case 2:
							var err = _v1.a;
							return $elm$html$Html$text(
								$author$project$Services$Api$errorToUserMessage(err));
						default:
							if (!_v1.a.b) {
								return $elm$html$Html$text('Nenhum registro encontrado');
							} else {
								var billets = _v1.a;
								return $elm$core$List$isEmpty(billets) ? $elm$html$Html$text('Nenhum Boleto encontrado para os filtros selecionados.') : A2($author$project$Pages$Admin$PaymentBillets$viewTable, shared.kS, billets);
							}
					}
				}()
				]));
	});
var $author$project$Pages$Admin$PaymentBillets$ClickedDownload = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Admin$PaymentBillets$ClickedManualPay = {$: 9};
var $author$project$Pages$Admin$PaymentBillets$CloseModal = {$: 11};
var $elm$html$Html$br = _VirtualDom_node('br');
var $elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);
var $author$project$Utils$removeLeftZeros = function () {
	var regex = A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('^0*(\\d*)$'));
	return A2(
		$elm$regex$Regex$replace,
		regex,
		function (_v0) {
			var submatches = _v0.pV;
			if ((submatches.b && (!submatches.a.$)) && (!submatches.b.b)) {
				var str = submatches.a.a;
				return str;
			} else {
				return '';
			}
		});
}();
var $author$project$Utils$formatMoneyInput = function (input) {
	var digits = $author$project$Utils$removeLeftZeros(
		A2($elm$core$String$filter, $elm$core$Char$isDigit, input));
	var _v0 = $elm$core$String$toList(digits);
	if (!_v0.b) {
		return '';
	} else {
		if (!_v0.b.b) {
			return '0,0' + digits;
		} else {
			if (!_v0.b.b.b) {
				var _v1 = _v0.b;
				return '0,' + digits;
			} else {
				var _v2 = _v0.b;
				return A2($elm$core$String$dropRight, 2, digits) + (',' + A2($elm$core$String$right, 2, digits));
			}
		}
	}
};
var $author$project$Pages$Admin$PaymentBillets$viewPageModal = function (_v0) {
	var isLoading = _v0.dP;
	var billet = _v0.eq;
	var _v1 = billet.qt;
	if (_v1.$ === 1) {
		return $elm$html$Html$text('');
	} else {
		var url = _v1.a;
		var totalValue = $author$project$Utils$formatMoneyInput(
			$elm$core$String$fromInt(billet.lo));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('modal-overlay')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('modal-container modal-dashboard modal-comprar-creditos')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('header-modal')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h3,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Pagar Boleto')
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('action-header'),
											$elm$html$Html$Events$onClick($author$project$Pages$Admin$PaymentBillets$CloseModal)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('fechar-ico')
												]),
											_List_Nil)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('modal-content center-modal')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Escolha como deseja pagar o boleto no valor de '),
											A2(
											$elm$html$Html$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('R$ ' + totalValue)
												])),
											$elm$html$Html$text('.'),
											A2($elm$html$Html$br, _List_Nil, _List_Nil),
											A2($elm$html$Html$br, _List_Nil, _List_Nil),
											$elm$html$Html$text('Obs: Após o pagamento o processamento pode levar até 40 horas, após processado           a compra será efetuada        ')
										])),
									isLoading ? $author$project$Components$View$loading : A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('buttons')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('btn-ce btn-no-ico'),
													$elm$html$Html$Events$onClick(
													$author$project$Pages$Admin$PaymentBillets$ClickedDownload(url))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Baixar PDF')
												])),
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('btn-ce btn-no-ico'),
													$elm$html$Html$Events$onClick($author$project$Pages$Admin$PaymentBillets$ClickedManualPay)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Pagar manualmente')
												]))
										]))
								]))
						]))
				]));
	}
};
var $author$project$Pages$Admin$PaymentBillets$view = F3(
	function (model, shared, user) {
		return _Utils_Tuple3(
			'Boletos',
			A3($author$project$Pages$Admin$PaymentBillets$viewPage, model, shared, user),
			function () {
				var _v0 = model.aY;
				if (_v0.$ === 1) {
					return $elm$html$Html$text('');
				} else {
					var modal = _v0.a;
					return $author$project$Pages$Admin$PaymentBillets$viewPageModal(modal);
				}
			}());
	});
var $author$project$Pages$Admin$PaymentGuides$GetTimeToDownload = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Admin$PaymentGuides$InputtedEnd = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$PaymentGuides$InputtedStart = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$PaymentGuides$InputtedStatus = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Admin$PaymentGuides$Submit = {$: 14};
var $author$project$Pages$Admin$PaymentGuides$ClickedPay = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Admin$PaymentGuides$viewRow = F2(
	function (timezone, guide) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Utils$formatDateTimeFromPosix, timezone, guide.ix))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'-',
								A2($elm$core$Maybe$map, $elm$core$String$fromInt, guide.pC)))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'Desconhecido',
								A2($elm$core$Maybe$map, $author$project$Services$Payments$statusToUserString, guide.kK)))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-align-right')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$formatAsMoney(
								$elm$core$String$fromInt(guide.lo)))
						])),
					function () {
					var _v0 = _Utils_Tuple2(guide.qt, guide.kK);
					if (((!_v0.a.$) && (!_v0.b.$)) && (_v0.b.a === 3)) {
						var url = _v0.a.a;
						var _v1 = _v0.b.a;
						return A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex-justify-end')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('action-system green-btn'),
											$elm$html$Html$Events$onClick(
											$author$project$Pages$Admin$PaymentGuides$ClickedPay(guide))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Ações')
										]))
								]));
					} else {
						return A2($elm$html$Html$td, _List_Nil, _List_Nil);
					}
				}()
				]));
	});
var $author$project$Pages$Admin$PaymentGuides$viewTable = F2(
	function (timezone, rows) {
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'cellspacing', '0'),
					$elm$html$Html$Attributes$class('data-table-dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$thead,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Data')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Nº do pedido')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Status')
										])),
									A2(
									$elm$html$Html$th,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-align-right')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Valor')
										])),
									A2($elm$html$Html$th, _List_Nil, _List_Nil)
								]))
						])),
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					A2(
						$elm$core$List$map,
						$author$project$Pages$Admin$PaymentGuides$viewRow(timezone),
						rows))
				]));
	});
var $author$project$Pages$Admin$PaymentGuides$viewPage = F3(
	function (model, shared, user) {
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard admin-reports')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('top-actions')
						]),
					_List_fromArray(
						[
							A2($elm$html$Html$div, _List_Nil, _List_Nil),
							A2($elm$html$Html$div, _List_Nil, _List_Nil)
						])),
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'color', 'black'),
							$elm$html$Html$Attributes$class('inner-center')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Guias')
						])),
					A2(
					$elm$html$Html$form,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('filtros-container payment-guides'),
							$elm$html$Html$Events$onSubmit($author$project$Pages$Admin$PaymentGuides$Submit)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Início'),
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$value(model.eb),
											$elm$html$Html$Attributes$type_('date'),
											$elm$html$Html$Events$onInput($author$project$Pages$Admin$PaymentGuides$InputtedStart)
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Fim'),
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$value(model.dH),
											$elm$html$Html$Attributes$type_('date'),
											$elm$html$Html$Events$onInput($author$project$Pages$Admin$PaymentGuides$InputtedEnd)
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Status'),
									$author$project$Components$Patterns$Forms$selectWithError(
									{
										iH: false,
										jl: $elm$core$Maybe$Nothing,
										jn: _List_Nil,
										jI: $elm$core$Maybe$Just($author$project$Pages$Admin$PaymentGuides$InputtedStatus),
										jO: A2(
											$elm$core$List$cons,
											{eX: model.kK === '', c3: 'Todos', di: ''},
											A2(
												$elm$core$List$map,
												function (status) {
													return {
														eX: _Utils_eq(
															model.kK,
															$author$project$Services$Payments$statusToApiString(status)),
														c3: $author$project$Services$Payments$statusToUserString(status),
														di: $author$project$Services$Payments$statusToApiString(status)
													};
												},
												$author$project$Services$Payments$allStatusPayment)),
										jQ: false,
										ks: _List_fromArray(
											[
												A2($elm$html$Html$Attributes$style, 'padding-top', '5px'),
												A2($elm$html$Html$Attributes$style, 'width', '250px')
											]),
										kE: false,
										k1: _List_Nil
									})
								])),
							A2(
							$author$project$Components$View$searchButton,
							'',
							$krisajenkins$remotedata$RemoteData$isLoading(model.b0)),
							function () {
							var _v0 = model.b0;
							if (_v0.$ === 3) {
								if (!_v0.a.b) {
									return $elm$html$Html$text('');
								} else {
									var guides = _v0.a;
									return $author$project$Components$GeneratorCSV$buttonDownload(
										$author$project$Pages$Admin$PaymentGuides$GetTimeToDownload(guides));
								}
							} else {
								return $elm$html$Html$text('');
							}
						}()
						])),
					function () {
					var _v1 = model.b0;
					switch (_v1.$) {
						case 0:
							return $elm$html$Html$text('Por favor, defina um período desejado ou utilize as datas padrão para realizar a busca.');
						case 1:
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[$author$project$Components$View$loading]));
						case 2:
							var err = _v1.a;
							return $elm$html$Html$text(
								$author$project$Services$Api$errorToUserMessage(err));
						default:
							if (!_v1.a.b) {
								return $elm$html$Html$text('Nenhum registro encontrado');
							} else {
								var guides = _v1.a;
								return $elm$core$List$isEmpty(guides) ? $elm$html$Html$text('Nenhuma guia encontrada para os filtros selecionados.') : A2($author$project$Pages$Admin$PaymentGuides$viewTable, shared.kS, guides);
							}
					}
				}()
				]));
	});
var $author$project$Pages$Admin$PaymentGuides$ClickedDownload = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Admin$PaymentGuides$ClickedManualPay = {$: 10};
var $author$project$Pages$Admin$PaymentGuides$CloseModal = {$: 12};
var $author$project$Pages$Admin$PaymentGuides$viewPageModal = function (_v0) {
	var isLoading = _v0.dP;
	var guide = _v0.eM;
	var _v1 = guide.qt;
	if (_v1.$ === 1) {
		return $elm$html$Html$text('');
	} else {
		var url = _v1.a;
		var totalValue = $author$project$Utils$formatMoneyInput(
			$elm$core$String$fromInt(guide.lo));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('modal-overlay')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('modal-container modal-dashboard modal-comprar-creditos')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('header-modal')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h3,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Pagar Guia')
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('action-header'),
											$elm$html$Html$Events$onClick($author$project$Pages$Admin$PaymentGuides$CloseModal)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('fechar-ico')
												]),
											_List_Nil)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('modal-content center-modal')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Escolha como deseja pagar a guia no valor de '),
											A2(
											$elm$html$Html$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('R$ ' + totalValue)
												])),
											$elm$html$Html$text('.'),
											A2($elm$html$Html$br, _List_Nil, _List_Nil),
											A2($elm$html$Html$br, _List_Nil, _List_Nil),
											$elm$html$Html$text('Obs: Após o pagamento o processamento pode levar até 40 horas, após processado           a compra será efetuada        ')
										])),
									isLoading ? $author$project$Components$View$loading : A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('buttons')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('btn-ce btn-no-ico'),
													$elm$html$Html$Events$onClick(
													$author$project$Pages$Admin$PaymentGuides$ClickedDownload(url))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Baixar PDF')
												])),
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('btn-ce btn-no-ico'),
													$elm$html$Html$Events$onClick($author$project$Pages$Admin$PaymentGuides$ClickedManualPay)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Pagar manualmente')
												]))
										]))
								]))
						]))
				]));
	}
};
var $author$project$Pages$Admin$PaymentGuides$view = F3(
	function (model, shared, user) {
		return _Utils_Tuple3(
			'Guias',
			A3($author$project$Pages$Admin$PaymentGuides$viewPage, model, shared, user),
			function () {
				var _v0 = model.aY;
				if (_v0.$ === 1) {
					return $elm$html$Html$text('');
				} else {
					var modal = _v0.a;
					return $author$project$Pages$Admin$PaymentGuides$viewPageModal(modal);
				}
			}());
	});
var $author$project$Components$PDF$Create$CloseModal = {$: 3};
var $author$project$Components$PDF$Create$InputtedReportName = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Attributes$novalidate = $elm$html$Html$Attributes$boolProperty('noValidate');
var $author$project$Components$Patterns$Forms$Button = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$PDF$Create$ClickedPage = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Services$Pdf$Page = 1;
var $author$project$Components$PDF$Create$viewActionIsShowCurrentPage = F4(
	function (titleButton, pageType, formStatus, exportType) {
		return $author$project$Components$Patterns$Forms$Button(
			{
				lx: _List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-full')
					]),
				l_: A2($author$project$Components$PDF$Create$ClickedPage, exportType, 1),
				iH: (formStatus === 2) || A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						$elm$core$Basics$eq(1),
						pageType)),
				fD: titleButton
			});
	});
var $author$project$Services$Pdf$Full = 0;
var $author$project$Components$PDF$Create$viewActionIsShowEntirePeriodPage = F4(
	function (titleButton, pageType, formStatus, exportType) {
		return $author$project$Components$Patterns$Forms$Button(
			{
				lx: _List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-full')
					]),
				l_: A2($author$project$Components$PDF$Create$ClickedPage, exportType, 0),
				iH: (formStatus === 2) || A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						$elm$core$Basics$eq(0),
						pageType)),
				fD: titleButton
			});
	});
var $author$project$Components$PDF$Create$viewModalCsv = F2(
	function (_v0, modal) {
		var isShowCurrentPage = _v0.a;
		var isShowEntirePeriodPage = _v0.b;
		return $author$project$Components$Patterns$Modal$simple(
			{
				hY: $elm$core$Maybe$Just(
					A2($elm$html$Html$Attributes$style, 'min-height', 'fit-content')),
				ii: '',
				il: '',
				ip: $author$project$Components$PDF$Create$CloseModal,
				fD: 'Gerar CSV',
				k4: A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('modal-content')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('center-modal')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Defina como você gostaria de gerar o CSV:')
										]))
								])),
							$author$project$Components$Patterns$Forms$formSimple(
							{
								hZ: _List_fromArray(
									[
										$elm$html$Html$Attributes$class('w-full'),
										$elm$html$Html$Attributes$novalidate(true)
									]),
								L: modal.L,
								jf: _Utils_ap(
									_List_fromArray(
										[
											$author$project$Components$Patterns$Forms$Input(
											{
												ie: $elm$core$Maybe$Nothing,
												iH: modal.L === 2,
												iP: _List_Nil,
												nR: _List_fromArray(
													[
														$elm$html$Html$Attributes$size(40)
													]),
												jl: $elm$core$Maybe$Just('Dê um nome ao seu relatório (Opcional)'),
												jn: _List_fromArray(
													[
														$elm$html$Html$Attributes$class('flex flex-col mb-6 mt-4'),
														A2($elm$html$Html$Attributes$style, 'width', 'max-content')
													]),
												n9: $elm$core$Maybe$Just(40),
												c3: 'Campo nome do relatório',
												jE: $elm$core$Maybe$Nothing,
												jF: $elm$core$Maybe$Nothing,
												jG: $elm$core$Maybe$Nothing,
												ov: $elm$core$Maybe$Nothing,
												jI: $elm$core$Maybe$Just(
													A2($elm$core$Basics$composeR, $author$project$Components$Patterns$Forms$strMaybe, $author$project$Components$PDF$Create$InputtedReportName)),
												hh: '',
												kE: modal.L === 1,
												kY: 'text',
												k1: _List_Nil,
												di: A2($elm$core$Maybe$withDefault, '', modal.da)
											})
										]),
									function () {
										var _v1 = _Utils_Tuple2(isShowCurrentPage, isShowEntirePeriodPage);
										if (_v1.a) {
											if (_v1.b) {
												return _List_fromArray(
													[
														A2(
														$author$project$Components$Patterns$Forms$Custom,
														'flex gap-4',
														_List_fromArray(
															[
																A4($author$project$Components$PDF$Create$viewActionIsShowCurrentPage, 'Página atual', modal.R, modal.L, modal.Y),
																A4($author$project$Components$PDF$Create$viewActionIsShowEntirePeriodPage, 'Todo o período', modal.R, modal.L, modal.Y)
															]))
													]);
											} else {
												return $elm$core$List$singleton(
													A4($author$project$Components$PDF$Create$viewActionIsShowCurrentPage, 'Gerar', modal.R, modal.L, modal.Y));
											}
										} else {
											if (_v1.b) {
												return $elm$core$List$singleton(
													A4($author$project$Components$PDF$Create$viewActionIsShowEntirePeriodPage, 'Gerar', modal.R, modal.L, modal.Y));
											} else {
												return _List_Nil;
											}
										}
									}()),
								oc: $elm$core$Maybe$Nothing,
								pX: 'Pesquisar'
							})
						])),
				k5: $elm$html$Html$text('')
			});
	});
var $author$project$Components$PDF$Create$viewModalPdf = F2(
	function (_v0, modal) {
		var isShowCurrentPage = _v0.a;
		var isShowEntirePeriodPage = _v0.b;
		return $author$project$Components$Patterns$Modal$simple(
			{
				hY: $elm$core$Maybe$Just(
					A2($elm$html$Html$Attributes$style, 'min-height', 'fit-content')),
				ii: '',
				il: '',
				ip: $author$project$Components$PDF$Create$CloseModal,
				fD: 'Gerar PDF',
				k4: A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('modal-content')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('center-modal')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Defina como você gostaria de gerar o PDF:')
										]))
								])),
							$author$project$Components$Patterns$Forms$formSimple(
							{
								hZ: _List_fromArray(
									[
										$elm$html$Html$Attributes$class('w-full'),
										$elm$html$Html$Attributes$novalidate(true)
									]),
								L: modal.L,
								jf: _Utils_ap(
									_List_fromArray(
										[
											$author$project$Components$Patterns$Forms$Input(
											{
												ie: $elm$core$Maybe$Nothing,
												iH: modal.L === 2,
												iP: _List_Nil,
												nR: _List_fromArray(
													[
														$elm$html$Html$Attributes$size(40)
													]),
												jl: $elm$core$Maybe$Just('Dê um nome ao seu relatório (Opcional)'),
												jn: _List_fromArray(
													[
														$elm$html$Html$Attributes$class('flex flex-col mb-6 mt-4'),
														A2($elm$html$Html$Attributes$style, 'width', 'max-content')
													]),
												n9: $elm$core$Maybe$Just(40),
												c3: 'Campo nome do relatório',
												jE: $elm$core$Maybe$Nothing,
												jF: $elm$core$Maybe$Nothing,
												jG: $elm$core$Maybe$Nothing,
												ov: $elm$core$Maybe$Nothing,
												jI: $elm$core$Maybe$Just(
													A2($elm$core$Basics$composeR, $author$project$Components$Patterns$Forms$strMaybe, $author$project$Components$PDF$Create$InputtedReportName)),
												hh: '',
												kE: modal.L === 1,
												kY: 'text',
												k1: _List_Nil,
												di: A2($elm$core$Maybe$withDefault, '', modal.da)
											})
										]),
									function () {
										var _v1 = _Utils_Tuple2(isShowCurrentPage, isShowEntirePeriodPage);
										if (_v1.a) {
											if (_v1.b) {
												return _List_fromArray(
													[
														A4($author$project$Components$PDF$Create$viewActionIsShowCurrentPage, 'Página atual', modal.R, modal.L, modal.Y),
														A4($author$project$Components$PDF$Create$viewActionIsShowEntirePeriodPage, 'Todo o período', modal.R, modal.L, modal.Y)
													]);
											} else {
												return $elm$core$List$singleton(
													A4($author$project$Components$PDF$Create$viewActionIsShowCurrentPage, 'Gerar', modal.R, modal.L, modal.Y));
											}
										} else {
											if (_v1.b) {
												return $elm$core$List$singleton(
													A4($author$project$Components$PDF$Create$viewActionIsShowEntirePeriodPage, 'Gerar', modal.R, modal.L, modal.Y));
											} else {
												return _List_Nil;
											}
										}
									}()),
								oc: $elm$core$Maybe$Nothing,
								pX: 'Pesquisar'
							})
						])),
				k5: $elm$html$Html$text('')
			});
	});
var $author$project$Components$PDF$Create$viewModal = function (modal) {
	var _v0 = modal.Y;
	if (!_v0) {
		return A2(
			$author$project$Components$PDF$Create$viewModalPdf,
			_Utils_Tuple2(modal.eY, modal.eZ),
			modal);
	} else {
		return A2(
			$author$project$Components$PDF$Create$viewModalCsv,
			_Utils_Tuple2(modal.eY, modal.eZ),
			modal);
	}
};
var $author$project$Components$Patterns$Forms$ButtonIcon = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Admin$Reports$Sales$ClickedGenerateReport = F3(
	function (a, b, c) {
		return {$: 17, a: a, b: b, c: c};
	});
var $author$project$Services$Pdf$Csv = 1;
var $author$project$Pages$Admin$Reports$Sales$ExpandFilters = {$: 12};
var $author$project$Pages$Admin$Reports$Sales$InputtedEnd = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Admin$Reports$Sales$InputtedStart = function (a) {
	return {$: 7, a: a};
};
var $author$project$Services$Pdf$Sales = 8;
var $author$project$Components$Patterns$Forms$Select = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$Reports$Sales$SelectedOperator = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$Reports$Sales$SelectedPaymentMethod = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Patterns$SalesSummaryCard$emphasisItem = F2(
	function (label, value) {
		return {eI: true, jl: label, di: value};
	});
var $author$project$Components$Patterns$SalesSummaryCard$item = F2(
	function (label, value) {
		return {eI: false, jl: label, di: value};
	});
var $author$project$Pages$Admin$Reports$Sales$listTuplePaymentMethod = _List_fromArray(
	[
		_Utils_Tuple2('boleto', 'Boleto'),
		_Utils_Tuple2('credit_card', 'Cartão de Crédito'),
		_Utils_Tuple2('ticket_window_credit_card', 'Cartão de Crédito no guichê'),
		_Utils_Tuple2('ticket_window_debit_card', 'Cartão de Débito no guichê'),
		_Utils_Tuple2('ticket_window_cash', 'Dinheiro no guichê'),
		_Utils_Tuple2('estorno', 'Estorno'),
		_Utils_Tuple2('guia_local', 'Guia de Pagamento'),
		_Utils_Tuple2('pix', 'Pix')
	]);
var $author$project$Pages$Admin$Reports$Sales$valueNotEmpty = function (str) {
	return $elm$core$String$isEmpty(str) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(str);
};
var $author$project$Components$Patterns$SalesSummaryCard$viewMetric = F2(
	function (isEmphasis, metric) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('sales-summary-card__metric'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('sales-summary-card__metric--emphasis', isEmphasis)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sales-summary-card__label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(metric.jl)
						])),
					A2(
					$elm$html$Html$strong,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sales-summary-card__value')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$formatAsMoney(
								$elm$core$String$fromInt(metric.di)))
						]))
				]));
	});
var $author$project$Components$Patterns$SalesSummaryCard$view = function (options) {
	var _v0 = A2(
		$elm$core$List$partition,
		function ($) {
			return $.eI;
		},
		options.jk);
	var emphasized = _v0.a;
	var regular = _v0.b;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('sales-summary-card')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('sales-summary-card__metrics')
					]),
				_Utils_ap(
					A2(
						$elm$core$List$map,
						$author$project$Components$Patterns$SalesSummaryCard$viewMetric(false),
						regular),
					A2(
						$elm$core$List$map,
						$author$project$Components$Patterns$SalesSummaryCard$viewMetric(true),
						emphasized))),
				function () {
				var _v1 = options.ns;
				if (!_v1.$) {
					var note = _v1.a;
					return A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('sales-summary-card__footnote')
							]),
						_List_fromArray(
							[note]));
				} else {
					return $elm$html$Html$text('');
				}
			}()
			]));
};
var $author$project$Pages$Admin$Reports$Sales$RequestRefund = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Admin$Reports$Sales$viewBtnToRequestRefund = F2(
	function (user, row) {
		return (row.lL && ((!row.lm) && A2(
			$elm$core$List$member,
			$author$project$Services$Models$REFUNDS_GUICHE(0),
			user.hg))) ? A4(
			$author$project$Components$Patterns$Button$icon,
			$author$project$Pages$Admin$Reports$Sales$RequestRefund(row),
			'icon-md',
			'undo',
			'Solicitar estorno') : $elm$html$Html$text('');
	});
var $author$project$Pages$Admin$Reports$Sales$PrintSalesReceipt = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Admin$Reports$Sales$isValidPrintCoupon = function (paymentMethodCODE) {
	return A2(
		$elm$core$List$any,
		$elm$core$Basics$eq(paymentMethodCODE),
		_List_fromArray(
			['debit_card', 'credit_card', 'ticket_window_cash']));
};
var $author$project$Pages$Admin$Reports$Sales$viewButtonToPrintCoupon = function (row) {
	return $author$project$Pages$Admin$Reports$Sales$isValidPrintCoupon(row.oQ) ? A4(
		$author$project$Components$Patterns$Button$icon,
		$author$project$Pages$Admin$Reports$Sales$PrintSalesReceipt(row),
		'icon-md',
		'receipt',
		'Imprimir cupom') : $elm$html$Html$text('');
};
var $author$project$Pages$Admin$Reports$Sales$viewOriginBadge = function (origin) {
	var modifier = function () {
		switch (origin) {
			case 'Empresa':
				return 'origin-badge--empresa';
			case 'Aplicativo':
				return 'origin-badge--aplicativo';
			case 'Guichê':
				return 'origin-badge--guiche';
			case 'WhatsApp':
				return 'origin-badge--whatsapp';
			default:
				return 'origin-badge--default';
		}
	}();
	return ((origin === '-') || $elm$core$String$isEmpty(origin)) ? $elm$html$Html$text('-') : A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('origin-badge ' + modifier)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('origin-badge__dot')
					]),
				_List_Nil),
				$elm$html$Html$text(origin)
			]));
};
var $author$project$Pages$Admin$Reports$Sales$viewRow = F4(
	function (user, hasIss, timezone, row) {
		var valueViewMoney = function (value) {
			return A2(
				$elm$core$Maybe$withDefault,
				'-',
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $author$project$Utils$formatAsMoney),
					value));
		};
		var valueView = function (v) {
			return (row.s === 'Estorno') ? A2(
				$elm$core$Basics$composeR,
				valueViewMoney,
				function (v_) {
					return '( ' + (v_ + ' )');
				})(v) : valueViewMoney(v);
		};
		var valueClass = function (paymentMethod) {
			return (paymentMethod === 'Estorno') ? $elm$html$Html$Attributes$class('text-red-500') : A2($elm$html$Html$Attributes$style, '', '');
		};
		var viewTdsIss = hasIss ? _List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						valueClass(row.s),
						A2($elm$html$Html$Attributes$style, 'text-wrap', 'nowrap')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						valueView(
							$elm$core$Maybe$Just(row.nA)))
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'text-wrap', 'nowrap')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						valueViewMoney(
							$elm$core$Maybe$Just(row.e_)))
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						valueClass(row.s),
						A2($elm$html$Html$Attributes$style, 'text-wrap', 'nowrap')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						valueView(
							$elm$core$Maybe$Just(
								$author$project$Pages$Admin$Reports$Sales$saleValueOf(row))))
					]))
			]) : _List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						valueClass(row.s),
						A2($elm$html$Html$Attributes$style, 'text-wrap', 'nowrap')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						valueView(
							$elm$core$Maybe$Just(
								$author$project$Pages$Admin$Reports$Sales$saleValueOf(row))))
					]))
			]);
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($author$project$Utils$formatDateTimeWithSecondsFromPosix, timezone, row.cO))
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Pages$Admin$Reports$Sales$viewOriginBadge(row.a$)
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(row.s)
							]))
					]),
				_Utils_ap(
					viewTdsIss,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'text-wrap', 'nowrap')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($author$project$Pages$Admin$Reports$Sales$feeView, row.s, row.ey))
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									valueClass(row.s),
									A2($elm$html$Html$Attributes$style, 'text-wrap', 'nowrap')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									valueView(
										$elm$core$Maybe$Just(
											$author$project$Pages$Admin$Reports$Sales$paidValueOf(row))))
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'text-wrap', 'nowrap')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($author$project$Pages$Admin$Reports$Sales$feeView, row.s, row.fe))
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									valueClass(row.s),
									A2($elm$html$Html$Attributes$style, 'text-wrap', 'nowrap')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									valueView(
										$elm$core$Maybe$Just(
											$author$project$Pages$Admin$Reports$Sales$netValueOf(row))))
								])),
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(row.k7)
								])),
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(row.lO)
								])),
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(row.f$)
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex gap-2')
								]),
							_List_fromArray(
								[
									$author$project$Pages$Admin$Reports$Sales$viewButtonToPrintCoupon(row),
									A2($author$project$Pages$Admin$Reports$Sales$viewBtnToRequestRefund, user, row)
								]))
						]))));
	});
var $elm$html$Html$tfoot = _VirtualDom_node('tfoot');
var $author$project$Pages$Admin$Reports$Sales$viewTableFooter = F2(
	function (hasIss, rows) {
		var sumBy = F2(
			function (f, rows_) {
				return $elm$core$List$sum(
					A2($elm$core$List$map, f, rows_));
			});
		var reversal = A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.s;
				},
				$elm$core$Basics$eq('Estorno')),
			rows);
		var nonReversal = A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.s;
				},
				$elm$core$Basics$neq('Estorno')),
			rows);
		var salesCount = $elm$core$List$length(nonReversal);
		var netOf = function (f) {
			return A2(sumBy, f, nonReversal) - $elm$core$Basics$abs(
				A2(sumBy, f, reversal));
		};
		var money = function (v) {
			return $author$project$Utils$formatAsMoney(
				$elm$core$String$fromInt(v));
		};
		var totalsIss = hasIss ? _List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'text-wrap', 'nowrap')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						money(
							A2(
								sumBy,
								function ($) {
									return $.nA;
								},
								nonReversal)))
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'text-wrap', 'nowrap')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						money(
							A2(
								sumBy,
								function ($) {
									return $.e_;
								},
								nonReversal)))
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'text-wrap', 'nowrap')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						money(
							netOf($author$project$Pages$Admin$Reports$Sales$saleValueOf)))
					]))
			]) : _List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'text-wrap', 'nowrap')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						money(
							netOf($author$project$Pages$Admin$Reports$Sales$saleValueOf)))
					]))
			]);
		return A2(
			$elm$html$Html$tfoot,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$tr,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('font-bold')
						]),
					_Utils_ap(
						_List_fromArray(
							[
								A2(
								$elm$html$Html$td,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Totais no período')
									])),
								A2($elm$html$Html$td, _List_Nil, _List_Nil),
								A2(
								$elm$html$Html$td,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(salesCount) + ' vendas')
									]))
							]),
						_Utils_ap(
							totalsIss,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$td,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'text-wrap', 'nowrap')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											money(
												A2(
													sumBy,
													function ($) {
														return $.ey;
													},
													nonReversal)))
										])),
									A2(
									$elm$html$Html$td,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'text-wrap', 'nowrap')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											money(
												netOf($author$project$Pages$Admin$Reports$Sales$paidValueOf)))
										])),
									A2(
									$elm$html$Html$td,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'text-wrap', 'nowrap')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											money(
												A2(
													sumBy,
													function ($) {
														return $.fe;
													},
													nonReversal)))
										])),
									A2(
									$elm$html$Html$td,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'text-wrap', 'nowrap')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											money(
												netOf($author$project$Pages$Admin$Reports$Sales$netValueOf)))
										])),
									A2($elm$html$Html$td, _List_Nil, _List_Nil),
									A2($elm$html$Html$td, _List_Nil, _List_Nil),
									A2($elm$html$Html$td, _List_Nil, _List_Nil),
									A2($elm$html$Html$td, _List_Nil, _List_Nil)
								]))))
				]));
	});
var $author$project$Pages$Admin$Reports$Sales$viewTable = F3(
	function (user, timezone, rows) {
		var hasIss = A2(
			$elm$core$List$any,
			function (_v0) {
				var issTaxValue = _v0.e_;
				return issTaxValue > 0;
			},
			rows);
		var headersIss = hasIss ? _List_fromArray(
			[
				A2(
				$elm$html$Html$th,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Valor Bruto')
					])),
				A2(
				$elm$html$Html$th,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Desconto ISS')
					])),
				A2(
				$elm$html$Html$th,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Valor Líquido')
					]))
			]) : _List_fromArray(
			[
				A2(
				$elm$html$Html$th,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Valor')
					]))
			]);
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'cellspacing', '0'),
					$elm$html$Html$Attributes$class('data-table-dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$thead,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tr,
							_List_Nil,
							_Utils_ap(
								_List_fromArray(
									[
										A2(
										$elm$html$Html$th,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Data')
											])),
										A2(
										$elm$html$Html$th,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Operador')
											])),
										A2(
										$elm$html$Html$th,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Tipo de Pagamento')
											]))
									]),
								_Utils_ap(
									headersIss,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Taxa Conveniência')
												])),
											A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Valor Pago')
												])),
											A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Taxa Pagar.me')
												])),
											A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Valor Líquido')
												])),
											A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Carteira')
												])),
											A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Cartão')
												])),
											A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Nome')
												])),
											A2($elm$html$Html$th, _List_Nil, _List_Nil)
										]))))
						])),
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					A2(
						$elm$core$List$map,
						A3($author$project$Pages$Admin$Reports$Sales$viewRow, user, hasIss, timezone),
						rows)),
					A2($author$project$Pages$Admin$Reports$Sales$viewTableFooter, hasIss, rows)
				]));
	});
var $author$project$Pages$Admin$Reports$Sales$viewPage = F3(
	function (model, shared, user) {
		var incUnique = F2(
			function (elem, lst) {
				var _v4 = A2(
					$elm$core$List$filter,
					function (x) {
						return _Utils_eq(x.a, elem.a);
					},
					lst);
				if (!_v4.b) {
					return A2($elm$core$List$cons, elem, lst);
				} else {
					return lst;
				}
			});
		var listSelectOperator = function (reports) {
			return A3(
				$elm$core$List$foldl,
				incUnique,
				_List_Nil,
				A2(
					$elm$core$List$filterMap,
					function (rr) {
						return ((rr.a$ === '-') || $elm$core$String$isEmpty(rr.a$)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
							_Utils_Tuple2(rr.a$, rr.a$));
					},
					reports));
		};
		var hasPeriodCSV = A2(
			$krisajenkins$remotedata$RemoteData$withDefault,
			false,
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.D;
					},
					A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not)),
				model.ck));
		var filters = _List_fromArray(
			[
				$author$project$Components$Patterns$Forms$Input(
				{
					ie: $elm$core$Maybe$Nothing,
					iH: model.L === 2,
					iP: _List_Nil,
					nR: _List_fromArray(
						[
							$elm$html$Html$Attributes$size(10)
						]),
					jl: $elm$core$Maybe$Just('Início'),
					jn: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col'),
							A2($elm$html$Html$Attributes$style, 'width', 'min-content')
						]),
					n9: $elm$core$Maybe$Just(10),
					c3: '',
					jE: $elm$core$Maybe$Nothing,
					jF: $elm$core$Maybe$Nothing,
					jG: $elm$core$Maybe$Nothing,
					ov: $elm$core$Maybe$Nothing,
					jI: $elm$core$Maybe$Just(
						A2($elm$core$Basics$composeR, $author$project$Pages$Admin$Reports$Sales$valueNotEmpty, $author$project$Pages$Admin$Reports$Sales$InputtedStart)),
					hh: 'Início',
					kE: model.L === 1,
					kY: 'date',
					k1: _List_Nil,
					di: A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.eb;
							},
							model.cO))
				}),
				$author$project$Components$Patterns$Forms$Input(
				{
					ie: $elm$core$Maybe$Nothing,
					iH: model.L === 2,
					iP: _List_Nil,
					nR: _List_fromArray(
						[
							$elm$html$Html$Attributes$size(10)
						]),
					jl: $elm$core$Maybe$Just('Fim'),
					jn: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col'),
							A2($elm$html$Html$Attributes$style, 'width', 'min-content')
						]),
					n9: $elm$core$Maybe$Just(10),
					c3: '',
					jE: $elm$core$Maybe$Nothing,
					jF: $elm$core$Maybe$Nothing,
					jG: $elm$core$Maybe$Nothing,
					ov: $elm$core$Maybe$Nothing,
					jI: $elm$core$Maybe$Just(
						A2($elm$core$Basics$composeR, $author$project$Pages$Admin$Reports$Sales$valueNotEmpty, $author$project$Pages$Admin$Reports$Sales$InputtedEnd)),
					hh: 'Fim',
					kE: model.L === 1,
					kY: 'date',
					k1: _List_Nil,
					di: A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.dH;
							},
							model.cO))
				}),
				$author$project$Components$Patterns$Forms$Select(
				{
					iH: model.L === 2,
					jl: $elm$core$Maybe$Just('Tipo de pagamento'),
					jn: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col justify-end'),
							A2($elm$html$Html$Attributes$style, 'width', 'fit-content')
						]),
					jI: $elm$core$Maybe$Just($author$project$Pages$Admin$Reports$Sales$SelectedPaymentMethod),
					jO: A2(
						$elm$core$List$map,
						function (_v3) {
							var id = _v3.a;
							var name = _v3.b;
							return {
								eX: _Utils_eq(
									id,
									A2($elm$core$Maybe$withDefault, '', model.cn)),
								c3: name,
								di: id
							};
						},
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2('', 'Todos'),
							$author$project$Pages$Admin$Reports$Sales$listTuplePaymentMethod)),
					jQ: false,
					ks: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('mt-2'),
							A2($elm$html$Html$Attributes$style, 'margin-bottom', '0')
						]),
					kE: model.L === 1,
					k1: _List_Nil
				}),
				$author$project$Components$Patterns$Forms$ButtonIcon(
				{
					lx: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('self-center w-40')
						]),
					l_: $author$project$Pages$Admin$Reports$Sales$ExpandFilters,
					l4: 'filter_list',
					iH: model.L === 2,
					fD: 'Filtros extra'
				}),
				$author$project$Components$Patterns$Forms$Button(
				{
					lx: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('self-center w-40')
						]),
					l_: $author$project$Pages$Admin$Reports$Sales$Submit,
					iH: model.L === 2,
					fD: 'Pesquisar'
				})
			]);
		var buttonCsv = (!_Utils_eq(model.cO, $elm$core$Maybe$Nothing)) ? _List_fromArray(
			[
				$author$project$Components$Patterns$Forms$Button(
				{
					lx: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('self-center w-40')
						]),
					l_: A3(
						$author$project$Pages$Admin$Reports$Sales$ClickedGenerateReport,
						_Utils_Tuple2(hasPeriodCSV, true),
						1,
						8),
					iH: model.L === 2,
					fD: 'Baixar CSV'
				})
			]) : _List_Nil;
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard admin-reports')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('top-actions')
						]),
					_List_fromArray(
						[
							A2($elm$html$Html$div, _List_Nil, _List_Nil),
							A2($elm$html$Html$div, _List_Nil, _List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('report-types')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$author$project$Route$href(
									A2(
										$author$project$Route$Admin,
										$author$project$Route$Reports($author$project$Services$Models$initQueriesSalesV2),
										$author$project$Route$extractConcessionaireId(shared.pv))),
									$elm$html$Html$Attributes$class('active')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Vendas')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex')
						]),
					_List_fromArray(
						[
							$author$project$Components$Patterns$Forms$formSimple(
							{
								hZ: _List_fromArray(
									[
										$elm$html$Html$Attributes$class('w-full'),
										$elm$html$Html$Attributes$novalidate(true)
									]),
								L: model.L,
								jf: _List_fromArray(
									[
										A2(
										$author$project$Components$Patterns$Forms$Custom,
										'flex gap-3',
										_Utils_ap(filters, buttonCsv)),
										A2(
										$author$project$Components$Patterns$Forms$Custom,
										'mt-4 flex flex-col gap-3',
										function () {
											var _v0 = _Utils_Tuple2(
												model.dK,
												A2(
													$krisajenkins$remotedata$RemoteData$map,
													function ($) {
														return $.D;
													},
													model.ck));
											if (_v0.a && (_v0.b.$ === 3)) {
												var reports = _v0.b.a;
												return _List_fromArray(
													[
														$author$project$Components$Patterns$Forms$Html(
														A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('flex gap-2 ')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$h3,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('text-black font-bold')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Filtro dinâmico')
																		])),
																	A2(
																	$elm$html$Html$span,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('material-symbols-outlined cursor-help'),
																			A2($elm$html$Html$Attributes$style, 'cursor', 'help'),
																			$elm$html$Html$Attributes$title('Filtro de relatório relativo ao resultado atual'),
																			$elm$html$Html$Attributes$alt('Filtro de relatório relativo ao resultado atual')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('info')
																		]))
																]))),
														$author$project$Components$Patterns$Forms$Select(
														{
															iH: model.L === 2,
															jl: $elm$core$Maybe$Just('Operador'),
															jn: _List_fromArray(
																[
																	$elm$html$Html$Attributes$class('flex flex-col justify-end'),
																	A2($elm$html$Html$Attributes$style, 'width', 'max-content')
																]),
															jI: $elm$core$Maybe$Just($author$project$Pages$Admin$Reports$Sales$SelectedOperator),
															jO: A2(
																$elm$core$List$map,
																function (_v1) {
																	var id = _v1.a;
																	var name = _v1.b;
																	return {
																		eX: _Utils_eq(
																			id,
																			A2($elm$core$Maybe$withDefault, '', model.a5)),
																		c3: name,
																		di: id
																	};
																},
																A2(
																	$elm$core$List$cons,
																	_Utils_Tuple2('', 'Todos'),
																	listSelectOperator(reports))),
															jQ: false,
															ks: _List_fromArray(
																[
																	$elm$html$Html$Attributes$class('mt-2'),
																	A2($elm$html$Html$Attributes$style, 'margin-bottom', '0')
																]),
															kE: model.L === 1,
															k1: _List_Nil
														})
													]);
											} else {
												return _List_Nil;
											}
										}())
									]),
								oc: $elm$core$Maybe$Nothing,
								pX: 'Pesquisar'
							})
						])),
					function () {
					var _v2 = A2(
						$krisajenkins$remotedata$RemoteData$map,
						function ($) {
							return $.D;
						},
						model.ck);
					switch (_v2.$) {
						case 0:
							return $elm$html$Html$text('Por favor, defina um período desejado ou utilize as datas padrão para realizar a busca.');
						case 1:
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[$author$project$Components$View$loading]));
						case 2:
							return $elm$html$Html$text('Ops! Algo deu errado');
						default:
							if (!_v2.a.b) {
								return $elm$html$Html$text('Não foram encontrados registros para o período escolhido');
							} else {
								var rows = _v2.a;
								var sumBy = F2(
									function (f, rows_) {
										return $elm$core$List$sum(
											A2($elm$core$List$map, f, rows_));
									});
								var rowFiltered = A2(
									$elm$core$Maybe$withDefault,
									rows,
									A2(
										$elm$core$Maybe$map,
										function (op) {
											return A2(
												$elm$core$List$filter,
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.a$;
													},
													$elm$core$Basics$eq(op)),
												rows);
										},
										model.a5));
								var reversal = A2(
									$elm$core$List$filter,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.s;
										},
										$elm$core$Basics$eq('Estorno')),
									rowFiltered);
								var nonReversal = A2(
									$elm$core$List$filter,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.s;
										},
										$elm$core$Basics$neq('Estorno')),
									rowFiltered);
								var totalConvenience = A2(
									sumBy,
									function ($) {
										return $.ey;
									},
									nonReversal);
								var totalPagarme = A2(
									sumBy,
									function ($) {
										return $.fe;
									},
									nonReversal);
								var netOf = function (f) {
									return A2(sumBy, f, nonReversal) - $elm$core$Basics$abs(
										A2(sumBy, f, reversal));
								};
								var totalPaidByPassengers = netOf($author$project$Pages$Admin$Reports$Sales$paidValueOf);
								var totalSales = netOf($author$project$Pages$Admin$Reports$Sales$saleValueOf);
								return A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A3($author$project$Pages$Admin$Reports$Sales$viewTable, user, shared.kS, rowFiltered),
											$author$project$Components$Patterns$SalesSummaryCard$view(
											{
												ns: $elm$core$Maybe$Nothing,
												jk: _List_fromArray(
													[
														A2($author$project$Components$Patterns$SalesSummaryCard$item, 'Total de vendas', totalSales),
														A2($author$project$Components$Patterns$SalesSummaryCard$item, 'Taxas Pagar.me', totalPagarme),
														A2($author$project$Components$Patterns$SalesSummaryCard$item, 'Taxas conveniência', totalConvenience),
														A2($author$project$Components$Patterns$SalesSummaryCard$emphasisItem, 'Total pago pelos passageiros', totalPaidByPassengers)
													])
											})
										]));
							}
					}
				}()
				]));
	});
var $author$project$Pages$Admin$Reports$Sales$view = F3(
	function (model, shared, user) {
		var viewModal = function () {
			var _v0 = model.bQ.aY;
			if (!_v0.$) {
				var m_ = _v0.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$Admin$Reports$Sales$CompPDFCreateMSg,
					$author$project$Components$PDF$Create$viewModal(m_));
			} else {
				return $elm$html$Html$text('');
			}
		}();
		return _Utils_Tuple3(
			'Relatório Vendas',
			A3($author$project$Pages$Admin$Reports$Sales$viewPage, model, shared, user),
			viewModal);
	});
var $author$project$Pages$Admin$SalesReport$GetTimeToDownload = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Admin$SalesReport$InputSearch = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$SalesReport$InputtedEnd = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Admin$SalesReport$InputtedStart = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Admin$SalesReport$viewRow = F2(
	function (timezone, row) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Utils$formatDateTimeFromPosix, timezone, row.kk))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(row.kl)
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(row.km)
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$formatAsMoney(
								$elm$core$String$fromInt(row.ht)))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(row.io)
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(row.$9)
						]))
				]));
	});
var $author$project$Pages$Admin$SalesReport$viewTable = F2(
	function (timezone, rows) {
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'cellspacing', '0'),
					$elm$html$Html$Attributes$class('data-table-dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$thead,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Data')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Operador')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Tipo de Pagamento')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Valor (R$)')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Nome')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Cartão')
										]))
								]))
						])),
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					A2(
						$elm$core$List$map,
						$author$project$Pages$Admin$SalesReport$viewRow(timezone),
						rows))
				]));
	});
var $author$project$Pages$Admin$SalesReport$viewPage = F3(
	function (model, shared, user) {
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard admin-reports')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('top-actions')
						]),
					_List_fromArray(
						[
							A2($elm$html$Html$div, _List_Nil, _List_Nil),
							A2($elm$html$Html$div, _List_Nil, _List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('report-types')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$author$project$Route$href(
									A2(
										$author$project$Route$Admin,
										$author$project$Route$AccountabilityReport,
										$author$project$Route$extractConcessionaireId(shared.pv)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Arrecadação')
								])),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$author$project$Route$href(
									A2(
										$author$project$Route$Admin,
										$author$project$Route$SalesReport,
										$author$project$Route$extractConcessionaireId(shared.pv))),
									$elm$html$Html$Attributes$class('active')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Vendas')
								])),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$author$project$Route$href(
									A2(
										$author$project$Route$Admin,
										$author$project$Route$SessionsReport,
										$author$project$Route$extractConcessionaireId(shared.pv)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Sessões')
								]))
						])),
					A2(
					$elm$html$Html$form,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('filtros-container report-sales'),
							$elm$html$Html$Events$onSubmit($author$project$Pages$Admin$SalesReport$MsgUpdateSearch)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Início'),
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$value(
											A2(
												$elm$core$Maybe$withDefault,
												'',
												A2(
													$elm$core$Maybe$map,
													function ($) {
														return $.eb;
													},
													model.cO))),
											$elm$html$Html$Attributes$type_('date'),
											$elm$html$Html$Events$onInput($author$project$Pages$Admin$SalesReport$InputtedStart)
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Fim'),
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$value(
											A2(
												$elm$core$Maybe$withDefault,
												'',
												A2(
													$elm$core$Maybe$map,
													function ($) {
														return $.dH;
													},
													model.cO))),
											$elm$html$Html$Attributes$type_('date'),
											$elm$html$Html$Events$onInput($author$project$Pages$Admin$SalesReport$InputtedEnd)
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Operador'),
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('bg-busca-right'),
											$elm$html$Html$Attributes$placeholder('Todos'),
											$elm$html$Html$Attributes$type_('text'),
											$elm$html$Html$Events$onInput($author$project$Pages$Admin$SalesReport$InputSearch)
										]),
									_List_Nil)
								])),
							A2(
							$author$project$Components$View$searchButton,
							'',
							$krisajenkins$remotedata$RemoteData$isLoading(model.ck)),
							function () {
							var _v0 = model.ck;
							if (_v0.$ === 3) {
								if (!_v0.a.b) {
									return $elm$html$Html$text('');
								} else {
									var rows = _v0.a;
									return $author$project$Components$GeneratorCSV$buttonDownload(
										$author$project$Pages$Admin$SalesReport$GetTimeToDownload(rows));
								}
							} else {
								return $elm$html$Html$text('');
							}
						}()
						])),
					function () {
					var _v1 = model.ck;
					switch (_v1.$) {
						case 0:
							return $elm$html$Html$text('Por favor, defina um período desejado ou utilize as datas padrão para realizar a busca.');
						case 1:
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[$author$project$Components$View$loading]));
						case 2:
							return $elm$html$Html$text('Ops! Algo deu errado');
						default:
							if (!_v1.a.b) {
								return $elm$html$Html$text('Nenhum registro encontrado');
							} else {
								var rows = _v1.a;
								return A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2($author$project$Pages$Admin$SalesReport$viewTable, shared.kS, rows),
											function () {
											var totaValue = A3(
												$elm$core$List$foldl,
												F2(
													function (row, acc) {
														return row.ht + acc;
													}),
												0,
												rows);
											return A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('bottom-actions flex justify-between')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$p,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('selecionados')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$strong,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('Totais no período')
																	])),
																A2(
																$elm$html$Html$strong,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		$author$project$Utils$formatAsMoney(
																			$elm$core$String$fromInt(totaValue)))
																	]))
															]))
													]));
										}()
										]));
							}
					}
				}()
				]));
	});
var $author$project$Pages$Admin$SalesReport$view = F3(
	function (model, shared, user) {
		return _Utils_Tuple3(
			'Relatório Vendas',
			A3($author$project$Pages$Admin$SalesReport$viewPage, model, shared, user),
			$elm$html$Html$text(''));
	});
var $author$project$Pages$Admin$SessionWithoutPouchReport$GetTimeToDownload = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Admin$SessionWithoutPouchReport$GotFilter = {$: 9};
var $author$project$Pages$Admin$SessionWithoutPouchReport$InputSearchLine = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$SessionWithoutPouchReport$InputSearchOperator = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$SessionWithoutPouchReport$InputVehicle = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Admin$SessionWithoutPouchReport$InputtedEnd = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Admin$SessionWithoutPouchReport$InputtedStart = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Admin$SessionWithoutPouchReport$alignCenter = A2($elm$html$Html$Attributes$style, 'text-align', 'center');
var $elm$html$Html$Attributes$colspan = function (n) {
	return A2(
		_VirtualDom_attribute,
		'colspan',
		$elm$core$String$fromInt(n));
};
var $author$project$Pages$Admin$SessionWithoutPouchReport$viewRow = F3(
	function (allClasses, timezone, row) {
		var classCells = A2(
			$elm$core$List$map,
			function (_class) {
				return A2(
					$elm$html$Html$td,
					_List_fromArray(
						[$author$project$Pages$Admin$SessionWithoutPouchReport$alignCenter]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(_class.di))
						]));
			},
			A2(
				$elm$core$List$sortBy,
				function ($) {
					return $.c3;
				},
				A3(
					$elm$core$List$foldl,
					F2(
						function (className, acc) {
							return function (v) {
								return A2($elm$core$List$cons, v, acc);
							}(
								A2(
									$elm$core$Maybe$withDefault,
									{c3: className, di: 0},
									$elm$core$List$head(
										A2(
											$elm$core$List$filter,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.c3;
												},
												$elm$core$Basics$eq(className)),
											row.dv))));
						}),
					_List_Nil,
					allClasses)));
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.l4;
										},
										row.k2)))
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Utils$emptyStrDefault(row.e1))
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($author$project$Utils$formatDateTimeFromMaybePosix, timezone, row.jJ)),
								A2($elm$html$Html$br, _List_Nil, _List_Nil),
								$elm$html$Html$text(
								A2($author$project$Utils$formatDateTimeFromMaybePosix, timezone, row.iq))
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Utils$emptyStrDefault(row.fb)),
								($elm$core$List$length(classCells) > 3) ? A2($elm$html$Html$br, _List_Nil, _List_Nil) : $elm$html$Html$text(''),
								$elm$html$Html$text(
								function () {
									var _v0 = _Utils_Tuple2(row.fb, row.jN);
									if (_v0.b === '') {
										return ' | -';
									} else {
										var str = _v0.a;
										var str2 = _v0.b;
										return (!_Utils_eq(str, str2)) ? (' | ' + str2) : '';
									}
								}())
							]))
					]),
				_Utils_ap(
					classCells,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Admin$SessionWithoutPouchReport$alignCenter]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(row.im))
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Admin$SessionWithoutPouchReport$alignCenter]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(row.i_))
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Admin$SessionWithoutPouchReport$alignCenter]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(row.iZ))
								]))
						]))));
	});
var $author$project$Pages$Admin$SessionWithoutPouchReport$viewTable = F3(
	function (allClasses, timezone, rows) {
		var lastRow = A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'font-weight', 'bold'),
					A2($elm$html$Html$Attributes$style, 'font-size', '20px')
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$colspan(4)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Totais no período')
							]))
					]),
				_Utils_ap(
					A2(
						$elm$core$List$map,
						function (className) {
							return function (v) {
								return A2(
									$elm$html$Html$td,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'color', '#6e46c8'),
											$author$project$Pages$Admin$SessionWithoutPouchReport$alignCenter
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$core$String$fromInt(v))
										]));
							}(
								A3(
									$elm$core$List$foldl,
									F2(
										function (class_, acc) {
											return _Utils_eq(class_.c3, className) ? (acc + class_.di) : acc;
										}),
									0,
									A2(
										$elm$core$List$concatMap,
										function ($) {
											return $.dv;
										},
										rows)));
						},
						allClasses),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'color', '#6e46c8'),
									$author$project$Pages$Admin$SessionWithoutPouchReport$alignCenter
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(
										A3(
											$elm$core$List$foldl,
											$elm$core$Basics$add,
											0,
											A2(
												$elm$core$List$map,
												function ($) {
													return $.di;
												},
												A2(
													$elm$core$List$concatMap,
													function ($) {
														return $.dv;
													},
													rows)))))
								])),
							A2($elm$html$Html$td, _List_Nil, _List_Nil),
							A2($elm$html$Html$td, _List_Nil, _List_Nil)
						]))));
		var classColumns = A2(
			$elm$core$List$map,
			function (className) {
				return A2(
					$elm$html$Html$th,
					_List_fromArray(
						[
							$author$project$Pages$Admin$SessionWithoutPouchReport$alignCenter,
							$elm$html$Html$Attributes$alt(className)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('tooltip')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$toUpper(
										A2($elm$core$String$left, 3, className))),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('tooltiptext')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(className)
										]))
								]))
						]));
			},
			allClasses);
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'cellspacing', '0'),
					$elm$html$Html$Attributes$class('data-table-dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$thead,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tr,
							_List_Nil,
							_Utils_ap(
								_List_fromArray(
									[
										A2(
										$elm$html$Html$th,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Veículo')
											])),
										A2(
										$elm$html$Html$th,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Linha')
											])),
										A2(
										$elm$html$Html$th,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Abertura/Fechamento')
											])),
										A2(
										$elm$html$Html$th,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Operadores')
											]))
									]),
								_Utils_ap(
									classColumns,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$th,
											_List_fromArray(
												[$author$project$Pages$Admin$SessionWithoutPouchReport$alignCenter]),
											_List_fromArray(
												[
													$elm$html$Html$text('Total')
												])),
											A2(
											$elm$html$Html$th,
											_List_fromArray(
												[$author$project$Pages$Admin$SessionWithoutPouchReport$alignCenter]),
											_List_fromArray(
												[
													$elm$html$Html$text('Catraca Inicial')
												])),
											A2(
											$elm$html$Html$th,
											_List_fromArray(
												[$author$project$Pages$Admin$SessionWithoutPouchReport$alignCenter]),
											_List_fromArray(
												[
													$elm$html$Html$text('Final')
												]))
										]))))
						])),
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					function (rows_) {
						return _Utils_ap(
							rows_,
							_List_fromArray(
								[lastRow]));
					}(
						A2(
							$elm$core$List$map,
							A2($author$project$Pages$Admin$SessionWithoutPouchReport$viewRow, allClasses, timezone),
							rows)))
				]));
	});
var $author$project$Pages$Admin$SessionWithoutPouchReport$viewPage = F3(
	function (model, shared, user) {
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard admin-reports')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('top-actions'),
							A2($elm$html$Html$Attributes$style, 'justify-content', 'center')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h2,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'color', 'black'),
									$elm$html$Html$Attributes$class('inner-center')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Sessões sem malote')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('report-types')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$form,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('filtros-container report-sessions flex-wrap'),
							$elm$html$Html$Events$onSubmit($author$project$Pages$Admin$SessionWithoutPouchReport$GotFilter)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Início'),
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$value(
											A2(
												$elm$core$Maybe$withDefault,
												'',
												A2(
													$elm$core$Maybe$map,
													function ($) {
														return $.eb;
													},
													model.cO))),
											$elm$html$Html$Attributes$type_('date'),
											$elm$html$Html$Events$onInput($author$project$Pages$Admin$SessionWithoutPouchReport$InputtedStart)
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Fim'),
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$value(
											A2(
												$elm$core$Maybe$withDefault,
												'',
												A2(
													$elm$core$Maybe$map,
													function ($) {
														return $.dH;
													},
													model.cO))),
											$elm$html$Html$Attributes$type_('date'),
											$elm$html$Html$Events$onInput($author$project$Pages$Admin$SessionWithoutPouchReport$InputtedEnd)
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Operador'),
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('bg-busca-right'),
											$elm$html$Html$Attributes$placeholder('Todos'),
											$elm$html$Html$Attributes$type_('text'),
											$elm$html$Html$Events$onInput($author$project$Pages$Admin$SessionWithoutPouchReport$InputSearchOperator)
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Linha'),
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('bg-busca-right'),
											$elm$html$Html$Attributes$placeholder('Todas'),
											$elm$html$Html$Attributes$type_('text'),
											$elm$html$Html$Events$onInput($author$project$Pages$Admin$SessionWithoutPouchReport$InputSearchLine)
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Veículo'),
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('bg-busca-right'),
											$elm$html$Html$Attributes$placeholder('Todos'),
											$elm$html$Html$Attributes$type_('text'),
											$elm$html$Html$Events$onInput($author$project$Pages$Admin$SessionWithoutPouchReport$InputVehicle)
										]),
									_List_Nil)
								])),
							A2(
							$author$project$Components$View$searchButton,
							'',
							$krisajenkins$remotedata$RemoteData$isLoading(model.ck)),
							function () {
							var _v0 = model.ck;
							if (_v0.$ === 3) {
								if (!_v0.a.b) {
									return $elm$html$Html$text('');
								} else {
									var rows = _v0.a;
									return $author$project$Components$GeneratorCSV$buttonDownload(
										$author$project$Pages$Admin$SessionWithoutPouchReport$GetTimeToDownload(rows));
								}
							} else {
								return $elm$html$Html$text('');
							}
						}()
						])),
					function () {
					var _v1 = model.ck;
					switch (_v1.$) {
						case 0:
							return $elm$html$Html$text('Por favor, defina um período desejado ou utilize as datas padrão para realizar a busca.');
						case 1:
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[$author$project$Components$View$loading]));
						case 2:
							return $elm$html$Html$text('Ops! Algo deu errado');
						default:
							var rows = _v1.a;
							var allClasses = $elm$core$List$sort(
								$elm$core$Set$toList(
									$elm$core$Set$fromList(
										$elm$core$List$concat(
											A2(
												$elm$core$List$map,
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.dv;
													},
													$elm$core$List$map(
														function ($) {
															return $.c3;
														})),
												rows)))));
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A3($author$project$Pages$Admin$SessionWithoutPouchReport$viewTable, allClasses, shared.kS, rows)
									]));
					}
				}()
				]));
	});
var $author$project$Pages$Admin$SessionWithoutPouchReport$view = F3(
	function (model, shared, user) {
		return _Utils_Tuple3(
			'Relatório Sessões',
			A3($author$project$Pages$Admin$SessionWithoutPouchReport$viewPage, model, shared, user),
			$elm$html$Html$text(''));
	});
var $author$project$Pages$Admin$SessionsReport$GetTimeToDownload = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Admin$SessionsReport$GotFilter = {$: 9};
var $author$project$Pages$Admin$SessionsReport$InputSearchLine = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$SessionsReport$InputSearchOperator = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$SessionsReport$InputVehicle = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Admin$SessionsReport$InputtedEnd = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Admin$SessionsReport$InputtedStart = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Admin$SessionsReport$alignCenter = A2($elm$html$Html$Attributes$style, 'text-align', 'center');
var $author$project$Pages$Admin$SessionsReport$viewRow = F3(
	function (allClasses, timezone, row) {
		var classCells = A2(
			$elm$core$List$map,
			function (_class) {
				return A2(
					$elm$html$Html$td,
					_List_fromArray(
						[$author$project$Pages$Admin$SessionsReport$alignCenter]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(_class.di))
						]));
			},
			A2(
				$elm$core$List$sortBy,
				function ($) {
					return $.c3;
				},
				A3(
					$elm$core$List$foldl,
					F2(
						function (className, acc) {
							return function (v) {
								return A2($elm$core$List$cons, v, acc);
							}(
								A2(
									$elm$core$Maybe$withDefault,
									{c3: className, di: 0},
									$elm$core$List$head(
										A2(
											$elm$core$List$filter,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.c3;
												},
												$elm$core$Basics$eq(className)),
											row.dv))));
						}),
					_List_Nil,
					allClasses)));
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.l4;
										},
										row.k2)))
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Utils$emptyStrDefault(row.e1))
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($author$project$Utils$formatDateTimeFromMaybePosix, timezone, row.jJ)),
								A2($elm$html$Html$br, _List_Nil, _List_Nil),
								$elm$html$Html$text(
								A2($author$project$Utils$formatDateTimeFromMaybePosix, timezone, row.iq))
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Utils$emptyStrDefault(row.fb)),
								($elm$core$List$length(classCells) > 3) ? A2($elm$html$Html$br, _List_Nil, _List_Nil) : $elm$html$Html$text(''),
								$elm$html$Html$text(
								function () {
									var _v0 = _Utils_Tuple2(row.fb, row.jN);
									if (_v0.b === '') {
										return ' | -';
									} else {
										var str = _v0.a;
										var str2 = _v0.b;
										return (!_Utils_eq(str, str2)) ? (' | ' + str2) : '';
									}
								}())
							]))
					]),
				_Utils_ap(
					classCells,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Admin$SessionsReport$alignCenter]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(row.im))
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Admin$SessionsReport$alignCenter]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(row.i_))
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[$author$project$Pages$Admin$SessionsReport$alignCenter]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(row.iZ))
								]))
						]))));
	});
var $author$project$Pages$Admin$SessionsReport$viewTable = F3(
	function (allClasses, timezone, rows) {
		var lastRow = A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'font-weight', 'bold'),
					A2($elm$html$Html$Attributes$style, 'font-size', '20px')
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$colspan(4)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Totais no período')
							]))
					]),
				_Utils_ap(
					A2(
						$elm$core$List$map,
						function (className) {
							return function (v) {
								return A2(
									$elm$html$Html$td,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'color', '#6e46c8'),
											$author$project$Pages$Admin$SessionsReport$alignCenter
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$core$String$fromInt(v))
										]));
							}(
								A3(
									$elm$core$List$foldl,
									F2(
										function (class_, acc) {
											return _Utils_eq(class_.c3, className) ? (acc + class_.di) : acc;
										}),
									0,
									A2(
										$elm$core$List$concatMap,
										function ($) {
											return $.dv;
										},
										rows)));
						},
						allClasses),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'color', '#6e46c8'),
									$author$project$Pages$Admin$SessionsReport$alignCenter
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(
										A3(
											$elm$core$List$foldl,
											$elm$core$Basics$add,
											0,
											A2(
												$elm$core$List$map,
												function ($) {
													return $.di;
												},
												A2(
													$elm$core$List$concatMap,
													function ($) {
														return $.dv;
													},
													rows)))))
								])),
							A2($elm$html$Html$td, _List_Nil, _List_Nil),
							A2($elm$html$Html$td, _List_Nil, _List_Nil)
						]))));
		var classColumns = A2(
			$elm$core$List$map,
			function (className) {
				return A2(
					$elm$html$Html$th,
					_List_fromArray(
						[
							$author$project$Pages$Admin$SessionsReport$alignCenter,
							$elm$html$Html$Attributes$alt(className)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('tooltip')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$toUpper(
										A2($elm$core$String$left, 3, className))),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('tooltiptext')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(className)
										]))
								]))
						]));
			},
			allClasses);
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'cellspacing', '0'),
					$elm$html$Html$Attributes$class('data-table-dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$thead,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tr,
							_List_Nil,
							_Utils_ap(
								_List_fromArray(
									[
										A2(
										$elm$html$Html$th,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Veículo')
											])),
										A2(
										$elm$html$Html$th,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Linha')
											])),
										A2(
										$elm$html$Html$th,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Abertura/Fechamento')
											])),
										A2(
										$elm$html$Html$th,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Operadores')
											]))
									]),
								_Utils_ap(
									classColumns,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$th,
											_List_fromArray(
												[$author$project$Pages$Admin$SessionsReport$alignCenter]),
											_List_fromArray(
												[
													$elm$html$Html$text('Total')
												])),
											A2(
											$elm$html$Html$th,
											_List_fromArray(
												[$author$project$Pages$Admin$SessionsReport$alignCenter]),
											_List_fromArray(
												[
													$elm$html$Html$text('Catraca Inicial')
												])),
											A2(
											$elm$html$Html$th,
											_List_fromArray(
												[$author$project$Pages$Admin$SessionsReport$alignCenter]),
											_List_fromArray(
												[
													$elm$html$Html$text('Final')
												]))
										]))))
						])),
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					function (rows_) {
						return _Utils_ap(
							rows_,
							_List_fromArray(
								[lastRow]));
					}(
						A2(
							$elm$core$List$map,
							A2($author$project$Pages$Admin$SessionsReport$viewRow, allClasses, timezone),
							rows)))
				]));
	});
var $author$project$Pages$Admin$SessionsReport$viewPage = F3(
	function (model, shared, user) {
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard admin-reports')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('top-actions')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('report-types')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$author$project$Route$href(
									A2(
										$author$project$Route$Admin,
										$author$project$Route$AccountabilityReport,
										$author$project$Route$extractConcessionaireId(shared.pv)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Arrecadação')
								])),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$author$project$Route$href(
									A2(
										$author$project$Route$Admin,
										$author$project$Route$SalesReport,
										$author$project$Route$extractConcessionaireId(shared.pv)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Vendas')
								])),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$author$project$Route$href(
									A2(
										$author$project$Route$Admin,
										$author$project$Route$SessionsReport,
										$author$project$Route$extractConcessionaireId(shared.pv))),
									$elm$html$Html$Attributes$class('active')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Sessões')
								]))
						])),
					A2(
					$elm$html$Html$form,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('filtros-container report-sessions flex-wrap'),
							$elm$html$Html$Events$onSubmit($author$project$Pages$Admin$SessionsReport$GotFilter)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Início'),
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$value(
											A2(
												$elm$core$Maybe$withDefault,
												'',
												A2(
													$elm$core$Maybe$map,
													function ($) {
														return $.eb;
													},
													model.cO))),
											$elm$html$Html$Attributes$type_('date'),
											$elm$html$Html$Events$onInput($author$project$Pages$Admin$SessionsReport$InputtedStart)
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Fim'),
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$value(
											A2(
												$elm$core$Maybe$withDefault,
												'',
												A2(
													$elm$core$Maybe$map,
													function ($) {
														return $.dH;
													},
													model.cO))),
											$elm$html$Html$Attributes$type_('date'),
											$elm$html$Html$Events$onInput($author$project$Pages$Admin$SessionsReport$InputtedEnd)
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Operador'),
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('bg-busca-right'),
											$elm$html$Html$Attributes$placeholder('Todos'),
											$elm$html$Html$Attributes$type_('text'),
											$elm$html$Html$Events$onInput($author$project$Pages$Admin$SessionsReport$InputSearchOperator)
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Linha'),
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('bg-busca-right'),
											$elm$html$Html$Attributes$placeholder('Todas'),
											$elm$html$Html$Attributes$type_('text'),
											$elm$html$Html$Events$onInput($author$project$Pages$Admin$SessionsReport$InputSearchLine)
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Veículo'),
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('bg-busca-right'),
											$elm$html$Html$Attributes$placeholder('Todos'),
											$elm$html$Html$Attributes$type_('text'),
											$elm$html$Html$Events$onInput($author$project$Pages$Admin$SessionsReport$InputVehicle)
										]),
									_List_Nil)
								])),
							A2(
							$author$project$Components$View$searchButton,
							'',
							$krisajenkins$remotedata$RemoteData$isLoading(model.ck)),
							function () {
							var _v0 = model.ck;
							if (_v0.$ === 3) {
								if (!_v0.a.b) {
									return $elm$html$Html$text('');
								} else {
									var rows = _v0.a;
									return $author$project$Components$GeneratorCSV$buttonDownload(
										$author$project$Pages$Admin$SessionsReport$GetTimeToDownload(rows));
								}
							} else {
								return $elm$html$Html$text('');
							}
						}()
						])),
					function () {
					var _v1 = model.ck;
					switch (_v1.$) {
						case 0:
							return $elm$html$Html$text('Por favor, defina um período desejado ou utilize as datas padrão para realizar a busca.');
						case 1:
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[$author$project$Components$View$loading]));
						case 2:
							return $elm$html$Html$text('Ops! Algo deu errado');
						default:
							if (!_v1.a.b) {
								return $elm$html$Html$text('Nenhum registro encontrado');
							} else {
								var rows = _v1.a;
								var allClasses = $elm$core$List$sort(
									$elm$core$Set$toList(
										$elm$core$Set$fromList(
											$elm$core$List$concat(
												A2(
													$elm$core$List$map,
													A2(
														$elm$core$Basics$composeR,
														function ($) {
															return $.dv;
														},
														$elm$core$List$map(
															function ($) {
																return $.c3;
															})),
													rows)))));
								return A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A3($author$project$Pages$Admin$SessionsReport$viewTable, allClasses, shared.kS, rows)
										]));
							}
					}
				}()
				]));
	});
var $author$project$Pages$Admin$SessionsReport$view = F3(
	function (model, shared, user) {
		return _Utils_Tuple3(
			'Relatório Sessões',
			A3($author$project$Pages$Admin$SessionsReport$viewPage, model, shared, user),
			$elm$html$Html$text(''));
	});
var $author$project$Pages$Admin$Users$AddUserModal_InputEmail = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Admin$Users$AddUserModal_InputName = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Admin$Users$AddUserModal_Previous = {$: 8};
var $author$project$Pages$Admin$Users$AddUserModal_SelectPermission = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Admin$Users$AddUserModal_SelectProfile = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Admin$Users$CloseModal = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$h4 = _VirtualDom_node('h4');
var $author$project$Utils$sublist = F2(
	function (size, xs) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (x, _v0) {
					var section = _v0.a;
					var sections = _v0.b;
					return _Utils_eq(
						$elm$core$List$length(section),
						size - 1) ? _Utils_Tuple2(
						_List_Nil,
						_Utils_ap(
							sections,
							_List_fromArray(
								[
									_Utils_ap(
									section,
									_List_fromArray(
										[x]))
								]))) : _Utils_Tuple2(
						_Utils_ap(
							section,
							_List_fromArray(
								[x])),
						sections);
				}),
			_Utils_Tuple2(_List_Nil, _List_Nil),
			xs).b;
	});
var $author$project$Pages$Admin$Users$viewCheckBox = function (options) {
	return A2(
		$elm$html$Html$label,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('c-custom')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('checkbox'),
						$elm$html$Html$Events$onClick(options.jG),
						$elm$html$Html$Attributes$checked(options.ie),
						$elm$html$Html$Attributes$disabled(options.iH)
					]),
				_List_Nil),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('checkmark')
					]),
				_List_Nil),
				$elm$html$Html$text(options.c3)
			]));
};
var $author$project$Pages$Admin$Users$viewSelectProfiles = F3(
	function (selectedPermissions, profiles, onClick) {
		var filtered = A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.c3;
				},
				A2(
					$elm$core$Basics$composeR,
					$elm$core$String$startsWith('DEV-'),
					$elm$core$Basics$not)),
			profiles);
		return A2(
			$elm$html$Html$article,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('blue-subtitle')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Perfis')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('checkbox-two-lines-container')
						]),
					A2(
						$elm$core$List$map,
						function (p_) {
							return $author$project$Pages$Admin$Users$viewCheckBox(
								{
									ie: A2($elm$core$List$member, p_, selectedPermissions),
									iH: false,
									c3: p_.c3,
									jG: onClick(p_)
								});
						},
						filtered))
				]));
	});
var $author$project$Pages$Admin$Users$viewAddUserForm = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal-overlay')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('modal-container modal-dashboard modal-cadastro-usuario-sistema')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('header-modal')
							]),
						_List_fromArray(
							[
								$krisajenkins$remotedata$RemoteData$isLoading(model.hV) ? $elm$html$Html$text('') : A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('action-header'),
										$elm$html$Html$Events$onClick($author$project$Pages$Admin$Users$AddUserModal_Previous)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('voltar-ico')
											]),
										_List_Nil)
									])),
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Adicionar Usuário do Sistema')
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('action-header'),
										$elm$html$Html$Events$onClick(
										$author$project$Pages$Admin$Users$CloseModal(true))
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('fechar-ico')
											]),
										_List_Nil)
									]))
							])),
						A2(
						$elm$html$Html$form,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('modal-content')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$input,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$id('input-name'),
														$elm$html$Html$Attributes$placeholder('Nome Completo'),
														$elm$html$Html$Attributes$type_('text'),
														$elm$html$Html$Events$onInput($author$project$Pages$Admin$Users$AddUserModal_InputName),
														$elm$html$Html$Attributes$value(model.c3),
														$elm$html$Html$Attributes$disabled(
														$krisajenkins$remotedata$RemoteData$isLoading(model.hV))
													]),
												_List_Nil),
												A2(
												$elm$html$Html$label,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$input,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$placeholder('Email'),
																$elm$html$Html$Attributes$type_('text'),
																$elm$html$Html$Events$onInput($author$project$Pages$Admin$Users$AddUserModal_InputEmail),
																$elm$html$Html$Attributes$value(model.mX),
																$elm$html$Html$Attributes$disabled(
																$krisajenkins$remotedata$RemoteData$isLoading(model.hV))
															]),
														_List_Nil)
													]))
											]))
									])),
								A3($author$project$Pages$Admin$Users$viewSelectProfiles, model.C, model.aq, $author$project$Pages$Admin$Users$AddUserModal_SelectProfile),
								A2(
								$elm$html$Html$h4,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('blue-subtitle')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Permissões')
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								A2(
									$elm$core$List$map,
									function (permissionsRow) {
										return A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('checkbox-line-container')
												]),
											A2(
												$elm$core$List$map,
												function (permission) {
													return $author$project$Pages$Admin$Users$viewCheckBox(
														{
															ie: !_Utils_eq(
																$elm$core$Maybe$Nothing,
																$elm$core$List$head(
																	A2(
																		$elm$core$List$filter,
																		function (p) {
																			return _Utils_eq(p, permission.di);
																		},
																		model.J))),
															iH: $krisajenkins$remotedata$RemoteData$isLoading(model.hV),
															c3: permission.jl,
															jG: $author$project$Pages$Admin$Users$AddUserModal_SelectPermission(permission.di)
														});
												},
												permissionsRow));
									},
									A2($author$project$Utils$sublist, 2, model.oU)))
							])),
						$krisajenkins$remotedata$RemoteData$isLoading(model.hV) ? $author$project$Components$View$loading : A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('center-modal center-modal-bottom')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('action-system green-btn'),
												$elm$html$Html$Events$onClick($author$project$Pages$Admin$Users$AddUserModal_AddUser)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cadastrar')
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Admin$Users$AddUserModal_InputCpf = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Admin$Users$viewAddUserInputCpf = function (cpf) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal-overlay')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('modal-container modal-dashboard modal-cadastro-usuario-sistema')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('header-modal')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Adicionar Usuário do Sistema')
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('action-header'),
										$elm$html$Html$Events$onClick(
										$author$project$Pages$Admin$Users$CloseModal(true))
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('fechar-ico')
											]),
										_List_Nil)
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('modal-content')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$for('')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$id('input-cpf'),
												$elm$html$Html$Attributes$placeholder('CPF'),
												$elm$html$Html$Attributes$type_('text'),
												$elm$html$Html$Events$onInput($author$project$Pages$Admin$Users$AddUserModal_InputCpf),
												$elm$html$Html$Attributes$value(
												$author$project$Utils$maskCPF(cpf))
											]),
										_List_Nil)
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('center-modal center-modal-bottom')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('action-system green-btn'),
										$elm$html$Html$Events$onClick($author$project$Pages$Admin$Users$AddUserModal_Next)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Continuar')
									]))
							]))
					]))
			]));
};
var $elm$html$Html$Attributes$download = function (fileName) {
	return A2($elm$html$Html$Attributes$stringProperty, 'download', fileName);
};
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $pablohirafuji$elm_qrcode$QRCode$Quartile = 2;
var $pablohirafuji$elm_qrcode$QRCode$QRCode = $elm$core$Basics$identity;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex = F3(
	function (size, row, col) {
		return (size * row) + col;
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$isOccupy = F4(
	function (row, col, size, matrix) {
		var _v0 = A2(
			$elm$core$Array$get,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row, col),
			matrix);
		if ((!_v0.$) && (!_v0.a.$)) {
			return true;
		} else {
			return false;
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$nextModule = function (placement) {
	var row = placement.ki;
	var col = placement.ir;
	var isRight = placement.aX;
	var isUp = placement.dX;
	return isRight ? _Utils_update(
		placement,
		{ir: col - 1, aX: false}) : (isUp ? _Utils_update(
		placement,
		{ir: col + 1, aX: true, ki: row - 1}) : _Utils_update(
		placement,
		{ir: col + 1, aX: true, ki: row + 1}));
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$bitToColor = F2(
	function (_byte, offset) {
		return (1 & (_byte >> (7 - offset))) === 1;
	});
var $elm$core$Elm$JsArray$unsafeSet = _JsArray_unsafeSet;
var $elm$core$Array$setHelp = F4(
	function (shift, index, value, tree) {
		var pos = $elm$core$Array$bitMask & (index >>> shift);
		var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
		if (!_v0.$) {
			var subTree = _v0.a;
			var newSub = A4($elm$core$Array$setHelp, shift - $elm$core$Array$shiftStep, index, value, subTree);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$SubTree(newSub),
				tree);
		} else {
			var values = _v0.a;
			var newLeaf = A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, values);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$Leaf(newLeaf),
				tree);
		}
	});
var $elm$core$Array$set = F3(
	function (index, value, array) {
		var len = array.a;
		var startShift = array.b;
		var tree = array.c;
		var tail = array.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? array : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			tree,
			A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, tail)) : A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			A4($elm$core$Array$setHelp, startShift, index, value, tree),
			tail));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setDataModule = F3(
	function (_v0, _byte, offset) {
		var size = _v0.pJ;
		var row = _v0.ki;
		var col = _v0.ir;
		return A2(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row, col),
			$elm$core$Maybe$Just(
				_Utils_Tuple2(
					false,
					A2($pablohirafuji$elm_qrcode$QRCode$Matrix$bitToColor, _byte, offset))));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$addDataModule = F4(
	function (placement, bytes, offset, matrix) {
		addDataModule:
		while (true) {
			var size = placement.pJ;
			var row = placement.ki;
			var col = placement.ir;
			if (!bytes.b) {
				return matrix;
			} else {
				var head = bytes.a;
				var tail = bytes.b;
				if (offset >= 8) {
					var $temp$placement = placement,
						$temp$bytes = tail,
						$temp$offset = 0,
						$temp$matrix = matrix;
					placement = $temp$placement;
					bytes = $temp$bytes;
					offset = $temp$offset;
					matrix = $temp$matrix;
					continue addDataModule;
				} else {
					if (col === 6) {
						var $temp$placement = _Utils_update(
							placement,
							{ir: col - 1, aX: true}),
							$temp$bytes = bytes,
							$temp$offset = offset,
							$temp$matrix = matrix;
						placement = $temp$placement;
						bytes = $temp$bytes;
						offset = $temp$offset;
						matrix = $temp$matrix;
						continue addDataModule;
					} else {
						if (row < 0) {
							var $temp$placement = _Utils_update(
								placement,
								{ir: col - 2, aX: true, dX: false, ki: 0}),
								$temp$bytes = bytes,
								$temp$offset = offset,
								$temp$matrix = matrix;
							placement = $temp$placement;
							bytes = $temp$bytes;
							offset = $temp$offset;
							matrix = $temp$matrix;
							continue addDataModule;
						} else {
							if (_Utils_cmp(row, size) > -1) {
								var $temp$placement = _Utils_update(
									placement,
									{ir: col - 2, aX: true, dX: true, ki: size - 1}),
									$temp$bytes = bytes,
									$temp$offset = offset,
									$temp$matrix = matrix;
								placement = $temp$placement;
								bytes = $temp$bytes;
								offset = $temp$offset;
								matrix = $temp$matrix;
								continue addDataModule;
							} else {
								if (A4($pablohirafuji$elm_qrcode$QRCode$Matrix$isOccupy, row, col, size, matrix)) {
									var $temp$placement = $pablohirafuji$elm_qrcode$QRCode$Matrix$nextModule(placement),
										$temp$bytes = bytes,
										$temp$offset = offset,
										$temp$matrix = matrix;
									placement = $temp$placement;
									bytes = $temp$bytes;
									offset = $temp$offset;
									matrix = $temp$matrix;
									continue addDataModule;
								} else {
									var $temp$placement = $pablohirafuji$elm_qrcode$QRCode$Matrix$nextModule(placement),
										$temp$bytes = bytes,
										$temp$offset = offset + 1,
										$temp$matrix = A4($pablohirafuji$elm_qrcode$QRCode$Matrix$setDataModule, placement, head, offset, matrix);
									placement = $temp$placement;
									bytes = $temp$bytes;
									offset = $temp$offset;
									matrix = $temp$matrix;
									continue addDataModule;
								}
							}
						}
					}
				}
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$initPlacement = function (size) {
	return {ir: size + 1, aX: true, dX: true, ki: size + 1, pJ: size};
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$addData = F3(
	function (size, bytes, matrix) {
		return A4(
			$pablohirafuji$elm_qrcode$QRCode$Matrix$addDataModule,
			$pablohirafuji$elm_qrcode$QRCode$Matrix$initPlacement(size),
			bytes,
			0,
			matrix);
	});
var $pablohirafuji$elm_qrcode$QRCode$Error$AlignmentPatternNotFound = {$: 0};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentPatternData = $elm$core$Array$fromList(
	_List_fromArray(
		[
			_List_Nil,
			_List_fromArray(
			[6, 18]),
			_List_fromArray(
			[6, 22]),
			_List_fromArray(
			[6, 26]),
			_List_fromArray(
			[6, 30]),
			_List_fromArray(
			[6, 34]),
			_List_fromArray(
			[6, 22, 38]),
			_List_fromArray(
			[6, 24, 42]),
			_List_fromArray(
			[6, 26, 46]),
			_List_fromArray(
			[6, 28, 50]),
			_List_fromArray(
			[6, 30, 54]),
			_List_fromArray(
			[6, 32, 58]),
			_List_fromArray(
			[6, 34, 62]),
			_List_fromArray(
			[6, 26, 46, 66]),
			_List_fromArray(
			[6, 26, 48, 70]),
			_List_fromArray(
			[6, 26, 50, 74]),
			_List_fromArray(
			[6, 30, 54, 78]),
			_List_fromArray(
			[6, 30, 56, 82]),
			_List_fromArray(
			[6, 30, 58, 86]),
			_List_fromArray(
			[6, 34, 62, 90]),
			_List_fromArray(
			[6, 28, 50, 72, 94]),
			_List_fromArray(
			[6, 26, 50, 74, 98]),
			_List_fromArray(
			[6, 30, 54, 78, 102]),
			_List_fromArray(
			[6, 28, 54, 80, 106]),
			_List_fromArray(
			[6, 32, 58, 84, 110]),
			_List_fromArray(
			[6, 30, 58, 86, 114]),
			_List_fromArray(
			[6, 34, 62, 90, 118]),
			_List_fromArray(
			[6, 26, 50, 74, 98, 122]),
			_List_fromArray(
			[6, 30, 54, 78, 102, 126]),
			_List_fromArray(
			[6, 26, 52, 78, 104, 130]),
			_List_fromArray(
			[6, 30, 56, 82, 108, 134]),
			_List_fromArray(
			[6, 34, 60, 86, 112, 138]),
			_List_fromArray(
			[6, 30, 58, 86, 114, 142]),
			_List_fromArray(
			[6, 34, 62, 90, 118, 146]),
			_List_fromArray(
			[6, 30, 54, 78, 102, 126, 150]),
			_List_fromArray(
			[6, 24, 50, 76, 102, 128, 154]),
			_List_fromArray(
			[6, 28, 54, 80, 106, 132, 158]),
			_List_fromArray(
			[6, 32, 58, 84, 110, 136, 162]),
			_List_fromArray(
			[6, 26, 54, 82, 110, 138, 166]),
			_List_fromArray(
			[6, 30, 58, 86, 114, 142, 170])
		]));
var $elm$core$Result$fromMaybe = F2(
	function (err, maybe) {
		if (!maybe.$) {
			var v = maybe.a;
			return $elm$core$Result$Ok(v);
		} else {
			return $elm$core$Result$Err(err);
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getAreaCoord = F2(
	function (rows, cols) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (row, list) {
					return A3(
						$elm$core$List$foldl,
						F2(
							function (col, list_) {
								return A2(
									$elm$core$List$cons,
									_Utils_Tuple2(row, col),
									list_);
							}),
						list,
						cols);
				}),
			_List_Nil,
			rows);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$isValidAlign = F2(
	function (size, _v0) {
		var row = _v0.a;
		var col = _v0.b;
		return ((row > 10) || ((10 < col) && (_Utils_cmp(col, size - 10) < 0))) && ((_Utils_cmp(row, size - 10) < 0) || (col > 10));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentRange = A2($elm$core$List$range, -2, 2);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentColor = F2(
	function (row, col) {
		return (_Utils_eq(row, -2) || ((row === 2) || (_Utils_eq(col, -2) || ((col === 2) || ((!row) && (!col)))))) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(true, true)) : $elm$core$Maybe$Just(
			_Utils_Tuple2(true, false));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignModule = F4(
	function (size, rowPos, colPos, _v0) {
		var row = _v0.a;
		var col = _v0.b;
		return A2(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row + rowPos, col + colPos),
			A2($pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentColor, row, col));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignment = F3(
	function (size, _v0, matrix) {
		var row = _v0.a;
		var col = _v0.b;
		return A3(
			$elm$core$List$foldl,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignModule, size, row, col),
			matrix,
			A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getAreaCoord, $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentRange, $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentRange));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignments = F3(
	function (size, locations, matrix) {
		return A3(
			$elm$core$List$foldl,
			$pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignment(size),
			matrix,
			A2(
				$elm$core$List$filter,
				$pablohirafuji$elm_qrcode$QRCode$Matrix$isValidAlign(size),
				A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getAreaCoord, locations, locations)));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentPattern = F3(
	function (version, size, matrix) {
		return A2(
			$elm$core$Result$map,
			function (a) {
				return A3($pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignments, size, a, matrix);
			},
			A2(
				$elm$core$Result$fromMaybe,
				$pablohirafuji$elm_qrcode$QRCode$Error$AlignmentPatternNotFound,
				A2($elm$core$Array$get, version - 1, $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentPatternData)));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$darkModule = F2(
	function (version, size) {
		return A2(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, (4 * version) + 9, 8),
			$elm$core$Maybe$Just(
				_Utils_Tuple2(true, true)));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$finderRange = A2($elm$core$List$range, 0, 8);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$finderColor = F2(
	function (row, col) {
		return ((1 <= row) && ((row <= 7) && ((col === 1) || (col === 7)))) || (((1 <= col) && ((col <= 7) && ((row === 1) || (row === 7)))) || ((3 <= row) && ((row <= 5) && ((3 <= col) && (col <= 5)))));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setFinder = F5(
	function (size, rowOffset, colOffset, _v0, matrix) {
		var row = _v0.a;
		var col = _v0.b;
		var finalRow = row + rowOffset;
		var finalCol = col + colOffset;
		return ((finalRow < 0) || ((finalCol < 0) || ((_Utils_cmp(finalRow, size) > -1) || (_Utils_cmp(finalCol, size) > -1)))) ? matrix : A3(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, finalRow, finalCol),
			$elm$core$Maybe$Just(
				_Utils_Tuple2(
					true,
					A2($pablohirafuji$elm_qrcode$QRCode$Matrix$finderColor, row, col))),
			matrix);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$finderPattern = F4(
	function (size, rowOffset, colOffset, matrix) {
		return A3(
			$elm$core$List$foldl,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$setFinder, size, rowOffset, colOffset),
			matrix,
			A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getAreaCoord, $pablohirafuji$elm_qrcode$QRCode$Matrix$finderRange, $pablohirafuji$elm_qrcode$QRCode$Matrix$finderRange));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$applyMaskColor = F2(
	function (maybeModule, isChange) {
		if (isChange) {
			if ((!maybeModule.$) && (!maybeModule.a.a)) {
				var _v1 = maybeModule.a;
				var isDark = _v1.b;
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(false, !isDark));
			} else {
				return maybeModule;
			}
		} else {
			return maybeModule;
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getCoord = F2(
	function (size, index) {
		return _Utils_Tuple2(
			(index / size) | 0,
			A2($elm$core$Basics$modBy, size, index));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$applyMaskFunction = F4(
	function (_function, size, index, maybeModule) {
		return A2(
			$pablohirafuji$elm_qrcode$QRCode$Matrix$applyMaskColor,
			maybeModule,
			_function(
				A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getCoord, size, index)));
	});
var $elm$core$Elm$JsArray$foldl = _JsArray_foldl;
var $elm$core$Elm$JsArray$indexedMap = _JsArray_indexedMap;
var $elm$core$Array$indexedMap = F2(
	function (func, _v0) {
		var len = _v0.a;
		var tree = _v0.c;
		var tail = _v0.d;
		var initialBuilder = {
			y: _List_Nil,
			p: 0,
			w: A3(
				$elm$core$Elm$JsArray$indexedMap,
				func,
				$elm$core$Array$tailIndex(len),
				tail)
		};
		var helper = F2(
			function (node, builder) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldl, helper, builder, subTree);
				} else {
					var leaf = node.a;
					var offset = builder.p * $elm$core$Array$branchFactor;
					var mappedLeaf = $elm$core$Array$Leaf(
						A3($elm$core$Elm$JsArray$indexedMap, func, offset, leaf));
					return {
						y: A2($elm$core$List$cons, mappedLeaf, builder.y),
						p: builder.p + 1,
						w: builder.w
					};
				}
			});
		return A2(
			$elm$core$Array$builderToArray,
			true,
			A3($elm$core$Elm$JsArray$foldl, helper, initialBuilder, tree));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$maskFunction = function (mask) {
	switch (mask) {
		case 0:
			return function (_v1) {
				var row = _v1.a;
				var col = _v1.b;
				return !A2($elm$core$Basics$modBy, 2, row + col);
			};
		case 1:
			return function (_v2) {
				var row = _v2.a;
				return !A2($elm$core$Basics$modBy, 2, row);
			};
		case 2:
			return function (_v3) {
				var col = _v3.b;
				return !A2($elm$core$Basics$modBy, 3, col);
			};
		case 3:
			return function (_v4) {
				var row = _v4.a;
				var col = _v4.b;
				return !A2($elm$core$Basics$modBy, 3, row + col);
			};
		case 4:
			return function (_v5) {
				var row = _v5.a;
				var col = _v5.b;
				return !A2(
					$elm$core$Basics$modBy,
					2,
					$elm$core$Basics$floor(row / 2) + $elm$core$Basics$floor(col / 3));
			};
		case 5:
			return function (_v6) {
				var row = _v6.a;
				var col = _v6.b;
				return !(A2($elm$core$Basics$modBy, 2, row * col) + A2($elm$core$Basics$modBy, 3, row * col));
			};
		case 6:
			return function (_v7) {
				var row = _v7.a;
				var col = _v7.b;
				return !A2(
					$elm$core$Basics$modBy,
					2,
					A2($elm$core$Basics$modBy, 2, row * col) + A2($elm$core$Basics$modBy, 3, row * col));
			};
		default:
			return function (_v8) {
				var row = _v8.a;
				var col = _v8.b;
				return !A2(
					$elm$core$Basics$modBy,
					2,
					A2($elm$core$Basics$modBy, 3, row * col) + A2($elm$core$Basics$modBy, 2, row + col));
			};
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$applyMask = F3(
	function (size, mask, matrix) {
		return A2(
			$elm$core$Array$indexedMap,
			A2(
				$pablohirafuji$elm_qrcode$QRCode$Matrix$applyMaskFunction,
				$pablohirafuji$elm_qrcode$QRCode$Matrix$maskFunction(mask),
				size),
			matrix);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$breakList = F3(
	function (width, list, acc) {
		breakList:
		while (true) {
			if (!list.b) {
				return $elm$core$List$reverse(acc);
			} else {
				var $temp$width = width,
					$temp$list = A2($elm$core$List$drop, width, list),
					$temp$acc = A2(
					$elm$core$List$cons,
					A2($elm$core$List$take, width, list),
					acc);
				width = $temp$width;
				list = $temp$list;
				acc = $temp$acc;
				continue breakList;
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$isDarkModule = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map($elm$core$Tuple$second),
	$elm$core$Maybe$withDefault(false));
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score_ = F2(
	function (simplifiedList, _v0) {
		rule1Score_:
		while (true) {
			var last = _v0.a;
			var partialScore = _v0.b;
			var score = _v0.c;
			if (!simplifiedList.b) {
				return (partialScore >= 5) ? ((score + partialScore) - 2) : score;
			} else {
				var head = simplifiedList.a;
				var tail = simplifiedList.b;
				if (_Utils_eq(last, head)) {
					var $temp$simplifiedList = tail,
						$temp$_v0 = _Utils_Tuple3(last, partialScore + 1, score);
					simplifiedList = $temp$simplifiedList;
					_v0 = $temp$_v0;
					continue rule1Score_;
				} else {
					if (partialScore >= 5) {
						var $temp$simplifiedList = tail,
							$temp$_v0 = _Utils_Tuple3(head, 0, (score + partialScore) - 2);
						simplifiedList = $temp$simplifiedList;
						_v0 = $temp$_v0;
						continue rule1Score_;
					} else {
						var $temp$simplifiedList = tail,
							$temp$_v0 = _Utils_Tuple3(head, 0, score);
						simplifiedList = $temp$simplifiedList;
						_v0 = $temp$_v0;
						continue rule1Score_;
					}
				}
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$map(
		function (a) {
			return A2(
				$pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score_,
				a,
				_Utils_Tuple3(false, 0, 0));
		}),
	$elm$core$List$sum);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule2Score_ = F4(
	function (row1, row2, maybeLast, score) {
		rule2Score_:
		while (true) {
			if (!row1.b) {
				return score;
			} else {
				var head = row1.a;
				var tail = row1.b;
				if (!row2.b) {
					return score;
				} else {
					var head2 = row2.a;
					var tail2 = row2.b;
					if (_Utils_eq(head, head2)) {
						if (_Utils_eq(
							$elm$core$Maybe$Just(head),
							maybeLast)) {
							var $temp$row1 = tail,
								$temp$row2 = tail2,
								$temp$maybeLast = $elm$core$Maybe$Just(head),
								$temp$score = score + 3;
							row1 = $temp$row1;
							row2 = $temp$row2;
							maybeLast = $temp$maybeLast;
							score = $temp$score;
							continue rule2Score_;
						} else {
							var $temp$row1 = tail,
								$temp$row2 = tail2,
								$temp$maybeLast = $elm$core$Maybe$Just(head),
								$temp$score = score;
							row1 = $temp$row1;
							row2 = $temp$row2;
							maybeLast = $temp$maybeLast;
							score = $temp$score;
							continue rule2Score_;
						}
					} else {
						var $temp$row1 = tail,
							$temp$row2 = tail2,
							$temp$maybeLast = $elm$core$Maybe$Nothing,
							$temp$score = score;
						row1 = $temp$row1;
						row2 = $temp$row2;
						maybeLast = $temp$maybeLast;
						score = $temp$score;
						continue rule2Score_;
					}
				}
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule2Score = F2(
	function (list, score) {
		rule2Score:
		while (true) {
			if (list.b && list.b.b) {
				var head1 = list.a;
				var _v1 = list.b;
				var head2 = _v1.a;
				var tail = _v1.b;
				var $temp$list = tail,
					$temp$score = score + A4($pablohirafuji$elm_qrcode$QRCode$Matrix$rule2Score_, head1, head2, $elm$core$Maybe$Nothing, 0);
				list = $temp$list;
				score = $temp$score;
				continue rule2Score;
			} else {
				return score;
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule3Score_ = F2(
	function (simplifiedList, score) {
		rule3Score_:
		while (true) {
			_v0$3:
			while (true) {
				if (!simplifiedList.b) {
					return score;
				} else {
					if (!simplifiedList.a) {
						if (((((((((((((((((((simplifiedList.b.b && (!simplifiedList.b.a)) && simplifiedList.b.b.b) && (!simplifiedList.b.b.a)) && simplifiedList.b.b.b.b) && (!simplifiedList.b.b.b.a)) && simplifiedList.b.b.b.b.b) && simplifiedList.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b) && simplifiedList.b.b.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b.b.b) && simplifiedList.b.b.b.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b.b.b.b) && simplifiedList.b.b.b.b.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b.b.b.b.b) && simplifiedList.b.b.b.b.b.b.b.b.b.b.a) {
							var _v1 = simplifiedList.b;
							var _v2 = _v1.b;
							var _v3 = _v2.b;
							var _v4 = _v3.b;
							var _v5 = _v4.b;
							var _v6 = _v5.b;
							var _v7 = _v6.b;
							var _v8 = _v7.b;
							var _v9 = _v8.b;
							var _v10 = _v9.b;
							var tail = _v10.b;
							var $temp$simplifiedList = tail,
								$temp$score = score + 40;
							simplifiedList = $temp$simplifiedList;
							score = $temp$score;
							continue rule3Score_;
						} else {
							break _v0$3;
						}
					} else {
						if (((((((((((((((((((simplifiedList.b.b && (!simplifiedList.b.a)) && simplifiedList.b.b.b) && simplifiedList.b.b.a) && simplifiedList.b.b.b.b) && simplifiedList.b.b.b.a) && simplifiedList.b.b.b.b.b) && simplifiedList.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b) && simplifiedList.b.b.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.b.b.b.b.b.a)) {
							var _v11 = simplifiedList.b;
							var _v12 = _v11.b;
							var _v13 = _v12.b;
							var _v14 = _v13.b;
							var _v15 = _v14.b;
							var _v16 = _v15.b;
							var _v17 = _v16.b;
							var _v18 = _v17.b;
							var _v19 = _v18.b;
							var _v20 = _v19.b;
							var tail = _v20.b;
							var $temp$simplifiedList = tail,
								$temp$score = score + 40;
							simplifiedList = $temp$simplifiedList;
							score = $temp$score;
							continue rule3Score_;
						} else {
							break _v0$3;
						}
					}
				}
			}
			var head = simplifiedList.a;
			var tail = simplifiedList.b;
			var $temp$simplifiedList = tail,
				$temp$score = score;
			simplifiedList = $temp$simplifiedList;
			score = $temp$score;
			continue rule3Score_;
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule3Score = A2($elm$core$List$foldl, $pablohirafuji$elm_qrcode$QRCode$Matrix$rule3Score_, 0);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule4Score = F2(
	function (size, simplifiedList) {
		var moduleCount = size * size;
		var darkCount = $elm$core$List$length(
			A2($elm$core$List$filter, $elm$core$Basics$identity, simplifiedList));
		var darkPerc = $elm$core$Basics$round((100 * darkCount) / moduleCount);
		var remOf5 = darkPerc % 5;
		var nextMult5 = $elm$core$Basics$round(
			$elm$core$Basics$abs((darkPerc + (5 - remOf5)) - 50) / 5);
		var prevMult5 = $elm$core$Basics$round(
			$elm$core$Basics$abs((darkPerc - remOf5) - 50) / 5);
		return A2($elm$core$Basics$min, prevMult5, nextMult5) * 10;
	});
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Helpers$transpose = function (ll) {
	transpose:
	while (true) {
		if (!ll.b) {
			return _List_Nil;
		} else {
			if (!ll.a.b) {
				var xss = ll.b;
				var $temp$ll = xss;
				ll = $temp$ll;
				continue transpose;
			} else {
				var _v1 = ll.a;
				var x = _v1.a;
				var xs = _v1.b;
				var xss = ll.b;
				var tails = A2($elm$core$List$filterMap, $elm$core$List$tail, xss);
				var heads = A2($elm$core$List$filterMap, $elm$core$List$head, xss);
				return A2(
					$elm$core$List$cons,
					A2($elm$core$List$cons, x, heads),
					$pablohirafuji$elm_qrcode$QRCode$Helpers$transpose(
						A2($elm$core$List$cons, xs, tails)));
			}
		}
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getMaskScore = F2(
	function (size, matrix) {
		var list = A2(
			$elm$core$List$map,
			$pablohirafuji$elm_qrcode$QRCode$Matrix$isDarkModule,
			$elm$core$Array$toList(matrix));
		var rowList = A3($pablohirafuji$elm_qrcode$QRCode$Matrix$breakList, size, list, _List_Nil);
		var transposedRowList = $pablohirafuji$elm_qrcode$QRCode$Helpers$transpose(rowList);
		return function (b) {
			return _Utils_Tuple2(rowList, b);
		}(
			A2($pablohirafuji$elm_qrcode$QRCode$Matrix$rule4Score, size, list) + ($pablohirafuji$elm_qrcode$QRCode$Matrix$rule3Score(transposedRowList) + ($pablohirafuji$elm_qrcode$QRCode$Matrix$rule3Score(rowList) + (A2($pablohirafuji$elm_qrcode$QRCode$Matrix$rule2Score, rowList, 0) + ($pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score(transposedRowList) + $pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score(rowList))))));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$ecLevelToInt = function (ecLevel) {
	switch (ecLevel) {
		case 0:
			return 1;
		case 1:
			return 0;
		case 2:
			return 3;
		default:
			return 2;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit = function (_int) {
	var helper = F2(
		function (digit, int_) {
			helper:
			while (true) {
				if (!(!int_)) {
					var $temp$digit = digit + 1,
						$temp$int_ = int_ >>> 1;
					digit = $temp$digit;
					int_ = $temp$int_;
					continue helper;
				} else {
					return digit;
				}
			}
		});
	return A2(helper, 0, _int);
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$maskToInt = function (mask) {
	switch (mask) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		case 4:
			return 4;
		case 5:
			return 5;
		case 6:
			return 6;
		default:
			return 7;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$encodeFormatInfo = F2(
	function (ecLevel, mask) {
		var g15Mask = 21522;
		var g15Int = 1335;
		var g15Digit = $pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(g15Int);
		var formatInfoInt = $pablohirafuji$elm_qrcode$QRCode$Matrix$maskToInt(mask) | ($pablohirafuji$elm_qrcode$QRCode$Matrix$ecLevelToInt(ecLevel) << 3);
		var helper = function (d_) {
			helper:
			while (true) {
				if (($pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(d_) - g15Digit) >= 0) {
					var $temp$d_ = d_ ^ (g15Int << ($pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(d_) - g15Digit));
					d_ = $temp$d_;
					continue helper;
				} else {
					return g15Mask ^ (d_ | (formatInfoInt << 10));
				}
			}
		};
		var d = formatInfoInt << 10;
		return helper(d);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$formatInfoHorizontal = F2(
	function (size, count) {
		return (count < 8) ? _Utils_Tuple2(8, (size - count) - 1) : ((count < 9) ? _Utils_Tuple2(8, 15 - count) : _Utils_Tuple2(8, (15 - count) - 1));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$formatInfoVertical = F2(
	function (size, count) {
		return (count < 6) ? _Utils_Tuple2(count, 8) : ((count < 8) ? _Utils_Tuple2(count + 1, 8) : _Utils_Tuple2((size - 15) + count, 8));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatModule = F4(
	function (size, isBlack, row, col) {
		return A2(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row, col),
			$elm$core$Maybe$Just(
				_Utils_Tuple2(true, isBlack)));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo_ = F4(
	function (size, isBlackFn, count, matrix) {
		setFormatInfo_:
		while (true) {
			if (count < 15) {
				var isBlack = isBlackFn(count);
				var _v0 = A2($pablohirafuji$elm_qrcode$QRCode$Matrix$formatInfoVertical, size, count);
				var x2 = _v0.a;
				var y2 = _v0.b;
				var _v1 = A2($pablohirafuji$elm_qrcode$QRCode$Matrix$formatInfoHorizontal, size, count);
				var x1 = _v1.a;
				var y1 = _v1.b;
				var $temp$size = size,
					$temp$isBlackFn = isBlackFn,
					$temp$count = count + 1,
					$temp$matrix = A5(
					$pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatModule,
					size,
					isBlack,
					x2,
					y2,
					A5($pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatModule, size, isBlack, x1, y1, matrix));
				size = $temp$size;
				isBlackFn = $temp$isBlackFn;
				count = $temp$count;
				matrix = $temp$matrix;
				continue setFormatInfo_;
			} else {
				return matrix;
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo = F4(
	function (ecLevel, size, mask, matrix) {
		var isBlack = F2(
			function (bits_, count) {
				return (1 & (bits_ >> count)) === 1;
			});
		var bits = A2($pablohirafuji$elm_qrcode$QRCode$Matrix$encodeFormatInfo, ecLevel, mask);
		return A4(
			$pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo_,
			size,
			isBlack(bits),
			0,
			matrix);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getBestMask_ = F5(
	function (ecLevel, size, matrix, mask, _v0) {
		var minSMatrix = _v0.a;
		var minScore = _v0.b;
		var maskedMatrix = A4(
			$pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo,
			ecLevel,
			size,
			mask,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$applyMask, size, mask, matrix));
		var _v1 = A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getMaskScore, size, maskedMatrix);
		var maskSMatrix = _v1.a;
		var maskScore = _v1.b;
		return ((_Utils_cmp(minScore, maskScore) < 0) && (!_Utils_eq(minScore, -1))) ? _Utils_Tuple2(minSMatrix, minScore) : _Utils_Tuple2(maskSMatrix, maskScore);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern0 = 0;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern1 = 1;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern2 = 2;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern3 = 3;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern4 = 4;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern5 = 5;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern6 = 6;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern7 = 7;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$patternList = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7]);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getBestMask = F3(
	function (ecLevel, size, matrix) {
		return A3(
			$elm$core$List$foldl,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getBestMask_, ecLevel, size, matrix),
			_Utils_Tuple2(_List_Nil, -1),
			$pablohirafuji$elm_qrcode$QRCode$Matrix$patternList).a;
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$reserveFormatInfo = F2(
	function (size, matrix) {
		return A4(
			$pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo_,
			size,
			$elm$core$Basics$always(true),
			0,
			matrix);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$encodeVersionInfo = function (version) {
	var g18Int = 7973;
	var g18Digit = $pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(g18Int);
	var helper = function (d_) {
		helper:
		while (true) {
			if (($pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(d_) - g18Digit) >= 0) {
				var $temp$d_ = d_ ^ (g18Int << ($pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(d_) - g18Digit));
				d_ = $temp$d_;
				continue helper;
			} else {
				return d_ | (version << 12);
			}
		}
	};
	var d = version << 12;
	return helper(d);
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionModule = F3(
	function (size, isBlack, _v0) {
		var row = _v0.a;
		var col = _v0.b;
		return A2(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row, col),
			$elm$core$Maybe$Just(
				_Utils_Tuple2(true, isBlack)));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionInfo_ = F4(
	function (size, isBlackFn, count, matrix) {
		setVersionInfo_:
		while (true) {
			if (count < 18) {
				var topRight = _Utils_Tuple2(
					$elm$core$Basics$floor(count / 3),
					((A2($elm$core$Basics$modBy, 3, count) + size) - 8) - 3);
				var isBlack = isBlackFn(count);
				var bottomLeft = _Utils_Tuple2(
					((A2($elm$core$Basics$modBy, 3, count) + size) - 8) - 3,
					$elm$core$Basics$floor(count / 3));
				var $temp$size = size,
					$temp$isBlackFn = isBlackFn,
					$temp$count = count + 1,
					$temp$matrix = A4(
					$pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionModule,
					size,
					isBlack,
					bottomLeft,
					A4($pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionModule, size, isBlack, topRight, matrix));
				size = $temp$size;
				isBlackFn = $temp$isBlackFn;
				count = $temp$count;
				matrix = $temp$matrix;
				continue setVersionInfo_;
			} else {
				return matrix;
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionInfo = F3(
	function (version, size, matrix) {
		if (version >= 7) {
			var isBlack = F2(
				function (bits_, count) {
					return (1 & (bits_ >> count)) === 1;
				});
			var bits = $pablohirafuji$elm_qrcode$QRCode$Matrix$encodeVersionInfo(version);
			return A4(
				$pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionInfo_,
				size,
				isBlack(bits),
				0,
				matrix);
		} else {
			return matrix;
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$timingColor = F2(
	function (row, col) {
		return (!A2($elm$core$Basics$modBy, 2, row + col)) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(true, true)) : $elm$core$Maybe$Just(
			_Utils_Tuple2(true, false));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setTiming = F3(
	function (size, row, col) {
		return A2(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row, col),
			A2($pablohirafuji$elm_qrcode$QRCode$Matrix$timingColor, row, col));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$timingPattern = F2(
	function (size, matrix) {
		var range = A2($elm$core$List$range, 8, size - 9);
		return A3(
			$elm$core$List$foldl,
			function (b) {
				return A3($pablohirafuji$elm_qrcode$QRCode$Matrix$setTiming, size, b, 6);
			},
			A3(
				$elm$core$List$foldl,
				A2($pablohirafuji$elm_qrcode$QRCode$Matrix$setTiming, size, 6),
				matrix,
				range),
			range);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$apply = function (_v0) {
	var ecLevel = _v0.a.iJ;
	var groupInfo = _v0.a.nC;
	var bytes = _v0.b;
	var version = groupInfo.k3;
	var size = ((version - 1) * 4) + 21;
	return A2(
		$elm$core$Result$map,
		A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getBestMask, ecLevel, size),
		A2(
			$elm$core$Result$map,
			A2($pablohirafuji$elm_qrcode$QRCode$Matrix$addData, size, bytes),
			A3(
				$pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentPattern,
				version,
				size,
				A2(
					$pablohirafuji$elm_qrcode$QRCode$Matrix$timingPattern,
					size,
					A3(
						$pablohirafuji$elm_qrcode$QRCode$Matrix$darkModule,
						version,
						size,
						A3(
							$pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionInfo,
							version,
							size,
							A2(
								$pablohirafuji$elm_qrcode$QRCode$Matrix$reserveFormatInfo,
								size,
								A4(
									$pablohirafuji$elm_qrcode$QRCode$Matrix$finderPattern,
									size,
									-1,
									size - 8,
									A4(
										$pablohirafuji$elm_qrcode$QRCode$Matrix$finderPattern,
										size,
										size - 8,
										-1,
										A4(
											$pablohirafuji$elm_qrcode$QRCode$Matrix$finderPattern,
											size,
											-1,
											-1,
											A2(
												$elm$core$Array$initialize,
												size * size,
												$elm$core$Basics$always($elm$core$Maybe$Nothing))))))))))));
};
var $pablohirafuji$elm_qrcode$QRCode$ECLevel$H = 3;
var $pablohirafuji$elm_qrcode$QRCode$ECLevel$L = 0;
var $pablohirafuji$elm_qrcode$QRCode$ECLevel$M = 1;
var $pablohirafuji$elm_qrcode$QRCode$ECLevel$Q = 2;
var $pablohirafuji$elm_qrcode$QRCode$convertEC = function (ec) {
	switch (ec) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$AlignmentPatternNotFound = {$: 0};
var $pablohirafuji$elm_qrcode$QRCode$InputLengthOverflow = {$: 7};
var $pablohirafuji$elm_qrcode$QRCode$InvalidAlphanumericChar = {$: 2};
var $pablohirafuji$elm_qrcode$QRCode$InvalidNumericChar = {$: 1};
var $pablohirafuji$elm_qrcode$QRCode$InvalidUTF8Char = {$: 3};
var $pablohirafuji$elm_qrcode$QRCode$LogTableException = function (a) {
	return {$: 4, a: a};
};
var $pablohirafuji$elm_qrcode$QRCode$PolynomialModException = {$: 6};
var $pablohirafuji$elm_qrcode$QRCode$PolynomialMultiplyException = {$: 5};
var $pablohirafuji$elm_qrcode$QRCode$convertError = function (e) {
	switch (e.$) {
		case 0:
			return $pablohirafuji$elm_qrcode$QRCode$AlignmentPatternNotFound;
		case 1:
			return $pablohirafuji$elm_qrcode$QRCode$InvalidNumericChar;
		case 2:
			return $pablohirafuji$elm_qrcode$QRCode$InvalidAlphanumericChar;
		case 3:
			return $pablohirafuji$elm_qrcode$QRCode$InvalidUTF8Char;
		case 4:
			var n = e.a;
			return $pablohirafuji$elm_qrcode$QRCode$LogTableException(n);
		case 5:
			return $pablohirafuji$elm_qrcode$QRCode$PolynomialMultiplyException;
		case 6:
			return $pablohirafuji$elm_qrcode$QRCode$PolynomialModException;
		default:
			return $pablohirafuji$elm_qrcode$QRCode$InputLengthOverflow;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$firstFillerByte = 236;
var $pablohirafuji$elm_qrcode$QRCode$Encode$secondFillerByte = 17;
var $pablohirafuji$elm_qrcode$QRCode$Encode$addFiller = F2(
	function (capacity, bytes) {
		var fillerLength = ((capacity / 8) | 0) - $elm$core$List$length(bytes);
		var ns = $elm$core$List$concat(
			A2(
				$elm$core$List$repeat,
				(fillerLength / 2) | 0,
				_List_fromArray(
					[$pablohirafuji$elm_qrcode$QRCode$Encode$firstFillerByte, $pablohirafuji$elm_qrcode$QRCode$Encode$secondFillerByte])));
		return (!A2($elm$core$Basics$modBy, 2, fillerLength)) ? _Utils_ap(bytes, ns) : _Utils_ap(
			bytes,
			_Utils_ap(
				ns,
				_List_fromArray(
					[$pablohirafuji$elm_qrcode$QRCode$Encode$firstFillerByte])));
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$addTerminator = F3(
	function (capacity, bitsCount, bits) {
		return _Utils_ap(
			bits,
			_List_fromArray(
				[
					_Utils_Tuple2(
					0,
					A2($elm$core$Basics$min, 4, capacity - bitsCount))
				]));
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes3 = function (_v0) {
	bitsToBytes3:
	while (true) {
		var _v1 = _v0.a;
		var bits = _v1.a;
		var length = _v1.b;
		var bytes = _v0.b;
		if (length >= 8) {
			var remLength = length - 8;
			var remBits = bits & ((1 << remLength) - 1);
			var _byte = bits >> remLength;
			var $temp$_v0 = _Utils_Tuple2(
				_Utils_Tuple2(remBits, remLength),
				A2($elm$core$List$cons, _byte, bytes));
			_v0 = $temp$_v0;
			continue bitsToBytes3;
		} else {
			return _Utils_Tuple2(
				_Utils_Tuple2(bits, length),
				bytes);
		}
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes2 = F2(
	function (_v0, _v1) {
		var curBits = _v0.a;
		var curLength = _v0.b;
		var _v2 = _v1.a;
		var remBits = _v2.a;
		var remLength = _v2.b;
		var bytes = _v1.b;
		var lengthSum = curLength + remLength;
		var bitsSum = curBits | (remBits << curLength);
		return $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes3(
			_Utils_Tuple2(
				_Utils_Tuple2(bitsSum, lengthSum),
				bytes));
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes1 = F2(
	function (bits, _v0) {
		bitsToBytes1:
		while (true) {
			var _v1 = _v0.a;
			var remBits = _v1.a;
			var remLength = _v1.b;
			var bytes = _v0.b;
			if (bits.b) {
				var head = bits.a;
				var tail = bits.b;
				var $temp$bits = tail,
					$temp$_v0 = A2(
					$pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes2,
					head,
					_Utils_Tuple2(
						_Utils_Tuple2(remBits, remLength),
						bytes));
				bits = $temp$bits;
				_v0 = $temp$_v0;
				continue bitsToBytes1;
			} else {
				return (!remLength) ? $elm$core$List$reverse(bytes) : $elm$core$List$reverse(
					A2($elm$core$List$cons, remBits << (8 - remLength), bytes));
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes = function (bits) {
	return A2(
		$pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes1,
		bits,
		_Utils_Tuple2(
			_Utils_Tuple2(0, 0),
			_List_Nil));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$UTF8 = 3;
var $pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicatorLength = F2(
	function (mode, version) {
		if (version <= 9) {
			switch (mode) {
				case 0:
					return 10;
				case 1:
					return 9;
				case 2:
					return 8;
				default:
					return 8;
			}
		} else {
			if (version <= 26) {
				switch (mode) {
					case 0:
						return 12;
					case 1:
						return 11;
					case 2:
						return 16;
					default:
						return 16;
				}
			} else {
				switch (mode) {
					case 0:
						return 14;
					case 1:
						return 13;
					case 2:
						return 16;
					default:
						return 16;
				}
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicator = F2(
	function (_v0, bits) {
		var groupInfo = _v0.nC;
		var inputStr = _v0.gK;
		var mode = _v0.aZ;
		var length = A2($pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicatorLength, mode, groupInfo.k3);
		var charCount = (mode === 3) ? $elm$core$List$length(bits) : $elm$core$String$length(inputStr);
		return _Utils_Tuple2(charCount, length);
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$modeIndicator = function (mode) {
	switch (mode) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 4;
		default:
			return 4;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$addInfoAndFinalBits = function (_v0) {
	var bits = _v0.a;
	var model = _v0.b;
	return _Utils_Tuple2(
		model,
		A2(
			$pablohirafuji$elm_qrcode$QRCode$Encode$addFiller,
			model.nC.et,
			$pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes(
				A3(
					$pablohirafuji$elm_qrcode$QRCode$Encode$addTerminator,
					model.nC.et,
					model.fX,
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							$pablohirafuji$elm_qrcode$QRCode$Encode$modeIndicator(model.aZ),
							4),
						A2(
							$elm$core$List$cons,
							A2($pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicator, model, bits),
							bits))))));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$concatTranspose = function (_v0) {
	var model = _v0.a;
	var dataBlocks = _v0.b;
	var ecBlocks = _v0.c;
	return _Utils_Tuple2(
		model,
		$elm$core$List$concat(
			_Utils_ap(
				$pablohirafuji$elm_qrcode$QRCode$Helpers$transpose(dataBlocks),
				$pablohirafuji$elm_qrcode$QRCode$Helpers$transpose(ecBlocks))));
};
var $elm_community$list_extra$List$Extra$greedyGroupsOfWithStep = F3(
	function (size, step, xs) {
		var xs_ = A2($elm$core$List$drop, step, xs);
		var okayXs = $elm$core$List$length(xs) > 0;
		var okayArgs = (size > 0) && (step > 0);
		return (okayArgs && okayXs) ? A2(
			$elm$core$List$cons,
			A2($elm$core$List$take, size, xs),
			A3($elm_community$list_extra$List$Extra$greedyGroupsOfWithStep, size, step, xs_)) : _List_Nil;
	});
var $elm_community$list_extra$List$Extra$greedyGroupsOf = F2(
	function (size, xs) {
		return A3($elm_community$list_extra$List$Extra$greedyGroupsOfWithStep, size, size, xs);
	});
var $pablohirafuji$elm_qrcode$QRCode$Error$InvalidAlphanumericChar = {$: 2};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$alphanumericCodes = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('0', 0),
			_Utils_Tuple2('1', 1),
			_Utils_Tuple2('2', 2),
			_Utils_Tuple2('3', 3),
			_Utils_Tuple2('4', 4),
			_Utils_Tuple2('5', 5),
			_Utils_Tuple2('6', 6),
			_Utils_Tuple2('7', 7),
			_Utils_Tuple2('8', 8),
			_Utils_Tuple2('9', 9),
			_Utils_Tuple2('A', 10),
			_Utils_Tuple2('B', 11),
			_Utils_Tuple2('C', 12),
			_Utils_Tuple2('D', 13),
			_Utils_Tuple2('E', 14),
			_Utils_Tuple2('F', 15),
			_Utils_Tuple2('G', 16),
			_Utils_Tuple2('H', 17),
			_Utils_Tuple2('I', 18),
			_Utils_Tuple2('J', 19),
			_Utils_Tuple2('K', 20),
			_Utils_Tuple2('L', 21),
			_Utils_Tuple2('M', 22),
			_Utils_Tuple2('N', 23),
			_Utils_Tuple2('O', 24),
			_Utils_Tuple2('P', 25),
			_Utils_Tuple2('Q', 26),
			_Utils_Tuple2('R', 27),
			_Utils_Tuple2('S', 28),
			_Utils_Tuple2('T', 29),
			_Utils_Tuple2('U', 30),
			_Utils_Tuple2('V', 31),
			_Utils_Tuple2('W', 32),
			_Utils_Tuple2('X', 33),
			_Utils_Tuple2('Y', 34),
			_Utils_Tuple2('Z', 35),
			_Utils_Tuple2(' ', 36),
			_Utils_Tuple2('$', 37),
			_Utils_Tuple2('%', 38),
			_Utils_Tuple2('*', 39),
			_Utils_Tuple2('+', 40),
			_Utils_Tuple2('-', 41),
			_Utils_Tuple2('.', 42),
			_Utils_Tuple2('/', 43),
			_Utils_Tuple2(':', 44)
		]));
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toAlphanumericCode = function (_char) {
	return A2(
		$elm$core$Result$fromMaybe,
		$pablohirafuji$elm_qrcode$QRCode$Error$InvalidAlphanumericChar,
		A2($elm$core$Dict$get, _char, $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$alphanumericCodes));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toBinary = function (chars) {
	_v0$2:
	while (true) {
		if (chars.b) {
			if (chars.b.b) {
				if (!chars.b.b.b) {
					var firstChar = chars.a;
					var _v1 = chars.b;
					var secondChar = _v1.a;
					return A3(
						$elm$core$Result$map2,
						F2(
							function (firstCode, secondCode) {
								return _Utils_Tuple2((firstCode * 45) + secondCode, 11);
							}),
						$pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toAlphanumericCode(firstChar),
						$pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toAlphanumericCode(secondChar));
				} else {
					break _v0$2;
				}
			} else {
				var _char = chars.a;
				return A2(
					$elm$core$Result$map,
					function (a) {
						return _Utils_Tuple2(a, 6);
					},
					$pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toAlphanumericCode(_char));
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Result$Err($pablohirafuji$elm_qrcode$QRCode$Error$InvalidAlphanumericChar);
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$encode = function (str) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Result$map2($elm$core$List$cons),
		$elm$core$Result$Ok(_List_Nil),
		A2(
			$elm$core$List$map,
			$pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toBinary,
			A2(
				$elm_community$list_extra$List$Extra$greedyGroupsOf,
				2,
				$elm$core$String$toList(str))));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Byte$encode = function (str) {
	return $elm$core$Result$Ok(
		A2(
			$elm$core$List$map,
			function (a) {
				return _Utils_Tuple2(
					$elm$core$Char$toCode(a),
					8);
			},
			$elm$core$String$toList(str)));
};
var $pablohirafuji$elm_qrcode$QRCode$Error$InvalidNumericChar = {$: 1};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$numericLength = function (str) {
	var _v0 = $elm$core$String$length(str);
	switch (_v0) {
		case 1:
			return 4;
		case 2:
			return 7;
		default:
			return 10;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$encodeHelp = function (chars) {
	var str = $elm$core$String$fromList(chars);
	return A2(
		$elm$core$Result$fromMaybe,
		$pablohirafuji$elm_qrcode$QRCode$Error$InvalidNumericChar,
		A2(
			$elm$core$Maybe$map,
			function (a) {
				return _Utils_Tuple2(
					a,
					$pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$numericLength(str));
			},
			$elm$core$String$toInt(str)));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$encode = function (str) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Result$map2($elm$core$List$cons),
		$elm$core$Result$Ok(_List_Nil),
		A2(
			$elm$core$List$map,
			$pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$encodeHelp,
			A2(
				$elm_community$list_extra$List$Extra$greedyGroupsOf,
				3,
				$elm$core$String$toList(str))));
};
var $pablohirafuji$elm_qrcode$QRCode$Error$InvalidUTF8Char = {$: 3};
var $elm$bytes$Bytes$Encode$getStringWidth = _Bytes_getStringWidth;
var $elm$bytes$Bytes$Decode$loopHelp = F4(
	function (state, callback, bites, offset) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var decoder = _v0;
			var _v1 = A2(decoder, bites, offset);
			var newOffset = _v1.a;
			var step = _v1.b;
			if (!step.$) {
				var newState = step.a;
				var $temp$state = newState,
					$temp$callback = callback,
					$temp$bites = bites,
					$temp$offset = newOffset;
				state = $temp$state;
				callback = $temp$callback;
				bites = $temp$bites;
				offset = $temp$offset;
				continue loopHelp;
			} else {
				var result = step.a;
				return _Utils_Tuple2(newOffset, result);
			}
		}
	});
var $elm$bytes$Bytes$Decode$loop = F2(
	function (state, callback) {
		return A2($elm$bytes$Bytes$Decode$loopHelp, state, callback);
	});
var $elm$bytes$Bytes$Decode$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$bytes$Bytes$Decode$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$bytes$Bytes$Decode$map = F2(
	function (func, _v0) {
		var decodeA = _v0;
		return F2(
			function (bites, offset) {
				var _v1 = A2(decodeA, bites, offset);
				var aOffset = _v1.a;
				var a = _v1.b;
				return _Utils_Tuple2(
					aOffset,
					func(a));
			});
	});
var $elm$bytes$Bytes$Decode$succeed = function (a) {
	return F2(
		function (_v0, offset) {
			return _Utils_Tuple2(offset, a);
		});
};
var $elm$bytes$Bytes$Decode$unsignedInt8 = _Bytes_read_u8;
var $pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$step = function (_v0) {
	var n = _v0.a;
	var xs = _v0.b;
	return (n <= 0) ? $elm$bytes$Bytes$Decode$succeed(
		$elm$bytes$Bytes$Decode$Done(
			$elm$core$List$reverse(xs))) : A2(
		$elm$bytes$Bytes$Decode$map,
		function (x) {
			return $elm$bytes$Bytes$Decode$Loop(
				_Utils_Tuple2(
					n - 1,
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(x, 8),
						xs)));
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$encode = function (str) {
	var utf8BytesWidth = $elm$bytes$Bytes$Encode$getStringWidth(str);
	var decoder = A2(
		$elm$bytes$Bytes$Decode$loop,
		_Utils_Tuple2(utf8BytesWidth, _List_Nil),
		$pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$step);
	return A2(
		$elm$core$Result$fromMaybe,
		$pablohirafuji$elm_qrcode$QRCode$Error$InvalidUTF8Char,
		A2(
			$elm$bytes$Bytes$Decode$decode,
			decoder,
			$elm$bytes$Bytes$Encode$encode(
				$elm$bytes$Bytes$Encode$string(str))));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$encoder = function (mode) {
	switch (mode) {
		case 0:
			return $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$encode;
		case 1:
			return $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$encode;
		case 2:
			return $pablohirafuji$elm_qrcode$QRCode$Encode$Byte$encode;
		default:
			return $pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$encode;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$expTable = $elm$core$Array$fromList(
	_List_fromArray(
		[1, 2, 4, 8, 16, 32, 64, 128, 29, 58, 116, 232, 205, 135, 19, 38, 76, 152, 45, 90, 180, 117, 234, 201, 143, 3, 6, 12, 24, 48, 96, 192, 157, 39, 78, 156, 37, 74, 148, 53, 106, 212, 181, 119, 238, 193, 159, 35, 70, 140, 5, 10, 20, 40, 80, 160, 93, 186, 105, 210, 185, 111, 222, 161, 95, 190, 97, 194, 153, 47, 94, 188, 101, 202, 137, 15, 30, 60, 120, 240, 253, 231, 211, 187, 107, 214, 177, 127, 254, 225, 223, 163, 91, 182, 113, 226, 217, 175, 67, 134, 17, 34, 68, 136, 13, 26, 52, 104, 208, 189, 103, 206, 129, 31, 62, 124, 248, 237, 199, 147, 59, 118, 236, 197, 151, 51, 102, 204, 133, 23, 46, 92, 184, 109, 218, 169, 79, 158, 33, 66, 132, 21, 42, 84, 168, 77, 154, 41, 82, 164, 85, 170, 73, 146, 57, 114, 228, 213, 183, 115, 230, 209, 191, 99, 198, 145, 63, 126, 252, 229, 215, 179, 123, 246, 241, 255, 227, 219, 171, 75, 150, 49, 98, 196, 149, 55, 110, 220, 165, 87, 174, 65, 130, 25, 50, 100, 200, 141, 7, 14, 28, 56, 112, 224, 221, 167, 83, 166, 81, 162, 89, 178, 121, 242, 249, 239, 195, 155, 43, 86, 172, 69, 138, 9, 18, 36, 72, 144, 61, 122, 244, 245, 247, 243, 251, 235, 203, 139, 11, 22, 44, 88, 176, 125, 250, 233, 207, 131, 27, 54, 108, 216, 173, 71, 142, 1]));
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getExp = function (index) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		A2(
			$elm$core$Array$get,
			A2($elm$core$Basics$modBy, 255, index),
			$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$expTable));
};
var $pablohirafuji$elm_qrcode$QRCode$Error$PolynomialMultiplyException = {$: 5};
var $pablohirafuji$elm_qrcode$QRCode$Error$LogTableException = function (a) {
	return {$: 4, a: a};
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$logTable = $elm$core$Array$fromList(
	_List_fromArray(
		[0, 1, 25, 2, 50, 26, 198, 3, 223, 51, 238, 27, 104, 199, 75, 4, 100, 224, 14, 52, 141, 239, 129, 28, 193, 105, 248, 200, 8, 76, 113, 5, 138, 101, 47, 225, 36, 15, 33, 53, 147, 142, 218, 240, 18, 130, 69, 29, 181, 194, 125, 106, 39, 249, 185, 201, 154, 9, 120, 77, 228, 114, 166, 6, 191, 139, 98, 102, 221, 48, 253, 226, 152, 37, 179, 16, 145, 34, 136, 54, 208, 148, 206, 143, 150, 219, 189, 241, 210, 19, 92, 131, 56, 70, 64, 30, 66, 182, 163, 195, 72, 126, 110, 107, 58, 40, 84, 250, 133, 186, 61, 202, 94, 155, 159, 10, 21, 121, 43, 78, 212, 229, 172, 115, 243, 167, 87, 7, 112, 192, 247, 140, 128, 99, 13, 103, 74, 222, 237, 49, 197, 254, 24, 227, 165, 153, 119, 38, 184, 180, 124, 17, 68, 146, 217, 35, 32, 137, 46, 55, 63, 209, 91, 149, 188, 207, 205, 144, 135, 151, 178, 220, 252, 190, 97, 242, 86, 211, 171, 20, 42, 93, 158, 132, 60, 57, 83, 71, 109, 65, 162, 31, 45, 67, 216, 183, 123, 164, 118, 196, 23, 73, 236, 127, 12, 111, 246, 108, 161, 59, 82, 41, 157, 85, 170, 251, 96, 134, 177, 187, 204, 62, 90, 203, 89, 95, 176, 156, 169, 160, 81, 11, 245, 22, 235, 122, 117, 44, 215, 79, 174, 213, 233, 230, 231, 173, 232, 116, 214, 244, 234, 168, 80, 88, 175]));
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getLog = function (index) {
	return (index < 1) ? $elm$core$Result$Err(
		$pablohirafuji$elm_qrcode$QRCode$Error$LogTableException(index)) : A2(
		$elm$core$Result$fromMaybe,
		$pablohirafuji$elm_qrcode$QRCode$Error$LogTableException(index),
		A2($elm$core$Array$get, index - 1, $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$logTable));
};
var $elm$core$Array$length = function (_v0) {
	var len = _v0.a;
	return len;
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getOffset = function (_v0) {
	getOffset:
	while (true) {
		var num = _v0.a;
		var offset = _v0.b;
		if (num.b) {
			var head = num.a;
			var tail = num.b;
			if (!head) {
				var $temp$_v0 = _Utils_Tuple2(tail, offset + 1);
				_v0 = $temp$_v0;
				continue getOffset;
			} else {
				return offset;
			}
		} else {
			return offset;
		}
	}
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial = F2(
	function (num, shift) {
		var offset = $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getOffset(
			_Utils_Tuple2(num, 0));
		var numArray = $elm$core$Array$fromList(num);
		return A2(
			$elm$core$Array$initialize,
			($elm$core$List$length(num) - offset) + shift,
			function (index) {
				return A2(
					$elm$core$Maybe$withDefault,
					0,
					A2($elm$core$Array$get, index + offset, numArray));
			});
	});
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$multiply = F2(
	function (poly1, poly2) {
		var valuesArray = A2(
			$elm$core$List$indexedMap,
			F2(
				function (index1, value1) {
					return A2(
						$elm$core$List$indexedMap,
						F2(
							function (index2, value2) {
								return _Utils_Tuple3(index1 + index2, value1, value2);
							}),
						$elm$core$Array$toList(poly2));
				}),
			$elm$core$Array$toList(poly1));
		var process__ = F3(
			function (indexSum, num_, exp) {
				return A2(
					$elm$core$Result$fromMaybe,
					$pablohirafuji$elm_qrcode$QRCode$Error$PolynomialMultiplyException,
					A2(
						$elm$core$Maybe$map,
						$elm$core$Bitwise$xor(exp),
						A2($elm$core$Array$get, indexSum, num_)));
			});
		var process_ = F2(
			function (_v0, num_) {
				var indexSum = _v0.a;
				var value1 = _v0.b;
				var value2 = _v0.c;
				return A2(
					$elm$core$Result$map,
					function (r) {
						return A3($elm$core$Array$set, indexSum, r, num_);
					},
					A2(
						$elm$core$Result$andThen,
						A2(process__, indexSum, num_),
						A2(
							$elm$core$Result$map,
							$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getExp,
							A3(
								$elm$core$Result$map2,
								$elm$core$Basics$add,
								$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getLog(value1),
								$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getLog(value2)))));
			});
		var process = F2(
			function (args, numResult) {
				return A2(
					$elm$core$Result$andThen,
					process_(args),
					numResult);
			});
		var num = A2(
			$elm$core$Array$initialize,
			($elm$core$Array$length(poly1) + $elm$core$Array$length(poly2)) - 1,
			$elm$core$Basics$always(0));
		return A2(
			$elm$core$Result$map,
			function (a) {
				return A2($pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial, a, 0);
			},
			A2(
				$elm$core$Result$map,
				$elm$core$Array$toList,
				A3(
					$elm$core$List$foldl,
					process,
					$elm$core$Result$Ok(num),
					$elm$core$List$concat(valuesArray))));
	});
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getECPolynomial = function (ecLength) {
	var generate = F2(
		function (count, polyResult) {
			generate:
			while (true) {
				if (_Utils_cmp(count, ecLength) < 0) {
					var $temp$count = count + 1,
						$temp$polyResult = A2(
						$elm$core$Result$andThen,
						function (a) {
							return A2(
								$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$multiply,
								a,
								A2(
									$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial,
									_List_fromArray(
										[
											1,
											$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getExp(count)
										]),
									0));
						},
						polyResult);
					count = $temp$count;
					polyResult = $temp$polyResult;
					continue generate;
				} else {
					return polyResult;
				}
			}
		});
	return A2(
		generate,
		0,
		$elm$core$Result$Ok(
			A2(
				$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial,
				_List_fromArray(
					[1]),
				0)));
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get___ = F2(
	function (ecLength, modPoly) {
		return $elm$core$Array$toList(
			A2(
				$elm$core$Array$initialize,
				ecLength,
				function (index) {
					var modIndex = (index + $elm$core$Array$length(modPoly)) - ecLength;
					return (modIndex >= 0) ? A2(
						$elm$core$Maybe$withDefault,
						0,
						A2($elm$core$Array$get, modIndex, modPoly)) : 0;
				}));
	});
var $pablohirafuji$elm_qrcode$QRCode$Error$PolynomialModException = {$: 6};
var $elm$core$Array$foldl = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldl, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldl, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldl,
			func,
			A3($elm$core$Elm$JsArray$foldl, helper, baseCase, tree),
			tail);
	});
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$mod = F2(
	function (poly1, poly2) {
		if (($elm$core$Array$length(poly1) - $elm$core$Array$length(poly2)) < 0) {
			return $elm$core$Result$Ok(poly1);
		} else {
			var helper_ = F3(
				function (index2, poly1_, exp) {
					return A2(
						$elm$core$Result$fromMaybe,
						$pablohirafuji$elm_qrcode$QRCode$Error$PolynomialModException,
						A2(
							$elm$core$Maybe$map,
							$elm$core$Bitwise$xor(exp),
							A2($elm$core$Array$get, index2, poly1_)));
				});
			var getHead = function (poly) {
				return A2(
					$elm$core$Result$andThen,
					$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getLog,
					A2(
						$elm$core$Result$fromMaybe,
						$pablohirafuji$elm_qrcode$QRCode$Error$PolynomialModException,
						A2($elm$core$Array$get, 0, poly)));
			};
			var ratio = A3(
				$elm$core$Result$map2,
				$elm$core$Basics$sub,
				getHead(poly1),
				getHead(poly2));
			var helper = F2(
				function (_v0, poly1_) {
					var index2 = _v0.a;
					var value2 = _v0.b;
					return A2(
						$elm$core$Result$map,
						function (r) {
							return A3($elm$core$Array$set, index2, r, poly1_);
						},
						A2(
							$elm$core$Result$andThen,
							A2(helper_, index2, poly1_),
							A2(
								$elm$core$Result$map,
								$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getExp,
								A3(
									$elm$core$Result$map2,
									$elm$core$Basics$add,
									ratio,
									$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getLog(value2)))));
				});
			var numFold = F2(
				function (args, poly1Result) {
					return A2(
						$elm$core$Result$andThen,
						helper(args),
						poly1Result);
				});
			var numResult = A3(
				$elm$core$Array$foldl,
				numFold,
				$elm$core$Result$Ok(poly1),
				A2(
					$elm$core$Array$indexedMap,
					F2(
						function (a, b) {
							return _Utils_Tuple2(a, b);
						}),
					poly2));
			return A2(
				$elm$core$Result$andThen,
				function (a) {
					return A2($pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$mod, a, poly2);
				},
				A2(
					$elm$core$Result$map,
					function (a) {
						return A2($pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial, a, 0);
					},
					A2($elm$core$Result$map, $elm$core$Array$toList, numResult)));
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get__ = F2(
	function (rsPoly, dataCodewords) {
		return A2(
			$elm$core$Result$map,
			$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get___(
				$elm$core$Array$length(rsPoly) - 1),
			A2(
				$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$mod,
				A2(
					$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial,
					dataCodewords,
					$elm$core$Array$length(rsPoly) - 1),
				rsPoly));
	});
var $pablohirafuji$elm_qrcode$QRCode$Helpers$listResult = F3(
	function (fun, listb, lista) {
		if (lista.b) {
			var head = lista.a;
			var tail = lista.b;
			return A2(
				$elm$core$Result$andThen,
				function (a) {
					return A3($pablohirafuji$elm_qrcode$QRCode$Helpers$listResult, fun, a, tail);
				},
				A2(
					$elm$core$Result$map,
					function (r) {
						return A2($elm$core$List$cons, r, listb);
					},
					fun(head)));
		} else {
			return $elm$core$Result$Ok(
				$elm$core$List$reverse(listb));
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get_ = F2(
	function (byteBlocks, rsPoly) {
		return A3(
			$pablohirafuji$elm_qrcode$QRCode$Helpers$listResult,
			$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get__(rsPoly),
			_List_Nil,
			byteBlocks);
	});
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get = F2(
	function (ecPerBlock, byteBlocks) {
		return A2(
			$elm$core$Result$andThen,
			$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get_(byteBlocks),
			$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getECPolynomial(ecPerBlock));
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$getErrorCorrection = function (_v0) {
	var model = _v0.a;
	var dataBlocks = _v0.b;
	return A2(
		$elm$core$Result$map,
		function (c) {
			return _Utils_Tuple3(model, dataBlocks, c);
		},
		A2($pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get, model.nC.mV, dataBlocks));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric = 1;
var $pablohirafuji$elm_qrcode$QRCode$Encode$Byte = 2;
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric = 0;
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$onlyAlphanumeric = A2(
	$elm$regex$Regex$fromStringWith,
	{lP: false, oj: false},
	'^[0-9A-Z $%*+\\-.\\/:]+$');
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$isValid = function (input) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (r) {
				return A2($elm$regex$Regex$contains, r, input);
			},
			$pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$onlyAlphanumeric));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Byte$only8Bit = A2(
	$elm$regex$Regex$fromStringWith,
	{lP: false, oj: false},
	'^[\\u0000-\\u00ff]+$');
var $pablohirafuji$elm_qrcode$QRCode$Encode$Byte$isValid = function (input) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (r) {
				return A2($elm$regex$Regex$contains, r, input);
			},
			$pablohirafuji$elm_qrcode$QRCode$Encode$Byte$only8Bit));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$onlyNumber = A2(
	$elm$regex$Regex$fromStringWith,
	{lP: false, oj: false},
	'^[0-9]+$');
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$isValid = function (input) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (r) {
				return A2($elm$regex$Regex$contains, r, input);
			},
			$pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$onlyNumber));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$selectMode = function (input) {
	return $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$isValid(input) ? 0 : ($pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$isValid(input) ? 1 : ($pablohirafuji$elm_qrcode$QRCode$Encode$Byte$isValid(input) ? 2 : 3));
};
var $pablohirafuji$elm_qrcode$QRCode$Error$InputLengthOverflow = {$: 7};
var $pablohirafuji$elm_qrcode$QRCode$Encode$filterCapacity = F3(
	function (mode, dataLength, _v0) {
		var version = _v0.k3;
		var capacity = _v0.et;
		return _Utils_cmp(
			A2($pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicatorLength, mode, version) + dataLength,
			capacity) < 1;
	});
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$blockByteCapacity = function (_v0) {
	var blockCount = _v0.a;
	var bytePerBlock = _v0.b;
	return blockCount * bytePerBlock;
};
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$byteCapacity = F2(
	function (group1, maybeGroup2) {
		if (!maybeGroup2.$) {
			var block2 = maybeGroup2.a;
			return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$blockByteCapacity(group1) + $pablohirafuji$elm_qrcode$QRCode$GroupInfo$blockByteCapacity(block2);
		} else {
			return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$blockByteCapacity(group1);
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo = F4(
	function (version, ecPerBlock, group1, maybeGroup2) {
		return {
			et: A2($pablohirafuji$elm_qrcode$QRCode$GroupInfo$byteCapacity, group1, maybeGroup2) * 8,
			mV: ecPerBlock,
			i4: group1,
			oa: maybeGroup2,
			k3: version
		};
	});
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataH = _List_fromArray(
	[
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		1,
		17,
		_Utils_Tuple2(1, 9),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		2,
		28,
		_Utils_Tuple2(1, 16),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		3,
		22,
		_Utils_Tuple2(2, 13),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		4,
		16,
		_Utils_Tuple2(4, 9),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		5,
		22,
		_Utils_Tuple2(2, 11),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 12))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		6,
		28,
		_Utils_Tuple2(4, 15),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		7,
		26,
		_Utils_Tuple2(4, 13),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 14))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		8,
		26,
		_Utils_Tuple2(4, 14),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 15))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		9,
		24,
		_Utils_Tuple2(4, 12),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 13))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		10,
		28,
		_Utils_Tuple2(6, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		11,
		24,
		_Utils_Tuple2(3, 12),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(8, 13))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		12,
		28,
		_Utils_Tuple2(7, 14),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 15))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		13,
		22,
		_Utils_Tuple2(12, 11),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 12))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		14,
		24,
		_Utils_Tuple2(11, 12),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 13))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		15,
		24,
		_Utils_Tuple2(11, 12),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 13))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		16,
		30,
		_Utils_Tuple2(3, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(13, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		17,
		28,
		_Utils_Tuple2(2, 14),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(17, 15))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		18,
		28,
		_Utils_Tuple2(2, 14),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(19, 15))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		19,
		26,
		_Utils_Tuple2(9, 13),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(16, 14))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		20,
		28,
		_Utils_Tuple2(15, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		21,
		30,
		_Utils_Tuple2(19, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 17))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		22,
		24,
		_Utils_Tuple2(34, 13),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		23,
		30,
		_Utils_Tuple2(16, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		24,
		30,
		_Utils_Tuple2(30, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 17))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		25,
		30,
		_Utils_Tuple2(22, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(13, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		26,
		30,
		_Utils_Tuple2(33, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 17))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		27,
		30,
		_Utils_Tuple2(12, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(28, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		28,
		30,
		_Utils_Tuple2(11, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(31, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		29,
		30,
		_Utils_Tuple2(19, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(26, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		30,
		30,
		_Utils_Tuple2(23, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(25, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		31,
		30,
		_Utils_Tuple2(23, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(28, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		32,
		30,
		_Utils_Tuple2(19, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(35, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		33,
		30,
		_Utils_Tuple2(11, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(46, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		34,
		30,
		_Utils_Tuple2(59, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 17))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		35,
		30,
		_Utils_Tuple2(22, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(41, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		36,
		30,
		_Utils_Tuple2(2, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(64, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		37,
		30,
		_Utils_Tuple2(24, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(46, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		38,
		30,
		_Utils_Tuple2(42, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(32, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		39,
		30,
		_Utils_Tuple2(10, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(67, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		40,
		30,
		_Utils_Tuple2(20, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(61, 16)))
	]);
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataL = _List_fromArray(
	[
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		1,
		7,
		_Utils_Tuple2(1, 19),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		2,
		10,
		_Utils_Tuple2(1, 34),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		3,
		15,
		_Utils_Tuple2(1, 55),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		4,
		20,
		_Utils_Tuple2(1, 80),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		5,
		26,
		_Utils_Tuple2(1, 108),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		6,
		18,
		_Utils_Tuple2(2, 68),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		7,
		20,
		_Utils_Tuple2(2, 78),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		8,
		24,
		_Utils_Tuple2(2, 97),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		9,
		30,
		_Utils_Tuple2(2, 116),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		10,
		18,
		_Utils_Tuple2(2, 68),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 69))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		11,
		20,
		_Utils_Tuple2(4, 81),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		12,
		24,
		_Utils_Tuple2(2, 92),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 93))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		13,
		26,
		_Utils_Tuple2(4, 107),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		14,
		30,
		_Utils_Tuple2(3, 115),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 116))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		15,
		22,
		_Utils_Tuple2(5, 87),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 88))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		16,
		24,
		_Utils_Tuple2(5, 98),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 99))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		17,
		28,
		_Utils_Tuple2(1, 107),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 108))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		18,
		30,
		_Utils_Tuple2(5, 120),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 121))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		19,
		28,
		_Utils_Tuple2(3, 113),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 114))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		20,
		28,
		_Utils_Tuple2(3, 107),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 108))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		21,
		28,
		_Utils_Tuple2(4, 116),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 117))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		22,
		28,
		_Utils_Tuple2(2, 111),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 112))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		23,
		30,
		_Utils_Tuple2(4, 121),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 122))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		24,
		30,
		_Utils_Tuple2(6, 117),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 118))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		25,
		26,
		_Utils_Tuple2(8, 106),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 107))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		26,
		28,
		_Utils_Tuple2(10, 114),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 115))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		27,
		30,
		_Utils_Tuple2(8, 122),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 123))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		28,
		30,
		_Utils_Tuple2(3, 117),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 118))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		29,
		30,
		_Utils_Tuple2(7, 116),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 117))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		30,
		30,
		_Utils_Tuple2(5, 115),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 116))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		31,
		30,
		_Utils_Tuple2(13, 115),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(3, 116))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		32,
		30,
		_Utils_Tuple2(17, 115),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		33,
		30,
		_Utils_Tuple2(17, 115),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 116))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		34,
		30,
		_Utils_Tuple2(13, 115),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 116))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		35,
		30,
		_Utils_Tuple2(12, 121),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 122))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		36,
		30,
		_Utils_Tuple2(6, 121),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 122))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		37,
		30,
		_Utils_Tuple2(17, 122),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 123))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		38,
		30,
		_Utils_Tuple2(4, 122),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(18, 123))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		39,
		30,
		_Utils_Tuple2(20, 117),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 118))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		40,
		30,
		_Utils_Tuple2(19, 118),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 119)))
	]);
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataM = _List_fromArray(
	[
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		1,
		10,
		_Utils_Tuple2(1, 16),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		2,
		16,
		_Utils_Tuple2(1, 28),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		3,
		26,
		_Utils_Tuple2(1, 44),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		4,
		18,
		_Utils_Tuple2(2, 32),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		5,
		24,
		_Utils_Tuple2(2, 43),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		6,
		16,
		_Utils_Tuple2(4, 27),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		7,
		18,
		_Utils_Tuple2(4, 31),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		8,
		22,
		_Utils_Tuple2(2, 38),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 39))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		9,
		22,
		_Utils_Tuple2(3, 36),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 37))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		10,
		26,
		_Utils_Tuple2(4, 43),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 44))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		11,
		30,
		_Utils_Tuple2(1, 50),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 51))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		12,
		22,
		_Utils_Tuple2(6, 36),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 37))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		13,
		22,
		_Utils_Tuple2(8, 37),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 38))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		14,
		24,
		_Utils_Tuple2(4, 40),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 41))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		15,
		24,
		_Utils_Tuple2(5, 41),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 42))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		16,
		28,
		_Utils_Tuple2(7, 45),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(3, 46))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		17,
		28,
		_Utils_Tuple2(10, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		18,
		26,
		_Utils_Tuple2(9, 43),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 44))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		19,
		26,
		_Utils_Tuple2(3, 44),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(11, 45))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		20,
		26,
		_Utils_Tuple2(3, 41),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(13, 42))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		21,
		26,
		_Utils_Tuple2(17, 42),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		22,
		28,
		_Utils_Tuple2(17, 46),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		23,
		28,
		_Utils_Tuple2(4, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 48))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		24,
		28,
		_Utils_Tuple2(6, 45),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 46))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		25,
		28,
		_Utils_Tuple2(8, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(13, 48))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		26,
		28,
		_Utils_Tuple2(19, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		27,
		28,
		_Utils_Tuple2(22, 45),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(3, 46))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		28,
		28,
		_Utils_Tuple2(3, 45),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(23, 46))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		29,
		28,
		_Utils_Tuple2(21, 45),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 46))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		30,
		28,
		_Utils_Tuple2(19, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 48))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		31,
		28,
		_Utils_Tuple2(2, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(29, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		32,
		28,
		_Utils_Tuple2(10, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(23, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		33,
		28,
		_Utils_Tuple2(14, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(21, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		34,
		28,
		_Utils_Tuple2(14, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(23, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		35,
		28,
		_Utils_Tuple2(12, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(26, 48))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		36,
		28,
		_Utils_Tuple2(6, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(34, 48))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		37,
		28,
		_Utils_Tuple2(29, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		38,
		28,
		_Utils_Tuple2(13, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(32, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		39,
		28,
		_Utils_Tuple2(40, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 48))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		40,
		28,
		_Utils_Tuple2(18, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(31, 48)))
	]);
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataQ = _List_fromArray(
	[
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		1,
		13,
		_Utils_Tuple2(1, 13),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		2,
		22,
		_Utils_Tuple2(1, 22),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		3,
		18,
		_Utils_Tuple2(2, 17),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		4,
		26,
		_Utils_Tuple2(2, 24),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		5,
		18,
		_Utils_Tuple2(2, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		6,
		24,
		_Utils_Tuple2(4, 19),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		7,
		18,
		_Utils_Tuple2(2, 14),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 15))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		8,
		22,
		_Utils_Tuple2(4, 18),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 19))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		9,
		20,
		_Utils_Tuple2(4, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 17))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		10,
		24,
		_Utils_Tuple2(6, 19),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 20))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		11,
		28,
		_Utils_Tuple2(4, 22),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 23))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		12,
		26,
		_Utils_Tuple2(4, 20),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 21))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		13,
		24,
		_Utils_Tuple2(8, 20),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 21))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		14,
		20,
		_Utils_Tuple2(11, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 17))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		15,
		30,
		_Utils_Tuple2(5, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		16,
		24,
		_Utils_Tuple2(15, 19),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 20))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		17,
		28,
		_Utils_Tuple2(1, 22),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(15, 23))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		18,
		28,
		_Utils_Tuple2(17, 22),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 23))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		19,
		26,
		_Utils_Tuple2(17, 21),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 22))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		20,
		30,
		_Utils_Tuple2(15, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		21,
		28,
		_Utils_Tuple2(17, 22),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 23))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		22,
		30,
		_Utils_Tuple2(7, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(16, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		23,
		30,
		_Utils_Tuple2(11, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		24,
		30,
		_Utils_Tuple2(11, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(16, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		25,
		30,
		_Utils_Tuple2(7, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(22, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		26,
		28,
		_Utils_Tuple2(28, 22),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 23))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		27,
		30,
		_Utils_Tuple2(8, 23),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(26, 24))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		28,
		30,
		_Utils_Tuple2(4, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(31, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		29,
		30,
		_Utils_Tuple2(1, 23),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(37, 24))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		30,
		30,
		_Utils_Tuple2(15, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(25, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		31,
		30,
		_Utils_Tuple2(42, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		32,
		30,
		_Utils_Tuple2(10, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(35, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		33,
		30,
		_Utils_Tuple2(29, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(19, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		34,
		30,
		_Utils_Tuple2(44, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		35,
		30,
		_Utils_Tuple2(39, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		36,
		30,
		_Utils_Tuple2(46, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		37,
		30,
		_Utils_Tuple2(49, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		38,
		30,
		_Utils_Tuple2(48, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		39,
		30,
		_Utils_Tuple2(43, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(22, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		40,
		30,
		_Utils_Tuple2(34, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(34, 25)))
	]);
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$getGroupData = function (ecLevel) {
	switch (ecLevel) {
		case 0:
			return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataL;
		case 1:
			return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataM;
		case 2:
			return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataQ;
		default:
			return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataH;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$getVersion = F3(
	function (ecLevel, mode, dataLength) {
		return A2(
			$elm$core$Result$fromMaybe,
			$pablohirafuji$elm_qrcode$QRCode$Error$InputLengthOverflow,
			$elm$core$List$head(
				A2(
					$elm$core$List$sortBy,
					function ($) {
						return $.et;
					},
					A2(
						$elm$core$List$filter,
						A2($pablohirafuji$elm_qrcode$QRCode$Encode$filterCapacity, mode, dataLength),
						$pablohirafuji$elm_qrcode$QRCode$GroupInfo$getGroupData(ecLevel)))));
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$versionToModel = F5(
	function (inputStr, ecLevel, mode, partialBitsCount, groupInfo) {
		return {
			fX: partialBitsCount + A2($pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicatorLength, mode, groupInfo.k3),
			iJ: ecLevel,
			nC: groupInfo,
			gK: inputStr,
			aZ: mode
		};
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$selectVersion = F4(
	function (inputStr, ecLevel, mode, encodedStr) {
		var partialBitsCount = 4 + A3(
			$elm$core$List$foldl,
			F2(
				function (a, b) {
					return a.b + b;
				}),
			0,
			encodedStr);
		return A2(
			$elm$core$Result$map,
			function (b) {
				return _Utils_Tuple2(encodedStr, b);
			},
			A2(
				$elm$core$Result$map,
				A4($pablohirafuji$elm_qrcode$QRCode$Encode$versionToModel, inputStr, ecLevel, mode, partialBitsCount),
				A3($pablohirafuji$elm_qrcode$QRCode$Encode$getVersion, ecLevel, mode, partialBitsCount)));
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$breakList = F3(
	function (checkFinish, _v0, _v1) {
		breakList:
		while (true) {
			var times = _v0.a;
			var itemCount = _v0.b;
			var byteList = _v1.a;
			var progress = _v1.b;
			if (times > 0) {
				var remainList = A2($elm$core$List$drop, itemCount, byteList);
				var block = A2($elm$core$List$take, itemCount, byteList);
				var $temp$checkFinish = checkFinish,
					$temp$_v0 = _Utils_Tuple2(times - 1, itemCount),
					$temp$_v1 = _Utils_Tuple2(
					remainList,
					A2($elm$core$List$cons, block, progress));
				checkFinish = $temp$checkFinish;
				_v0 = $temp$_v0;
				_v1 = $temp$_v1;
				continue breakList;
			} else {
				if (checkFinish && ($elm$core$List$length(byteList) > 0)) {
					return $elm$core$Result$Err($pablohirafuji$elm_qrcode$QRCode$Error$InputLengthOverflow);
				} else {
					return $elm$core$Result$Ok(
						_Utils_Tuple2(byteList, progress));
				}
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$toBlocks = function (_v0) {
	var model = _v0.a;
	var groupInfo = model.nC;
	var byteList = _v0.b;
	var _v1 = groupInfo.oa;
	if (!_v1.$) {
		var group2 = _v1.a;
		return A2(
			$elm$core$Result$map,
			function (b) {
				return _Utils_Tuple2(model, b);
			},
			A2(
				$elm$core$Result$map,
				A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $elm$core$List$reverse),
				A2(
					$elm$core$Result$andThen,
					A2($pablohirafuji$elm_qrcode$QRCode$Encode$breakList, true, group2),
					A3(
						$pablohirafuji$elm_qrcode$QRCode$Encode$breakList,
						false,
						groupInfo.i4,
						_Utils_Tuple2(byteList, _List_Nil)))));
	} else {
		return A2(
			$elm$core$Result$map,
			function (b) {
				return _Utils_Tuple2(model, b);
			},
			A2(
				$elm$core$Result$map,
				A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $elm$core$List$reverse),
				A3(
					$pablohirafuji$elm_qrcode$QRCode$Encode$breakList,
					true,
					groupInfo.i4,
					_Utils_Tuple2(byteList, _List_Nil))));
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$encode = F2(
	function (inputStr, ecLevel) {
		var mode = $pablohirafuji$elm_qrcode$QRCode$Encode$selectMode(inputStr);
		return A2(
			$elm$core$Result$map,
			$pablohirafuji$elm_qrcode$QRCode$Encode$concatTranspose,
			A2(
				$elm$core$Result$andThen,
				$pablohirafuji$elm_qrcode$QRCode$Encode$getErrorCorrection,
				A2(
					$elm$core$Result$andThen,
					$pablohirafuji$elm_qrcode$QRCode$Encode$toBlocks,
					A2(
						$elm$core$Result$map,
						$pablohirafuji$elm_qrcode$QRCode$Encode$addInfoAndFinalBits,
						A2(
							$elm$core$Result$andThen,
							A3($pablohirafuji$elm_qrcode$QRCode$Encode$selectVersion, inputStr, ecLevel, mode),
							A2($pablohirafuji$elm_qrcode$QRCode$Encode$encoder, mode, inputStr))))));
	});
var $pablohirafuji$elm_qrcode$QRCode$fromStringWith = F2(
	function (ecLevel, input) {
		return A2(
			$elm$core$Result$mapError,
			$pablohirafuji$elm_qrcode$QRCode$convertError,
			A2(
				$elm$core$Result$andThen,
				function (_v0) {
					var encodeModel = _v0.a;
					var encodedData = _v0.b;
					return A2(
						$elm$core$Result$map,
						function (matrix) {
							return {d_: matrix, k3: encodeModel.nC.k3};
						},
						$pablohirafuji$elm_qrcode$QRCode$Matrix$apply(
							_Utils_Tuple2(encodeModel, encodedData)));
				},
				A2(
					$pablohirafuji$elm_qrcode$QRCode$Encode$encode,
					input,
					$pablohirafuji$elm_qrcode$QRCode$convertEC(ecLevel))));
	});
var $pablohirafuji$elm_qrcode$QRCode$fromString = $pablohirafuji$elm_qrcode$QRCode$fromStringWith(2);
var $pablohirafuji$elm_qrcode$QRCode$defaultImageOptions = {iB: 255, jp: 4294967295, jy: 5, j5: 4};
var $pablohirafuji$elm_qrcode$QRCode$Render$Raster$addQuietZone = F2(
	function (quietZoneSize, matrix) {
		if (quietZoneSize <= 0) {
			return matrix;
		} else {
			var matrixWithQZLength = $elm$core$List$length(matrix) + (2 * quietZoneSize);
			var rows = A2(
				$elm$core$List$repeat,
				quietZoneSize,
				A2($elm$core$List$repeat, matrixWithQZLength, false));
			var cols = A2($elm$core$List$repeat, quietZoneSize, false);
			return _Utils_ap(
				rows,
				_Utils_ap(
					A2(
						$elm$core$List$map,
						function (row) {
							return _Utils_ap(
								cols,
								_Utils_ap(row, cols));
						},
						matrix),
					rows));
		}
	});
var $justgook$elm_image$Image$Internal$Meta$FromData = function (a) {
	return {$: 3, a: a};
};
var $justgook$elm_image$Image$Internal$Meta$FromDataBitDepth8 = 3;
var $justgook$elm_image$Image$Internal$Meta$FromDataChannel4 = function (a) {
	return {$: 3, a: a};
};
var $justgook$elm_image$Image$Internal$ImageData$ImageRaw = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$core$Elm$JsArray$push = _JsArray_push;
var $elm$core$Elm$JsArray$singleton = _JsArray_singleton;
var $elm$core$Array$insertTailInTree = F4(
	function (shift, index, tail, tree) {
		var pos = $elm$core$Array$bitMask & (index >>> shift);
		if (_Utils_cmp(
			pos,
			$elm$core$Elm$JsArray$length(tree)) > -1) {
			if (shift === 5) {
				return A2(
					$elm$core$Elm$JsArray$push,
					$elm$core$Array$Leaf(tail),
					tree);
			} else {
				var newSub = $elm$core$Array$SubTree(
					A4($elm$core$Array$insertTailInTree, shift - $elm$core$Array$shiftStep, index, tail, $elm$core$Elm$JsArray$empty));
				return A2($elm$core$Elm$JsArray$push, newSub, tree);
			}
		} else {
			var value = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!value.$) {
				var subTree = value.a;
				var newSub = $elm$core$Array$SubTree(
					A4($elm$core$Array$insertTailInTree, shift - $elm$core$Array$shiftStep, index, tail, subTree));
				return A3($elm$core$Elm$JsArray$unsafeSet, pos, newSub, tree);
			} else {
				var newSub = $elm$core$Array$SubTree(
					A4(
						$elm$core$Array$insertTailInTree,
						shift - $elm$core$Array$shiftStep,
						index,
						tail,
						$elm$core$Elm$JsArray$singleton(value)));
				return A3($elm$core$Elm$JsArray$unsafeSet, pos, newSub, tree);
			}
		}
	});
var $elm$core$Array$unsafeReplaceTail = F2(
	function (newTail, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		var originalTailLen = $elm$core$Elm$JsArray$length(tail);
		var newTailLen = $elm$core$Elm$JsArray$length(newTail);
		var newArrayLen = len + (newTailLen - originalTailLen);
		if (_Utils_eq(newTailLen, $elm$core$Array$branchFactor)) {
			var overflow = _Utils_cmp(newArrayLen >>> $elm$core$Array$shiftStep, 1 << startShift) > 0;
			if (overflow) {
				var newShift = startShift + $elm$core$Array$shiftStep;
				var newTree = A4(
					$elm$core$Array$insertTailInTree,
					newShift,
					len,
					newTail,
					$elm$core$Elm$JsArray$singleton(
						$elm$core$Array$SubTree(tree)));
				return A4($elm$core$Array$Array_elm_builtin, newArrayLen, newShift, newTree, $elm$core$Elm$JsArray$empty);
			} else {
				return A4(
					$elm$core$Array$Array_elm_builtin,
					newArrayLen,
					startShift,
					A4($elm$core$Array$insertTailInTree, startShift, len, newTail, tree),
					$elm$core$Elm$JsArray$empty);
			}
		} else {
			return A4($elm$core$Array$Array_elm_builtin, newArrayLen, startShift, tree, newTail);
		}
	});
var $elm$core$Array$push = F2(
	function (a, array) {
		var tail = array.d;
		return A2(
			$elm$core$Array$unsafeReplaceTail,
			A2($elm$core$Elm$JsArray$push, a, tail),
			array);
	});
var $justgook$elm_image$Image$Internal$Array2d$fromList2D = A2(
	$elm$core$List$foldl,
	A2($elm$core$Basics$composeR, $elm$core$Array$fromList, $elm$core$Array$push),
	$elm$core$Array$empty);
var $justgook$elm_image$Image$fromList2d = function (l) {
	return A2(
		$justgook$elm_image$Image$Internal$ImageData$ImageRaw,
		$justgook$elm_image$Image$Internal$Meta$FromData(
			{
				cK: $justgook$elm_image$Image$Internal$Meta$FromDataChannel4(3),
				i6: $elm$core$List$length(l),
				qQ: A2(
					$elm$core$Maybe$withDefault,
					0,
					A2(
						$elm$core$Maybe$map,
						$elm$core$List$length,
						$elm$core$List$head(l)))
			}),
		$justgook$elm_image$Image$Internal$Array2d$fromList2D(l));
};
var $pablohirafuji$elm_qrcode$QRCode$Render$Raster$moduleToPixel = F2(
	function (options, isDark) {
		return isDark ? options.iB : options.jp;
	});
var $pablohirafuji$elm_qrcode$QRCode$Render$Raster$toImageWithOptions = F2(
	function (options, matrix) {
		var moduleSize = A2($elm$core$Basics$max, 1, options.jy);
		return $justgook$elm_image$Image$fromList2d(
			$elm$core$List$concat(
				A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$map(
							A2(
								$elm$core$Basics$composeR,
								$pablohirafuji$elm_qrcode$QRCode$Render$Raster$moduleToPixel(options),
								$elm$core$List$repeat(moduleSize))),
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$concat,
							$elm$core$List$repeat(moduleSize))),
					A2($pablohirafuji$elm_qrcode$QRCode$Render$Raster$addQuietZone, options.j5, matrix))));
	});
var $pablohirafuji$elm_qrcode$QRCode$toImageWithOptions = F2(
	function (config, _v0) {
		var matrix = _v0.d_;
		return A2($pablohirafuji$elm_qrcode$QRCode$Render$Raster$toImageWithOptions, config, matrix);
	});
var $pablohirafuji$elm_qrcode$QRCode$toImage = $pablohirafuji$elm_qrcode$QRCode$toImageWithOptions($pablohirafuji$elm_qrcode$QRCode$defaultImageOptions);
var $danfishgold$base64_bytes$Decode$lowest6BitsMask = 63;
var $danfishgold$base64_bytes$Decode$unsafeToChar = function (n) {
	if (n <= 25) {
		return $elm$core$Char$fromCode(65 + n);
	} else {
		if (n <= 51) {
			return $elm$core$Char$fromCode(97 + (n - 26));
		} else {
			if (n <= 61) {
				return $elm$core$Char$fromCode(48 + (n - 52));
			} else {
				switch (n) {
					case 62:
						return '+';
					case 63:
						return '/';
					default:
						return '\u0000';
				}
			}
		}
	}
};
var $danfishgold$base64_bytes$Decode$bitsToChars = F2(
	function (bits, missing) {
		var s = $danfishgold$base64_bytes$Decode$unsafeToChar(bits & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
		var r = $danfishgold$base64_bytes$Decode$unsafeToChar((bits >>> 6) & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
		var q = $danfishgold$base64_bytes$Decode$unsafeToChar((bits >>> 12) & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
		var p = $danfishgold$base64_bytes$Decode$unsafeToChar(bits >>> 18);
		switch (missing) {
			case 0:
				return A2(
					$elm$core$String$cons,
					p,
					A2(
						$elm$core$String$cons,
						q,
						A2(
							$elm$core$String$cons,
							r,
							$elm$core$String$fromChar(s))));
			case 1:
				return A2(
					$elm$core$String$cons,
					p,
					A2(
						$elm$core$String$cons,
						q,
						A2($elm$core$String$cons, r, '=')));
			case 2:
				return A2(
					$elm$core$String$cons,
					p,
					A2($elm$core$String$cons, q, '=='));
			default:
				return '';
		}
	});
var $danfishgold$base64_bytes$Decode$bitsToCharSpecialized = F4(
	function (bits1, bits2, bits3, accum) {
		var z = $danfishgold$base64_bytes$Decode$unsafeToChar((bits3 >>> 6) & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
		var y = $danfishgold$base64_bytes$Decode$unsafeToChar((bits3 >>> 12) & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
		var x = $danfishgold$base64_bytes$Decode$unsafeToChar(bits3 >>> 18);
		var w = $danfishgold$base64_bytes$Decode$unsafeToChar(bits3 & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
		var s = $danfishgold$base64_bytes$Decode$unsafeToChar(bits1 & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
		var r = $danfishgold$base64_bytes$Decode$unsafeToChar((bits1 >>> 6) & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
		var q = $danfishgold$base64_bytes$Decode$unsafeToChar((bits1 >>> 12) & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
		var p = $danfishgold$base64_bytes$Decode$unsafeToChar(bits1 >>> 18);
		var d = $danfishgold$base64_bytes$Decode$unsafeToChar(bits2 & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
		var c = $danfishgold$base64_bytes$Decode$unsafeToChar((bits2 >>> 6) & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
		var b = $danfishgold$base64_bytes$Decode$unsafeToChar((bits2 >>> 12) & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
		var a = $danfishgold$base64_bytes$Decode$unsafeToChar(bits2 >>> 18);
		return A2(
			$elm$core$String$cons,
			x,
			A2(
				$elm$core$String$cons,
				y,
				A2(
					$elm$core$String$cons,
					z,
					A2(
						$elm$core$String$cons,
						w,
						A2(
							$elm$core$String$cons,
							a,
							A2(
								$elm$core$String$cons,
								b,
								A2(
									$elm$core$String$cons,
									c,
									A2(
										$elm$core$String$cons,
										d,
										A2(
											$elm$core$String$cons,
											p,
											A2(
												$elm$core$String$cons,
												q,
												A2(
													$elm$core$String$cons,
													r,
													A2($elm$core$String$cons, s, accum))))))))))));
	});
var $danfishgold$base64_bytes$Decode$decode18Help = F5(
	function (a, b, c, d, e) {
		var combined6 = ((255 & d) << 16) | e;
		var combined5 = d >>> 8;
		var combined4 = 16777215 & c;
		var combined3 = ((65535 & b) << 8) | (c >>> 24);
		var combined2 = ((255 & a) << 16) | (b >>> 16);
		var combined1 = a >>> 8;
		return A4(
			$danfishgold$base64_bytes$Decode$bitsToCharSpecialized,
			combined3,
			combined2,
			combined1,
			A4($danfishgold$base64_bytes$Decode$bitsToCharSpecialized, combined6, combined5, combined4, ''));
	});
var $elm$bytes$Bytes$Decode$map5 = F6(
	function (func, _v0, _v1, _v2, _v3, _v4) {
		var decodeA = _v0;
		var decodeB = _v1;
		var decodeC = _v2;
		var decodeD = _v3;
		var decodeE = _v4;
		return F2(
			function (bites, offset) {
				var _v5 = A2(decodeA, bites, offset);
				var aOffset = _v5.a;
				var a = _v5.b;
				var _v6 = A2(decodeB, bites, aOffset);
				var bOffset = _v6.a;
				var b = _v6.b;
				var _v7 = A2(decodeC, bites, bOffset);
				var cOffset = _v7.a;
				var c = _v7.b;
				var _v8 = A2(decodeD, bites, cOffset);
				var dOffset = _v8.a;
				var d = _v8.b;
				var _v9 = A2(decodeE, bites, dOffset);
				var eOffset = _v9.a;
				var e = _v9.b;
				return _Utils_Tuple2(
					eOffset,
					A5(func, a, b, c, d, e));
			});
	});
var $elm$bytes$Bytes$BE = 1;
var $elm$bytes$Bytes$Decode$unsignedInt16 = function (endianness) {
	return _Bytes_read_u16(!endianness);
};
var $danfishgold$base64_bytes$Decode$u16BE = $elm$bytes$Bytes$Decode$unsignedInt16(1);
var $elm$bytes$Bytes$Decode$unsignedInt32 = function (endianness) {
	return _Bytes_read_u32(!endianness);
};
var $danfishgold$base64_bytes$Decode$u32BE = $elm$bytes$Bytes$Decode$unsignedInt32(1);
var $danfishgold$base64_bytes$Decode$decode18Bytes = A6($elm$bytes$Bytes$Decode$map5, $danfishgold$base64_bytes$Decode$decode18Help, $danfishgold$base64_bytes$Decode$u32BE, $danfishgold$base64_bytes$Decode$u32BE, $danfishgold$base64_bytes$Decode$u32BE, $danfishgold$base64_bytes$Decode$u32BE, $danfishgold$base64_bytes$Decode$u16BE);
var $elm$bytes$Bytes$Decode$map2 = F3(
	function (func, _v0, _v1) {
		var decodeA = _v0;
		var decodeB = _v1;
		return F2(
			function (bites, offset) {
				var _v2 = A2(decodeA, bites, offset);
				var aOffset = _v2.a;
				var a = _v2.b;
				var _v3 = A2(decodeB, bites, aOffset);
				var bOffset = _v3.a;
				var b = _v3.b;
				return _Utils_Tuple2(
					bOffset,
					A2(func, a, b));
			});
	});
var $elm$bytes$Bytes$Decode$map3 = F4(
	function (func, _v0, _v1, _v2) {
		var decodeA = _v0;
		var decodeB = _v1;
		var decodeC = _v2;
		return F2(
			function (bites, offset) {
				var _v3 = A2(decodeA, bites, offset);
				var aOffset = _v3.a;
				var a = _v3.b;
				var _v4 = A2(decodeB, bites, aOffset);
				var bOffset = _v4.a;
				var b = _v4.b;
				var _v5 = A2(decodeC, bites, bOffset);
				var cOffset = _v5.a;
				var c = _v5.b;
				return _Utils_Tuple2(
					cOffset,
					A3(func, a, b, c));
			});
	});
var $danfishgold$base64_bytes$Decode$loopHelp = function (_v0) {
	var remaining = _v0.fo;
	var string = _v0.fz;
	if (remaining >= 18) {
		return A2(
			$elm$bytes$Bytes$Decode$map,
			function (result) {
				return $elm$bytes$Bytes$Decode$Loop(
					{
						fo: remaining - 18,
						fz: _Utils_ap(string, result)
					});
			},
			$danfishgold$base64_bytes$Decode$decode18Bytes);
	} else {
		if (remaining >= 3) {
			var helper = F3(
				function (a, b, c) {
					var combined = ((a << 16) | (b << 8)) | c;
					return $elm$bytes$Bytes$Decode$Loop(
						{
							fo: remaining - 3,
							fz: _Utils_ap(
								string,
								A2($danfishgold$base64_bytes$Decode$bitsToChars, combined, 0))
						});
				});
			return A4($elm$bytes$Bytes$Decode$map3, helper, $elm$bytes$Bytes$Decode$unsignedInt8, $elm$bytes$Bytes$Decode$unsignedInt8, $elm$bytes$Bytes$Decode$unsignedInt8);
		} else {
			if (!remaining) {
				return $elm$bytes$Bytes$Decode$succeed(
					$elm$bytes$Bytes$Decode$Done(string));
			} else {
				if (remaining === 2) {
					var helper = F2(
						function (a, b) {
							var combined = (a << 16) | (b << 8);
							return $elm$bytes$Bytes$Decode$Done(
								_Utils_ap(
									string,
									A2($danfishgold$base64_bytes$Decode$bitsToChars, combined, 1)));
						});
					return A3($elm$bytes$Bytes$Decode$map2, helper, $elm$bytes$Bytes$Decode$unsignedInt8, $elm$bytes$Bytes$Decode$unsignedInt8);
				} else {
					return A2(
						$elm$bytes$Bytes$Decode$map,
						function (a) {
							return $elm$bytes$Bytes$Decode$Done(
								_Utils_ap(
									string,
									A2($danfishgold$base64_bytes$Decode$bitsToChars, a << 16, 2)));
						},
						$elm$bytes$Bytes$Decode$unsignedInt8);
				}
			}
		}
	}
};
var $danfishgold$base64_bytes$Decode$decoder = function (width) {
	return A2(
		$elm$bytes$Bytes$Decode$loop,
		{fo: width, fz: ''},
		$danfishgold$base64_bytes$Decode$loopHelp);
};
var $danfishgold$base64_bytes$Decode$fromBytes = function (bytes) {
	return A2(
		$elm$bytes$Bytes$Decode$decode,
		$danfishgold$base64_bytes$Decode$decoder(
			$elm$bytes$Bytes$width(bytes)),
		bytes);
};
var $danfishgold$base64_bytes$Base64$fromBytes = $danfishgold$base64_bytes$Decode$fromBytes;
var $justgook$elm_image$Image$Internal$ImageData$RGBA = 0;
var $justgook$elm_image$Image$Internal$ImageData$RightDown = 0;
var $justgook$elm_image$Image$Internal$ImageData$defaultOptions = {iW: 0, oE: 0};
var $elm$bytes$Bytes$Encode$Bytes = function (a) {
	return {$: 10, a: a};
};
var $elm$bytes$Bytes$Encode$bytes = $elm$bytes$Bytes$Encode$Bytes;
var $folkertdev$elm_flate$Checksum$Crc32$tinf_crc32case = function (i) {
	switch (i) {
		case 0:
			return 0;
		case 1:
			return 498536548;
		case 2:
			return 997073096;
		case 3:
			return 651767980;
		case 4:
			return 1994146192;
		case 5:
			return 1802195444;
		case 6:
			return 1303535960;
		case 7:
			return 1342533948;
		case 8:
			return 3988292384;
		case 9:
			return 4027552580;
		case 10:
			return 3604390888;
		case 11:
			return 3412177804;
		case 12:
			return 2607071920;
		case 13:
			return 2262029012;
		case 14:
			return 2685067896;
		default:
			return 3183342108;
	}
};
var $folkertdev$elm_flate$Checksum$Crc32$step = F2(
	function (_byte, crc) {
		var a = (crc ^ _byte) >>> 0;
		var b = ((a >>> 4) ^ $folkertdev$elm_flate$Checksum$Crc32$tinf_crc32case(a & 15)) >>> 0;
		var c = (b >>> 4) ^ $folkertdev$elm_flate$Checksum$Crc32$tinf_crc32case(b & 15);
		return c;
	});
var $folkertdev$elm_flate$Checksum$Crc32$crc32Help = function (_v0) {
	var remaining = _v0.fo;
	var crc = _v0.eA;
	return (remaining >= 8) ? A3(
		$elm$bytes$Bytes$Decode$map2,
		F2(
			function (word1, word2) {
				var byte8 = 255 & word2;
				var byte7 = 255 & (word2 >>> 8);
				var byte6 = 255 & (word2 >>> 16);
				var byte5 = 255 & (word2 >>> 24);
				var byte4 = 255 & word1;
				var byte3 = 255 & (word1 >>> 8);
				var byte2 = 255 & (word1 >>> 16);
				var byte1 = 255 & (word1 >>> 24);
				return $elm$bytes$Bytes$Decode$Loop(
					{
						eA: A2(
							$folkertdev$elm_flate$Checksum$Crc32$step,
							byte8,
							A2(
								$folkertdev$elm_flate$Checksum$Crc32$step,
								byte7,
								A2(
									$folkertdev$elm_flate$Checksum$Crc32$step,
									byte6,
									A2(
										$folkertdev$elm_flate$Checksum$Crc32$step,
										byte5,
										A2(
											$folkertdev$elm_flate$Checksum$Crc32$step,
											byte4,
											A2(
												$folkertdev$elm_flate$Checksum$Crc32$step,
												byte3,
												A2(
													$folkertdev$elm_flate$Checksum$Crc32$step,
													byte2,
													A2($folkertdev$elm_flate$Checksum$Crc32$step, byte1, crc)))))))),
						fo: remaining - 8
					});
			}),
		$elm$bytes$Bytes$Decode$unsignedInt32(1),
		$elm$bytes$Bytes$Decode$unsignedInt32(1)) : ((remaining > 0) ? A2(
		$elm$bytes$Bytes$Decode$map,
		function (_byte) {
			return $elm$bytes$Bytes$Decode$Loop(
				{
					eA: A2($folkertdev$elm_flate$Checksum$Crc32$step, _byte, crc),
					fo: remaining - 1
				});
		},
		$elm$bytes$Bytes$Decode$unsignedInt8) : $elm$bytes$Bytes$Decode$succeed(
		$elm$bytes$Bytes$Decode$Done((crc ^ 4294967295) >>> 0)));
};
var $folkertdev$elm_flate$Checksum$Crc32$tinf_crc32 = function (buffer) {
	var length = $elm$bytes$Bytes$width(buffer);
	var initialCrc = 4294967295;
	return (!length) ? 0 : A2(
		$elm$core$Maybe$withDefault,
		0,
		A2(
			$elm$bytes$Bytes$Decode$decode,
			A2(
				$elm$bytes$Bytes$Decode$loop,
				{eA: initialCrc, fo: length},
				$folkertdev$elm_flate$Checksum$Crc32$crc32Help),
			buffer));
};
var $folkertdev$elm_flate$Checksum$Crc32$crc32 = $folkertdev$elm_flate$Checksum$Crc32$tinf_crc32;
var $folkertdev$elm_flate$Flate$crc32 = $folkertdev$elm_flate$Checksum$Crc32$crc32;
var $elm$bytes$Bytes$Encode$U32 = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $elm$bytes$Bytes$Encode$unsignedInt32 = $elm$bytes$Bytes$Encode$U32;
var $justgook$elm_image$Image$Internal$PNG$encodeChunk = F2(
	function (kind, data) {
		var length = $elm$bytes$Bytes$width(data);
		var kindAndData = $elm$bytes$Bytes$Encode$encode(
			$elm$bytes$Bytes$Encode$sequence(
				_List_fromArray(
					[
						A2($elm$bytes$Bytes$Encode$unsignedInt32, 1, kind),
						$elm$bytes$Bytes$Encode$bytes(data)
					])));
		return $elm$bytes$Bytes$Encode$sequence(
			_List_fromArray(
				[
					A2($elm$bytes$Bytes$Encode$unsignedInt32, 1, length),
					$elm$bytes$Bytes$Encode$bytes(kindAndData),
					A2(
					$elm$bytes$Bytes$Encode$unsignedInt32,
					1,
					$folkertdev$elm_flate$Flate$crc32(kindAndData))
				]));
	});
var $folkertdev$elm_flate$Flate$Dynamic = function (a) {
	return {$: 1, a: a};
};
var $folkertdev$elm_flate$Flate$WithWindowSize = function (a) {
	return {$: 1, a: a};
};
var $folkertdev$elm_flate$Checksum$Adler32$a32 = {fW: 65521, jB: 5552};
var $folkertdev$elm_flate$Checksum$Adler32$step8Bytes = F5(
	function (remaining, s1, s2, word1, word2) {
		var byte8 = 255 & word2;
		var byte7 = 255 & (word2 >>> 8);
		var byte6 = 255 & (word2 >>> 16);
		var byte5 = 255 & (word2 >>> 24);
		var byte4 = 255 & word1;
		var byte3 = 255 & (word1 >>> 8);
		var byte2 = 255 & (word1 >>> 16);
		var byte1 = 255 & (word1 >>> 24);
		var s1a_1 = s1 + byte1;
		var s1a_2 = s1a_1 + byte2;
		var s1a_3 = s1a_2 + byte3;
		var s1a_4 = s1a_3 + byte4;
		var s2a_1 = s2 + s1a_1;
		var s2a_2 = s2a_1 + s1a_2;
		var s2a_3 = s2a_2 + s1a_3;
		var s2a_4 = s2a_3 + s1a_4;
		var s1b_1 = s1a_4 + byte5;
		var s1b_2 = s1b_1 + byte6;
		var s1b_3 = s1b_2 + byte7;
		var s1b_4 = s1b_3 + byte8;
		var s2b_1 = s2a_4 + s1b_1;
		var s2b_2 = s2b_1 + s1b_2;
		var s2b_3 = s2b_2 + s1b_3;
		var s2b_4 = s2b_3 + s1b_4;
		return $elm$bytes$Bytes$Decode$Loop(
			{fo: remaining - 8, ad: s1b_4, ae: s2b_4});
	});
var $folkertdev$elm_flate$Checksum$Adler32$processChunkHelp = function (_v0) {
	var remaining = _v0.fo;
	var s1 = _v0.ad;
	var s2 = _v0.ae;
	return (remaining >= 8) ? A3(
		$elm$bytes$Bytes$Decode$map2,
		A3($folkertdev$elm_flate$Checksum$Adler32$step8Bytes, remaining, s1, s2),
		$elm$bytes$Bytes$Decode$unsignedInt32(1),
		$elm$bytes$Bytes$Decode$unsignedInt32(1)) : ((remaining > 0) ? A2(
		$elm$bytes$Bytes$Decode$map,
		function (_byte) {
			return $elm$bytes$Bytes$Decode$Loop(
				{fo: remaining - 1, ad: s1 + _byte, ae: (s1 + _byte) + s2});
		},
		$elm$bytes$Bytes$Decode$unsignedInt8) : $elm$bytes$Bytes$Decode$succeed(
		$elm$bytes$Bytes$Decode$Done(
			{ad: s1 % $folkertdev$elm_flate$Checksum$Adler32$a32.fW, ae: s2 % $folkertdev$elm_flate$Checksum$Adler32$a32.fW})));
};
var $folkertdev$elm_flate$Checksum$Adler32$processChunk = function (config) {
	return A2($elm$bytes$Bytes$Decode$loop, config, $folkertdev$elm_flate$Checksum$Adler32$processChunkHelp);
};
var $folkertdev$elm_flate$Checksum$Adler32$chunkedFold = function (_v0) {
	var bufferSize = _v0.h8;
	var maxBlockSize = _v0.ju;
	var go = function (_v1) {
		var remainingLength = _v1.ho;
		var s1 = _v1.ad;
		var s2 = _v1.ae;
		return (!remainingLength) ? $elm$bytes$Bytes$Decode$succeed(
			$elm$bytes$Bytes$Decode$Done(
				{ad: s1, ae: s2})) : ((_Utils_cmp(remainingLength, maxBlockSize) < 0) ? A2(
			$elm$bytes$Bytes$Decode$map,
			$elm$bytes$Bytes$Decode$Done,
			$folkertdev$elm_flate$Checksum$Adler32$processChunk(
				{fo: remainingLength, ad: s1, ae: s2})) : A2(
			$elm$bytes$Bytes$Decode$map,
			function (result) {
				return $elm$bytes$Bytes$Decode$Loop(
					{ho: remainingLength - maxBlockSize, ad: result.ad, ae: result.ae});
			},
			$folkertdev$elm_flate$Checksum$Adler32$processChunk(
				{fo: maxBlockSize, ad: s1, ae: s2})));
	};
	return A2(
		$elm$bytes$Bytes$Decode$loop,
		{ho: bufferSize, ad: 1, ae: 0},
		go);
};
var $folkertdev$elm_flate$Checksum$Adler32$adler32 = function (buffer) {
	var _v0 = A2(
		$elm$bytes$Bytes$Decode$decode,
		$folkertdev$elm_flate$Checksum$Adler32$chunkedFold(
			{
				h8: $elm$bytes$Bytes$width(buffer),
				ju: $folkertdev$elm_flate$Checksum$Adler32$a32.jB
			}),
		buffer);
	if (_v0.$ === 1) {
		return 0;
	} else {
		var s1 = _v0.a.ad;
		var s2 = _v0.a.ae;
		return ((s2 << 16) | s1) >>> 0;
	}
};
var $elm$bytes$Bytes$Decode$bytes = function (n) {
	return _Bytes_read_bytes(n);
};
var $folkertdev$elm_flate$Deflate$Internal$chunksHelp = F2(
	function (chunkSize, _v0) {
		var sizeRemaining = _v0.a;
		var accum = _v0.b;
		return (!sizeRemaining) ? $elm$bytes$Bytes$Decode$succeed(
			$elm$bytes$Bytes$Decode$Done(_List_Nil)) : ((_Utils_cmp(chunkSize, sizeRemaining) > -1) ? A2(
			$elm$bytes$Bytes$Decode$map,
			function (_new) {
				return $elm$bytes$Bytes$Decode$Done(
					$elm$core$List$reverse(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(true, _new),
							accum)));
			},
			$elm$bytes$Bytes$Decode$bytes(sizeRemaining)) : A2(
			$elm$bytes$Bytes$Decode$map,
			function (_new) {
				return $elm$bytes$Bytes$Decode$Loop(
					_Utils_Tuple2(
						sizeRemaining - chunkSize,
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(false, _new),
							accum)));
			},
			$elm$bytes$Bytes$Decode$bytes(chunkSize)));
	});
var $folkertdev$elm_flate$Deflate$Internal$chunks = F2(
	function (chunkSize, buffer) {
		var _v0 = A2(
			$elm$bytes$Bytes$Decode$decode,
			A2(
				$elm$bytes$Bytes$Decode$loop,
				_Utils_Tuple2(
					$elm$bytes$Bytes$width(buffer),
					_List_Nil),
				$folkertdev$elm_flate$Deflate$Internal$chunksHelp(chunkSize)),
			buffer);
		if (_v0.$ === 1) {
			return _List_fromArray(
				[
					_Utils_Tuple2(
					true,
					$elm$bytes$Bytes$Encode$encode(
						$elm$bytes$Bytes$Encode$sequence(_List_Nil)))
				]);
		} else {
			if (!_v0.a.b) {
				return _List_fromArray(
					[
						_Utils_Tuple2(
						true,
						$elm$bytes$Bytes$Encode$encode(
							$elm$bytes$Bytes$Encode$sequence(_List_Nil)))
					]);
			} else {
				var value = _v0.a;
				return value;
			}
		}
	});
var $folkertdev$elm_flate$Deflate$Internal$default_block_size = 1024 * 1024;
var $folkertdev$elm_flate$Deflate$BitWriter$empty = {au: 0, ay: _List_Nil, a8: 0};
var $folkertdev$elm_flate$Deflate$Symbol$code = function (symbol) {
	switch (symbol.$) {
		case 1:
			var _byte = symbol.a;
			return _byte;
		case 0:
			return 256;
		default:
			var length = symbol.a;
			return ((length >= 3) && (length <= 10)) ? ((257 + length) - 3) : (((length >= 11) && (length <= 18)) ? (265 + (((length - 11) / 2) | 0)) : (((length >= 19) && (length <= 34)) ? (269 + (((length - 19) / 4) | 0)) : (((length >= 35) && (length <= 66)) ? (273 + (((length - 35) / 8) | 0)) : (((length >= 67) && (length <= 130)) ? (277 + (((length - 67) / 16) | 0)) : (((length >= 131) && (length <= 257)) ? (281 + (((length - 131) / 32) | 0)) : ((length === 258) ? 285 : (-1)))))));
	}
};
var $folkertdev$elm_flate$Deflate$Symbol$distance = function (symbol) {
	if (symbol.$ === 2) {
		var distance_ = symbol.b;
		if (distance_ <= 4) {
			return $elm$core$Maybe$Just(
				_Utils_Tuple3(distance_ - 1, 0, 0));
		} else {
			var go = F3(
				function (extraBits, code_, base) {
					go:
					while (true) {
						if (_Utils_cmp(base * 2, distance_) < 0) {
							var $temp$extraBits = extraBits + 1,
								$temp$code_ = code_ + 2,
								$temp$base = base * 2;
							extraBits = $temp$extraBits;
							code_ = $temp$code_;
							base = $temp$base;
							continue go;
						} else {
							return _Utils_Tuple3(extraBits, code_, base);
						}
					}
				});
			var _v1 = A3(go, 1, 4, 4);
			var extraBits = _v1.a;
			var code_ = _v1.b;
			var base = _v1.c;
			var delta = (distance_ - base) - 1;
			var half = (base / 2) | 0;
			return (_Utils_cmp(distance_, base + half) < 1) ? $elm$core$Maybe$Just(
				_Utils_Tuple3(
					code_,
					extraBits,
					A2($elm$core$Basics$modBy, half, delta))) : $elm$core$Maybe$Just(
				_Utils_Tuple3(
					code_ + 1,
					extraBits,
					A2($elm$core$Basics$modBy, half, delta)));
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $folkertdev$elm_flate$Deflate$Symbol$update = F3(
	function (index, tagger, array) {
		var _v0 = A2($elm$core$Array$get, index, array);
		if (_v0.$ === 1) {
			return array;
		} else {
			var value = _v0.a;
			return A3(
				$elm$core$Array$set,
				index,
				tagger(value),
				array);
		}
	});
var $folkertdev$elm_flate$Deflate$Symbol$dynamicFindFrequencies = F2(
	function (symbol, _v0) {
		var literalCounts = _v0.a;
		var distanceCounts = _v0.b;
		var emptyDistanceCount = _v0.c;
		var _v1 = $folkertdev$elm_flate$Deflate$Symbol$distance(symbol);
		if (_v1.$ === 1) {
			return _Utils_Tuple3(
				A3(
					$folkertdev$elm_flate$Deflate$Symbol$update,
					$folkertdev$elm_flate$Deflate$Symbol$code(symbol),
					function (v) {
						return v + 1;
					},
					literalCounts),
				distanceCounts,
				emptyDistanceCount);
		} else {
			var _v2 = _v1.a;
			var d = _v2.a;
			return _Utils_Tuple3(
				A3(
					$folkertdev$elm_flate$Deflate$Symbol$update,
					$folkertdev$elm_flate$Deflate$Symbol$code(symbol),
					function (v) {
						return v + 1;
					},
					literalCounts),
				A3(
					$folkertdev$elm_flate$Deflate$Symbol$update,
					d,
					function (v) {
						return v + 1;
					},
					distanceCounts),
				false);
		}
	});
var $folkertdev$elm_flate$Huffman$calcOptimalMaxBitWidth = function (frequencies) {
	var heapModificationLoop = function (heap) {
		heapModificationLoop:
		while (true) {
			if (!heap.b) {
				return 0;
			} else {
				if (!heap.b.b) {
					var _v1 = heap.a;
					var value = _v1.b;
					return A2($elm$core$Basics$max, 1, value);
				} else {
					var _v2 = heap.a;
					var weight1 = _v2.a;
					var width1 = _v2.b;
					var _v3 = heap.b;
					var _v4 = _v3.a;
					var weight2 = _v4.a;
					var width2 = _v4.b;
					var rest = _v3.b;
					var $temp$heap = A2(
						$elm$core$List$sortWith,
						F2(
							function (a, b) {
								return A2($elm$core$Basics$compare, b, a);
							}),
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								weight1 + weight2,
								1 + A2($elm$core$Basics$max, width1, width2)),
							rest));
					heap = $temp$heap;
					continue heapModificationLoop;
				}
			}
		}
	};
	var createHeapFolder = F2(
		function (freq, heap) {
			return (freq > 0) ? A2(
				$elm$core$List$cons,
				_Utils_Tuple2(-freq, 0),
				heap) : heap;
		});
	var createHeap = A3($elm$core$Array$foldl, createHeapFolder, _List_Nil, frequencies);
	return heapModificationLoop(createHeap);
};
var $elm$core$Array$filter = F2(
	function (isGood, array) {
		return $elm$core$Array$fromList(
			A3(
				$elm$core$Array$foldr,
				F2(
					function (x, xs) {
						return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
					}),
				_List_Nil,
				array));
	});
var $elm$core$Elm$JsArray$map = _JsArray_map;
var $elm$core$Array$map = F2(
	function (func, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = function (node) {
			if (!node.$) {
				var subTree = node.a;
				return $elm$core$Array$SubTree(
					A2($elm$core$Elm$JsArray$map, helper, subTree));
			} else {
				var values = node.a;
				return $elm$core$Array$Leaf(
					A2($elm$core$Elm$JsArray$map, func, values));
			}
		};
		return A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			A2($elm$core$Elm$JsArray$map, helper, tree),
			A2($elm$core$Elm$JsArray$map, func, tail));
	});
var $elm$core$Elm$JsArray$appendN = _JsArray_appendN;
var $elm$core$Elm$JsArray$slice = _JsArray_slice;
var $elm$core$Array$appendHelpBuilder = F2(
	function (tail, builder) {
		var tailLen = $elm$core$Elm$JsArray$length(tail);
		var notAppended = ($elm$core$Array$branchFactor - $elm$core$Elm$JsArray$length(builder.w)) - tailLen;
		var appended = A3($elm$core$Elm$JsArray$appendN, $elm$core$Array$branchFactor, builder.w, tail);
		return (notAppended < 0) ? {
			y: A2(
				$elm$core$List$cons,
				$elm$core$Array$Leaf(appended),
				builder.y),
			p: builder.p + 1,
			w: A3($elm$core$Elm$JsArray$slice, notAppended, tailLen, tail)
		} : ((!notAppended) ? {
			y: A2(
				$elm$core$List$cons,
				$elm$core$Array$Leaf(appended),
				builder.y),
			p: builder.p + 1,
			w: $elm$core$Elm$JsArray$empty
		} : {y: builder.y, p: builder.p, w: appended});
	});
var $elm$core$Array$appendHelpTree = F2(
	function (toAppend, array) {
		var len = array.a;
		var tree = array.c;
		var tail = array.d;
		var itemsToAppend = $elm$core$Elm$JsArray$length(toAppend);
		var notAppended = ($elm$core$Array$branchFactor - $elm$core$Elm$JsArray$length(tail)) - itemsToAppend;
		var appended = A3($elm$core$Elm$JsArray$appendN, $elm$core$Array$branchFactor, tail, toAppend);
		var newArray = A2($elm$core$Array$unsafeReplaceTail, appended, array);
		if (notAppended < 0) {
			var nextTail = A3($elm$core$Elm$JsArray$slice, notAppended, itemsToAppend, toAppend);
			return A2($elm$core$Array$unsafeReplaceTail, nextTail, newArray);
		} else {
			return newArray;
		}
	});
var $elm$core$Array$builderFromArray = function (_v0) {
	var len = _v0.a;
	var tree = _v0.c;
	var tail = _v0.d;
	var helper = F2(
		function (node, acc) {
			if (!node.$) {
				var subTree = node.a;
				return A3($elm$core$Elm$JsArray$foldl, helper, acc, subTree);
			} else {
				return A2($elm$core$List$cons, node, acc);
			}
		});
	return {
		y: A3($elm$core$Elm$JsArray$foldl, helper, _List_Nil, tree),
		p: (len / $elm$core$Array$branchFactor) | 0,
		w: tail
	};
};
var $elm$core$Array$append = F2(
	function (a, _v0) {
		var aTail = a.d;
		var bLen = _v0.a;
		var bTree = _v0.c;
		var bTail = _v0.d;
		if (_Utils_cmp(bLen, $elm$core$Array$branchFactor * 4) < 1) {
			var foldHelper = F2(
				function (node, array) {
					if (!node.$) {
						var tree = node.a;
						return A3($elm$core$Elm$JsArray$foldl, foldHelper, array, tree);
					} else {
						var leaf = node.a;
						return A2($elm$core$Array$appendHelpTree, leaf, array);
					}
				});
			return A2(
				$elm$core$Array$appendHelpTree,
				bTail,
				A3($elm$core$Elm$JsArray$foldl, foldHelper, a, bTree));
		} else {
			var foldHelper = F2(
				function (node, builder) {
					if (!node.$) {
						var tree = node.a;
						return A3($elm$core$Elm$JsArray$foldl, foldHelper, builder, tree);
					} else {
						var leaf = node.a;
						return A2($elm$core$Array$appendHelpBuilder, leaf, builder);
					}
				});
			return A2(
				$elm$core$Array$builderToArray,
				true,
				A2(
					$elm$core$Array$appendHelpBuilder,
					bTail,
					A3(
						$elm$core$Elm$JsArray$foldl,
						foldHelper,
						$elm$core$Array$builderFromArray(a),
						bTree)));
		}
	});
var $folkertdev$elm_flate$LengthLimitedHuffmanCodes$mergeLoop = F3(
	function (xarr, yarr, accum) {
		mergeLoop:
		while (true) {
			var _v0 = _Utils_Tuple2(xarr, yarr);
			if (!_v0.a.b) {
				return A2(
					$elm$core$Array$append,
					accum,
					$elm$core$Array$fromList(yarr));
			} else {
				if (!_v0.b.b) {
					return A2(
						$elm$core$Array$append,
						accum,
						$elm$core$Array$fromList(xarr));
				} else {
					var _v1 = _v0.a;
					var x = _v1.a;
					var xrest = _v1.b;
					var _v2 = _v0.b;
					var y = _v2.a;
					var yrest = _v2.b;
					if (_Utils_cmp(x.aO, y.aO) < 0) {
						var $temp$xarr = xrest,
							$temp$yarr = yarr,
							$temp$accum = A2($elm$core$Array$push, x, accum);
						xarr = $temp$xarr;
						yarr = $temp$yarr;
						accum = $temp$accum;
						continue mergeLoop;
					} else {
						var $temp$xarr = xarr,
							$temp$yarr = yrest,
							$temp$accum = A2($elm$core$Array$push, y, accum);
						xarr = $temp$xarr;
						yarr = $temp$yarr;
						accum = $temp$accum;
						continue mergeLoop;
					}
				}
			}
		}
	});
var $folkertdev$elm_flate$LengthLimitedHuffmanCodes$merge = F2(
	function (x, y) {
		return A3(
			$folkertdev$elm_flate$LengthLimitedHuffmanCodes$mergeLoop,
			$elm$core$Array$toList(x),
			$elm$core$Array$toList(y),
			$elm$core$Array$empty);
	});
var $folkertdev$elm_flate$LengthLimitedHuffmanCodes$mergeNodes = F2(
	function (node1, node2) {
		return {
			cy: A2($elm$core$Array$append, node1.cy, node2.cy),
			aO: node1.aO + node2.aO
		};
	});
var $folkertdev$elm_flate$LengthLimitedHuffmanCodes$package = function (nodes) {
	if ($elm$core$Array$length(nodes) >= 2) {
		var newLen = ($elm$core$Array$length(nodes) / 2) | 0;
		var loop = F2(
			function (currentNodes, accum) {
				loop:
				while (true) {
					if (currentNodes.b && currentNodes.b.b) {
						var self = currentNodes.a;
						var _v1 = currentNodes.b;
						var other = _v1.a;
						var rest = _v1.b;
						var $temp$currentNodes = rest,
							$temp$accum = A2(
							$elm$core$List$cons,
							A2($folkertdev$elm_flate$LengthLimitedHuffmanCodes$mergeNodes, self, other),
							accum);
						currentNodes = $temp$currentNodes;
						accum = $temp$accum;
						continue loop;
					} else {
						return $elm$core$Array$fromList(
							$elm$core$List$reverse(accum));
					}
				}
			});
		return A2(
			loop,
			$elm$core$Array$toList(nodes),
			_List_Nil);
	} else {
		return nodes;
	}
};
var $elm$core$Array$repeat = F2(
	function (n, e) {
		return A2(
			$elm$core$Array$initialize,
			n,
			function (_v0) {
				return e;
			});
	});
var $folkertdev$elm_flate$LengthLimitedHuffmanCodes$singletonNode = F2(
	function (symbol, weight) {
		return {
			cy: A2($elm$core$Array$repeat, 1, symbol),
			aO: weight
		};
	});
var $elm_community$list_extra$List$Extra$stableSortWith = F2(
	function (pred, list) {
		var predWithIndex = F2(
			function (_v1, _v2) {
				var a1 = _v1.a;
				var i1 = _v1.b;
				var a2 = _v2.a;
				var i2 = _v2.b;
				var result = A2(pred, a1, a2);
				if (result === 1) {
					return A2($elm$core$Basics$compare, i1, i2);
				} else {
					return result;
				}
			});
		var listWithIndex = A2(
			$elm$core$List$indexedMap,
			F2(
				function (i, a) {
					return _Utils_Tuple2(a, i);
				}),
			list);
		return A2(
			$elm$core$List$map,
			$elm$core$Tuple$first,
			A2($elm$core$List$sortWith, predWithIndex, listWithIndex));
	});
var $folkertdev$elm_flate$LengthLimitedHuffmanCodes$update = F3(
	function (index, tagger, array) {
		var _v0 = A2($elm$core$Array$get, index, array);
		if (_v0.$ === 1) {
			return array;
		} else {
			var value = _v0.a;
			return A3(
				$elm$core$Array$set,
				index,
				tagger(value),
				array);
		}
	});
var $folkertdev$elm_flate$LengthLimitedHuffmanCodes$calculate = F2(
	function (maxBitWidth, frequencies) {
		var source = $elm$core$Array$fromList(
			A2(
				$elm_community$list_extra$List$Extra$stableSortWith,
				F2(
					function (a, b) {
						return A2($elm$core$Basics$compare, a.aO, b.aO);
					}),
				$elm$core$Array$toList(
					A2(
						$elm$core$Array$map,
						function (_v3) {
							var symbol = _v3.a;
							var weight = _v3.b;
							return A2($folkertdev$elm_flate$LengthLimitedHuffmanCodes$singletonNode, symbol, weight);
						},
						A2(
							$elm$core$Array$filter,
							function (_v2) {
								var f = _v2.b;
								return f > 0;
							},
							A2($elm$core$Array$indexedMap, $elm$core$Tuple$pair, frequencies))))));
		var weighted = A3(
			$elm$core$List$foldl,
			F2(
				function (_v1, w) {
					return A2(
						$folkertdev$elm_flate$LengthLimitedHuffmanCodes$merge,
						$folkertdev$elm_flate$LengthLimitedHuffmanCodes$package(w),
						source);
				}),
			source,
			A2($elm$core$List$range, 0, maxBitWidth - 2));
		var loop = F2(
			function (symbols, accum) {
				loop:
				while (true) {
					if (!symbols.b) {
						return accum;
					} else {
						var symbol = symbols.a;
						var rest = symbols.b;
						var $temp$symbols = rest,
							$temp$accum = A3(
							$folkertdev$elm_flate$LengthLimitedHuffmanCodes$update,
							symbol,
							function (v) {
								return v + 1;
							},
							accum);
						symbols = $temp$symbols;
						accum = $temp$accum;
						continue loop;
					}
				}
			});
		var allSymbols = A2(
			$elm$core$List$concatMap,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.cy;
				},
				$elm$core$Array$toList),
			$elm$core$Array$toList(
				$folkertdev$elm_flate$LengthLimitedHuffmanCodes$package(weighted)));
		return A2(
			loop,
			allSymbols,
			A2(
				$elm$core$Array$repeat,
				$elm$core$Array$length(frequencies),
				0));
	});
var $folkertdev$elm_flate$Huffman$Tree = $elm$core$Basics$identity;
var $folkertdev$elm_flate$Huffman$Code = $elm$core$Basics$identity;
var $folkertdev$elm_flate$Huffman$codeFromRecord = $elm$core$Basics$identity;
var $folkertdev$elm_flate$Huffman$new = function (n) {
	return A2(
		$elm$core$Array$repeat,
		n,
		$folkertdev$elm_flate$Huffman$codeFromRecord(
			{a: 0, qQ: 0}));
};
var $folkertdev$elm_flate$Huffman$inverseEndianLoop = F4(
	function (i, limit, f, t) {
		inverseEndianLoop:
		while (true) {
			if (_Utils_cmp(i, limit) < 0) {
				var $temp$i = i + 1,
					$temp$limit = limit,
					$temp$f = f >> 1,
					$temp$t = (f & 1) | (t << 1);
				i = $temp$i;
				limit = $temp$limit;
				f = $temp$f;
				t = $temp$t;
				continue inverseEndianLoop;
			} else {
				return t;
			}
		}
	});
var $folkertdev$elm_flate$Huffman$inverseEndian = function (_v0) {
	var width = _v0.qQ;
	var bits = _v0.a;
	var inverseBits = A4($folkertdev$elm_flate$Huffman$inverseEndianLoop, 0, width, bits, 0);
	return {a: inverseBits, qQ: width};
};
var $folkertdev$elm_flate$Huffman$setMapping = F3(
	function (symbol, code, _v0) {
		var array = _v0;
		return A3(
			$elm$core$Array$set,
			symbol,
			$folkertdev$elm_flate$Huffman$inverseEndian(code),
			array);
	});
var $folkertdev$elm_flate$Huffman$restoreCanonicalHuffmanCodes = F2(
	function (bitWidths, tree) {
		var symbols = A2(
			$elm_community$list_extra$List$Extra$stableSortWith,
			F2(
				function (_v4, _v5) {
					var a = _v4.b;
					var b = _v5.b;
					return A2($elm$core$Basics$compare, a, b);
				}),
			$elm$core$Array$toList(
				A2(
					$elm$core$Array$filter,
					function (_v3) {
						var codeBitWidth = _v3.b;
						return codeBitWidth > 0;
					},
					A2($elm$core$Array$indexedMap, $elm$core$Tuple$pair, bitWidths))));
		var loop = F2(
			function (_v1, _v2) {
				var symbol = _v1.a;
				var bitWidth = _v1.b;
				var code = _v2.a;
				var prevWidth = _v2.b;
				var currentTree = _v2.c;
				var newBits = code << (bitWidth - prevWidth);
				var nextCode = {a: newBits, qQ: bitWidth};
				return _Utils_Tuple3(
					newBits + 1,
					bitWidth,
					A3($folkertdev$elm_flate$Huffman$setMapping, symbol, nextCode, currentTree));
			});
		return function (_v0) {
			var x = _v0.c;
			return x;
		}(
			A3(
				$elm$core$List$foldl,
				loop,
				_Utils_Tuple3(0, 0, tree),
				symbols));
	});
var $folkertdev$elm_flate$Huffman$fromBitWidths = function (bitWidths) {
	var symbolCount = function (v) {
		return v + 1;
	}(
		A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$first,
				function (a) {
					return A2(
						$elm$core$Array$get,
						$elm$core$Array$length(a) - 1,
						a);
				}(
					A2(
						$elm$core$Array$filter,
						function (e) {
							return e.b > 0;
						},
						A2($elm$core$Array$indexedMap, $elm$core$Tuple$pair, bitWidths))))));
	return A2(
		$folkertdev$elm_flate$Huffman$restoreCanonicalHuffmanCodes,
		bitWidths,
		$folkertdev$elm_flate$Huffman$new(symbolCount));
};
var $folkertdev$elm_flate$Huffman$fromFrequencies = F2(
	function (symbolFrequencies, maxBitWidth_) {
		var maxBitWidth = A2(
			$elm$core$Basics$min,
			maxBitWidth_,
			$folkertdev$elm_flate$Huffman$calcOptimalMaxBitWidth(symbolFrequencies));
		var codeBitWidhts = A2($folkertdev$elm_flate$LengthLimitedHuffmanCodes$calculate, maxBitWidth, symbolFrequencies);
		return $folkertdev$elm_flate$Huffman$fromBitWidths(codeBitWidhts);
	});
var $folkertdev$elm_flate$Deflate$Symbol$buildDynamicHuffmanCodec = function (symbols) {
	var _v0 = A3(
		$elm$core$Array$foldl,
		$folkertdev$elm_flate$Deflate$Symbol$dynamicFindFrequencies,
		_Utils_Tuple3(
			A2($elm$core$Array$repeat, 286, 0),
			A2($elm$core$Array$repeat, 30, 0),
			true),
		symbols);
	var literalCounts = _v0.a;
	var distanceCounts = _v0.b;
	var emptyDistanceCount = _v0.c;
	return {
		bV: emptyDistanceCount ? A2(
			$folkertdev$elm_flate$Huffman$fromFrequencies,
			A3($elm$core$Array$set, 0, 1, distanceCounts),
			15) : A2($folkertdev$elm_flate$Huffman$fromFrequencies, distanceCounts, 15),
		b4: A2($folkertdev$elm_flate$Huffman$fromFrequencies, literalCounts, 15)
	};
};
var $folkertdev$elm_flate$Deflate$Symbol$EndOfBlock = {$: 0};
var $folkertdev$elm_flate$Deflate$Symbol$Literal = function (a) {
	return {$: 1, a: a};
};
var $folkertdev$elm_flate$Deflate$Symbol$Share = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $folkertdev$elm_flate$Deflate$Internal$codeToSymbol = function (code) {
	if (!code.$) {
		var v = code.a;
		return $folkertdev$elm_flate$Deflate$Symbol$Literal(v);
	} else {
		var length = code.a;
		var backwardDistance = code.b;
		return A2($folkertdev$elm_flate$Deflate$Symbol$Share, length, backwardDistance);
	}
};
var $folkertdev$elm_flate$LZ77$Literal = function (a) {
	return {$: 0, a: a};
};
var $folkertdev$elm_flate$LZ77$Pointer = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $folkertdev$elm_flate$PrefixTable$Small = function (a) {
	return {$: 0, a: a};
};
var $folkertdev$elm_flate$PrefixTable$Large = function (a) {
	return {$: 1, a: a};
};
var $folkertdev$elm_flate$PrefixTable$LargePrefixTable = $elm$core$Basics$identity;
var $folkertdev$elm_flate$PrefixTable$insertInList = F6(
	function (i, array, p2, position, remaining, accum) {
		insertInList:
		while (true) {
			if (!remaining.b) {
				var newPositions = A2(
					$elm$core$List$cons,
					_Utils_Tuple2(p2, position),
					accum);
				return _Utils_Tuple2(
					$folkertdev$elm_flate$PrefixTable$Large(
						A3($elm$core$Array$set, i, newPositions, array)),
					$elm$core$Maybe$Nothing);
			} else {
				var current = remaining.a;
				var key = current.a;
				var oldValue = current.b;
				var rest = remaining.b;
				if (!(key - p2)) {
					var newPositions = _Utils_ap(
						accum,
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(key, position),
							rest));
					return _Utils_Tuple2(
						$folkertdev$elm_flate$PrefixTable$Large(
							A3($elm$core$Array$set, i, newPositions, array)),
						$elm$core$Maybe$Just(oldValue));
				} else {
					var $temp$i = i,
						$temp$array = array,
						$temp$p2 = p2,
						$temp$position = position,
						$temp$remaining = rest,
						$temp$accum = A2($elm$core$List$cons, current, accum);
					i = $temp$i;
					array = $temp$array;
					p2 = $temp$p2;
					position = $temp$position;
					remaining = $temp$remaining;
					accum = $temp$accum;
					continue insertInList;
				}
			}
		}
	});
var $folkertdev$elm_flate$PrefixTable$insert = F3(
	function (_v0, position, ptable) {
		var prefix_ = _v0;
		var prefix = 16777215 & (prefix_ >>> 0);
		if (!ptable.$) {
			var dict = ptable.a;
			var _v2 = A2($elm$core$Dict$get, prefix, dict);
			if (_v2.$ === 1) {
				return _Utils_Tuple2(
					$folkertdev$elm_flate$PrefixTable$Small(
						A3($elm$core$Dict$insert, prefix, position, dict)),
					$elm$core$Maybe$Nothing);
			} else {
				var oldValue = _v2.a;
				return _Utils_Tuple2(
					$folkertdev$elm_flate$PrefixTable$Small(
						A3($elm$core$Dict$insert, prefix, position, dict)),
					$elm$core$Maybe$Just(oldValue));
			}
		} else {
			var array = ptable.a;
			var index = prefix >> 8;
			var _v3 = A2($elm$core$Array$get, index, array);
			if (_v3.$ === 1) {
				return _Utils_Tuple2(ptable, $elm$core$Maybe$Nothing);
			} else {
				var positions = _v3.a;
				return A6($folkertdev$elm_flate$PrefixTable$insertInList, index, array, 255 & prefix, position, positions, _List_Nil);
			}
		}
	});
var $folkertdev$elm_flate$Experimental$ByteArray$length = function (_v0) {
	var array = _v0.a;
	var finalSize = _v0.b;
	var finalBytes = _v0.c;
	var _v1 = $elm$core$Array$length(array) * 4;
	if (!_v1) {
		return finalSize;
	} else {
		var l = _v1;
		return l + finalSize;
	}
};
var $folkertdev$elm_flate$Experimental$ByteArray$get = F2(
	function (index, _v0) {
		var array = _v0.a;
		var finalSize = _v0.b;
		var finalBytes = _v0.c;
		var offset = index % 4;
		if (_Utils_cmp(
			index,
			($elm$core$Array$length(array) * 4) + finalSize) > -1) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (_Utils_cmp(
				index,
				$elm$core$Array$length(array) * 4) > -1) {
				return $elm$core$Maybe$Just(255 & (finalBytes >>> (8 * (3 - offset))));
			} else {
				var internalIndex = (index / 4) | 0;
				var _v1 = A2($elm$core$Array$get, internalIndex, array);
				if (_v1.$ === 1) {
					return $elm$core$Maybe$Nothing;
				} else {
					var int32 = _v1.a;
					return $elm$core$Maybe$Just(255 & (int32 >>> (8 * (3 - offset))));
				}
			}
		}
	});
var $folkertdev$elm_flate$LZ77$longestCommonPrefixLoop = F5(
	function (i, j, limit, accum, array) {
		longestCommonPrefixLoop:
		while (true) {
			if (_Utils_cmp(i, limit) < 0) {
				var _v0 = A2($folkertdev$elm_flate$Experimental$ByteArray$get, i, array);
				if (_v0.$ === 1) {
					return accum;
				} else {
					var value1 = _v0.a;
					var _v1 = A2($folkertdev$elm_flate$Experimental$ByteArray$get, j, array);
					if (_v1.$ === 1) {
						return accum;
					} else {
						var value2 = _v1.a;
						if (!(value1 - value2)) {
							var $temp$i = i + 1,
								$temp$j = j + 1,
								$temp$limit = limit,
								$temp$accum = accum + 1,
								$temp$array = array;
							i = $temp$i;
							j = $temp$j;
							limit = $temp$limit;
							accum = $temp$accum;
							array = $temp$array;
							continue longestCommonPrefixLoop;
						} else {
							return accum;
						}
					}
				}
			} else {
				return accum;
			}
		}
	});
var $folkertdev$elm_flate$LZ77$max_length = 258;
var $folkertdev$elm_flate$LZ77$longestCommonPrefix = F3(
	function (i, j, array) {
		var remaining = A2(
			$elm$core$Basics$min,
			$folkertdev$elm_flate$LZ77$max_length - 3,
			$folkertdev$elm_flate$Experimental$ByteArray$length(array) - j);
		return A5($folkertdev$elm_flate$LZ77$longestCommonPrefixLoop, i, j, i + remaining, 0, array);
	});
var $folkertdev$elm_flate$PrefixTable$OutOfBounds = {$: 3};
var $folkertdev$elm_flate$PrefixTable$Prefix = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $folkertdev$elm_flate$PrefixTable$PrefixCode = $elm$core$Basics$identity;
var $folkertdev$elm_flate$PrefixTable$Trailing1 = function (a) {
	return {$: 1, a: a};
};
var $folkertdev$elm_flate$PrefixTable$Trailing2 = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $folkertdev$elm_flate$Experimental$ByteArray$getInt32 = F2(
	function (index, _v0) {
		var array = _v0.a;
		var finalBytes = _v0.c;
		var size = $elm$core$Array$length(array);
		return (!(index - size)) ? $elm$core$Maybe$Just(finalBytes) : A2($elm$core$Array$get, index, array);
	});
var $folkertdev$elm_flate$PrefixTable$prefixAt = F2(
	function (k, input) {
		var size = $folkertdev$elm_flate$Experimental$ByteArray$length(input);
		if (_Utils_cmp(k + 2, size) > -1) {
			if (_Utils_cmp(k, size) > -1) {
				return $folkertdev$elm_flate$PrefixTable$OutOfBounds;
			} else {
				if (_Utils_cmp(k + 1, size) > -1) {
					var _v0 = A2($folkertdev$elm_flate$Experimental$ByteArray$get, k, input);
					if (_v0.$ === 1) {
						return $folkertdev$elm_flate$PrefixTable$OutOfBounds;
					} else {
						var value = _v0.a;
						return $folkertdev$elm_flate$PrefixTable$Trailing1(value);
					}
				} else {
					var _v1 = A2($folkertdev$elm_flate$Experimental$ByteArray$get, k, input);
					if (_v1.$ === 1) {
						return $folkertdev$elm_flate$PrefixTable$OutOfBounds;
					} else {
						var v1 = _v1.a;
						var _v2 = A2($folkertdev$elm_flate$Experimental$ByteArray$get, k + 1, input);
						if (_v2.$ === 1) {
							return $folkertdev$elm_flate$PrefixTable$OutOfBounds;
						} else {
							var v2 = _v2.a;
							return A2($folkertdev$elm_flate$PrefixTable$Trailing2, v1, v2);
						}
					}
				}
			}
		} else {
			var offset = k % 4;
			var internalIndex = (k / 4) | 0;
			switch (offset) {
				case 0:
					var _v4 = A2($folkertdev$elm_flate$Experimental$ByteArray$getInt32, internalIndex, input);
					if (_v4.$ === 1) {
						return $folkertdev$elm_flate$PrefixTable$OutOfBounds;
					} else {
						var int32 = _v4.a;
						var first = 255 & ((int32 >> 24) >>> 0);
						var code = int32 >> 8;
						return A2($folkertdev$elm_flate$PrefixTable$Prefix, first, code);
					}
				case 1:
					var _v5 = A2($folkertdev$elm_flate$Experimental$ByteArray$getInt32, internalIndex, input);
					if (_v5.$ === 1) {
						return $folkertdev$elm_flate$PrefixTable$OutOfBounds;
					} else {
						var int32 = _v5.a;
						var first = 255 & ((255 & (int32 >> 16)) >>> 0);
						var code = 16777215 & int32;
						return A2($folkertdev$elm_flate$PrefixTable$Prefix, first, code);
					}
				case 2:
					var _v6 = A2($folkertdev$elm_flate$Experimental$ByteArray$getInt32, internalIndex, input);
					if (_v6.$ === 1) {
						return $folkertdev$elm_flate$PrefixTable$OutOfBounds;
					} else {
						var int32 = _v6.a;
						var _v7 = A2($folkertdev$elm_flate$Experimental$ByteArray$getInt32, internalIndex + 1, input);
						if (_v7.$ === 1) {
							return $folkertdev$elm_flate$PrefixTable$OutOfBounds;
						} else {
							var nextInt32 = _v7.a;
							var first = 255 & ((255 & (int32 >> 8)) >>> 0);
							var code = 16777215 & (((255 & (nextInt32 >> 24)) | ((65535 & int32) << 8)) >>> 0);
							return A2($folkertdev$elm_flate$PrefixTable$Prefix, first, code);
						}
					}
				default:
					var _v8 = A2($folkertdev$elm_flate$Experimental$ByteArray$getInt32, internalIndex, input);
					if (_v8.$ === 1) {
						return $folkertdev$elm_flate$PrefixTable$OutOfBounds;
					} else {
						var int32 = _v8.a;
						var _v9 = A2($folkertdev$elm_flate$Experimental$ByteArray$getInt32, internalIndex + 1, input);
						if (_v9.$ === 1) {
							return $folkertdev$elm_flate$PrefixTable$OutOfBounds;
						} else {
							var nextInt32 = _v9.a;
							var first = 255 & ((255 & int32) >>> 0);
							var code = (65535 & (nextInt32 >> 16)) | ((255 & int32) << 16);
							return A2($folkertdev$elm_flate$PrefixTable$Prefix, first, code);
						}
					}
			}
		}
	});
var $folkertdev$elm_flate$LZ77$updatePrefixTableLoop = F4(
	function (k, limit, buffer, prefixTable) {
		updatePrefixTableLoop:
		while (true) {
			if (_Utils_cmp(k, limit) < 0) {
				var _v0 = A2($folkertdev$elm_flate$PrefixTable$prefixAt, k, buffer);
				if (!_v0.$) {
					var code = _v0.b;
					var _v1 = A3($folkertdev$elm_flate$PrefixTable$insert, code, k, prefixTable);
					var newPrefixTable = _v1.a;
					var $temp$k = k + 1,
						$temp$limit = limit,
						$temp$buffer = buffer,
						$temp$prefixTable = newPrefixTable;
					k = $temp$k;
					limit = $temp$limit;
					buffer = $temp$buffer;
					prefixTable = $temp$prefixTable;
					continue updatePrefixTableLoop;
				} else {
					return prefixTable;
				}
			} else {
				return prefixTable;
			}
		}
	});
var $folkertdev$elm_flate$LZ77$flushLoop = F5(
	function (i, windowSize, buffer, prefixTable, encoders) {
		flushLoop:
		while (true) {
			var _v0 = A2($folkertdev$elm_flate$PrefixTable$prefixAt, i, buffer);
			switch (_v0.$) {
				case 3:
					return encoders;
				case 1:
					var p1 = _v0.a;
					return A2(
						$elm$core$Array$push,
						$folkertdev$elm_flate$LZ77$Literal(p1),
						encoders);
				case 2:
					var p1 = _v0.a;
					var p2 = _v0.b;
					return A2(
						$elm$core$Array$push,
						$folkertdev$elm_flate$LZ77$Literal(p2),
						A2(
							$elm$core$Array$push,
							$folkertdev$elm_flate$LZ77$Literal(p1),
							encoders));
				default:
					var p1 = _v0.a;
					var key = _v0.b;
					var _v1 = A3($folkertdev$elm_flate$PrefixTable$insert, key, i, prefixTable);
					var newPrefixTable = _v1.a;
					var matched = _v1.b;
					if (!matched.$) {
						var j = matched.a;
						var distance = i - j;
						if ((distance - windowSize) <= 0) {
							var length = 3 + A3($folkertdev$elm_flate$LZ77$longestCommonPrefix, i + 3, j + 3, buffer);
							var newEncoders = A2(
								$elm$core$Array$push,
								A2($folkertdev$elm_flate$LZ77$Pointer, length, distance),
								encoders);
							var newerPrefixTable = A4($folkertdev$elm_flate$LZ77$updatePrefixTableLoop, i + 1, i + length, buffer, newPrefixTable);
							var $temp$i = i + length,
								$temp$windowSize = windowSize,
								$temp$buffer = buffer,
								$temp$prefixTable = newerPrefixTable,
								$temp$encoders = newEncoders;
							i = $temp$i;
							windowSize = $temp$windowSize;
							buffer = $temp$buffer;
							prefixTable = $temp$prefixTable;
							encoders = $temp$encoders;
							continue flushLoop;
						} else {
							var $temp$i = i + 1,
								$temp$windowSize = windowSize,
								$temp$buffer = buffer,
								$temp$prefixTable = newPrefixTable,
								$temp$encoders = A2(
								$elm$core$Array$push,
								$folkertdev$elm_flate$LZ77$Literal(p1),
								encoders);
							i = $temp$i;
							windowSize = $temp$windowSize;
							buffer = $temp$buffer;
							prefixTable = $temp$prefixTable;
							encoders = $temp$encoders;
							continue flushLoop;
						}
					} else {
						var $temp$i = i + 1,
							$temp$windowSize = windowSize,
							$temp$buffer = buffer,
							$temp$prefixTable = newPrefixTable,
							$temp$encoders = A2(
							$elm$core$Array$push,
							$folkertdev$elm_flate$LZ77$Literal(p1),
							encoders);
						i = $temp$i;
						windowSize = $temp$windowSize;
						buffer = $temp$buffer;
						prefixTable = $temp$prefixTable;
						encoders = $temp$encoders;
						continue flushLoop;
					}
			}
		}
	});
var $folkertdev$elm_flate$PrefixTable$max_distance = 32768;
var $folkertdev$elm_flate$PrefixTable$max_window_size = $folkertdev$elm_flate$PrefixTable$max_distance;
var $folkertdev$elm_flate$PrefixTable$newLargePrefixTable = A2($elm$core$Array$repeat, 65535, _List_Nil);
var $folkertdev$elm_flate$PrefixTable$new = function (nbytes) {
	return (_Utils_cmp(nbytes, $folkertdev$elm_flate$PrefixTable$max_window_size) < 0) ? $folkertdev$elm_flate$PrefixTable$Small($elm$core$Dict$empty) : $folkertdev$elm_flate$PrefixTable$Large($folkertdev$elm_flate$PrefixTable$newLargePrefixTable);
};
var $folkertdev$elm_flate$LZ77$flush = F2(
	function (windowSize, buffer) {
		var codes = A5(
			$folkertdev$elm_flate$LZ77$flushLoop,
			0,
			windowSize,
			buffer,
			$folkertdev$elm_flate$PrefixTable$new(
				$folkertdev$elm_flate$Experimental$ByteArray$length(buffer)),
			$elm$core$Array$empty);
		return codes;
	});
var $folkertdev$elm_flate$Experimental$ByteArray$ByteArray = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $folkertdev$elm_flate$Experimental$ByteArray$empty = A3($folkertdev$elm_flate$Experimental$ByteArray$ByteArray, $elm$core$Array$empty, 0, 0);
var $elm$bytes$Bytes$Decode$andThen = F2(
	function (callback, _v0) {
		var decodeA = _v0;
		return F2(
			function (bites, offset) {
				var _v1 = A2(decodeA, bites, offset);
				var newOffset = _v1.a;
				var a = _v1.b;
				var _v2 = callback(a);
				var decodeB = _v2;
				return A2(decodeB, bites, newOffset);
			});
	});
var $folkertdev$elm_flate$Experimental$ByteArray$fromBytesHelp = function (_v0) {
	var remaining = _v0.a;
	var array = _v0.b;
	if (remaining >= 40) {
		return A2(
			$elm$bytes$Bytes$Decode$andThen,
			$elm$core$Basics$identity,
			A6(
				$elm$bytes$Bytes$Decode$map5,
				F5(
					function (a, b, c, d, e) {
						return A6(
							$elm$bytes$Bytes$Decode$map5,
							F5(
								function (f, g, h, i, j) {
									return $elm$bytes$Bytes$Decode$Loop(
										_Utils_Tuple2(
											remaining - 40,
											A2(
												$elm$core$Array$append,
												array,
												$elm$core$Array$fromList(
													_List_fromArray(
														[a, b, c, d, e, f, g, h, i, j])))));
								}),
							$elm$bytes$Bytes$Decode$unsignedInt32(1),
							$elm$bytes$Bytes$Decode$unsignedInt32(1),
							$elm$bytes$Bytes$Decode$unsignedInt32(1),
							$elm$bytes$Bytes$Decode$unsignedInt32(1),
							$elm$bytes$Bytes$Decode$unsignedInt32(1));
					}),
				$elm$bytes$Bytes$Decode$unsignedInt32(1),
				$elm$bytes$Bytes$Decode$unsignedInt32(1),
				$elm$bytes$Bytes$Decode$unsignedInt32(1),
				$elm$bytes$Bytes$Decode$unsignedInt32(1),
				$elm$bytes$Bytes$Decode$unsignedInt32(1)));
	} else {
		if (remaining >= 20) {
			return A6(
				$elm$bytes$Bytes$Decode$map5,
				F5(
					function (a, b, c, d, e) {
						return $elm$bytes$Bytes$Decode$Loop(
							_Utils_Tuple2(
								remaining - 20,
								A2(
									$elm$core$Array$push,
									e,
									A2(
										$elm$core$Array$push,
										d,
										A2(
											$elm$core$Array$push,
											c,
											A2(
												$elm$core$Array$push,
												b,
												A2($elm$core$Array$push, a, array)))))));
					}),
				$elm$bytes$Bytes$Decode$unsignedInt32(1),
				$elm$bytes$Bytes$Decode$unsignedInt32(1),
				$elm$bytes$Bytes$Decode$unsignedInt32(1),
				$elm$bytes$Bytes$Decode$unsignedInt32(1),
				$elm$bytes$Bytes$Decode$unsignedInt32(1));
		} else {
			if (remaining >= 4) {
				return A2(
					$elm$bytes$Bytes$Decode$map,
					function (a) {
						return $elm$bytes$Bytes$Decode$Loop(
							_Utils_Tuple2(
								remaining - 4,
								A2($elm$core$Array$push, a, array)));
					},
					$elm$bytes$Bytes$Decode$unsignedInt32(1));
			} else {
				switch (remaining) {
					case 0:
						return $elm$bytes$Bytes$Decode$succeed(
							$elm$bytes$Bytes$Decode$Done(
								_Utils_Tuple3(0, 0, array)));
					case 1:
						return A2(
							$elm$bytes$Bytes$Decode$map,
							function (_byte) {
								return $elm$bytes$Bytes$Decode$Done(
									_Utils_Tuple3(1, _byte << 24, array));
							},
							$elm$bytes$Bytes$Decode$unsignedInt8);
					case 2:
						return A2(
							$elm$bytes$Bytes$Decode$map,
							function (_byte) {
								return $elm$bytes$Bytes$Decode$Done(
									_Utils_Tuple3(2, _byte << 16, array));
							},
							$elm$bytes$Bytes$Decode$unsignedInt16(1));
					default:
						return A3(
							$elm$bytes$Bytes$Decode$map2,
							F2(
								function (bytes, _byte) {
									return $elm$bytes$Bytes$Decode$Done(
										_Utils_Tuple3(3, (bytes << 16) | (_byte << 8), array));
								}),
							$elm$bytes$Bytes$Decode$unsignedInt16(1),
							$elm$bytes$Bytes$Decode$unsignedInt8);
				}
			}
		}
	}
};
var $folkertdev$elm_flate$Experimental$ByteArray$fromBytes = function (buffer) {
	var _v0 = A2(
		$elm$bytes$Bytes$Decode$decode,
		A2(
			$elm$bytes$Bytes$Decode$loop,
			_Utils_Tuple2(
				$elm$bytes$Bytes$width(buffer),
				$elm$core$Array$empty),
			$folkertdev$elm_flate$Experimental$ByteArray$fromBytesHelp),
		buffer);
	if (_v0.$ === 1) {
		return $folkertdev$elm_flate$Experimental$ByteArray$empty;
	} else {
		var _v1 = _v0.a;
		var finalSize = _v1.a;
		var finalBytes = _v1.b;
		var array = _v1.c;
		return A3($folkertdev$elm_flate$Experimental$ByteArray$ByteArray, array, finalSize, finalBytes);
	}
};
var $folkertdev$elm_flate$LZ77$encodeWithOptions = F2(
	function (_v0, buffer) {
		var windowSize = _v0.qR;
		return A2(
			$folkertdev$elm_flate$LZ77$flush,
			windowSize,
			$folkertdev$elm_flate$Experimental$ByteArray$fromBytes(buffer));
	});
var $folkertdev$elm_flate$ByteArray$decodeByteArrayHelp = function (_v0) {
	var remaining = _v0.a;
	var accum = _v0.b;
	return (remaining >= 4) ? A2(
		$elm$bytes$Bytes$Decode$map,
		function (_new) {
			var byte4 = 255 & (_new >>> 0);
			var byte3 = 255 & ((_new >> 8) >>> 0);
			var byte2 = 255 & ((_new >> 16) >>> 0);
			var byte1 = 255 & ((_new >> 24) >>> 0);
			var newAccum = A2(
				$elm$core$Array$push,
				byte4,
				A2(
					$elm$core$Array$push,
					byte3,
					A2(
						$elm$core$Array$push,
						byte2,
						A2($elm$core$Array$push, byte1, accum))));
			return $elm$bytes$Bytes$Decode$Loop(
				_Utils_Tuple2(remaining - 4, newAccum));
		},
		$elm$bytes$Bytes$Decode$unsignedInt32(1)) : ((remaining > 0) ? A2(
		$elm$bytes$Bytes$Decode$map,
		function (_new) {
			return $elm$bytes$Bytes$Decode$Loop(
				_Utils_Tuple2(
					remaining - 1,
					A2($elm$core$Array$push, _new, accum)));
		},
		$elm$bytes$Bytes$Decode$unsignedInt8) : $elm$bytes$Bytes$Decode$succeed(
		$elm$bytes$Bytes$Decode$Done(accum)));
};
var $folkertdev$elm_flate$ByteArray$decoder = function (n) {
	return A2(
		$elm$bytes$Bytes$Decode$loop,
		_Utils_Tuple2(n, $elm$core$Array$empty),
		$folkertdev$elm_flate$ByteArray$decodeByteArrayHelp);
};
var $folkertdev$elm_flate$ByteArray$fromBytes = function (buffer) {
	var _v0 = A2(
		$elm$bytes$Bytes$Decode$decode,
		$folkertdev$elm_flate$ByteArray$decoder(
			$elm$bytes$Bytes$width(buffer)),
		buffer);
	if (_v0.$ === 1) {
		return $elm$core$Array$empty;
	} else {
		var value = _v0.a;
		return value;
	}
};
var $folkertdev$elm_flate$Deflate$Internal$compress = F2(
	function (maybeWindowSize, buf) {
		if (maybeWindowSize.$ === 1) {
			return A2(
				$elm$core$Array$push,
				$folkertdev$elm_flate$Deflate$Symbol$EndOfBlock,
				A2(
					$elm$core$Array$map,
					$folkertdev$elm_flate$Deflate$Symbol$Literal,
					$folkertdev$elm_flate$ByteArray$fromBytes(buf)));
		} else {
			var windowSize = maybeWindowSize.a;
			return A2(
				$elm$core$Array$push,
				$folkertdev$elm_flate$Deflate$Symbol$EndOfBlock,
				A2(
					$elm$core$Array$map,
					$folkertdev$elm_flate$Deflate$Internal$codeToSymbol,
					A2(
						$folkertdev$elm_flate$LZ77$encodeWithOptions,
						{qR: windowSize},
						buf)));
		}
	});
var $elm$bytes$Bytes$Encode$U16 = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$bytes$Bytes$Encode$unsignedInt16 = $elm$bytes$Bytes$Encode$U16;
var $folkertdev$elm_flate$Deflate$BitWriter$flushIfNeeded = F3(
	function (tag, bitsWritten, encoders) {
		return (bitsWritten >= 16) ? {
			au: bitsWritten - 16,
			ay: A2(
				$elm$core$List$cons,
				A2($elm$bytes$Bytes$Encode$unsignedInt16, 0, tag),
				encoders),
			a8: tag >> 16
		} : {au: bitsWritten, ay: encoders, a8: tag};
	});
var $folkertdev$elm_flate$Deflate$BitWriter$writeBits = F3(
	function (bitwidth, bits, state) {
		return A3($folkertdev$elm_flate$Deflate$BitWriter$flushIfNeeded, state.a8 | (bits << state.au), state.au + bitwidth, state.ay);
	});
var $folkertdev$elm_flate$Huffman$encode = F2(
	function (symbol, _v0) {
		var table = _v0;
		var _v1 = A2($elm$core$Array$get, symbol, table);
		if (_v1.$ === 1) {
			return A2($folkertdev$elm_flate$Deflate$BitWriter$writeBits, 0, 0);
		} else {
			var width = _v1.a.qQ;
			var bits = _v1.a.a;
			return A2($folkertdev$elm_flate$Deflate$BitWriter$writeBits, width, bits);
		}
	});
var $folkertdev$elm_flate$Deflate$Symbol$extraLength = function (symbol) {
	if (symbol.$ === 2) {
		var length = symbol.a;
		return (((length >= 3) && (length <= 10)) || (length === 258)) ? $elm$core$Maybe$Nothing : (((length >= 11) && (length <= 18)) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(
				1,
				A2($elm$core$Basics$modBy, 2, length - 11))) : (((length >= 19) && (length <= 34)) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(
				2,
				A2($elm$core$Basics$modBy, 4, length - 19))) : (((length >= 35) && (length <= 66)) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(
				3,
				A2($elm$core$Basics$modBy, 8, length - 35))) : (((length >= 67) && (length <= 130)) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(
				4,
				A2($elm$core$Basics$modBy, 16, length - 67))) : (((length >= 131) && (length <= 257)) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(
				5,
				A2($elm$core$Basics$modBy, 32, length - 131))) : $elm$core$Maybe$Nothing)))));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $folkertdev$elm_flate$Deflate$Symbol$encode = F3(
	function (symbol, htrees, bitWriter) {
		var maybeExtra = function () {
			var _v2 = $folkertdev$elm_flate$Deflate$Symbol$extraLength(symbol);
			if (_v2.$ === 1) {
				return $elm$core$Basics$identity;
			} else {
				var _v3 = _v2.a;
				var bits = _v3.a;
				var extra = _v3.b;
				return A2($folkertdev$elm_flate$Deflate$BitWriter$writeBits, bits, extra);
			}
		}();
		var maybeDistance = function () {
			var _v0 = $folkertdev$elm_flate$Deflate$Symbol$distance(symbol);
			if (_v0.$ === 1) {
				return $elm$core$Basics$identity;
			} else {
				var _v1 = _v0.a;
				var code_ = _v1.a;
				var bits = _v1.b;
				var extra = _v1.c;
				return A2(
					$elm$core$Basics$composeR,
					A2($folkertdev$elm_flate$Huffman$encode, code_, htrees.bV),
					(bits > 0) ? A2($folkertdev$elm_flate$Deflate$BitWriter$writeBits, bits, extra) : $elm$core$Basics$identity);
			}
		}();
		return maybeDistance(
			maybeExtra(
				A3(
					$folkertdev$elm_flate$Huffman$encode,
					$folkertdev$elm_flate$Deflate$Symbol$code(symbol),
					htrees.b4,
					bitWriter)));
	});
var $folkertdev$elm_flate$Deflate$Symbol$bitwidth_code_order = _List_fromArray(
	[16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
var $folkertdev$elm_flate$Deflate$Symbol$calculateCodes = function (runLengths) {
	var loop2 = F3(
		function (r, c, codes) {
			loop2:
			while (true) {
				if (c >= 3) {
					var n = A2($elm$core$Basics$min, 6, c);
					var $temp$r = r,
						$temp$c = c - n,
						$temp$codes = A2(
						$elm$core$Array$push,
						_Utils_Tuple3(16, 2, n - 3),
						codes);
					r = $temp$r;
					c = $temp$c;
					codes = $temp$codes;
					continue loop2;
				} else {
					return A2(
						$elm$core$Array$append,
						codes,
						A2(
							$elm$core$Array$repeat,
							c,
							_Utils_Tuple3(r.di, 0, 0)));
				}
			}
		});
	var loop1 = F2(
		function (c, codes) {
			loop1:
			while (true) {
				if (c >= 11) {
					var n = A2($elm$core$Basics$min, 138, c);
					var $temp$c = c - n,
						$temp$codes = A2(
						$elm$core$Array$push,
						_Utils_Tuple3(18, 7, n - 11),
						codes);
					c = $temp$c;
					codes = $temp$codes;
					continue loop1;
				} else {
					if (c >= 3) {
						return A2(
							$elm$core$Array$push,
							_Utils_Tuple3(17, 3, c - 3),
							codes);
					} else {
						return A2(
							$elm$core$Array$append,
							codes,
							A2(
								$elm$core$Array$repeat,
								c,
								_Utils_Tuple3(0, 0, 0)));
					}
				}
			}
		});
	var folder = F2(
		function (r, codes) {
			return (!r.di) ? A2(loop1, r.iw, codes) : A3(
				loop2,
				r,
				r.iw - 1,
				A2(
					$elm$core$Array$push,
					_Utils_Tuple3(r.di, 0, 0),
					codes));
		});
	return A3($elm$core$Array$foldl, folder, $elm$core$Array$empty, runLengths);
};
var $folkertdev$elm_flate$Huffman$getWidth = function (_v0) {
	var width = _v0.qQ;
	return width;
};
var $folkertdev$elm_flate$Huffman$lookup = F2(
	function (symbol, _v0) {
		var array = _v0;
		return A2($elm$core$Array$get, symbol, array);
	});
var $folkertdev$elm_flate$Deflate$Symbol$calculateRunLengths = F2(
	function (lengths, accum) {
		calculateRunLengths:
		while (true) {
			if (!lengths.b) {
				return A3($elm$core$List$foldr, $elm$core$Array$push, $elm$core$Array$empty, accum);
			} else {
				var _v1 = lengths.a;
				var e = _v1.a;
				var size = _v1.b;
				var rest = lengths.b;
				var list = A2(
					$elm$core$List$indexedMap,
					$elm$core$Tuple$pair,
					A2(
						$elm$core$List$map,
						function (x) {
							return A2(
								$elm$core$Maybe$withDefault,
								0,
								A2(
									$elm$core$Maybe$map,
									$folkertdev$elm_flate$Huffman$getWidth,
									A2($folkertdev$elm_flate$Huffman$lookup, x, e)));
						},
						A2($elm$core$List$range, 0, size - 1)));
				var folder = F2(
					function (_v3, runLengths) {
						var i = _v3.a;
						var c = _v3.b;
						if (!runLengths.b) {
							return A2(
								$elm$core$List$cons,
								{iw: 1, di: c},
								runLengths);
						} else {
							var last = runLengths.a;
							var remaining = runLengths.b;
							return _Utils_eq(last.di, c) ? A2(
								$elm$core$List$cons,
								{iw: last.iw + 1, di: last.di},
								remaining) : A2(
								$elm$core$List$cons,
								{iw: 1, di: c},
								runLengths);
						}
					});
				var $temp$lengths = rest,
					$temp$accum = A3($elm$core$List$foldl, folder, accum, list);
				lengths = $temp$lengths;
				accum = $temp$accum;
				continue calculateRunLengths;
			}
		}
	});
var $folkertdev$elm_flate$Deflate$Symbol$buildBitWidthCodes = F3(
	function (literalCodeCount, distanceCodeCount, trees) {
		var runLengths = A2(
			$folkertdev$elm_flate$Deflate$Symbol$calculateRunLengths,
			_List_fromArray(
				[
					_Utils_Tuple2(trees.b4, literalCodeCount),
					_Utils_Tuple2(trees.bV, distanceCodeCount)
				]),
			_List_Nil);
		return $folkertdev$elm_flate$Deflate$Symbol$calculateCodes(runLengths);
	});
var $folkertdev$elm_flate$Deflate$Symbol$positionLoop = F3(
	function (predicate, i, elements) {
		positionLoop:
		while (true) {
			if (!elements.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var x = elements.a;
				var xs = elements.b;
				if (predicate(x)) {
					return $elm$core$Maybe$Just(i);
				} else {
					var $temp$predicate = predicate,
						$temp$i = i + 1,
						$temp$elements = xs;
					predicate = $temp$predicate;
					i = $temp$i;
					elements = $temp$elements;
					continue positionLoop;
				}
			}
		}
	});
var $folkertdev$elm_flate$Deflate$Symbol$position = F2(
	function (predicate, elements) {
		return A3($folkertdev$elm_flate$Deflate$Symbol$positionLoop, predicate, 0, elements);
	});
var $folkertdev$elm_flate$Huffman$positionFromTheEnd = F2(
	function (predicated, array) {
		var folder = F2(
			function (element, _v1) {
				var index = _v1.a;
				var accum = _v1.b;
				if (!accum.$) {
					return _Utils_Tuple2(index, accum);
				} else {
					return predicated(element) ? _Utils_Tuple2(
						index,
						$elm$core$Maybe$Just(index)) : _Utils_Tuple2(index - 1, $elm$core$Maybe$Nothing);
				}
			});
		var finalIndex = $elm$core$Array$length(array) - 1;
		return A2(
			$elm$core$Maybe$map,
			function (v) {
				return finalIndex - v;
			},
			A3(
				$elm$core$Array$foldr,
				folder,
				_Utils_Tuple2(finalIndex, $elm$core$Maybe$Nothing),
				array).b);
	});
var $folkertdev$elm_flate$Huffman$usedMaxSymbol = function (_v0) {
	var array = _v0;
	return A2(
		$elm$core$Maybe$map,
		function (trailingZeros) {
			return ($elm$core$Array$length(array) - 1) - trailingZeros;
		},
		A2(
			$folkertdev$elm_flate$Huffman$positionFromTheEnd,
			function (_v1) {
				var value = _v1;
				return value.qQ > 0;
			},
			array));
};
var $folkertdev$elm_flate$Deflate$Symbol$writeDynamicHuffmanCodec = F2(
	function (trees, bitWriter) {
		var literal_code_count = A2(
			$elm$core$Basics$max,
			257,
			A2(
				$elm$core$Maybe$withDefault,
				0,
				$folkertdev$elm_flate$Huffman$usedMaxSymbol(trees.b4)) + 1);
		var distance_code_count = A2(
			$elm$core$Basics$max,
			1,
			A2(
				$elm$core$Maybe$withDefault,
				0,
				$folkertdev$elm_flate$Huffman$usedMaxSymbol(trees.bV)) + 1);
		var codes = A3(
			$folkertdev$elm_flate$Deflate$Symbol$buildBitWidthCodes,
			literal_code_count,
			distance_code_count,
			{bV: trees.bV, b4: trees.b4});
		var codeCounts = A3(
			$elm$core$Array$foldl,
			function (_v2) {
				var i = _v2.a;
				return A2(
					$folkertdev$elm_flate$Deflate$Symbol$update,
					i,
					function (v) {
						return v + 1;
					});
			},
			A2($elm$core$Array$repeat, 19, 0),
			codes);
		var bitWidthEncoder = A2($folkertdev$elm_flate$Huffman$fromFrequencies, codeCounts, 7);
		var bitwidthCodeCount = A2(
			$elm$core$Basics$max,
			4,
			A2(
				$elm$core$Maybe$withDefault,
				0,
				A2(
					$elm$core$Maybe$map,
					function (trailingZeros) {
						return 19 - trailingZeros;
					},
					A2(
						$folkertdev$elm_flate$Deflate$Symbol$position,
						function (i) {
							var _v1 = A2($folkertdev$elm_flate$Huffman$lookup, i, bitWidthEncoder);
							if (_v1.$ === 1) {
								return false;
							} else {
								var value = _v1.a;
								return $folkertdev$elm_flate$Huffman$getWidth(value) > 0;
							}
						},
						$elm$core$List$reverse($folkertdev$elm_flate$Deflate$Symbol$bitwidth_code_order)))));
		var v1 = function (writer) {
			return A3(
				$elm$core$List$foldl,
				F2(
					function (i, current) {
						var width = _Utils_eq(
							A2($elm$core$Array$get, i, codeCounts),
							$elm$core$Maybe$Just(0)) ? 0 : A2(
							$elm$core$Maybe$withDefault,
							0,
							A2(
								$elm$core$Maybe$map,
								$folkertdev$elm_flate$Huffman$getWidth,
								A2($folkertdev$elm_flate$Huffman$lookup, i, bitWidthEncoder)));
						return A3($folkertdev$elm_flate$Deflate$BitWriter$writeBits, 3, width, current);
					}),
				writer,
				A2($elm$core$List$take, bitwidthCodeCount, $folkertdev$elm_flate$Deflate$Symbol$bitwidth_code_order));
		};
		var v2 = function (writer) {
			return A3(
				$elm$core$Array$foldl,
				F2(
					function (_v0, current) {
						var code_ = _v0.a;
						var bits = _v0.b;
						var extra = _v0.c;
						return (bits > 0) ? A3(
							$folkertdev$elm_flate$Deflate$BitWriter$writeBits,
							bits,
							extra,
							A3($folkertdev$elm_flate$Huffman$encode, code_, bitWidthEncoder, current)) : A3($folkertdev$elm_flate$Huffman$encode, code_, bitWidthEncoder, current);
					}),
				writer,
				codes);
		};
		return v2(
			v1(
				A3(
					$folkertdev$elm_flate$Deflate$BitWriter$writeBits,
					4,
					bitwidthCodeCount - 4,
					A3(
						$folkertdev$elm_flate$Deflate$BitWriter$writeBits,
						5,
						distance_code_count - 1,
						A3($folkertdev$elm_flate$Deflate$BitWriter$writeBits, 5, literal_code_count - 257, bitWriter)))));
	});
var $folkertdev$elm_flate$Deflate$Internal$encodeCompressDynamic = F3(
	function (maybeWindowSize, buf, bitWriter) {
		var compressed = A2($folkertdev$elm_flate$Deflate$Internal$compress, maybeWindowSize, buf);
		var huffmanTree = $folkertdev$elm_flate$Deflate$Symbol$buildDynamicHuffmanCodec(compressed);
		var huffmanTreeWriter = A2($folkertdev$elm_flate$Deflate$Symbol$writeDynamicHuffmanCodec, huffmanTree, bitWriter);
		return A3(
			$elm$core$Array$foldl,
			F2(
				function (symbol, first) {
					return A3($folkertdev$elm_flate$Deflate$Symbol$encode, symbol, huffmanTree, first);
				}),
			huffmanTreeWriter,
			compressed);
	});
var $folkertdev$elm_flate$Deflate$BitWriter$writeBit = function (b) {
	if (!b) {
		return A2($folkertdev$elm_flate$Deflate$BitWriter$writeBits, 1, 0);
	} else {
		return A2($folkertdev$elm_flate$Deflate$BitWriter$writeBits, 1, 1);
	}
};
var $folkertdev$elm_flate$Deflate$Internal$encodeDynamicBlock = F3(
	function (windowSize, _v0, bitWriter) {
		var isLastBlock = _v0.a;
		var buffer = _v0.b;
		return A3(
			$folkertdev$elm_flate$Deflate$Internal$encodeCompressDynamic,
			windowSize,
			buffer,
			A3(
				$folkertdev$elm_flate$Deflate$BitWriter$writeBits,
				2,
				2,
				A2($folkertdev$elm_flate$Deflate$BitWriter$writeBit, isLastBlock, bitWriter)));
	});
var $elm$bytes$Bytes$Encode$U8 = function (a) {
	return {$: 3, a: a};
};
var $elm$bytes$Bytes$Encode$unsignedInt8 = $elm$bytes$Bytes$Encode$U8;
var $folkertdev$elm_flate$Deflate$BitWriter$flushLoop = F3(
	function (tag, bitsWritten, encoders) {
		flushLoop:
		while (true) {
			if (bitsWritten > 0) {
				var $temp$tag = tag >> 8,
					$temp$bitsWritten = A2($elm$core$Basics$max, 0, bitsWritten - 8),
					$temp$encoders = A2(
					$elm$core$List$cons,
					$elm$bytes$Bytes$Encode$unsignedInt8(tag),
					encoders);
				tag = $temp$tag;
				bitsWritten = $temp$bitsWritten;
				encoders = $temp$encoders;
				continue flushLoop;
			} else {
				return {au: bitsWritten, ay: encoders, a8: tag};
			}
		}
	});
var $folkertdev$elm_flate$Deflate$BitWriter$flush = function (state) {
	return A3($folkertdev$elm_flate$Deflate$BitWriter$flushLoop, state.a8, state.au, state.ay);
};
var $folkertdev$elm_flate$Deflate$BitWriter$run = function (state) {
	return $elm$core$List$reverse(state.ay);
};
var $folkertdev$elm_flate$Deflate$Internal$encodeDynamic = F2(
	function (windowSize, buffer) {
		var encodedChunks = A2(
			$elm$core$List$map,
			$folkertdev$elm_flate$Deflate$Internal$encodeDynamicBlock(windowSize),
			A2($folkertdev$elm_flate$Deflate$Internal$chunks, $folkertdev$elm_flate$Deflate$Internal$default_block_size, buffer));
		return $elm$bytes$Bytes$Encode$encode(
			$elm$bytes$Bytes$Encode$sequence(
				$folkertdev$elm_flate$Deflate$BitWriter$run(
					$folkertdev$elm_flate$Deflate$BitWriter$flush(
						A3(
							$elm$core$List$foldl,
							F2(
								function (chunk, first) {
									return chunk(first);
								}),
							$folkertdev$elm_flate$Deflate$BitWriter$empty,
							encodedChunks)))));
	});
var $elm$core$Bitwise$complement = _Bitwise_complement;
var $folkertdev$elm_flate$Deflate$Internal$max_non_compressed_block_size = 65535;
var $elm$core$Array$sliceLeft = F2(
	function (from, array) {
		var len = array.a;
		var tree = array.c;
		var tail = array.d;
		if (!from) {
			return array;
		} else {
			if (_Utils_cmp(
				from,
				$elm$core$Array$tailIndex(len)) > -1) {
				return A4(
					$elm$core$Array$Array_elm_builtin,
					len - from,
					$elm$core$Array$shiftStep,
					$elm$core$Elm$JsArray$empty,
					A3(
						$elm$core$Elm$JsArray$slice,
						from - $elm$core$Array$tailIndex(len),
						$elm$core$Elm$JsArray$length(tail),
						tail));
			} else {
				var skipNodes = (from / $elm$core$Array$branchFactor) | 0;
				var helper = F2(
					function (node, acc) {
						if (!node.$) {
							var subTree = node.a;
							return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
						} else {
							var leaf = node.a;
							return A2($elm$core$List$cons, leaf, acc);
						}
					});
				var leafNodes = A3(
					$elm$core$Elm$JsArray$foldr,
					helper,
					_List_fromArray(
						[tail]),
					tree);
				var nodesToInsert = A2($elm$core$List$drop, skipNodes, leafNodes);
				if (!nodesToInsert.b) {
					return $elm$core$Array$empty;
				} else {
					var head = nodesToInsert.a;
					var rest = nodesToInsert.b;
					var firstSlice = from - (skipNodes * $elm$core$Array$branchFactor);
					var initialBuilder = {
						y: _List_Nil,
						p: 0,
						w: A3(
							$elm$core$Elm$JsArray$slice,
							firstSlice,
							$elm$core$Elm$JsArray$length(head),
							head)
					};
					return A2(
						$elm$core$Array$builderToArray,
						true,
						A3($elm$core$List$foldl, $elm$core$Array$appendHelpBuilder, initialBuilder, rest));
				}
			}
		}
	});
var $elm$core$Array$fetchNewTail = F4(
	function (shift, end, treeEnd, tree) {
		fetchNewTail:
		while (true) {
			var pos = $elm$core$Array$bitMask & (treeEnd >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var sub = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$end = end,
					$temp$treeEnd = treeEnd,
					$temp$tree = sub;
				shift = $temp$shift;
				end = $temp$end;
				treeEnd = $temp$treeEnd;
				tree = $temp$tree;
				continue fetchNewTail;
			} else {
				var values = _v0.a;
				return A3($elm$core$Elm$JsArray$slice, 0, $elm$core$Array$bitMask & end, values);
			}
		}
	});
var $elm$core$Array$hoistTree = F3(
	function (oldShift, newShift, tree) {
		hoistTree:
		while (true) {
			if ((_Utils_cmp(oldShift, newShift) < 1) || (!$elm$core$Elm$JsArray$length(tree))) {
				return tree;
			} else {
				var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, 0, tree);
				if (!_v0.$) {
					var sub = _v0.a;
					var $temp$oldShift = oldShift - $elm$core$Array$shiftStep,
						$temp$newShift = newShift,
						$temp$tree = sub;
					oldShift = $temp$oldShift;
					newShift = $temp$newShift;
					tree = $temp$tree;
					continue hoistTree;
				} else {
					return tree;
				}
			}
		}
	});
var $elm$core$Array$sliceTree = F3(
	function (shift, endIdx, tree) {
		var lastPos = $elm$core$Array$bitMask & (endIdx >>> shift);
		var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, lastPos, tree);
		if (!_v0.$) {
			var sub = _v0.a;
			var newSub = A3($elm$core$Array$sliceTree, shift - $elm$core$Array$shiftStep, endIdx, sub);
			return (!$elm$core$Elm$JsArray$length(newSub)) ? A3($elm$core$Elm$JsArray$slice, 0, lastPos, tree) : A3(
				$elm$core$Elm$JsArray$unsafeSet,
				lastPos,
				$elm$core$Array$SubTree(newSub),
				A3($elm$core$Elm$JsArray$slice, 0, lastPos + 1, tree));
		} else {
			return A3($elm$core$Elm$JsArray$slice, 0, lastPos, tree);
		}
	});
var $elm$core$Array$sliceRight = F2(
	function (end, array) {
		var len = array.a;
		var startShift = array.b;
		var tree = array.c;
		var tail = array.d;
		if (_Utils_eq(end, len)) {
			return array;
		} else {
			if (_Utils_cmp(
				end,
				$elm$core$Array$tailIndex(len)) > -1) {
				return A4(
					$elm$core$Array$Array_elm_builtin,
					end,
					startShift,
					tree,
					A3($elm$core$Elm$JsArray$slice, 0, $elm$core$Array$bitMask & end, tail));
			} else {
				var endIdx = $elm$core$Array$tailIndex(end);
				var depth = $elm$core$Basics$floor(
					A2(
						$elm$core$Basics$logBase,
						$elm$core$Array$branchFactor,
						A2($elm$core$Basics$max, 1, endIdx - 1)));
				var newShift = A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep);
				return A4(
					$elm$core$Array$Array_elm_builtin,
					end,
					newShift,
					A3(
						$elm$core$Array$hoistTree,
						startShift,
						newShift,
						A3($elm$core$Array$sliceTree, startShift, endIdx, tree)),
					A4($elm$core$Array$fetchNewTail, startShift, end, endIdx, tree));
			}
		}
	});
var $elm$core$Array$translateIndex = F2(
	function (index, _v0) {
		var len = _v0.a;
		var posIndex = (index < 0) ? (len + index) : index;
		return (posIndex < 0) ? 0 : ((_Utils_cmp(posIndex, len) > 0) ? len : posIndex);
	});
var $elm$core$Array$slice = F3(
	function (from, to, array) {
		var correctTo = A2($elm$core$Array$translateIndex, to, array);
		var correctFrom = A2($elm$core$Array$translateIndex, from, array);
		return (_Utils_cmp(correctFrom, correctTo) > 0) ? $elm$core$Array$empty : A2(
			$elm$core$Array$sliceLeft,
			correctFrom,
			A2($elm$core$Array$sliceRight, correctTo, array));
	});
var $folkertdev$elm_flate$ByteArray$fasterEncodeFolderR = F2(
	function (_byte, _v0) {
		var bytesOnAccum = _v0.a;
		var accum = _v0.b;
		var encoders = _v0.c;
		switch (bytesOnAccum) {
			case 0:
				var value = 255 & _byte;
				return _Utils_Tuple3(1, value, encoders);
			case 1:
				var value = accum | ((255 & _byte) << 8);
				return _Utils_Tuple3(2, value, encoders);
			case 2:
				var value = accum | ((255 & _byte) << 16);
				return _Utils_Tuple3(3, value, encoders);
			default:
				var value = accum | ((255 & _byte) << 24);
				return _Utils_Tuple3(
					0,
					0,
					A2(
						$elm$core$List$cons,
						A2($elm$bytes$Bytes$Encode$unsignedInt32, 1, value),
						encoders));
		}
	});
var $folkertdev$elm_flate$ByteArray$fasterEncodeR = function (_v0) {
	var bytesOnAccum = _v0.a;
	var accum = _v0.b;
	var otherEncoders = _v0.c;
	var encoders = function () {
		switch (bytesOnAccum) {
			case 0:
				return otherEncoders;
			case 1:
				return A2(
					$elm$core$List$cons,
					$elm$bytes$Bytes$Encode$unsignedInt8(accum),
					otherEncoders);
			case 2:
				return A2(
					$elm$core$List$cons,
					A2($elm$bytes$Bytes$Encode$unsignedInt16, 1, accum),
					otherEncoders);
			default:
				var otherBytes = accum >> 8;
				var firstByte = 255 & accum;
				return A2(
					$elm$core$List$cons,
					A2($elm$bytes$Bytes$Encode$unsignedInt16, 1, otherBytes),
					A2(
						$elm$core$List$cons,
						$elm$bytes$Bytes$Encode$unsignedInt8(firstByte),
						otherEncoders));
		}
	}();
	return encoders;
};
var $folkertdev$elm_flate$ByteArray$toBytes = function (array) {
	return $elm$bytes$Bytes$Encode$encode(
		$elm$bytes$Bytes$Encode$sequence(
			$folkertdev$elm_flate$ByteArray$fasterEncodeR(
				A3(
					$elm$core$Array$foldr,
					$folkertdev$elm_flate$ByteArray$fasterEncodeFolderR,
					_Utils_Tuple3(0, 0, _List_Nil),
					array))));
};
var $folkertdev$elm_flate$Deflate$BitWriter$writeEncoder = F2(
	function (encoder, state) {
		return {
			au: state.au,
			ay: A2($elm$core$List$cons, encoder, state.ay),
			a8: state.a8
		};
	});
var $folkertdev$elm_flate$Deflate$Internal$encodeRawBlock = F2(
	function (_v0, bitWriter) {
		var isLastBlock = _v0.a;
		var buffer = _v0.b;
		var byteArray = $folkertdev$elm_flate$ByteArray$fromBytes(buffer);
		var size = A2(
			$elm$core$Basics$min,
			$elm$core$Array$length(byteArray),
			$folkertdev$elm_flate$Deflate$Internal$max_non_compressed_block_size);
		var sliced = A3($elm$core$Array$slice, 0, size, byteArray);
		return A2(
			$folkertdev$elm_flate$Deflate$BitWriter$writeEncoder,
			$elm$bytes$Bytes$Encode$bytes(
				$folkertdev$elm_flate$ByteArray$toBytes(sliced)),
			A2(
				$folkertdev$elm_flate$Deflate$BitWriter$writeEncoder,
				A2($elm$bytes$Bytes$Encode$unsignedInt16, 0, ~size),
				A2(
					$folkertdev$elm_flate$Deflate$BitWriter$writeEncoder,
					A2($elm$bytes$Bytes$Encode$unsignedInt16, 0, size),
					$folkertdev$elm_flate$Deflate$BitWriter$flush(
						A3(
							$folkertdev$elm_flate$Deflate$BitWriter$writeBits,
							2,
							0,
							A2($folkertdev$elm_flate$Deflate$BitWriter$writeBit, isLastBlock, bitWriter))))));
	});
var $folkertdev$elm_flate$Deflate$Internal$encodeRaw = function (buffer) {
	return $elm$bytes$Bytes$Encode$encode(
		$elm$bytes$Bytes$Encode$sequence(
			$folkertdev$elm_flate$Deflate$BitWriter$run(
				A3(
					$elm$core$List$foldl,
					F2(
						function (chunk, first) {
							return A2($folkertdev$elm_flate$Deflate$Internal$encodeRawBlock, chunk, first);
						}),
					$folkertdev$elm_flate$Deflate$BitWriter$empty,
					A2(
						$folkertdev$elm_flate$Deflate$Internal$chunks,
						A2($elm$core$Basics$min, $folkertdev$elm_flate$Deflate$Internal$max_non_compressed_block_size, $folkertdev$elm_flate$Deflate$Internal$default_block_size),
						buffer)))));
};
var $folkertdev$elm_flate$Huffman$fromList = A2(
	$elm$core$Basics$composeL,
	A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $elm$core$Array$fromList),
	$elm$core$List$map($folkertdev$elm_flate$Huffman$codeFromRecord));
var $folkertdev$elm_flate$Huffman$hardcodedStaticHuffmanTree = {
	bV: $folkertdev$elm_flate$Huffman$fromList(
		_List_fromArray(
			[
				{a: 0, qQ: 5},
				{a: 16, qQ: 5},
				{a: 8, qQ: 5},
				{a: 24, qQ: 5},
				{a: 4, qQ: 5},
				{a: 20, qQ: 5},
				{a: 12, qQ: 5},
				{a: 28, qQ: 5},
				{a: 2, qQ: 5},
				{a: 18, qQ: 5},
				{a: 10, qQ: 5},
				{a: 26, qQ: 5},
				{a: 6, qQ: 5},
				{a: 22, qQ: 5},
				{a: 14, qQ: 5},
				{a: 30, qQ: 5},
				{a: 1, qQ: 5},
				{a: 17, qQ: 5},
				{a: 9, qQ: 5},
				{a: 25, qQ: 5},
				{a: 5, qQ: 5},
				{a: 21, qQ: 5},
				{a: 13, qQ: 5},
				{a: 29, qQ: 5},
				{a: 3, qQ: 5},
				{a: 19, qQ: 5},
				{a: 11, qQ: 5},
				{a: 27, qQ: 5},
				{a: 7, qQ: 5},
				{a: 23, qQ: 5}
			])),
	b4: $folkertdev$elm_flate$Huffman$fromList(
		_List_fromArray(
			[
				{a: 12, qQ: 8},
				{a: 140, qQ: 8},
				{a: 76, qQ: 8},
				{a: 204, qQ: 8},
				{a: 44, qQ: 8},
				{a: 172, qQ: 8},
				{a: 108, qQ: 8},
				{a: 236, qQ: 8},
				{a: 28, qQ: 8},
				{a: 156, qQ: 8},
				{a: 92, qQ: 8},
				{a: 220, qQ: 8},
				{a: 60, qQ: 8},
				{a: 188, qQ: 8},
				{a: 124, qQ: 8},
				{a: 252, qQ: 8},
				{a: 2, qQ: 8},
				{a: 130, qQ: 8},
				{a: 66, qQ: 8},
				{a: 194, qQ: 8},
				{a: 34, qQ: 8},
				{a: 162, qQ: 8},
				{a: 98, qQ: 8},
				{a: 226, qQ: 8},
				{a: 18, qQ: 8},
				{a: 146, qQ: 8},
				{a: 82, qQ: 8},
				{a: 210, qQ: 8},
				{a: 50, qQ: 8},
				{a: 178, qQ: 8},
				{a: 114, qQ: 8},
				{a: 242, qQ: 8},
				{a: 10, qQ: 8},
				{a: 138, qQ: 8},
				{a: 74, qQ: 8},
				{a: 202, qQ: 8},
				{a: 42, qQ: 8},
				{a: 170, qQ: 8},
				{a: 106, qQ: 8},
				{a: 234, qQ: 8},
				{a: 26, qQ: 8},
				{a: 154, qQ: 8},
				{a: 90, qQ: 8},
				{a: 218, qQ: 8},
				{a: 58, qQ: 8},
				{a: 186, qQ: 8},
				{a: 122, qQ: 8},
				{a: 250, qQ: 8},
				{a: 6, qQ: 8},
				{a: 134, qQ: 8},
				{a: 70, qQ: 8},
				{a: 198, qQ: 8},
				{a: 38, qQ: 8},
				{a: 166, qQ: 8},
				{a: 102, qQ: 8},
				{a: 230, qQ: 8},
				{a: 22, qQ: 8},
				{a: 150, qQ: 8},
				{a: 86, qQ: 8},
				{a: 214, qQ: 8},
				{a: 54, qQ: 8},
				{a: 182, qQ: 8},
				{a: 118, qQ: 8},
				{a: 246, qQ: 8},
				{a: 14, qQ: 8},
				{a: 142, qQ: 8},
				{a: 78, qQ: 8},
				{a: 206, qQ: 8},
				{a: 46, qQ: 8},
				{a: 174, qQ: 8},
				{a: 110, qQ: 8},
				{a: 238, qQ: 8},
				{a: 30, qQ: 8},
				{a: 158, qQ: 8},
				{a: 94, qQ: 8},
				{a: 222, qQ: 8},
				{a: 62, qQ: 8},
				{a: 190, qQ: 8},
				{a: 126, qQ: 8},
				{a: 254, qQ: 8},
				{a: 1, qQ: 8},
				{a: 129, qQ: 8},
				{a: 65, qQ: 8},
				{a: 193, qQ: 8},
				{a: 33, qQ: 8},
				{a: 161, qQ: 8},
				{a: 97, qQ: 8},
				{a: 225, qQ: 8},
				{a: 17, qQ: 8},
				{a: 145, qQ: 8},
				{a: 81, qQ: 8},
				{a: 209, qQ: 8},
				{a: 49, qQ: 8},
				{a: 177, qQ: 8},
				{a: 113, qQ: 8},
				{a: 241, qQ: 8},
				{a: 9, qQ: 8},
				{a: 137, qQ: 8},
				{a: 73, qQ: 8},
				{a: 201, qQ: 8},
				{a: 41, qQ: 8},
				{a: 169, qQ: 8},
				{a: 105, qQ: 8},
				{a: 233, qQ: 8},
				{a: 25, qQ: 8},
				{a: 153, qQ: 8},
				{a: 89, qQ: 8},
				{a: 217, qQ: 8},
				{a: 57, qQ: 8},
				{a: 185, qQ: 8},
				{a: 121, qQ: 8},
				{a: 249, qQ: 8},
				{a: 5, qQ: 8},
				{a: 133, qQ: 8},
				{a: 69, qQ: 8},
				{a: 197, qQ: 8},
				{a: 37, qQ: 8},
				{a: 165, qQ: 8},
				{a: 101, qQ: 8},
				{a: 229, qQ: 8},
				{a: 21, qQ: 8},
				{a: 149, qQ: 8},
				{a: 85, qQ: 8},
				{a: 213, qQ: 8},
				{a: 53, qQ: 8},
				{a: 181, qQ: 8},
				{a: 117, qQ: 8},
				{a: 245, qQ: 8},
				{a: 13, qQ: 8},
				{a: 141, qQ: 8},
				{a: 77, qQ: 8},
				{a: 205, qQ: 8},
				{a: 45, qQ: 8},
				{a: 173, qQ: 8},
				{a: 109, qQ: 8},
				{a: 237, qQ: 8},
				{a: 29, qQ: 8},
				{a: 157, qQ: 8},
				{a: 93, qQ: 8},
				{a: 221, qQ: 8},
				{a: 61, qQ: 8},
				{a: 189, qQ: 8},
				{a: 125, qQ: 8},
				{a: 253, qQ: 8},
				{a: 19, qQ: 9},
				{a: 275, qQ: 9},
				{a: 147, qQ: 9},
				{a: 403, qQ: 9},
				{a: 83, qQ: 9},
				{a: 339, qQ: 9},
				{a: 211, qQ: 9},
				{a: 467, qQ: 9},
				{a: 51, qQ: 9},
				{a: 307, qQ: 9},
				{a: 179, qQ: 9},
				{a: 435, qQ: 9},
				{a: 115, qQ: 9},
				{a: 371, qQ: 9},
				{a: 243, qQ: 9},
				{a: 499, qQ: 9},
				{a: 11, qQ: 9},
				{a: 267, qQ: 9},
				{a: 139, qQ: 9},
				{a: 395, qQ: 9},
				{a: 75, qQ: 9},
				{a: 331, qQ: 9},
				{a: 203, qQ: 9},
				{a: 459, qQ: 9},
				{a: 43, qQ: 9},
				{a: 299, qQ: 9},
				{a: 171, qQ: 9},
				{a: 427, qQ: 9},
				{a: 107, qQ: 9},
				{a: 363, qQ: 9},
				{a: 235, qQ: 9},
				{a: 491, qQ: 9},
				{a: 27, qQ: 9},
				{a: 283, qQ: 9},
				{a: 155, qQ: 9},
				{a: 411, qQ: 9},
				{a: 91, qQ: 9},
				{a: 347, qQ: 9},
				{a: 219, qQ: 9},
				{a: 475, qQ: 9},
				{a: 59, qQ: 9},
				{a: 315, qQ: 9},
				{a: 187, qQ: 9},
				{a: 443, qQ: 9},
				{a: 123, qQ: 9},
				{a: 379, qQ: 9},
				{a: 251, qQ: 9},
				{a: 507, qQ: 9},
				{a: 7, qQ: 9},
				{a: 263, qQ: 9},
				{a: 135, qQ: 9},
				{a: 391, qQ: 9},
				{a: 71, qQ: 9},
				{a: 327, qQ: 9},
				{a: 199, qQ: 9},
				{a: 455, qQ: 9},
				{a: 39, qQ: 9},
				{a: 295, qQ: 9},
				{a: 167, qQ: 9},
				{a: 423, qQ: 9},
				{a: 103, qQ: 9},
				{a: 359, qQ: 9},
				{a: 231, qQ: 9},
				{a: 487, qQ: 9},
				{a: 23, qQ: 9},
				{a: 279, qQ: 9},
				{a: 151, qQ: 9},
				{a: 407, qQ: 9},
				{a: 87, qQ: 9},
				{a: 343, qQ: 9},
				{a: 215, qQ: 9},
				{a: 471, qQ: 9},
				{a: 55, qQ: 9},
				{a: 311, qQ: 9},
				{a: 183, qQ: 9},
				{a: 439, qQ: 9},
				{a: 119, qQ: 9},
				{a: 375, qQ: 9},
				{a: 247, qQ: 9},
				{a: 503, qQ: 9},
				{a: 15, qQ: 9},
				{a: 271, qQ: 9},
				{a: 143, qQ: 9},
				{a: 399, qQ: 9},
				{a: 79, qQ: 9},
				{a: 335, qQ: 9},
				{a: 207, qQ: 9},
				{a: 463, qQ: 9},
				{a: 47, qQ: 9},
				{a: 303, qQ: 9},
				{a: 175, qQ: 9},
				{a: 431, qQ: 9},
				{a: 111, qQ: 9},
				{a: 367, qQ: 9},
				{a: 239, qQ: 9},
				{a: 495, qQ: 9},
				{a: 31, qQ: 9},
				{a: 287, qQ: 9},
				{a: 159, qQ: 9},
				{a: 415, qQ: 9},
				{a: 95, qQ: 9},
				{a: 351, qQ: 9},
				{a: 223, qQ: 9},
				{a: 479, qQ: 9},
				{a: 63, qQ: 9},
				{a: 319, qQ: 9},
				{a: 191, qQ: 9},
				{a: 447, qQ: 9},
				{a: 127, qQ: 9},
				{a: 383, qQ: 9},
				{a: 255, qQ: 9},
				{a: 511, qQ: 9},
				{a: 0, qQ: 7},
				{a: 64, qQ: 7},
				{a: 32, qQ: 7},
				{a: 96, qQ: 7},
				{a: 16, qQ: 7},
				{a: 80, qQ: 7},
				{a: 48, qQ: 7},
				{a: 112, qQ: 7},
				{a: 8, qQ: 7},
				{a: 72, qQ: 7},
				{a: 40, qQ: 7},
				{a: 104, qQ: 7},
				{a: 24, qQ: 7},
				{a: 88, qQ: 7},
				{a: 56, qQ: 7},
				{a: 120, qQ: 7},
				{a: 4, qQ: 7},
				{a: 68, qQ: 7},
				{a: 36, qQ: 7},
				{a: 100, qQ: 7},
				{a: 20, qQ: 7},
				{a: 84, qQ: 7},
				{a: 52, qQ: 7},
				{a: 116, qQ: 7},
				{a: 3, qQ: 8},
				{a: 131, qQ: 8},
				{a: 67, qQ: 8},
				{a: 195, qQ: 8},
				{a: 35, qQ: 8},
				{a: 163, qQ: 8},
				{a: 99, qQ: 8},
				{a: 227, qQ: 8}
			]))
};
var $folkertdev$elm_flate$Deflate$Internal$encodeCompressStatic = F3(
	function (maybeWindowSize, buf, bitWriter) {
		var huffmanTrees = $folkertdev$elm_flate$Huffman$hardcodedStaticHuffmanTree;
		var compressed = A2($folkertdev$elm_flate$Deflate$Internal$compress, maybeWindowSize, buf);
		return A3(
			$elm$core$Array$foldl,
			F2(
				function (symbol, first) {
					return A3($folkertdev$elm_flate$Deflate$Symbol$encode, symbol, huffmanTrees, first);
				}),
			bitWriter,
			compressed);
	});
var $folkertdev$elm_flate$Deflate$Internal$encodeStaticBlock = F3(
	function (windowSize, _v0, bitWriter) {
		var isLastBlock = _v0.a;
		var buffer = _v0.b;
		return A3(
			$folkertdev$elm_flate$Deflate$Internal$encodeCompressStatic,
			windowSize,
			buffer,
			A3(
				$folkertdev$elm_flate$Deflate$BitWriter$writeBits,
				2,
				1,
				A2($folkertdev$elm_flate$Deflate$BitWriter$writeBit, isLastBlock, bitWriter)));
	});
var $folkertdev$elm_flate$Deflate$Internal$encodeStatic = F2(
	function (windowSize, buffer) {
		return $elm$bytes$Bytes$Encode$encode(
			$elm$bytes$Bytes$Encode$sequence(
				$folkertdev$elm_flate$Deflate$BitWriter$run(
					$folkertdev$elm_flate$Deflate$BitWriter$flush(
						A3(
							$elm$core$List$foldl,
							F2(
								function (chunk, first) {
									return A3($folkertdev$elm_flate$Deflate$Internal$encodeStaticBlock, windowSize, chunk, first);
								}),
							$folkertdev$elm_flate$Deflate$BitWriter$empty,
							A2($folkertdev$elm_flate$Deflate$Internal$chunks, $folkertdev$elm_flate$Deflate$Internal$default_block_size, buffer))))));
	});
var $folkertdev$elm_flate$Flate$deflateWithOptions = F2(
	function (encoding, buffer) {
		switch (encoding.$) {
			case 0:
				return $folkertdev$elm_flate$Deflate$Internal$encodeRaw(buffer);
			case 2:
				if (!encoding.a.$) {
					var _v1 = encoding.a;
					return A2($folkertdev$elm_flate$Deflate$Internal$encodeStatic, $elm$core$Maybe$Nothing, buffer);
				} else {
					var w = encoding.a.a;
					return A2(
						$folkertdev$elm_flate$Deflate$Internal$encodeStatic,
						$elm$core$Maybe$Just(w),
						buffer);
				}
			default:
				if (!encoding.a.$) {
					var _v2 = encoding.a;
					return A2($folkertdev$elm_flate$Deflate$Internal$encodeDynamic, $elm$core$Maybe$Nothing, buffer);
				} else {
					var w = encoding.a.a;
					return A2(
						$folkertdev$elm_flate$Deflate$Internal$encodeDynamic,
						$elm$core$Maybe$Just(w),
						buffer);
				}
		}
	});
var $elm$core$Basics$pow = _Basics_pow;
var $folkertdev$elm_flate$Flate$deflateZlibWithOptions = F2(
	function (encoding, buffer) {
		var windowSizeHelp = function (size) {
			var kb = 1024;
			return (size <= 256) ? 0 : ((size <= 512) ? 1 : ((_Utils_cmp(size, 1 * kb) < 1) ? 2 : ((_Utils_cmp(size, 2 * kb) < 1) ? 3 : ((_Utils_cmp(size, 4 * kb) < 1) ? 4 : ((_Utils_cmp(size, 8 * kb) < 1) ? 5 : ((_Utils_cmp(size, 16 * kb) < 1) ? 6 : ((_Utils_cmp(size, 32 * kb) < 1) ? 7 : 0)))))));
		};
		var windowSize = function () {
			switch (encoding.$) {
				case 0:
					return 0;
				case 2:
					if (!encoding.a.$) {
						var _v1 = encoding.a;
						return 0;
					} else {
						var size = encoding.a.a;
						return windowSizeHelp(size);
					}
				default:
					if (!encoding.a.$) {
						var _v2 = encoding.a;
						return 0;
					} else {
						var size = encoding.a.a;
						return windowSizeHelp(size);
					}
			}
		}();
		var mask16 = function (value) {
			return value & (A2($elm$core$Basics$pow, 2, 16) - 1);
		};
		var encodedTrailer = _List_fromArray(
			[
				A2(
				$elm$bytes$Bytes$Encode$unsignedInt32,
				1,
				$folkertdev$elm_flate$Checksum$Adler32$adler32(buffer))
			]);
		var data = A2($folkertdev$elm_flate$Flate$deflateWithOptions, encoding, buffer);
		var compressionLevel = 2;
		var cmf = (windowSize << 4) | 8;
		var check = (cmf << 8) + (compressionLevel << 6);
		var flag = (!(!A2($elm$core$Basics$modBy, 31, check))) ? ((compressionLevel << 6) + (31 - A2($elm$core$Basics$modBy, 31, check))) : (compressionLevel << 6);
		var encodedHeader = _List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(cmf),
				$elm$bytes$Bytes$Encode$unsignedInt8(flag)
			]);
		return $elm$bytes$Bytes$Encode$encode(
			$elm$bytes$Bytes$Encode$sequence(
				_Utils_ap(
					encodedHeader,
					_Utils_ap(
						_List_fromArray(
							[
								$elm$bytes$Bytes$Encode$bytes(data)
							]),
						encodedTrailer))));
	});
var $folkertdev$elm_flate$LZ77$max_distance = 32768;
var $folkertdev$elm_flate$LZ77$maxWindowSize = $folkertdev$elm_flate$LZ77$max_distance;
var $folkertdev$elm_flate$Flate$deflateZlib = $folkertdev$elm_flate$Flate$deflateZlibWithOptions(
	$folkertdev$elm_flate$Flate$Dynamic(
		$folkertdev$elm_flate$Flate$WithWindowSize($folkertdev$elm_flate$LZ77$maxWindowSize)));
var $justgook$elm_image$Image$Internal$PNG$packIntoInt32 = F4(
	function (r, g, b, a) {
		return (((255 & r) << 24) | ((255 & g) << 16)) | (((255 & b) << 8) | (255 & a));
	});
var $justgook$elm_image$Image$Internal$PNG$encodePixel32 = F2(
	function (px, prev) {
		var r = px >>> 24;
		var prevR = prev >>> 24;
		var prevG = 255 & (prev >> 16);
		var prevB = 255 & (prev >> 8);
		var prevA = 255 & prev;
		var g = 255 & (px >> 16);
		var b = 255 & (px >> 8);
		var a = 255 & px;
		return A2(
			$elm$bytes$Bytes$Encode$unsignedInt32,
			1,
			A4($justgook$elm_image$Image$Internal$PNG$packIntoInt32, r - prevR, g - prevG, b - prevB, a - prevA));
	});
var $justgook$elm_image$Image$Internal$PNG$encodeIDAT = F2(
	function (_v0, arr) {
		var order = _v0.oE;
		var scanLineFilter = $elm$bytes$Bytes$Encode$unsignedInt8(1);
		var _v1 = function () {
			switch (order) {
				case 0:
					return _Utils_Tuple2($elm$core$Array$foldl, $elm$core$Array$foldl);
				case 1:
					return _Utils_Tuple2($elm$core$Array$foldr, $elm$core$Array$foldl);
				case 2:
					return _Utils_Tuple2($elm$core$Array$foldl, $elm$core$Array$foldr);
				default:
					return _Utils_Tuple2($elm$core$Array$foldr, $elm$core$Array$foldr);
			}
		}();
		var fold1 = _v1.a;
		var fold2 = _v1.b;
		return A3(
			$elm$core$Basics$composeR,
			$elm$core$List$reverse,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$concatMap($elm$core$List$reverse),
				A2(
					$elm$core$Basics$composeR,
					$elm$bytes$Bytes$Encode$sequence,
					A2(
						$elm$core$Basics$composeR,
						$elm$bytes$Bytes$Encode$encode,
						A2($elm$core$Basics$composeR, $folkertdev$elm_flate$Flate$deflateZlib, $elm$bytes$Bytes$Encode$bytes)))),
			A3(
				fold1,
				F2(
					function (sArr, acc) {
						return function (_v4) {
							var line = _v4.b;
							return A2($elm$core$List$cons, line, acc);
						}(
							A3(
								fold2,
								F2(
									function (px, _v3) {
										var prev = _v3.a;
										var acc2 = _v3.b;
										var packed = A2($justgook$elm_image$Image$Internal$PNG$encodePixel32, px, prev);
										return _Utils_Tuple2(
											px,
											A2($elm$core$List$cons, packed, acc2));
									}),
								_Utils_Tuple2(
									0,
									_List_fromArray(
										[scanLineFilter])),
								sArr));
					}),
				_List_Nil,
				arr));
	});
var $justgook$elm_image$Image$Internal$PNG$encodeIHDR = F3(
	function (width, height, _v0) {
		var format = _v0.iW;
		var interlace = 0;
		var _v1 = function () {
			switch (format) {
				case 0:
					return _Utils_Tuple2(8, 6);
				case 1:
					return _Utils_Tuple2(8, 2);
				case 2:
					return _Utils_Tuple2(16, 0);
				default:
					return _Utils_Tuple2(8, 0);
			}
		}();
		var depth = _v1.a;
		var color = _v1.b;
		return $elm$bytes$Bytes$Encode$sequence(
			_List_fromArray(
				[
					A2($elm$bytes$Bytes$Encode$unsignedInt32, 1, width),
					A2($elm$bytes$Bytes$Encode$unsignedInt32, 1, height),
					$elm$bytes$Bytes$Encode$unsignedInt8(depth),
					$elm$bytes$Bytes$Encode$unsignedInt8(color),
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$elm$bytes$Bytes$Encode$unsignedInt8(interlace)
				]));
	});
var $justgook$elm_image$Image$Internal$PNG$encodeSignature = $elm$bytes$Bytes$Encode$sequence(
	_List_fromArray(
		[
			$elm$bytes$Bytes$Encode$unsignedInt8(137),
			$elm$bytes$Bytes$Encode$unsignedInt8(80),
			$elm$bytes$Bytes$Encode$unsignedInt8(78),
			$elm$bytes$Bytes$Encode$unsignedInt8(71),
			$elm$bytes$Bytes$Encode$unsignedInt8(13),
			$elm$bytes$Bytes$Encode$unsignedInt8(10),
			$elm$bytes$Bytes$Encode$unsignedInt8(26),
			$elm$bytes$Bytes$Encode$unsignedInt8(10)
		]));
var $justgook$elm_image$Image$Internal$ImageData$toArray2d = function (image) {
	toArray2d:
	while (true) {
		if (!image.$) {
			var arr = image.b;
			return arr;
		} else {
			var meta = image.a;
			var fn = image.b;
			var _v1 = fn(meta);
			if (_v1.$ === 1) {
				return $elm$core$Array$empty;
			} else {
				var newData = _v1;
				var $temp$image = newData;
				image = $temp$image;
				continue toArray2d;
			}
		}
	}
};
var $justgook$elm_image$Image$Internal$PNG$encode = function (imgData) {
	var opt = $justgook$elm_image$Image$Internal$ImageData$defaultOptions;
	var chunkIEND = A2(
		$justgook$elm_image$Image$Internal$PNG$encodeChunk,
		1229278788,
		$elm$bytes$Bytes$Encode$encode(
			$elm$bytes$Bytes$Encode$sequence(_List_Nil)));
	var arr = $justgook$elm_image$Image$Internal$ImageData$toArray2d(imgData);
	var chunkIDAT = A2(
		$justgook$elm_image$Image$Internal$PNG$encodeChunk,
		1229209940,
		$elm$bytes$Bytes$Encode$encode(
			A2($justgook$elm_image$Image$Internal$PNG$encodeIDAT, opt, arr)));
	var height = $elm$core$Array$length(arr);
	var width = A2(
		$elm$core$Maybe$withDefault,
		0,
		A2(
			$elm$core$Maybe$map,
			$elm$core$Array$length,
			A2($elm$core$Array$get, 0, arr)));
	var chunkIHDR = A2(
		$justgook$elm_image$Image$Internal$PNG$encodeChunk,
		1229472850,
		$elm$bytes$Bytes$Encode$encode(
			A3($justgook$elm_image$Image$Internal$PNG$encodeIHDR, width, height, opt)));
	return $elm$bytes$Bytes$Encode$encode(
		$elm$bytes$Bytes$Encode$sequence(
			_List_fromArray(
				[$justgook$elm_image$Image$Internal$PNG$encodeSignature, chunkIHDR, chunkIDAT, chunkIEND])));
};
var $justgook$elm_image$Image$Internal$ImageData$map = F2(
	function (fn, image) {
		map:
		while (true) {
			if (!image.$) {
				var meta = image.a;
				var arr = image.b;
				return A2(
					$justgook$elm_image$Image$Internal$ImageData$ImageRaw,
					meta,
					A2(
						$elm$core$Array$map,
						$elm$core$Array$map(fn),
						arr));
			} else {
				var meta = image.a;
				var fn_ = image.b;
				var _v1 = fn_(meta);
				if (_v1.$ === 1) {
					return image;
				} else {
					var newData = _v1;
					var $temp$fn = fn,
						$temp$image = newData;
					fn = $temp$fn;
					image = $temp$image;
					continue map;
				}
			}
		}
	});
var $justgook$elm_image$Image$Internal$Pixel$addAlphaChannel = $justgook$elm_image$Image$Internal$ImageData$map(
	A2(
		$elm$core$Basics$composeR,
		$elm$core$Bitwise$shiftLeftBy(8),
		$elm$core$Basics$add(255)));
var $justgook$elm_image$Image$Internal$ImageData$getInfo = function (image) {
	if (!image.$) {
		var meta = image.a;
		return meta;
	} else {
		var meta = image.a;
		return meta;
	}
};
var $justgook$elm_image$Image$Internal$Pixel$px8AlphaTo32 = function (px_) {
	var px = px_ >>> 8;
	return (255 & px_) + ((px + ((px + ((px + (px << 8)) << 8)) << 8)) << 8);
};
var $justgook$elm_image$Image$Internal$Pixel$px8to32 = function (px) {
	return 255 + ((px + ((px + ((px + (px << 8)) << 8)) << 8)) << 8);
};
var $justgook$elm_image$Image$Internal$Pixel$toBit32 = function (image) {
	var _v0 = $justgook$elm_image$Image$Internal$ImageData$getInfo(image);
	switch (_v0.$) {
		case 0:
			var color = _v0.a.cK;
			switch (color.$) {
				case 0:
					return image;
				case 2:
					return image;
				case 4:
					return image;
				case 1:
					return A2($justgook$elm_image$Image$Internal$ImageData$map, $justgook$elm_image$Image$Internal$Pixel$px8AlphaTo32, image);
				default:
					return image;
			}
		case 1:
			var bitsPerPixel = _v0.a.h4;
			switch (bitsPerPixel) {
				case 0:
					return A2($justgook$elm_image$Image$Internal$ImageData$map, $justgook$elm_image$Image$Internal$Pixel$px8to32, image);
				case 1:
					return image;
				case 2:
					return $justgook$elm_image$Image$Internal$Pixel$addAlphaChannel(image);
				default:
					return image;
			}
		case 2:
			return image;
		default:
			var color = _v0.a.cK;
			switch (color.$) {
				case 0:
					return image;
				case 1:
					return image;
				case 2:
					return image;
				default:
					return image;
			}
	}
};
var $justgook$elm_image$Image$Advanced$toPng32 = A2($elm$core$Basics$composeR, $justgook$elm_image$Image$Internal$Pixel$toBit32, $justgook$elm_image$Image$Internal$PNG$encode);
var $justgook$elm_image$Image$toPngUrl = A2(
	$elm$core$Basics$composeR,
	$justgook$elm_image$Image$Advanced$toPng32,
	A2(
		$elm$core$Basics$composeR,
		$danfishgold$base64_bytes$Base64$fromBytes,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$withDefault(''),
			$elm$core$Basics$append('data:image/png;base64,'))));
var $author$project$Components$QRCodeGenerator$init = function (value) {
	return A2(
		$elm$core$Result$withDefault,
		'',
		A2(
			$elm$core$Result$map,
			function (qrCode) {
				return $justgook$elm_image$Image$toPngUrl(
					$pablohirafuji$elm_qrcode$QRCode$toImage(qrCode));
			},
			$pablohirafuji$elm_qrcode$QRCode$fromString(value)));
};
var $author$project$Pages$Admin$Users$viewCreatedUserQRCodeModal = function (qRCodeUser) {
	var dataImgQRCode = $author$project$Components$QRCodeGenerator$init(qRCodeUser.dM);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal-overlay')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('modal-container modal-dashboard modal-cadastro-usuario-sistema')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('header-modal')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(qRCodeUser.fD)
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('action-header'),
										$elm$html$Html$Events$onClick(
										$author$project$Pages$Admin$Users$CloseModal(qRCodeUser.eW))
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('fechar-ico')
											]),
										_List_Nil)
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('modal-content')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('center-modal')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href(dataImgQRCode),
												$elm$html$Html$Attributes$download('QRCode-' + qRCodeUser.c3),
												$elm$html$Html$Attributes$title('Baixar QRCode')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$img,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$src(dataImgQRCode)
													]),
												_List_Nil)
											]))
									])),
								A2(
								$elm$html$Html$h1,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('center-modal mb-0')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(qRCodeUser.c3)
									])),
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('center-modal')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Utils$maskCPF(qRCodeUser.iI))
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('center-modal center-modal-bottom')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('action-system green-btn'),
												$elm$html$Html$Events$onClick(
												$author$project$Pages$Admin$Users$CloseModal(qRCodeUser.eW))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Fechar')
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Admin$Users$EditUserModal_Previous = {$: 29};
var $author$project$Pages$Admin$Users$viewDeleteConfirmationModal = function (_v0) {
	var loading = _v0.jr;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal-overlay')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('modal-container modal-dashboard modal-cadastro-usuario-sistema')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('header-modal')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('action-header'),
										$elm$html$Html$Events$onClick($author$project$Pages$Admin$Users$EditUserModal_Previous)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('voltar-ico')
											]),
										_List_Nil)
									])),
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Excluir Usuário do Sistema')
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('action-header'),
										$elm$html$Html$Events$onClick(
										$author$project$Pages$Admin$Users$CloseModal(true))
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('fechar-ico')
											]),
										_List_Nil)
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('modal-content')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('alerta')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$img,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$src('/images/alerta-ico.svg')
											]),
										_List_Nil),
										A2(
										$elm$html$Html$h2,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('txt-vermelho')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Atenção!')
											]))
									])),
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('center-modal')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Você tem certeza que deseja excluir este usuário do sistema?')
											])),
										$elm$html$Html$text('Esta pessoa não poderá mais acessar o sistema Buzzao.')
									])),
								loading ? $author$project$Components$View$loading : A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('center-modal center-modal-bottom')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('action-system green-btn'),
												$elm$html$Html$Events$onClick($author$project$Pages$Admin$Users$EditUserModal_Delete)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Confirmar')
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Admin$Users$EditUserModal_InputEmail = function (a) {
	return {$: 26, a: a};
};
var $author$project$Pages$Admin$Users$EditUserModal_InputName = function (a) {
	return {$: 25, a: a};
};
var $author$project$Pages$Admin$Users$EditUserModal_SelectPermission = function (a) {
	return {$: 27, a: a};
};
var $author$project$Pages$Admin$Users$EditUserModal_SelectProfile = function (a) {
	return {$: 28, a: a};
};
var $author$project$Pages$Admin$Users$viewBody = function (model) {
	return A2(
		$elm$html$Html$form,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal-content')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$id('input-name'),
										$elm$html$Html$Attributes$placeholder('Nome Completo'),
										$elm$html$Html$Attributes$type_('text'),
										$elm$html$Html$Events$onInput($author$project$Pages$Admin$Users$EditUserModal_InputName),
										$elm$html$Html$Attributes$value(model.c3),
										$elm$html$Html$Attributes$disabled(
										$krisajenkins$remotedata$RemoteData$isLoading(model.hV))
									]),
								_List_Nil),
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$placeholder('Email'),
												$elm$html$Html$Attributes$type_('text'),
												$elm$html$Html$Events$onInput($author$project$Pages$Admin$Users$EditUserModal_InputEmail),
												$elm$html$Html$Attributes$value(model.mX),
												$elm$html$Html$Attributes$disabled(
												$krisajenkins$remotedata$RemoteData$isLoading(model.hV))
											]),
										_List_Nil)
									]))
							]))
					])),
				A3($author$project$Pages$Admin$Users$viewSelectProfiles, model.C, model.aq, $author$project$Pages$Admin$Users$EditUserModal_SelectProfile),
				A2(
				$elm$html$Html$h4,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('blue-subtitle')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Permissões')
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				A2(
					$elm$core$List$map,
					function (permissionsRow) {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('checkbox-line-container')
								]),
							A2(
								$elm$core$List$map,
								function (permission) {
									return $author$project$Pages$Admin$Users$viewCheckBox(
										{
											ie: !_Utils_eq(
												$elm$core$Maybe$Nothing,
												$elm$core$List$head(
													A2(
														$elm$core$List$filter,
														function (p) {
															return _Utils_eq(p, permission.di);
														},
														model.J))),
											iH: $krisajenkins$remotedata$RemoteData$isLoading(model.hV),
											c3: permission.jl,
											jG: $author$project$Pages$Admin$Users$EditUserModal_SelectPermission(permission.di)
										});
								},
								permissionsRow));
					},
					A2($author$project$Utils$sublist, 2, model.oU)))
			]));
};
var $author$project$Pages$Admin$Users$EditUserModal_Next = {$: 30};
var $author$project$Pages$Admin$Users$viewFooter = function (action) {
	return $krisajenkins$remotedata$RemoteData$isLoading(action) ? $author$project$Components$View$loading : A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('center-modal center-modal-bottom')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('action-system green-btn'),
								$elm$html$Html$Events$onClick($author$project$Pages$Admin$Users$EditUserModal_EditUser)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Salvar')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('center-modal center-modal-bottom')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('action-system red-btn'),
								$elm$html$Html$Events$onClick($author$project$Pages$Admin$Users$EditUserModal_Next)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Excluir Usuário Sistema')
							]))
					]))
			]));
};
var $author$project$Pages$Admin$Users$viewEditUserModalForm = function (model) {
	return $author$project$Components$Patterns$Modal$simple(
		{
			hY: $elm$core$Maybe$Nothing,
			ii: 'modal-cadastro-usuario-sistema',
			il: '',
			ip: $author$project$Pages$Admin$Users$CloseModal(true),
			fD: 'Editar Usuário do Sistema',
			k4: $author$project$Pages$Admin$Users$viewBody(model),
			k5: $author$project$Pages$Admin$Users$viewFooter(model.hV)
		});
};
var $author$project$Pages$Admin$Users$viewUserLoading = function (title) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal-overlay')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('modal-container modal-dashboard modal-cadastro-usuario-sistema')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('header-modal')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(title)
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('action-header'),
										$elm$html$Html$Events$onClick(
										$author$project$Pages$Admin$Users$CloseModal(true))
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('fechar-ico')
											]),
										_List_Nil)
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('modal-content')
							]),
						_List_fromArray(
							[$author$project$Components$View$loading]))
					]))
			]));
};
var $author$project$Pages$Admin$Users$viewModal = function (modal) {
	switch (modal.$) {
		case 0:
			return $elm$html$Html$text('');
		case 1:
			var model_ = modal.a;
			switch (model_.$) {
				case 0:
					var cpf = model_.a;
					return $author$project$Pages$Admin$Users$viewAddUserInputCpf(cpf);
				case 1:
					return $author$project$Pages$Admin$Users$viewUserLoading('Adicionar Usuário do Sistema');
				default:
					var model__ = model_.a;
					return $author$project$Pages$Admin$Users$viewAddUserForm(model__);
			}
		case 3:
			var model_ = modal.a;
			if (!model_.$) {
				return $author$project$Pages$Admin$Users$viewUserLoading('Editar Usuário do Sistema');
			} else {
				var model__ = model_.a;
				return model__.dz ? $author$project$Pages$Admin$Users$viewDeleteConfirmationModal(
					{
						jr: $krisajenkins$remotedata$RemoteData$isLoading(model__.hV)
					}) : ($krisajenkins$remotedata$RemoteData$isLoading(model__.C) ? $author$project$Pages$Admin$Users$viewUserLoading('Editar Usuário do Sistema') : $author$project$Pages$Admin$Users$viewEditUserModalForm(
					{
						hV: model__.hV,
						mX: model__.mX,
						dM: model__.dM,
						c3: model__.c3,
						oU: model__.oU,
						aq: model__.aq,
						J: model__.J,
						C: A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, model__.C)
					}));
			}
		default:
			var user = modal.a;
			return $author$project$Pages$Admin$Users$viewCreatedUserQRCodeModal(user);
	}
};
var $author$project$Pages$Admin$Users$AddUserModal_Open = {$: 6};
var $author$project$Pages$Admin$Users$InputtedFilterDocument = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$Users$InputtedFilterEmail = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$Users$InputtedFilterName = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Admin$Users$algorithmToFilter = F2(
	function (queries, list) {
		var filtered = F3(
			function (filter, key, list_) {
				return A2(
					$elm$core$Maybe$withDefault,
					list_,
					A2(
						$elm$core$Maybe$map,
						function (queryName) {
							return A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									filter,
									A2(
										$elm$core$Basics$composeR,
										$elm$core$String$toLower,
										$elm$core$String$contains(queryName))),
								list);
						},
						key));
			});
		return A3(
			filtered,
			function ($) {
				return $.mX;
			},
			A2($elm$core$Maybe$map, $elm$core$String$toLower, queries.mX),
			A3(
				filtered,
				function ($) {
					return $.aS;
				},
				queries.iI,
				A3(
					filtered,
					function ($) {
						return $.c3;
					},
					A2($elm$core$Maybe$map, $elm$core$String$toLower, queries.c3),
					list)));
	});
var $author$project$Components$Patterns$Forms$filtersWithoutSendButton = function (_v0) {
	var disabledSubmit = _v0.mM;
	var inputs = _v0.jf;
	return A2(
		$elm$html$Html$form,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('filtros-container items-baseline')
			]),
		A2(
			$elm$core$List$map,
			function (input_) {
				return A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(input_.n_)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class(input_.nS),
									A2($elm$html$Html$Attributes$style, 'margin-bottom', '1rem'),
									$elm$html$Html$Attributes$placeholder(input_.hh),
									$elm$html$Html$Attributes$type_(input_.kY),
									$elm$html$Html$Events$onInput(input_.jI),
									$elm$html$Html$Attributes$value(input_.di)
								]),
							_List_Nil)
						]));
			},
			inputs));
};
var $author$project$Pages$Admin$Users$EditUserModal_Open = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$Admin$Users$viewButtonEdit = function (user) {
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('action-system green-btn'),
				$elm$html$Html$Events$onClick(
				$author$project$Pages$Admin$Users$EditUserModal_Open(user))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Editar')
			]));
};
var $author$project$Pages$Admin$Users$QRCodeModal_Open = function (a) {
	return {$: 36, a: a};
};
var $author$project$Pages$Admin$Users$viewButtonQRCode = F2(
	function (user, permissionsValue) {
		return $author$project$Pages$Admin$Users$isOperatorOrMaintenance(permissionsValue) ? _List_fromArray(
			[
				A4(
				$author$project$Components$Patterns$Button$icon,
				$author$project$Pages$Admin$Users$QRCodeModal_Open(user),
				'icon-qrcode',
				'qr_code',
				'Abrir QRCode')
			]) : _List_Nil;
	});
var $author$project$Pages$Admin$Users$viewTableRow = F2(
	function (myUser, user) {
		var permissionsValue = A2(
			$elm$core$List$map,
			function ($) {
				return $.di;
			},
			user.oU);
		var permissionsStr = A2(
			$elm$core$String$join,
			', ',
			A2(
				$elm$core$List$map,
				function ($) {
					return $.jl;
				},
				user.oU));
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(user.c3)
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'width', '200px')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$maskCPF(user.aS))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(permissionsStr)
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'width', '200px')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($elm$core$Maybe$withDefault, '', user.ex))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex gap-2 justify-end')
								]),
							_Utils_ap(
								A2($author$project$Pages$Admin$Users$viewButtonQRCode, user, permissionsValue),
								$author$project$Services$Models$iHaveAccess(
									{
										gZ: myUser.hg,
										hf: $author$project$Services$Models$SYSTEM_USER(2),
										hQ: _List_fromArray(
											[
												$author$project$Pages$Admin$Users$viewButtonEdit(user)
											]),
										hR: _List_Nil
									})))
						]))
				]));
	});
var $author$project$Pages$Admin$Users$viewTable = F2(
	function (myUser, users) {
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'cellspacing', '0'),
					$elm$html$Html$Attributes$class('data-table-dashboard data-table-cadastro-usuarios-concessionaria')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$thead,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$th,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'padding-left', '25px')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Nome')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('CPF')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Permissões')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Concessionária')
										])),
									A2($elm$html$Html$th, _List_Nil, _List_Nil)
								]))
						])),
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					A2(
						$elm$core$List$map,
						$author$project$Pages$Admin$Users$viewTableRow(myUser),
						users))
				]));
	});
var $author$project$Pages$Admin$Users$viewPage = F3(
	function (model, shared, user) {
		var viewAddUser = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('top-actions')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('btn-ce btn-adicionar'),
									$elm$html$Html$Events$onClick($author$project$Pages$Admin$Users$AddUserModal_Open)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Adicionar Usuário do Sistema')
								]))
						]))
				]));
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard')
				]),
			_List_fromArray(
				[
					$author$project$Services$Models$iHaveAccess(
					{
						gZ: user.hg,
						hf: $author$project$Services$Models$SYSTEM_USER(1),
						hQ: viewAddUser,
						hR: $elm$html$Html$text('')
					}),
					$author$project$Components$Patterns$Forms$filtersWithoutSendButton(
					{
						mM: false,
						jf: _List_fromArray(
							[
								{
								nS: 'bg-busca',
								n_: '',
								jI: $author$project$Pages$Admin$Users$InputtedFilterName,
								hh: 'Nome',
								kY: 'text',
								di: A2($elm$core$Maybe$withDefault, '', model.T.c3)
							},
								{
								nS: 'bg-busca',
								n_: '',
								jI: $author$project$Pages$Admin$Users$InputtedFilterDocument,
								hh: 'CPF',
								kY: 'text',
								di: $author$project$Utils$maskCPF(
									A2($elm$core$Maybe$withDefault, '', model.T.iI))
							},
								{
								nS: 'bg-busca',
								n_: '',
								jI: $author$project$Pages$Admin$Users$InputtedFilterEmail,
								hh: 'E-Mail',
								kY: 'text',
								di: A2($elm$core$Maybe$withDefault, '', model.T.mX)
							}
							])
					}),
					function () {
					var _v0 = A2(
						$krisajenkins$remotedata$RemoteData$map,
						$author$project$Pages$Admin$Users$algorithmToFilter(model.T),
						model.ei);
					switch (_v0.$) {
						case 0:
							return $elm$html$Html$text('');
						case 1:
							return $author$project$Components$View$loading;
						case 2:
							return $elm$html$Html$text('');
						default:
							if (!_v0.a.b) {
								return $elm$html$Html$text('Nenhum registro encontrado');
							} else {
								var users = _v0.a;
								return A2($author$project$Pages$Admin$Users$viewTable, user, users);
							}
					}
				}()
				]));
	});
var $author$project$Pages$Admin$Users$view = F3(
	function (model, shared, user) {
		return _Utils_Tuple3(
			'Painel',
			A3($author$project$Pages$Admin$Users$viewPage, model, shared, user),
			$author$project$Pages$Admin$Users$viewModal(model.aY));
	});
var $author$project$Pages$Admin$Vehicles$ClickedCloseModal = {$: 8};
var $author$project$Pages$Admin$Vehicles$InputtedSerialNumber = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Admin$Vehicles$SubmittedEditor = {$: 12};
var $author$project$Pages$Admin$Vehicles$viewDeviceEditorModal = F2(
	function (vehicle, model) {
		var isLoading = $krisajenkins$remotedata$RemoteData$isLoading(model.q) || $krisajenkins$remotedata$RemoteData$isLoading(model.cM);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('modal-overlay')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('modal-container modal-dashboard modal-cadastro-usuario-sistema')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('header-modal')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h3,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Instalar Equipamento')
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('action-header'),
											$elm$html$Html$Events$onClick($author$project$Pages$Admin$Vehicles$ClickedCloseModal),
											$elm$html$Html$Attributes$disabled(
											$krisajenkins$remotedata$RemoteData$isLoading(model.q))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('fechar-ico')
												]),
											_List_Nil)
										]))
								])),
							A2(
							$elm$html$Html$form,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('modal-content'),
									$elm$html$Html$Events$onSubmit($author$project$Pages$Admin$Vehicles$SubmittedEditor)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$label,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$input,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$id('input-name'),
															$elm$html$Html$Attributes$placeholder('Número de Série do dispositivo'),
															$elm$html$Html$Attributes$type_('text'),
															$elm$html$Html$Events$onInput($author$project$Pages$Admin$Vehicles$InputtedSerialNumber),
															$elm$html$Html$Attributes$value(model.pE),
															$elm$html$Html$Attributes$disabled(isLoading)
														]),
													_List_Nil)
												]))
										])),
									function () {
									if (isLoading) {
										return $author$project$Components$View$loading;
									} else {
										var confirmButtons = A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('button-row')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$button,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('action-system white-btn'),
															$elm$html$Html$Attributes$type_('button'),
															$elm$html$Html$Events$onClick($author$project$Pages$Admin$Vehicles$ClickedCloseModal)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Não')
														])),
													A2(
													$elm$html$Html$button,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('action-system green-btn'),
															$elm$html$Html$Attributes$type_('submit')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Sim')
														]))
												]));
										var _v0 = model.q;
										if (_v0.$ === 3) {
											if (!_v0.a.$) {
												var installedVehicle = _v0.a.a;
												return A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('center-modal center-modal-bottom')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$p,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('modal-h3 y-margin-big text-red')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Este dispositivo está vinculado ao veículo ' + (installedVehicle.ac + ', deseja continuar com esta instalação?'))
																])),
															confirmButtons
														]));
											} else {
												var _v1 = _v0.a;
												return A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('center-modal center-modal-bottom')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$p,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('modal-h3 y-margin-big')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Dispositivo não cadastrado, confirma instalação?')
																])),
															confirmButtons
														]));
											}
										} else {
											return A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('center-modal center-modal-bottom')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$button,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('action-system green-btn'),
																$elm$html$Html$Attributes$type_('submit')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Instalar')
															]))
													]));
										}
									}
								}()
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$Vehicles$InputtedCode = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Admin$Vehicles$InputtedPlate = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Admin$Vehicles$viewVehicleEditorModal = F2(
	function (maybeVehicle, model) {
		var verb = function () {
			if (maybeVehicle.$ === 1) {
				return 'Adicionar';
			} else {
				return 'Editar';
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('modal-overlay')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('modal-container modal-dashboard modal-cadastro-usuario-sistema')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('header-modal')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h3,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(verb + ' Veículo')
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('action-header'),
											$elm$html$Html$Events$onClick($author$project$Pages$Admin$Vehicles$ClickedCloseModal),
											$elm$html$Html$Attributes$disabled(
											$krisajenkins$remotedata$RemoteData$isLoading(model.q))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('fechar-ico')
												]),
											_List_Nil)
										]))
								])),
							A2(
							$elm$html$Html$form,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('modal-content'),
									$elm$html$Html$Events$onSubmit($author$project$Pages$Admin$Vehicles$SubmittedEditor)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$label,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$input,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$id('input-name'),
															$elm$html$Html$Attributes$placeholder('Código'),
															$elm$html$Html$Attributes$type_('text'),
															$elm$html$Html$Events$onInput($author$project$Pages$Admin$Vehicles$InputtedCode),
															$elm$html$Html$Attributes$value(model.l4),
															$elm$html$Html$Attributes$disabled(
															$krisajenkins$remotedata$RemoteData$isLoading(model.q))
														]),
													_List_Nil)
												])),
											A2(
											$elm$html$Html$label,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$input,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$placeholder('Placa'),
															$elm$html$Html$Attributes$type_('text'),
															$elm$html$Html$Events$onInput($author$project$Pages$Admin$Vehicles$InputtedPlate),
															$elm$html$Html$Attributes$value(model.ac),
															$elm$html$Html$Attributes$disabled(
															$krisajenkins$remotedata$RemoteData$isLoading(model.q))
														]),
													_List_Nil)
												]))
										])),
									$krisajenkins$remotedata$RemoteData$isLoading(model.q) ? $author$project$Components$View$loading : A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('center-modal center-modal-bottom')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('action-system green-btn'),
													$elm$html$Html$Attributes$type_('submit')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(verb)
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$Vehicles$viewModal = function (modal) {
	if (!modal.$) {
		var maybeVehicle = modal.a;
		var model = modal.b;
		return A2($author$project$Pages$Admin$Vehicles$viewVehicleEditorModal, maybeVehicle, model);
	} else {
		var vehicle = modal.a;
		var model = modal.b;
		return A2($author$project$Pages$Admin$Vehicles$viewDeviceEditorModal, vehicle, model);
	}
};
var $author$project$Pages$Admin$Vehicles$ClickedAddVehicle = {$: 5};
var $author$project$Pages$Admin$Vehicles$GotSearch = {$: 4};
var $author$project$Pages$Admin$Vehicles$InputtedSearch = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$Vehicles$SelectedActive = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Patterns$Forms$valueNotEmpty = function (str) {
	return $elm$core$String$isEmpty(str) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(str);
};
var $author$project$Pages$Admin$Vehicles$ClickedEditVehicle = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Admin$Vehicles$ClickedInstallDevice = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Admin$Vehicles$viewRow = F2(
	function (shared, vehicle) {
		var boolToActive = vehicle.at ? 'Ativo' : 'Inativo';
		var deviceCols = function () {
			var _v0 = vehicle.mG;
			if (_v0.$ === 1) {
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Sem equipamento')
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$colspan(3)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(boolToActive)
							]))
					]);
			} else {
				var device = _v0.a;
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Instalado')
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(boolToActive)
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($author$project$Utils$formatDateTimeFromPosix, shared.kS, device.nT))
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(device.pE)
							]))
					]);
			}
		}();
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(vehicle.l4)
								])),
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(vehicle.ac)
								]))
						]),
						deviceCols,
						_List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('double-button-cell')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('action-system green-btn'),
											$elm$html$Html$Events$onClick(
											$author$project$Pages$Admin$Vehicles$ClickedInstallDevice(vehicle))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Instalar')
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('action-system green-btn'),
											$elm$html$Html$Events$onClick(
											$author$project$Pages$Admin$Vehicles$ClickedEditVehicle(vehicle))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Editar')
										]))
								]))
						])
					])));
	});
var $author$project$Pages$Admin$Vehicles$viewTable = F4(
	function (shared, maybePage, vehicles, recordCount) {
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'cellspacing', '0'),
					$elm$html$Html$Attributes$class('data-table-dashboard'),
					A2($elm$html$Html$Attributes$style, 'margin-bottom', '10px')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$thead,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Código')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Placa')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Status')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Ativo/Inativo')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Data Instalação')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Equipamento')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('')
										]))
								]))
						])),
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					A2(
						$elm$core$List$map,
						$author$project$Pages$Admin$Vehicles$viewRow(shared),
						vehicles))
				]));
	});
var $author$project$Pages$Admin$Vehicles$viewPage = F6(
	function (model, shared, maybePage, maybeSearch, maybeActive, user) {
		var searchInput = A2(
			$elm$html$Html$form,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('filtros-container items-baseline gap-4 '),
					A2($elm$html$Html$Attributes$style, 'align-items', 'flex-end'),
					$elm$html$Html$Events$onSubmit($author$project$Pages$Admin$Vehicles$GotSearch)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bg-busca m-0 mb-4'),
									$elm$html$Html$Attributes$placeholder('Procurar veículo '),
									$elm$html$Html$Attributes$type_('text'),
									$elm$html$Html$Attributes$value(model.fq),
									$elm$html$Html$Events$onInput($author$project$Pages$Admin$Vehicles$InputtedSearch)
								]),
							_List_Nil)
						])),
					$author$project$Components$Patterns$Forms$selectWithError(
					{
						iH: false,
						jl: $elm$core$Maybe$Just('Ativo/Inativo'),
						jn: _List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex flex-col')
							]),
						jI: $elm$core$Maybe$Just(
							A2($elm$core$Basics$composeR, $author$project$Components$Patterns$Forms$valueNotEmpty, $author$project$Pages$Admin$Vehicles$SelectedActive)),
						jO: _List_fromArray(
							[
								{
								eX: A2(
									$elm$core$Maybe$withDefault,
									false,
									A2(
										$elm$core$Maybe$map,
										$elm$core$Basics$eq('true'),
										model.at)),
								c3: 'Ativo',
								di: 'true'
							},
								{
								eX: A2(
									$elm$core$Maybe$withDefault,
									false,
									A2(
										$elm$core$Maybe$map,
										$elm$core$Basics$eq('false'),
										model.at)),
								c3: 'Inativo',
								di: 'false'
							},
								{
								eX: _Utils_eq(model.at, $elm$core$Maybe$Nothing),
								c3: 'Todos',
								di: ''
							}
							]),
						jQ: false,
						ks: _List_fromArray(
							[
								$elm$html$Html$Attributes$class('m-0')
							]),
						kE: false,
						k1: _List_Nil
					}),
					A2(
					$author$project$Components$View$searchButton,
					'self-center mb-2',
					!$krisajenkins$remotedata$RemoteData$isSuccess(model.en))
				]));
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('top-actions')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('btn-ce btn-adicionar'),
										$elm$html$Html$Events$onClick($author$project$Pages$Admin$Vehicles$ClickedAddVehicle)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Adicionar Veículo')
									]))
							]))
					])),
				function () {
				var _v0 = model.en;
				switch (_v0.$) {
					case 0:
						return $elm$html$Html$text('');
					case 1:
						return A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[searchInput, $author$project$Components$View$loading]));
					case 2:
						var err = _v0.a;
						return $elm$html$Html$text(
							$author$project$Services$Api$errorToUserMessage(err));
					default:
						if ((!_v0.a.a.b) && (!_v0.a.b)) {
							var _v1 = _v0.a;
							if (maybeSearch.$ === 1) {
								return $elm$html$Html$text('Nenhum veículo encontrado.');
							} else {
								var search = maybeSearch.a;
								return A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											searchInput,
											$elm$html$Html$text('Nenhum veículo encontrado contendo o termo \"' + (search + '\".'))
										]));
							}
						} else {
							var _v3 = _v0.a;
							var vehicles = _v3.a;
							var recordCount = _v3.b;
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										searchInput,
										A4($author$project$Pages$Admin$Vehicles$viewTable, shared, maybePage, vehicles, recordCount),
										A4(
										$author$project$Components$View$pagination,
										function (p) {
											return A2(
												$author$project$Route$Admin,
												A3(
													$author$project$Route$Vehicles,
													$elm$core$Maybe$Just(p),
													maybeSearch,
													maybeActive),
												$author$project$Route$extractConcessionaireId(shared.pv));
										},
										$author$project$Pages$Admin$Vehicles$vehiclesPerPage,
										maybePage,
										recordCount)
									]));
						}
				}
			}()
			]);
	});
var $author$project$Pages$Admin$Vehicles$view = F6(
	function (model, shared, maybePage, maybeSearch, maybeActive, user) {
		return _Utils_Tuple3(
			A2(
				$elm$core$String$join,
				'',
				_List_fromArray(
					[
						'Veículos',
						A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$String$fromInt,
								$elm$core$Basics$append(' página ')),
							maybePage))
					])),
			A2(
				$elm$html$Html$main_,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('main-dashboard')
					]),
				function () {
					var _v0 = $author$project$Route$extractConcessionaireId(shared.pv);
					if (_v0.$ === 1) {
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('top-actions')
									]),
								_List_fromArray(
									[
										A2($elm$html$Html$div, _List_Nil, _List_Nil)
									])),
								$elm$html$Html$text('Selecione uma concessionária.')
							]);
					} else {
						return A6($author$project$Pages$Admin$Vehicles$viewPage, model, shared, maybePage, maybeSearch, maybeActive, user);
					}
				}()),
			A2(
				$elm$core$Maybe$withDefault,
				$elm$html$Html$text(''),
				A2($elm$core$Maybe$map, $author$project$Pages$Admin$Vehicles$viewModal, model.aY)));
	});
var $author$project$Pages$Admin$view = F5(
	function (compNavigationDrawer, model, shared, maybeConcessionaireId, user) {
		var mapPageModal = F2(
			function (tag, _v2) {
				var t = _v2.a;
				var p = _v2.b;
				var m = _v2.c;
				return _Utils_Tuple3(
					t,
					A2($elm$html$Html$map, tag, p),
					A2($elm$html$Html$map, tag, m));
			});
		var _default = _Utils_Tuple3(
			'',
			$elm$html$Html$text(''),
			$elm$html$Html$text(''));
		var _v0 = function () {
			var _v1 = model.bv;
			switch (_v1.$) {
				case 0:
					return _default;
				case 1:
					var model_ = _v1.a;
					return $author$project$Services$Models$iHaveAccess(
						{
							gZ: user.hg,
							hf: $author$project$Services$Models$SYSTEM_USER(0),
							hQ: A2(
								mapPageModal,
								$author$project$Pages$Admin$UsersMsg,
								A3($author$project$Pages$Admin$Users$view, model_, shared, user)),
							hR: _default
						});
				case 2:
					var model_ = _v1.a;
					return A2(
						mapPageModal,
						$author$project$Pages$Admin$EquipmentsMsg,
						A3($author$project$Pages$Admin$Equipments$view, model_, shared, user));
				case 3:
					var maybePage = _v1.a;
					var maybeSearch = _v1.b;
					var model_ = _v1.c;
					return A2(
						mapPageModal,
						$author$project$Pages$Admin$CardsMsg,
						A5($author$project$Pages$Admin$Cards$view, model_, shared, maybePage, maybeSearch, user));
				case 4:
					var id = _v1.a;
					var model_ = _v1.b;
					return A2(
						mapPageModal,
						$author$project$Pages$Admin$CardExtractMsg,
						A3($author$project$Pages$Admin$CardExtract$view, model_, shared, user));
				case 5:
					var maybePage = _v1.a;
					var maybeSearch = _v1.b;
					var maybeActive = _v1.c;
					var model_ = _v1.d;
					return A2(
						mapPageModal,
						$author$project$Pages$Admin$VehiclesMsg,
						A6($author$project$Pages$Admin$Vehicles$view, model_, shared, maybePage, maybeSearch, maybeActive, user));
				case 9:
					var model_ = _v1.a;
					return A2(
						mapPageModal,
						$author$project$Pages$Admin$AccountabilityReportMsg,
						A3($author$project$Pages$Admin$AccountabilityReport$view, model_, shared, user));
				case 10:
					var model_ = _v1.a;
					return A2(
						mapPageModal,
						$author$project$Pages$Admin$SalesReportMsg,
						A3($author$project$Pages$Admin$SalesReport$view, model_, shared, user));
				case 11:
					var model_ = _v1.a;
					return A2(
						mapPageModal,
						$author$project$Pages$Admin$SessionsReportMsg,
						A3($author$project$Pages$Admin$SessionsReport$view, model_, shared, user));
				case 12:
					var model_ = _v1.a;
					return $author$project$Services$Models$iHaveAccess(
						{
							gZ: user.hg,
							hf: $author$project$Services$Models$REPORTS($author$project$Services$Models$SessionsWithoutPouch),
							hQ: A2(
								mapPageModal,
								$author$project$Pages$Admin$SessionsWithoutPouchReportMsg,
								A3($author$project$Pages$Admin$SessionWithoutPouchReport$view, model_, shared, user)),
							hR: _default
						});
				case 13:
					var model_ = _v1.a;
					return $author$project$Services$Models$iHaveAccess(
						{
							gZ: user.hg,
							hf: $author$project$Services$Models$REPORTS($author$project$Services$Models$Sales),
							hQ: A2(
								mapPageModal,
								$author$project$Pages$Admin$SalesReportV2Msg,
								A3($author$project$Pages$Admin$Reports$Sales$view, model_, shared, user)),
							hR: _default
						});
				case 6:
					var model_ = _v1.a;
					return A2(
						mapPageModal,
						$author$project$Pages$Admin$PaymentGuidesMsg,
						A3($author$project$Pages$Admin$PaymentGuides$view, model_, shared, user));
				case 7:
					var model_ = _v1.a;
					return A2(
						mapPageModal,
						$author$project$Pages$Admin$PaymentBilletsMsg,
						A3($author$project$Pages$Admin$PaymentBillets$view, model_, shared, user));
				default:
					var model_ = _v1.a;
					return A2(
						mapPageModal,
						$author$project$Pages$Admin$CompanyOrdersMsg,
						A3($author$project$Pages$Admin$CompanyOrders$view, model_, shared, user));
			}
		}();
		var pageTitle = _v0.a;
		var pageView = _v0.b;
		var pageModal = _v0.c;
		return _Utils_Tuple2(
			A2(
				$elm$core$String$join,
				'',
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$withDefault,
						'Admin',
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.c3;
							},
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.dM;
										},
										A2(
											$elm$core$Basics$composeR,
											$elm$core$Maybe$Just,
											$elm$core$Basics$eq(maybeConcessionaireId))),
									A2(
										$elm$core$Maybe$withDefault,
										_List_Nil,
										A2(
											$elm$core$Maybe$map,
											function ($) {
												return $.bR;
											},
											compNavigationDrawer)))))),
						' - ',
						pageTitle
					])),
			_List_fromArray(
				[pageView, pageModal]));
	});
var $author$project$Pages$ChangePassword$invalidTokenView = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mx-auto md:w-2/4 sm:w-full flex flex-col justify-center items-center h-screen justify-center')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col items-center rounded w-11/12  border-solid border border-black login-box p-10 box-border')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col justify-center items-center h-96 forgot-password')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-white text-center pb-5')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Token para alteração de senha é inválido!')
								])),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$author$project$Route$href($author$project$Route$Login),
									$elm$html$Html$Attributes$class('text-teal-main font-bold text-xl')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Login')
								]))
						]))
				]))
		]));
var $author$project$Pages$ChangePassword$sentView = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mx-auto md:w-2/4 sm:w-full flex flex-col justify-center items-center h-screen justify-center')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col items-center rounded w-11/12  border-solid border border-black login-box p-10 box-border')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col justify-center items-center h-96 forgot-password')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-white text-center pb-5')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Senha alterada com sucesso!')
								])),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$author$project$Route$href($author$project$Route$Login),
									$elm$html$Html$Attributes$class('text-teal-main font-bold text-xl')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Login')
								]))
						]))
				]))
		]));
var $author$project$Pages$ChangePassword$ClickedToggleVisibilityPassword = {$: 2};
var $author$project$Pages$ChangePassword$ClickedToggleVisibilityPasswordConfirmation = {$: 3};
var $author$project$Components$Patterns$Forms$InputPassword = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$ChangePassword$InputPassword = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$ChangePassword$InputRPassword = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$ChangePassword$SendSetPassword = {$: 4};
var $author$project$Pages$ChangePassword$isInvalidPasswordConfirmation = F2(
	function (password, passwordConfirmation) {
		return !_Utils_eq(passwordConfirmation, password);
	});
var $author$project$Pages$ChangePassword$toSentView = function (model) {
	var formStatus = (model.bw === 1) ? 1 : (_Utils_eq(model.q, $krisajenkins$remotedata$RemoteData$Loading) ? 2 : 0);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mx-auto md:w-3/4 sm:w-full flex flex-col justify-center items-center h-screen justify-center')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex flex-col items-center rounded w-11/12  border-solid border border-black login-box')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex flex-col justify-center items-center h-96 forgot-password')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-white text-center pt-4 pb-4')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Digite sua nova senha')
									])),
								$author$project$Components$Patterns$Forms$formSimple(
								{
									hZ: _List_fromArray(
										[
											$elm$html$Html$Attributes$class('flex flex-col gap-4 mb-4 items-center '),
											A2($elm$html$Html$Attributes$style, 'width', 'min-content')
										]),
									L: formStatus,
									jf: _List_fromArray(
										[
											$author$project$Components$Patterns$Forms$InputPassword(
											{
												ie: $elm$core$Maybe$Nothing,
												iH: _Utils_eq(model.q, $krisajenkins$remotedata$RemoteData$Loading),
												nR: _List_fromArray(
													[
														$elm$html$Html$Attributes$class('text-white border-0 border-b-2 border-solid '),
														A2($elm$html$Html$Attributes$style, 'border-color', 'white')
													]),
												dY: model.d0,
												jl: $elm$core$Maybe$Just('Nova senha'),
												jn: _List_Nil,
												n9: $elm$core$Maybe$Just(100),
												c3: 'Campo para definir nova senha',
												jE: $elm$core$Maybe$Nothing,
												jF: $elm$core$Maybe$Nothing,
												jG: $elm$core$Maybe$Nothing,
												jH: $author$project$Pages$ChangePassword$ClickedToggleVisibilityPassword,
												ov: $elm$core$Maybe$Nothing,
												jI: $elm$core$Maybe$Just($author$project$Pages$ChangePassword$InputPassword),
												hh: 'Nova senha',
												kE: model.bw === 1,
												k1: _List_fromArray(
													[
														_Utils_Tuple2($elm$core$String$isEmpty, 'A senha não pode ser vazia.')
													]),
												di: model.bu
											}),
											$author$project$Components$Patterns$Forms$InputPassword(
											{
												ie: $elm$core$Maybe$Nothing,
												iH: _Utils_eq(model.q, $krisajenkins$remotedata$RemoteData$Loading),
												nR: _List_fromArray(
													[
														$elm$html$Html$Attributes$class('text-white border-0 border-b-2 border-solid '),
														A2($elm$html$Html$Attributes$style, 'border-color', 'white')
													]),
												dY: model.d4,
												jl: $elm$core$Maybe$Just('Repita a nova senha'),
												jn: _List_Nil,
												n9: $elm$core$Maybe$Just(100),
												c3: 'Campo para confirmar nova senha',
												jE: $elm$core$Maybe$Nothing,
												jF: $elm$core$Maybe$Nothing,
												jG: $elm$core$Maybe$Nothing,
												jH: $author$project$Pages$ChangePassword$ClickedToggleVisibilityPasswordConfirmation,
												ov: $elm$core$Maybe$Nothing,
												jI: $elm$core$Maybe$Just($author$project$Pages$ChangePassword$InputRPassword),
												hh: 'Repita a nova senha',
												kE: model.bw === 1,
												k1: _List_fromArray(
													[
														_Utils_Tuple2(
														$author$project$Pages$ChangePassword$isInvalidPasswordConfirmation(model.bu),
														'As senhas informadas não correspondem. Certifique-se de digitar a mesma senha nos dois campos.'),
														_Utils_Tuple2($elm$core$String$isEmpty, 'A confirmação de senha não pode ser vazia.')
													]),
												di: model.c8
											})
										]),
									oc: $elm$core$Maybe$Just(
										{
											lx: _List_Nil,
											l_: $author$project$Pages$ChangePassword$SendSetPassword,
											iH: $elm$core$String$isEmpty(model.c8) || $elm$core$String$isEmpty(model.bu)
										}),
									pX: 'Enviar'
								})
							]))
					]))
			]));
};
var $author$project$Pages$ChangePassword$view = F2(
	function (model, shared) {
		return _Utils_Tuple2(
			'Recuperar senha',
			function () {
				var _v0 = model.ea;
				switch (_v0) {
					case 0:
						return $author$project$Pages$ChangePassword$toSentView(model);
					case 1:
						return $author$project$Pages$ChangePassword$sentView;
					default:
						return $author$project$Pages$ChangePassword$invalidTokenView;
				}
			}());
	});
var $author$project$Pages$Enterprise$Dashboard$GoDeleteListModal = function (a) {
	return {$: 39, a: a};
};
var $author$project$Pages$Enterprise$Dashboard$Navigate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Enterprise$Dashboard$OpenImportModal = {$: 4};
var $author$project$Pages$Enterprise$Dashboard$SelectedClass = function (a) {
	return {$: 32, a: a};
};
var $author$project$Pages$Enterprise$Dashboard$isOrderDetails = function (model) {
	return (!$elm$core$String$isEmpty(
		A2($elm$core$Maybe$withDefault, '', model.cX))) || model.gO;
};
var $author$project$Utils$pluralize = F3(
	function (number, singular, plural) {
		return (number === 1) ? singular : plural;
	});
var $author$project$Pages$Enterprise$Dashboard$SaveList = {$: 38};
var $author$project$Pages$Enterprise$Dashboard$viewSaveList = function (maybeClassSelected) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$html$Html$text(''),
		A2(
			$elm$core$Maybe$map,
			function (_v0) {
				return A4($author$project$Components$Patterns$Button$icon, $author$project$Pages$Enterprise$Dashboard$SaveList, 'icon-save-config', 'save', 'Gravar lista');
			},
			maybeClassSelected));
};
var $author$project$Pages$Enterprise$Dashboard$viewEmployeeTableFooter = function (model) {
	var viewActions = _List_fromArray(
		[
			$author$project$Pages$Enterprise$Dashboard$viewSaveList(model.ab),
			A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('green-btn action-system'),
					$elm$html$Html$Events$onClick($author$project$Pages$Enterprise$Dashboard$OpenPaymentModal)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Comprar')
				]))
		]);
	var viewIss = (model.d.nY > 0) ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex gap-4 mr-10')
			]),
		_Utils_ap(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('self-center mr-0')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Valor Bruto: '),
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									'R$ ' + $author$project$Utils$formatMoneyInput(
										$elm$core$String$fromInt(model.d.i3)))
								]))
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('self-center mr-0')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Desconto ISS: '),
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									'R$ ' + $author$project$Utils$formatMoneyInput(
										$elm$core$String$fromInt(model.d.nY)))
								]))
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('total  self-center mr-0')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Valor líquido: '),
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									'R$ ' + $author$project$Utils$formatMoneyInput(
										$elm$core$String$fromInt(model.d.h2)))
								]))
						]))
				]),
			viewActions)) : A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex gap-4 mr-10')
			]),
		_Utils_ap(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('total  self-center mr-0')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Valor: '),
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									'R$ ' + $author$project$Utils$formatMoneyInput(
										$elm$core$String$fromInt(
											$author$project$Pages$Enterprise$Dashboard$sumTotalValue(model))))
								]))
						]))
				]),
			viewActions));
	var employeesCount = $elm$core$List$length(model.d.an);
	return ($elm$core$List$length(model.d.an) > 0) ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('bottom-actions flex justify-between')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('selecionados')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(employeesCount))
							])),
						$elm$html$Html$text(
						' importado' + A3($author$project$Utils$pluralize, employeesCount, '', 's'))
					])),
				viewIss
			])) : $elm$html$Html$text('');
};
var $author$project$Pages$Enterprise$Dashboard$viewEmployee = F2(
	function (_v0, employee) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(employee.c3)
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$maskPhoneDDD(
								function ($) {
									return $.jX;
								}(employee)))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$maskCPF(employee.aS))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$formatAsMoney(
								$elm$core$String$fromInt(employee.h2)))
						]))
				]));
	});
var $author$project$Pages$Enterprise$Dashboard$viewExcludedEmployee = function (error) {
	var viewStrong = function (value) {
		return A2(
			$elm$html$Html$strong,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('font-bold')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(value)
				]));
	};
	return A2(
		$elm$html$Html$tr,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('data-table-dashboard-row-error')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						viewStrong(error)
					])),
				A2($elm$html$Html$td, _List_Nil, _List_Nil),
				A2($elm$html$Html$td, _List_Nil, _List_Nil),
				A2($elm$html$Html$td, _List_Nil, _List_Nil)
			]));
};
var $author$project$Pages$Enterprise$Dashboard$viewEmployeeTableMain = function (model) {
	var employees = A2(
		$elm$core$List$append,
		A2(
			$elm$core$List$map,
			$author$project$Pages$Enterprise$Dashboard$viewEmployee(model),
			model.d.an),
		A2(
			$elm$core$List$map,
			function (ex) {
				if (!ex.$) {
					var infos = ex.a;
					return $author$project$Pages$Enterprise$Dashboard$viewExcludedEmployee(infos.m$);
				} else {
					var error_ = ex.a;
					return $author$project$Pages$Enterprise$Dashboard$viewExcludedEmployee(error_);
				}
			},
			model.d.bY));
	return A2(
		$elm$html$Html$table,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'cellspacing', '0'),
				$elm$html$Html$Attributes$class('data-table-dashboard')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$thead,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$tr,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$th,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Nome')
									])),
								A2(
								$elm$html$Html$th,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Fone')
									])),
								A2(
								$elm$html$Html$th,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('CPF')
									])),
								A2(
								$elm$html$Html$th,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Valor')
									]))
							]))
					])),
				A2($elm$html$Html$tbody, _List_Nil, employees)
			]));
};
var $author$project$Pages$Enterprise$Dashboard$viewEmployeeTable = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Pages$Enterprise$Dashboard$viewEmployeeTableMain(model),
				$author$project$Pages$Enterprise$Dashboard$viewEmployeeTableFooter(model)
			]));
};
var $author$project$Pages$Enterprise$Dashboard$viewRowHtml = F2(
	function (timezone, import_) {
		var viewRowStr = function () {
			var maybeValue = function (v) {
				return A2($elm$core$Maybe$withDefault, '-', v);
			};
			var emptyValue = function (v) {
				return $elm$core$String$isEmpty(v) ? '-' : v;
			};
			return _List_fromArray(
				[
					A2($author$project$Utils$formatDateTimeFromPosixWithSeconds, timezone, import_.ix),
					emptyValue(import_.mj),
					emptyValue(import_.qJ),
					emptyValue(import_.nk),
					import_.kK
				]);
		}();
		var isClickable = ($elm$core$String$toLower(import_.kK) === 'importando') ? false : true;
		var onClick = isClickable ? $elm$html$Html$Events$onClick(
			$author$project$Pages$Enterprise$Dashboard$Navigate(
				A2(
					$author$project$Route$EnterpriseDashboard,
					$elm$core$Maybe$Nothing,
					$elm$core$Maybe$Just(import_.dM)))) : $elm$html$Html$Attributes$class('');
		var class_ = isClickable ? 'cursor-pointer' : 'cursor-wait';
		return _Utils_Tuple2(
			A2(
				$elm$core$List$map,
				function (str) {
					return A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								onClick,
								$elm$html$Html$Attributes$class(class_)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(str)
							]));
				},
				viewRowStr),
			isClickable);
	});
var $author$project$Pages$Enterprise$Dashboard$viewImports = F2(
	function (timezone, model) {
		var _v0 = model.eP;
		switch (_v0.$) {
			case 0:
				return $elm$html$Html$text('');
			case 1:
				return $elm$html$Html$text('');
			case 2:
				var e = _v0.a;
				return $elm$html$Html$text('');
			default:
				var imports = _v0.a;
				return $author$project$Components$Patterns$Tables$defaultSomeLinesAreClickable(
					{
						lw: _List_Nil,
						nF: _List_fromArray(
							['Criado em', 'Criado por', 'Classe', 'Arquivo', 'Status']),
						nX: true,
						pj: A2(
							$elm$core$List$map,
							$author$project$Pages$Enterprise$Dashboard$viewRowHtml(timezone),
							imports)
					});
		}
	});
var $author$project$Pages$Enterprise$Dashboard$viewMainContainer = F2(
	function (shared, model) {
		var maybeConcessionaireClassSelectedId = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.dM;
			},
			model.ab);
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('top-actions gap-4'),
							A2(
							$elm$html$Html$Attributes$style,
							'justify-content',
							$author$project$Pages$Enterprise$Dashboard$isOrderDetails(model) ? 'space-between' : 'flex-start')
						]),
					_List_fromArray(
						[
							$author$project$Pages$Enterprise$Dashboard$isOrderDetails(model) ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex items-center cursor-pointer'),
									$elm$html$Html$Events$onClick(
									$author$project$Pages$Enterprise$Dashboard$Navigate(
										A2($author$project$Route$EnterpriseDashboard, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing)))
								]),
							_List_fromArray(
								[
									A4(
									$author$project$Components$Patterns$Button$icon,
									$author$project$Pages$Enterprise$Dashboard$Navigate(
										A2($author$project$Route$EnterpriseDashboard, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing)),
									'icon-md m-0 bg-transparent shadow-none hover:text-teal-main border-0',
									'arrow_back',
									'Voltar'),
									$elm$html$Html$text('Voltar')
								])) : A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('btn-ce btn-importar cursor-pointer no-select'),
									$elm$html$Html$Events$onClick($author$project$Pages$Enterprise$Dashboard$OpenImportModal)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Importar Planilha')
								])),
							$author$project$Pages$Enterprise$Dashboard$isOrderDetails(model) ? $elm$html$Html$text('') : $author$project$Components$Patterns$Forms$selectWithError(
							{
								iH: false,
								jl: $elm$core$Maybe$Nothing,
								jn: _List_Nil,
								jI: $elm$core$Maybe$Just($author$project$Pages$Enterprise$Dashboard$SelectedClass),
								jO: A2(
									$elm$core$List$cons,
									{
										eX: _Utils_eq(maybeConcessionaireClassSelectedId, $elm$core$Maybe$Nothing),
										c3: 'Classes',
										di: ''
									},
									A2(
										$elm$core$List$map,
										function (_class) {
											return {
												eX: _Utils_eq(
													maybeConcessionaireClassSelectedId,
													$elm$core$Maybe$Just(_class.dM)),
												c3: _class.c3,
												di: _class.dM
											};
										},
										model.cL)),
								jQ: false,
								ks: _List_Nil,
								kE: false,
								k1: _List_Nil
							}),
							function () {
							var _v0 = model.cX;
							if (!_v0.$) {
								var id = _v0.a;
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('flex flex-row justify-end gap-2')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$label,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-black flex flex-col items-end')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$strong,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('font-bold')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Nº do pedido')
														])),
													A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2(
																$elm$core$Maybe$withDefault,
																'-',
																A2($elm$core$Maybe$map, $elm$core$String$fromInt, model.d.pC)))
														]))
												])),
											A4(
											$author$project$Components$Patterns$Button$icon,
											$author$project$Pages$Enterprise$Dashboard$GoDeleteListModal(id),
											'icon-md red-btn m-0 icon-delete-dashboard',
											'delete',
											'Deletar')
										]));
							} else {
								return $elm$html$Html$text('');
							}
						}()
						])),
					model.dP ? A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[$author$project$Components$View$loading])) : (((!($elm$core$List$length(model.d.an) + $elm$core$List$length(model.d.bY))) && ($author$project$Pages$Enterprise$Dashboard$isOrderDetails(model) && (model.d.dM !== ''))) ? A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-gray-tint')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Não foram encontrados registros no arquivo importado.')
								]))
						])) : ($author$project$Pages$Enterprise$Dashboard$isOrderDetails(model) ? $author$project$Pages$Enterprise$Dashboard$viewEmployeeTable(model) : A2($author$project$Pages$Enterprise$Dashboard$viewImports, shared.kS, model)))
				]));
	});
var $author$project$Pages$Enterprise$Dashboard$CardInput = F2(
	function (a, b) {
		return {$: 27, a: a, b: b};
	});
var $author$project$Pages$Enterprise$Dashboard$CardNumber = 0;
var $author$project$Pages$Enterprise$Dashboard$CloseModal = {$: 3};
var $author$project$Pages$Enterprise$Dashboard$Cnpj = 4;
var $author$project$Pages$Enterprise$Dashboard$Cvv = 3;
var $author$project$Pages$Enterprise$Dashboard$EnterpriseName = 1;
var $author$project$Pages$Enterprise$Dashboard$ExpirationDate = 2;
var $author$project$Utils$creditCardCvv = $Massolari$elm_mask$Mask$number('###');
var $author$project$Utils$creditCardExpirationMask = $Massolari$elm_mask$Mask$number('##/##');
var $author$project$Utils$creditCardMask = $Massolari$elm_mask$Mask$number('#### #### #### ####');
var $author$project$Components$Input$defaultOptions = {fR: $elm$core$Maybe$Nothing, fS: false, iH: false, dM: $elm$core$Maybe$Nothing, gH: _List_Nil, gU: 250, jI: $elm$core$Maybe$Nothing, hh: '', kY: 'text', di: ''};
var $elm$html$Html$Attributes$autofocus = $elm$html$Html$Attributes$boolProperty('autofocus');
var $author$project$Components$Input$input_ = function (options) {
	var isEmptyValue = $elm$core$String$isEmpty(options.di);
	return A2(
		$elm$html$Html$label,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('permanent-placeholder'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('bg', isEmptyValue),
								_Utils_Tuple2('fg', !isEmptyValue)
							]))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(options.hh)
					])),
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$placeholder(options.hh),
						$elm$html$Html$Attributes$type_(options.kY),
						function () {
						var _v0 = options.jI;
						if (!_v0.$) {
							var input = _v0.a;
							return $elm$html$Html$Events$onInput(input);
						} else {
							return $elm$html$Html$Attributes$class('');
						}
					}(),
						A2(
						$elm$core$Maybe$withDefault,
						$elm$html$Html$Attributes$classList(_List_Nil),
						A2(
							$elm$core$Maybe$map,
							$elm$html$Html$Attributes$attribute('autocomplete'),
							options.fR)),
						$elm$html$Html$Attributes$value(options.di),
						(options.kY === 'text') ? $elm$html$Html$Attributes$maxlength(options.gU) : A2($elm$html$Html$Attributes$style, '', ''),
						$elm$html$Html$Attributes$classList(
						A2(
							$elm$core$List$map,
							function (c) {
								return _Utils_Tuple2(c, true);
							},
							options.gH)),
						$elm$html$Html$Attributes$autofocus(options.fS),
						$elm$html$Html$Attributes$disabled(options.iH),
						A2(
						$elm$core$Maybe$withDefault,
						A2($elm$html$Html$Attributes$style, '', ''),
						A2($elm$core$Maybe$map, $elm$html$Html$Attributes$id, options.dM))
					]),
				_List_Nil)
			]));
};
var $author$project$Pages$Enterprise$Dashboard$viewModalAddCard = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal-container modal-dashboard modal-comprar-creditos')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('header-modal')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Pagamento')
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('action-header'),
								$elm$html$Html$Events$onClick($author$project$Pages$Enterprise$Dashboard$CloseModal)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('fechar-ico')
									]),
								_List_Nil)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('modal-content')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Components$Input$input_(
								_Utils_update(
									$author$project$Components$Input$defaultOptions,
									{
										fS: true,
										jI: $elm$core$Maybe$Just(
											A2(
												$elm$core$Basics$composeL,
												$author$project$Pages$Enterprise$Dashboard$CardInput(0),
												$elm$core$String$filter($elm$core$Char$isDigit))),
										hh: 'Número do Cartão',
										di: $author$project$Utils$creditCardMask(model.ia)
									})),
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Components$Input$input_(
										_Utils_update(
											$author$project$Components$Input$defaultOptions,
											{
												jI: $elm$core$Maybe$Just(
													$author$project$Pages$Enterprise$Dashboard$CardInput(1)),
												hh: 'Nome da Empresa (Igual no Cartão)',
												di: model.cT
											}))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('inputs')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('numero')
											]),
										_List_fromArray(
											[
												$author$project$Components$Input$input_(
												_Utils_update(
													$author$project$Components$Input$defaultOptions,
													{
														jI: $elm$core$Maybe$Just(
															A2(
																$elm$core$Basics$composeL,
																$author$project$Pages$Enterprise$Dashboard$CardInput(2),
																$elm$core$String$filter($elm$core$Char$isDigit))),
														hh: 'Validade',
														di: $author$project$Utils$creditCardExpirationMask(model.nb)
													}))
											])),
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Components$Input$input_(
												_Utils_update(
													$author$project$Components$Input$defaultOptions,
													{
														jI: $elm$core$Maybe$Just(
															A2(
																$elm$core$Basics$composeL,
																$author$project$Pages$Enterprise$Dashboard$CardInput(3),
																$elm$core$String$filter($elm$core$Char$isDigit))),
														hh: 'CVV',
														di: $author$project$Utils$creditCardCvv(model.bU)
													}))
											]))
									])),
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Components$Input$input_(
										_Utils_update(
											$author$project$Components$Input$defaultOptions,
											{
												jI: $elm$core$Maybe$Just(
													A2(
														$elm$core$Basics$composeL,
														$author$project$Pages$Enterprise$Dashboard$CardInput(4),
														$elm$core$String$filter($elm$core$Char$isDigit))),
												hh: 'CNPJ',
												di: $author$project$Utils$maskCNPJ(model.l3)
											}))
									])),
								$krisajenkins$remotedata$RemoteData$isLoading(model.dm) ? $author$project$Components$View$loading : A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('center-modal center-modal-bottom')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('action-system green-btn'),
												$elm$html$Html$Events$onClick($author$project$Pages$Enterprise$Dashboard$AddCard)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Continuar')
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Enterprise$Dashboard$MakePayment = {$: 16};
var $author$project$Pages$Enterprise$Dashboard$OpenAddCardModal = {$: 14};
var $author$project$Pages$Enterprise$Dashboard$SelectPaymentMethod = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Enterprise$Dashboard$viewBankSlipRadioButton = function (method) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('boleto'),
					$elm$html$Html$Attributes$name('radio-group'),
					$elm$html$Html$Attributes$type_('radio'),
					$elm$html$Html$Events$onClick(
					$author$project$Pages$Enterprise$Dashboard$SelectPaymentMethod($author$project$Pages$Enterprise$Dashboard$BankSlip)),
					$elm$html$Html$Attributes$checked(
					_Utils_eq(
						method,
						$elm$core$Maybe$Just($author$project$Pages$Enterprise$Dashboard$BankSlip))),
					$elm$html$Html$Attributes$class('no-select')
				]),
			_List_Nil),
			A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$for('boleto'),
					$elm$html$Html$Attributes$class('no-select')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Boleto Bancário')
				]))
		]);
};
var $author$project$Pages$Enterprise$Dashboard$CreditCard = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Enterprise$Dashboard$viewCreditCardRadioButton = F2(
	function (m_method, card) {
		var isChecked = function () {
			if ((!m_method.$) && (m_method.a.$ === 3)) {
				var card_ = m_method.a.a;
				return _Utils_eq(card_.c1, card.c1);
			} else {
				return false;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id('cartao-final-' + card.c1),
							$elm$html$Html$Attributes$name('radio-group'),
							$elm$html$Html$Attributes$class('no-select'),
							$elm$html$Html$Attributes$type_('radio'),
							$elm$html$Html$Events$onClick(
							$author$project$Pages$Enterprise$Dashboard$SelectPaymentMethod(
								$author$project$Pages$Enterprise$Dashboard$CreditCard(card))),
							$elm$html$Html$Attributes$checked(isChecked)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for('cartao-final-' + card.c1),
							$elm$html$Html$Attributes$class('no-select')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Cartão Mastercard com final '),
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(card.c1)
								]))
						]))
				]));
	});
var $author$project$Pages$Enterprise$Dashboard$PaymentGuide = {$: 2};
var $author$project$Pages$Enterprise$Dashboard$viewPaymentGuideRadioButton = function (method) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('guia-de-pagamento'),
					$elm$html$Html$Attributes$name('radio-group'),
					$elm$html$Html$Attributes$type_('radio'),
					$elm$html$Html$Events$onClick(
					$author$project$Pages$Enterprise$Dashboard$SelectPaymentMethod($author$project$Pages$Enterprise$Dashboard$PaymentGuide)),
					$elm$html$Html$Attributes$checked(
					_Utils_eq(
						method,
						$elm$core$Maybe$Just($author$project$Pages$Enterprise$Dashboard$PaymentGuide))),
					$elm$html$Html$Attributes$class('no-select')
				]),
			_List_Nil),
			A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$for('guia-de-pagamento'),
					$elm$html$Html$Attributes$class('no-select')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Guia de pagamento')
				]))
		]);
};
var $author$project$Pages$Enterprise$Dashboard$Pix = {$: 1};
var $author$project$Pages$Enterprise$Dashboard$viewPixRadioButton = function (method) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('pix'),
					$elm$html$Html$Attributes$name('radio-group'),
					$elm$html$Html$Attributes$type_('radio'),
					$elm$html$Html$Events$onClick(
					$author$project$Pages$Enterprise$Dashboard$SelectPaymentMethod($author$project$Pages$Enterprise$Dashboard$Pix)),
					$elm$html$Html$Attributes$checked(
					_Utils_eq(
						method,
						$elm$core$Maybe$Just($author$project$Pages$Enterprise$Dashboard$Pix))),
					$elm$html$Html$Attributes$class('no-select')
				]),
			_List_Nil),
			A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$for('pix'),
					$elm$html$Html$Attributes$class('no-select')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('PIX')
				]))
		]);
};
var $author$project$Pages$Enterprise$Dashboard$viewModalBuyCreditsMethod = F3(
	function (model, m_cards, m_method) {
		var totalValue = $author$project$Utils$formatMoneyInput(
			$elm$core$String$fromInt(
				$author$project$Pages$Enterprise$Dashboard$sumTotalValue(model)));
		var viewIssTax = (model.d.nY > 0) ? _List_fromArray(
			[
				A2(
				$elm$html$Html$h4,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('cc-total no-select text-lg mb-2')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Valor bruto: '),
						A2(
						$elm$html$Html$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								'R$ ' + $author$project$Utils$formatAsMoney(
									$elm$core$String$fromInt(model.d.i3)))
							]))
					])),
				A2(
				$elm$html$Html$h4,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('cc-total no-select text-lg mb-2')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Desconto ISS: '),
						A2(
						$elm$html$Html$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								'R$ ' + $author$project$Utils$formatAsMoney(
									$elm$core$String$fromInt(model.d.nY)))
							]))
					])),
				A2(
				$elm$html$Html$h4,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('cc-total no-select')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Valor líquido: '),
						A2(
						$elm$html$Html$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								'R$ ' + $author$project$Utils$formatAsMoney(
									$elm$core$String$fromInt(model.d.h2)))
							]))
					]))
			]) : _List_fromArray(
			[
				A2(
				$elm$html$Html$h4,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('cc-total no-select')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Valor líquido: '),
						A2(
						$elm$html$Html$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('R$ ' + totalValue)
							]))
					]))
			]);
		var canViewPaymentMethod = F3(
			function (paymentMethodsAvailable, paymentMethod, listView) {
				return A2(
					$elm$core$List$any,
					$elm$core$Basics$eq(paymentMethod),
					paymentMethodsAvailable) ? listView : _List_Nil;
			});
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('modal-container modal-dashboard modal-comprar-creditos')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('header-modal no-select')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h3,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Pagamento')
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('action-header absolute'),
									$elm$html$Html$Events$onClick($author$project$Pages$Enterprise$Dashboard$CloseModal)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fechar-ico')
										]),
									_List_Nil)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('modal-content flex flex-col items-center'),
							A2($elm$html$Html$Attributes$style, 'padding-top', '32px')
						]),
					function () {
						if (m_cards.$ === 1) {
							return _List_fromArray(
								[$author$project$Components$View$loading]);
						} else {
							var _v1 = m_cards.a;
							var cards = _v1.a;
							var canEmitPaymentGuide = _v1.b;
							var paymentMethodsAvailable = _v1.c;
							return _Utils_ap(
								viewIssTax,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('radio-container')
											]),
										$elm$core$List$concat(
											_List_fromArray(
												[
													A3(
													canViewPaymentMethod,
													paymentMethodsAvailable,
													5,
													$author$project$Pages$Enterprise$Dashboard$viewBankSlipRadioButton(m_method)),
													A3(
													canViewPaymentMethod,
													paymentMethodsAvailable,
													3,
													$author$project$Pages$Enterprise$Dashboard$viewPixRadioButton(m_method)),
													canEmitPaymentGuide ? A3(
													canViewPaymentMethod,
													paymentMethodsAvailable,
													4,
													$author$project$Pages$Enterprise$Dashboard$viewPaymentGuideRadioButton(m_method)) : _List_Nil,
													A3(
													canViewPaymentMethod,
													paymentMethodsAvailable,
													1,
													A2(
														$elm$core$List$map,
														$author$project$Pages$Enterprise$Dashboard$viewCreditCardRadioButton(m_method),
														cards))
												]))),
										A2(
										$elm$html$Html$div,
										_List_Nil,
										A3(
											canViewPaymentMethod,
											paymentMethodsAvailable,
											1,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$button,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('btn-ce btn-adicionar'),
															$elm$html$Html$Events$onClick($author$project$Pages$Enterprise$Dashboard$OpenAddCardModal)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Adicionar Cartão de Crédito')
														]))
												]))),
										function () {
										if (!m_method.$) {
											return A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('center-modal center-modal-bottom')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$button,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('action-system green-btn'),
																$elm$html$Html$Events$onClick($author$project$Pages$Enterprise$Dashboard$MakePayment)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Continuar')
															]))
													]));
										} else {
											return $elm$html$Html$text('');
										}
									}()
									]));
						}
					}())
				]));
	});
var $author$project$Pages$Enterprise$Dashboard$SubmittedDeleteList = {$: 35};
var $author$project$Pages$Enterprise$Dashboard$viewModalDeleteList = function (m) {
	return $author$project$Components$Patterns$Modal$simple(
		{
			hY: $elm$core$Maybe$Just(
				A2($elm$html$Html$Attributes$style, 'min-height', 'fit-content')),
			ii: '',
			il: '',
			ip: $author$project$Pages$Enterprise$Dashboard$CloseModal,
			fD: '',
			k4: A2(
				$elm$html$Html$article,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex flex-col gap-4')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('alerta')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$img,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$src('/images/alerta-ico.svg')
									]),
								_List_Nil),
								A2(
								$elm$html$Html$h2,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('txt-vermelho')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Atenção!')
									]))
							])),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('center-modal')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Você tem certeza que deseja cancelar esta importação?')
									])),
								$elm$html$Html$text('Esta ação não pode ser desfeita.')
							])),
						m.dP ? $author$project$Components$View$loading : A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex gap-4')
							]),
						_List_fromArray(
							[
								A4(
								$author$project$Components$Patterns$Button$text,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('w-full'),
										$elm$html$Html$Attributes$title('Realiza a exclusão do registro')
									]),
								'red-btn w-full',
								'Confirmar',
								$author$project$Pages$Enterprise$Dashboard$SubmittedDeleteList),
								A4(
								$author$project$Components$Patterns$Button$text,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('w-full'),
										$elm$html$Html$Attributes$title('Volta para a tela anterior e cancela a exclusão')
									]),
								'green-btn w-full',
								'Voltar',
								$author$project$Pages$Enterprise$Dashboard$CloseModal)
							]))
					])),
			k5: $elm$html$Html$text('')
		});
};
var $author$project$Pages$Enterprise$Dashboard$CloseAndFinish = {$: 30};
var $author$project$Pages$Enterprise$Dashboard$DownloadBankSlip = {$: 22};
var $author$project$Pages$Enterprise$Dashboard$viewModalFinishedBankSlip = function (model) {
	var totalValue = $author$project$Utils$formatMoneyInput(
		$elm$core$String$fromInt(
			$author$project$Pages$Enterprise$Dashboard$sumTotalValue(model)));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal-container modal-dashboard modal-comprar-creditos')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('header-modal')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Pagamento')
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('action-header'),
								$elm$html$Html$Events$onClick($author$project$Pages$Enterprise$Dashboard$CloseModal)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('fechar-ico')
									]),
								_List_Nil)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('modal-content center-modal')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h4,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('processo-info confirma-info')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Boleto Gerado com Sucesso!')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Boleto no valor de '),
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('R$ ' + totalValue)
									])),
								$elm$html$Html$text(' gerado com sucesso, faça download do arquivo ou imprima logo abaixo.'),
								A2($elm$html$Html$br, _List_Nil, _List_Nil),
								A2($elm$html$Html$br, _List_Nil, _List_Nil),
								$elm$html$Html$text('Obs: Após o pagamento o processamento pode levar até 40 horas, após processado a compra será efetuada')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('buttons')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('btn-ce btn-no-ico'),
										$elm$html$Html$Events$onClick($author$project$Pages$Enterprise$Dashboard$DownloadBankSlip)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Baixar PDF')
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('green-btn action-system'),
										$elm$html$Html$Events$onClick($author$project$Pages$Enterprise$Dashboard$CloseAndFinish)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Fechar')
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Enterprise$Dashboard$viewModalFinishedCard = function (model) {
	var viewIssTax = (model.d.nY > 0) ? _List_fromArray(
		[
			A2(
			$elm$html$Html$h4,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('cc-total no-select text-lg mb-2')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Valor bruto: '),
					A2(
					$elm$html$Html$strong,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							'R$ ' + $author$project$Utils$formatAsMoney(
								$elm$core$String$fromInt(model.d.i3)))
						]))
				])),
			A2(
			$elm$html$Html$h4,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('cc-total no-select text-lg mb-2')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Desconto ISS: '),
					A2(
					$elm$html$Html$strong,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							'R$ ' + $author$project$Utils$formatAsMoney(
								$elm$core$String$fromInt(model.d.nY)))
						]))
				])),
			A2(
			$elm$html$Html$h4,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('cc-total no-select')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Valor líquido: '),
					A2(
					$elm$html$Html$strong,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							'R$ ' + $author$project$Utils$formatAsMoney(
								$elm$core$String$fromInt(model.d.h2)))
						]))
				]))
		]) : _List_fromArray(
		[
			A2(
			$elm$html$Html$h4,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('cc-total no-select')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Valor: '),
					A2(
					$elm$html$Html$strong,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							'R$ ' + $author$project$Utils$formatMoneyInput(
								$elm$core$String$fromInt(
									$author$project$Pages$Enterprise$Dashboard$sumTotalValue(model))))
						]))
				]))
		]);
	var info = _List_fromArray(
		[
			A2(
			$elm$html$Html$h4,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('processo-info confirma-info')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Estamos processando seu pagamento!')
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Para usuários que utilizam o aplicativo os créditos já estão disponíveis           a partir deste momento. Caso precise de ajuda entre em contato através do           email: '),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href('mailto:sac@pazze.app')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('sac@pazze.app')
						]))
				]))
		]);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal-container modal-dashboard modal-comprar-creditos')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('header-modal')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Pagamento')
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('action-header'),
								$elm$html$Html$Events$onClick($author$project$Pages$Enterprise$Dashboard$CloseAndFinish)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('fechar-ico')
									]),
								_List_Nil)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('modal-content center-modal')
					]),
				_Utils_ap(
					info,
					_Utils_ap(
						viewIssTax,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('green-btn action-system'),
										$elm$html$Html$Events$onClick($author$project$Pages$Enterprise$Dashboard$CloseAndFinish)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Fechar')
									]))
							]))))
			]));
};
var $author$project$Pages$Enterprise$Dashboard$DownloadPaymentGuide = {$: 25};
var $author$project$Pages$Enterprise$Dashboard$viewModalFinishedPaymentGuide = function (model) {
	var totalValue = $author$project$Utils$formatMoneyInput(
		$elm$core$String$fromInt(
			$author$project$Pages$Enterprise$Dashboard$sumTotalValue(model)));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal-container modal-dashboard modal-comprar-creditos')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('header-modal')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Pagamento')
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('action-header'),
								$elm$html$Html$Events$onClick($author$project$Pages$Enterprise$Dashboard$CloseModal)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('fechar-ico')
									]),
								_List_Nil)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('modal-content center-modal')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h4,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('processo-info confirma-info')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Guia de Pagamento Gerada com Sucesso!')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Guia de Pagamento no valor de '),
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('R$ ' + totalValue)
									])),
								$elm$html$Html$text(' gerada com sucesso, faça download do arquivo ou imprima logo abaixo.'),
								A2($elm$html$Html$br, _List_Nil, _List_Nil),
								A2($elm$html$Html$br, _List_Nil, _List_Nil),
								$elm$html$Html$text('Obs: Após o pagamento o processamento pode levar até 40 horas, após processado a compra será efetuada')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('buttons')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('btn-ce btn-no-ico'),
										$elm$html$Html$Events$onClick($author$project$Pages$Enterprise$Dashboard$DownloadPaymentGuide)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Baixar PDF')
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('green-btn action-system'),
										$elm$html$Html$Events$onClick($author$project$Pages$Enterprise$Dashboard$CloseAndFinish)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Fechar')
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Enterprise$Dashboard$ClickedCopyPix = {$: 24};
var $author$project$Pages$Enterprise$Dashboard$viewModalFinishedPix = F2(
	function (model, pix) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('modal-container modal-dashboard modal-comprar-creditos')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('header-modal')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h3,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Pagamento')
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('action-header'),
									$elm$html$Html$Events$onClick($author$project$Pages$Enterprise$Dashboard$CloseModal)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fechar-ico')
										]),
									_List_Nil)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('modal-content center-modal')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('processo-info confirma-info')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('PIX Gerado com Sucesso!')
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Aponte seu smartphone para o QR Code abaixo ou copie a chave para o aplicativo do banco de sua preferência.')
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Obs: O processamento é instantâneo, mas pode variar de acordo com a sua instituição financeira.')
								])),
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pix-qrcode'),
									$elm$html$Html$Attributes$src(pix.pd)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('buttons')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('btn-ce btn-no-ico'),
											$elm$html$Html$Events$onClick($author$project$Pages$Enterprise$Dashboard$ClickedCopyPix)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Clique aqui para copiar a chave PIX')
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('green-btn action-system'),
											$elm$html$Html$Events$onClick($author$project$Pages$Enterprise$Dashboard$CloseAndFinish)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Fechar')
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Enterprise$Dashboard$ImportCsvReadContent = {$: 8};
var $author$project$Pages$Enterprise$Dashboard$SelectCsv = {$: 6};
var $elm$file$File$name = _File_name;
var $author$project$Pages$Enterprise$Dashboard$viewModalImportEmployeeCsv = function (model) {
	var m_file = function () {
		switch (model.$) {
			case 0:
				return $elm$core$Maybe$Nothing;
			case 1:
				var file = model.a;
				return $elm$core$Maybe$Just(file);
			default:
				var file = model.a;
				return $elm$core$Maybe$Just(file);
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal-container modal-dashboard modal-comprar-creditos')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('header-modal')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Importar Planilha')
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('action-header'),
								$elm$html$Html$Events$onClick($author$project$Pages$Enterprise$Dashboard$CloseModal)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('fechar-ico')
									]),
								_List_Nil)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('modal-content center-modal')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'font-size', '22px')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Para importar uma planilha dentro do'),
								A2($elm$html$Html$br, _List_Nil, _List_Nil),
								$elm$html$Html$text('sistema, é necessário que ela esteja de'),
								A2($elm$html$Html$br, _List_Nil, _List_Nil),
								$elm$html$Html$text('acordo com o modelo padrão.'),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('link')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href('/spreadsheets/planilha-exemplo.csv'),
												$elm$html$Html$Attributes$download('planilha-exemplo.csv')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Clique aqui para baixar um modelo de planilha')
											]))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$core$Maybe$withDefault,
								$elm$html$Html$text(''),
								A2(
									$elm$core$Maybe$map,
									function (file) {
										return A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$href('#')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$elm$file$File$name(file))
												]));
									},
									m_file))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mt-2 w-full')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$for('csv-fill'),
										$elm$html$Html$Attributes$class('btn-ce btn-no-ico cursor-pointer no-select'),
										$elm$html$Html$Events$onClick($author$project$Pages$Enterprise$Dashboard$SelectCsv)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										_Utils_eq(m_file, $elm$core$Maybe$Nothing) ? 'Selecionar Planilha' : 'Selecionar outra Planilha')
									]))
							]))
					])),
				function () {
				if (model.$ === 2) {
					return $author$project$Components$View$loading;
				} else {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('center-modal center-modal-bottom w-2/3')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('action-system green-btn'),
										A2($elm$html$Html$Attributes$style, 'width', '100%'),
										$elm$html$Html$Attributes$disabled(
										_Utils_eq(m_file, $elm$core$Maybe$Nothing)),
										$elm$html$Html$Events$onClick($author$project$Pages$Enterprise$Dashboard$ImportCsvReadContent)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Continuar')
									]))
							]));
				}
			}()
			]));
};
var $author$project$Pages$Enterprise$Dashboard$viewModalProcessingPayment = F2(
	function (model, method) {
		var totalValue = $author$project$Utils$formatMoneyInput(
			$elm$core$String$fromInt(
				$author$project$Pages$Enterprise$Dashboard$sumTotalValue(model)));
		var viewIssTax = (model.d.nY > 0) ? _List_fromArray(
			[
				A2(
				$elm$html$Html$h4,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('cc-total no-select text-lg mb-2')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Valor bruto: '),
						A2(
						$elm$html$Html$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								'R$ ' + $author$project$Utils$formatAsMoney(
									$elm$core$String$fromInt(model.d.i3)))
							]))
					])),
				A2(
				$elm$html$Html$h4,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('cc-total no-select text-lg mb-2')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Desconto ISS: '),
						A2(
						$elm$html$Html$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								'R$ ' + $author$project$Utils$formatAsMoney(
									$elm$core$String$fromInt(model.d.nY)))
							]))
					])),
				A2(
				$elm$html$Html$h4,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('cc-total no-select')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Valor líquido: '),
						A2(
						$elm$html$Html$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								'R$ ' + $author$project$Utils$formatAsMoney(
									$elm$core$String$fromInt(model.d.h2)))
							]))
					]))
			]) : _List_fromArray(
			[
				A2(
				$elm$html$Html$h4,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('cc-total no-select')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Valor: '),
						A2(
						$elm$html$Html$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('R$ ' + totalValue)
							]))
					]))
			]);
		var textProcessing = function () {
			switch (method.$) {
				case 3:
					var info = method.a;
					return {kK: 'Processando Pagamento...', ej: 'Pagamento utilizando cartão com final ' + info.c1};
				case 1:
					return {kK: 'Gerando PIX...', ej: 'Pagamento utilizando PIX'};
				case 0:
					return {kK: 'Gerando Boleto...', ej: 'Pagamento utilizando boleto bancário'};
				default:
					return {kK: 'Gerando Guia de Pagamento...', ej: 'Pagamento utilizando guia de pagamento'};
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('modal-container modal-dashboard modal-comprar-creditos')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('header-modal')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h3,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Pagamento')
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('action-header'),
									$elm$html$Html$Events$onClick($author$project$Pages$Enterprise$Dashboard$CloseModal)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fechar-ico')
										]),
									_List_Nil)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('modal-content center-modal')
						]),
					_Utils_ap(
						viewIssTax,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(textProcessing.ej)
									])),
								A2(
								$elm$html$Html$h4,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('processo-info processando-info')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(textProcessing.kK)
									]))
							])))
				]));
	});
var $author$project$Pages$Enterprise$Dashboard$ConfirmSaveList = {$: 34};
var $author$project$Pages$Enterprise$Dashboard$InputtedListOrderName = function (a) {
	return {$: 33, a: a};
};
var $author$project$Components$Patterns$Forms$inputWithLabel = function (options) {
	var maybeAttributeMsg = F2(
		function (attr, maybeMsg) {
			return A2(
				$elm$core$Maybe$withDefault,
				$elm$html$Html$Attributes$class(''),
				A2($elm$core$Maybe$map, attr, maybeMsg));
		});
	var label = A2(
		$elm$html$Html$h2,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('title-left mb-0 text-black')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(options.fD)
			]));
	return A2(
		$elm$html$Html$label,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mt-0 ' + options.ij)
			]),
		_List_fromArray(
			[
				label,
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(options.ih),
						A2($elm$html$Html$Attributes$style, 'margin-bottom', '1rem'),
						$elm$html$Html$Attributes$placeholder(options.hh),
						$elm$html$Html$Attributes$type_(options.kY),
						$elm$html$Html$Events$onInput(options.jI),
						$elm$html$Html$Attributes$value(options.di),
						A2(maybeAttributeMsg, $elm_community$html_extra$Html$Events$Extra$onEnter, options.ov)
					]),
				_List_Nil)
			]));
};
var $author$project$Pages$Enterprise$Dashboard$viewModalSaveList = function (m) {
	return $author$project$Components$Patterns$Modal$simple(
		{
			hY: $elm$core$Maybe$Just(
				A2($elm$html$Html$Attributes$style, 'min-height', 'fit-content')),
			ii: 'modal-dashboard-order',
			il: '',
			ip: $author$project$Pages$Enterprise$Dashboard$CloseModal,
			fD: 'Gravação de lista',
			k4: m.jr ? $author$project$Components$View$loading : A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-full')
					]),
				_List_fromArray(
					[
						$author$project$Components$Patterns$Forms$inputWithLabel(
						{
							ih: '',
							ij: 'mt-0 w-full',
							ov: $elm$core$Maybe$Just($author$project$Pages$Enterprise$Dashboard$ConfirmSaveList),
							jI: $author$project$Pages$Enterprise$Dashboard$InputtedListOrderName,
							hh: 'Informe o nome para lista',
							fD: 'Nome da lista',
							kY: 'input',
							di: m.c2
						})
					])),
			k5: m.jr ? $elm$html$Html$text('') : A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex gap-4')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('center-modal center-modal-bottom')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('action-system green-btn'),
										$elm$html$Html$Events$onClick($author$project$Pages$Enterprise$Dashboard$ConfirmSaveList),
										$elm$html$Html$Attributes$disabled(
										$elm$core$String$isEmpty(m.c2))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Gravar lista')
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('center-modal center-modal-bottom')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('action-system red-btn'),
										$elm$html$Html$Events$onClick($author$project$Pages$Enterprise$Dashboard$CloseModal)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Não gravar')
									]))
							]))
					]))
		});
};
var $author$project$Pages$Enterprise$Dashboard$viewPageModal = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal-overlay')
			]),
		_List_fromArray(
			[
				function () {
				var _v0 = model.aY;
				switch (_v0.$) {
					case 0:
						return $elm$html$Html$text('');
					case 1:
						var model_ = _v0.a;
						return $author$project$Pages$Enterprise$Dashboard$viewModalImportEmployeeCsv(model_);
					case 2:
						var model_ = _v0.a;
						return $author$project$Pages$Enterprise$Dashboard$viewModalAddCard(model_);
					case 3:
						var model_ = _v0.a;
						switch (model_.$) {
							case 0:
								return A3($author$project$Pages$Enterprise$Dashboard$viewModalBuyCreditsMethod, model, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
							case 1:
								var cards = model_.a;
								return A3(
									$author$project$Pages$Enterprise$Dashboard$viewModalBuyCreditsMethod,
									model,
									$elm$core$Maybe$Just(cards),
									$elm$core$Maybe$Nothing);
							case 2:
								var cards = model_.a;
								var method = model_.b;
								return A3(
									$author$project$Pages$Enterprise$Dashboard$viewModalBuyCreditsMethod,
									model,
									$elm$core$Maybe$Just(cards),
									$elm$core$Maybe$Just(method));
							case 3:
								var method = model_.b;
								return A2($author$project$Pages$Enterprise$Dashboard$viewModalProcessingPayment, model, method);
							case 4:
								return $author$project$Pages$Enterprise$Dashboard$viewModalFinishedCard(model);
							case 5:
								return $author$project$Pages$Enterprise$Dashboard$viewModalFinishedBankSlip(model);
							case 6:
								var pix = model_.a;
								return A2($author$project$Pages$Enterprise$Dashboard$viewModalFinishedPix, model, pix);
							default:
								return $author$project$Pages$Enterprise$Dashboard$viewModalFinishedPaymentGuide(model);
						}
					case 4:
						var m = _v0.a;
						return $author$project$Pages$Enterprise$Dashboard$viewModalSaveList(m);
					default:
						var m = _v0.a;
						return $author$project$Pages$Enterprise$Dashboard$viewModalDeleteList(m);
				}
			}()
			]));
};
var $author$project$Pages$Enterprise$Dashboard$view = F2(
	function (model, shared) {
		return _Utils_Tuple2(
			'Empresa - Dashboard',
			_List_fromArray(
				[
					A2($author$project$Pages$Enterprise$Dashboard$viewMainContainer, shared, model),
					(!_Utils_eq(model.aY, $author$project$Pages$Enterprise$Dashboard$None)) ? $author$project$Pages$Enterprise$Dashboard$viewPageModal(model) : $elm$html$Html$text('')
				]));
	});
var $author$project$Pages$Enterprise$HistoryDetails$ClickedBackHistory = {$: 2};
var $author$project$Pages$Enterprise$HistoryDetails$viewPurchaseRow = F2(
	function (timezone, purchase) {
		var strPaymentMethod = $author$project$Services$Models$paymentFormatToCode(
			function ($) {
				return $.jW;
			}(purchase));
		var strPaymentDate = A2(
			$elm$core$Basics$composeL,
			$elm$core$Maybe$withDefault(''),
			$elm$core$Maybe$map(
				$author$project$Utils$formatDateTimeFromPosix(timezone)));
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Basics$composeL,
								function ($) {
									return $.c3;
								},
								function ($) {
									return $.mj;
								})(purchase))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Utils$formatDateTimeFromPosix, timezone, purchase.ix))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							strPaymentDate(
								function ($) {
									return $.jV;
								}(purchase)))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(purchase.kK)
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(strPaymentMethod)
						]))
				]));
	});
var $author$project$Pages$Enterprise$HistoryDetails$viewPurchaseTable = F2(
	function (timezone, purchaseDetail) {
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'cellspacing', '0'),
					$elm$html$Html$Attributes$class('data-table-dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$thead,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Solicitante')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Criado em ')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Data Pagamento')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Status')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Tipo')
										]))
								]))
						])),
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Pages$Enterprise$HistoryDetails$viewPurchaseRow, timezone, purchaseDetail)
						]))
				]));
	});
var $author$project$Pages$Enterprise$HistoryDetails$viewRequesterRow = F2(
	function (timezone, requester) {
		var strAppliedDate = A2(
			$elm$core$Basics$composeL,
			$elm$core$Maybe$withDefault('Não aplicada'),
			$elm$core$Maybe$map(
				$author$project$Utils$formatDateTimeFromPosix(timezone)));
		var strAppliedBy = $elm$core$Maybe$withDefault('Não aplicada');
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							function ($) {
								return $.c3;
							}(requester))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$maskCPF(
								function ($) {
									return $.p$;
								}(requester)))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							function ($) {
								return $.lO;
							}(requester))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$formatAsMoney(
								$elm$core$String$fromInt(
									function ($) {
										return $.di;
									}(requester))))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$maybeEmptyStrDefault(
								A2($elm$core$Maybe$map, $elm$core$String$fromInt, requester.pn)))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							strAppliedDate(
								function ($) {
									return $.ls;
								}(requester)))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							strAppliedBy(
								function ($) {
									return $.lr;
								}(requester)))
						]))
				]));
	});
var $author$project$Pages$Enterprise$HistoryDetails$viewRequesterTable = F2(
	function (timezone, requesters) {
		return $elm$core$List$isEmpty(requesters) ? _List_fromArray(
			[
				$elm$html$Html$text('')
			]) : _List_fromArray(
			[
				A2(
				$elm$html$Html$h2,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'color', 'black'),
						$elm$html$Html$Attributes$class('inner-center')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Detalhes do solicitante')
					])),
				A2(
				$elm$html$Html$table,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'cellspacing', '0'),
						$elm$html$Html$Attributes$class('data-table-dashboard'),
						A2($elm$html$Html$Attributes$style, 'margin-bottom', '0')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$th,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Nome')
											])),
										A2(
										$elm$html$Html$th,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('CPF')
											])),
										A2(
										$elm$html$Html$th,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Cartão')
											])),
										A2(
										$elm$html$Html$th,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Valor da carga')
											])),
										A2(
										$elm$html$Html$th,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Lista de carga')
											])),
										A2(
										$elm$html$Html$th,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Data da aplicação')
											])),
										A2(
										$elm$html$Html$th,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Aplicado por')
											]))
									]))
							])),
						A2(
						$elm$html$Html$tbody,
						_List_Nil,
						A2(
							$elm$core$List$map,
							$author$project$Pages$Enterprise$HistoryDetails$viewRequesterRow(timezone),
							requesters))
					]))
			]);
	});
var $author$project$Pages$Enterprise$HistoryDetails$viewContentPage = F2(
	function (shared, purchase) {
		return _Utils_ap(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('header-history-details')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('voltar-ico-blue'),
									$elm$html$Html$Events$onClick($author$project$Pages$Enterprise$HistoryDetails$ClickedBackHistory)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$h2,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'color', 'black'),
									$elm$html$Html$Attributes$class('inner-center')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Detalhes do Pedido')
								]))
						])),
					A2($author$project$Pages$Enterprise$HistoryDetails$viewPurchaseTable, shared.kS, purchase)
				]),
			A2($author$project$Pages$Enterprise$HistoryDetails$viewRequesterTable, shared.kS, purchase.pp));
	});
var $author$project$Pages$Enterprise$HistoryDetails$viewPage = F3(
	function (maybePage, model, shared) {
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('top-actions ')
						]),
					_List_Nil),
					function () {
					var _v0 = model.fk;
					switch (_v0.$) {
						case 0:
							return $elm$html$Html$text('');
						case 1:
							return $author$project$Components$View$loading;
						case 2:
							return $elm$html$Html$text('');
						default:
							var purchase = _v0.a;
							return A2(
								$elm$html$Html$section,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mb-4')
									]),
								A2($author$project$Pages$Enterprise$HistoryDetails$viewContentPage, shared, purchase));
					}
				}()
				]));
	});
var $author$project$Pages$Enterprise$HistoryDetails$view = F3(
	function (maybePage, model, shared) {
		return _Utils_Tuple2(
			'Empresa - Detalhes do Pedido',
			A3($author$project$Pages$Enterprise$HistoryDetails$viewPage, maybePage, model, shared));
	});
var $author$project$Components$View$Button = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$View$InternalLink = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Enterprise$Register$PreviousStep = {$: 1};
var $elm$html$Html$Attributes$rel = _VirtualDom_attribute('rel');
var $author$project$Components$View$actionElement = function (action) {
	switch (action.$) {
		case 0:
			var route = action.a;
			return _Utils_Tuple2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$href(
						$author$project$Route$toString(route))
					]));
		case 1:
			var url = action.a;
			return _Utils_Tuple2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$target('_blank'),
						$elm$html$Html$Attributes$rel('noopener noreferrer'),
						$elm$html$Html$Attributes$href(url)
					]));
		default:
			var msg = action.a;
			return _Utils_Tuple2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(msg)
					]));
	}
};
var $author$project$Components$View$getConcessionaire = function (user) {
	var _v0 = A2(
		$elm$core$Basics$composeL,
		$elm$core$List$head,
		function ($) {
			return $.bR;
		})(user);
	if (!_v0.$) {
		var concessionaire = _v0.a;
		return concessionaire;
	} else {
		return {dM: '', c3: 'Concessionária não informada'};
	}
};
var $author$project$Components$View$getUserName = function ($) {
	return $.qx;
};
var $author$project$Components$View$cashierHeader = F3(
	function (maybeUser, leftActions, rightActions) {
		var viewActions = function (_v2) {
			var action = _v2.a;
			var children = _v2.b;
			var _v1 = $author$project$Components$View$actionElement(action);
			var elem = _v1.a;
			var attrs = _v1.b;
			return A2(
				elem,
				_Utils_ap(
					attrs,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('action-header')
						])),
				children);
		};
		return A2(
			$elm$html$Html$header,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('guiche')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('container ')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ico-action')
								]),
							A2($elm$core$List$map, viewActions, leftActions)),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('logo-img')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$alt('Pazze'),
											$elm$html$Html$Attributes$class('logo'),
											$elm$html$Html$Attributes$src('/images/logo-pazze.png')
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ico-action')
								]),
							A2($elm$core$List$map, viewActions, rightActions))
						])),
					function () {
					if (!maybeUser.$) {
						var user = maybeUser.a;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-col items-center text-white')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h2,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mb-0'),
											$elm$html$Html$Attributes$title(
											'Concessionária ' + function ($) {
												return $.c3;
											}(
												$author$project$Components$View$getConcessionaire(user)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											function ($) {
												return $.c3;
											}(
												$author$project$Components$View$getConcessionaire(user)))
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-center')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Components$View$getUserName(user))
										]))
								]));
					} else {
						return $elm$html$Html$text('');
					}
				}()
				]));
	});
var $author$project$Pages$Enterprise$Register$AddCompany = {$: 4};
var $author$project$Pages$Enterprise$Register$Address = 9;
var $author$project$Pages$Enterprise$Register$AddressComp = 11;
var $author$project$Pages$Enterprise$Register$AddressNumber = 10;
var $author$project$Pages$Enterprise$Register$Cep = 8;
var $author$project$Pages$Enterprise$Register$City = 13;
var $author$project$Pages$Enterprise$Register$Cnpj = 6;
var $author$project$Pages$Enterprise$Register$EnterpriseName = 7;
var $author$project$Pages$Enterprise$Register$Neighborhood = 12;
var $author$project$Pages$Enterprise$Register$State = 14;
var $author$project$Pages$Enterprise$Register$UpdateField = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Utils$brazilian_states = _List_fromArray(
	[
		_Utils_Tuple2('AC', 'Acre'),
		_Utils_Tuple2('AL', 'Alagoas'),
		_Utils_Tuple2('AP', 'Amapá'),
		_Utils_Tuple2('AM', 'Amazonas'),
		_Utils_Tuple2('BA', 'Bahia'),
		_Utils_Tuple2('CE', 'Ceará'),
		_Utils_Tuple2('DF', 'Distrito Federal'),
		_Utils_Tuple2('ES', 'Espírito Santo'),
		_Utils_Tuple2('GO', 'Goiás'),
		_Utils_Tuple2('MA', 'Maranhão'),
		_Utils_Tuple2('MT', 'Mato Grosso'),
		_Utils_Tuple2('MS', 'Mato Grosso do Sul'),
		_Utils_Tuple2('MG', 'Minas Gerais'),
		_Utils_Tuple2('PA', 'Pará'),
		_Utils_Tuple2('PB', 'Paraíba'),
		_Utils_Tuple2('PR', 'Paraná'),
		_Utils_Tuple2('PE', 'Pernambuco'),
		_Utils_Tuple2('PI', 'Piauí'),
		_Utils_Tuple2('RJ', 'Rio de Janeiro'),
		_Utils_Tuple2('RN', 'Rio Grande do Norte'),
		_Utils_Tuple2('RS', 'Rio Grande do Sul'),
		_Utils_Tuple2('RO', 'Rondônia'),
		_Utils_Tuple2('RR', 'Roraima'),
		_Utils_Tuple2('SC', 'Santa Catarina'),
		_Utils_Tuple2('SP', 'São Paulo'),
		_Utils_Tuple2('SE', 'Sergipe'),
		_Utils_Tuple2('TO', 'Tocantins')
	]);
var $author$project$Utils$maskPostalCode = $Massolari$elm_mask$Mask$number('#####-###');
var $author$project$Pages$Enterprise$Register$formEnterpriseInfo = function (model) {
	return A2(
		$elm$html$Html$main_,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$form,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('container cadastrar-empresa'),
						$elm$html$Html$Events$onSubmit($author$project$Pages$Enterprise$Register$AddCompany)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Cadastro de Nova Empresa')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('inner-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h2,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Dados da Empresa')
									])),
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Components$Input$input_(
										_Utils_update(
											$author$project$Components$Input$defaultOptions,
											{
												dM: $elm$core$Maybe$Just('cnpj'),
												jI: $elm$core$Maybe$Just(
													A2(
														$elm$core$Basics$composeL,
														$author$project$Pages$Enterprise$Register$UpdateField(6),
														$elm$core$String$filter($elm$core$Char$isDigit))),
												hh: 'CNPJ',
												di: $author$project$Utils$maskCNPJ(model.l3)
											}))
									])),
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Components$Input$input_(
										_Utils_update(
											$author$project$Components$Input$defaultOptions,
											{
												gU: 60,
												jI: $elm$core$Maybe$Just(
													$author$project$Pages$Enterprise$Register$UpdateField(7)),
												hh: 'Razão Social',
												di: model.cT
											}))
									])),
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Components$Input$input_(
										_Utils_update(
											$author$project$Components$Input$defaultOptions,
											{
												jI: $elm$core$Maybe$Just(
													A2(
														$elm$core$Basics$composeL,
														$author$project$Pages$Enterprise$Register$UpdateField(8),
														$elm$core$String$filter($elm$core$Char$isDigit))),
												hh: 'CEP',
												di: $author$project$Utils$maskPostalCode(model.bO)
											}))
									])),
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Components$Input$input_(
										_Utils_update(
											$author$project$Components$Input$defaultOptions,
											{
												jI: $elm$core$Maybe$Just(
													$author$project$Pages$Enterprise$Register$UpdateField(9)),
												hh: 'Endereço',
												di: model.ep
											}))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('inputs')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('numero')
											]),
										_List_fromArray(
											[
												$author$project$Components$Input$input_(
												_Utils_update(
													$author$project$Components$Input$defaultOptions,
													{
														jI: $elm$core$Maybe$Just(
															$author$project$Pages$Enterprise$Register$UpdateField(10)),
														hh: 'Número',
														di: model.bL
													}))
											])),
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Components$Input$input_(
												_Utils_update(
													$author$project$Components$Input$defaultOptions,
													{
														jI: $elm$core$Maybe$Just(
															$author$project$Pages$Enterprise$Register$UpdateField(11)),
														hh: 'Complemento',
														di: model.dn
													}))
											]))
									])),
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Components$Input$input_(
										_Utils_update(
											$author$project$Components$Input$defaultOptions,
											{
												jI: $elm$core$Maybe$Just(
													$author$project$Pages$Enterprise$Register$UpdateField(12)),
												hh: 'Bairro',
												di: model.om
											}))
									])),
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Components$Input$input_(
										_Utils_update(
											$author$project$Components$Input$defaultOptions,
											{
												jI: $elm$core$Maybe$Just(
													$author$project$Pages$Enterprise$Register$UpdateField(13)),
												hh: 'Cidade',
												di: model.lW
											}))
									])),
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Components$Patterns$Forms$selectWithError(
										{
											iH: false,
											jl: $elm$core$Maybe$Nothing,
											jn: _List_Nil,
											jI: $elm$core$Maybe$Just(
												$author$project$Pages$Enterprise$Register$UpdateField(14)),
											jO: A2(
												$elm$core$List$cons,
												{eX: model.fy === '', c3: 'Estado', di: ''},
												A2(
													$elm$core$List$map,
													function (_v0) {
														var sigla = _v0.a;
														var estado = _v0.b;
														return {
															eX: _Utils_eq(model.fy, sigla),
															c3: estado,
															di: sigla
														};
													},
													$author$project$Utils$brazilian_states)),
											jQ: false,
											ks: _List_Nil,
											kE: false,
											k1: _List_Nil
										})
									])),
								$krisajenkins$remotedata$RemoteData$isLoading(model.q) ? $author$project$Components$View$loading : A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('action-system green-btn')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Continuar')
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Enterprise$Register$Email = 1;
var $author$project$Pages$Enterprise$Register$Name = 0;
var $author$project$Pages$Enterprise$Register$Password = 4;
var $author$project$Pages$Enterprise$Register$PasswordConfirmation = 5;
var $author$project$Pages$Enterprise$Register$Phone = 3;
var $author$project$Pages$Enterprise$Register$PhoneAreaCode = 2;
var $author$project$Utils$maskPhone = $Massolari$elm_mask$Mask$number('# ####-####');
var $author$project$Pages$Enterprise$Register$formOwner = function (model) {
	var passwordMatch = (model.oN !== '') && _Utils_eq(model.oN, model.c6);
	var passwordClass = passwordMatch ? 'senha-confirmada' : '';
	return A2(
		$elm$html$Html$main_,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('container cadastrar-empresa')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Cadastro de Nova Empresa')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('inner-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h2,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Dados do Responsável')
									])),
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Components$Input$input_(
										_Utils_update(
											$author$project$Components$Input$defaultOptions,
											{
												fR: $elm$core$Maybe$Just('name'),
												fS: true,
												gU: 50,
												jI: $elm$core$Maybe$Just(
													$author$project$Pages$Enterprise$Register$UpdateField(0)),
												hh: 'Nome Completo',
												di: model.c3
											}))
									])),
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Components$Input$input_(
										_Utils_update(
											$author$project$Components$Input$defaultOptions,
											{
												fR: $elm$core$Maybe$Just('email'),
												gU: 50,
												jI: $elm$core$Maybe$Just(
													$author$project$Pages$Enterprise$Register$UpdateField(1)),
												hh: 'Email',
												di: model.mX
											}))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('inputs')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('numero')
											]),
										_List_fromArray(
											[
												$author$project$Components$Input$input_(
												_Utils_update(
													$author$project$Components$Input$defaultOptions,
													{
														fR: $elm$core$Maybe$Just('tel-area-code'),
														gU: 2,
														jI: $elm$core$Maybe$Just(
															A2(
																$elm$core$Basics$composeL,
																$author$project$Pages$Enterprise$Register$UpdateField(2),
																$elm$core$String$filter($elm$core$Char$isDigit))),
														hh: 'DDD',
														di: model.oV
													}))
											])),
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Components$Input$input_(
												_Utils_update(
													$author$project$Components$Input$defaultOptions,
													{
														fR: $elm$core$Maybe$Just('tel-local'),
														gU: 20,
														jI: $elm$core$Maybe$Just(
															A2(
																$elm$core$Basics$composeL,
																$author$project$Pages$Enterprise$Register$UpdateField(3),
																$elm$core$String$filter($elm$core$Char$isDigit))),
														hh: 'Telefone',
														di: $author$project$Utils$maskPhone(model.jX)
													}))
											]))
									])),
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Components$Input$input_(
										_Utils_update(
											$author$project$Components$Input$defaultOptions,
											{
												fR: $elm$core$Maybe$Just('new-password'),
												gH: _List_fromArray(
													[passwordClass]),
												gU: 20,
												jI: $elm$core$Maybe$Just(
													$author$project$Pages$Enterprise$Register$UpdateField(4)),
												hh: 'Senha',
												kY: 'password',
												di: model.oN
											}))
									])),
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Components$Input$input_(
										_Utils_update(
											$author$project$Components$Input$defaultOptions,
											{
												fR: $elm$core$Maybe$Just('new-password'),
												gH: _List_fromArray(
													[passwordClass]),
												gU: 20,
												jI: $elm$core$Maybe$Just(
													$author$project$Pages$Enterprise$Register$UpdateField(5)),
												hh: 'Confirmar Senha',
												kY: 'password',
												di: model.c6
											}))
									])),
								$krisajenkins$remotedata$RemoteData$isLoading(model.q) ? $author$project$Components$View$loading : A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('action-system green-btn'),
										$elm$html$Html$Events$onClick($author$project$Pages$Enterprise$Register$NextStep)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Continuar')
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Enterprise$Register$registerFinished = A2(
	$elm$html$Html$main_,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container cadastrar-empresa')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Cadastro de Nova Empresa')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('inner-container inner-center')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h2,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-centered')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Usuário cadastrado com sucesso')
								])),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('action-system green-btn'),
									$elm$html$Html$Attributes$href(
									$author$project$Route$toString($author$project$Route$Login))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Fazer Login')
								]))
						]))
				]))
		]));
var $author$project$Pages$Enterprise$Register$viewPage = F2(
	function (maybeUser, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('min-height-100')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Components$View$cashierHeader,
					maybeUser,
					(model.hG === 1) ? _List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Components$View$Button($author$project$Pages$Enterprise$Register$PreviousStep),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('voltar-ico')
										]),
									_List_Nil),
									$elm$html$Html$text('Voltar')
								]))
						]) : _List_Nil,
					(model.hG !== 2) ? _List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Components$View$InternalLink($author$project$Route$Login),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancelar Cadastro'),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fechar-ico')
										]),
									_List_Nil)
								]))
						]) : _List_Nil),
					function () {
					var _v0 = model.hG;
					switch (_v0) {
						case 0:
							return $author$project$Pages$Enterprise$Register$formOwner(model);
						case 1:
							return $author$project$Pages$Enterprise$Register$formEnterpriseInfo(model);
						default:
							return $author$project$Pages$Enterprise$Register$registerFinished;
					}
				}()
				]));
	});
var $author$project$Pages$Enterprise$Register$view = F3(
	function (user, model, _v0) {
		return _Utils_Tuple2(
			'Registrar empresa',
			A2($author$project$Pages$Enterprise$Register$viewPage, user, model));
	});
var $author$project$Pages$Garage$Dashboard$GoToHome = {$: 2};
var $author$project$Pages$Garage$Dashboard$ToggleTabView = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Garage$Dashboard$getConcessionaire = function (user) {
	var _v0 = A2(
		$elm$core$Basics$composeL,
		$elm$core$List$head,
		function ($) {
			return $.bR;
		})(user);
	if (!_v0.$) {
		var concessionaire = _v0.a;
		return concessionaire;
	} else {
		return {dM: '', c3: 'Concessionária não informada'};
	}
};
var $author$project$Pages$Garage$Dashboard$getUserName = function ($) {
	return $.qx;
};
var $author$project$Pages$Garage$Dashboard$OpenSessionVault = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Garage$Dashboard$sessionComponentCalculated = F2(
	function (timezone, sessionVault) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Utils$formatDateTime, timezone, sessionVault.ig))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(sessionVault.qx)
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Utils$formatDateTime, timezone, sessionVault.ga))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$toUpper(
								A2($elm$core$String$right, 4, sessionVault.dM)))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(sessionVault.fi)
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$formatAsMoney(
								$elm$core$String$fromInt(sessionVault.lo)))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('action-system'),
									$elm$html$Html$Attributes$class('green-btn'),
									$elm$html$Html$Events$onClick(
									$author$project$Pages$Garage$Dashboard$OpenSessionVault(sessionVault))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Detalhes')
								]))
						]))
				]));
	});
var $author$project$Pages$Garage$Dashboard$renderSessionsCalculated = F2(
	function (timezone, sessionVaultList) {
		return _List_fromArray(
			[
				function () {
				switch (sessionVaultList.$) {
					case 3:
						if (!sessionVaultList.a.b) {
							return A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Nenhum registro encontrado!')
									]));
						} else {
							var sessionVaultList_ = sessionVaultList.a;
							var vaultListOrdered = $elm$core$List$reverse(
								A2(
									$elm$core$List$sortBy,
									function ($) {
										return $.ig;
									},
									sessionVaultList_));
							return A2(
								$elm$html$Html$table,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'cellspacing', '0'),
										$elm$html$Html$Attributes$class('data-table-dashboard data-table-apuracoes')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$thead,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$tr,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$th,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Data Apuração')
															])),
														A2(
														$elm$html$Html$th,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Operador')
															])),
														A2(
														$elm$html$Html$th,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Data Criação')
															])),
														A2(
														$elm$html$Html$th,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Cód. Confirmação')
															])),
														A2(
														$elm$html$Html$th,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Malote')
															])),
														A2(
														$elm$html$Html$th,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Valor')
															]))
													]))
											])),
										A2(
										$elm$html$Html$tbody,
										_List_Nil,
										A2(
											$elm$core$List$map,
											$author$project$Pages$Garage$Dashboard$sessionComponentCalculated(timezone),
											vaultListOrdered))
									]));
						}
					case 0:
						return $elm$html$Html$text('Por favor, defina um período desejado ou utilize as datas padrão para realizar a busca.');
					case 1:
						return $author$project$Components$View$loading;
					default:
						var e = sessionVaultList.a;
						return A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Algo deu errado!')
								]));
				}
			}()
			]);
	});
var $author$project$Pages$Garage$Dashboard$sessionComponentToCalculated = F2(
	function (timezone, sessionVault) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(sessionVault.qx)
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Utils$formatDateTime, timezone, sessionVault.ga))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$toUpper(
								A2($elm$core$String$right, 4, sessionVault.dM)))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(sessionVault.fi)
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$formatAsMoney(
								$elm$core$String$fromInt(sessionVault.lo)))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('action-system'),
									$elm$html$Html$Attributes$class('green-btn'),
									$elm$html$Html$Events$onClick(
									$author$project$Pages$Garage$Dashboard$OpenSessionVault(sessionVault))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Detalhes')
								]))
						]))
				]));
	});
var $author$project$Pages$Garage$Dashboard$renderSessionsToCalculate = F2(
	function (timezone, sessionVaultList) {
		return _List_fromArray(
			[
				function () {
				switch (sessionVaultList.$) {
					case 3:
						if (!sessionVaultList.a.b) {
							return A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Nenhum registro encontrado!')
									]));
						} else {
							var sessionVaultList_ = sessionVaultList.a;
							var vaultListOrdered = $elm$core$List$reverse(
								A2(
									$elm$core$List$sortBy,
									function ($) {
										return $.ga;
									},
									sessionVaultList_));
							return A2(
								$elm$html$Html$table,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'cellspacing', '0'),
										$elm$html$Html$Attributes$class('data-table-dashboard data-table-apuracoes')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$thead,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$tr,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$th,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Operador')
															])),
														A2(
														$elm$html$Html$th,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Data')
															])),
														A2(
														$elm$html$Html$th,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Cód. Confirmação')
															])),
														A2(
														$elm$html$Html$th,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Malote')
															])),
														A2(
														$elm$html$Html$th,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Valor')
															]))
													]))
											])),
										A2(
										$elm$html$Html$tbody,
										_List_Nil,
										A2(
											$elm$core$List$map,
											$author$project$Pages$Garage$Dashboard$sessionComponentToCalculated(timezone),
											vaultListOrdered))
									]));
						}
					case 0:
						return $elm$html$Html$text('Por favor, defina um período desejado ou utilize as datas padrão para realizar a busca.');
					case 1:
						return $author$project$Components$View$loading;
					default:
						var e = sessionVaultList.a;
						return A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Algo deu errado!')
								]));
				}
			}()
			]);
	});
var $author$project$Pages$Garage$Dashboard$ExpandFilters = {$: 14};
var $author$project$Pages$Garage$Dashboard$InputtedEnd = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Garage$Dashboard$InputtedStart = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Garage$Dashboard$Submit = {$: 15};
var $author$project$Pages$Garage$Dashboard$SelectedOperator = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Garage$Dashboard$dynamicFilters = function (model) {
	var incUnique = F2(
		function (elem, lst) {
			var _v2 = A2(
				$elm$core$List$filter,
				function (x) {
					return _Utils_eq(x.a, elem.a);
				},
				lst);
			if (!_v2.b) {
				return A2($elm$core$List$cons, elem, lst);
			} else {
				return lst;
			}
		});
	var listSelectUser = function (reports) {
		return A3(
			$elm$core$List$foldl,
			incUnique,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (_v1) {
					var userName = _v1.qx;
					var userID = _v1.fL;
					return _Utils_Tuple2(userID, userName);
				},
				reports));
	};
	return A2(
		$elm$html$Html$article,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('filtros-container report-sales flex-col items-start')
			]),
		A2(
			$krisajenkins$remotedata$RemoteData$withDefault,
			_List_Nil,
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				function (reports) {
					return ((!model.dK) || $elm$core$List$isEmpty(reports)) ? _List_Nil : _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex gap-2 ')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h3,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-black font-bold')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Filtro dinâmico')
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('material-symbols-outlined cursor-help'),
											A2($elm$html$Html$Attributes$style, 'cursor', 'help'),
											$elm$html$Html$Attributes$title('Filtro de relatório relativo ao resultado atual'),
											$elm$html$Html$Attributes$alt('Filtro de relatório relativo ao resultado atual')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('info')
										]))
								])),
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$title('Esse filtro é aplicado apenas no resultado atual')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Operador'),
									$author$project$Components$Patterns$Forms$selectWithError(
									{
										iH: false,
										jl: $elm$core$Maybe$Nothing,
										jn: _List_Nil,
										jI: $elm$core$Maybe$Just($author$project$Pages$Garage$Dashboard$SelectedOperator),
										jO: A2(
											$elm$core$List$map,
											function (_v0) {
												var id = _v0.a;
												var name = _v0.b;
												return {
													eX: _Utils_eq(
														id,
														A2($elm$core$Maybe$withDefault, '', model.a5)),
													c3: name,
													di: id
												};
											},
											A2(
												$elm$core$List$cons,
												_Utils_Tuple2('', 'Todos'),
												listSelectUser(reports))),
										jQ: false,
										ks: _List_Nil,
										kE: false,
										k1: _List_Nil
									})
								]))
						]);
				},
				model.ar)));
};
var $author$project$Pages$Garage$Dashboard$viewFilter = function (model) {
	var queries = model.T;
	return A2(
		$elm$html$Html$form,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex-col'),
				$elm$html$Html$Events$onSubmit($author$project$Pages$Garage$Dashboard$Submit)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$article,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('filtros-container filtros-container-inputs')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Início'),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$value(
										A2($elm$core$Maybe$withDefault, '', queries.bB)),
										$elm$html$Html$Attributes$type_('date'),
										$elm$html$Html$Events$onInput($author$project$Pages$Garage$Dashboard$InputtedStart),
										A2($elm$html$Html$Attributes$style, 'margin-bottom', '1rem')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Fim'),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$value(
										A2($elm$core$Maybe$withDefault, '', queries.bl)),
										$elm$html$Html$Attributes$type_('date'),
										$elm$html$Html$Events$onInput($author$project$Pages$Garage$Dashboard$InputtedEnd),
										A2($elm$html$Html$Attributes$style, 'margin-bottom', '1rem')
									]),
								_List_Nil)
							])),
						A2(
						$author$project$Components$View$searchButton,
						'',
						$krisajenkins$remotedata$RemoteData$isLoading(model.ar)),
						A2(
						$krisajenkins$remotedata$RemoteData$withDefault,
						$elm$html$Html$text(''),
						A2(
							$krisajenkins$remotedata$RemoteData$map,
							function (reports) {
								return ($elm$core$String$isEmpty(
									A2($elm$core$Maybe$withDefault, '', model.a5)) && $elm$core$List$isEmpty(reports)) ? $elm$html$Html$text('') : A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('action-system green-btn min-btn-with-icon '),
													$elm$html$Html$Attributes$title('Filtro dinâmico'),
													$elm$html$Html$Attributes$type_('button'),
													$elm$html$Html$Events$onClick($author$project$Pages$Garage$Dashboard$ExpandFilters)
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('material-symbols-outlined align-middle ')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('filter_list')
														]))
												]))
										]));
							},
							model.ar))
					])),
				$author$project$Pages$Garage$Dashboard$dynamicFilters(model)
			]));
};
var $author$project$Pages$Garage$Dashboard$CloseModal = {$: 1};
var $elm$html$Html$b = _VirtualDom_node('b');
var $author$project$Components$Patterns$Tables$default = function (opts) {
	var cssTableDefaultPanel = opts.nX ? _List_fromArray(
		[
			$elm$html$Html$Attributes$class('overflow-x-auto'),
			A2($elm$html$Html$Attributes$style, 'width', 'calc(100vw - 23rem)')
		]) : _List_Nil;
	return A2(
		$elm$html$Html$div,
		cssTableDefaultPanel,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$table,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'cellspacing', '0'),
						$elm$html$Html$Attributes$class('data-table-dashboard my-4')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$tr,
								_List_Nil,
								A2(
									$elm$core$List$map,
									function (header) {
										return A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(header)
												]));
									},
									opts.nF))
							])),
						A2(
						$elm$html$Html$tbody,
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (record) {
								return A2($elm$html$Html$tr, _List_Nil, record);
							},
							opts.pj))
					]))
			]));
};
var $author$project$Pages$Garage$Dashboard$renderSessionsTags = F3(
	function (timezone, sessionVault, sessionVaultDetails) {
		switch (sessionVaultDetails.$) {
			case 3:
				var detail = sessionVaultDetails.a;
				var rowTd = function (txt) {
					return A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(txt)
							]));
				};
				var headers = _List_fromArray(
					['Veículo', 'Linha', 'Tarifa', 'Abertura', 'Fechamento', 'Cat.Ini', 'Cat.Fim', 'Total', 'GSL', 'Int. Temp.', 'Pagantes', 'Valor']);
				var getSpinsCount = F2(
					function (classId, spinsCounts) {
						return A2(
							$elm$core$Maybe$withDefault,
							0,
							$elm$core$List$head(
								A2(
									$elm$core$List$filterMap,
									function (sprint) {
										return _Utils_eq(sprint.lY, classId) ? $elm$core$Maybe$Just(sprint.iw) : $elm$core$Maybe$Nothing;
									},
									spinsCounts)));
					});
				var formatStringEmpty = function (v) {
					return $elm$core$String$isEmpty(v) ? '-' : v;
				};
				var rows = A2(
					$elm$core$List$map,
					function (line) {
						return _List_fromArray(
							[
								rowTd(
								A2($elm$core$Maybe$withDefault, '-', line.em)),
								rowTd(
								formatStringEmpty(line.e1)),
								rowTd(
								A2(
									$elm$core$Maybe$withDefault,
									'-',
									A2(
										$elm$core$Maybe$map,
										A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $author$project$Utils$formatAsMoney),
										line.ni))),
								rowTd(
								A2($author$project$Utils$formatDateTimeFromPosix, timezone, line.jL)),
								rowTd(
								A2($author$project$Utils$formatDateTimeFromPosix, timezone, line.l2)),
								rowTd(
								$elm$core$String$fromInt(line.oB)),
								rowTd(
								$elm$core$String$fromInt(line.l0)),
								rowTd(
								$elm$core$String$fromInt(
									A3(
										$elm$core$List$foldl,
										$elm$core$Basics$add,
										0,
										A2(
											$elm$core$List$map,
											function ($) {
												return $.iw;
											},
											line.kJ)))),
								rowTd(
								$elm$core$String$fromInt(
									A2(getSpinsCount, 254, line.kJ))),
								rowTd(
								$elm$core$String$fromInt(
									A2(getSpinsCount, 253, line.kJ))),
								rowTd(
								$elm$core$String$fromInt(
									A2(getSpinsCount, 255, line.kJ))),
								rowTd(
								$author$project$Utils$formatAsMoney(
									$elm$core$String$fromInt(line.h2)))
							]);
					},
					$elm$core$List$reverse(
						A2(
							$elm$core$List$sortBy,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.jL;
								},
								$elm$time$Time$posixToMillis),
							detail.n2)));
				var table = $author$project$Components$Patterns$Tables$default(
					{nF: headers, nX: false, pj: rows});
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'max-height', '35rem'),
							A2($elm$html$Html$Attributes$style, 'overflow', 'auto'),
							$elm$html$Html$Attributes$class('w-full')
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Operador(a): '),
									A2(
									$elm$html$Html$b,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(sessionVault.qx)
										]))
								])),
						_List_fromArray(
							[table])));
			case 1:
				return $author$project$Components$View$loading;
			default:
				return A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'color', 'red')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Erro ao carregar sessões.')
						]));
		}
	});
var $author$project$Pages$Garage$Dashboard$statusToPtStr = function (str) {
	switch (str) {
		case 'opened':
			return 'Em Aberto';
		case 'closed':
			return 'Fechado';
		default:
			return '';
	}
};
var $author$project$Pages$Garage$Dashboard$Confirm = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Garage$Dashboard$viewConfirmationButton = F3(
	function (label, sessionVault, confirmation) {
		if (confirmation.$ === 1) {
			return $author$project$Components$View$loading;
		} else {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex items-baseline gap-4')
					]),
				_List_fromArray(
					[
						function () {
						if (confirmation.$ === 2) {
							return $elm$html$Html$text('Houve um erro.');
						} else {
							return $elm$html$Html$text('');
						}
					}(),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('action-system green-btn'),
								$elm$html$Html$Events$onClick(
								$author$project$Pages$Garage$Dashboard$Confirm(sessionVault))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(label)
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('btn-ce btn-no-ico'),
								A2($elm$html$Html$Attributes$style, 'margin-bottom', '0'),
								$elm$html$Html$Events$onClick($author$project$Pages$Garage$Dashboard$CloseModal)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancelar')
							]))
					]));
		}
	});
var $author$project$Pages$Garage$Dashboard$modalConfirm = F4(
	function (timezone, model, sessionVault, hasDiff) {
		var updateDivergencyRes = function (divergencyRes) {
			return _Utils_update(
				sessionVault,
				{gj: divergencyRes});
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('modal-overlay')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('modal-container modal-dashboard modal-sessoes'),
							A2($elm$html$Html$Attributes$style, 'width', '90vw')
						]),
					$elm$core$List$concat(
						_List_fromArray(
							[
								_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('header-modal')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h3,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Sessões')
												])),
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('action-header')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('fechar-ico'),
															$elm$html$Html$Events$onClick($author$project$Pages$Garage$Dashboard$CloseModal)
														]),
													_List_Nil)
												]))
										])),
									A2(
									$elm$html$Html$h4,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('status-sessao')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Status: '),
											A2(
											$elm$html$Html$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Pages$Garage$Dashboard$statusToPtStr(sessionVault.kK))
												]))
										]))
								]),
								_List_fromArray(
								[
									A3($author$project$Pages$Garage$Dashboard$renderSessionsTags, timezone, sessionVault, model.bA)
								]),
								_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'width', '100%'),
											A2($elm$html$Html$Attributes$style, 'text-align', 'end'),
											A2($elm$html$Html$Attributes$style, 'font-size', 'larger')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Valor no Malote: '),
											A2(
											$elm$html$Html$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Utils$formatAsMoney(
														$elm$core$String$fromInt(sessionVault.lo)))
												]))
										]))
								]),
								hasDiff ? _List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Divergência: '),
											A2(
											$elm$html$Html$strong,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('txt-vermelho')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Utils$formatAsMoney(
														$elm$core$String$fromInt(sessionVault.gi)))
												]))
										])),
									A2(
									$elm$html$Html$textarea,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$placeholder('Descreva a resolução da divergência aqui'),
											$elm$html$Html$Events$onInput(
											A2($elm$core$Basics$composeL, $author$project$Pages$Garage$Dashboard$UpdateSessionVault, updateDivergencyRes)),
											$elm$html$Html$Attributes$value(sessionVault.gj)
										]),
									_List_Nil)
								]) : _List_Nil,
								_List_fromArray(
								[
									A3($author$project$Pages$Garage$Dashboard$viewConfirmationButton, 'Enviar Confirmação', sessionVault, model.bS)
								])
							])))
				]));
	});
var $author$project$Pages$Garage$Dashboard$defineConfirmModal = F2(
	function (timezone, model) {
		var _v0 = model.aI;
		if (!_v0.$) {
			var sessionVault = _v0.a;
			var hasDiff = false;
			return A4($author$project$Pages$Garage$Dashboard$modalConfirm, timezone, model, sessionVault, hasDiff);
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Pages$Garage$Dashboard$modalCalculateSession = F3(
	function (model, shared, inputToUpdate) {
		var _v0 = model.aI;
		if (!_v0.$) {
			var sessionVault = _v0.a;
			var updateDivergency = function (value) {
				var checkedAmount = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(value));
				return _Utils_update(
					sessionVault,
					{
						$8: checkedAmount,
						gi: checkedAmount - A2(
							$krisajenkins$remotedata$RemoteData$withDefault,
							0,
							A2(
								$krisajenkins$remotedata$RemoteData$map,
								function ($) {
									return $.lo;
								},
								model.bA))
					});
			};
			var sessionVaultInfo = _List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'width', '100%')
						]),
					inputToUpdate ? _List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'width', '100%'),
									A2($elm$html$Html$Attributes$style, 'text-align', 'end'),
									A2($elm$html$Html$Attributes$style, 'font-size', 'larger')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Valor Total das Sessões: '),
									A2(
									$elm$html$Html$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Utils$formatAsMoney(
												$elm$core$String$fromInt(sessionVault.lo)))
										]))
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('action-system green-btn'),
									A2($elm$html$Html$Attributes$style, 'margin', 'auto'),
									$elm$html$Html$Events$onClick($author$project$Pages$Garage$Dashboard$CloseModal)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Ok')
								]))
						]) : _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('alterar-sessao-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('red-btn'),
											$elm$html$Html$Events$onClick(
											$author$project$Pages$Garage$Dashboard$NextModal($elm$core$Maybe$Nothing))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Alterar')
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Divergência: '),
											A2(
											$elm$html$Html$strong,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('txt-vermelho')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Utils$formatAsMoney(
														$elm$core$String$fromInt(sessionVault.gi)))
												]))
										]))
								]))
						]))
				]);
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('modal-overlay')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('modal-container modal-dashboard modal-sessoes'),
								A2($elm$html$Html$Attributes$style, 'width', '90vw')
							]),
						$elm$core$List$concat(
							_List_fromArray(
								[
									_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('header-modal')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$h3,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Apuração')
													])),
												A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('action-header'),
														$elm$html$Html$Events$onClick($author$project$Pages$Garage$Dashboard$CloseModal)
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('fechar-ico')
															]),
														_List_Nil)
													]))
											])),
										A2(
										$elm$html$Html$h4,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('status-sessao')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Status: '),
												A2(
												$elm$html$Html$strong,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Pages$Garage$Dashboard$statusToPtStr(sessionVault.kK))
													]))
											]))
									]),
									A2(
									$elm$core$List$cons,
									A3($author$project$Pages$Garage$Dashboard$renderSessionsTags, shared.kS, sessionVault, model.bA),
									sessionVaultInfo)
								])))
					]));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Pages$Garage$Dashboard$modalFinish = F2(
	function (model, _v0) {
		var confirmationText = function () {
			var _v2 = model.aI;
			if (!_v2.$) {
				var sessionVault = _v2.a;
				var _v3 = sessionVault.kK;
				switch (_v3) {
					case 'opened':
						return 'Alteração de Apuração de caixa da sessão ' + (sessionVault.fi + ' enviada com sucesso!');
					case 'closed':
						return 'Apuração de caixa da sessão ' + (sessionVault.fi + ' enviada com sucesso!');
					default:
						return '';
				}
			} else {
				return '';
			}
		}();
		var _v1 = model.aI;
		if (!_v1.$) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('modal-overlay')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('modal-container sucesso-bg')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('header-modal')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('action-header')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('fechar-ico'),
														$elm$html$Html$Events$onClick($author$project$Pages$Garage$Dashboard$CloseModal)
													]),
												_List_Nil)
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('check-pagamento-realizado')
									]),
								_List_Nil),
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('sucesso-confirma')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(confirmationText)
											]))
									]))
							]))
					]));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Pages$Garage$Dashboard$viewModal = F2(
	function (model, shared) {
		var modalSteps = function () {
			var _v0 = model.T.kK;
			if (!_v0) {
				return $elm$core$Array$fromList(
					_List_fromArray(
						[
							A2($author$project$Pages$Garage$Dashboard$defineConfirmModal, shared.kS, model),
							A2($author$project$Pages$Garage$Dashboard$modalFinish, model, shared)
						]));
			} else {
				return $elm$core$Array$fromList(
					_List_fromArray(
						[
							A3($author$project$Pages$Garage$Dashboard$modalCalculateSession, model, shared, true),
							A2($author$project$Pages$Garage$Dashboard$modalFinish, model, shared)
						]));
			}
		}();
		var modal = A2(
			$elm$core$Maybe$withDefault,
			A3($author$project$Pages$Garage$Dashboard$modalCalculateSession, model, shared, true),
			A2($elm$core$Array$get, model.bs, modalSteps));
		return modal;
	});
var $author$project$Pages$Garage$Dashboard$viewPage = F3(
	function (user, model, shared) {
		var viewTypeOnCalculate = function (viewType) {
			if (!viewType) {
				return true;
			} else {
				return false;
			}
		};
		var rowFiltered = A2(
			$elm$core$Maybe$withDefault,
			model.ar,
			A2(
				$elm$core$Maybe$map,
				function (opID) {
					return A2(
						$krisajenkins$remotedata$RemoteData$map,
						function (rows) {
							return A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.fL;
									},
									$elm$core$Basics$eq(opID)),
								rows);
						},
						model.ar);
				},
				model.a5));
		var modal = model.e6 ? A2($author$project$Pages$Garage$Dashboard$viewModal, model, shared) : $elm$html$Html$text('');
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('wrapper')
				]),
			_List_fromArray(
				[
					modal,
					A2(
					$elm$html$Html$header,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('header-dashboard')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('logo-img')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$alt('Buzzao'),
											$elm$html$Html$Attributes$src('/images/logo-pazze.png'),
											$elm$html$Html$Events$onClick($author$project$Pages$Garage$Dashboard$GoToHome),
											A2($elm$html$Html$Attributes$style, 'cursor', 'pointer')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pt-4 flex flex-col items-center text-white')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h2,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('mb-0'),
													$elm$html$Html$Attributes$title(
													'Concessionária ' + function ($) {
														return $.c3;
													}(
														$author$project$Pages$Garage$Dashboard$getConcessionaire(user)))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													function ($) {
														return $.c3;
													}(
														$author$project$Pages$Garage$Dashboard$getConcessionaire(user)))
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-center')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Pages$Garage$Dashboard$getUserName(user))
												]))
										]))
								])),
							A2(
							$elm$html$Html$nav,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('menu')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$ul,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('justify-self-start ml-6')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$li,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('menu-item')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('apuracao-de-caixa'),
															$author$project$Route$href($author$project$Route$Guiche)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Guiche')
														]))
												]))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('complete-space')
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$main_,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('main-dashboard')
						]),
					$elm$core$List$concat(
						_List_fromArray(
							[
								_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('top-actions')
										]),
									_List_Nil)
								]),
								_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('filtros-apuracoes-container')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2('apuracoes', true),
															_Utils_Tuple2(
															'active',
															viewTypeOnCalculate(model.T.kK))
														])),
													$elm$html$Html$Events$onClick(
													$author$project$Pages$Garage$Dashboard$ToggleTabView(0))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Apurações em Aberto')
												])),
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2('apuracoes', true),
															_Utils_Tuple2(
															'active',
															!viewTypeOnCalculate(model.T.kK))
														])),
													$elm$html$Html$Events$onClick(
													$author$project$Pages$Garage$Dashboard$ToggleTabView(1))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Apurações Realizadas')
												]))
										])),
									$author$project$Pages$Garage$Dashboard$viewFilter(model)
								]),
								function () {
								var _v0 = model.T.kK;
								if (!_v0) {
									return A2($author$project$Pages$Garage$Dashboard$renderSessionsToCalculate, shared.kS, rowFiltered);
								} else {
									return A2($author$project$Pages$Garage$Dashboard$renderSessionsCalculated, shared.kS, rowFiltered);
								}
							}()
							])))
				]));
	});
var $author$project$Pages$Garage$Dashboard$view = F3(
	function (user, model, shared) {
		return _Utils_Tuple2(
			'Garagem - Dashboard',
			A3($author$project$Pages$Garage$Dashboard$viewPage, user, model, shared));
	});
var $author$project$Pages$Home$WelcomeBack$viewPage = function (user) {
	return A2(
		$elm$html$Html$main_,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('main-dashboard')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$section,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('h-screen flex flex-col items-center justify-center')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('my-4 text-purple-main text-5xl')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Bem-vindo de volta ' + user.qx)
							])),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-3xl')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('É ótimo tê-lo de volta à nossa plataforma.')
							]))
					]))
			]));
};
var $author$project$Pages$Home$WelcomeBack$view = F3(
	function (model, user, shared) {
		var viewModal = $elm$html$Html$text('');
		return _Utils_Tuple2(
			'Bem vindo de volta',
			_List_fromArray(
				[
					$author$project$Pages$Home$WelcomeBack$viewPage(user),
					viewModal
				]));
	});
var $author$project$Pages$Login$emailInfo = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('flex flex-col justify-center items-center h-96 forgot-password')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-white text-center pt-10')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Um email com instruções de como recuperar sua senha será enviado para:')
				])),
			A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-white text-center underline text-blue-400'),
					$elm$html$Html$Attributes$href('')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('administracao@sorrisodetoledo.com.br')
				])),
			A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('font-bold text-purple-main my-10 w-56 py-3 bg-teal-main rounded-3xl')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Enviar')
				]))
		]));
var $author$project$Pages$Login$InputEmail = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Login$InputPassword = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Login$formUser = function (model) {
	var buttonClass = ((model.oN === '') || (model.mX === '')) ? 'bg-teal-shade' : 'bg-teal-main';
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('w-full flex flex-col items-center p-5 px-20')
			]),
		$krisajenkins$remotedata$RemoteData$isLoading(model.q) ? _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[$author$project$Components$View$loading]))
			]) : _List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$placeholder('Email'),
								$elm$html$Html$Attributes$type_('text'),
								$elm$html$Html$Events$onInput($author$project$Pages$Login$InputEmail),
								$elm$html$Html$Attributes$autofocus(true)
							]),
						_List_Nil),
						$elm$html$Html$text('')
					])),
				A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$placeholder('Senha'),
								$elm$html$Html$Attributes$type_('password'),
								$elm$html$Html$Events$onInput($author$project$Pages$Login$InputPassword)
							]),
						_List_Nil),
						$elm$html$Html$text('')
					])),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('font-bold text-purple-main my-10 w-56 py-3 rounded-3xl ' + buttonClass),
						$elm$html$Html$Events$onClick($author$project$Pages$Login$SendLogin),
						$elm$html$Html$Attributes$disabled(
						$krisajenkins$remotedata$RemoteData$isSuccess(model.q))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Continuar')
					]))
			]));
};
var $author$project$Pages$Login$BackToLogin = {$: 7};
var $author$project$Pages$Login$SelectedConcessionaire = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Login$viewSelectConcessionaire = function (model) {
	var concessionairesSelectedId = A2(
		$elm$core$Maybe$map,
		function ($) {
			return $.dM;
		},
		model.dy);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('w-full flex flex-col  p-5 px-20 ')
			]),
		$krisajenkins$remotedata$RemoteData$isLoading(model.q) ? _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[$author$project$Components$View$loading]))
			]) : _List_fromArray(
			[
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('action-header'),
						$elm$html$Html$Events$onClick($author$project$Pages$Login$BackToLogin)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('voltar-ico')
							]),
						_List_Nil),
						$elm$html$Html$text('Voltar')
					])),
				A2(
				$elm$html$Html$section,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-full flex flex-col items-center text-center')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Selecione uma Concessionária'),
								$author$project$Components$Patterns$Forms$selectWithError(
								{
									iH: false,
									jl: $elm$core$Maybe$Nothing,
									jn: _List_Nil,
									jI: $elm$core$Maybe$Just($author$project$Pages$Login$SelectedConcessionaire),
									jO: A2(
										$elm$core$List$cons,
										{
											eX: _Utils_eq(concessionairesSelectedId, $elm$core$Maybe$Nothing),
											c3: 'Concessionárias disponíveis',
											di: ''
										},
										A2(
											$elm$core$List$map,
											function (c) {
												return {
													eX: _Utils_eq(
														concessionairesSelectedId,
														$elm$core$Maybe$Just(c.dM)),
													c3: c.c3,
													di: c.dM
												};
											},
											model.bR)),
									jQ: false,
									ks: _List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'width', '90%'),
											A2($elm$html$Html$Attributes$style, 'align-self', 'center'),
											A2($elm$html$Html$Attributes$style, 'margin-top', '1.5rem')
										]),
									kE: false,
									k1: _List_Nil
								})
							]))
					]))
			]));
};
var $author$project$Pages$Login$viewPage = F2(
	function (model, shared) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('w-full container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mx-auto md:w-3/4 sm:w-full flex flex-col justify-center items-center')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src('images/logo-pazze.png'),
									$elm$html$Html$Attributes$class('mt-12')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('m-5 text-teal-main font-bold text-xl my-10')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Login')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('rounded w-11/12 md:w-full border-solid border border-black login-box')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('flex flex-col items-center pt-10')
										]),
									_List_fromArray(
										[
											function () {
											if (model.dL) {
												return $author$project$Pages$Login$emailInfo;
											} else {
												var _v0 = model.ec;
												if (!_v0) {
													return $author$project$Pages$Login$formUser(model);
												} else {
													return $author$project$Pages$Login$viewSelectConcessionaire(model);
												}
											}
										}()
										]))
								])),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$author$project$Route$href($author$project$Route$RecoverPassword),
									$elm$html$Html$Attributes$class('underline text-white text-sm my-10'),
									A2($elm$html$Html$Attributes$style, 'background', 'transparent')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Esqueceu sua senha?')
								]))
						]))
				]));
	});
var $author$project$Pages$Login$view = F2(
	function (model, shared) {
		return _Utils_Tuple2(
			'Login',
			_List_fromArray(
				[
					A2($author$project$Pages$Login$viewPage, model, shared)
				]));
	});
var $author$project$Pages$NotFound$GoToHome = 0;
var $author$project$Pages$NotFound$viewPage = A2(
	$elm$html$Html$div,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$html$Html$section,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Ops! Algo de errado aconteceu! Você tentou acessar um recurso que não existe!')
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(0)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Ir para tela inicial')
								]))
						]))
				]))
		]));
var $author$project$Pages$NotFound$view = _Utils_Tuple2('Página não encontrada!', $author$project$Pages$NotFound$viewPage);
var $author$project$Pages$Order$Detail$CloseModal = {$: 5};
var $author$project$Pages$Order$Detail$ConfirmDeletion = {$: 3};
var $author$project$Pages$Order$Detail$viewConfirmRecordDeletion = function (orderUser) {
	return $author$project$Components$Patterns$Modal$simple(
		{
			hY: $elm$core$Maybe$Nothing,
			ii: 'modal-order-detail-edit min-h-0 pb-5 rounded-2xl gap-4 w-min',
			il: '',
			ip: $author$project$Pages$Order$Detail$CloseModal,
			fD: 'Confirmação de exclusão de registro do pedido',
			k4: A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-full')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mt-0')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(orderUser.qx)
							])),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-center')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Você tem certeza de que deseja excluir este usuário do pedido?')
							]))
					])),
			k5: A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex gap-4')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('center-modal center-modal-bottom')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('action-system red-btn'),
										$elm$html$Html$Events$onClick(
										$author$project$Pages$Order$Detail$ModalMsg($author$project$Pages$Order$Detail$ConfirmDeletion))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Sim, Excluir')
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('center-modal center-modal-bottom')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('action-system green-btn'),
										$elm$html$Html$Events$onClick($author$project$Pages$Order$Detail$CloseModal)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Cancelar')
									]))
							]))
					]))
		});
};
var $author$project$Pages$Order$Detail$InputtedAmountEdit = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Order$Detail$viewContentEdit = function (orderUser) {
	return $author$project$Components$Patterns$Modal$simple(
		{
			hY: $elm$core$Maybe$Nothing,
			ii: 'modal-order-detail-edit min-h-0 pb-5 rounded-2xl gap-4',
			il: '',
			ip: $author$project$Pages$Order$Detail$CloseModal,
			fD: 'Editar registro',
			k4: A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-full')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mt-0')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(orderUser.qx)
							])),
						$author$project$Components$Patterns$Forms$inputWithLabel(
						{
							ih: 'mt-0 w-full',
							ij: '',
							ov: $elm$core$Maybe$Just($author$project$Pages$Order$Detail$CloseModal),
							jI: A2($elm$core$Basics$composeR, $author$project$Pages$Order$Detail$InputtedAmountEdit, $author$project$Pages$Order$Detail$ModalMsg),
							hh: 'Valor',
							fD: 'Valor',
							kY: 'input',
							di: $author$project$Utils$formatMoneyInput(
								$elm$core$String$fromInt(orderUser.lo))
						})
					])),
			k5: A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex gap-4')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('center-modal center-modal-bottom')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('action-system green-btn'),
										$elm$html$Html$Events$onClick($author$project$Pages$Order$Detail$CloseModal)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Ok!')
									]))
							]))
					]))
		});
};
var $author$project$Pages$Order$Detail$ConfirmEditListName = {$: 2};
var $author$project$Pages$Order$Detail$InputtedListNameEdit = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Order$Detail$viewContentEditListName = function (order) {
	return $author$project$Components$Patterns$Modal$simple(
		{
			hY: $elm$core$Maybe$Nothing,
			ii: 'modal-order-detail-edit min-h-0 pb-5 rounded-2xl gap-4',
			il: '',
			ip: $author$project$Pages$Order$Detail$CloseModal,
			fD: 'Editar nome da lista',
			k4: A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-full')
					]),
				_List_fromArray(
					[
						$author$project$Components$Patterns$Forms$inputWithLabel(
						{
							ih: 'mt-0 w-full',
							ij: '',
							ov: $elm$core$Maybe$Just(
								$author$project$Pages$Order$Detail$ModalMsg($author$project$Pages$Order$Detail$ConfirmEditListName)),
							jI: A2($elm$core$Basics$composeR, $author$project$Pages$Order$Detail$InputtedListNameEdit, $author$project$Pages$Order$Detail$ModalMsg),
							hh: 'Nome da lista',
							fD: 'Nome da lista',
							kY: 'input',
							di: order.c3
						})
					])),
			k5: A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex gap-4')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('center-modal center-modal-bottom')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('action-system green-btn'),
										$elm$html$Html$Events$onClick(
										$author$project$Pages$Order$Detail$ModalMsg($author$project$Pages$Order$Detail$ConfirmEditListName))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Editar!')
									]))
							]))
					]))
		});
};
var $author$project$Pages$Order$Detail$ClickedFindUser = {$: 6};
var $author$project$Pages$Order$Detail$InputtedDocument = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Order$Detail$InputtedValue = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Order$Detail$SubmitCreateRecord = {$: 8};
var $author$project$Pages$Order$Detail$viewCreateRecord = function (model) {
	return $author$project$Components$Patterns$Modal$simple(
		{
			hY: $elm$core$Maybe$Nothing,
			ii: 'modal-order-detail-edit min-h-0 pb-5 rounded-2xl gap-4',
			il: '',
			ip: $author$project$Pages$Order$Detail$CloseModal,
			fD: 'Incluir passageiro',
			k4: A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-full')
					]),
				_List_fromArray(
					[
						function () {
						var _v0 = model.bF;
						switch (_v0.$) {
							case 3:
								var user_ = _v0.a;
								return A2(
									$elm$html$Html$h1,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mt-0')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											user_.c3 + (' - ' + $author$project$Utils$maskCPF(user_.iI)))
										]));
							case 1:
								return $author$project$Components$View$loading;
							default:
								return $elm$html$Html$text('');
						}
					}(),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex gap-4 items-center')
							]),
						_List_fromArray(
							[
								$author$project$Components$Patterns$Forms$inputWithLabel(
								{
									ih: 'mt-0 w-full',
									ij: 'w-full',
									ov: $elm$core$Maybe$Just(
										$author$project$Pages$Order$Detail$ModalMsg($author$project$Pages$Order$Detail$ClickedFindUser)),
									jI: A2($elm$core$Basics$composeR, $author$project$Pages$Order$Detail$InputtedDocument, $author$project$Pages$Order$Detail$ModalMsg),
									hh: 'Informe o CPF do usuário',
									fD: 'CPF',
									kY: 'input',
									di: $author$project$Utils$maskCPF(model.cZ)
								}),
								A4(
								$author$project$Components$Patterns$Button$icon,
								$author$project$Pages$Order$Detail$ModalMsg($author$project$Pages$Order$Detail$ClickedFindUser),
								'icon-search-config',
								'search',
								'Buscar registro')
							])),
						$author$project$Components$Patterns$Forms$inputWithLabel(
						{
							ih: 'mt-0 w-full',
							ij: 'w-full',
							ov: $elm$core$Maybe$Just(
								$author$project$Pages$Order$Detail$ModalMsg($author$project$Pages$Order$Detail$SubmitCreateRecord)),
							jI: A2($elm$core$Basics$composeR, $author$project$Pages$Order$Detail$InputtedValue, $author$project$Pages$Order$Detail$ModalMsg),
							hh: 'Informe o valor',
							fD: 'Valor',
							kY: 'input',
							di: $author$project$Utils$formatMoneyInput(
								$elm$core$String$fromInt(model.lo))
						})
					])),
			k5: A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex gap-4')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('center-modal center-modal-bottom')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('action-system green-btn'),
										$elm$html$Html$Events$onClick(
										$author$project$Pages$Order$Detail$ModalMsg($author$project$Pages$Order$Detail$SubmitCreateRecord)),
										$elm$html$Html$Attributes$disabled(
										(!$krisajenkins$remotedata$RemoteData$isSuccess(model.bF)) || (!model.lo))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Incluir passageiro')
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('center-modal center-modal-bottom')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('action-system white-btn mt-0'),
										$elm$html$Html$Events$onClick($author$project$Pages$Order$Detail$CloseModal)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Fechar')
									]))
							]))
					]))
		});
};
var $author$project$Pages$Order$Detail$viewModal = function (m) {
	if (!m.$) {
		switch (m.a.$) {
			case 1:
				var order = m.a.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('modal-overlay')
						]),
					_List_fromArray(
						[
							$author$project$Pages$Order$Detail$viewContentEditListName(order)
						]));
			case 0:
				var orderUser = m.a.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('modal-overlay')
						]),
					_List_fromArray(
						[
							$author$project$Pages$Order$Detail$viewContentEdit(orderUser)
						]));
			case 2:
				var orderUser = m.a.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('modal-overlay')
						]),
					_List_fromArray(
						[
							$author$project$Pages$Order$Detail$viewConfirmRecordDeletion(orderUser)
						]));
			default:
				var modal_ = m.a.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('modal-overlay')
						]),
					_List_fromArray(
						[
							$author$project$Pages$Order$Detail$viewCreateRecord(modal_)
						]));
		}
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Pages$Order$Detail$ClickedBackOrderLists = {$: 6};
var $author$project$Pages$Order$Detail$EditListName = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Order$Detail$ClickedCreateRecord = {$: 4};
var $author$project$Pages$Order$Detail$ClickedPurchaseOrder = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Order$Detail$SaveOrder = {$: 7};
var $author$project$Pages$Order$Detail$sumTotalValue = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$map(
		function ($) {
			return $.lo;
		}),
	$elm$core$List$sum);
var $author$project$Pages$Order$Detail$viewFooter = F3(
	function (user, model, order) {
		var viewActions = _Utils_eq(model.x, model.dD) ? A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('green-btn action-system'),
					$elm$html$Html$Events$onClick(
					$author$project$Pages$Order$Detail$ClickedPurchaseOrder(order.dM))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Gerar pedido')
				])) : A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('green-btn action-system'),
					$elm$html$Html$Events$onClick($author$project$Pages$Order$Detail$SaveOrder)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Salvar pedido')
				]));
		var viewValues = function () {
			if (_Utils_eq(model.x, model.dD)) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex gap-4 mr-10')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('self-center mr-0')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Valor Bruto: '),
									A2(
									$elm$html$Html$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											'R$ ' + $author$project$Utils$formatMoneyInput(
												$elm$core$String$fromInt(order.i3)))
										]))
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('self-center mr-0')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Desconto ISS: '),
									A2(
									$elm$html$Html$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											'R$ ' + $author$project$Utils$formatMoneyInput(
												$elm$core$String$fromInt(order.e_)))
										]))
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('total  self-center mr-0')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Valor líquido: '),
									A2(
									$elm$html$Html$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											'R$ ' + $author$project$Utils$formatMoneyInput(
												$elm$core$String$fromInt(order.qd)))
										]))
								])),
							viewActions
						]));
			} else {
				var grossBalance = $author$project$Pages$Order$Detail$sumTotalValue(order.F);
				var percentValue = grossBalance * (A2($elm$core$Maybe$withDefault, 0, user.p0) / 100);
				var totalBalance = grossBalance - percentValue;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex self-center gap-4 mr-10')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('self-center mr-0')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$strong,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-purple-main font-bold')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Ao salvar, os valores serão calculados.')
										]))
								])),
							viewActions
						]));
			}
		}();
		var hasIss = order.e_ > 0;
		var viewIss = hasIss ? viewValues : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex gap-4 mr-10')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('total  self-center mr-0')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Valor: '),
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									'R$ ' + $author$project$Utils$formatMoneyInput(
										$elm$core$String$fromInt(
											$author$project$Pages$Order$Detail$sumTotalValue(order.F))))
								]))
						])),
					viewActions
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bottom-actions flex justify-between')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('selecionados')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('btn-ce btn-adicionar cursor-pointer no-select'),
									$elm$html$Html$Events$onClick($author$project$Pages$Order$Detail$ClickedCreateRecord)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Incluir passageiro')
								]))
						])),
					viewIss
				]));
	});
var $author$project$Components$Patterns$Tables$headerAndRecordsCustomizable = function (opts) {
	var cssTableDefaultPanel = opts.nX ? _List_fromArray(
		[
			$elm$html$Html$Attributes$class('overflow-x-auto'),
			A2($elm$html$Html$Attributes$style, 'width', 'calc(100vw - 23rem)')
		]) : _List_Nil;
	return A2(
		$elm$html$Html$div,
		cssTableDefaultPanel,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$table,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'cellspacing', '0'),
						$elm$html$Html$Attributes$class('data-table-dashboard my-4')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$tr,
								_List_Nil,
								A2(
									$elm$core$List$map,
									function (header) {
										return header;
									},
									opts.nF))
							])),
						A2(
						$elm$html$Html$tbody,
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (record) {
								return A2($elm$html$Html$tr, _List_Nil, record);
							},
							opts.pj))
					]))
			]));
};
var $author$project$Pages$Order$Detail$isDisplayExtraInfoDigitalCard = function (orderUsers) {
	return A2(
		$elm$core$List$member,
		true,
		A2(
			$elm$core$List$map,
			function (_v0) {
				var extraInfo = _v0.cV;
				return A2(
					$elm$core$List$any,
					function ($) {
						return $.qE;
					},
					extraInfo);
			},
			orderUsers));
};
var $author$project$Pages$Order$Detail$isDisplayExtraInfoPhysicalCard = function (orderUsers) {
	return A2(
		$elm$core$List$member,
		true,
		A2(
			$elm$core$List$map,
			function (_v0) {
				var extraInfo = _v0.cV;
				return A2(
					$elm$core$List$any,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.qE;
						},
						$elm$core$Basics$eq(false)),
					extraInfo);
			},
			orderUsers));
};
var $author$project$Pages$Order$Detail$isNotAccessExtraInfo = function (orderUsers) {
	return $elm$core$List$isEmpty(
		A2(
			$elm$core$List$map,
			function ($) {
				return $.cV;
			},
			orderUsers));
};
var $author$project$Pages$Order$Detail$DeleteRecord = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Order$Detail$EditRecord = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Order$Detail$viewCellCardInRecord = F2(
	function (isDisplayCardDivisionBorder, card) {
		var viewStyleCardDivisionBorder = isDisplayCardDivisionBorder ? $elm$html$Html$Attributes$class('border-solid border-l-4 border-purple-main') : $elm$html$Html$Attributes$class('');
		var maybeMoneyOfExtraInfo = function (key) {
			return A2(
				$elm$core$Basics$composeR,
				key,
				A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $author$project$Utils$formatAsMoney))(card);
		};
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[viewStyleCardDivisionBorder]),
				_List_fromArray(
					[
						$elm$html$Html$text(card.kw)
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						maybeMoneyOfExtraInfo(
							function ($) {
								return $.h2;
							}))
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						maybeMoneyOfExtraInfo(
							function ($) {
								return $.qf;
							}))
					]))
			]);
	});
var $author$project$Pages$Order$Detail$viewCellEmptyCardInRecord = function (isDisplayCardDivisionBorder) {
	var viewStyleCardDivisionBorder = isDisplayCardDivisionBorder ? $elm$html$Html$Attributes$class('border-solid border-l-4 border-purple-main') : $elm$html$Html$Attributes$class('');
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$td,
			_List_fromArray(
				[viewStyleCardDivisionBorder]),
			_List_fromArray(
				[
					$elm$html$Html$text('-')
				])),
			A2(
			$elm$html$Html$td,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('-')
				])),
			A2(
			$elm$html$Html$td,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('-')
				]))
		]);
};
var $author$project$Pages$Order$Detail$viewRecord = F4(
	function (isDisplayExtraInfoPhysicalCard_, isDisplayExtraInfoDigitalCard_, timezone, record) {
		var withDefaultCellCardInRecord = F2(
			function (isDisplay, isDisplayCardDivisionBorder_) {
				return isDisplay ? $elm$core$Maybe$withDefault(
					$author$project$Pages$Order$Detail$viewCellEmptyCardInRecord(isDisplayCardDivisionBorder_)) : $elm$core$Maybe$withDefault(_List_Nil);
			});
		var virtualCard = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (_v1) {
					var virtual = _v1.qE;
					return virtual;
				},
				record.cV));
		var physicalCard = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (_v0) {
					var virtual = _v0.qE;
					return !virtual;
				},
				record.cV));
		var isDisplayCardDivisionBorder = isDisplayExtraInfoPhysicalCard_ && isDisplayExtraInfoDigitalCard_;
		return $elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(record.qx)
							]))
					]),
					A3(
					withDefaultCellCardInRecord,
					isDisplayExtraInfoPhysicalCard_,
					false,
					A2(
						$elm$core$Maybe$map,
						$author$project$Pages$Order$Detail$viewCellCardInRecord(false),
						physicalCard)),
					A3(
					withDefaultCellCardInRecord,
					isDisplayExtraInfoDigitalCard_,
					isDisplayCardDivisionBorder,
					A2(
						$elm$core$Maybe$map,
						$author$project$Pages$Order$Detail$viewCellCardInRecord(isDisplayCardDivisionBorder),
						virtualCard)),
					_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Utils$formatAsMoney(
									$elm$core$String$fromInt(record.lo)))
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex gap-2 justify-center')
							]),
						_List_fromArray(
							[
								A4(
								$author$project$Components$Patterns$Button$icon,
								$author$project$Pages$Order$Detail$EditRecord(record),
								'icon-edit-config',
								'edit',
								'Editar registro'),
								A4(
								$author$project$Components$Patterns$Button$icon,
								$author$project$Pages$Order$Detail$DeleteRecord(record),
								'icon-edit-config red-btn',
								'delete_forever',
								'Apagar registro')
							]))
					])
				]));
	});
var $author$project$Pages$Order$Detail$viewTable = F2(
	function (timezone, order) {
		var isNotAccessExtraInfo_ = $author$project$Pages$Order$Detail$isNotAccessExtraInfo(order.F);
		var isDisplayExtraInfoPhysicalCard_ = $author$project$Pages$Order$Detail$isDisplayExtraInfoPhysicalCard(order.F);
		var isDisplayExtraInfoDigitalCard_ = $author$project$Pages$Order$Detail$isDisplayExtraInfoDigitalCard(order.F);
		var viewRecords = A2(
			$elm$core$List$map,
			A3($author$project$Pages$Order$Detail$viewRecord, isDisplayExtraInfoPhysicalCard_, isDisplayExtraInfoDigitalCard_, timezone),
			order.F);
		var viewStyleCardDivisionBorder = (isDisplayExtraInfoPhysicalCard_ && isDisplayExtraInfoDigitalCard_) ? $elm$html$Html$Attributes$class('border-solid border-l-4 border-purple-main') : $elm$html$Html$Attributes$class('');
		var herdersPhysicalCard = isNotAccessExtraInfo_ ? _List_Nil : (isDisplayExtraInfoPhysicalCard_ ? _List_fromArray(
			[
				A2(
				$elm$html$Html$th,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Serial')
					])),
				A2(
				$elm$html$Html$th,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Saldo')
					])),
				A2(
				$elm$html$Html$th,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Cargas')
					]))
			]) : _List_Nil);
		var herdersDigitalCard = isNotAccessExtraInfo_ ? _List_Nil : (isDisplayExtraInfoDigitalCard_ ? _List_fromArray(
			[
				A2(
				$elm$html$Html$th,
				_List_fromArray(
					[viewStyleCardDivisionBorder]),
				_List_fromArray(
					[
						$elm$html$Html$text('Serial')
					])),
				A2(
				$elm$html$Html$th,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Saldo')
					])),
				A2(
				$elm$html$Html$th,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Cargas')
					]))
			]) : _List_Nil);
		var headers = A2(
			$elm$core$List$cons,
			A2(
				$elm$html$Html$th,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Nome')
					])),
			_Utils_ap(
				herdersPhysicalCard,
				_Utils_ap(
					herdersDigitalCard,
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$th,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Valor')
								])),
						A2(
							$elm$core$List$cons,
							A2(
								$elm$html$Html$th,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('')
									])),
							_List_Nil)))));
		return $author$project$Components$Patterns$Tables$headerAndRecordsCustomizable(
			{nF: headers, nX: true, pj: viewRecords});
	});
var $author$project$Pages$Order$Detail$viewPage = F3(
	function (model, shared, user) {
		var viewIconEdit = A2(
			$krisajenkins$remotedata$RemoteData$withDefault,
			$elm$html$Html$text(''),
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				function (order_) {
					return A4(
						$author$project$Components$Patterns$Button$icon,
						$author$project$Pages$Order$Detail$EditListName(
							{c3: order_.c3}),
						'icon-edit-config m-0 flex justify-center items-center',
						'edit',
						'Editar registro');
				},
				model.x));
		var listName = A2(
			$krisajenkins$remotedata$RemoteData$withDefault,
			'',
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				function ($) {
					return $.c3;
				},
				model.x));
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('top-actions')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('voltar-ico-blue'),
									$elm$html$Html$Attributes$title('Lista de pedidos'),
									$elm$html$Html$Events$onClick($author$project$Pages$Order$Detail$ClickedBackOrderLists)
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'color', 'black'),
							$elm$html$Html$Attributes$class('inner-center flex-row justify-center gap-4')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Gerar pedido - ' + listName),
							viewIconEdit
						])),
					function () {
					var _v0 = model.x;
					switch (_v0.$) {
						case 0:
							return $elm$html$Html$text('');
						case 1:
							return $author$project$Components$View$loading;
						case 2:
							var err = _v0.a;
							return $elm$html$Html$text(err);
						default:
							var order = _v0.a;
							return A2(
								$elm$html$Html$section,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$Pages$Order$Detail$viewTable, shared.kS, order),
										A3($author$project$Pages$Order$Detail$viewFooter, user, model, order)
									]));
					}
				}()
				]));
	});
var $author$project$Pages$Order$Detail$view = F3(
	function (model, shared, user) {
		var listName = A2(
			$krisajenkins$remotedata$RemoteData$withDefault,
			'',
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				function ($) {
					return $.c3;
				},
				model.x));
		return _Utils_Tuple2(
			'Gerar pedido - ' + listName,
			_List_fromArray(
				[
					A3($author$project$Pages$Order$Detail$viewPage, model, shared, user),
					$author$project$Pages$Order$Detail$viewModal(model.aY)
				]));
	});
var $author$project$Components$Patterns$Tables$defaultClickable = function (opts) {
	var cssTableDefaultPanel = opts.nX ? _List_fromArray(
		[
			$elm$html$Html$Attributes$class('overflow-x-auto'),
			A2($elm$html$Html$Attributes$style, 'width', 'calc(100vw - 23rem)')
		]) : _List_Nil;
	return A2(
		$elm$html$Html$div,
		cssTableDefaultPanel,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$table,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'cellspacing', '0'),
						$elm$html$Html$Attributes$class('data-table-dashboard my-4')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$tr,
								_List_Nil,
								A2(
									$elm$core$List$map,
									function (header) {
										return A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(header)
												]));
									},
									opts.nF))
							])),
						A2(
						$elm$html$Html$tbody,
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (record) {
								return A2(
									$elm$html$Html$tr,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('hover:bg-gray-tint1 cursor-pointer')
										]),
									record);
							},
							opts.pj))
					]))
			]));
};
var $author$project$Pages$Order$Lists$ClickedOpenOrder = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Order$Lists$viewRecord = F2(
	function (timezone, record) {
		var onClick = $elm$html$Html$Events$onClick(
			$author$project$Pages$Order$Lists$ClickedOpenOrder(record.dM));
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[onClick]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($author$project$Utils$formatDateTimeFromPosix, timezone, record.qs))
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[onClick]),
				_List_fromArray(
					[
						$elm$html$Html$text(record.c3)
					]))
			]);
	});
var $author$project$Pages$Order$Lists$viewTable = F2(
	function (timezone, ordersSummarized) {
		var viewRecords = A2(
			$elm$core$List$map,
			$author$project$Pages$Order$Lists$viewRecord(timezone),
			A2(
				$elm$core$List$sortBy,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.qs;
					},
					$author$project$Utils$formatDateTimeFromPosix(timezone)),
				ordersSummarized));
		var headers = _List_fromArray(
			['Atualizada em', 'Nome']);
		return $author$project$Components$Patterns$Tables$defaultClickable(
			{nF: headers, nX: true, pj: viewRecords});
	});
var $author$project$Pages$Order$Lists$viewPage = F3(
	function (model, shared, user) {
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('top-actions')
						]),
					_List_fromArray(
						[
							A2($elm$html$Html$div, _List_Nil, _List_Nil),
							A2($elm$html$Html$div, _List_Nil, _List_Nil)
						])),
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'color', 'black'),
							$elm$html$Html$Attributes$class('inner-center')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Listas de pedidos gravadas')
						])),
					function () {
					var _v0 = model.fd;
					switch (_v0.$) {
						case 0:
							return $elm$html$Html$text('');
						case 1:
							return $author$project$Components$View$loading;
						case 2:
							var err = _v0.a;
							return $elm$html$Html$text(err);
						default:
							if (!_v0.a.b) {
								return $elm$html$Html$text('Nenhuma lista de pedido encontrado.');
							} else {
								var ordersSummarized = _v0.a;
								return A2($author$project$Pages$Order$Lists$viewTable, shared.kS, ordersSummarized);
							}
					}
				}()
				]));
	});
var $author$project$Pages$Order$Lists$view = F3(
	function (model, shared, user) {
		return _Utils_Tuple2(
			'Listas de pedidos gravadas',
			_List_fromArray(
				[
					A3($author$project$Pages$Order$Lists$viewPage, model, shared, user),
					$elm$html$Html$text('')
				]));
	});
var $author$project$Components$Schedule$ClickedAmountType = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Schedule$CloseModal = {$: 13};
var $author$project$Components$Schedule$InputtedAmount = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Patterns$Forms$Radio = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Schedule$SubmitCreateNewPeriod = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Schedule$typesAmount = _List_fromArray(
	[
		_Utils_Tuple2('percent', 'Porcentagem'),
		_Utils_Tuple2('value', 'Valor')
	]);
var $author$project$Components$Schedule$viewModalCreateNewPeriod = F2(
	function (modal, m) {
		var labelSelect = function (_v1) {
			var i = _v1.a;
			var v = _v1.b;
			return (i === 'value') ? $author$project$Utils$formatAsMoney(
				$elm$core$String$fromInt(v)) : ($elm$core$String$fromInt(v) + '%');
		};
		var info = (modal.ah === 'percent') ? _List_fromArray(
			[
				A2(
				$elm$html$Html$em,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-black')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Pode ser de 0% até 200%')
					]))
			]) : ((modal.ah === 'value') ? _List_fromArray(
			[
				A2(
				$elm$html$Html$em,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-black')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Pode ser de R$ 0 até R$ 40')
					]))
			]) : _List_Nil);
		var formatValue = function (v) {
			return (modal.ah === 'percent') ? v : ((modal.ah === 'value') ? $author$project$Utils$formatMoneyInput(v) : v);
		};
		return $author$project$Components$Patterns$Modal$simple(
			{
				hY: $elm$core$Maybe$Just(
					A2($elm$html$Html$Attributes$style, 'min-height', 'fit-content')),
				ii: 'modal-cadastro-usuario-sistema gap-4 p-8 w-fit',
				il: 'truncate ',
				ip: $author$project$Components$Schedule$CloseModal,
				fD: 'Criar novo período',
				k4: A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-full px-20 ')
						]),
					_List_fromArray(
						[
							$author$project$Components$Patterns$Forms$formSimple(
							{
								hZ: _List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex flex-col gap-4')
									]),
								L: modal.L,
								jf: _List_fromArray(
									[
										$author$project$Components$Patterns$Forms$Radio(
										{
											i5: 'amount-type',
											jm: _List_fromArray(
												[
													$elm$html$Html$Attributes$class('m-0')
												]),
											jG: $author$project$Components$Schedule$ClickedAmountType,
											jO: A2(
												$elm$core$List$map,
												function (_v0) {
													var k = _v0.a;
													var v = _v0.b;
													return {
														ie: _Utils_eq(modal.ah, k),
														iH: modal.L === 2,
														dM: k,
														c3: v
													};
												},
												$author$project$Components$Schedule$typesAmount),
											jP: _List_fromArray(
												[
													$elm$html$Html$Attributes$class('flex gap-4 justify-center')
												]),
											fD: $elm$core$Maybe$Nothing
										}),
										$author$project$Components$Patterns$Forms$Input(
										{
											ie: $elm$core$Maybe$Nothing,
											iH: false,
											iP: info,
											nR: _List_fromArray(
												[
													$elm$html$Html$Attributes$class('flex flex-col w-full')
												]),
											jl: A2(
												$elm$core$Maybe$map,
												$elm$core$Tuple$second,
												$elm$core$List$head(
													A2(
														$elm$core$List$filter,
														A2(
															$elm$core$Basics$composeR,
															$elm$core$Tuple$first,
															$elm$core$Basics$eq(modal.ah)),
														$author$project$Components$Schedule$typesAmount))),
											jn: _List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'width', 'fit-content')
												]),
											n9: $elm$core$Maybe$Just(5),
											c3: '',
											jE: $elm$core$Maybe$Nothing,
											jF: $elm$core$Maybe$Nothing,
											jG: $elm$core$Maybe$Nothing,
											ov: $elm$core$Maybe$Nothing,
											jI: $elm$core$Maybe$Just(
												A2(
													$elm$core$Basics$composeL,
													$author$project$Components$Schedule$InputtedAmount,
													$elm$core$String$filter($elm$core$Char$isDigit))),
											hh: '',
											kE: false,
											kY: 'text',
											k1: _List_Nil,
											di: formatValue(
												$elm$core$String$fromInt(modal.lo))
										})
									]),
								oc: $elm$core$Maybe$Just(
									{
										lx: _List_fromArray(
											[
												$elm$html$Html$Attributes$class('self-center w-full')
											]),
										l_: $author$project$Components$Schedule$SubmitCreateNewPeriod(modal),
										iH: false
									}),
								pX: 'Adicionar'
							})
						])),
				k5: $elm$html$Html$text('')
			});
	});
var $author$project$Components$Schedule$SelectedAvailability = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Schedule$SubmitSelected = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Schedule$viewModalSelectedPeriod = F2(
	function (modal, m) {
		var labelSelect = function (_v0) {
			var i = _v0.a;
			var v = _v0.b;
			return (i === 'value') ? $author$project$Utils$formatAsMoney(
				$elm$core$String$fromFloat(v)) : ($elm$core$String$fromFloat(v) + '%');
		};
		return $author$project$Components$Patterns$Modal$simple(
			{
				hY: $elm$core$Maybe$Just(
					A2($elm$html$Html$Attributes$style, 'min-height', 'fit-content')),
				ii: 'modal-cadastro-usuario-sistema gap-12 p-8',
				il: 'truncate ',
				ip: $author$project$Components$Schedule$CloseModal,
				fD: 'Selecione qual período deseja vincular',
				k4: A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-full px-20 ')
						]),
					_List_fromArray(
						[
							$author$project$Components$Patterns$Forms$formSimple(
							{
								hZ: _List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex flex-col gap-4')
									]),
								L: modal.L,
								jf: _List_fromArray(
									[
										$author$project$Components$Patterns$Forms$Select(
										{
											iH: modal.L === 2,
											jl: $elm$core$Maybe$Just('Selecione o período'),
											jn: _List_Nil,
											jI: $elm$core$Maybe$Just($author$project$Components$Schedule$SelectedAvailability),
											jO: _Utils_ap(
												_List_fromArray(
													[
														{eX: modal.cm === '', c3: 'Período', di: ''}
													]),
												A2(
													$krisajenkins$remotedata$RemoteData$withDefault,
													_List_Nil,
													A2(
														$krisajenkins$remotedata$RemoteData$map,
														function (avs) {
															return A2(
																$elm$core$List$map,
																function (av) {
																	return {
																		eX: _Utils_eq(modal.cm, av.dM),
																		c3: A2(
																			$elm$core$Maybe$withDefault,
																			'',
																			A2(
																				$elm$core$Maybe$map,
																				labelSelect,
																				$elm$core$List$head(
																					$elm$core$Dict$toList(av.lo)))),
																		di: av.dM
																	};
																},
																avs);
														},
														m.g))),
											jQ: false,
											ks: _List_Nil,
											kE: modal.L === 1,
											k1: _List_Nil
										})
									]),
								oc: $elm$core$Maybe$Just(
									{
										lx: _List_fromArray(
											[
												$elm$html$Html$Attributes$class('self-center')
											]),
										l_: $author$project$Components$Schedule$SubmitSelected(modal),
										iH: false
									}),
								pX: 'Adicionar'
							})
						])),
				k5: $elm$html$Html$text('')
			});
	});
var $author$project$Components$Schedule$viewModal = function (m) {
	var _v0 = m.aY;
	_v0$2:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a.$) {
				case 6:
					var modal = _v0.a.a;
					return A2($author$project$Components$Schedule$viewModalSelectedPeriod, modal, m);
				case 7:
					var modal = _v0.a.a;
					return A2($author$project$Components$Schedule$viewModalCreateNewPeriod, modal, m);
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$html$Html$text('');
};
var $author$project$Pages$Panel$Classes$Create$CloseModal = {$: 2};
var $author$project$Pages$Panel$Classes$Create$GetCurrentDate = {$: 19};
var $author$project$Pages$Panel$Classes$Create$viewModalUpdateRule = function (options) {
	return $author$project$Components$Patterns$Modal$simple(
		{
			hY: $elm$core$Maybe$Just(
				A2($elm$html$Html$Attributes$style, 'min-height', 'fit-content')),
			ii: '',
			il: '',
			ip: $author$project$Pages$Panel$Classes$Create$CloseModal,
			fD: options.jx,
			k4: $author$project$Components$Patterns$Forms$formSimple(
				{
					hZ: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col gap-4'),
							A2($elm$html$Html$Attributes$style, 'width', 'min-content')
						]),
					L: options.L,
					jf: _List_fromArray(
						[
							$author$project$Components$Patterns$Forms$Html(
							A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-gray-600 text-center'),
										A2($elm$html$Html$Attributes$style, 'width', 'fit-content')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Insira a data de início de vigência, para a atualização da regra na classe')
									])))
						]),
					oc: $elm$core$Maybe$Just(
						{
							lx: _List_fromArray(
								[
									$elm$html$Html$Attributes$class('self-center w-full')
								]),
							l_: $author$project$Pages$Panel$Classes$Create$FormMsg($author$project$Pages$Panel$Classes$Create$GetCurrentDate),
							iH: false
						}),
					pX: options.kM
				}),
			k5: $elm$html$Html$text('')
		});
};
var $author$project$Pages$Panel$Classes$Create$BackToClasses = {$: 0};
var $author$project$Pages$Panel$Classes$Create$SubmitUpdate = {$: 16};
var $elm$svg$Svg$circle = $elm$svg$Svg$trustedNode('circle');
var $elm$svg$Svg$Attributes$cx = _VirtualDom_attribute('cx');
var $elm$svg$Svg$Attributes$cy = _VirtualDom_attribute('cy');
var $elm$svg$Svg$Attributes$r = _VirtualDom_attribute('r');
var $author$project$Components$Patterns$Button$loading = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$class('animate-spin -ml-1 mr-3 h-5 w-5 text-purple-main'),
			$elm$svg$Svg$Attributes$fill('none'),
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('opacity-25'),
					$elm$svg$Svg$Attributes$cx('12'),
					$elm$svg$Svg$Attributes$cy('12'),
					$elm$svg$Svg$Attributes$r('10'),
					$elm$svg$Svg$Attributes$stroke('currentColor'),
					$elm$svg$Svg$Attributes$strokeWidth('4')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('opacity-75'),
					$elm$svg$Svg$Attributes$fill('currentColor'),
					$elm$svg$Svg$Attributes$d('M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z')
				]),
			_List_Nil)
		]));
var $author$project$Components$Patterns$Button$textWithLoading = F6(
	function (attrBtn, isLoading, isDisabled, classBtn, title, msg) {
		return A2(
			$elm$html$Html$button,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('action-system green-btn flex justify-center ' + classBtn),
						$elm$html$Html$Events$onClick(msg),
						$elm$html$Html$Attributes$disabled(isLoading || isDisabled)
					]),
				attrBtn),
			_List_fromArray(
				[
					isLoading ? $author$project$Components$Patterns$Button$loading : $elm$html$Html$text(''),
					$elm$html$Html$text(title)
				]));
	});
var $author$project$Components$Patterns$Forms$Checkbox = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Panel$Classes$Create$InputtedClassID = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Panel$Classes$Create$InputtedClassName = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Panel$Classes$Create$InputtedClassPriority = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Panel$Classes$Create$InputtedEffectiveFrom = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Panel$Classes$Create$InputtedMaxCompanions = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Panel$Classes$Create$InputtedMaxDayUseCounter = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Panel$Classes$Create$InputtedMaxMonthUseCounter = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Panel$Classes$Create$InputtedPaymentRole = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Pages$Panel$Classes$Create$InputtedSubsequentUsePeriod = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Panel$Classes$Create$SelectedCompanion = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Panel$Classes$Create$SelectedDefaultPaymentRole = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Panel$Classes$Create$SelectedTwoSteps = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Panel$Classes$Create$SelectedType = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Patterns$Forms$SliderWithInput = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Panel$Classes$Create$ToggleActive = {$: 13};
var $author$project$Pages$Panel$Classes$Create$ToggleWalletPhysical = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Panel$Classes$Create$ToggleWalletVirtual = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Panel$Classes$Create$validatorClassType = function (str) {
	return _Utils_Tuple2(
		$elm$core$String$isEmpty(str),
		'Tipo é obrigatório');
};
var $author$project$Pages$Panel$Classes$Create$validatorEffectiveFromDate = F3(
	function (timezone, now, effectiveFrom) {
		var dateTimeInPosix = A2(
			$elm$core$Maybe$withDefault,
			$elm$time$Time$millisToPosix(0),
			A2($author$project$Utils$datetimeLocalHTMLToPosixWithZone, timezone, effectiveFrom));
		return _Utils_cmp(
			$elm$time$Time$posixToMillis(now),
			$elm$time$Time$posixToMillis(dateTimeInPosix)) > -1;
	});
var $author$project$Pages$Panel$Classes$Create$validatorsEffectiveFrom = F2(
	function (timezone, now) {
		return _List_fromArray(
			[
				_Utils_Tuple2($elm$core$String$isEmpty, 'Data de vigência é obrigatório'),
				_Utils_Tuple2(
				A2($author$project$Pages$Panel$Classes$Create$validatorEffectiveFromDate, timezone, now),
				'Data precisa maior que a atual')
			]);
	});
var $author$project$Pages$Panel$Classes$Create$valueDefaultPaymentPercent = A2(
	$elm$core$Basics$composeR,
	$elm$core$String$toFloat,
	$elm$core$Maybe$andThen(
		function (i) {
			return $author$project$Pages$Panel$Classes$Create$isInvalidDefaultPaymentPercent(i) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(i);
		}));
var $author$project$Pages$Panel$Classes$Create$valueDefaultPaymentValue = A2(
	$elm$core$Basics$composeR,
	$elm$core$String$filter($elm$core$Char$isDigit),
	A2(
		$elm$core$Basics$composeR,
		$elm$core$String$toFloat,
		$elm$core$Maybe$andThen(
			function (i) {
				return $author$project$Pages$Panel$Classes$Create$isInvalidDefaultPaymentValue(i) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(i);
			})));
var $author$project$Utils$Time$map = F2(
	function (mapFun, time) {
		return $elm$time$Time$millisToPosix(
			mapFun(
				$elm$time$Time$posixToMillis(time)));
	});
var $elm_community$list_extra$List$Extra$rowsLength = function (listOfLists) {
	if (!listOfLists.b) {
		return 0;
	} else {
		var x = listOfLists.a;
		return $elm$core$List$length(x);
	}
};
var $elm_community$list_extra$List$Extra$transpose = function (listOfLists) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$List$map2($elm$core$List$cons),
		A2(
			$elm$core$List$repeat,
			$elm_community$list_extra$List$Extra$rowsLength(listOfLists),
			_List_Nil),
		listOfLists);
};
var $author$project$Components$Schedule$RemovePeriod = {$: 5};
var $author$project$Components$Schedule$viewButtonSelectedPeriodReserved = function (model) {
	return (A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (s) {
				return s !== '-';
			},
			model.af)) && (!$elm$core$Set$isEmpty(model.A))) ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex gap-2')
			]),
		_List_fromArray(
			[
				A4(
				$author$project$Components$Patterns$Button$text,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('button')
					]),
				'red-btn m-0 py-2 px-4 w-fit',
				'Remover',
				$author$project$Components$Schedule$RemovePeriod)
			])) : $elm$html$Html$text('');
};
var $author$project$Components$Schedule$AddPeriod = {$: 6};
var $author$project$Components$Schedule$CreatePeriod = {$: 7};
var $author$project$Components$Schedule$viewButtonSelectedUnreservedPeriod = function (model) {
	return (A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (s) {
				return s === '-';
			},
			model.af)) && (!$elm$core$Set$isEmpty(model.A))) ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex gap-2')
			]),
		_List_fromArray(
			[
				A2(
				$krisajenkins$remotedata$RemoteData$withDefault,
				true,
				A2($krisajenkins$remotedata$RemoteData$map, $elm$core$List$isEmpty, model.g)) ? $elm$html$Html$text('') : A4(
				$author$project$Components$Patterns$Button$text,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('button')
					]),
				'm-0 py-2 px-4 w-fit',
				'Adicionar',
				$author$project$Components$Schedule$AddPeriod),
				A4(
				$author$project$Components$Patterns$Button$text,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('button')
					]),
				'm-0 py-2 px-4 w-fit',
				'Criar',
				$author$project$Components$Schedule$CreatePeriod)
			])) : $elm$html$Html$text('');
};
var $author$project$Components$Schedule$ClickedCell = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Schedule$MouseDownedCell = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Schedule$MouseOveredCell = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Schedule$primaryPointerMainButton = F2(
	function (onEvent, decoder) {
		return A2(
			$elm$html$Html$Events$on,
			onEvent,
			A2(
				$elm$json$Json$Decode$andThen,
				$elm$core$Basics$identity,
				A3(
					$elm$json$Json$Decode$map2,
					F2(
						function (isPrimary, button) {
							return (isPrimary && (!button)) ? decoder : $elm$json$Json$Decode$fail('Not primary pointer');
						}),
					A2($elm$json$Json$Decode$field, 'isPrimary', $elm$json$Json$Decode$bool),
					A2($elm$json$Json$Decode$field, 'button', $elm$json$Json$Decode$int))));
	});
var $elm$html$Html$Attributes$tabindex = function (n) {
	return A2(
		_VirtualDom_attribute,
		'tabIndex',
		$elm$core$String$fromInt(n));
};
var $author$project$Components$Schedule$MouseDownedResizeHandler = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Schedule$availabilityText = F3(
	function (shared, mode, av) {
		return $elm$core$Maybe$Just(' ');
	});
var $author$project$Components$Schedule$availabilityClasses = F4(
	function (shared, model, availability, isSelected) {
		var unavailable = _Utils_Tuple2('', '');
		var reserved = _Utils_Tuple2('unavailable', 'Reservado');
		var cancelling = _Utils_Tuple3('cancelling', 'Cancelar', _List_Nil);
		var available = _Utils_Tuple2('instant-booking', 'Reserva instantânea');
		var _v0 = _Utils_Tuple2(
			_Utils_Tuple3(
				'reserved ',
				A2(
					$elm$core$Maybe$withDefault,
					'Reservado',
					A3($author$project$Components$Schedule$availabilityText, shared, model.aZ, availability)),
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'background-color', availability.cK)
					])),
			cancelling);
		var notSelected = _v0.a;
		var selected = _v0.b;
		return isSelected ? selected : notSelected;
	});
var $author$project$Components$Schedule$viewAvailability = F7(
	function (shared, model, now, cell, availabilitiesLength, cellAvailabilitiesIndex, _v0) {
		var availability = _v0.a;
		var availabilityIndex = _v0.b;
		var percentageCalcStyle = F2(
			function (property, value) {
				return A2(
					$elm$html$Html$Attributes$style,
					property,
					$elm$core$String$fromFloat(value) + '%');
			});
		var isSelected = cell.eX && _Utils_eq(cellAvailabilitiesIndex, availabilitiesLength - 1);
		var isResizing = function () {
			var _v7 = model.I;
			if (_v7.$ === 2) {
				var r = _v7.a;
				return _Utils_eq(availability.dM, r.dM);
			} else {
				return false;
			}
		}();
		var isClickable = true;
		var _v1 = function () {
			var _v2 = model.I;
			switch (_v2.$) {
				case 0:
					return _Utils_Tuple2(false, false);
				case 1:
					var id = _v2.a;
					return _Utils_Tuple2(
						_Utils_eq(availability.dM, id),
						false);
				case 2:
					var r = _v2.a;
					return _Utils_Tuple2(
						_Utils_eq(availability.dM, r.dM),
						false);
				default:
					var r = _v2.a;
					return _Utils_Tuple2(
						false,
						_Utils_eq(availability.dM, r.dM));
			}
		}();
		var isResizable = _v1.a;
		var isLoading = _v1.b;
		var _v3 = function () {
			if ((!availabilityIndex) || (!cell.m)) {
				var totalRowSpan = $elm$core$List$length(availability.n);
				var remainRowSpan = (!cell.m) ? totalRowSpan : (totalRowSpan - cell.m);
				return {
					fU: cellAvailabilitiesIndex,
					fV: A2($elm$core$Basics$min, remainRowSpan, 48 - cell.m),
					f1: function (_v4) {
						var c = _v4.c;
						return c;
					}(
						A4($author$project$Components$Schedule$availabilityClasses, shared, model, availability, isSelected)),
					f2: function (_v5) {
						var a = _v5.a;
						var b = _v5.b;
						return _Utils_Tuple2(a, b);
					}(
						A4($author$project$Components$Schedule$availabilityClasses, shared, model, availability, isSelected)),
					gw: (cell.m + remainRowSpan) <= 48,
					gx: !availabilityIndex,
					gL: true
				};
			} else {
				return {
					fU: 0,
					fV: 1,
					f1: _List_Nil,
					f2: _Utils_Tuple2('', ''),
					gw: true,
					gx: true,
					gL: false
				};
			}
		}();
		var isColumnHead = _v3.gL;
		var hasAvailabilityTop = _v3.gx;
		var hasAvailabilityBottom = _v3.gw;
		var availabilitySlotsLength = _v3.fV;
		var cellClass = _v3.f2;
		var cellAttrs = _v3.f1;
		var availabilitySlotTop = _v3.fU;
		var customTitle = function () {
			var _v6 = A3($author$project$Components$Schedule$availabilityText, shared, model.aZ, availability);
			if (!_v6.$) {
				var name = _v6.a;
				return $elm$core$List$singleton(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('custom-title', true),
										_Utils_Tuple2('cursor-s-resize', isResizing),
										_Utils_Tuple2('cursor-pointer', isClickable)
									])),
								A2($elm$html$Html$Attributes$attribute, 'custom-title', name),
								A2(percentageCalcStyle, 'height', availabilitySlotsLength * 100),
								A2(percentageCalcStyle, 'top', availabilitySlotTop * 100)
							]),
						_List_Nil));
			} else {
				return _List_Nil;
			}
		}();
		return isColumnHead ? A2(
			$elm$core$List$cons,
			A2(
				$elm$html$Html$div,
				_Utils_ap(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('availability', true),
									_Utils_Tuple2(cellClass.a, true),
									_Utils_Tuple2('resizable', isResizable),
									_Utils_Tuple2('opacity-50', isLoading),
									_Utils_Tuple2('overflow-hidden !text-[0.67rem]', true)
								])),
							A2(percentageCalcStyle, 'height', 100),
							A2(percentageCalcStyle, 'top', availabilitySlotTop * 100)
						]),
					cellAttrs),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$text(cellClass.b),
					function () {
						if (isResizable) {
							var onPointerDown = F2(
								function (isTop, rowIndex_) {
									return A2(
										$elm$html$Html$Events$stopPropagationOn,
										'pointerdown',
										A2(
											$elm$json$Json$Decode$andThen,
											$elm$core$Basics$identity,
											A3(
												$elm$json$Json$Decode$map2,
												F2(
													function (isPrimary, button) {
														return (isPrimary && (!button)) ? $elm$json$Json$Decode$succeed(
															_Utils_Tuple2(
																A2($author$project$Components$Schedule$MouseDownedResizeHandler, isTop, rowIndex_),
																true)) : $elm$json$Json$Decode$fail('Not primary pointer');
													}),
												A2($elm$json$Json$Decode$field, 'isPrimary', $elm$json$Json$Decode$bool),
												A2($elm$json$Json$Decode$field, 'button', $elm$json$Json$Decode$int))));
								});
							var isNowAfterStartTime = false;
							var isNowAfterEndTime = false;
							var bottomRowIndex = (cell.m + $elm$core$Basics$ceiling(availabilitySlotsLength)) - 1;
							return _List_fromArray(
								[
									(hasAvailabilityTop && (!isNowAfterStartTime)) ? A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('resize-handler top'),
											A2(onPointerDown, true, cell.m)
										]),
									_List_Nil) : $elm$html$Html$text(''),
									(hasAvailabilityBottom && (!isNowAfterEndTime)) ? A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('resize-handler bottom'),
											A2(onPointerDown, false, bottomRowIndex),
											A2(
											$elm$html$Html$Events$stopPropagationOn,
											'pointerover',
											$elm$json$Json$Decode$succeed(
												_Utils_Tuple2(
													A2($author$project$Components$Schedule$MouseOveredCell, cell.r, bottomRowIndex),
													true)))
										]),
									_List_Nil) : $elm$html$Html$text('')
								]);
						} else {
							return _List_Nil;
						}
					}())),
			customTitle) : customTitle;
	});
var $author$project$Components$Schedule$viewGridCell = F5(
	function (shared, model, now, cellsWithSelectionBorder, cell) {
		var isNow = _Utils_eq(now.r, cell.r) && _Utils_eq(now.m, cell.m);
		var colRowIndex = _Utils_Tuple2(cell.r, cell.m);
		var selectionBorder = function () {
			var hasBorderTop = A2($elm$core$Set$member, colRowIndex, cellsWithSelectionBorder.fE);
			var hasBorderRight = A2($elm$core$Set$member, colRowIndex, cellsWithSelectionBorder.fp);
			var hasBorderLeft = A2($elm$core$Set$member, colRowIndex, cellsWithSelectionBorder.e0);
			var hasBorderBottom = A2($elm$core$Set$member, colRowIndex, cellsWithSelectionBorder.er);
			var hasAnyBorder = hasBorderTop || (hasBorderRight || (hasBorderBottom || hasBorderLeft));
			return hasAnyBorder ? _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('selection-area'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('border-top', hasBorderTop),
									_Utils_Tuple2('border-right', hasBorderRight),
									_Utils_Tuple2('border-bottom', hasBorderBottom),
									_Utils_Tuple2('border-left', hasBorderLeft)
								]))
						]),
					_List_Nil)
				]) : _List_Nil;
		}();
		return A2(
			$elm$html$Html$td,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$tabindex(0),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('availability-grid-now', isNow),
							_Utils_Tuple2('tdAvailabilityGrid', true)
						])),
					isNow ? A2(
					$elm$html$Html$Attributes$attribute,
					'style',
					'position:relative; --availability-grid-now-top:' + ($elm$core$String$fromInt(((100 * now.hn) / $author$project$Components$Schedule$minutesInMillis30) | 0) + '%;')) : $elm$html$Html$Attributes$class(''),
					$elm$html$Html$Events$onClick(
					A2($author$project$Components$Schedule$ClickedCell, cell.r, cell.m)),
					A2(
					$elm$html$Html$Events$on,
					'pointerover',
					$elm$json$Json$Decode$succeed(
						A2($author$project$Components$Schedule$MouseOveredCell, cell.r, cell.m))),
					A2(
					$author$project$Components$Schedule$primaryPointerMainButton,
					'pointerdown',
					$elm$json$Json$Decode$succeed(
						A2($author$project$Components$Schedule$MouseDownedCell, cell.r, cell.m)))
				]),
			function () {
				var shouldAppendSelectingView = cell.eX;
				var selectingView = function () {
					if (shouldAppendSelectingView) {
						var _v1 = (!model.aZ) ? _Utils_Tuple2(
							$elm$html$Html$Attributes$class('selecting'),
							_List_Nil) : _Utils_Tuple2(
							$elm$html$Html$Attributes$class('requesting'),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Solicitar')
										]))
								]));
						var class_ = _v1.a;
						var content = _v1.b;
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'height', '100%'),
										$elm$html$Html$Attributes$class('availability'),
										class_
									]),
								content)
							]);
					} else {
						return _List_Nil;
					}
				}();
				var isAvailable = (_Utils_cmp(cell.r, now.r) > 0) || (_Utils_eq(cell.r, now.r) && (_Utils_cmp(cell.m, now.m) > -1));
				var availabilitiesLength = $elm$core$List$length(cell.g);
				var viewContent = function () {
					var _v0 = cell.g;
					if (!_v0.b) {
						return isAvailable ? _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('availability available')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(' ')
											]))
									]))
							]) : _List_Nil;
					} else {
						var availabilities = _v0;
						return $elm$core$List$concat(
							A2(
								$elm$core$List$indexedMap,
								A5($author$project$Components$Schedule$viewAvailability, shared, model, now, cell, availabilitiesLength),
								availabilities));
					}
				}();
				return _Utils_ap(
					selectingView,
					_Utils_ap(selectionBorder, viewContent));
			}());
	});
var $elm$html$Html$Attributes$rowspan = function (n) {
	return A2(
		_VirtualDom_attribute,
		'rowspan',
		$elm$core$String$fromInt(n));
};
var $author$project$Components$Schedule$viewGridRow = F2(
	function (rowIndex, children) {
		var isHalf = A2($elm$core$Basics$modBy, 2, rowIndex) === 1;
		var hour = (rowIndex / 2) | 0;
		var hourStr = A2(
			$elm$core$String$right,
			2,
			'0' + $elm$core$String$fromInt(hour));
		var rowHeader = isHalf ? $elm$html$Html$text('') : A2(
			$elm$html$Html$td,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$rowspan(2),
					$elm$html$Html$Attributes$class('daytime')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(hourStr + ':00')
				]));
		return A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[
					isHalf ? $elm$html$Html$Attributes$class('dashed-border') : $elm$html$Html$Attributes$class(''),
					A2(
					$elm$html$Html$Attributes$attribute,
					'data-hour-part',
					$elm$core$String$fromInt(rowIndex))
				]),
			A2($elm$core$List$cons, rowHeader, children));
	});
var $author$project$Components$Schedule$viewPeriods = function (model) {
	return A2(
		$elm$html$Html$ul,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex gap-4')
			]),
		A2(
			$krisajenkins$remotedata$RemoteData$withDefault,
			_List_Nil,
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				function (avs) {
					return A2(
						$elm$core$List$map,
						function (av) {
							var amount = function () {
								var _v0 = $elm$core$List$head(
									$elm$core$Dict$toList(av.lo));
								_v0$2:
								while (true) {
									if (!_v0.$) {
										switch (_v0.a.a) {
											case 'percent':
												var _v1 = _v0.a;
												var v = _v1.b;
												return $elm$core$String$fromFloat(v) + '%';
											case 'value':
												var _v2 = _v0.a;
												var v = _v2.b;
												return $author$project$Utils$formatAsMoney(
													$elm$core$String$fromFloat(v));
											default:
												break _v0$2;
										}
									} else {
										break _v0$2;
									}
								}
								return '';
							}();
							return A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex items-center gap-2 ')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('w-4 h-4 rounded-full'),
												A2($elm$html$Html$Attributes$style, 'background-color', av.cK)
											]),
										_List_Nil),
										$elm$html$Html$text(amount)
									]));
						},
						avs);
				},
				model.g)));
};
var $author$project$Components$Schedule$viewGrid = F2(
	function (model, shared) {
		var viewWeekDayHeader = F2(
			function (dayIndex, label) {
				return A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('days')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$b,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(label)
										]))
								]))
						]));
			});
		var now_ = $elm$time$Time$millisToPosix(1721012400000);
		var now = A2($author$project$Components$Schedule$nowIndexes, model.bT, now_);
		var cellsWithSelectionBorder = function () {
			var _v0 = model.ai;
			if (!_v0.$) {
				var sr = _v0.a;
				var minRowIndex = A2($elm$core$Basics$min, sr.cv, sr.bm);
				var minColIndex = A2($elm$core$Basics$min, sr.cu, sr.bk);
				var maxRowIndex = A2($elm$core$Basics$max, sr.cv, sr.bm);
				var rowRange = A2($elm$core$List$range, minRowIndex, maxRowIndex);
				var maxColIndex = A2($elm$core$Basics$max, sr.cu, sr.bk);
				var colRange = A2($elm$core$List$range, minColIndex, maxColIndex);
				return {
					er: $elm$core$Set$fromList(
						A2(
							$elm$core$List$map,
							function (colIndex) {
								return _Utils_Tuple2(colIndex, maxRowIndex);
							},
							colRange)),
					e0: $elm$core$Set$fromList(
						A2(
							$elm$core$List$map,
							function (rowIndex) {
								return _Utils_Tuple2(minColIndex, rowIndex);
							},
							rowRange)),
					fp: $elm$core$Set$fromList(
						A2(
							$elm$core$List$map,
							function (rowIndex) {
								return _Utils_Tuple2(maxColIndex, rowIndex);
							},
							rowRange)),
					fE: $elm$core$Set$fromList(
						A2(
							$elm$core$List$map,
							function (colIndex) {
								return _Utils_Tuple2(colIndex, minRowIndex);
							},
							colRange))
				};
			} else {
				return {er: $elm$core$Set$empty, e0: $elm$core$Set$empty, fp: $elm$core$Set$empty, fE: $elm$core$Set$empty};
			}
		}();
		var addDays = function (days) {
			return A2(
				$author$project$Utils$Time$map,
				$elm$core$Basics$add(days * $author$project$Components$Schedule$dayInMillis1),
				model.bT);
		};
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex justify-between')
						]),
					_List_fromArray(
						[
							$author$project$Components$Schedule$viewPeriods(model),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Components$Schedule$viewButtonSelectedPeriodReserved(model),
									$author$project$Components$Schedule$viewButtonSelectedUnreservedPeriod(model)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('time-grid-container scroll--super--small')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$table,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$thead,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$tr,
													_List_Nil,
													A2(
														$elm$core$List$cons,
														A2(
															$elm$html$Html$th,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('empty')
																]),
															_List_Nil),
														A2(
															$elm$core$List$indexedMap,
															viewWeekDayHeader,
															_List_fromArray(
																['DOM', 'SEG', 'TER', 'QUA', 'QUI', 'SEX', 'SAB']))))
												])),
											A2(
											$elm$html$Html$tbody,
											_List_fromArray(
												[
													model.gM ? $elm$html$Html$Attributes$class('calendar-loading') : $elm$html$Html$Attributes$class('')
												]),
											A2(
												$elm$core$List$indexedMap,
												$author$project$Components$Schedule$viewGridRow,
												$elm_community$list_extra$List$Extra$transpose(
													A2(
														$elm$core$List$map,
														$elm$core$List$map(
															A4($author$project$Components$Schedule$viewGridCell, shared, model, now, cellsWithSelectionBorder)),
														$author$project$Components$Schedule$availabilitiesToCellViews(model)))))
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Panel$Classes$Create$viewRuleConfig = F3(
	function (shared, model, form) {
		return _List_fromArray(
			[
				$author$project$Components$Patterns$Forms$formSimple(
				{
					hZ: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-4 flex flex-col gap-5 p-2')
						]),
					L: 0,
					jf: _List_fromArray(
						[
							$author$project$Components$Patterns$Forms$Input(
							{
								ie: $elm$core$Maybe$Nothing,
								iH: form.L === 2,
								iP: _List_Nil,
								nR: _List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-gray-shade placeholder-gray-tint')
									]),
								jl: $elm$core$Maybe$Just('Nome'),
								jn: _List_Nil,
								n9: $elm$core$Maybe$Just(80),
								c3: 'Campo para nome',
								jE: $elm$core$Maybe$Nothing,
								jF: $elm$core$Maybe$Nothing,
								jG: $elm$core$Maybe$Nothing,
								ov: $elm$core$Maybe$Nothing,
								jI: $elm$core$Maybe$Just(
									A2($elm$core$Basics$composeL, $author$project$Pages$Panel$Classes$Create$FormMsg, $author$project$Pages$Panel$Classes$Create$InputtedClassName)),
								hh: 'Insira uma nome para classe',
								kE: form.L === 1,
								kY: 'text',
								k1: _List_fromArray(
									[
										_Utils_Tuple2($elm$core$String$isEmpty, 'Nome não pode ser vazio')
									]),
								di: form.c3
							}),
							$author$project$Components$Patterns$Forms$Input(
							{
								ie: $elm$core$Maybe$Nothing,
								iH: form.L === 2,
								iP: _List_Nil,
								nR: _List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-gray-shade w-fit'),
										$elm$html$Html$Attributes$size(5)
									]),
								jl: $elm$core$Maybe$Just('Prioridade'),
								jn: _List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex flex-col')
									]),
								n9: $elm$core$Maybe$Just(5),
								c3: 'Campo para proridade da classe',
								jE: $elm$core$Maybe$Nothing,
								jF: $elm$core$Maybe$Nothing,
								jG: $elm$core$Maybe$Nothing,
								ov: $elm$core$Maybe$Nothing,
								jI: $elm$core$Maybe$Just(
									A2($elm$core$Basics$composeL, $author$project$Pages$Panel$Classes$Create$FormMsg, $author$project$Pages$Panel$Classes$Create$InputtedClassPriority)),
								hh: '',
								kE: form.L === 1,
								kY: 'number',
								k1: _List_fromArray(
									[
										_Utils_Tuple2($elm$core$String$isEmpty, 'Prioridade não pode ser vazio')
									]),
								di: A2(
									$elm$core$Maybe$withDefault,
									'',
									A2($elm$core$Maybe$map, $elm$core$String$fromInt, form.ch))
							}),
							$author$project$Components$Patterns$Forms$Input(
							{
								ie: $elm$core$Maybe$Nothing,
								iH: form.L === 2,
								iP: _List_Nil,
								nR: _List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-black'),
										$elm$html$Html$Attributes$step('1')
									]),
								jl: $elm$core$Maybe$Just('Data de início de vigência'),
								jn: _List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex flex-col'),
										A2($elm$html$Html$Attributes$style, 'width', 'fit-content')
									]),
								n9: $elm$core$Maybe$Nothing,
								c3: 'Campo para data de vigência',
								jE: $elm$core$Maybe$Nothing,
								jF: $elm$core$Maybe$Nothing,
								jG: $elm$core$Maybe$Nothing,
								ov: $elm$core$Maybe$Nothing,
								jI: $elm$core$Maybe$Just(
									A2($elm$core$Basics$composeL, $author$project$Pages$Panel$Classes$Create$FormMsg, $author$project$Pages$Panel$Classes$Create$InputtedEffectiveFrom)),
								hh: 'Insira a data para início de vigência',
								kE: form.L === 1,
								kY: 'datetime-local',
								k1: A2($author$project$Pages$Panel$Classes$Create$validatorsEffectiveFrom, shared.kS, form.b2),
								di: form.aT
							}),
							A2(
							$author$project$Components$Patterns$Forms$Custom,
							'flex flex-col',
							_List_fromArray(
								[
									$author$project$Components$Patterns$Forms$SliderWithInput(
									{
										iH: form.L === 2,
										nR: _List_Nil,
										jl: $elm$core$Maybe$Just('Limite de Uso Diário'),
										jn: _List_fromArray(
											[
												$elm$html$Html$Attributes$class(' w-full')
											]),
										d$: '15',
										e4: '0',
										c3: '',
										jI: $elm$core$Maybe$Just(
											A2($elm$core$Basics$composeL, $author$project$Pages$Panel$Classes$Create$FormMsg, $author$project$Pages$Panel$Classes$Create$InputtedMaxDayUseCounter)),
										kE: form.L === 1,
										hG: '1',
										k1: _List_fromArray(
											[
												_Utils_Tuple2(
												function (str) {
													return A2(
														$elm$core$Maybe$withDefault,
														true,
														A2(
															$elm$core$Maybe$map,
															$author$project$Pages$Panel$Classes$Create$isInvalidMaxDayUseCounter,
															$elm$core$String$toInt(str)));
												},
												'Definir de 0 até 15 limite de uso diário')
											]),
										di: $elm$core$String$fromInt(form.aD)
									}),
									$author$project$Components$Patterns$Forms$Html(
									A2(
										$elm$html$Html$em,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Pode ser de 0 até 15')
											])))
								])),
							A2(
							$author$project$Components$Patterns$Forms$Custom,
							'flex flex-col',
							_List_fromArray(
								[
									$author$project$Components$Patterns$Forms$SliderWithInput(
									{
										iH: form.L === 2,
										nR: _List_Nil,
										jl: $elm$core$Maybe$Just('Limite de Uso Mensal'),
										jn: _List_fromArray(
											[
												$elm$html$Html$Attributes$class(' w-full')
											]),
										d$: '255',
										e4: '0',
										c3: '',
										jI: $elm$core$Maybe$Just(
											A2($elm$core$Basics$composeL, $author$project$Pages$Panel$Classes$Create$FormMsg, $author$project$Pages$Panel$Classes$Create$InputtedMaxMonthUseCounter)),
										kE: form.L === 1,
										hG: '1',
										k1: _List_fromArray(
											[
												_Utils_Tuple2(
												function (str) {
													return A2(
														$elm$core$Maybe$withDefault,
														true,
														A2(
															$elm$core$Maybe$map,
															$author$project$Pages$Panel$Classes$Create$isInvalidMaxMonthUseCounter,
															$elm$core$String$toInt(str)));
												},
												'Definir de 0 até 255 limite de uso mensal')
											]),
										di: $elm$core$String$fromInt(form.ao)
									}),
									$author$project$Components$Patterns$Forms$Html(
									A2(
										$elm$html$Html$em,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Pode ser de 0 até 255')
											])))
								])),
							A2(
							$author$project$Components$Patterns$Forms$Custom,
							'flex flex-col',
							_List_fromArray(
								[
									$author$project$Components$Patterns$Forms$SliderWithInput(
									{
										iH: form.L === 2,
										nR: _List_Nil,
										jl: $elm$core$Maybe$Just('Intervalo de Uso (Minutos)'),
										jn: _List_fromArray(
											[
												$elm$html$Html$Attributes$class(' w-full')
											]),
										d$: '180',
										e4: '0',
										c3: 'Campo para Intervalo de Uso',
										jI: $elm$core$Maybe$Just(
											A2($elm$core$Basics$composeL, $author$project$Pages$Panel$Classes$Create$FormMsg, $author$project$Pages$Panel$Classes$Create$InputtedSubsequentUsePeriod)),
										kE: form.L === 1,
										hG: '1',
										k1: _List_fromArray(
											[
												_Utils_Tuple2(
												function (str) {
													return A2(
														$elm$core$Maybe$withDefault,
														true,
														A2(
															$elm$core$Maybe$map,
															$author$project$Pages$Panel$Classes$Create$isInvalidSubsequentUsePeriod,
															$elm$core$String$toInt(str)));
												},
												'Definir de 0 até 180 para intervalo de uso')
											]),
										di: $elm$core$String$fromInt(form.a7)
									}),
									$author$project$Components$Patterns$Forms$Html(
									A2(
										$elm$html$Html$em,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Pode ser de 0 até 180 minutos')
											])))
								])),
							A2(
							$author$project$Components$Patterns$Forms$Custom,
							'flex flex-col',
							_List_fromArray(
								[
									$author$project$Components$Patterns$Forms$SliderWithInput(
									{
										iH: form.L === 2,
										nR: _List_Nil,
										jl: $elm$core$Maybe$Just('Classe ID'),
										jn: _List_fromArray(
											[
												$elm$html$Html$Attributes$class(' w-full')
											]),
										d$: '255',
										e4: '0',
										c3: 'Campo para Classe ID',
										jI: $elm$core$Maybe$Just(
											A2($elm$core$Basics$composeL, $author$project$Pages$Panel$Classes$Create$FormMsg, $author$project$Pages$Panel$Classes$Create$InputtedClassID)),
										kE: form.L === 1,
										hG: '1',
										k1: _List_fromArray(
											[
												_Utils_Tuple2(
												function (str) {
													return A2(
														$elm$core$Maybe$withDefault,
														true,
														A2(
															$elm$core$Maybe$map,
															$author$project$Pages$Panel$Classes$Create$isInvalidClasseID,
															$elm$core$String$toInt(str)));
												},
												'Definir de 0 até 255 para classe ID')
											]),
										di: $elm$core$String$fromInt(form.lX)
									}),
									$author$project$Components$Patterns$Forms$Html(
									A2(
										$elm$html$Html$em,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Pode ser de 0 até 255')
											])))
								])),
							A2(
							$author$project$Components$Patterns$Forms$Custom,
							'',
							_List_fromArray(
								[
									$author$project$Components$Patterns$Forms$Radio(
									{
										i5: 'two-steps',
										jm: _List_Nil,
										jG: A2($elm$core$Basics$composeL, $author$project$Pages$Panel$Classes$Create$FormMsg, $author$project$Pages$Panel$Classes$Create$SelectedTwoSteps),
										jO: _List_fromArray(
											[
												{ie: form.aM, iH: form.L === 2, dM: 'two-steps-true', c3: 'Sim'},
												{ie: !form.aM, iH: form.L === 2, dM: 'two-steps-false', c3: 'Não'}
											]),
										jP: _List_fromArray(
											[
												$elm$html$Html$Attributes$class('flex gap-2')
											]),
										fD: $elm$core$Maybe$Just('Requer Confirmação do Operador')
									})
								])),
							A2(
							$author$project$Components$Patterns$Forms$Custom,
							'flex flex-col gap-2 w-fit',
							_List_fromArray(
								[
									$author$project$Components$Patterns$Forms$Radio(
									{
										i5: 'companion',
										jm: _List_Nil,
										jG: A2($elm$core$Basics$composeL, $author$project$Pages$Panel$Classes$Create$FormMsg, $author$project$Pages$Panel$Classes$Create$SelectedCompanion),
										jO: _List_fromArray(
											[
												{ie: form.K, iH: form.L === 2, dM: 'companion-true', c3: 'Sim'},
												{ie: !form.K, iH: form.L === 2, dM: 'companion-false', c3: 'Não'}
											]),
										jP: _List_fromArray(
											[
												$elm$html$Html$Attributes$class('flex gap-2')
											]),
										fD: $elm$core$Maybe$Just('Direito a Acompanhante')
									}),
									A2(
									$author$project$Components$Patterns$Forms$Custom,
									'flex items-center pl-4',
									form.K ? _List_fromArray(
										[
											$author$project$Components$Patterns$Forms$Html(
											A2(
												$elm$html$Html$strong,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('text-xl')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$elm$core$String$fromInt(form.aa))
													]))),
											$author$project$Components$Patterns$Forms$Slider(
											{
												iH: form.L === 2,
												nR: _List_Nil,
												jl: $elm$core$Maybe$Just('Quantidade de Acompanhantes'),
												jn: _List_fromArray(
													[
														$elm$html$Html$Attributes$class('ml-4 w-full')
													]),
												d$: '3',
												e4: '1',
												c3: '',
												jI: $elm$core$Maybe$Just(
													A2($elm$core$Basics$composeL, $author$project$Pages$Panel$Classes$Create$FormMsg, $author$project$Pages$Panel$Classes$Create$InputtedMaxCompanions)),
												kE: form.L === 1,
												hG: '1',
												k1: _List_fromArray(
													[
														_Utils_Tuple2(
														A2(
															$elm$core$Basics$composeR,
															$elm$core$String$toInt,
															A2(
																$elm$core$Basics$composeR,
																$elm$core$Maybe$map(
																	$author$project$Pages$Panel$Classes$Create$isInvalidMaxCompanions(form.K)),
																$elm$core$Maybe$withDefault(true))),
														'Definir de 1 até 3 acompanhantes')
													]),
												di: $elm$core$String$fromInt(form.aa)
											})
										]) : _List_Nil),
									A2(
									$author$project$Components$Patterns$Forms$Custom,
									'',
									_List_fromArray(
										[
											$author$project$Components$Patterns$Forms$Radio(
											{
												i5: 'default-payment',
												jm: _List_Nil,
												jG: A2($elm$core$Basics$composeL, $author$project$Pages$Panel$Classes$Create$FormMsg, $author$project$Pages$Panel$Classes$Create$SelectedDefaultPaymentRole),
												jO: _List_fromArray(
													[
														{
														ie: A2($elm$core$Dict$member, 'percent', form.l),
														iH: form.L === 2,
														dM: 'default-payment-true-percent',
														c3: 'Sim - Porcentagem'
													},
														{
														ie: A2($elm$core$Dict$member, 'value', form.l),
														iH: form.L === 2,
														dM: 'default-payment-true-value',
														c3: 'Sim - Valor'
													},
														{
														ie: $elm$core$Dict$isEmpty(form.l),
														iH: form.L === 2,
														dM: 'default-payment-false',
														c3: 'Não'
													}
													]),
												jP: _List_fromArray(
													[
														$elm$html$Html$Attributes$class('flex gap-3')
													]),
												fD: $elm$core$Maybe$Just('Pagamento padrão')
											}),
											$author$project$Components$Patterns$Forms$Html(
											(A2(
												$author$project$Pages$Panel$Classes$Create$isInvalidPaymentRule,
												A2(
													$krisajenkins$remotedata$RemoteData$withDefault,
													_List_Nil,
													A2(
														$krisajenkins$remotedata$RemoteData$map,
														A2(
															$elm$core$Basics$composeR,
															$elm$core$List$map(
																function ($) {
																	return $.c7;
																}),
															$elm$core$List$concat),
														form.al.g)),
												form.l) && (form.L === 1)) ? A2(
												$elm$html$Html$label,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('input-error')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$ul,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$li,
																_List_Nil,
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$span,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('text-secondary-error')
																			]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text('Você precisa configurar cobrança padrão ou cobrança por período')
																			]))
																	]))
															]))
													])) : $elm$html$Html$text(''))
										])),
									A2(
									$author$project$Components$Patterns$Forms$Custom,
									'flex items-center pl-4',
									function () {
										var _v0 = _Utils_Tuple2(
											A2($elm$core$Dict$get, 'percent', form.l),
											A2($elm$core$Dict$get, 'value', form.l));
										_v0$2:
										while (true) {
											if (!_v0.a.$) {
												if (_v0.b.$ === 1) {
													var v = _v0.a.a;
													var _v1 = _v0.b;
													return _List_fromArray(
														[
															$author$project$Components$Patterns$Forms$Input(
															{
																ie: $elm$core$Maybe$Nothing,
																iH: form.L === 2,
																iP: _List_fromArray(
																	[
																		A2(
																		$elm$html$Html$em,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('text-black')
																			]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text('Pode ser de 0% até 200%')
																			]))
																	]),
																nR: _List_fromArray(
																	[
																		$elm$html$Html$Attributes$min('0'),
																		$elm$html$Html$Attributes$max('200')
																	]),
																jl: $elm$core$Maybe$Just('Porcentagem padrão'),
																jn: _List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('flex flex-col'),
																		A2($elm$html$Html$Attributes$style, 'width', 'fit-content')
																	]),
																n9: $elm$core$Maybe$Just(3),
																c3: '',
																jE: $elm$core$Maybe$Nothing,
																jF: $elm$core$Maybe$Nothing,
																jG: $elm$core$Maybe$Nothing,
																ov: $elm$core$Maybe$Nothing,
																jI: $elm$core$Maybe$Just(
																	A2(
																		$elm$core$Basics$composeL,
																		$author$project$Pages$Panel$Classes$Create$FormMsg,
																		A2(
																			$elm$core$Basics$composeR,
																			$author$project$Pages$Panel$Classes$Create$valueDefaultPaymentPercent,
																			$author$project$Pages$Panel$Classes$Create$InputtedPaymentRole('percent')))),
																hh: '%',
																kE: form.L === 1,
																kY: 'text',
																k1: _List_fromArray(
																	[
																		_Utils_Tuple2(
																		function (_v2) {
																			return A2(
																				$author$project$Pages$Panel$Classes$Create$isInvalidPaymentRule,
																				A2(
																					$krisajenkins$remotedata$RemoteData$withDefault,
																					_List_Nil,
																					A2(
																						$krisajenkins$remotedata$RemoteData$map,
																						A2(
																							$elm$core$Basics$composeR,
																							$elm$core$List$map(
																								function ($) {
																									return $.c7;
																								}),
																							$elm$core$List$concat),
																						form.al.g)),
																				form.l);
																		},
																		'Configurar cobrança padrão ou cobrança por período'),
																		_Utils_Tuple2(
																		A2(
																			$elm$core$Basics$composeR,
																			$elm$core$String$toFloat,
																			A2(
																				$elm$core$Basics$composeR,
																				$elm$core$Maybe$map($author$project$Pages$Panel$Classes$Create$isInvalidDefaultPaymentPercent),
																				$elm$core$Maybe$withDefault(true))),
																		'Definir de 0% até 200%')
																	]),
																di: $elm$core$String$fromFloat(v)
															})
														]);
												} else {
													break _v0$2;
												}
											} else {
												if (!_v0.b.$) {
													var _v3 = _v0.a;
													var v = _v0.b.a;
													return _List_fromArray(
														[
															$author$project$Components$Patterns$Forms$Input(
															{
																ie: $elm$core$Maybe$Nothing,
																iH: form.L === 2,
																iP: _List_fromArray(
																	[
																		A2(
																		$elm$html$Html$em,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('text-black')
																			]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text('Pode ser de R$ 0 até R$ 40')
																			]))
																	]),
																nR: _List_Nil,
																jl: $elm$core$Maybe$Just('Valor padrão em Reais'),
																jn: _List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('flex flex-col'),
																		A2($elm$html$Html$Attributes$style, 'width', 'fit-content')
																	]),
																n9: $elm$core$Maybe$Just(5),
																c3: '',
																jE: $elm$core$Maybe$Nothing,
																jF: $elm$core$Maybe$Nothing,
																jG: $elm$core$Maybe$Nothing,
																ov: $elm$core$Maybe$Nothing,
																jI: $elm$core$Maybe$Just(
																	A2(
																		$elm$core$Basics$composeL,
																		$author$project$Pages$Panel$Classes$Create$FormMsg,
																		A2(
																			$elm$core$Basics$composeR,
																			$author$project$Pages$Panel$Classes$Create$valueDefaultPaymentValue,
																			$author$project$Pages$Panel$Classes$Create$InputtedPaymentRole('value')))),
																hh: 'R$',
																kE: form.L === 1,
																kY: 'text',
																k1: _List_fromArray(
																	[
																		_Utils_Tuple2(
																		function (_v4) {
																			return A2(
																				$author$project$Pages$Panel$Classes$Create$isInvalidPaymentRule,
																				A2(
																					$krisajenkins$remotedata$RemoteData$withDefault,
																					_List_Nil,
																					A2(
																						$krisajenkins$remotedata$RemoteData$map,
																						A2(
																							$elm$core$Basics$composeR,
																							$elm$core$List$map(
																								function ($) {
																									return $.c7;
																								}),
																							$elm$core$List$concat),
																						form.al.g)),
																				form.l);
																		},
																		'Configurar cobrança padrão ou cobrança por período'),
																		_Utils_Tuple2(
																		A2(
																			$elm$core$Basics$composeR,
																			$elm$core$String$toFloat,
																			A2(
																				$elm$core$Basics$composeR,
																				$elm$core$Maybe$map($author$project$Pages$Panel$Classes$Create$isInvalidDefaultPaymentValue),
																				$elm$core$Maybe$withDefault(true))),
																		'Definir de R$ 0 até R$ 40')
																	]),
																di: $author$project$Utils$formatMoneyInput(
																	$elm$core$String$fromFloat(v))
															})
														]);
												} else {
													break _v0$2;
												}
											}
										}
										return _List_Nil;
									}())
								])),
							A2(
							$author$project$Components$Patterns$Forms$Custom,
							'w-fit',
							_List_fromArray(
								[
									$author$project$Components$Patterns$Forms$Html(
									A2(
										$elm$html$Html$label,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('font-semibold text-purple-main')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Carteira virtual')
											]))),
									$author$project$Components$Patterns$Forms$Checkbox(
									{
										h0: _List_fromArray(
											[
												$elm$html$Html$Attributes$class('flex flex-col ml-2')
											]),
										jk: A2(
											$elm$core$List$map,
											function (wt) {
												return {
													ie: _Utils_eq(wt.dM, form.bI),
													iH: form.L === 2,
													c3: wt.c3,
													jG: $author$project$Pages$Panel$Classes$Create$FormMsg(
														$author$project$Pages$Panel$Classes$Create$ToggleWalletVirtual(wt.dM))
												};
											},
											A2(
												$elm$core$List$filter,
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.cH;
													},
													$elm$core$Basics$not),
												A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, model.eo)))
									})
								])),
							A2(
							$author$project$Components$Patterns$Forms$Custom,
							'w-fit',
							_List_fromArray(
								[
									$author$project$Components$Patterns$Forms$Html(
									A2(
										$elm$html$Html$label,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('font-semibold text-purple-main')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Carteira física')
											]))),
									$author$project$Components$Patterns$Forms$Checkbox(
									{
										h0: _List_fromArray(
											[
												$elm$html$Html$Attributes$class('flex flex-col ml-2')
											]),
										jk: A2(
											$elm$core$List$map,
											function (wt) {
												return {
													ie: _Utils_eq(wt.dM, form.bH),
													iH: form.L === 2,
													c3: wt.c3,
													jG: $author$project$Pages$Panel$Classes$Create$FormMsg(
														$author$project$Pages$Panel$Classes$Create$ToggleWalletPhysical(wt.dM))
												};
											},
											A2(
												$elm$core$List$filter,
												function ($) {
													return $.cH;
												},
												A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, model.eo)))
									}),
									$author$project$Components$Patterns$Forms$Html(
									(A2($author$project$Pages$Panel$Classes$Create$isInvalidWalletTypes, form.bH, form.bI) && (form.L === 1)) ? A2(
										$elm$html$Html$label,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('input-error')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$ul,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$li,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$span,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('text-secondary-error')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Você precisa selecionar pelo menos um tipo de carteira ')
																	]))
															]))
													]))
											])) : $elm$html$Html$text(''))
								])),
							$author$project$Components$Patterns$Forms$Select(
							{
								iH: form.L === 2,
								jl: $elm$core$Maybe$Just('Tipo da classe'),
								jn: _List_Nil,
								jI: $elm$core$Maybe$Just(
									A2($elm$core$Basics$composeL, $author$project$Pages$Panel$Classes$Create$FormMsg, $author$project$Pages$Panel$Classes$Create$SelectedType)),
								jO: _Utils_ap(
									_List_fromArray(
										[
											{eX: form.ba === '', c3: 'Tipo', di: ''}
										]),
									_List_fromArray(
										[
											{eX: form.ba === 'vt', c3: 'VT', di: 'vt'},
											{eX: form.ba === 'beneficiary', c3: 'Beneficiário', di: 'beneficiary'}
										])),
								jQ: false,
								ks: _List_Nil,
								kE: form.L === 1,
								k1: _List_fromArray(
									[
										$author$project$Pages$Panel$Classes$Create$validatorClassType(form.ba)
									])
							}),
							A2(
							$author$project$Components$Patterns$Forms$Custom,
							'w-fit',
							_List_fromArray(
								[
									$author$project$Components$Patterns$Forms$Checkbox(
									{
										h0: _List_Nil,
										jk: _List_fromArray(
											[
												{
												ie: form.at,
												iH: form.L === 2,
												c3: 'Classe ativa',
												jG: $author$project$Pages$Panel$Classes$Create$FormMsg($author$project$Pages$Panel$Classes$Create$ToggleActive)
											}
											])
									})
								])),
							$author$project$Components$Patterns$Forms$Html(
							A2(
								$elm$html$Html$map,
								A2($elm$core$Basics$composeR, $author$project$Pages$Panel$Classes$Create$CompScheduleMsg, $author$project$Pages$Panel$Classes$Create$FormMsg),
								A2($author$project$Components$Schedule$viewGrid, form.al, shared)))
						]),
					oc: $elm$core$Maybe$Nothing,
					pX: ''
				})
			]);
	});
var $author$project$Pages$Panel$Classes$Create$viewRule = F2(
	function (model, shared) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('m-2 p-2 bg-gray-tint3 rounded')
				]),
			A3($author$project$Pages$Panel$Classes$Create$viewRuleConfig, shared, model, model.bp));
	});
var $author$project$Pages$Panel$Classes$Create$viewRules = F2(
	function (model, shared) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Pages$Panel$Classes$Create$viewRule, model, shared)
				]));
	});
var $author$project$Pages$Panel$Classes$Create$viewPage = F2(
	function (model, shared) {
		var isLoading = model.bp.L === 2;
		var btnBack = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('top-actions p-0 ')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('voltar-ico-blue'),
							$elm$html$Html$Attributes$title('Voltar para classes'),
							$elm$html$Html$Events$onClick($author$project$Pages$Panel$Classes$Create$BackToClasses)
						]),
					_List_Nil)
				]));
		var actions = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex gap-2')
				]),
			_List_fromArray(
				[
					A6(
					$author$project$Components$Patterns$Button$textWithLoading,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'width', 'max-content')
						]),
					isLoading,
					isLoading,
					'm-0 px-2 py-2 ',
					'Criar',
					$author$project$Pages$Panel$Classes$Create$FormMsg($author$project$Pages$Panel$Classes$Create$SubmitUpdate))
				]));
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$header,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-row pt-8 pb-4')
						]),
					_List_fromArray(
						[
							btnBack,
							A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-black m-0 content-center')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Criar classe')
								])),
							actions
						])),
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col gap-4 mb-4')
						]),
					_List_fromArray(
						[
							A2($author$project$Pages$Panel$Classes$Create$viewRules, model, shared)
						]))
				]));
	});
var $author$project$Pages$Panel$Classes$Create$view = F2(
	function (model, shared) {
		var viewModal = function () {
			var _v0 = model.aY;
			if (!_v0.$) {
				if (!_v0.a) {
					var _v1 = _v0.a;
					return A2(
						$elm$html$Html$map,
						A2($elm$core$Basics$composeR, $author$project$Pages$Panel$Classes$Create$CompScheduleMsg, $author$project$Pages$Panel$Classes$Create$FormMsg),
						$author$project$Components$Schedule$viewModal(model.bp.al));
				} else {
					var _v2 = _v0.a;
					return $author$project$Pages$Panel$Classes$Create$viewModalUpdateRule(
						{
							aT: _Utils_Tuple2(model.bp.aT, false),
							L: model.bp.L,
							jx: 'Confirmar criação',
							e8: model.bp.b2,
							kM: 'Confirmar',
							kS: shared.kS
						});
				}
			} else {
				return $elm$html$Html$text('');
			}
		}();
		return _Utils_Tuple2(
			'Detalhes da classe',
			_List_fromArray(
				[
					A2($author$project$Pages$Panel$Classes$Create$viewPage, model, shared),
					viewModal
				]));
	});
var $author$project$Pages$Panel$Classes$Details$CloseModal = {$: 6};
var $author$project$Pages$Panel$Classes$Details$GetCurrentDate = {$: 1};
var $author$project$Pages$Panel$Classes$Details$InputtedEffectiveFrom = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Panel$Classes$Details$validatorEffectiveFromDate = F3(
	function (timezone, now, effectiveFrom) {
		var dateTimeInPosix = A2(
			$elm$core$Maybe$withDefault,
			$elm$time$Time$millisToPosix(0),
			A2($author$project$Utils$datetimeLocalHTMLToPosixWithZone, timezone, effectiveFrom));
		return _Utils_cmp(
			$elm$time$Time$posixToMillis(now),
			$elm$time$Time$posixToMillis(dateTimeInPosix)) > -1;
	});
var $author$project$Pages$Panel$Classes$Details$validatorsEffectiveFrom = F2(
	function (timezone, now) {
		return _List_fromArray(
			[
				_Utils_Tuple2($elm$core$String$isEmpty, 'Data de vigência é obrigatório'),
				_Utils_Tuple2(
				A2($author$project$Pages$Panel$Classes$Details$validatorEffectiveFromDate, timezone, now),
				'Data precisa maior que a atual')
			]);
	});
var $author$project$Pages$Panel$Classes$Details$viewModalUpdateRule = function (options) {
	return $author$project$Components$Patterns$Modal$simple(
		{
			hY: $elm$core$Maybe$Just(
				A2($elm$html$Html$Attributes$style, 'min-height', 'fit-content')),
			ii: '',
			il: '',
			ip: $author$project$Pages$Panel$Classes$Details$CloseModal,
			fD: options.jx,
			k4: $author$project$Components$Patterns$Forms$formSimple(
				{
					hZ: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col gap-4'),
							A2($elm$html$Html$Attributes$style, 'width', 'min-content')
						]),
					L: options.L,
					jf: _List_fromArray(
						[
							$author$project$Components$Patterns$Forms$Html(
							A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-gray-600 text-center'),
										A2($elm$html$Html$Attributes$style, 'width', 'fit-content')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Insira a data de início de vigência, para a atualização da regra na classe')
									]))),
							$author$project$Components$Patterns$Forms$Input(
							{
								ie: $elm$core$Maybe$Nothing,
								iH: (options.L === 2) || options.aT.b,
								iP: _List_Nil,
								nR: _List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-black'),
										$elm$html$Html$Attributes$step('1')
									]),
								jl: $elm$core$Maybe$Just('Data de início de vigência'),
								jn: _List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'width', 'fit-content')
									]),
								n9: $elm$core$Maybe$Nothing,
								c3: 'Campo para data de vigência',
								jE: $elm$core$Maybe$Nothing,
								jF: $elm$core$Maybe$Nothing,
								jG: $elm$core$Maybe$Nothing,
								ov: $elm$core$Maybe$Nothing,
								jI: $elm$core$Maybe$Just(
									A2($elm$core$Basics$composeL, $author$project$Pages$Panel$Classes$Details$ModalMsg, $author$project$Pages$Panel$Classes$Details$InputtedEffectiveFrom)),
								hh: 'Insira a data para início de vigência',
								kE: options.L === 1,
								kY: 'datetime-local',
								k1: A2($author$project$Pages$Panel$Classes$Details$validatorsEffectiveFrom, options.kS, options.e8),
								di: options.aT.a
							})
						]),
					oc: $elm$core$Maybe$Just(
						{
							lx: _List_fromArray(
								[
									$elm$html$Html$Attributes$class('self-center w-full')
								]),
							l_: $author$project$Pages$Panel$Classes$Details$ModalMsg($author$project$Pages$Panel$Classes$Details$GetCurrentDate),
							iH: false
						}),
					pX: options.kM
				}),
			k5: $elm$html$Html$text('')
		});
};
var $author$project$Pages$Panel$Classes$Details$BackToClasses = {$: 0};
var $author$project$Components$Patterns$Cards$simple = function (content) {
	return A2(
		$elm$html$Html$article,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('bg-gray-tint2 p-4 w-full')
			]),
		content);
};
var $author$project$Pages$Panel$Classes$Details$viewInfos = function (details) {
	var status = function (bool) {
		return bool ? 'Ativo' : 'Inativo';
	};
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex gap-2')
			]),
		_List_fromArray(
			[
				$author$project$Components$Patterns$Cards$simple(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-gray-main flex flex-col')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$strong,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('font-extrabold')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Nome')
											]))
									])),
								A2(
								$elm$html$Html$strong,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-black font-bold text-lg')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(details.c3)
									]))
							]))
					])),
				$author$project$Components$Patterns$Cards$simple(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-gray-main flex flex-col')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$strong,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('font-extrabold')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Status')
											]))
									])),
								A2(
								$elm$html$Html$strong,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-black font-bold text-lg')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										status(details.at))
									]))
							]))
					])),
				$author$project$Components$Patterns$Cards$simple(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-gray-main flex flex-col')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$strong,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('font-extrabold')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Prioridade')
											]))
									])),
								A2(
								$elm$html$Html$strong,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-black font-bold text-lg')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(details.ch))
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Panel$Classes$Details$SubmitUpdate = {$: 8};
var $author$project$Pages$Panel$Classes$Details$ToggleList = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$Panel$Classes$Details$InputtedMaxCompanions = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Panel$Classes$Details$InputtedMaxDayUseCounter = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Panel$Classes$Details$InputtedMaxMonthUseCounter = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Panel$Classes$Details$InputtedPaymentRole = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$Panel$Classes$Details$InputtedSubsequentUsePeriod = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Panel$Classes$Details$SelectedCompanion = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Panel$Classes$Details$SelectedDefaultPaymentRole = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Panel$Classes$Details$SelectedTwoSteps = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Panel$Classes$Details$valueDefaultPaymentPercent = A2(
	$elm$core$Basics$composeR,
	$elm$core$String$toFloat,
	$elm$core$Maybe$andThen(
		function (i) {
			return $author$project$Pages$Panel$Classes$Details$isInvalidDefaultPaymentPercent(i) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(i);
		}));
var $author$project$Pages$Panel$Classes$Details$valueDefaultPaymentValue = A2(
	$elm$core$Basics$composeR,
	$elm$core$String$filter($elm$core$Char$isDigit),
	A2(
		$elm$core$Basics$composeR,
		$elm$core$String$toFloat,
		$elm$core$Maybe$andThen(
			function (i) {
				return $author$project$Pages$Panel$Classes$Details$isInvalidDefaultPaymentValue(i) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(i);
			})));
var $author$project$Pages$Panel$Classes$Details$viewRuleConfig = F3(
	function (shared, model, form) {
		return _List_fromArray(
			[
				$author$project$Components$Patterns$Forms$formSimple(
				{
					hZ: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-4 flex flex-col gap-5 p-2')
						]),
					L: 0,
					jf: _List_fromArray(
						[
							A2(
							$author$project$Components$Patterns$Forms$Custom,
							'flex flex-col',
							_List_fromArray(
								[
									$author$project$Components$Patterns$Forms$SliderWithInput(
									{
										iH: form.L === 2,
										nR: _List_Nil,
										jl: $elm$core$Maybe$Just('Limite de Uso Diário'),
										jn: _List_fromArray(
											[
												$elm$html$Html$Attributes$class(' w-full')
											]),
										d$: '15',
										e4: '0',
										c3: '',
										jI: $elm$core$Maybe$Just(
											A2($elm$core$Basics$composeL, $author$project$Pages$Panel$Classes$Details$FormMsg, $author$project$Pages$Panel$Classes$Details$InputtedMaxDayUseCounter)),
										kE: form.L === 1,
										hG: '1',
										k1: _List_fromArray(
											[
												_Utils_Tuple2(
												function (str) {
													return A2(
														$elm$core$Maybe$withDefault,
														true,
														A2(
															$elm$core$Maybe$map,
															$author$project$Pages$Panel$Classes$Details$isInvalidMaxDayUseCounter,
															$elm$core$String$toInt(str)));
												},
												'Definir de 0 até 15 limite de uso diário')
											]),
										di: $elm$core$String$fromInt(form.aD)
									}),
									$author$project$Components$Patterns$Forms$Html(
									A2(
										$elm$html$Html$em,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Pode ser de 0 até 15')
											])))
								])),
							A2(
							$author$project$Components$Patterns$Forms$Custom,
							'flex flex-col',
							_List_fromArray(
								[
									$author$project$Components$Patterns$Forms$SliderWithInput(
									{
										iH: form.L === 2,
										nR: _List_Nil,
										jl: $elm$core$Maybe$Just('Limite de Uso Mensal'),
										jn: _List_fromArray(
											[
												$elm$html$Html$Attributes$class(' w-full')
											]),
										d$: '255',
										e4: '0',
										c3: '',
										jI: $elm$core$Maybe$Just(
											A2($elm$core$Basics$composeL, $author$project$Pages$Panel$Classes$Details$FormMsg, $author$project$Pages$Panel$Classes$Details$InputtedMaxMonthUseCounter)),
										kE: form.L === 1,
										hG: '1',
										k1: _List_fromArray(
											[
												_Utils_Tuple2(
												function (str) {
													return A2(
														$elm$core$Maybe$withDefault,
														true,
														A2(
															$elm$core$Maybe$map,
															$author$project$Pages$Panel$Classes$Details$isInvalidMaxMonthUseCounter,
															$elm$core$String$toInt(str)));
												},
												'Definir de 0 até 255 limite de uso mensal')
											]),
										di: $elm$core$String$fromInt(form.ao)
									}),
									$author$project$Components$Patterns$Forms$Html(
									A2(
										$elm$html$Html$em,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Pode ser de 0 até 255')
											])))
								])),
							A2(
							$author$project$Components$Patterns$Forms$Custom,
							'flex flex-col',
							_List_fromArray(
								[
									$author$project$Components$Patterns$Forms$SliderWithInput(
									{
										iH: form.L === 2,
										nR: _List_Nil,
										jl: $elm$core$Maybe$Just('Intervalo de Uso (Minutos)'),
										jn: _List_fromArray(
											[
												$elm$html$Html$Attributes$class(' w-full')
											]),
										d$: '180',
										e4: '0',
										c3: 'Campo para Intervalo de Uso',
										jI: $elm$core$Maybe$Just(
											A2($elm$core$Basics$composeL, $author$project$Pages$Panel$Classes$Details$FormMsg, $author$project$Pages$Panel$Classes$Details$InputtedSubsequentUsePeriod)),
										kE: form.L === 1,
										hG: '1',
										k1: _List_fromArray(
											[
												_Utils_Tuple2(
												function (str) {
													return A2(
														$elm$core$Maybe$withDefault,
														true,
														A2(
															$elm$core$Maybe$map,
															$author$project$Pages$Panel$Classes$Details$isInvalidSubsequentUsePeriod,
															$elm$core$String$toInt(str)));
												},
												'Definir de 0 até 180 para intervalo de uso')
											]),
										di: $elm$core$String$fromInt(form.a7)
									}),
									$author$project$Components$Patterns$Forms$Html(
									A2(
										$elm$html$Html$em,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Pode ser de 0 até 180 minutos')
											])))
								])),
							A2(
							$author$project$Components$Patterns$Forms$Custom,
							'',
							_List_fromArray(
								[
									$author$project$Components$Patterns$Forms$Radio(
									{
										i5: 'two-steps',
										jm: _List_Nil,
										jG: A2($elm$core$Basics$composeL, $author$project$Pages$Panel$Classes$Details$FormMsg, $author$project$Pages$Panel$Classes$Details$SelectedTwoSteps),
										jO: _List_fromArray(
											[
												{ie: form.aM, iH: form.L === 2, dM: 'two-steps-true', c3: 'Sim'},
												{ie: !form.aM, iH: form.L === 2, dM: 'two-steps-false', c3: 'Não'}
											]),
										jP: _List_fromArray(
											[
												$elm$html$Html$Attributes$class('flex gap-2')
											]),
										fD: $elm$core$Maybe$Just('Requer Confirmação do Operador')
									})
								])),
							A2(
							$author$project$Components$Patterns$Forms$Custom,
							'flex flex-col gap-2 w-fit',
							_List_fromArray(
								[
									$author$project$Components$Patterns$Forms$Radio(
									{
										i5: 'companion',
										jm: _List_Nil,
										jG: A2($elm$core$Basics$composeL, $author$project$Pages$Panel$Classes$Details$FormMsg, $author$project$Pages$Panel$Classes$Details$SelectedCompanion),
										jO: _List_fromArray(
											[
												{ie: form.K, iH: form.L === 2, dM: 'companion-true', c3: 'Sim'},
												{ie: !form.K, iH: form.L === 2, dM: 'companion-false', c3: 'Não'}
											]),
										jP: _List_fromArray(
											[
												$elm$html$Html$Attributes$class('flex gap-2')
											]),
										fD: $elm$core$Maybe$Just('Direito a Acompanhante')
									}),
									A2(
									$author$project$Components$Patterns$Forms$Custom,
									'flex items-center pl-4',
									form.K ? _List_fromArray(
										[
											$author$project$Components$Patterns$Forms$Html(
											A2(
												$elm$html$Html$strong,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('text-xl')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$elm$core$String$fromInt(form.aa))
													]))),
											$author$project$Components$Patterns$Forms$Slider(
											{
												iH: form.L === 2,
												nR: _List_Nil,
												jl: $elm$core$Maybe$Just('Quantidade de Acompanhantes'),
												jn: _List_fromArray(
													[
														$elm$html$Html$Attributes$class('ml-4 w-full')
													]),
												d$: '3',
												e4: '1',
												c3: '',
												jI: $elm$core$Maybe$Just(
													A2($elm$core$Basics$composeL, $author$project$Pages$Panel$Classes$Details$FormMsg, $author$project$Pages$Panel$Classes$Details$InputtedMaxCompanions)),
												kE: form.L === 1,
												hG: '1',
												k1: _List_fromArray(
													[
														_Utils_Tuple2(
														A2(
															$elm$core$Basics$composeR,
															$elm$core$String$toInt,
															A2(
																$elm$core$Basics$composeR,
																$elm$core$Maybe$map(
																	$author$project$Pages$Panel$Classes$Details$isInvalidMaxCompanions(form.K)),
																$elm$core$Maybe$withDefault(true))),
														'Definir de 1 até 3 acompanhantes')
													]),
												di: $elm$core$String$fromInt(form.aa)
											})
										]) : _List_Nil),
									A2(
									$author$project$Components$Patterns$Forms$Custom,
									'',
									_List_fromArray(
										[
											$author$project$Components$Patterns$Forms$Radio(
											{
												i5: 'default-payment',
												jm: _List_Nil,
												jG: A2($elm$core$Basics$composeL, $author$project$Pages$Panel$Classes$Details$FormMsg, $author$project$Pages$Panel$Classes$Details$SelectedDefaultPaymentRole),
												jO: _List_fromArray(
													[
														{
														ie: A2($elm$core$Dict$member, 'percent', form.l),
														iH: form.L === 2,
														dM: 'default-payment-true-percent',
														c3: 'Sim - Porcentagem'
													},
														{
														ie: A2($elm$core$Dict$member, 'value', form.l),
														iH: form.L === 2,
														dM: 'default-payment-true-value',
														c3: 'Sim - Valor'
													},
														{
														ie: $elm$core$Dict$isEmpty(form.l),
														iH: form.L === 2,
														dM: 'default-payment-false',
														c3: 'Não'
													}
													]),
												jP: _List_fromArray(
													[
														$elm$html$Html$Attributes$class('flex gap-3')
													]),
												fD: $elm$core$Maybe$Just('Pagamento padrão')
											}),
											$author$project$Components$Patterns$Forms$Html(
											A2(
												$author$project$Pages$Panel$Classes$Details$isInvalidPaymentRule,
												A2(
													$krisajenkins$remotedata$RemoteData$withDefault,
													_List_Nil,
													A2(
														$krisajenkins$remotedata$RemoteData$map,
														A2(
															$elm$core$Basics$composeR,
															$elm$core$List$map(
																function ($) {
																	return $.c7;
																}),
															$elm$core$List$concat),
														form.al.g)),
												form.l) ? A2(
												$elm$html$Html$label,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('input-error')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$ul,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$li,
																_List_Nil,
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$span,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('text-secondary-error')
																			]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text('Você precisa configurar cobrança padrão ou cobrança por período')
																			]))
																	]))
															]))
													])) : $elm$html$Html$text(''))
										])),
									A2(
									$author$project$Components$Patterns$Forms$Custom,
									'flex items-center pl-4',
									function () {
										var _v0 = _Utils_Tuple2(
											A2($elm$core$Dict$get, 'percent', form.l),
											A2($elm$core$Dict$get, 'value', form.l));
										_v0$2:
										while (true) {
											if (!_v0.a.$) {
												if (_v0.b.$ === 1) {
													var v = _v0.a.a;
													var _v1 = _v0.b;
													return _List_fromArray(
														[
															$author$project$Components$Patterns$Forms$Input(
															{
																ie: $elm$core$Maybe$Nothing,
																iH: form.L === 2,
																iP: _List_fromArray(
																	[
																		A2(
																		$elm$html$Html$em,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('text-black')
																			]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text('Pode ser de 0% até 200%')
																			]))
																	]),
																nR: _List_fromArray(
																	[
																		$elm$html$Html$Attributes$min('0'),
																		$elm$html$Html$Attributes$max('200')
																	]),
																jl: $elm$core$Maybe$Just('Porcentagem padrão'),
																jn: _List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('flex flex-col'),
																		A2($elm$html$Html$Attributes$style, 'width', 'fit-content')
																	]),
																n9: $elm$core$Maybe$Just(3),
																c3: '',
																jE: $elm$core$Maybe$Nothing,
																jF: $elm$core$Maybe$Nothing,
																jG: $elm$core$Maybe$Nothing,
																ov: $elm$core$Maybe$Nothing,
																jI: $elm$core$Maybe$Just(
																	A2(
																		$elm$core$Basics$composeL,
																		$author$project$Pages$Panel$Classes$Details$FormMsg,
																		A2(
																			$elm$core$Basics$composeR,
																			$author$project$Pages$Panel$Classes$Details$valueDefaultPaymentPercent,
																			$author$project$Pages$Panel$Classes$Details$InputtedPaymentRole('percent')))),
																hh: '%',
																kE: form.L === 1,
																kY: 'text',
																k1: _List_fromArray(
																	[
																		_Utils_Tuple2(
																		function (_v2) {
																			return A2(
																				$author$project$Pages$Panel$Classes$Details$isInvalidPaymentRule,
																				A2(
																					$krisajenkins$remotedata$RemoteData$withDefault,
																					_List_Nil,
																					A2(
																						$krisajenkins$remotedata$RemoteData$map,
																						A2(
																							$elm$core$Basics$composeR,
																							$elm$core$List$map(
																								function ($) {
																									return $.c7;
																								}),
																							$elm$core$List$concat),
																						form.al.g)),
																				form.l);
																		},
																		'Configurar cobrança padrão ou cobrança por período'),
																		_Utils_Tuple2(
																		A2(
																			$elm$core$Basics$composeR,
																			$elm$core$String$toFloat,
																			A2(
																				$elm$core$Basics$composeR,
																				$elm$core$Maybe$map($author$project$Pages$Panel$Classes$Details$isInvalidDefaultPaymentPercent),
																				$elm$core$Maybe$withDefault(true))),
																		'Definir de 0% até 200%')
																	]),
																di: $elm$core$String$fromFloat(v)
															})
														]);
												} else {
													break _v0$2;
												}
											} else {
												if (!_v0.b.$) {
													var _v3 = _v0.a;
													var v = _v0.b.a;
													return _List_fromArray(
														[
															$author$project$Components$Patterns$Forms$Input(
															{
																ie: $elm$core$Maybe$Nothing,
																iH: form.L === 2,
																iP: _List_fromArray(
																	[
																		A2(
																		$elm$html$Html$em,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('text-black')
																			]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text('Pode ser de R$ 0 até R$ 40')
																			]))
																	]),
																nR: _List_Nil,
																jl: $elm$core$Maybe$Just('Valor padrão em Reais'),
																jn: _List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('flex flex-col'),
																		A2($elm$html$Html$Attributes$style, 'width', 'fit-content')
																	]),
																n9: $elm$core$Maybe$Just(5),
																c3: '',
																jE: $elm$core$Maybe$Nothing,
																jF: $elm$core$Maybe$Nothing,
																jG: $elm$core$Maybe$Nothing,
																ov: $elm$core$Maybe$Nothing,
																jI: $elm$core$Maybe$Just(
																	A2(
																		$elm$core$Basics$composeL,
																		$author$project$Pages$Panel$Classes$Details$FormMsg,
																		A2(
																			$elm$core$Basics$composeR,
																			$author$project$Pages$Panel$Classes$Details$valueDefaultPaymentValue,
																			$author$project$Pages$Panel$Classes$Details$InputtedPaymentRole('value')))),
																hh: 'R$',
																kE: form.L === 1,
																kY: 'text',
																k1: _List_fromArray(
																	[
																		_Utils_Tuple2(
																		function (_v4) {
																			return A2(
																				$author$project$Pages$Panel$Classes$Details$isInvalidPaymentRule,
																				A2(
																					$krisajenkins$remotedata$RemoteData$withDefault,
																					_List_Nil,
																					A2(
																						$krisajenkins$remotedata$RemoteData$map,
																						A2(
																							$elm$core$Basics$composeR,
																							$elm$core$List$map(
																								function ($) {
																									return $.c7;
																								}),
																							$elm$core$List$concat),
																						form.al.g)),
																				form.l);
																		},
																		'Configurar cobrança padrão ou cobrança por período'),
																		_Utils_Tuple2(
																		A2(
																			$elm$core$Basics$composeR,
																			$elm$core$String$toFloat,
																			A2(
																				$elm$core$Basics$composeR,
																				$elm$core$Maybe$map($author$project$Pages$Panel$Classes$Details$isInvalidDefaultPaymentValue),
																				$elm$core$Maybe$withDefault(true))),
																		'Definir de R$ 0 até R$ 40')
																	]),
																di: $author$project$Utils$formatMoneyInput(
																	$elm$core$String$fromFloat(v))
															})
														]);
												} else {
													break _v0$2;
												}
											}
										}
										return _List_Nil;
									}())
								])),
							$author$project$Components$Patterns$Forms$Html(
							A2(
								$elm$html$Html$map,
								A2($elm$core$Basics$composeR, $author$project$Pages$Panel$Classes$Details$CompScheduleMsg, $author$project$Pages$Panel$Classes$Details$FormMsg),
								A2($author$project$Components$Schedule$viewGrid, form.al, shared)))
						]),
					oc: $elm$core$Maybe$Nothing,
					pX: ''
				})
			]);
	});
var $author$project$Pages$Panel$Classes$Details$viewRule = F3(
	function (model, shared, details) {
		var isLoading = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (f) {
					return f.L === 2;
				},
				model.bp));
		var actions = function (k) {
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.db;
						},
						$elm$core$Basics$eq(k)),
					model.bp)) ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex gap-2')
					]),
				_List_fromArray(
					[
						A6(
						$author$project$Components$Patterns$Button$textWithLoading,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'width', 'max-content')
							]),
						isLoading,
						isLoading,
						'm-0 px-2 py-2 ',
						'Atualizar',
						$author$project$Pages$Panel$Classes$Details$FormMsg($author$project$Pages$Panel$Classes$Details$SubmitUpdate))
					])) : $elm$html$Html$text('');
		};
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col gap-1')
				]),
			A2(
				$elm$core$List$map,
				function (_v0) {
					var k = _v0.a;
					var rule = _v0.b;
					var isoDecoder = A2(
						$elm$core$Result$withDefault,
						'',
						A2(
							$elm$core$Result$map,
							function (posix) {
								return A2($author$project$Utils$formatDateTimeFromPosixWithSeconds, shared.kS, posix);
							},
							$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(k)));
					return A2(
						$elm$html$Html$li,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('bg-gray-tint1  ')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex items-center px-2 py-2')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-black  cursor-pointer'),
												$elm$html$Html$Events$onClick(
												A2($author$project$Pages$Panel$Classes$Details$ToggleList, k, rule))
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$strong,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('font-bold')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Início de vigência: ')
													])),
												A2(
												$elm$html$Html$em,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(isoDecoder)
													])),
												A2(
												$elm$html$Html$strong,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('font-bold')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(' | ')
													])),
												A2(
												$elm$html$Html$strong,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('font-bold')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Criado por: ')
													])),
												A2(
												$elm$html$Html$em,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2(
															$elm$core$Maybe$withDefault,
															'-',
															A2(
																$elm$core$Maybe$map,
																function ($) {
																	return $.c3;
																},
																rule.kZ)))
													]))
											])),
										actions(k)
									])),
								A2(
								$elm$core$Maybe$withDefault,
								$elm$html$Html$text(''),
								A2(
									$elm$core$Maybe$map,
									function (f) {
										return _Utils_eq(f.db, k) ? A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('m-2 p-2 bg-gray-tint3 rounded')
												]),
											A3($author$project$Pages$Panel$Classes$Details$viewRuleConfig, shared, model, f)) : $elm$html$Html$text('');
									},
									model.bp))
							]));
				},
				$elm$core$List$reverse(
					A2(
						$elm$core$List$sortBy,
						$elm$core$Tuple$first,
						$elm$core$Dict$toList(details.py)))));
	});
var $author$project$Pages$Panel$Classes$Details$viewRules = F3(
	function (model, shared, details) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A3($author$project$Pages$Panel$Classes$Details$viewRule, model, shared, details)
				]));
	});
var $author$project$Pages$Panel$Classes$Details$viewPage = F2(
	function (model, shared) {
		var btnBack = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('top-actions p-0 ')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('voltar-ico-blue'),
							$elm$html$Html$Attributes$title('Voltar para classes'),
							$elm$html$Html$Events$onClick($author$project$Pages$Panel$Classes$Details$BackToClasses)
						]),
					_List_Nil)
				]));
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$header,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-row pt-8')
						]),
					_List_fromArray(
						[
							btnBack,
							A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-black m-0 content-center')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Detalhes')
								]))
						])),
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col gap-4 mb-4')
						]),
					function () {
						var _v0 = model.cI;
						switch (_v0.$) {
							case 1:
								return _List_fromArray(
									[$author$project$Components$View$loading]);
							case 3:
								var details = _v0.a;
								return _List_fromArray(
									[
										$author$project$Pages$Panel$Classes$Details$viewInfos(details),
										A3($author$project$Pages$Panel$Classes$Details$viewRules, model, shared, details)
									]);
							case 0:
								return _List_Nil;
							default:
								var e = _v0.a;
								return _List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Algo deu errado!')
											]))
									]);
						}
					}())
				]));
	});
var $author$project$Pages$Panel$Classes$Details$view = F2(
	function (model, shared) {
		var viewModal = function () {
			var _v0 = model.aY;
			if (!_v0.$) {
				if (_v0.a.$ === 1) {
					var _v1 = _v0.a;
					return A2(
						$elm$core$Maybe$withDefault,
						$elm$html$Html$text(''),
						A2(
							$elm$core$Maybe$map,
							function (f) {
								return A2(
									$elm$html$Html$map,
									A2($elm$core$Basics$composeR, $author$project$Pages$Panel$Classes$Details$CompScheduleMsg, $author$project$Pages$Panel$Classes$Details$FormMsg),
									$author$project$Components$Schedule$viewModal(f.al));
							},
							model.bp));
				} else {
					var m = _v0.a.a;
					return $author$project$Pages$Panel$Classes$Details$viewModalUpdateRule(
						{
							aT: _Utils_Tuple2(m.aT, false),
							L: m.L,
							jx: 'Confirmar Atualização',
							e8: m.b2,
							kM: 'Confirmar',
							kS: shared.kS
						});
				}
			} else {
				return $elm$html$Html$text('');
			}
		}();
		return _Utils_Tuple2(
			'Detalhes da classe',
			_List_fromArray(
				[
					A2($author$project$Pages$Panel$Classes$Details$viewPage, model, shared),
					viewModal
				]));
	});
var $author$project$Components$Patterns$Tables$dragAndDrop = function (opts) {
	var cssTableDefaultPanel = opts.nX ? _List_fromArray(
		[
			$elm$html$Html$Attributes$class('overflow-x-auto'),
			A2($elm$html$Html$Attributes$style, 'width', 'calc(100vw - 23rem)')
		]) : _List_Nil;
	return A2(
		$elm$html$Html$div,
		cssTableDefaultPanel,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$table,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id('draggable-table'),
						A2($elm$html$Html$Attributes$attribute, 'cellspacing', '0'),
						$elm$html$Html$Attributes$class('data-table-dashboard my-4')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$tr,
								_List_Nil,
								A2(
									$elm$core$List$map,
									function (header) {
										return A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(header)
												]));
									},
									opts.nF))
							])),
						A2(
						$elm$html$Html$tbody,
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (_v0) {
								var trID = _v0.a;
								var record = _v0.b;
								return A2(
									$elm$html$Html$tr,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$id(trID),
											$elm$html$Html$Attributes$class('cursor-pointer')
										]),
									record);
							},
							opts.pj))
					]))
			]));
};
var $author$project$Pages$Panel$Classes$List$CancelUpdate = {$: 4};
var $author$project$Pages$Panel$Classes$List$GoNewClass = {$: 6};
var $author$project$Pages$Panel$Classes$List$SubmitUpdate = {$: 3};
var $author$project$Pages$Panel$Classes$List$viewAction = F2(
	function (user, model) {
		return A2(
			$krisajenkins$remotedata$RemoteData$withDefault,
			$elm$html$Html$text(''),
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				function (list) {
					return _Utils_eq(list, model.dN) ? $author$project$Services$Models$iHaveAccess(
						{
							gZ: user.hg,
							hf: $author$project$Services$Models$CLASS(0),
							hQ: A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex justify-end')
									]),
								_List_fromArray(
									[
										A6(
										$author$project$Components$Patterns$Button$textWithLoading,
										_List_fromArray(
											[
												A2($elm$html$Html$Attributes$style, 'width', 'max-content'),
												$elm$html$Html$Attributes$class('self-center ')
											]),
										false,
										false,
										'm-0 px-2 py-2 ',
										'Nova classe',
										$author$project$Pages$Panel$Classes$List$GoNewClass)
									])),
							hR: $elm$html$Html$text('')
						}) : A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex gap-4')
							]),
						_List_fromArray(
							[
								A6(
								$author$project$Components$Patterns$Button$textWithLoading,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'width', 'max-content')
									]),
								model.dP,
								model.dP,
								'm-0 px-4',
								'Atualizar',
								$author$project$Pages$Panel$Classes$List$SubmitUpdate),
								A6(
								$author$project$Components$Patterns$Button$textWithLoading,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'width', 'max-content')
									]),
								model.dP,
								model.dP,
								'action-system m-0 px-4 white-btn',
								'Cancelar',
								$author$project$Pages$Panel$Classes$List$CancelUpdate)
							]));
				},
				model.ck));
	});
var $author$project$Pages$Panel$Classes$List$ClickedDetails = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Panel$Classes$List$viewCells = F2(
	function (attr, c) {
		var status = function (active) {
			return active ? 'Ativo' : 'Inativo';
		};
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[attr]),
				_List_fromArray(
					[
						$elm$html$Html$text(c.c3)
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[attr]),
				_List_fromArray(
					[
						$elm$html$Html$text(c.kY)
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[attr]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						status(c.at))
					]))
			]);
	});
var $author$project$Pages$Panel$Classes$List$viewRowClassEdit = function (classe) {
	var clickMsg = $elm$html$Html$Events$onClick(
		$author$project$Pages$Panel$Classes$List$ClickedDetails(classe.k8));
	return _Utils_Tuple2(
		classe.k8,
		A2($author$project$Pages$Panel$Classes$List$viewCells, clickMsg, classe));
};
var $author$project$Pages$Panel$Classes$List$viewRowNoClassEdit = function (classe) {
	return A2(
		$author$project$Pages$Panel$Classes$List$viewCells,
		$elm$html$Html$Attributes$class(''),
		classe);
};
var $author$project$Pages$Panel$Classes$List$viewPage = F2(
	function (user, model) {
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-black  mb-4')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Classes')
						])),
					A2($author$project$Pages$Panel$Classes$List$viewAction, user, model),
					A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Services$Models$iHaveAccess(
							{
								gZ: user.hg,
								hf: $author$project$Services$Models$CLASS(0),
								hQ: $author$project$Components$Patterns$Tables$dragAndDrop(
									{
										nF: _List_fromArray(
											['Nome', 'Tipo', 'Status']),
										nX: true,
										pj: A2(
											$krisajenkins$remotedata$RemoteData$withDefault,
											_List_Nil,
											A2(
												$krisajenkins$remotedata$RemoteData$map,
												$elm$core$List$map($author$project$Pages$Panel$Classes$List$viewRowClassEdit),
												model.ck))
									}),
								hR: $author$project$Components$Patterns$Tables$default(
									{
										nF: _List_fromArray(
											['Nome', 'Tipo', 'Status']),
										nX: true,
										pj: A2(
											$krisajenkins$remotedata$RemoteData$withDefault,
											_List_Nil,
											A2(
												$krisajenkins$remotedata$RemoteData$map,
												$elm$core$List$map($author$project$Pages$Panel$Classes$List$viewRowNoClassEdit),
												model.ck))
									})
							}),
							function () {
							var _v0 = model.ck;
							switch (_v0.$) {
								case 3:
									var classes = _v0.a;
									return $elm$html$Html$text('');
								case 0:
									return $elm$html$Html$text('Processo de inicialização não foi executado!');
								case 1:
									return $author$project$Components$View$loading;
								default:
									var e = _v0.a;
									return $elm$html$Html$text('Algo deu errado: ' + e);
							}
						}()
						]))
				]));
	});
var $author$project$Pages$Panel$Classes$List$view = F3(
	function (model, shared, user) {
		var viewModal = $elm$html$Html$text('');
		return _Utils_Tuple2(
			'Classes',
			_List_fromArray(
				[
					A2($author$project$Pages$Panel$Classes$List$viewPage, user, model),
					viewModal
				]));
	});
var $author$project$Pages$Panel$Classes$SubPage$view = F3(
	function (model, shared, user) {
		switch (model.$) {
			case 0:
				var model_ = model.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$List$map(
						$elm$html$Html$map($author$project$Pages$Panel$Classes$SubPage$ClassesListMsg)),
					A3($author$project$Pages$Panel$Classes$List$view, model_, shared, user));
			case 1:
				var model_ = model.a;
				return $author$project$Services$Models$iHaveAccess(
					{
						gZ: user.hg,
						hf: $author$project$Services$Models$CLASS(0),
						hQ: A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$List$map(
								$elm$html$Html$map($author$project$Pages$Panel$Classes$SubPage$ClassesDetailsMsg)),
							A2($author$project$Pages$Panel$Classes$Details$view, model_, shared)),
						hR: _Utils_Tuple2(
							'Sem acesso!',
							_List_fromArray(
								[
									$elm$html$Html$text('Você não tem permissão para acessar essa tela!')
								]))
					});
			default:
				var model_ = model.a;
				return $author$project$Services$Models$iHaveAccess(
					{
						gZ: user.hg,
						hf: $author$project$Services$Models$CLASS(0),
						hQ: A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$List$map(
								$elm$html$Html$map($author$project$Pages$Panel$Classes$SubPage$ClassesCreateMsg)),
							A2($author$project$Pages$Panel$Classes$Create$view, model_, shared)),
						hR: _Utils_Tuple2(
							'Sem acesso!',
							_List_fromArray(
								[
									$elm$html$Html$text('Você não tem permissão para acessar essa tela!')
								]))
					});
		}
	});
var $author$project$Pages$Panel$EquipmentsV2$InputtedSerial = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Panel$EquipmentsV2$InputtedVehicle = function (a) {
	return {$: 4, a: a};
};
var $author$project$Services$Equipments$deviceVersionTypeToBRL = function (type_) {
	switch (type_) {
		case 0:
			return 'Bloqueios';
		case 1:
			return 'Cargas';
		default:
			return 'Migração';
	}
};
var $author$project$Pages$Panel$EquipmentsV2$viewCurrentLists = function (deviceVersions) {
	var filter = F2(
		function (a, b) {
			var _v0 = _Utils_Tuple2(a.kY, b.kY);
			_v0$1:
			while (true) {
				_v0$2:
				while (true) {
					switch (_v0.a) {
						case 1:
							switch (_v0.b) {
								case 1:
									var _v1 = _v0.a;
									var _v2 = _v0.b;
									return 1;
								case 0:
									break _v0$1;
								default:
									break _v0$1;
							}
						case 0:
							switch (_v0.b) {
								case 1:
									break _v0$2;
								case 0:
									var _v5 = _v0.a;
									var _v6 = _v0.b;
									return 1;
								default:
									var _v7 = _v0.a;
									return 0;
							}
						default:
							switch (_v0.b) {
								case 1:
									break _v0$2;
								case 0:
									var _v8 = _v0.b;
									return 2;
								default:
									var _v9 = _v0.a;
									var _v10 = _v0.b;
									return 1;
							}
					}
				}
				var _v4 = _v0.b;
				return 2;
			}
			var _v3 = _v0.a;
			return 0;
		});
	var filtered = A2($elm$core$List$sortWith, filter, deviceVersions);
	var content_ = function (d) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-gray-main flex flex-col')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Quantidade atual de listas de '),
								A2(
								$elm$html$Html$strong,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('font-extrabold')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Services$Equipments$deviceVersionTypeToBRL(d.kY))
									]))
							])),
						A2(
						$elm$html$Html$strong,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-black font-bold text-lg')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(d.k3))
							]))
					]))
			]);
	};
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex flex-col gap-4')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex gap-4')
					]),
				A2(
					$elm$core$List$map,
					A2($elm$core$Basics$composeL, $author$project$Components$Patterns$Cards$simple, content_),
					filtered)),
				A2(
				$elm$html$Html$em,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('font-semibold text-purple-main')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Se o número na listagem for menor, ele será destacado em vermelho para indicar que está faltando listas.')
					]))
			]));
};
var $author$project$Pages$Panel$EquipmentsV2$algorithmToFilter = F2(
	function (queries, list) {
		var filtered = F3(
			function (filter, key, list_) {
				return A2(
					$elm$core$Maybe$withDefault,
					list_,
					A2(
						$elm$core$Maybe$map,
						function (queryName) {
							return A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									filter,
									A2(
										$elm$core$Basics$composeR,
										$elm$core$String$toLower,
										$elm$core$String$contains(queryName))),
								list);
						},
						key));
			});
		return A3(
			filtered,
			function ($) {
				return $.k0;
			},
			A2($elm$core$Maybe$map, $elm$core$String$toLower, queries.kw),
			A3(
				filtered,
				function ($) {
					return $.em;
				},
				A2($elm$core$Maybe$map, $elm$core$String$toLower, queries.k2),
				list));
	});
var $author$project$Components$Patterns$Tables$headerAndRecordsCustomizableWithFixedHeader = function (opts) {
	var cssTableDefaultPanel = opts.nX ? _List_fromArray(
		[
			$elm$html$Html$Attributes$class('overflow-x-auto'),
			A2($elm$html$Html$Attributes$style, 'width', 'calc(100vw - 23rem)')
		]) : _List_Nil;
	return A2(
		$elm$html$Html$div,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('table-fixed-header')
				]),
			cssTableDefaultPanel),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$table,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'cellspacing', '0'),
						$elm$html$Html$Attributes$class('data-table-dashboard my-4')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$tr,
								_List_Nil,
								A2(
									$elm$core$List$map,
									function (header) {
										return header;
									},
									opts.nF))
							])),
						A2(
						$elm$html$Html$tbody,
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (record) {
								return A2($elm$html$Html$tr, _List_Nil, record);
							},
							opts.pj))
					]))
			]));
};
var $author$project$Pages$Panel$EquipmentsV2$getListVersion = F2(
	function (list, type_) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.k3;
				},
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.kY;
						},
						$elm$core$Basics$eq(type_)),
					list)));
	});
var $author$project$Pages$Panel$EquipmentsV2$viewRecord = F3(
	function (timezone, devicesVersion, record) {
		var maybeValue = function (maybeV) {
			return A2($elm$core$Maybe$withDefault, '-', maybeV);
		};
		var emptyValue = function (str) {
			return $elm$core$String$isEmpty(str) ? '-' : str;
		};
		var cellWithVersion = F2(
			function (type_, currentVersion) {
				return A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (v) {
							return (_Utils_cmp(currentVersion, v) < 0) ? _List_fromArray(
								[
									$elm$html$Html$Attributes$class('font-black text-red-500 cursor-help'),
									$elm$html$Html$Attributes$title('Está faltando listas.')
								]) : _List_Nil;
						},
						A2($author$project$Pages$Panel$EquipmentsV2$getListVersion, devicesVersion, type_)));
			});
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						maybeValue(
							A2(
								$elm$core$Maybe$map,
								$author$project$Utils$formatDateTimeFromPosix(timezone),
								record.jo)))
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(record.k0)
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						emptyValue(record.kG))
					])),
				A2(
				$elm$html$Html$td,
				A2(cellWithVersion, 1, record.fn),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm$core$String$fromInt(record.fn))
					])),
				A2(
				$elm$html$Html$td,
				A2(cellWithVersion, 0, record.h5),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm$core$String$fromInt(record.h5))
					])),
				A2(
				$elm$html$Html$td,
				A2(cellWithVersion, 2, record.kL),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm$core$String$fromInt(record.kL))
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						maybeValue(
							A2($elm$core$Maybe$map, $elm$core$String$fromInt, record.D)))
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						emptyValue(
							maybeValue(record.kK)))
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						emptyValue(
							maybeValue(record.mT)))
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						emptyValue(
							maybeValue(record.mU)))
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						maybeValue(
							A2(
								$elm$core$Maybe$map,
								$author$project$Utils$formatDateTimeFromPosix(timezone),
								record.qB)))
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						emptyValue(record.em))
					]))
			]);
	});
var $author$project$Pages$Panel$EquipmentsV2$viewTable = F4(
	function (timezone, deviceVersions, equipments, queries) {
		var viewHeader = function (colum) {
			return A2(
				$elm$html$Html$th,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(colum)
					]));
		};
		var headers = _List_fromArray(
			[
				viewHeader('Última Comunicação'),
				viewHeader('Serial Validador'),
				viewHeader('Versão'),
				viewHeader('Lista Cargas'),
				viewHeader('Lista Bloqueios'),
				viewHeader('Lista Migração'),
				viewHeader('Eventos'),
				viewHeader('Status'),
				viewHeader('Serial EB1'),
				viewHeader('Versão EB1'),
				viewHeader('Data Validador'),
				viewHeader('Veículo')
			]);
		var equipmentsOrder = A2(
			$elm$core$List$sortBy,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.jo;
				},
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Maybe$map($elm$time$Time$posixToMillis),
					$elm$core$Maybe$withDefault(9999999999999))),
			equipments);
		var recordsFiltered = A2($author$project$Pages$Panel$EquipmentsV2$algorithmToFilter, queries, equipmentsOrder);
		var viewRecords = A2(
			$elm$core$List$map,
			A2($author$project$Pages$Panel$EquipmentsV2$viewRecord, timezone, deviceVersions),
			recordsFiltered);
		return $author$project$Components$Patterns$Tables$headerAndRecordsCustomizableWithFixedHeader(
			{nF: headers, nX: true, pj: viewRecords});
	});
var $author$project$Pages$Panel$EquipmentsV2$viewPage = F3(
	function (model, shared, user) {
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard flex flex-col gap-4')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'color', 'black'),
							$elm$html$Html$Attributes$class('inner-center mb-4 mt-4')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Status de comunicação')
						])),
					A2(
					$krisajenkins$remotedata$RemoteData$withDefault,
					$elm$html$Html$text(''),
					A2($krisajenkins$remotedata$RemoteData$map, $author$project$Pages$Panel$EquipmentsV2$viewCurrentLists, model.dF)),
					$author$project$Components$Patterns$Forms$filtersWithoutSendButton(
					{
						mM: !$krisajenkins$remotedata$RemoteData$isSuccess(model.cU),
						jf: _List_fromArray(
							[
								{
								nS: 'bg-busca',
								n_: '',
								jI: $author$project$Pages$Panel$EquipmentsV2$InputtedSerial,
								hh: 'Serial',
								kY: 'text',
								di: A2($elm$core$Maybe$withDefault, '', model.T.kw)
							},
								{
								nS: 'bg-busca',
								n_: '',
								jI: $author$project$Pages$Panel$EquipmentsV2$InputtedVehicle,
								hh: 'Veículo',
								kY: 'text',
								di: A2($elm$core$Maybe$withDefault, '', model.T.k2)
							}
							])
					}),
					function () {
					var _v0 = _Utils_Tuple2(model.cU, model.dF);
					switch (_v0.a.$) {
						case 0:
							var _v1 = _v0.a;
							return $elm$html$Html$text('');
						case 1:
							var _v2 = _v0.a;
							return $author$project$Components$View$loading;
						case 2:
							var err = _v0.a.a;
							return $elm$html$Html$text(err);
						default:
							if (!_v0.a.a.b) {
								return $elm$html$Html$text('Nenhum histórico encontrado.');
							} else {
								if (_v0.b.$ === 3) {
									var deviceStatus = _v0.a.a;
									var deviceListVersion = _v0.b.a;
									return A4($author$project$Pages$Panel$EquipmentsV2$viewTable, shared.kS, deviceListVersion, deviceStatus, model.T);
								} else {
									var deviceStatus = _v0.a.a;
									return A4($author$project$Pages$Panel$EquipmentsV2$viewTable, shared.kS, _List_Nil, deviceStatus, model.T);
								}
							}
					}
				}()
				]));
	});
var $author$project$Pages$Panel$EquipmentsV2$view = F3(
	function (model, shared, user) {
		return _Utils_Tuple2(
			'Equipamentos',
			_List_fromArray(
				[
					A3($author$project$Pages$Panel$EquipmentsV2$viewPage, model, shared, user),
					$elm$html$Html$text('')
				]));
	});
var $author$project$Pages$Panel$Financial$Account$CloseModal = {$: 11};
var $author$project$Pages$Panel$Financial$Account$InputtedAmountToWithdraw = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Panel$Financial$Account$ModalMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Panel$Financial$Account$SubmittedToWithdraw = {$: 1};
var $author$project$Pages$Panel$Financial$Account$isPossibleToWithdraw = function (amount) {
	return amount >= 1000;
};
var $author$project$Pages$Panel$Financial$Account$viewModal = F3(
	function (rdInfo, maybeModal, model) {
		var _v0 = _Utils_Tuple3(rdInfo, maybeModal, model.bQ.aY);
		if (!_v0.c.$) {
			var m_ = _v0.c.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Pages$Panel$Financial$Account$CompPDFCreateMSg,
				$author$project$Components$PDF$Create$viewModal(m_));
		} else {
			if ((_v0.a.$ === 3) && (!_v0.b.$)) {
				var info = _v0.a.a;
				var m = _v0.b.a;
				var _v1 = _v0.c;
				var showError = m.cx === 1;
				var amountFieldToInt = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(m.aP));
				var disabledSubmit = $author$project$Pages$Panel$Financial$Account$isPossibleToWithdraw(amountFieldToInt) && (_Utils_cmp(amountFieldToInt, info.bN) < 1);
				return $author$project$Components$Patterns$Modal$simple(
					{
						hY: $elm$core$Maybe$Just(
							A2($elm$html$Html$Attributes$style, 'min-height', 'fit-content')),
						ii: '',
						il: '',
						ip: $author$project$Pages$Panel$Financial$Account$CloseModal,
						fD: 'Sacar valor para conta bancária',
						k4: $author$project$Components$Patterns$Forms$formSimple(
							{
								hZ: _List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex flex-col gap-2')
									]),
								L: m.cx,
								jf: _List_fromArray(
									[
										$author$project$Components$Patterns$Forms$Input(
										{
											ie: $elm$core$Maybe$Nothing,
											iH: false,
											iP: _List_Nil,
											nR: _List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'width', 'fit-content'),
													$elm$html$Html$Attributes$class('text-center')
												]),
											jl: $elm$core$Maybe$Just('Valor'),
											jn: _List_fromArray(
												[
													$elm$html$Html$Attributes$class('flex flex-col items-center')
												]),
											n9: $elm$core$Maybe$Just(15),
											c3: 'Valor',
											jE: $elm$core$Maybe$Nothing,
											jF: $elm$core$Maybe$Nothing,
											jG: $elm$core$Maybe$Nothing,
											ov: $elm$core$Maybe$Nothing,
											jI: $elm$core$Maybe$Just(
												A2(
													$elm$core$Basics$composeL,
													A2($elm$core$Basics$composeL, $author$project$Pages$Panel$Financial$Account$ModalMsg, $author$project$Pages$Panel$Financial$Account$InputtedAmountToWithdraw),
													$elm$core$String$filter($elm$core$Char$isDigit))),
											hh: 'Insira a quantidade que deseja sacar',
											kE: showError,
											kY: 'text',
											k1: _List_fromArray(
												[
													_Utils_Tuple2(
													A2(
														$elm$core$Basics$composeR,
														$elm$core$String$filter($elm$core$Char$isDigit),
														$author$project$Pages$Panel$Financial$Account$isGreaterThanMaximum(info.bN)),
													'O valor máximo para sacar é de ' + $author$project$Utils$formatAsMoney(
														$elm$core$String$fromInt(info.bN))),
													_Utils_Tuple2(
													A2(
														$elm$core$Basics$composeR,
														$elm$core$String$filter($elm$core$Char$isDigit),
														$author$project$Pages$Panel$Financial$Account$isLessMinimum),
													'O mínimo para sacar é de R$10,00')
												]),
											di: $author$project$Utils$formatMoneyInput(m.aP)
										})
									]),
								oc: $elm$core$Maybe$Just(
									{
										lx: _List_Nil,
										l_: $author$project$Pages$Panel$Financial$Account$ModalMsg($author$project$Pages$Panel$Financial$Account$SubmittedToWithdraw),
										iH: $elm$core$String$isEmpty(m.aP)
									}),
								pX: 'Solicitar saque'
							}),
						k5: $elm$html$Html$text('')
					});
			} else {
				return $elm$html$Html$text('');
			}
		}
	});
var $author$project$Pages$Panel$Financial$Account$viewCurrentBalance = function (availableAmount) {
	return A2(
		$elm$html$Html$article,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('bg-gray-tint2 p-4 w-full')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-gray-main flex flex-col')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Saldo atual'),
						A2(
						$elm$html$Html$strong,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-black font-bold text-lg')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Utils$formatAsMoney(
									$elm$core$String$fromInt(availableAmount)))
							])),
						A2(
						$elm$html$Html$em,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Disponível para sacar')
							]))
					]))
			]));
};
var $author$project$Pages$Panel$Financial$Account$ClickedGenerateReport = F3(
	function (a, b, c) {
		return {$: 12, a: a, b: b, c: c};
	});
var $author$project$Services$Pdf$FinancialAccount = 7;
var $author$project$Pages$Panel$Financial$Account$InputtedEndDate = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Panel$Financial$Account$InputtedStartDate = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Panel$Financial$Account$Submit = {$: 4};
var $author$project$Pages$Panel$Financial$Account$valueNotEmpty = function (str) {
	return $elm$core$String$isEmpty(str) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(str);
};
var $author$project$Pages$Panel$Financial$Account$viewFilters = function (model) {
	var hasPeriodCSV = A2(
		$krisajenkins$remotedata$RemoteData$withDefault,
		false,
		A2(
			$krisajenkins$remotedata$RemoteData$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.iC;
				},
				A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not)),
			model.cE));
	var filters = _List_fromArray(
		[
			$author$project$Components$Patterns$Forms$Input(
			{
				ie: $elm$core$Maybe$Nothing,
				iH: model.L === 2,
				iP: _List_Nil,
				nR: _List_fromArray(
					[
						$elm$html$Html$Attributes$size(10)
					]),
				jl: $elm$core$Maybe$Just('Início'),
				jn: _List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex flex-col'),
						A2($elm$html$Html$Attributes$style, 'width', 'min-content')
					]),
				n9: $elm$core$Maybe$Just(10),
				c3: '',
				jE: $elm$core$Maybe$Nothing,
				jF: $elm$core$Maybe$Nothing,
				jG: $elm$core$Maybe$Nothing,
				ov: $elm$core$Maybe$Nothing,
				jI: $elm$core$Maybe$Just(
					A2($elm$core$Basics$composeR, $author$project$Pages$Panel$Financial$Account$valueNotEmpty, $author$project$Pages$Panel$Financial$Account$InputtedStartDate)),
				hh: 'Início',
				kE: model.L === 1,
				kY: 'date',
				k1: _List_Nil,
				di: A2($elm$core$Maybe$withDefault, '', model.T.bB)
			}),
			$author$project$Components$Patterns$Forms$Input(
			{
				ie: $elm$core$Maybe$Nothing,
				iH: model.L === 2,
				iP: _List_Nil,
				nR: _List_fromArray(
					[
						$elm$html$Html$Attributes$size(10)
					]),
				jl: $elm$core$Maybe$Just('Fim'),
				jn: _List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex flex-col'),
						A2($elm$html$Html$Attributes$style, 'width', 'min-content')
					]),
				n9: $elm$core$Maybe$Just(10),
				c3: '',
				jE: $elm$core$Maybe$Nothing,
				jF: $elm$core$Maybe$Nothing,
				jG: $elm$core$Maybe$Nothing,
				ov: $elm$core$Maybe$Nothing,
				jI: $elm$core$Maybe$Just(
					A2($elm$core$Basics$composeR, $author$project$Pages$Panel$Financial$Account$valueNotEmpty, $author$project$Pages$Panel$Financial$Account$InputtedEndDate)),
				hh: 'Fim',
				kE: model.L === 1,
				kY: 'date',
				k1: _List_Nil,
				di: A2($elm$core$Maybe$withDefault, '', model.T.bl)
			}),
			$author$project$Components$Patterns$Forms$Button(
			{
				lx: _List_fromArray(
					[
						$elm$html$Html$Attributes$class('self-center w-40')
					]),
				l_: $author$project$Pages$Panel$Financial$Account$Submit,
				iH: model.L === 2,
				fD: 'Pesquisar'
			})
		]);
	var buttonCsv = ((!_Utils_eq(model.T.bB, $elm$core$Maybe$Nothing)) && (!_Utils_eq(model.T.bl, $elm$core$Maybe$Nothing))) ? _List_fromArray(
		[
			$author$project$Components$Patterns$Forms$Button(
			{
				lx: _List_fromArray(
					[
						$elm$html$Html$Attributes$class('self-center w-40')
					]),
				l_: A3(
					$author$project$Pages$Panel$Financial$Account$ClickedGenerateReport,
					_Utils_Tuple2(hasPeriodCSV, true),
					1,
					7),
				iH: model.L === 2,
				fD: 'Baixar CSV'
			})
		]) : _List_Nil;
	return $author$project$Components$Patterns$Forms$formSimple(
		{
			hZ: _List_fromArray(
				[
					$elm$html$Html$Attributes$class('w-full'),
					$elm$html$Html$Attributes$novalidate(true)
				]),
			L: model.L,
			jf: _List_fromArray(
				[
					A2(
					$author$project$Components$Patterns$Forms$Custom,
					'flex gap-3',
					_Utils_ap(filters, buttonCsv))
				]),
			oc: $elm$core$Maybe$Nothing,
			pX: 'Pesquisar'
		});
};
var $author$project$Pages$Panel$Financial$Account$viewPagination = F2(
	function (queries, recordCount) {
		return A4(
			$author$project$Components$View$pagination,
			function (p) {
				return $author$project$Route$Panel(
					$author$project$Route$PanelFinancial(
						$author$project$Route$FinancialAccount(
							_Utils_update(
								queries,
								{bv: p}))));
			},
			$author$project$Pages$Panel$Financial$Account$cardsPerPage,
			$elm$core$Maybe$Just(queries.bv),
			recordCount);
	});
var $author$project$Pages$Panel$Financial$Account$viewReceivable = function (waitingFundsAmount) {
	return A2(
		$elm$html$Html$article,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('bg-gray-tint2 p-4 w-full')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-gray-main flex flex-col')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('A receber'),
						A2(
						$elm$html$Html$strong,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-black font-bold text-lg ')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Utils$formatAsMoney(
									$elm$core$String$fromInt(waitingFundsAmount)))
							])),
						A2(
						$elm$html$Html$em,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Valor pendente de recebimento')
							]))
					]))
			]));
};
var $author$project$Pages$Panel$Financial$Account$balanceTypeToTextBRL = function (type_) {
	if (!type_) {
		return 'Conta corrente';
	} else {
		return 'Conta poupança';
	}
};
var $author$project$Pages$Panel$Financial$Account$Error = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Panel$Financial$Account$OpenModal = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Panel$Financial$Account$initModal = function (maximumWithdrawal) {
	return {
		aP: $elm$core$String$fromInt(maximumWithdrawal),
		cx: 0
	};
};
var $author$project$Pages$Panel$Financial$Account$viewButtonToWithdraw = function (info) {
	return $author$project$Pages$Panel$Financial$Account$isPossibleToWithdraw(info.bN) ? A4(
		$author$project$Components$Patterns$Button$text,
		_List_Nil,
		'm-0',
		'Sacar valor para conta bancária',
		$author$project$Pages$Panel$Financial$Account$OpenModal(
			$author$project$Pages$Panel$Financial$Account$initModal(info.bN))) : A4(
		$author$project$Components$Patterns$Button$text,
		_List_Nil,
		'm-0 disabled',
		'Sacar valor para conta bancária',
		$author$project$Pages$Panel$Financial$Account$Error('Valor mínimo para poder sacar é de R$ 10,00 '));
};
var $author$project$Pages$Panel$Financial$Account$viewWithdraw = function (info) {
	var viewLabel = F2(
		function (title, content) {
			return A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-gray-main flex flex-col gap-2'),
						A2($elm$html$Html$Attributes$style, 'text-wrap', 'nowrap')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(title),
						A2(
						$elm$html$Html$strong,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-black font-bold'),
								A2($elm$html$Html$Attributes$style, 'text-wrap', 'nowrap')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(content)
							]))
					]));
		});
	return A2(
		$elm$html$Html$article,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('bg-gray-tint2 p-4 flex items-center justify-between ')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex gap-4')
					]),
				_List_fromArray(
					[
						A2(viewLabel, 'Recebedor', info.nJ),
						A2(viewLabel, 'Conta', info.lg + ('-' + info.lf)),
						A2(viewLabel, 'Agência', info.lI),
						A2(viewLabel, 'Banco', info.lz),
						A2(
						viewLabel,
						'Tipo de conta',
						$author$project$Pages$Panel$Financial$Account$balanceTypeToTextBRL(info.kY))
					])),
				$author$project$Pages$Panel$Financial$Account$viewButtonToWithdraw(info)
			]));
};
var $author$project$Services$Financial$pagarmeWithdrawalStatusToBRL = function (status) {
	switch (status) {
		case 0:
			return 'Pendente';
		case 1:
			return 'Efetivado';
		case 2:
			return 'Falha';
		case 3:
			return 'Em processamento';
		default:
			return 'Transferido';
	}
};
var $author$project$Pages$Panel$Financial$Account$viewWithdrawalReport = F2(
	function (timezone, withdrawals) {
		var rowTd = function (txt) {
			return A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(txt)
					]));
		};
		var netValue = function (withdrawal) {
			return withdrawal.lo + withdrawal.iR;
		};
		var classForNegativeValue = function (withdrawal) {
			return (netValue(withdrawal) < 0) ? $elm$html$Html$Attributes$class('text-red-500') : $elm$html$Html$Attributes$class('');
		};
		var viewRow = function (withdrawal) {
			return _List_fromArray(
				[
					rowTd(
					A2($author$project$Utils$formatDateTimeFromPosixWithSeconds, timezone, withdrawal.ix)),
					rowTd(
					$author$project$Services$Financial$pagarmeWithdrawalStatusToBRL(withdrawal.kK)),
					rowTd(
					A2($author$project$Utils$formatDateTimeFromPosixWithSeconds, timezone, withdrawal.qs)),
					rowTd(
					$author$project$Utils$formatAsMoney(
						$elm$core$String$fromInt(withdrawal.lo))),
					rowTd(
					$author$project$Utils$formatAsMoney(
						$elm$core$String$fromInt(withdrawal.iR))),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							classForNegativeValue(withdrawal)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$formatAsMoney(
								$elm$core$String$fromInt(
									netValue(withdrawal))))
						]))
				]);
		};
		return $author$project$Components$Patterns$Tables$default(
			{
				nF: _List_fromArray(
					['Data solicitação', 'Status', 'Data efetivação', 'Valor', 'Taxas', 'Total']),
				nX: false,
				pj: A2($elm$core$List$map, viewRow, withdrawals)
			});
	});
var $author$project$Pages$Panel$Financial$Account$viewWithdrawn = function (transferredAmount) {
	return A2(
		$elm$html$Html$article,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('bg-gray-tint2 p-4 w-full')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-gray-main flex flex-col')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Valor sacado'),
						A2(
						$elm$html$Html$strong,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-black font-bold text-lg ')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Utils$formatAsMoney(
									$elm$core$String$fromInt(transferredAmount)))
							])),
						A2(
						$elm$html$Html$em,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Total já sacado, transferido para conta bancária')
							]))
					]))
			]));
};
var $author$project$Pages$Panel$Financial$Account$viewPage = F2(
	function (model, shared) {
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-black')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Financeiro - conta')
						])),
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col gap-4')
						]),
					A2(
						$krisajenkins$remotedata$RemoteData$withDefault,
						_List_fromArray(
							[$author$project$Components$View$loading]),
						A2(
							$krisajenkins$remotedata$RemoteData$map,
							function (info) {
								return _List_fromArray(
									[
										$author$project$Pages$Panel$Financial$Account$viewWithdraw(info),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('flex gap-4')
											]),
										_List_fromArray(
											[
												$author$project$Pages$Panel$Financial$Account$viewCurrentBalance(info.bN),
												$author$project$Pages$Panel$Financial$Account$viewReceivable(info.qG),
												$author$project$Pages$Panel$Financial$Account$viewWithdrawn(info.ql)
											]))
									]);
							},
							model.cY))),
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mt-6')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h2,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-black text-center mb-2')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Lista de saques')
								])),
							$author$project$Pages$Panel$Financial$Account$viewFilters(model),
							function () {
							var _v0 = A2(
								$krisajenkins$remotedata$RemoteData$map,
								function ($) {
									return $.iC;
								},
								model.cE);
							switch (_v0.$) {
								case 3:
									if (!_v0.a.b) {
										return $elm$html$Html$text('Nenhum registro foi encontrado.');
									} else {
										var data = _v0.a;
										return A2($author$project$Pages$Panel$Financial$Account$viewWithdrawalReport, shared.kS, data);
									}
								case 0:
									return $elm$html$Html$text('Por favor, defina um período desejado ou utilize as datas padrão para realizar a busca.');
								case 1:
									return $author$project$Components$View$loading;
								default:
									var e = _v0.a;
									return $elm$html$Html$text('Ops! Algo deu errado');
							}
						}(),
							A2(
							$krisajenkins$remotedata$RemoteData$withDefault,
							$elm$html$Html$text(''),
							A2(
								$krisajenkins$remotedata$RemoteData$map,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.oJ;
									},
									$author$project$Pages$Panel$Financial$Account$viewPagination(model.T)),
								model.cE))
						]))
				]));
	});
var $author$project$Pages$Panel$Financial$Account$view = F2(
	function (model, shared) {
		return _Utils_Tuple2(
			'Financeiro - conta',
			_List_fromArray(
				[
					A2($author$project$Pages$Panel$Financial$Account$viewPage, model, shared),
					A3($author$project$Pages$Panel$Financial$Account$viewModal, model.cY, model.aY, model)
				]));
	});
var $author$project$Pages$Panel$Financial$PendingTransactions$ClickedGenerateReport = F3(
	function (a, b, c) {
		return {$: 10, a: a, b: b, c: c};
	});
var $author$project$Services$Pdf$FinancialPendingTransactions = 5;
var $author$project$Pages$Panel$Financial$PendingTransactions$InputtedEndDate = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Panel$Financial$PendingTransactions$InputtedStartDate = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Panel$Financial$PendingTransactions$Submit = {$: 6};
var $author$project$Pages$Panel$Financial$PendingTransactions$setsEmptyValue = function (v_) {
	return $elm$core$String$isEmpty(v_) ? '-' : v_;
};
var $author$project$Pages$Panel$Financial$PendingTransactions$viewPagination = F2(
	function (queries, recordCount) {
		return A4(
			$author$project$Components$View$pagination,
			function (p) {
				return $author$project$Route$Panel(
					$author$project$Route$PanelFinancial(
						$author$project$Route$FinancialPendingTransactions(
							_Utils_update(
								queries,
								{bv: p}))));
			},
			$author$project$Pages$Panel$Financial$PendingTransactions$cardsPerPage,
			$elm$core$Maybe$Just(queries.bv),
			recordCount);
	});
var $author$project$Pages$Panel$Financial$PendingTransactions$viewPage = F3(
	function (model, shared, user) {
		var hasPeriodCSV = A2(
			$krisajenkins$remotedata$RemoteData$withDefault,
			false,
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.iC;
					},
					A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not)),
				model.ck));
		var filters = _List_fromArray(
			[
				$author$project$Components$Patterns$Forms$Input(
				{
					ie: $elm$core$Maybe$Nothing,
					iH: model.L === 2,
					iP: _List_Nil,
					nR: _List_fromArray(
						[
							$elm$html$Html$Attributes$size(10)
						]),
					jl: $elm$core$Maybe$Just('Início'),
					jn: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col'),
							A2($elm$html$Html$Attributes$style, 'width', 'min-content')
						]),
					n9: $elm$core$Maybe$Just(10),
					c3: '',
					jE: $elm$core$Maybe$Nothing,
					jF: $elm$core$Maybe$Nothing,
					jG: $elm$core$Maybe$Nothing,
					ov: $elm$core$Maybe$Nothing,
					jI: $elm$core$Maybe$Just(
						A2($elm$core$Basics$composeR, $author$project$Pages$Panel$Financial$PendingTransactions$valueNotEmpty, $author$project$Pages$Panel$Financial$PendingTransactions$InputtedStartDate)),
					hh: 'Início',
					kE: model.L === 1,
					kY: 'date',
					k1: _List_Nil,
					di: A2($elm$core$Maybe$withDefault, '', model.T.bB)
				}),
				$author$project$Components$Patterns$Forms$Input(
				{
					ie: $elm$core$Maybe$Nothing,
					iH: model.L === 2,
					iP: _List_Nil,
					nR: _List_fromArray(
						[
							$elm$html$Html$Attributes$size(10)
						]),
					jl: $elm$core$Maybe$Just('Fim'),
					jn: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col'),
							A2($elm$html$Html$Attributes$style, 'width', 'min-content')
						]),
					n9: $elm$core$Maybe$Just(10),
					c3: '',
					jE: $elm$core$Maybe$Nothing,
					jF: $elm$core$Maybe$Nothing,
					jG: $elm$core$Maybe$Nothing,
					ov: $elm$core$Maybe$Nothing,
					jI: $elm$core$Maybe$Just(
						A2($elm$core$Basics$composeR, $author$project$Pages$Panel$Financial$PendingTransactions$valueNotEmpty, $author$project$Pages$Panel$Financial$PendingTransactions$InputtedEndDate)),
					hh: 'Fim',
					kE: model.L === 1,
					kY: 'date',
					k1: _List_Nil,
					di: A2($elm$core$Maybe$withDefault, '', model.T.bl)
				}),
				$author$project$Components$Patterns$Forms$Button(
				{
					lx: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('self-center w-40')
						]),
					l_: $author$project$Pages$Panel$Financial$PendingTransactions$Submit,
					iH: model.L === 2,
					fD: 'Pesquisar'
				})
			]);
		var buttonCsv = ((!_Utils_eq(model.T.bB, $elm$core$Maybe$Nothing)) && (!_Utils_eq(model.T.bl, $elm$core$Maybe$Nothing))) ? _List_fromArray(
			[
				$author$project$Components$Patterns$Forms$Button(
				{
					lx: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('self-center w-40')
						]),
					l_: A3(
						$author$project$Pages$Panel$Financial$PendingTransactions$ClickedGenerateReport,
						_Utils_Tuple2(hasPeriodCSV, true),
						1,
						5),
					iH: model.L === 2,
					fD: 'Baixar CSV'
				})
			]) : _List_Nil;
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-black')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Financeiro - Transações pendentes')
						])),
					A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('flex')
										]),
									_List_fromArray(
										[
											$author$project$Components$Patterns$Forms$formSimple(
											{
												hZ: _List_fromArray(
													[
														$elm$html$Html$Attributes$class('w-full'),
														$elm$html$Html$Attributes$novalidate(true)
													]),
												L: model.L,
												jf: _List_fromArray(
													[
														A2(
														$author$project$Components$Patterns$Forms$Custom,
														'flex gap-3',
														_Utils_ap(filters, buttonCsv))
													]),
												oc: $elm$core$Maybe$Nothing,
												pX: 'Pesquisar'
											})
										])),
									A2(
									$elm$html$Html$article,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('filtros-container report-sales  items-start')
										]),
									A2(
										$krisajenkins$remotedata$RemoteData$withDefault,
										_List_Nil,
										A2(
											$krisajenkins$remotedata$RemoteData$map,
											function (_v0) {
												var data = _v0.iC;
												return ((!model.dK) || $elm$core$List$isEmpty(data)) ? _List_Nil : _List_Nil;
											},
											model.ck)))
								])),
							function () {
							var _v1 = model.ck;
							switch (_v1.$) {
								case 3:
									var data = _v1.a.iC;
									var rowsTdDefineHyperlink = function (url) {
										return A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$href(url)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Abrir pedido')
														]))
												]));
									};
									var rowsFilteredStatus = A2(
										$elm$core$Maybe$withDefault,
										data,
										A2(
											$elm$core$Maybe$map,
											function (status) {
												return A2(
													$elm$core$List$filter,
													A2(
														$elm$core$Basics$composeR,
														function ($) {
															return $.kK;
														},
														$elm$core$Basics$eq(status)),
													data);
											},
											model.T.kK));
									var rowsFilteredPaymentMethod = A2(
										$elm$core$Maybe$withDefault,
										rowsFilteredStatus,
										A2(
											$elm$core$Maybe$map,
											function (status) {
												return A2(
													$elm$core$List$filter,
													A2(
														$elm$core$Basics$composeR,
														function ($) {
															return $.jW;
														},
														$elm$core$Basics$eq(status)),
													rowsFilteredStatus);
											},
											model.T.jW));
									var rowTd = function (txt) {
										return A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(txt)
												]));
									};
									var records = A2(
										$elm$core$List$map,
										function (item) {
											return _Utils_ap(
												A2($author$project$Pages$Panel$Financial$PendingTransactions$reportRow, shared.kS, item),
												_List_fromArray(
													[
														A2($author$project$Pages$Panel$Financial$PendingTransactions$reportRowOrderLink, shared, item)
													]));
										},
										rowsFilteredPaymentMethod);
									var viewRecords = A2(
										$elm$core$List$map,
										function (cells) {
											return A2(
												$elm$core$List$indexedMap,
												F2(
													function (index, cell) {
														return (_Utils_eq(
															$elm$core$List$length(cells),
															index + 1) && (cell !== '')) ? rowsTdDefineHyperlink(cell) : rowTd(
															$author$project$Pages$Panel$Financial$PendingTransactions$setsEmptyValue(cell));
													}),
												cells);
										},
										records);
									var headers = $author$project$Pages$Panel$Financial$PendingTransactions$reportHeaders;
									return $elm$core$List$isEmpty(viewRecords) ? $elm$html$Html$text('Nenhum registro encontrado') : $author$project$Components$Patterns$Tables$default(
										{nF: headers, nX: true, pj: viewRecords});
								case 0:
									return $elm$html$Html$text('Por favor, defina um período desejado ou utilize as datas padrão para realizar a busca.');
								case 1:
									return $author$project$Components$View$loading;
								default:
									var e = _v1.a;
									return $elm$html$Html$text('Ops! Algo deu errado');
							}
						}(),
							A2(
							$author$project$Pages$Panel$Financial$PendingTransactions$viewPagination,
							model.T,
							A2(
								$krisajenkins$remotedata$RemoteData$withDefault,
								0,
								A2(
									$krisajenkins$remotedata$RemoteData$map,
									function ($) {
										return $.qc;
									},
									model.ck)))
						]))
				]));
	});
var $author$project$Pages$Panel$Financial$PendingTransactions$view = F3(
	function (model, user, shared) {
		var viewModal = function () {
			var _v0 = model.bQ.aY;
			if (!_v0.$) {
				var m_ = _v0.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$Panel$Financial$PendingTransactions$CompPDFCreateMSg,
					$author$project$Components$PDF$Create$viewModal(m_));
			} else {
				return $elm$html$Html$text('');
			}
		}();
		return _Utils_Tuple2(
			'Financeiro - Transações pendentes',
			_List_fromArray(
				[
					A3($author$project$Pages$Panel$Financial$PendingTransactions$viewPage, model, shared, user),
					viewModal
				]));
	});
var $author$project$Pages$Panel$Financial$Transactions$ClickedGenerateReport = F3(
	function (a, b, c) {
		return {$: 10, a: a, b: b, c: c};
	});
var $author$project$Pages$Panel$Financial$Transactions$ExpandFilters = {$: 7};
var $author$project$Services$Pdf$FinancialTransactions = 6;
var $author$project$Pages$Panel$Financial$Transactions$InputtedEndDate = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Panel$Financial$Transactions$InputtedStartDate = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Panel$Financial$Transactions$SelectedPaymentMethod = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Panel$Financial$Transactions$SelectedStatus = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Panel$Financial$Transactions$Submit = {$: 6};
var $author$project$Services$Financial$allPagarmePayablesStatus = _List_fromArray(
	[0, 1, 2]);
var $author$project$Pages$Panel$Financial$Transactions$pagarmeWithdrawalStatusToOptions = A2(
	$elm$core$List$map,
	function (status) {
		return _Utils_Tuple2(
			$author$project$Services$Financial$pagarmePayablesStatusToCode(status),
			$author$project$Services$Financial$pagarmePayablesStatusToBRL(status));
	},
	$author$project$Services$Financial$allPagarmePayablesStatus);
var $author$project$Services$Models$allPaymentMethod = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11]);
var $author$project$Pages$Panel$Financial$Transactions$paymentMethodToOptions = function (reports) {
	return A2(
		$elm$core$List$map,
		function (pm) {
			return _Utils_Tuple2(
				$author$project$Services$Models$paymentFormatToCode(pm),
				$author$project$Services$Models$paymentFormatToStr(pm));
		},
		A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Services$Models$paymentFormatToCode,
				$elm$core$Basics$neq('')),
			$author$project$Services$Models$allPaymentMethod));
};
var $author$project$Pages$Panel$Financial$Transactions$setsEmptyValue = function (v_) {
	return $elm$core$String$isEmpty(v_) ? '-' : v_;
};
var $author$project$Pages$Panel$Financial$Transactions$viewPagination = function (queries) {
	return A4(
		$author$project$Components$View$pagination,
		function (p) {
			return $author$project$Route$Panel(
				$author$project$Route$PanelFinancial(
					$author$project$Route$FinancialTransactions(
						_Utils_update(
							queries,
							{bv: p}))));
		},
		$author$project$Pages$Panel$Financial$Transactions$cardsPerPage,
		$elm$core$Maybe$Just(queries.bv),
		queries.gk);
};
var $author$project$Pages$Panel$Financial$Transactions$viewPage = F3(
	function (model, shared, user) {
		var hasPeriodCSV = A2(
			$krisajenkins$remotedata$RemoteData$withDefault,
			false,
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not),
				model.ck));
		var filters = _List_fromArray(
			[
				$author$project$Components$Patterns$Forms$Input(
				{
					ie: $elm$core$Maybe$Nothing,
					iH: model.L === 2,
					iP: _List_Nil,
					nR: _List_fromArray(
						[
							$elm$html$Html$Attributes$size(10)
						]),
					jl: $elm$core$Maybe$Just('Início'),
					jn: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col'),
							A2($elm$html$Html$Attributes$style, 'width', 'min-content')
						]),
					n9: $elm$core$Maybe$Just(10),
					c3: '',
					jE: $elm$core$Maybe$Nothing,
					jF: $elm$core$Maybe$Nothing,
					jG: $elm$core$Maybe$Nothing,
					ov: $elm$core$Maybe$Nothing,
					jI: $elm$core$Maybe$Just(
						A2($elm$core$Basics$composeR, $author$project$Pages$Panel$Financial$Transactions$valueNotEmpty, $author$project$Pages$Panel$Financial$Transactions$InputtedStartDate)),
					hh: 'Início',
					kE: model.L === 1,
					kY: 'date',
					k1: _List_Nil,
					di: A2($elm$core$Maybe$withDefault, '', model.T.bB)
				}),
				$author$project$Components$Patterns$Forms$Input(
				{
					ie: $elm$core$Maybe$Nothing,
					iH: model.L === 2,
					iP: _List_Nil,
					nR: _List_fromArray(
						[
							$elm$html$Html$Attributes$size(10)
						]),
					jl: $elm$core$Maybe$Just('Fim'),
					jn: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col'),
							A2($elm$html$Html$Attributes$style, 'width', 'min-content')
						]),
					n9: $elm$core$Maybe$Just(10),
					c3: '',
					jE: $elm$core$Maybe$Nothing,
					jF: $elm$core$Maybe$Nothing,
					jG: $elm$core$Maybe$Nothing,
					ov: $elm$core$Maybe$Nothing,
					jI: $elm$core$Maybe$Just(
						A2($elm$core$Basics$composeR, $author$project$Pages$Panel$Financial$Transactions$valueNotEmpty, $author$project$Pages$Panel$Financial$Transactions$InputtedEndDate)),
					hh: 'Fim',
					kE: model.L === 1,
					kY: 'date',
					k1: _List_Nil,
					di: A2($elm$core$Maybe$withDefault, '', model.T.bl)
				}),
				$author$project$Components$Patterns$Forms$ButtonIcon(
				{
					lx: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('self-center w-40')
						]),
					l_: $author$project$Pages$Panel$Financial$Transactions$ExpandFilters,
					l4: 'filter_list',
					iH: model.L === 2,
					fD: 'Filtros extra'
				}),
				$author$project$Components$Patterns$Forms$Button(
				{
					lx: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('self-center w-40')
						]),
					l_: $author$project$Pages$Panel$Financial$Transactions$Submit,
					iH: model.L === 2,
					fD: 'Pesquisar'
				})
			]);
		var buttonCsv = ((!_Utils_eq(model.T.bB, $elm$core$Maybe$Nothing)) && (!_Utils_eq(model.T.bl, $elm$core$Maybe$Nothing))) ? _List_fromArray(
			[
				$author$project$Components$Patterns$Forms$Button(
				{
					lx: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('self-center w-40')
						]),
					l_: A3(
						$author$project$Pages$Panel$Financial$Transactions$ClickedGenerateReport,
						_Utils_Tuple2(hasPeriodCSV, true),
						1,
						6),
					iH: model.L === 2,
					fD: 'Baixar CSV'
				})
			]) : _List_Nil;
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-black')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Financeiro - Transações')
						])),
					A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('flex')
										]),
									_List_fromArray(
										[
											$author$project$Components$Patterns$Forms$formSimple(
											{
												hZ: _List_fromArray(
													[
														$elm$html$Html$Attributes$class('w-full'),
														$elm$html$Html$Attributes$novalidate(true)
													]),
												L: model.L,
												jf: _List_fromArray(
													[
														A2(
														$author$project$Components$Patterns$Forms$Custom,
														'flex gap-3',
														_Utils_ap(filters, buttonCsv)),
														A2(
														$author$project$Components$Patterns$Forms$Custom,
														'mt-4 grid grid-cols-auto-fit-minmax gap-3',
														function () {
															var _v0 = _Utils_Tuple2(model.dK, model.ck);
															if (_v0.a && (_v0.b.$ === 3)) {
																var reports = _v0.b.a;
																return _List_fromArray(
																	[
																		$author$project$Components$Patterns$Forms$Select(
																		{
																			iH: model.L === 2,
																			jl: $elm$core$Maybe$Just('Status'),
																			jn: _List_fromArray(
																				[
																					$elm$html$Html$Attributes$class('flex flex-col justify-end')
																				]),
																			jI: $elm$core$Maybe$Just($author$project$Pages$Panel$Financial$Transactions$SelectedStatus),
																			jO: A2(
																				$elm$core$List$cons,
																				{
																					eX: '' === A2(
																						$elm$core$Maybe$withDefault,
																						'',
																						A2($elm$core$Maybe$map, $author$project$Services$Models$paymentFormatToCode, model.T.jW)),
																					c3: 'Todos',
																					di: ''
																				},
																				A2(
																					$elm$core$List$map,
																					function (_v1) {
																						var id = _v1.a;
																						var name = _v1.b;
																						return {
																							eX: _Utils_eq(
																								id,
																								A2(
																									$elm$core$Maybe$withDefault,
																									'',
																									A2($elm$core$Maybe$map, $author$project$Services$Financial$pagarmePayablesStatusToCode, model.T.kK))),
																							c3: name,
																							di: id
																						};
																					},
																					A2($elm$core$List$sortBy, $elm$core$Tuple$second, $author$project$Pages$Panel$Financial$Transactions$pagarmeWithdrawalStatusToOptions))),
																			jQ: false,
																			ks: _List_fromArray(
																				[
																					$elm$html$Html$Attributes$class('mt-2'),
																					A2($elm$html$Html$Attributes$style, 'margin-bottom', '0')
																				]),
																			kE: model.L === 1,
																			k1: _List_Nil
																		}),
																		$author$project$Components$Patterns$Forms$Select(
																		{
																			iH: model.L === 2,
																			jl: $elm$core$Maybe$Just('Tipo de pagamento'),
																			jn: _List_fromArray(
																				[
																					$elm$html$Html$Attributes$class('flex flex-col justify-end')
																				]),
																			jI: $elm$core$Maybe$Just($author$project$Pages$Panel$Financial$Transactions$SelectedPaymentMethod),
																			jO: A2(
																				$elm$core$List$cons,
																				{
																					eX: '' === A2(
																						$elm$core$Maybe$withDefault,
																						'',
																						A2($elm$core$Maybe$map, $author$project$Services$Financial$pagarmePayablesStatusToCode, model.T.kK)),
																					c3: 'Todos',
																					di: ''
																				},
																				A2(
																					$elm$core$List$map,
																					function (_v2) {
																						var id = _v2.a;
																						var name = _v2.b;
																						return {
																							eX: _Utils_eq(
																								id,
																								A2(
																									$elm$core$Maybe$withDefault,
																									'',
																									A2($elm$core$Maybe$map, $author$project$Services$Models$paymentFormatToCode, model.T.jW))),
																							c3: name,
																							di: id
																						};
																					},
																					$author$project$Pages$Panel$Financial$Transactions$paymentMethodToOptions(reports))),
																			jQ: false,
																			ks: _List_fromArray(
																				[
																					$elm$html$Html$Attributes$class('mt-2'),
																					A2($elm$html$Html$Attributes$style, 'margin-bottom', '0')
																				]),
																			kE: model.L === 1,
																			k1: _List_Nil
																		})
																	]);
															} else {
																return _List_Nil;
															}
														}())
													]),
												oc: $elm$core$Maybe$Nothing,
												pX: 'Pesquisar'
											})
										]))
								])),
							function () {
							var _v3 = model.ck;
							switch (_v3.$) {
								case 3:
									var table = _v3.a;
									var rowsTdDefineHyperlink = function (url) {
										return A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$href(url)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Abrir pedido')
														]))
												]));
									};
									var rowsFilteredStatus = A2(
										$elm$core$Maybe$withDefault,
										table,
										A2(
											$elm$core$Maybe$map,
											function (status) {
												return A2(
													$elm$core$List$filter,
													A2(
														$elm$core$Basics$composeR,
														function ($) {
															return $.kK;
														},
														$elm$core$Basics$eq(status)),
													table);
											},
											model.T.kK));
									var rowsFilteredPaymentMethod = A2(
										$elm$core$Maybe$withDefault,
										rowsFilteredStatus,
										A2(
											$elm$core$Maybe$map,
											function (status) {
												return A2(
													$elm$core$List$filter,
													A2(
														$elm$core$Basics$composeR,
														function ($) {
															return $.jW;
														},
														$elm$core$Basics$eq(status)),
													rowsFilteredStatus);
											},
											model.T.jW));
									var rowTd = function (txt) {
										return A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(txt)
												]));
									};
									var records = A2(
										$elm$core$List$map,
										function (item) {
											return _Utils_ap(
												A2($author$project$Pages$Panel$Financial$Transactions$reportRow, shared.kS, item),
												_List_fromArray(
													[
														A2($author$project$Pages$Panel$Financial$Transactions$reportRowOrderLink, shared, item)
													]));
										},
										rowsFilteredPaymentMethod);
									var viewRecords = A2(
										$elm$core$List$map,
										function (cells) {
											return A2(
												$elm$core$List$indexedMap,
												F2(
													function (index, cell) {
														return (_Utils_eq(
															$elm$core$List$length(cells),
															index + 1) && (cell !== '')) ? rowsTdDefineHyperlink(cell) : rowTd(
															$author$project$Pages$Panel$Financial$Transactions$setsEmptyValue(cell));
													}),
												cells);
										},
										records);
									var headers = $author$project$Pages$Panel$Financial$Transactions$reportHeaders;
									return $elm$core$List$isEmpty(viewRecords) ? $elm$html$Html$text('Nenhum registro encontrado') : $author$project$Components$Patterns$Tables$default(
										{nF: headers, nX: true, pj: viewRecords});
								case 0:
									return $elm$html$Html$text('Por favor, defina um período desejado ou utilize as datas padrão para realizar a busca.');
								case 1:
									return $author$project$Components$View$loading;
								default:
									var e = _v3.a;
									return $elm$html$Html$text('Ops! Algo deu errado');
							}
						}(),
							$author$project$Pages$Panel$Financial$Transactions$viewPagination(model.T)
						]))
				]));
	});
var $author$project$Pages$Panel$Financial$Transactions$view = F3(
	function (model, user, shared) {
		var viewModal = function () {
			var _v0 = model.bQ.aY;
			if (!_v0.$) {
				var m_ = _v0.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$Panel$Financial$Transactions$CompPDFCreateMSg,
					$author$project$Components$PDF$Create$viewModal(m_));
			} else {
				return $elm$html$Html$text('');
			}
		}();
		return _Utils_Tuple2(
			'Financeiro - Transações',
			_List_fromArray(
				[
					A3($author$project$Pages$Panel$Financial$Transactions$viewPage, model, shared, user),
					viewModal
				]));
	});
var $author$project$Pages$Panel$History$ExpandFilters = {$: 10};
var $author$project$Pages$Panel$History$InputtedEndDate = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Panel$History$InputtedStartDate = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Panel$History$InputtedUser = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Panel$History$MS_ActionType = 1;
var $author$project$Pages$Panel$History$MS_ExecutionUser = 0;
var $author$project$Components$Patterns$Forms$MultiSelect = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Panel$History$SelectedActionType = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Panel$History$SelectedExecutionUser = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Panel$History$SetMultiSelect = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Pages$Panel$History$Submit = {$: 9};
var $author$project$Pages$Panel$History$actionTypeInputID = 'history-action-type-input';
var $author$project$Pages$Panel$History$actionTypeSelectID = 'history-action-type-select';
var $author$project$Pages$Panel$History$executionUserInputID = 'history-execution-user-input';
var $author$project$Pages$Panel$History$executionUserSelectID = 'history-execution-user-select';
var $author$project$Pages$Panel$History$optionsActionTypes = function (rdResult) {
	var options_ = A2(
		$elm$core$List$map,
		function (u) {
			return _Utils_Tuple2(u.l4, u.c3);
		},
		rdResult);
	return A2(
		$elm$core$List$cons,
		_Utils_Tuple2('', 'Todos'),
		options_);
};
var $author$project$Pages$Panel$History$optionsSystemUser = function (rdLines) {
	var options_ = A2(
		$elm$core$List$map,
		function (u) {
			return _Utils_Tuple2(u.dM, u.c3);
		},
		rdLines);
	return A2(
		$elm$core$List$cons,
		_Utils_Tuple2('', 'Todos'),
		options_);
};
var $author$project$Pages$Panel$History$viewPagination = function (queries) {
	return A4(
		$author$project$Components$View$pagination,
		function (p) {
			return $author$project$Route$Panel(
				$author$project$Route$History(
					_Utils_update(
						queries,
						{bv: p})));
		},
		$author$project$Pages$Panel$History$cardsPerPage,
		$elm$core$Maybe$Just(queries.bv),
		queries.gk);
};
var $author$project$Pages$Panel$History$viewPage = F3(
	function (model, shared, user) {
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-black')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Histórico')
						])),
					A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Components$Patterns$Forms$formSimple(
									{
										hZ: _List_fromArray(
											[
												$elm$html$Html$Attributes$class('w-full'),
												$elm$html$Html$Attributes$novalidate(true)
											]),
										L: model.L,
										jf: _List_fromArray(
											[
												A2(
												$author$project$Components$Patterns$Forms$Custom,
												'flex gap-3',
												_List_fromArray(
													[
														$author$project$Components$Patterns$Forms$Input(
														{
															ie: $elm$core$Maybe$Nothing,
															iH: model.L === 2,
															iP: _List_Nil,
															nR: _List_fromArray(
																[
																	$elm$html$Html$Attributes$size(10)
																]),
															jl: $elm$core$Maybe$Just('Início'),
															jn: _List_fromArray(
																[
																	$elm$html$Html$Attributes$class('flex flex-col'),
																	A2($elm$html$Html$Attributes$style, 'width', 'min-content')
																]),
															n9: $elm$core$Maybe$Just(10),
															c3: '',
															jE: $elm$core$Maybe$Nothing,
															jF: $elm$core$Maybe$Nothing,
															jG: $elm$core$Maybe$Nothing,
															ov: $elm$core$Maybe$Nothing,
															jI: $elm$core$Maybe$Just(
																A2($elm$core$Basics$composeR, $author$project$Pages$Panel$History$valueNotEmpty, $author$project$Pages$Panel$History$InputtedStartDate)),
															hh: 'Início',
															kE: model.L === 1,
															kY: 'date',
															k1: _List_Nil,
															di: A2($elm$core$Maybe$withDefault, '', model.T.bB)
														}),
														$author$project$Components$Patterns$Forms$Input(
														{
															ie: $elm$core$Maybe$Nothing,
															iH: model.L === 2,
															iP: _List_Nil,
															nR: _List_fromArray(
																[
																	$elm$html$Html$Attributes$size(10)
																]),
															jl: $elm$core$Maybe$Just('Fim'),
															jn: _List_fromArray(
																[
																	$elm$html$Html$Attributes$class('flex flex-col'),
																	A2($elm$html$Html$Attributes$style, 'width', 'min-content')
																]),
															n9: $elm$core$Maybe$Just(10),
															c3: '',
															jE: $elm$core$Maybe$Nothing,
															jF: $elm$core$Maybe$Nothing,
															jG: $elm$core$Maybe$Nothing,
															ov: $elm$core$Maybe$Nothing,
															jI: $elm$core$Maybe$Just(
																A2($elm$core$Basics$composeR, $author$project$Pages$Panel$History$valueNotEmpty, $author$project$Pages$Panel$History$InputtedEndDate)),
															hh: 'Fim',
															kE: model.L === 1,
															kY: 'date',
															k1: _List_Nil,
															di: A2($elm$core$Maybe$withDefault, '', model.T.bl)
														}),
														$author$project$Components$Patterns$Forms$ButtonIcon(
														{
															lx: _List_fromArray(
																[
																	$elm$html$Html$Attributes$class('self-center w-40')
																]),
															l_: $author$project$Pages$Panel$History$ExpandFilters,
															l4: 'filter_list',
															iH: model.L === 2,
															fD: 'Filtros extra'
														}),
														$author$project$Components$Patterns$Forms$Button(
														{
															lx: _List_fromArray(
																[
																	$elm$html$Html$Attributes$class('self-center w-40')
																]),
															l_: $author$project$Pages$Panel$History$Submit,
															iH: model.L === 2,
															fD: 'Pesquisar'
														})
													])),
												A2(
												$author$project$Components$Patterns$Forms$Custom,
												'mt-4 grid grid-cols-auto-fit-minmax gap-3',
												model.dK ? _List_fromArray(
													[
														$author$project$Components$Patterns$Forms$Input(
														{
															ie: $elm$core$Maybe$Nothing,
															iH: model.L === 2,
															iP: _List_Nil,
															nR: _List_fromArray(
																[
																	$elm$html$Html$Attributes$class('flex flex-col')
																]),
															jl: $elm$core$Maybe$Just('Passageiro'),
															jn: _List_Nil,
															n9: $elm$core$Maybe$Nothing,
															c3: '',
															jE: $elm$core$Maybe$Nothing,
															jF: $elm$core$Maybe$Nothing,
															jG: $elm$core$Maybe$Nothing,
															ov: $elm$core$Maybe$Nothing,
															jI: $elm$core$Maybe$Just(
																A2($elm$core$Basics$composeR, $author$project$Pages$Panel$History$valueNotEmpty, $author$project$Pages$Panel$History$InputtedUser)),
															hh: 'Passageiro',
															kE: model.L === 1,
															kY: 'text',
															k1: _List_Nil,
															di: A2($elm$core$Maybe$withDefault, '', model.T.kZ)
														}),
														$author$project$Components$Patterns$Forms$MultiSelect(
														{
															h$: _List_Nil,
															fT: true,
															eS: $author$project$Pages$Panel$History$executionUserInputID,
															gO: model.dS,
															jl: 'Usuário do sistema',
															jI: $author$project$Pages$Panel$History$SelectedExecutionUser,
															g2: A2($author$project$Pages$Panel$History$SetMultiSelect, 0, true),
															jO: A2(
																$krisajenkins$remotedata$RemoteData$withDefault,
																_List_Nil,
																A2($krisajenkins$remotedata$RemoteData$map, $author$project$Pages$Panel$History$optionsSystemUser, model.ei)),
															g7: model.T.bZ,
															hh: 'Selecione múltiplos usuários do sistema',
															kt: $author$project$Pages$Panel$History$executionUserSelectID
														}),
														$author$project$Components$Patterns$Forms$MultiSelect(
														{
															h$: _List_Nil,
															fT: true,
															eS: $author$project$Pages$Panel$History$actionTypeInputID,
															gO: model.dQ,
															jl: 'Tipo de ação',
															jI: $author$project$Pages$Panel$History$SelectedActionType,
															g2: A2($author$project$Pages$Panel$History$SetMultiSelect, 1, true),
															jO: $author$project$Pages$Panel$History$optionsActionTypes(model.dl),
															g7: model.T.bK,
															hh: 'Selecione múltiplas ações',
															kt: $author$project$Pages$Panel$History$actionTypeSelectID
														})
													]) : _List_Nil)
											]),
										oc: $elm$core$Maybe$Nothing,
										pX: 'Pesquisar'
									})
								])),
							function () {
							var _v0 = model.ck;
							switch (_v0.$) {
								case 3:
									var table = _v0.a;
									var rowsTdDefineHyperlink = function (url) {
										return A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$href(url)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Abrir pedido')
														]))
												]));
									};
									var rowTd = function (txt) {
										return A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(txt)
												]));
									};
									var records = A2(
										$elm$core$List$map,
										function (item) {
											return A2($author$project$Pages$Panel$History$reportRow, shared.kS, item);
										},
										table);
									var viewRecords = A2(
										$elm$core$List$map,
										function (rows_) {
											return A2($elm$core$List$map, rowTd, rows_);
										},
										records);
									var headers = $author$project$Pages$Panel$History$reportHeaders;
									return $elm$core$List$isEmpty(viewRecords) ? $elm$html$Html$text('Nenhum registro encontrado') : $author$project$Components$Patterns$Tables$default(
										{nF: headers, nX: true, pj: viewRecords});
								case 0:
									return $elm$html$Html$text('Por favor, insira uma data de início e fim para realizar a busca.');
								case 1:
									return $author$project$Components$View$loading;
								default:
									var e = _v0.a;
									return $elm$html$Html$text('Ops! Algo deu errado');
							}
						}(),
							$author$project$Pages$Panel$History$viewPagination(model.T)
						]))
				]));
	});
var $author$project$Pages$Panel$History$view = F3(
	function (model, user, shared) {
		var viewModal = $elm$html$Html$text('');
		return _Utils_Tuple2(
			'Histórico',
			_List_fromArray(
				[
					A3($author$project$Pages$Panel$History$viewPage, model, shared, user),
					viewModal
				]));
	});
var $author$project$Pages$Panel$ManageFare$CloseModal = {$: 0};
var $author$project$Pages$Panel$ManageFare$GetCurrentDate = {$: 5};
var $author$project$Pages$Panel$ManageFare$InputtedFareCode = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Panel$ManageFare$validatorsCode = _List_fromArray(
	[
		_Utils_Tuple2($elm$core$String$isEmpty, 'Código para a tarifa é obrigatório')
	]);
var $author$project$Pages$Panel$ManageFare$InputtedFareEffectiveFrom = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Panel$ManageFare$validatorEffectiveFromDate = F3(
	function (timezone, now, effectiveFrom) {
		var dateTimeInPosix = A2(
			$elm$core$Maybe$withDefault,
			$elm$time$Time$millisToPosix(0),
			A2($author$project$Utils$datetimeLocalHTMLToPosixWithZone, timezone, effectiveFrom));
		return _Utils_cmp(
			$elm$time$Time$posixToMillis(now),
			$elm$time$Time$posixToMillis(dateTimeInPosix)) > -1;
	});
var $author$project$Pages$Panel$ManageFare$validatorsEffectiveFrom = F2(
	function (timezone, now) {
		return _List_fromArray(
			[
				_Utils_Tuple2($elm$core$String$isEmpty, 'Data de vigência é obrigatório'),
				_Utils_Tuple2(
				A2($author$project$Pages$Panel$ManageFare$validatorEffectiveFromDate, timezone, now),
				'Data precisa maior que a atual')
			]);
	});
var $author$project$Pages$Panel$ManageFare$viewInputEffectiveFrom = function (options) {
	return $author$project$Components$Patterns$Forms$Input(
		{
			ie: $elm$core$Maybe$Nothing,
			iH: (options.L === 2) || options.aT.b,
			iP: _List_Nil,
			nR: _List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-black'),
					$elm$html$Html$Attributes$step('1')
				]),
			jl: $elm$core$Maybe$Just('Data de vigência da tarifa'),
			jn: _List_Nil,
			n9: $elm$core$Maybe$Nothing,
			c3: 'Campo para data de vigência da tarifa',
			jE: $elm$core$Maybe$Nothing,
			jF: $elm$core$Maybe$Nothing,
			jG: $elm$core$Maybe$Nothing,
			ov: $elm$core$Maybe$Nothing,
			jI: $elm$core$Maybe$Just(
				A2($elm$core$Basics$composeL, $author$project$Pages$Panel$ManageFare$ModalMsg, $author$project$Pages$Panel$ManageFare$InputtedFareEffectiveFrom)),
			hh: 'Insira a data para vigência da tarifa',
			kE: options.L === 1,
			kY: 'datetime-local',
			k1: A2($author$project$Pages$Panel$ManageFare$validatorsEffectiveFrom, options.kS, options.e8),
			di: options.aT.a
		});
};
var $author$project$Pages$Panel$ManageFare$InputtedFareValue = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Panel$ManageFare$ToggleFreeFare = {$: 3};
var $author$project$Pages$Panel$ManageFare$validatorsValue = _List_fromArray(
	[
		_Utils_Tuple2($elm$core$String$isEmpty, 'Valor da tarifa é obrigatório')
	]);
var $author$project$Pages$Panel$ManageFare$viewInputCheckbox_ = F3(
	function (formStatus, checked, msg) {
		return $author$project$Components$Patterns$Forms$Checkbox(
			{
				h0: _List_Nil,
				jk: _List_fromArray(
					[
						{
						ie: checked,
						iH: formStatus === 2,
						c3: 'Tarifa gratuita ',
						jG: $author$project$Pages$Panel$ManageFare$ModalMsg(msg)
					}
					])
			});
	});
var $author$project$Pages$Panel$ManageFare$viewInputMoney = function (options) {
	var inputValue = options.aW ? _List_Nil : _List_fromArray(
		[
			$author$project$Components$Patterns$Forms$Input(
			{
				ie: $elm$core$Maybe$Nothing,
				iH: (options.L === 2) || options.di.b,
				iP: _List_Nil,
				nR: _List_Nil,
				jl: $elm$core$Maybe$Just('Valor da tarifa'),
				jn: _List_Nil,
				n9: $elm$core$Maybe$Just(10),
				c3: 'Campo para valor da tarifa',
				jE: $elm$core$Maybe$Nothing,
				jF: $elm$core$Maybe$Nothing,
				jG: $elm$core$Maybe$Nothing,
				ov: $elm$core$Maybe$Nothing,
				jI: $elm$core$Maybe$Just(
					A2(
						$elm$core$Basics$composeL,
						$author$project$Pages$Panel$ManageFare$ModalMsg,
						A2(
							$elm$core$Basics$composeL,
							$author$project$Pages$Panel$ManageFare$InputtedFareValue,
							$elm$core$String$filter($elm$core$Char$isDigit)))),
				hh: 'Insira o valor para tarifa',
				kE: options.L === 1,
				kY: 'text',
				k1: $author$project$Pages$Panel$ManageFare$validatorsValue,
				di: $author$project$Utils$formatMoneyInput(options.di.a)
			})
		]);
	return A2(
		$author$project$Components$Patterns$Forms$Custom,
		'flex flex-col gap-2',
		_Utils_ap(
			inputValue,
			_List_fromArray(
				[
					A3($author$project$Pages$Panel$ManageFare$viewInputCheckbox_, options.L, options.aW, $author$project$Pages$Panel$ManageFare$ToggleFreeFare)
				])));
};
var $author$project$Pages$Panel$ManageFare$viewModalContentCREATE = function (options) {
	return $author$project$Components$Patterns$Modal$simple(
		{
			hY: $elm$core$Maybe$Just(
				A2($elm$html$Html$Attributes$style, 'min-height', 'fit-content')),
			ii: '',
			il: '',
			ip: $author$project$Pages$Panel$ManageFare$CloseModal,
			fD: options.jx,
			k4: $author$project$Components$Patterns$Forms$formSimple(
				{
					hZ: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col gap-4')
						]),
					L: options.L,
					jf: _List_fromArray(
						[
							$author$project$Components$Patterns$Forms$Input(
							{
								ie: $elm$core$Maybe$Nothing,
								iH: (options.L === 2) || (options.l4.b || options.b$),
								iP: _List_Nil,
								nR: _List_Nil,
								jl: $elm$core$Maybe$Just('Código da tarifa'),
								jn: _List_Nil,
								n9: $elm$core$Maybe$Just(100),
								c3: 'Campo para código da tarifa',
								jE: $elm$core$Maybe$Nothing,
								jF: $elm$core$Maybe$Nothing,
								jG: $elm$core$Maybe$Nothing,
								ov: $elm$core$Maybe$Nothing,
								jI: $elm$core$Maybe$Just(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Pages$Panel$ManageFare$ModalMsg,
										A2(
											$elm$core$Basics$composeL,
											$author$project$Pages$Panel$ManageFare$InputtedFareCode,
											$elm$core$String$filter($elm$core$Char$isDigit)))),
								hh: 'Insira o código para a tarifa',
								kE: options.L === 1,
								kY: 'input',
								k1: $author$project$Pages$Panel$ManageFare$validatorsCode,
								di: options.l4.a
							}),
							$author$project$Pages$Panel$ManageFare$viewInputMoney(options),
							$author$project$Pages$Panel$ManageFare$viewInputEffectiveFrom(options)
						]),
					oc: $elm$core$Maybe$Just(
						{
							lx: _List_fromArray(
								[
									$elm$html$Html$Attributes$class('self-center')
								]),
							l_: $author$project$Pages$Panel$ManageFare$ModalMsg($author$project$Pages$Panel$ManageFare$GetCurrentDate),
							iH: false
						}),
					pX: options.kM
				}),
			k5: $elm$html$Html$text('')
		});
};
var $author$project$Services$Fares$statusToStrPTBR = function (status) {
	if (!status) {
		return 'Ativo';
	} else {
		return 'Inativo';
	}
};
var $author$project$Pages$Panel$ManageFare$viewHistoryRow = F2(
	function (timezone, history) {
		var rowTd = function (txt) {
			return A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(txt)
					]));
		};
		return _List_fromArray(
			[
				rowTd(
				A2($author$project$Utils$formatDateTimeFromPosix, timezone, history.ix)),
				rowTd(
				A2($author$project$Utils$formatDateTimeFromPosixWithSeconds, timezone, history.aT)),
				rowTd(
				$author$project$Services$Fares$statusToStrPTBR(history.at)),
				rowTd(
				A2($elm$core$Maybe$withDefault, '-', history.qx)),
				rowTd(
				$author$project$Utils$formatAsMoney(
					$elm$core$String$fromInt(history.di)))
			]);
	});
var $author$project$Pages$Panel$ManageFare$viewModalContentHISTORY = function (options) {
	return $author$project$Components$Patterns$Modal$simple(
		{
			hY: $elm$core$Maybe$Just(
				A2($elm$html$Html$Attributes$style, 'min-height', 'fit-content')),
			ii: '',
			il: '',
			ip: $author$project$Pages$Panel$ManageFare$CloseModal,
			fD: options.jx,
			k4: function () {
				var _v0 = options.aY.eN;
				switch (_v0.$) {
					case 3:
						if (!_v0.a.b) {
							return $elm$html$Html$text('Nenhum registro encontrado');
						} else {
							var history = _v0.a;
							var historyOrder = $elm$core$List$reverse(
								A2(
									$elm$core$List$sortBy,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.aT;
										},
										$elm$time$Time$posixToMillis),
									history));
							return $author$project$Components$Patterns$Tables$default(
								{
									nF: _List_fromArray(
										['Criado em', 'Início de Vigência', 'Status', 'Usuário', 'Valor']),
									nX: false,
									pj: A2(
										$elm$core$List$map,
										$author$project$Pages$Panel$ManageFare$viewHistoryRow(options.kS),
										historyOrder)
								});
						}
					case 0:
						return $elm$html$Html$text('Processo de execução está incorreto!');
					case 1:
						return $author$project$Components$View$loading;
					default:
						var e = _v0.a;
						return $elm$html$Html$text('Algo deu errado: ' + e);
				}
			}(),
			k5: $elm$html$Html$text('')
		});
};
var $author$project$Pages$Panel$ManageFare$viewModal = F2(
	function (shared, modal) {
		if (!modal.$) {
			var m = modal.a;
			var title = m.b$ ? 'Editar tarifa' : 'Criar tarifa';
			return $author$project$Pages$Panel$ManageFare$viewModalContentCREATE(
				{
					l4: _Utils_Tuple2(m.l4, false),
					aT: _Utils_Tuple2(m.aT, false),
					L: m.L,
					b$: m.b$,
					aW: m.aW,
					jx: title,
					e8: m.b2,
					kM: title,
					kS: shared.kS,
					di: _Utils_Tuple2(m.di, false)
				});
		} else {
			var m = modal.a;
			return $author$project$Pages$Panel$ManageFare$viewModalContentHISTORY(
				{aY: m, jx: 'Histórico da tarifa - ' + m.ni.l4, kS: shared.kS});
		}
	});
var $author$project$Pages$Panel$ManageFare$ChangedOrder = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Panel$ManageFare$CreateFare = {$: 2};
var $author$project$Components$Patterns$Tables$defaultWithOrderByColum = function (opts) {
	var cssTableDefaultPanel = opts.nX ? _List_fromArray(
		[
			$elm$html$Html$Attributes$class('overflow-x-auto'),
			A2($elm$html$Html$Attributes$style, 'width', 'calc(100vw - 23rem)')
		]) : _List_Nil;
	return A2(
		$elm$html$Html$div,
		cssTableDefaultPanel,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$table,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'cellspacing', '0'),
						$elm$html$Html$Attributes$class('data-table-dashboard my-4')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$tr,
								_List_Nil,
								A2(
									$elm$core$List$map,
									function (header) {
										var order = function () {
											var _v0 = _Utils_Tuple2(
												_Utils_eq(opts.mn, header.g8),
												opts.mo);
											if (_v0.a && (!_v0.b.$)) {
												if (!_v0.b.a) {
													var _v1 = _v0.b.a;
													return A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('material-symbols-outlined')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('arrow_upward')
															]));
												} else {
													var _v2 = _v0.b.a;
													return A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('material-symbols-outlined')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('arrow_downward')
															]));
												}
											} else {
												return $elm$html$Html$text('');
											}
										}();
										return A2(
											$elm$html$Html$th,
											$elm$core$String$isEmpty(header.g8) ? _List_Nil : _List_fromArray(
												[
													$elm$html$Html$Events$onClick(
													opts.oG(header.g8)),
													$elm$html$Html$Attributes$class('cursor-pointer')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('flex gap-2 items-center')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(header.p2),
															order
														]))
												]));
									},
									opts.nF))
							])),
						A2(
						$elm$html$Html$tbody,
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (record) {
								return A2($elm$html$Html$tr, _List_Nil, record);
							},
							opts.pj))
					]))
			]));
};
var $author$project$Pages$Panel$ManageFare$EditFare = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Panel$ManageFare$HistoryFare = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Panel$ManageFare$SelectedFareStatus = function (a) {
	return {$: 5, a: a};
};
var $author$project$Services$Fares$statusToBool = function (status) {
	if (!status) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$Patterns$Input$Toggle$view = F2(
	function (isChecked, msg) {
		var titleTxt = isChecked ? 'Desativar' : 'Ativar';
		return A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('toggle-switch'),
					$elm$html$Html$Attributes$title(titleTxt)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('checkbox'),
							$elm$html$Html$Attributes$checked(isChecked),
							$elm$html$Html$Events$onClick(msg)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('toggle-switch-background')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('toggle-switch-handle')
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$Pages$Panel$ManageFare$viewFareRow = F3(
	function (timezone, user, fare) {
		var viewBtnEdit = $author$project$Services$Models$iHaveAccess(
			{
				gZ: user.hg,
				hf: $author$project$Services$Models$TARIFFS(1),
				hQ: _List_fromArray(
					[
						A4(
						$author$project$Components$Patterns$Button$icon,
						$author$project$Pages$Panel$ManageFare$EditFare(fare),
						'icon-md',
						'edit',
						'Editar'),
						A2(
						$author$project$Components$Patterns$Input$Toggle$view,
						$author$project$Services$Fares$statusToBool(fare.at),
						$author$project$Pages$Panel$ManageFare$SelectedFareStatus(fare))
					]),
				hR: _List_Nil
			});
		var rowTd = function (txt) {
			return A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(txt)
					]));
		};
		return _List_fromArray(
			[
				rowTd(
				A2($author$project$Utils$formatDateTimeFromPosix, timezone, fare.ix)),
				rowTd(
				A2($author$project$Utils$formatDateTimeFromPosixWithSeconds, timezone, fare.aT)),
				rowTd(
				$author$project$Services$Fares$statusToStrPTBR(fare.at)),
				rowTd(fare.l4),
				rowTd(
				$author$project$Utils$formatAsMoney(
					$elm$core$String$fromInt(fare.di))),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex gap-4')
					]),
				_Utils_ap(
					_List_fromArray(
						[
							A4(
							$author$project$Components$Patterns$Button$icon,
							$author$project$Pages$Panel$ManageFare$HistoryFare(fare),
							'icon-md',
							'info',
							'Histórico da tarifa')
						]),
					viewBtnEdit))
			]);
	});
var $author$project$Pages$Panel$ManageFare$viewPage = F3(
	function (shared, user, model) {
		var viewAddFare = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('top-actions pb-0 pt-4 mt-4')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('btn-ce btn-adicionar'),
							A2($elm$html$Html$Attributes$style, 'width', 'max-content'),
							$elm$html$Html$Events$onClick($author$project$Pages$Panel$ManageFare$CreateFare)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Criar Tarifa')
						]))
				]));
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Services$Models$iHaveAccess(
							{
								gZ: user.hg,
								hf: $author$project$Services$Models$TARIFFS(1),
								hQ: viewAddFare,
								hR: $elm$html$Html$text('')
							}),
							A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-black ')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Tarifas')
								]))
						])),
					A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = model.aV;
							switch (_v0.$) {
								case 3:
									if (!_v0.a.b) {
										return $elm$html$Html$text('Nenhum registro encontrado');
									} else {
										var fares = _v0.a;
										var listCODE = $elm$core$Dict$keys(
											$elm$core$Dict$fromList(
												A2(
													$elm$core$List$map,
													function (f) {
														return _Utils_Tuple2(f.l4, f);
													},
													fares)));
										var filtered = A2(
											$elm$core$List$filterMap,
											function (fCODE) {
												return $elm$core$List$head(
													$elm$core$List$reverse(
														A2(
															$elm$core$List$sortBy,
															A2(
																$elm$core$Basics$composeR,
																function ($) {
																	return $.aT;
																},
																$elm$time$Time$posixToMillis),
															A2(
																$elm$core$List$filter,
																A2(
																	$elm$core$Basics$composeR,
																	function ($) {
																		return $.l4;
																	},
																	$elm$core$Basics$eq(fCODE)),
																fares))));
											},
											listCODE);
										var order = function () {
											var _v1 = _Utils_Tuple2(model.T.mn, model.T.mo);
											_v1$10:
											while (true) {
												if ((!_v1.a.$) && (!_v1.b.$)) {
													if (_v1.b.a === 1) {
														switch (_v1.a.a) {
															case 'createdIn':
																var _v2 = _v1.b.a;
																return A2(
																	$elm$core$List$sortBy,
																	A2(
																		$elm$core$Basics$composeR,
																		function ($) {
																			return $.ix;
																		},
																		$elm$time$Time$posixToMillis),
																	filtered);
															case 'effectiveDate':
																var _v4 = _v1.b.a;
																return A2(
																	$elm$core$List$sortBy,
																	A2(
																		$elm$core$Basics$composeR,
																		function ($) {
																			return $.aT;
																		},
																		$elm$time$Time$posixToMillis),
																	filtered);
															case 'status':
																var _v6 = _v1.b.a;
																return A2(
																	$elm$core$List$sortBy,
																	A2(
																		$elm$core$Basics$composeR,
																		function ($) {
																			return $.at;
																		},
																		$author$project$Services$Fares$statusToStrPTBR),
																	filtered);
															case 'code':
																var _v8 = _v1.b.a;
																return A2(
																	$elm$core$List$sortBy,
																	A2(
																		$elm$core$Basics$composeR,
																		function ($) {
																			return $.l4;
																		},
																		A2(
																			$elm$core$Basics$composeR,
																			$elm$core$String$toInt,
																			$elm$core$Maybe$withDefault(0))),
																	filtered);
															case 'value':
																var _v10 = _v1.b.a;
																return A2(
																	$elm$core$List$sortBy,
																	function ($) {
																		return $.di;
																	},
																	filtered);
															default:
																break _v1$10;
														}
													} else {
														switch (_v1.a.a) {
															case 'createdIn':
																var _v3 = _v1.b.a;
																return $elm$core$List$reverse(
																	A2(
																		$elm$core$List$sortBy,
																		A2(
																			$elm$core$Basics$composeR,
																			function ($) {
																				return $.ix;
																			},
																			$elm$time$Time$posixToMillis),
																		filtered));
															case 'effectiveDate':
																var _v5 = _v1.b.a;
																return $elm$core$List$reverse(
																	A2(
																		$elm$core$List$sortBy,
																		A2(
																			$elm$core$Basics$composeR,
																			function ($) {
																				return $.aT;
																			},
																			$elm$time$Time$posixToMillis),
																		filtered));
															case 'status':
																var _v7 = _v1.b.a;
																return $elm$core$List$reverse(
																	A2(
																		$elm$core$List$sortBy,
																		A2(
																			$elm$core$Basics$composeR,
																			function ($) {
																				return $.at;
																			},
																			$author$project$Services$Fares$statusToStrPTBR),
																		filtered));
															case 'code':
																var _v9 = _v1.b.a;
																return $elm$core$List$reverse(
																	A2(
																		$elm$core$List$sortBy,
																		A2(
																			$elm$core$Basics$composeR,
																			function ($) {
																				return $.l4;
																			},
																			A2(
																				$elm$core$Basics$composeR,
																				$elm$core$String$toInt,
																				$elm$core$Maybe$withDefault(0))),
																		filtered));
															case 'value':
																var _v11 = _v1.b.a;
																return $elm$core$List$reverse(
																	A2(
																		$elm$core$List$sortBy,
																		function ($) {
																			return $.di;
																		},
																		filtered));
															default:
																break _v1$10;
														}
													}
												} else {
													break _v1$10;
												}
											}
											return filtered;
										}();
										return $author$project$Components$Patterns$Tables$defaultWithOrderByColum(
											{
												mn: A2($elm$core$Maybe$withDefault, '', model.T.mn),
												mo: model.T.mo,
												nF: _List_fromArray(
													[
														{g8: 'createdIn', p2: 'Criado em'},
														{g8: 'effectiveDate', p2: 'Início de Vigência'},
														{g8: 'status', p2: 'Status'},
														{g8: 'code', p2: 'Código'},
														{g8: 'value', p2: 'Valor'}
													]),
												nX: true,
												oG: $author$project$Pages$Panel$ManageFare$ChangedOrder,
												pj: A2(
													$elm$core$List$map,
													A2($author$project$Pages$Panel$ManageFare$viewFareRow, shared.kS, user),
													order)
											});
									}
								case 0:
									return $elm$html$Html$text('Processo de execução está incorreto!');
								case 1:
									return $author$project$Components$View$loading;
								default:
									var e = _v0.a;
									return $elm$html$Html$text('Algo deu errado: ' + e);
							}
						}()
						]))
				]));
	});
var $author$project$Pages$Panel$ManageFare$view = F3(
	function (user, model, shared) {
		return _Utils_Tuple2(
			'Tarifa',
			_List_fromArray(
				[
					A3($author$project$Pages$Panel$ManageFare$viewPage, shared, user, model),
					A2(
					$elm$core$Maybe$withDefault,
					$elm$html$Html$text(''),
					A2(
						$elm$core$Maybe$map,
						$author$project$Pages$Panel$ManageFare$viewModal(shared),
						model.aY))
				]));
	});
var $author$project$Pages$Panel$ManageLines$CloseModal = {$: 4};
var $author$project$Pages$Panel$ManageLines$InputtedDescription = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Panel$ManageLines$InputtedLine = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Panel$ManageLines$InputtedName = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Panel$ManageLines$SelectedFare = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Panel$ManageLines$SelectedLineStatus = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Panel$ManageLines$SubmitCREATE = {$: 11};
var $author$project$Services$Line$statusToStrCODE = function (status) {
	if (!status) {
		return 'ativo';
	} else {
		return 'inativo';
	}
};
var $author$project$Services$Line$statusToStrPTBR = function (status) {
	if (!status) {
		return 'Ativo';
	} else {
		return 'Inativo';
	}
};
var $author$project$Pages$Panel$ManageLines$viewInputSelect_ = F6(
	function (formStatus, label, msg, valueSelected, validators, options) {
		return $author$project$Components$Patterns$Forms$Select(
			{
				iH: formStatus === 2,
				jl: $elm$core$Maybe$Just(label),
				jn: _List_Nil,
				jI: $elm$core$Maybe$Just(
					A2($elm$core$Basics$composeL, $author$project$Pages$Panel$ManageLines$ModalMsg, msg)),
				jO: A2(
					$elm$core$List$cons,
					{eX: valueSelected === '', c3: 'Selecione', di: ''},
					options),
				jQ: false,
				ks: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'margin', '0'),
						$elm$html$Html$Attributes$class('text-gray-shade')
					]),
				kE: formStatus === 1,
				k1: validators
			});
	});
var $author$project$Pages$Panel$ManageLines$viewInput_ = F7(
	function (formStatus, label, placeholder, name, msg, validators, value) {
		return $author$project$Components$Patterns$Forms$Input(
			{
				ie: $elm$core$Maybe$Nothing,
				iH: formStatus === 2,
				iP: _List_Nil,
				nR: _List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-gray-shade')
					]),
				jl: $elm$core$Maybe$Just(label),
				jn: _List_Nil,
				n9: $elm$core$Maybe$Just(80),
				c3: name,
				jE: $elm$core$Maybe$Nothing,
				jF: $elm$core$Maybe$Nothing,
				jG: $elm$core$Maybe$Nothing,
				ov: $elm$core$Maybe$Nothing,
				jI: $elm$core$Maybe$Just(
					A2($elm$core$Basics$composeL, $author$project$Pages$Panel$ManageLines$ModalMsg, msg)),
				hh: placeholder,
				kE: formStatus === 1,
				kY: 'input',
				k1: validators,
				di: value
			});
	});
var $author$project$Pages$Panel$ManageLines$viewModalContentCREATE = function (model) {
	var optionsLineType_ = $author$project$Pages$Panel$ManageLines$optionsLineType(model.kY);
	var optionsFare_ = A2($author$project$Pages$Panel$ManageLines$optionsFare, model.u, model.aV);
	var fares = A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, model.aV);
	return $author$project$Components$Patterns$Modal$simple(
		{
			hY: $elm$core$Maybe$Just(
				A2($elm$html$Html$Attributes$style, 'min-height', 'fit-content')),
			ii: '',
			il: '',
			ip: $author$project$Pages$Panel$ManageLines$CloseModal,
			fD: 'Criar linha',
			k4: $author$project$Components$Patterns$Forms$formSimple(
				{
					hZ: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col gap-4')
						]),
					L: model.L,
					jf: _List_fromArray(
						[
							A6(
							$author$project$Pages$Panel$ManageLines$viewInputSelect_,
							model.L,
							'Tarifa',
							$author$project$Pages$Panel$ManageLines$SelectedFare,
							model.u,
							A3($author$project$Pages$Panel$ManageLines$validatorsFare, model.u, fares, optionsFare_),
							optionsFare_),
							$author$project$Components$Patterns$Forms$Input(
							{
								ie: $elm$core$Maybe$Nothing,
								iH: model.L === 2,
								iP: _List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-purple-secondary')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('A linha precisa estar entre 0 e 255.')
											]))
									]),
								nR: _List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-gray-shade'),
										$elm$html$Html$Attributes$max('255'),
										$elm$html$Html$Attributes$min('0')
									]),
								jl: $elm$core$Maybe$Just('Linha'),
								jn: _List_Nil,
								n9: $elm$core$Maybe$Just(3),
								c3: 'Campo para linha',
								jE: $elm$core$Maybe$Nothing,
								jF: $elm$core$Maybe$Nothing,
								jG: $elm$core$Maybe$Nothing,
								ov: $elm$core$Maybe$Nothing,
								jI: $elm$core$Maybe$Just(
									A2($elm$core$Basics$composeL, $author$project$Pages$Panel$ManageLines$ModalMsg, $author$project$Pages$Panel$ManageLines$InputtedLine)),
								hh: 'Insira a linha',
								kE: model.L === 1,
								kY: 'text',
								k1: $author$project$Pages$Panel$ManageLines$validatorsLine,
								di: model.e1
							}),
							A7($author$project$Pages$Panel$ManageLines$viewInput_, model.L, 'Nome', 'Insira o nome da linha', 'Campo para nome da linha', $author$project$Pages$Panel$ManageLines$InputtedName, $author$project$Pages$Panel$ManageLines$validatorsName, model.c3),
							A7($author$project$Pages$Panel$ManageLines$viewInput_, model.L, 'Descrição', 'Insira a descrição da linha', 'Campo para descrição da linha', $author$project$Pages$Panel$ManageLines$InputtedDescription, $author$project$Pages$Panel$ManageLines$validatorsDescription, model.z),
							$author$project$Components$Patterns$Forms$Select(
							{
								iH: model.L === 2,
								jl: $elm$core$Maybe$Just('Status da linha'),
								jn: _List_Nil,
								jI: $elm$core$Maybe$Just(
									A2($elm$core$Basics$composeL, $author$project$Pages$Panel$ManageLines$ModalMsg, $author$project$Pages$Panel$ManageLines$SelectedLineStatus)),
								jO: _List_fromArray(
									[
										{
										eX: !model.at,
										c3: $author$project$Services$Line$statusToStrPTBR(0),
										di: $author$project$Services$Line$statusToStrCODE(0)
									},
										{
										eX: model.at === 1,
										c3: $author$project$Services$Line$statusToStrPTBR(1),
										di: $author$project$Services$Line$statusToStrCODE(1)
									}
									]),
								jQ: false,
								ks: _List_Nil,
								kE: model.L === 1,
								k1: _List_Nil
							})
						]),
					oc: $elm$core$Maybe$Just(
						{
							lx: _List_fromArray(
								[
									$elm$html$Html$Attributes$class('self-center')
								]),
							l_: $author$project$Pages$Panel$ManageLines$ModalMsg($author$project$Pages$Panel$ManageLines$SubmitCREATE),
							iH: false
						}),
					pX: 'Criar'
				}),
			k5: $elm$html$Html$text('')
		});
};
var $author$project$Pages$Panel$ManageLines$SubmitEDIT = {$: 12};
var $author$project$Pages$Panel$ManageLines$viewModalContentEDIT = function (model) {
	var optionsLineType_ = $author$project$Pages$Panel$ManageLines$optionsLineType(model.kY);
	var optionsFare_ = A2($author$project$Pages$Panel$ManageLines$optionsFare, model.u, model.aV);
	var fares = A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, model.aV);
	return $author$project$Components$Patterns$Modal$simple(
		{
			hY: $elm$core$Maybe$Just(
				A2($elm$html$Html$Attributes$style, 'min-height', 'fit-content')),
			ii: '',
			il: '',
			ip: $author$project$Pages$Panel$ManageLines$CloseModal,
			fD: 'Editar linha',
			k4: $author$project$Components$Patterns$Forms$formSimple(
				{
					hZ: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col gap-4')
						]),
					L: model.L,
					jf: _List_fromArray(
						[
							A6(
							$author$project$Pages$Panel$ManageLines$viewInputSelect_,
							model.L,
							'Tarifa',
							$author$project$Pages$Panel$ManageLines$SelectedFare,
							model.u,
							A3($author$project$Pages$Panel$ManageLines$validatorsFare, model.u, fares, optionsFare_),
							optionsFare_),
							$author$project$Components$Patterns$Forms$Input(
							{
								ie: $elm$core$Maybe$Nothing,
								iH: model.L === 2,
								iP: _List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-purple-secondary')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('A linha precisa estar entre 0 e 255.')
											]))
									]),
								nR: _List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-gray-shade'),
										$elm$html$Html$Attributes$max('255'),
										$elm$html$Html$Attributes$min('0')
									]),
								jl: $elm$core$Maybe$Just('Linha'),
								jn: _List_Nil,
								n9: $elm$core$Maybe$Just(3),
								c3: 'Campo para linha',
								jE: $elm$core$Maybe$Nothing,
								jF: $elm$core$Maybe$Nothing,
								jG: $elm$core$Maybe$Nothing,
								ov: $elm$core$Maybe$Nothing,
								jI: $elm$core$Maybe$Just(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Pages$Panel$ManageLines$ModalMsg,
										A2(
											$elm$core$Basics$composeL,
											$author$project$Pages$Panel$ManageLines$InputtedLine,
											$elm$core$String$filter($elm$core$Char$isDigit)))),
								hh: 'Insira a linha',
								kE: model.L === 1,
								kY: 'text',
								k1: $author$project$Pages$Panel$ManageLines$validatorsLine,
								di: model.e1
							}),
							A7($author$project$Pages$Panel$ManageLines$viewInput_, model.L, 'Nome', 'Insira o nome da linha', 'Campo para nome da linha', $author$project$Pages$Panel$ManageLines$InputtedName, $author$project$Pages$Panel$ManageLines$validatorsName, model.c3),
							A7($author$project$Pages$Panel$ManageLines$viewInput_, model.L, 'Descrição', 'Insira a descrição da linha', 'Campo para descrição da linha', $author$project$Pages$Panel$ManageLines$InputtedDescription, $author$project$Pages$Panel$ManageLines$validatorsDescription, model.z),
							$author$project$Components$Patterns$Forms$Select(
							{
								iH: model.L === 2,
								jl: $elm$core$Maybe$Just('Status da linha'),
								jn: _List_Nil,
								jI: $elm$core$Maybe$Just(
									A2($elm$core$Basics$composeL, $author$project$Pages$Panel$ManageLines$ModalMsg, $author$project$Pages$Panel$ManageLines$SelectedLineStatus)),
								jO: _List_fromArray(
									[
										{
										eX: !model.at,
										c3: $author$project$Services$Line$statusToStrPTBR(0),
										di: $author$project$Services$Line$statusToStrCODE(0)
									},
										{
										eX: model.at === 1,
										c3: $author$project$Services$Line$statusToStrPTBR(1),
										di: $author$project$Services$Line$statusToStrCODE(1)
									}
									]),
								jQ: false,
								ks: _List_Nil,
								kE: model.L === 1,
								k1: _List_Nil
							})
						]),
					oc: $elm$core$Maybe$Just(
						{
							lx: _List_fromArray(
								[
									$elm$html$Html$Attributes$class('self-center')
								]),
							l_: $author$project$Pages$Panel$ManageLines$ModalMsg($author$project$Pages$Panel$ManageLines$SubmitEDIT),
							iH: false
						}),
					pX: 'Editar'
				}),
			k5: $elm$html$Html$text('')
		});
};
var $author$project$Pages$Panel$ManageLines$viewModal = F2(
	function (timezone, maybeModal) {
		if (!maybeModal.$) {
			if (!maybeModal.a.$) {
				var m = maybeModal.a.a;
				return $author$project$Pages$Panel$ManageLines$viewModalContentCREATE(m);
			} else {
				var m = maybeModal.a.a;
				return $author$project$Pages$Panel$ManageLines$viewModalContentEDIT(m);
			}
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Pages$Panel$ManageLines$ChangedOrder = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Panel$ManageLines$GoToCREATE = {$: 1};
var $author$project$Components$Patterns$Button$textSimple = F4(
	function (attrBtn, classBtn, title, msg) {
		return A2(
			$elm$html$Html$button,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('action-system  ' + classBtn),
						$elm$html$Html$Events$onClick(msg)
					]),
				attrBtn),
			_List_fromArray(
				[
					$elm$html$Html$text(title)
				]));
	});
var $author$project$Pages$Panel$ManageLines$GoToEDIT = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Panel$ManageLines$viewUserRow = F3(
	function (timezone, user, line) {
		var viewEditLine = $author$project$Services$Models$iHaveAccess(
			{
				gZ: user.hg,
				hf: $author$project$Services$Models$LINES(1),
				hQ: _List_fromArray(
					[
						A4(
						$author$project$Components$Patterns$Button$icon,
						$author$project$Pages$Panel$ManageLines$GoToEDIT(line),
						'icon-md',
						'edit',
						'Editar linha')
					]),
				hR: _List_Nil
			});
		var emptyValie = function (str) {
			return $elm$core$String$isEmpty(str) ? '-' : str;
		};
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($author$project$Utils$formatDateTimeFromPosix, timezone, line.ix))
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(line.e1)
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($elm$core$Maybe$withDefault, '-', line.gq))
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Services$Line$statusToStrPTBR(line.at))
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(line.c3)
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(line.z)
					])),
				A2($elm$html$Html$td, _List_Nil, viewEditLine)
			]);
	});
var $author$project$Pages$Panel$ManageLines$viewPage = F3(
	function (model, shared, user) {
		var viewCreateLine = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('top-actions pb-0 pt-4 mt-4')
				]),
			_List_fromArray(
				[
					A4(
					$author$project$Components$Patterns$Button$textSimple,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'width', 'max-content')
						]),
					'btn-ce btn-adicionar m-0',
					'Criar linha',
					$author$project$Pages$Panel$ManageLines$GoToCREATE)
				]));
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard')
				]),
			_List_fromArray(
				[
					$author$project$Services$Models$iHaveAccess(
					{
						gZ: user.hg,
						hf: $author$project$Services$Models$LINES(1),
						hQ: viewCreateLine,
						hR: $elm$html$Html$text('')
					}),
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-black mb-4')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Linhas')
						])),
					A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = model.n2;
							switch (_v0.$) {
								case 3:
									if (!_v0.a.b) {
										return $elm$html$Html$text('Nenhum registro encontrado');
									} else {
										var lines = _v0.a;
										var order = function () {
											var _v1 = _Utils_Tuple2(model.T.mn, model.T.mo);
											_v1$12:
											while (true) {
												if ((!_v1.a.$) && (!_v1.b.$)) {
													if (_v1.b.a === 1) {
														switch (_v1.a.a) {
															case 'createdIn':
																var _v2 = _v1.b.a;
																return A2(
																	$elm$core$List$sortBy,
																	A2(
																		$elm$core$Basics$composeR,
																		function ($) {
																			return $.ix;
																		},
																		$elm$time$Time$posixToMillis),
																	lines);
															case 'line':
																var _v4 = _v1.b.a;
																return A2(
																	$elm$core$List$sortBy,
																	A2(
																		$elm$core$Basics$composeR,
																		function ($) {
																			return $.e1;
																		},
																		A2(
																			$elm$core$Basics$composeR,
																			$elm$core$String$toInt,
																			$elm$core$Maybe$withDefault(0))),
																	lines);
															case 'fare':
																var _v6 = _v1.b.a;
																return A2(
																	$elm$core$List$sortBy,
																	A2(
																		$elm$core$Basics$composeR,
																		function ($) {
																			return $.gq;
																		},
																		A2(
																			$elm$core$Basics$composeR,
																			$elm$core$Maybe$andThen($elm$core$String$toInt),
																			$elm$core$Maybe$withDefault(0))),
																	lines);
															case 'status':
																var _v8 = _v1.b.a;
																return A2(
																	$elm$core$List$sortBy,
																	A2(
																		$elm$core$Basics$composeR,
																		function ($) {
																			return $.at;
																		},
																		$author$project$Services$Line$statusToStrPTBR),
																	lines);
															case 'name':
																var _v10 = _v1.b.a;
																return A2(
																	$elm$core$List$sortBy,
																	A2(
																		$elm$core$Basics$composeR,
																		function ($) {
																			return $.c3;
																		},
																		$elm$core$String$toLower),
																	lines);
															case 'description':
																var _v12 = _v1.b.a;
																return A2(
																	$elm$core$List$sortBy,
																	A2(
																		$elm$core$Basics$composeR,
																		function ($) {
																			return $.z;
																		},
																		$elm$core$String$toLower),
																	lines);
															default:
																break _v1$12;
														}
													} else {
														switch (_v1.a.a) {
															case 'createdIn':
																var _v3 = _v1.b.a;
																return $elm$core$List$reverse(
																	A2(
																		$elm$core$List$sortBy,
																		A2(
																			$elm$core$Basics$composeR,
																			function ($) {
																				return $.ix;
																			},
																			$elm$time$Time$posixToMillis),
																		lines));
															case 'line':
																var _v5 = _v1.b.a;
																return $elm$core$List$reverse(
																	A2(
																		$elm$core$List$sortBy,
																		A2(
																			$elm$core$Basics$composeR,
																			function ($) {
																				return $.e1;
																			},
																			A2(
																				$elm$core$Basics$composeR,
																				$elm$core$String$toInt,
																				$elm$core$Maybe$withDefault(0))),
																		lines));
															case 'fare':
																var _v7 = _v1.b.a;
																return $elm$core$List$reverse(
																	A2(
																		$elm$core$List$sortBy,
																		A2(
																			$elm$core$Basics$composeR,
																			function ($) {
																				return $.gq;
																			},
																			A2(
																				$elm$core$Basics$composeR,
																				$elm$core$Maybe$andThen($elm$core$String$toInt),
																				$elm$core$Maybe$withDefault(0))),
																		lines));
															case 'status':
																var _v9 = _v1.b.a;
																return $elm$core$List$reverse(
																	A2(
																		$elm$core$List$sortBy,
																		A2(
																			$elm$core$Basics$composeR,
																			function ($) {
																				return $.at;
																			},
																			$author$project$Services$Line$statusToStrPTBR),
																		lines));
															case 'name':
																var _v11 = _v1.b.a;
																return $elm$core$List$reverse(
																	A2(
																		$elm$core$List$sortBy,
																		A2(
																			$elm$core$Basics$composeR,
																			function ($) {
																				return $.c3;
																			},
																			$elm$core$String$toLower),
																		lines));
															case 'description':
																var _v13 = _v1.b.a;
																return $elm$core$List$reverse(
																	A2(
																		$elm$core$List$sortBy,
																		A2(
																			$elm$core$Basics$composeR,
																			function ($) {
																				return $.z;
																			},
																			$elm$core$String$toLower),
																		lines));
															default:
																break _v1$12;
														}
													}
												} else {
													break _v1$12;
												}
											}
											return lines;
										}();
										return $author$project$Components$Patterns$Tables$defaultWithOrderByColum(
											{
												mn: A2($elm$core$Maybe$withDefault, '', model.T.mn),
												mo: model.T.mo,
												nF: _List_fromArray(
													[
														{g8: 'createdIn', p2: 'Criado em'},
														{g8: 'line', p2: 'Linha'},
														{g8: 'fare', p2: 'Tarifa'},
														{g8: 'status', p2: 'Status'},
														{g8: 'name', p2: 'Nome'},
														{g8: 'description', p2: 'Descrição'},
														{g8: '', p2: ''}
													]),
												nX: true,
												oG: $author$project$Pages$Panel$ManageLines$ChangedOrder,
												pj: A2(
													$elm$core$List$map,
													A2($author$project$Pages$Panel$ManageLines$viewUserRow, shared.kS, user),
													order)
											});
									}
								case 0:
									return $elm$html$Html$text('Processo de inicialização não foi executado!');
								case 1:
									return $author$project$Components$View$loading;
								default:
									var e = _v0.a;
									return $elm$html$Html$text('Algo deu errado: ');
							}
						}()
						]))
				]));
	});
var $author$project$Pages$Panel$ManageLines$view = F3(
	function (model, shared, user) {
		return _Utils_Tuple2(
			'Linhas',
			_List_fromArray(
				[
					A3($author$project$Pages$Panel$ManageLines$viewPage, model, shared, user),
					A2($author$project$Pages$Panel$ManageLines$viewModal, shared.kS, model.aY)
				]));
	});
var $author$project$Pages$Panel$ManageOperators$CloseModal = {$: 5};
var $author$project$Pages$Panel$ManageOperators$InputtedEmail = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Panel$ManageOperators$InputtedName = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Panel$ManageOperators$SubmittedCreateOperator = {$: 10};
var $author$project$Pages$Panel$ManageOperators$SelectedPermission = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Panel$ManageOperators$viewCheckBox_ = function (modal) {
	return {
		h0: _List_Nil,
		jk: A2(
			$elm$core$List$map,
			function (p_) {
				return {
					ie: !_Utils_eq(
						$elm$core$Maybe$Nothing,
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (p) {
									return _Utils_eq(p, p_.di);
								},
								modal.J))),
					iH: modal.L === 2,
					c3: p_.jl,
					jG: $author$project$Pages$Panel$ManageOperators$ModalMsg(
						$author$project$Pages$Panel$ManageOperators$SelectedPermission(p_.di))
				};
			},
			A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, modal.oU))
	};
};
var $author$project$Pages$Panel$ManageOperators$viewModalContentCREATE = function (modal) {
	return $author$project$Components$Patterns$Modal$simple(
		{
			hY: $elm$core$Maybe$Just(
				A2($elm$html$Html$Attributes$style, 'min-height', 'fit-content')),
			ii: '',
			il: '',
			ip: $author$project$Pages$Panel$ManageOperators$CloseModal,
			fD: 'Cadastrar operador',
			k4: $author$project$Components$Patterns$Forms$formSimple(
				{
					hZ: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col gap-4')
						]),
					L: modal.L,
					jf: _List_fromArray(
						[
							$author$project$Components$Patterns$Forms$Input(
							{
								ie: $elm$core$Maybe$Nothing,
								iH: modal.L === 2,
								iP: _List_Nil,
								nR: _List_Nil,
								jl: $elm$core$Maybe$Just('Nome completo'),
								jn: _List_Nil,
								n9: $elm$core$Maybe$Just(70),
								c3: 'Nome completo',
								jE: $elm$core$Maybe$Nothing,
								jF: $elm$core$Maybe$Nothing,
								jG: $elm$core$Maybe$Nothing,
								ov: $elm$core$Maybe$Nothing,
								jI: $elm$core$Maybe$Just(
									A2($elm$core$Basics$composeL, $author$project$Pages$Panel$ManageOperators$ModalMsg, $author$project$Pages$Panel$ManageOperators$InputtedName)),
								hh: 'Insira o Nome completo do operador',
								kE: modal.L === 1,
								kY: 'input',
								k1: _List_fromArray(
									[
										_Utils_Tuple2($elm$core$String$isEmpty, 'Nome Não pode ser vázio')
									]),
								di: modal.c3
							}),
							$author$project$Components$Patterns$Forms$Input(
							{
								ie: $elm$core$Maybe$Nothing,
								iH: modal.L === 2,
								iP: _List_Nil,
								nR: _List_Nil,
								jl: $elm$core$Maybe$Just('Email'),
								jn: _List_Nil,
								n9: $elm$core$Maybe$Just(30),
								c3: 'E-mail',
								jE: $elm$core$Maybe$Nothing,
								jF: $elm$core$Maybe$Nothing,
								jG: $elm$core$Maybe$Nothing,
								ov: $elm$core$Maybe$Nothing,
								jI: $elm$core$Maybe$Just(
									A2($elm$core$Basics$composeL, $author$project$Pages$Panel$ManageOperators$ModalMsg, $author$project$Pages$Panel$ManageOperators$InputtedEmail)),
								hh: 'Insira o e-mail do operador',
								kE: modal.L === 1,
								kY: 'input',
								k1: _List_fromArray(
									[
										_Utils_Tuple2(
										A2($elm$core$Basics$composeR, $author$project$Utils$isValidEmail, $elm$core$Basics$not),
										'E-Mail está incorreto!')
									]),
								di: modal.mX
							}),
							$author$project$Components$Patterns$Forms$Checkbox(
							$author$project$Pages$Panel$ManageOperators$viewCheckBox_(
								{L: modal.L, oU: modal.oU, J: modal.J}))
						]),
					oc: $elm$core$Maybe$Just(
						{
							lx: _List_fromArray(
								[
									$elm$html$Html$Attributes$class('w-full')
								]),
							l_: $author$project$Pages$Panel$ManageOperators$ModalMsg($author$project$Pages$Panel$ManageOperators$SubmittedCreateOperator),
							iH: $elm$core$String$isEmpty(modal.iI)
						}),
					pX: 'Cadastrar'
				}),
			k5: $elm$html$Html$text('')
		});
};
var $author$project$Pages$Panel$ManageOperators$SubmittedDeleteOperator = {$: 12};
var $author$project$Pages$Panel$ManageOperators$viewModalContentDELETE = function (modal) {
	return $author$project$Components$Patterns$Modal$simple(
		{
			hY: $elm$core$Maybe$Just(
				A2($elm$html$Html$Attributes$style, 'min-height', 'fit-content')),
			ii: '',
			il: '',
			ip: $author$project$Pages$Panel$ManageOperators$CloseModal,
			fD: '',
			k4: A2(
				$elm$html$Html$article,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex flex-col gap-4')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('alerta')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$img,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$src('/images/alerta-ico.svg')
									]),
								_List_Nil),
								A2(
								$elm$html$Html$h2,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('txt-vermelho')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Atenção!')
									]))
							])),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('center-modal')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Você tem certeza que deseja Inativar este operador do sistema?')
									])),
								$elm$html$Html$text('Esta pessoa não terá as permissoes de operador.')
							])),
						modal.dP ? $author$project$Components$View$loading : A4(
						$author$project$Components$Patterns$Button$text,
						_List_Nil,
						'red-btn w-full',
						'Inativar',
						$author$project$Pages$Panel$ManageOperators$ModalMsg($author$project$Pages$Panel$ManageOperators$SubmittedDeleteOperator))
					])),
			k5: $elm$html$Html$text('')
		});
};
var $author$project$Pages$Panel$ManageOperators$SubmittedEditOperator = {$: 11};
var $author$project$Pages$Panel$ManageOperators$viewModalContentEDIT = function (modal) {
	return $author$project$Components$Patterns$Modal$simple(
		{
			hY: $elm$core$Maybe$Just(
				A2($elm$html$Html$Attributes$style, 'min-height', 'fit-content')),
			ii: '',
			il: '',
			ip: $author$project$Pages$Panel$ManageOperators$CloseModal,
			fD: 'Editar operador',
			k4: $author$project$Components$Patterns$Forms$formSimple(
				{
					hZ: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col gap-4')
						]),
					L: modal.L,
					jf: _List_fromArray(
						[
							$author$project$Components$Patterns$Forms$Input(
							{
								ie: $elm$core$Maybe$Nothing,
								iH: modal.L === 2,
								iP: _List_Nil,
								nR: _List_Nil,
								jl: $elm$core$Maybe$Just('Nome completo'),
								jn: _List_Nil,
								n9: $elm$core$Maybe$Just(70),
								c3: 'Nome completo',
								jE: $elm$core$Maybe$Nothing,
								jF: $elm$core$Maybe$Nothing,
								jG: $elm$core$Maybe$Nothing,
								ov: $elm$core$Maybe$Nothing,
								jI: $elm$core$Maybe$Just(
									A2($elm$core$Basics$composeL, $author$project$Pages$Panel$ManageOperators$ModalMsg, $author$project$Pages$Panel$ManageOperators$InputtedName)),
								hh: 'Insira o Nome completo do operador',
								kE: modal.L === 1,
								kY: 'input',
								k1: _List_fromArray(
									[
										_Utils_Tuple2($elm$core$String$isEmpty, 'Nome não pode ser vázio')
									]),
								di: modal.c3
							}),
							$author$project$Components$Patterns$Forms$Input(
							{
								ie: $elm$core$Maybe$Nothing,
								iH: modal.L === 2,
								iP: _List_Nil,
								nR: _List_Nil,
								jl: $elm$core$Maybe$Just('Email'),
								jn: _List_Nil,
								n9: $elm$core$Maybe$Just(30),
								c3: 'E-mail',
								jE: $elm$core$Maybe$Nothing,
								jF: $elm$core$Maybe$Nothing,
								jG: $elm$core$Maybe$Nothing,
								ov: $elm$core$Maybe$Nothing,
								jI: $elm$core$Maybe$Just(
									A2($elm$core$Basics$composeL, $author$project$Pages$Panel$ManageOperators$ModalMsg, $author$project$Pages$Panel$ManageOperators$InputtedEmail)),
								hh: 'Insira o e-mail do operador',
								kE: modal.L === 1,
								kY: 'input',
								k1: _List_fromArray(
									[
										_Utils_Tuple2(
										A2($elm$core$Basics$composeR, $author$project$Utils$isValidEmail, $elm$core$Basics$not),
										'E-Mail está incorreto!')
									]),
								di: modal.mX
							}),
							$author$project$Components$Patterns$Forms$Checkbox(
							$author$project$Pages$Panel$ManageOperators$viewCheckBox_(
								{L: modal.L, oU: modal.oU, J: modal.J}))
						]),
					oc: $elm$core$Maybe$Just(
						{
							lx: _List_fromArray(
								[
									$elm$html$Html$Attributes$class('w-full')
								]),
							l_: $author$project$Pages$Panel$ManageOperators$ModalMsg($author$project$Pages$Panel$ManageOperators$SubmittedEditOperator),
							iH: $elm$core$String$isEmpty(modal.iI)
						}),
					pX: 'Editar'
				}),
			k5: $elm$html$Html$text('')
		});
};
var $author$project$Pages$Panel$ManageOperators$InputtedDocument = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Panel$ManageOperators$SubmittedInsertDocument = {$: 9};
var $author$project$Pages$Panel$ManageOperators$validators = _List_fromArray(
	[
		_Utils_Tuple2($elm$core$String$isEmpty, 'CPF Não pode ser vázio'),
		_Utils_Tuple2(
		function (str) {
			return $elm$core$String$length(
				A2($elm$core$String$filter, $elm$core$Char$isDigit, str)) < 11;
		},
		'CPF incompleto')
	]);
var $author$project$Pages$Panel$ManageOperators$viewModalContentINSERT_DOCUMENT = function (modal) {
	return $author$project$Components$Patterns$Modal$simple(
		{
			hY: $elm$core$Maybe$Just(
				A2($elm$html$Html$Attributes$style, 'min-height', 'fit-content')),
			ii: '',
			il: '',
			ip: $author$project$Pages$Panel$ManageOperators$CloseModal,
			fD: 'Cadastrar operador',
			k4: $author$project$Components$Patterns$Forms$formSimple(
				{
					hZ: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col gap-4')
						]),
					L: modal.L,
					jf: _List_fromArray(
						[
							$author$project$Components$Patterns$Forms$Input(
							{
								ie: $elm$core$Maybe$Nothing,
								iH: modal.L === 2,
								iP: _List_Nil,
								nR: _List_Nil,
								jl: $elm$core$Maybe$Just('CPF'),
								jn: _List_Nil,
								n9: $elm$core$Maybe$Just(14),
								c3: 'CPF',
								jE: $elm$core$Maybe$Nothing,
								jF: $elm$core$Maybe$Nothing,
								jG: $elm$core$Maybe$Nothing,
								ov: $elm$core$Maybe$Nothing,
								jI: $elm$core$Maybe$Just(
									A2(
										$elm$core$Basics$composeL,
										A2($elm$core$Basics$composeL, $author$project$Pages$Panel$ManageOperators$ModalMsg, $author$project$Pages$Panel$ManageOperators$InputtedDocument),
										$elm$core$String$filter($elm$core$Char$isDigit))),
								hh: 'Insira o CPF do operador',
								kE: modal.L === 1,
								kY: 'input',
								k1: $author$project$Pages$Panel$ManageOperators$validators,
								di: $author$project$Utils$maskCPF(modal.iI)
							})
						]),
					oc: $elm$core$Maybe$Just(
						{
							lx: _List_Nil,
							l_: $author$project$Pages$Panel$ManageOperators$ModalMsg($author$project$Pages$Panel$ManageOperators$SubmittedInsertDocument),
							iH: $elm$core$String$isEmpty(modal.iI)
						}),
					pX: 'Cadastrar'
				}),
			k5: $elm$html$Html$text('')
		});
};
var $author$project$Pages$Panel$ManageOperators$viewModalContentQRCODE = function (m) {
	var dataImgQRCode = $author$project$Components$QRCodeGenerator$init(m.g6);
	return $author$project$Components$Patterns$Modal$simple(
		{
			hY: $elm$core$Maybe$Just(
				A2($elm$html$Html$Attributes$style, 'min-height', 'fit-content')),
			ii: '',
			il: '',
			ip: $author$project$Pages$Panel$ManageOperators$CloseModal,
			fD: 'QR CODE do Operador',
			k4: A2(
				$elm$html$Html$article,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex flex-col gap-4 items-center')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href(dataImgQRCode),
								$elm$html$Html$Attributes$download('QRCode-' + m.fa),
								$elm$html$Html$Attributes$title('Baixar QRCode')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$img,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$src(dataImgQRCode)
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$h1,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('m-0')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(m.fa)
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Utils$maskCPF(m.g5))
									]))
							]))
					])),
			k5: A4($author$project$Components$Patterns$Button$text, _List_Nil, ' w-full mt-4', 'Fechar', $author$project$Pages$Panel$ManageOperators$CloseModal)
		});
};
var $author$project$Pages$Panel$ManageOperators$GoToModalINSERT_DOCUMENT = {$: 1};
var $author$project$Pages$Panel$ManageOperators$GoToModalDELETE = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Panel$ManageOperators$GoToModalEDIT = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Panel$ManageOperators$GoToModalQRCODE = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Panel$ManageOperators$viewUserRow = F2(
	function (userLogged, user) {
		var permissions = A2(
			$elm$core$String$join,
			', ',
			A2(
				$elm$core$List$map,
				function ($) {
					return $.jl;
				},
				user.oU));
		var buttonEdit = $author$project$Services$Models$iHaveAccess(
			{
				gZ: userLogged.hg,
				hf: $author$project$Services$Models$OPERATORS(1),
				hQ: A4(
					$author$project$Components$Patterns$Button$text,
					_List_Nil,
					'',
					'Editar',
					$author$project$Pages$Panel$ManageOperators$GoToModalEDIT(user)),
				hR: $elm$html$Html$text('')
			});
		var buttonDelete = $author$project$Services$Models$iHaveAccess(
			{
				gZ: userLogged.hg,
				hf: $author$project$Services$Models$OPERATORS(1),
				hQ: A4(
					$author$project$Components$Patterns$Button$icon,
					$author$project$Pages$Panel$ManageOperators$GoToModalDELETE(user),
					'icon-md red-btn',
					'delete',
					'Deletar'),
				hR: $elm$html$Html$text('')
			});
		var actions = _List_fromArray(
			[
				A4(
				$author$project$Components$Patterns$Button$icon,
				$author$project$Pages$Panel$ManageOperators$GoToModalQRCODE(user),
				'icon-md',
				'qr_code',
				'QR CODE'),
				buttonEdit,
				buttonDelete
			]);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(user.c3)
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Utils$maskCPF(user.aS))
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(permissions)
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($elm$core$Maybe$withDefault, '-', user.ex))
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex gap-4')
					]),
				actions)
			]);
	});
var $author$project$Pages$Panel$ManageOperators$viewPage = F2(
	function (model, user) {
		var viewAddPouch = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('top-actions pb-0 pt-4 mt-4')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('btn-ce btn-adicionar'),
							A2($elm$html$Html$Attributes$style, 'width', 'max-content'),
							$elm$html$Html$Events$onClick($author$project$Pages$Panel$ManageOperators$GoToModalINSERT_DOCUMENT)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Cadastrar operador')
						]))
				]));
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard')
				]),
			_List_fromArray(
				[
					$author$project$Services$Models$iHaveAccess(
					{
						gZ: user.hg,
						hf: $author$project$Services$Models$OPERATORS(1),
						hQ: viewAddPouch,
						hR: $elm$html$Html$text('')
					}),
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-black mb-4')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Operadores')
						])),
					A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = model.c5;
							switch (_v0.$) {
								case 3:
									if (!_v0.a.b) {
										return $elm$html$Html$text('Nenhum registro encontrado');
									} else {
										var users = _v0.a;
										var filteredUsers = A2(
											$elm$core$List$filter,
											function (user_) {
												return A2($elm$core$List$any, $author$project$Pages$Panel$ManageOperators$filterPermission, user_.oU);
											},
											users);
										return $author$project$Components$Patterns$Tables$default(
											{
												nF: _List_fromArray(
													['Nome', 'CPF', 'Permissões', 'Concessionária', '']),
												nX: true,
												pj: A2(
													$elm$core$List$map,
													$author$project$Pages$Panel$ManageOperators$viewUserRow(user),
													filteredUsers)
											});
									}
								case 0:
									return $elm$html$Html$text('Processo de inicialização não foi executado!');
								case 1:
									return $author$project$Components$View$loading;
								default:
									var e = _v0.a;
									return $elm$html$Html$text('Algo deu errado: ');
							}
						}()
						]))
				]));
	});
var $author$project$Pages$Panel$ManageOperators$view = F3(
	function (model, user, shared) {
		var viewModal = function () {
			var _v0 = model.aY;
			if (!_v0.$) {
				switch (_v0.a.$) {
					case 1:
						var m_ = _v0.a.a;
						return $author$project$Pages$Panel$ManageOperators$viewModalContentCREATE(m_);
					case 0:
						var m_ = _v0.a.a;
						return $author$project$Pages$Panel$ManageOperators$viewModalContentINSERT_DOCUMENT(m_);
					case 2:
						var m_ = _v0.a.a;
						return $author$project$Pages$Panel$ManageOperators$viewModalContentEDIT(m_);
					case 3:
						var m_ = _v0.a.a;
						return $author$project$Pages$Panel$ManageOperators$viewModalContentDELETE(m_);
					default:
						var m_ = _v0.a.a;
						return $author$project$Pages$Panel$ManageOperators$viewModalContentQRCODE(m_);
				}
			} else {
				return $elm$html$Html$text('');
			}
		}();
		return _Utils_Tuple2(
			'Operadores',
			_List_fromArray(
				[
					A2($author$project$Pages$Panel$ManageOperators$viewPage, model, user),
					viewModal
				]));
	});
var $author$project$Pages$Panel$ManagePouches$CloseModal = {$: 4};
var $author$project$Pages$Panel$ManagePouches$InputtedPouchCode = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Panel$ManagePouches$SelectedPouchStatus = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Panel$ManagePouches$SubmittedPouch = {$: 2};
var $author$project$Services$Pouches$statusToStrPTBR = function (status) {
	if (!status) {
		return 'Ativo';
	} else {
		return 'Inativo';
	}
};
var $author$project$Pages$Panel$ManagePouches$validatorsPouchCODE = _List_fromArray(
	[
		_Utils_Tuple2($elm$core$String$isEmpty, 'Código para o malote é obrigatório')
	]);
var $author$project$Pages$Panel$ManagePouches$viewModalContent = function (options) {
	return $author$project$Components$Patterns$Modal$simple(
		{
			hY: $elm$core$Maybe$Just(
				A2($elm$html$Html$Attributes$style, 'min-height', 'fit-content')),
			ii: '',
			il: '',
			ip: $author$project$Pages$Panel$ManagePouches$CloseModal,
			fD: options.jx,
			k4: $author$project$Components$Patterns$Forms$formSimple(
				{
					hZ: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col gap-4')
						]),
					L: options.L,
					jf: _List_fromArray(
						[
							$author$project$Components$Patterns$Forms$Input(
							{
								ie: $elm$core$Maybe$Nothing,
								iH: (options.L === 2) || options.el.b,
								iP: _List_Nil,
								nR: _List_Nil,
								jl: $elm$core$Maybe$Just('Código do malote'),
								jn: _List_Nil,
								n9: $elm$core$Maybe$Just(30),
								c3: 'Campo para código do malote',
								jE: $elm$core$Maybe$Nothing,
								jF: $elm$core$Maybe$Nothing,
								jG: $elm$core$Maybe$Nothing,
								ov: $elm$core$Maybe$Nothing,
								jI: $elm$core$Maybe$Just(
									A2($elm$core$Basics$composeL, $author$project$Pages$Panel$ManagePouches$ModalMsg, $author$project$Pages$Panel$ManagePouches$InputtedPouchCode)),
								hh: 'Insira o código para o malote',
								kE: options.L === 1,
								kY: 'input',
								k1: $author$project$Pages$Panel$ManagePouches$validatorsPouchCODE,
								di: options.el.a
							}),
							$author$project$Components$Patterns$Forms$Select(
							{
								iH: options.L === 2,
								jl: $elm$core$Maybe$Just('Status do malote'),
								jn: _List_Nil,
								jI: $elm$core$Maybe$Just(
									A2($elm$core$Basics$composeL, $author$project$Pages$Panel$ManagePouches$ModalMsg, $author$project$Pages$Panel$ManagePouches$SelectedPouchStatus)),
								jO: _List_fromArray(
									[
										{
										eX: !options.fM,
										c3: $author$project$Services$Pouches$statusToStrPTBR(0),
										di: $author$project$Services$Pouches$statusToStrCODE(0)
									},
										{
										eX: options.fM === 1,
										c3: $author$project$Services$Pouches$statusToStrPTBR(1),
										di: $author$project$Services$Pouches$statusToStrCODE(1)
									}
									]),
								jQ: false,
								ks: _List_Nil,
								kE: options.L === 1,
								k1: _List_Nil
							})
						]),
					oc: $elm$core$Maybe$Just(
						{
							lx: _List_Nil,
							l_: $author$project$Pages$Panel$ManagePouches$ModalMsg($author$project$Pages$Panel$ManagePouches$SubmittedPouch),
							iH: $elm$core$String$isEmpty(options.el.a)
						}),
					pX: options.kM
				}),
			k5: $elm$html$Html$text('')
		});
};
var $author$project$Pages$Panel$ManagePouches$viewModalQRCODE = function (options) {
	var dataImgQRCode = $author$project$Components$QRCodeGenerator$init('www.pazze.app/?a=' + options.cf.fi);
	return $author$project$Components$Patterns$Modal$simple(
		{
			hY: $elm$core$Maybe$Just(
				A2($elm$html$Html$Attributes$style, 'min-height', 'fit-content')),
			ii: '',
			il: '',
			ip: $author$project$Pages$Panel$ManagePouches$CloseModal,
			fD: options.jx,
			k4: A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('center-modal')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href(dataImgQRCode),
										$elm$html$Html$Attributes$download('QRCode-malote-' + options.cf.fi),
										$elm$html$Html$Attributes$title('Baixar QRCode')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$img,
										_List_fromArray(
											[
												A2($elm$html$Html$Attributes$style, 'width', '17rem'),
												$elm$html$Html$Attributes$src(dataImgQRCode)
											]),
										_List_Nil)
									]))
							])),
						A2(
						$elm$html$Html$h1,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('center-modal m-0')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(options.cf.fi)
							]))
					])),
			k5: A4($author$project$Components$Patterns$Button$text, _List_Nil, ' mt-4', 'Fechar', $author$project$Pages$Panel$ManagePouches$CloseModal)
		});
};
var $author$project$Pages$Panel$ManagePouches$viewModal = function (modalStatus) {
	if (!modalStatus.$) {
		switch (modalStatus.a.$) {
			case 0:
				var p = modalStatus.a.a;
				return $author$project$Pages$Panel$ManagePouches$viewModalQRCODE(
					{jx: 'QR Code do malote', cf: p});
			case 1:
				var m = modalStatus.a.a;
				return $author$project$Pages$Panel$ManagePouches$viewModalContent(
					{
						L: m.L,
						jv: $elm$core$Maybe$Nothing,
						jx: 'Criar malote',
						kM: 'Criar malote',
						el: _Utils_Tuple2(m.fi, false),
						fM: m.M
					});
			default:
				var m = modalStatus.a.a;
				return $author$project$Pages$Panel$ManagePouches$viewModalContent(
					{
						L: m.L,
						jv: $elm$core$Maybe$Just(m.cf),
						jx: 'Editar malote',
						kM: 'Editar malote',
						el: _Utils_Tuple2(m.cf.fi, true),
						fM: m.M
					});
		}
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Pages$Panel$ManagePouches$CreatePouch = {$: 1};
var $author$project$Pages$Panel$ManagePouches$EditPouch = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Panel$ManagePouches$ViewQRCODE = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Panel$ManagePouches$viewPouchRow = function (pouch) {
	var viewBtnEdit = A4(
		$author$project$Components$Patterns$Button$text,
		_List_Nil,
		'',
		'Editar',
		$author$project$Pages$Panel$ManagePouches$EditPouch(pouch));
	var rowTd = function (txt) {
		return A2(
			$elm$html$Html$td,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(txt)
				]));
	};
	return _List_fromArray(
		[
			rowTd(pouch.fi),
			rowTd(
			$author$project$Services$Pouches$statusToStrPTBR(pouch.kK)),
			A2(
			$elm$html$Html$td,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex gap-4 justify-end')
				]),
			_List_fromArray(
				[
					A4(
					$author$project$Components$Patterns$Button$icon,
					$author$project$Pages$Panel$ManagePouches$ViewQRCODE(pouch),
					'icon-qrcode',
					'qr_code',
					'Abrir QRCode'),
					viewBtnEdit
				]))
		]);
};
var $author$project$Pages$Panel$ManagePouches$viewPage = F2(
	function (user, model) {
		var viewAddPouch = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('top-actions pb-0 pt-4 mt-4')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('btn-ce btn-adicionar'),
							A2($elm$html$Html$Attributes$style, 'width', 'max-content'),
							$elm$html$Html$Events$onClick($author$project$Pages$Panel$ManagePouches$CreatePouch)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Criar malote')
						]))
				]));
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Services$Models$iHaveAccess(
							{
								gZ: user.hg,
								hf: $author$project$Services$Models$POUCH(1),
								hQ: viewAddPouch,
								hR: $elm$html$Html$text('')
							}),
							A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-black ')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Malotes criados')
								]))
						])),
					A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = model.fj;
							switch (_v0.$) {
								case 3:
									if (!_v0.a.b) {
										return $elm$html$Html$text('Nenhum registro encontrado');
									} else {
										var pouches = _v0.a;
										return $author$project$Components$Patterns$Tables$default(
											{
												nF: _List_fromArray(
													['Código do malote', 'Status', '']),
												nX: true,
												pj: A2($elm$core$List$map, $author$project$Pages$Panel$ManagePouches$viewPouchRow, pouches)
											});
									}
								case 0:
									return $elm$html$Html$text('Processo de execução está incorreto!');
								case 1:
									return $author$project$Components$View$loading;
								default:
									var e = _v0.a;
									return $elm$html$Html$text('Algo deu errado: ' + e);
							}
						}()
						]))
				]));
	});
var $author$project$Pages$Panel$ManagePouches$view = F3(
	function (user, model, shared) {
		return _Utils_Tuple2(
			'Malotes',
			_List_fromArray(
				[
					A2($author$project$Pages$Panel$ManagePouches$viewPage, user, model),
					$author$project$Pages$Panel$ManagePouches$viewModal(model.aY)
				]));
	});
var $author$project$Pages$Panel$MyAccount$SubPage$InputtedEmail = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Panel$MyAccount$SubPage$InputtedEmailConfirmation = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Panel$MyAccount$SubPage$SubmitAccount = {$: 2};
var $author$project$Pages$Panel$MyAccount$SubPage$formAccount_ = F2(
	function (options, submitTitle) {
		return $author$project$Components$Patterns$Forms$formSimple(
			{
				hZ: _List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex flex-col gap-4 mt-8 mx-12 items-center')
					]),
				L: options.L,
				jf: _List_fromArray(
					[
						$author$project$Components$Patterns$Forms$Input(
						{
							ie: $elm$core$Maybe$Nothing,
							iH: options.L === 2,
							iP: _List_Nil,
							nR: _List_Nil,
							jl: $elm$core$Maybe$Just('Novo e-mail'),
							jn: _List_fromArray(
								[
									$elm$html$Html$Attributes$class('w-full md:w-100')
								]),
							n9: $elm$core$Maybe$Just(100),
							c3: 'Campo para definir novo e-mail',
							jE: $elm$core$Maybe$Nothing,
							jF: $elm$core$Maybe$Nothing,
							jG: $elm$core$Maybe$Nothing,
							ov: $elm$core$Maybe$Nothing,
							jI: $elm$core$Maybe$Just($author$project$Pages$Panel$MyAccount$SubPage$InputtedEmail),
							hh: '',
							kE: options.L === 1,
							kY: 'text',
							k1: _List_fromArray(
								[
									_Utils_Tuple2($elm$core$String$isEmpty, 'E-mail não pode ser vazio.'),
									_Utils_Tuple2(
									A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Utils$isValidEmail),
									'E-mail inválido.')
								]),
							di: options.mX
						}),
						$author$project$Components$Patterns$Forms$Input(
						{
							ie: $elm$core$Maybe$Nothing,
							iH: options.L === 2,
							iP: _List_Nil,
							nR: _List_Nil,
							jl: $elm$core$Maybe$Just('Confirme seu novo e-mail'),
							jn: _List_fromArray(
								[
									$elm$html$Html$Attributes$class('w-full md:w-100')
								]),
							n9: $elm$core$Maybe$Just(100),
							c3: 'Campo para confirmar novo e-mail',
							jE: $elm$core$Maybe$Nothing,
							jF: $elm$core$Maybe$Nothing,
							jG: $elm$core$Maybe$Nothing,
							ov: $elm$core$Maybe$Nothing,
							jI: $elm$core$Maybe$Just($author$project$Pages$Panel$MyAccount$SubPage$InputtedEmailConfirmation),
							hh: '',
							kE: options.L === 1,
							kY: 'text',
							k1: _List_fromArray(
								[
									_Utils_Tuple2(
									$author$project$Pages$Panel$MyAccount$SubPage$isInvalidPasswordConfirmation(options.mX),
									'Certifique-se de digitar o mesmo e-mail nos dois campos.'),
									_Utils_Tuple2($elm$core$String$isEmpty, 'A confirmação de e-mail não pode ser vazio.'),
									_Utils_Tuple2(
									A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Utils$isValidEmail),
									'E-mail inválido.')
								]),
							di: options.bW
						})
					]),
				oc: $elm$core$Maybe$Just(
					{
						lx: _List_fromArray(
							[
								$elm$html$Html$Attributes$class('')
							]),
						l_: $author$project$Pages$Panel$MyAccount$SubPage$SubmitAccount,
						iH: $elm$core$String$isEmpty(options.mX) || $elm$core$String$isEmpty(options.bW)
					}),
				pX: submitTitle
			});
	});
var $author$project$Pages$Panel$MyAccount$SubPage$ClickedToggleVisibilityPassword = {$: 1};
var $author$project$Pages$Panel$MyAccount$SubPage$ClickedToggleVisibilityPasswordConfirmation = {$: 3};
var $author$project$Pages$Panel$MyAccount$SubPage$InputtedPassword = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Panel$MyAccount$SubPage$InputtedPasswordConfirmation = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Panel$MyAccount$SubPage$SubmitPassword = {$: 4};
var $author$project$Pages$Panel$MyAccount$SubPage$formPassword_ = F2(
	function (options, submitTitle) {
		return $author$project$Components$Patterns$Forms$formSimple(
			{
				hZ: _List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex flex-col gap-4 mt-8 mx-12 items-center')
					]),
				L: options.L,
				jf: _List_fromArray(
					[
						$author$project$Components$Patterns$Forms$InputPassword(
						{
							ie: $elm$core$Maybe$Nothing,
							iH: options.L === 2,
							nR: _List_Nil,
							dY: options.oN.dY,
							jl: $elm$core$Maybe$Just('Nova senha'),
							jn: _List_fromArray(
								[
									$elm$html$Html$Attributes$class('w-full md:w-100')
								]),
							n9: $elm$core$Maybe$Just(100),
							c3: 'Campo para definir nova senha',
							jE: $elm$core$Maybe$Nothing,
							jF: $elm$core$Maybe$Nothing,
							jG: $elm$core$Maybe$Nothing,
							jH: $author$project$Pages$Panel$MyAccount$SubPage$ClickedToggleVisibilityPassword,
							ov: $elm$core$Maybe$Nothing,
							jI: $elm$core$Maybe$Just($author$project$Pages$Panel$MyAccount$SubPage$InputtedPassword),
							hh: '',
							kE: options.L === 1,
							k1: _List_fromArray(
								[
									_Utils_Tuple2($elm$core$String$isEmpty, 'A senha não pode ser vazia.')
								]),
							di: options.oN.di
						}),
						$author$project$Components$Patterns$Forms$InputPassword(
						{
							ie: $elm$core$Maybe$Nothing,
							iH: options.L === 2,
							nR: _List_Nil,
							dY: options.c6.dY,
							jl: $elm$core$Maybe$Just('Confirme sua nova senha'),
							jn: _List_fromArray(
								[
									$elm$html$Html$Attributes$class('w-full md:w-100')
								]),
							n9: $elm$core$Maybe$Just(100),
							c3: 'Campo para confirmar nova senha',
							jE: $elm$core$Maybe$Nothing,
							jF: $elm$core$Maybe$Nothing,
							jG: $elm$core$Maybe$Nothing,
							jH: $author$project$Pages$Panel$MyAccount$SubPage$ClickedToggleVisibilityPasswordConfirmation,
							ov: $elm$core$Maybe$Nothing,
							jI: $elm$core$Maybe$Just($author$project$Pages$Panel$MyAccount$SubPage$InputtedPasswordConfirmation),
							hh: '',
							kE: options.L === 1,
							k1: _List_fromArray(
								[
									_Utils_Tuple2(
									$author$project$Pages$Panel$MyAccount$SubPage$isInvalidPasswordConfirmation(options.oN.di),
									'As senhas informadas não correspondem. Certifique-se de digitar a mesma senha nos dois campos.'),
									_Utils_Tuple2($elm$core$String$isEmpty, 'A confirmação de senha não pode ser vazia.')
								]),
							di: options.c6.di
						})
					]),
				oc: $elm$core$Maybe$Just(
					{
						lx: _List_fromArray(
							[
								$elm$html$Html$Attributes$class('')
							]),
						l_: $author$project$Pages$Panel$MyAccount$SubPage$SubmitPassword,
						iH: $elm$core$String$isEmpty(options.oN.di) || $elm$core$String$isEmpty(options.c6.di)
					}),
				pX: submitTitle
			});
	});
var $elm$html$Html$hr = _VirtualDom_node('hr');
var $author$project$Components$Patterns$Division$horizontalLine = A2(
	$elm$html$Html$hr,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('m-0 p-0 my-2 border-purple-main')
		]),
	_List_Nil);
var $author$project$Pages$Panel$MyAccount$SubPage$nav = function (shared) {
	var item = F2(
		function (title, route) {
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('font-semibold text-base p-2 rounded-t-lg mr-2'),
						$author$project$Route$href(route),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'text-white bg-purple-main',
								_Utils_eq(shared.pv, route)),
								_Utils_Tuple2(
								'text-purple-main hover:text-white hover:bg-purple-main',
								!_Utils_eq(shared.pv, route))
							]))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(title)
					]));
		});
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$nav,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						item,
						'Conta',
						$author$project$Route$Panel(
							$author$project$Route$MyAccount(1))),
						A2(
						item,
						'Senha',
						$author$project$Route$Panel(
							$author$project$Route$MyAccount(0)))
					])),
				$author$project$Components$Patterns$Division$horizontalLine
			]));
};
var $author$project$Pages$Panel$MyAccount$SubPage$viewPage = F2(
	function (model, shared) {
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-black mb-4')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Minha conta')
						])),
					A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Panel$MyAccount$SubPage$nav(shared)
						])),
					function () {
					if (!model.$) {
						var m = model.a;
						return A2(
							$elm$html$Html$map,
							$author$project$Pages$Panel$MyAccount$SubPage$PasswordMsg,
							A2($author$project$Pages$Panel$MyAccount$SubPage$formPassword_, m, 'Alterar senha'));
					} else {
						var m = model.a;
						return A2(
							$elm$html$Html$map,
							$author$project$Pages$Panel$MyAccount$SubPage$AccountMsg,
							A2($author$project$Pages$Panel$MyAccount$SubPage$formAccount_, m, 'Alterar e-mail'));
					}
				}()
				]));
	});
var $author$project$Pages$Panel$MyAccount$SubPage$view = F2(
	function (model, shared) {
		var viewModal = $elm$html$Html$text('');
		return _Utils_Tuple2(
			'Minha conta',
			_List_fromArray(
				[
					A2($author$project$Pages$Panel$MyAccount$SubPage$viewPage, model, shared),
					viewModal
				]));
	});
var $author$project$Pages$Panel$Reason$CloseModal = {$: 2};
var $author$project$Pages$Panel$Reason$InputtedDescription = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Panel$Reason$InputtedReasonValue = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Panel$Reason$SelectedAction = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Panel$Reason$SubmitCREATE = {$: 3};
var $author$project$Pages$Panel$Reason$viewModalCreateReason = function (model) {
	return $author$project$Components$Patterns$Modal$simple(
		{
			hY: $elm$core$Maybe$Just(
				A2($elm$html$Html$Attributes$style, 'min-height', 'fit-content')),
			ii: '',
			il: '',
			ip: $author$project$Pages$Panel$Reason$CloseModal,
			fD: 'Criar motivo',
			k4: $author$project$Components$Patterns$Forms$formSimple(
				{
					hZ: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col gap-4')
						]),
					L: model.L,
					jf: _List_fromArray(
						[
							$author$project$Components$Patterns$Forms$Input(
							{
								ie: $elm$core$Maybe$Nothing,
								iH: model.L === 2,
								iP: _List_Nil,
								nR: _List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-gray-shade')
									]),
								jl: $elm$core$Maybe$Just('Descrição'),
								jn: _List_Nil,
								n9: $elm$core$Maybe$Just(80),
								c3: 'Campo para Descrição',
								jE: $elm$core$Maybe$Nothing,
								jF: $elm$core$Maybe$Nothing,
								jG: $elm$core$Maybe$Nothing,
								ov: $elm$core$Maybe$Nothing,
								jI: $elm$core$Maybe$Just(
									A2($elm$core$Basics$composeL, $author$project$Pages$Panel$Reason$ModalMsg, $author$project$Pages$Panel$Reason$InputtedDescription)),
								hh: 'Insira uma descrição para o motivo',
								kE: model.L === 1,
								kY: 'text',
								k1: $author$project$Pages$Panel$Reason$validatorsDescription,
								di: model.z
							}),
							$author$project$Components$Patterns$Forms$Select(
							{
								iH: model.L === 2,
								jl: $elm$core$Maybe$Just('Tipo'),
								jn: _List_Nil,
								jI: $elm$core$Maybe$Just(
									A2($elm$core$Basics$composeL, $author$project$Pages$Panel$Reason$ModalMsg, $author$project$Pages$Panel$Reason$SelectedAction)),
								jO: A2(
									$elm$core$List$cons,
									{
										eX: _Utils_eq(model.N, $elm$core$Maybe$Nothing),
										c3: 'Selecione',
										di: ''
									},
									A2(
										$elm$core$List$map,
										function (action) {
											return {
												eX: A2(
													$elm$core$Maybe$withDefault,
													false,
													A2(
														$elm$core$Maybe$map,
														$elm$core$Basics$eq(action),
														model.N)),
												c3: $author$project$Services$Reason$actionToBRL(action),
												di: $author$project$Services$Reason$actionToCode(action)
											};
										},
										$author$project$Services$Reason$allActions)),
								jQ: false,
								ks: _List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'margin', '0'),
										$elm$html$Html$Attributes$class('text-gray-shade')
									]),
								kE: model.L === 1,
								k1: A2($author$project$Pages$Panel$Reason$validatorsActions, model.N, $author$project$Services$Reason$allActions)
							}),
							A2(
							$elm$core$Maybe$withDefault,
							true,
							A2(
								$elm$core$Maybe$map,
								$elm$core$Basics$neq(2),
								model.N)) ? $author$project$Components$Patterns$Forms$Html(
							$elm$html$Html$text('')) : $author$project$Components$Patterns$Forms$Input(
							{
								ie: $elm$core$Maybe$Nothing,
								iH: model.L === 2,
								iP: _List_Nil,
								nR: _List_Nil,
								jl: $elm$core$Maybe$Just('Valor'),
								jn: _List_Nil,
								n9: $elm$core$Maybe$Just(10),
								c3: '',
								jE: $elm$core$Maybe$Nothing,
								jF: $elm$core$Maybe$Nothing,
								jG: $elm$core$Maybe$Nothing,
								ov: $elm$core$Maybe$Nothing,
								jI: $elm$core$Maybe$Just(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Pages$Panel$Reason$ModalMsg,
										A2(
											$elm$core$Basics$composeL,
											$author$project$Pages$Panel$Reason$InputtedReasonValue,
											$elm$core$String$filter($elm$core$Char$isDigit)))),
								hh: 'Informe o valor',
								kE: model.L === 1,
								kY: 'text',
								k1: $author$project$Pages$Panel$Reason$validatorsValue,
								di: $author$project$Utils$formatMoneyInput(
									$elm$core$String$fromInt(model.lo))
							})
						]),
					oc: $elm$core$Maybe$Just(
						{
							lx: _List_fromArray(
								[
									$elm$html$Html$Attributes$class('self-center')
								]),
							l_: $author$project$Pages$Panel$Reason$ModalMsg($author$project$Pages$Panel$Reason$SubmitCREATE),
							iH: false
						}),
					pX: 'Criar'
				}),
			k5: $elm$html$Html$text('')
		});
};
var $author$project$Pages$Panel$Reason$SubmitEDIT = {$: 4};
var $author$project$Pages$Panel$Reason$viewModalEditReason = function (model) {
	return $author$project$Components$Patterns$Modal$simple(
		{
			hY: $elm$core$Maybe$Just(
				A2($elm$html$Html$Attributes$style, 'min-height', 'fit-content')),
			ii: '',
			il: '',
			ip: $author$project$Pages$Panel$Reason$CloseModal,
			fD: 'Editar motivo',
			k4: $author$project$Components$Patterns$Forms$formSimple(
				{
					hZ: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col gap-4')
						]),
					L: model.L,
					jf: _List_fromArray(
						[
							$author$project$Components$Patterns$Forms$Input(
							{
								ie: $elm$core$Maybe$Nothing,
								iH: model.L === 2,
								iP: _List_Nil,
								nR: _List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-gray-shade')
									]),
								jl: $elm$core$Maybe$Just('Descrição'),
								jn: _List_Nil,
								n9: $elm$core$Maybe$Just(80),
								c3: 'Campo para Descrição',
								jE: $elm$core$Maybe$Nothing,
								jF: $elm$core$Maybe$Nothing,
								jG: $elm$core$Maybe$Nothing,
								ov: $elm$core$Maybe$Nothing,
								jI: $elm$core$Maybe$Just(
									A2($elm$core$Basics$composeL, $author$project$Pages$Panel$Reason$ModalMsg, $author$project$Pages$Panel$Reason$InputtedDescription)),
								hh: 'Insira uma descrição para o motivo',
								kE: model.L === 1,
								kY: 'text',
								k1: $author$project$Pages$Panel$Reason$validatorsDescription,
								di: model.z
							}),
							A2(
							$elm$core$Maybe$withDefault,
							true,
							A2(
								$elm$core$Maybe$map,
								$elm$core$Basics$neq(2),
								model.N)) ? $author$project$Components$Patterns$Forms$Html(
							$elm$html$Html$text('')) : $author$project$Components$Patterns$Forms$Input(
							{
								ie: $elm$core$Maybe$Nothing,
								iH: model.L === 2,
								iP: _List_Nil,
								nR: _List_Nil,
								jl: $elm$core$Maybe$Just('Valor'),
								jn: _List_Nil,
								n9: $elm$core$Maybe$Just(10),
								c3: '',
								jE: $elm$core$Maybe$Nothing,
								jF: $elm$core$Maybe$Nothing,
								jG: $elm$core$Maybe$Nothing,
								ov: $elm$core$Maybe$Nothing,
								jI: $elm$core$Maybe$Just(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Pages$Panel$Reason$ModalMsg,
										A2(
											$elm$core$Basics$composeL,
											$author$project$Pages$Panel$Reason$InputtedReasonValue,
											$elm$core$String$filter($elm$core$Char$isDigit)))),
								hh: 'Informe o valor',
								kE: model.L === 1,
								kY: 'text',
								k1: $author$project$Pages$Panel$Reason$validatorsValue,
								di: $author$project$Utils$formatMoneyInput(
									$elm$core$String$fromInt(model.lo))
							})
						]),
					oc: $elm$core$Maybe$Just(
						{
							lx: _List_fromArray(
								[
									$elm$html$Html$Attributes$class('self-center')
								]),
							l_: $author$project$Pages$Panel$Reason$ModalMsg($author$project$Pages$Panel$Reason$SubmitEDIT),
							iH: false
						}),
					pX: 'Editar'
				}),
			k5: $elm$html$Html$text('')
		});
};
var $author$project$Pages$Panel$Reason$viewModal = F2(
	function (timezone, maybeModal) {
		if (!maybeModal.$) {
			if (!maybeModal.a.$) {
				var m = maybeModal.a.a;
				return $author$project$Pages$Panel$Reason$viewModalCreateReason(m);
			} else {
				var m = maybeModal.a.a;
				return $author$project$Pages$Panel$Reason$viewModalEditReason(m);
			}
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Pages$Panel$Reason$OpenCreateReason = {$: 4};
var $author$project$Pages$Panel$Reason$SelectedActionList = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Panel$Reason$OpenEditReason = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Panel$Reason$viewRowStr = F2(
	function (timezone, reason) {
		return _List_fromArray(
			[
				A2($author$project$Utils$formatDateTimeFromPosixWithSeconds, timezone, reason.ix),
				reason.pf,
				$author$project$Services$Reason$actionToBRL(reason.hV),
				$author$project$Utils$formatAsMoney(
				$elm$core$String$fromInt(reason.fB))
			]);
	});
var $author$project$Pages$Panel$Reason$viewRowHtml = F3(
	function (user, timezone, reason) {
		var viewEdit = $author$project$Services$Models$iHaveAccess(
			{
				gZ: user.hg,
				hf: $author$project$Services$Models$REASONS(1),
				hQ: A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							A4(
							$author$project$Components$Patterns$Button$icon,
							$author$project$Pages$Panel$Reason$OpenEditReason(reason),
							'icon-md',
							'edit',
							'Editar motivo')
						])),
				hR: A2($elm$html$Html$td, _List_Nil, _List_Nil)
			});
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(str)
							]));
				},
				A2($author$project$Pages$Panel$Reason$viewRowStr, timezone, reason)),
			_List_fromArray(
				[viewEdit]));
	});
var $author$project$Pages$Panel$Reason$viewPage = F3(
	function (model, shared, user) {
		var viewCreateLine = $author$project$Services$Models$iHaveAccess(
			{
				gZ: user.hg,
				hf: $author$project$Services$Models$REASONS(1),
				hQ: A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('top-actions pb-0 pt-4 mt-4')
						]),
					_List_fromArray(
						[
							A4(
							$author$project$Components$Patterns$Button$textSimple,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'width', 'max-content')
								]),
							'btn-ce btn-adicionar m-0',
							'Criar motivo',
							$author$project$Pages$Panel$Reason$OpenCreateReason)
						])),
				hR: $elm$html$Html$text('')
			});
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard')
				]),
			_List_fromArray(
				[
					viewCreateLine,
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-black mb-4')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Motivos')
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Components$Patterns$Forms$formSimple(
							{
								hZ: _List_fromArray(
									[
										$elm$html$Html$Attributes$class('w-full'),
										$elm$html$Html$Attributes$novalidate(true)
									]),
								L: model.L,
								jf: _List_fromArray(
									[
										$author$project$Components$Patterns$Forms$Select(
										{
											iH: model.L === 2,
											jl: $elm$core$Maybe$Just('Tipo'),
											jn: _List_fromArray(
												[
													$elm$html$Html$Attributes$class('flex flex-col justify-end'),
													A2($elm$html$Html$Attributes$style, 'width', 'fit-content')
												]),
											jI: $elm$core$Maybe$Just($author$project$Pages$Panel$Reason$SelectedActionList),
											jO: A2(
												$elm$core$List$cons,
												{
													eX: _Utils_eq(model.T.hV, $elm$core$Maybe$Nothing),
													c3: 'Selecione',
													di: ''
												},
												A2(
													$elm$core$List$map,
													function (action) {
														return {
															eX: A2(
																$elm$core$Maybe$withDefault,
																false,
																A2(
																	$elm$core$Maybe$map,
																	$elm$core$Basics$eq(action),
																	model.T.hV)),
															c3: $author$project$Services$Reason$actionToBRL(action),
															di: $author$project$Services$Reason$actionToCode(action)
														};
													},
													$author$project$Services$Reason$allActions)),
											jQ: false,
											ks: _List_fromArray(
												[
													$elm$html$Html$Attributes$class('mt-2'),
													A2($elm$html$Html$Attributes$style, 'margin-bottom', '0')
												]),
											kE: model.L === 1,
											k1: _List_Nil
										})
									]),
								oc: $elm$core$Maybe$Nothing,
								pX: 'Pesquisar'
							})
						])),
					A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = model.d5;
							switch (_v0.$) {
								case 3:
									if (!_v0.a.b) {
										return $elm$html$Html$text('Nenhum registro encontrado');
									} else {
										var reasons = _v0.a;
										var filterByQuery = A2(
											$elm$core$List$filter,
											function (_v1) {
												var action = _v1.hV;
												return A2(
													$elm$core$Maybe$withDefault,
													true,
													A2(
														$elm$core$Maybe$map,
														$elm$core$Basics$eq(action),
														model.T.hV));
											},
											reasons);
										return $author$project$Components$Patterns$Tables$default(
											{
												nF: _List_fromArray(
													['Criado em', 'Descrição', 'Tipo', 'Valor', '']),
												nX: true,
												pj: A2(
													$elm$core$List$map,
													A2($author$project$Pages$Panel$Reason$viewRowHtml, user, shared.kS),
													filterByQuery)
											});
									}
								case 0:
									return $elm$html$Html$text('Processo de execução está incorreto!');
								case 1:
									return $author$project$Components$View$loading;
								default:
									var e = _v0.a;
									return $elm$html$Html$text('Algo deu errado: ' + e);
							}
						}()
						]))
				]));
	});
var $author$project$Pages$Panel$Reason$view = F3(
	function (model, shared, user) {
		return _Utils_Tuple2(
			'Motivos',
			_List_fromArray(
				[
					A3($author$project$Pages$Panel$Reason$viewPage, model, shared, user),
					A2($author$project$Pages$Panel$Reason$viewModal, shared.kS, model.aY)
				]));
	});
var $author$project$Pages$Panel$ReversalApprovalCashier$GenerateCsvDownload = {$: 13};
var $author$project$Pages$Panel$ReversalApprovalCashier$InputtedEnd = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Panel$ReversalApprovalCashier$InputtedStart = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Panel$ReversalApprovalCashier$InputtedStatus = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Panel$ReversalApprovalCashier$Submit = {$: 15};
var $author$project$Pages$Panel$ReversalApprovalCashier$ToggleState = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Patterns$TotalBar$view = function (options) {
	var valueClass = function (v) {
		return (v < 0) ? A2($elm$html$Html$Attributes$style, 'color', '#f56565') : $elm$html$Html$Attributes$class('text-purple-main');
	};
	var result = options.lo - options.qg;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$html$Html$text(''),
				options.md),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bottom-actions flex justify-between')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('selecionados flex gap-8 ')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(options.fD)
									])),
								A2(
								$elm$html$Html$strong,
								_List_fromArray(
									[
										valueClass(result)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Utils$formatAsMoney(
											$elm$core$String$fromInt(result)))
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Panel$ReversalApprovalCashier$ClickedPay = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Panel$ReversalApprovalCashier$viewRow = F3(
	function (user, timezone, r) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Utils$formatDateTimeFromPosix, timezone, r.ix))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(r.kf)
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Pages$Panel$ReversalApprovalCashier$emptyValue(r.ke))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'-',
								A2(
									$elm$core$Maybe$map,
									$author$project$Utils$formatDateTimeFromPosix(timezone),
									r.kd)))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(r.kh)
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'text-wrap', 'nowrap')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$maskCPFOrCNPJ(r.kg))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Services$Payments$statusToUserString(r.kK))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-align-right')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$formatAsMoney(
								$elm$core$String$fromInt(r.lo)))
						])),
					function () {
					var _v0 = _Utils_Tuple2(
						3 === r.kK,
						A2(
							$elm$core$List$member,
							$author$project$Services$Models$REFUNDS_GUICHE(1),
							user.hg));
					if (_v0.a && _v0.b) {
						return A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex-justify-end')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('action-system green-btn'),
											$elm$html$Html$Events$onClick(
											$author$project$Pages$Panel$ReversalApprovalCashier$ClickedPay(r))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Ações')
										]))
								]));
					} else {
						return A2($elm$html$Html$td, _List_Nil, _List_Nil);
					}
				}()
				]));
	});
var $author$project$Pages$Panel$ReversalApprovalCashier$viewTable = F4(
	function (user, timezone, model, r) {
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'cellspacing', '0'),
					$elm$html$Html$Attributes$class('data-table-dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$thead,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Data de solicitação')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Solicitante')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Aprovado por')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Aprovado em')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Usuário')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Documento')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Status')
										])),
									A2(
									$elm$html$Html$th,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-align-right')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Valor')
										])),
									A2($elm$html$Html$th, _List_Nil, _List_Nil)
								]))
						])),
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					A2(
						$elm$core$List$map,
						A2($author$project$Pages$Panel$ReversalApprovalCashier$viewRow, user, timezone),
						r))
				]));
	});
var $author$project$Pages$Panel$ReversalApprovalCashier$viewPage = F3(
	function (model, shared, user) {
		var btnSystem = $author$project$Services$Models$iHaveAccess(
			{
				gZ: user.hg,
				hf: $author$project$Services$Models$REVERSE(1),
				hQ: A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('apuracoes', true),
									_Utils_Tuple2('active', !model.fy)
								])),
							$elm$html$Html$Events$onClick(
							$author$project$Pages$Panel$ReversalApprovalCashier$ToggleState(0))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Estornos de pedidos')
						])),
				hR: $elm$html$Html$text('')
			});
		var btnCashier = $author$project$Services$Models$iHaveAccess(
			{
				gZ: user.hg,
				hf: $author$project$Services$Models$REVERSE(1),
				hQ: A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('apuracoes', true),
									_Utils_Tuple2('active', !model.fy)
								])),
							$elm$html$Html$Events$onClick(
							$author$project$Pages$Panel$ReversalApprovalCashier$ToggleState(0))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Estornos de pedidos')
						])),
				hR: $elm$html$Html$text('')
			});
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard admin-reports')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('filtros-apuracoes-container mt-8')
						]),
					_List_fromArray(
						[
							btnSystem,
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('apuracoes', true),
											_Utils_Tuple2('active', model.fy === 1)
										])),
									$elm$html$Html$Events$onClick(
									$author$project$Pages$Panel$ReversalApprovalCashier$ToggleState(1))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Estornos do caixa')
								]))
						])),
					A2(
					$elm$html$Html$form,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('filtros-container payment-guides'),
							$elm$html$Html$Events$onSubmit($author$project$Pages$Panel$ReversalApprovalCashier$Submit)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Início'),
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$value(model.eb),
											$elm$html$Html$Attributes$type_('date'),
											$elm$html$Html$Events$onInput($author$project$Pages$Panel$ReversalApprovalCashier$InputtedStart)
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Fim'),
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$value(model.dH),
											$elm$html$Html$Attributes$type_('date'),
											$elm$html$Html$Events$onInput($author$project$Pages$Panel$ReversalApprovalCashier$InputtedEnd)
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Status'),
									$author$project$Components$Patterns$Forms$selectWithError(
									{
										iH: false,
										jl: $elm$core$Maybe$Nothing,
										jn: _List_Nil,
										jI: $elm$core$Maybe$Just($author$project$Pages$Panel$ReversalApprovalCashier$InputtedStatus),
										jO: A2(
											$elm$core$List$cons,
											{eX: model.kK === '', c3: 'Todos', di: ''},
											A2(
												$elm$core$List$map,
												function (status) {
													return {
														eX: _Utils_eq(
															model.kK,
															$author$project$Services$Payments$statusToApiString(status)),
														c3: $author$project$Services$Payments$statusToUserString(status),
														di: $author$project$Services$Payments$statusToApiString(status)
													};
												},
												A2(
													$elm$core$List$filter,
													function (s) {
														return (s === 1) || (s === 3);
													},
													$author$project$Services$Payments$allStatus))),
										jQ: false,
										ks: _List_fromArray(
											[
												A2($elm$html$Html$Attributes$style, 'padding-top', '5px'),
												A2($elm$html$Html$Attributes$style, 'width', '250px')
											]),
										kE: false,
										k1: _List_Nil
									})
								])),
							A2(
							$author$project$Components$View$searchButton,
							'',
							$krisajenkins$remotedata$RemoteData$isLoading(model.a2)),
							function () {
							var _v0 = model.a2;
							if (_v0.$ === 3) {
								var r = _v0.a;
								return $elm$core$List$isEmpty(r) ? $elm$html$Html$text('') : $author$project$Components$GeneratorCSV$buttonDownload($author$project$Pages$Panel$ReversalApprovalCashier$GenerateCsvDownload);
							} else {
								return $elm$html$Html$text('');
							}
						}()
						])),
					function () {
					var _v1 = model.a2;
					switch (_v1.$) {
						case 0:
							return $elm$html$Html$text('Por favor, defina um período desejado ou utilize as datas padrão para realizar a busca.');
						case 1:
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[$author$project$Components$View$loading]));
						case 2:
							var err = _v1.a;
							return $elm$html$Html$text(
								$author$project$Services$Api$errorToUserMessage(err));
						default:
							var r = _v1.a;
							var totalValue = A3(
								$elm$core$List$foldl,
								F2(
									function (row, acc) {
										return row.lo + acc;
									}),
								0,
								r);
							return $elm$core$List$isEmpty(r) ? $elm$html$Html$text('Nenhuma solicitação de estorno foi encontrado.') : $author$project$Components$Patterns$TotalBar$view(
								{
									lo: totalValue,
									md: $elm$core$Maybe$Just(
										A4($author$project$Pages$Panel$ReversalApprovalCashier$viewTable, user, shared.kS, model, r)),
									fD: 'Totais no período',
									qg: 0
								});
					}
				}()
				]));
	});
var $author$project$Pages$Panel$ReversalApprovalCashier$ClickedManualPay = {$: 9};
var $author$project$Pages$Panel$ReversalApprovalCashier$CloseModal = {$: 12};
var $author$project$Pages$Panel$ReversalApprovalCashier$viewPageModal = function (_v0) {
	var isLoading = _v0.dP;
	var billet = _v0.eq;
	var totalValue = $author$project$Utils$formatMoneyInput(
		$elm$core$String$fromInt(billet.lo));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal-overlay')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('modal-container modal-dashboard modal-comprar-creditos'),
						A2($elm$html$Html$Attributes$style, 'min-height', 'auto')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('header-modal')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Aprovar Estorno')
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('action-header'),
										$elm$html$Html$Events$onClick($author$project$Pages$Panel$ReversalApprovalCashier$CloseModal)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('fechar-ico')
											]),
										_List_Nil)
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('modal-content center-modal')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Aprovação de estorno de '),
										A2(
										$elm$html$Html$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('R$ ' + totalValue)
											])),
										$elm$html$Html$text('.'),
										A2($elm$html$Html$br, _List_Nil, _List_Nil),
										A2($elm$html$Html$br, _List_Nil, _List_Nil)
									])),
								isLoading ? $author$project$Components$View$loading : A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('buttons')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('btn-ce btn-no-ico'),
												$elm$html$Html$Events$onClick($author$project$Pages$Panel$ReversalApprovalCashier$ClickedManualPay)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Aprovar estorno')
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Panel$ReversalApprovalCashier$view = F3(
	function (model, shared, user) {
		return _Utils_Tuple3(
			'Estornos',
			A3($author$project$Pages$Panel$ReversalApprovalCashier$viewPage, model, shared, user),
			function () {
				var _v0 = model.aY;
				if (_v0.$ === 1) {
					return $elm$html$Html$text('');
				} else {
					var modal = _v0.a;
					return $author$project$Pages$Panel$ReversalApprovalCashier$viewPageModal(modal);
				}
			}());
	});
var $author$project$Pages$Panel$ReversalApprovalSystem$GenerateCsvDownload = {$: 13};
var $author$project$Pages$Panel$ReversalApprovalSystem$InputtedEnd = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Panel$ReversalApprovalSystem$InputtedStart = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Panel$ReversalApprovalSystem$InputtedStatus = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Panel$ReversalApprovalSystem$Submit = {$: 15};
var $author$project$Pages$Panel$ReversalApprovalSystem$ToggleState = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Panel$ReversalApprovalSystem$ClickedPay = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Panel$ReversalApprovalSystem$viewRow = F3(
	function (user, timezone, b) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Utils$formatDateTimeFromPosix, timezone, b.ix))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(b.kf)
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Pages$Panel$ReversalApprovalSystem$emptyValue(b.ke))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'-',
								A2(
									$elm$core$Maybe$map,
									$author$project$Utils$formatDateTimeFromPosix(timezone),
									b.kd)))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(b.kh)
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'text-wrap', 'nowrap')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$maskCPFOrCNPJ(b.kg))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(b.pC))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Services$Payments$statusToUserString(b.kK))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-align-right')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$formatAsMoney(
								$elm$core$String$fromInt(b.lo)))
						])),
					function () {
					var _v0 = _Utils_Tuple2(
						3 === b.kK,
						A2(
							$elm$core$List$member,
							$author$project$Services$Models$REVERSE(1),
							user.hg));
					if (_v0.a && _v0.b) {
						return A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex-justify-end')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('action-system green-btn'),
											$elm$html$Html$Events$onClick(
											$author$project$Pages$Panel$ReversalApprovalSystem$ClickedPay(b))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Ações')
										]))
								]));
					} else {
						return A2($elm$html$Html$td, _List_Nil, _List_Nil);
					}
				}()
				]));
	});
var $author$project$Pages$Panel$ReversalApprovalSystem$viewTable = F4(
	function (user, timezone, model, r) {
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'cellspacing', '0'),
					$elm$html$Html$Attributes$class('data-table-dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$thead,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Data de solicitação')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Solicitante')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Aprovado por')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Aprovado em')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Empresa')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Documento')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Número do Pedido')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Status')
										])),
									A2(
									$elm$html$Html$th,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-align-right')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Valor')
										])),
									A2($elm$html$Html$th, _List_Nil, _List_Nil)
								]))
						])),
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					A2(
						$elm$core$List$map,
						A2($author$project$Pages$Panel$ReversalApprovalSystem$viewRow, user, timezone),
						r))
				]));
	});
var $author$project$Pages$Panel$ReversalApprovalSystem$viewPage = F3(
	function (model, shared, user) {
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard admin-reports')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('filtros-apuracoes-container mt-8')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('apuracoes', true),
											_Utils_Tuple2('active', !model.fy)
										])),
									$elm$html$Html$Events$onClick(
									$author$project$Pages$Panel$ReversalApprovalSystem$ToggleState(0))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Estornos de pedidos')
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('apuracoes', true),
											_Utils_Tuple2('active', model.fy === 1)
										])),
									$elm$html$Html$Events$onClick(
									$author$project$Pages$Panel$ReversalApprovalSystem$ToggleState(1))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Estornos do caixa')
								]))
						])),
					A2(
					$elm$html$Html$form,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('filtros-container payment-guides'),
							$elm$html$Html$Events$onSubmit($author$project$Pages$Panel$ReversalApprovalSystem$Submit)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Início'),
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$value(model.eb),
											$elm$html$Html$Attributes$type_('date'),
											$elm$html$Html$Events$onInput($author$project$Pages$Panel$ReversalApprovalSystem$InputtedStart)
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Fim'),
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$value(model.dH),
											$elm$html$Html$Attributes$type_('date'),
											$elm$html$Html$Events$onInput($author$project$Pages$Panel$ReversalApprovalSystem$InputtedEnd)
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Status'),
									$author$project$Components$Patterns$Forms$selectWithError(
									{
										iH: false,
										jl: $elm$core$Maybe$Nothing,
										jn: _List_Nil,
										jI: $elm$core$Maybe$Just($author$project$Pages$Panel$ReversalApprovalSystem$InputtedStatus),
										jO: A2(
											$elm$core$List$cons,
											{eX: model.kK === '', c3: 'Todos', di: ''},
											A2(
												$elm$core$List$map,
												function (status) {
													return {
														eX: _Utils_eq(
															model.kK,
															$author$project$Services$Payments$statusToApiString(status)),
														c3: $author$project$Services$Payments$statusToUserString(status),
														di: $author$project$Services$Payments$statusToApiString(status)
													};
												},
												A2(
													$elm$core$List$filter,
													function (s) {
														return (s === 1) || (s === 3);
													},
													$author$project$Services$Payments$allStatus))),
										jQ: false,
										ks: _List_fromArray(
											[
												A2($elm$html$Html$Attributes$style, 'padding-top', '5px'),
												A2($elm$html$Html$Attributes$style, 'width', '250px')
											]),
										kE: false,
										k1: _List_Nil
									})
								])),
							A2(
							$author$project$Components$View$searchButton,
							'',
							$krisajenkins$remotedata$RemoteData$isLoading(model.a2)),
							function () {
							var _v0 = model.a2;
							if (_v0.$ === 3) {
								var r = _v0.a;
								return $elm$core$List$isEmpty(r) ? $elm$html$Html$text('') : $author$project$Components$GeneratorCSV$buttonDownload($author$project$Pages$Panel$ReversalApprovalSystem$GenerateCsvDownload);
							} else {
								return $elm$html$Html$text('');
							}
						}()
						])),
					function () {
					var _v1 = model.a2;
					switch (_v1.$) {
						case 0:
							return $elm$html$Html$text('Por favor, defina um período desejado ou utilize as datas padrão para realizar a busca.');
						case 1:
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[$author$project$Components$View$loading]));
						case 2:
							var err = _v1.a;
							return $elm$html$Html$text(
								$author$project$Services$Api$errorToUserMessage(err));
						default:
							var r = _v1.a;
							if ($elm$core$List$isEmpty(r)) {
								return $elm$html$Html$text('Nenhuma solicitação de estorno foi encontrado.');
							} else {
								var totalValue = A3(
									$elm$core$List$foldl,
									F2(
										function (row, acc) {
											return row.lo + acc;
										}),
									0,
									r);
								return $elm$core$List$isEmpty(r) ? $elm$html$Html$text('Nenhuma solicitação de estorno foi encontrado.') : $author$project$Components$Patterns$TotalBar$view(
									{
										lo: totalValue,
										md: $elm$core$Maybe$Just(
											A4($author$project$Pages$Panel$ReversalApprovalSystem$viewTable, user, shared.kS, model, r)),
										fD: 'Totais no período',
										qg: 0
									});
							}
					}
				}()
				]));
	});
var $author$project$Pages$Panel$ReversalApprovalSystem$ClickedManualPay = {$: 9};
var $author$project$Pages$Panel$ReversalApprovalSystem$CloseModal = {$: 12};
var $author$project$Pages$Panel$ReversalApprovalSystem$viewPageModal = function (_v0) {
	var isLoading = _v0.dP;
	var billet = _v0.eq;
	var totalValue = $author$project$Utils$formatMoneyInput(
		$elm$core$String$fromInt(billet.lo));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal-overlay')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('modal-container modal-dashboard modal-comprar-creditos'),
						A2($elm$html$Html$Attributes$style, 'min-height', 'auto')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('header-modal')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Aprovar Estorno')
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('action-header'),
										$elm$html$Html$Events$onClick($author$project$Pages$Panel$ReversalApprovalSystem$CloseModal)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('fechar-ico')
											]),
										_List_Nil)
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('modal-content center-modal')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Aprovação de estorno de '),
										A2(
										$elm$html$Html$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('R$ ' + totalValue)
											])),
										$elm$html$Html$text('.'),
										A2($elm$html$Html$br, _List_Nil, _List_Nil),
										A2($elm$html$Html$br, _List_Nil, _List_Nil)
									])),
								isLoading ? $author$project$Components$View$loading : A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('buttons')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('btn-ce btn-no-ico'),
												$elm$html$Html$Events$onClick($author$project$Pages$Panel$ReversalApprovalSystem$ClickedManualPay)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Aprovar estorno')
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Panel$ReversalApprovalSystem$view = F3(
	function (model, shared, user) {
		return _Utils_Tuple3(
			'Estornos',
			A3($author$project$Pages$Panel$ReversalApprovalSystem$viewPage, model, shared, user),
			function () {
				var _v0 = model.aY;
				if (_v0.$ === 1) {
					return $elm$html$Html$text('');
				} else {
					var modal = _v0.a;
					return $author$project$Pages$Panel$ReversalApprovalSystem$viewPageModal(modal);
				}
			}());
	});
var $author$project$Pages$Panel$SingleCharge$CloseModal = {$: 2};
var $author$project$Pages$Panel$SingleCharge$InputtedDescription = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Panel$SingleCharge$InputtedValue = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Panel$SingleCharge$SubmitCREATE = {$: 3};
var $author$project$Pages$Panel$SingleCharge$viewModalCreate = function (model) {
	return $author$project$Components$Patterns$Modal$simple(
		{
			hY: $elm$core$Maybe$Just(
				A2($elm$html$Html$Attributes$style, 'min-height', 'fit-content')),
			ii: '',
			il: '',
			ip: $author$project$Pages$Panel$SingleCharge$CloseModal,
			fD: 'Criar tipo de cobrança',
			k4: $author$project$Components$Patterns$Forms$formSimple(
				{
					hZ: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col gap-4')
						]),
					L: model.L,
					jf: _List_fromArray(
						[
							$author$project$Components$Patterns$Forms$Input(
							{
								ie: $elm$core$Maybe$Nothing,
								iH: model.L === 2,
								iP: _List_Nil,
								nR: _List_Nil,
								jl: $elm$core$Maybe$Just('Valor'),
								jn: _List_Nil,
								n9: $elm$core$Maybe$Just(10),
								c3: '',
								jE: $elm$core$Maybe$Nothing,
								jF: $elm$core$Maybe$Nothing,
								jG: $elm$core$Maybe$Nothing,
								ov: $elm$core$Maybe$Nothing,
								jI: $elm$core$Maybe$Just(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Pages$Panel$SingleCharge$ModalMsg,
										A2(
											$elm$core$Basics$composeL,
											$author$project$Pages$Panel$SingleCharge$InputtedValue,
											$elm$core$String$filter($elm$core$Char$isDigit)))),
								hh: 'Informe o valor',
								kE: model.L === 1,
								kY: 'text',
								k1: $author$project$Pages$Panel$SingleCharge$validatorsValue,
								di: $author$project$Utils$formatMoneyInput(
									$elm$core$String$fromInt(model.di))
							}),
							$author$project$Components$Patterns$Forms$Input(
							{
								ie: $elm$core$Maybe$Nothing,
								iH: model.L === 2,
								iP: _List_Nil,
								nR: _List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-gray-shade')
									]),
								jl: $elm$core$Maybe$Just('Descrição'),
								jn: _List_Nil,
								n9: $elm$core$Maybe$Just(80),
								c3: 'Campo para Descrição',
								jE: $elm$core$Maybe$Nothing,
								jF: $elm$core$Maybe$Nothing,
								jG: $elm$core$Maybe$Nothing,
								ov: $elm$core$Maybe$Nothing,
								jI: $elm$core$Maybe$Just(
									A2($elm$core$Basics$composeL, $author$project$Pages$Panel$SingleCharge$ModalMsg, $author$project$Pages$Panel$SingleCharge$InputtedDescription)),
								hh: 'Insira uma descrição para a cobrança',
								kE: model.L === 1,
								kY: 'text',
								k1: $author$project$Pages$Panel$SingleCharge$validatorsDescription,
								di: model.z
							})
						]),
					oc: $elm$core$Maybe$Just(
						{
							lx: _List_fromArray(
								[
									$elm$html$Html$Attributes$class('self-center')
								]),
							l_: $author$project$Pages$Panel$SingleCharge$ModalMsg($author$project$Pages$Panel$SingleCharge$SubmitCREATE),
							iH: false
						}),
					pX: 'Criar'
				}),
			k5: $elm$html$Html$text('')
		});
};
var $author$project$Pages$Panel$SingleCharge$SubmitEDIT = {$: 4};
var $author$project$Pages$Panel$SingleCharge$viewModalEdit = function (model) {
	return $author$project$Components$Patterns$Modal$simple(
		{
			hY: $elm$core$Maybe$Just(
				A2($elm$html$Html$Attributes$style, 'min-height', 'fit-content')),
			ii: '',
			il: '',
			ip: $author$project$Pages$Panel$SingleCharge$CloseModal,
			fD: 'Editar cobrança avulsa',
			k4: $author$project$Components$Patterns$Forms$formSimple(
				{
					hZ: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col gap-4')
						]),
					L: model.L,
					jf: _List_fromArray(
						[
							$author$project$Components$Patterns$Forms$Input(
							{
								ie: $elm$core$Maybe$Nothing,
								iH: model.L === 2,
								iP: _List_Nil,
								nR: _List_Nil,
								jl: $elm$core$Maybe$Just('Valor'),
								jn: _List_Nil,
								n9: $elm$core$Maybe$Just(10),
								c3: '',
								jE: $elm$core$Maybe$Nothing,
								jF: $elm$core$Maybe$Nothing,
								jG: $elm$core$Maybe$Nothing,
								ov: $elm$core$Maybe$Nothing,
								jI: $elm$core$Maybe$Just(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Pages$Panel$SingleCharge$ModalMsg,
										A2(
											$elm$core$Basics$composeL,
											$author$project$Pages$Panel$SingleCharge$InputtedValue,
											$elm$core$String$filter($elm$core$Char$isDigit)))),
								hh: 'Informe o valor',
								kE: model.L === 1,
								kY: 'text',
								k1: $author$project$Pages$Panel$SingleCharge$validatorsValue,
								di: $author$project$Utils$formatMoneyInput(
									$elm$core$String$fromInt(model.di))
							}),
							$author$project$Components$Patterns$Forms$Input(
							{
								ie: $elm$core$Maybe$Nothing,
								iH: model.L === 2,
								iP: _List_Nil,
								nR: _List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-gray-shade')
									]),
								jl: $elm$core$Maybe$Just('Descrição'),
								jn: _List_Nil,
								n9: $elm$core$Maybe$Just(80),
								c3: 'Campo para Descrição',
								jE: $elm$core$Maybe$Nothing,
								jF: $elm$core$Maybe$Nothing,
								jG: $elm$core$Maybe$Nothing,
								ov: $elm$core$Maybe$Nothing,
								jI: $elm$core$Maybe$Just(
									A2($elm$core$Basics$composeL, $author$project$Pages$Panel$SingleCharge$ModalMsg, $author$project$Pages$Panel$SingleCharge$InputtedDescription)),
								hh: 'Insira uma descrição para a cobrança',
								kE: model.L === 1,
								kY: 'text',
								k1: $author$project$Pages$Panel$SingleCharge$validatorsDescription,
								di: model.z
							})
						]),
					oc: $elm$core$Maybe$Just(
						{
							lx: _List_fromArray(
								[
									$elm$html$Html$Attributes$class('self-center')
								]),
							l_: $author$project$Pages$Panel$SingleCharge$ModalMsg($author$project$Pages$Panel$SingleCharge$SubmitEDIT),
							iH: false
						}),
					pX: 'Editar'
				}),
			k5: $elm$html$Html$text('')
		});
};
var $author$project$Pages$Panel$SingleCharge$viewModal = F2(
	function (timezone, maybeModal) {
		if (!maybeModal.$) {
			if (!maybeModal.a.$) {
				var m = maybeModal.a.a;
				return $author$project$Pages$Panel$SingleCharge$viewModalCreate(m);
			} else {
				var m = maybeModal.a.a;
				return $author$project$Pages$Panel$SingleCharge$viewModalEdit(m);
			}
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Pages$Panel$SingleCharge$OpenCreate = {$: 4};
var $author$project$Pages$Panel$SingleCharge$OpenEdit = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Panel$SingleCharge$SelectedStatus = function (a) {
	return {$: 6, a: a};
};
var $author$project$Services$SingleCharge$statusToBool = function (status) {
	if (!status) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Pages$Panel$SingleCharge$viewRowStr = F2(
	function (timezone, singleCharge) {
		return _List_fromArray(
			[
				A2($author$project$Utils$formatDateTimeFromPosixWithSeconds, timezone, singleCharge.ix),
				singleCharge.kX,
				$author$project$Utils$formatAsMoney(
				$elm$core$String$fromInt(singleCharge.di))
			]);
	});
var $author$project$Pages$Panel$SingleCharge$viewRowHtml = F3(
	function (user, timezone, singleCharge) {
		var viewEdit = $author$project$Services$Models$iHaveAccess(
			{
				gZ: user.hg,
				hf: $author$project$Services$Models$AVULSAS(1),
				hQ: A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex gap-4')
						]),
					_List_fromArray(
						[
							A4(
							$author$project$Components$Patterns$Button$icon,
							$author$project$Pages$Panel$SingleCharge$OpenEdit(singleCharge),
							'icon-md',
							'edit',
							'Editar cobrança avulsa'),
							A2(
							$author$project$Components$Patterns$Input$Toggle$view,
							$author$project$Services$SingleCharge$statusToBool(singleCharge.at),
							$author$project$Pages$Panel$SingleCharge$SelectedStatus(singleCharge))
						])),
				hR: A2($elm$html$Html$td, _List_Nil, _List_Nil)
			});
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(str)
							]));
				},
				A2($author$project$Pages$Panel$SingleCharge$viewRowStr, timezone, singleCharge)),
			_List_fromArray(
				[viewEdit]));
	});
var $author$project$Pages$Panel$SingleCharge$viewPage = F3(
	function (model, shared, user) {
		var viewCreateLine = $author$project$Services$Models$iHaveAccess(
			{
				gZ: user.hg,
				hf: $author$project$Services$Models$AVULSAS(1),
				hQ: A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('top-actions pb-0 pt-4 mt-4')
						]),
					_List_fromArray(
						[
							A4(
							$author$project$Components$Patterns$Button$textSimple,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'width', 'max-content')
								]),
							'btn-ce btn-adicionar m-0',
							'Criar tipo de cobrança',
							$author$project$Pages$Panel$SingleCharge$OpenCreate)
						])),
				hR: $elm$html$Html$text('')
			});
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard')
				]),
			_List_fromArray(
				[
					viewCreateLine,
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-black mb-4')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Cobrança avulsa')
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Components$Patterns$Forms$formSimple(
							{
								hZ: _List_fromArray(
									[
										$elm$html$Html$Attributes$class('w-full'),
										$elm$html$Html$Attributes$novalidate(true)
									]),
								L: model.L,
								jf: _List_Nil,
								oc: $elm$core$Maybe$Nothing,
								pX: 'Pesquisar'
							})
						])),
					A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = model.cr;
							switch (_v0.$) {
								case 3:
									if (!_v0.a.b) {
										return $elm$html$Html$text('Nenhum registro encontrado');
									} else {
										var singleCharges = _v0.a;
										return $author$project$Components$Patterns$Tables$default(
											{
												nF: _List_fromArray(
													['Criado em', 'Descrição', 'Valor', '']),
												nX: true,
												pj: A2(
													$elm$core$List$map,
													A2($author$project$Pages$Panel$SingleCharge$viewRowHtml, user, shared.kS),
													singleCharges)
											});
									}
								case 0:
									return $elm$html$Html$text('Processo de execução está incorreto!');
								case 1:
									return $author$project$Components$View$loading;
								default:
									var e = _v0.a;
									return $elm$html$Html$text('Algo deu errado: ' + e);
							}
						}()
						]))
				]));
	});
var $author$project$Pages$Panel$SingleCharge$view = F3(
	function (model, shared, user) {
		return _Utils_Tuple2(
			'Cobrança avulsa',
			_List_fromArray(
				[
					A3($author$project$Pages$Panel$SingleCharge$viewPage, model, shared, user),
					A2($author$project$Pages$Panel$SingleCharge$viewModal, shared.kS, model.aY)
				]));
	});
var $author$project$Pages$Panel$Stock$Details$CloseModal = {$: 5};
var $author$project$Pages$Panel$Stock$Details$SubmitDELETE = {$: 5};
var $author$project$Pages$Panel$Stock$Details$viewModalDeleteEquipment = F2(
	function (serial, isLoading) {
		return $author$project$Components$Patterns$Modal$simple(
			{
				hY: $elm$core$Maybe$Just(
					A2($elm$html$Html$Attributes$style, 'min-height', 'fit-content')),
				ii: '',
				il: '',
				ip: $author$project$Pages$Panel$Stock$Details$CloseModal,
				fD: 'Excluir Equipamento',
				k4: isLoading ? $author$project$Components$View$loading : A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Tem certeza de que deseja excluir este equipamento? Esta ação não pode ser desfeita.')
								]))
						])),
				k5: isLoading ? $elm$html$Html$text('') : A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex w-full mt-4 gap-4')
						]),
					_List_fromArray(
						[
							A4($author$project$Components$Patterns$Button$text, _List_Nil, 'm-0 w-full  white-btn', 'Cancelar', $author$project$Pages$Panel$Stock$Details$CloseModal),
							A4(
							$author$project$Components$Patterns$Button$text,
							_List_Nil,
							'm-0 w-full red-btn',
							'Excluir',
							$author$project$Pages$Panel$Stock$Details$ModalMsg($author$project$Pages$Panel$Stock$Details$SubmitDELETE))
						]))
			});
	});
var $author$project$Pages$Panel$Stock$Details$InputtedBatch = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Panel$Stock$Details$InputtedDescription = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Panel$Stock$Details$SelectedStatus = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Panel$Stock$Details$SubmitEDIT = {$: 3};
var $author$project$Pages$Panel$Stock$Details$viewModalEditEquipment = function (model) {
	return $author$project$Components$Patterns$Modal$simple(
		{
			hY: $elm$core$Maybe$Just(
				A2($elm$html$Html$Attributes$style, 'min-height', 'fit-content')),
			ii: '',
			il: '',
			ip: $author$project$Pages$Panel$Stock$Details$CloseModal,
			fD: 'Editar equipamento',
			k4: $author$project$Components$Patterns$Forms$formSimple(
				{
					hZ: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col gap-4')
						]),
					L: model.L,
					jf: _List_fromArray(
						[
							$author$project$Components$Patterns$Forms$Select(
							{
								iH: model.L === 2,
								jl: $elm$core$Maybe$Just('Status'),
								jn: _List_Nil,
								jI: $elm$core$Maybe$Just(
									A2($elm$core$Basics$composeL, $author$project$Pages$Panel$Stock$Details$ModalMsg, $author$project$Pages$Panel$Stock$Details$SelectedStatus)),
								jO: A2(
									$elm$core$List$cons,
									{
										eX: _Utils_eq(model.kK, $elm$core$Maybe$Nothing),
										c3: 'Selecione',
										di: ''
									},
									A2(
										$elm$core$List$map,
										function (status) {
											return {
												eX: A2(
													$elm$core$Maybe$withDefault,
													false,
													A2(
														$elm$core$Maybe$map,
														$elm$core$Basics$eq(status),
														model.kK)),
												c3: status,
												di: status
											};
										},
										$author$project$Services$Stock$allStatus)),
								jQ: false,
								ks: _List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'margin', '0'),
										$elm$html$Html$Attributes$class('text-gray-shade')
									]),
								kE: model.L === 1,
								k1: A2($author$project$Pages$Panel$Stock$Details$validatorsStatus, model.kK, $author$project$Services$Stock$allStatus)
							}),
							$author$project$Components$Patterns$Forms$Input(
							{
								ie: $elm$core$Maybe$Nothing,
								iH: model.L === 2,
								iP: _List_Nil,
								nR: _List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-gray-shade')
									]),
								jl: $elm$core$Maybe$Just('Observação'),
								jn: _List_Nil,
								n9: $elm$core$Maybe$Just(100),
								c3: 'Campo para Observação',
								jE: $elm$core$Maybe$Nothing,
								jF: $elm$core$Maybe$Nothing,
								jG: $elm$core$Maybe$Nothing,
								ov: $elm$core$Maybe$Nothing,
								jI: $elm$core$Maybe$Just(
									A2($elm$core$Basics$composeL, $author$project$Pages$Panel$Stock$Details$ModalMsg, $author$project$Pages$Panel$Stock$Details$InputtedDescription)),
								hh: 'Insira uma Observação',
								kE: model.L === 1,
								kY: 'text',
								k1: $author$project$Pages$Panel$Stock$Details$validatorsDescription,
								di: model.ca
							}),
							$author$project$Components$Patterns$Forms$Input(
							{
								ie: $elm$core$Maybe$Nothing,
								iH: model.L === 2,
								iP: _List_Nil,
								nR: _List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-gray-shade')
									]),
								jl: $elm$core$Maybe$Just('Lote'),
								jn: _List_Nil,
								n9: $elm$core$Maybe$Just(80),
								c3: 'Campo para lote',
								jE: $elm$core$Maybe$Nothing,
								jF: $elm$core$Maybe$Nothing,
								jG: $elm$core$Maybe$Nothing,
								ov: $elm$core$Maybe$Nothing,
								jI: $elm$core$Maybe$Just(
									A2($elm$core$Basics$composeL, $author$project$Pages$Panel$Stock$Details$ModalMsg, $author$project$Pages$Panel$Stock$Details$InputtedBatch)),
								hh: 'Insira o lote',
								kE: model.L === 1,
								kY: 'text',
								k1: $author$project$Pages$Panel$Stock$Details$validatorsBatch,
								di: model.bh
							})
						]),
					oc: $elm$core$Maybe$Just(
						{
							lx: _List_fromArray(
								[
									$elm$html$Html$Attributes$class('self-center')
								]),
							l_: $author$project$Pages$Panel$Stock$Details$ModalMsg($author$project$Pages$Panel$Stock$Details$SubmitEDIT),
							iH: false
						}),
					pX: 'Criar'
				}),
			k5: $elm$html$Html$text('')
		});
};
var $author$project$Pages$Panel$Stock$Details$GoDelete = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Panel$Stock$Details$GoDetails = {$: 4};
var $author$project$Pages$Panel$Stock$Details$GoEdit = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Panel$Stock$Details$row = F2(
	function (info, value) {
		return A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('border-b border-solid border-gray-tint1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('py-2 px-4 font-semibold text-gray-600')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(info)
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('py-2 px-4 text-gray-800')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(value)
						]))
				]));
	});
var $author$project$Pages$Panel$Stock$Details$viewStatus = F2(
	function (timezone, status) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mb-6')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-xl font-semibold text-purple-secondary mb-2')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$strong,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('font-bold')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Status Atual')
								]))
						])),
					A2(
					$elm$html$Html$table,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-full bg-white border border-collapse border-gray-tint1')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tbody,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Pages$Panel$Stock$Details$row,
									'Bloco: ',
									$elm$core$String$fromInt(status.h5)),
									A2(
									$author$project$Pages$Panel$Stock$Details$row,
									'Estoque: ',
									$elm$core$String$fromInt(status.kL)),
									A2(
									$author$project$Pages$Panel$Stock$Details$row,
									'Eventos: ',
									$elm$core$String$fromInt(status.D)),
									A2(
									$author$project$Pages$Panel$Stock$Details$row,
									'Refill: ',
									$elm$core$String$fromInt(status.fn)),
									A2($author$project$Pages$Panel$Stock$Details$row, 'Status: ', status.kK),
									A2(
									$author$project$Pages$Panel$Stock$Details$row,
									'EB Serial: ',
									A2($elm$core$Maybe$withDefault, '-', status.mT)),
									A2(
									$author$project$Pages$Panel$Stock$Details$row,
									'Versão do EB: ',
									A2($elm$core$Maybe$withDefault, '-', status.mU)),
									A2(
									$author$project$Pages$Panel$Stock$Details$row,
									'Data do Validador: ',
									A2($author$project$Utils$formatDateTimeFromPosixWithSeconds, timezone, status.qB)),
									A2($author$project$Pages$Panel$Stock$Details$row, 'Número de Série do Validador: ', status.k0),
									A2($author$project$Pages$Panel$Stock$Details$row, 'Concessionária ID: ', status.mc)
								]))
						]))
				]));
	});
var $author$project$Pages$Panel$Stock$Details$viewInfos = F2(
	function (details, timezone) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-6')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h2,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-xl font-semibold text-purple-secondary mb-2')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$strong,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('font-bold')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Informações Gerais')
										]))
								])),
							A2(
							$elm$html$Html$table,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('w-full bg-white border border-collapse border-gray-tint1')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tbody,
									_List_Nil,
									_List_fromArray(
										[
											A2($author$project$Pages$Panel$Stock$Details$row, 'ID: ', details.dM),
											A2(
											$author$project$Pages$Panel$Stock$Details$row,
											'Data de Criação: ',
											A2($author$project$Utils$formatDateTimeFromPosixWithSeconds, timezone, details.ix)),
											A2(
											$author$project$Pages$Panel$Stock$Details$row,
											'Última Atualização: ',
											A2($author$project$Utils$formatDateTimeFromPosixWithSeconds, timezone, details.qs)),
											A2(
											$author$project$Pages$Panel$Stock$Details$row,
											'Concessionária ID: ',
											A2($elm$core$Maybe$withDefault, '-', details.mb)),
											A2($author$project$Pages$Panel$Stock$Details$row, 'Número de Série: ', details.pE),
											A2(
											$author$project$Pages$Panel$Stock$Details$row,
											'Tipo: ',
											A2($elm$core$Maybe$withDefault, '-', details.kY)),
											A2(
											$author$project$Pages$Panel$Stock$Details$row,
											'Versão do Software: ',
											A2($elm$core$Maybe$withDefault, '-', details.kG))
										]))
								]))
						])),
					A2(
					$elm$core$Maybe$withDefault,
					$elm$html$Html$text(''),
					A2(
						$elm$core$Maybe$map,
						$author$project$Pages$Panel$Stock$Details$viewStatus(timezone),
						details.kK))
				]));
	});
var $author$project$Pages$Panel$Stock$Details$viewPage = F2(
	function (model, shared) {
		var actions = A2(
			$krisajenkins$remotedata$RemoteData$withDefault,
			$elm$html$Html$text(''),
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				function (d) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex justify-between')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('top-actions p-0 pt-4')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('voltar-ico-blue'),
												$elm$html$Html$Attributes$title('Empresas'),
												$elm$html$Html$Events$onClick($author$project$Pages$Panel$Stock$Details$GoDetails)
											]),
										_List_Nil)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pt-4 flex gap-2 w-64')
									]),
								_List_fromArray(
									[
										A4(
										$author$project$Components$Patterns$Button$text,
										_List_Nil,
										'm-0 w-full red-btn',
										'Deletar',
										$author$project$Pages$Panel$Stock$Details$GoDelete(d.pE)),
										A4(
										$author$project$Components$Patterns$Button$text,
										_List_Nil,
										'm-0 w-full  ',
										'Editar',
										$author$project$Pages$Panel$Stock$Details$GoEdit(d))
									]))
							]));
				},
				model.dE));
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard')
				]),
			_List_fromArray(
				[
					actions,
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-black mb-4')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Detalhes do Equipamento')
						])),
					A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = model.dE;
							switch (_v0.$) {
								case 3:
									var d = _v0.a;
									return A2($author$project$Pages$Panel$Stock$Details$viewInfos, d, shared.kS);
								case 0:
									return $elm$html$Html$text('Processo de execução está incorreto!');
								case 1:
									return $author$project$Components$View$loading;
								default:
									var e = _v0.a;
									return $elm$html$Html$text('Algo deu errado: ' + e);
							}
						}()
						]))
				]));
	});
var $author$project$Pages$Panel$Stock$Details$view = F2(
	function (model, shared) {
		var viewModal = function () {
			var _v0 = model.aY;
			if (!_v0.$) {
				if (!_v0.a.$) {
					var m = _v0.a.a;
					return $author$project$Pages$Panel$Stock$Details$viewModalEditEquipment(m);
				} else {
					var _v1 = _v0.a;
					var serial = _v1.a;
					var isLoading = _v1.b;
					return A2($author$project$Pages$Panel$Stock$Details$viewModalDeleteEquipment, serial, isLoading);
				}
			} else {
				return $elm$html$Html$text('');
			}
		}();
		return _Utils_Tuple2(
			'Detalhes do Equipamento em estoque',
			_List_fromArray(
				[
					A2($author$project$Pages$Panel$Stock$Details$viewPage, model, shared),
					viewModal
				]));
	});
var $author$project$Pages$Panel$Stock$List$CloseModal = {$: 2};
var $author$project$Pages$Panel$Stock$List$InputtedBatch = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Panel$Stock$List$InputtedDescription = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Panel$Stock$List$InputtedPcbID = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Panel$Stock$List$InputtedSerial = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Panel$Stock$List$SelectedStatus = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Panel$Stock$List$SelectedType = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Panel$Stock$List$SubmitCREATE = {$: 6};
var $author$project$Pages$Panel$Stock$List$viewModalCreateReason = function (model) {
	return $author$project$Components$Patterns$Modal$simple(
		{
			hY: $elm$core$Maybe$Just(
				A2($elm$html$Html$Attributes$style, 'min-height', 'fit-content')),
			ii: '',
			il: '',
			ip: $author$project$Pages$Panel$Stock$List$CloseModal,
			fD: 'Cadastrar equipamento',
			k4: $author$project$Components$Patterns$Forms$formSimple(
				{
					hZ: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col gap-4')
						]),
					L: model.L,
					jf: _List_fromArray(
						[
							$author$project$Components$Patterns$Forms$Input(
							{
								ie: $elm$core$Maybe$Nothing,
								iH: model.L === 2,
								iP: _List_Nil,
								nR: _List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-gray-shade')
									]),
								jl: $elm$core$Maybe$Just('Serial'),
								jn: _List_Nil,
								n9: $elm$core$Maybe$Just(90),
								c3: 'Campo para serial',
								jE: $elm$core$Maybe$Nothing,
								jF: $elm$core$Maybe$Nothing,
								jG: $elm$core$Maybe$Nothing,
								ov: $elm$core$Maybe$Nothing,
								jI: $elm$core$Maybe$Just(
									A2($elm$core$Basics$composeL, $author$project$Pages$Panel$Stock$List$ModalMsg, $author$project$Pages$Panel$Stock$List$InputtedSerial)),
								hh: 'Insira o serial do equipamento',
								kE: model.L === 1,
								kY: 'text',
								k1: $author$project$Pages$Panel$Stock$List$validatorsSerial,
								di: model.kw
							}),
							$author$project$Components$Patterns$Forms$Select(
							{
								iH: model.L === 2,
								jl: $elm$core$Maybe$Just('Status'),
								jn: _List_Nil,
								jI: $elm$core$Maybe$Just(
									A2($elm$core$Basics$composeL, $author$project$Pages$Panel$Stock$List$ModalMsg, $author$project$Pages$Panel$Stock$List$SelectedStatus)),
								jO: A2(
									$elm$core$List$cons,
									{
										eX: _Utils_eq(model.kK, $elm$core$Maybe$Nothing),
										c3: 'Selecione',
										di: ''
									},
									A2(
										$elm$core$List$map,
										function (status) {
											return {
												eX: A2(
													$elm$core$Maybe$withDefault,
													false,
													A2(
														$elm$core$Maybe$map,
														$elm$core$Basics$eq(status),
														model.kK)),
												c3: status,
												di: status
											};
										},
										$author$project$Services$Stock$allStatus)),
								jQ: false,
								ks: _List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'margin', '0'),
										$elm$html$Html$Attributes$class('text-gray-shade')
									]),
								kE: model.L === 1,
								k1: A2($author$project$Pages$Panel$Stock$List$validatorsStatus, model.kK, $author$project$Services$Stock$allStatus)
							}),
							$author$project$Components$Patterns$Forms$Select(
							{
								iH: model.L === 2,
								jl: $elm$core$Maybe$Just('Tipo'),
								jn: _List_Nil,
								jI: $elm$core$Maybe$Just(
									A2($elm$core$Basics$composeL, $author$project$Pages$Panel$Stock$List$ModalMsg, $author$project$Pages$Panel$Stock$List$SelectedType)),
								jO: A2(
									$elm$core$List$cons,
									{
										eX: _Utils_eq(model.kK, $elm$core$Maybe$Nothing),
										c3: 'Selecione',
										di: ''
									},
									A2(
										$elm$core$List$map,
										function (type_) {
											return {
												eX: A2(
													$elm$core$Maybe$withDefault,
													false,
													A2(
														$elm$core$Maybe$map,
														$elm$core$Basics$eq(type_),
														model.kK)),
												c3: type_,
												di: type_
											};
										},
										$author$project$Services$Stock$allTypes)),
								jQ: false,
								ks: _List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'margin', '0'),
										$elm$html$Html$Attributes$class('text-gray-shade')
									]),
								kE: model.L === 1,
								k1: A2($author$project$Pages$Panel$Stock$List$validatorsTypes, model.kY, $author$project$Services$Stock$allTypes)
							}),
							$author$project$Components$Patterns$Forms$Input(
							{
								ie: $elm$core$Maybe$Nothing,
								iH: model.L === 2,
								iP: _List_Nil,
								nR: _List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-gray-shade')
									]),
								jl: $elm$core$Maybe$Just('Observação'),
								jn: _List_Nil,
								n9: $elm$core$Maybe$Just(100),
								c3: 'Campo para Observação',
								jE: $elm$core$Maybe$Nothing,
								jF: $elm$core$Maybe$Nothing,
								jG: $elm$core$Maybe$Nothing,
								ov: $elm$core$Maybe$Nothing,
								jI: $elm$core$Maybe$Just(
									A2($elm$core$Basics$composeL, $author$project$Pages$Panel$Stock$List$ModalMsg, $author$project$Pages$Panel$Stock$List$InputtedDescription)),
								hh: 'Insira uma Observação',
								kE: model.L === 1,
								kY: 'text',
								k1: $author$project$Pages$Panel$Stock$List$validatorsDescription,
								di: model.z
							}),
							$author$project$Components$Patterns$Forms$Input(
							{
								ie: $elm$core$Maybe$Nothing,
								iH: model.L === 2,
								iP: _List_Nil,
								nR: _List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-gray-shade')
									]),
								jl: $elm$core$Maybe$Just('Lote'),
								jn: _List_Nil,
								n9: $elm$core$Maybe$Just(80),
								c3: 'Campo para lote',
								jE: $elm$core$Maybe$Nothing,
								jF: $elm$core$Maybe$Nothing,
								jG: $elm$core$Maybe$Nothing,
								ov: $elm$core$Maybe$Nothing,
								jI: $elm$core$Maybe$Just(
									A2($elm$core$Basics$composeL, $author$project$Pages$Panel$Stock$List$ModalMsg, $author$project$Pages$Panel$Stock$List$InputtedBatch)),
								hh: 'Insira o lote',
								kE: model.L === 1,
								kY: 'text',
								k1: $author$project$Pages$Panel$Stock$List$validatorsBatch,
								di: model.bh
							}),
							$author$project$Components$Patterns$Forms$Input(
							{
								ie: $elm$core$Maybe$Nothing,
								iH: model.L === 2,
								iP: _List_Nil,
								nR: _List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-gray-shade')
									]),
								jl: $elm$core$Maybe$Just('PCB ID'),
								jn: _List_Nil,
								n9: $elm$core$Maybe$Just(80),
								c3: 'Campo para lote',
								jE: $elm$core$Maybe$Nothing,
								jF: $elm$core$Maybe$Nothing,
								jG: $elm$core$Maybe$Nothing,
								ov: $elm$core$Maybe$Nothing,
								jI: $elm$core$Maybe$Just(
									A2($elm$core$Basics$composeL, $author$project$Pages$Panel$Stock$List$ModalMsg, $author$project$Pages$Panel$Stock$List$InputtedPcbID)),
								hh: 'Insira o PCB ID',
								kE: model.L === 1,
								kY: 'text',
								k1: $author$project$Pages$Panel$Stock$List$validatorsPcbID,
								di: model.bx
							})
						]),
					oc: $elm$core$Maybe$Just(
						{
							lx: _List_fromArray(
								[
									$elm$html$Html$Attributes$class('self-center')
								]),
							l_: $author$project$Pages$Panel$Stock$List$ModalMsg($author$project$Pages$Panel$Stock$List$SubmitCREATE),
							iH: false
						}),
					pX: 'Criar'
				}),
			k5: $elm$html$Html$text('')
		});
};
var $author$project$Pages$Panel$Stock$List$viewModal = F2(
	function (timezone, maybeModal) {
		if (!maybeModal.$) {
			var m = maybeModal.a;
			return $author$project$Pages$Panel$Stock$List$viewModalCreateReason(m);
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Pages$Panel$Stock$List$InputtedQuerySerial = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Panel$Stock$List$OpenCreate = {$: 3};
var $author$project$Pages$Panel$Stock$List$Submit = {$: 7};
var $author$project$Pages$Panel$Stock$List$valueNotEmpty = function (str) {
	return $elm$core$String$isEmpty(str) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(str);
};
var $author$project$Pages$Panel$Stock$List$GoDetails = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Panel$Stock$List$viewRowStr = F2(
	function (timezone, stock) {
		var maybeValue = function (v) {
			return A2($elm$core$Maybe$withDefault, '-', v);
		};
		var emptyValue = function (v) {
			return $elm$core$String$isEmpty(v) ? '-' : v;
		};
		return _List_fromArray(
			[
				A2($author$project$Utils$formatDateTimeFromPosixWithSeconds, timezone, stock.ix),
				emptyValue(
				maybeValue(stock.kY)),
				emptyValue(stock.pE),
				emptyValue(stock.bh),
				emptyValue(
				maybeValue(stock.kK)),
				emptyValue(stock.bx)
			]);
	});
var $author$project$Pages$Panel$Stock$List$viewRowHtml = F2(
	function (timezone, equipment) {
		var onClick = $elm$html$Html$Events$onClick(
			$author$project$Pages$Panel$Stock$List$GoDetails(equipment.pE));
		return A2(
			$elm$core$List$map,
			function (str) {
				return A2(
					$elm$html$Html$td,
					_List_fromArray(
						[onClick]),
					_List_fromArray(
						[
							$elm$html$Html$text(str)
						]));
			},
			A2($author$project$Pages$Panel$Stock$List$viewRowStr, timezone, equipment));
	});
var $author$project$Pages$Panel$Stock$List$viewPage = F2(
	function (model, shared) {
		var viewCreate = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('top-actions pb-0 pt-4 mt-4')
				]),
			_List_fromArray(
				[
					A4(
					$author$project$Components$Patterns$Button$textSimple,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'width', 'max-content')
						]),
					'btn-ce btn-adicionar m-0',
					'Cadastrar equipamento',
					$author$project$Pages$Panel$Stock$List$OpenCreate)
				]));
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard')
				]),
			_List_fromArray(
				[
					viewCreate,
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-black mb-4')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Estoque')
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Components$Patterns$Forms$formSimple(
							{
								hZ: _List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex gap-4'),
										$elm$html$Html$Attributes$novalidate(true)
									]),
								L: model.L,
								jf: _List_fromArray(
									[
										$author$project$Components$Patterns$Forms$Input(
										{
											ie: $elm$core$Maybe$Nothing,
											iH: model.L === 2,
											iP: _List_Nil,
											nR: _List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'border-bottom', '1px solid #6e46c8'),
													$elm$html$Html$Attributes$class('mt-4')
												]),
											jl: $elm$core$Maybe$Just('Serial'),
											jn: _List_fromArray(
												[
													$elm$html$Html$Attributes$class('flex flex-col'),
													A2($elm$html$Html$Attributes$style, 'width', 'fit-content')
												]),
											n9: $elm$core$Maybe$Just(25),
											c3: '',
											jE: $elm$core$Maybe$Nothing,
											jF: $elm$core$Maybe$Nothing,
											jG: $elm$core$Maybe$Nothing,
											ov: $elm$core$Maybe$Nothing,
											jI: $elm$core$Maybe$Just(
												A2($elm$core$Basics$composeR, $author$project$Pages$Panel$Stock$List$valueNotEmpty, $author$project$Pages$Panel$Stock$List$InputtedQuerySerial)),
											hh: '',
											kE: model.L === 1,
											kY: 'text',
											k1: _List_Nil,
											di: A2($elm$core$Maybe$withDefault, '', model.T.kw)
										})
									]),
								oc: $elm$core$Maybe$Just(
									{
										lx: _List_fromArray(
											[
												$elm$html$Html$Attributes$class('self-center w-40')
											]),
										l_: $author$project$Pages$Panel$Stock$List$Submit,
										iH: model.L === 2
									}),
								pX: 'Pesquisar'
							})
						])),
					A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = model.kL;
							switch (_v0.$) {
								case 3:
									if (!_v0.a.b) {
										return $elm$html$Html$text('Nenhum registro encontrado');
									} else {
										var reasons = _v0.a;
										return $author$project$Components$Patterns$Tables$defaultClickable(
											{
												nF: _List_fromArray(
													['Criado em', 'Tipo', 'Serial', 'Lote', 'Status', 'PCBID', '']),
												nX: true,
												pj: A2(
													$elm$core$List$map,
													$author$project$Pages$Panel$Stock$List$viewRowHtml(shared.kS),
													reasons)
											});
									}
								case 0:
									return $elm$html$Html$text('Processo de execução está incorreto!');
								case 1:
									return $author$project$Components$View$loading;
								default:
									var e = _v0.a;
									return $elm$html$Html$text('Algo deu errado: ' + e);
							}
						}()
						]))
				]));
	});
var $author$project$Pages$Panel$Stock$List$view = F2(
	function (model, shared) {
		return _Utils_Tuple2(
			'Estoque',
			_List_fromArray(
				[
					A2($author$project$Pages$Panel$Stock$List$viewPage, model, shared),
					A2($author$project$Pages$Panel$Stock$List$viewModal, shared.kS, model.aY)
				]));
	});
var $author$project$Pages$Panel$UpdateEquipment$CloseModal = {$: 4};
var $author$project$Pages$Panel$UpdateEquipment$SelectedNewSoftware = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Panel$UpdateEquipment$UpdateSubmitted = {$: 2};
var $author$project$Pages$Panel$UpdateEquipment$defaultOptionSoftware = function (softwareSelectedID) {
	return {eX: softwareSelectedID === '', c3: 'Versão do software', di: ''};
};
var $elm$core$Dict$map = F2(
	function (func, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				A2(func, key, value),
				A2($elm$core$Dict$map, func, left),
				A2($elm$core$Dict$map, func, right));
		}
	});
var $author$project$Pages$Panel$UpdateEquipment$optionsSoftware = F2(
	function (softwareSelectedID, software) {
		return {
			eX: _Utils_eq(softwareSelectedID, software.dM),
			c3: software.l4,
			di: software.dM
		};
	});
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $author$project$Pages$Panel$UpdateEquipment$viewModalUpdate = F2(
	function (modal, devicesSelected) {
		var viewDevices = A2(
			$elm$core$String$join,
			', ',
			$elm$core$Dict$values(
				A2(
					$elm$core$Dict$map,
					F2(
						function (_v0, device) {
							return device.pE;
						}),
					devicesSelected)));
		return $author$project$Components$Patterns$Modal$simple(
			{
				hY: $elm$core$Maybe$Just(
					A2($elm$html$Html$Attributes$style, 'min-height', 'fit-content')),
				ii: '',
				il: '',
				ip: $author$project$Pages$Panel$UpdateEquipment$CloseModal,
				fD: 'Atualizar equipamentos',
				k4: A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col gap-2')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_Utils_ap(
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												'Equipamentos que serão atualizados (' + ($elm$core$String$fromInt(
													$elm$core$Dict$size(devicesSelected)) + '): '))
											]))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(viewDevices)
									]))),
							$author$project$Components$Patterns$Forms$formSimple(
							{
								hZ: _List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex flex-col gap-4')
									]),
								L: modal.L,
								jf: _List_fromArray(
									[
										$author$project$Components$Patterns$Forms$Select(
										{
											iH: modal.L === 2,
											jl: $elm$core$Maybe$Just('Selecione a nova versão para os equipamentos'),
											jn: _List_Nil,
											jI: $elm$core$Maybe$Just(
												A2($elm$core$Basics$composeL, $author$project$Pages$Panel$UpdateEquipment$ModalMsg, $author$project$Pages$Panel$UpdateEquipment$SelectedNewSoftware)),
											jO: _Utils_ap(
												$elm$core$List$singleton(
													$author$project$Pages$Panel$UpdateEquipment$defaultOptionSoftware(modal.cs)),
												A2(
													$elm$core$List$map,
													$author$project$Pages$Panel$UpdateEquipment$optionsSoftware(modal.cs),
													$elm$core$List$reverse(
														A2(
															$elm$core$List$sortBy,
															A2(
																$elm$core$Basics$composeR,
																function ($) {
																	return $.ix;
																},
																$elm$time$Time$posixToMillis),
															A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, modal.fw))))),
											jQ: true,
											ks: _List_Nil,
											kE: modal.L === 1,
											k1: _List_Nil
										})
									]),
								oc: $elm$core$Maybe$Just(
									{
										lx: _List_fromArray(
											[
												$elm$html$Html$Attributes$class('self-center')
											]),
										l_: $author$project$Pages$Panel$UpdateEquipment$ModalMsg($author$project$Pages$Panel$UpdateEquipment$UpdateSubmitted),
										iH: false
									}),
								pX: 'Solicitar atualização'
							})
						])),
				k5: $elm$html$Html$text('')
			});
	});
var $author$project$Pages$Panel$UpdateEquipment$viewModalUpdateSuccess = function (resultUpdateDevice) {
	return $author$project$Components$Patterns$Modal$simple(
		{
			hY: $elm$core$Maybe$Just(
				A2($elm$html$Html$Attributes$style, 'min-height', 'fit-content')),
			ii: '',
			il: '',
			ip: $author$project$Pages$Panel$UpdateEquipment$CloseModal,
			fD: 'Resultado da solicitação',
			k4: A2(
				$elm$html$Html$section,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex flex-col gap-2')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(resultUpdateDevice.od)
									]))
							])),
						A2(
						$elm$core$Maybe$withDefault,
						$elm$html$Html$text(''),
						A2(
							$elm$core$Maybe$map,
							function (d) {
								return A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Equipamentos atualizados: ')
												])),
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2($elm$core$String$join, ', ', d))
												]))
										]));
							},
							resultUpdateDevice.lj)),
						A2(
						$elm$core$Maybe$withDefault,
						$elm$html$Html$text(''),
						A2(
							$elm$core$Maybe$map,
							function (d) {
								return A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Equipamentos que falharam: ')
												])),
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2($elm$core$String$join, ', ', d))
												]))
										]));
							},
							resultUpdateDevice.nh))
					])),
			k5: A4($author$project$Components$Patterns$Button$text, _List_Nil, ' mt-4', 'Fechar', $author$project$Pages$Panel$UpdateEquipment$CloseModal)
		});
};
var $author$project$Pages$Panel$UpdateEquipment$ClickedToggleAllDevice = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Panel$UpdateEquipment$InitModalUpdateDevices = {$: 3};
var $author$project$Components$Patterns$Tables$defaultWithCheckbox = function (opts) {
	var cssTableDefaultPanel = opts.nX ? _List_fromArray(
		[
			$elm$html$Html$Attributes$class('overflow-x-auto'),
			A2($elm$html$Html$Attributes$style, 'width', 'calc(100vw - 23rem)')
		]) : _List_Nil;
	var cbTr = F2(
		function (checked, onClick) {
			return A2(
				$elm$html$Html$tr,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-4 content-start')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$article,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('checkbox-line-container flex gap-4')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('c-custom m-0 pl-6')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$type_('checkbox'),
												$elm$html$Html$Events$onClick(onClick),
												$elm$html$Html$Attributes$checked(checked)
											]),
										_List_Nil),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('checkmark')
											]),
										_List_Nil)
									]))
							]))
					]));
		});
	var cbTd = F2(
		function (checked, onClick) {
			return A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-4 content-start'),
						$elm$html$Html$Events$onClick(onClick)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$article,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('checkbox-line-container flex gap-4'),
								$elm$html$Html$Events$onClick(onClick)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('c-custom m-0 pl-6')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$type_('checkbox'),
												$elm$html$Html$Events$onClick(onClick),
												$elm$html$Html$Attributes$checked(checked)
											]),
										_List_Nil),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('checkmark')
											]),
										_List_Nil)
									]))
							]))
					]));
		});
	return A2(
		$elm$html$Html$div,
		cssTableDefaultPanel,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$table,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'cellspacing', '0'),
						$elm$html$Html$Attributes$class('data-table-dashboard my-4')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$tr,
								_List_Nil,
								_Utils_ap(
									_List_fromArray(
										[
											A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													function (_v0) {
													var checked = _v0.a;
													var onClick = _v0.b;
													return A2(cbTr, checked, onClick);
												}(opts.pA)
												]))
										]),
									A2(
										$elm$core$List$map,
										function (header) {
											return A2(
												$elm$html$Html$th,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(header)
													]));
										},
										opts.nF)))
							])),
						A2(
						$elm$html$Html$tbody,
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (_v1) {
								var record = _v1.a;
								var checked = _v1.b;
								var onClick = _v1.c;
								return A2(
									$elm$html$Html$tr,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('hover:bg-gray-tint1 cursor-pointer'),
											$elm$html$Html$Attributes$class(
											checked ? 'text-purple-main' : ''),
											$elm$html$Html$Events$onClick(onClick)
										]),
									_Utils_ap(
										_List_fromArray(
											[
												A2(cbTd, checked, onClick)
											]),
										record));
							},
							opts.pj))
					]))
			]));
};
var $author$project$Pages$Panel$UpdateEquipment$viewFareRow = function (device) {
	var rowTd = function (txt) {
		return A2(
			$elm$html$Html$td,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(txt)
				]));
	};
	var maybeText = function (mText) {
		return A2($elm$core$Maybe$withDefault, '-', mText);
	};
	return _List_fromArray(
		[
			rowTd(device.pE),
			rowTd(
			maybeText(device.n6)),
			rowTd(device.kY)
		]);
};
var $author$project$Pages$Panel$UpdateEquipment$ClickedToggleDevice = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Panel$UpdateEquipment$viewFareRowWithCheckbox = F4(
	function (devicesSelected, timezone, user, device) {
		var rowTd = function (txt) {
			return A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(txt)
					]));
		};
		var maybeText = function (mText) {
			return A2($elm$core$Maybe$withDefault, '-', mText);
		};
		var emptyText = function (mText) {
			return $elm$core$String$isEmpty(mText) ? '-' : mText;
		};
		return _Utils_Tuple3(
			_List_fromArray(
				[
					rowTd(device.pE),
					rowTd(
					emptyText(device.em)),
					rowTd(device.kG),
					rowTd(device.kY)
				]),
			A2($elm$core$Dict$member, device.dM, devicesSelected),
			$author$project$Pages$Panel$UpdateEquipment$ClickedToggleDevice(device));
	});
var $author$project$Pages$Panel$UpdateEquipment$viewPage = F3(
	function (model, user, shared) {
		var viewUpdateDevices = $author$project$Services$Models$iHaveAccess(
			{
				gZ: user.hg,
				hf: $author$project$Services$Models$EQUIPMENT_UPDATE(1),
				hQ: ($elm$core$Dict$size(model.P) > 0) ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('top-actions pb-0 pt-4 mt-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('btn-ce btn-update'),
									A2($elm$html$Html$Attributes$style, 'width', 'max-content'),
									$elm$html$Html$Events$onClick($author$project$Pages$Panel$UpdateEquipment$InitModalUpdateDevices)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Atualizar equipamentos selecionados')
								]))
						])) : $elm$html$Html$text(''),
				hR: $elm$html$Html$text('')
			});
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-black mb-4')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Equipamentos')
						])),
					A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							viewUpdateDevices,
							function () {
							var _v0 = model.eF;
							switch (_v0.$) {
								case 0:
									return $elm$html$Html$text('Processo de execução está incorreto!');
								case 1:
									return $author$project$Components$View$loading;
								case 2:
									var e = _v0.a;
									return $elm$html$Html$text('Algo deu errado: ' + e);
								default:
									if (!_v0.a.b) {
										return $elm$html$Html$text('Nenhum registro encontrado');
									} else {
										var devices = _v0.a;
										return $author$project$Services$Models$iHaveAccess(
											{
												gZ: user.hg,
												hf: $author$project$Services$Models$EQUIPMENT_UPDATE(1),
												hQ: $author$project$Components$Patterns$Tables$defaultWithCheckbox(
													{
														nF: _List_fromArray(
															['Serial', 'Veículo', 'Versão', 'Tipo']),
														nX: true,
														pj: A2(
															$elm$core$List$map,
															A3($author$project$Pages$Panel$UpdateEquipment$viewFareRowWithCheckbox, model.P, shared.kS, user),
															devices),
														pA: _Utils_Tuple2(
															_Utils_eq(
																$elm$core$Dict$size(model.P),
																$elm$core$List$length(devices)),
															$author$project$Pages$Panel$UpdateEquipment$ClickedToggleAllDevice(devices))
													}),
												hR: $author$project$Components$Patterns$Tables$default(
													{
														nF: _List_fromArray(
															['Serial', 'MacAddress', 'Tipo']),
														nX: true,
														pj: A2($elm$core$List$map, $author$project$Pages$Panel$UpdateEquipment$viewFareRow, devices)
													})
											});
									}
							}
						}()
						]))
				]));
	});
var $author$project$Pages$Panel$UpdateEquipment$view = F3(
	function (model, user, shared) {
		var viewModal = function () {
			var _v0 = model.aY;
			if (!_v0.$) {
				if (!_v0.a.$) {
					var m = _v0.a.a;
					return A2($author$project$Pages$Panel$UpdateEquipment$viewModalUpdate, m, model.P);
				} else {
					var m = _v0.a.a;
					return $author$project$Pages$Panel$UpdateEquipment$viewModalUpdateSuccess(m);
				}
			} else {
				return $elm$html$Html$text('');
			}
		}();
		return _Utils_Tuple2(
			'Equipamentos',
			_List_fromArray(
				[
					A3($author$project$Pages$Panel$UpdateEquipment$viewPage, model, user, shared),
					viewModal
				]));
	});
var $author$project$Pages$Panel$UpdateRequestsEquipments$CancelRequest = {$: 0};
var $author$project$Pages$Panel$UpdateRequestsEquipments$CloseModal = {$: 1};
var $author$project$Pages$Panel$UpdateRequestsEquipments$viewModalConfirmDelete = function (updateRequest) {
	return $author$project$Components$Patterns$Modal$simple(
		{
			hY: $elm$core$Maybe$Just(
				A2($elm$html$Html$Attributes$style, 'min-height', 'fit-content')),
			ii: '',
			il: '',
			ip: $author$project$Pages$Panel$UpdateRequestsEquipments$CloseModal,
			fD: 'Confirmação de Cancelamento',
			k4: A2(
				$elm$html$Html$section,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('font-bold my-4')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Você está prestes a cancelar a atualização. Esta ação não pode ser desfeita. Deseja continuar?')
							]))
					])),
			k5: A2(
				$elm$html$Html$section,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex gap-4 w-full')
					]),
				_List_fromArray(
					[
						A4(
						$author$project$Components$Patterns$Button$text,
						_List_Nil,
						'w-full red-btn',
						'Sim, cancelar!',
						$author$project$Pages$Panel$UpdateRequestsEquipments$ModalMsg($author$project$Pages$Panel$UpdateRequestsEquipments$CancelRequest)),
						A4($author$project$Components$Patterns$Button$text, _List_Nil, 'w-full  ', 'Fechar', $author$project$Pages$Panel$UpdateRequestsEquipments$CloseModal)
					]))
		});
};
var $author$project$Pages$Panel$UpdateRequestsEquipments$viewModalUpdateSuccess = function (resultUpdateDevice) {
	return $author$project$Components$Patterns$Modal$simple(
		{
			hY: $elm$core$Maybe$Just(
				A2($elm$html$Html$Attributes$style, 'min-height', 'fit-content')),
			ii: '',
			il: '',
			ip: $author$project$Pages$Panel$UpdateRequestsEquipments$CloseModal,
			fD: 'Resultado do cancelamento',
			k4: A2(
				$elm$html$Html$section,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex flex-col gap-2')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(resultUpdateDevice.od)
									]))
							])),
						A2(
						$elm$core$Maybe$withDefault,
						$elm$html$Html$text(''),
						A2(
							$elm$core$Maybe$map,
							function (d) {
								return A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Equipamentos deletados: ')
												])),
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2($elm$core$String$join, ', ', d))
												]))
										]));
							},
							resultUpdateDevice.lj)),
						A2(
						$elm$core$Maybe$withDefault,
						$elm$html$Html$text(''),
						A2(
							$elm$core$Maybe$map,
							function (d) {
								return A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Equipamentos que falharam: ')
												])),
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2($elm$core$String$join, ', ', d))
												]))
										]));
							},
							resultUpdateDevice.nh))
					])),
			k5: A4($author$project$Components$Patterns$Button$text, _List_Nil, ' mt-4', 'Fechar', $author$project$Pages$Panel$UpdateRequestsEquipments$CloseModal)
		});
};
var $author$project$Pages$Panel$UpdateRequestsEquipments$DELETE = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Panel$UpdateRequestsEquipments$OpenModal = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Panel$UpdateRequestsEquipments$viewUpdateRequestRow = F3(
	function (user, timezone, updateRequest) {
		var viewButtonCancel = $author$project$Services$Models$iHaveAccess(
			{
				gZ: user.hg,
				hf: $author$project$Services$Models$EQUIPMENT_UPDATE(1),
				hQ: A4(
					$author$project$Components$Patterns$Button$text,
					_List_Nil,
					'red-btn',
					'Cancelar',
					$author$project$Pages$Panel$UpdateRequestsEquipments$OpenModal(
						$author$project$Pages$Panel$UpdateRequestsEquipments$DELETE(updateRequest))),
				hR: $elm$html$Html$text('')
			});
		var valueEmpty = function (str) {
			return $elm$core$String$isEmpty(str) ? '-' : str;
		};
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						valueEmpty(updateRequest.mj))
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($author$project$Utils$formatDateTimeFromPosixWithSeconds, timezone, updateRequest.ix))
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						valueEmpty(updateRequest.em))
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(updateRequest.pK)
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						valueEmpty(updateRequest.pD))
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$withDefault,
						viewButtonCancel,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Utils$formatDateTimeFromPosixWithSeconds(timezone),
								$elm$html$Html$text),
							updateRequest.lq))
					]))
			]);
	});
var $author$project$Pages$Panel$UpdateRequestsEquipments$viewPage = F3(
	function (model, shared, user) {
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-black mb-4')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Solicitações de atualização')
						])),
					A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = model.fK;
							switch (_v0.$) {
								case 3:
									if (!_v0.a.b) {
										return $elm$html$Html$text('Nenhum registro encontrado');
									} else {
										var updateRequests = _v0.a;
										var ordered = $elm$core$List$reverse(
											A2(
												$elm$core$List$sortBy,
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.ix;
													},
													$elm$time$Time$posixToMillis),
												updateRequests));
										return $author$project$Components$Patterns$Tables$default(
											{
												nF: _List_fromArray(
													['Criado por', 'Criado em', 'Veículo', 'Versão', 'Serial', 'Aplicado em']),
												nX: true,
												pj: A2(
													$elm$core$List$map,
													A2($author$project$Pages$Panel$UpdateRequestsEquipments$viewUpdateRequestRow, user, shared.kS),
													ordered)
											});
									}
								case 0:
									return $elm$html$Html$text('Processo de inicialização não foi executado!');
								case 1:
									return $author$project$Components$View$loading;
								default:
									var e = _v0.a;
									return $elm$html$Html$text('Algo deu errado: ');
							}
						}()
						]))
				]));
	});
var $author$project$Pages$Panel$UpdateRequestsEquipments$view = F3(
	function (model, shared, user) {
		var viewModal = function () {
			var _v0 = model.aY;
			if (!_v0.$) {
				if (!_v0.a.$) {
					var updateRequest = _v0.a.a;
					return $author$project$Pages$Panel$UpdateRequestsEquipments$viewModalConfirmDelete(updateRequest);
				} else {
					var result = _v0.a.a;
					return $author$project$Pages$Panel$UpdateRequestsEquipments$viewModalUpdateSuccess(result);
				}
			} else {
				return $elm$html$Html$text('');
			}
		}();
		return _Utils_Tuple2(
			'Solicitações de atualização',
			_List_fromArray(
				[
					A3($author$project$Pages$Panel$UpdateRequestsEquipments$viewPage, model, shared, user),
					viewModal
				]));
	});
var $author$project$Pages$Pos$CloseCashier$confirmationModal = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('modal-overlay')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('modal-container sucesso-bg')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('header-modal')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('action-header'),
									$elm$html$Html$Attributes$href(
									$author$project$Route$toString($author$project$Route$Guiche))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fechar-ico')
										]),
									_List_Nil)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('check-pagamento-realizado')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sucesso-confirma')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Fechamento realizado com sucesso!')
								]))
						]))
				]))
		]));
var $author$project$Pages$Pos$CloseCashier$modal = function (_v0) {
	var modalActive = _v0.e6;
	return modalActive ? $author$project$Pages$Pos$CloseCashier$confirmationModal : $elm$html$Html$text('');
};
var $author$project$Pages$Pos$CloseCashier$viewHeader = function (user) {
	return A3(
		$author$project$Components$View$cashierHeader,
		$elm$core$Maybe$Just(user),
		_List_Nil,
		_List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Components$View$InternalLink($author$project$Route$Guiche),
				_List_fromArray(
					[
						$elm$html$Html$text('Cancelar'),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fechar-ico')
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$Pages$Pos$CloseCashier$CloseCashier = {$: 0};
var $author$project$Pages$Pos$CloseCashier$listCardsView = function (_v0) {
	var resume = _v0.cl;
	var moneyToValue = function (v) {
		var _int = v;
		return _int;
	};
	var totalValue = $elm$core$List$sum(
		A2(
			$elm$core$List$map,
			function (v) {
				return moneyToValue(v.lo);
			},
			resume.f0.dA));
	return A2(
		$elm$core$List$cons,
		A2(
			$elm$html$Html$h2,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Cartões Emitidos')
				])),
		_Utils_ap(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fechamento-data')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('item')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Quantidade')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('line')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('total-item')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(totalValue))
								]))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fechamento-data fechamento-total')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('item')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('total-item')
								]),
							_List_Nil)
						]))
				])));
};
var $author$project$Data$Money$toString = function (_v0) {
	var value = _v0;
	var str = $elm$core$String$fromInt(
		$elm$core$Basics$abs(value));
	var negativeSignal = (value < 0) ? '-' : '';
	return _Utils_ap(
		negativeSignal,
		function () {
			var _v1 = $elm$core$String$toList(str);
			if (!_v1.b) {
				return '0';
			} else {
				if (!_v1.b.b) {
					return '0,0' + str;
				} else {
					if (!_v1.b.b.b) {
						var _v2 = _v1.b;
						return '0,' + str;
					} else {
						var _v3 = _v1.b;
						return A2($elm$core$String$dropRight, 2, str) + (',' + A2($elm$core$String$right, 2, str));
					}
				}
			}
		}());
};
var $author$project$Pages$Pos$CloseCashier$dataTag = function (_v0) {
	var type_ = _v0.kY;
	var amount = _v0.lo;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('fechamento-data')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(type_)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('line')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('total-item')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Data$Money$toString(amount))
					]))
			]));
};
var $author$project$Pages$Pos$CloseCashier$dataTagList = F2(
	function (title, _v0) {
		var counts = _v0.dA;
		var total = _v0.qc;
		return A2(
			$elm$core$List$cons,
			A2(
				$elm$html$Html$h2,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(title)
					])),
			_Utils_ap(
				A2($elm$core$List$map, $author$project$Pages$Pos$CloseCashier$dataTag, counts),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fechamento-data fechamento-total')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('item')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Total')
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('line')
									]),
								_List_Nil),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('total-item')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Data$Money$toString(total))
									]))
							]))
					])));
	});
var $author$project$Pages$Pos$CloseCashier$listCreditsView = function (_v0) {
	var resume = _v0.cl;
	return A2($author$project$Pages$Pos$CloseCashier$dataTagList, 'Créditos Vendidos', resume.gb);
};
var $author$project$Pages$Pos$CloseCashier$listSecondWayView = function (_v0) {
	var resume = _v0.cl;
	return A2(
		$elm$core$List$cons,
		A2(
			$elm$html$Html$h2,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('2ª Vias emitidos')
				])),
		_Utils_ap(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fechamento-data')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('item')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Quantidade')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('line')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('total-item')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(resume.hv.dA))
								]))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fechamento-data fechamento-total')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('item')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Valor total')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('line')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('total-item')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Data$Money$toString(resume.hv.qc))
								]))
						]))
				])));
};
var $author$project$Utils$posixToHHmmDDMMYYYY = F2(
	function (timezone, time) {
		return A3(
			$elm$core$String$padLeft,
			2,
			'0',
			$elm$core$String$fromInt(
				A2($elm$time$Time$toHour, timezone, time))) + (':' + (A3(
			$elm$core$String$padLeft,
			2,
			'0',
			$elm$core$String$fromInt(
				A2($elm$time$Time$toMinute, timezone, time))) + (' ' + (A3(
			$elm$core$String$padLeft,
			2,
			'0',
			$elm$core$String$fromInt(
				A2($elm$time$Time$toDay, timezone, time))) + ('/' + (A3(
			$elm$core$String$padLeft,
			2,
			'0',
			$elm$core$String$fromInt(
				$justinmimbs$date$Date$monthToNumber(
					A2($elm$time$Time$toMonth, timezone, time)))) + ('/' + $elm$core$String$fromInt(
			A2($elm$time$Time$toYear, timezone, time)))))))));
	});
var $author$project$Pages$Pos$CloseCashier$viewMain = F2(
	function (model, shared) {
		return A2(
			$elm$html$Html$main_,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('container fechamento-de-caixa-container'),
							A2($elm$html$Html$Attributes$style, 'width', '100dvw')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h1,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Fechamento de Caixa')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fechamento-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fechamento-inner')
										]),
									$author$project$Pages$Pos$CloseCashier$listCreditsView(model)),
									$elm$html$Html$text(''),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fechamento-inner')
										]),
									$author$project$Pages$Pos$CloseCashier$listCardsView(model)),
									$elm$html$Html$text(''),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fechamento-inner')
										]),
									$author$project$Pages$Pos$CloseCashier$listSecondWayView(model))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('horarios-fechamento-caixa')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Horário de abertura: ')
												])),
											$elm$html$Html$text(
											A2($author$project$Utils$posixToHHmmDDMMYYYY, shared.kS, model.jL))
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Horário de fechamento: ')
												])),
											A2(
											$elm$core$Maybe$withDefault,
											$elm$html$Html$text('caixa aberto'),
											A2(
												$elm$core$Maybe$map,
												A2(
													$elm$core$Basics$composeR,
													$author$project$Utils$posixToHHmmDDMMYYYY(shared.kS),
													$elm$html$Html$text),
												model.l2))
										]))
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('action-system green-btn'),
									$elm$html$Html$Events$onClick($author$project$Pages$Pos$CloseCashier$CloseCashier)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Confirmar Fechamento de Caixa')
								]))
						]))
				]));
	});
var $author$project$Pages$Pos$CloseCashier$viewPage = F3(
	function (user, model, shared) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Pages$Pos$CloseCashier$modal(model),
					$author$project$Pages$Pos$CloseCashier$viewHeader(user),
					A2($author$project$Pages$Pos$CloseCashier$viewMain, model, shared)
				]));
	});
var $author$project$Pages$Pos$CloseCashier$view = F3(
	function (user, model, shared) {
		return _Utils_Tuple2(
			'Guichê - Fechamento de Caixa',
			A3($author$project$Pages$Pos$CloseCashier$viewPage, user, model, shared));
	});
var $author$project$Pages$Pos$Editor$PreviousStep = {$: 7};
var $author$project$Pages$Pos$Editor$container = F2(
	function (model, children) {
		return A2(
			$elm$html$Html$main_,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('container')
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$h1,
							_List_Nil,
							_List_fromArray(
								[
									function () {
									var _v0 = model.j;
									if (_v0.$ === 1) {
										return $elm$html$Html$text('Cadastro de Novo Usuário');
									} else {
										return $elm$html$Html$text('Editar Usuário');
									}
								}()
								])),
						children))
				]));
	});
var $author$project$Pages$Pos$Editor$Address = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Pos$Editor$AddressComplement = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Pos$Editor$AddressNumber = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Pos$Editor$AddressState = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Pos$Editor$City = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Pos$Editor$Document = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Pos$Editor$Email = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Pos$Editor$Input = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Pos$Editor$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Pos$Editor$Neighborhood = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Pos$Editor$OpenClassEditModal = {$: 16};
var $author$project$Pages$Pos$Editor$OpenPhoneEditModal = {$: 17};
var $author$project$Pages$Pos$Editor$PostalCode = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Pos$Editor$viewClasses = function (model) {
	return A2(
		$elm$html$Html$ul,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mt-2 flex flex-col gap-2 text-white text-lg')
			]),
		function () {
			var _v0 = model.dv;
			switch (_v0.$) {
				case 3:
					var classes = _v0.a;
					return A2(
						$elm$core$List$map,
						function (class_) {
							var _v1 = A2($elm$core$Dict$get, class_.dM, model.B);
							if (!_v1.$) {
								var maybeType_ = _v1.a;
								return A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('● ' + class_.c3)
												])),
											A2(
											$elm$html$Html$ul,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pl-4')
												]),
											A2(
												$elm$core$List$map,
												function (tp) {
													return _Utils_eq(
														$elm$core$Maybe$Just(tp.dM),
														maybeType_) ? A2(
														$elm$html$Html$li,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('○ ' + tp.c3)
															])) : $elm$html$Html$text('');
												},
												class_.dh))
										]));
							} else {
								return $elm$html$Html$text('');
							}
						},
						classes);
				case 1:
					return _List_fromArray(
						[$author$project$Components$View$loading]);
				default:
					return _List_Nil;
			}
		}());
};
var $author$project$Pages$Pos$Editor$InputtedClassType = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Pages$Pos$Editor$SelectClass = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$Pos$Editor$viewCreateClasses = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mt-2')
			]),
		A2(
			$elm$core$List$map,
			function (class_) {
				var maybeType = A2($elm$core$Dict$get, class_.dM, model.B);
				var isChecked = !_Utils_eq(maybeType, $elm$core$Maybe$Nothing);
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-2')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'cursor', 'pointer'),
									$elm$html$Html$Attributes$class('text-white flex mt-0')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('w-4 h-4 mt-0'),
											$elm$html$Html$Attributes$type_('checkbox'),
											$elm$html$Html$Attributes$checked(isChecked),
											$elm$html$Html$Events$onCheck(
											$author$project$Pages$Pos$Editor$SelectClass(class_.dM))
										]),
									_List_Nil),
									$elm$html$Html$text(class_.c3)
								])),
							function () {
							if (!maybeType.$) {
								var maybeType_ = maybeType.a;
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('editor-class-types  flex flex-col gap-2')
										]),
									A2(
										$elm$core$List$map,
										function (tp) {
											return A2(
												$elm$html$Html$label,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('text-white flex mt-0 relative ')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$input,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('w-4 h-4 mt-0 mb-4 left-auto contents after:content-[\'\']'),
																$elm$html$Html$Attributes$type_('radio'),
																$elm$html$Html$Attributes$value(tp.dM),
																$elm$html$Html$Attributes$name('class-type-' + class_.dM),
																$elm$html$Html$Attributes$id(
																_Utils_ap(class_.dM, tp.dM)),
																$elm$html$Html$Attributes$checked(
																_Utils_eq(
																	$elm$core$Maybe$Just(tp.dM),
																	maybeType_)),
																$elm$html$Html$Events$onInput(
																$author$project$Pages$Pos$Editor$InputtedClassType(class_.dM))
															]),
														_List_Nil),
														A2(
														$elm$html$Html$label,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$for(
																_Utils_ap(class_.dM, tp.dM)),
																$elm$html$Html$Attributes$class('text-black m-0 pl-5')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$span,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('ml-2 text-gray-tint1')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(tp.c3)
																	]))
															]))
													]));
										},
										class_.dh));
							} else {
								return $elm$html$Html$text('');
							}
						}()
						]));
			},
			A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, model.dv)));
};
var $author$project$Pages$Pos$Editor$viewForm = F2(
	function (model, timezone) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('inner-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Dados Pessoais')
							])),
						$author$project$Components$Input$input_(
						_Utils_update(
							$author$project$Components$Input$defaultOptions,
							{
								fS: true,
								gU: 50,
								jI: $elm$core$Maybe$Just(
									A2($elm$core$Basics$composeL, $author$project$Pages$Pos$Editor$Input, $author$project$Pages$Pos$Editor$Name)),
								hh: 'Nome Completo',
								di: model.c3
							})),
						$author$project$Components$Input$input_(
						_Utils_update(
							$author$project$Components$Input$defaultOptions,
							{
								iH: !_Utils_eq(model.j, $elm$core$Maybe$Nothing),
								gU: 20,
								jI: $elm$core$Maybe$Just(
									A2(
										$elm$core$Basics$composeL,
										A2($elm$core$Basics$composeL, $author$project$Pages$Pos$Editor$Input, $author$project$Pages$Pos$Editor$Document),
										$elm$core$String$filter($elm$core$Char$isDigit))),
								hh: 'CPF',
								di: $author$project$Utils$maskCPF(model.iI)
							})),
						$author$project$Components$Input$input_(
						_Utils_update(
							$author$project$Components$Input$defaultOptions,
							{
								gU: 50,
								jI: $elm$core$Maybe$Just(
									A2($elm$core$Basics$composeL, $author$project$Pages$Pos$Editor$Input, $author$project$Pages$Pos$Editor$Email)),
								hh: 'Email',
								di: model.mX
							})),
						function () {
						var _v0 = model.j;
						if (!_v0.$) {
							var p = _v0.a;
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex gap-4')
									]),
								_List_fromArray(
									[
										$author$project$Components$Input$input_(
										_Utils_update(
											$author$project$Components$Input$defaultOptions,
											{
												iH: true,
												jI: $elm$core$Maybe$Nothing,
												hh: 'Celular',
												di: $author$project$Utils$maskPhoneDDD(p.oe.jX)
											})),
										A4($author$project$Components$Patterns$Button$icon, $author$project$Pages$Pos$Editor$OpenPhoneEditModal, 'icon-edit-config flex items-center m-0', 'edit_square', 'Editar celular')
									]));
						} else {
							return $elm$html$Html$text('');
						}
					}(),
						$author$project$Components$Input$input_(
						_Utils_update(
							$author$project$Components$Input$defaultOptions,
							{
								gU: 9,
								jI: $elm$core$Maybe$Just(
									A2(
										$elm$core$Basics$composeL,
										A2($elm$core$Basics$composeL, $author$project$Pages$Pos$Editor$Input, $author$project$Pages$Pos$Editor$PostalCode),
										$elm$core$String$filter($elm$core$Char$isDigit))),
								hh: 'CEP',
								di: $author$project$Utils$maskPostalCode(model.o0)
							})),
						$author$project$Components$Input$input_(
						_Utils_update(
							$author$project$Components$Input$defaultOptions,
							{
								gU: 100,
								jI: $elm$core$Maybe$Just(
									A2($elm$core$Basics$composeL, $author$project$Pages$Pos$Editor$Input, $author$project$Pages$Pos$Editor$Address)),
								hh: 'Endereço',
								di: model.ep
							})),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('inputs')
							]),
						_List_fromArray(
							[
								$author$project$Components$Input$input_(
								_Utils_update(
									$author$project$Components$Input$defaultOptions,
									{
										gU: 6,
										jI: $elm$core$Maybe$Just(
											A2($elm$core$Basics$composeL, $author$project$Pages$Pos$Editor$Input, $author$project$Pages$Pos$Editor$AddressNumber)),
										hh: 'Número',
										di: model.bL
									})),
								$author$project$Components$Input$input_(
								_Utils_update(
									$author$project$Components$Input$defaultOptions,
									{
										gU: 20,
										jI: $elm$core$Maybe$Just(
											A2($elm$core$Basics$composeL, $author$project$Pages$Pos$Editor$Input, $author$project$Pages$Pos$Editor$AddressComplement)),
										hh: 'Complemento',
										di: model.lk
									}))
							])),
						$author$project$Components$Input$input_(
						_Utils_update(
							$author$project$Components$Input$defaultOptions,
							{
								gU: 50,
								jI: $elm$core$Maybe$Just(
									A2($elm$core$Basics$composeL, $author$project$Pages$Pos$Editor$Input, $author$project$Pages$Pos$Editor$Neighborhood)),
								hh: 'Bairro',
								di: model.om
							})),
						$author$project$Components$Input$input_(
						_Utils_update(
							$author$project$Components$Input$defaultOptions,
							{
								gU: 50,
								jI: $elm$core$Maybe$Just(
									A2($elm$core$Basics$composeL, $author$project$Pages$Pos$Editor$Input, $author$project$Pages$Pos$Editor$City)),
								hh: 'Cidade',
								di: model.lW
							})),
						A2(
						$elm$html$Html$select,
						_List_fromArray(
							[
								$elm$html$Html$Events$onInput(
								A2($elm$core$Basics$composeL, $author$project$Pages$Pos$Editor$Input, $author$project$Pages$Pos$Editor$AddressState))
							]),
						A2(
							$elm$core$List$map,
							function (_v1) {
								var sigla = _v1.a;
								var estado = _v1.b;
								return A2(
									$elm$html$Html$option,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$value(sigla),
											$elm$html$Html$Attributes$selected(
											_Utils_eq(model.bd, sigla))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(estado)
										]));
							},
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2('', 'Estado'),
								$author$project$Utils$brazilian_states))),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex gap-4 items-center')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h2,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('m-0')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Classes')
											])),
										(!_Utils_eq(model.j, $elm$core$Maybe$Nothing)) ? A2(
										$elm$core$Maybe$withDefault,
										A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-white text-base')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Sem data de vencimento')
												])),
										A2(
											$elm$core$Maybe$map,
											function (date) {
												var expiration = $author$project$Utils$formatDate(date);
												return A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('text-white text-base')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Validade: ' + expiration)
														]));
											},
											A2(
												$elm$core$Maybe$andThen,
												function ($) {
													return $.nb;
												},
												model.aQ))) : $elm$html$Html$text('')
									])),
								(!_Utils_eq(model.j, $elm$core$Maybe$Nothing)) ? A4($author$project$Components$Patterns$Button$icon, $author$project$Pages$Pos$Editor$OpenClassEditModal, 'icon-edit-config flex items-center m-0', 'edit_square', 'Editar classes') : $elm$html$Html$text('')
							])),
						A2(
						$elm$core$Maybe$withDefault,
						$author$project$Pages$Pos$Editor$viewCreateClasses(model),
						A2(
							$elm$core$Maybe$map,
							function (_v2) {
								return $author$project$Pages$Pos$Editor$viewClasses(model);
							},
							model.j)),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('action-system green-btn'),
								$elm$html$Html$Events$onClick($author$project$Pages$Pos$Editor$NextStep)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Continuar')
							]))
					]))
			]);
	});
var $author$project$Pages$Pos$Editor$ClickedCloseModal = {$: 18};
var $author$project$Pages$Pos$Editor$ConfirmClassesEdit = {$: 21};
var $author$project$Pages$Pos$Editor$InputtedDueDate = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$Pos$Editor$viewEditClasses = F3(
	function (modal, formStatus, m) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('editor-classes w-full ')
				]),
			function () {
				var _v0 = m.dv;
				switch (_v0.$) {
					case 3:
						var classes = _v0.a;
						return _Utils_ap(
							A2(
								$elm$core$List$map,
								function (class_) {
									var maybeType = A2($elm$core$Dict$get, class_.dM, modal.dv);
									var isChecked = !_Utils_eq(maybeType, $elm$core$Maybe$Nothing);
									return A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('mb-2')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$label,
												_List_fromArray(
													[
														A2($elm$html$Html$Attributes$style, 'cursor', 'pointer'),
														$elm$html$Html$Attributes$class('text-black flex mt-0')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$input,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('w-4 h-4 mt-0 items-center'),
																$elm$html$Html$Attributes$type_('checkbox'),
																$elm$html$Html$Attributes$checked(isChecked),
																$elm$html$Html$Events$onCheck(
																$author$project$Pages$Pos$Editor$SelectClass(class_.dM))
															]),
														_List_Nil),
														$elm$html$Html$text(class_.c3)
													])),
												function () {
												if (!maybeType.$) {
													var maybeType_ = maybeType.a;
													return A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('editor-class-types mt-2')
															]),
														A2(
															$elm$core$List$map,
															function (tp) {
																return A2(
																	$elm$html$Html$label,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('text-black flex mt-0 relative ')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$input,
																			_List_fromArray(
																				[
																					$elm$html$Html$Attributes$class('w-4 h-4 mt-0 mb-4 left-auto relative after:content-[\'\']'),
																					$elm$html$Html$Attributes$type_('radio'),
																					$elm$html$Html$Attributes$value(tp.dM),
																					$elm$html$Html$Attributes$name('class-type-' + class_.dM),
																					$elm$html$Html$Attributes$id(
																					_Utils_ap(class_.dM, tp.dM)),
																					$elm$html$Html$Attributes$checked(
																					_Utils_eq(
																						$elm$core$Maybe$Just(tp.dM),
																						maybeType_)),
																					$elm$html$Html$Events$onInput(
																					$author$project$Pages$Pos$Editor$InputtedClassType(class_.dM))
																				]),
																			_List_Nil),
																			A2(
																			$elm$html$Html$label,
																			_List_fromArray(
																				[
																					$elm$html$Html$Attributes$for(
																					_Utils_ap(class_.dM, tp.dM)),
																					$elm$html$Html$Attributes$class('text-black m-0 pl-5')
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text(tp.c3)
																				]))
																		]));
															},
															class_.dh));
												} else {
													return $elm$html$Html$text('');
												}
											}()
											]));
								},
								classes),
							_List_fromArray(
								[
									$author$project$Components$Patterns$Forms$inputWithError(
									{
										ie: $elm$core$Maybe$Nothing,
										iH: formStatus === 2,
										iP: _List_Nil,
										nR: _List_fromArray(
											[
												$elm$html$Html$Attributes$max('2148-12-31')
											]),
										jl: $elm$core$Maybe$Just('Data de vencimento'),
										jn: _List_Nil,
										n9: $elm$core$Maybe$Just(10),
										c3: 'Campo para data de vencimento',
										jE: $elm$core$Maybe$Nothing,
										jF: $elm$core$Maybe$Nothing,
										jG: $elm$core$Maybe$Nothing,
										ov: $elm$core$Maybe$Nothing,
										jI: $elm$core$Maybe$Just($author$project$Pages$Pos$Editor$InputtedDueDate),
										hh: 'Insira a date de vencimento',
										kE: formStatus === 1,
										kY: 'date',
										k1: _List_fromArray(
											[
												_Utils_Tuple2(
												function (duesDate) {
													return $author$project$Pages$Pos$Editor$isInvalidDueDate(
														$elm$core$Maybe$Just(duesDate));
												},
												'Data limite de vencimento é 31/12/2148.'),
												_Utils_Tuple2($elm$core$String$isEmpty, 'Data de vencimento é obrigatório!')
											]),
										di: A2($elm$core$Maybe$withDefault, '', modal.am)
									}),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mt-5 flex gap-4')
										]),
									_List_fromArray(
										[
											A4($author$project$Components$Patterns$Button$text, _List_Nil, 'w-full', 'Confirmar edição', $author$project$Pages$Pos$Editor$ConfirmClassesEdit),
											A4($author$project$Components$Patterns$Button$text, _List_Nil, 'red-btn w-full', 'Fechar', $author$project$Pages$Pos$Editor$ClickedCloseModal)
										]))
								]));
					case 1:
						return _List_fromArray(
							[$author$project$Components$View$loading]);
					default:
						return _List_Nil;
				}
			}());
	});
var $author$project$Pages$Pos$Editor$ConfirmPhoneEdit = {$: 22};
var $author$project$Pages$Pos$Editor$InputtedPhone = function (a) {
	return {$: 20, a: a};
};
var $author$project$Pages$Pos$Editor$viewEditPhone = F3(
	function (modal, formStatus, m) {
		var isSubmitting = formStatus === 2;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('editor-classes w-full ')
				]),
			_List_fromArray(
				[
					$author$project$Components$Patterns$Forms$inputWithError(
					{
						ie: $elm$core$Maybe$Nothing,
						iH: isSubmitting,
						iP: _List_Nil,
						nR: _List_Nil,
						jl: $elm$core$Maybe$Just('Celular'),
						jn: _List_Nil,
						n9: $elm$core$Maybe$Just(16),
						c3: 'Campo para número do celular',
						jE: $elm$core$Maybe$Nothing,
						jF: $elm$core$Maybe$Nothing,
						jG: $elm$core$Maybe$Nothing,
						ov: $elm$core$Maybe$Nothing,
						jI: $elm$core$Maybe$Just($author$project$Pages$Pos$Editor$InputtedPhone),
						hh: 'Insira o número do celular',
						kE: formStatus === 1,
						kY: 'text',
						k1: _List_fromArray(
							[
								_Utils_Tuple2($author$project$Pages$Pos$Editor$isInvalidNewPhone, 'Número está incorreto')
							]),
						di: $author$project$Utils$maskPhoneDDD(modal.b9)
					}),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mt-5 flex gap-4')
						]),
					_List_fromArray(
						[
							A6($author$project$Components$Patterns$Button$textWithLoading, _List_Nil, isSubmitting, isSubmitting, 'w-full', 'Confirmar edição', $author$project$Pages$Pos$Editor$ConfirmPhoneEdit),
							A4($author$project$Components$Patterns$Button$text, _List_Nil, 'red-btn w-full', 'Fechar', $author$project$Pages$Pos$Editor$ClickedCloseModal)
						]))
				]));
	});
var $author$project$Pages$Pos$Editor$viewModal = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$html$Html$text(''),
		A2(
			$elm$core$Maybe$map,
			function (modal) {
				var contentModal = F4(
					function (title, body, footer, attrContent) {
						return $author$project$Components$Patterns$Modal$simple(
							{hY: attrContent, ii: 'modal-cadastro-usuario-sistema gap-4 rounded-lg ', il: 'truncate ', ip: $author$project$Pages$Pos$Editor$ClickedCloseModal, fD: title, k4: body, k5: footer});
					});
				if (!modal.$) {
					var modal_ = modal.a;
					var _v1 = modal_.a6;
					switch (_v1.$) {
						case 0:
							var formStatus = _v1.a;
							return A4(
								contentModal,
								'Editar classes',
								A3($author$project$Pages$Pos$Editor$viewEditClasses, modal_, formStatus, model),
								$elm$html$Html$text(''),
								$elm$core$Maybe$Just(
									A2($elm$html$Html$Attributes$style, 'padding', '2rem')));
						case 1:
							return A4(
								contentModal,
								'Editar classes',
								A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('info-emitir-cartao m-0')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Pegue o cartão correspondente a '),
													A2(
													$elm$html$Html$strong,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('info-tipo-usuario')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(modal_.cH.kw)
														])),
													$elm$html$Html$text(' e aproxime do leitor para validação')
												])),
											A2(
											$elm$html$Html$h4,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('processo-info'),
													$elm$html$Html$Attributes$class('processando-info')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Aguardando Aproximação...')
												]))
										])),
								$elm$html$Html$text(''),
								$elm$core$Maybe$Just(
									A2($elm$html$Html$Attributes$style, 'padding', '2rem')));
						case 2:
							var title = _v1.a;
							return A4(
								contentModal,
								'Editar classes',
								A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('formatar-container')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h4,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('processo-info processando-info')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(title)
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('progress-bar-container')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('progress-bar')
														]),
													_List_Nil)
												]))
										])),
								$elm$html$Html$text(''),
								$elm$core$Maybe$Just(
									A2($elm$html$Html$Attributes$style, 'padding', '2rem')));
						default:
							return A4(
								contentModal,
								'Editar classes',
								A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('processo-info'),
											$elm$html$Html$Attributes$class('confirma-info')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Cartão Editado!')
										])),
								$elm$html$Html$text(''),
								$elm$core$Maybe$Just(
									A2($elm$html$Html$Attributes$style, 'padding', '2rem')));
					}
				} else {
					var m = modal.a;
					return A4(
						contentModal,
						'Editar celular',
						A3($author$project$Pages$Pos$Editor$viewEditPhone, m, m.kK, model),
						$elm$html$Html$text(''),
						$elm$core$Maybe$Just(
							A2($elm$html$Html$Attributes$style, 'min-height', 'auto')));
				}
			},
			model.aY));
};
var $author$project$Pages$Pos$Editor$ClickedCancelCamera = {$: 15};
var $author$project$Pages$Pos$Editor$ClickedTakePhoto = {$: 13};
var $author$project$Pages$Pos$Editor$ClickedUseCamera = {$: 12};
var $author$project$Pages$Pos$Editor$PickImage = {$: 8};
var $elm$html$Html$Attributes$autoplay = $elm$html$Html$Attributes$boolProperty('autoplay');
var $elm$html$Html$Attributes$height = function (n) {
	return A2(
		_VirtualDom_attribute,
		'height',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$video = _VirtualDom_node('video');
var $elm$html$Html$Attributes$width = function (n) {
	return A2(
		_VirtualDom_attribute,
		'width',
		$elm$core$String$fromInt(n));
};
var $author$project$Pages$Pos$Editor$viewPhoto = F3(
	function (photo, model, config) {
		var viewPreviewPhoto = function (url) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'width', '300px'),
						A2($elm$html$Html$Attributes$style, 'height', '210px'),
						A2($elm$html$Html$Attributes$style, 'background-image', 'url(\'' + (url + '\')')),
						A2($elm$html$Html$Attributes$style, 'background-position', 'center'),
						A2($elm$html$Html$Attributes$style, 'background-repeat', 'no-repeat'),
						A2($elm$html$Html$Attributes$style, 'background-size', 'contain'),
						$elm$html$Html$Events$onClick($author$project$Pages$Pos$Editor$PickImage)
					]),
				_List_Nil);
		};
		var continueButton = A2($author$project$Pages$Pos$Editor$canSubmitPhoto, photo, model) ? A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('action-system green-btn'),
					$elm$html$Html$Events$onClick($author$project$Pages$Pos$Editor$NextStep)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Continuar')
				])) : $elm$html$Html$text('');
		switch (photo.$) {
			case 0:
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Anexar ' + config.fD)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('add-usuario-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$core$Maybe$withDefault,
								A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$alt('Anexar ' + config.fD),
											$elm$html$Html$Attributes$src(config.fh),
											$elm$html$Html$Events$onClick($author$project$Pages$Pos$Editor$PickImage)
										]),
									_List_Nil),
								A2($elm$core$Maybe$map, viewPreviewPhoto, config.eC))
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('action-system white-btn'),
								$elm$html$Html$Events$onClick($author$project$Pages$Pos$Editor$ClickedUseCamera)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Tirar foto')
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('action-system white-btn'),
								$elm$html$Html$Events$onClick($author$project$Pages$Pos$Editor$PickImage)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Anexar foto')
							])),
						continueButton
					]);
			case 1:
				var preview = photo.a.cg;
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Anexar ' + config.fD)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('add-usuario-container')
							]),
						_List_fromArray(
							[
								viewPreviewPhoto(preview)
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('action-system white-btn'),
								$elm$html$Html$Events$onClick($author$project$Pages$Pos$Editor$ClickedUseCamera)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Tirar foto')
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('action-system white-btn'),
								$elm$html$Html$Events$onClick($author$project$Pages$Pos$Editor$PickImage)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Anexar outra foto')
							])),
						continueButton
					]);
			case 2:
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Tirar ' + config.fD)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('add-usuario-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$video,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$id($author$project$Pages$Pos$Editor$videoElemId),
										$elm$html$Html$Attributes$width(config.dr),
										$elm$html$Html$Attributes$height(config.dq),
										$elm$html$Html$Attributes$autoplay(true),
										A2($elm$html$Html$Attributes$style, 'object-fit', 'cover'),
										$elm$html$Html$Events$onClick($author$project$Pages$Pos$Editor$ClickedTakePhoto)
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('action-system white-btn'),
								$elm$html$Html$Events$onClick($author$project$Pages$Pos$Editor$ClickedTakePhoto)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Tirar foto')
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('action-system white-btn'),
								$elm$html$Html$Events$onClick($author$project$Pages$Pos$Editor$ClickedCancelCamera)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancelar')
							]))
					]);
			default:
				var preview = photo.a.cg;
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Tirar ' + config.fD)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('add-usuario-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$img,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$src(preview),
										$elm$html$Html$Events$onClick($author$project$Pages$Pos$Editor$ClickedUseCamera),
										$elm$html$Html$Attributes$width(config.dr),
										$elm$html$Html$Attributes$height(config.dq)
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('action-system white-btn'),
								$elm$html$Html$Events$onClick($author$project$Pages$Pos$Editor$ClickedUseCamera)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Tirar outra foto')
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('action-system white-btn'),
								$elm$html$Html$Events$onClick($author$project$Pages$Pos$Editor$PickImage)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Anexar foto')
							])),
						continueButton
					]);
		}
	});
var $author$project$Pages$Pos$Editor$view = F3(
	function (shared, user, model) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A3(
					$author$project$Components$View$cashierHeader,
					$elm$core$Maybe$Just(user),
					((!(!model.hG)) && (!$krisajenkins$remotedata$RemoteData$isLoading(model.q))) ? _List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Components$View$Button($author$project$Pages$Pos$Editor$PreviousStep),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('voltar-ico')
										]),
									_List_Nil),
									$elm$html$Html$text('Voltar')
								]))
						]) : _List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = model.j;
							if (_v0.$ === 1) {
								return _Utils_Tuple2(
									$author$project$Components$View$InternalLink($author$project$Route$Guiche),
									_List_fromArray(
										[
											$elm$html$Html$text('Cancelar Cadastro'),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('fechar-ico')
												]),
											_List_Nil)
										]));
							} else {
								var passenger = _v0.a;
								return _Utils_Tuple2(
									$author$project$Components$View$InternalLink(
										A2($author$project$Route$Passenger, passenger.oe.dM, 0)),
									_List_fromArray(
										[
											$elm$html$Html$text('Cancelar Edição'),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('fechar-ico')
												]),
											_List_Nil)
										]));
							}
						}()
						])),
					A2(
					$author$project$Pages$Pos$Editor$container,
					model,
					function () {
						if ($krisajenkins$remotedata$RemoteData$isLoading(model.q)) {
							return _List_fromArray(
								[$author$project$Components$View$loading]);
						} else {
							var _v1 = model.hG;
							switch (_v1) {
								case 0:
									return A2($author$project$Pages$Pos$Editor$viewForm, model, shared.kS);
								case 1:
									return A3(
										$author$project$Pages$Pos$Editor$viewPhoto,
										model.bn,
										model,
										{
											dq: 240,
											dr: 180,
											eC: A2(
												$elm$core$Maybe$andThen,
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.mP;
													},
													A2(
														$elm$core$Basics$composeR,
														$elm$core$List$filter(
															function ($) {
																return $.nW;
															}),
														A2(
															$elm$core$Basics$composeR,
															$elm$core$List$head,
															$elm$core$Maybe$map(
																function ($) {
																	return $.qt;
																})))),
												model.j),
											fh: '/images/anexar-foto-usuario-ico.svg',
											fD: 'Foto do Usuário'
										});
								case 2:
									return A3(
										$author$project$Pages$Pos$Editor$viewPhoto,
										model.bj,
										model,
										{
											dq: 250,
											dr: 425,
											eC: A2(
												$elm$core$Maybe$andThen,
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.mP;
													},
													A2(
														$elm$core$Basics$composeR,
														$elm$core$List$filter(
															A2(
																$elm$core$Basics$composeR,
																function ($) {
																	return $.nW;
																},
																$elm$core$Basics$not)),
														A2(
															$elm$core$Basics$composeR,
															$elm$core$List$head,
															$elm$core$Maybe$map(
																function ($) {
																	return $.qt;
																})))),
												model.j),
											fh: '/images/anexar-documentos-ico.svg',
											fD: 'Foto da frente do Documento'
										});
								default:
									return A3(
										$author$project$Pages$Pos$Editor$viewPhoto,
										model.bi,
										model,
										{
											dq: 250,
											dr: 425,
											eC: A2(
												$elm$core$Maybe$andThen,
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.mP;
													},
													A2(
														$elm$core$Basics$composeR,
														$elm$core$List$filter(
															A2(
																$elm$core$Basics$composeR,
																function ($) {
																	return $.nW;
																},
																$elm$core$Basics$not)),
														A2(
															$elm$core$Basics$composeR,
															$elm$core$List$drop(1),
															A2(
																$elm$core$Basics$composeR,
																$elm$core$List$head,
																$elm$core$Maybe$map(
																	function ($) {
																		return $.qt;
																	}))))),
												model.j),
											fh: '/images/anexar-documentos-ico.svg',
											fD: 'Foto das costas do Documento'
										});
							}
						}
					}()),
					function () {
					var _v2 = model.j;
					if (_v2.$ === 1) {
						return $elm$html$Html$text('');
					} else {
						var passenger = _v2.a;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
									A2($elm$html$Html$Attributes$style, 'pointer-events', 'none'),
									A2($elm$html$Html$Attributes$style, 'opacity', '0'),
									A2($elm$html$Html$Attributes$style, 'transform', 'scale(0)')
								]),
							A2(
								$elm$core$List$map,
								function (d) {
									return A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												A2($elm$html$Html$Attributes$style, 'width', '300px'),
												A2($elm$html$Html$Attributes$style, 'height', '210px'),
												A2($elm$html$Html$Attributes$style, 'background-image', 'url(\'' + (d.qt + '\')'))
											]),
										_List_Nil);
								},
								passenger.mP));
					}
				}(),
					$author$project$Pages$Pos$Editor$viewModal(model)
				]));
	});
var $author$project$Pages$Pos$Edit$view = F3(
	function (shared, user, model) {
		return _Utils_Tuple2(
			'Guichê - Editar cliente',
			function () {
				if (!model.$) {
					return $author$project$Components$View$loading;
				} else {
					var editorModel = model.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$Pos$Edit$GotEditorMsg,
						A3($author$project$Pages$Pos$Editor$view, shared, user, editorModel));
				}
			}());
	});
var $author$project$Pages$Pos$Guiche$Logout = {$: 2};
var $author$project$Components$View$actionIcon = function (actionIcon_) {
	var _v0 = actionIcon_.ji ? $author$project$Components$View$actionElement(actionIcon_.hV) : _Utils_Tuple2($elm$html$Html$div, _List_Nil);
	var elem = _v0.a;
	var actionAttrs = _v0.b;
	return A2(
		elem,
		A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$class('actions-item'),
			actionAttrs),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('action'),
						$elm$html$Html$Attributes$class(actionIcon_.ih)
					]),
				_List_Nil),
				A2(
				$elm$html$Html$h3,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(actionIcon_.fD)
					]))
			]));
};
var $author$project$Components$View$actionIcons = F2(
	function (maybeClass, actionIcons_) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					A2($elm$core$Maybe$withDefault, 'actions-container', maybeClass)),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'two-columns',
							!(!A2(
								$elm$core$Basics$modBy,
								3,
								$elm$core$List$length(actionIcons_))))
						]))
				]),
			A2($elm$core$List$map, $author$project$Components$View$actionIcon, actionIcons_));
	});
var $author$project$Pages$Pos$Guiche$ToggleCashier = {$: 3};
var $author$project$Data$User$canEnterInCashierAccountabilityArea = function (user) {
	return $author$project$Data$User$canEnterInAdminArea(user) || A2($elm$core$List$member, $author$project$Data$Permission$Counting, user.oU);
};
var $author$project$Data$User$canEnterInFindCustomer = function (user) {
	return $author$project$Data$User$canEnterInAdminArea(user) || (A2($elm$core$List$member, $author$project$Data$Permission$SalesTicketWindow, user.oU) || A2($elm$core$List$member, $author$project$Data$Permission$SecondCardOperator, user.oU));
};
var $author$project$Data$User$canEnterInRegisterCustomer = function (user) {
	return $author$project$Data$User$canEnterInAdminArea(user) || A2($elm$core$List$member, $author$project$Data$Permission$IssuingTicketWindow, user.oU);
};
var $author$project$Pages$Pos$Guiche$actionIcons = F2(
	function (isCashierOpen, user) {
		return _List_fromArray(
			[
				{
				hV: $author$project$Components$View$InternalLink($author$project$Route$PosRegister),
				ih: 'cadastrar-usuario',
				ji: _Utils_eq(
					isCashierOpen,
					$elm$core$Maybe$Just(true)) && $author$project$Data$User$canEnterInRegisterCustomer(user),
				fD: 'Cadastrar Cliente'
			},
				{
				hV: $author$project$Components$View$InternalLink(
					$author$project$Route$PosLocalize($elm$core$Maybe$Nothing)),
				ih: 'localizar-cliente',
				ji: _Utils_eq(
					isCashierOpen,
					$elm$core$Maybe$Just(true)) && $author$project$Data$User$canEnterInFindCustomer(user),
				fD: 'Localizar Cliente'
			},
				{
				hV: $author$project$Components$View$Button($author$project$Pages$Pos$Guiche$ToggleCashier),
				ih: 'fechamento-de-caixa',
				ji: !_Utils_eq(isCashierOpen, $elm$core$Maybe$Nothing),
				fD: _Utils_eq(
					isCashierOpen,
					$elm$core$Maybe$Just(true)) ? 'Fechamento de Caixa' : 'Abrir Caixa'
			},
				{
				hV: $author$project$Components$View$InternalLink(
					$author$project$Route$PosGarage($author$project$Services$Models$initQueriesPosGarage)),
				ih: 'arrecadacao',
				ji: _Utils_eq(
					isCashierOpen,
					$elm$core$Maybe$Just(true)) && $author$project$Data$User$canEnterInCashierAccountabilityArea(user),
				fD: 'Arrecadação'
			}
			]);
	});
var $author$project$Pages$Pos$Guiche$viewPage = F2(
	function (model, user) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('min-height-100')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Components$View$cashierHeader,
					$elm$core$Maybe$Just(user),
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Components$View$InternalLink($author$project$Route$WelcomeBack),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('voltar-ico')
										]),
									_List_Nil),
									$elm$html$Html$text('Painel')
								]))
						]),
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Components$View$Button($author$project$Pages$Pos$Guiche$Logout),
							_List_fromArray(
								[
									$elm$html$Html$text('Logout'),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fechar-ico')
										]),
									_List_Nil)
								]))
						])),
					A2(
					$elm$html$Html$main_,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h1,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Sistema Guichê')
										])),
									A2(
									$author$project$Components$View$actionIcons,
									$elm$core$Maybe$Nothing,
									A2($author$project$Pages$Pos$Guiche$actionIcons, model.dO, user))
								]))
						]))
				]));
	});
var $author$project$Pages$Pos$Guiche$view = F2(
	function (model, user) {
		return _Utils_Tuple2(
			'Guichê',
			A2($author$project$Pages$Pos$Guiche$viewPage, model, user));
	});
var $author$project$Pages$Pos$Localize$viewHeader = function (user) {
	return A3(
		$author$project$Components$View$cashierHeader,
		$elm$core$Maybe$Just(user),
		_List_Nil,
		_List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Components$View$InternalLink($author$project$Route$Guiche),
				_List_fromArray(
					[
						$elm$html$Html$text('Cancelar'),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fechar-ico')
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$Pages$Pos$Localize$EnteredSearch = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Pos$Localize$SubmittedSearch = {$: 2};
var $elm$virtual_dom$VirtualDom$lazy2 = _VirtualDom_lazy2;
var $elm$html$Html$Lazy$lazy2 = $elm$virtual_dom$VirtualDom$lazy2;
var $elm$html$Html$Attributes$readonly = $elm$html$Html$Attributes$boolProperty('readOnly');
var $elm$html$Html$h5 = _VirtualDom_node('h5');
var $author$project$Components$View$passengerRow = function (passenger) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('exibicao-usuario')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$img,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$width(128),
								$elm$html$Html$Attributes$height(134),
								$elm$html$Html$Attributes$src(passenger.nM),
								$elm$html$Html$Attributes$class('img-profile-placeholder')
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('usuario-dados')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h5,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(passenger.c3)
							])),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('cpf')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('CPF: '),
								A2(
								$elm$html$Html$strong,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'padding-left', '4px')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Utils$maskCPF(passenger.iI))
									]))
							])),
						($elm$core$String$length(passenger.jX) >= 8) ? A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('telefone')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Telefone: '),
								A2(
								$elm$html$Html$strong,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'padding-left', '4px')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Utils$maskPhoneDDD(passenger.jX))
									]))
							])) : A2($elm$html$Html$p, _List_Nil, _List_Nil),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('marine-button'),
								A2($elm$html$Html$Attributes$style, 'width', '163px'),
								A2($elm$html$Html$Attributes$style, 'flex-grow', '0'),
								$elm$html$Html$Attributes$href(
								$author$project$Route$toString(
									A2($author$project$Route$Passenger, passenger.dM, 0)))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Selecionar')
							]))
					]))
			]));
};
var $author$project$Pages$Pos$Localize$viewPassengers = F2(
	function (passengers, currentSearch) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(
								$elm$core$List$length(passengers)) + (' ' + (A3(
								$author$project$Utils$pluralize,
								$elm$core$List$length(passengers),
								'resultado',
								'resultados') + (' para ' + currentSearch))))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					A2($elm$core$List$map, $author$project$Components$View$passengerRow, passengers))
				]));
	});
var $author$project$Pages$Pos$Localize$viewSearch = function (model) {
	var isSearchDisabled = $elm$core$String$length(model.a3) < 3;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h1,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Localizar Cliente')
					])),
				A2(
				$elm$html$Html$form,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('inner-container inner-center'),
						$elm$html$Html$Events$onSubmit($author$project$Pages$Pos$Localize$SubmittedSearch)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('title-left')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Selecionar Usuário')
							])),
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('bg-busca'),
										$elm$html$Html$Attributes$id($author$project$Pages$Pos$Localize$searchPassengerInputId),
										$elm$html$Html$Attributes$placeholder('Pesquisar por Nome, CPF ou Telefone'),
										$elm$html$Html$Attributes$type_('text'),
										$elm$html$Html$Events$onInput($author$project$Pages$Pos$Localize$EnteredSearch),
										$elm$html$Html$Attributes$value(model.a3),
										$elm$html$Html$Attributes$readonly(
										$krisajenkins$remotedata$RemoteData$isLoading(model.a0))
									]),
								_List_Nil)
							])),
						$krisajenkins$remotedata$RemoteData$isLoading(model.a0) ? $elm$html$Html$text('') : A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('action-system green-btn'),
								$elm$html$Html$Attributes$disabled(isSearchDisabled),
								$elm$html$Html$Attributes$type_('submit')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Pesquisar')
							])),
						function () {
						var _v0 = model.a0;
						switch (_v0.$) {
							case 3:
								var passengers = _v0.a;
								return A3($elm$html$Html$Lazy$lazy2, $author$project$Pages$Pos$Localize$viewPassengers, passengers, model.dB);
							case 1:
								return $author$project$Components$View$loading;
							case 2:
								return $elm$html$Html$text('');
							default:
								return $elm$html$Html$text('');
						}
					}()
					]))
			]));
};
var $author$project$Pages$Pos$Localize$viewPage = F2(
	function (user, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('min-height-100')
				]),
			_List_fromArray(
				[
					$author$project$Pages$Pos$Localize$viewHeader(user),
					A2(
					$elm$html$Html$main_,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Pos$Localize$viewSearch(model)
						]))
				]));
	});
var $author$project$Pages$Pos$Localize$view = F2(
	function (user, model) {
		return _Utils_Tuple2(
			'Guichê - Localizar cliente',
			A2($author$project$Pages$Pos$Localize$viewPage, user, model));
	});
var $author$project$Data$Passenger$do_last_card_have_serial = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.f0;
	},
	$elm$core$List$any(
		function (card) {
			return (!card.qE) && (card.kw !== '');
		}));
var $author$project$Data$Passenger$has_virtual_card = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.f0;
	},
	$elm$core$List$any(
		function ($) {
			return $.qE;
		}));
var $author$project$Data$Passenger$is_card_without_serial = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.f0;
	},
	$elm$core$List$any(
		function (card) {
			return (!card.qE) && (card.kw === '');
		}));
var $author$project$Data$Passenger$is_last_card_with_block_or_unblock_request = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.f0;
	},
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$head,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map(
				function (card) {
					return (!card.qE) && ((card.h7 === 3) || (card.h7 === 2));
				}),
			$elm$core$Maybe$withDefault(false))));
var $author$project$Data$Passenger$is_last_card_with_serial_and_charges = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.f0;
	},
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$head,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map(
				function (card) {
					return (!card.qE) && ((card.kw !== '') && ($elm$core$List$length(card.j8) > 0));
				}),
			$elm$core$Maybe$withDefault(false))));
var $author$project$Pages$Pos$Passenger$actionIcons = F3(
	function (isCashierOpen, passenger, user) {
		return _List_fromArray(
			[
				{
				hV: $author$project$Components$View$InternalLink(
					A2($author$project$Route$Passenger, passenger.dM, 4)),
				ih: 'emitir-cartao',
				ji: _Utils_eq(
					isCashierOpen,
					$elm$core$Maybe$Just(true)) && ($author$project$Data$Passenger$is_card_without_serial(passenger) && ($author$project$Data$User$canEnterInAdminArea(user) || A2($elm$core$List$member, $author$project$Data$Permission$SalesTicketWindow, user.oU))),
				fD: 'Emitir Cartão'
			},
				{
				hV: $author$project$Components$View$InternalLink(
					A2($author$project$Route$Passenger, passenger.dM, 1)),
				ih: 'vender-passagem',
				ji: _Utils_eq(
					isCashierOpen,
					$elm$core$Maybe$Just(true)) && (($author$project$Data$Passenger$do_last_card_have_serial(passenger) || $author$project$Data$Passenger$has_virtual_card(passenger)) && ($author$project$Data$User$canEnterInAdminArea(user) || A2($elm$core$List$member, $author$project$Data$Permission$SalesTicketWindow, user.oU))),
				fD: 'Vender Passagem'
			},
				{
				hV: $author$project$Components$View$InternalLink(
					A2($author$project$Route$Passenger, passenger.dM, 3)),
				ih: 'aplicar-carga',
				ji: _Utils_eq(
					isCashierOpen,
					$elm$core$Maybe$Just(true)) && (($author$project$Data$Passenger$is_last_card_with_serial_and_charges(passenger) || $author$project$Data$Passenger$is_last_card_with_block_or_unblock_request(passenger)) && ($author$project$Data$User$canEnterInAdminArea(user) || A2($elm$core$List$member, $author$project$Data$Permission$SalesTicketWindow, user.oU))),
				fD: 'Aplicar Carga'
			},
				{
				hV: $author$project$Components$View$InternalLink(
					A2($author$project$Route$Passenger, passenger.dM, 5)),
				ih: 'emitir-cartao',
				ji: _Utils_eq(
					isCashierOpen,
					$elm$core$Maybe$Just(true)) && ($author$project$Data$Passenger$do_last_card_have_serial(passenger) && ($author$project$Data$User$canEnterInAdminArea(user) || A2($elm$core$List$member, $author$project$Data$Permission$SalesTicketWindow, user.oU))),
				fD: 'Emitir 2a via Cartão'
			},
				{
				hV: $author$project$Components$View$InternalLink(
					A2($author$project$Route$Passenger, passenger.dM, 7)),
				ih: 'lock-unlock-scard',
				ji: _Utils_eq(
					isCashierOpen,
					$elm$core$Maybe$Just(true)) && ($author$project$Data$User$canEnterInAdminArea(user) || A2($elm$core$List$member, $author$project$Data$Permission$SalesTicketWindow, user.oU)),
				fD: 'Bloqueio/Desbloqueio'
			},
				{
				hV: $author$project$Components$View$InternalLink(
					A2($author$project$Route$Passenger, passenger.dM, 6)),
				ih: 'cadastrar-beneficiario',
				ji: _Utils_eq(
					isCashierOpen,
					$elm$core$Maybe$Just(true)) && ($author$project$Data$Passenger$has_virtual_card(passenger) && ($author$project$Data$User$canEnterInAdminArea(user) || A2($elm$core$List$member, $author$project$Data$Permission$SalesTicketWindow, user.oU))),
				fD: 'Cadastrar Beneficiário'
			},
				{
				hV: $author$project$Components$View$InternalLink(
					A2($author$project$Route$Passenger, passenger.dM, 2)),
				ih: 'venda-avulsa',
				ji: _Utils_eq(
					isCashierOpen,
					$elm$core$Maybe$Just(true)) && (($author$project$Data$Passenger$do_last_card_have_serial(passenger) || $author$project$Data$Passenger$has_virtual_card(passenger)) && ($author$project$Data$User$canEnterInAdminArea(user) || A2($elm$core$List$member, $author$project$Data$Permission$SalesTicketWindow, user.oU))),
				fD: 'Venda avulsa'
			}
			]);
	});
var $author$project$Pages$Pos$Passenger$headerCancelButton = _Utils_Tuple2(
	$author$project$Components$View$InternalLink($author$project$Route$Guiche),
	_List_fromArray(
		[
			$elm$html$Html$text('Cancelar'),
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fechar-ico')
				]),
			_List_Nil)
		]));
var $author$project$Components$View$ExternalLink = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$View$mapAction = F2(
	function (toMsg, action) {
		switch (action.$) {
			case 0:
				var route = action.a;
				return $author$project$Components$View$InternalLink(route);
			case 1:
				var url = action.a;
				return $author$project$Components$View$ExternalLink(url);
			default:
				var msg = action.a;
				return $author$project$Components$View$Button(
					toMsg(msg));
		}
	});
var $author$project$Components$View$mapPassengerPage = F2(
	function (toMsg, page) {
		return {
			f7: page.f7,
			md: A2(
				$elm$core$List$map,
				$elm$html$Html$map(toMsg),
				page.md),
			gv: page.gv,
			gQ: A2(
				$elm$core$List$map,
				function (_v0) {
					var a = _v0.a;
					var b = _v0.b;
					return _Utils_Tuple2(
						A2($author$project$Components$View$mapAction, toMsg, a),
						A2(
							$elm$core$List$map,
							$elm$html$Html$map(toMsg),
							b));
				},
				page.gQ),
			aY: A2(
				$elm$core$Maybe$map,
				$elm$html$Html$map(toMsg),
				page.aY),
			hr: A2(
				$elm$core$List$map,
				function (_v1) {
					var a = _v1.a;
					var b = _v1.b;
					return _Utils_Tuple2(
						A2($author$project$Components$View$mapAction, toMsg, a),
						A2(
							$elm$core$List$map,
							$elm$html$Html$map(toMsg),
							b));
				},
				page.hr),
			fD: page.fD
		};
	});
var $author$project$Components$View$loadingWithText = function (text_) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('loading-container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('loading')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('loading-txt')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(text_)
					]))
			]));
};
var $author$project$Pages$Pos$Passenger$ApplyRefill$viewContent = F2(
	function (lModel, model) {
		switch (model.$) {
			case 0:
				return $elm$html$Html$text('');
			case 1:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'padding-top', '64px')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h2,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('title-left first-h2')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Aproxime o cartão na leitora')
										]))
								]))
						]));
			case 2:
				return $author$project$Components$View$loadingWithText('Verificando por requisições de bloqueio/desbloqueio');
			default:
				var sModel = model.a;
				var where_ = sModel.fA ? 'plugin' : 'server';
				var step = $elm$core$String$fromInt(
					sModel.hk - $elm$core$List$length(sModel.ci)) + ('/' + $elm$core$String$fromInt(sModel.hk));
				return $author$project$Components$View$loadingWithText('Aplicando carga - ' + (step + (' ' + where_)));
		}
	});
var $author$project$Pages$Pos$Passenger$ApplyRefill$view = F2(
	function (passenger, model) {
		return {
			f7: 'vender-passagem',
			md: _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('inner-center')
						]),
					_List_fromArray(
						[
							A2($author$project$Pages$Pos$Passenger$ApplyRefill$viewContent, passenger, model)
						]))
				]),
			gv: 'Aplicar carga',
			gQ: _List_Nil,
			aY: $elm$core$Maybe$Nothing,
			hr: _List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Components$View$InternalLink(
						A2($author$project$Route$Passenger, passenger.dM, 0)),
					_List_fromArray(
						[
							$elm$html$Html$text('Cancelar'),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fechar-ico')
								]),
							_List_Nil)
						]))
				]),
			fD: _List_fromArray(
				['Aplicar carga'])
		};
	});
var $author$project$Pages$Pos$Passenger$IssueCard$viewCantIssue = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('ja-possui-cartao-container')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('alerta-ico')
				]),
			_List_Nil),
			A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('info-ja-possui-cartao')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Atenção! Este usuário já possui cartão emitido, por favor selecione outro usuário')
				]))
		]));
var $author$project$Pages$Pos$Passenger$IssueCard$viewCardAlreadyIssued = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('ja-possui-cartao-container')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('alerta-ico')
				]),
			_List_Nil),
			A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('info-ja-possui-cartao')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Atenção! Não é possível emitir um cartão já emitido. Por favor, selecione um cartão sem número de serial.')
				]))
		]));
var $author$project$Pages$Pos$Passenger$IssueCard$GoPrintCard = {$: 3};
var $author$project$Pages$Pos$Passenger$IssueCard$viewModalIssuedCard = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('modal-overlay')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('modal-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('header-modal')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h3,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Emitir Cartão')
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('action-header'),
									$elm$html$Html$Events$onClick($author$project$Pages$Pos$Passenger$IssueCard$GoPrintCard)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fechar-ico')
										]),
									_List_Nil)
								]))
						])),
					A2(
					$elm$html$Html$h4,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('processo-info confirma-info')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Cartão Emitido com Sucesso!')
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('action-system green-btn'),
							$elm$html$Html$Events$onClick($author$project$Pages$Pos$Passenger$IssueCard$GoPrintCard)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Concluir')
						]))
				]))
		]));
var $author$project$Pages$Pos$Passenger$IssueCard$Back = {$: 1};
var $author$project$Pages$Pos$Passenger$IssueCard$viewModalIssuingCard = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('modal-overlay')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('modal-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('header-modal')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h3,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Emitir Cartão')
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('action-header'),
									$elm$html$Html$Events$onClick($author$project$Pages$Pos$Passenger$IssueCard$Back)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fechar-ico')
										]),
									_List_Nil)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('formatar-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('processo-info processando-info')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Formatando cartão...')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('progress-bar-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('progress-bar')
										]),
									_List_Nil)
								]))
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('action-system green-btn'),
							$elm$html$Html$Attributes$disabled(true)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Confirmar')
						]))
				]))
		]));
var $author$project$Pages$Pos$Passenger$IssueCard$ClickedPrint = {$: 8};
var $author$project$Pages$Pos$Passenger$IssueCard$GoPassenger = {$: 10};
var $author$project$Pages$Pos$Passenger$IssueCard$viewModalPrint = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal-overlay')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('modal-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('header-modal')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Imprimir Cartão')
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('action-header'),
										$elm$html$Html$Events$onClick($author$project$Pages$Pos$Passenger$IssueCard$Back)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('fechar-ico')
											]),
										_List_Nil)
									]))
							])),
						model.d3 ? A2(
						$elm$html$Html$h4,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('processo-info confirma-info')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cartão Impresso com Sucesso!')
							])) : $elm$html$Html$text(''),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('info-emitir-cartao imprimir-cartao')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								model.d3 ? 'Clique no avançar para seguir com a emissão.' : 'Coloque o cartão na impressora na posição correta e clique abaixo em imprimir')
							])),
						model.d3 ? A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('action-system green-btn'),
								$elm$html$Html$Events$onClick($author$project$Pages$Pos$Passenger$IssueCard$GoPassenger)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Avançar')
							])) : A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('action-system green-btn'),
								$elm$html$Html$Events$onClick($author$project$Pages$Pos$Passenger$IssueCard$ClickedPrint)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Imprimir')
							]))
					]))
			]));
};
var $author$project$Pages$Pos$Passenger$IssueCard$GoValidateCarAgain = {$: 7};
var $author$project$Pages$Pos$Passenger$IssueCard$viewModalValidate = F2(
	function (passenger, model) {
		var classesStr = A2(
			$elm$core$String$join,
			', ',
			A2(
				$elm$core$List$map,
				function ($) {
					return $.c3;
				},
				$author$project$Pages$Pos$Passenger$IssueCard$takeCardClasses(model.cH)));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('modal-overlay')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('modal-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('header-modal')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h3,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Validar Cartão')
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('action-header'),
											$elm$html$Html$Events$onClick($author$project$Pages$Pos$Passenger$IssueCard$Back)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('fechar-ico')
												]),
											_List_Nil)
										]))
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('info-emitir-cartao')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Pegue o cartão correspondente a'),
									A2(
									$elm$html$Html$strong,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('info-tipo-usuario')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(classesStr)
										])),
									$elm$html$Html$text('e aproxime do leitor para validação')
								])),
							model.ek ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('processo-info'),
									$elm$html$Html$Attributes$class('confirma-info')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cartão Validado!')
								])) : A2(
							$elm$html$Html$h4,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('processo-info'),
									$elm$html$Html$Attributes$class('processando-info')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Aguardando Aproximação...')
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('action-system green-btn'),
									$elm$html$Html$Events$onClick($author$project$Pages$Pos$Passenger$IssueCard$GoValidateCarAgain),
									$elm$html$Html$Attributes$disabled(!model.ek)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Avançar')
								]))
						]))
				]));
	});
var $author$project$Pages$Pos$Passenger$IssueCard$viewModalValidateAgain = function (_v0) {
	var loading = _v0.jr;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal-overlay')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('modal-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('header-modal')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Emitir Cartão')
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('action-header'),
										$elm$html$Html$Events$onClick($author$project$Pages$Pos$Passenger$IssueCard$Back)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('fechar-ico')
											]),
										_List_Nil)
									]))
							])),
						loading ? $author$project$Components$View$loading : A2(
						$elm$html$Html$h4,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('processo-info processando-info')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Aguardando Aproximação...')
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('action-system green-btn'),
								$elm$html$Html$Attributes$disabled(true)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Confirmar')
							]))
					]))
			]));
};
var $author$project$Pages$Pos$Passenger$IssueCard$ClickedValidateCard = {$: 5};
var $CurrySoftware$elm_datepicker$DatePicker$Blur = {$: 6};
var $CurrySoftware$elm_datepicker$DatePicker$Focus = {$: 5};
var $CurrySoftware$elm_datepicker$DatePicker$SubmitText = {$: 4};
var $CurrySoftware$elm_datepicker$DatePicker$Text = function (a) {
	return {$: 3, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$ChangeFocus = function (a) {
	return {$: 1, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$MouseDown = {$: 7};
var $CurrySoftware$elm_datepicker$DatePicker$MouseUp = {$: 8};
var $CurrySoftware$elm_datepicker$DatePicker$Date$changeYear = F2(
	function (current, newYear) {
		var _v0 = $elm$core$String$toInt(newYear);
		if (!_v0.$) {
			var year = _v0.a;
			return A3(
				$justinmimbs$date$Date$fromCalendarDate,
				year,
				$justinmimbs$date$Date$month(current),
				$justinmimbs$date$Date$day(current));
		} else {
			return current;
		}
	});
var $CurrySoftware$elm_datepicker$DatePicker$groupDates = function (dates) {
	var go = F4(
		function (i, xs, racc, acc) {
			go:
			while (true) {
				if (!xs.b) {
					return $elm$core$List$reverse(acc);
				} else {
					var x = xs.a;
					var xxs = xs.b;
					if (i === 6) {
						var $temp$i = 0,
							$temp$xs = xxs,
							$temp$racc = _List_Nil,
							$temp$acc = A2(
							$elm$core$List$cons,
							$elm$core$List$reverse(
								A2($elm$core$List$cons, x, racc)),
							acc);
						i = $temp$i;
						xs = $temp$xs;
						racc = $temp$racc;
						acc = $temp$acc;
						continue go;
					} else {
						var $temp$i = i + 1,
							$temp$xs = xxs,
							$temp$racc = A2($elm$core$List$cons, x, racc),
							$temp$acc = acc;
						i = $temp$i;
						xs = $temp$xs;
						racc = $temp$racc;
						acc = $temp$acc;
						continue go;
					}
				}
			}
		});
	return A4(go, 0, dates, _List_Nil, _List_Nil);
};
var $CurrySoftware$elm_datepicker$DatePicker$maybeOr = F2(
	function (lhs, rhs) {
		if (!rhs.$) {
			return rhs;
		} else {
			return lhs;
		}
	});
var $CurrySoftware$elm_datepicker$DatePicker$mkClass = F2(
	function (_v0, c) {
		var classNamespace = _v0.cJ;
		return $elm$html$Html$Attributes$class(
			_Utils_ap(classNamespace, c));
	});
var $justinmimbs$date$Date$Weeks = 2;
var $justinmimbs$date$Date$Years = 0;
var $justinmimbs$date$Date$intervalToUnits = function (interval) {
	switch (interval) {
		case 0:
			return _Utils_Tuple2(1, 0);
		case 1:
			return _Utils_Tuple2(3, 1);
		case 2:
			return _Utils_Tuple2(1, 1);
		case 11:
			return _Utils_Tuple2(1, 3);
		default:
			var week = interval;
			return _Utils_Tuple2(1, 2);
	}
};
var $justinmimbs$date$Date$ceiling = F2(
	function (interval, date) {
		var floored = A2($justinmimbs$date$Date$floor, interval, date);
		if (_Utils_eq(date, floored)) {
			return date;
		} else {
			var _v0 = $justinmimbs$date$Date$intervalToUnits(interval);
			var n = _v0.a;
			var unit = _v0.b;
			return A3($justinmimbs$date$Date$add, unit, n, floored);
		}
	});
var $justinmimbs$date$Date$rangeHelp = F5(
	function (unit, step, until, revList, current) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(current, until) < 0) {
				var _v0 = A3($justinmimbs$date$Date$add, unit, step, current);
				var next = _v0;
				var $temp$unit = unit,
					$temp$step = step,
					$temp$until = until,
					$temp$revList = A2($elm$core$List$cons, current, revList),
					$temp$current = next;
				unit = $temp$unit;
				step = $temp$step;
				until = $temp$until;
				revList = $temp$revList;
				current = $temp$current;
				continue rangeHelp;
			} else {
				return $elm$core$List$reverse(revList);
			}
		}
	});
var $justinmimbs$date$Date$range = F4(
	function (interval, step, _v0, _v1) {
		var start = _v0;
		var until = _v1;
		var _v2 = $justinmimbs$date$Date$intervalToUnits(interval);
		var n = _v2.a;
		var unit = _v2.b;
		var _v3 = A2($justinmimbs$date$Date$ceiling, interval, start);
		var first = _v3;
		return (_Utils_cmp(first, until) < 0) ? A5(
			$justinmimbs$date$Date$rangeHelp,
			unit,
			A2($elm$core$Basics$max, 1, step) * n,
			until,
			_List_Nil,
			first) : _List_Nil;
	});
var $CurrySoftware$elm_datepicker$DatePicker$Date$weekdayToInterval = function (weekday) {
	switch (weekday) {
		case 0:
			return 4;
		case 1:
			return 5;
		case 2:
			return 6;
		case 3:
			return 7;
		case 4:
			return 8;
		case 5:
			return 9;
		default:
			return 10;
	}
};
var $CurrySoftware$elm_datepicker$DatePicker$prepareDates = F2(
	function (date, firstDayOfWeek) {
		var weekdayAsInterval = $CurrySoftware$elm_datepicker$DatePicker$Date$weekdayToInterval(firstDayOfWeek);
		var start = A2(
			$justinmimbs$date$Date$floor,
			weekdayAsInterval,
			A3(
				$justinmimbs$date$Date$fromCalendarDate,
				$justinmimbs$date$Date$year(date),
				$justinmimbs$date$Date$month(date),
				1));
		var firstOfMonth = A3(
			$justinmimbs$date$Date$fromCalendarDate,
			$justinmimbs$date$Date$year(date),
			$justinmimbs$date$Date$month(date),
			1);
		var end = A2(
			$justinmimbs$date$Date$ceiling,
			weekdayAsInterval,
			A3($justinmimbs$date$Date$add, 1, 1, firstOfMonth));
		return {
			iA: A4($justinmimbs$date$Date$range, 11, 1, start, end),
			gd: date
		};
	});
var $CurrySoftware$elm_datepicker$DatePicker$Pick = function (a) {
	return {$: 2, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$mkClassList = F2(
	function (_v0, cs) {
		var classNamespace = _v0.cJ;
		return $elm$html$Html$Attributes$classList(
			A2(
				$elm$core$List$map,
				function (_v1) {
					var c = _v1.a;
					var b = _v1.b;
					return _Utils_Tuple2(
						_Utils_ap(classNamespace, c),
						b);
				},
				cs));
	});
var $CurrySoftware$elm_datepicker$DatePicker$viewDay = F5(
	function (settings, picked, isOtherMonth, isToday, d) {
		var disabled = settings.eU(d);
		var props = (!disabled) ? _List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				$CurrySoftware$elm_datepicker$DatePicker$Pick(d))
			]) : _List_Nil;
		var classList = $CurrySoftware$elm_datepicker$DatePicker$mkClassList(settings);
		return A2(
			$elm$html$Html$td,
			_Utils_ap(
				_List_fromArray(
					[
						classList(
						_List_fromArray(
							[
								_Utils_Tuple2('day', true),
								_Utils_Tuple2('disabled', disabled),
								_Utils_Tuple2(
								'picked',
								picked(d)),
								_Utils_Tuple2(
								'today',
								isToday(d)),
								_Utils_Tuple2(
								'other-month',
								isOtherMonth(d))
							]))
					]),
				props),
			_List_fromArray(
				[
					settings.f3(
					$elm$core$String$fromInt(
						$justinmimbs$date$Date$day(d)))
				]));
	});
var $CurrySoftware$elm_datepicker$DatePicker$Date$yearRange = F2(
	function (_v0, range) {
		var currentMonth = _v0.gd;
		var today = _v0.ef;
		switch (range.$) {
			case 1:
				var num = range.a;
				return A2(
					$elm$core$List$range,
					$justinmimbs$date$Date$year(currentMonth) - num,
					$justinmimbs$date$Date$year(currentMonth) + num);
			case 2:
				var start = range.a;
				var end = range.b;
				return A2($elm$core$List$range, start, end);
			case 3:
				var year_ = range.a;
				return A2(
					$elm$core$List$range,
					year_,
					$justinmimbs$date$Date$year(today));
			case 4:
				var year_ = range.a;
				return A2(
					$elm$core$List$range,
					$justinmimbs$date$Date$year(today),
					year_);
			default:
				return _List_Nil;
		}
	});
var $CurrySoftware$elm_datepicker$DatePicker$yearRangeActive = function (yearRange) {
	return !_Utils_eq(yearRange, $CurrySoftware$elm_datepicker$DatePicker$Date$Off);
};
var $CurrySoftware$elm_datepicker$DatePicker$datePicker = F3(
	function (pickedDate, settings, model) {
		var focused = model._;
		var today = model.ef;
		var picked = function (d) {
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function (pdate) {
						return _Utils_eq(
							$justinmimbs$date$Date$toRataDie(pdate),
							$justinmimbs$date$Date$toRataDie(d));
					},
					pickedDate));
		};
		var onChange = function (handler) {
			return A2(
				$elm$html$Html$Events$on,
				'change',
				A2($elm$json$Json$Decode$map, handler, $elm$html$Html$Events$targetValue));
		};
		var isToday = function (d) {
			return _Utils_eq(
				$justinmimbs$date$Date$toRataDie(d),
				$justinmimbs$date$Date$toRataDie(today));
		};
		var firstDayOffset = $justinmimbs$date$Date$weekdayToNumber(settings.eK) - 1;
		var dpClass = $CurrySoftware$elm_datepicker$DatePicker$mkClass(settings);
		var currentDate = A2(
			$elm$core$Maybe$withDefault,
			today,
			A2($CurrySoftware$elm_datepicker$DatePicker$maybeOr, pickedDate, focused));
		var isOtherMonth = function (d) {
			return !_Utils_eq(
				$justinmimbs$date$Date$month(currentDate),
				$justinmimbs$date$Date$month(d));
		};
		var arrow = F2(
			function (className, message) {
				return A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							dpClass(className),
							$elm$html$Html$Events$onClick(message),
							$elm$html$Html$Attributes$tabindex(-1),
							$elm$html$Html$Attributes$type_('button')
						]),
					_List_Nil);
			});
		var _v0 = A2($CurrySoftware$elm_datepicker$DatePicker$prepareDates, currentDate, settings.eK);
		var currentMonth = _v0.gd;
		var currentDates = _v0.iA;
		var dayList = A2(
			$elm$core$List$map,
			function (rowDays) {
				return A2(
					$elm$html$Html$tr,
					_List_fromArray(
						[
							dpClass('row')
						]),
					A2(
						$elm$core$List$map,
						A4($CurrySoftware$elm_datepicker$DatePicker$viewDay, settings, picked, isOtherMonth, isToday),
						rowDays));
			},
			$CurrySoftware$elm_datepicker$DatePicker$groupDates(currentDates));
		var isCurrentYear = function (selectedYear) {
			return _Utils_eq(
				$justinmimbs$date$Date$year(currentMonth),
				selectedYear);
		};
		var yearOption = F2(
			function (index, selectedYear) {
				return _Utils_Tuple2(
					$elm$core$String$fromInt(index),
					A2(
						$elm$html$Html$option,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$value(
								$elm$core$String$fromInt(selectedYear)),
								$elm$html$Html$Attributes$selected(
								isCurrentYear(selectedYear))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(selectedYear))
							])));
			});
		var _v1 = function () {
			var front = function (to_) {
				return A2(
					$elm$core$List$range,
					$justinmimbs$date$Date$year(currentMonth),
					to_);
			};
			var back = function (from_) {
				return A2(
					$elm$core$List$range,
					from_,
					$justinmimbs$date$Date$year(currentMonth));
			};
			var _v2 = settings.dt;
			switch (_v2.$) {
				case 3:
					var from_ = _v2.a;
					return _Utils_Tuple2(
						front(from_ - 1),
						back(
							$justinmimbs$date$Date$year(today) + 1));
				case 4:
					var to_ = _v2.a;
					return _Utils_Tuple2(
						front(
							$justinmimbs$date$Date$year(today) - 1),
						back(to_ + 1));
				case 2:
					var from_ = _v2.a;
					var to_ = _v2.b;
					return _Utils_Tuple2(
						front(from_ - 1),
						back(to_ + 1));
				case 1:
					var y = _v2.a;
					return _Utils_Tuple2(_List_Nil, _List_Nil);
				default:
					return _Utils_Tuple2(_List_Nil, _List_Nil);
			}
		}();
		var addedYearsFront = _v1.a;
		var addedYearsBack = _v1.b;
		var dropdownYear = A3(
			$elm$html$Html$Keyed$node,
			'select',
			_List_fromArray(
				[
					onChange(
					A2(
						$elm$core$Basics$composeR,
						$CurrySoftware$elm_datepicker$DatePicker$Date$changeYear(currentDate),
						$CurrySoftware$elm_datepicker$DatePicker$ChangeFocus)),
					dpClass('year-menu')
				]),
			A2(
				$elm$core$List$indexedMap,
				yearOption,
				$elm$core$List$concat(
					_List_fromArray(
						[
							addedYearsFront,
							A2(
							$CurrySoftware$elm_datepicker$DatePicker$Date$yearRange,
							{gd: currentMonth, ef: today},
							settings.dt),
							addedYearsBack
						]))));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					dpClass('picker'),
					A2(
					$elm$html$Html$Events$stopPropagationOn,
					'mousedown',
					$elm$json$Json$Decode$succeed(
						_Utils_Tuple2($CurrySoftware$elm_datepicker$DatePicker$MouseDown, true))),
					A2(
					$elm$html$Html$Events$stopPropagationOn,
					'mouseup',
					$elm$json$Json$Decode$succeed(
						_Utils_Tuple2($CurrySoftware$elm_datepicker$DatePicker$MouseUp, true)))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							dpClass('picker-header')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									dpClass('prev-container')
								]),
							_List_fromArray(
								[
									A2(
									arrow,
									'prev',
									$CurrySoftware$elm_datepicker$DatePicker$ChangeFocus(
										A3($justinmimbs$date$Date$add, 1, -1, currentDate)))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									dpClass('month-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											dpClass('month')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											settings.gX(
												$justinmimbs$date$Date$month(currentMonth)))
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											dpClass('year')
										]),
									_List_fromArray(
										[
											(!$CurrySoftware$elm_datepicker$DatePicker$yearRangeActive(settings.dt)) ? $elm$html$Html$text(
											settings.hS(
												$justinmimbs$date$Date$year(currentMonth))) : A3(
											$elm$html$Html$Keyed$node,
											'span',
											_List_Nil,
											_List_fromArray(
												[
													_Utils_Tuple2(
													$elm$core$String$fromInt(
														$justinmimbs$date$Date$year(currentMonth)),
													dropdownYear)
												]))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									dpClass('next-container')
								]),
							_List_fromArray(
								[
									A2(
									arrow,
									'next',
									$CurrySoftware$elm_datepicker$DatePicker$ChangeFocus(
										A3($justinmimbs$date$Date$add, 1, 1, currentDate)))
								]))
						])),
					A2(
					$elm$html$Html$table,
					_List_fromArray(
						[
							dpClass('table')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$thead,
							_List_fromArray(
								[
									dpClass('weekdays')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									A2(
										$elm$core$List$map,
										function (d) {
											return A2(
												$elm$html$Html$td,
												_List_fromArray(
													[
														dpClass('dow')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														settings.gf(d))
													]));
										},
										A2(
											$elm$core$List$take,
											7,
											A2(
												$elm$core$List$drop,
												firstDayOffset,
												$elm$core$List$concat(
													A2(
														$elm$core$List$repeat,
														2,
														_List_fromArray(
															[0, 1, 2, 3, 4, 5, 6])))))))
								])),
							A2(
							$elm$html$Html$tbody,
							_List_fromArray(
								[
									dpClass('days')
								]),
							dayList)
						]))
				]));
	});
var $elm$html$Html$Events$onFocus = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'focus',
		$elm$json$Json$Decode$succeed(msg));
};
var $CurrySoftware$elm_datepicker$DatePicker$view = F3(
	function (pickedDate, settings, _v0) {
		var datepicker = _v0;
		var model = datepicker;
		var potentialInputId = A3(
			$elm$core$Basics$composeR,
			$elm$core$List$singleton,
			$elm$core$List$filterMap($elm$core$Basics$identity),
			A2($elm$core$Maybe$map, $elm$html$Html$Attributes$id, settings.gI));
		var inputClasses = _Utils_ap(
			_List_fromArray(
				[
					_Utils_Tuple2(settings.cJ + 'input', true)
				]),
			settings.gG);
		var inputCommon = function (xs) {
			return A2(
				$elm$html$Html$input,
				_Utils_ap(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(inputClasses),
							$elm$html$Html$Attributes$name(
							A2($elm$core$Maybe$withDefault, '', settings.gJ)),
							$elm$html$Html$Attributes$type_('text'),
							A2(
							$elm$html$Html$Events$on,
							'change',
							$elm$json$Json$Decode$succeed($CurrySoftware$elm_datepicker$DatePicker$SubmitText)),
							$elm$html$Html$Events$onInput($CurrySoftware$elm_datepicker$DatePicker$Text),
							$elm$html$Html$Events$onBlur($CurrySoftware$elm_datepicker$DatePicker$Blur),
							$elm$html$Html$Events$onClick($CurrySoftware$elm_datepicker$DatePicker$Focus),
							$elm$html$Html$Events$onFocus($CurrySoftware$elm_datepicker$DatePicker$Focus)
						]),
					_Utils_ap(
						settings.je,
						_Utils_ap(potentialInputId, xs))),
				_List_Nil);
		};
		var dateInput = inputCommon(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$placeholder(settings.hh),
					$elm$html$Html$Attributes$value(
					A2(
						$elm$core$Maybe$withDefault,
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2($elm$core$Maybe$map, settings.mt, pickedDate)),
						model.aA))
				]));
		var containerClassList = A2(
			$elm$core$List$cons,
			_Utils_Tuple2(settings.cJ + 'container', true),
			settings.f8);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(containerClassList)
				]),
			_List_fromArray(
				[
					dateInput,
					model.jJ ? A3($CurrySoftware$elm_datepicker$DatePicker$datePicker, pickedDate, settings, model) : $elm$html$Html$text('')
				]));
	});
var $author$project$Pages$Pos$Passenger$IssueCard$viewSelectExpiration = F2(
	function (passenger, model) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					function () {
						var classesStr = A2(
							$elm$core$String$join,
							', ',
							A2(
								$elm$core$List$map,
								function ($) {
									return $.c3;
								},
								$author$project$Pages$Pos$Passenger$IssueCard$takeCardClasses(model.cH)));
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('classe-usuario')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Classes cadastradas: '),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('tipo-usuario')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(classesStr)
											]))
									])),
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Pos$Passenger$IssueCard$GotDatePickerMsg,
								A3($CurrySoftware$elm_datepicker$DatePicker$view, model.cO, $author$project$Pages$Pos$Passenger$IssueCard$datePickerSettings, model.cP))
							]);
					}()),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('action-system green-btn'),
							$elm$html$Html$Events$onClick($author$project$Pages$Pos$Passenger$IssueCard$ClickedValidateCard)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Confirmar')
						]))
				]));
	});
var $author$project$Pages$Pos$Passenger$IssueCard$viewContent = F2(
	function (passenger, model) {
		switch (model.$) {
			case 0:
				return $author$project$Pages$Pos$Passenger$IssueCard$viewCantIssue;
			case 1:
				return $author$project$Pages$Pos$Passenger$IssueCard$viewCardAlreadyIssued;
			case 2:
				var model_ = model.a;
				return A2($author$project$Pages$Pos$Passenger$IssueCard$viewSelectExpiration, passenger, model_);
			case 3:
				var model_ = model.a;
				return A2($author$project$Pages$Pos$Passenger$IssueCard$viewModalValidate, passenger, model_);
			case 4:
				var model_ = model.a;
				return $author$project$Pages$Pos$Passenger$IssueCard$viewModalPrint(model_);
			case 5:
				var model_ = model.a;
				return $author$project$Pages$Pos$Passenger$IssueCard$viewModalValidateAgain(
					{jr: false});
			case 6:
				var model_ = model.a;
				return $author$project$Pages$Pos$Passenger$IssueCard$viewModalValidateAgain(
					{jr: true});
			case 7:
				var model_ = model.a;
				return $author$project$Pages$Pos$Passenger$IssueCard$viewModalIssuingCard;
			default:
				return $author$project$Pages$Pos$Passenger$IssueCard$viewModalIssuedCard;
		}
	});
var $author$project$Pages$Pos$Passenger$IssueCard$view = F2(
	function (passenger, model) {
		return {
			f7: 'emitir-cartao-container',
			md: _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('inner-container inner-center')
						]),
					_List_fromArray(
						[
							A2($author$project$Pages$Pos$Passenger$IssueCard$viewContent, passenger, model)
						]))
				]),
			gv: 'Emitir Cartão',
			gQ: _List_Nil,
			aY: $elm$core$Maybe$Nothing,
			hr: _List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Components$View$InternalLink(
						A2($author$project$Route$Passenger, passenger.dM, 0)),
					_List_fromArray(
						[
							$elm$html$Html$text('Cancelar'),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fechar-ico')
								]),
							_List_Nil)
						]))
				]),
			fD: _List_fromArray(
				['Emitir cartão'])
		};
	});
var $author$project$Pages$Pos$Passenger$IssueDuplicate$ClickedBack = {$: 0};
var $author$project$Pages$Pos$Passenger$IssueDuplicate$SelectCard = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Pos$Passenger$IssueDuplicate$viewCardRow = F4(
	function (card, timezone, idFirstCard, allBlocked) {
		var scardOrApp = card.qE ? 'Aplicativo' : 'Cartão';
		var hasCriptogram = !$elm$core$String$isEmpty(card.ml);
		var datetime = _Utils_eq(
			card.lF,
			$elm$time$Time$millisToPosix(0)) ? '-' : A2(
			$author$project$Utils$formatDateTime,
			timezone,
			$rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(card.lF));
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(card.kw + (' - ' + scardOrApp))
								]))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									(card.ml === '') ? '-' : card.ml)
								]))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Data$Passenger$blockStatusToStr(card.h7))
								]))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(datetime)
								]))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							(_Utils_eq(idFirstCard, card.dM) && (allBlocked && hasCriptogram)) ? A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('action-system green-btn'),
									$elm$html$Html$Events$onClick(
									$author$project$Pages$Pos$Passenger$IssueDuplicate$SelectCard(card))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Emitir 2a via')
								])) : A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'width', '40px')
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$Pages$Pos$Passenger$IssueDuplicate$viewCards = F2(
	function (shared, passenger) {
		var notVirtual = function (card) {
			return !card.qE;
		};
		var idFirstCard = function (maybeCard) {
			if (!maybeCard.$) {
				var card = maybeCard.a;
				return card.dM;
			} else {
				return '';
			}
		}(
			A2(
				$elm_community$list_extra$List$Extra$find,
				function (card) {
					return notVirtual(card);
				},
				passenger.f0));
		var allBlocked = A2(
			$elm$core$List$all,
			function (card) {
				var _v0 = card.h7;
				switch (_v0) {
					case 0:
						return true;
					case 2:
						return true;
					default:
						return false;
				}
			},
			A2($elm$core$List$filter, notVirtual, passenger.f0));
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('data-table-dashboard data-table-apuracoes--desabilitei data-table-checkbox'),
					A2($elm$html$Html$Attributes$attribute, 'cellspacing', '0'),
					A2($elm$html$Html$Attributes$style, 'max-width', '1100px')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$thead,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Nº Cartão')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Criptograma')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Status')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Data/Hora')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('')
										]))
								]))
						])),
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					A2(
						$elm$core$List$map,
						function (card) {
							return A4($author$project$Pages$Pos$Passenger$IssueDuplicate$viewCardRow, card, shared.kS, idFirstCard, allBlocked);
						},
						passenger.f0))
				]));
	});
var $author$project$Pages$Pos$Passenger$IssueDuplicate$SelectReason = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Pos$Passenger$IssueDuplicate$Submit = {$: 4};
var $author$project$Pages$Pos$Passenger$IssueDuplicate$viewLockUnlock = function (model) {
	var cardType = model.cH.qE ? ' - Aplicativo' : '';
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				$krisajenkins$remotedata$RemoteData$isLoading(model.q) ? _List_fromArray(
					[
						$author$project$Components$View$loadingWithText('Confirmando')
					]) : _List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('title-left first-h2')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Motivos de emissão de 2a via - ' + (model.cH.kw + cardType))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('radio-container')
							]),
						A2(
							$elm$core$List$indexedMap,
							F2(
								function (index, reason) {
									return A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$input,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$id(
														'reason-' + $elm$core$String$fromInt(index)),
														$elm$html$Html$Attributes$name('radio-group-reason'),
														$elm$html$Html$Attributes$type_('radio'),
														$elm$html$Html$Events$onClick(
														$author$project$Pages$Pos$Passenger$IssueDuplicate$SelectReason(reason)),
														$elm$html$Html$Attributes$checked(
														_Utils_eq(
															model.d8,
															$elm$core$Maybe$Just(reason.dM)))
													]),
												_List_Nil),
												A2(
												$elm$html$Html$label,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$for(
														'reason-' + $elm$core$String$fromInt(index))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(reason.pf + ' - '),
														A2(
														$elm$html$Html$strong,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('font-bold')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(
																$author$project$Utils$formatAsMoney(
																	$elm$core$String$fromInt(reason.fB)))
															]))
													]))
											]));
								}),
							A2(
								$elm$core$List$sortBy,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.qs;
									},
									$elm$time$Time$posixToMillis),
								model.d5)))
					])),
				($krisajenkins$remotedata$RemoteData$isLoading(model.q) || $krisajenkins$remotedata$RemoteData$isSuccess(model.q)) ? $elm$html$Html$text('') : A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('action-system green-btn'),
						$elm$html$Html$Events$onClick($author$project$Pages$Pos$Passenger$IssueDuplicate$Submit),
						$elm$html$Html$Attributes$disabled(
						_Utils_eq(model.d8, $elm$core$Maybe$Nothing))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Confirmar')
					]))
			]));
};
var $author$project$Pages$Pos$Passenger$IssueDuplicate$viewContent = F3(
	function (shared, passenger, model) {
		switch (model.$) {
			case 0:
				return A2($author$project$Pages$Pos$Passenger$IssueDuplicate$viewCards, shared, passenger);
			case 1:
				var model_ = model.a;
				return $author$project$Components$View$loading;
			default:
				var model_ = model.a;
				return $author$project$Pages$Pos$Passenger$IssueDuplicate$viewLockUnlock(model_);
		}
	});
var $author$project$Pages$Pos$Passenger$IssueDuplicate$view = F3(
	function (shared, passenger, model) {
		var showBackButton = !_Utils_eq(model, $author$project$Pages$Pos$Passenger$IssueDuplicate$DisplayCards);
		return {
			f7: 'desbloquear-cartao',
			md: _List_fromArray(
				[
					A3($author$project$Pages$Pos$Passenger$IssueDuplicate$viewContent, shared, passenger, model)
				]),
			gv: 'Emitir 2a via',
			gQ: _Utils_eq(model, $author$project$Pages$Pos$Passenger$IssueDuplicate$DisplayCards) ? _List_Nil : _List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Components$View$Button($author$project$Pages$Pos$Passenger$IssueDuplicate$ClickedBack),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('voltar-ico')
								]),
							_List_Nil),
							$elm$html$Html$text('Voltar')
						]))
				]),
			aY: $elm$core$Maybe$Nothing,
			hr: _List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Components$View$InternalLink(
						A2($author$project$Route$Passenger, passenger.dM, 0)),
					_List_fromArray(
						[
							$elm$html$Html$text('Cancelar'),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fechar-ico')
								]),
							_List_Nil)
						]))
				]),
			fD: _List_fromArray(
				['Emitir 2a via'])
		};
	});
var $author$project$Pages$Pos$Passenger$RegisterBeneficiary$SelectClass = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Pos$Passenger$RegisterBeneficiary$Submit = {$: 2};
var $author$project$Pages$Pos$Passenger$RegisterBeneficiary$viewRegister = function (model) {
	return _List_fromArray(
		[
			$krisajenkins$remotedata$RemoteData$isLoading(model.q) ? $author$project$Components$View$loadingWithText('Confirmando') : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'max-width', '800px'),
					A2($elm$html$Html$Attributes$style, 'width', '100%')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('title-left first-h2')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Classes')
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					A2(
						$elm$core$List$map,
						function (_class) {
							return A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$type_('checkbox'),
												$elm$html$Html$Attributes$id(_class.dM),
												$elm$html$Html$Attributes$name('checkbox-group-class'),
												$elm$html$Html$Attributes$checked(
												A2($elm$core$Set$member, _class.dM, model.B)),
												$elm$html$Html$Events$onClick(
												$author$project$Pages$Pos$Passenger$RegisterBeneficiary$SelectClass(_class.dM)),
												A2($elm$html$Html$Attributes$style, 'cursor', 'pointer')
											]),
										_List_Nil),
										$elm$html$Html$text(_class.c3)
									]));
						},
						model.dv))
				])),
			function () {
			var _v0 = model.q;
			if (_v0.$ === 1) {
				return $elm$html$Html$text('');
			} else {
				return A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('action-system green-btn'),
							$elm$html$Html$Events$onClick($author$project$Pages$Pos$Passenger$RegisterBeneficiary$Submit),
							$elm$html$Html$Attributes$disabled(
							$elm$core$Set$isEmpty(model.B))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Confirmar')
						]));
			}
		}()
		]);
};
var $author$project$Pages$Pos$Passenger$RegisterBeneficiary$viewContent = function (model) {
	switch (model.$) {
		case 0:
			return _List_Nil;
		case 1:
			return _List_fromArray(
				[$author$project$Components$View$loading]);
		case 2:
			var error = model.a;
			return _List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Services$Api$errorToUserMessage(error))
				]);
		default:
			var model_ = model.a;
			return $author$project$Pages$Pos$Passenger$RegisterBeneficiary$viewRegister(model_);
	}
};
var $author$project$Pages$Pos$Passenger$RegisterBeneficiary$view = F2(
	function (passenger, model) {
		return {
			f7: 'vender-passagem',
			md: $author$project$Pages$Pos$Passenger$RegisterBeneficiary$viewContent(model),
			gv: 'Cadastrar Beneficiário',
			gQ: _List_Nil,
			aY: $elm$core$Maybe$Nothing,
			hr: _List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Components$View$InternalLink(
						A2($author$project$Route$Passenger, passenger.dM, 0)),
					_List_fromArray(
						[
							$elm$html$Html$text('Cancelar'),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fechar-ico')
								]),
							_List_Nil)
						]))
				]),
			fD: _List_fromArray(
				['Registro de Beneficiário'])
		};
	});
var $author$project$Pages$Pos$Passenger$SellSingleCharge$Back = {$: 1};
var $author$project$Pages$Pos$Passenger$SellSingleCharge$PreviousModal = {$: 7};
var $author$project$Pages$Pos$Passenger$SellSingleCharge$viewModalConfirmation = function (_v0) {
	var paymentDataFinal = _v0.jU;
	var receivedAmount = _v0.j7;
	var confirmation = _v0.bS;
	var diffFromFinalCost = receivedAmount - paymentDataFinal.eB;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal-overlay')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('modal-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('header-modal')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('action-header'),
										$elm$html$Html$Events$onClick($author$project$Pages$Pos$Passenger$SellSingleCharge$PreviousModal)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('voltar-ico')
											]),
										_List_Nil)
									])),
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Pagamento em Dinheiro')
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('action-header')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('fechar-ico'),
												$elm$html$Html$Events$onClick($author$project$Pages$Pos$Passenger$SellSingleCharge$Back)
											]),
										_List_Nil)
									]))
							])),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('total-a-pagar')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Total a pagar: '),
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Utils$formatAsMoney(
											$elm$core$String$fromInt(paymentDataFinal.eB)))
									]))
							])),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('valor-recebido')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Valor Recebido: '),
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Utils$formatAsMoney(
											$elm$core$String$fromInt(receivedAmount)))
									]))
							])),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('troco-a-devolver')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Troco a devolver: '),
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Utils$formatAsMoney(
											$elm$core$String$fromInt(diffFromFinalCost)))
									]))
							])),
						$krisajenkins$remotedata$RemoteData$isLoading(confirmation) ? A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('loading-container'),
								A2($elm$html$Html$Attributes$style, 'margin-top', '-16px')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('loading')
									]),
								_List_Nil),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('loading-txt')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Carregando')
									]))
							])) : A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('action-system green-btn'),
								$elm$html$Html$Events$onClick($author$project$Pages$Pos$Passenger$SellSingleCharge$ConfirmValue),
								$elm$html$Html$Attributes$disabled(
								$krisajenkins$remotedata$RemoteData$isLoading(confirmation))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Confirmar Valor')
							]))
					]))
			]));
};
var $author$project$Pages$Pos$Passenger$SellSingleCharge$InputtedReceivedMoney = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Pos$Passenger$SellSingleCharge$viewModalReceipt = function (_v0) {
	var paymentDataFinal = _v0.jU;
	var receivedAmount = _v0.j7;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal-overlay')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('modal-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('header-modal')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										'Pagamento em ' + $author$project$Services$Models$paymentFormatToStr(paymentDataFinal.he))
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('action-header')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('fechar-ico'),
												$elm$html$Html$Events$onClick($author$project$Pages$Pos$Passenger$SellSingleCharge$Back)
											]),
										_List_Nil)
									]))
							])),
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$id('received-amount'),
										$elm$html$Html$Attributes$placeholder('Valor Recebido'),
										$elm$html$Html$Attributes$type_('text'),
										$elm$html$Html$Events$onInput(
										A2(
											$elm$core$Basics$composeL,
											$author$project$Pages$Pos$Passenger$SellSingleCharge$InputtedReceivedMoney,
											$elm$core$String$filter($elm$core$Char$isDigit))),
										$elm$html$Html$Attributes$value(
										$author$project$Utils$formatMoneyInput(receivedAmount))
									]),
								_List_Nil),
								$elm$html$Html$text('R$ ' + receivedAmount)
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('action-system green-btn'),
								$elm$html$Html$Events$onClick($author$project$Pages$Pos$Passenger$SellSingleCharge$NextModal),
								$elm$html$Html$Attributes$disabled(receivedAmount === '')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Confirmar Valor')
							]))
					]))
			]));
};
var $author$project$Pages$Pos$Passenger$SellSingleCharge$viewModal = function (modal) {
	switch (modal.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			var data = modal.a;
			return $elm$core$Maybe$Just(
				$author$project$Pages$Pos$Passenger$SellSingleCharge$viewModalReceipt(data));
		default:
			var data = modal.a;
			return $elm$core$Maybe$Just(
				$author$project$Pages$Pos$Passenger$SellSingleCharge$viewModalConfirmation(data));
	}
};
var $author$project$Pages$Pos$Passenger$SellSingleCharge$ClickedSellSingleChargeType = {$: 12};
var $author$project$Pages$Pos$Passenger$SellSingleCharge$ClickedSingleChargeType = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Pos$Passenger$SellSingleCharge$viewPassenger = F2(
	function (passenger, model) {
		var viewCardOption = function (card) {
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id(card.dM),
								$elm$html$Html$Attributes$name('radio-group-destiny'),
								$elm$html$Html$Attributes$value(card.dM),
								$elm$html$Html$Attributes$type_('radio'),
								$elm$html$Html$Events$onInput($author$project$Pages$Pos$Passenger$SellSingleCharge$ClickedSingleChargeType),
								$elm$html$Html$Attributes$checked(
								_Utils_eq(model.dg, card.dM))
							]),
						_List_Nil),
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$for(card.dM)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								card.kX + (' - ' + $author$project$Utils$formatMoneyInput(
									$elm$core$String$fromInt(card.di))))
							]))
					]));
		};
		var filterWithoutSerialCards = function (card) {
			return !$elm$core$String$isEmpty(card.kw);
		};
		var filterUnblockedCards = function (card) {
			var _v0 = card.h7;
			switch (_v0) {
				case 0:
					return false;
				case 2:
					return false;
				default:
					return true;
			}
		};
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('inner-container inner-center')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('title-left first-h2')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Tipos de vendas avulsas')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('radio-container ml-20')
							]),
						A2(
							$elm$core$List$map,
							viewCardOption,
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.at;
									},
									$elm$core$Basics$eq(0)),
								A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, model.fv))))
					])),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('action-system green-btn'),
						$elm$html$Html$Events$onClick($author$project$Pages$Pos$Passenger$SellSingleCharge$ClickedSellSingleChargeType)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Confirmar')
					]))
			]);
	});
var $author$project$Pages$Pos$Passenger$SellSingleCharge$view = F2(
	function (passenger, model) {
		return {
			f7: 'vender-passagem',
			md: A2($author$project$Pages$Pos$Passenger$SellSingleCharge$viewPassenger, passenger, model),
			gv: 'Venda avulsa',
			gQ: _List_Nil,
			aY: $author$project$Pages$Pos$Passenger$SellSingleCharge$viewModal(model.aY),
			hr: _List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Components$View$InternalLink(
						A2($author$project$Route$Passenger, passenger.dM, 0)),
					_List_fromArray(
						[
							$elm$html$Html$text('Cancelar Venda'),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fechar-ico')
								]),
							_List_Nil)
						]))
				]),
			fD: _List_fromArray(
				['Venda avulsa'])
		};
	});
var $author$project$Pages$Pos$Passenger$SellTicket$Back = {$: 1};
var $author$project$Pages$Pos$Passenger$SellTicket$PreviousModal = {$: 7};
var $author$project$Pages$Pos$Passenger$SellTicket$viewModalConfirmation = function (_v0) {
	var paymentDataFinal = _v0.jU;
	var receivedAmount = _v0.j7;
	var confirmation = _v0.bS;
	var diffFromFinalCost = receivedAmount - paymentDataFinal.eB;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal-overlay')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('modal-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('header-modal')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('action-header'),
										$elm$html$Html$Events$onClick($author$project$Pages$Pos$Passenger$SellTicket$PreviousModal)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('voltar-ico')
											]),
										_List_Nil)
									])),
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Pagamento em Dinheiro')
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('action-header')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('fechar-ico'),
												$elm$html$Html$Events$onClick($author$project$Pages$Pos$Passenger$SellTicket$Back)
											]),
										_List_Nil)
									]))
							])),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('total-a-pagar')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Total a pagar: '),
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Utils$formatAsMoney(
											$elm$core$String$fromInt(paymentDataFinal.eB)))
									]))
							])),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('valor-recebido')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Valor Recebido: '),
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Utils$formatAsMoney(
											$elm$core$String$fromInt(receivedAmount)))
									]))
							])),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('troco-a-devolver')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Troco a devolver: '),
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Utils$formatAsMoney(
											$elm$core$String$fromInt(diffFromFinalCost)))
									]))
							])),
						$krisajenkins$remotedata$RemoteData$isLoading(confirmation) ? A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('loading-container'),
								A2($elm$html$Html$Attributes$style, 'margin-top', '-16px')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('loading')
									]),
								_List_Nil),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('loading-txt')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Carregando')
									]))
							])) : A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('action-system green-btn'),
								$elm$html$Html$Events$onClick($author$project$Pages$Pos$Passenger$SellTicket$ConfirmValue),
								$elm$html$Html$Attributes$disabled(
								$krisajenkins$remotedata$RemoteData$isLoading(confirmation))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Confirmar Valor')
							]))
					]))
			]));
};
var $author$project$Pages$Pos$Passenger$SellTicket$InputtedReceivedMoney = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Pos$Passenger$SellTicket$viewModalReceipt = function (_v0) {
	var paymentDataFinal = _v0.jU;
	var receivedAmount = _v0.j7;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal-overlay')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('modal-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('header-modal')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										'Pagamento em ' + $author$project$Services$Models$paymentFormatToStr(paymentDataFinal.he))
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('action-header')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('fechar-ico'),
												$elm$html$Html$Events$onClick($author$project$Pages$Pos$Passenger$SellTicket$Back)
											]),
										_List_Nil)
									]))
							])),
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$id('received-amount'),
										$elm$html$Html$Attributes$placeholder('Valor Recebido'),
										$elm$html$Html$Attributes$type_('text'),
										$elm$html$Html$Events$onInput(
										A2(
											$elm$core$Basics$composeL,
											$author$project$Pages$Pos$Passenger$SellTicket$InputtedReceivedMoney,
											$elm$core$String$filter($elm$core$Char$isDigit))),
										$elm$html$Html$Attributes$value(
										$author$project$Utils$formatMoneyInput(receivedAmount))
									]),
								_List_Nil),
								$elm$html$Html$text('R$ ' + receivedAmount)
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('action-system green-btn'),
								$elm$html$Html$Events$onClick($author$project$Pages$Pos$Passenger$SellTicket$NextModal),
								$elm$html$Html$Attributes$disabled(receivedAmount === '')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Confirmar Valor')
							]))
					]))
			]));
};
var $author$project$Pages$Pos$Passenger$SellTicket$viewModal = function (modal) {
	switch (modal.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			var data = modal.a;
			return $elm$core$Maybe$Just(
				$author$project$Pages$Pos$Passenger$SellTicket$viewModalReceipt(data));
		default:
			var data = modal.a;
			return $elm$core$Maybe$Just(
				$author$project$Pages$Pos$Passenger$SellTicket$viewModalConfirmation(data));
	}
};
var $author$project$Pages$Pos$Passenger$SellTicket$FulfillPaymentData = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Pos$Passenger$SellTicket$updateCreditDestiny = F2(
	function (_v0, creditDestiny) {
		var paymentData = _v0.k;
		return _Utils_update(
			paymentData,
			{
				mk: $elm$core$Maybe$Just(creditDestiny)
			});
	});
var $author$project$Pages$Pos$Passenger$SellTicket$updateCreditValue = F2(
	function (_v0, inputCreditValue) {
		var paymentData = _v0.k;
		return _Utils_update(
			paymentData,
			{eB: inputCreditValue});
	});
var $author$project$Pages$Pos$Passenger$SellTicket$updatePaymentFormat = F2(
	function (_v0, paymentFormat) {
		var paymentData = _v0.k;
		return _Utils_update(
			paymentData,
			{
				he: $elm$core$Maybe$Just(paymentFormat)
			});
	});
var $author$project$Pages$Pos$Passenger$SellTicket$updateUserClass = F2(
	function (_v0, classId) {
		var paymentData = _v0.k;
		return _Utils_update(
			paymentData,
			{
				lY: $elm$core$Maybe$Just(classId)
			});
	});
var $author$project$Pages$Pos$Passenger$SellTicket$viewAvailableClass = F3(
	function (model, maybeSelectedId, _v0) {
		var id_ = _v0.a;
		var name_ = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('radio'),
							$elm$html$Html$Attributes$id(id_),
							$elm$html$Html$Attributes$name('radio-group-user-class'),
							$elm$html$Html$Events$onClick(
							$author$project$Pages$Pos$Passenger$SellTicket$FulfillPaymentData(
								A2($author$project$Pages$Pos$Passenger$SellTicket$updateUserClass, model, id_))),
							$elm$html$Html$Attributes$checked(
							_Utils_eq(
								maybeSelectedId,
								$elm$core$Maybe$Just(id_)))
						]),
					_List_Nil),
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for(id_)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(name_)
						]))
				]));
	});
var $author$project$Components$PassengerCard$viewCardName = function (card) {
	var cardType = card.qE ? 'Aplicativo' : 'Cartão';
	var str = (card.kw === '') ? (cardType + ' sem serial') : (cardType + (' ' + card.kw));
	return str;
};
var $author$project$Pages$Pos$Passenger$SellTicket$viewPassenger = F2(
	function (passenger, model) {
		var viewCardOption = function (card) {
			return $elm$core$Maybe$Just(
				A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id(card.dM),
									$elm$html$Html$Attributes$name('radio-group-destiny'),
									$elm$html$Html$Attributes$value(card.dM),
									$elm$html$Html$Attributes$type_('radio'),
									$elm$html$Html$Events$onInput(
									function (_v1) {
										return $author$project$Pages$Pos$Passenger$SellTicket$FulfillPaymentData(
											A2(
												$author$project$Pages$Pos$Passenger$SellTicket$updateCreditDestiny,
												model,
												card.qE ? $author$project$Pages$Pos$Passenger$SellTicket$VirtualCard : $author$project$Pages$Pos$Passenger$SellTicket$PhysicalCard(card.dM)));
									}),
									$elm$html$Html$Attributes$checked(
									function () {
										var _v2 = model.k.mk;
										if (!_v2.$) {
											if (!_v2.a.$) {
												var s = _v2.a.a;
												return _Utils_eq(card.dM, s);
											} else {
												var _v3 = _v2.a;
												return card.qE;
											}
										} else {
											return false;
										}
									}())
								]),
							_List_Nil),
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$for(card.dM)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Components$PassengerCard$viewCardName(card))
								]))
						])));
		};
		var filterWithoutSerialCards = function (card) {
			return !$elm$core$String$isEmpty(card.kw);
		};
		var filterUnblockedCards = function (card) {
			var _v0 = card.h7;
			switch (_v0) {
				case 0:
					return false;
				case 2:
					return false;
				default:
					return true;
			}
		};
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('inner-container inner-center')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('title-left first-h2')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Destino do Crédito')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('radio-container')
							]),
						A2(
							$elm$core$List$filterMap,
							$elm$core$Basics$identity,
							A2(
								$elm$core$List$map,
								viewCardOption,
								A2(
									$elm$core$List$filter,
									filterWithoutSerialCards,
									A2($elm$core$List$filter, filterUnblockedCards, passenger.f0))))),
						A2(
						$elm$html$Html$h2,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('title-left')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Valor a ser vendido')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('container-inputs radio-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$placeholder('Valor'),
										$elm$html$Html$Attributes$type_('text'),
										A2($elm$html$Html$Attributes$style, 'padding', '0px'),
										A2($elm$html$Html$Attributes$style, 'margin-bottom', '20px'),
										$elm$html$Html$Events$onInput(
										A2(
											$elm$core$Basics$composeL,
											A2(
												$elm$core$Basics$composeL,
												$author$project$Pages$Pos$Passenger$SellTicket$FulfillPaymentData,
												$author$project$Pages$Pos$Passenger$SellTicket$updateCreditValue(model)),
											$elm$core$String$filter($elm$core$Char$isDigit))),
										$elm$html$Html$Attributes$value(
										$author$project$Utils$formatMoneyInput(model.k.eB))
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$h2,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('title-left')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Classes disponíveis para o Usuário')
							])),
						$elm$core$List$isEmpty(
						A2($author$project$Pages$Pos$Passenger$SellTicket$availableWallets, model, passenger)) ? A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('action-header radio-container')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Escolha um destino do crédito')
							])) : A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('radio-container')
							]),
						A2(
							$elm$core$List$map,
							A2($author$project$Pages$Pos$Passenger$SellTicket$viewAvailableClass, model, model.k.lY),
							A2($author$project$Pages$Pos$Passenger$SellTicket$availableWallets, model, passenger))),
						A2(
						$elm$html$Html$h2,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('title-left')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Forma de Pagamento')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('radio-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$id('debito'),
										$elm$html$Html$Attributes$name('radio-group-payment'),
										$elm$html$Html$Attributes$type_('radio'),
										$elm$html$Html$Events$onClick(
										$author$project$Pages$Pos$Passenger$SellTicket$FulfillPaymentData(
											A2($author$project$Pages$Pos$Passenger$SellTicket$updatePaymentFormat, model, 2))),
										$elm$html$Html$Attributes$checked(
										_Utils_eq(
											model.k.he,
											$elm$core$Maybe$Just(2)))
									]),
								_List_Nil),
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$for('debito')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Débito')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$id('credito'),
										$elm$html$Html$Attributes$name('radio-group-payment'),
										$elm$html$Html$Attributes$type_('radio'),
										$elm$html$Html$Events$onClick(
										$author$project$Pages$Pos$Passenger$SellTicket$FulfillPaymentData(
											A2($author$project$Pages$Pos$Passenger$SellTicket$updatePaymentFormat, model, 1))),
										$elm$html$Html$Attributes$checked(
										_Utils_eq(
											model.k.he,
											$elm$core$Maybe$Just(1)))
									]),
								_List_Nil),
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$for('credito')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Crédito')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$id('dinheiro'),
										$elm$html$Html$Attributes$name('radio-group-payment'),
										$elm$html$Html$Attributes$type_('radio'),
										$elm$html$Html$Events$onClick(
										$author$project$Pages$Pos$Passenger$SellTicket$FulfillPaymentData(
											A2($author$project$Pages$Pos$Passenger$SellTicket$updatePaymentFormat, model, 0))),
										$elm$html$Html$Attributes$checked(
										_Utils_eq(
											model.k.he,
											$elm$core$Maybe$Just(0)))
									]),
								_List_Nil),
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$for('dinheiro')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Dinheiro')
									]))
							]))
					])),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('total-passagens')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Total: '),
						A2(
						$elm$html$Html$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Utils$formatAsMoney(model.k.eB))
							]))
					])),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('action-system green-btn'),
						$elm$html$Html$Events$onClick($author$project$Pages$Pos$Passenger$SellTicket$NextModal)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Confirmar')
					]))
			]);
	});
var $author$project$Pages$Pos$Passenger$SellTicket$view = F2(
	function (passenger, model) {
		return {
			f7: 'vender-passagem',
			md: A2($author$project$Pages$Pos$Passenger$SellTicket$viewPassenger, passenger, model),
			gv: 'Vender Passagem',
			gQ: _List_Nil,
			aY: $author$project$Pages$Pos$Passenger$SellTicket$viewModal(model.aY),
			hr: _List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Components$View$InternalLink(
						A2($author$project$Route$Passenger, passenger.dM, 0)),
					_List_fromArray(
						[
							$elm$html$Html$text('Cancelar Venda'),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fechar-ico')
								]),
							_List_Nil)
						]))
				]),
			fD: _List_fromArray(
				['Venda de bilhete'])
		};
	});
var $author$project$Pages$Pos$Passenger$UnlockCard$ClickedBack = {$: 0};
var $author$project$Pages$Pos$Passenger$UnlockCard$ClickedDetails = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Pos$Passenger$UnlockCard$SelectCard = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Pos$Passenger$UnlockCard$viewCardRow = F4(
	function (card, timezone, idFirstCardF, idFirstCardV) {
		var scardOrApp = card.qE ? 'Aplicativo' : 'Cartão';
		var datetime = _Utils_eq(
			card.lF,
			$elm$time$Time$millisToPosix(0)) ? '-' : A2(
			$author$project$Utils$formatDateTime,
			timezone,
			$rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(card.lF));
		var buttonColor = ((!card.h7) || (card.h7 === 2)) ? 'green' : 'red';
		var blockedActionStatus = function () {
			var _v0 = card.h7;
			switch (_v0) {
				case 0:
					return 'Desbloquear';
				case 2:
					return 'Desbloquear';
				case 1:
					return 'Bloquear';
				default:
					return 'Bloquear';
			}
		}();
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(card.kw + (' - ' + scardOrApp))
								]))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(card.pf)
								]))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Data$Passenger$blockStatusToStr(card.h7))
								]))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(datetime)
								]))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('content-center')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'display', 'flex'),
									A2($elm$html$Html$Attributes$style, 'justify-content', 'flex-end'),
									A2($elm$html$Html$Attributes$style, 'padding-right', '16px')
								]),
							_List_fromArray(
								[
									((_Utils_eq(idFirstCardF, card.dM) || _Utils_eq(idFirstCardV, card.dM)) && (!$elm$core$String$isEmpty(card.kw))) ? A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('flex gap-3')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('action-system ' + (buttonColor + '-btn')),
													$elm$html$Html$Events$onClick(
													$author$project$Pages$Pos$Passenger$UnlockCard$SelectCard(card))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(blockedActionStatus)
												])),
											((2 === card.h7) && card.lE) ? A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('action-system gray-btn'),
													$elm$html$Html$Events$onClick(
													$author$project$Pages$Pos$Passenger$UnlockCard$ClickedDetails(card))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Detalhes')
												])) : $elm$html$Html$text('')
										])) : A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'width', '40px')
										]),
									_List_Nil)
								]))
						]))
				]));
	});
var $author$project$Pages$Pos$Passenger$UnlockCard$viewCards = F2(
	function (shared, passenger) {
		var notVirtual = function (card) {
			return !card.qE;
		};
		var notFisical = function (card) {
			return card.qE;
		};
		var idFirstCardV = function (maybeCard) {
			if (!maybeCard.$) {
				var card = maybeCard.a;
				return card.dM;
			} else {
				return '';
			}
		}(
			A2(
				$elm_community$list_extra$List$Extra$find,
				function (card) {
					return notFisical(card);
				},
				passenger.f0));
		var idFirstCardF = function (maybeCard) {
			if (!maybeCard.$) {
				var card = maybeCard.a;
				return card.dM;
			} else {
				return '';
			}
		}(
			A2(
				$elm_community$list_extra$List$Extra$find,
				function (card) {
					return notVirtual(card);
				},
				passenger.f0));
		var allBlocked = A2(
			$elm$core$List$all,
			function (card) {
				var _v0 = card.h7;
				switch (_v0) {
					case 0:
						return true;
					case 2:
						return true;
					default:
						return false;
				}
			},
			A2($elm$core$List$filter, notVirtual, passenger.f0));
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('data-table-dashboard data-table-apuracoes--desabilitei data-table-checkbox'),
					A2($elm$html$Html$Attributes$attribute, 'cellspacing', '0'),
					A2($elm$html$Html$Attributes$style, 'max-width', '1100px')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$thead,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Nº Cartão')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Motivo')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Status')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Data/Hora')
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('')
										]))
								]))
						])),
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (i, card) {
								return A4($author$project$Pages$Pos$Passenger$UnlockCard$viewCardRow, card, shared.kS, idFirstCardF, idFirstCardV);
							}),
						passenger.f0))
				]));
	});
var $author$project$Pages$Pos$Passenger$UnlockCard$ClickedPDFFailEvidence = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Pos$Passenger$UnlockCard$viewIcon = function (value) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$title('Similaridade')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$strong,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-purple-tint4 font-bold text-lg')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$elm$core$String$left,
							5,
							$elm$core$String$fromFloat(value)) + '%')
					]))
			]));
};
var $author$project$Pages$Pos$Passenger$UnlockCard$viewLineVertical = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('line-vertical h-3/6 border-purple-tint4')
		]),
	_List_Nil);
var $author$project$Pages$Pos$Passenger$UnlockCard$viewFraudEvidence = F2(
	function (shared, model) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mt-4')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('title-center first-h2')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Detalhes do bloqueio por biometria facial')
							])),
						function () {
						var _v0 = model.eJ;
						switch (_v0.$) {
							case 3:
								var details = _v0.a;
								return A2(
									$elm$html$Html$section,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('flex gap-3')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('flex-col')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$h3,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Foto do cadastro')
																])),
															A2(
															$elm$html$Html$article,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('rounded-lg bg-purple-tint4 p-4')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$img,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('divergence-image'),
																			$elm$html$Html$Attributes$src(details.o5)
																		]),
																	_List_Nil)
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('group-line-vertical')
														]),
													_List_fromArray(
														[
															$author$project$Pages$Pos$Passenger$UnlockCard$viewLineVertical,
															$author$project$Pages$Pos$Passenger$UnlockCard$viewIcon(details.pI),
															$author$project$Pages$Pos$Passenger$UnlockCard$viewLineVertical
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('flex-col')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$h3,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Foto no momento do uso ')
																])),
															A2(
															$elm$html$Html$article,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('rounded-lg bg-purple-tint4 p-4')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$img,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('divergence-image'),
																			$elm$html$Html$Attributes$src(details.mY)
																		]),
																	_List_Nil)
																]))
														]))
												])),
											A2(
											$elm$html$Html$ul,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('mt-4 flex flex-col gap-3')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$li,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('text-white text-xl')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$strong,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('font-bold')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Data do uso: ')
																])),
															$elm$html$Html$text(
															A2($author$project$Utils$formatDateTimeFromPosixWithSeconds, shared.kS, details.m2))
														])),
													A2(
													$elm$html$Html$li,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('text-white text-xl')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$strong,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('font-bold')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Linha: ')
																])),
															$elm$html$Html$text(details.e1)
														])),
													A2(
													$elm$html$Html$li,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('text-white text-xl')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$strong,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('font-bold')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Veículo: ')
																])),
															$elm$html$Html$text(details.em)
														])),
													A2(
													$elm$html$Html$li,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('text-white text-xl')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$strong,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('font-bold')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Nome do passageiro(a): ')
																])),
															$elm$html$Html$text(details.k_)
														])),
													A2(
													$elm$html$Html$li,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('text-white text-xl')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$strong,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('font-bold')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Cartão do passageiro(a): ')
																])),
															$elm$html$Html$text(details.lO)
														])),
													A2(
													$elm$html$Html$li,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('text-white text-xl')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$strong,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('font-bold')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Classe: ')
																])),
															$elm$html$Html$text(details.qH)
														]))
												])),
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('action-system green-btn'),
													$elm$html$Html$Attributes$disabled(model.eG),
													$elm$html$Html$Events$onClick(
													$author$project$Pages$Pos$Passenger$UnlockCard$ClickedPDFFailEvidence(model.cH.dM))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Gerar PDF')
												]))
										]));
							case 0:
								return $elm$html$Html$text('Componente não iniciado.');
							case 1:
								return $author$project$Components$View$loading;
							default:
								var e = _v0.a;
								return $elm$html$Html$text('Ops! Algo deu errado');
						}
					}()
					]))
			]);
	});
var $author$project$Pages$Pos$Passenger$UnlockCard$SelectReason = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Pos$Passenger$UnlockCard$Submit = {$: 8};
var $author$project$Pages$Pos$Passenger$UnlockCard$viewLockUnlock = function (model) {
	var cardType = model.cH.qE ? ' - Aplicativo' : '';
	var blockStr = function () {
		var _v0 = model.cH.h7;
		switch (_v0) {
			case 0:
				return 'desbloqueio';
			case 2:
				return 'desbloqueio';
			case 1:
				return 'bloqueio';
			default:
				return 'bloqueio';
		}
	}();
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_Nil,
			$krisajenkins$remotedata$RemoteData$isLoading(model.q) ? _List_fromArray(
				[
					$author$project$Components$View$loadingWithText('Confirmando')
				]) : _List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('title-left first-h2')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Motivos de ' + (blockStr + (' para Cartão ' + (model.cH.kw + cardType))))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('radio-container')
						]),
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (index, reason) {
								return A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$id(
													'reason-' + $elm$core$String$fromInt(index)),
													$elm$html$Html$Attributes$name('radio-group-reason'),
													$elm$html$Html$Attributes$type_('radio'),
													$elm$html$Html$Events$onClick(
													$author$project$Pages$Pos$Passenger$UnlockCard$SelectReason(reason)),
													$elm$html$Html$Attributes$checked(
													_Utils_eq(
														model.d8,
														$elm$core$Maybe$Just(reason.dM)))
												]),
											_List_Nil),
											A2(
											$elm$html$Html$label,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$for(
													'reason-' + $elm$core$String$fromInt(index))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(reason.pf)
												]))
										]));
							}),
						A2(
							$elm$core$List$sortBy,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.qs;
								},
								$elm$time$Time$posixToMillis),
							model.d5)))
				])),
			($krisajenkins$remotedata$RemoteData$isLoading(model.q) || $krisajenkins$remotedata$RemoteData$isSuccess(model.q)) ? $elm$html$Html$text('') : A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('action-system green-btn'),
					$elm$html$Html$Events$onClick($author$project$Pages$Pos$Passenger$UnlockCard$Submit),
					$elm$html$Html$Attributes$disabled(
					_Utils_eq(model.d8, $elm$core$Maybe$Nothing))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Confirmar')
				]))
		]);
};
var $author$project$Pages$Pos$Passenger$UnlockCard$viewContent = F3(
	function (shared, passenger, model) {
		switch (model.$) {
			case 0:
				return _List_fromArray(
					[
						A2($author$project$Pages$Pos$Passenger$UnlockCard$viewCards, shared, passenger)
					]);
			case 1:
				var model_ = model.a;
				return _List_fromArray(
					[$author$project$Components$View$loading]);
			case 2:
				var model_ = model.a;
				return $author$project$Pages$Pos$Passenger$UnlockCard$viewLockUnlock(model_);
			default:
				var model_ = model.a;
				return A2($author$project$Pages$Pos$Passenger$UnlockCard$viewFraudEvidence, shared, model_);
		}
	});
var $author$project$Pages$Pos$Passenger$UnlockCard$view = F3(
	function (shared, passenger, model) {
		return {
			f7: 'desbloquear-cartao',
			md: A3($author$project$Pages$Pos$Passenger$UnlockCard$viewContent, shared, passenger, model),
			gv: 'Bloqueio/Desbloqueio',
			gQ: function () {
				if (!model.$) {
					return _List_Nil;
				} else {
					return _List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Components$View$Button($author$project$Pages$Pos$Passenger$UnlockCard$ClickedBack),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('voltar-ico')
										]),
									_List_Nil),
									$elm$html$Html$text('Voltar')
								]))
						]);
				}
			}(),
			aY: $elm$core$Maybe$Nothing,
			hr: _List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Components$View$InternalLink(
						A2($author$project$Route$Passenger, passenger.dM, 0)),
					_List_fromArray(
						[
							$elm$html$Html$text('Cancelar'),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fechar-ico')
								]),
							_List_Nil)
						]))
				]),
			fD: _List_fromArray(
				['Bloqueio/Desbloqueio'])
		};
	});
var $author$project$Data$Passenger$hasPhysicalCard = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.f0;
	},
	$elm$core$List$any(
		function (c) {
			return !c.qE;
		}));
var $author$project$Components$PassengerCard$OpenModalCustomerObservation = {$: 8};
var $author$project$Components$PassengerCard$viewButtonCustomerObservation = A2(
	$elm$html$Html$span,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('material-symbols-outlined cursor-pointer icon-extract-card contents'),
			$elm$html$Html$Attributes$title('Observações'),
			$elm$html$Html$Events$onClick($author$project$Components$PassengerCard$OpenModalCustomerObservation)
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('chat')
		]));
var $author$project$Components$PassengerCard$OpenModalAppliedRefill = F3(
	function (a, b, c) {
		return {$: 6, a: a, b: b, c: c};
	});
var $author$project$Components$PassengerCard$viewButtonAppliedRefill = F3(
	function (cards, document, serial) {
		return $elm$core$String$isEmpty(serial) ? $elm$html$Html$text('') : A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('material-symbols-outlined cursor-pointer icon-extract-card '),
					$elm$html$Html$Attributes$title('Ver cargas'),
					$elm$html$Html$Events$onClick(
					A3($author$project$Components$PassengerCard$OpenModalAppliedRefill, cards, document, serial))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('list_alt')
				]));
	});
var $author$project$Components$PassengerCard$OpenModalCreditTransfer = {$: 7};
var $author$project$Components$PassengerCard$viewButtonCreditTransfer = A2(
	$elm$html$Html$span,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('material-symbols-outlined cursor-pointer icon-extract-card '),
			$elm$html$Html$Attributes$title('Transferir credito'),
			$elm$html$Html$Events$onClick($author$project$Components$PassengerCard$OpenModalCreditTransfer)
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('send_money')
		]));
var $author$project$Components$PassengerCard$OpenModalExtractCard = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$PassengerCard$viewButtonExtractCard = function (cardID) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('material-symbols-outlined cursor-pointer icon-extract-card '),
				$elm$html$Html$Attributes$title('Ver extrato do cartão'),
				$elm$html$Html$Events$onClick(
				$author$project$Components$PassengerCard$OpenModalExtractCard(cardID))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('receipt_long')
			]));
};
var $author$project$Components$PassengerCard$SelectedWallet = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$PassengerCard$getValueOfPurse = F2(
	function (wallet, refills) {
		return $elm$core$List$sum(
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (purseID_) {
						return A2(
							$elm$core$List$map,
							function (refill_) {
								return _Utils_eq(purseID_, refill_.o9) ? refill_.di : 0;
							},
							refills);
					},
					wallet.o8)));
	});
var $author$project$Components$PassengerCard$viewCardWallet = F4(
	function (model, card, index, wallet) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('wallet'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'active',
							_Utils_eq(model.dd, index))
						])),
					$elm$html$Html$Attributes$id(
					'wallet-' + $elm$core$String$fromInt(index))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('balance')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$formatAsMoney(
								$elm$core$String$fromInt(wallet.h2)))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('description')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$formatAsMoney(
								$elm$core$String$fromInt(
									A2($author$project$Components$PassengerCard$getValueOfPurse, wallet, card.j8)))),
							A2($elm$html$Html$br, _List_Nil, _List_Nil),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('block w-48 truncate'),
									$elm$html$Html$Attributes$title(
									A2(
										$elm$core$String$join,
										' + ',
										A2(
											$elm$core$List$map,
											function ($) {
												return $.c3;
											},
											wallet.dv)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$String$join,
										' + ',
										A2(
											$elm$core$List$map,
											function ($) {
												return $.c3;
											},
											wallet.dv)))
								]))
						]))
				]));
	});
var $author$project$Components$PassengerCard$viewCard = F2(
	function (model, card) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('wallets-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('wallets'),
								$elm$html$Html$Attributes$id('wallets-scrollable')
							]),
						A2(
							$elm$core$List$indexedMap,
							A2($author$project$Components$PassengerCard$viewCardWallet, model, card),
							card.hO))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pagination')
					]),
				A2(
					$elm$core$List$indexedMap,
					F2(
						function (idx, _v0) {
							return A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick(
										$author$project$Components$PassengerCard$SelectedWallet(idx)),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'active',
												_Utils_eq(idx, model.dd))
											]))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										'Ir para carteira ' + $elm$core$String$fromInt(idx + 1))
									]));
						}),
					card.hO))
			]);
	});
var $author$project$Components$PassengerCard$viewCards = F4(
	function (shared, user, passenger, model) {
		var _v0 = $elm$core$List$head(passenger.f0);
		if (_v0.$ === 1) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('cards')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Nenhum cartão encontrado')
					]));
		} else {
			var firstCard = _v0.a;
			var currentCard = A2(
				$elm$core$Maybe$withDefault,
				firstCard,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (c) {
							return _Utils_eq(
								$elm$core$Maybe$Just(c.dM),
								model.dc);
						},
						passenger.f0)));
			var isCurrentCardLocked = (!currentCard.h7) || (currentCard.h7 === 2);
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('cards')
					]),
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$article,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex items-center')
							]),
						_Utils_ap(
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('select w-full'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('locked', isCurrentCardLocked)
												]))
										]),
									_List_fromArray(
										[
											$author$project$Components$Patterns$Forms$selectWithError(
											{
												iH: false,
												jl: $elm$core$Maybe$Nothing,
												jn: _List_Nil,
												jI: $elm$core$Maybe$Just($author$project$Components$PassengerCard$SelectedCard),
												jO: A2(
													$elm$core$List$map,
													function (c) {
														return {
															eX: _Utils_eq(currentCard.dM, c.dM),
															c3: $author$project$Components$PassengerCard$viewCardName(c),
															di: c.dM
														};
													},
													passenger.f0),
												jQ: true,
												ks: _List_Nil,
												kE: false,
												k1: _List_Nil
											})
										]))
								]),
							function () {
								var _v1 = shared.pv;
								if ((_v1.$ === 7) && (!_v1.b)) {
									var _v2 = _v1.b;
									return _List_fromArray(
										[
											$author$project$Services$Models$iHaveAccess(
											{
												gZ: user.hg,
												hf: $author$project$Services$Models$GUICHE(3),
												hQ: A3($author$project$Components$PassengerCard$viewButtonAppliedRefill, passenger.f0, passenger.iI, currentCard.kw),
												hR: $elm$html$Html$text('')
											}),
											$author$project$Services$Models$iHaveAccess(
											{
												gZ: user.hg,
												hf: $author$project$Services$Models$GUICHE(0),
												hQ: $author$project$Components$PassengerCard$viewButtonExtractCard(currentCard.dM),
												hR: $elm$html$Html$text('')
											}),
											$author$project$Services$Models$iHaveAccess(
											{
												gZ: user.hg,
												hf: $author$project$Services$Models$GUICHE(2),
												hQ: $author$project$Components$PassengerCard$viewButtonCreditTransfer,
												hR: $elm$html$Html$text('')
											})
										]);
								} else {
									return _List_Nil;
								}
							}())),
					A2($author$project$Components$PassengerCard$viewCard, model, currentCard)));
		}
	});
var $author$project$Components$PassengerCard$CloseModal = {$: 4};
var $author$project$Pages$Pos$Passenger$AppliedRefill$GoRefillList = {$: 6};
var $author$project$Pages$Pos$Passenger$AppliedRefill$InputtedEndDate = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Pos$Passenger$AppliedRefill$InputtedStartDate = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Pos$Passenger$AppliedRefill$Submit = {$: 4};
var $author$project$Pages$Pos$Passenger$AppliedRefill$viewCardName = F2(
	function (cards, cardSerialSelected) {
		var card = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.kw;
					},
					$elm$core$Basics$eq(cardSerialSelected)),
				cards));
		return A2(
			$elm$core$Maybe$withDefault,
			'Cartão não encontrado',
			A2(
				$elm$core$Maybe$map,
				function (card_) {
					var cardType = card_.qE ? 'Aplicativo' : 'Cartão';
					var str = (card_.kw === '') ? (cardType + ' sem serial') : (cardType + (' ' + card_.kw));
					return str;
				},
				card));
	});
var $author$project$Pages$Pos$Passenger$AppliedRefill$GoOrderDetails = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Pages$Pos$Passenger$AppliedRefill$emptyString = function (str) {
	return $elm$core$String$isEmpty(str) ? '-' : str;
};
var $author$project$Pages$Pos$Passenger$AppliedRefill$viewIconClickable = function (isClickable) {
	return isClickable ? _List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('material-symbols-outlined'),
					$elm$html$Html$Attributes$class('Ver pedido')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('read_more')
				]))
		]) : _List_Nil;
};
var $author$project$Pages$Pos$Passenger$AppliedRefill$viewRow = F3(
	function (user, shared, appliedRefill) {
		var _class = function () {
			var _v0 = _Utils_Tuple2(appliedRefill.pm, appliedRefill.iu);
			if ((!_v0.a.$) && (!_v0.b.$)) {
				var refillId = _v0.a.a;
				var companyId = _v0.b.a;
				return $author$project$Services$Models$iHaveAccess(
					{
						gZ: user.hg,
						hf: $author$project$Services$Models$GUICHE(4),
						hQ: _List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								A2($author$project$Pages$Pos$Passenger$AppliedRefill$GoOrderDetails, companyId, refillId))
							]),
						hR: _List_Nil
					});
			} else {
				return _List_Nil;
			}
		}();
		var isClickable = !$elm$core$List$isEmpty(_class);
		return _Utils_Tuple2(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_class,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Pages$Pos$Passenger$AppliedRefill$emptyString(
										$elm$core$String$fromInt(appliedRefill.pl)))
								]))
						])),
					A2(
					$elm$html$Html$td,
					_class,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Pages$Pos$Passenger$AppliedRefill$emptyString(appliedRefill.a$))
								]))
						])),
					A2(
					$elm$html$Html$td,
					_class,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Pages$Pos$Passenger$AppliedRefill$emptyString(appliedRefill.kX))
								]))
						])),
					A2(
					$elm$html$Html$td,
					_class,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$formatAsMoney(
										$elm$core$String$fromInt(appliedRefill.di)))
								]))
						])),
					A2(
					$elm$html$Html$td,
					_class,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($author$project$Utils$formatDateTimeFromPosixWithSeconds, shared.kS, appliedRefill.lK))
								]))
						])),
					A2(
					$elm$html$Html$td,
					_class,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($author$project$Utils$formatDateTimeFromPosixWithSeconds, shared.kS, appliedRefill.nx))
								]))
						])),
					A2(
					$elm$html$Html$td,
					_class,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'-',
										A2(
											$elm$core$Maybe$map,
											$author$project$Utils$formatDateTimeFromPosixWithSeconds(shared.kS),
											appliedRefill.lt)))
								]))
						])),
					A2(
					$elm$html$Html$td,
					_class,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Pages$Pos$Passenger$AppliedRefill$emptyString(appliedRefill.lu))
								]))
						])),
					A2(
					$elm$html$Html$td,
					_class,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Pages$Pos$Passenger$AppliedRefill$emptyString(appliedRefill.pn))
								]))
						])),
					A2(
					$elm$html$Html$td,
					_class,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Pages$Pos$Passenger$AppliedRefill$emptyString(appliedRefill.k7))
								]))
						])),
					A2(
					$elm$html$Html$td,
					_class,
					$author$project$Pages$Pos$Passenger$AppliedRefill$viewIconClickable(isClickable))
				]),
			isClickable);
	});
var $author$project$Pages$Pos$Passenger$AppliedRefill$viewTable = F3(
	function (user, shared, list) {
		return $author$project$Components$Patterns$Tables$defaultSomeLinesAreClickable(
			{
				lw: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'width', '100%'),
						A2($elm$html$Html$Attributes$style, 'overflow-y', 'auto')
					]),
				nF: _List_fromArray(
					['Contador de carga', 'Origem', 'Tipo', 'Valor', 'Data compra', 'Data geração', 'Data aplicação', 'Local aplicação', 'Lista cargas', 'Carteira', '']),
				nX: false,
				pj: A2(
					$elm$core$List$map,
					A2($author$project$Pages$Pos$Passenger$AppliedRefill$viewRow, user, shared),
					list)
			});
	});
var $author$project$Pages$Pos$Passenger$AppliedRefill$viewContent = F3(
	function (user, shared, model) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$h2,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'color', 'black'),
						$elm$html$Html$Attributes$class('inner-center')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						'Cargas do ' + A2($author$project$Pages$Pos$Passenger$AppliedRefill$viewCardName, model.f0, model.eu))
					])),
				A2(
				$elm$html$Html$form,
				_List_fromArray(
					[
						$elm$html$Html$Events$onSubmit($author$project$Pages$Pos$Passenger$AppliedRefill$Submit),
						$elm$html$Html$Attributes$class('flex gap-4')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-purple-main')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Início'),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$placeholder('Início'),
										$elm$html$Html$Attributes$type_('date'),
										$elm$html$Html$Events$onInput($author$project$Pages$Pos$Passenger$AppliedRefill$InputtedStartDate),
										$elm$html$Html$Attributes$value(model.bB)
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-purple-main')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Fim'),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$placeholder('Fim'),
										$elm$html$Html$Attributes$type_('date'),
										$elm$html$Html$Events$onInput($author$project$Pages$Pos$Passenger$AppliedRefill$InputtedEndDate),
										$elm$html$Html$Attributes$value(model.bl)
									]),
								_List_Nil)
							])),
						A2(
						$author$project$Components$View$searchButton,
						'self-center',
						$krisajenkins$remotedata$RemoteData$isLoading(model.c9))
					])),
				function () {
				var _v0 = model.c9;
				switch (_v0.$) {
					case 1:
						return $author$project$Components$View$loading;
					case 3:
						if (!_v0.a.b) {
							return A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Nenhum registro encontrado!')
									]));
						} else {
							var list = _v0.a;
							return A3($author$project$Pages$Pos$Passenger$AppliedRefill$viewTable, user, shared, list);
						}
					case 0:
						return $elm$html$Html$text('Por favor, defina um período desejado ou utilize as datas padrão para realizar a busca.');
					default:
						var e = _v0.a;
						return A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Algo deu errado!')
								]));
				}
			}()
			]);
	});
var $author$project$Pages$Pos$Passenger$AppliedRefill$view = F3(
	function (user, shared, typeModel) {
		if (!typeModel.$) {
			var model = typeModel.a;
			return A3($author$project$Pages$Pos$Passenger$AppliedRefill$viewContent, user, shared, model);
		} else {
			var model = typeModel.b;
			var _v1 = model.fy;
			if (_v1.$ === 2) {
				var refillDetails = _v1.a;
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$section,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(' mb-4 w-full ')
							]),
						_Utils_ap(
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('top-actions')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('voltar-ico-blue'),
													$elm$html$Html$Attributes$title('Cargas'),
													$elm$html$Html$Events$onClick($author$project$Pages$Pos$Passenger$AppliedRefill$GoRefillList)
												]),
											_List_Nil)
										]))
								]),
							A2(
								$elm$core$List$map,
								$elm$html$Html$map($author$project$Pages$Pos$Passenger$AppliedRefill$HistoryDetailsMsg),
								A5($author$project$Pages$Admin$CompanyOrders$viewContentDetails, shared, refillDetails, model.l8, model.bv, $elm$core$Maybe$Nothing))))
					]);
			} else {
				return _List_fromArray(
					[$author$project$Components$View$loading]);
			}
		}
	});
var $author$project$Components$CreditTransfer$Destiny = 1;
var $author$project$Components$CreditTransfer$Source = 0;
var $author$project$Components$CreditTransfer$Submit = {$: 4};
var $author$project$Components$CreditTransfer$viewTotalBalance = F2(
	function (currentID, maybeWallets) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$html$Html$text(''),
			A2(
				$elm$core$Maybe$map,
				function (wSelected) {
					var value = $author$project$Utils$formatAsMoney(
						$elm$core$String$fromInt(wSelected.h2));
					return A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Saldo'),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$value(value),
										$elm$html$Html$Attributes$class('cursor-default border-none '),
										$elm$html$Html$Attributes$size(
										$elm$core$String$length(value)),
										$elm$html$Html$Attributes$disabled(true)
									]),
								_List_Nil)
							]));
				},
				A2(
					$author$project$Components$CreditTransfer$getWalletSelected,
					currentID,
					A2($elm$core$Maybe$withDefault, _List_Nil, maybeWallets))));
	});
var $author$project$Components$CreditTransfer$viewTotalRefills = F2(
	function (currentID, cards) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$html$Html$text(''),
			A2(
				$elm$core$Maybe$map,
				function (c) {
					var value = $author$project$Utils$formatAsMoney(
						$elm$core$String$fromInt(
							A3(
								$elm$core$List$foldl,
								$elm$core$Basics$add,
								0,
								A2(
									$elm$core$List$map,
									function ($) {
										return $.di;
									},
									c.j8))));
					return A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Cargas'),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$value(value),
										$elm$html$Html$Attributes$class('cursor-default border-none '),
										$elm$html$Html$Attributes$size(
										$elm$core$String$length(value)),
										$elm$html$Html$Attributes$disabled(true)
									]),
								_List_Nil)
							]));
				},
				A2($author$project$Components$CreditTransfer$getCardSelected, currentID, cards)));
	});
var $author$project$Components$CreditTransfer$viewAvailableValues = F4(
	function (selectedCardID, selectedWalletClassID, cards, maybeWallets) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('credit-transfer-available-values')
				]),
			_List_fromArray(
				[
					A2($author$project$Components$CreditTransfer$viewTotalBalance, selectedWalletClassID, maybeWallets),
					A2($author$project$Components$CreditTransfer$viewTotalRefills, selectedCardID, cards)
				]));
	});
var $author$project$Components$CreditTransfer$viewIcon = A2(
	$elm$html$Html$span,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('material-symbols-outlined icon-credit-transfer ')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('send_money')
		]));
var $author$project$Components$CreditTransfer$InputtedAmountBalance = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$CreditTransfer$viewInputAmountBalance = function (currentAmount) {
	return A2(
		$elm$html$Html$label,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Valor do saldo que deseja transferir'),
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$placeholder('0,00'),
						$elm$html$Html$Attributes$type_('text'),
						$elm$html$Html$Events$onInput(
						A2(
							$elm$core$Basics$composeL,
							$author$project$Components$CreditTransfer$InputtedAmountBalance,
							$elm$core$String$filter($elm$core$Char$isDigit))),
						$elm$html$Html$Attributes$value(
						$author$project$Utils$formatMoneyInput(currentAmount))
					]),
				_List_Nil)
			]));
};
var $author$project$Components$CreditTransfer$InputtedAmountRefill = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$CreditTransfer$viewInputAmountRefill = function (currentAmount) {
	return A2(
		$elm$html$Html$label,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Valor das cargas que deseja transferir '),
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$placeholder('0,00'),
						$elm$html$Html$Attributes$type_('text'),
						$elm$html$Html$Events$onInput(
						A2(
							$elm$core$Basics$composeL,
							$author$project$Components$CreditTransfer$InputtedAmountRefill,
							$elm$core$String$filter($elm$core$Char$isDigit))),
						$elm$html$Html$Attributes$value(
						$author$project$Utils$formatMoneyInput(currentAmount))
					]),
				_List_Nil)
			]));
};
var $author$project$Components$CreditTransfer$viewLineVertical = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('line-vertical h-3/6 ')
		]),
	_List_Nil);
var $author$project$Components$CreditTransfer$SelectedCard = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$CreditTransfer$viewCardName = function (card) {
	var cardType = card.qE ? 'Aplicativo' : 'Cartão';
	var str = (card.kw === '') ? (cardType + ' sem serial') : (cardType + (' ' + card.kw));
	return str;
};
var $author$project$Components$CreditTransfer$viewSelectCard = F3(
	function (cardMsg, currentID, cards) {
		var isSelected = function (cID) {
			return _Utils_eq(
				A2($elm$core$Maybe$withDefault, '', currentID),
				cID);
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex gap-2 items-end ')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Cartão'),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Components$Patterns$Forms$selectWithError(
									{
										iH: false,
										jl: $elm$core$Maybe$Nothing,
										jn: _List_Nil,
										jI: $elm$core$Maybe$Just(
											$author$project$Components$CreditTransfer$SelectedCard(cardMsg)),
										jO: A2(
											$elm$core$List$cons,
											{
												eX: isSelected(''),
												c3: 'Selecione um cartão',
												di: ''
											},
											A2(
												$elm$core$List$map,
												function (c) {
													return {
														eX: isSelected(c.dM),
														c3: $author$project$Components$CreditTransfer$viewCardName(c),
														di: c.dM
													};
												},
												A2($elm$core$List$sortBy, $author$project$Components$CreditTransfer$viewCardName, cards))),
										jQ: false,
										ks: _List_Nil,
										kE: false,
										k1: _List_Nil
									})
								]))
						]))
				]));
	});
var $author$project$Components$CreditTransfer$SelectedWallet = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$CreditTransfer$viewSelectWallet = F3(
	function (cardMsg, currentW, maybeWallets) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$html$Html$text(''),
			A2(
				$elm$core$Maybe$map,
				function (wallets) {
					var isSelected = function (purseID) {
						return _Utils_eq(
							A2($elm$core$Maybe$withDefault, '', currentW),
							purseID);
					};
					return A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Carteira'),
								$author$project$Components$Patterns$Forms$selectWithError(
								{
									iH: false,
									jl: $elm$core$Maybe$Nothing,
									jn: _List_Nil,
									jI: $elm$core$Maybe$Just(
										$author$project$Components$CreditTransfer$SelectedWallet(cardMsg)),
									jO: A2(
										$elm$core$List$cons,
										{
											eX: isSelected(''),
											c3: 'Selecione uma carteira',
											di: ''
										},
										A2(
											$elm$core$List$map,
											function (w) {
												return {
													eX: isSelected(
														$author$project$Components$CreditTransfer$getClassCode(w)),
													c3: A2(
														$elm$core$String$join,
														' + ',
														A2(
															$elm$core$List$map,
															function ($) {
																return $.c3;
															},
															w.dv)),
													di: $author$project$Components$CreditTransfer$getClassCode(w)
												};
											},
											A2(
												$elm$core$List$sortBy,
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.dv;
													},
													A2(
														$elm$core$Basics$composeR,
														$elm$core$List$map(
															function ($) {
																return $.c3;
															}),
														$elm$core$String$join(' + '))),
												wallets))),
									jQ: false,
									ks: _List_Nil,
									kE: false,
									k1: _List_Nil
								})
							]));
				},
				maybeWallets));
	});
var $author$project$Components$CreditTransfer$viewContent = F2(
	function (model, passengerInfo) {
		var allCards = passengerInfo.f0;
		var destinyCards = A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.h7;
				},
				$elm$core$Basics$neq(0)),
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.h7;
					},
					$elm$core$Basics$neq(2)),
				allCards));
		var destinyWallets = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.hO;
			},
			A2($author$project$Components$CreditTransfer$getCardSelected, model.aH, destinyCards));
		var sourceCards = allCards;
		var sourceWallets = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.hO;
			},
			A2($author$project$Components$CreditTransfer$getCardSelected, model.ag, sourceCards));
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$section,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('credit-transfer-content')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$article,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('credit-transfer-content-source-destiny')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h1,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Origem')
											])),
										A3($author$project$Components$CreditTransfer$viewSelectCard, 0, model.ag, sourceCards),
										A3($author$project$Components$CreditTransfer$viewSelectWallet, 0, model.aJ, sourceWallets),
										A4($author$project$Components$CreditTransfer$viewAvailableValues, model.ag, model.aJ, sourceCards, sourceWallets)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('group-line-vertical')
									]),
								_List_fromArray(
									[$author$project$Components$CreditTransfer$viewLineVertical, $author$project$Components$CreditTransfer$viewIcon, $author$project$Components$CreditTransfer$viewLineVertical])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h1,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Destino')
											])),
										A3($author$project$Components$CreditTransfer$viewSelectCard, 1, model.aH, destinyCards),
										A3($author$project$Components$CreditTransfer$viewSelectWallet, 1, model.a4, destinyWallets),
										A4($author$project$Components$CreditTransfer$viewAvailableValues, model.aH, model.a4, destinyCards, destinyWallets)
									]))
							])),
						A2(
						$elm$html$Html$article,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('credit-transfer-content-input-values')
							]),
						_List_fromArray(
							[
								$author$project$Components$CreditTransfer$viewInputAmountBalance(model.bM),
								$author$project$Components$CreditTransfer$viewInputAmountRefill(model.be)
							])),
						(model.dx === 1) ? $author$project$Components$View$loading : A2(
						$elm$html$Html$article,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('action-system green-btn'),
										A2($elm$html$Html$Attributes$style, 'width', '100%'),
										$elm$html$Html$Events$onClick($author$project$Components$CreditTransfer$Submit)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Transferir')
									]))
							]))
					]))
			]);
	});
var $author$project$Components$Patterns$Forms$TextArea = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$CustomerObservation$SubmittedNewObservation = {$: 4};
var $author$project$Components$CustomerObservation$formSimpleConfigSubmit = {
	lx: _List_fromArray(
		[
			A2($elm$html$Html$Attributes$style, 'height', 'fit-content'),
			$elm$html$Html$Attributes$class('w-full')
		]),
	l_: $author$project$Components$CustomerObservation$SubmittedNewObservation,
	iH: false
};
var $author$project$Components$CustomerObservation$InputtedNewObservation = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$CustomerObservation$formSimpleConfigTextArea = F2(
	function (formStatus, value) {
		return {
			l6: $elm$core$Maybe$Just(85),
			iH: formStatus === 2,
			nR: _List_Nil,
			jl: $elm$core$Maybe$Nothing,
			jn: _List_Nil,
			n9: $elm$core$Maybe$Just(600),
			c3: 'Observação',
			ov: $elm$core$Maybe$Just($author$project$Components$CustomerObservation$SubmittedNewObservation),
			jI: $elm$core$Maybe$Just($author$project$Components$CustomerObservation$InputtedNewObservation),
			hh: 'Nova observação',
			px: $elm$core$Maybe$Just(20),
			kE: formStatus === 1,
			k1: _List_fromArray(
				[
					_Utils_Tuple2($elm$core$String$isEmpty, 'Observação não pode ser vazio')
				]),
			di: value
		};
	});
var $author$project$Components$CustomerObservation$viewAddObservation = function (form) {
	return $author$project$Components$Patterns$Forms$formSimple(
		{
			hZ: _List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col gap-2 ')
				]),
			L: form.L,
			jf: _List_fromArray(
				[
					$author$project$Components$Patterns$Forms$TextArea(
					A2($author$project$Components$CustomerObservation$formSimpleConfigTextArea, form.L, form.c4))
				]),
			oc: $elm$core$Maybe$Just($author$project$Components$CustomerObservation$formSimpleConfigSubmit),
			pX: 'Criar'
		});
};
var $author$project$Components$CustomerObservation$InputtedEndDate = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$CustomerObservation$InputtedStartDate = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$CustomerObservation$SubmitApplyFilter = {$: 5};
var $author$project$Components$Patterns$Forms$filters = function (_v0) {
	var submitMsg = _v0.pW;
	var disabledSubmit = _v0.mM;
	var inputs = _v0.jf;
	var classSubmit = _v0.lZ;
	var attrForm = _v0.hZ;
	return A2(
		$elm$html$Html$form,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('filtros-container items-baseline'),
					$elm$html$Html$Events$onSubmit(submitMsg)
				]),
			attrForm),
		_Utils_ap(
			A2(
				$elm$core$List$map,
				function (input_) {
					return A2(
						$elm$html$Html$label,
						_Utils_ap(
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-col')
								]),
							input_.h$),
						_List_fromArray(
							[
								function () {
								var _v1 = input_.kQ;
								if (!_v1.$) {
									var label = _v1.a;
									return A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-purple-main')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(label)
											]));
								} else {
									return $elm$html$Html$text('');
								}
							}(),
								A2(
								$elm$html$Html$input,
								_Utils_ap(
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class(input_.ih),
											A2($elm$html$Html$Attributes$style, 'margin-bottom', '1rem'),
											$elm$html$Html$Attributes$placeholder(input_.hh),
											$elm$html$Html$Attributes$type_(input_.kY),
											$elm$html$Html$Events$onInput(input_.jI),
											$elm$html$Html$Attributes$value(input_.di)
										]),
									input_.h_),
								_List_Nil)
							]));
				},
				inputs),
			_List_fromArray(
				[
					A2($author$project$Components$View$searchButton, classSubmit, disabledSubmit)
				])));
};
var $author$project$Components$CustomerObservation$valueNotEmpty = function (str) {
	return $elm$core$String$isEmpty(str) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(str);
};
var $author$project$Components$CustomerObservation$viewFilters = function (filters) {
	return filters.dY ? $author$project$Components$Patterns$Forms$filters(
		{
			hZ: _List_fromArray(
				[
					$elm$html$Html$Attributes$class('justify-center')
				]),
			lZ: 'm-0',
			mM: filters.L === 2,
			jf: _List_fromArray(
				[
					{
					h_: _List_Nil,
					h$: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('m-0')
						]),
					ih: 'bg-busca',
					jI: A2($elm$core$Basics$composeR, $author$project$Components$CustomerObservation$valueNotEmpty, $author$project$Components$CustomerObservation$InputtedStartDate),
					hh: 'Início',
					kQ: $elm$core$Maybe$Nothing,
					kY: 'datetime-local',
					di: A2($elm$core$Maybe$withDefault, '', filters.bB)
				},
					{
					h_: _List_Nil,
					h$: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('m-0')
						]),
					ih: 'bg-busca',
					jI: A2($elm$core$Basics$composeR, $author$project$Components$CustomerObservation$valueNotEmpty, $author$project$Components$CustomerObservation$InputtedEndDate),
					hh: 'Fim',
					kQ: $elm$core$Maybe$Nothing,
					kY: 'datetime-local',
					di: A2($elm$core$Maybe$withDefault, '', filters.bl)
				}
				]),
			pW: $author$project$Components$CustomerObservation$SubmitApplyFilter
		}) : $elm$html$Html$text('');
};
var $elm$html$Html$pre = _VirtualDom_node('pre');
var $author$project$Components$CustomerObservation$viewObservationDetails = F2(
	function (timezone, ob) {
		var maybeEmail = function (email) {
			return $elm$core$String$isEmpty(email) ? $elm$html$Html$text('') : A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(' ('),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href('mailto:' + email)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(email)
							])),
						$elm$html$Html$text(')')
					]));
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col gap-3')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Data: ')
								])),
							$elm$html$Html$text(
							A2($author$project$Utils$formatDateTimeFromPosixWithSeconds, timezone, ob.jM))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Observação: ')
										]))
								])),
							A2(
							$elm$html$Html$pre,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('whitespace-pre-wrap bg-purple-tint4 rounded-md p-2 overflow-auto'),
									A2($elm$html$Html$Attributes$style, 'max-height', 'calc(100dvh - 303px)')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(ob.g_)
								]))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Operador: ')
								])),
							$elm$html$Html$text(ob.g4.c3),
							maybeEmail(ob.g4.mX)
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Cliente: ')
								])),
							$elm$html$Html$text(ob.mr),
							maybeEmail(ob.mp)
						]))
				]));
	});
var $author$project$Components$CustomerObservation$ChangedState = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$CustomerObservation$ObservationDetails = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$CustomerObservation$textTruncate = _List_fromArray(
	[
		A2($elm$html$Html$Attributes$style, 'max-width', 'calc(100dvw - 745px)'),
		$elm$html$Html$Attributes$class('truncate overflow-hidden')
	]);
var $author$project$Components$CustomerObservation$viewObservationRow = F2(
	function (timezone, observation) {
		var onClick = $elm$html$Html$Events$onClick(
			$author$project$Components$CustomerObservation$ChangedState(
				$author$project$Components$CustomerObservation$ObservationDetails(observation)));
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[onClick]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($author$project$Utils$formatDateTimeFromPosix, timezone, observation.jM))
					])),
				A2(
				$elm$html$Html$td,
				_Utils_ap(
					_List_fromArray(
						[
							onClick,
							$elm$html$Html$Attributes$class('text-clip overflow-hidden')
						]),
					$author$project$Components$CustomerObservation$textTruncate),
				_List_fromArray(
					[
						$elm$html$Html$text(observation.g_)
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[onClick]),
				_List_fromArray(
					[
						$elm$html$Html$text(observation.g4.c3)
					]))
			]);
	});
var $author$project$Components$CustomerObservation$viewTableObservations = F2(
	function (timezone, rdObservations) {
		switch (rdObservations.$) {
			case 3:
				if (!rdObservations.a.b) {
					return $elm$html$Html$text('Nenhum registro encontrado');
				} else {
					var observations = rdObservations.a;
					return $author$project$Components$Patterns$Tables$defaultClickable(
						{
							nF: _List_fromArray(
								['Data', 'Observação', 'Operador']),
							nX: false,
							pj: A2(
								$elm$core$List$map,
								$author$project$Components$CustomerObservation$viewObservationRow(timezone),
								observations)
						});
				}
			case 0:
				return $elm$html$Html$text('Processo de inicialização não foi executado!');
			case 1:
				return $author$project$Components$View$loading;
			default:
				var e = rdObservations.a;
				return $elm$html$Html$text('Algo deu errado: ');
		}
	});
var $author$project$Components$CustomerObservation$viewContent = F2(
	function (shared, model) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$section,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex flex-col gap-5 w-full')
					]),
				function () {
					var _v0 = model.fy;
					switch (_v0.$) {
						case 0:
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$article,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('w-full overflow-auto'),
											A2($elm$html$Html$Attributes$style, 'max-height', 'calc(100dvh - 170px)'),
											A2($elm$html$Html$Attributes$style, 'min-height', 'calc(100dvh - 550px)')
										]),
									_List_fromArray(
										[
											$author$project$Components$CustomerObservation$viewFilters(model.Z),
											A2($author$project$Components$CustomerObservation$viewTableObservations, shared.kS, model.e9)
										]))
								]);
						case 2:
							return _List_fromArray(
								[
									$author$project$Components$CustomerObservation$viewAddObservation(model.bp)
								]);
						default:
							var ob = _v0.a;
							return _List_fromArray(
								[
									A2($author$project$Components$CustomerObservation$viewObservationDetails, shared.kS, ob)
								]);
					}
				}())
			]);
	});
var $author$project$Components$CustomerObservation$viewIconBackToViewObservations = A4(
	$author$project$Components$Patterns$Button$icon,
	$author$project$Components$CustomerObservation$ChangedState($author$project$Components$CustomerObservation$ViewObservation),
	'icon-md icon-back-observation',
	'arrow_back',
	'Voltar');
var $author$project$Components$CustomerObservation$CreateObservation = {$: 2};
var $author$project$Components$CustomerObservation$viewIconCreateObservation = A4(
	$author$project$Components$Patterns$Button$text,
	_List_fromArray(
		[
			A2($elm$html$Html$Attributes$style, 'width', '38rem'),
			A2($elm$html$Html$Attributes$style, 'text-wrap', 'nowrap')
		]),
	'pr-2 pl-2',
	'Criar observação',
	$author$project$Components$CustomerObservation$ChangedState($author$project$Components$CustomerObservation$CreateObservation));
var $author$project$Components$CustomerObservation$ToggleFilters = {$: 0};
var $author$project$Components$CustomerObservation$viewIconToggleFilters = A4($author$project$Components$Patterns$Button$icon, $author$project$Components$CustomerObservation$ToggleFilters, 'icon-md  icon-filter-observation', 'filter_alt', 'Filtros');
var $author$project$Components$PassengerCard$viewModal = F3(
	function (passengerInfo, shared, modal) {
		var classModal = function () {
			switch (modal.$) {
				case 0:
					return 'modal-extract-card';
				case 1:
					return 'modal-credit-transfer';
				case 2:
					var model = modal.a;
					return 'modal-applied-refill';
				default:
					return 'modal-customer-observation';
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('modal-overlay')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('modal-container modal-dashboard ' + classModal)
						]),
					$elm$core$List$concat(
						_List_fromArray(
							[
								_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('header-modal')
										]),
									_List_fromArray(
										[
											function () {
											if (modal.$ === 3) {
												var m = modal.a;
												return A2(
													$elm$html$Html$map,
													$author$project$Components$PassengerCard$CustomerObservationMsg,
													A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('flex gap-4'),
																A2($elm$html$Html$Attributes$style, 'width', '25%')
															]),
														function () {
															var _v1 = m.fy;
															switch (_v1.$) {
																case 0:
																	return _List_fromArray(
																		[$author$project$Components$CustomerObservation$viewIconToggleFilters, $author$project$Components$CustomerObservation$viewIconCreateObservation]);
																case 2:
																	return _List_fromArray(
																		[$author$project$Components$CustomerObservation$viewIconBackToViewObservations]);
																default:
																	var observation = _v1.a;
																	return _List_fromArray(
																		[$author$project$Components$CustomerObservation$viewIconBackToViewObservations]);
															}
														}()));
											} else {
												return $elm$html$Html$text('');
											}
										}(),
											function () {
											switch (modal.$) {
												case 1:
													return A2(
														$elm$html$Html$h3,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Transferência de créditos')
															]));
												case 3:
													var m = modal.a;
													return A2(
														$elm$html$Html$h3,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('content-center')
															]),
														_List_fromArray(
															[
																function () {
																var _v3 = m.fy;
																switch (_v3.$) {
																	case 0:
																		return $elm$html$Html$text('Observações');
																	case 2:
																		return $elm$html$Html$text('Criar observação');
																	default:
																		return $elm$html$Html$text('Detalhes');
																}
															}()
															]));
												default:
													return $elm$html$Html$text('');
											}
										}(),
											function () {
											switch (modal.$) {
												case 1:
													return A2(
														$elm$html$Html$button,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('action-header justify-end')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$span,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('fechar-ico'),
																		$elm$html$Html$Events$onClick($author$project$Components$PassengerCard$CloseModal)
																	]),
																_List_Nil)
															]));
												case 3:
													var m = modal.a;
													var _v5 = m.fy;
													switch (_v5.$) {
														case 0:
															return A2(
																$elm$html$Html$button,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('action-header justify-end'),
																		A2($elm$html$Html$Attributes$style, 'width', '25%')
																	]),
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$span,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('fechar-ico'),
																				$elm$html$Html$Events$onClick($author$project$Components$PassengerCard$CloseModal)
																			]),
																		_List_Nil)
																	]));
														case 2:
															return A2(
																$elm$html$Html$button,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('action-header justify-end'),
																		A2($elm$html$Html$Attributes$style, 'width', '25%')
																	]),
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$span,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('fechar-ico'),
																				$elm$html$Html$Events$onClick($author$project$Components$PassengerCard$CloseModal)
																			]),
																		_List_Nil)
																	]));
														default:
															return A2(
																$elm$html$Html$button,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('action-header justify-end'),
																		A2($elm$html$Html$Attributes$style, 'width', '25%')
																	]),
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$span,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('fechar-ico'),
																				$elm$html$Html$Events$onClick($author$project$Components$PassengerCard$CloseModal)
																			]),
																		_List_Nil)
																	]));
													}
												default:
													return A2(
														$elm$html$Html$button,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('action-header justify-end')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$span,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('fechar-ico'),
																		$elm$html$Html$Events$onClick($author$project$Components$PassengerCard$CloseModal)
																	]),
																_List_Nil)
															]));
											}
										}()
										]))
								]),
								function () {
								var _v6 = _Utils_Tuple2(modal, shared.pF);
								switch (_v6.a.$) {
									case 0:
										var model_ = _v6.a.a;
										return A2(
											$elm$core$List$map,
											$elm$html$Html$map($author$project$Components$PassengerCard$CardExtractMsg),
											A2($author$project$Pages$Admin$CardExtract$contentExtractCard, model_, shared));
									case 1:
										var modelComp = _v6.a.a;
										return A2(
											$elm$core$List$map,
											$elm$html$Html$map($author$project$Components$PassengerCard$CreditTransferMsg),
											A2($author$project$Components$CreditTransfer$viewContent, modelComp, passengerInfo));
									case 3:
										var m = _v6.a.a;
										return A2(
											$elm$core$List$map,
											$elm$html$Html$map($author$project$Components$PassengerCard$CustomerObservationMsg),
											A2($author$project$Components$CustomerObservation$viewContent, shared, m));
									default:
										if (!_v6.b.$) {
											var modelComp = _v6.a.a;
											var user = _v6.b.a;
											return A2(
												$elm$core$List$map,
												$elm$html$Html$map($author$project$Components$PassengerCard$AppliedRefillMsg),
												A3($author$project$Pages$Pos$Passenger$AppliedRefill$view, user, shared, modelComp));
										} else {
											var modelComp = _v6.a.a;
											var _v7 = _v6.b;
											return _List_Nil;
										}
								}
							}()
							])))
				]));
	});
var $author$project$Components$PassengerCard$view = F4(
	function (user, shared, passenger, model) {
		return _Utils_Tuple2(
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('exibicao-usuario exibicao-usuario-cards')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('usuario-foto')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$img,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$width(128),
										$elm$html$Html$Attributes$height(134),
										$elm$html$Html$Attributes$src(passenger.nM),
										$elm$html$Html$Attributes$class('img-profile-placeholder')
									]),
								_List_Nil),
								($author$project$Data$Passenger$hasPhysicalCard(passenger) && ($author$project$Data$User$canEnterInAdminArea(user) || A2($elm$core$List$member, $author$project$Data$Permission$SalesTicketWindow, user.oU))) ? A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href(
										$author$project$Route$toString(
											$author$project$Route$PosEdit(passenger.dM))),
										$elm$html$Html$Attributes$class('marine-button')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Editar')
									])) : A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('marine-button'),
										$elm$html$Html$Attributes$disabled(true)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Editar')
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('usuario-dados')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h5,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(passenger.c3)
									])),
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('cpf')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('CPF:'),
										A2(
										$elm$html$Html$strong,
										_List_fromArray(
											[
												A2($elm$html$Html$Attributes$style, 'padding-left', '4px')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Utils$maskCPF(passenger.iI))
											]))
									])),
								($elm$core$String$length(passenger.jX) >= 8) ? A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('telefone')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Telefone:'),
										A2(
										$elm$html$Html$strong,
										_List_fromArray(
											[
												A2($elm$html$Html$Attributes$style, 'padding-left', '4px')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Utils$maskPhoneDDD(passenger.jX))
											]))
									])) : A2($elm$html$Html$p, _List_Nil, _List_Nil),
								$author$project$Components$PassengerCard$viewButtonCustomerObservation
							])),
						A4($author$project$Components$PassengerCard$viewCards, shared, user, passenger, model)
					])),
			A2(
				$elm$core$Maybe$withDefault,
				$elm$html$Html$text(''),
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Components$PassengerCard$viewModal, passenger, shared),
					model.aY)));
	});
var $author$project$Pages$Pos$Passenger$viewPassengerCard = F4(
	function (user, shared, passenger, passengerCard) {
		var mapPageModal = F2(
			function (tag, _v0) {
				var p = _v0.a;
				var m = _v0.b;
				return _Utils_Tuple2(
					A2($elm$html$Html$map, tag, p),
					A2($elm$html$Html$map, tag, m));
			});
		return A2(
			mapPageModal,
			$author$project$Pages$Pos$Passenger$GotPassengerCardMsg,
			A4($author$project$Components$PassengerCard$view, user, shared, passenger, passengerCard));
	});
var $author$project$Pages$Pos$Passenger$view = F3(
	function (user, shared, model) {
		switch (model.$) {
			case 0:
				return _Utils_Tuple2(
					'Guichê - Cliente',
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('min-height-100')
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Components$View$cashierHeader,
								$elm$core$Maybe$Just(user),
								_List_Nil,
								_List_fromArray(
									[$author$project$Pages$Pos$Passenger$headerCancelButton])),
								A2(
								$elm$html$Html$main_,
								_List_Nil,
								_List_fromArray(
									[$author$project$Components$View$loading]))
							])));
			case 1:
				var error = model.c;
				return _Utils_Tuple2(
					'Guichê - Cliente',
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('min-height-100')
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Components$View$cashierHeader,
								$elm$core$Maybe$Just(user),
								_List_Nil,
								_List_fromArray(
									[$author$project$Pages$Pos$Passenger$headerCancelButton])),
								A2(
								$elm$html$Html$main_,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('inner-container inner-center')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Services$Api$errorToUserMessage(error))
											]))
									]))
							])));
			default:
				var lModel = model.a;
				var isCashierOpen = $elm$core$Maybe$Just(true);
				var config = function () {
					var _v1 = lModel.bv;
					switch (_v1.$) {
						case 0:
							return {
								f7: '',
								md: _List_fromArray(
									[
										A2(
										$author$project$Components$View$actionIcons,
										$elm$core$Maybe$Just('actions-container actions-container-customer'),
										A3($author$project$Pages$Pos$Passenger$actionIcons, isCashierOpen, lModel.j, user))
									]),
								gv: 'Sistema Guichê',
								gQ: _List_Nil,
								aY: $elm$core$Maybe$Just(
									A4($author$project$Pages$Pos$Passenger$viewPassengerCard, user, shared, lModel.j, lModel.G).b),
								hr: _List_fromArray(
									[$author$project$Pages$Pos$Passenger$headerCancelButton]),
								fD: _List_fromArray(
									['Cliente'])
							};
						case 1:
							var subModel = _v1.a;
							return A2(
								$author$project$Components$View$mapPassengerPage,
								$author$project$Pages$Pos$Passenger$GotSellTicketMsg,
								A2($author$project$Pages$Pos$Passenger$SellTicket$view, lModel.j, subModel));
						case 2:
							var subModel = _v1.a;
							return A2(
								$author$project$Components$View$mapPassengerPage,
								$author$project$Pages$Pos$Passenger$GotSellSingleChargeMsg,
								A2($author$project$Pages$Pos$Passenger$SellSingleCharge$view, lModel.j, subModel));
						case 3:
							var subModel = _v1.a;
							return A2(
								$author$project$Components$View$mapPassengerPage,
								$author$project$Pages$Pos$Passenger$GotApplyRefillMsg,
								A2($author$project$Pages$Pos$Passenger$ApplyRefill$view, lModel.j, subModel));
						case 4:
							var subModel = _v1.a;
							return A2(
								$author$project$Components$View$mapPassengerPage,
								$author$project$Pages$Pos$Passenger$GotIssueCardMsg,
								A2($author$project$Pages$Pos$Passenger$IssueCard$view, lModel.j, subModel));
						case 5:
							var subModel = _v1.a;
							return A2(
								$author$project$Components$View$mapPassengerPage,
								$author$project$Pages$Pos$Passenger$GotIssueDuplicateMsg,
								A3($author$project$Pages$Pos$Passenger$IssueDuplicate$view, shared, lModel.j, subModel));
						case 6:
							var subModel = _v1.a;
							return A2(
								$author$project$Components$View$mapPassengerPage,
								$author$project$Pages$Pos$Passenger$GotRegisterBeneficiaryMsg,
								A2($author$project$Pages$Pos$Passenger$RegisterBeneficiary$view, lModel.j, subModel));
						default:
							var subModel = _v1.a;
							return A2(
								$author$project$Components$View$mapPassengerPage,
								$author$project$Pages$Pos$Passenger$GotUnlockCardMsg,
								A3($author$project$Pages$Pos$Passenger$UnlockCard$view, shared, lModel.j, subModel));
					}
				}();
				return _Utils_Tuple2(
					A2(
						$elm$core$String$join,
						' - ',
						A2($elm$core$List$cons, 'Guichê', config.fD)),
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('min-height-100')
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Components$View$cashierHeader,
								$elm$core$Maybe$Just(user),
								config.gQ,
								config.hr),
								A3(
								$elm$html$Html$Keyed$node,
								'main',
								_List_Nil,
								_List_fromArray(
									[
										_Utils_Tuple2(
										config.gv,
										A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('container ' + config.f7)
												]),
											_Utils_ap(
												_List_fromArray(
													[
														A2(
														$elm$html$Html$h1,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(config.gv)
															])),
														A4($author$project$Pages$Pos$Passenger$viewPassengerCard, user, shared, lModel.j, lModel.G).a
													]),
												config.md)))
									])),
								A2(
								$elm$core$Maybe$withDefault,
								$elm$html$Html$text(''),
								config.aY)
							])));
		}
	});
var $author$project$Pages$Pos$Register$view = F3(
	function (shared, user, model) {
		return _Utils_Tuple2(
			'Guichê - Registro de cliente',
			A2(
				$elm$html$Html$map,
				$author$project$Pages$Pos$Register$GotEditorMsg,
				A3($author$project$Pages$Pos$Editor$view, shared, user, model.cR)));
	});
var $author$project$Pages$RecoverPassword$viewErrorMsg = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mx-auto md:w-2/4 sm:w-full flex flex-col justify-center items-center h-screen justify-center')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col items-center rounded w-11/12  border-solid border border-black login-box p-10 box-border')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col justify-center items-center h-96 forgot-password')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-white text-center pb-5')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('O e-mail indicado não foi encontrado!')
								])),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$author$project$Route$href($author$project$Route$Login),
									$elm$html$Html$Attributes$class('text-teal-main font-bold text-xl')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Login')
								]))
						]))
				]))
		]));
var $author$project$Pages$RecoverPassword$InputEmail = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$RecoverPassword$SendRecoverPassword = {$: 1};
var $author$project$Pages$RecoverPassword$viewFormRecoverPassword = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mx-auto md:w-3/4 sm:w-full flex flex-col justify-center items-center h-screen justify-center')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col items-center rounded w-11/12  border-solid border border-black login-box')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col justify-center items-center h-96 forgot-password')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-white text-center pt-5 pb-10')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Informe seu e-mail para receber as instruções de recuperação')
								])),
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$placeholder('Email'),
											$elm$html$Html$Attributes$type_('text'),
											$elm$html$Html$Events$onInput($author$project$Pages$RecoverPassword$InputEmail),
											$elm$html$Html$Attributes$autofocus(true)
										]),
									_List_Nil),
									$elm$html$Html$text('')
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$Pages$RecoverPassword$SendRecoverPassword),
									$elm$html$Html$Attributes$class('font-bold text-purple-main my-10 w-56 py-3 bg-teal-main rounded-3xl')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Enviar')
								]))
						]))
				]))
		]));
var $author$project$Pages$RecoverPassword$viewRecoverPasswordMsg = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mx-auto md:w-2/4 sm:w-full flex flex-col justify-center items-center h-screen justify-center')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex flex-col items-center rounded w-11/12  border-solid border border-black login-box p-10 box-border')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex flex-col justify-center items-center h-96 forgot-password')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-white text-center pb-5')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Um e-mail com as instruções de recuperação foi enviado para: '),
										A2(
										$elm$html$Html$strong,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-xl')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(model.mX)
											]))
									])),
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$author$project$Route$href($author$project$Route$Login),
										$elm$html$Html$Attributes$class('text-teal-main font-bold text-xl')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Login')
									]))
							]))
					]))
			]));
};
var $author$project$Pages$RecoverPassword$view = F2(
	function (model, shared) {
		return _Utils_Tuple2(
			'Recuperar senha',
			function () {
				var _v0 = model.d9;
				switch (_v0) {
					case 1:
						return $author$project$Pages$RecoverPassword$viewRecoverPasswordMsg(model);
					case 0:
						return $author$project$Pages$RecoverPassword$viewFormRecoverPassword;
					default:
						return $author$project$Pages$RecoverPassword$viewErrorMsg;
				}
			}());
	});
var $author$project$Services$Pdf$AdministrativeSales = 10;
var $author$project$Pages$Reports$AdministrativeSales$ClickedGenerateReport = F3(
	function (a, b, c) {
		return {$: 11, a: a, b: b, c: c};
	});
var $author$project$Pages$Reports$AdministrativeSales$InputtedEndDate = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Reports$AdministrativeSales$InputtedStartDate = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Reports$AdministrativeSales$SelectedOperators = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Reports$AdministrativeSales$Submit = {$: 7};
var $author$project$Pages$Reports$AdministrativeSales$optionsOperators = function (rdLines) {
	var options_ = A2(
		$elm$core$List$map,
		function (u) {
			return _Utils_Tuple2(u.dM, u.c3);
		},
		rdLines);
	return A2(
		$elm$core$List$cons,
		_Utils_Tuple2('', 'Todos'),
		options_);
};
var $author$project$Pages$Reports$AdministrativeSales$subtractionTotal = function (resultRD) {
	return 0;
};
var $author$project$Pages$Reports$AdministrativeSales$totalValue = function (resultRD) {
	return A2(
		$krisajenkins$remotedata$RemoteData$withDefault,
		0,
		A2(
			$krisajenkins$remotedata$RemoteData$map,
			function (result) {
				return A3(
					$elm$core$List$foldl,
					F2(
						function (row, acc) {
							return row.di + acc;
						}),
					0,
					result);
			},
			resultRD));
};
var $author$project$Pages$Reports$AdministrativeSales$viewTable = F2(
	function (model, shared) {
		var _v0 = model.ck;
		switch (_v0.$) {
			case 3:
				var table = _v0.a;
				var rowTd = function (txt) {
					return A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(txt)
							]));
				};
				var records = A2(
					$elm$core$List$map,
					function (item) {
						return A2($author$project$Pages$Reports$AdministrativeSales$reportRow, shared.kS, item);
					},
					table);
				var viewRecords = A2(
					$elm$core$List$map,
					function (rows_) {
						return A2($elm$core$List$map, rowTd, rows_);
					},
					records);
				var headers = $author$project$Pages$Reports$AdministrativeSales$reportHeaders;
				return $elm$core$List$isEmpty(viewRecords) ? $elm$html$Html$text('Nenhum registro encontrado') : $author$project$Components$Patterns$Tables$default(
					{nF: headers, nX: true, pj: viewRecords});
			case 0:
				return $elm$html$Html$text('Por favor, insira uma data de início e fim para realizar a busca.');
			case 1:
				return $author$project$Components$View$loading;
			default:
				var e = _v0.a;
				return $elm$html$Html$text('Ops! Algo deu errado');
		}
	});
var $author$project$Pages$Reports$AdministrativeSales$viewPage = F3(
	function (model, shared, user) {
		var hasPeriodCSV = A2(
			$krisajenkins$remotedata$RemoteData$withDefault,
			false,
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not),
				model.ck));
		var buttonCsv = ((!_Utils_eq(model.T.bB, $elm$core$Maybe$Nothing)) && (!_Utils_eq(model.T.bl, $elm$core$Maybe$Nothing))) ? _List_fromArray(
			[
				$author$project$Components$Patterns$Forms$Button(
				{
					lx: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('self-center w-40')
						]),
					l_: A3(
						$author$project$Pages$Reports$AdministrativeSales$ClickedGenerateReport,
						_Utils_Tuple2(hasPeriodCSV, true),
						1,
						10),
					iH: model.L === 2,
					fD: 'Baixar CSV'
				})
			]) : _List_Nil;
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-black')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Vendas administrativas')
						])),
					A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Components$Patterns$Forms$formSimple(
									{
										hZ: _List_fromArray(
											[
												$elm$html$Html$Attributes$class('w-full'),
												$elm$html$Html$Attributes$novalidate(true)
											]),
										L: model.L,
										jf: _List_fromArray(
											[
												A2(
												$author$project$Components$Patterns$Forms$Custom,
												'flex gap-3',
												_Utils_ap(
													_List_fromArray(
														[
															$author$project$Components$Patterns$Forms$Input(
															{
																ie: $elm$core$Maybe$Nothing,
																iH: model.L === 2,
																iP: _List_Nil,
																nR: _List_fromArray(
																	[
																		$elm$html$Html$Attributes$size(10)
																	]),
																jl: $elm$core$Maybe$Just('Início'),
																jn: _List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('flex flex-col'),
																		A2($elm$html$Html$Attributes$style, 'width', 'min-content')
																	]),
																n9: $elm$core$Maybe$Just(10),
																c3: '',
																jE: $elm$core$Maybe$Nothing,
																jF: $elm$core$Maybe$Nothing,
																jG: $elm$core$Maybe$Nothing,
																ov: $elm$core$Maybe$Nothing,
																jI: $elm$core$Maybe$Just(
																	A2($elm$core$Basics$composeR, $author$project$Pages$Reports$AdministrativeSales$valueNotEmpty, $author$project$Pages$Reports$AdministrativeSales$InputtedStartDate)),
																hh: 'Início',
																kE: model.L === 1,
																kY: 'date',
																k1: _List_Nil,
																di: A2($elm$core$Maybe$withDefault, '', model.T.bB)
															}),
															$author$project$Components$Patterns$Forms$Input(
															{
																ie: $elm$core$Maybe$Nothing,
																iH: model.L === 2,
																iP: _List_Nil,
																nR: _List_fromArray(
																	[
																		$elm$html$Html$Attributes$size(10)
																	]),
																jl: $elm$core$Maybe$Just('Fim'),
																jn: _List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('flex flex-col'),
																		A2($elm$html$Html$Attributes$style, 'width', 'min-content')
																	]),
																n9: $elm$core$Maybe$Just(10),
																c3: '',
																jE: $elm$core$Maybe$Nothing,
																jF: $elm$core$Maybe$Nothing,
																jG: $elm$core$Maybe$Nothing,
																ov: $elm$core$Maybe$Nothing,
																jI: $elm$core$Maybe$Just(
																	A2($elm$core$Basics$composeR, $author$project$Pages$Reports$AdministrativeSales$valueNotEmpty, $author$project$Pages$Reports$AdministrativeSales$InputtedEndDate)),
																hh: 'Fim',
																kE: model.L === 1,
																kY: 'date',
																k1: _List_Nil,
																di: A2($elm$core$Maybe$withDefault, '', model.T.bl)
															}),
															$author$project$Components$Patterns$Forms$MultiSelect(
															{
																h$: _List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('self-end'),
																		A2($elm$html$Html$Attributes$style, 'width', 'max-content')
																	]),
																fT: true,
																eS: $author$project$Pages$Reports$AdministrativeSales$operatorInputID,
																gO: model.dV,
																jl: 'Operador',
																jI: $author$project$Pages$Reports$AdministrativeSales$SelectedOperators,
																g2: A2($author$project$Pages$Reports$AdministrativeSales$SetMultiSelect, 0, true),
																jO: A2(
																	$krisajenkins$remotedata$RemoteData$withDefault,
																	_List_Nil,
																	A2($krisajenkins$remotedata$RemoteData$map, $author$project$Pages$Reports$AdministrativeSales$optionsOperators, model.c5)),
																g7: model.T.g6,
																hh: 'Selecione múltiplos operadores',
																kt: $author$project$Pages$Reports$AdministrativeSales$operatorSelectID
															}),
															$author$project$Components$Patterns$Forms$Button(
															{
																lx: _List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('self-center w-40')
																	]),
																l_: $author$project$Pages$Reports$AdministrativeSales$Submit,
																iH: model.L === 2,
																fD: 'Pesquisar'
															})
														]),
													buttonCsv)),
												A2(
												$author$project$Components$Patterns$Forms$Custom,
												'mt-4 grid grid-cols-auto-fit-minmax gap-3',
												model.dK ? _List_Nil : _List_Nil)
											]),
										oc: $elm$core$Maybe$Nothing,
										pX: 'Pesquisar'
									})
								])),
							$author$project$Components$Patterns$TotalBar$view(
							{
								lo: $author$project$Pages$Reports$AdministrativeSales$totalValue(model.ck),
								md: $elm$core$Maybe$Just(
									A2($author$project$Pages$Reports$AdministrativeSales$viewTable, model, shared)),
								fD: 'Resultado',
								qg: $author$project$Pages$Reports$AdministrativeSales$subtractionTotal(model.ck)
							})
						]))
				]));
	});
var $author$project$Pages$Reports$AdministrativeSales$view = F3(
	function (model, user, shared) {
		var viewModal = function () {
			var _v0 = model.bQ.aY;
			if (!_v0.$) {
				var m_ = _v0.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$Reports$AdministrativeSales$CompPDFCreateMSg,
					$author$project$Components$PDF$Create$viewModal(m_));
			} else {
				return $elm$html$Html$text('');
			}
		}();
		return _Utils_Tuple2(
			'Vendas administrativas',
			_List_fromArray(
				[
					A3($author$project$Pages$Reports$AdministrativeSales$viewPage, model, shared, user),
					viewModal
				]));
	});
var $author$project$Pages$Reports$DetailedVehicle$ClickedBackVehicles = {$: 15};
var $author$project$Pages$Reports$DetailedVehicle$ClickedDetails = {$: 12};
var $author$project$Pages$Reports$DetailedVehicle$GetTimeToDownload = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Reports$DetailedVehicle$InputtedEnd = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Reports$DetailedVehicle$InputtedStart = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Reports$DetailedVehicle$SubmitForm = {$: 6};
var $author$project$Pages$Reports$DetailedVehicle$viewCheckBox = function (options) {
	return options.iH ? $elm$html$Html$text('') : A2(
		$elm$html$Html$label,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('c-custom'),
				A2($elm$html$Html$Attributes$style, 'color', '#6e46c8')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('checkbox'),
						$elm$html$Html$Events$onClick(options.jG),
						$elm$html$Html$Attributes$checked(options.ie),
						$elm$html$Html$Attributes$disabled(options.iH)
					]),
				_List_Nil),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('checkmark'),
						A2($elm$html$Html$Attributes$style, 'margin-top', '0.15rem')
					]),
				_List_Nil),
				$elm$html$Html$text(options.c3)
			]));
};
var $author$project$Pages$Reports$DetailedVehicle$ClickedHideFails = {$: 13};
var $author$project$Pages$Reports$DetailedVehicle$viewCheckBoxFails = F2(
	function (details, hideFails) {
		if (details.$ === 3) {
			var ds = details.a;
			return A2(
				$elm$core$List$any,
				function ($) {
					return $.bD;
				},
				ds) ? $author$project$Pages$Reports$DetailedVehicle$viewCheckBox(
				{
					ie: hideFails,
					iH: !$krisajenkins$remotedata$RemoteData$isSuccess(details),
					c3: 'Mostrar falhas',
					jG: $author$project$Pages$Reports$DetailedVehicle$ClickedHideFails
				}) : $elm$html$Html$text('');
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Pages$Reports$DetailedVehicle$ClickedShowOnlyPayment = {$: 14};
var $author$project$Pages$Reports$DetailedVehicle$viewCheckBoxPaymentOnly = F2(
	function (details, hidePayment) {
		if (details.$ === 3) {
			return $author$project$Pages$Reports$DetailedVehicle$viewCheckBox(
				{
					ie: hidePayment,
					iH: !$krisajenkins$remotedata$RemoteData$isSuccess(details),
					c3: 'Mostrar apenas pagamentos',
					jG: $author$project$Pages$Reports$DetailedVehicle$ClickedShowOnlyPayment
				});
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Pages$Reports$DetailedVehicle$viewRecordDetails = F3(
	function (hideDetails, timezone, detail) {
		var valueViewMoney = function (value) {
			return A2(
				$elm$core$Maybe$withDefault,
				'-',
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $author$project$Utils$formatAsMoney),
					value));
		};
		var valueView = function (v) {
			return ((detail.z === 'Carga negativa aplicada') || ((detail.z === 'Carga negativa aplicada no Guichê') || (detail.z === 'Transferência de crédito (Débito)'))) ? A2(
				$elm$core$Basics$composeR,
				valueViewMoney,
				function (v_) {
					return '( ' + (v_ + ' )');
				})(v) : valueViewMoney(v);
		};
		var valueNegativeClass = function (value) {
			return ((value < 0) || ((detail.z === 'Carga negativa aplicada') || ((detail.z === 'Carga negativa aplicada no Guichê') || (detail.z === 'Transferência de crédito (Débito)')))) ? $elm$html$Html$Attributes$class('text-red-500') : A2($elm$html$Html$Attributes$style, '', '');
		};
		var userName = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$andThen,
				function (_v0) {
					return detail.qx;
				},
				detail.lO));
		var startOrEndOfSessionClass = ((detail.z === 'Abertura de sessão (App)') || (detail.z === 'Abertura de sessão')) ? $elm$html$Html$Attributes$class('bg-purple-main text-white font-bold') : (((detail.z === 'Fechamento de sessão (App)') || (detail.z === 'Fechamento de sessão')) ? $elm$html$Html$Attributes$class('bg-purple-secondary text-white font-bold') : $elm$html$Html$Attributes$class(''));
		var sessionOpeningLineStr = ((detail.z === 'Abertura de sessão (App)') || (detail.z === 'Abertura de sessão')) ? (detail.z + (' - ' + detail.e1)) : detail.z;
		return hideDetails ? _List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[startOrEndOfSessionClass]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Pages$Reports$DetailedVehicle$setsEmptyValue(
							$author$project$Pages$Reports$DetailedVehicle$maybeCell(
								A2($elm$core$Maybe$map, $elm$core$String$fromInt, detail.fu))))
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						startOrEndOfSessionClass,
						A2($elm$html$Html$Attributes$style, 'text-wrap', 'nowrap')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Pages$Reports$DetailedVehicle$setsEmptyValue(
							A2($author$project$Utils$formatDateTimeFromPosixWithSeconds, timezone, detail.cO)))
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						startOrEndOfSessionClass,
						$elm$html$Html$Attributes$class('min-w-23rem')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Pages$Reports$DetailedVehicle$setsEmptyValue(sessionOpeningLineStr))
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[startOrEndOfSessionClass]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Pages$Reports$DetailedVehicle$setsEmptyValue(userName))
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[startOrEndOfSessionClass]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Pages$Reports$DetailedVehicle$setsEmptyValue(
							$author$project$Pages$Reports$DetailedVehicle$maybeCell(detail.lO)))
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[startOrEndOfSessionClass]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Pages$Reports$DetailedVehicle$setsEmptyValue(detail.ih))
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						startOrEndOfSessionClass,
						A2($elm$html$Html$Attributes$style, 'text-wrap', 'nowrap'),
						valueNegativeClass(
						A2($elm$core$Maybe$withDefault, 0, detail.di))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						valueView(detail.di))
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						startOrEndOfSessionClass,
						A2($elm$html$Html$Attributes$style, 'text-wrap', 'nowrap')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Pages$Reports$DetailedVehicle$setsEmptyValue(
							$author$project$Pages$Reports$DetailedVehicle$maybeCell(
								A2(
									$elm$core$Maybe$map,
									A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $author$project$Utils$formatAsMoney),
									detail.h2))))
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[startOrEndOfSessionClass]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Pages$Reports$DetailedVehicle$setsEmptyValue(
							$author$project$Pages$Reports$DetailedVehicle$maybeCell(
								A2($elm$core$Maybe$map, $elm$core$String$fromInt, detail.iy))))
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[startOrEndOfSessionClass]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Pages$Reports$DetailedVehicle$setsEmptyValue(
							$author$project$Pages$Reports$DetailedVehicle$maybeCell(
								A2($elm$core$Maybe$map, $elm$core$String$fromInt, detail.js))))
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[startOrEndOfSessionClass]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Pages$Reports$DetailedVehicle$setsEmptyValue(
							$author$project$Pages$Reports$DetailedVehicle$maybeCell(
								A2($elm$core$Maybe$map, $elm$core$String$fromInt, detail.eL))))
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[startOrEndOfSessionClass]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Pages$Reports$DetailedVehicle$setsEmptyValue(detail.k7))
					]))
			]) : _List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[startOrEndOfSessionClass]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Pages$Reports$DetailedVehicle$setsEmptyValue(
							$author$project$Pages$Reports$DetailedVehicle$maybeCell(
								A2($elm$core$Maybe$map, $elm$core$String$fromInt, detail.fu))))
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						startOrEndOfSessionClass,
						A2($elm$html$Html$Attributes$style, 'text-wrap', 'nowrap')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Pages$Reports$DetailedVehicle$setsEmptyValue(
							A2($author$project$Utils$formatDateTimeFromPosixWithSeconds, timezone, detail.cO)))
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						startOrEndOfSessionClass,
						$elm$html$Html$Attributes$class('min-w-23rem')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Pages$Reports$DetailedVehicle$setsEmptyValue(sessionOpeningLineStr))
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[startOrEndOfSessionClass]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Pages$Reports$DetailedVehicle$setsEmptyValue(userName))
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[startOrEndOfSessionClass]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Pages$Reports$DetailedVehicle$setsEmptyValue(
							$author$project$Pages$Reports$DetailedVehicle$maybeCell(detail.lO)))
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[startOrEndOfSessionClass]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Pages$Reports$DetailedVehicle$setsEmptyValue(detail.ih))
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						startOrEndOfSessionClass,
						A2($elm$html$Html$Attributes$style, 'text-wrap', 'nowrap'),
						valueNegativeClass(
						A2($elm$core$Maybe$withDefault, 0, detail.di))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						valueView(detail.di))
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						startOrEndOfSessionClass,
						A2($elm$html$Html$Attributes$style, 'text-wrap', 'nowrap')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Pages$Reports$DetailedVehicle$setsEmptyValue(
							$author$project$Pages$Reports$DetailedVehicle$maybeCell(
								A2(
									$elm$core$Maybe$map,
									A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $author$project$Utils$formatAsMoney),
									detail.h2))))
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[startOrEndOfSessionClass]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Pages$Reports$DetailedVehicle$setsEmptyValue(
							$author$project$Pages$Reports$DetailedVehicle$maybeCell(
								A2($elm$core$Maybe$map, $elm$core$String$fromInt, detail.eL))))
					]))
			]);
	});
var $author$project$Pages$Reports$DetailedVehicle$viewDetails = F2(
	function (timezone, model) {
		var vehicleName = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$append(' - '),
				model.T.hN));
		var disabledSubmit = $krisajenkins$remotedata$RemoteData$isLoading(model.dE);
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('top-actions')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('voltar-ico-blue'),
									$elm$html$Html$Attributes$title('Veículos'),
									$elm$html$Html$Events$onClick($author$project$Pages$Reports$DetailedVehicle$ClickedBackVehicles)
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'color', 'black'),
							$elm$html$Html$Attributes$class('inner-center')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Veículo detalhado' + vehicleName)
						])),
					A2(
					$elm$html$Html$form,
					_List_fromArray(
						[
							disabledSubmit ? $elm$html$Html$Attributes$class('') : $elm$html$Html$Events$onSubmit($author$project$Pages$Reports$DetailedVehicle$SubmitForm)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$article,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('filtros-container payment-guides items-center gap-2')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Início'),
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$value(
													A2($elm$core$Maybe$withDefault, '', model.T.bB)),
													$elm$html$Html$Attributes$type_('datetime-local'),
													$elm$html$Html$Attributes$step('1'),
													$elm$html$Html$Events$onInput($author$project$Pages$Reports$DetailedVehicle$InputtedStart),
													A2($elm$html$Html$Attributes$style, 'margin-bottom', '1rem')
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Fim'),
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$value(
													A2($elm$core$Maybe$withDefault, '', model.T.bl)),
													$elm$html$Html$Attributes$type_('datetime-local'),
													$elm$html$Html$Attributes$step('1'),
													$elm$html$Html$Events$onInput($author$project$Pages$Reports$DetailedVehicle$InputtedEnd),
													A2($elm$html$Html$Attributes$style, 'margin-bottom', '1rem')
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$label,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('self-center')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('action-system green-btn min-btn-with-icon '),
													$elm$html$Html$Attributes$disabled(disabledSubmit),
													$elm$html$Html$Attributes$type_('submit')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('material-symbols-outlined text-sm')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('search')
														])),
													$elm$html$Html$text('Pesquisar')
												]))
										])),
									function () {
									var _v0 = model.dE;
									if (_v0.$ === 3) {
										if (!_v0.a.b) {
											return $elm$html$Html$text('');
										} else {
											var rows = _v0.a;
											return $author$project$Components$GeneratorCSV$buttonDownload(
												$author$project$Pages$Reports$DetailedVehicle$GetTimeToDownload(rows));
										}
									} else {
										return $elm$html$Html$text('');
									}
								}()
								])),
							$author$project$Pages$Reports$DetailedVehicle$viewCheckBox(
							{
								ie: model.az,
								iH: !$krisajenkins$remotedata$RemoteData$isSuccess(model.dE),
								c3: 'Detalhes',
								jG: $author$project$Pages$Reports$DetailedVehicle$ClickedDetails
							}),
							A2($author$project$Pages$Reports$DetailedVehicle$viewCheckBoxFails, model.dE, model.b1),
							A2($author$project$Pages$Reports$DetailedVehicle$viewCheckBoxPaymentOnly, model.dE, model.cq)
						])),
					A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v1 = model.dE;
							switch (_v1.$) {
								case 3:
									var vehicles = _v1.a;
									var headers = model.az ? _List_fromArray(
										['', 'Data/Horário', 'Evento', 'Nome', 'Cartão', 'Classe', 'Valor', 'Saldo', 'Contador', 'Contador carga', 'Contador catraca', 'Carteira']) : _List_fromArray(
										['', 'Data/Horário', 'Evento', 'Nome', 'Cartão', 'Classe', 'Valor', 'Saldo', 'Contador catraca']);
									var filteredTransactionsHideDetails = model.az ? vehicles : A2(
										$elm$core$List$filter,
										function (_v4) {
											var description = _v4.z;
											return (description !== 'Catraca liberada') && (description !== 'Catraca girada');
										},
										vehicles);
									var filteredTransactionsHideError = model.b1 ? filteredTransactionsHideDetails : A2(
										$elm$core$List$filter,
										function (_v3) {
											var transactionError = _v3.bD;
											return !transactionError;
										},
										filteredTransactionsHideDetails);
									var filteredTransactionsShowOnlyPayment = model.cq ? A2(
										$elm$core$List$filter,
										function (_v2) {
											var description = _v2.z;
											return (description === 'Pagamento de passagem') || ((description === 'Catraca liberada via Botoeira') || ((description === 'Abertura de sessão (App)') || ((description === 'Abertura de sessão') || ((description === 'Fechamento de sessão (App)') || (description === 'Fechamento de sessão')))));
										},
										filteredTransactionsHideError) : filteredTransactionsHideError;
									var viewRecords = A2(
										$elm$core$List$map,
										A2($author$project$Pages$Reports$DetailedVehicle$viewRecordDetails, model.az, timezone),
										filteredTransactionsShowOnlyPayment);
									return $elm$core$List$isEmpty(viewRecords) ? $elm$html$Html$text('Nenhum registro encontrado') : $author$project$Components$Patterns$Tables$default(
										{nF: headers, nX: true, pj: viewRecords});
								case 0:
									return $elm$html$Html$text('Por favor, defina um período desejado ou utilize as datas padrão para realizar a busca.');
								case 1:
									return $author$project$Components$View$loading;
								default:
									var e = _v1.a;
									return $elm$html$Html$text('Ops! Algo deu errado');
							}
						}()
						]))
				]));
	});
var $author$project$Pages$Reports$DetailedVehicle$InputtedSerial = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Reports$DetailedVehicle$InputtedVehicle = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Reports$DetailedVehicle$algorithmToFilter = F2(
	function (queries, list) {
		var filteredVehicle = F2(
			function (key, list_) {
				return A2(
					$elm$core$Maybe$withDefault,
					list_,
					A2(
						$elm$core$Maybe$map,
						function (queryName) {
							var f = A2(
								$elm$core$Basics$composeR,
								$elm$core$String$toLower,
								$elm$core$String$contains(queryName));
							return A2(
								$elm$core$List$filter,
								function (_v0) {
									var code = _v0.l4;
									var plate = _v0.ac;
									var _v1 = _Utils_Tuple2(
										f(code),
										f(plate));
									if (_v1.a) {
										if (_v1.b) {
											return true;
										} else {
											return true;
										}
									} else {
										if (_v1.b) {
											return true;
										} else {
											return false;
										}
									}
								},
								list);
						},
						key));
			});
		var filtered = F3(
			function (filter, key, list_) {
				return A2(
					$elm$core$Maybe$withDefault,
					list_,
					A2(
						$elm$core$Maybe$map,
						function (queryName) {
							return A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									filter,
									A2(
										$elm$core$Basics$composeR,
										$elm$core$String$toLower,
										$elm$core$String$contains(queryName))),
								list);
						},
						key));
			});
		var filterDeviceSn = F2(
			function (key, list_) {
				return A2(
					$elm$core$Maybe$withDefault,
					list_,
					A2(
						$elm$core$Maybe$map,
						function (queryName) {
							return A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.mG;
									},
									A2(
										$elm$core$Basics$composeR,
										$elm$core$Maybe$map(
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.iF;
												},
												A2(
													$elm$core$Basics$composeR,
													$elm$core$String$toLower,
													$elm$core$String$contains(queryName)))),
										$elm$core$Maybe$withDefault(false))),
								list);
						},
						key));
			});
		return A2(
			filteredVehicle,
			A2($elm$core$Maybe$map, $elm$core$String$toLower, queries.k2),
			A2(
				filterDeviceSn,
				A2($elm$core$Maybe$map, $elm$core$String$toLower, queries.kw),
				list));
	});
var $author$project$Pages$Reports$DetailedVehicle$OpenDetails = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $Massolari$elm_mask$Mask$string = F2(
	function (pattern, value) {
		return A3($Massolari$elm_mask$Mask$maskStringHelper, pattern, value, '');
	});
var $author$project$Utils$maskPlate = $Massolari$elm_mask$Mask$string('###-####');
var $author$project$Pages$Reports$DetailedVehicle$viewRecordVehicles = F2(
	function (timezone, vehicle) {
		var onClick = $elm$html$Html$Events$onClick(
			A2($author$project$Pages$Reports$DetailedVehicle$OpenDetails, vehicle.dM, vehicle.l4));
		var viewTDDevice = A2(
			$elm$core$Maybe$withDefault,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[onClick]),
					_List_fromArray(
						[
							$elm$html$Html$text('-')
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[onClick]),
					_List_fromArray(
						[
							$elm$html$Html$text('-')
						]))
				]),
			A2(
				$elm$core$Maybe$map,
				function (d) {
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[onClick]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($author$project$Utils$formatDateTimeFromPosix, timezone, d.mJ))
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[onClick]),
							_List_fromArray(
								[
									$elm$html$Html$text(d.iF)
								]))
						]);
				},
				vehicle.mG));
		return _Utils_ap(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[onClick]),
					_List_fromArray(
						[
							$elm$html$Html$text(vehicle.l4)
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[onClick]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$maskPlate(vehicle.ac))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[onClick]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'Sem equipamento',
								A2(
									$elm$core$Maybe$map,
									function (_v0) {
										return 'Instalado';
									},
									vehicle.mG)))
						]))
				]),
			viewTDDevice);
	});
var $author$project$Pages$Reports$DetailedVehicle$viewVehicles = F2(
	function (timezone, model) {
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-black')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Veículos')
						])),
					$author$project$Components$Patterns$Forms$formSimple(
					{
						hZ: _List_fromArray(
							[
								$elm$html$Html$Attributes$class('w-full'),
								$elm$html$Html$Attributes$novalidate(true)
							]),
						L: model.L,
						jf: _List_fromArray(
							[
								A2(
								$author$project$Components$Patterns$Forms$Custom,
								'flex gap-3',
								_List_fromArray(
									[
										$author$project$Components$Patterns$Forms$Input(
										{
											ie: $elm$core$Maybe$Nothing,
											iH: model.L === 2,
											iP: _List_Nil,
											nR: _List_fromArray(
												[
													$elm$html$Html$Attributes$size(20)
												]),
											jl: $elm$core$Maybe$Just('Veículo (Código/Placa)'),
											jn: _List_fromArray(
												[
													$elm$html$Html$Attributes$class('flex flex-col'),
													A2($elm$html$Html$Attributes$style, 'width', 'max-content')
												]),
											n9: $elm$core$Maybe$Just(20),
											c3: '',
											jE: $elm$core$Maybe$Nothing,
											jF: $elm$core$Maybe$Nothing,
											jG: $elm$core$Maybe$Nothing,
											ov: $elm$core$Maybe$Nothing,
											jI: $elm$core$Maybe$Just(
												A2($elm$core$Basics$composeR, $author$project$Components$Patterns$Forms$strMaybe, $author$project$Pages$Reports$DetailedVehicle$InputtedVehicle)),
											hh: 'Código ou placa',
											kE: model.L === 1,
											kY: 'text',
											k1: _List_Nil,
											di: A2($elm$core$Maybe$withDefault, '', model.T.k2)
										}),
										$author$project$Components$Patterns$Forms$Input(
										{
											ie: $elm$core$Maybe$Nothing,
											iH: model.L === 2,
											iP: _List_Nil,
											nR: _List_fromArray(
												[
													$elm$html$Html$Attributes$size(20)
												]),
											jl: $elm$core$Maybe$Just('Serial'),
											jn: _List_fromArray(
												[
													$elm$html$Html$Attributes$class('flex flex-col'),
													A2($elm$html$Html$Attributes$style, 'width', 'max-content')
												]),
											n9: $elm$core$Maybe$Just(20),
											c3: '',
											jE: $elm$core$Maybe$Nothing,
											jF: $elm$core$Maybe$Nothing,
											jG: $elm$core$Maybe$Nothing,
											ov: $elm$core$Maybe$Nothing,
											jI: $elm$core$Maybe$Just(
												A2($elm$core$Basics$composeR, $author$project$Components$Patterns$Forms$strMaybe, $author$project$Pages$Reports$DetailedVehicle$InputtedSerial)),
											hh: '',
											kE: model.L === 1,
											kY: 'text',
											k1: _List_Nil,
											di: A2($elm$core$Maybe$withDefault, '', model.T.kw)
										})
									]))
							]),
						oc: $elm$core$Maybe$Nothing,
						pX: 'Pesquisar'
					}),
					A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = model.en;
							switch (_v0.$) {
								case 3:
									var vehicles = _v0.a;
									var recordsFiltered = A2($author$project$Pages$Reports$DetailedVehicle$algorithmToFilter, model.T, vehicles);
									var viewRecords = A2(
										$elm$core$List$map,
										$author$project$Pages$Reports$DetailedVehicle$viewRecordVehicles(timezone),
										recordsFiltered);
									var headers = _List_fromArray(
										['Código', 'Placa', 'Status', 'Data de instalação', 'Equipamento']);
									return $elm$core$List$isEmpty(viewRecords) ? $elm$html$Html$text('Nenhum registro encontrado') : $author$project$Components$Patterns$Tables$defaultClickable(
										{nF: headers, nX: true, pj: viewRecords});
								case 0:
									return $elm$html$Html$text('');
								case 1:
									return $author$project$Components$View$loading;
								default:
									var e = _v0.a;
									return $elm$html$Html$text('Ops! Algo deu errado');
							}
						}()
						]))
				]));
	});
var $author$project$Pages$Reports$DetailedVehicle$viewPage = F3(
	function (timezone, model, user) {
		var _v0 = model.fy;
		switch (_v0) {
			case 0:
				return A2(
					$elm$html$Html$main_,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('main-dashboard')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$section,
							_List_Nil,
							_List_fromArray(
								[$author$project$Components$View$loading]))
						]));
			case 1:
				return A2($author$project$Pages$Reports$DetailedVehicle$viewVehicles, timezone, model);
			default:
				return A2($author$project$Pages$Reports$DetailedVehicle$viewDetails, timezone, model);
		}
	});
var $author$project$Pages$Reports$DetailedVehicle$view = F3(
	function (model, user, shared) {
		var viewModal = $elm$html$Html$text('');
		var title = function () {
			var _v0 = model.fy;
			switch (_v0) {
				case 0:
					return 'Carregando..';
				case 1:
					return 'Veículos';
				default:
					return 'Veículo detalhado';
			}
		}();
		return _Utils_Tuple2(
			title,
			_List_fromArray(
				[
					A3($author$project$Pages$Reports$DetailedVehicle$viewPage, shared.kS, model, user),
					viewModal
				]));
	});
var $author$project$Pages$Reports$DetailedVehicleV2$ClickedBackVehicles = {$: 15};
var $author$project$Pages$Reports$DetailedVehicleV2$InputtedEnd = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Reports$DetailedVehicleV2$InputtedStart = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Reports$DetailedVehicleV2$SubmitForm = {$: 6};
var $author$project$Pages$Reports$DetailedVehicleV2$ToggleExpand = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$View$loadingWithoutText = function (loadingCss) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('loading-container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('loading '),
					loadingCss),
				_List_Nil)
			]));
};
var $author$project$Components$Patterns$Tables$defaultWithExpandable = function (opts) {
	var cssTableDefaultPanel = opts.nX ? _List_fromArray(
		[
			$elm$html$Html$Attributes$class('table-with-expandable '),
			$elm$html$Html$Attributes$class('overflow-x-auto'),
			A2($elm$html$Html$Attributes$style, 'width', 'calc(100vw - 23rem)')
		]) : _List_fromArray(
		[
			$elm$html$Html$Attributes$class('table-with-expandable ')
		]);
	return A2(
		$elm$html$Html$div,
		cssTableDefaultPanel,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$table,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'cellspacing', '0'),
						$elm$html$Html$Attributes$class('data-table-dashboard my-4 cell')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$tr,
								_List_Nil,
								A2(
									$elm$core$List$cons,
									A2(
										$elm$html$Html$th,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('')
											])),
									A2(
										$elm$core$List$map,
										function (h) {
											return A2(
												$elm$html$Html$th,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(h)
													]));
										},
										opts.nF)))
							])),
						A2(
						$elm$html$Html$tbody,
						_List_Nil,
						A2(
							$elm$core$List$concatMap,
							function (rec) {
								var isExpandedClass = rec.eV ? 'bg-teal-main ' : '';
								var mainRow = A2(
									$elm$html$Html$tr,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(
											opts.ox(
												_Utils_Tuple2(rec.dM, rec.m6))),
											$elm$html$Html$Attributes$class('hover:bg-gray-tint1 cursor-pointer font-bold ' + isExpandedClass)
										]),
									A2(
										$elm$core$List$cons,
										A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													($elm$core$List$isEmpty(rec.iM) && rec.eV) ? $author$project$Components$View$loadingWithoutText(
													_List_fromArray(
														[
															A2($elm$html$Html$Attributes$style, 'width', '20px'),
															A2($elm$html$Html$Attributes$style, 'height', '20px')
														])) : (rec.eV ? $elm$html$Html$text('▼') : $elm$html$Html$text('▶'))
												])),
										rec.gR.a));
								var expandedRows = rec.eV ? A2(
									$elm$core$List$map,
									function (cells) {
										return A2(
											$elm$html$Html$tr,
											_List_Nil,
											A2(
												$elm$core$List$cons,
												A2($elm$html$Html$td, _List_Nil, _List_Nil),
												cells));
									},
									rec.iM) : _List_Nil;
								return _Utils_eq(rec.qk, $elm$core$Maybe$Nothing) ? _List_fromArray(
									[
										A2(
										$elm$html$Html$tr,
										_List_Nil,
										A2(
											$elm$core$List$cons,
											A2(
												$elm$html$Html$td,
												_List_fromArray(
													[rec.gR.b]),
												_List_Nil),
											rec.gR.a))
									]) : A2($elm$core$List$cons, mainRow, expandedRows);
							},
							opts.pj))
					]))
			]));
};
var $author$project$Pages$Reports$DetailedVehicleV2$viewDetails = F2(
	function (timezone, model) {
		var vehicleName = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$append(' - '),
				model.T.hN));
		var disabledSubmit = $krisajenkins$remotedata$RemoteData$isLoading(model.dE);
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('top-actions')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('voltar-ico-blue'),
									$elm$html$Html$Attributes$title('Veículos'),
									$elm$html$Html$Events$onClick($author$project$Pages$Reports$DetailedVehicleV2$ClickedBackVehicles)
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'color', 'black'),
							$elm$html$Html$Attributes$class('inner-center')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Veículo detalhado' + vehicleName)
						])),
					A2(
					$elm$html$Html$form,
					_List_fromArray(
						[
							disabledSubmit ? $elm$html$Html$Attributes$class('') : $elm$html$Html$Events$onSubmit($author$project$Pages$Reports$DetailedVehicleV2$SubmitForm)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$article,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('filtros-container payment-guides items-center gap-2')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Início'),
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$value(
													A2($elm$core$Maybe$withDefault, '', model.T.bB)),
													$elm$html$Html$Attributes$type_('datetime-local'),
													$elm$html$Html$Attributes$step('1'),
													$elm$html$Html$Events$onInput($author$project$Pages$Reports$DetailedVehicleV2$InputtedStart),
													A2($elm$html$Html$Attributes$style, 'margin-bottom', '1rem')
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Fim'),
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$value(
													A2($elm$core$Maybe$withDefault, '', model.T.bl)),
													$elm$html$Html$Attributes$type_('datetime-local'),
													$elm$html$Html$Attributes$step('1'),
													$elm$html$Html$Events$onInput($author$project$Pages$Reports$DetailedVehicleV2$InputtedEnd),
													A2($elm$html$Html$Attributes$style, 'margin-bottom', '1rem')
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$label,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('self-center')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('action-system green-btn min-btn-with-icon '),
													$elm$html$Html$Attributes$disabled(disabledSubmit),
													$elm$html$Html$Attributes$type_('submit')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('material-symbols-outlined text-sm')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('search')
														])),
													$elm$html$Html$text('Pesquisar')
												]))
										]))
								]))
						])),
					A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = model.dE;
							switch (_v0.$) {
								case 3:
									var vehicles = _v0.a;
									var headers = _List_fromArray(
										['', 'Data/Horário', 'Evento', 'Nome', 'Cartão', 'Classe', 'Valor', 'Saldo', 'Contador de uso', 'Contador de carga', 'Contador catraca', 'Carteira']);
									return $elm$core$List$isEmpty(model.av) ? $elm$html$Html$text('Nenhum registro encontrado') : $author$project$Components$Patterns$Tables$defaultWithExpandable(
										{nF: headers, nX: true, ox: $author$project$Pages$Reports$DetailedVehicleV2$ToggleExpand, pj: model.av});
								case 0:
									return $elm$html$Html$text('Por favor, defina um período desejado ou utilize as datas padrão para realizar a busca.');
								case 1:
									return $author$project$Components$View$loading;
								default:
									var e = _v0.a;
									return $elm$html$Html$text('Ops! Algo deu errado');
							}
						}()
						]))
				]));
	});
var $author$project$Pages$Reports$DetailedVehicleV2$InputtedSerial = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Reports$DetailedVehicleV2$InputtedVehicle = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Reports$DetailedVehicleV2$algorithmToFilter = F2(
	function (queries, list) {
		var filteredVehicle = F2(
			function (key, list_) {
				return A2(
					$elm$core$Maybe$withDefault,
					list_,
					A2(
						$elm$core$Maybe$map,
						function (queryName) {
							var f = A2(
								$elm$core$Basics$composeR,
								$elm$core$String$toLower,
								$elm$core$String$contains(queryName));
							return A2(
								$elm$core$List$filter,
								function (_v0) {
									var code = _v0.l4;
									var plate = _v0.ac;
									var _v1 = _Utils_Tuple2(
										f(code),
										f(plate));
									if (_v1.a) {
										if (_v1.b) {
											return true;
										} else {
											return true;
										}
									} else {
										if (_v1.b) {
											return true;
										} else {
											return false;
										}
									}
								},
								list);
						},
						key));
			});
		var filtered = F3(
			function (filter, key, list_) {
				return A2(
					$elm$core$Maybe$withDefault,
					list_,
					A2(
						$elm$core$Maybe$map,
						function (queryName) {
							return A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									filter,
									A2(
										$elm$core$Basics$composeR,
										$elm$core$String$toLower,
										$elm$core$String$contains(queryName))),
								list);
						},
						key));
			});
		var filterDeviceSn = F2(
			function (key, list_) {
				return A2(
					$elm$core$Maybe$withDefault,
					list_,
					A2(
						$elm$core$Maybe$map,
						function (queryName) {
							return A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.mG;
									},
									A2(
										$elm$core$Basics$composeR,
										$elm$core$Maybe$map(
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.iF;
												},
												A2(
													$elm$core$Basics$composeR,
													$elm$core$String$toLower,
													$elm$core$String$contains(queryName)))),
										$elm$core$Maybe$withDefault(false))),
								list);
						},
						key));
			});
		return A2(
			filteredVehicle,
			A2($elm$core$Maybe$map, $elm$core$String$toLower, queries.k2),
			A2(
				filterDeviceSn,
				A2($elm$core$Maybe$map, $elm$core$String$toLower, queries.kw),
				list));
	});
var $author$project$Pages$Reports$DetailedVehicleV2$OpenDetails = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Pages$Reports$DetailedVehicleV2$viewRecordVehicles = F2(
	function (timezone, vehicle) {
		var onClick = $elm$html$Html$Events$onClick(
			A2($author$project$Pages$Reports$DetailedVehicleV2$OpenDetails, vehicle.dM, vehicle.l4));
		var viewTDDevice = A2(
			$elm$core$Maybe$withDefault,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[onClick]),
					_List_fromArray(
						[
							$elm$html$Html$text('-')
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[onClick]),
					_List_fromArray(
						[
							$elm$html$Html$text('-')
						]))
				]),
			A2(
				$elm$core$Maybe$map,
				function (d) {
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[onClick]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($author$project$Utils$formatDateTimeFromPosix, timezone, d.mJ))
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[onClick]),
							_List_fromArray(
								[
									$elm$html$Html$text(d.iF)
								]))
						]);
				},
				vehicle.mG));
		return _Utils_ap(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[onClick]),
					_List_fromArray(
						[
							$elm$html$Html$text(vehicle.l4)
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[onClick]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$maskPlate(vehicle.ac))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[onClick]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'Sem equipamento',
								A2(
									$elm$core$Maybe$map,
									function (_v0) {
										return 'Instalado';
									},
									vehicle.mG)))
						]))
				]),
			viewTDDevice);
	});
var $author$project$Pages$Reports$DetailedVehicleV2$viewVehicles = F2(
	function (timezone, model) {
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-black')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Veículos')
						])),
					$author$project$Components$Patterns$Forms$formSimple(
					{
						hZ: _List_fromArray(
							[
								$elm$html$Html$Attributes$class('w-full'),
								$elm$html$Html$Attributes$novalidate(true)
							]),
						L: model.L,
						jf: _List_fromArray(
							[
								A2(
								$author$project$Components$Patterns$Forms$Custom,
								'flex gap-3',
								_List_fromArray(
									[
										$author$project$Components$Patterns$Forms$Input(
										{
											ie: $elm$core$Maybe$Nothing,
											iH: model.L === 2,
											iP: _List_Nil,
											nR: _List_fromArray(
												[
													$elm$html$Html$Attributes$size(20)
												]),
											jl: $elm$core$Maybe$Just('Veículo (Código/Placa)'),
											jn: _List_fromArray(
												[
													$elm$html$Html$Attributes$class('flex flex-col'),
													A2($elm$html$Html$Attributes$style, 'width', 'max-content')
												]),
											n9: $elm$core$Maybe$Just(20),
											c3: '',
											jE: $elm$core$Maybe$Nothing,
											jF: $elm$core$Maybe$Nothing,
											jG: $elm$core$Maybe$Nothing,
											ov: $elm$core$Maybe$Nothing,
											jI: $elm$core$Maybe$Just(
												A2($elm$core$Basics$composeR, $author$project$Components$Patterns$Forms$strMaybe, $author$project$Pages$Reports$DetailedVehicleV2$InputtedVehicle)),
											hh: 'Código ou placa',
											kE: model.L === 1,
											kY: 'text',
											k1: _List_Nil,
											di: A2($elm$core$Maybe$withDefault, '', model.T.k2)
										}),
										$author$project$Components$Patterns$Forms$Input(
										{
											ie: $elm$core$Maybe$Nothing,
											iH: model.L === 2,
											iP: _List_Nil,
											nR: _List_fromArray(
												[
													$elm$html$Html$Attributes$size(20)
												]),
											jl: $elm$core$Maybe$Just('Serial'),
											jn: _List_fromArray(
												[
													$elm$html$Html$Attributes$class('flex flex-col'),
													A2($elm$html$Html$Attributes$style, 'width', 'max-content')
												]),
											n9: $elm$core$Maybe$Just(20),
											c3: '',
											jE: $elm$core$Maybe$Nothing,
											jF: $elm$core$Maybe$Nothing,
											jG: $elm$core$Maybe$Nothing,
											ov: $elm$core$Maybe$Nothing,
											jI: $elm$core$Maybe$Just(
												A2($elm$core$Basics$composeR, $author$project$Components$Patterns$Forms$strMaybe, $author$project$Pages$Reports$DetailedVehicleV2$InputtedSerial)),
											hh: '',
											kE: model.L === 1,
											kY: 'text',
											k1: _List_Nil,
											di: A2($elm$core$Maybe$withDefault, '', model.T.kw)
										})
									]))
							]),
						oc: $elm$core$Maybe$Nothing,
						pX: 'Pesquisar'
					}),
					A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = model.en;
							switch (_v0.$) {
								case 3:
									var vehicles = _v0.a;
									var recordsFiltered = A2($author$project$Pages$Reports$DetailedVehicleV2$algorithmToFilter, model.T, vehicles);
									var viewRecords = A2(
										$elm$core$List$map,
										$author$project$Pages$Reports$DetailedVehicleV2$viewRecordVehicles(timezone),
										recordsFiltered);
									var headers = _List_fromArray(
										['Código', 'Placa', 'Status', 'Data de instalação', 'Equipamento']);
									return $elm$core$List$isEmpty(viewRecords) ? $elm$html$Html$text('Nenhum registro encontrado') : $author$project$Components$Patterns$Tables$defaultClickable(
										{nF: headers, nX: true, pj: viewRecords});
								case 0:
									return $elm$html$Html$text('');
								case 1:
									return $author$project$Components$View$loading;
								default:
									var e = _v0.a;
									return $elm$html$Html$text('Ops! Algo deu errado');
							}
						}()
						]))
				]));
	});
var $author$project$Pages$Reports$DetailedVehicleV2$viewPage = F3(
	function (timezone, model, user) {
		var _v0 = model.fy;
		switch (_v0) {
			case 0:
				return A2(
					$elm$html$Html$main_,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('main-dashboard')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$section,
							_List_Nil,
							_List_fromArray(
								[$author$project$Components$View$loading]))
						]));
			case 1:
				return A2($author$project$Pages$Reports$DetailedVehicleV2$viewVehicles, timezone, model);
			default:
				return A2($author$project$Pages$Reports$DetailedVehicleV2$viewDetails, timezone, model);
		}
	});
var $author$project$Pages$Reports$DetailedVehicleV2$view = F3(
	function (model, user, shared) {
		var viewModal = $elm$html$Html$text('');
		var title = function () {
			var _v0 = model.fy;
			switch (_v0) {
				case 0:
					return 'Carregando..';
				case 1:
					return 'Veículos';
				default:
					return 'Veículo detalhado';
			}
		}();
		return _Utils_Tuple2(
			title,
			_List_fromArray(
				[
					A3($author$project$Pages$Reports$DetailedVehicleV2$viewPage, shared.kS, model, user),
					viewModal
				]));
	});
var $author$project$Pages$Reports$Divergences$BackDetails = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Reports$Divergences$CloseModal = {$: 20};
var $author$project$Pages$Reports$Divergences$SubmitBlock = {$: 4};
var $author$project$Pages$Reports$Divergences$viewModalBLOCK = F2(
	function (options, m) {
		return $author$project$Components$Patterns$Modal$simple(
			{
				hY: $elm$core$Maybe$Just(
					A2($elm$html$Html$Attributes$style, 'min-height', 'fit-content')),
				ii: '',
				il: '',
				ip: $author$project$Pages$Reports$Divergences$CloseModal,
				fD: options.jx,
				k4: A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('modal-content')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('alerta')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$src('/images/alerta-ico.svg')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$h2,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('txt-vermelho')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Atenção!')
										]))
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('center-modal')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Você está prestes a bloquear o cartão. Tem certeza de que deseja continuar?')
										]))
								])),
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mt-4')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Nome do Titular: ')
												])),
											$elm$html$Html$text(m.dE.kZ.c3)
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Número do Cartão: ')
												])),
											$elm$html$Html$text(m.dE.lO)
										]))
								]))
						])),
				k5: m.dP ? $author$project$Components$View$loading : A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex gap-4 mt-4')
						]),
					_List_fromArray(
						[
							A4(
							$author$project$Components$Patterns$Button$textSimple,
							_List_Nil,
							' mt-4',
							'Voltar',
							$author$project$Pages$Reports$Divergences$ModalMsg(
								$author$project$Pages$Reports$Divergences$BackDetails(m.dE))),
							A4(
							$author$project$Components$Patterns$Button$text,
							_List_Nil,
							'red-btn mt-4',
							'Bloquear',
							$author$project$Pages$Reports$Divergences$ModalMsg($author$project$Pages$Reports$Divergences$SubmitBlock))
						]))
			});
	});
var $author$project$Pages$Reports$Divergences$GoBlockConfirmation = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Reports$Divergences$GoIgnoreConfirmation = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Pages$Reports$Divergences$GoReprocess = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Reports$Divergences$viewIcon = function (value) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$title('Similaridade')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$strong,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-purple-main font-bold text-lg')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$elm$core$String$left,
							5,
							$elm$core$String$fromFloat(value)) + '%')
					]))
			]));
};
var $author$project$Pages$Reports$Divergences$viewLineVertical = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('line-vertical h-3/6 ')
		]),
	_List_Nil);
var $author$project$Pages$Reports$Divergences$viewModalDETAILS = F4(
	function (options, shared, user, m) {
		return $author$project$Components$Patterns$Modal$simple(
			{
				hY: $elm$core$Maybe$Just(
					A2($elm$html$Html$Attributes$style, 'min-height', 'fit-content')),
				ii: '',
				il: '',
				ip: $author$project$Pages$Reports$Divergences$CloseModal,
				fD: options.jx,
				k4: function () {
					var _v0 = m.dE;
					switch (_v0.$) {
						case 3:
							var details = _v0.a;
							return A2(
								$elm$html$Html$section,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('flex gap-3')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$article,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('rounded-lg bg-purple-tint4 p-4')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$img,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('divergence-image'),
																$elm$html$Html$Attributes$src(details.oO)
															]),
														_List_Nil)
													])),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('group-line-vertical')
													]),
												_List_fromArray(
													[
														$author$project$Pages$Reports$Divergences$viewLineVertical,
														$author$project$Pages$Reports$Divergences$viewIcon(details.pI),
														$author$project$Pages$Reports$Divergences$viewLineVertical
													])),
												A2(
												$elm$html$Html$article,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('rounded-lg bg-purple-tint4 p-4')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$img,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('divergence-image'),
																$elm$html$Html$Attributes$src(details.pQ)
															]),
														_List_Nil)
													]))
											])),
										A2(
										$elm$core$Maybe$withDefault,
										$elm$html$Html$text(''),
										A2(
											$elm$core$Maybe$map,
											function (errorStr) {
												return A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('modal-content')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$p,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('center-modal')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$strong,
																	_List_fromArray(
																		[
																			A2($elm$html$Html$Attributes$style, 'color', 'red'),
																			A2($elm$html$Html$Attributes$style, 'font-size', '1.2em')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Erro: ' + errorStr)
																		]))
																]))
														]));
											},
											details.m$)),
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-center pt-2')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$strong,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														'Última atualização ' + A2($author$project$Utils$formatDateTimeFromPosixWithSeconds, shared.kS, details.qs))
													]))
											]))
									]));
						case 0:
							return $elm$html$Html$text('Componente não iniciado.');
						case 1:
							return $author$project$Components$View$loading;
						default:
							var e = _v0.a;
							return $elm$html$Html$text('Ops! Algo deu errado');
					}
				}(),
				k5: function () {
					var _v1 = m.dE;
					switch (_v1.$) {
						case 3:
							var details = _v1.a;
							return $author$project$Services$Models$iHaveAccess(
								{
									gZ: user.hg,
									hf: $author$project$Services$Models$BIOMETRY(1),
									hQ: A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('w-full')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('flex gap-4 mt-4')
													]),
												_List_fromArray(
													[
														A4(
														$author$project$Components$Patterns$Button$textSimple,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$disabled(m.br)
															]),
														'mt-4 w-full',
														'Ignorar',
														$author$project$Pages$Reports$Divergences$ModalMsg(
															A2(
																$author$project$Pages$Reports$Divergences$GoIgnoreConfirmation,
																details.dM,
																$elm$core$Maybe$Just(details)))),
														A4(
														$author$project$Components$Patterns$Button$text,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$disabled(m.br)
															]),
														'red-btn mt-4 w-full',
														'Bloquear',
														$author$project$Pages$Reports$Divergences$ModalMsg(
															$author$project$Pages$Reports$Divergences$GoBlockConfirmation(details))),
														A4(
														$author$project$Components$Patterns$Button$text,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$disabled(m.br)
															]),
														'green-btn mt-4 w-full',
														'Reprocessar imagem',
														$author$project$Pages$Reports$Divergences$ModalMsg(
															$author$project$Pages$Reports$Divergences$GoReprocess(details.dM)))
													]))
											])),
									hR: A4($author$project$Components$Patterns$Button$textSimple, _List_Nil, ' mt-4', 'Fechar', $author$project$Pages$Reports$Divergences$CloseModal)
								});
						case 0:
							return $elm$html$Html$text('');
						case 1:
							return $elm$html$Html$text('');
						default:
							var e = _v1.a;
							return A4($author$project$Components$Patterns$Button$textSimple, _List_Nil, ' mt-4', 'Fechar', $author$project$Pages$Reports$Divergences$CloseModal);
					}
				}()
			});
	});
var $author$project$Pages$Reports$Divergences$SubmitIgnore = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Reports$Divergences$viewModalIGNORE = F2(
	function (options, m) {
		return $author$project$Components$Patterns$Modal$simple(
			{
				hY: $elm$core$Maybe$Just(
					A2($elm$html$Html$Attributes$style, 'min-height', 'fit-content')),
				ii: '',
				il: '',
				ip: $author$project$Pages$Reports$Divergences$CloseModal,
				fD: options.jx,
				k4: A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('modal-content')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('center-modal')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Você está prestes a ignorar a divergência detectada. Esta ação não pode ser desfeita.')
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Tem certeza de que deseja continuar?')
										]))
								]))
						])),
				k5: m.c_ ? $author$project$Components$View$loading : A2(
					$krisajenkins$remotedata$RemoteData$withDefault,
					$elm$html$Html$text(''),
					A2(
						$krisajenkins$remotedata$RemoteData$map,
						function (d) {
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex gap-4 mt-4')
									]),
								_List_fromArray(
									[
										A4(
										$author$project$Components$Patterns$Button$textSimple,
										_List_Nil,
										' mt-4',
										'Voltar',
										$author$project$Pages$Reports$Divergences$ModalMsg(
											$author$project$Pages$Reports$Divergences$BackDetails(d))),
										A4(
										$author$project$Components$Patterns$Button$text,
										_List_Nil,
										'red-btn mt-4',
										'Ignorar',
										$author$project$Pages$Reports$Divergences$ModalMsg(
											$author$project$Pages$Reports$Divergences$SubmitIgnore(d)))
									]));
						},
						m.dE))
			});
	});
var $author$project$Pages$Reports$Divergences$DualRangeCompMsg = function (a) {
	return {$: 22, a: a};
};
var $author$project$Pages$Reports$Divergences$InputtedDocument = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Reports$Divergences$InputtedEndDate = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Reports$Divergences$InputtedSerialCard = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Reports$Divergences$InputtedStartDate = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Reports$Divergences$SelectedClass = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Reports$Divergences$SelectedLine = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Reports$Divergences$SelectedOperator = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Reports$Divergences$SelectedType = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Reports$Divergences$SelectedVehicle = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Reports$Divergences$Submit = {$: 18};
var $author$project$Pages$Reports$Divergences$ToggleFilters = {$: 17};
var $author$project$Pages$Reports$Divergences$headers = function (hasWalletClassTypeName) {
	var walletClassTypeNameHeader = hasWalletClassTypeName ? _List_fromArray(
		['Subclasse do cartão']) : _List_Nil;
	return _Utils_ap(
		_List_fromArray(
			['Criado em', 'Nome', 'Classe do cartão']),
		_Utils_ap(
			walletClassTypeNameHeader,
			_List_fromArray(
				['Serial do cartão', 'Veículo', 'Similaridade'])));
};
var $author$project$Pages$Reports$Divergences$operatorOptions = function (operators) {
	var options_ = A2(
		$elm$core$List$map,
		function (o) {
			return _Utils_Tuple2(o.dM, o.c3);
		},
		operators);
	return A2(
		$elm$core$List$cons,
		_Utils_Tuple2('', 'Todos'),
		options_);
};
var $author$project$Pages$Reports$Divergences$optionsClass = function (classes) {
	var options_ = A2(
		$elm$core$List$map,
		function (u) {
			return _Utils_Tuple2(u.k8, u.c3);
		},
		classes);
	return A2(
		$elm$core$List$cons,
		_Utils_Tuple2('', 'Todos'),
		options_);
};
var $author$project$Pages$Reports$Divergences$optionsLines = function (lines) {
	var options_ = A2(
		$elm$core$List$map,
		function (l) {
			return _Utils_Tuple2(l.e1, l.e1 + (' - ' + l.c3));
		},
		lines);
	return A2(
		$elm$core$List$cons,
		_Utils_Tuple2('', 'Todas'),
		options_);
};
var $author$project$Pages$Reports$Divergences$optionsVehicle = function (vehicles) {
	var options_ = A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(v.dM, v.l4);
		},
		vehicles);
	return A2(
		$elm$core$List$cons,
		_Utils_Tuple2('', 'Todos'),
		options_);
};
var $author$project$Pages$Reports$Divergences$valueToUpperCase = $elm$core$String$toUpper;
var $author$project$Components$Patterns$Input$DualRange$InputtedFrom = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Patterns$Input$DualRange$InputtedTo = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Patterns$Input$DualRange$input = F5(
	function (onInputMsg, label, value, min, max) {
		return A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('border-purple-main text-black m-0 mt-2'),
					A2($elm$html$Html$Attributes$style, 'width', 'fit-content'),
					$elm$html$Html$Attributes$type_('text'),
					$elm$html$Html$Events$onInput(onInputMsg),
					$elm$html$Html$Attributes$type_('text'),
					$elm$html$Html$Attributes$id('toInput'),
					$elm$html$Html$Attributes$value(value),
					$elm$html$Html$Attributes$min(
					$elm$core$String$fromInt(min)),
					$elm$html$Html$Attributes$max(
					$elm$core$String$fromInt(max)),
					$elm$html$Html$Attributes$size(3)
				]),
			_List_Nil);
	});
var $author$project$Components$Patterns$Input$DualRange$view = function (model) {
	return A2(
		$elm$html$Html$label,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('m-0')
				]),
			model.jn),
		_List_fromArray(
			[
				function () {
				var _v0 = model.jl;
				if (!_v0.$) {
					var label = _v0.a;
					return A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('font-semibold text-purple-main')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(label)
							]));
				} else {
					return $elm$html$Html$text('');
				}
			}(),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('range_container')
					]),
				_List_fromArray(
					[
						A5($author$project$Components$Patterns$Input$DualRange$input, $author$project$Components$Patterns$Input$DualRange$InputtedFrom, 'Min', model.bq, model.e4, model.d$),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('sliders_control')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$id('fromSlider'),
										$elm$html$Html$Attributes$type_('range'),
										$elm$html$Html$Attributes$value(model.bq),
										$elm$html$Html$Attributes$min(
										$elm$core$String$fromInt(model.e4)),
										$elm$html$Html$Attributes$max(
										$elm$core$String$fromInt(model.d$)),
										$elm$html$Html$Events$onInput($author$project$Components$Patterns$Input$DualRange$InputtedFrom)
									]),
								_List_Nil),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$id('toSlider'),
										$elm$html$Html$Attributes$type_('range'),
										$elm$html$Html$Attributes$value(model.bC),
										$elm$html$Html$Attributes$min(
										$elm$core$String$fromInt(model.e4)),
										$elm$html$Html$Attributes$max(
										$elm$core$String$fromInt(model.d$)),
										$elm$html$Html$Events$onInput($author$project$Components$Patterns$Input$DualRange$InputtedTo)
									]),
								_List_Nil)
							])),
						A5($author$project$Components$Patterns$Input$DualRange$input, $author$project$Components$Patterns$Input$DualRange$InputtedTo, 'Max', model.bC, model.e4, model.d$)
					]))
			]));
};
var $author$project$Pages$Reports$Divergences$viewPagination = function (queries) {
	return A4(
		$author$project$Components$View$pagination,
		function (p) {
			return $author$project$Route$Report(
				$author$project$Route$Divergences(
					_Utils_update(
						queries,
						{bv: p})));
		},
		$author$project$Pages$Reports$Divergences$cardsPerPage,
		$elm$core$Maybe$Just(queries.bv),
		queries.gk);
};
var $author$project$Pages$Reports$Divergences$GoDetails = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$Patterns$Tables$evaluateEmptyText = function (text) {
	return $elm$core$String$isEmpty(text) ? '-' : text;
};
var $author$project$Pages$Reports$Divergences$record = F3(
	function (hasWalletClassTypeName, timezone, divergence) {
		var fromBool = function (v) {
			return v ? 'Sim' : 'Não';
		};
		var addWalletClassTypeName = hasWalletClassTypeName ? _List_fromArray(
			[divergence.k9]) : _List_Nil;
		return _Utils_ap(
			_List_fromArray(
				[
					A2($author$project$Utils$formatDateTimeFromPosixWithSeconds, timezone, divergence.ix),
					divergence.qx,
					divergence.qJ
				]),
			_Utils_ap(
				addWalletClassTypeName,
				_List_fromArray(
					[
						divergence.lO,
						A2($elm$core$Maybe$withDefault, '', divergence.k2),
						A2($elm$core$String$left, 5, divergence.pI) + '%'
					])));
	});
var $author$project$Pages$Reports$Divergences$viewRecord = F4(
	function (hasWalletClassTypeName, user, timezone, divergence) {
		var record_ = A3($author$project$Pages$Reports$Divergences$record, hasWalletClassTypeName, timezone, divergence);
		var addRecordActions = _List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex gap-2')
					]),
				_List_fromArray(
					[
						A4(
						$author$project$Components$Patterns$Button$text,
						_List_Nil,
						'',
						'Detalhes',
						$author$project$Pages$Reports$Divergences$GoDetails(divergence.dM)),
						$author$project$Services$Models$iHaveAccess(
						{
							gZ: user.hg,
							hf: $author$project$Services$Models$BIOMETRY(1),
							hQ: A4(
								$author$project$Components$Patterns$Button$icon,
								$author$project$Pages$Reports$Divergences$ModalMsg(
									A2($author$project$Pages$Reports$Divergences$GoIgnoreConfirmation, divergence.dM, $elm$core$Maybe$Nothing)),
								'icon-md icon-person-check',
								'person_check',
								'Ignorar'),
							hR: $elm$html$Html$text('')
						})
					]))
			]);
		return A2(
			$elm$core$List$append,
			A2(
				$elm$core$List$map,
				function (str) {
					return A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Components$Patterns$Tables$evaluateEmptyText(str))
							]));
				},
				record_),
			addRecordActions);
	});
var $author$project$Pages$Reports$Divergences$viewPage = F3(
	function (model, shared, user) {
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard h-dvh scroll-normal ')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-black')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Divergências')
						])),
					A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex')
								]),
							_List_fromArray(
								[
									$author$project$Components$Patterns$Forms$formSimple(
									{
										hZ: _List_fromArray(
											[
												$elm$html$Html$Attributes$class(''),
												$elm$html$Html$Attributes$novalidate(true)
											]),
										L: model.L,
										jf: _List_fromArray(
											[
												A2(
												$author$project$Components$Patterns$Forms$Custom,
												'flex gap-3',
												_List_fromArray(
													[
														$author$project$Components$Patterns$Forms$Input(
														{
															ie: $elm$core$Maybe$Nothing,
															iH: model.L === 2,
															iP: _List_Nil,
															nR: _List_fromArray(
																[
																	$elm$html$Html$Attributes$step('1')
																]),
															jl: $elm$core$Maybe$Just('Início'),
															jn: _List_fromArray(
																[
																	$elm$html$Html$Attributes$class('flex flex-col'),
																	A2($elm$html$Html$Attributes$style, 'width', 'min-content')
																]),
															n9: $elm$core$Maybe$Nothing,
															c3: '',
															jE: $elm$core$Maybe$Nothing,
															jF: $elm$core$Maybe$Nothing,
															jG: $elm$core$Maybe$Nothing,
															ov: $elm$core$Maybe$Nothing,
															jI: $elm$core$Maybe$Just(
																A2($elm$core$Basics$composeR, $author$project$Pages$Reports$Divergences$valueNotEmpty, $author$project$Pages$Reports$Divergences$InputtedStartDate)),
															hh: 'Início',
															kE: model.L === 1,
															kY: 'datetime-local',
															k1: _List_Nil,
															di: A2($elm$core$Maybe$withDefault, '', model.T.bB)
														}),
														$author$project$Components$Patterns$Forms$Input(
														{
															ie: $elm$core$Maybe$Nothing,
															iH: model.L === 2,
															iP: _List_Nil,
															nR: _List_fromArray(
																[
																	$elm$html$Html$Attributes$step('1')
																]),
															jl: $elm$core$Maybe$Just('Fim'),
															jn: _List_fromArray(
																[
																	$elm$html$Html$Attributes$class('flex flex-col'),
																	A2($elm$html$Html$Attributes$style, 'width', 'min-content')
																]),
															n9: $elm$core$Maybe$Nothing,
															c3: '',
															jE: $elm$core$Maybe$Nothing,
															jF: $elm$core$Maybe$Nothing,
															jG: $elm$core$Maybe$Nothing,
															ov: $elm$core$Maybe$Nothing,
															jI: $elm$core$Maybe$Just(
																A2($elm$core$Basics$composeR, $author$project$Pages$Reports$Divergences$valueNotEmpty, $author$project$Pages$Reports$Divergences$InputtedEndDate)),
															hh: 'Fim',
															kE: model.L === 1,
															kY: 'datetime-local',
															k1: _List_Nil,
															di: A2($elm$core$Maybe$withDefault, '', model.T.bl)
														}),
														$author$project$Components$Patterns$Forms$Html(
														A2(
															$elm$html$Html$map,
															$author$project$Pages$Reports$Divergences$DualRangeCompMsg,
															$author$project$Components$Patterns$Input$DualRange$view(model.dG))),
														$author$project$Components$Patterns$Forms$ButtonIcon(
														{
															lx: _List_fromArray(
																[
																	$elm$html$Html$Attributes$class('self-center w-40')
																]),
															l_: $author$project$Pages$Reports$Divergences$ToggleFilters,
															l4: 'filter_list',
															iH: model.L === 2,
															fD: 'Filtros extra'
														}),
														$author$project$Components$Patterns$Forms$Button(
														{
															lx: _List_fromArray(
																[
																	$elm$html$Html$Attributes$class('self-center w-40')
																]),
															l_: $author$project$Pages$Reports$Divergences$Submit,
															iH: model.L === 2,
															fD: 'Pesquisar'
														})
													])),
												A2(
												$author$project$Components$Patterns$Forms$Custom,
												'mt-4 flex gap-4 flex-wrap',
												model.dJ ? _List_fromArray(
													[
														$author$project$Components$Patterns$Forms$Input(
														{
															ie: $elm$core$Maybe$Nothing,
															iH: model.L === 2,
															iP: _List_Nil,
															nR: _List_Nil,
															jl: $elm$core$Maybe$Just('Serial do cartão'),
															jn: _List_fromArray(
																[
																	$elm$html$Html$Attributes$class('flex flex-col'),
																	A2($elm$html$Html$Attributes$style, 'width', 'fit-content')
																]),
															n9: $elm$core$Maybe$Nothing,
															c3: '',
															jE: $elm$core$Maybe$Nothing,
															jF: $elm$core$Maybe$Nothing,
															jG: $elm$core$Maybe$Nothing,
															ov: $elm$core$Maybe$Nothing,
															jI: $elm$core$Maybe$Just(
																A2(
																	$elm$core$Basics$composeR,
																	A2($elm$core$Basics$composeR, $author$project$Pages$Reports$Divergences$valueToUpperCase, $author$project$Pages$Reports$Divergences$valueNotEmpty),
																	$author$project$Pages$Reports$Divergences$InputtedSerialCard)),
															hh: '',
															kE: model.L === 1,
															kY: 'text',
															k1: _List_Nil,
															di: A2($elm$core$Maybe$withDefault, '', model.T.kx)
														}),
														$author$project$Components$Patterns$Forms$MultiSelect(
														{
															h$: _List_fromArray(
																[
																	$elm$html$Html$Attributes$class('self-end'),
																	A2($elm$html$Html$Attributes$style, 'width', 'max-content')
																]),
															fT: true,
															eS: $author$project$Pages$Reports$Divergences$classInputID,
															gO: model.dR,
															jl: 'Classe',
															jI: $author$project$Pages$Reports$Divergences$SelectedClass,
															g2: A2($author$project$Pages$Reports$Divergences$SetMultiSelect, 0, true),
															jO: A2(
																$krisajenkins$remotedata$RemoteData$withDefault,
																_List_Nil,
																A2($krisajenkins$remotedata$RemoteData$map, $author$project$Pages$Reports$Divergences$optionsClass, model.dv)),
															g7: model.T.lX,
															hh: 'Selecione múltiplas classes',
															kt: $author$project$Pages$Reports$Divergences$classSelectID
														}),
														$author$project$Components$Patterns$Forms$MultiSelect(
														{
															h$: _List_fromArray(
																[
																	$elm$html$Html$Attributes$class('self-end'),
																	A2($elm$html$Html$Attributes$style, 'width', 'max-content')
																]),
															fT: true,
															eS: $author$project$Pages$Reports$Divergences$vehicleInputID,
															gO: model.dW,
															jl: 'Veículo',
															jI: $author$project$Pages$Reports$Divergences$SelectedVehicle,
															g2: A2($author$project$Pages$Reports$Divergences$SetMultiSelect, 1, true),
															jO: A2(
																$krisajenkins$remotedata$RemoteData$withDefault,
																_List_Nil,
																A2($krisajenkins$remotedata$RemoteData$map, $author$project$Pages$Reports$Divergences$optionsVehicle, model.en)),
															g7: model.T.fN,
															hh: 'Selecione múltiplos veículos',
															kt: $author$project$Pages$Reports$Divergences$vehicleSelectID
														}),
														$author$project$Components$Patterns$Forms$Input(
														{
															ie: $elm$core$Maybe$Nothing,
															iH: model.L === 2,
															iP: _List_Nil,
															nR: _List_Nil,
															jl: $elm$core$Maybe$Just('CPF'),
															jn: _List_fromArray(
																[
																	$elm$html$Html$Attributes$class('flex flex-col'),
																	A2($elm$html$Html$Attributes$style, 'width', 'fit-content')
																]),
															n9: $elm$core$Maybe$Nothing,
															c3: '',
															jE: $elm$core$Maybe$Nothing,
															jF: $elm$core$Maybe$Nothing,
															jG: $elm$core$Maybe$Nothing,
															ov: $elm$core$Maybe$Nothing,
															jI: $elm$core$Maybe$Just(
																A2($elm$core$Basics$composeR, $author$project$Pages$Reports$Divergences$valueNotEmpty, $author$project$Pages$Reports$Divergences$InputtedDocument)),
															hh: '',
															kE: model.L === 1,
															kY: 'text',
															k1: _List_Nil,
															di: $author$project$Utils$maskCPF(
																A2($elm$core$Maybe$withDefault, '', model.T.iI))
														}),
														$author$project$Components$Patterns$Forms$MultiSelect(
														{
															h$: _List_fromArray(
																[
																	$elm$html$Html$Attributes$class('self-end'),
																	A2($elm$html$Html$Attributes$style, 'width', 'max-content')
																]),
															fT: true,
															eS: $author$project$Pages$Reports$Divergences$lineInputID,
															gO: model.dT,
															jl: 'Linhas',
															jI: $author$project$Pages$Reports$Divergences$SelectedLine,
															g2: A2($author$project$Pages$Reports$Divergences$SetMultiSelect, 2, true),
															jO: A2(
																$krisajenkins$remotedata$RemoteData$withDefault,
																_List_Nil,
																A2($krisajenkins$remotedata$RemoteData$map, $author$project$Pages$Reports$Divergences$optionsLines, model.n2)),
															g7: model.T.b3,
															hh: 'Selecione múltiplas linhas',
															kt: $author$project$Pages$Reports$Divergences$lineSelectID
														}),
														$author$project$Components$Patterns$Forms$MultiSelect(
														{
															h$: _List_fromArray(
																[
																	$elm$html$Html$Attributes$class('self-end'),
																	A2($elm$html$Html$Attributes$style, 'width', 'max-content')
																]),
															fT: true,
															eS: $author$project$Pages$Reports$Divergences$operatorInputID,
															gO: model.dU,
															jl: 'Operador',
															jI: $author$project$Pages$Reports$Divergences$SelectedOperator,
															g2: A2($author$project$Pages$Reports$Divergences$SetMultiSelect, 3, true),
															jO: A2(
																$krisajenkins$remotedata$RemoteData$withDefault,
																_List_Nil,
																A2($krisajenkins$remotedata$RemoteData$map, $author$project$Pages$Reports$Divergences$operatorOptions, model.c5)),
															g7: model.T.g6,
															hh: 'Selecione múltiplos operadores',
															kt: $author$project$Pages$Reports$Divergences$operatorSelectID
														}),
														$author$project$Components$Patterns$Forms$Select(
														{
															iH: model.L === 2,
															jl: $elm$core$Maybe$Just('Tipo'),
															jn: _List_fromArray(
																[
																	$elm$html$Html$Attributes$class('flex flex-col'),
																	A2($elm$html$Html$Attributes$style, 'width', 'fit-content')
																]),
															jI: $elm$core$Maybe$Just($author$project$Pages$Reports$Divergences$SelectedType),
															jO: _Utils_ap(
																_List_fromArray(
																	[
																		{
																		eX: _Utils_eq(model.T.kY, $elm$core$Maybe$Nothing),
																		c3: 'Tipo',
																		di: ''
																	}
																	]),
																_List_fromArray(
																	[
																		{
																		eX: _Utils_eq(
																			model.T.kY,
																			$elm$core$Maybe$Just('block')),
																		c3: 'Bloqueado',
																		di: 'block'
																	},
																		{
																		eX: _Utils_eq(
																			model.T.kY,
																			$elm$core$Maybe$Just('ignore')),
																		c3: 'Ignorado',
																		di: 'ignore'
																	},
																		{
																		eX: _Utils_eq(
																			model.T.kY,
																			$elm$core$Maybe$Just('reprocess')),
																		c3: 'Reprocessar',
																		di: 'reprocess'
																	},
																		{
																		eX: _Utils_eq(
																			model.T.kY,
																			$elm$core$Maybe$Just('error')),
																		c3: 'Erro',
																		di: 'error'
																	}
																	])),
															jQ: false,
															ks: _List_fromArray(
																[
																	A2($elm$html$Html$Attributes$style, 'margin-bottom', '0'),
																	$elm$html$Html$Attributes$class('mt-4')
																]),
															kE: model.L === 1,
															k1: _List_Nil
														})
													]) : _List_Nil)
											]),
										oc: $elm$core$Maybe$Nothing,
										pX: 'Pesquisar'
									})
								])),
							function () {
							var _v0 = model.ck;
							switch (_v0.$) {
								case 3:
									var report = _v0.a;
									var hasWalletClassTypeName = A2(
										$elm$core$List$any,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.k9;
											},
											A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not)),
										report);
									var viewRecords = A2(
										$elm$core$List$map,
										A3($author$project$Pages$Reports$Divergences$viewRecord, hasWalletClassTypeName, user, shared.kS),
										report);
									return $elm$core$List$isEmpty(viewRecords) ? $elm$html$Html$text('Nenhum registro encontrado') : $author$project$Components$Patterns$Tables$default(
										{
											nF: $author$project$Pages$Reports$Divergences$headers(hasWalletClassTypeName),
											nX: true,
											pj: viewRecords
										});
								case 0:
									return $elm$html$Html$text('Por favor, defina um período desejado ou utilize as datas padrão para realizar a busca.');
								case 1:
									return $author$project$Components$View$loading;
								default:
									return $elm$html$Html$text('Ops! Algo deu errado');
							}
						}(),
							$author$project$Pages$Reports$Divergences$viewPagination(model.T)
						]))
				]));
	});
var $author$project$Pages$Reports$Divergences$view = F3(
	function (model, user, shared) {
		var viewModal = function () {
			var _v0 = model.aY;
			if (!_v0.$) {
				switch (_v0.a.$) {
					case 0:
						var m = _v0.a.a;
						return A4(
							$author$project$Pages$Reports$Divergences$viewModalDETAILS,
							{jx: 'Detalhes'},
							shared,
							user,
							m);
					case 1:
						var m = _v0.a.a;
						return A2(
							$author$project$Pages$Reports$Divergences$viewModalBLOCK,
							{jx: 'Confirmação de Bloqueio'},
							m);
					default:
						var m = _v0.a.a;
						return A2(
							$author$project$Pages$Reports$Divergences$viewModalIGNORE,
							{jx: 'Confirmação para Ignorar Divergência'},
							m);
				}
			} else {
				return $elm$html$Html$text('');
			}
		}();
		return _Utils_Tuple2(
			'Divergências',
			_List_fromArray(
				[
					A3($author$project$Pages$Reports$Divergences$viewPage, model, shared, user),
					viewModal
				]));
	});
var $author$project$Pages$Reports$Event$Audit$ExpandFilters = {$: 10};
var $author$project$Pages$Reports$Event$Audit$InputtedEndDate = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Reports$Event$Audit$InputtedStartDate = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Reports$Event$Audit$SelectedActionType = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Reports$Event$Audit$SelectedVehicle = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Reports$Event$Audit$Submit = {$: 9};
var $author$project$Pages$Reports$Event$Audit$optionsActionTypes = function (rdResult) {
	var options_ = A2(
		$elm$core$List$map,
		function (u) {
			return _Utils_Tuple2(u.l4, u.c3);
		},
		rdResult);
	return A2(
		$elm$core$List$cons,
		_Utils_Tuple2('', 'Todos'),
		options_);
};
var $author$project$Pages$Reports$Event$Audit$vehicleOptions = function (rdVehicles) {
	var options_ = A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(v.dM, v.l4);
		},
		rdVehicles);
	return A2(
		$elm$core$List$cons,
		_Utils_Tuple2('', 'Todos'),
		options_);
};
var $author$project$Pages$Reports$Event$Audit$viewPage = F3(
	function (model, shared, user) {
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-black')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Auditorias')
						])),
					A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Components$Patterns$Forms$formSimple(
									{
										hZ: _List_fromArray(
											[
												$elm$html$Html$Attributes$class('w-full'),
												$elm$html$Html$Attributes$novalidate(true)
											]),
										L: model.L,
										jf: _List_fromArray(
											[
												A2(
												$author$project$Components$Patterns$Forms$Custom,
												'flex gap-3',
												_List_fromArray(
													[
														$author$project$Components$Patterns$Forms$Input(
														{
															ie: $elm$core$Maybe$Nothing,
															iH: model.L === 2,
															iP: _List_Nil,
															nR: _List_fromArray(
																[
																	$elm$html$Html$Attributes$size(10)
																]),
															jl: $elm$core$Maybe$Just('Início'),
															jn: _List_fromArray(
																[
																	$elm$html$Html$Attributes$class('flex flex-col'),
																	A2($elm$html$Html$Attributes$style, 'width', 'min-content')
																]),
															n9: $elm$core$Maybe$Just(10),
															c3: '',
															jE: $elm$core$Maybe$Nothing,
															jF: $elm$core$Maybe$Nothing,
															jG: $elm$core$Maybe$Nothing,
															ov: $elm$core$Maybe$Nothing,
															jI: $elm$core$Maybe$Just(
																A2($elm$core$Basics$composeR, $author$project$Pages$Reports$Event$Audit$valueNotEmpty, $author$project$Pages$Reports$Event$Audit$InputtedStartDate)),
															hh: 'Início',
															kE: model.L === 1,
															kY: 'date',
															k1: _List_Nil,
															di: A2($elm$core$Maybe$withDefault, '', model.T.bB)
														}),
														$author$project$Components$Patterns$Forms$Input(
														{
															ie: $elm$core$Maybe$Nothing,
															iH: model.L === 2,
															iP: _List_Nil,
															nR: _List_fromArray(
																[
																	$elm$html$Html$Attributes$size(10)
																]),
															jl: $elm$core$Maybe$Just('Fim'),
															jn: _List_fromArray(
																[
																	$elm$html$Html$Attributes$class('flex flex-col'),
																	A2($elm$html$Html$Attributes$style, 'width', 'min-content')
																]),
															n9: $elm$core$Maybe$Just(10),
															c3: '',
															jE: $elm$core$Maybe$Nothing,
															jF: $elm$core$Maybe$Nothing,
															jG: $elm$core$Maybe$Nothing,
															ov: $elm$core$Maybe$Nothing,
															jI: $elm$core$Maybe$Just(
																A2($elm$core$Basics$composeR, $author$project$Pages$Reports$Event$Audit$valueNotEmpty, $author$project$Pages$Reports$Event$Audit$InputtedEndDate)),
															hh: 'Fim',
															kE: model.L === 1,
															kY: 'date',
															k1: _List_Nil,
															di: A2($elm$core$Maybe$withDefault, '', model.T.bl)
														}),
														$author$project$Components$Patterns$Forms$ButtonIcon(
														{
															lx: _List_fromArray(
																[
																	$elm$html$Html$Attributes$class('self-center w-40')
																]),
															l_: $author$project$Pages$Reports$Event$Audit$ExpandFilters,
															l4: 'filter_list',
															iH: model.L === 2,
															fD: 'Filtros extra'
														}),
														$author$project$Components$Patterns$Forms$Button(
														{
															lx: _List_fromArray(
																[
																	$elm$html$Html$Attributes$class('self-center w-40')
																]),
															l_: $author$project$Pages$Reports$Event$Audit$Submit,
															iH: model.L === 2,
															fD: 'Pesquisar'
														})
													])),
												A2(
												$author$project$Components$Patterns$Forms$Custom,
												'mt-4 grid grid-cols-auto-fit-minmax gap-3',
												model.dK ? _List_fromArray(
													[
														$author$project$Components$Patterns$Forms$MultiSelect(
														{
															h$: _List_Nil,
															fT: true,
															eS: $author$project$Pages$Reports$Event$Audit$vehicleInputID,
															gO: model.dW,
															jl: 'Veículo',
															jI: $author$project$Pages$Reports$Event$Audit$SelectedVehicle,
															g2: A2($author$project$Pages$Reports$Event$Audit$SetMultiSelect, 0, true),
															jO: $author$project$Pages$Reports$Event$Audit$vehicleOptions(model.en),
															g7: model.T.en,
															hh: 'Selecione múltiplos veículos',
															kt: $author$project$Pages$Reports$Event$Audit$vehicleSelectID
														}),
														$author$project$Components$Patterns$Forms$MultiSelect(
														{
															h$: _List_Nil,
															fT: true,
															eS: $author$project$Pages$Reports$Event$Audit$actionTypeInputID,
															gO: model.dQ,
															jl: 'Tipo de ação',
															jI: $author$project$Pages$Reports$Event$Audit$SelectedActionType,
															g2: A2($author$project$Pages$Reports$Event$Audit$SetMultiSelect, 1, true),
															jO: $author$project$Pages$Reports$Event$Audit$optionsActionTypes(model.dl),
															g7: model.T.bX,
															hh: 'Selecione múltiplas ações',
															kt: $author$project$Pages$Reports$Event$Audit$actionTypeSelectID
														})
													]) : _List_Nil)
											]),
										oc: $elm$core$Maybe$Nothing,
										pX: 'Pesquisar'
									})
								])),
							function () {
							var _v0 = model.ck;
							switch (_v0.$) {
								case 3:
									var table = _v0.a;
									var rowsTdDefineHyperlink = function (url) {
										return A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$href(url)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Abrir pedido')
														]))
												]));
									};
									var rowTd = function (txt) {
										return A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(txt)
												]));
									};
									var records = A2(
										$elm$core$List$map,
										function (item) {
											return A2($author$project$Pages$Reports$Event$Audit$reportRow, shared.kS, item);
										},
										table);
									var viewRecords = A2(
										$elm$core$List$map,
										function (rows_) {
											return A2($elm$core$List$map, rowTd, rows_);
										},
										records);
									var headers = $author$project$Pages$Reports$Event$Audit$reportHeaders;
									return $elm$core$List$isEmpty(viewRecords) ? $elm$html$Html$text('Nenhum registro encontrado') : $author$project$Components$Patterns$Tables$default(
										{nF: headers, nX: true, pj: viewRecords});
								case 0:
									return $elm$html$Html$text('Por favor, insira uma data de início e fim para realizar a busca.');
								case 1:
									return $author$project$Components$View$loading;
								default:
									var e = _v0.a;
									return $elm$html$Html$text('Ops! Algo deu errado');
							}
						}()
						]))
				]));
	});
var $author$project$Pages$Reports$Event$Audit$view = F3(
	function (model, user, shared) {
		var viewModal = $elm$html$Html$text('');
		return _Utils_Tuple2(
			'Auditorias',
			_List_fromArray(
				[
					A3($author$project$Pages$Reports$Event$Audit$viewPage, model, shared, user),
					viewModal
				]));
	});
var $author$project$Pages$Reports$Event$UsingDay$GetTimeToDownload = {$: 5};
var $author$project$Pages$Reports$Event$UsingDay$InputtedStartDate = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Reports$Event$UsingDay$InputtedVEndDate = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Reports$Event$UsingDay$Submit = {$: 4};
var $author$project$Pages$Reports$Event$UsingDay$valueNotEmpty = function (str) {
	return $elm$core$String$isEmpty(str) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(str);
};
var $author$project$Pages$Reports$Event$UsingDay$alignCenter = A2($elm$html$Html$Attributes$style, 'text-align', 'center');
var $author$project$Pages$Reports$Event$UsingDay$isSubClass = function (header) {
	return !$elm$core$String$isEmpty(header.kY);
};
var $author$project$Pages$Reports$Event$UsingDay$getClassName = function (header) {
	return $author$project$Pages$Reports$Event$UsingDay$isSubClass(header) ? header.kY : header.ik;
};
var $author$project$Pages$Reports$Event$UsingDay$hasBreadClass = F2(
	function (header, data) {
		return A2(
			$elm$core$List$any,
			function (h_) {
				return _Utils_eq(header.ik, h_.ik) && (h_.kY === '');
			},
			data.nG);
	});
var $author$project$Pages$Reports$Event$UsingDay$isBreadClass = F2(
	function (header, data) {
		return A2(
			$elm$core$List$any,
			function (h_) {
				return _Utils_eq(header.ik, h_.ik) && (!$elm$core$String$isEmpty(h_.kY));
			},
			data.nG);
	});
var $author$project$Pages$Reports$Event$UsingDay$viewCell = F2(
	function (header, line) {
		var totalQuantity = ($elm$core$String$toLower(header.dM) === 'totalQuantity') ? A2(
			$elm$core$Maybe$map,
			$elm$core$String$fromInt,
			A2($elm$core$Dict$get, 'totalQuantity', line.dv)) : (($elm$core$String$toLower(header.dM) === 'totalFare') ? A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeL, $author$project$Utils$formatAsMoney, $elm$core$String$fromInt),
			A2($elm$core$Dict$get, 'totalFare', line.ni)) : $elm$core$Maybe$Nothing);
		var quantity = A2(
			$elm$core$Maybe$map,
			$elm$core$String$fromInt,
			A2($elm$core$Dict$get, header.dM, line.dv));
		var fare = A2(
			$elm$core$Maybe$map,
			$elm$core$String$fromInt,
			A2($elm$core$Dict$get, header.dM, line.ni));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			function () {
				var _v0 = _Utils_Tuple3(quantity, fare, totalQuantity);
				if (!_v0.a.$) {
					if (!_v0.b.$) {
						var q = _v0.a.a;
						var f = _v0.b.a;
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Pages$Reports$Event$UsingDay$alignCenter,
										A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(q)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Pages$Reports$Event$UsingDay$alignCenter,
										A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Utils$formatAsMoney(f))
									]))
							]);
					} else {
						var q = _v0.a.a;
						var _v2 = _v0.b;
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Pages$Reports$Event$UsingDay$alignCenter,
										A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(q)
									]))
							]);
					}
				} else {
					if (!_v0.b.$) {
						var _v1 = _v0.a;
						var f = _v0.b.a;
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Pages$Reports$Event$UsingDay$alignCenter,
										A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Utils$formatAsMoney(f))
									]))
							]);
					} else {
						if (!_v0.c.$) {
							var _v3 = _v0.a;
							var _v4 = _v0.b;
							var total = _v0.c.a;
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Pages$Reports$Event$UsingDay$alignCenter,
											A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(total)
										]))
								]);
						} else {
							var _v5 = _v0.a;
							var _v6 = _v0.b;
							var _v7 = _v0.c;
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[$author$project$Pages$Reports$Event$UsingDay$alignCenter]),
									_List_fromArray(
										[
											$elm$html$Html$text('-')
										]))
								]);
						}
					}
				}
			}());
	});
var $author$project$Pages$Reports$Event$UsingDay$viewRow = F4(
	function (timezone, data, headers_, line) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$tr,
				_List_Nil,
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('border px-4 py-2')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($author$project$Utils$formatDateFromPosix, $elm$time$Time$utc, line.fD))
							])),
					A2(
						$elm$core$List$map,
						function (header) {
							var classSubItemOrBreadTH = (($author$project$Pages$Reports$Event$UsingDay$isSubClass(header) || A2($author$project$Pages$Reports$Event$UsingDay$isBreadClass, header, data)) && A2($author$project$Pages$Reports$Event$UsingDay$hasBreadClass, header, data)) ? 'bg-gray-tint1' : '';
							return A2(
								$elm$html$Html$td,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(classSubItemOrBreadTH),
										$elm$html$Html$Attributes$class('border px-4 py-2')
									]),
								_List_fromArray(
									[
										A2($author$project$Pages$Reports$Event$UsingDay$viewCell, header, line)
									]));
						},
						headers_)))
			]);
	});
var $author$project$Pages$Reports$Event$UsingDay$viewTable = F2(
	function (timezone, data) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$table,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'border-collapse', 'collapse'),
							A2($elm$html$Html$Attributes$style, 'text-align', 'left'),
							A2($elm$html$Html$Attributes$attribute, 'cellspacing', '0'),
							$elm$html$Html$Attributes$class('data-table-dashboard my-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$thead,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_Utils_ap(
										_List_fromArray(
											[
												A2(
												$elm$html$Html$th,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Dia')
													]))
											]),
										A2(
											$elm$core$List$map,
											function (header) {
												if ((header.dM === 'totalQuantity') || (header.dM === 'totalFare')) {
													return A2(
														$elm$html$Html$th,
														_List_fromArray(
															[$author$project$Pages$Reports$Event$UsingDay$alignCenter]),
														_List_fromArray(
															[
																$elm$html$Html$text(header.ik)
															]));
												} else {
													var classSubItemOrBreadTH = (($author$project$Pages$Reports$Event$UsingDay$isSubClass(header) || A2($author$project$Pages$Reports$Event$UsingDay$isBreadClass, header, data)) && A2($author$project$Pages$Reports$Event$UsingDay$hasBreadClass, header, data)) ? 'bg-gray-tint1' : '';
													return A2(
														$elm$html$Html$th,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class(classSubItemOrBreadTH),
																$author$project$Pages$Reports$Event$UsingDay$alignCenter,
																$elm$html$Html$Attributes$alt(
																$author$project$Pages$Reports$Event$UsingDay$getClassName(header))
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('tooltip')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		$elm$core$String$toUpper(
																			A2(
																				$elm$core$String$left,
																				3,
																				$author$project$Pages$Reports$Event$UsingDay$getClassName(header)))),
																		A2(
																		$elm$html$Html$span,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('tooltiptext')
																			]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text(
																				$author$project$Pages$Reports$Event$UsingDay$getClassName(header))
																			]))
																	]))
															]));
												}
											},
											data.nG)))
								])),
							A2(
							$elm$html$Html$tbody,
							_List_Nil,
							A2(
								$elm$core$List$concatMap,
								A3($author$project$Pages$Reports$Event$UsingDay$viewRow, timezone, data, data.nG),
								data.px))
						]))
				]));
	});
var $author$project$Pages$Reports$Event$UsingDay$viewPage = F3(
	function (model, shared, user) {
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-black')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Utilização por dia baseado em eventos')
						])),
					A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex ')
								]),
							_List_fromArray(
								[
									$author$project$Components$Patterns$Forms$filters(
									{
										hZ: _List_Nil,
										lZ: '',
										mM: $krisajenkins$remotedata$RemoteData$isLoading(model.ck),
										jf: _List_fromArray(
											[
												{
												h_: _List_Nil,
												h$: _List_Nil,
												ih: 'bg-busca',
												jI: A2($elm$core$Basics$composeR, $author$project$Pages$Reports$Event$UsingDay$valueNotEmpty, $author$project$Pages$Reports$Event$UsingDay$InputtedStartDate),
												hh: 'Início',
												kQ: $elm$core$Maybe$Just('Início'),
												kY: 'date',
												di: A2($elm$core$Maybe$withDefault, '', model.T.bB)
											},
												{
												h_: _List_Nil,
												h$: _List_Nil,
												ih: 'bg-busca',
												jI: A2($elm$core$Basics$composeR, $author$project$Pages$Reports$Event$UsingDay$valueNotEmpty, $author$project$Pages$Reports$Event$UsingDay$InputtedVEndDate),
												hh: 'Fim',
												kQ: $elm$core$Maybe$Just('Fim'),
												kY: 'date',
												di: A2($elm$core$Maybe$withDefault, '', model.T.bl)
											}
											]),
										pW: $author$project$Pages$Reports$Event$UsingDay$Submit
									}),
									A2(
									$krisajenkins$remotedata$RemoteData$withDefault,
									true,
									A2(
										$krisajenkins$remotedata$RemoteData$map,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.px;
											},
											$elm$core$List$isEmpty),
										model.ck)) ? $elm$html$Html$text('') : $author$project$Components$GeneratorCSV$buttonDownload($author$project$Pages$Reports$Event$UsingDay$GetTimeToDownload)
								])),
							function () {
							var _v0 = model.ck;
							switch (_v0.$) {
								case 3:
									var table = _v0.a;
									return $elm$core$List$isEmpty(table.px) ? $elm$html$Html$text('Nenhum registro encontrado') : A2($author$project$Pages$Reports$Event$UsingDay$viewTable, shared.kS, table);
								case 0:
									return $elm$html$Html$text('Por favor, defina um período desejado ou utilize as datas padrão para realizar a busca.');
								case 1:
									return $author$project$Components$View$loading;
								default:
									var e = _v0.a;
									return $elm$html$Html$text('Ops! Algo deu errado');
							}
						}()
						]))
				]));
	});
var $author$project$Pages$Reports$Event$UsingDay$view = F3(
	function (model, user, shared) {
		var viewModal = $elm$html$Html$text('');
		return _Utils_Tuple2(
			'Utilização por dia baseado em eventos',
			_List_fromArray(
				[
					A3($author$project$Pages$Reports$Event$UsingDay$viewPage, model, shared, user),
					viewModal
				]));
	});
var $author$project$Pages$Reports$Event$UsingLine$GetTimeToDownload = {$: 8};
var $author$project$Pages$Reports$Event$UsingLine$InputtedEndDate = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Reports$Event$UsingLine$InputtedStartDate = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Reports$Event$UsingLine$SelectedLine = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Reports$Event$UsingLine$Submit = {$: 7};
var $author$project$Pages$Reports$Event$UsingLine$lineOptions = function (rdLines) {
	var options_ = A2(
		$elm$core$List$map,
		function (l) {
			return _Utils_Tuple2(l.e1, l.e1 + (' - ' + l.c3));
		},
		rdLines);
	return A2(
		$elm$core$List$cons,
		_Utils_Tuple2('', 'Todos'),
		options_);
};
var $author$project$Pages$Reports$Event$UsingLine$alignCenter = A2($elm$html$Html$Attributes$style, 'text-align', 'center');
var $author$project$Pages$Reports$Event$UsingLine$isSubClass = function (header) {
	return !$elm$core$String$isEmpty(header.kY);
};
var $author$project$Pages$Reports$Event$UsingLine$getClassName = function (header) {
	return $author$project$Pages$Reports$Event$UsingLine$isSubClass(header) ? header.kY : header.ik;
};
var $author$project$Pages$Reports$Event$UsingLine$hasBreadClass = F2(
	function (header, data) {
		return A2(
			$elm$core$List$any,
			function (h_) {
				return _Utils_eq(header.ik, h_.ik) && (h_.kY === '');
			},
			data.nG);
	});
var $author$project$Pages$Reports$Event$UsingLine$isBreadClass = F2(
	function (header, data) {
		return A2(
			$elm$core$List$any,
			function (h_) {
				return _Utils_eq(header.ik, h_.ik) && (!$elm$core$String$isEmpty(h_.kY));
			},
			data.nG);
	});
var $author$project$Pages$Reports$Event$UsingLine$viewCell = F2(
	function (header, line) {
		var totalQuantity = ($elm$core$String$toLower(header.dM) === 'totalQuantity') ? A2(
			$elm$core$Maybe$map,
			$elm$core$String$fromInt,
			A2($elm$core$Dict$get, 'totalQuantity', line.dv)) : (($elm$core$String$toLower(header.dM) === 'totalFare') ? A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeL, $author$project$Utils$formatAsMoney, $elm$core$String$fromInt),
			A2($elm$core$Dict$get, 'totalFare', line.ni)) : $elm$core$Maybe$Nothing);
		var quantity = A2(
			$elm$core$Maybe$map,
			$elm$core$String$fromInt,
			A2($elm$core$Dict$get, header.dM, line.dv));
		var fare = A2(
			$elm$core$Maybe$map,
			$elm$core$String$fromInt,
			A2($elm$core$Dict$get, header.dM, line.ni));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			function () {
				var _v0 = _Utils_Tuple3(quantity, fare, totalQuantity);
				if (!_v0.a.$) {
					if (!_v0.b.$) {
						var q = _v0.a.a;
						var f = _v0.b.a;
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Pages$Reports$Event$UsingLine$alignCenter,
										A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(q)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Pages$Reports$Event$UsingLine$alignCenter,
										A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Utils$formatAsMoney(f))
									]))
							]);
					} else {
						var q = _v0.a.a;
						var _v2 = _v0.b;
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Pages$Reports$Event$UsingLine$alignCenter,
										A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(q)
									]))
							]);
					}
				} else {
					if (!_v0.b.$) {
						var _v1 = _v0.a;
						var f = _v0.b.a;
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Pages$Reports$Event$UsingLine$alignCenter,
										A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Utils$formatAsMoney(f))
									]))
							]);
					} else {
						if (!_v0.c.$) {
							var _v3 = _v0.a;
							var _v4 = _v0.b;
							var total = _v0.c.a;
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Pages$Reports$Event$UsingLine$alignCenter,
											A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(total)
										]))
								]);
						} else {
							var _v5 = _v0.a;
							var _v6 = _v0.b;
							var _v7 = _v0.c;
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[$author$project$Pages$Reports$Event$UsingLine$alignCenter]),
									_List_fromArray(
										[
											$elm$html$Html$text('-')
										]))
								]);
						}
					}
				}
			}());
	});
var $author$project$Pages$Reports$Event$UsingLine$viewRow = F3(
	function (data, headers_, line) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$tr,
				_List_Nil,
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('border px-4 py-2')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(line.fD)
							])),
					A2(
						$elm$core$List$map,
						function (header) {
							var classSubItemOrBreadTH = (($author$project$Pages$Reports$Event$UsingLine$isSubClass(header) || A2($author$project$Pages$Reports$Event$UsingLine$isBreadClass, header, data)) && A2($author$project$Pages$Reports$Event$UsingLine$hasBreadClass, header, data)) ? 'bg-gray-tint1' : '';
							return A2(
								$elm$html$Html$td,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(classSubItemOrBreadTH),
										$elm$html$Html$Attributes$class('border px-4 py-2')
									]),
								_List_fromArray(
									[
										A2($author$project$Pages$Reports$Event$UsingLine$viewCell, header, line)
									]));
						},
						headers_)))
			]);
	});
var $author$project$Pages$Reports$Event$UsingLine$viewTable = function (data) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$table,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'border-collapse', 'collapse'),
						A2($elm$html$Html$Attributes$style, 'text-align', 'left'),
						A2($elm$html$Html$Attributes$attribute, 'cellspacing', '0'),
						$elm$html$Html$Attributes$class('data-table-dashboard my-4')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$tr,
								_List_Nil,
								_Utils_ap(
									_List_fromArray(
										[
											A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Linha')
												]))
										]),
									A2(
										$elm$core$List$map,
										function (header) {
											if ((header.dM === 'totalQuantity') || (header.dM === 'totalFare')) {
												return A2(
													$elm$html$Html$th,
													_List_fromArray(
														[$author$project$Pages$Reports$Event$UsingLine$alignCenter]),
													_List_fromArray(
														[
															$elm$html$Html$text(header.ik)
														]));
											} else {
												var classSubItemOrBreadTH = (($author$project$Pages$Reports$Event$UsingLine$isSubClass(header) || A2($author$project$Pages$Reports$Event$UsingLine$isBreadClass, header, data)) && A2($author$project$Pages$Reports$Event$UsingLine$hasBreadClass, header, data)) ? 'bg-gray-tint1' : '';
												return A2(
													$elm$html$Html$th,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class(classSubItemOrBreadTH),
															$author$project$Pages$Reports$Event$UsingLine$alignCenter,
															$elm$html$Html$Attributes$alt(
															$author$project$Pages$Reports$Event$UsingLine$getClassName(header))
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('tooltip')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$elm$core$String$toUpper(
																		A2(
																			$elm$core$String$left,
																			3,
																			$author$project$Pages$Reports$Event$UsingLine$getClassName(header)))),
																	A2(
																	$elm$html$Html$span,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('tooltiptext')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Pages$Reports$Event$UsingLine$getClassName(header))
																		]))
																]))
														]));
											}
										},
										data.nG)))
							])),
						A2(
						$elm$html$Html$tbody,
						_List_Nil,
						A2(
							$elm$core$List$concatMap,
							A2($author$project$Pages$Reports$Event$UsingLine$viewRow, data, data.nG),
							data.px))
					]))
			]));
};
var $author$project$Pages$Reports$Event$UsingLine$viewPage = F2(
	function (model, user) {
		var buttonCsv = A2(
			$krisajenkins$remotedata$RemoteData$withDefault,
			true,
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.px;
					},
					$elm$core$List$isEmpty),
				model.ck)) ? _List_Nil : _List_fromArray(
			[
				$author$project$Components$Patterns$Forms$Button(
				{
					lx: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('self-center w-40')
						]),
					l_: $author$project$Pages$Reports$Event$UsingLine$GetTimeToDownload,
					iH: model.L === 2,
					fD: 'Baixar CSV'
				})
			]);
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-black')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Utilização por linha baseado em eventos')
						])),
					A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex ')
								]),
							_List_fromArray(
								[
									$author$project$Components$Patterns$Forms$formSimple(
									{
										hZ: _List_fromArray(
											[
												$elm$html$Html$Attributes$class(''),
												$elm$html$Html$Attributes$novalidate(true)
											]),
										L: model.L,
										jf: _List_fromArray(
											[
												A2(
												$author$project$Components$Patterns$Forms$Custom,
												'flex gap-3',
												_Utils_ap(
													_List_fromArray(
														[
															$author$project$Components$Patterns$Forms$Input(
															{
																ie: $elm$core$Maybe$Nothing,
																iH: model.L === 2,
																iP: _List_Nil,
																nR: _List_fromArray(
																	[
																		$elm$html$Html$Attributes$size(10)
																	]),
																jl: $elm$core$Maybe$Just('Início'),
																jn: _List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('flex flex-col'),
																		A2($elm$html$Html$Attributes$style, 'width', 'min-content')
																	]),
																n9: $elm$core$Maybe$Just(10),
																c3: '',
																jE: $elm$core$Maybe$Nothing,
																jF: $elm$core$Maybe$Nothing,
																jG: $elm$core$Maybe$Nothing,
																ov: $elm$core$Maybe$Nothing,
																jI: $elm$core$Maybe$Just(
																	A2($elm$core$Basics$composeR, $author$project$Pages$Reports$Event$UsingLine$valueNotEmpty, $author$project$Pages$Reports$Event$UsingLine$InputtedStartDate)),
																hh: 'Início',
																kE: model.L === 1,
																kY: 'date',
																k1: _List_Nil,
																di: A2($elm$core$Maybe$withDefault, '', model.T.bB)
															}),
															$author$project$Components$Patterns$Forms$Input(
															{
																ie: $elm$core$Maybe$Nothing,
																iH: model.L === 2,
																iP: _List_Nil,
																nR: _List_fromArray(
																	[
																		$elm$html$Html$Attributes$size(10)
																	]),
																jl: $elm$core$Maybe$Just('Fim'),
																jn: _List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('flex flex-col'),
																		A2($elm$html$Html$Attributes$style, 'width', 'min-content')
																	]),
																n9: $elm$core$Maybe$Just(10),
																c3: '',
																jE: $elm$core$Maybe$Nothing,
																jF: $elm$core$Maybe$Nothing,
																jG: $elm$core$Maybe$Nothing,
																ov: $elm$core$Maybe$Nothing,
																jI: $elm$core$Maybe$Just(
																	A2($elm$core$Basics$composeR, $author$project$Pages$Reports$Event$UsingLine$valueNotEmpty, $author$project$Pages$Reports$Event$UsingLine$InputtedEndDate)),
																hh: 'Fim',
																kE: model.L === 1,
																kY: 'date',
																k1: _List_Nil,
																di: A2($elm$core$Maybe$withDefault, '', model.T.bl)
															}),
															$author$project$Components$Patterns$Forms$MultiSelect(
															{
																h$: _List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('self-end'),
																		A2($elm$html$Html$Attributes$style, 'width', 'max-content')
																	]),
																fT: false,
																eS: $author$project$Pages$Reports$Event$UsingLine$lineInputID,
																gO: model.dT,
																jl: 'Linha',
																jI: $author$project$Pages$Reports$Event$UsingLine$SelectedLine,
																g2: A2($author$project$Pages$Reports$Event$UsingLine$SetMultiSelect, 0, true),
																jO: $author$project$Pages$Reports$Event$UsingLine$lineOptions(model.n2),
																g7: model.T.n2,
																hh: 'Selecione múltiplas linhas',
																kt: $author$project$Pages$Reports$Event$UsingLine$lineSelectID
															}),
															$author$project$Components$Patterns$Forms$Button(
															{
																lx: _List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('self-center w-40')
																	]),
																l_: $author$project$Pages$Reports$Event$UsingLine$Submit,
																iH: model.L === 2,
																fD: 'Pesquisar'
															})
														]),
													buttonCsv))
											]),
										oc: $elm$core$Maybe$Nothing,
										pX: 'Pesquisar'
									})
								])),
							function () {
							var _v0 = model.ck;
							switch (_v0.$) {
								case 3:
									var table = _v0.a;
									return $elm$core$List$isEmpty(table.px) ? $elm$html$Html$text('Nenhum registro encontrado') : $author$project$Pages$Reports$Event$UsingLine$viewTable(table);
								case 0:
									return $elm$html$Html$text('Por favor, defina um período desejado ou utilize as datas padrão para realizar a busca.');
								case 1:
									return $author$project$Components$View$loading;
								default:
									var e = _v0.a;
									return $elm$html$Html$text('Ops! Algo deu errado');
							}
						}()
						]))
				]));
	});
var $author$project$Pages$Reports$Event$UsingLine$view = F3(
	function (model, user, shared) {
		var viewModal = $elm$html$Html$text('');
		return _Utils_Tuple2(
			'Utilização por linha baseado em eventos',
			_List_fromArray(
				[
					A2($author$project$Pages$Reports$Event$UsingLine$viewPage, model, user),
					viewModal
				]));
	});
var $author$project$Pages$Reports$Event$UsingOperator$GetTimeToDownload = {$: 7};
var $author$project$Pages$Reports$Event$UsingOperator$InputtedEndDate = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Reports$Event$UsingOperator$InputtedStartDate = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Reports$Event$UsingOperator$SelectedLine = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Reports$Event$UsingOperator$Submit = {$: 6};
var $author$project$Pages$Reports$Event$UsingOperator$operatorsOptions = function (rdLines) {
	var options_ = A2(
		$elm$core$List$map,
		function (op) {
			return _Utils_Tuple2(op.dM, op.c3);
		},
		rdLines);
	return A2(
		$elm$core$List$cons,
		_Utils_Tuple2('', 'Todos'),
		options_);
};
var $author$project$Pages$Reports$Event$UsingOperator$alignCenter = A2($elm$html$Html$Attributes$style, 'text-align', 'center');
var $author$project$Pages$Reports$Event$UsingOperator$isSubClass = function (header) {
	return !$elm$core$String$isEmpty(header.kY);
};
var $author$project$Pages$Reports$Event$UsingOperator$getClassName = function (header) {
	return $author$project$Pages$Reports$Event$UsingOperator$isSubClass(header) ? header.kY : header.ik;
};
var $author$project$Pages$Reports$Event$UsingOperator$hasBreadClass = F2(
	function (header, data) {
		return A2(
			$elm$core$List$any,
			function (h_) {
				return _Utils_eq(header.ik, h_.ik) && (h_.kY === '');
			},
			data.nG);
	});
var $author$project$Pages$Reports$Event$UsingOperator$isBreadClass = F2(
	function (header, data) {
		return A2(
			$elm$core$List$any,
			function (h_) {
				return _Utils_eq(header.ik, h_.ik) && (!$elm$core$String$isEmpty(h_.kY));
			},
			data.nG);
	});
var $author$project$Pages$Reports$Event$UsingOperator$viewCell = F2(
	function (header, line) {
		var totalQuantity = ($elm$core$String$toLower(header.dM) === 'totalQuantity') ? A2(
			$elm$core$Maybe$map,
			$elm$core$String$fromInt,
			A2($elm$core$Dict$get, 'totalQuantity', line.dv)) : (($elm$core$String$toLower(header.dM) === 'totalFare') ? A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeL, $author$project$Utils$formatAsMoney, $elm$core$String$fromInt),
			A2($elm$core$Dict$get, 'totalFare', line.ni)) : $elm$core$Maybe$Nothing);
		var quantity = A2(
			$elm$core$Maybe$map,
			$elm$core$String$fromInt,
			A2($elm$core$Dict$get, header.dM, line.dv));
		var fare = A2(
			$elm$core$Maybe$map,
			$elm$core$String$fromInt,
			A2($elm$core$Dict$get, header.dM, line.ni));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			function () {
				var _v0 = _Utils_Tuple3(quantity, fare, totalQuantity);
				if (!_v0.a.$) {
					if (!_v0.b.$) {
						var q = _v0.a.a;
						var f = _v0.b.a;
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Pages$Reports$Event$UsingOperator$alignCenter,
										A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(q)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Pages$Reports$Event$UsingOperator$alignCenter,
										A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Utils$formatAsMoney(f))
									]))
							]);
					} else {
						var q = _v0.a.a;
						var _v2 = _v0.b;
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Pages$Reports$Event$UsingOperator$alignCenter,
										A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(q)
									]))
							]);
					}
				} else {
					if (!_v0.b.$) {
						var _v1 = _v0.a;
						var f = _v0.b.a;
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Pages$Reports$Event$UsingOperator$alignCenter,
										A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Utils$formatAsMoney(f))
									]))
							]);
					} else {
						if (!_v0.c.$) {
							var _v3 = _v0.a;
							var _v4 = _v0.b;
							var total = _v0.c.a;
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Pages$Reports$Event$UsingOperator$alignCenter,
											A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(total)
										]))
								]);
						} else {
							var _v5 = _v0.a;
							var _v6 = _v0.b;
							var _v7 = _v0.c;
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[$author$project$Pages$Reports$Event$UsingOperator$alignCenter]),
									_List_fromArray(
										[
											$elm$html$Html$text('-')
										]))
								]);
						}
					}
				}
			}());
	});
var $author$project$Pages$Reports$Event$UsingOperator$viewRow = F3(
	function (data, headers_, line) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$tr,
				_List_Nil,
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('border px-4 py-2')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(line.fD)
							])),
					A2(
						$elm$core$List$map,
						function (header) {
							var classSubItemOrBreadTH = (($author$project$Pages$Reports$Event$UsingOperator$isSubClass(header) || A2($author$project$Pages$Reports$Event$UsingOperator$isBreadClass, header, data)) && A2($author$project$Pages$Reports$Event$UsingOperator$hasBreadClass, header, data)) ? 'bg-gray-tint1' : '';
							return A2(
								$elm$html$Html$td,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(classSubItemOrBreadTH),
										$elm$html$Html$Attributes$class('border px-4 py-2')
									]),
								_List_fromArray(
									[
										A2($author$project$Pages$Reports$Event$UsingOperator$viewCell, header, line)
									]));
						},
						headers_)))
			]);
	});
var $author$project$Pages$Reports$Event$UsingOperator$viewTable = function (data) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$table,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'border-collapse', 'collapse'),
						A2($elm$html$Html$Attributes$style, 'text-align', 'left'),
						A2($elm$html$Html$Attributes$attribute, 'cellspacing', '0'),
						$elm$html$Html$Attributes$class('data-table-dashboard my-4')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$tr,
								_List_Nil,
								_Utils_ap(
									_List_fromArray(
										[
											A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Operador')
												]))
										]),
									A2(
										$elm$core$List$map,
										function (header) {
											if ((header.dM === 'totalQuantity') || (header.dM === 'totalFare')) {
												return A2(
													$elm$html$Html$th,
													_List_fromArray(
														[$author$project$Pages$Reports$Event$UsingOperator$alignCenter]),
													_List_fromArray(
														[
															$elm$html$Html$text(header.ik)
														]));
											} else {
												var classSubItemOrBreadTH = (($author$project$Pages$Reports$Event$UsingOperator$isSubClass(header) || A2($author$project$Pages$Reports$Event$UsingOperator$isBreadClass, header, data)) && A2($author$project$Pages$Reports$Event$UsingOperator$hasBreadClass, header, data)) ? 'bg-gray-tint1' : '';
												return A2(
													$elm$html$Html$th,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class(classSubItemOrBreadTH),
															$author$project$Pages$Reports$Event$UsingOperator$alignCenter,
															$elm$html$Html$Attributes$alt(
															$author$project$Pages$Reports$Event$UsingOperator$getClassName(header))
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('tooltip')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$elm$core$String$toUpper(
																		A2(
																			$elm$core$String$left,
																			3,
																			$author$project$Pages$Reports$Event$UsingOperator$getClassName(header)))),
																	A2(
																	$elm$html$Html$span,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('tooltiptext')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Pages$Reports$Event$UsingOperator$getClassName(header))
																		]))
																]))
														]));
											}
										},
										data.nG)))
							])),
						A2(
						$elm$html$Html$tbody,
						_List_Nil,
						A2(
							$elm$core$List$concatMap,
							A2($author$project$Pages$Reports$Event$UsingOperator$viewRow, data, data.nG),
							data.px))
					]))
			]));
};
var $author$project$Pages$Reports$Event$UsingOperator$viewPage = F3(
	function (model, shared, user) {
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-black')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Utilização por operador baseado em eventos')
						])),
					A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex gap-4')
								]),
							_List_fromArray(
								[
									$author$project$Components$Patterns$Forms$formSimple(
									{
										hZ: _List_fromArray(
											[
												$elm$html$Html$Attributes$class('flex gap-4 '),
												$elm$html$Html$Attributes$novalidate(true)
											]),
										L: 0,
										jf: _List_fromArray(
											[
												$author$project$Components$Patterns$Forms$Input(
												{
													ie: $elm$core$Maybe$Nothing,
													iH: $krisajenkins$remotedata$RemoteData$isLoading(model.ck),
													iP: _List_Nil,
													nR: _List_fromArray(
														[
															$elm$html$Html$Attributes$size(10)
														]),
													jl: $elm$core$Maybe$Just('Início'),
													jn: _List_fromArray(
														[
															$elm$html$Html$Attributes$class('flex flex-col'),
															A2($elm$html$Html$Attributes$style, 'width', 'min-content')
														]),
													n9: $elm$core$Maybe$Just(10),
													c3: '',
													jE: $elm$core$Maybe$Nothing,
													jF: $elm$core$Maybe$Nothing,
													jG: $elm$core$Maybe$Nothing,
													ov: $elm$core$Maybe$Nothing,
													jI: $elm$core$Maybe$Just(
														A2($elm$core$Basics$composeR, $author$project$Pages$Reports$Event$UsingOperator$valueNotEmpty, $author$project$Pages$Reports$Event$UsingOperator$InputtedStartDate)),
													hh: 'Início',
													kE: false,
													kY: 'date',
													k1: _List_Nil,
													di: A2($elm$core$Maybe$withDefault, '', model.T.bB)
												}),
												$author$project$Components$Patterns$Forms$Input(
												{
													ie: $elm$core$Maybe$Nothing,
													iH: $krisajenkins$remotedata$RemoteData$isLoading(model.ck),
													iP: _List_Nil,
													nR: _List_fromArray(
														[
															$elm$html$Html$Attributes$size(10)
														]),
													jl: $elm$core$Maybe$Just('Fim'),
													jn: _List_fromArray(
														[
															$elm$html$Html$Attributes$class('flex flex-col'),
															A2($elm$html$Html$Attributes$style, 'width', 'min-content')
														]),
													n9: $elm$core$Maybe$Just(10),
													c3: '',
													jE: $elm$core$Maybe$Nothing,
													jF: $elm$core$Maybe$Nothing,
													jG: $elm$core$Maybe$Nothing,
													ov: $elm$core$Maybe$Nothing,
													jI: $elm$core$Maybe$Just(
														A2($elm$core$Basics$composeR, $author$project$Pages$Reports$Event$UsingOperator$valueNotEmpty, $author$project$Pages$Reports$Event$UsingOperator$InputtedEndDate)),
													hh: 'Fim',
													kE: false,
													kY: 'date',
													k1: _List_Nil,
													di: A2($elm$core$Maybe$withDefault, '', model.T.bl)
												}),
												$author$project$Components$Patterns$Forms$MultiSelect(
												{
													h$: _List_fromArray(
														[
															A2($elm$html$Html$Attributes$style, 'width', 'max-content'),
															$elm$html$Html$Attributes$class('self-end')
														]),
													fT: true,
													eS: $author$project$Pages$Reports$Event$UsingOperator$operatorInputID,
													gO: model.dU,
													jl: 'Operador',
													jI: $author$project$Pages$Reports$Event$UsingOperator$SelectedLine,
													g2: A2($author$project$Pages$Reports$Event$UsingOperator$SetMultiSelect, 0, true),
													jO: $author$project$Pages$Reports$Event$UsingOperator$operatorsOptions(model.c5),
													g7: model.T.c5,
													hh: 'Selecione múltiplos operadores',
													kt: $author$project$Pages$Reports$Event$UsingOperator$operatorSelectID
												}),
												$author$project$Components$Patterns$Forms$Button(
												{
													lx: _List_fromArray(
														[
															$elm$html$Html$Attributes$class('self-center w-40')
														]),
													l_: $author$project$Pages$Reports$Event$UsingOperator$Submit,
													iH: _Utils_eq(model.T.bB, $elm$core$Maybe$Nothing) || _Utils_eq(model.T.bl, $elm$core$Maybe$Nothing),
													fD: 'Pesquisar'
												}),
												A2(
												$krisajenkins$remotedata$RemoteData$withDefault,
												true,
												A2(
													$krisajenkins$remotedata$RemoteData$map,
													A2(
														$elm$core$Basics$composeR,
														function ($) {
															return $.px;
														},
														$elm$core$List$isEmpty),
													model.ck)) ? $author$project$Components$Patterns$Forms$Html(
												$elm$html$Html$text('')) : $author$project$Components$Patterns$Forms$Button(
												{
													lx: _List_fromArray(
														[
															$elm$html$Html$Attributes$class('self-center w-40')
														]),
													l_: $author$project$Pages$Reports$Event$UsingOperator$GetTimeToDownload,
													iH: false,
													fD: 'Baixar CSV'
												})
											]),
										oc: $elm$core$Maybe$Nothing,
										pX: 'Pesquisar'
									})
								])),
							function () {
							var _v0 = model.ck;
							switch (_v0.$) {
								case 3:
									var table = _v0.a;
									return $elm$core$List$isEmpty(table.px) ? $elm$html$Html$text('Nenhum registro encontrado') : $author$project$Pages$Reports$Event$UsingOperator$viewTable(table);
								case 0:
									return $elm$html$Html$text('Por favor, defina um período desejado ou utilize as datas padrão para realizar a busca.');
								case 1:
									return $author$project$Components$View$loading;
								default:
									var e = _v0.a;
									return $elm$html$Html$text('Ops! Algo deu errado');
							}
						}()
						]))
				]));
	});
var $author$project$Pages$Reports$Event$UsingOperator$view = F3(
	function (model, user, shared) {
		var viewModal = $elm$html$Html$text('');
		return _Utils_Tuple2(
			'Utilização por operador baseado em eventos',
			_List_fromArray(
				[
					A3($author$project$Pages$Reports$Event$UsingOperator$viewPage, model, shared, user),
					viewModal
				]));
	});
var $author$project$Services$Pdf$Cashiers = 1;
var $author$project$Pages$Reports$Event$UsingSession$InputtedEndDate = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Reports$Event$UsingSession$InputtedStartDate = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Reports$Event$UsingSession$SelectedLine = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Reports$Event$UsingSession$SelectedOperator = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Reports$Event$UsingSession$SelectedVehicle = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Reports$Event$UsingSession$Submit = {$: 11};
var $author$project$Pages$Reports$Event$UsingSession$ToggleFilters = {$: 10};
var $author$project$Pages$Reports$Event$UsingSession$lineOptions = function (lines) {
	var options_ = A2(
		$elm$core$List$map,
		function (l) {
			return _Utils_Tuple2(l.e1, l.e1 + (' - ' + l.c3));
		},
		lines);
	return A2(
		$elm$core$List$cons,
		_Utils_Tuple2('', 'Todos'),
		options_);
};
var $author$project$Pages$Reports$Event$UsingSession$operatorOptions = function (operators) {
	var options_ = A2(
		$elm$core$List$map,
		function (op) {
			return _Utils_Tuple2(op.dM, op.c3);
		},
		operators);
	return A2(
		$elm$core$List$cons,
		_Utils_Tuple2('', 'Todos'),
		options_);
};
var $author$project$Pages$Reports$Event$UsingSession$listToStr = function (list) {
	var _v0 = A2($elm$core$String$join, ',', list);
	if (_v0 === '') {
		return $elm$core$Maybe$Nothing;
	} else {
		var str = _v0;
		return $elm$core$Maybe$Just(str);
	}
};
var $author$project$Pages$Reports$Event$UsingSession$queriesToFilter = function (queries) {
	var maybeQ = F2(
		function (param, mValue) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (v) {
						return $elm$core$List$singleton(
							{oK: param, di: v});
					},
					mValue));
		});
	return _Utils_ap(
		A2(maybeQ, 'start', queries.bB),
		_Utils_ap(
			A2(maybeQ, 'end', queries.bl),
			_Utils_ap(
				A2(
					maybeQ,
					'operatorID',
					$author$project$Pages$Reports$Event$UsingSession$listToStr(queries.c5)),
				_Utils_ap(
					A2(
						maybeQ,
						'vehicleID',
						$author$project$Pages$Reports$Event$UsingSession$listToStr(queries.en)),
					A2(
						maybeQ,
						'lineCode',
						$author$project$Pages$Reports$Event$UsingSession$listToStr(queries.n2))))));
};
var $author$project$Pages$Reports$Event$UsingSession$vehicleOptions = function (vehicles) {
	var options_ = A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(v.dM, v.l4);
		},
		vehicles);
	return A2(
		$elm$core$List$cons,
		_Utils_Tuple2('', 'Todos'),
		options_);
};
var $author$project$Pages$Reports$Event$UsingSession$alignCenter = A2($elm$html$Html$Attributes$style, 'text-align', 'center');
var $author$project$Pages$Reports$Event$UsingSession$extraColum = function (data) {
	var allColl = $elm$core$Set$toList(
		$elm$core$Set$fromList(
			A2(
				$elm$core$List$map,
				function (s) {
					return _Utils_Tuple2(s.lY, s.ik);
				},
				$elm$core$List$concat(
					A2(
						$elm$core$List$map,
						function ($) {
							return $.kJ;
						},
						data)))));
	return allColl;
};
var $author$project$Pages$Reports$Event$UsingSession$headersHtml = function (extraColum_) {
	var thDefault = function (txt) {
		return A2(
			$elm$html$Html$th,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(txt)
				]));
	};
	var ec = function (className) {
		return A2(
			$elm$html$Html$th,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$alt(className)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tooltip')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$toUpper(
								A2($elm$core$String$left, 3, className))),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('tooltiptext')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(className)
								]))
						]))
				]));
	};
	return _Utils_ap(
		_List_fromArray(
			[
				thDefault('Veículo'),
				thDefault('Linha'),
				thDefault('Abertura/Fechamento'),
				thDefault('Operadores')
			]),
		_Utils_ap(
			A2(
				$elm$core$List$map,
				A2($elm$core$Basics$composeR, $elm$core$Tuple$second, ec),
				extraColum_),
			_List_fromArray(
				[
					thDefault('Total'),
					thDefault('Catraca Inicial'),
					thDefault('Catraca Final')
				])));
};
var $author$project$Pages$Reports$Event$UsingSession$NoOp = {$: 14};
var $author$project$Pages$Reports$Event$UsingSession$viewRows = F4(
	function (allData, extraColum_, timezone, data) {
		var extraCell = A2(
			$elm$core$List$map,
			function (_v1) {
				var id = _v1.a;
				return A2(
					$elm$html$Html$td,
					_List_fromArray(
						[$author$project$Pages$Reports$Event$UsingSession$alignCenter]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(
								$elm$core$List$sum(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iw;
										},
										A2(
											$elm$core$List$filter,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.lY;
												},
												$elm$core$Basics$eq(id)),
											data.kJ)))))
						]));
			},
			extraColum_);
		var btnGoUsesPerClass = function () {
			var q = {
				ic: $elm$core$Maybe$Just(data.dM),
				bl: $elm$core$Maybe$Nothing,
				nB: $elm$core$Maybe$Nothing,
				b3: $elm$core$Maybe$Nothing,
				g6: $elm$core$Maybe$Nothing,
				bv: 1,
				bB: $elm$core$Maybe$Nothing,
				fN: $elm$core$Maybe$Nothing
			};
			var route = $author$project$Route$Report(
				$author$project$Route$UsesPerClass(q));
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$target('_blank'),
						$elm$html$Html$Attributes$href(
						$author$project$Route$toString(route))
					]),
				_List_fromArray(
					[
						A4(
						$author$project$Components$Patterns$Button$textSimple,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'width', 'max-content')
							]),
						'green-btn m-0 px-2',
						'Ver Usos Agrupado',
						$author$project$Pages$Reports$Event$UsingSession$NoOp)
					]));
		}();
		var btnGoUsage = function () {
			var q = {
				ic: $elm$core$Maybe$Just(data.dM),
				lX: $elm$core$Maybe$Nothing,
				bl: $elm$core$Maybe$Nothing,
				b3: $elm$core$Maybe$Nothing,
				g6: $elm$core$Maybe$Nothing,
				bv: 1,
				kx: $elm$core$Maybe$Nothing,
				bB: $elm$core$Maybe$Nothing,
				fN: $elm$core$Maybe$Nothing
			};
			var route = $author$project$Route$Report(
				$author$project$Route$Usage(q));
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$target('_blank'),
						$elm$html$Html$Attributes$href(
						$author$project$Route$toString(route))
					]),
				_List_fromArray(
					[
						A4($author$project$Components$Patterns$Button$textSimple, _List_Nil, 'green-btn m-0 ', 'Ver Usos', $author$project$Pages$Reports$Event$UsingSession$NoOp)
					]));
		}();
		return _Utils_ap(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(data.em)
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(data.e1)
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'-',
								A2(
									$elm$core$Maybe$map,
									$author$project$Utils$formatDateTimeFromPosixWithSeconds(timezone),
									data.jL))),
							A2($elm$html$Html$br, _List_Nil, _List_Nil),
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'-',
								A2(
									$elm$core$Maybe$map,
									$author$project$Utils$formatDateTimeFromPosixWithSeconds(timezone),
									data.l2)))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$emptyStrDefault(data.jK)),
							($elm$core$List$length(extraCell) > 3) ? A2($elm$html$Html$br, _List_Nil, _List_Nil) : $elm$html$Html$text(''),
							$elm$html$Html$text(
							function () {
								var _v0 = _Utils_Tuple2(data.jK, data.l1);
								if (_v0.b === '') {
									return ' | -';
								} else {
									var str = _v0.a;
									var str2 = _v0.b;
									return (!_Utils_eq(str, str2)) ? (' | ' + str2) : '';
								}
							}())
						]))
				]),
			_Utils_ap(
				extraCell,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[$author$project$Pages$Reports$Event$UsingSession$alignCenter]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(data.kV))
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[$author$project$Pages$Reports$Event$UsingSession$alignCenter]),
						_List_fromArray(
							[
								$elm$html$Html$text(data.oB)
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[$author$project$Pages$Reports$Event$UsingSession$alignCenter]),
						_List_fromArray(
							[
								$elm$html$Html$text(data.l0)
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex gap-2')
							]),
						_List_fromArray(
							[btnGoUsage, btnGoUsesPerClass]))
					])));
	});
var $author$project$Pages$Reports$Event$UsingSession$viewTable = F2(
	function (timezone, data) {
		var extraColum_ = $author$project$Pages$Reports$Event$UsingSession$extraColum(data);
		var lastRow = _Utils_ap(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$colspan(4),
							$elm$html$Html$Attributes$class('font-bold text-xl')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Totais no período')
						]))
				]),
			_Utils_ap(
				A2(
					$elm$core$List$map,
					function (_v0) {
						var id = _v0.a;
						var spinsCounts = $elm$core$List$sum(
							A2(
								$elm$core$List$map,
								function ($) {
									return $.iw;
								},
								A2(
									$elm$core$List$filter,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.lY;
										},
										$elm$core$Basics$eq(id)),
									A2(
										$elm$core$List$concatMap,
										function ($) {
											return $.kJ;
										},
										data))));
						return A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'color', '#6e46c8'),
									$elm$html$Html$Attributes$class('font-bold text-xl'),
									$author$project$Pages$Reports$Event$UsingSession$alignCenter
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(spinsCounts))
								]));
					},
					extraColum_),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'color', '#6e46c8'),
								$elm$html$Html$Attributes$class('font-bold text-xl'),
								$author$project$Pages$Reports$Event$UsingSession$alignCenter
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(
									A3(
										$elm$core$List$foldl,
										$elm$core$Basics$add,
										0,
										A2(
											$elm$core$List$map,
											function ($) {
												return $.kV;
											},
											data))))
							])),
						A2($elm$html$Html$td, _List_Nil, _List_Nil),
						A2($elm$html$Html$td, _List_Nil, _List_Nil),
						A2($elm$html$Html$td, _List_Nil, _List_Nil)
					])));
		return $author$project$Components$Patterns$Tables$headerAndRecordsCustomizable(
			{
				nF: $author$project$Pages$Reports$Event$UsingSession$headersHtml(extraColum_),
				nX: false,
				pj: _Utils_ap(
					A2(
						$elm$core$List$map,
						A3($author$project$Pages$Reports$Event$UsingSession$viewRows, data, extraColum_, timezone),
						data),
					_List_fromArray(
						[lastRow]))
			});
	});
var $author$project$Pages$Reports$Event$UsingSession$viewPage = F3(
	function (model, shared, user) {
		var buttonCsv = A2(
			$krisajenkins$remotedata$RemoteData$withDefault,
			true,
			A2($krisajenkins$remotedata$RemoteData$map, $elm$core$List$isEmpty, model.ck)) ? _List_Nil : _List_fromArray(
			[
				$author$project$Components$Patterns$Forms$Button(
				{
					lx: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('self-center w-40')
						]),
					l_: $author$project$Pages$Reports$Event$UsingSession$CompPDFCreateMSg(
						A4(
							$author$project$Components$PDF$Create$ClickedOpenModal,
							_Utils_Tuple2(false, true),
							1,
							1,
							$author$project$Pages$Reports$Event$UsingSession$queriesToFilter(model.T))),
					iH: model.L === 2,
					fD: 'Baixar CSV'
				})
			]);
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-black')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Utilização por sessão baseado em eventos')
						])),
					A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex gap-4')
								]),
							_List_fromArray(
								[
									$author$project$Components$Patterns$Forms$formSimple(
									{
										hZ: _List_fromArray(
											[
												$elm$html$Html$Attributes$class('w-full'),
												$elm$html$Html$Attributes$novalidate(true)
											]),
										L: model.L,
										jf: _List_fromArray(
											[
												A2(
												$author$project$Components$Patterns$Forms$Custom,
												'flex gap-3',
												_Utils_ap(
													_List_fromArray(
														[
															$author$project$Components$Patterns$Forms$Input(
															{
																ie: $elm$core$Maybe$Nothing,
																iH: model.L === 2,
																iP: _List_Nil,
																nR: _List_fromArray(
																	[
																		$elm$html$Html$Attributes$size(20),
																		$elm$html$Html$Attributes$step('1')
																	]),
																jl: $elm$core$Maybe$Just('Início'),
																jn: _List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('flex flex-col'),
																		A2($elm$html$Html$Attributes$style, 'width', 'min-content')
																	]),
																n9: $elm$core$Maybe$Just(20),
																c3: '',
																jE: $elm$core$Maybe$Nothing,
																jF: $elm$core$Maybe$Nothing,
																jG: $elm$core$Maybe$Nothing,
																ov: $elm$core$Maybe$Nothing,
																jI: $elm$core$Maybe$Just(
																	A2($elm$core$Basics$composeR, $author$project$Pages$Reports$Event$UsingSession$valueNotEmpty, $author$project$Pages$Reports$Event$UsingSession$InputtedStartDate)),
																hh: 'Início',
																kE: model.L === 1,
																kY: 'datetime-local',
																k1: _List_Nil,
																di: A2($elm$core$Maybe$withDefault, '', model.T.bB)
															}),
															$author$project$Components$Patterns$Forms$Input(
															{
																ie: $elm$core$Maybe$Nothing,
																iH: model.L === 2,
																iP: _List_Nil,
																nR: _List_fromArray(
																	[
																		$elm$html$Html$Attributes$size(20),
																		$elm$html$Html$Attributes$step('1')
																	]),
																jl: $elm$core$Maybe$Just('Fim'),
																jn: _List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('flex flex-col'),
																		A2($elm$html$Html$Attributes$style, 'width', 'min-content')
																	]),
																n9: $elm$core$Maybe$Just(20),
																c3: '',
																jE: $elm$core$Maybe$Nothing,
																jF: $elm$core$Maybe$Nothing,
																jG: $elm$core$Maybe$Nothing,
																ov: $elm$core$Maybe$Nothing,
																jI: $elm$core$Maybe$Just(
																	A2($elm$core$Basics$composeR, $author$project$Pages$Reports$Event$UsingSession$valueNotEmpty, $author$project$Pages$Reports$Event$UsingSession$InputtedEndDate)),
																hh: 'Fim',
																kE: model.L === 1,
																kY: 'datetime-local',
																k1: _List_Nil,
																di: A2($elm$core$Maybe$withDefault, '', model.T.bl)
															}),
															$author$project$Components$Patterns$Forms$ButtonIcon(
															{
																lx: _List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('self-center w-40')
																	]),
																l_: $author$project$Pages$Reports$Event$UsingSession$ToggleFilters,
																l4: 'filter_list',
																iH: model.L === 2,
																fD: 'Filtros extra'
															}),
															$author$project$Components$Patterns$Forms$Button(
															{
																lx: _List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('self-center w-40')
																	]),
																l_: $author$project$Pages$Reports$Event$UsingSession$Submit,
																iH: model.L === 2,
																fD: 'Pesquisar'
															})
														]),
													buttonCsv)),
												A2(
												$author$project$Components$Patterns$Forms$Custom,
												'mt-4 grid grid-cols-auto-fit-minmax gap-3',
												model.dJ ? _List_fromArray(
													[
														$author$project$Components$Patterns$Forms$MultiSelect(
														{
															h$: _List_Nil,
															fT: true,
															eS: $author$project$Pages$Reports$Event$UsingSession$lineInputID,
															gO: model.dT,
															jl: 'Linha',
															jI: $author$project$Pages$Reports$Event$UsingSession$SelectedLine,
															g2: A2($author$project$Pages$Reports$Event$UsingSession$SetMultiSelect, 2, true),
															jO: $author$project$Pages$Reports$Event$UsingSession$lineOptions(model.n2),
															g7: model.T.n2,
															hh: 'Selecione múltiplas linhas',
															kt: $author$project$Pages$Reports$Event$UsingSession$lineSelectID
														}),
														$author$project$Components$Patterns$Forms$MultiSelect(
														{
															h$: _List_Nil,
															fT: true,
															eS: $author$project$Pages$Reports$Event$UsingSession$operatorInputID,
															gO: model.dU,
															jl: 'Operador',
															jI: $author$project$Pages$Reports$Event$UsingSession$SelectedOperator,
															g2: A2($author$project$Pages$Reports$Event$UsingSession$SetMultiSelect, 0, true),
															jO: $author$project$Pages$Reports$Event$UsingSession$operatorOptions(model.c5),
															g7: model.T.c5,
															hh: 'Selecione múltiplos operadores',
															kt: $author$project$Pages$Reports$Event$UsingSession$operatorSelectID
														}),
														$author$project$Components$Patterns$Forms$MultiSelect(
														{
															h$: _List_Nil,
															fT: true,
															eS: $author$project$Pages$Reports$Event$UsingSession$vehicleInputID,
															gO: model.dW,
															jl: 'Veículo',
															jI: $author$project$Pages$Reports$Event$UsingSession$SelectedVehicle,
															g2: A2($author$project$Pages$Reports$Event$UsingSession$SetMultiSelect, 1, true),
															jO: $author$project$Pages$Reports$Event$UsingSession$vehicleOptions(model.en),
															g7: model.T.en,
															hh: 'Selecione múltiplos veículos',
															kt: $author$project$Pages$Reports$Event$UsingSession$vehicleSelectID
														})
													]) : _List_Nil)
											]),
										oc: $elm$core$Maybe$Nothing,
										pX: 'Pesquisar'
									})
								])),
							function () {
							var _v0 = model.ck;
							switch (_v0.$) {
								case 3:
									var table = _v0.a;
									return $elm$core$List$isEmpty(table) ? $elm$html$Html$text('Nenhum registro encontrado') : A2($author$project$Pages$Reports$Event$UsingSession$viewTable, shared.kS, table);
								case 0:
									return $elm$html$Html$text('Por favor, defina um período desejado ou utilize as datas padrão para realizar a busca.');
								case 1:
									return $author$project$Components$View$loading;
								default:
									var e = _v0.a;
									return $elm$html$Html$text('Ops! Algo deu errado');
							}
						}()
						]))
				]));
	});
var $author$project$Pages$Reports$Event$UsingSession$view = F3(
	function (model, user, shared) {
		var viewModal = function () {
			var _v0 = model.bQ.aY;
			if (!_v0.$) {
				var m_ = _v0.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$Reports$Event$UsingSession$CompPDFCreateMSg,
					$author$project$Components$PDF$Create$viewModal(m_));
			} else {
				return $elm$html$Html$text('');
			}
		}();
		return _Utils_Tuple2(
			'Utilização por sessão baseado em eventos',
			_List_fromArray(
				[
					A3($author$project$Pages$Reports$Event$UsingSession$viewPage, model, shared, user),
					viewModal
				]));
	});
var $author$project$Pages$Reports$Event$UsingVehicle$GetTimeToDownload = {$: 8};
var $author$project$Pages$Reports$Event$UsingVehicle$InputtedEndDate = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Reports$Event$UsingVehicle$InputtedStartDate = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Reports$Event$UsingVehicle$SelectedVehicle = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Reports$Event$UsingVehicle$Submit = {$: 7};
var $author$project$Pages$Reports$Event$UsingVehicle$vehicleOptions = function (rdVehicles) {
	var options_ = A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(v.dM, v.l4);
		},
		rdVehicles);
	return A2(
		$elm$core$List$cons,
		_Utils_Tuple2('', 'Todos'),
		options_);
};
var $author$project$Pages$Reports$Event$UsingVehicle$alignCenter = A2($elm$html$Html$Attributes$style, 'text-align', 'center');
var $author$project$Pages$Reports$Event$UsingVehicle$isSubClass = function (header) {
	return !$elm$core$String$isEmpty(header.kY);
};
var $author$project$Pages$Reports$Event$UsingVehicle$getClassName = function (header) {
	return $author$project$Pages$Reports$Event$UsingVehicle$isSubClass(header) ? header.kY : header.ik;
};
var $author$project$Pages$Reports$Event$UsingVehicle$hasBreadClass = F2(
	function (header, data) {
		return A2(
			$elm$core$List$any,
			function (h_) {
				return _Utils_eq(header.ik, h_.ik) && (h_.kY === '');
			},
			data.nG);
	});
var $author$project$Pages$Reports$Event$UsingVehicle$isBreadClass = F2(
	function (header, data) {
		return A2(
			$elm$core$List$any,
			function (h_) {
				return _Utils_eq(header.ik, h_.ik) && (!$elm$core$String$isEmpty(h_.kY));
			},
			data.nG);
	});
var $author$project$Pages$Reports$Event$UsingVehicle$viewCell = F2(
	function (header, line) {
		var totalQuantity = ($elm$core$String$toLower(header.dM) === 'totalQuantity') ? A2(
			$elm$core$Maybe$map,
			$elm$core$String$fromInt,
			A2($elm$core$Dict$get, 'totalQuantity', line.dv)) : (($elm$core$String$toLower(header.dM) === 'totalFare') ? A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeL, $author$project$Utils$formatAsMoney, $elm$core$String$fromInt),
			A2($elm$core$Dict$get, 'totalFare', line.ni)) : $elm$core$Maybe$Nothing);
		var quantity = A2(
			$elm$core$Maybe$map,
			$elm$core$String$fromInt,
			A2($elm$core$Dict$get, header.dM, line.dv));
		var fare = A2(
			$elm$core$Maybe$map,
			$elm$core$String$fromInt,
			A2($elm$core$Dict$get, header.dM, line.ni));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			function () {
				var _v0 = _Utils_Tuple3(quantity, fare, totalQuantity);
				if (!_v0.a.$) {
					if (!_v0.b.$) {
						var q = _v0.a.a;
						var f = _v0.b.a;
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Pages$Reports$Event$UsingVehicle$alignCenter,
										A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(q)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Pages$Reports$Event$UsingVehicle$alignCenter,
										A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Utils$formatAsMoney(f))
									]))
							]);
					} else {
						var q = _v0.a.a;
						var _v2 = _v0.b;
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Pages$Reports$Event$UsingVehicle$alignCenter,
										A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(q)
									]))
							]);
					}
				} else {
					if (!_v0.b.$) {
						var _v1 = _v0.a;
						var f = _v0.b.a;
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Pages$Reports$Event$UsingVehicle$alignCenter,
										A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Utils$formatAsMoney(f))
									]))
							]);
					} else {
						if (!_v0.c.$) {
							var _v3 = _v0.a;
							var _v4 = _v0.b;
							var total = _v0.c.a;
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Pages$Reports$Event$UsingVehicle$alignCenter,
											A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(total)
										]))
								]);
						} else {
							var _v5 = _v0.a;
							var _v6 = _v0.b;
							var _v7 = _v0.c;
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[$author$project$Pages$Reports$Event$UsingVehicle$alignCenter]),
									_List_fromArray(
										[
											$elm$html$Html$text('-')
										]))
								]);
						}
					}
				}
			}());
	});
var $author$project$Pages$Reports$Event$UsingVehicle$viewRow = F3(
	function (data, headers_, line) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$tr,
				_List_Nil,
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('border px-4 py-2')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(line.fD)
							])),
					A2(
						$elm$core$List$map,
						function (header) {
							var classSubItemOrBreadTH = (($author$project$Pages$Reports$Event$UsingVehicle$isSubClass(header) || A2($author$project$Pages$Reports$Event$UsingVehicle$isBreadClass, header, data)) && A2($author$project$Pages$Reports$Event$UsingVehicle$hasBreadClass, header, data)) ? 'bg-gray-tint1' : '';
							return A2(
								$elm$html$Html$td,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(classSubItemOrBreadTH),
										$elm$html$Html$Attributes$class('border px-4 py-2')
									]),
								_List_fromArray(
									[
										A2($author$project$Pages$Reports$Event$UsingVehicle$viewCell, header, line)
									]));
						},
						headers_)))
			]);
	});
var $author$project$Pages$Reports$Event$UsingVehicle$viewTable = function (data) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$table,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'border-collapse', 'collapse'),
						A2($elm$html$Html$Attributes$style, 'text-align', 'left'),
						A2($elm$html$Html$Attributes$attribute, 'cellspacing', '0'),
						$elm$html$Html$Attributes$class('data-table-dashboard my-4')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$tr,
								_List_Nil,
								_Utils_ap(
									_List_fromArray(
										[
											A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Veículo')
												]))
										]),
									A2(
										$elm$core$List$map,
										function (header) {
											if ((header.dM === 'totalQuantity') || (header.dM === 'totalFare')) {
												return A2(
													$elm$html$Html$th,
													_List_fromArray(
														[$author$project$Pages$Reports$Event$UsingVehicle$alignCenter]),
													_List_fromArray(
														[
															$elm$html$Html$text(header.ik)
														]));
											} else {
												var classSubItemOrBreadTH = (($author$project$Pages$Reports$Event$UsingVehicle$isSubClass(header) || A2($author$project$Pages$Reports$Event$UsingVehicle$isBreadClass, header, data)) && A2($author$project$Pages$Reports$Event$UsingVehicle$hasBreadClass, header, data)) ? 'bg-gray-tint1' : '';
												return A2(
													$elm$html$Html$th,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class(classSubItemOrBreadTH),
															$author$project$Pages$Reports$Event$UsingVehicle$alignCenter,
															$elm$html$Html$Attributes$alt(
															$author$project$Pages$Reports$Event$UsingVehicle$getClassName(header))
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('tooltip')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$elm$core$String$toUpper(
																		A2(
																			$elm$core$String$left,
																			3,
																			$author$project$Pages$Reports$Event$UsingVehicle$getClassName(header)))),
																	A2(
																	$elm$html$Html$span,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('tooltiptext')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Pages$Reports$Event$UsingVehicle$getClassName(header))
																		]))
																]))
														]));
											}
										},
										data.nG)))
							])),
						A2(
						$elm$html$Html$tbody,
						_List_Nil,
						A2(
							$elm$core$List$concatMap,
							A2($author$project$Pages$Reports$Event$UsingVehicle$viewRow, data, data.nG),
							data.px))
					]))
			]));
};
var $author$project$Pages$Reports$Event$UsingVehicle$viewPage = F2(
	function (model, user) {
		var buttonCsv = A2(
			$krisajenkins$remotedata$RemoteData$withDefault,
			true,
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.px;
					},
					$elm$core$List$isEmpty),
				model.ck)) ? _List_Nil : _List_fromArray(
			[
				$author$project$Components$Patterns$Forms$Button(
				{
					lx: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('self-center w-40')
						]),
					l_: $author$project$Pages$Reports$Event$UsingVehicle$GetTimeToDownload,
					iH: model.L === 2,
					fD: 'Baixar CSV'
				})
			]);
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-black')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Utilização por veículo baseado em eventos')
						])),
					A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex ')
								]),
							_List_fromArray(
								[
									$author$project$Components$Patterns$Forms$formSimple(
									{
										hZ: _List_fromArray(
											[
												$elm$html$Html$Attributes$class(''),
												$elm$html$Html$Attributes$novalidate(true)
											]),
										L: model.L,
										jf: _List_fromArray(
											[
												A2(
												$author$project$Components$Patterns$Forms$Custom,
												'flex gap-3',
												_Utils_ap(
													_List_fromArray(
														[
															$author$project$Components$Patterns$Forms$Input(
															{
																ie: $elm$core$Maybe$Nothing,
																iH: model.L === 2,
																iP: _List_Nil,
																nR: _List_fromArray(
																	[
																		$elm$html$Html$Attributes$size(10)
																	]),
																jl: $elm$core$Maybe$Just('Início'),
																jn: _List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('flex flex-col'),
																		A2($elm$html$Html$Attributes$style, 'width', 'min-content')
																	]),
																n9: $elm$core$Maybe$Just(10),
																c3: '',
																jE: $elm$core$Maybe$Nothing,
																jF: $elm$core$Maybe$Nothing,
																jG: $elm$core$Maybe$Nothing,
																ov: $elm$core$Maybe$Nothing,
																jI: $elm$core$Maybe$Just(
																	A2($elm$core$Basics$composeR, $author$project$Pages$Reports$Event$UsingVehicle$valueNotEmpty, $author$project$Pages$Reports$Event$UsingVehicle$InputtedStartDate)),
																hh: 'Início',
																kE: model.L === 1,
																kY: 'date',
																k1: _List_Nil,
																di: A2($elm$core$Maybe$withDefault, '', model.T.bB)
															}),
															$author$project$Components$Patterns$Forms$Input(
															{
																ie: $elm$core$Maybe$Nothing,
																iH: model.L === 2,
																iP: _List_Nil,
																nR: _List_fromArray(
																	[
																		$elm$html$Html$Attributes$size(10)
																	]),
																jl: $elm$core$Maybe$Just('Fim'),
																jn: _List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('flex flex-col'),
																		A2($elm$html$Html$Attributes$style, 'width', 'min-content')
																	]),
																n9: $elm$core$Maybe$Just(10),
																c3: '',
																jE: $elm$core$Maybe$Nothing,
																jF: $elm$core$Maybe$Nothing,
																jG: $elm$core$Maybe$Nothing,
																ov: $elm$core$Maybe$Nothing,
																jI: $elm$core$Maybe$Just(
																	A2($elm$core$Basics$composeR, $author$project$Pages$Reports$Event$UsingVehicle$valueNotEmpty, $author$project$Pages$Reports$Event$UsingVehicle$InputtedEndDate)),
																hh: 'Fim',
																kE: model.L === 1,
																kY: 'date',
																k1: _List_Nil,
																di: A2($elm$core$Maybe$withDefault, '', model.T.bl)
															}),
															$author$project$Components$Patterns$Forms$MultiSelect(
															{
																h$: _List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('self-end'),
																		A2($elm$html$Html$Attributes$style, 'width', 'max-content')
																	]),
																fT: true,
																eS: $author$project$Pages$Reports$Event$UsingVehicle$vehicleInputID,
																gO: model.dW,
																jl: 'Veículo',
																jI: $author$project$Pages$Reports$Event$UsingVehicle$SelectedVehicle,
																g2: A2($author$project$Pages$Reports$Event$UsingVehicle$SetMultiSelect, 0, true),
																jO: $author$project$Pages$Reports$Event$UsingVehicle$vehicleOptions(model.en),
																g7: model.T.en,
																hh: 'Selecione múltiplos veículos',
																kt: $author$project$Pages$Reports$Event$UsingVehicle$vehicleSelectID
															}),
															$author$project$Components$Patterns$Forms$Button(
															{
																lx: _List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('self-center w-40')
																	]),
																l_: $author$project$Pages$Reports$Event$UsingVehicle$Submit,
																iH: model.L === 2,
																fD: 'Pesquisar'
															})
														]),
													buttonCsv))
											]),
										oc: $elm$core$Maybe$Nothing,
										pX: 'Pesquisar'
									})
								])),
							function () {
							var _v0 = model.ck;
							switch (_v0.$) {
								case 3:
									var table = _v0.a;
									return $elm$core$List$isEmpty(table.px) ? $elm$html$Html$text('Nenhum registro encontrado') : $author$project$Pages$Reports$Event$UsingVehicle$viewTable(table);
								case 0:
									return $elm$html$Html$text('Por favor, defina um período desejado ou utilize as datas padrão para realizar a busca.');
								case 1:
									return $author$project$Components$View$loading;
								default:
									var e = _v0.a;
									return $elm$html$Html$text('Ops! Algo deu errado');
							}
						}()
						]))
				]));
	});
var $author$project$Pages$Reports$Event$UsingVehicle$view = F3(
	function (model, user, shared) {
		var viewModal = $elm$html$Html$text('');
		return _Utils_Tuple2(
			'Utilização por veículo baseado em eventos',
			_List_fromArray(
				[
					A2($author$project$Pages$Reports$Event$UsingVehicle$viewPage, model, user),
					viewModal
				]));
	});
var $author$project$Pages$Reports$PDFs$ReloadList = {$: 1};
var $author$project$Pages$Reports$PDFs$headersStr = _List_fromArray(
	['Exportado em', 'Nome do Relatório', 'Tipo do relatório', 'Tipo da exportação', 'Gerado por', 'Status', '']);
var $author$project$Pages$Reports$PDFs$iconOpenPDF = function (file) {
	return $elm$core$String$isEmpty(file) ? $elm$html$Html$text('') : A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('action-system green-btn icon-md '),
				$elm$html$Html$Attributes$title('Ver relatório')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$target('_blank'),
						$elm$html$Html$Attributes$href(file)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('material-symbols-outlined pl-2 pr-2 align-middle hover:text-white')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('open_in_new')
							]))
					]))
			]));
};
var $author$project$Services$Pdf$reportCodeToPTBR = function (t) {
	switch (t) {
		case 'usage':
			return 'Usos';
		case 'cashiers':
			return 'Sessão baseado em eventos';
		case 'usingByWalletClass':
			return 'Uso por classe';
		case 'cashierGroupedUsage':
			return 'Uso agrupado por sessão';
		case 'cashierUsage':
			return 'Uso por sessão';
		default:
			return t;
	}
};
var $author$project$Pages$Reports$PDFs$viewRowStr = F2(
	function (timezone, pdf) {
		var maybeValue = function (v) {
			return A2($elm$core$Maybe$withDefault, '-', v);
		};
		var filteredFileName = A2(
			$elm$core$String$left,
			40,
			A3($elm$core$String$replace, '.csv', '', pdf.nk));
		var emptyValue = function (v) {
			return $elm$core$String$isEmpty(v) ? '-' : v;
		};
		var addPoints = ($elm$core$String$length(pdf.nk) > 40) ? '...' : '';
		return _List_fromArray(
			[
				_Utils_Tuple2(
				$elm$core$Maybe$Nothing,
				maybeValue(
					A2(
						$elm$core$Maybe$map,
						$author$project$Utils$formatDateTimeFromPosixWithSeconds(timezone),
						pdf.nf))),
				_Utils_Tuple2(
				$elm$core$Maybe$Just(pdf.nk),
				emptyValue(
					_Utils_ap(filteredFileName, addPoints))),
				_Utils_Tuple2(
				$elm$core$Maybe$Nothing,
				emptyValue(
					$author$project$Services$Pdf$reportCodeToPTBR(pdf.hp))),
				_Utils_Tuple2(
				$elm$core$Maybe$Nothing,
				emptyValue(
					$author$project$Services$Pdf$reportCodeToPTBR(pdf.Y))),
				_Utils_Tuple2(
				$elm$core$Maybe$Nothing,
				emptyValue(pdf.qx)),
				_Utils_Tuple2(
				$elm$core$Maybe$Nothing,
				emptyValue(pdf.kK))
			]);
	});
var $author$project$Pages$Reports$PDFs$viewRowHtml = F2(
	function (timezone, pdf) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (_v0) {
					var title = _v0.a;
					var str = _v0.b;
					return A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								A2(
								$elm$core$Maybe$withDefault,
								$elm$html$Html$Attributes$class(''),
								A2($elm$core$Maybe$map, $elm$html$Html$Attributes$title, title))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(str)
							]));
				},
				A2($author$project$Pages$Reports$PDFs$viewRowStr, timezone, pdf)),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Reports$PDFs$iconOpenPDF(pdf.iS)
						]))
				]));
	});
var $author$project$Pages$Reports$PDFs$viewTable = F2(
	function (timezone, data) {
		return $author$project$Components$Patterns$Tables$default(
			{
				nF: $author$project$Pages$Reports$PDFs$headersStr,
				nX: false,
				pj: A2(
					$elm$core$List$map,
					$author$project$Pages$Reports$PDFs$viewRowHtml(timezone),
					data)
			});
	});
var $author$project$Pages$Reports$PDFs$viewPage = F3(
	function (model, shared, user) {
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-black mb-4')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Relatórios gerados')
						])),
					A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex gap-4')
								]),
							_List_fromArray(
								[
									A4($author$project$Components$Patterns$Button$icon, $author$project$Pages$Reports$PDFs$ReloadList, 'icon-md  white-btn m-0 py-4 px-2 border-0', 'refresh', 'Recarregar')
								])),
							function () {
							var _v0 = model.ck;
							switch (_v0.$) {
								case 3:
									var table = _v0.a;
									return A2($author$project$Pages$Reports$PDFs$viewTable, shared.kS, table);
								case 0:
									return $elm$html$Html$text('Por favor, defina um período desejado ou utilize as datas padrão para realizar a busca.');
								case 1:
									return $author$project$Components$View$loading;
								default:
									var e = _v0.a;
									return $elm$html$Html$text('Ops! Algo deu errado');
							}
						}()
						]))
				]));
	});
var $author$project$Pages$Reports$PDFs$view = F3(
	function (model, user, shared) {
		var viewModal = $elm$html$Html$text('');
		return _Utils_Tuple2(
			'Relatórios gerados',
			_List_fromArray(
				[
					A3($author$project$Pages$Reports$PDFs$viewPage, model, shared, user),
					viewModal
				]));
	});
var $author$project$Pages$Reports$SalesSummarized$subtractionTotal = function (resultRD) {
	return A2(
		$krisajenkins$remotedata$RemoteData$withDefault,
		0,
		A2(
			$krisajenkins$remotedata$RemoteData$map,
			function (result) {
				return $elm$core$Basics$abs(
					$elm$core$List$sum(
						A2(
							$elm$core$List$map,
							function ($) {
								return $.fI;
							},
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.cd;
									},
									$elm$core$Basics$eq('Estorno')),
								result))));
			},
			resultRD));
};
var $author$project$Pages$Reports$SalesSummarized$totalValue = function (resultRD) {
	return A2(
		$krisajenkins$remotedata$RemoteData$withDefault,
		0,
		A2(
			$krisajenkins$remotedata$RemoteData$map,
			function (result) {
				return A3(
					$elm$core$List$foldl,
					F2(
						function (row, acc) {
							return row.fI + acc;
						}),
					0,
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.cd;
							},
							$elm$core$Basics$neq('Estorno')),
						result));
			},
			resultRD));
};
var $author$project$Pages$Reports$SalesSummarized$ClickedGenerateReport = F3(
	function (a, b, c) {
		return {$: 7, a: a, b: b, c: c};
	});
var $author$project$Pages$Reports$SalesSummarized$InputtedEndDate = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Reports$SalesSummarized$InputtedStartDate = function (a) {
	return {$: 2, a: a};
};
var $author$project$Services$Pdf$ResumedSales = 9;
var $author$project$Pages$Reports$SalesSummarized$Search = {$: 6};
var $author$project$Utils$formatDateInputHTMLFromPosix = function (timezone) {
	return A2(
		$ryan_haskell$date_format$DateFormat$format,
		_List_fromArray(
			[
				$ryan_haskell$date_format$DateFormat$yearNumber,
				$ryan_haskell$date_format$DateFormat$text('-'),
				$ryan_haskell$date_format$DateFormat$monthFixed,
				$ryan_haskell$date_format$DateFormat$text('-'),
				$ryan_haskell$date_format$DateFormat$dayOfMonthFixed
			]),
		timezone);
};
var $author$project$Pages$Reports$SalesSummarized$valueNotEmpty = function (str) {
	return $elm$core$String$isEmpty(str) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(str);
};
var $author$project$Pages$Reports$SalesSummarized$viewFilters = function (model) {
	var hasPeriodCSV = A2(
		$krisajenkins$remotedata$RemoteData$withDefault,
		false,
		A2(
			$krisajenkins$remotedata$RemoteData$map,
			A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not),
			model.ck));
	var buttonCsv = ((!_Utils_eq(model.T.bB, $elm$core$Maybe$Nothing)) && (!_Utils_eq(model.T.bl, $elm$core$Maybe$Nothing))) ? _List_fromArray(
		[
			$author$project$Components$Patterns$Forms$Button(
			{
				lx: _List_fromArray(
					[
						$elm$html$Html$Attributes$class('self-center w-40')
					]),
				l_: A3(
					$author$project$Pages$Reports$SalesSummarized$ClickedGenerateReport,
					_Utils_Tuple2(hasPeriodCSV, true),
					1,
					9),
				iH: model.L === 2,
				fD: 'Baixar CSV'
			})
		]) : _List_Nil;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex')
			]),
		_List_fromArray(
			[
				$author$project$Components$Patterns$Forms$formSimple(
				{
					hZ: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex gap-4'),
							$elm$html$Html$Attributes$novalidate(true)
						]),
					L: model.L,
					jf: _Utils_ap(
						_List_fromArray(
							[
								$author$project$Components$Patterns$Forms$Input(
								{
									ie: $elm$core$Maybe$Nothing,
									iH: model.L === 2,
									iP: _List_Nil,
									nR: _List_fromArray(
										[
											$elm$html$Html$Attributes$size(10)
										]),
									jl: $elm$core$Maybe$Just('Início'),
									jn: _List_fromArray(
										[
											$elm$html$Html$Attributes$class('flex flex-col'),
											A2($elm$html$Html$Attributes$style, 'width', 'min-content')
										]),
									n9: $elm$core$Maybe$Just(10),
									c3: 'Campo data de início',
									jE: $elm$core$Maybe$Nothing,
									jF: $elm$core$Maybe$Nothing,
									jG: $elm$core$Maybe$Nothing,
									ov: $elm$core$Maybe$Nothing,
									jI: $elm$core$Maybe$Just(
										A2($elm$core$Basics$composeR, $author$project$Pages$Reports$SalesSummarized$valueNotEmpty, $author$project$Pages$Reports$SalesSummarized$InputtedStartDate)),
									hh: 'Início',
									kE: model.L === 1,
									kY: 'date',
									k1: _List_Nil,
									di: A2($elm$core$Maybe$withDefault, '', model.T.bB)
								}),
								$author$project$Components$Patterns$Forms$Input(
								{
									ie: $elm$core$Maybe$Nothing,
									iH: model.L === 2,
									iP: _List_Nil,
									nR: _List_fromArray(
										[
											$elm$html$Html$Attributes$size(10),
											A2(
											$elm$core$Maybe$withDefault,
											$elm$html$Html$Attributes$class(''),
											A2(
												$elm$core$Maybe$map,
												A2(
													$elm$core$Basics$composeR,
													$author$project$Utils$formatDateInputHTMLFromPosix($elm$time$Time$utc),
													$elm$html$Html$Attributes$max),
												model.eE))
										]),
									jl: $elm$core$Maybe$Just('Fim'),
									jn: _List_fromArray(
										[
											$elm$html$Html$Attributes$class('flex flex-col'),
											A2($elm$html$Html$Attributes$style, 'width', 'min-content')
										]),
									n9: $elm$core$Maybe$Just(10),
									c3: 'Campo data de Fim',
									jE: $elm$core$Maybe$Nothing,
									jF: $elm$core$Maybe$Nothing,
									jG: $elm$core$Maybe$Nothing,
									ov: $elm$core$Maybe$Nothing,
									jI: $elm$core$Maybe$Just(
										A2($elm$core$Basics$composeR, $author$project$Pages$Reports$SalesSummarized$valueNotEmpty, $author$project$Pages$Reports$SalesSummarized$InputtedEndDate)),
									hh: 'Fim',
									kE: model.L === 1,
									kY: 'date',
									k1: _List_fromArray(
										[
											_Utils_Tuple2(
											function (_v0) {
												return A2($author$project$Pages$Reports$SalesSummarized$periodInvalid, model.T.bB, model.T.bl);
											},
											'O período não pode exceder 31 dias!')
										]),
									di: A2($elm$core$Maybe$withDefault, '', model.T.bl)
								}),
								$author$project$Components$Patterns$Forms$Button(
								{
									lx: _List_fromArray(
										[
											$elm$html$Html$Attributes$class('self-center w-40')
										]),
									l_: $author$project$Pages$Reports$SalesSummarized$Search,
									iH: model.L === 2,
									fD: 'Pesquisar'
								})
							]),
						buttonCsv),
					oc: $elm$core$Maybe$Nothing,
					pX: 'Pesquisar'
				})
			]));
};
var $author$project$Pages$Reports$SalesSummarized$viewTable = function (reportRD) {
	switch (reportRD.$) {
		case 3:
			if (!reportRD.a.b) {
				return $elm$html$Html$text('Nenhum registro encontrado');
			} else {
				var report = reportRD.a;
				var tds = A2(
					$elm$core$List$map,
					function (row) {
						var valueViewMoney = function (value) {
							return A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $author$project$Utils$formatAsMoney)(value);
						};
						var valueView = function (v) {
							return (row.cd === 'Estorno') ? A2(
								$elm$core$Basics$composeR,
								valueViewMoney,
								function (v_) {
									return '( ' + (v_ + ' )');
								})(v) : valueViewMoney(v);
						};
						var valueClass = function (paymentMethod) {
							return (paymentMethod === 'Estorno') ? $elm$html$Html$Attributes$class('text-red-500') : A2($elm$html$Html$Attributes$style, '', '');
						};
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$td,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(row.cd)
									])),
								A2(
								$elm$html$Html$td,
								_List_fromArray(
									[
										valueClass(row.cd),
										A2($elm$html$Html$Attributes$style, 'text-wrap', 'nowrap')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										valueView(row.fI))
									]))
							]);
					},
					report);
				return $author$project$Components$Patterns$Tables$default(
					{nF: $author$project$Pages$Reports$SalesSummarized$headerReport, nX: true, pj: tds});
			}
		case 1:
			return $author$project$Components$View$loading;
		case 2:
			return $elm$html$Html$text('Algo deu errado, entre em contato com o suporte');
		default:
			return $elm$html$Html$text('Por favor, defina um período desejado ou utilize as datas padrão para realizar a busca.');
	}
};
var $author$project$Pages$Reports$SalesSummarized$viewPage = function (model) {
	return A2(
		$elm$html$Html$main_,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('main-dashboard')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h1,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-black')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Vendas resumidas')
					])),
				A2(
				$elm$html$Html$section,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pages$Reports$SalesSummarized$viewFilters(model),
						$author$project$Components$Patterns$TotalBar$view(
						{
							lo: $author$project$Pages$Reports$SalesSummarized$totalValue(model.ck),
							md: $elm$core$Maybe$Just(
								$author$project$Pages$Reports$SalesSummarized$viewTable(model.ck)),
							fD: 'Resultado',
							qg: $author$project$Pages$Reports$SalesSummarized$subtractionTotal(model.ck)
						})
					]))
			]));
};
var $author$project$Pages$Reports$SalesSummarized$view = F2(
	function (model, shared) {
		var viewModal = function () {
			var _v0 = model.bQ.aY;
			if (!_v0.$) {
				var m_ = _v0.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$Reports$SalesSummarized$CompPDFCreateMSg,
					$author$project$Components$PDF$Create$viewModal(m_));
			} else {
				return $elm$html$Html$text('');
			}
		}();
		return _Utils_Tuple2(
			'Vendas resumidas',
			_List_fromArray(
				[
					$author$project$Pages$Reports$SalesSummarized$viewPage(model),
					viewModal
				]));
	});
var $author$project$Pages$Reports$SalesSummarizedV2$ClickedGenerateReport = F3(
	function (a, b, c) {
		return {$: 7, a: a, b: b, c: c};
	});
var $author$project$Pages$Reports$SalesSummarizedV2$InputtedEndDate = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Reports$SalesSummarizedV2$InputtedStartDate = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Reports$SalesSummarizedV2$Search = {$: 5};
var $author$project$Pages$Reports$SalesSummarizedV2$valueNotEmpty = function (str) {
	return $elm$core$String$isEmpty(str) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(str);
};
var $author$project$Pages$Reports$SalesSummarizedV2$CurrentMonth = 3;
var $author$project$Pages$Reports$SalesSummarizedV2$Last30Days = 2;
var $author$project$Pages$Reports$SalesSummarizedV2$Last7Days = 1;
var $author$project$Pages$Reports$SalesSummarizedV2$PreviousMonth = 4;
var $author$project$Pages$Reports$SalesSummarizedV2$SelectedQuickPeriod = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Reports$SalesSummarizedV2$Today = 0;
var $author$project$Pages$Reports$SalesSummarizedV2$viewQuickPeriods = function (model) {
	var isActive = function (quickPeriod) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (today) {
					var range = A2($author$project$Pages$Reports$SalesSummarizedV2$quickRange, quickPeriod, today);
					return _Utils_eq(
						model.T.bB,
						$elm$core$Maybe$Just(
							$justinmimbs$date$Date$toIsoString(range.eb))) && _Utils_eq(
						model.T.bl,
						$elm$core$Maybe$Just(
							$justinmimbs$date$Date$toIsoString(range.dH)));
				},
				model.ef));
	};
	var chip = function (_v0) {
		var quickPeriod = _v0.a;
		var label = _v0.b;
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('button'),
					$elm$html$Html$Attributes$class('ssv2-chip'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'ssv2-chip--active',
							isActive(quickPeriod))
						])),
					$elm$html$Html$Events$onClick(
					$author$project$Pages$Reports$SalesSummarizedV2$SelectedQuickPeriod(quickPeriod))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	};
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex flex-col')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('ssv2-chip-label')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Período rápido')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex gap-2')
					]),
				A2(
					$elm$core$List$map,
					chip,
					_List_fromArray(
						[
							_Utils_Tuple2(0, 'Hoje'),
							_Utils_Tuple2(1, '7 dias'),
							_Utils_Tuple2(2, '30 dias'),
							_Utils_Tuple2(3, 'Mês atual'),
							_Utils_Tuple2(4, 'Mês anterior')
						])))
			]));
};
var $author$project$Pages$Reports$SalesSummarizedV2$viewFilters = function (model) {
	var hasPeriodCSV = A2(
		$krisajenkins$remotedata$RemoteData$withDefault,
		false,
		A2(
			$krisajenkins$remotedata$RemoteData$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.hb;
				},
				A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not)),
			model.ck));
	var buttonCsv = ((!_Utils_eq(model.T.bB, $elm$core$Maybe$Nothing)) && (!_Utils_eq(model.T.bl, $elm$core$Maybe$Nothing))) ? _List_fromArray(
		[
			$author$project$Components$Patterns$Forms$Button(
			{
				lx: _List_fromArray(
					[
						$elm$html$Html$Attributes$class('self-center w-40')
					]),
				l_: A3(
					$author$project$Pages$Reports$SalesSummarizedV2$ClickedGenerateReport,
					_Utils_Tuple2(hasPeriodCSV, true),
					1,
					9),
				iH: model.L === 2,
				fD: 'Baixar CSV'
			})
		]) : _List_Nil;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex')
			]),
		_List_fromArray(
			[
				$author$project$Components$Patterns$Forms$formSimple(
				{
					hZ: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex gap-4 items-end flex-wrap'),
							$elm$html$Html$Attributes$novalidate(true)
						]),
					L: model.L,
					jf: _Utils_ap(
						_List_fromArray(
							[
								$author$project$Components$Patterns$Forms$Input(
								{
									ie: $elm$core$Maybe$Nothing,
									iH: model.L === 2,
									iP: _List_Nil,
									nR: _List_fromArray(
										[
											$elm$html$Html$Attributes$size(10)
										]),
									jl: $elm$core$Maybe$Just('Início'),
									jn: _List_fromArray(
										[
											$elm$html$Html$Attributes$class('flex flex-col'),
											A2($elm$html$Html$Attributes$style, 'width', 'min-content')
										]),
									n9: $elm$core$Maybe$Just(10),
									c3: 'Campo data de início',
									jE: $elm$core$Maybe$Nothing,
									jF: $elm$core$Maybe$Nothing,
									jG: $elm$core$Maybe$Nothing,
									ov: $elm$core$Maybe$Nothing,
									jI: $elm$core$Maybe$Just(
										A2($elm$core$Basics$composeR, $author$project$Pages$Reports$SalesSummarizedV2$valueNotEmpty, $author$project$Pages$Reports$SalesSummarizedV2$InputtedStartDate)),
									hh: 'Início',
									kE: model.L === 1,
									kY: 'date',
									k1: _List_Nil,
									di: A2($elm$core$Maybe$withDefault, '', model.T.bB)
								}),
								$author$project$Components$Patterns$Forms$Input(
								{
									ie: $elm$core$Maybe$Nothing,
									iH: model.L === 2,
									iP: _List_Nil,
									nR: _List_fromArray(
										[
											$elm$html$Html$Attributes$size(10)
										]),
									jl: $elm$core$Maybe$Just('Fim'),
									jn: _List_fromArray(
										[
											$elm$html$Html$Attributes$class('flex flex-col'),
											A2($elm$html$Html$Attributes$style, 'width', 'min-content')
										]),
									n9: $elm$core$Maybe$Just(10),
									c3: 'Campo data de Fim',
									jE: $elm$core$Maybe$Nothing,
									jF: $elm$core$Maybe$Nothing,
									jG: $elm$core$Maybe$Nothing,
									ov: $elm$core$Maybe$Nothing,
									jI: $elm$core$Maybe$Just(
										A2($elm$core$Basics$composeR, $author$project$Pages$Reports$SalesSummarizedV2$valueNotEmpty, $author$project$Pages$Reports$SalesSummarizedV2$InputtedEndDate)),
									hh: 'Fim',
									kE: model.L === 1,
									kY: 'date',
									k1: _List_fromArray(
										[
											_Utils_Tuple2(
											function (_v0) {
												return A2($author$project$Pages$Reports$SalesSummarizedV2$periodInvalid, model.T.bB, model.T.bl);
											},
											'O período não pode exceder 31 dias!')
										]),
									di: A2($elm$core$Maybe$withDefault, '', model.T.bl)
								}),
								$author$project$Components$Patterns$Forms$Html(
								$author$project$Pages$Reports$SalesSummarizedV2$viewQuickPeriods(model)),
								$author$project$Components$Patterns$Forms$Button(
								{
									lx: _List_fromArray(
										[
											$elm$html$Html$Attributes$class('self-center w-40')
										]),
									l_: $author$project$Pages$Reports$SalesSummarizedV2$Search,
									iH: model.L === 2,
									fD: 'Pesquisar'
								})
							]),
						buttonCsv),
					oc: $elm$core$Maybe$Nothing,
					pX: 'Pesquisar'
				})
			]));
};
var $author$project$Pages$Reports$SalesSummarizedV2$intSep = function (n) {
	var grouped = $elm$core$String$fromList(
		$elm$core$List$reverse(
			$elm$core$List$concat(
				A2(
					$elm$core$List$indexedMap,
					F2(
						function (i, c) {
							return ((i > 0) && (!A2($elm$core$Basics$modBy, 3, i))) ? _List_fromArray(
								[c, '.']) : _List_fromArray(
								[c]);
						}),
					$elm$core$String$toList(
						$elm$core$String$reverse(
							$elm$core$String$fromInt(
								$elm$core$Basics$abs(n))))))));
	return _Utils_ap(
		(n < 0) ? '-' : '',
		grouped);
};
var $author$project$Pages$Reports$SalesSummarizedV2$moneyStr = A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $author$project$Utils$formatAsMoney);
var $author$project$Pages$Reports$SalesSummarizedV2$originMeta = function (origin) {
	switch (origin) {
		case 'Empresa':
			return {cK: '#3b82f6', z: 'Vendas faturadas e pagamentos corporativos', cW: 'domain'};
		case 'Aplicativo':
			return {cK: '#14b8a6', z: 'Compras realizadas no app Pazze', cW: 'smartphone'};
		case 'Guichê':
			return {cK: '#6e46c8', z: 'Vendas presenciais nos pontos de atendimento', cW: 'point_of_sale'};
		case 'WhatsApp':
			return {cK: '#22c55e', z: 'Vendas realizadas pelo atendimento via WhatsApp', cW: 'chat'};
		default:
			return {cK: '#979797', z: '', cW: 'storefront'};
	}
};
var $author$project$Pages$Reports$SalesSummarizedV2$percentStr = function (pct) {
	return A3(
		$elm$core$String$replace,
		'.',
		',',
		$elm$core$String$fromFloat(
			$elm$core$Basics$round(pct * 10) / 10));
};
var $author$project$Pages$Reports$SalesSummarizedV2$periodLabel = function (queries) {
	var fmt = function (iso) {
		var _v0 = A2($elm$core$String$split, '-', iso);
		if (((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.b.b)) {
			var y = _v0.a;
			var _v1 = _v0.b;
			var m = _v1.a;
			var _v2 = _v1.b;
			var d = _v2.a;
			return d + ('/' + (m + ('/' + y)));
		} else {
			return iso;
		}
	};
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A3(
			$elm$core$Maybe$map2,
			F2(
				function (s, e) {
					return fmt(s) + (' — ' + fmt(e));
				}),
			queries.bB,
			queries.bl));
};
var $author$project$Pages$Reports$SalesSummarizedV2$viewConsolidatedFooter = F2(
	function (queries, report) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('ssv2-consolidated')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ssv2-card__label')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									'Total consolidado · ' + $author$project$Pages$Reports$SalesSummarizedV2$periodLabel(queries))
								])),
							A2(
							$elm$html$Html$strong,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ssv2-consolidated__value')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Pages$Reports$SalesSummarizedV2$moneyStr(report.nz))
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ssv2-card__foot')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Pages$Reports$SalesSummarizedV2$intSep(report.qh) + (' transações em ' + ($elm$core$String$fromInt(
										$elm$core$List$length(report.fF)) + ' origens de venda')))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ssv2-consolidated__origins')
						]),
					A2(
						$elm$core$List$map,
						function (ot) {
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('ssv2-consolidated__origin')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('ssv2-card__origin')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('ssv2-dot'),
														A2(
														$elm$html$Html$Attributes$style,
														'background',
														$author$project$Pages$Reports$SalesSummarizedV2$originMeta(ot.a$).cK)
													]),
												_List_Nil),
												$elm$html$Html$text(ot.a$)
											])),
										A2(
										$elm$html$Html$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Pages$Reports$SalesSummarizedV2$moneyStr(ot.qc))
											])),
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('ssv2-card__foot')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Pages$Reports$SalesSummarizedV2$percentStr(ot.ce) + ('% · ' + ($author$project$Pages$Reports$SalesSummarizedV2$intSep(ot.a9) + ' transações')))
											]))
									]));
						},
						report.fF))
				]));
	});
var $author$project$Pages$Reports$SalesSummarizedV2$percentCss = function (pct) {
	return $elm$core$String$fromFloat(
		$elm$core$Basics$round(
			A2(
				$elm$core$Basics$min,
				100,
				$elm$core$Basics$abs(pct)) * 10) / 10);
};
var $author$project$Pages$Reports$SalesSummarizedV2$viewDistribution = function (report) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('ssv2-panel')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h3,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('ssv2-panel__title')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Distribuição por origem')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('ssv2-distribution')
					]),
				A2(
					$elm$core$List$map,
					function (ot) {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$Attributes$style,
									'background',
									$author$project$Pages$Reports$SalesSummarizedV2$originMeta(ot.a$).cK),
									A2(
									$elm$html$Html$Attributes$style,
									'width',
									$author$project$Pages$Reports$SalesSummarizedV2$percentCss(ot.ce) + '%'),
									$elm$html$Html$Attributes$title(
									ot.a$ + (' · ' + ($author$project$Pages$Reports$SalesSummarizedV2$percentStr(ot.ce) + '%')))
								]),
							_List_Nil);
					},
					report.fF)),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('ssv2-legend')
					]),
				A2(
					$elm$core$List$map,
					function (ot) {
						return A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ssv2-legend__item')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('ssv2-dot'),
											A2(
											$elm$html$Html$Attributes$style,
											'background',
											$author$project$Pages$Reports$SalesSummarizedV2$originMeta(ot.a$).cK)
										]),
									_List_Nil),
									$elm$html$Html$text(ot.a$),
									A2(
									$elm$html$Html$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Pages$Reports$SalesSummarizedV2$moneyStr(ot.qc))
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('ssv2-muted')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											'· ' + ($author$project$Pages$Reports$SalesSummarizedV2$percentStr(ot.ce) + '%'))
										]))
								]));
					},
					report.fF))
			]));
};
var $author$project$Pages$Reports$SalesSummarizedV2$ToggleOrigin = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Reports$SalesSummarizedV2$viewMethodRow = F2(
	function (color, method) {
		var isNegative = method.di < 0;
		var valueView = isNegative ? A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-red-500'),
					A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					'( ' + ($author$project$Pages$Reports$SalesSummarizedV2$moneyStr(
						$elm$core$Basics$abs(method.di)) + ' )'))
				])) : A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Pages$Reports$SalesSummarizedV2$moneyStr(method.di))
				]));
		var barColor = isNegative ? '#f56565' : color;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('ssv2-origin__grid')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(method.of)
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ssv2-muted')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Pages$Reports$SalesSummarizedV2$intSep(method.a9) + ' transações')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex gap-3 items-center')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ssv2-progress ssv2-progress--sm')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('ssv2-progress__bar'),
											A2($elm$html$Html$Attributes$style, 'background', barColor),
											A2(
											$elm$html$Html$Attributes$style,
											'width',
											$author$project$Pages$Reports$SalesSummarizedV2$percentCss(method.ce) + '%')
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ssv2-muted')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Pages$Reports$SalesSummarizedV2$percentStr(method.ce) + '%')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-right')
						]),
					_List_fromArray(
						[valueView]))
				]));
	});
var $author$project$Pages$Reports$SalesSummarizedV2$viewOriginCard = F2(
	function (collapsedOrigins, origin) {
		var meta = $author$project$Pages$Reports$SalesSummarizedV2$originMeta(origin.a$);
		var isExpanded = !A2($elm$core$List$member, origin.a$, collapsedOrigins);
		var headerStat = F2(
			function (label, value) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ssv2-origin__stat')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ssv2-muted-label')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(label)
								])),
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(value)
								]))
						]));
			});
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('ssv2-panel ssv2-origin')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ssv2-origin__header'),
							$elm$html$Html$Events$onClick(
							$author$project$Pages$Reports$SalesSummarizedV2$ToggleOrigin(origin.a$))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex gap-4 items-center')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('ssv2-origin__icon'),
											A2($elm$html$Html$Attributes$style, 'color', meta.cK)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('material-symbols-outlined')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(meta.cW)
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(origin.a$)
												])),
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('ssv2-muted')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(meta.z)
												]))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex gap-8 items-center')
								]),
							_List_fromArray(
								[
									A2(
									headerStat,
									'Transações',
									$author$project$Pages$Reports$SalesSummarizedV2$intSep(origin.a9)),
									A2(
									headerStat,
									'Tipos de pagamento',
									$elm$core$String$fromInt(origin.oS)),
									A2(
									headerStat,
									'Subtotal',
									$author$project$Pages$Reports$SalesSummarizedV2$moneyStr(origin.kO)),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('ssv2-muted')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Pages$Reports$SalesSummarizedV2$percentStr(origin.ce) + '%')
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('material-symbols-outlined ssv2-muted')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											isExpanded ? 'expand_less' : 'expand_more')
										]))
								]))
						])),
				isExpanded ? _Utils_ap(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ssv2-origin__grid ssv2-origin__grid--head')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Tipo de pagamento')
										])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Participação')
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-right')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Valor (R$)')
										]))
								]))
						]),
					_Utils_ap(
						A2(
							$elm$core$List$map,
							$author$project$Pages$Reports$SalesSummarizedV2$viewMethodRow(meta.cK),
							origin.og),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('ssv2-origin__grid ssv2-origin__subtotal')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Subtotal ' + origin.a$)
											])),
										A2($elm$html$Html$span, _List_Nil, _List_Nil),
										A2(
										$elm$html$Html$strong,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-right'),
												A2($elm$html$Html$Attributes$style, 'color', meta.cK)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Pages$Reports$SalesSummarizedV2$moneyStr(origin.kO))
											]))
									]))
							]))) : _List_Nil));
	});
var $author$project$Pages$Reports$SalesSummarizedV2$viewReport = function (model) {
	var _v0 = model.ck;
	switch (_v0.$) {
		case 0:
			return A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mt-4')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Por favor, defina um período desejado ou utilize as datas padrão para realizar a busca.')
					]));
		case 1:
			return $author$project$Components$View$loading;
		case 2:
			return A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mt-4')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Algo deu errado, entre em contato com o suporte')
					]));
		default:
			var report = _v0.a;
			return $elm$core$List$isEmpty(report.hb) ? A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mt-4')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Nenhum registro encontrado')
					])) : A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pages$Reports$SalesSummarizedV2$viewDistribution(report),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						A2(
							$elm$core$List$map,
							$author$project$Pages$Reports$SalesSummarizedV2$viewOriginCard(model.bP),
							report.hb)),
						A2($author$project$Pages$Reports$SalesSummarizedV2$viewConsolidatedFooter, model.T, report)
					]));
	}
};
var $author$project$Pages$Reports$SalesSummarizedV2$viewPage = function (model) {
	return A2(
		$elm$html$Html$main_,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('main-dashboard ssv2')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h1,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-black')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Vendas resumidas')
					])),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('ssv2-subtitle')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Resumo das vendas realizadas no período, agrupado por origem da compra (guichê, WhatsApp, empresa e aplicativo).')
					])),
				$author$project$Pages$Reports$SalesSummarizedV2$viewFilters(model),
				$author$project$Pages$Reports$SalesSummarizedV2$viewReport(model)
			]));
};
var $author$project$Pages$Reports$SalesSummarizedV2$view = F2(
	function (model, shared) {
		var viewModal = function () {
			var _v0 = model.bQ.aY;
			if (!_v0.$) {
				var m_ = _v0.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$Reports$SalesSummarizedV2$CompPDFCreateMSg,
					$author$project$Components$PDF$Create$viewModal(m_));
			} else {
				return $elm$html$Html$text('');
			}
		}();
		return _Utils_Tuple2(
			'Vendas resumidas',
			_List_fromArray(
				[
					$author$project$Pages$Reports$SalesSummarizedV2$viewPage(model),
					viewModal
				]));
	});
var $author$project$Services$Pdf$CashierUsage = 4;
var $author$project$Pages$Reports$Usage$ClickedGenerateReport = F3(
	function (a, b, c) {
		return {$: 20, a: a, b: b, c: c};
	});
var $author$project$Pages$Reports$Usage$InputtedEndDate = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Reports$Usage$InputtedSerialCard = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Reports$Usage$InputtedStartDate = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Reports$Usage$ScrollOpportunitiesEvent = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$Reports$Usage$SelectedClass = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Reports$Usage$SelectedLine = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Reports$Usage$SelectedOperator = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Reports$Usage$SelectedVehicle = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Reports$Usage$Submit = {$: 15};
var $author$project$Pages$Reports$Usage$ToggleFilters = {$: 14};
var $author$project$Services$Pdf$Usage = 0;
var $author$project$Pages$Reports$Usage$classeOptions = F2(
	function (classeIDSelected, rdClasses) {
		var classeIDSelected_ = A2($elm$core$Maybe$withDefault, '', classeIDSelected);
		var options_ = A2(
			$elm$core$List$map,
			function (c) {
				return {
					eX: _Utils_eq(c.k8, classeIDSelected_),
					c3: c.c3,
					di: c.k8
				};
			},
			A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, rdClasses));
		return A2(
			$elm$core$List$cons,
			{eX: classeIDSelected_ === '', c3: 'Todos', di: ''},
			options_);
	});
var $author$project$Pages$Reports$Usage$lineOptions = F2(
	function (lineIDSelected, rdLines) {
		var lineIDSelected_ = A2($elm$core$Maybe$withDefault, '', lineIDSelected);
		var options_ = A2(
			$elm$core$List$map,
			function (l) {
				return {
					eX: _Utils_eq(lineIDSelected_, l.e1),
					c3: l.e1 + (' - ' + l.c3),
					di: l.e1
				};
			},
			A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, rdLines));
		return A2(
			$elm$core$List$cons,
			{eX: lineIDSelected_ === '', c3: 'Todos', di: ''},
			options_);
	});
var $author$project$Pages$Reports$Usage$ScrollInfo = F3(
	function (scrollHeight, scrollTop, offsetHeight) {
		return {jD: offsetHeight, ko: scrollHeight, kp: scrollTop};
	});
var $author$project$Pages$Reports$Usage$scrollInfoDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Reports$Usage$ScrollInfo,
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['target', 'scrollHeight']),
		$elm$json$Json$Decode$float),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['target', 'scrollTop']),
		$elm$json$Json$Decode$float),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['target', 'offsetHeight']),
		$elm$json$Json$Decode$float));
var $author$project$Pages$Reports$Usage$onScroll = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'scroll',
		A2($elm$json$Json$Decode$map, msg, $author$project$Pages$Reports$Usage$scrollInfoDecoder));
};
var $author$project$Pages$Reports$Usage$operatorOptions = F2(
	function (classIDSelected, rdOperators) {
		var classIDSelected_ = A2($elm$core$Maybe$withDefault, '', classIDSelected);
		var options_ = A2(
			$elm$core$List$map,
			function (o) {
				return {
					eX: _Utils_eq(o.dM, classIDSelected_),
					c3: o.c3,
					di: o.dM
				};
			},
			A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, rdOperators));
		return A2(
			$elm$core$List$cons,
			{eX: classIDSelected_ === '', c3: 'Todos', di: ''},
			options_);
	});
var $author$project$Pages$Reports$Usage$vehicleOptions = F2(
	function (vehicleIDSelected, rdVehicle) {
		var vehicleIDSelected_ = A2($elm$core$Maybe$withDefault, '', vehicleIDSelected);
		var options_ = A2(
			$elm$core$List$map,
			function (v) {
				return {
					eX: _Utils_eq(v.dM, vehicleIDSelected_),
					c3: v.l4,
					di: v.dM
				};
			},
			A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, rdVehicle));
		return A2(
			$elm$core$List$cons,
			{eX: vehicleIDSelected_ === '', c3: 'Todos', di: ''},
			options_);
	});
var $author$project$Components$Patterns$Forms$cellEmpty = function (v) {
	return $elm$core$String$isEmpty(v) ? '-' : v;
};
var $author$project$Pages$Reports$Usage$viewRecord = F3(
	function (q, timezone, row) {
		var record_ = A3($author$project$Pages$Reports$Usage$record, q, timezone, row);
		return A2(
			$elm$core$List$map,
			function (str) {
				return A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Components$Patterns$Forms$cellEmpty(str))
						]));
			},
			record_);
	});
var $author$project$Pages$Reports$Usage$viewPage = F3(
	function (model, shared, user) {
		var titleDetailing = (!_Utils_eq(model.T.ic, $elm$core$Maybe$Nothing)) ? 'Detalhamento - ' : '';
		var reportType = (!_Utils_eq(model.T.ic, $elm$core$Maybe$Nothing)) ? 4 : 0;
		var hasPeriodCSV = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				function (_v1) {
					return false;
				},
				model.T.ic)) && A2(
			$krisajenkins$remotedata$RemoteData$withDefault,
			false,
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not),
				model.ck));
		var filters = (!_Utils_eq(model.T.ic, $elm$core$Maybe$Nothing)) ? _List_Nil : _List_fromArray(
			[
				$author$project$Components$Patterns$Forms$Input(
				{
					ie: $elm$core$Maybe$Nothing,
					iH: model.L === 2,
					iP: _List_Nil,
					nR: _List_fromArray(
						[
							$elm$html$Html$Attributes$size(10)
						]),
					jl: $elm$core$Maybe$Just('Início'),
					jn: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col'),
							A2($elm$html$Html$Attributes$style, 'width', 'min-content')
						]),
					n9: $elm$core$Maybe$Just(10),
					c3: '',
					jE: $elm$core$Maybe$Nothing,
					jF: $elm$core$Maybe$Nothing,
					jG: $elm$core$Maybe$Nothing,
					ov: $elm$core$Maybe$Nothing,
					jI: $elm$core$Maybe$Just(
						A2($elm$core$Basics$composeR, $author$project$Pages$Reports$Usage$valueNotEmpty, $author$project$Pages$Reports$Usage$InputtedStartDate)),
					hh: 'Início',
					kE: model.L === 1,
					kY: 'date',
					k1: _List_Nil,
					di: A2($elm$core$Maybe$withDefault, '', model.T.bB)
				}),
				$author$project$Components$Patterns$Forms$Input(
				{
					ie: $elm$core$Maybe$Nothing,
					iH: model.L === 2,
					iP: _List_Nil,
					nR: _List_fromArray(
						[
							$elm$html$Html$Attributes$size(10)
						]),
					jl: $elm$core$Maybe$Just('Fim'),
					jn: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col'),
							A2($elm$html$Html$Attributes$style, 'width', 'min-content')
						]),
					n9: $elm$core$Maybe$Just(10),
					c3: '',
					jE: $elm$core$Maybe$Nothing,
					jF: $elm$core$Maybe$Nothing,
					jG: $elm$core$Maybe$Nothing,
					ov: $elm$core$Maybe$Nothing,
					jI: $elm$core$Maybe$Just(
						A2($elm$core$Basics$composeR, $author$project$Pages$Reports$Usage$valueNotEmpty, $author$project$Pages$Reports$Usage$InputtedEndDate)),
					hh: 'Fim',
					kE: model.L === 1,
					kY: 'date',
					k1: _List_Nil,
					di: A2($elm$core$Maybe$withDefault, '', model.T.bl)
				}),
				$author$project$Components$Patterns$Forms$ButtonIcon(
				{
					lx: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('self-center w-40')
						]),
					l_: $author$project$Pages$Reports$Usage$ToggleFilters,
					l4: 'filter_list',
					iH: model.L === 2,
					fD: 'Filtros extra'
				}),
				$author$project$Components$Patterns$Forms$Button(
				{
					lx: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('self-center w-40')
						]),
					l_: $author$project$Pages$Reports$Usage$Submit,
					iH: model.L === 2,
					fD: 'Pesquisar'
				})
			]);
		var buttonCsv = (((!_Utils_eq(model.T.bB, $elm$core$Maybe$Nothing)) && (!_Utils_eq(model.T.bl, $elm$core$Maybe$Nothing))) || ((!_Utils_eq(model.T.ic, $elm$core$Maybe$Nothing)) && A2(
			$krisajenkins$remotedata$RemoteData$withDefault,
			false,
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not),
				model.ck)))) ? _List_fromArray(
			[
				$author$project$Components$Patterns$Forms$Button(
				{
					lx: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('self-center w-40')
						]),
					l_: A3(
						$author$project$Pages$Reports$Usage$ClickedGenerateReport,
						_Utils_Tuple2(hasPeriodCSV, true),
						1,
						reportType),
					iH: model.L === 2,
					fD: 'Baixar CSV'
				})
			]) : _List_Nil;
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard h-dvh scroll-normal '),
					$author$project$Pages$Reports$Usage$onScroll($author$project$Pages$Reports$Usage$ScrollOpportunitiesEvent)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-black')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(titleDetailing + 'Relatório de Usos')
						])),
					A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex')
								]),
							_List_fromArray(
								[
									$author$project$Components$Patterns$Forms$formSimple(
									{
										hZ: _List_fromArray(
											[
												$elm$html$Html$Attributes$class('w-full'),
												$elm$html$Html$Attributes$novalidate(true)
											]),
										L: model.L,
										jf: _List_fromArray(
											[
												A2(
												$author$project$Components$Patterns$Forms$Custom,
												'flex gap-3',
												_Utils_ap(filters, buttonCsv)),
												A2(
												$author$project$Components$Patterns$Forms$Custom,
												'mt-4 grid grid-cols-auto-fit-minmax gap-3',
												model.dJ ? _List_fromArray(
													[
														$author$project$Components$Patterns$Forms$Select(
														{
															iH: model.L === 2,
															jl: $elm$core$Maybe$Just('Linha'),
															jn: _List_fromArray(
																[
																	$elm$html$Html$Attributes$class('flex flex-col justify-end')
																]),
															jI: $elm$core$Maybe$Just($author$project$Pages$Reports$Usage$SelectedLine),
															jO: A2($author$project$Pages$Reports$Usage$lineOptions, model.T.b3, model.n2),
															jQ: false,
															ks: _List_fromArray(
																[
																	$elm$html$Html$Attributes$class('mt-2'),
																	A2($elm$html$Html$Attributes$style, 'margin-bottom', '0')
																]),
															kE: model.L === 1,
															k1: _List_Nil
														}),
														$author$project$Components$Patterns$Forms$Select(
														{
															iH: model.L === 2,
															jl: $elm$core$Maybe$Just('Classe'),
															jn: _List_fromArray(
																[
																	$elm$html$Html$Attributes$class('flex flex-col justify-end')
																]),
															jI: $elm$core$Maybe$Just($author$project$Pages$Reports$Usage$SelectedClass),
															jO: A2($author$project$Pages$Reports$Usage$classeOptions, model.T.lX, model.dv),
															jQ: false,
															ks: _List_fromArray(
																[
																	$elm$html$Html$Attributes$class('mt-2'),
																	A2($elm$html$Html$Attributes$style, 'margin-bottom', '0')
																]),
															kE: model.L === 1,
															k1: _List_Nil
														}),
														$author$project$Components$Patterns$Forms$Select(
														{
															iH: model.L === 2,
															jl: $elm$core$Maybe$Just('Operador'),
															jn: _List_fromArray(
																[
																	$elm$html$Html$Attributes$class('flex flex-col justify-end')
																]),
															jI: $elm$core$Maybe$Just($author$project$Pages$Reports$Usage$SelectedOperator),
															jO: A2($author$project$Pages$Reports$Usage$operatorOptions, model.T.g6, model.c5),
															jQ: false,
															ks: _List_fromArray(
																[
																	$elm$html$Html$Attributes$class('mt-2'),
																	A2($elm$html$Html$Attributes$style, 'margin-bottom', '0')
																]),
															kE: model.L === 1,
															k1: _List_Nil
														}),
														$author$project$Components$Patterns$Forms$Select(
														{
															iH: model.L === 2,
															jl: $elm$core$Maybe$Just('Veículo'),
															jn: _List_fromArray(
																[
																	$elm$html$Html$Attributes$class('flex flex-col justify-end')
																]),
															jI: $elm$core$Maybe$Just($author$project$Pages$Reports$Usage$SelectedVehicle),
															jO: A2($author$project$Pages$Reports$Usage$vehicleOptions, model.T.fN, model.en),
															jQ: false,
															ks: _List_fromArray(
																[
																	$elm$html$Html$Attributes$class('mt-2'),
																	A2($elm$html$Html$Attributes$style, 'margin-bottom', '0')
																]),
															kE: model.L === 1,
															k1: _List_Nil
														}),
														$author$project$Components$Patterns$Forms$Input(
														{
															ie: $elm$core$Maybe$Nothing,
															iH: model.L === 2,
															iP: _List_Nil,
															nR: _List_Nil,
															jl: $elm$core$Maybe$Just('Serial do cartão'),
															jn: _List_fromArray(
																[
																	$elm$html$Html$Attributes$class('flex flex-col')
																]),
															n9: $elm$core$Maybe$Just(80),
															c3: '',
															jE: $elm$core$Maybe$Nothing,
															jF: $elm$core$Maybe$Nothing,
															jG: $elm$core$Maybe$Nothing,
															ov: $elm$core$Maybe$Nothing,
															jI: $elm$core$Maybe$Just(
																A2($elm$core$Basics$composeR, $author$project$Pages$Reports$Usage$valueNotEmpty, $author$project$Pages$Reports$Usage$InputtedSerialCard)),
															hh: 'Fim',
															kE: model.L === 1,
															kY: 'text',
															k1: _List_Nil,
															di: A2($elm$core$Maybe$withDefault, '', model.T.kx)
														})
													]) : _List_Nil)
											]),
										oc: $elm$core$Maybe$Nothing,
										pX: 'Pesquisar'
									})
								])),
							function () {
							var _v0 = model.ck;
							switch (_v0.$) {
								case 3:
									var report = _v0.a;
									var viewRecords = A2(
										$elm$core$List$map,
										A2($author$project$Pages$Reports$Usage$viewRecord, model.T, shared.kS),
										report);
									return $elm$core$List$isEmpty(viewRecords) ? $elm$html$Html$text('Nenhum registro encontrado') : $author$project$Components$Patterns$Tables$default(
										{
											nF: $author$project$Pages$Reports$Usage$headers(model.T),
											nX: true,
											pj: viewRecords
										});
								case 0:
									return $elm$html$Html$text('Por favor, defina um período desejado ou utilize as datas padrão para realizar a busca.');
								case 1:
									return $author$project$Components$View$loading;
								default:
									var e = _v0.a;
									return $elm$html$Html$text('Ops! Algo deu errado');
							}
						}()
						]))
				]));
	});
var $author$project$Pages$Reports$Usage$view = F3(
	function (model, user, shared) {
		var viewModal = function () {
			var _v0 = model.bQ.aY;
			if (!_v0.$) {
				var m_ = _v0.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$Reports$Usage$CompPDFCreateMSg,
					$author$project$Components$PDF$Create$viewModal(m_));
			} else {
				return $elm$html$Html$text('');
			}
		}();
		var titleDetailing = (!_Utils_eq(model.T.ic, $elm$core$Maybe$Nothing)) ? 'Detalhamento - ' : '';
		return _Utils_Tuple2(
			titleDetailing + 'Relatório de Usos',
			_List_fromArray(
				[
					A3($author$project$Pages$Reports$Usage$viewPage, model, shared, user),
					viewModal
				]));
	});
var $author$project$Services$Pdf$CashierGroupedUsage = 3;
var $author$project$Pages$Reports$UsesPerClass$InputtedEndDate = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Reports$UsesPerClass$InputtedStartDate = function (a) {
	return {$: 6, a: a};
};
var $author$project$Services$Pdf$Pdf = 0;
var $author$project$Pages$Reports$UsesPerClass$SelectedGroupBy = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Reports$UsesPerClass$SelectedLine = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Reports$UsesPerClass$SelectedOperator = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Reports$UsesPerClass$SelectedVehicle = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Reports$UsesPerClass$Submit = {$: 13};
var $author$project$Pages$Reports$UsesPerClass$ToggleFilters = {$: 12};
var $author$project$Services$Pdf$UsingByWalletClass = 2;
var $author$project$Pages$Reports$UsesPerClass$groupOptions = function (groupSelected) {
	var groupSelected_ = A2($elm$core$Maybe$withDefault, '', groupSelected);
	var options_ = A2(
		$elm$core$List$map,
		function (_v0) {
			var k = _v0.a;
			var v = _v0.b;
			return {
				eX: _Utils_eq(groupSelected_, k),
				c3: v,
				di: k
			};
		},
		$author$project$Pages$Reports$UsesPerClass$groups);
	return A2(
		$elm$core$List$cons,
		{eX: groupSelected_ === '', c3: 'Não selecionado', di: ''},
		options_);
};
var $author$project$Pages$Reports$UsesPerClass$lineOptions = function (rdLines) {
	var options_ = A2(
		$elm$core$List$map,
		function (l) {
			return _Utils_Tuple2(l.e1, l.e1 + (' - ' + l.c3));
		},
		A2(
			$elm$core$List$sortBy,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.e1;
				},
				A2(
					$elm$core$Basics$composeR,
					$elm$core$String$toInt,
					$elm$core$Maybe$withDefault(0))),
			A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, rdLines)));
	return A2(
		$elm$core$List$cons,
		_Utils_Tuple2('', 'Todos'),
		options_);
};
var $author$project$Pages$Reports$UsesPerClass$operatorOptions = function (rdOperators) {
	var options_ = A2(
		$elm$core$List$map,
		function (o) {
			return _Utils_Tuple2(o.dM, o.c3);
		},
		A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, rdOperators));
	return A2(
		$elm$core$List$cons,
		_Utils_Tuple2('', 'Todos'),
		options_);
};
var $author$project$Pages$Reports$UsesPerClass$queriesToFilter = function (queries) {
	var maybeQ = F2(
		function (param, mValue) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (v) {
						return $elm$core$List$singleton(
							{oK: param, di: v});
					},
					mValue));
		});
	return _Utils_ap(
		A2(maybeQ, 'start', queries.bB),
		_Utils_ap(
			A2(maybeQ, 'end', queries.bl),
			_Utils_ap(
				A2(
					maybeQ,
					'page',
					$elm$core$Maybe$Just(
						$elm$core$String$fromInt(queries.bv))),
				_Utils_ap(
					A2(maybeQ, 'groupBy', queries.nB),
					_Utils_ap(
						A2(maybeQ, 'lineCode', queries.b3),
						_Utils_ap(
							A2(maybeQ, 'operatorID', queries.g6),
							_Utils_ap(
								A2(maybeQ, 'vehicleID', queries.fN),
								A2(maybeQ, 'cashierID', queries.ic))))))));
};
var $author$project$Pages$Reports$UsesPerClass$vehicleOptions = function (rdVehicle) {
	var options_ = A2(
		$elm$core$List$map,
		function (v) {
			return _Utils_Tuple2(v.dM, v.l4);
		},
		A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, rdVehicle));
	return A2(
		$elm$core$List$cons,
		_Utils_Tuple2('', 'Todos'),
		options_);
};
var $author$project$Pages$Reports$UsesPerClass$isBreadClass = F2(
	function (header, data) {
		return A2(
			$elm$core$List$any,
			function (h_) {
				return _Utils_eq(header.ik, h_.ik) && (!$elm$core$String$isEmpty(h_.kY));
			},
			data.nG);
	});
var $author$project$Pages$Reports$UsesPerClass$viewRowNoGrouping = F2(
	function (data, header) {
		var classRows = function () {
			var classSubItemTDName = ($author$project$Pages$Reports$UsesPerClass$isSubClass(header) && A2($author$project$Pages$Reports$UsesPerClass$hasBreadClass, header, data)) ? 'pl-16' : '';
			var classSubItemOrBreadTR = (($author$project$Pages$Reports$UsesPerClass$isSubClass(header) || A2($author$project$Pages$Reports$UsesPerClass$isBreadClass, header, data)) && A2($author$project$Pages$Reports$UsesPerClass$hasBreadClass, header, data)) ? 'bg-gray-tint1' : '';
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$tr,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(classSubItemOrBreadTR)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class(classSubItemTDName)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Pages$Reports$UsesPerClass$getClassName(header))
								])),
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($author$project$Pages$Reports$UsesPerClass$getClassAmount, header.dM, data.px))
								])),
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$formatAsMoney(
										A2($author$project$Pages$Reports$UsesPerClass$getFareAmount, header.dM, data.px)))
								]))
						]))
				]);
		}();
		return classRows;
	});
var $author$project$Pages$Reports$UsesPerClass$viewTableNoGrouping = function (data) {
	var takeTotalValues = A2(
		$elm$core$List$filter,
		function (h_) {
			return (h_.dM !== 'totalFare') && (h_.dM !== 'totalQuantity');
		},
		data.nG);
	var _v0 = A3(
		$elm$core$List$foldl,
		F2(
			function (row, _v1) {
				var qtyAcc = _v1.a;
				var fareAcc = _v1.b;
				return _Utils_Tuple2(
					qtyAcc + A2(
						$elm$core$Maybe$withDefault,
						0,
						A2($elm$core$Dict$get, 'totalQuantity', row.dv)),
					fareAcc + A2(
						$elm$core$Maybe$withDefault,
						0,
						A2($elm$core$Dict$get, 'totalFare', row.ni)));
			}),
		_Utils_Tuple2(0, 0),
		data.px);
	var totalQuantity = _v0.a;
	var totalFare = _v0.b;
	var total = _List_fromArray(
		[
			A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-gray-tint text-gray-tint4'),
					A2($elm$html$Html$Attributes$style, 'font-weight', 'bold')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Total')
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(totalQuantity))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$formatAsMoney(
								$elm$core$String$fromInt(totalFare)))
						]))
				]))
		]);
	return A2(
		$elm$html$Html$table,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'border-collapse', 'collapse'),
				A2($elm$html$Html$Attributes$style, 'text-align', 'left'),
				A2($elm$html$Html$Attributes$attribute, 'cellspacing', '0'),
				$elm$html$Html$Attributes$class('data-table-dashboard my-4')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$thead,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$tr,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$th,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Classe')
									])),
								A2(
								$elm$html$Html$th,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Quantidade')
									])),
								A2(
								$elm$html$Html$th,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Valor')
									]))
							]))
					])),
				A2(
				$elm$html$Html$tbody,
				_List_Nil,
				_Utils_ap(
					A2(
						$elm$core$List$concatMap,
						$author$project$Pages$Reports$UsesPerClass$viewRowNoGrouping(data),
						takeTotalValues),
					total))
			]));
};
var $author$project$Pages$Reports$UsesPerClass$alignCenter = A2($elm$html$Html$Attributes$style, 'text-align', 'center');
var $author$project$Pages$Reports$UsesPerClass$cellWithGroup = F2(
	function (header, line) {
		var totalQuantity = ($elm$core$String$toLower(header.dM) === 'totalQuantity') ? A2(
			$elm$core$Maybe$map,
			$elm$core$String$fromInt,
			A2($elm$core$Dict$get, 'totalQuantity', line.dv)) : (($elm$core$String$toLower(header.dM) === 'totalFare') ? A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeL, $author$project$Utils$formatAsMoney, $elm$core$String$fromInt),
			A2($elm$core$Dict$get, 'totalFare', line.ni)) : $elm$core$Maybe$Nothing);
		var quantity = A2(
			$elm$core$Maybe$map,
			$elm$core$String$fromInt,
			A2($elm$core$Dict$get, header.dM, line.dv));
		var fare = A2(
			$elm$core$Maybe$map,
			$elm$core$String$fromInt,
			A2($elm$core$Dict$get, header.dM, line.ni));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			function () {
				var _v0 = _Utils_Tuple3(quantity, fare, totalQuantity);
				if (!_v0.a.$) {
					if (!_v0.b.$) {
						var q = _v0.a.a;
						var f = _v0.b.a;
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Pages$Reports$UsesPerClass$alignCenter,
										A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(q)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Pages$Reports$UsesPerClass$alignCenter,
										A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Utils$formatAsMoney(f))
									]))
							]);
					} else {
						var q = _v0.a.a;
						var _v2 = _v0.b;
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Pages$Reports$UsesPerClass$alignCenter,
										A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(q)
									]))
							]);
					}
				} else {
					if (!_v0.b.$) {
						var _v1 = _v0.a;
						var f = _v0.b.a;
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Pages$Reports$UsesPerClass$alignCenter,
										A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Utils$formatAsMoney(f))
									]))
							]);
					} else {
						if (!_v0.c.$) {
							var _v3 = _v0.a;
							var _v4 = _v0.b;
							var total = _v0.c.a;
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Pages$Reports$UsesPerClass$alignCenter,
											A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(total)
										]))
								]);
						} else {
							var _v5 = _v0.a;
							var _v6 = _v0.b;
							var _v7 = _v0.c;
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[$author$project$Pages$Reports$UsesPerClass$alignCenter]),
									_List_fromArray(
										[
											$elm$html$Html$text('-')
										]))
								]);
						}
					}
				}
			}());
	});
var $author$project$Pages$Reports$UsesPerClass$viewRowWithGrouping = F3(
	function (data, headers_, line) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$tr,
				_List_Nil,
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('border px-4 py-2')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(line.fD)
							])),
					A2(
						$elm$core$List$map,
						function (header) {
							var classSubItemOrBreadTH = (($author$project$Pages$Reports$UsesPerClass$isSubClass(header) || A2($author$project$Pages$Reports$UsesPerClass$isBreadClass, header, data)) && A2($author$project$Pages$Reports$UsesPerClass$hasBreadClass, header, data)) ? 'bg-gray-tint1' : '';
							return A2(
								$elm$html$Html$td,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(classSubItemOrBreadTH),
										$elm$html$Html$Attributes$class('border px-4 py-2')
									]),
								_List_fromArray(
									[
										A2($author$project$Pages$Reports$UsesPerClass$cellWithGroup, header, line)
									]));
						},
						headers_)))
			]);
	});
var $author$project$Pages$Reports$UsesPerClass$viewTableWithGrouping = F2(
	function (data, groupByCode) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$table,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'border-collapse', 'collapse'),
							A2($elm$html$Html$Attributes$style, 'text-align', 'left'),
							A2($elm$html$Html$Attributes$attribute, 'cellspacing', '0'),
							$elm$html$Html$Attributes$class('data-table-dashboard my-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$thead,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_Utils_ap(
										_List_fromArray(
											[
												A2(
												$elm$html$Html$th,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2(
															$elm$core$Maybe$withDefault,
															'-',
															A2(
																$elm$core$Maybe$map,
																$elm$core$Tuple$second,
																$elm$core$List$head(
																	A2(
																		$elm$core$List$filter,
																		function (_v0) {
																			var k = _v0.a;
																			return _Utils_eq(k, groupByCode);
																		},
																		$author$project$Pages$Reports$UsesPerClass$groups)))))
													]))
											]),
										A2(
											$elm$core$List$map,
											function (header) {
												if ((header.dM === 'totalQuantity') || (header.dM === 'totalFare')) {
													return A2(
														$elm$html$Html$th,
														_List_fromArray(
															[$author$project$Pages$Reports$UsesPerClass$alignCenter]),
														_List_fromArray(
															[
																$elm$html$Html$text(header.ik)
															]));
												} else {
													var classSubItemOrBreadTH = (($author$project$Pages$Reports$UsesPerClass$isSubClass(header) || A2($author$project$Pages$Reports$UsesPerClass$isBreadClass, header, data)) && A2($author$project$Pages$Reports$UsesPerClass$hasBreadClass, header, data)) ? 'bg-gray-tint1' : '';
													return A2(
														$elm$html$Html$th,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class(classSubItemOrBreadTH),
																$author$project$Pages$Reports$UsesPerClass$alignCenter,
																$elm$html$Html$Attributes$alt(
																$author$project$Pages$Reports$UsesPerClass$getClassName(header))
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('tooltip')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		$elm$core$String$toUpper(
																			A2(
																				$elm$core$String$left,
																				3,
																				$author$project$Pages$Reports$UsesPerClass$getClassName(header)))),
																		A2(
																		$elm$html$Html$span,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('tooltiptext')
																			]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text(
																				$author$project$Pages$Reports$UsesPerClass$getClassName(header))
																			]))
																	]))
															]));
												}
											},
											data.nG)))
								])),
							A2(
							$elm$html$Html$tbody,
							_List_Nil,
							A2(
								$elm$core$List$concatMap,
								A2($author$project$Pages$Reports$UsesPerClass$viewRowWithGrouping, data, data.nG),
								data.px))
						]))
				]));
	});
var $author$project$Pages$Reports$UsesPerClass$view__ = F2(
	function (groupBy, data) {
		if (!groupBy.$) {
			var group = groupBy.a;
			return A2($author$project$Pages$Reports$UsesPerClass$viewTableWithGrouping, data, group);
		} else {
			return $author$project$Pages$Reports$UsesPerClass$viewTableNoGrouping(data);
		}
	});
var $author$project$Pages$Reports$UsesPerClass$viewPage = F3(
	function (model, shared, user) {
		var titleDetailing = (!_Utils_eq(model.T.ic, $elm$core$Maybe$Nothing)) ? 'Detalhamento - ' : '';
		var reportType = (!_Utils_eq(model.T.ic, $elm$core$Maybe$Nothing)) ? 3 : 2;
		var filters = (!_Utils_eq(model.T.ic, $elm$core$Maybe$Nothing)) ? _List_Nil : _List_fromArray(
			[
				$author$project$Components$Patterns$Forms$Input(
				{
					ie: $elm$core$Maybe$Nothing,
					iH: model.L === 2,
					iP: _List_Nil,
					nR: _List_fromArray(
						[
							$elm$html$Html$Attributes$size(10)
						]),
					jl: $elm$core$Maybe$Just('Início'),
					jn: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col'),
							A2($elm$html$Html$Attributes$style, 'width', 'min-content')
						]),
					n9: $elm$core$Maybe$Just(10),
					c3: '',
					jE: $elm$core$Maybe$Nothing,
					jF: $elm$core$Maybe$Nothing,
					jG: $elm$core$Maybe$Nothing,
					ov: $elm$core$Maybe$Nothing,
					jI: $elm$core$Maybe$Just(
						A2($elm$core$Basics$composeR, $author$project$Pages$Reports$UsesPerClass$valueNotEmpty, $author$project$Pages$Reports$UsesPerClass$InputtedStartDate)),
					hh: 'Início',
					kE: model.L === 1,
					kY: 'date',
					k1: _List_Nil,
					di: A2($elm$core$Maybe$withDefault, '', model.T.bB)
				}),
				$author$project$Components$Patterns$Forms$Input(
				{
					ie: $elm$core$Maybe$Nothing,
					iH: model.L === 2,
					iP: _List_Nil,
					nR: _List_fromArray(
						[
							$elm$html$Html$Attributes$size(10)
						]),
					jl: $elm$core$Maybe$Just('Fim'),
					jn: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col'),
							A2($elm$html$Html$Attributes$style, 'width', 'min-content')
						]),
					n9: $elm$core$Maybe$Just(10),
					c3: '',
					jE: $elm$core$Maybe$Nothing,
					jF: $elm$core$Maybe$Nothing,
					jG: $elm$core$Maybe$Nothing,
					ov: $elm$core$Maybe$Nothing,
					jI: $elm$core$Maybe$Just(
						A2($elm$core$Basics$composeR, $author$project$Pages$Reports$UsesPerClass$valueNotEmpty, $author$project$Pages$Reports$UsesPerClass$InputtedEndDate)),
					hh: 'Fim',
					kE: model.L === 1,
					kY: 'date',
					k1: _List_Nil,
					di: A2($elm$core$Maybe$withDefault, '', model.T.bl)
				}),
				$author$project$Components$Patterns$Forms$ButtonIcon(
				{
					lx: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('self-center w-40')
						]),
					l_: $author$project$Pages$Reports$UsesPerClass$ToggleFilters,
					l4: 'filter_list',
					iH: model.L === 2,
					fD: 'Filtros extra'
				}),
				$author$project$Components$Patterns$Forms$Button(
				{
					lx: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('self-center w-40')
						]),
					l_: $author$project$Pages$Reports$UsesPerClass$Submit,
					iH: model.L === 2,
					fD: 'Pesquisar'
				})
			]);
		var buttonPDF = function () {
			if (A2(
				$krisajenkins$remotedata$RemoteData$withDefault,
				true,
				A2(
					$krisajenkins$remotedata$RemoteData$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.px;
						},
						$elm$core$List$isEmpty),
					model.ck))) {
				return _List_Nil;
			} else {
				var newQueries = function () {
					var _v2 = model.T.ic;
					if (!_v2.$) {
						var cashierID = _v2.a;
						return function (q) {
							return _Utils_update(
								q,
								{
									ic: $elm$core$Maybe$Just(cashierID)
								});
						}($author$project$Services$Models$initQueriesUsesPerClass);
					} else {
						return model.T;
					}
				}();
				return _List_fromArray(
					[
						$author$project$Components$Patterns$Forms$ButtonIcon(
						{
							lx: _List_Nil,
							l_: $author$project$Pages$Reports$UsesPerClass$CompPDFCreateMSg(
								A4(
									$author$project$Components$PDF$Create$ClickedOpenModal,
									_Utils_Tuple2(false, true),
									0,
									reportType,
									$author$project$Pages$Reports$UsesPerClass$queriesToFilter(newQueries))),
							l4: 'picture_as_pdf',
							iH: model.L === 2,
							fD: 'Gerar PDF'
						})
					]);
			}
		}();
		var buttonCsv = function () {
			if (A2(
				$krisajenkins$remotedata$RemoteData$withDefault,
				true,
				A2(
					$krisajenkins$remotedata$RemoteData$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.px;
						},
						$elm$core$List$isEmpty),
					model.ck))) {
				return _List_Nil;
			} else {
				var newQueries = function () {
					var _v1 = model.T.ic;
					if (!_v1.$) {
						var cashierID = _v1.a;
						return function (q) {
							return _Utils_update(
								q,
								{
									ic: $elm$core$Maybe$Just(cashierID)
								});
						}($author$project$Services$Models$initQueriesUsesPerClass);
					} else {
						return model.T;
					}
				}();
				return _List_fromArray(
					[
						$author$project$Components$Patterns$Forms$Button(
						{
							lx: _List_fromArray(
								[
									$elm$html$Html$Attributes$class('self-center w-40')
								]),
							l_: $author$project$Pages$Reports$UsesPerClass$CompPDFCreateMSg(
								A4(
									$author$project$Components$PDF$Create$ClickedOpenModal,
									_Utils_Tuple2(false, true),
									1,
									reportType,
									$author$project$Pages$Reports$UsesPerClass$queriesToFilter(newQueries))),
							iH: model.L === 2,
							fD: 'Baixar CSV'
						})
					]);
			}
		}();
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard h-dvh scroll-normal ')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-black')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(titleDetailing + 'Relatório utilização por classes')
						])),
					A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex')
								]),
							_List_fromArray(
								[
									$author$project$Components$Patterns$Forms$formSimple(
									{
										hZ: _List_fromArray(
											[
												$elm$html$Html$Attributes$class('w-full'),
												$elm$html$Html$Attributes$novalidate(true)
											]),
										L: model.L,
										jf: _List_fromArray(
											[
												A2(
												$author$project$Components$Patterns$Forms$Custom,
												'flex gap-3',
												_Utils_ap(
													filters,
													_Utils_ap(buttonCsv, buttonPDF))),
												A2(
												$author$project$Components$Patterns$Forms$Custom,
												'mt-4 grid grid-cols-auto-fit-minmax gap-3',
												model.dJ ? _List_fromArray(
													[
														$author$project$Components$Patterns$Forms$Select(
														{
															iH: model.L === 2,
															jl: $elm$core$Maybe$Just('Agrupar'),
															jn: _List_fromArray(
																[
																	$elm$html$Html$Attributes$class('flex flex-col justify-end')
																]),
															jI: $elm$core$Maybe$Just($author$project$Pages$Reports$UsesPerClass$SelectedGroupBy),
															jO: $author$project$Pages$Reports$UsesPerClass$groupOptions(model.T.nB),
															jQ: false,
															ks: _List_fromArray(
																[
																	$elm$html$Html$Attributes$class('mt-2'),
																	A2($elm$html$Html$Attributes$style, 'margin-bottom', '0')
																]),
															kE: model.L === 1,
															k1: _List_Nil
														}),
														$author$project$Components$Patterns$Forms$MultiSelect(
														{
															h$: _List_Nil,
															fT: false,
															eS: $author$project$Pages$Reports$UsesPerClass$lineInputID,
															gO: model.dT,
															jl: 'Linha',
															jI: $author$project$Pages$Reports$UsesPerClass$SelectedLine,
															g2: A2($author$project$Pages$Reports$UsesPerClass$SetMultiSelect, 0, true),
															jO: $author$project$Pages$Reports$UsesPerClass$lineOptions(model.n2),
															g7: model.aB,
															hh: 'Selecione múltiplas linhas',
															kt: $author$project$Pages$Reports$UsesPerClass$lineSelectID
														}),
														$author$project$Components$Patterns$Forms$MultiSelect(
														{
															h$: _List_Nil,
															fT: true,
															eS: $author$project$Pages$Reports$UsesPerClass$operatorInputID,
															gO: model.dU,
															jl: 'Operador',
															jI: $author$project$Pages$Reports$UsesPerClass$SelectedOperator,
															g2: A2($author$project$Pages$Reports$UsesPerClass$SetMultiSelect, 1, true),
															jO: $author$project$Pages$Reports$UsesPerClass$operatorOptions(model.c5),
															g7: model.aF,
															hh: 'Selecione múltiplos operadores',
															kt: $author$project$Pages$Reports$UsesPerClass$operatorSelectID
														}),
														$author$project$Components$Patterns$Forms$MultiSelect(
														{
															h$: _List_Nil,
															fT: true,
															eS: $author$project$Pages$Reports$UsesPerClass$vehicleInputID,
															gO: model.dW,
															jl: 'Veículo',
															jI: $author$project$Pages$Reports$UsesPerClass$SelectedVehicle,
															g2: A2($author$project$Pages$Reports$UsesPerClass$SetMultiSelect, 2, true),
															jO: $author$project$Pages$Reports$UsesPerClass$vehicleOptions(model.en),
															g7: model.aN,
															hh: 'Selecione múltiplos veículos',
															kt: $author$project$Pages$Reports$UsesPerClass$vehicleSelectID
														})
													]) : _List_Nil)
											]),
										oc: $elm$core$Maybe$Nothing,
										pX: 'Pesquisar'
									})
								])),
							function () {
							var _v0 = model.ck;
							switch (_v0.$) {
								case 3:
									var report = _v0.a;
									return $elm$core$List$isEmpty(report.px) ? $elm$html$Html$text('Nenhum registro encontrado') : A2($author$project$Pages$Reports$UsesPerClass$view__, model.T.nB, report);
								case 0:
									return $elm$html$Html$text('Por favor, defina um período desejado ou utilize as datas padrão para realizar a busca.');
								case 1:
									return $author$project$Components$View$loading;
								default:
									var e = _v0.a;
									return $elm$html$Html$text('Ops! Algo deu errado');
							}
						}()
						]))
				]));
	});
var $author$project$Pages$Reports$UsesPerClass$view = F3(
	function (model, user, shared) {
		var viewModal = function () {
			var _v0 = model.bQ.aY;
			if (!_v0.$) {
				var m_ = _v0.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$Reports$UsesPerClass$CompPDFCreateMSg,
					$author$project$Components$PDF$Create$viewModal(m_));
			} else {
				return $elm$html$Html$text('');
			}
		}();
		var titleDetailing = (!_Utils_eq(model.T.ic, $elm$core$Maybe$Nothing)) ? 'Detalhamento - ' : '';
		return _Utils_Tuple2(
			titleDetailing + 'Relatório utilização por classes',
			_List_fromArray(
				[
					A3($author$project$Pages$Reports$UsesPerClass$viewPage, model, shared, user),
					viewModal
				]));
	});
var $author$project$Pages$Reports$UsesPerDay$GetTimeToDownload = {$: 5};
var $author$project$Pages$Reports$UsesPerDay$InputtedEndDate = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Reports$UsesPerDay$InputtedStartDate = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Reports$UsesPerDay$Submit = {$: 4};
var $author$project$Pages$Reports$UsesPerDay$valueNotEmpty = function (str) {
	return $elm$core$String$isEmpty(str) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(str);
};
var $author$project$Pages$Reports$UsesPerDay$viewRecord = function (row) {
	return A2(
		$elm$core$List$cons,
		A2(
			$elm$html$Html$td,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(row.fD)
				])),
		A2(
			$elm$core$List$map,
			function (v) {
				return A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(v))
						]));
			},
			row.di));
};
var $author$project$Pages$Reports$UsesPerDay$viewPage = F2(
	function (model, user) {
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-black')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Utilização por dia')
						])),
					A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex')
								]),
							_List_fromArray(
								[
									$author$project$Components$Patterns$Forms$filters(
									{
										hZ: _List_Nil,
										lZ: '',
										mM: $krisajenkins$remotedata$RemoteData$isLoading(model.ck),
										jf: _List_fromArray(
											[
												{
												h_: _List_Nil,
												h$: _List_Nil,
												ih: 'bg-busca',
												jI: A2($elm$core$Basics$composeR, $author$project$Pages$Reports$UsesPerDay$valueNotEmpty, $author$project$Pages$Reports$UsesPerDay$InputtedStartDate),
												hh: 'Início',
												kQ: $elm$core$Maybe$Nothing,
												kY: 'date',
												di: A2($elm$core$Maybe$withDefault, '', model.T.bB)
											},
												{
												h_: _List_Nil,
												h$: _List_Nil,
												ih: 'bg-busca',
												jI: A2($elm$core$Basics$composeR, $author$project$Pages$Reports$UsesPerDay$valueNotEmpty, $author$project$Pages$Reports$UsesPerDay$InputtedEndDate),
												hh: 'Fim',
												kQ: $elm$core$Maybe$Nothing,
												kY: 'date',
												di: A2($elm$core$Maybe$withDefault, '', model.T.bl)
											}
											]),
										pW: $author$project$Pages$Reports$UsesPerDay$Submit
									}),
									A2(
									$krisajenkins$remotedata$RemoteData$withDefault,
									true,
									A2(
										$krisajenkins$remotedata$RemoteData$map,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.px;
											},
											$elm$core$List$isEmpty),
										model.ck)) ? $elm$html$Html$text('') : $author$project$Components$GeneratorCSV$buttonDownload($author$project$Pages$Reports$UsesPerDay$GetTimeToDownload)
								])),
							function () {
							var _v0 = model.ck;
							switch (_v0.$) {
								case 3:
									var table = _v0.a;
									var viewRecords = A2($elm$core$List$map, $author$project$Pages$Reports$UsesPerDay$viewRecord, table.px);
									var headers = A2($elm$core$List$cons, 'Classe', table.nF);
									return $elm$core$List$isEmpty(viewRecords) ? $elm$html$Html$text('Nenhum registro encontrado') : $author$project$Components$Patterns$Tables$default(
										{nF: headers, nX: true, pj: viewRecords});
								case 0:
									return $elm$html$Html$text('Por favor, defina um período desejado ou utilize as datas padrão para realizar a busca.');
								case 1:
									return $author$project$Components$View$loading;
								default:
									var e = _v0.a;
									return $elm$html$Html$text('Ops! Algo deu errado');
							}
						}()
						]))
				]));
	});
var $author$project$Pages$Reports$UsesPerDay$view = F3(
	function (model, user, shared) {
		var viewModal = $elm$html$Html$text('');
		return _Utils_Tuple2(
			'Relatório utilização por dia',
			_List_fromArray(
				[
					A2($author$project$Pages$Reports$UsesPerDay$viewPage, model, user),
					viewModal
				]));
	});
var $author$project$Pages$Reports$UsesPerLine$GetTimeToDownload = {$: 5};
var $author$project$Pages$Reports$UsesPerLine$InputtedEndDate = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Reports$UsesPerLine$InputtedStartDate = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Reports$UsesPerLine$Submit = {$: 4};
var $author$project$Pages$Reports$UsesPerLine$valueNotEmpty = function (str) {
	return $elm$core$String$isEmpty(str) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(str);
};
var $author$project$Pages$Reports$UsesPerLine$viewRecord = function (row) {
	return A2(
		$elm$core$List$cons,
		A2(
			$elm$html$Html$td,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(row.fD)
				])),
		A2(
			$elm$core$List$map,
			function (v) {
				return A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(v))
						]));
			},
			row.di));
};
var $author$project$Pages$Reports$UsesPerLine$viewPage = F2(
	function (model, user) {
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-black')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Utilização por linha')
						])),
					A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex')
								]),
							_List_fromArray(
								[
									$author$project$Components$Patterns$Forms$filters(
									{
										hZ: _List_Nil,
										lZ: '',
										mM: $krisajenkins$remotedata$RemoteData$isLoading(model.ck),
										jf: _List_fromArray(
											[
												{
												h_: _List_Nil,
												h$: _List_Nil,
												ih: 'bg-busca',
												jI: A2($elm$core$Basics$composeR, $author$project$Pages$Reports$UsesPerLine$valueNotEmpty, $author$project$Pages$Reports$UsesPerLine$InputtedStartDate),
												hh: 'Início',
												kQ: $elm$core$Maybe$Nothing,
												kY: 'date',
												di: A2($elm$core$Maybe$withDefault, '', model.T.bB)
											},
												{
												h_: _List_Nil,
												h$: _List_Nil,
												ih: 'bg-busca',
												jI: A2($elm$core$Basics$composeR, $author$project$Pages$Reports$UsesPerLine$valueNotEmpty, $author$project$Pages$Reports$UsesPerLine$InputtedEndDate),
												hh: 'Fim',
												kQ: $elm$core$Maybe$Nothing,
												kY: 'date',
												di: A2($elm$core$Maybe$withDefault, '', model.T.bl)
											}
											]),
										pW: $author$project$Pages$Reports$UsesPerLine$Submit
									}),
									A2(
									$krisajenkins$remotedata$RemoteData$withDefault,
									true,
									A2(
										$krisajenkins$remotedata$RemoteData$map,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.px;
											},
											$elm$core$List$isEmpty),
										model.ck)) ? $elm$html$Html$text('') : $author$project$Components$GeneratorCSV$buttonDownload($author$project$Pages$Reports$UsesPerLine$GetTimeToDownload)
								])),
							function () {
							var _v0 = model.ck;
							switch (_v0.$) {
								case 3:
									var table = _v0.a;
									var viewRecords = A2($elm$core$List$map, $author$project$Pages$Reports$UsesPerLine$viewRecord, table.px);
									var headers = A2($elm$core$List$cons, 'Classe', table.nF);
									return $elm$core$List$isEmpty(viewRecords) ? $elm$html$Html$text('Nenhum registro encontrado') : $author$project$Components$Patterns$Tables$default(
										{nF: headers, nX: true, pj: viewRecords});
								case 0:
									return $elm$html$Html$text('Por favor, defina um período desejado ou utilize as datas padrão para realizar a busca.');
								case 1:
									return $author$project$Components$View$loading;
								default:
									var e = _v0.a;
									return $elm$html$Html$text('Ops! Algo deu errado');
							}
						}()
						]))
				]));
	});
var $author$project$Pages$Reports$UsesPerLine$view = F3(
	function (model, user, shared) {
		var viewModal = $elm$html$Html$text('');
		return _Utils_Tuple2(
			'Relatório utilização por linha',
			_List_fromArray(
				[
					A2($author$project$Pages$Reports$UsesPerLine$viewPage, model, user),
					viewModal
				]));
	});
var $author$project$Pages$Reports$UsesPerVehicle$GetTimeToDownload = {$: 5};
var $author$project$Pages$Reports$UsesPerVehicle$InputtedStartDate = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Reports$UsesPerVehicle$InputtedVEndDate = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Reports$UsesPerVehicle$Submit = {$: 4};
var $author$project$Pages$Reports$UsesPerVehicle$valueNotEmpty = function (str) {
	return $elm$core$String$isEmpty(str) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(str);
};
var $author$project$Pages$Reports$UsesPerVehicle$viewRecord = function (row) {
	return A2(
		$elm$core$List$cons,
		A2(
			$elm$html$Html$td,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(row.fD)
				])),
		A2(
			$elm$core$List$map,
			function (v) {
				return A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(v))
						]));
			},
			row.di));
};
var $author$project$Pages$Reports$UsesPerVehicle$viewPage = F2(
	function (model, user) {
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-black')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Utilização por veiculo')
						])),
					A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex ')
								]),
							_List_fromArray(
								[
									$author$project$Components$Patterns$Forms$filters(
									{
										hZ: _List_Nil,
										lZ: '',
										mM: $krisajenkins$remotedata$RemoteData$isLoading(model.ck),
										jf: _List_fromArray(
											[
												{
												h_: _List_Nil,
												h$: _List_Nil,
												ih: 'bg-busca',
												jI: A2($elm$core$Basics$composeR, $author$project$Pages$Reports$UsesPerVehicle$valueNotEmpty, $author$project$Pages$Reports$UsesPerVehicle$InputtedStartDate),
												hh: 'Início',
												kQ: $elm$core$Maybe$Nothing,
												kY: 'date',
												di: A2($elm$core$Maybe$withDefault, '', model.T.bB)
											},
												{
												h_: _List_Nil,
												h$: _List_Nil,
												ih: 'bg-busca',
												jI: A2($elm$core$Basics$composeR, $author$project$Pages$Reports$UsesPerVehicle$valueNotEmpty, $author$project$Pages$Reports$UsesPerVehicle$InputtedVEndDate),
												hh: 'Fim',
												kQ: $elm$core$Maybe$Nothing,
												kY: 'date',
												di: A2($elm$core$Maybe$withDefault, '', model.T.bl)
											}
											]),
										pW: $author$project$Pages$Reports$UsesPerVehicle$Submit
									}),
									A2(
									$krisajenkins$remotedata$RemoteData$withDefault,
									true,
									A2(
										$krisajenkins$remotedata$RemoteData$map,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.px;
											},
											$elm$core$List$isEmpty),
										model.ck)) ? $elm$html$Html$text('') : $author$project$Components$GeneratorCSV$buttonDownload($author$project$Pages$Reports$UsesPerVehicle$GetTimeToDownload)
								])),
							function () {
							var _v0 = model.ck;
							switch (_v0.$) {
								case 3:
									var table = _v0.a;
									var viewRecords = A2($elm$core$List$map, $author$project$Pages$Reports$UsesPerVehicle$viewRecord, table.px);
									var headers = A2($elm$core$List$cons, 'Classe', table.nF);
									return $elm$core$List$isEmpty(viewRecords) ? $elm$html$Html$text('Nenhum registro encontrado') : $author$project$Components$Patterns$Tables$default(
										{nF: headers, nX: true, pj: viewRecords});
								case 0:
									return $elm$html$Html$text('Por favor, defina um período desejado ou utilize as datas padrão para realizar a busca.');
								case 1:
									return $author$project$Components$View$loading;
								default:
									var e = _v0.a;
									return $elm$html$Html$text('Ops! Algo deu errado');
							}
						}()
						]))
				]));
	});
var $author$project$Pages$Reports$UsesPerVehicle$view = F3(
	function (model, user, shared) {
		var viewModal = $elm$html$Html$text('');
		return _Utils_Tuple2(
			'Relatório utilização por veiculo',
			_List_fromArray(
				[
					A2($author$project$Pages$Reports$UsesPerVehicle$viewPage, model, user),
					viewModal
				]));
	});
var $elm$html$Html$iframe = _VirtualDom_node('iframe');
var $author$project$Pages$ZenviaChat$view = A2(
	$elm$html$Html$iframe,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$src('https://chat.zenvia.com/chat/A5DD13819249A3D0F454F7D8D5742A1C'),
			A2($elm$html$Html$Attributes$style, 'width', '100%'),
			A2($elm$html$Html$Attributes$style, 'height', '100%'),
			A2($elm$html$Html$Attributes$style, 'margin', '0px'),
			A2($elm$html$Html$Attributes$style, 'padding', '0px'),
			A2($elm$html$Html$Attributes$style, 'overflow', 'hidden'),
			A2($elm$html$Html$Attributes$style, 'position', 'fixed')
		]),
	_List_Nil);
var $author$project$Pages$view = F3(
	function (compNavigationDrawer, model, shared) {
		var notification = function () {
			var _v13 = _Utils_Tuple2(shared.qq, shared.qr);
			if (_v13.a) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick($author$project$Pages$UpdateWebapp),
							$elm$html$Html$Attributes$class('notification-new-version')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex gap-3')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[$author$project$Svgs$alert])),
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h3,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('m-0 text-left ')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Nova versão disponível!')
												])),
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Uma nova atualização está pronta. Clique em atualizar')
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('mt-2')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$button,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$type_('button'),
															$elm$html$Html$Events$onClick($author$project$Pages$UpdateWebapp)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Atualizar')
														]))
												]))
										]))
								]))
						]));
			} else {
				return $elm$html$Html$text('');
			}
		}();
		var notFound = A2(
			$elm$core$Tuple$mapSecond,
			A2(
				$elm$core$Basics$composeR,
				$elm$html$Html$map($author$project$Pages$NotFoundMsg),
				$elm$core$List$singleton),
			$author$project$Pages$NotFound$view);
		return function (_v0) {
			var str = _v0.a;
			var listHtml = _v0.b;
			return _Utils_Tuple2(
				str,
				_Utils_ap(
					listHtml,
					_List_fromArray(
						[notification])));
		}(
			function () {
				var _v1 = _Utils_Tuple2(shared.pF, model);
				_v1$58:
				while (true) {
					switch (_v1.b.$) {
						case 0:
							var model_ = _v1.b.a;
							return A2(
								$elm$core$Tuple$mapSecond,
								$elm$core$List$map(
									$elm$html$Html$map($author$project$Pages$LoginMsg)),
								A2($author$project$Pages$Login$view, model_, shared));
						case 1:
							var model_ = _v1.b.a;
							return A2(
								$elm$core$Tuple$mapSecond,
								A2(
									$elm$core$Basics$composeR,
									$elm$html$Html$map($author$project$Pages$RecoverPasswordMsg),
									$elm$core$List$singleton),
								A2($author$project$Pages$RecoverPassword$view, model_, shared));
						case 2:
							var model_ = _v1.b.a;
							return A2(
								$elm$core$Tuple$mapSecond,
								A2(
									$elm$core$Basics$composeR,
									$elm$html$Html$map($author$project$Pages$ChangePasswordMsg),
									$elm$core$List$singleton),
								A2($author$project$Pages$ChangePassword$view, model_, shared));
						case 4:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var model_ = _v1.b.a;
								return A2(
									$elm$core$Tuple$mapSecond,
									$elm$core$List$map(
										$elm$html$Html$map($author$project$Pages$HomeWelcomeBackMsg)),
									A3($author$project$Pages$Home$WelcomeBack$view, model_, user, shared));
							} else {
								break _v1$58;
							}
						case 5:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var model_ = _v1.b.a;
								return A2(
									$elm$core$Tuple$mapSecond,
									$elm$core$List$map(
										$elm$html$Html$map($author$project$Pages$MyAccountMsg)),
									A2($author$project$Pages$Panel$MyAccount$SubPage$view, model_, shared));
							} else {
								break _v1$58;
							}
						case 3:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var model_ = _v1.b.a;
								return A2(
									$elm$core$Tuple$mapSecond,
									A2(
										$elm$core$Basics$composeR,
										$elm$html$Html$map($author$project$Pages$PosGuicheMsg),
										$elm$core$List$singleton),
									A2($author$project$Pages$Pos$Guiche$view, model_, user));
							} else {
								break _v1$58;
							}
						case 6:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var model_ = _v1.b.a;
								return A2(
									$elm$core$Tuple$mapSecond,
									A2(
										$elm$core$Basics$composeR,
										$elm$html$Html$map($author$project$Pages$PosRegisterMsg),
										$elm$core$List$singleton),
									A3($author$project$Pages$Pos$Register$view, shared, user, model_));
							} else {
								break _v1$58;
							}
						case 7:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var _v2 = _v1.b;
								var model_ = _v2.b;
								return A2(
									$elm$core$Tuple$mapSecond,
									A2(
										$elm$core$Basics$composeR,
										$elm$html$Html$map($author$project$Pages$PosPassengerMsg),
										$elm$core$List$singleton),
									A3($author$project$Pages$Pos$Passenger$view, user, shared, model_));
							} else {
								break _v1$58;
							}
						case 8:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var model_ = _v1.b.a;
								return A2(
									$elm$core$Tuple$mapSecond,
									A2(
										$elm$core$Basics$composeR,
										$elm$html$Html$map($author$project$Pages$PosEditMsg),
										$elm$core$List$singleton),
									A3($author$project$Pages$Pos$Edit$view, shared, user, model_));
							} else {
								break _v1$58;
							}
						case 9:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var model_ = _v1.b.a;
								return A2(
									$elm$core$Tuple$mapSecond,
									A2(
										$elm$core$Basics$composeR,
										$elm$html$Html$map($author$project$Pages$PosLocalizeMsg),
										$elm$core$List$singleton),
									A2($author$project$Pages$Pos$Localize$view, user, model_));
							} else {
								break _v1$58;
							}
						case 10:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var model_ = _v1.b.a;
								return A2(
									$elm$core$Tuple$mapSecond,
									A2(
										$elm$core$Basics$composeR,
										$elm$html$Html$map($author$project$Pages$PosCloseCashierMsg),
										$elm$core$List$singleton),
									A3($author$project$Pages$Pos$CloseCashier$view, user, model_, shared));
							} else {
								break _v1$58;
							}
						case 11:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var model_ = _v1.b.a;
								return A2(
									$elm$core$Tuple$mapSecond,
									A2(
										$elm$core$Basics$composeR,
										$elm$html$Html$map($author$project$Pages$PosGarageMsg),
										$elm$core$List$singleton),
									A3($author$project$Pages$Garage$Dashboard$view, user, model_, shared));
							} else {
								break _v1$58;
							}
						case 17:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var _v3 = _v1.b;
								var maybeConcessionaireId = _v3.a;
								var model_ = _v3.b;
								return A2(
									$elm$core$Tuple$mapSecond,
									A2(
										$elm$core$Basics$composeR,
										$elm$html$Html$map($author$project$Pages$EnterpriseRegisterMsg),
										$elm$core$List$singleton),
									A3(
										$author$project$Pages$Enterprise$Register$view,
										$elm$core$Maybe$Just(user),
										model_,
										shared));
							} else {
								var _v4 = _v1.a;
								var _v5 = _v1.b;
								var maybeConcessionaireId = _v5.a;
								var model_ = _v5.b;
								return A2(
									$elm$core$Tuple$mapSecond,
									A2(
										$elm$core$Basics$composeR,
										$elm$html$Html$map($author$project$Pages$EnterpriseRegisterMsg),
										$elm$core$List$singleton),
									A3($author$project$Pages$Enterprise$Register$view, $elm$core$Maybe$Nothing, model_, shared));
							}
						case 12:
							if (!_v1.a.$) {
								var model_ = _v1.b.a;
								return A2(
									$elm$core$Tuple$mapSecond,
									$elm$core$List$map(
										$elm$html$Html$map($author$project$Pages$EnterpriseDashboardMsg)),
									A2($author$project$Pages$Enterprise$Dashboard$view, model_, shared));
							} else {
								break _v1$58;
							}
						case 13:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var model_ = _v1.b.a;
								return A2(
									$elm$core$Tuple$mapSecond,
									$elm$core$List$map(
										$elm$html$Html$map($author$project$Pages$SavedOrderListsMsg)),
									A3($author$project$Pages$Order$Lists$view, model_, shared, user));
							} else {
								break _v1$58;
							}
						case 14:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var model_ = _v1.b.a;
								return A2(
									$elm$core$Tuple$mapSecond,
									$elm$core$List$map(
										$elm$html$Html$map($author$project$Pages$SavedOrderDetailMsg)),
									A3($author$project$Pages$Order$Detail$view, model_, shared, user));
							} else {
								break _v1$58;
							}
						case 15:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var model_ = _v1.b.a;
								var _v6 = A3($author$project$Pages$Admin$CompanyOrders$view, model_, shared, user);
								var title_ = _v6.a;
								var page_ = _v6.b;
								var modal = _v6.c;
								return A2(
									$elm$core$Tuple$mapSecond,
									$elm$core$List$map(
										$elm$html$Html$map($author$project$Pages$EnterpriseHistoryMsg)),
									_Utils_Tuple2(
										title_,
										_List_fromArray(
											[page_, modal])));
							} else {
								break _v1$58;
							}
						case 16:
							if (!_v1.a.$) {
								var _v7 = _v1.b;
								var maybePage = _v7.a;
								var model_ = _v7.b;
								return A2(
									$elm$core$Tuple$mapSecond,
									A2(
										$elm$core$Basics$composeR,
										$elm$html$Html$map($author$project$Pages$EnterpriseHistoryDetailsMsg),
										$elm$core$List$singleton),
									A3($author$project$Pages$Enterprise$HistoryDetails$view, maybePage, model_, shared));
							} else {
								break _v1$58;
							}
						case 18:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var _v8 = _v1.b;
								var maybeConcessionaireId = _v8.a;
								var model_ = _v8.b;
								return A2(
									$elm$core$Tuple$mapSecond,
									$elm$core$List$map(
										$elm$html$Html$map($author$project$Pages$AdminMsg)),
									A5($author$project$Pages$Admin$view, compNavigationDrawer, model_, shared, maybeConcessionaireId, user));
							} else {
								break _v1$58;
							}
						case 19:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var model_ = _v1.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$EQUIPMENT(3),
										hQ: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$List$map(
												$elm$html$Html$map($author$project$Pages$EquipmentsMsg)),
											A3($author$project$Pages$Panel$EquipmentsV2$view, model_, shared, user)),
										hR: notFound
									});
							} else {
								break _v1$58;
							}
						case 20:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var model_ = _v1.b.a;
								var _v9 = A3($author$project$Pages$Panel$ReversalApprovalSystem$view, model_, shared, user);
								var title_ = _v9.a;
								var page_ = _v9.b;
								var modal = _v9.c;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$REVERSE(0),
										hQ: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$List$map(
												$elm$html$Html$map($author$project$Pages$ReversalApprovalSystemMsg)),
											_Utils_Tuple2(
												title_,
												_List_fromArray(
													[page_, modal]))),
										hR: notFound
									});
							} else {
								break _v1$58;
							}
						case 21:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var model_ = _v1.b.a;
								var _v10 = A3($author$project$Pages$Panel$ReversalApprovalCashier$view, model_, shared, user);
								var title_ = _v10.a;
								var page_ = _v10.b;
								var modal = _v10.c;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$REVERSE(0),
										hQ: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$List$map(
												$elm$html$Html$map($author$project$Pages$ReversalApprovalCashierMsg)),
											_Utils_Tuple2(
												title_,
												_List_fromArray(
													[page_, modal]))),
										hR: notFound
									});
							} else {
								break _v1$58;
							}
						case 22:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var model_ = _v1.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$POUCH(0),
										hQ: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$List$map(
												$elm$html$Html$map($author$project$Pages$ManagePouchesMsg)),
											A3($author$project$Pages$Panel$ManagePouches$view, user, model_, shared)),
										hR: notFound
									});
							} else {
								break _v1$58;
							}
						case 23:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var model_ = _v1.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$TARIFFS(0),
										hQ: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$List$map(
												$elm$html$Html$map($author$project$Pages$ManageFareMsg)),
											A3($author$project$Pages$Panel$ManageFare$view, user, model_, shared)),
										hR: notFound
									});
							} else {
								break _v1$58;
							}
						case 24:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var model_ = _v1.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$OPERATORS(0),
										hQ: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$List$map(
												$elm$html$Html$map($author$project$Pages$ManageOperatorsMsg)),
											A3($author$project$Pages$Panel$ManageOperators$view, model_, user, shared)),
										hR: notFound
									});
							} else {
								break _v1$58;
							}
						case 25:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var model_ = _v1.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$EQUIPMENT_UPDATE(0),
										hQ: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$List$map(
												$elm$html$Html$map($author$project$Pages$UpdateEquipmentMsg)),
											A3($author$project$Pages$Panel$UpdateEquipment$view, model_, user, shared)),
										hR: notFound
									});
							} else {
								break _v1$58;
							}
						case 26:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var model_ = _v1.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$REASONS(0),
										hQ: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$List$map(
												$elm$html$Html$map($author$project$Pages$ReasonMsg)),
											A3($author$project$Pages$Panel$Reason$view, model_, shared, user)),
										hR: notFound
									});
							} else {
								break _v1$58;
							}
						case 27:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var model_ = _v1.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$AVULSAS(0),
										hQ: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$List$map(
												$elm$html$Html$map($author$project$Pages$SingleChargeMsg)),
											A3($author$project$Pages$Panel$SingleCharge$view, model_, shared, user)),
										hR: notFound
									});
							} else {
								break _v1$58;
							}
						case 28:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var model_ = _v1.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$STOCK(0),
										hQ: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$List$map(
												$elm$html$Html$map($author$project$Pages$StockListMsg)),
											A2($author$project$Pages$Panel$Stock$List$view, model_, shared)),
										hR: notFound
									});
							} else {
								break _v1$58;
							}
						case 29:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var model_ = _v1.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$STOCK(0),
										hQ: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$List$map(
												$elm$html$Html$map($author$project$Pages$StockDetailsMsg)),
											A2($author$project$Pages$Panel$Stock$Details$view, model_, shared)),
										hR: notFound
									});
							} else {
								break _v1$58;
							}
						case 30:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var model_ = _v1.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$EQUIPMENT_UPDATE(0),
										hQ: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$List$map(
												$elm$html$Html$map($author$project$Pages$UpdateRequestsEquipmentsMsg)),
											A3($author$project$Pages$Panel$UpdateRequestsEquipments$view, model_, shared, user)),
										hR: notFound
									});
							} else {
								break _v1$58;
							}
						case 31:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var model_ = _v1.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$LINES(0),
										hQ: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$List$map(
												$elm$html$Html$map($author$project$Pages$ManageLinesMsg)),
											A3($author$project$Pages$Panel$ManageLines$view, model_, shared, user)),
										hR: notFound
									});
							} else {
								break _v1$58;
							}
						case 32:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var model_ = _v1.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$PASSENGER(0),
										hQ: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$List$map(
												$elm$html$Html$map($author$project$Pages$HistoryMsg)),
											A3($author$project$Pages$Panel$History$view, model_, user, shared)),
										hR: notFound
									});
							} else {
								break _v1$58;
							}
						case 33:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var model_ = _v1.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$REPORTS(
											$author$project$Services$Models$UsesVehicles(0)),
										hQ: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$List$map(
												$elm$html$Html$map($author$project$Pages$ReportUsesPerVehicleMsg)),
											A3($author$project$Pages$Reports$UsesPerVehicle$view, model_, user, shared)),
										hR: notFound
									});
							} else {
								break _v1$58;
							}
						case 34:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var model_ = _v1.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$REPORT_PDF(0),
										hQ: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$List$map(
												$elm$html$Html$map($author$project$Pages$ReportPDFsMsg)),
											A3($author$project$Pages$Reports$PDFs$view, model_, user, shared)),
										hR: notFound
									});
							} else {
								break _v1$58;
							}
						case 35:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var model_ = _v1.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$REPORTS_EVENTS(1),
										hQ: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$List$map(
												$elm$html$Html$map($author$project$Pages$ReportEventUsingVehicleMsg)),
											A3($author$project$Pages$Reports$Event$UsingVehicle$view, model_, user, shared)),
										hR: notFound
									});
							} else {
								break _v1$58;
							}
						case 36:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var model_ = _v1.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$REPORTS_EVENTS(3),
										hQ: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$List$map(
												$elm$html$Html$map($author$project$Pages$ReportEventUsingLineMsg)),
											A3($author$project$Pages$Reports$Event$UsingLine$view, model_, user, shared)),
										hR: notFound
									});
							} else {
								break _v1$58;
							}
						case 37:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var model_ = _v1.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$REPORTS_EVENTS(0),
										hQ: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$List$map(
												$elm$html$Html$map($author$project$Pages$ReportEventUsingDayMsg)),
											A3($author$project$Pages$Reports$Event$UsingDay$view, model_, user, shared)),
										hR: notFound
									});
							} else {
								break _v1$58;
							}
						case 38:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var model_ = _v1.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$REPORTS_EVENTS(2),
										hQ: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$List$map(
												$elm$html$Html$map($author$project$Pages$ReportEventUsingOperatorMsg)),
											A3($author$project$Pages$Reports$Event$UsingOperator$view, model_, user, shared)),
										hR: notFound
									});
							} else {
								break _v1$58;
							}
						case 39:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var model_ = _v1.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$REPORTS_EVENTS(4),
										hQ: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$List$map(
												$elm$html$Html$map($author$project$Pages$ReportEventUsingSessionMsg)),
											A3($author$project$Pages$Reports$Event$UsingSession$view, model_, user, shared)),
										hR: notFound
									});
							} else {
								break _v1$58;
							}
						case 40:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var model_ = _v1.b.a;
								return A2(
									$elm$core$Tuple$mapSecond,
									$elm$core$List$map(
										$elm$html$Html$map($author$project$Pages$ReportAuditMsg)),
									A3($author$project$Pages$Reports$Event$Audit$view, model_, user, shared));
							} else {
								break _v1$58;
							}
						case 41:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var model_ = _v1.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$REPORTS(
											$author$project$Services$Models$UsesDay(0)),
										hQ: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$List$map(
												$elm$html$Html$map($author$project$Pages$ReportUsesPerDayMsg)),
											A3($author$project$Pages$Reports$UsesPerDay$view, model_, user, shared)),
										hR: notFound
									});
							} else {
								break _v1$58;
							}
						case 42:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var model_ = _v1.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$REPORTS(
											$author$project$Services$Models$UsesLine(0)),
										hQ: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$List$map(
												$elm$html$Html$map($author$project$Pages$ReportUsesPerLineMsg)),
											A3($author$project$Pages$Reports$UsesPerLine$view, model_, user, shared)),
										hR: notFound
									});
							} else {
								break _v1$58;
							}
						case 45:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var model_ = _v1.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$REPORTS($author$project$Services$Models$Usage),
										hQ: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$List$map(
												$elm$html$Html$map($author$project$Pages$ReportUsageMsg)),
											A3($author$project$Pages$Reports$Usage$view, model_, user, shared)),
										hR: notFound
									});
							} else {
								break _v1$58;
							}
						case 43:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var model_ = _v1.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$REPORTS($author$project$Services$Models$UsesClass),
										hQ: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$List$map(
												$elm$html$Html$map($author$project$Pages$ReportUsesPerClassMsg)),
											A3($author$project$Pages$Reports$UsesPerClass$view, model_, user, shared)),
										hR: notFound
									});
							} else {
								break _v1$58;
							}
						case 44:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var model_ = _v1.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$BIOMETRY(0),
										hQ: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$List$map(
												$elm$html$Html$map($author$project$Pages$ReportDivergencesMsg)),
											A3($author$project$Pages$Reports$Divergences$view, model_, user, shared)),
										hR: notFound
									});
							} else {
								break _v1$58;
							}
						case 46:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var model_ = _v1.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$REPORTS($author$project$Services$Models$DetailedVehicle),
										hQ: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$List$map(
												$elm$html$Html$map($author$project$Pages$ReportDetailedVehicleMsg)),
											A3($author$project$Pages$Reports$DetailedVehicle$view, model_, user, shared)),
										hR: notFound
									});
							} else {
								break _v1$58;
							}
						case 47:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var model_ = _v1.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$REPORTS($author$project$Services$Models$DetailedVehicle),
										hQ: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$List$map(
												$elm$html$Html$map($author$project$Pages$ReportDetailedVehicleV2Msg)),
											A3($author$project$Pages$Reports$DetailedVehicleV2$view, model_, user, shared)),
										hR: notFound
									});
							} else {
								break _v1$58;
							}
						case 48:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var model_ = _v1.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$REPORTS($author$project$Services$Models$SalesSummary),
										hQ: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$List$map(
												$elm$html$Html$map($author$project$Pages$ReportSalesSummarizedMsg)),
											A2($author$project$Pages$Reports$SalesSummarized$view, model_, shared)),
										hR: notFound
									});
							} else {
								break _v1$58;
							}
						case 49:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var model_ = _v1.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$REPORTS($author$project$Services$Models$SalesSummary),
										hQ: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$List$map(
												$elm$html$Html$map($author$project$Pages$ReportSalesSummarizedV2Msg)),
											A2($author$project$Pages$Reports$SalesSummarizedV2$view, model_, shared)),
										hR: notFound
									});
							} else {
								break _v1$58;
							}
						case 50:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var model_ = _v1.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$REPORTS($author$project$Services$Models$SalesSummary),
										hQ: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$List$map(
												$elm$html$Html$map($author$project$Pages$ReportAdministrativeSalesMsg)),
											A3($author$project$Pages$Reports$AdministrativeSales$view, model_, user, shared)),
										hR: notFound
									});
							} else {
								break _v1$58;
							}
						case 51:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var model_ = _v1.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$FINANCIAL(1),
										hQ: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$List$map(
												$elm$html$Html$map($author$project$Pages$FinancialAccountMsg)),
											A2($author$project$Pages$Panel$Financial$Account$view, model_, shared)),
										hR: notFound
									});
							} else {
								break _v1$58;
							}
						case 52:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var model_ = _v1.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$FINANCIAL(2),
										hQ: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$List$map(
												$elm$html$Html$map($author$project$Pages$FinancialTransactionsMsg)),
											A3($author$project$Pages$Panel$Financial$Transactions$view, model_, user, shared)),
										hR: notFound
									});
							} else {
								break _v1$58;
							}
						case 53:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var model_ = _v1.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$FINANCIAL(3),
										hQ: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$List$map(
												$elm$html$Html$map($author$project$Pages$FinancialPendingTransactionsMsg)),
											A3($author$project$Pages$Panel$Financial$PendingTransactions$view, model_, user, shared)),
										hR: notFound
									});
							} else {
								break _v1$58;
							}
						case 54:
							if (!_v1.a.$) {
								var user = _v1.a.a;
								var model_ = _v1.b.a;
								return $author$project$Services$Models$iHaveAccess(
									{
										gZ: user.hg,
										hf: $author$project$Services$Models$CLASS(1),
										hQ: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$List$map(
												$elm$html$Html$map($author$project$Pages$PanelClassesMsg)),
											A3($author$project$Pages$Panel$Classes$SubPage$view, model_, shared, user)),
										hR: notFound
									});
							} else {
								break _v1$58;
							}
						case 55:
							var _v11 = _v1.b;
							return _Utils_Tuple2(
								'',
								$elm$core$List$singleton(
									A2($elm$html$Html$map, $elm$core$Basics$never, $author$project$Pages$ZenviaChat$view)));
						case 56:
							var _v12 = _v1.b;
							return notFound;
						default:
							break _v1$58;
					}
				}
				return _Utils_Tuple2(
					'',
					$elm$core$List$singleton(
						A2(
							$elm$html$Html$map,
							$author$project$Pages$RedirectMsg,
							$elm$html$Html$text(''))));
			}());
	});
var $author$project$Components$View$success = function (options) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal-overlay')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('modal-container pagamento-realizado')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('header-modal')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('action-header')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('fechar-ico'),
												$elm$html$Html$Events$onClick(options.ou)
											]),
										_List_Nil)
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('check-pagamento-realizado')
							]),
						_List_Nil),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pagamento-realizado-txt')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(options.fD)
							])),
						function () {
						var _v0 = options.pk;
						if (!_v0.$) {
							var redirect = _v0.a;
							return A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('action-system'),
										$elm$html$Html$Events$onClick(redirect.jG)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(redirect.fD)
									]));
						} else {
							return $elm$html$Html$text('');
						}
					}()
					]))
			]));
};
var $author$project$Shared$view = function (model) {
	var _v0 = model.iG;
	if (!_v0.$) {
		if (_v0.a.$ === 1) {
			var error = _v0.a.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('msg-container'),
						$elm$html$Html$Events$onClick($author$project$Shared$CloseDialog)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('warning-container danger')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('main-flex-container')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('ico-close close-red')
											]),
										_List_Nil),
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(error)
											]))
									]))
							]))
					]));
		} else {
			var options = _v0.a.a;
			var onClickMsg = function (isLoad) {
				return isLoad ? $author$project$Shared$RedirectLoadPage : $author$project$Shared$Redirect;
			};
			return $author$project$Components$View$success(
				{
					ou: $author$project$Shared$CloseDialog,
					pk: A2(
						$elm$core$Maybe$map,
						function (redirect) {
							return {
								jG: A2(onClickMsg, redirect.gN, redirect.pv),
								fD: redirect.fD
							};
						},
						options.pk),
					fD: options.fD
				});
		}
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Main$view = function (model) {
	var _v0 = A2(
		$elm$core$Tuple$mapSecond,
		$elm$core$List$map(
			$elm$html$Html$map($author$project$Main$PagesMsg)),
		A3($author$project$Pages$view, model.ak, model.bv, model.v));
	var title = _v0.a;
	var body = _v0.b;
	var body_ = function () {
		var _v1 = _Utils_Tuple3(
			$author$project$Components$Patterns$NavigationDrawer$pagesWithNavigationDrawer(model.v.pv),
			model.ak,
			model.v.pF);
		if ((_v1.a && (!_v1.b.$)) && (!_v1.c.$)) {
			var model_ = _v1.b.a;
			var user = _v1.c.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('wrapper')
					]),
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Main$NavigationDrawerMsg,
							A3($author$project$Components$Patterns$NavigationDrawer$view, user, model_, model.v))
						]),
					body));
		} else {
			return A2($elm$html$Html$div, _List_Nil, body);
		}
	}();
	return {
		lG: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Main$SharedMsg,
				$author$project$Shared$view(model.v)),
				$author$project$Shared$billingBanner(model.v),
				A3(
				$elm$html$Html$Keyed$node,
				'div',
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id('app')
					]),
				_List_fromArray(
					[
						_Utils_Tuple2(title, body_)
					])),
				$author$project$Components$View$version
			]),
		fD: 'Buzzao - ' + title
	};
};
var $author$project$Main$main = $elm$browser$Browser$application(
	{nQ: $author$project$Main$init, oy: $author$project$Main$ChangedUrl, oz: $author$project$Main$ClickedLink, pY: $author$project$Main$subscriptions, qp: $author$project$Main$update, qD: $author$project$Main$view});
_Platform_export({'Main':{'init':$author$project$Main$main($elm$json$Json$Decode$value)(0)}});}(this));